
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $ab3f2a5cc6216ae5$var$_defineProperty(e, r, t) {
    return (r = $ab3f2a5cc6216ae5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ab3f2a5cc6216ae5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab3f2a5cc6216ae5$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab3f2a5cc6216ae5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ab3f2a5cc6216ae5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab3f2a5cc6216ae5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ab3f2a5cc6216ae5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ab3f2a5cc6216ae5$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ab3f2a5cc6216ae5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
function $ab3f2a5cc6216ae5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ab3f2a5cc6216ae5$var$_toPropertyKey(t) {
    var i = $ab3f2a5cc6216ae5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
class $ab3f2a5cc6216ae5$var$BaseConfiguration {
    constructor(){
        /**
     * Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
     * which is unitless and not rendered equally across browsers.
     *
     * Values that work quite well (as of October 2017) are:
     * - Chrome: 1.5
     * - Edge: 1.75
     * - Firefox: 0.9
     * - Safari: 0.95
     *
     * @since 2.0.0
     * @type Number
     * @default 1
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "browserShadowBlurConstant", 1);
        /**
     * Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "DPI", 96);
        /**
     * Device Pixel Ratio
     * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "devicePixelRatio", typeof window !== "undefined" ? window.devicePixelRatio : 1);
        // eslint-disable-line no-restricted-globals
        /**
     * Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
     * @since 1.7.14
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "perfLimitSizeTotal", 2097152);
        /**
     * Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
     * @since 1.7.14
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "maxCacheSideLimit", 4096);
        /**
     * Lowest pixel limit for cache canvases, set at 256PX
     * @since 1.7.14
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "minCacheSideLimit", 256);
        /**
     * When 'true', style information is not retained when copy/pasting text, making
     * pasted text use destination style.
     * Defaults to 'false'.
     * @type Boolean
     * @default
     * @deprecated
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "disableStyleCopyPaste", false);
        /**
     * Enable webgl for filtering picture is available
     * A filtering backend will be initialized, this will both take memory and
     * time since a default 2048x2048 canvas will be created for the gl context
     * @since 2.0.0
     * @type Boolean
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "enableGLFiltering", true);
        /**
     * if webgl is enabled and available, textureSize will determine the size
     * of the canvas backend
     *
     * In order to support old hardware set to `2048` to avoid OOM
     *
     * @since 2.0.0
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "textureSize", 4096);
        /**
     * Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
     * Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
     * this has to be set before instantiating the filtering backend ( before filtering the first image )
     * @type Boolean
     * @default false
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "forceGLPutImageData", false);
        /**
     * If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
     * @default true
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "cachesBoundsOfCurve", true);
        /**
     * Map of font files
     * Map<fontFamily, pathToFile> of font files
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "fontPaths", {});
        /**
     * Defines the number of fraction digits to use when serializing object values.
     * Used in exporting methods (`toObject`, `toJSON`, `toSVG`)
     * You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "NUM_FRACTION_DIGITS", 4);
    }
}
class $ab3f2a5cc6216ae5$var$Configuration extends $ab3f2a5cc6216ae5$var$BaseConfiguration {
    constructor(config){
        super();
        this.configure(config);
    }
    configure() {
        let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        Object.assign(this, config);
    }
    /**
   * Map<fontFamily, pathToFile> of font files
   */ addFonts() {
        let paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.fontPaths = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, this.fontPaths), paths);
    }
    removeFonts() {
        let fontFamilys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        fontFamilys.forEach((fontFamily)=>{
            delete this.fontPaths[fontFamily];
        });
    }
    clearFonts() {
        this.fontPaths = {};
    }
    restoreDefaults(keys) {
        const defaults = new $ab3f2a5cc6216ae5$var$BaseConfiguration();
        const config = (keys === null || keys === void 0 ? void 0 : keys.reduce((acc, key)=>{
            acc[key] = defaults[key];
            return acc;
        }, {})) || defaults;
        this.configure(config);
    }
}
const $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20 = new $ab3f2a5cc6216ae5$var$Configuration();
const $ab3f2a5cc6216ae5$var$log = function(severity) {
    for(var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)optionalParams[_key - 1] = arguments[_key];
    return(// eslint-disable-next-line no-restricted-syntax
    console[severity]("fabric", ...optionalParams));
};
class $ab3f2a5cc6216ae5$var$FabricError extends Error {
    constructor(message, options){
        super("fabric: ".concat(message), options);
    }
}
class $ab3f2a5cc6216ae5$var$SignalAbortedError extends $ab3f2a5cc6216ae5$var$FabricError {
    constructor(context){
        super("".concat(context, " 'options.signal' is in 'aborted' state"));
    }
}
class $ab3f2a5cc6216ae5$var$GLProbe {
}
/**
 * Lazy initialize WebGL constants
 */ class $ab3f2a5cc6216ae5$var$WebGLProbe extends $ab3f2a5cc6216ae5$var$GLProbe {
    /**
   * Tests if webgl supports certain precision
   * @param {WebGL} Canvas WebGL context to test on
   * @param {GLPrecision} Precision to test can be any of following
   * @returns {Boolean} Whether the user's browser WebGL supports given precision.
   */ testPrecision(gl, precision) {
        const fragmentSource = "precision ".concat(precision, " float;\nvoid main(){}");
        const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        if (!fragmentShader) return false;
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        return !!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS);
    }
    /**
   * query browser for WebGL
   */ queryWebGL(canvas) {
        const gl = canvas.getContext("webgl");
        if (gl) {
            this.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
            this.GLPrecision = [
                "highp",
                "mediump",
                "lowp"
            ].find((precision)=>this.testPrecision(gl, precision));
            gl.getExtension("WEBGL_lose_context").loseContext();
            $ab3f2a5cc6216ae5$var$log("log", "WebGL: max texture size ".concat(this.maxTextureSize));
        }
    }
    isSupported(textureSize) {
        return !!this.maxTextureSize && this.maxTextureSize >= textureSize;
    }
}
/* eslint-disable no-restricted-globals */ const $ab3f2a5cc6216ae5$var$copyPasteData = {};
const $ab3f2a5cc6216ae5$var$getEnv$1 = ()=>{
    return {
        document: document,
        window: window,
        isTouchSupported: "ontouchstart" in window || "ontouchstart" in document || window && window.navigator && window.navigator.maxTouchPoints > 0,
        WebGLProbe: new $ab3f2a5cc6216ae5$var$WebGLProbe(),
        dispose () {
        // noop
        },
        copyPasteData: $ab3f2a5cc6216ae5$var$copyPasteData
    };
};
/**
 * This file is consumed by fabric.
 * The `./node` and `./browser` files define the env variable that is used by this module.
 * The `./browser` module is defined to be the default env and doesn't set the env at all.
 * This is done in order to support isomorphic usage for browser and node applications
 * since window and document aren't defined at time of import in SSR, we can't set env so we avoid it by deferring to the default env.
 */ let $ab3f2a5cc6216ae5$var$env;
/**
 * Sets the environment variables used by fabric.\
 * This is exposed for special cases, such as configuring a test environment, and should be used with care.
 *
 * **CAUTION**: Must be called before using the package.
 *
 * @example
 * <caption>Passing `window` and `document` objects to fabric (in case they are mocked or something)</caption>
 * import { getEnv, setEnv } from 'fabric';
 * // we want fabric to use the `window` and `document` objects exposed by the environment we are running in.
 * setEnv({ ...getEnv(), window, document });
 * // done with setup, using fabric is now safe
 */ const $ab3f2a5cc6216ae5$export$84bc02d3c7a6b55f = (value)=>{
    $ab3f2a5cc6216ae5$var$env = value;
};
/**
 * In order to support SSR we **MUST** access the browser env only after the window has loaded
 */ const $ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e = ()=>$ab3f2a5cc6216ae5$var$env || ($ab3f2a5cc6216ae5$var$env = $ab3f2a5cc6216ae5$var$getEnv$1());
const $ab3f2a5cc6216ae5$export$91e93c41e950ddbb = ()=>$ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e().document;
const $ab3f2a5cc6216ae5$export$4a3a3142573970c3 = ()=>$ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e().window;
/**
 * @returns the config value if defined, fallbacks to the environment value
 */ const $ab3f2a5cc6216ae5$var$getDevicePixelRatio = ()=>{
    var _config$devicePixelRa;
    return Math.max((_config$devicePixelRa = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.devicePixelRatio) !== null && _config$devicePixelRa !== void 0 ? _config$devicePixelRa : $ab3f2a5cc6216ae5$export$4a3a3142573970c3().devicePixelRatio, 1);
};
class $ab3f2a5cc6216ae5$var$Cache {
    constructor(){
        /**
     * Cache of widths of chars in text rendering.
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "charWidthsCache", {});
        /**
     * This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
     * It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
     * you do not get any speed benefit and you get a big object in memory.
     * The object was a private variable before, while now is appended to the lib so that you have access to it and you
     * can eventually clear it.
     * It was an internal variable, is accessible since version 2.3.4
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "boundsOfCurveCache", {});
    }
    /**
   * @return {Object} reference to cache
   */ getFontCache(_ref) {
        let { fontFamily: fontFamily, fontStyle: fontStyle, fontWeight: fontWeight } = _ref;
        fontFamily = fontFamily.toLowerCase();
        if (!this.charWidthsCache[fontFamily]) this.charWidthsCache[fontFamily] = {};
        const fontCache = this.charWidthsCache[fontFamily];
        const cacheKey = "".concat(fontStyle.toLowerCase(), "_").concat((fontWeight + "").toLowerCase());
        if (!fontCache[cacheKey]) fontCache[cacheKey] = {};
        return fontCache[cacheKey];
    }
    /**
   * Clear char widths cache for the given font family or all the cache if no
   * fontFamily is specified.
   * Use it if you know you are loading fonts in a lazy way and you are not waiting
   * for custom fonts to load properly when adding text objects to the canvas.
   * If a text object is added when its own font is not loaded yet, you will get wrong
   * measurement and so wrong bounding boxes.
   * After the font cache is cleared, either change the textObject text content or call
   * initDimensions() to trigger a recalculation
   * @param {String} [fontFamily] font family to clear
   */ clearFontCache(fontFamily) {
        fontFamily = (fontFamily || "").toLowerCase();
        if (!fontFamily) this.charWidthsCache = {};
        else if (this.charWidthsCache[fontFamily]) delete this.charWidthsCache[fontFamily];
    }
    /**
   * Given current aspect ratio, determines the max width and height that can
   * respect the total allowed area for the cache.
   * @param {number} ar aspect ratio
   * @return {number[]} Limited dimensions X and Y
   */ limitDimsByArea(ar) {
        const { perfLimitSizeTotal: perfLimitSizeTotal } = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20;
        const roughWidth = Math.sqrt(perfLimitSizeTotal * ar);
        // we are not returning a point on purpose, to avoid circular dependencies
        // this is an internal utility
        return [
            Math.floor(roughWidth),
            Math.floor(perfLimitSizeTotal / roughWidth)
        ];
    }
}
const $ab3f2a5cc6216ae5$export$69a3209f1a06c04d = new $ab3f2a5cc6216ae5$var$Cache();
var $ab3f2a5cc6216ae5$var$version = "6.0.2";
// use this syntax so babel plugin see this import here
const $ab3f2a5cc6216ae5$export$83d89fbfd8236492 = $ab3f2a5cc6216ae5$var$version;
// eslint-disable-next-line @typescript-eslint/no-empty-function
function $ab3f2a5cc6216ae5$var$noop() {}
const $ab3f2a5cc6216ae5$var$halfPI = Math.PI / 2;
const $ab3f2a5cc6216ae5$var$twoMathPi = Math.PI * 2;
const $ab3f2a5cc6216ae5$var$PiBy180 = Math.PI / 180;
const $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0 = Object.freeze([
    1,
    0,
    0,
    1,
    0,
    0
]);
const $ab3f2a5cc6216ae5$var$DEFAULT_SVG_FONT_SIZE = 16;
const $ab3f2a5cc6216ae5$var$ALIASING_LIMIT = 2;
/* "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) */ const $ab3f2a5cc6216ae5$var$kRect = 0.4477152502;
const $ab3f2a5cc6216ae5$var$CENTER = "center";
const $ab3f2a5cc6216ae5$var$LEFT = "left";
const $ab3f2a5cc6216ae5$var$TOP = "top";
const $ab3f2a5cc6216ae5$var$BOTTOM = "bottom";
const $ab3f2a5cc6216ae5$var$RIGHT = "right";
const $ab3f2a5cc6216ae5$var$NONE = "none";
const $ab3f2a5cc6216ae5$var$reNewline = /\r?\n/;
const $ab3f2a5cc6216ae5$var$MOVING = "moving";
const $ab3f2a5cc6216ae5$var$SCALING = "scaling";
const $ab3f2a5cc6216ae5$var$ROTATING = "rotating";
const $ab3f2a5cc6216ae5$var$ROTATE = "rotate";
const $ab3f2a5cc6216ae5$var$SKEWING = "skewing";
const $ab3f2a5cc6216ae5$var$RESIZING = "resizing";
const $ab3f2a5cc6216ae5$var$MODIFY_POLY = "modifyPoly";
const $ab3f2a5cc6216ae5$var$CHANGED = "changed";
const $ab3f2a5cc6216ae5$var$SCALE = "scale";
const $ab3f2a5cc6216ae5$var$SCALE_X = "scaleX";
const $ab3f2a5cc6216ae5$var$SCALE_Y = "scaleY";
const $ab3f2a5cc6216ae5$var$SKEW_X = "skewX";
const $ab3f2a5cc6216ae5$var$SKEW_Y = "skewY";
const $ab3f2a5cc6216ae5$var$FILL = "fill";
const $ab3f2a5cc6216ae5$var$STROKE = "stroke";
const $ab3f2a5cc6216ae5$var$MODIFIED = "modified";
/*
 * This Map connects the objects type value with their
 * class implementation. It used from any object to understand which are
 * the classes to enlive when requesting a object.type = 'path' for example.
 * Objects uses it for clipPath, Canvas uses it for everything.
 * This is necessary for generic code to run and enlive instances from serialized representation.
 * You can customize which classes get enlived from SVG parsing using this classRegistry.
 * The Registry start empty and gets filled in depending which files you import.
 * If you want to be able to parse arbitrary SVGs or JSON representation of canvases, coming from
 * different sources you will need to import all fabric because you may need all classes.
 */ const $ab3f2a5cc6216ae5$var$JSON$1 = "json";
const $ab3f2a5cc6216ae5$var$SVG = "svg";
class $ab3f2a5cc6216ae5$var$ClassRegistry {
    constructor(){
        this[$ab3f2a5cc6216ae5$var$JSON$1] = new Map();
        this[$ab3f2a5cc6216ae5$var$SVG] = new Map();
    }
    getClass(classType) {
        const constructor = this[$ab3f2a5cc6216ae5$var$JSON$1].get(classType);
        if (!constructor) throw new $ab3f2a5cc6216ae5$var$FabricError("No class registered for ".concat(classType));
        return constructor;
    }
    setClass(classConstructor, classType) {
        if (classType) this[$ab3f2a5cc6216ae5$var$JSON$1].set(classType, classConstructor);
        else {
            this[$ab3f2a5cc6216ae5$var$JSON$1].set(classConstructor.type, classConstructor);
            // legacy
            // @TODO: needs to be removed in fabric 7 or 8
            this[$ab3f2a5cc6216ae5$var$JSON$1].set(classConstructor.type.toLowerCase(), classConstructor);
        }
    }
    getSVGClass(SVGTagName) {
        return this[$ab3f2a5cc6216ae5$var$SVG].get(SVGTagName);
    }
    setSVGClass(classConstructor, SVGTagName) {
        this[$ab3f2a5cc6216ae5$var$SVG].set(SVGTagName !== null && SVGTagName !== void 0 ? SVGTagName : classConstructor.type.toLowerCase(), classConstructor);
    }
}
const $ab3f2a5cc6216ae5$export$2792378e23a7920c = new $ab3f2a5cc6216ae5$var$ClassRegistry();
/**
 * Array holding all running animations
 */ class $ab3f2a5cc6216ae5$var$AnimationRegistry extends Array {
    /**
   * Remove a single animation using an animation context
   * @param {AnimationBase} context
   */ remove(context) {
        const index = this.indexOf(context);
        index > -1 && this.splice(index, 1);
    }
    /**
   * Cancel all running animations on the next frame
   */ cancelAll() {
        const animations = this.splice(0);
        animations.forEach((animation)=>animation.abort());
        return animations;
    }
    /**
   * Cancel all running animations attached to a canvas on the next frame
   * @param {StaticCanvas} canvas
   */ cancelByCanvas(canvas) {
        if (!canvas) return [];
        const animations = this.filter((animation)=>{
            var _animation$target;
            return animation.target === canvas || typeof animation.target === "object" && ((_animation$target = animation.target) === null || _animation$target === void 0 ? void 0 : _animation$target.canvas) === canvas;
        });
        animations.forEach((animation)=>animation.abort());
        return animations;
    }
    /**
   * Cancel all running animations for target on the next frame
   * @param target
   */ cancelByTarget(target) {
        if (!target) return [];
        const animations = this.filter((animation)=>animation.target === target);
        animations.forEach((animation)=>animation.abort());
        return animations;
    }
}
const $ab3f2a5cc6216ae5$export$dc18923894d9e56a = new $ab3f2a5cc6216ae5$var$AnimationRegistry();
/**
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#events}
 * @see {@link http://fabricjs.com/events|Events demo}
 */ class $ab3f2a5cc6216ae5$export$77cea355fa80b5f4 {
    constructor(){
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "__eventListeners", {});
    }
    /**
   * Observes specified event
   * @alias on
   * @param {string} eventName Event name (eg. 'after:render')
   * @param {EventRegistryObject} handlers key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
   * @return {Function} disposer
   */ on(arg0, handler) {
        if (!this.__eventListeners) this.__eventListeners = {};
        if (typeof arg0 === "object") {
            // one object with key/value pairs was passed
            Object.entries(arg0).forEach((_ref)=>{
                let [eventName, handler] = _ref;
                this.on(eventName, handler);
            });
            return ()=>this.off(arg0);
        } else if (handler) {
            const eventName = arg0;
            if (!this.__eventListeners[eventName]) this.__eventListeners[eventName] = [];
            this.__eventListeners[eventName].push(handler);
            return ()=>this.off(eventName, handler);
        } else // noop
        return ()=>false;
    }
    /**
   * Observes specified event **once**
   * @alias once
   * @param {string} eventName Event name (eg. 'after:render')
   * @param {EventRegistryObject} handlers key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
   * @return {Function} disposer
   */ once(arg0, handler) {
        if (typeof arg0 === "object") {
            // one object with key/value pairs was passed
            const disposers = [];
            Object.entries(arg0).forEach((_ref2)=>{
                let [eventName, handler] = _ref2;
                disposers.push(this.once(eventName, handler));
            });
            return ()=>disposers.forEach((d)=>d());
        } else if (handler) {
            const disposer = this.on(arg0, function onceHandler() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                handler.call(this, ...args);
                disposer();
            });
            return disposer;
        } else // noop
        return ()=>false;
    }
    /**
   * @private
   * @param {string} eventName
   * @param {Function} [handler]
   */ _removeEventListener(eventName, handler) {
        if (!this.__eventListeners[eventName]) return;
        if (handler) {
            const eventListener = this.__eventListeners[eventName];
            const index = eventListener.indexOf(handler);
            index > -1 && eventListener.splice(index, 1);
        } else this.__eventListeners[eventName] = [];
    }
    /**
   * Unsubscribe all event listeners for eventname.
   * Do not use this pattern. You could kill internal fabricJS events.
   * We know we should have protected events for internal flows, but we don't have yet
   * @deprecated
   * @param {string} eventName event name (eg. 'after:render')
   */ /**
   * unsubscribe an event listener
   * @param {string} eventName event name (eg. 'after:render')
   * @param {TEventCallback} handler event listener to unsubscribe
   */ /**
   * unsubscribe event listeners
   * @param handlers handlers key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   */ /**
   * unsubscribe all event listeners
   */ off(arg0, handler) {
        if (!this.__eventListeners) return;
        // remove all key/value pairs (event name -> event handler)
        if (typeof arg0 === "undefined") for(const eventName in this.__eventListeners)this._removeEventListener(eventName);
        else if (typeof arg0 === "object") Object.entries(arg0).forEach((_ref3)=>{
            let [eventName, handler] = _ref3;
            this._removeEventListener(eventName, handler);
        });
        else this._removeEventListener(arg0, handler);
    }
    /**
   * Fires event with an optional options object
   * @param {String} eventName Event name to fire
   * @param {Object} [options] Options object
   */ fire(eventName, options) {
        var _this$__eventListener;
        if (!this.__eventListeners) return;
        const listenersForEvent = (_this$__eventListener = this.__eventListeners[eventName]) === null || _this$__eventListener === void 0 ? void 0 : _this$__eventListener.concat();
        if (listenersForEvent) for(let i = 0; i < listenersForEvent.length; i++)listenersForEvent[i].call(this, options || {});
    }
}
const $ab3f2a5cc6216ae5$var$findIndexRight = (array, predicate)=>{
    for(let index = array.length - 1; index >= 0; index--){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
};
/**
 * Returns random number between 2 specified ones.
 * @param {Number} min lower limit
 * @param {Number} max upper limit
 * @return {Number} random value (between min and max)
 */ const $ab3f2a5cc6216ae5$var$getRandomInt = (min, max)=>Math.floor(Math.random() * (max - min + 1)) + min;
/**
 *
 * @param value value to check if NaN
 * @param [valueIfNaN]
 * @returns `fallback` is `value is NaN
 */ const $ab3f2a5cc6216ae5$var$ifNaN = (value, valueIfNaN)=>{
    return isNaN(value) && typeof valueIfNaN === "number" ? valueIfNaN : value;
};
/**
 * Removes value from an array.
 * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
 * @param {Array} array
 * @param {*} value
 * @return {Array} original array
 */ const $ab3f2a5cc6216ae5$var$removeFromArray = (array, value)=>{
    const idx = array.indexOf(value);
    if (idx !== -1) array.splice(idx, 1);
    return array;
};
/**
 * Calculate the cos of an angle, avoiding returning floats for known results
 * This function is here just to avoid getting 0.999999999999999 when dealing
 * with numbers that are really 1 or 0.
 * @param {TRadian} angle the angle
 * @return {Number} the cosin value for angle.
 */ const $ab3f2a5cc6216ae5$var$cos = (angle)=>{
    if (angle === 0) return 1;
    const angleSlice = Math.abs(angle) / $ab3f2a5cc6216ae5$var$halfPI;
    switch(angleSlice){
        case 1:
        case 3:
            return 0;
        case 2:
            return -1;
    }
    return Math.cos(angle);
};
/**
 * Calculate the cos of an angle, avoiding returning floats for known results
 * This function is here just to avoid getting 0.999999999999999 when dealing
 * with numbers that are really 1 or 0.
 * @param {TRadian} angle the angle
 * @return {Number} the sin value for angle.
 */ const $ab3f2a5cc6216ae5$var$sin = (angle)=>{
    if (angle === 0) return 0;
    const angleSlice = angle / $ab3f2a5cc6216ae5$var$halfPI;
    const value = Math.sign(angle);
    switch(angleSlice){
        case 1:
            return value;
        case 2:
            return 0;
        case 3:
            return -value;
    }
    return Math.sin(angle);
};
/**
 * Adaptation of work of Kevin Lindsey(kevin@kevlindev.com)
 */ class $ab3f2a5cc6216ae5$export$baf26146a414f24a {
    constructor(){
        let arg0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof arg0 === "object") {
            this.x = arg0.x;
            this.y = arg0.y;
        } else {
            this.x = arg0;
            this.y = y;
        }
    }
    /**
   * Adds another point to this one and returns another one
   * @param {XY} that
   * @return {Point} new Point instance with added values
   */ add(that) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x + that.x, this.y + that.y);
    }
    /**
   * Adds another point to this one
   * @param {XY} that
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ addEquals(that) {
        this.x += that.x;
        this.y += that.y;
        return this;
    }
    /**
   * Adds value to this point and returns a new one
   * @param {Number} scalar
   * @return {Point} new Point with added value
   */ scalarAdd(scalar) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x + scalar, this.y + scalar);
    }
    /**
   * Adds value to this point
   * @param {Number} scalar
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ scalarAddEquals(scalar) {
        this.x += scalar;
        this.y += scalar;
        return this;
    }
    /**
   * Subtracts another point from this point and returns a new one
   * @param {XY} that
   * @return {Point} new Point object with subtracted values
   */ subtract(that) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x - that.x, this.y - that.y);
    }
    /**
   * Subtracts another point from this point
   * @param {XY} that
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ subtractEquals(that) {
        this.x -= that.x;
        this.y -= that.y;
        return this;
    }
    /**
   * Subtracts value from this point and returns a new one
   * @param {Number} scalar
   * @return {Point}
   */ scalarSubtract(scalar) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x - scalar, this.y - scalar);
    }
    /**
   * Subtracts value from this point
   * @param {Number} scalar
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ scalarSubtractEquals(scalar) {
        this.x -= scalar;
        this.y -= scalar;
        return this;
    }
    /**
   * Multiplies this point by another value and returns a new one
   * @param {XY} that
   * @return {Point}
   */ multiply(that) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x * that.x, this.y * that.y);
    }
    /**
   * Multiplies this point by a value and returns a new one
   * @param {Number} scalar
   * @return {Point}
   */ scalarMultiply(scalar) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x * scalar, this.y * scalar);
    }
    /**
   * Multiplies this point by a value
   * @param {Number} scalar
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ scalarMultiplyEquals(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
   * Divides this point by another and returns a new one
   * @param {XY} that
   * @return {Point}
   */ divide(that) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x / that.x, this.y / that.y);
    }
    /**
   * Divides this point by a value and returns a new one
   * @param {Number} scalar
   * @return {Point}
   */ scalarDivide(scalar) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x / scalar, this.y / scalar);
    }
    /**
   * Divides this point by a value
   * @param {Number} scalar
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ scalarDivideEquals(scalar) {
        this.x /= scalar;
        this.y /= scalar;
        return this;
    }
    /**
   * Returns true if this point is equal to another one
   * @param {XY} that
   * @return {Boolean}
   */ eq(that) {
        return this.x === that.x && this.y === that.y;
    }
    /**
   * Returns true if this point is less than another one
   * @param {XY} that
   * @return {Boolean}
   */ lt(that) {
        return this.x < that.x && this.y < that.y;
    }
    /**
   * Returns true if this point is less than or equal to another one
   * @param {XY} that
   * @return {Boolean}
   */ lte(that) {
        return this.x <= that.x && this.y <= that.y;
    }
    /**
    * Returns true if this point is greater another one
   * @param {XY} that
   * @return {Boolean}
   */ gt(that) {
        return this.x > that.x && this.y > that.y;
    }
    /**
   * Returns true if this point is greater than or equal to another one
   * @param {XY} that
   * @return {Boolean}
   */ gte(that) {
        return this.x >= that.x && this.y >= that.y;
    }
    /**
   * Returns new point which is the result of linear interpolation with this one and another one
   * @param {XY} that
   * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
   * @return {Point}
   */ lerp(that) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
        t = Math.max(Math.min(1, t), 0);
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
    }
    /**
   * Returns distance from this point and another one
   * @param {XY} that
   * @return {Number}
   */ distanceFrom(that) {
        const dx = this.x - that.x, dy = this.y - that.y;
        return Math.sqrt(dx * dx + dy * dy);
    }
    /**
   * Returns the point between this point and another one
   * @param {XY} that
   * @return {Point}
   */ midPointFrom(that) {
        return this.lerp(that);
    }
    /**
   * Returns a new point which is the min of this and another one
   * @param {XY} that
   * @return {Point}
   */ min(that) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(Math.min(this.x, that.x), Math.min(this.y, that.y));
    }
    /**
   * Returns a new point which is the max of this and another one
   * @param {XY} that
   * @return {Point}
   */ max(that) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(Math.max(this.x, that.x), Math.max(this.y, that.y));
    }
    /**
   * Returns string representation of this point
   * @return {String}
   */ toString() {
        return "".concat(this.x, ",").concat(this.y);
    }
    /**
   * Sets x/y of this point
   * @param {Number} x
   * @param {Number} y
   * @chainable
   */ setXY(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
   * Sets x of this point
   * @param {Number} x
   * @chainable
   */ setX(x) {
        this.x = x;
        return this;
    }
    /**
   * Sets y of this point
   * @param {Number} y
   * @chainable
   */ setY(y) {
        this.y = y;
        return this;
    }
    /**
   * Sets x/y of this point from another point
   * @param {XY} that
   * @chainable
   */ setFromPoint(that) {
        this.x = that.x;
        this.y = that.y;
        return this;
    }
    /**
   * Swaps x/y of this point and another point
   * @param {XY} that
   */ swap(that) {
        const x = this.x, y = this.y;
        this.x = that.x;
        this.y = that.y;
        that.x = x;
        that.y = y;
    }
    /**
   * return a cloned instance of the point
   * @return {Point}
   */ clone() {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Rotates `point` around `origin` with `radians`
   * @static
   * @memberOf fabric.util
   * @param {XY} origin The origin of the rotation
   * @param {TRadian} radians The radians of the angle for the rotation
   * @return {Point} The new rotated point
   */ rotate(radians) {
        let origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ab3f2a5cc6216ae5$var$ZERO;
        // TODO benchmark and verify the add and subtract how much cost
        // and then in case early return if no origin is passed
        const sinus = $ab3f2a5cc6216ae5$var$sin(radians), cosinus = $ab3f2a5cc6216ae5$var$cos(radians);
        const p = this.subtract(origin);
        const rotated = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(p.x * cosinus - p.y * sinus, p.x * sinus + p.y * cosinus);
        return rotated.add(origin);
    }
    /**
   * Apply transform t to point p
   * @static
   * @memberOf fabric.util
   * @param  {TMat2D} t The transform
   * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
   * @return {Point} The transformed point
   */ transform(t) {
        let ignoreOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(t[0] * this.x + t[2] * this.y + (ignoreOffset ? 0 : t[4]), t[1] * this.x + t[3] * this.y + (ignoreOffset ? 0 : t[5]));
    }
}
const $ab3f2a5cc6216ae5$var$ZERO = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(0, 0);
const $ab3f2a5cc6216ae5$var$isCollection = (fabricObject)=>{
    return !!fabricObject && Array.isArray(fabricObject._objects);
};
function $ab3f2a5cc6216ae5$export$f589b6d5b7ad4722(Base) {
    class Collection extends Base {
        constructor(){
            super(...arguments);
            /**
       * @type {FabricObject[]}
       * @TODO needs to end up in the constructor too
       */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_objects", []);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _onObjectAdded(object) {
        // subclasses should override this method
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _onObjectRemoved(object) {
        // subclasses should override this method
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _onStackOrderChanged(object) {
        // subclasses should override this method
        }
        /**
     * Adds objects to collection
     * Objects should be instances of (or inherit from) FabricObject
     * @param {...FabricObject[]} objects to add
     * @returns {number} new array length
     */ add() {
            for(var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++)objects[_key] = arguments[_key];
            const size = this._objects.push(...objects);
            objects.forEach((object)=>this._onObjectAdded(object));
            return size;
        }
        /**
     * Inserts an object into collection at specified index
     * @param {number} index Index to insert object at
     * @param {...FabricObject[]} objects Object(s) to insert
     * @returns {number} new array length
     */ insertAt(index) {
            for(var _len2 = arguments.length, objects = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)objects[_key2 - 1] = arguments[_key2];
            this._objects.splice(index, 0, ...objects);
            objects.forEach((object)=>this._onObjectAdded(object));
            return this._objects.length;
        }
        /**
     * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
     * @private
     * @param {...FabricObject[]} objects objects to remove
     * @returns {FabricObject[]} removed objects
     */ remove() {
            const array = this._objects, removed = [];
            for(var _len3 = arguments.length, objects = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)objects[_key3] = arguments[_key3];
            objects.forEach((object)=>{
                const index = array.indexOf(object);
                // only call onObjectRemoved if an object was actually removed
                if (index !== -1) {
                    array.splice(index, 1);
                    removed.push(object);
                    this._onObjectRemoved(object);
                }
            });
            return removed;
        }
        /**
     * Executes given function for each object in this group
     * A simple shortcut for getObjects().forEach, before es6 was more complicated,
     * now is just a shortcut.
     * @param {Function} callback
     *                   Callback invoked with current object as first argument,
     *                   index - as second and an array of all objects - as third.
     */ forEachObject(callback) {
            this.getObjects().forEach((object, index, objects)=>callback(object, index, objects));
        }
        /**
     * Returns an array of children objects of this instance
     * @param {...String} [types] When specified, only objects of these types are returned
     * @return {Array}
     */ getObjects() {
            for(var _len4 = arguments.length, types = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)types[_key4] = arguments[_key4];
            if (types.length === 0) return [
                ...this._objects
            ];
            return this._objects.filter((o)=>o.isType(...types));
        }
        /**
     * Returns object at specified index
     * @param {Number} index
     * @return {Object} object at index
     */ item(index) {
            return this._objects[index];
        }
        /**
     * Returns true if collection contains no objects
     * @return {Boolean} true if collection is empty
     */ isEmpty() {
            return this._objects.length === 0;
        }
        /**
     * Returns a size of a collection (i.e: length of an array containing its objects)
     * @return {Number} Collection size
     */ size() {
            return this._objects.length;
        }
        /**
     * Returns true if collection contains an object.\
     * **Prefer using {@link FabricObject#isDescendantOf} for performance reasons**
     * instead of `a.contains(b)` use `b.isDescendantOf(a)`
     * @param {Object} object Object to check against
     * @param {Boolean} [deep=false] `true` to check all descendants, `false` to check only `_objects`
     * @return {Boolean} `true` if collection contains an object
     */ contains(object, deep) {
            if (this._objects.includes(object)) return true;
            else if (deep) return this._objects.some((obj)=>obj instanceof Collection && obj.contains(object, true));
            return false;
        }
        /**
     * Returns number representation of a collection complexity
     * @return {Number} complexity
     */ complexity() {
            return this._objects.reduce((memo, current)=>{
                memo += current.complexity ? current.complexity() : 0;
                return memo;
            }, 0);
        }
        /**
     * Moves an object or the objects of a multiple selection
     * to the bottom of the stack of drawn objects
     * @param {fabric.Object} object Object to send to back
     * @returns {boolean} true if change occurred
     */ sendObjectToBack(object) {
            if (!object || object === this._objects[0]) return false;
            $ab3f2a5cc6216ae5$var$removeFromArray(this._objects, object);
            this._objects.unshift(object);
            this._onStackOrderChanged(object);
            return true;
        }
        /**
     * Moves an object or the objects of a multiple selection
     * to the top of the stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @returns {boolean} true if change occurred
     */ bringObjectToFront(object) {
            if (!object || object === this._objects[this._objects.length - 1]) return false;
            $ab3f2a5cc6216ae5$var$removeFromArray(this._objects, object);
            this._objects.push(object);
            this._onStackOrderChanged(object);
            return true;
        }
        /**
     * Moves an object or a selection down in stack of drawn objects
     * An optional parameter, `intersecting` allows to move the object in behind
     * the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {boolean} [intersecting] If `true`, send object behind next lower intersecting object
     * @returns {boolean} true if change occurred
     */ sendObjectBackwards(object, intersecting) {
            if (!object) return false;
            const idx = this._objects.indexOf(object);
            if (idx !== 0) {
                // if object is not on the bottom of stack
                const newIdx = this.findNewLowerIndex(object, idx, intersecting);
                $ab3f2a5cc6216ae5$var$removeFromArray(this._objects, object);
                this._objects.splice(newIdx, 0, object);
                this._onStackOrderChanged(object);
                return true;
            }
            return false;
        }
        /**
     * Moves an object or a selection up in stack of drawn objects
     * An optional parameter, intersecting allows to move the object in front
     * of the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {boolean} [intersecting] If `true`, send object in front of next upper intersecting object
     * @returns {boolean} true if change occurred
     */ bringObjectForward(object, intersecting) {
            if (!object) return false;
            const idx = this._objects.indexOf(object);
            if (idx !== this._objects.length - 1) {
                // if object is not on top of stack (last item in an array)
                const newIdx = this.findNewUpperIndex(object, idx, intersecting);
                $ab3f2a5cc6216ae5$var$removeFromArray(this._objects, object);
                this._objects.splice(newIdx, 0, object);
                this._onStackOrderChanged(object);
                return true;
            }
            return false;
        }
        /**
     * Moves an object to specified level in stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @param {number} index Position to move to
     * @returns {boolean} true if change occurred
     */ moveObjectTo(object, index) {
            if (object === this._objects[index]) return false;
            $ab3f2a5cc6216ae5$var$removeFromArray(this._objects, object);
            this._objects.splice(index, 0, object);
            this._onStackOrderChanged(object);
            return true;
        }
        findNewLowerIndex(object, idx, intersecting) {
            let newIdx;
            if (intersecting) {
                newIdx = idx;
                // traverse down the stack looking for the nearest intersecting object
                for(let i = idx - 1; i >= 0; --i)if (object.isOverlapping(this._objects[i])) {
                    newIdx = i;
                    break;
                }
            } else newIdx = idx - 1;
            return newIdx;
        }
        findNewUpperIndex(object, idx, intersecting) {
            let newIdx;
            if (intersecting) {
                newIdx = idx;
                // traverse up the stack looking for the nearest intersecting object
                for(let i = idx + 1; i < this._objects.length; ++i)if (object.isOverlapping(this._objects[i])) {
                    newIdx = i;
                    break;
                }
            } else newIdx = idx + 1;
            return newIdx;
        }
        /**
     * Given a bounding box, return all the objects of the collection that are contained in the bounding box.
     * If `includeIntersecting` is true, return also the objects that intersect the bounding box as well.
     * This is meant to work with selection. Is not a generic method.
     * @param {TBBox} bbox a bounding box in scene coordinates
     * @param {{ includeIntersecting?: boolean }} options an object with includeIntersecting
     * @returns array of objects contained in the bounding box, ordered from top to bottom stacking wise
     */ collectObjects(_ref) {
            let { left: left, top: top, width: width, height: height } = _ref;
            let { includeIntersecting: includeIntersecting = true } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            const objects = [], tl = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(left, top), br = tl.add(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(width, height));
            // we iterate reverse order to collect top first in case of click.
            for(let i = this._objects.length - 1; i >= 0; i--){
                const object = this._objects[i];
                if (object.selectable && object.visible && (includeIntersecting && object.intersectsWithRect(tl, br) || object.isContainedWithinRect(tl, br) || includeIntersecting && object.containsPoint(tl) || includeIntersecting && object.containsPoint(br))) objects.push(object);
            }
            return objects;
        }
    }
    // https://github.com/microsoft/TypeScript/issues/32080
    return Collection;
}
class $ab3f2a5cc6216ae5$var$CommonMethods extends $ab3f2a5cc6216ae5$export$77cea355fa80b5f4 {
    /**
   * Sets object's properties from options, for initialization only
   * @protected
   * @param {Object} [options] Options object
   */ _setOptions() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        for(const prop in options)this.set(prop, options[prop]);
    }
    /**
   * @private
   */ _setObject(obj) {
        for(const prop in obj)this._set(prop, obj[prop]);
    }
    /**
   * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
   * @param {String|Object} key Property name or object (if object, iterate over the object properties)
   * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
   */ set(key, value) {
        if (typeof key === "object") this._setObject(key);
        else this._set(key, value);
        return this;
    }
    _set(key, value) {
        this[key] = value;
    }
    /**
   * Toggles specified property from `true` to `false` or from `false` to `true`
   * @param {String} property Property to toggle
   */ toggle(property) {
        const value = this.get(property);
        if (typeof value === "boolean") this.set(property, !value);
        return this;
    }
    /**
   * Basic getter
   * @param {String} property Property name
   * @return {*} value of a property
   */ get(property) {
        return this[property];
    }
}
function $ab3f2a5cc6216ae5$var$requestAnimFrame(callback) {
    return $ab3f2a5cc6216ae5$export$4a3a3142573970c3().requestAnimationFrame(callback);
}
function $ab3f2a5cc6216ae5$var$cancelAnimFrame(handle) {
    return $ab3f2a5cc6216ae5$export$4a3a3142573970c3().cancelAnimationFrame(handle);
}
let $ab3f2a5cc6216ae5$var$id = 0;
const $ab3f2a5cc6216ae5$var$uid = ()=>$ab3f2a5cc6216ae5$var$id++;
/**
 * Creates canvas element
 * @return {CanvasElement} initialized canvas element
 */ const $ab3f2a5cc6216ae5$var$createCanvasElement = ()=>{
    const element = $ab3f2a5cc6216ae5$export$91e93c41e950ddbb().createElement("canvas");
    if (!element || typeof element.getContext === "undefined") throw new $ab3f2a5cc6216ae5$var$FabricError("Failed to create `canvas` element");
    return element;
};
/**
 * Creates image element (works on client and node)
 * @return {HTMLImageElement} HTML image element
 */ const $ab3f2a5cc6216ae5$var$createImage = ()=>$ab3f2a5cc6216ae5$export$91e93c41e950ddbb().createElement("img");
/**
 * Creates a canvas element that is a copy of another and is also painted
 * @param {CanvasElement} canvas to copy size and content of
 * @return {CanvasElement} initialized canvas element
 */ const $ab3f2a5cc6216ae5$var$copyCanvasElement = (canvas)=>{
    var _newCanvas$getContext;
    const newCanvas = $ab3f2a5cc6216ae5$var$createCanvasElement();
    newCanvas.width = canvas.width;
    newCanvas.height = canvas.height;
    (_newCanvas$getContext = newCanvas.getContext("2d")) === null || _newCanvas$getContext === void 0 || _newCanvas$getContext.drawImage(canvas, 0, 0);
    return newCanvas;
};
/**
 * since 2.6.0 moved from canvas instance to utility.
 * possibly useless
 * @param {CanvasElement} canvasEl to copy size and content of
 * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
 * @param {Number} quality <= 1 and > 0
 * @return {String} data url
 */ const $ab3f2a5cc6216ae5$var$toDataURL = (canvasEl, format, quality)=>canvasEl.toDataURL("image/".concat(format), quality);
const $ab3f2a5cc6216ae5$var$isHTMLCanvas = (canvas)=>{
    return !!canvas && canvas.getContext !== undefined;
};
/**
 * Transforms degrees to radians.
 * @param {TDegree} degrees value in degrees
 * @return {TRadian} value in radians
 */ const $ab3f2a5cc6216ae5$var$degreesToRadians = (degrees)=>degrees * $ab3f2a5cc6216ae5$var$PiBy180;
/**
 * Transforms radians to degrees.
 * @param {TRadian} radians value in radians
 * @return {TDegree} value in degrees
 */ const $ab3f2a5cc6216ae5$var$radiansToDegrees = (radians)=>radians / $ab3f2a5cc6216ae5$var$PiBy180;
const $ab3f2a5cc6216ae5$var$isIdentityMatrix = (mat)=>mat.every((value, index)=>value === $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0[index]);
/**
 * Apply transform t to point p
 * @deprecated use {@link Point#transform}
 * @param  {Point | XY} p The point to transform
 * @param  {Array} t The transform
 * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
 * @return {Point} The transformed point
 */ const $ab3f2a5cc6216ae5$var$transformPoint = (p, t, ignoreOffset)=>new $ab3f2a5cc6216ae5$export$baf26146a414f24a(p).transform(t, ignoreOffset);
/**
 * Invert transformation t
 * @param {Array} t The transform
 * @return {Array} The inverted transform
 */ const $ab3f2a5cc6216ae5$var$invertTransform = (t)=>{
    const a = 1 / (t[0] * t[3] - t[1] * t[2]), r = [
        a * t[3],
        -a * t[1],
        -a * t[2],
        a * t[0],
        0,
        0
    ], { x: x, y: y } = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(t[4], t[5]).transform(r, true);
    r[4] = -x;
    r[5] = -y;
    return r;
};
/**
 * Multiply matrix A by matrix B to nest transformations
 * @param  {TMat2D} a First transformMatrix
 * @param  {TMat2D} b Second transformMatrix
 * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
 * @return {TMat2D} The product of the two transform matrices
 */ const $ab3f2a5cc6216ae5$var$multiplyTransformMatrices = (a, b, is2x2)=>[
        a[0] * b[0] + a[2] * b[1],
        a[1] * b[0] + a[3] * b[1],
        a[0] * b[2] + a[2] * b[3],
        a[1] * b[2] + a[3] * b[3],
        is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4],
        is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]
    ];
/**
 * Multiplies {@link matrices} such that a matrix defines the plane for the rest of the matrices **after** it
 *
 * `multiplyTransformMatrixArray([A, B, C, D])` is equivalent to `A(B(C(D)))`
 *
 * @param matrices an array of matrices
 * @param [is2x2] flag to multiply matrices as 2x2 matrices
 * @returns the multiplication product
 */ const $ab3f2a5cc6216ae5$var$multiplyTransformMatrixArray = (matrices, is2x2)=>matrices.reduceRight((product, curr)=>curr && product ? $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(curr, product, is2x2) : curr || product, undefined) || $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0.concat();
const $ab3f2a5cc6216ae5$var$calcPlaneRotation = (_ref)=>{
    let [a, b] = _ref;
    return Math.atan2(b, a);
};
/**
 * Decomposes standard 2x3 matrix into transform components
 * @param  {TMat2D} a transformMatrix
 * @return {Object} Components of transform
 */ const $ab3f2a5cc6216ae5$var$qrDecompose = (a)=>{
    const angle = $ab3f2a5cc6216ae5$var$calcPlaneRotation(a), denom = Math.pow(a[0], 2) + Math.pow(a[1], 2), scaleX = Math.sqrt(denom), scaleY = (a[0] * a[3] - a[2] * a[1]) / scaleX, skewX = Math.atan2(a[0] * a[2] + a[1] * a[3], denom);
    return {
        angle: $ab3f2a5cc6216ae5$var$radiansToDegrees(angle),
        scaleX: scaleX,
        scaleY: scaleY,
        skewX: $ab3f2a5cc6216ae5$var$radiansToDegrees(skewX),
        skewY: 0,
        translateX: a[4] || 0,
        translateY: a[5] || 0
    };
};
/**
 * Generate a translation matrix
 *
 * A translation matrix in the form of
 * [ 1 0 x ]
 * [ 0 1 y ]
 * [ 0 0 1 ]
 *
 * See @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#translate for more details
 *
 * @param {number} x translation on X axis
 * @param {number} [y] translation on Y axis
 * @returns {TMat2D} matrix
 */ const $ab3f2a5cc6216ae5$var$createTranslateMatrix = function(x) {
    let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return [
        1,
        0,
        0,
        1,
        x,
        y
    ];
};
/**
 * Generate a rotation matrix around around a point (x,y), defaulting to (0,0)
 *
 * A matrix in the form of
 * [cos(a) -sin(a) -x*cos(a)+y*sin(a)+x]
 * [sin(a)  cos(a) -x*sin(a)-y*cos(a)+y]
 * [0       0      1                 ]
 *
 *
 * @param {TDegree} angle rotation in degrees
 * @param {XY} [pivotPoint] pivot point to rotate around
 * @returns {TMat2D} matrix
 */ function $ab3f2a5cc6216ae5$var$createRotateMatrix() {
    let { angle: angle = 0 } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let { x: x = 0, y: y = 0 } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const angleRadiant = $ab3f2a5cc6216ae5$var$degreesToRadians(angle), cosValue = $ab3f2a5cc6216ae5$var$cos(angleRadiant), sinValue = $ab3f2a5cc6216ae5$var$sin(angleRadiant);
    return [
        cosValue,
        sinValue,
        -sinValue,
        cosValue,
        x ? x - (cosValue * x - sinValue * y) : 0,
        y ? y - (sinValue * x + cosValue * y) : 0
    ];
}
/**
 * Generate a scale matrix around the point (0,0)
 *
 * A matrix in the form of
 * [x 0 0]
 * [0 y 0]
 * [0 0 1]
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#scale
 *
 * @param {number} x scale on X axis
 * @param {number} [y] scale on Y axis
 * @returns {TMat2D} matrix
 */ const $ab3f2a5cc6216ae5$var$createScaleMatrix = function(x) {
    let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
    return [
        x,
        0,
        0,
        y,
        0,
        0
    ];
};
const $ab3f2a5cc6216ae5$var$angleToSkew = (angle)=>Math.tan($ab3f2a5cc6216ae5$var$degreesToRadians(angle));
/**
 * Generate a skew matrix for the X axis
 *
 * A matrix in the form of
 * [1 x 0]
 * [0 1 0]
 * [0 0 1]
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#skewx
 *
 * @param {TDegree} skewValue translation on X axis
 * @returns {TMat2D} matrix
 */ const $ab3f2a5cc6216ae5$var$createSkewXMatrix = (skewValue)=>[
        1,
        0,
        $ab3f2a5cc6216ae5$var$angleToSkew(skewValue),
        1,
        0,
        0
    ];
/**
 * Generate a skew matrix for the Y axis
 *
 * A matrix in the form of
 * [1 0 0]
 * [y 1 0]
 * [0 0 1]
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#skewy
 *
 * @param {TDegree} skewValue translation on Y axis
 * @returns {TMat2D} matrix
 */ const $ab3f2a5cc6216ae5$var$createSkewYMatrix = (skewValue)=>[
        1,
        $ab3f2a5cc6216ae5$var$angleToSkew(skewValue),
        0,
        1,
        0,
        0
    ];
/**
 * Returns a transform matrix starting from an object of the same kind of
 * the one returned from qrDecompose, useful also if you want to calculate some
 * transformations from an object that is not enlived yet.
 * is called DimensionsTransformMatrix because those properties are the one that influence
 * the size of the resulting box of the object.
 * @param  {Object} options
 * @param  {Number} [options.scaleX]
 * @param  {Number} [options.scaleY]
 * @param  {Boolean} [options.flipX]
 * @param  {Boolean} [options.flipY]
 * @param  {Number} [options.skewX]
 * @param  {Number} [options.skewY]
 * @return {Number[]} transform matrix
 */ const $ab3f2a5cc6216ae5$var$calcDimensionsMatrix = (_ref2)=>{
    let { scaleX: scaleX = 1, scaleY: scaleY = 1, flipX: flipX = false, flipY: flipY = false, skewX: skewX = 0, skewY: skewY = 0 } = _ref2;
    let matrix = $ab3f2a5cc6216ae5$var$createScaleMatrix(flipX ? -scaleX : scaleX, flipY ? -scaleY : scaleY);
    if (skewX) matrix = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(matrix, $ab3f2a5cc6216ae5$var$createSkewXMatrix(skewX), true);
    if (skewY) matrix = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(matrix, $ab3f2a5cc6216ae5$var$createSkewYMatrix(skewY), true);
    return matrix;
};
/**
 * Returns a transform matrix starting from an object of the same kind of
 * the one returned from qrDecompose, useful also if you want to calculate some
 * transformations from an object that is not enlived yet
 * Before changing this function look at: src/benchmarks/calcTransformMatrix.mjs
 * @param  {Object} options
 * @param  {Number} [options.angle]
 * @param  {Number} [options.scaleX]
 * @param  {Number} [options.scaleY]
 * @param  {Boolean} [options.flipX]
 * @param  {Boolean} [options.flipY]
 * @param  {Number} [options.skewX]
 * @param  {Number} [options.skewY]
 * @param  {Number} [options.translateX]
 * @param  {Number} [options.translateY]
 * @return {Number[]} transform matrix
 */ const $ab3f2a5cc6216ae5$var$composeMatrix = (options)=>{
    const { translateX: translateX = 0, translateY: translateY = 0, angle: angle = 0 } = options;
    let matrix = $ab3f2a5cc6216ae5$var$createTranslateMatrix(translateX, translateY);
    if (angle) matrix = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(matrix, $ab3f2a5cc6216ae5$var$createRotateMatrix({
        angle: angle
    }));
    const scaleMatrix = $ab3f2a5cc6216ae5$var$calcDimensionsMatrix(options);
    if (!$ab3f2a5cc6216ae5$var$isIdentityMatrix(scaleMatrix)) matrix = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(matrix, scaleMatrix);
    return matrix;
};
/**
 * Loads image element from given url and resolve it, or catch.
 * @param {String} url URL representing an image
 * @param {LoadImageOptions} [options] image loading options
 * @returns {Promise<HTMLImageElement>} the loaded image.
 */ const $ab3f2a5cc6216ae5$var$loadImage = function(url) {
    let { signal: signal, crossOrigin: crossOrigin = null } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function(resolve, reject) {
        if (signal && signal.aborted) return reject(new $ab3f2a5cc6216ae5$var$SignalAbortedError("loadImage"));
        const img = $ab3f2a5cc6216ae5$var$createImage();
        let abort;
        if (signal) {
            abort = function(err) {
                img.src = "";
                reject(err);
            };
            signal.addEventListener("abort", abort, {
                once: true
            });
        }
        const done = function() {
            img.onload = img.onerror = null;
            abort && (signal === null || signal === void 0 || signal.removeEventListener("abort", abort));
            resolve(img);
        };
        if (!url) {
            done();
            return;
        }
        img.onload = done;
        img.onerror = function() {
            abort && (signal === null || signal === void 0 || signal.removeEventListener("abort", abort));
            reject(new $ab3f2a5cc6216ae5$var$FabricError("Error loading ".concat(img.src)));
        };
        crossOrigin && (img.crossOrigin = crossOrigin);
        img.src = url;
    });
};
/**
 * @TODO type this correctly.
 * Creates corresponding fabric instances from their object representations
 * @param {Object[]} objects Objects to enliven
 * @param {EnlivenObjectOptions} [options]
 * @param {(serializedObj: object, instance: FabricObject) => any} [options.reviver] Method for further parsing of object elements,
 * called after each fabric object created.
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 * @returns {Promise<FabricObject[]>}
 */ const $ab3f2a5cc6216ae5$var$enlivenObjects = function(objects) {
    let { signal: signal, reviver: reviver = $ab3f2a5cc6216ae5$var$noop } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise((resolve, reject)=>{
        const instances = [];
        signal && signal.addEventListener("abort", reject, {
            once: true
        });
        Promise.all(objects.map((obj)=>$ab3f2a5cc6216ae5$export$2792378e23a7920c.getClass(obj.type).fromObject(obj, {
                signal: signal
            }).then((fabricInstance)=>{
                reviver(obj, fabricInstance);
                instances.push(fabricInstance);
                return fabricInstance;
            }))).then(resolve).catch((error)=>{
            // cleanup
            instances.forEach((instance)=>{
                instance.dispose && instance.dispose();
            });
            reject(error);
        }).finally(()=>{
            signal && signal.removeEventListener("abort", reject);
        });
    });
};
/**
 * Creates corresponding fabric instances residing in an object, e.g. `clipPath`
 * @param {Object} object with properties to enlive ( fill, stroke, clipPath, path )
 * @param {object} [options]
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 * @returns {Promise<Record<string, FabricObject | TFiller | null>>} the input object with enlived values
 */ const $ab3f2a5cc6216ae5$var$enlivenObjectEnlivables = function(serializedObject) {
    let { signal: signal } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise((resolve, reject)=>{
        const instances = [];
        signal && signal.addEventListener("abort", reject, {
            once: true
        });
        // enlive every possible property
        const promises = Object.values(serializedObject).map((value)=>{
            if (!value) return value;
            // clipPath or shadow or gradient
            if (value.type) return $ab3f2a5cc6216ae5$var$enlivenObjects([
                value
            ], {
                signal: signal
            }).then((_ref)=>{
                let [enlived] = _ref;
                instances.push(enlived);
                return enlived;
            });
            // pattern
            if (value.source) return $ab3f2a5cc6216ae5$export$2792378e23a7920c.getClass("pattern").fromObject(value, {
                signal: signal
            }).then((pattern)=>{
                instances.push(pattern);
                return pattern;
            });
            return value;
        });
        const keys = Object.keys(serializedObject);
        Promise.all(promises).then((enlived)=>{
            return enlived.reduce((acc, instance, index)=>{
                acc[keys[index]] = instance;
                return acc;
            }, {});
        }).then(resolve).catch((error)=>{
            // cleanup
            instances.forEach((instance)=>{
                instance.dispose && instance.dispose();
            });
            reject(error);
        }).finally(()=>{
            signal && signal.removeEventListener("abort", reject);
        });
    });
};
/**
 * Populates an object with properties of another object
 * @param {Object} source Source object
 * @param {string[]} properties Properties names to include
 * @returns object populated with the picked keys
 */ const $ab3f2a5cc6216ae5$var$pick = function(source) {
    let keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return keys.reduce((o, key)=>{
        if (key in source) o[key] = source[key];
        return o;
    }, {});
};
const $ab3f2a5cc6216ae5$var$pickBy = (source, predicate)=>{
    return Object.keys(source).reduce((o, key)=>{
        if (predicate(source[key], key, source)) o[key] = source[key];
        return o;
    }, {});
};
/**
 * Map of the 148 color names with HEX code
 * @see: https://www.w3.org/TR/css3-color/#svg-color
 */ const $ab3f2a5cc6216ae5$var$ColorNameMap = {
    aliceblue: "#F0F8FF",
    antiquewhite: "#FAEBD7",
    aqua: "#0FF",
    aquamarine: "#7FFFD4",
    azure: "#F0FFFF",
    beige: "#F5F5DC",
    bisque: "#FFE4C4",
    black: "#000",
    blanchedalmond: "#FFEBCD",
    blue: "#00F",
    blueviolet: "#8A2BE2",
    brown: "#A52A2A",
    burlywood: "#DEB887",
    cadetblue: "#5F9EA0",
    chartreuse: "#7FFF00",
    chocolate: "#D2691E",
    coral: "#FF7F50",
    cornflowerblue: "#6495ED",
    cornsilk: "#FFF8DC",
    crimson: "#DC143C",
    cyan: "#0FF",
    darkblue: "#00008B",
    darkcyan: "#008B8B",
    darkgoldenrod: "#B8860B",
    darkgray: "#A9A9A9",
    darkgrey: "#A9A9A9",
    darkgreen: "#006400",
    darkkhaki: "#BDB76B",
    darkmagenta: "#8B008B",
    darkolivegreen: "#556B2F",
    darkorange: "#FF8C00",
    darkorchid: "#9932CC",
    darkred: "#8B0000",
    darksalmon: "#E9967A",
    darkseagreen: "#8FBC8F",
    darkslateblue: "#483D8B",
    darkslategray: "#2F4F4F",
    darkslategrey: "#2F4F4F",
    darkturquoise: "#00CED1",
    darkviolet: "#9400D3",
    deeppink: "#FF1493",
    deepskyblue: "#00BFFF",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1E90FF",
    firebrick: "#B22222",
    floralwhite: "#FFFAF0",
    forestgreen: "#228B22",
    fuchsia: "#F0F",
    gainsboro: "#DCDCDC",
    ghostwhite: "#F8F8FF",
    gold: "#FFD700",
    goldenrod: "#DAA520",
    gray: "#808080",
    grey: "#808080",
    green: "#008000",
    greenyellow: "#ADFF2F",
    honeydew: "#F0FFF0",
    hotpink: "#FF69B4",
    indianred: "#CD5C5C",
    indigo: "#4B0082",
    ivory: "#FFFFF0",
    khaki: "#F0E68C",
    lavender: "#E6E6FA",
    lavenderblush: "#FFF0F5",
    lawngreen: "#7CFC00",
    lemonchiffon: "#FFFACD",
    lightblue: "#ADD8E6",
    lightcoral: "#F08080",
    lightcyan: "#E0FFFF",
    lightgoldenrodyellow: "#FAFAD2",
    lightgray: "#D3D3D3",
    lightgrey: "#D3D3D3",
    lightgreen: "#90EE90",
    lightpink: "#FFB6C1",
    lightsalmon: "#FFA07A",
    lightseagreen: "#20B2AA",
    lightskyblue: "#87CEFA",
    lightslategray: "#789",
    lightslategrey: "#789",
    lightsteelblue: "#B0C4DE",
    lightyellow: "#FFFFE0",
    lime: "#0F0",
    limegreen: "#32CD32",
    linen: "#FAF0E6",
    magenta: "#F0F",
    maroon: "#800000",
    mediumaquamarine: "#66CDAA",
    mediumblue: "#0000CD",
    mediumorchid: "#BA55D3",
    mediumpurple: "#9370DB",
    mediumseagreen: "#3CB371",
    mediumslateblue: "#7B68EE",
    mediumspringgreen: "#00FA9A",
    mediumturquoise: "#48D1CC",
    mediumvioletred: "#C71585",
    midnightblue: "#191970",
    mintcream: "#F5FFFA",
    mistyrose: "#FFE4E1",
    moccasin: "#FFE4B5",
    navajowhite: "#FFDEAD",
    navy: "#000080",
    oldlace: "#FDF5E6",
    olive: "#808000",
    olivedrab: "#6B8E23",
    orange: "#FFA500",
    orangered: "#FF4500",
    orchid: "#DA70D6",
    palegoldenrod: "#EEE8AA",
    palegreen: "#98FB98",
    paleturquoise: "#AFEEEE",
    palevioletred: "#DB7093",
    papayawhip: "#FFEFD5",
    peachpuff: "#FFDAB9",
    peru: "#CD853F",
    pink: "#FFC0CB",
    plum: "#DDA0DD",
    powderblue: "#B0E0E6",
    purple: "#800080",
    rebeccapurple: "#639",
    red: "#F00",
    rosybrown: "#BC8F8F",
    royalblue: "#4169E1",
    saddlebrown: "#8B4513",
    salmon: "#FA8072",
    sandybrown: "#F4A460",
    seagreen: "#2E8B57",
    seashell: "#FFF5EE",
    sienna: "#A0522D",
    silver: "#C0C0C0",
    skyblue: "#87CEEB",
    slateblue: "#6A5ACD",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#FFFAFA",
    springgreen: "#00FF7F",
    steelblue: "#4682B4",
    tan: "#D2B48C",
    teal: "#008080",
    thistle: "#D8BFD8",
    tomato: "#FF6347",
    turquoise: "#40E0D0",
    violet: "#EE82EE",
    wheat: "#F5DEB3",
    white: "#FFF",
    whitesmoke: "#F5F5F5",
    yellow: "#FF0",
    yellowgreen: "#9ACD32"
};
/**
 * Regex matching color in RGB or RGBA formats (ex: `rgb(0, 0, 0)`, `rgba(255, 100, 10, 0.5)`, `rgba( 255 , 100 , 10 , 0.5 )`, `rgb(1,1,1)`, `rgba(100%, 60%, 10%, 0.5)`)
 * Also matching rgba(r g b / a) as per new specs
 * https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/rgb
 * Formal syntax at the time of writing:
 * <rgb()> =
 *  rgb( [ <percentage> | none ]{3} [ / [ <alpha-value> | none ] ]? )  |
 *  rgb( [ <number> | none ]{3} [ / [ <alpha-value> | none ] ]? )
 * <alpha-value> = <number> | <percentage>
 *
 * For learners this is how you can read this regex
 * Regular expression for matching an rgba or rgb CSS color value
 *
 * /^          # Beginning of the string
 * rgba?       # "rgb" or "rgba"
 * \(\s*       # Opening parenthesis and optional whitespace
 * (\d{0,3}    # 0 to three digits R channel
 *  (?:\.\d+)? # Optional decimal with one or more digits
 * )           # End of capturing group for the first color component
 * %?          # Optional percent sign after the first color component
 * \s*         # Optional whitespace
 * [\s|,]      # Separator between color components can be a space or comma
 * \s*         # Optional whitespace
 * (\d{0,3}    # 0 to three digits G channel
 *  (?:\.\d+)? # Optional decimal with one or more digits
 * )           # End of capturing group for the second color component
 * %?          # Optional percent sign after the second color component
 * \s*         # Optional whitespace
 * [\s|,]      # Separator between color components can be a space or comma
 * \s*         # Optional whitespace
 * (\d{0,3}    # 0 to three digits B channel
 *  (?:\.\d+)? # Optional decimal with one or more digits
 * )           # End of capturing group for the third color component
 * %?          # Optional percent sign after the third color component
 * \s*         # Optional whitespace
 * (?:         # Beginning of non-capturing group for alpha value
 *  \s*        # Optional whitespace
 *  [,/]       # Comma or slash separator for alpha value
 *  \s*        # Optional whitespace
 *  (\d{0,3}   # Zero to three digits
 *    (?:\.\d+)? # Optional decimal with one or more digits
 *  )          # End of capturing group for alpha value
 *  %?         # Optional percent sign after alpha value
 *  \s*        # Optional whitespace
 * )?          # End of non-capturing group for alpha value (optional)
 * \)          # Closing parenthesis
 * $           # End of the string
 *
 * The alpha channel can be in the format 0.4 .7 or 1 or 73%
 *
 * WARNING this regex doesn't fail on off spec colors. it matches everything that could be a color.
 * So the spec does not allow for `rgba(30 , 45%  35, 49%)` but this will work anyways for us
 */ const $ab3f2a5cc6216ae5$var$reRGBa = ()=>/^rgba?\(\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*(?:\s*[,/]\s*(\d{0,3}(?:\.\d+)?%?)\s*)?\)$/i;
/**
 * Regex matching color in HSL or HSLA formats (ex: hsl(0, 0, 0), rgba(255, 100, 10, 0.5), rgba( 255 , 100 , 10 , 0.5 ), rgb(1,1,1), rgba(100%, 60%, 10%, 0.5))
 * Also matching rgba(r g b / a) as per new specs
 * https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/hsl
 * Formal syntax at the time of writing:
 * <hsl()> =
 *   hsl( [ <hue> | none ] [ <percentage> | none ] [ <percentage> | none ] [ / [ <alpha-value> | none ] ]? )
 *
 * <hue> =
 *   <number>  |
 *   <angle>
 *
 * <alpha-value> =
 *   <number>      |
 *   <percentage>
 *
 * For learners this is how you can read this regex
 * Regular expression for matching an hsla or hsl CSS color value
 *
 * /^hsla?\(         // Matches the beginning of the string and the opening parenthesis of "hsl" or "hsla"
 * \s*               // Matches any whitespace characters (space, tab, etc.) zero or more times
 * (\d{0,3}          // Hue: 0 to three digits - start capture in a group
 * (?:\.\d+)?        // Hue: Optional (non capture group) decimal with one or more digits.
 * (?:deg|turn|rad)? // Hue: Optionally include suffix deg or turn or rad
 * )                 // Hue: End capture group
 * \s*               // Matches any whitespace characters zero or more times
 * [\s|,]            // Matches a space, tab or comma
 * \s*               // Matches any whitespace characters zero or more times
 * (\d{0,3}          // Saturation: 0 to three digits - start capture in a group
 * (?:\.\d+)?        // Saturation: Optional decimal with one or more digits in a non-capturing group
 * %?)               // Saturation: match optional % character and end capture group
 * \s*               // Matches any whitespace characters zero or more times
 * [\s|,]            // Matches a space, tab or comma
 * \s*               // Matches any whitespace characters zero or more times
 * (\d{0,3}          // Lightness: 0 to three digits - start capture in a group
 * (?:\.\d+)?        // Lightness: Optional decimal with one or more digits in a non-capturing group
 * %?)                // Lightness: match % character and end capture group
 * \s*               // Matches any whitespace characters zero or more times
 * (?:               // Alpha: Begins a non-capturing group for the alpha value
 *   \s*             // Matches any whitespace characters zero or more times
 *   [,/]            // Matches a comma or forward slash
 *   \s*             // Matches any whitespace characters zero or more times
 *   (\d*(?:\.\d+)?%?) // Matches zero or more digits, optionally followed by a decimal point and one or more digits, followed by an optional percentage sign and captures it in a group
 *   \s*             // Matches any whitespace characters zero or more times
 * )?                // Makes the alpha value group optional
 * \)                // Matches the closing parenthesis
 * $/i               // Matches the end of the string and sets the regular expression to case-insensitive mode
 *
 * WARNING this regex doesn't fail on off spec colors. It matches everything that could be a color.
 * So the spec does not allow `hsl(30 , 45%  35, 49%)` but this will work anyways for us.
 */ const $ab3f2a5cc6216ae5$var$reHSLa = ()=>/^hsla?\(\s*([+-]?\d{0,3}(?:\.\d+)?(?:deg|turn|rad)?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*(?:\s*[,/]\s*(\d*(?:\.\d+)?%?)\s*)?\)$/i;
/**
 * Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
 */ const $ab3f2a5cc6216ae5$var$reHex = ()=>/^#?(([0-9a-f]){3,4}|([0-9a-f]{2}){3,4})$/i;
/**
 * @param {Number} p
 * @param {Number} q
 * @param {Number} t
 * @return {Number}
 */ const $ab3f2a5cc6216ae5$var$hue2rgb = (p, q, t)=>{
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
};
/**
 * Adapted from {@link https://gist.github.com/mjackson/5311256 https://gist.github.com/mjackson}
 * @param {Number} r Red color value
 * @param {Number} g Green color value
 * @param {Number} b Blue color value
 * @param {Number} a Alpha color value pass through
 * @return {TRGBColorSource} Hsl color
 */ const $ab3f2a5cc6216ae5$var$rgb2Hsl = (r, g, b, a)=>{
    r /= 255;
    g /= 255;
    b /= 255;
    const maxValue = Math.max(r, g, b), minValue = Math.min(r, g, b);
    let h, s;
    const l = (maxValue + minValue) / 2;
    if (maxValue === minValue) h = s = 0; // achromatic
    else {
        const d = maxValue - minValue;
        s = l > 0.5 ? d / (2 - maxValue - minValue) : d / (maxValue + minValue);
        switch(maxValue){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return [
        Math.round(h * 360),
        Math.round(s * 100),
        Math.round(l * 100),
        a
    ];
};
const $ab3f2a5cc6216ae5$var$fromAlphaToFloat = function() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "1";
    return parseFloat(value) / (value.endsWith("%") ? 100 : 1);
};
/**
 * Convert a value in the inclusive range [0, 255] to hex
 */ const $ab3f2a5cc6216ae5$var$hexify = (value)=>Math.min(Math.round(value), 255).toString(16).toUpperCase().padStart(2, "0");
/**
 * Calculate the grey average value for rgb and pass through alpha
 */ const $ab3f2a5cc6216ae5$var$greyAverage = (_ref)=>{
    let [r, g, b, a = 1] = _ref;
    const avg = Math.round(r * 0.3 + g * 0.59 + b * 0.11);
    return [
        avg,
        avg,
        avg,
        a
    ];
};
/**
 * @class Color common color operations
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2/#colors colors}
 */ class $ab3f2a5cc6216ae5$export$892596cec99bc70e {
    /**
   *
   * @param {string} [color] optional in hex or rgb(a) or hsl format or from known color list
   */ constructor(color){
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "isUnrecognised", false);
        if (!color) // we default to black as canvas does
        this.setSource([
            0,
            0,
            0,
            1
        ]);
        else if (color instanceof $ab3f2a5cc6216ae5$export$892596cec99bc70e) this.setSource([
            ...color._source
        ]);
        else if (Array.isArray(color)) {
            const [r, g, b, a = 1] = color;
            this.setSource([
                r,
                g,
                b,
                a
            ]);
        } else this.setSource(this._tryParsingColor(color));
    }
    /**
   * @private
   * @param {string} [color] Color value to parse
   * @returns {TRGBAColorSource}
   */ _tryParsingColor(color) {
        if (color in $ab3f2a5cc6216ae5$var$ColorNameMap) color = $ab3f2a5cc6216ae5$var$ColorNameMap[color];
        return color === "transparent" ? [
            255,
            255,
            255,
            0
        ] : $ab3f2a5cc6216ae5$export$892596cec99bc70e.sourceFromHex(color) || $ab3f2a5cc6216ae5$export$892596cec99bc70e.sourceFromRgb(color) || $ab3f2a5cc6216ae5$export$892596cec99bc70e.sourceFromHsl(color) || (// color is not recognized
        // we default to black as canvas does
        this.isUnrecognised = true, [
            0,
            0,
            0,
            1
        ]);
    }
    /**
   * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
   * @return {TRGBAColorSource}
   */ getSource() {
        return this._source;
    }
    /**
   * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
   * @param {TRGBAColorSource} source
   */ setSource(source) {
        this._source = source;
    }
    /**
   * Returns color representation in RGB format
   * @return {String} ex: rgb(0-255,0-255,0-255)
   */ toRgb() {
        const [r, g, b] = this.getSource();
        return "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
    }
    /**
   * Returns color representation in RGBA format
   * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
   */ toRgba() {
        return "rgba(".concat(this.getSource().join(","), ")");
    }
    /**
   * Returns color representation in HSL format
   * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
   */ toHsl() {
        const [h, s, l] = $ab3f2a5cc6216ae5$var$rgb2Hsl(...this.getSource());
        return "hsl(".concat(h, ",").concat(s, "%,").concat(l, "%)");
    }
    /**
   * Returns color representation in HSLA format
   * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
   */ toHsla() {
        const [h, s, l, a] = $ab3f2a5cc6216ae5$var$rgb2Hsl(...this.getSource());
        return "hsla(".concat(h, ",").concat(s, "%,").concat(l, "%,").concat(a, ")");
    }
    /**
   * Returns color representation in HEX format
   * @return {String} ex: FF5555
   */ toHex() {
        const fullHex = this.toHexa();
        return fullHex.slice(0, 6);
    }
    /**
   * Returns color representation in HEXA format
   * @return {String} ex: FF5555CC
   */ toHexa() {
        const [r, g, b, a] = this.getSource();
        return "".concat($ab3f2a5cc6216ae5$var$hexify(r)).concat($ab3f2a5cc6216ae5$var$hexify(g)).concat($ab3f2a5cc6216ae5$var$hexify(b)).concat($ab3f2a5cc6216ae5$var$hexify(Math.round(a * 255)));
    }
    /**
   * Gets value of alpha channel for this color
   * @return {Number} 0-1
   */ getAlpha() {
        return this.getSource()[3];
    }
    /**
   * Sets value of alpha channel for this color
   * @param {Number} alpha Alpha value 0-1
   * @return {Color} thisArg
   */ setAlpha(alpha) {
        this._source[3] = alpha;
        return this;
    }
    /**
   * Transforms color to its grayscale representation
   * @return {Color} thisArg
   */ toGrayscale() {
        this.setSource($ab3f2a5cc6216ae5$var$greyAverage(this.getSource()));
        return this;
    }
    /**
   * Transforms color to its black and white representation
   * @param {Number} threshold
   * @return {Color} thisArg
   */ toBlackWhite(threshold) {
        const [average, , , a] = $ab3f2a5cc6216ae5$var$greyAverage(this.getSource()), bOrW = average < (threshold || 127) ? 0 : 255;
        this.setSource([
            bOrW,
            bOrW,
            bOrW,
            a
        ]);
        return this;
    }
    /**
   * Overlays color with another color
   * @param {String|Color} otherColor
   * @return {Color} thisArg
   */ overlayWith(otherColor) {
        if (!(otherColor instanceof $ab3f2a5cc6216ae5$export$892596cec99bc70e)) otherColor = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(otherColor);
        const source = this.getSource(), otherAlpha = 0.5, otherSource = otherColor.getSource(), [R, G, B] = source.map((value, index)=>Math.round(value * (1 - otherAlpha) + otherSource[index] * otherAlpha));
        this.setSource([
            R,
            G,
            B,
            source[3]
        ]);
        return this;
    }
    /**
   * Returns new color object, when given a color in RGB format
   * @memberOf Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255)
   * @return {Color}
   */ static fromRgb(color) {
        return $ab3f2a5cc6216ae5$export$892596cec99bc70e.fromRgba(color);
    }
    /**
   * Returns new color object, when given a color in RGBA format
   * @static
   * @function
   * @memberOf Color
   * @param {String} color
   * @return {Color}
   */ static fromRgba(color) {
        return new $ab3f2a5cc6216ae5$export$892596cec99bc70e($ab3f2a5cc6216ae5$export$892596cec99bc70e.sourceFromRgb(color));
    }
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
   * @memberOf Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
   * @return {TRGBAColorSource | undefined} source
   */ static sourceFromRgb(color) {
        const match = color.match($ab3f2a5cc6216ae5$var$reRGBa());
        if (match) {
            const [r, g, b] = match.slice(1, 4).map((value)=>{
                const parsedValue = parseFloat(value);
                return value.endsWith("%") ? Math.round(parsedValue * 2.55) : parsedValue;
            });
            return [
                r,
                g,
                b,
                $ab3f2a5cc6216ae5$var$fromAlphaToFloat(match[4])
            ];
        }
    }
    /**
   * Returns new color object, when given a color in HSL format
   * @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
   * @memberOf Color
   * @return {Color}
   */ static fromHsl(color) {
        return $ab3f2a5cc6216ae5$export$892596cec99bc70e.fromHsla(color);
    }
    /**
   * Returns new color object, when given a color in HSLA format
   * @static
   * @function
   * @memberOf Color
   * @param {String} color
   * @return {Color}
   */ static fromHsla(color) {
        return new $ab3f2a5cc6216ae5$export$892596cec99bc70e($ab3f2a5cc6216ae5$export$892596cec99bc70e.sourceFromHsl(color));
    }
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
   * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
   * @memberOf Color
   * @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
   * @return {TRGBAColorSource | undefined} source
   * @see http://http://www.w3.org/TR/css3-color/#hsl-color
   */ static sourceFromHsl(color) {
        const match = color.match($ab3f2a5cc6216ae5$var$reHSLa());
        if (!match) return;
        const match1degrees = $ab3f2a5cc6216ae5$export$892596cec99bc70e.parseAngletoDegrees(match[1]);
        const h = (match1degrees % 360 + 360) % 360 / 360, s = parseFloat(match[2]) / 100, l = parseFloat(match[3]) / 100;
        let r, g, b;
        if (s === 0) r = g = b = l;
        else {
            const q = l <= 0.5 ? l * (s + 1) : l + s - l * s, p = l * 2 - q;
            r = $ab3f2a5cc6216ae5$var$hue2rgb(p, q, h + 1 / 3);
            g = $ab3f2a5cc6216ae5$var$hue2rgb(p, q, h);
            b = $ab3f2a5cc6216ae5$var$hue2rgb(p, q, h - 1 / 3);
        }
        return [
            Math.round(r * 255),
            Math.round(g * 255),
            Math.round(b * 255),
            $ab3f2a5cc6216ae5$var$fromAlphaToFloat(match[4])
        ];
    }
    /**
   * Returns new color object, when given a color in HEX format
   * @static
   * @memberOf Color
   * @param {String} color Color value ex: FF5555
   * @return {Color}
   */ static fromHex(color) {
        return new $ab3f2a5cc6216ae5$export$892596cec99bc70e($ab3f2a5cc6216ae5$export$892596cec99bc70e.sourceFromHex(color));
    }
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
   * @static
   * @memberOf Color
   * @param {String} color ex: FF5555 or FF5544CC (RGBa)
   * @return {TRGBAColorSource | undefined} source
   */ static sourceFromHex(color) {
        if (color.match($ab3f2a5cc6216ae5$var$reHex())) {
            const value = color.slice(color.indexOf("#") + 1), isShortNotation = value.length <= 4;
            let expandedValue;
            if (isShortNotation) expandedValue = value.split("").map((hex)=>hex + hex);
            else expandedValue = value.match(/.{2}/g);
            const [r, g, b, a = 255] = expandedValue.map((hexCouple)=>parseInt(hexCouple, 16));
            return [
                r,
                g,
                b,
                a / 255
            ];
        }
    }
    /**
   * Converts a string that could be any angle notation (50deg, 0.5turn, 2rad)
   * into degrees without the 'deg' suffix
   * @static
   * @memberOf Color
   * @param {String} value ex: 0deg, 0.5turn, 2rad
   * @return {Number} number in degrees or NaN if inputs are invalid
   */ static parseAngletoDegrees(value) {
        const lowercase = value.toLowerCase();
        const numeric = parseFloat(lowercase);
        if (lowercase.includes("rad")) return $ab3f2a5cc6216ae5$var$radiansToDegrees(numeric);
        if (lowercase.includes("turn")) return numeric * 360;
        // Value is probably just a number already in degrees eg '50'
        return numeric;
    }
}
/**
 * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
 * @param {number|string} number number to operate on
 * @param {number} fractionDigits number of fraction digits to "leave"
 * @return {number}
 */ const $ab3f2a5cc6216ae5$var$toFixed = (number, fractionDigits)=>parseFloat(Number(number).toFixed(fractionDigits));
/**
 * Returns array of attributes for given svg that fabric parses
 * @param {SVGElementName} type Type of svg element (eg. 'circle')
 * @return {Array} string names of supported attributes
 */ const $ab3f2a5cc6216ae5$var$getSvgAttributes = (type)=>{
    const commonAttributes = [
        "instantiated_by_use",
        "style",
        "id",
        "class"
    ];
    switch(type){
        case "linearGradient":
            return commonAttributes.concat([
                "x1",
                "y1",
                "x2",
                "y2",
                "gradientUnits",
                "gradientTransform"
            ]);
        case "radialGradient":
            return commonAttributes.concat([
                "gradientUnits",
                "gradientTransform",
                "cx",
                "cy",
                "r",
                "fx",
                "fy",
                "fr"
            ]);
        case "stop":
            return commonAttributes.concat([
                "offset",
                "stop-color",
                "stop-opacity"
            ]);
    }
    return commonAttributes;
};
/**
 * Converts from attribute value to pixel value if applicable.
 * Returns converted pixels or original value not converted.
 * @param {string} value number to operate on
 * @param {number} fontSize
 * @return {number}
 */ const $ab3f2a5cc6216ae5$var$parseUnit = function(value) {
    let fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ab3f2a5cc6216ae5$var$DEFAULT_SVG_FONT_SIZE;
    const unit = /\D{0,2}$/.exec(value), number = parseFloat(value);
    const dpi = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.DPI;
    switch(unit === null || unit === void 0 ? void 0 : unit[0]){
        case "mm":
            return number * dpi / 25.4;
        case "cm":
            return number * dpi / 2.54;
        case "in":
            return number * dpi;
        case "pt":
            return number * dpi / 72;
        // or * 4 / 3
        case "pc":
            return number * dpi / 72 * 12;
        // or * 16
        case "em":
            return number * fontSize;
        default:
            return number;
    }
};
// align can be either none or undefined or a combination of mid/max
const $ab3f2a5cc6216ae5$var$parseAlign = (align)=>{
    //divide align in alignX and alignY
    if (align && align !== $ab3f2a5cc6216ae5$var$NONE) return [
        align.slice(1, 4),
        align.slice(5, 8)
    ];
    else if (align === $ab3f2a5cc6216ae5$var$NONE) return [
        align,
        align
    ];
    return [
        "Mid",
        "Mid"
    ];
};
/**
 * Parse preserveAspectRatio attribute from element
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/preserveAspectRatio
 * @param {string} attribute to be parsed
 * @return {Object} an object containing align and meetOrSlice attribute
 */ const $ab3f2a5cc6216ae5$var$parsePreserveAspectRatioAttribute = (attribute)=>{
    const [firstPart, secondPart] = attribute.trim().split(" ");
    const [alignX, alignY] = $ab3f2a5cc6216ae5$var$parseAlign(firstPart);
    return {
        meetOrSlice: secondPart || "meet",
        alignX: alignX,
        alignY: alignY
    };
};
/**
 * given an array of 6 number returns something like `"matrix(...numbers)"`
 * @param {TMat2D} transform an array with 6 numbers
 * @return {String} transform matrix for svg
 */ const $ab3f2a5cc6216ae5$var$matrixToSVG = (transform)=>"matrix(" + transform.map((value)=>$ab3f2a5cc6216ae5$var$toFixed(value, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS)).join(" ") + ")";
/**
 * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
 * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
 * @param prop
 * @param value
 * @param {boolean} inlineStyle The default is inline style, the separator used is ":", The other is "="
 * @returns
 */ const $ab3f2a5cc6216ae5$var$colorPropToSVG = function(prop, value) {
    let inlineStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    let colorValue;
    let opacityValue;
    if (!value) colorValue = "none";
    else if (value.toLive) colorValue = "url(#SVGID_".concat(value.id, ")");
    else {
        const color = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(value), opacity = color.getAlpha();
        colorValue = color.toRgb();
        if (opacity !== 1) opacityValue = opacity.toString();
    }
    if (inlineStyle) return "".concat(prop, ": ").concat(colorValue, "; ").concat(opacityValue ? "".concat(prop, "-opacity: ").concat(opacityValue, "; ") : "");
    else return "".concat(prop, '="').concat(colorValue, '" ').concat(opacityValue ? "".concat(prop, '-opacity="').concat(opacityValue, '" ') : "");
};
const $ab3f2a5cc6216ae5$var$createSVGRect = function(color, _ref) {
    let { left: left, top: top, width: width, height: height } = _ref;
    let precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
    const svgColor = $ab3f2a5cc6216ae5$var$colorPropToSVG($ab3f2a5cc6216ae5$var$FILL, color, false);
    const [x, y, w, h] = [
        left,
        top,
        width,
        height
    ].map((value)=>$ab3f2a5cc6216ae5$var$toFixed(value, precision));
    return "<rect ".concat(svgColor, ' x="').concat(x, '" y="').concat(y, '" width="').concat(w, '" height="').concat(h, '"></rect>');
};
const $ab3f2a5cc6216ae5$var$isFiller = (filler)=>{
    return !!filler && filler.toLive !== undefined;
};
const $ab3f2a5cc6216ae5$var$isSerializableFiller = (filler)=>{
    return !!filler && typeof filler.toObject === "function";
};
const $ab3f2a5cc6216ae5$var$isPattern = (filler)=>{
    return !!filler && filler.offsetX !== undefined && "source" in filler;
};
const $ab3f2a5cc6216ae5$var$isTextObject = (fabricObject)=>{
    return !!fabricObject && typeof fabricObject._renderText === "function";
};
const $ab3f2a5cc6216ae5$var$isPath = (fabricObject)=>{
    // we could use instanceof but that would mean pulling in Text code for a simple check
    // @todo discuss what to do and how to do
    return !!fabricObject && typeof fabricObject._renderPathCommands === "function";
};
const $ab3f2a5cc6216ae5$var$isActiveSelection = (fabricObject)=>!!fabricObject && "multiSelectionStacking" in fabricObject;
/**
 * Returns element scroll offsets
 * @param {HTMLElement} element Element to operate on
 * @return {Object} Object with left/top values
 */ function $ab3f2a5cc6216ae5$var$getScrollLeftTop(element) {
    const doc = element && $ab3f2a5cc6216ae5$var$getDocumentFromElement(element);
    let left = 0, top = 0;
    if (!element || !doc) return {
        left: left,
        top: top
    };
    const docElement = doc.documentElement, body = doc.body || {
        scrollLeft: 0,
        scrollTop: 0
    };
    // While loop checks (and then sets element to) .parentNode OR .host
    //  to account for ShadowDOM. We still want to traverse up out of ShadowDOM,
    //  but the .parentNode of a root ShadowDOM node will always be null, instead
    //  it should be accessed through .host. See http://stackoverflow.com/a/24765528/4383938
    // @ts-expect-error Set element to element parent, or 'host' in case of ShadowDOM
    while(element && (element.parentNode || element.host)){
        // @ts-expect-error Set element to element parent, or 'host' in case of ShadowDOM
        element = element.parentNode || element.host;
        // @ts-expect-error because element is typed as HTMLElement but it can go up to document
        if (element === doc) {
            left = body.scrollLeft || docElement.scrollLeft || 0;
            top = body.scrollTop || docElement.scrollTop || 0;
        } else {
            left += element.scrollLeft || 0;
            top += element.scrollTop || 0;
        }
        if (element.nodeType === 1 && element.style.position === "fixed") break;
    }
    return {
        left: left,
        top: top
    };
}
const $ab3f2a5cc6216ae5$var$getDocumentFromElement = (el)=>el.ownerDocument || null;
const $ab3f2a5cc6216ae5$var$getWindowFromElement = (el)=>{
    var _el$ownerDocument;
    return ((_el$ownerDocument = el.ownerDocument) === null || _el$ownerDocument === void 0 ? void 0 : _el$ownerDocument.defaultView) || null;
};
// TODO this file needs to go away, cross browser style support is not fabricjs domain.
/**
 * wrapper for setting element's style
 * @param {HTMLElement} element
 * @param {Object | string} styles
 */ function $ab3f2a5cc6216ae5$var$setStyle(element, styles) {
    const elementStyle = element.style;
    if (!elementStyle) return;
    else if (typeof styles === "string") element.style.cssText += ";" + styles;
    else Object.entries(styles).forEach((_ref)=>{
        let [property, value] = _ref;
        return elementStyle.setProperty(property, value);
    });
}
const $ab3f2a5cc6216ae5$var$setCanvasDimensions = function(el, ctx, _ref) {
    let { width: width, height: height } = _ref;
    let retinaScaling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    el.width = width;
    el.height = height;
    if (retinaScaling > 1) {
        el.setAttribute("width", (width * retinaScaling).toString());
        el.setAttribute("height", (height * retinaScaling).toString());
        ctx.scale(retinaScaling, retinaScaling);
    }
};
function $ab3f2a5cc6216ae5$var$allowTouchScrolling(element, allow) {
    const touchAction = allow ? "manipulation" : $ab3f2a5cc6216ae5$var$NONE;
    $ab3f2a5cc6216ae5$var$setStyle(element, {
        "touch-action": touchAction,
        "-ms-touch-action": touchAction
    });
}
const $ab3f2a5cc6216ae5$var$setCSSDimensions = (el, _ref2)=>{
    let { width: width, height: height } = _ref2;
    width && (el.style.width = typeof width === "number" ? "".concat(width, "px") : width);
    height && (el.style.height = typeof height === "number" ? "".concat(height, "px") : height);
};
/**
 * Returns offset for a given element
 * @param {HTMLElement} element Element to get offset for
 * @return {Object} Object with "left" and "top" properties
 */ function $ab3f2a5cc6216ae5$var$getElementOffset(element) {
    var _getWindowFromElement;
    let box = {
        left: 0,
        top: 0
    };
    const doc = element && $ab3f2a5cc6216ae5$var$getDocumentFromElement(element), offset = {
        left: 0,
        top: 0
    }, offsetAttributes = {
        borderLeftWidth: $ab3f2a5cc6216ae5$var$LEFT,
        borderTopWidth: $ab3f2a5cc6216ae5$var$TOP,
        paddingLeft: $ab3f2a5cc6216ae5$var$LEFT,
        paddingTop: $ab3f2a5cc6216ae5$var$TOP
    };
    if (!doc) return offset;
    const elemStyle = ((_getWindowFromElement = $ab3f2a5cc6216ae5$var$getWindowFromElement(element)) === null || _getWindowFromElement === void 0 ? void 0 : _getWindowFromElement.getComputedStyle(element, null)) || {};
    for(const attr in offsetAttributes)// @ts-expect-error TS learn to iterate!
    offset[offsetAttributes[attr]] += parseInt(elemStyle[attr], 10) || 0;
    const docElem = doc.documentElement;
    if (typeof element.getBoundingClientRect !== "undefined") box = element.getBoundingClientRect();
    const scrollLeftTop = $ab3f2a5cc6216ae5$var$getScrollLeftTop(element);
    return {
        left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
        top: box.top + scrollLeftTop.top - (docElem.clientTop || 0) + offset.top
    };
}
/**
 * Makes element unselectable
 * @param {HTMLElement} element Element to make unselectable
 * @return {HTMLElement} Element that was passed in
 */ function $ab3f2a5cc6216ae5$var$makeElementUnselectable(element) {
    if (typeof element.onselectstart !== "undefined") element.onselectstart = ()=>false;
    element.style.userSelect = $ab3f2a5cc6216ae5$var$NONE;
    return element;
}
class $ab3f2a5cc6216ae5$export$cf489a44e232c033 {
    constructor(arg0){
        /**
     * Keeps a copy of the canvas style before setting retina scaling and other potions
     * in order to return it to original state on dispose
     * @type string
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_originalCanvasStyle", void 0);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "lower", void 0);
        const el = this.createLowerCanvas(arg0);
        this.lower = {
            el: el,
            ctx: el.getContext("2d")
        };
    }
    createLowerCanvas(arg0) {
        // canvasEl === 'HTMLCanvasElement' does not work on jsdom/node
        const el = $ab3f2a5cc6216ae5$var$isHTMLCanvas(arg0) ? arg0 : arg0 && $ab3f2a5cc6216ae5$export$91e93c41e950ddbb().getElementById(arg0) || $ab3f2a5cc6216ae5$var$createCanvasElement();
        if (el.hasAttribute("data-fabric")) throw new $ab3f2a5cc6216ae5$var$FabricError("Trying to initialize a canvas that has already been initialized. Did you forget to dispose the canvas?");
        this._originalCanvasStyle = el.style.cssText;
        el.setAttribute("data-fabric", "main");
        el.classList.add("lower-canvas");
        return el;
    }
    cleanupDOM(_ref) {
        let { width: width, height: height } = _ref;
        const { el: el } = this.lower;
        // restore canvas style and attributes
        el.classList.remove("lower-canvas");
        el.removeAttribute("data-fabric");
        // restore canvas size to original size in case retina scaling was applied
        el.setAttribute("width", "".concat(width));
        el.setAttribute("height", "".concat(height));
        el.style.cssText = this._originalCanvasStyle || "";
        this._originalCanvasStyle = undefined;
    }
    setDimensions(size, retinaScaling) {
        const { el: el, ctx: ctx } = this.lower;
        $ab3f2a5cc6216ae5$var$setCanvasDimensions(el, ctx, size, retinaScaling);
    }
    setCSSDimensions(size) {
        $ab3f2a5cc6216ae5$var$setCSSDimensions(this.lower.el, size);
    }
    /**
   * Calculates canvas element offset relative to the document
   */ calcOffset() {
        return $ab3f2a5cc6216ae5$var$getElementOffset(this.lower.el);
    }
    dispose() {
        $ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e().dispose(this.lower.el);
        // @ts-expect-error disposing
        delete this.lower;
    }
}
const $ab3f2a5cc6216ae5$var$staticCanvasDefaults = {
    backgroundVpt: true,
    backgroundColor: "",
    overlayVpt: true,
    overlayColor: "",
    includeDefaultValues: true,
    svgViewportTransformation: true,
    renderOnAddRemove: true,
    skipOffscreen: true,
    enableRetinaScaling: true,
    imageSmoothingEnabled: true,
    /**
   * @todo move to Canvas
   */ controlsAboveOverlay: false,
    /**
   * @todo move to Canvas
   */ allowTouchScrolling: false,
    viewportTransform: [
        ...$ab3f2a5cc6216ae5$export$3c5a7f9475b116e0
    ]
};
/**
 * Having both options in TCanvasSizeOptions set to true transform the call in a calcOffset
 * Better try to restrict with types to avoid confusion.
 */ /**
 * Static canvas class
 * @see {@link http://fabricjs.com/static_canvas|StaticCanvas demo}
 * @fires before:render
 * @fires after:render
 * @fires canvas:cleared
 * @fires object:added
 * @fires object:removed
 */ // TODO: fix `EventSpec` inheritance https://github.com/microsoft/TypeScript/issues/26154#issuecomment-1366616260
class $ab3f2a5cc6216ae5$export$ad01921fb0b1386e extends $ab3f2a5cc6216ae5$export$f589b6d5b7ad4722($ab3f2a5cc6216ae5$var$CommonMethods) {
    // background
    // overlay
    // rendering config
    /**
   * @todo move to Canvas
   */ /**
   * @todo move to Canvas
   */ /**
   * The viewport bounding box in scene plane coordinates, see {@link calcViewportBoundaries}
   */ /**
   * A reference to the canvas actual HTMLCanvasElement.
   * Can be use to read the raw pixels, but never write or manipulate
   * @type HTMLCanvasElement
   */ get lowerCanvasEl() {
        var _this$elements$lower;
        return (_this$elements$lower = this.elements.lower) === null || _this$elements$lower === void 0 ? void 0 : _this$elements$lower.el;
    }
    get contextContainer() {
        var _this$elements$lower2;
        return (_this$elements$lower2 = this.elements.lower) === null || _this$elements$lower2 === void 0 ? void 0 : _this$elements$lower2.ctx;
    }
    /**
   * If true the Canvas is in the process or has been disposed/destroyed.
   * No more rendering operation will be executed on this canvas.
   * @type boolean
   */ /**
   * Started the process of disposing but not done yet.
   * WIll likely complete the render cycle already scheduled but stopping adding more.
   * @type boolean
   */ /**
   * When true control drawing is skipped.
   * This boolean is used to avoid toDataURL to export controls.
   * Usage of this boolean to build up other flows and features is not supported
   * @type Boolean
   * @default false
   */ // reference to
    static getDefaults() {
        return $ab3f2a5cc6216ae5$export$ad01921fb0b1386e.ownDefaults;
    }
    constructor(el){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        Object.assign(this, this.constructor.getDefaults());
        this.set(options);
        this.initElements(el);
        this._setDimensionsImpl({
            width: this.width || this.elements.lower.el.width || 0,
            height: this.height || this.elements.lower.el.height || 0
        });
        this.skipControlsDrawing = false;
        this.viewportTransform = [
            ...this.viewportTransform
        ];
        this.calcViewportBoundaries();
    }
    initElements(el) {
        this.elements = new $ab3f2a5cc6216ae5$export$cf489a44e232c033(el);
    }
    add() {
        const size = super.add(...arguments);
        arguments.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
        return size;
    }
    insertAt(index) {
        for(var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)objects[_key - 1] = arguments[_key];
        const size = super.insertAt(index, ...objects);
        objects.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
        return size;
    }
    remove() {
        const removed = super.remove(...arguments);
        removed.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
        return removed;
    }
    _onObjectAdded(obj) {
        if (obj.canvas && obj.canvas !== this) {
            $ab3f2a5cc6216ae5$var$log("warn", "Canvas is trying to add an object that belongs to a different canvas.\nResulting to default behavior: removing object from previous canvas and adding to new canvas");
            obj.canvas.remove(obj);
        }
        obj._set("canvas", this);
        obj.setCoords();
        this.fire("object:added", {
            target: obj
        });
        obj.fire("added", {
            target: this
        });
    }
    _onObjectRemoved(obj) {
        obj._set("canvas", undefined);
        this.fire("object:removed", {
            target: obj
        });
        obj.fire("removed", {
            target: this
        });
    }
    _onStackOrderChanged() {
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
   * @private
   * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
   * @return {Number} retinaScaling if applied, otherwise 1;
   */ getRetinaScaling() {
        return this.enableRetinaScaling ? $ab3f2a5cc6216ae5$var$getDevicePixelRatio() : 1;
    }
    /**
   * Calculates canvas element offset relative to the document
   * This method is also attached as "resize" event handler of window
   */ calcOffset() {
        return this._offset = this.elements.calcOffset();
    }
    /**
   * Returns canvas width (in px)
   * @return {Number}
   */ getWidth() {
        return this.width;
    }
    /**
   * Returns canvas height (in px)
   * @return {Number}
   */ getHeight() {
        return this.height;
    }
    /**
   * Sets width of this canvas instance
   * @param {Number|String} value                         Value to set width to
   * @param {Object}        [options]                     Options object
   * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
   * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
   * @deprecated will be removed in 7.0
   */ setWidth(value, options) {
        return this.setDimensions({
            width: value
        }, options);
    }
    /**s
   * Sets height of this canvas instance
   * @param {Number|String} value                         Value to set height to
   * @param {Object}        [options]                     Options object
   * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
   * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
   * @deprecated will be removed in 7.0
   */ setHeight(value, options) {
        return this.setDimensions({
            height: value
        }, options);
    }
    /**
   * Internal use only
   * @protected
   */ _setDimensionsImpl(dimensions) {
        let { cssOnly: cssOnly = false, backstoreOnly: backstoreOnly = false } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!cssOnly) {
            const size = $ab3f2a5cc6216ae5$var$_objectSpread2({
                width: this.width,
                height: this.height
            }, dimensions);
            this.elements.setDimensions(size, this.getRetinaScaling());
            this.hasLostContext = true;
            this.width = size.width;
            this.height = size.height;
        }
        if (!backstoreOnly) this.elements.setCSSDimensions(dimensions);
        this.calcOffset();
    }
    /**
   * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
   * @param {Object}        dimensions                    Object with width/height properties
   * @param {Number|String} [dimensions.width]            Width of canvas element
   * @param {Number|String} [dimensions.height]           Height of canvas element
   * @param {Object}        [options]                     Options object
   * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
   * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
   */ setDimensions(dimensions, options) {
        this._setDimensionsImpl(dimensions, options);
        if (!options || !options.cssOnly) this.requestRenderAll();
    }
    /**
   * Returns canvas zoom level
   * @return {Number}
   */ getZoom() {
        return this.viewportTransform[0];
    }
    /**
   * Sets viewport transformation of this canvas instance
   * @param {Array} vpt a Canvas 2D API transform matrix
   */ setViewportTransform(vpt) {
        this.viewportTransform = vpt;
        this.calcViewportBoundaries();
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
   * Sets zoom level of this canvas instance, the zoom centered around point
   * meaning that following zoom to point with the same point will have the visual
   * effect of the zoom originating from that point. The point won't move.
   * It has nothing to do with canvas center or visual center of the viewport.
   * @param {Point} point to zoom with respect to
   * @param {Number} value to set zoom to, less than 1 zooms out
   */ zoomToPoint(point, value) {
        // TODO: just change the scale, preserve other transformations
        const before = point, vpt = [
            ...this.viewportTransform
        ];
        const newPoint = $ab3f2a5cc6216ae5$var$transformPoint(point, $ab3f2a5cc6216ae5$var$invertTransform(vpt));
        vpt[0] = value;
        vpt[3] = value;
        const after = $ab3f2a5cc6216ae5$var$transformPoint(newPoint, vpt);
        vpt[4] += before.x - after.x;
        vpt[5] += before.y - after.y;
        this.setViewportTransform(vpt);
    }
    /**
   * Sets zoom level of this canvas instance
   * @param {Number} value to set zoom to, less than 1 zooms out
   */ setZoom(value) {
        this.zoomToPoint(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(0, 0), value);
    }
    /**
   * Pan viewport so as to place point at top left corner of canvas
   * @param {Point} point to move to
   */ absolutePan(point) {
        const vpt = [
            ...this.viewportTransform
        ];
        vpt[4] = -point.x;
        vpt[5] = -point.y;
        return this.setViewportTransform(vpt);
    }
    /**
   * Pans viewpoint relatively
   * @param {Point} point (position vector) to move by
   */ relativePan(point) {
        return this.absolutePan(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(-point.x - this.viewportTransform[4], -point.y - this.viewportTransform[5]));
    }
    /**
   * Returns &lt;canvas> element corresponding to this instance
   * @return {HTMLCanvasElement}
   */ getElement() {
        return this.elements.lower.el;
    }
    /**
   * Clears specified context of canvas element
   * @param {CanvasRenderingContext2D} ctx Context to clear
   */ clearContext(ctx) {
        ctx.clearRect(0, 0, this.width, this.height);
    }
    /**
   * Returns context of canvas where objects are drawn
   * @return {CanvasRenderingContext2D}
   */ getContext() {
        return this.elements.lower.ctx;
    }
    /**
   * Clears all contexts (background, main, top) of an instance
   */ clear() {
        this.remove(...this.getObjects());
        this.backgroundImage = undefined;
        this.overlayImage = undefined;
        this.backgroundColor = "";
        this.overlayColor = "";
        this.clearContext(this.getContext());
        this.fire("canvas:cleared");
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
   * Renders the canvas
   */ renderAll() {
        this.cancelRequestedRender();
        if (this.destroyed) return;
        this.renderCanvas(this.getContext(), this._objects);
    }
    /**
   * Function created to be instance bound at initialization
   * used in requestAnimationFrame rendering
   * Let the fabricJS call it. If you call it manually you could have more
   * animationFrame stacking on to of each other
   * for an imperative rendering, use canvas.renderAll
   * @private
   */ renderAndReset() {
        this.nextRenderHandle = 0;
        this.renderAll();
    }
    /**
   * Append a renderAll request to next animation frame.
   * unless one is already in progress, in that case nothing is done
   * a boolean flag will avoid appending more.
   */ requestRenderAll() {
        if (!this.nextRenderHandle && !this.disposed && !this.destroyed) this.nextRenderHandle = $ab3f2a5cc6216ae5$var$requestAnimFrame(()=>this.renderAndReset());
    }
    /**
   * Calculate the position of the 4 corner of canvas with current viewportTransform.
   * helps to determinate when an object is in the current rendering viewport
   */ calcViewportBoundaries() {
        const width = this.width, height = this.height, iVpt = $ab3f2a5cc6216ae5$var$invertTransform(this.viewportTransform), a = $ab3f2a5cc6216ae5$var$transformPoint({
            x: 0,
            y: 0
        }, iVpt), b = $ab3f2a5cc6216ae5$var$transformPoint({
            x: width,
            y: height
        }, iVpt), // we don't support vpt flipping
        // but the code is robust enough to mostly work with flipping
        min = a.min(b), max = a.max(b);
        return this.vptCoords = {
            tl: min,
            tr: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(max.x, min.y),
            bl: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(min.x, max.y),
            br: max
        };
    }
    cancelRequestedRender() {
        if (this.nextRenderHandle) {
            $ab3f2a5cc6216ae5$var$cancelAnimFrame(this.nextRenderHandle);
            this.nextRenderHandle = 0;
        }
    }
    drawControls(ctx) {
    // Static canvas has no controls
    }
    /**
   * Renders background, objects, overlay and controls.
   * @param {CanvasRenderingContext2D} ctx
   * @param {Array} objects to render
   */ renderCanvas(ctx, objects) {
        if (this.destroyed) return;
        const v = this.viewportTransform, path = this.clipPath;
        this.calcViewportBoundaries();
        this.clearContext(ctx);
        ctx.imageSmoothingEnabled = this.imageSmoothingEnabled;
        // @ts-expect-error node-canvas stuff
        ctx.patternQuality = "best";
        this.fire("before:render", {
            ctx: ctx
        });
        this._renderBackground(ctx);
        ctx.save();
        //apply viewport transform once for all rendering process
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        this._renderObjects(ctx, objects);
        ctx.restore();
        if (!this.controlsAboveOverlay && !this.skipControlsDrawing) this.drawControls(ctx);
        if (path) {
            path._set("canvas", this);
            // needed to setup a couple of variables
            path.shouldCache();
            path._transformDone = true;
            path.renderCache({
                forClipping: true
            });
            this.drawClipPathOnCanvas(ctx, path);
        }
        this._renderOverlay(ctx);
        if (this.controlsAboveOverlay && !this.skipControlsDrawing) this.drawControls(ctx);
        this.fire("after:render", {
            ctx: ctx
        });
        if (this.__cleanupTask) {
            this.__cleanupTask();
            this.__cleanupTask = undefined;
        }
    }
    /**
   * Paint the cached clipPath on the lowerCanvasEl
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ drawClipPathOnCanvas(ctx, clipPath) {
        const v = this.viewportTransform;
        ctx.save();
        ctx.transform(...v);
        // DEBUG: uncomment this line, comment the following
        // ctx.globalAlpha = 0.4;
        ctx.globalCompositeOperation = "destination-in";
        clipPath.transform(ctx);
        ctx.scale(1 / clipPath.zoomX, 1 / clipPath.zoomY);
        ctx.drawImage(clipPath._cacheCanvas, -clipPath.cacheTranslationX, -clipPath.cacheTranslationY);
        ctx.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Array} objects to render
   */ _renderObjects(ctx, objects) {
        for(let i = 0, len = objects.length; i < len; ++i)objects[i] && objects[i].render(ctx);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {string} property 'background' or 'overlay'
   */ _renderBackgroundOrOverlay(ctx, property) {
        const fill = this["".concat(property, "Color")], object = this["".concat(property, "Image")], v = this.viewportTransform, needsVpt = this["".concat(property, "Vpt")];
        if (!fill && !object) return;
        const isAFiller = $ab3f2a5cc6216ae5$var$isFiller(fill);
        if (fill) {
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(this.width, 0);
            ctx.lineTo(this.width, this.height);
            ctx.lineTo(0, this.height);
            ctx.closePath();
            ctx.fillStyle = isAFiller ? fill.toLive(ctx /* this */ ) : fill;
            if (needsVpt) ctx.transform(...v);
            if (isAFiller) {
                ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
                const m = fill.gradientTransform || fill.patternTransform;
                m && ctx.transform(...m);
            }
            ctx.fill();
            ctx.restore();
        }
        if (object) {
            ctx.save();
            const { skipOffscreen: skipOffscreen } = this;
            // if the object doesn't move with the viewport,
            // the offscreen concept does not apply;
            this.skipOffscreen = needsVpt;
            if (needsVpt) ctx.transform(...v);
            object.render(ctx);
            this.skipOffscreen = skipOffscreen;
            ctx.restore();
        }
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderBackground(ctx) {
        this._renderBackgroundOrOverlay(ctx, "background");
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderOverlay(ctx) {
        this._renderBackgroundOrOverlay(ctx, "overlay");
    }
    /**
   * Returns coordinates of a center of canvas.
   * Returned value is an object with top and left properties
   * @return {Object} object with "top" and "left" number values
   * @deprecated migrate to `getCenterPoint`
   */ getCenter() {
        return {
            top: this.height / 2,
            left: this.width / 2
        };
    }
    /**
   * Returns coordinates of a center of canvas.
   * @return {Point}
   */ getCenterPoint() {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.width / 2, this.height / 2);
    }
    /**
   * Centers object horizontally in the canvas
   */ centerObjectH(object) {
        return this._centerObject(object, new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.getCenterPoint().x, object.getCenterPoint().y));
    }
    /**
   * Centers object vertically in the canvas
   * @param {FabricObject} object Object to center vertically
   */ centerObjectV(object) {
        return this._centerObject(object, new $ab3f2a5cc6216ae5$export$baf26146a414f24a(object.getCenterPoint().x, this.getCenterPoint().y));
    }
    /**
   * Centers object vertically and horizontally in the canvas
   * @param {FabricObject} object Object to center vertically and horizontally
   */ centerObject(object) {
        return this._centerObject(object, this.getCenterPoint());
    }
    /**
   * Centers object vertically and horizontally in the viewport
   * @param {FabricObject} object Object to center vertically and horizontally
   */ viewportCenterObject(object) {
        return this._centerObject(object, this.getVpCenter());
    }
    /**
   * Centers object horizontally in the viewport, object.top is unchanged
   * @param {FabricObject} object Object to center vertically and horizontally
   */ viewportCenterObjectH(object) {
        return this._centerObject(object, new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.getVpCenter().x, object.getCenterPoint().y));
    }
    /**
   * Centers object Vertically in the viewport, object.top is unchanged
   * @param {FabricObject} object Object to center vertically and horizontally
   */ viewportCenterObjectV(object) {
        return this._centerObject(object, new $ab3f2a5cc6216ae5$export$baf26146a414f24a(object.getCenterPoint().x, this.getVpCenter().y));
    }
    /**
   * Calculate the point in canvas that correspond to the center of actual viewport.
   * @return {Point} vpCenter, viewport center
   */ getVpCenter() {
        return $ab3f2a5cc6216ae5$var$transformPoint(this.getCenterPoint(), $ab3f2a5cc6216ae5$var$invertTransform(this.viewportTransform));
    }
    /**
   * @private
   * @param {FabricObject} object Object to center
   * @param {Point} center Center point
   */ _centerObject(object, center) {
        object.setXY(center, $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER);
        object.setCoords();
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
   * Returns dataless JSON representation of canvas
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {String} json string
   */ toDatalessJSON(propertiesToInclude) {
        return this.toDatalessObject(propertiesToInclude);
    }
    /**
   * Returns object representation of canvas
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject(propertiesToInclude) {
        return this._toObjectMethod("toObject", propertiesToInclude);
    }
    /**
   * Returns Object representation of canvas
   * this alias is provided because if you call JSON.stringify on an instance,
   * the toJSON object will be invoked if it exists.
   * Having a toJSON method means you can do JSON.stringify(myCanvas)
   * @return {Object} JSON compatible object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
   * @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
   * @example <caption>JSON without additional properties</caption>
   * var json = canvas.toJSON();
   * @example <caption>JSON with additional properties included</caption>
   * var json = canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY']);
   * @example <caption>JSON without default values</caption>
   * var json = canvas.toJSON();
   */ toJSON() {
        return this.toObject();
    }
    /**
   * Returns dataless object representation of canvas
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toDatalessObject(propertiesToInclude) {
        return this._toObjectMethod("toDatalessObject", propertiesToInclude);
    }
    /**
   * @private
   */ _toObjectMethod(methodName, propertiesToInclude) {
        const clipPath = this.clipPath;
        const clipPathData = clipPath && !clipPath.excludeFromExport ? this._toObject(clipPath, methodName, propertiesToInclude) : null;
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({
            version: $ab3f2a5cc6216ae5$export$83d89fbfd8236492
        }, $ab3f2a5cc6216ae5$var$pick(this, propertiesToInclude)), {}, {
            objects: this._objects.filter((object)=>!object.excludeFromExport).map((instance)=>this._toObject(instance, methodName, propertiesToInclude))
        }, this.__serializeBgOverlay(methodName, propertiesToInclude)), clipPathData ? {
            clipPath: clipPathData
        } : null);
    }
    /**
   * @private
   */ _toObject(instance, methodName, propertiesToInclude) {
        let originalValue;
        if (!this.includeDefaultValues) {
            originalValue = instance.includeDefaultValues;
            instance.includeDefaultValues = false;
        }
        const object = instance[methodName](propertiesToInclude);
        if (!this.includeDefaultValues) instance.includeDefaultValues = !!originalValue;
        return object;
    }
    /**
   * @private
   */ __serializeBgOverlay(methodName, propertiesToInclude) {
        const data = {}, bgImage = this.backgroundImage, overlayImage = this.overlayImage, bgColor = this.backgroundColor, overlayColor = this.overlayColor;
        if ($ab3f2a5cc6216ae5$var$isFiller(bgColor)) {
            if (!bgColor.excludeFromExport) data.background = bgColor.toObject(propertiesToInclude);
        } else if (bgColor) data.background = bgColor;
        if ($ab3f2a5cc6216ae5$var$isFiller(overlayColor)) {
            if (!overlayColor.excludeFromExport) data.overlay = overlayColor.toObject(propertiesToInclude);
        } else if (overlayColor) data.overlay = overlayColor;
        if (bgImage && !bgImage.excludeFromExport) data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
        if (overlayImage && !overlayImage.excludeFromExport) data.overlayImage = this._toObject(overlayImage, methodName, propertiesToInclude);
        return data;
    }
    /* _TO_SVG_START_ */ /**
   * Returns SVG representation of canvas
   * @function
   * @param {Object} [options] Options object for SVG output
   * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
   * @param {Object} [options.viewBox] SVG viewbox object
   * @param {Number} [options.viewBox.x] x-coordinate of viewbox
   * @param {Number} [options.viewBox.y] y-coordinate of viewbox
   * @param {Number} [options.viewBox.width] Width of viewbox
   * @param {Number} [options.viewBox.height] Height of viewbox
   * @param {String} [options.encoding=UTF-8] Encoding of SVG output
   * @param {String} [options.width] desired width of svg with or without units
   * @param {String} [options.height] desired height of svg with or without units
   * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
   * @return {String} SVG string
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
   * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
   * @example <caption>Normal SVG output</caption>
   * var svg = canvas.toSVG();
   * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
   * var svg = canvas.toSVG({suppressPreamble: true});
   * @example <caption>SVG output with viewBox attribute</caption>
   * var svg = canvas.toSVG({
   *   viewBox: {
   *     x: 100,
   *     y: 100,
   *     width: 200,
   *     height: 300
   *   }
   * });
   * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
   * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
   * @example <caption>Modify SVG output with reviver function</caption>
   * var svg = canvas.toSVG(null, function(svg) {
   *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
   * });
   */ toSVG() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let reviver = arguments.length > 1 ? arguments[1] : undefined;
        options.reviver = reviver;
        const markup = [];
        this._setSVGPreamble(markup, options);
        this._setSVGHeader(markup, options);
        if (this.clipPath) markup.push('<g clip-path="url(#'.concat(this.clipPath.clipPathId, ')" >\n'));
        this._setSVGBgOverlayColor(markup, "background");
        this._setSVGBgOverlayImage(markup, "backgroundImage", reviver);
        this._setSVGObjects(markup, reviver);
        if (this.clipPath) markup.push("</g>\n");
        this._setSVGBgOverlayColor(markup, "overlay");
        this._setSVGBgOverlayImage(markup, "overlayImage", reviver);
        markup.push("</svg>");
        return markup.join("");
    }
    /**
   * @private
   */ _setSVGPreamble(markup, options) {
        if (options.suppressPreamble) return;
        markup.push('<?xml version="1.0" encoding="', options.encoding || "UTF-8", '" standalone="no" ?>\n', '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ', '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n');
    }
    /**
   * @private
   */ _setSVGHeader(markup, options) {
        const width = options.width || "".concat(this.width), height = options.height || "".concat(this.height), NUM_FRACTION_DIGITS = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS, optViewBox = options.viewBox;
        let viewBox;
        if (optViewBox) viewBox = 'viewBox="'.concat(optViewBox.x, " ").concat(optViewBox.y, " ").concat(optViewBox.width, " ").concat(optViewBox.height, '" ');
        else if (this.svgViewportTransformation) {
            const vpt = this.viewportTransform;
            viewBox = 'viewBox="'.concat($ab3f2a5cc6216ae5$var$toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS), " ").concat($ab3f2a5cc6216ae5$var$toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS), " ").concat($ab3f2a5cc6216ae5$var$toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS), " ").concat($ab3f2a5cc6216ae5$var$toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS), '" ');
        } else viewBox = 'viewBox="0 0 '.concat(this.width, " ").concat(this.height, '" ');
        markup.push("<svg ", 'xmlns="http://www.w3.org/2000/svg" ', 'xmlns:xlink="http://www.w3.org/1999/xlink" ', 'version="1.1" ', 'width="', width, '" ', 'height="', height, '" ', viewBox, 'xml:space="preserve">\n', "<desc>Created with Fabric.js ", $ab3f2a5cc6216ae5$export$83d89fbfd8236492, "</desc>\n", "<defs>\n", this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(options), "</defs>\n");
    }
    createSVGClipPathMarkup(options) {
        const clipPath = this.clipPath;
        if (clipPath) {
            clipPath.clipPathId = "CLIPPATH_".concat($ab3f2a5cc6216ae5$var$uid());
            return '<clipPath id="'.concat(clipPath.clipPathId, '" >\n').concat(clipPath.toClipPathSVG(options.reviver), "</clipPath>\n");
        }
        return "";
    }
    /**
   * Creates markup containing SVG referenced elements like patterns, gradients etc.
   * @return {String}
   */ createSVGRefElementsMarkup() {
        return [
            "background",
            "overlay"
        ].map((prop)=>{
            const fill = this["".concat(prop, "Color")];
            if ($ab3f2a5cc6216ae5$var$isFiller(fill)) {
                const shouldTransform = this["".concat(prop, "Vpt")], vpt = this.viewportTransform, object = {
                    // otherwise circular dependency
                    isType: ()=>false,
                    width: this.width / (shouldTransform ? vpt[0] : 1),
                    height: this.height / (shouldTransform ? vpt[3] : 1)
                };
                return fill.toSVG(object, {
                    additionalTransform: shouldTransform ? $ab3f2a5cc6216ae5$var$matrixToSVG(vpt) : ""
                });
            }
        }).join("");
    }
    /**
   * Creates markup containing SVG font faces,
   * font URLs for font faces must be collected by developers
   * and are not extracted from the DOM by fabricjs
   * @param {Array} objects Array of fabric objects
   * @return {String}
   */ createSVGFontFacesMarkup() {
        const objects = [], fontList = {}, fontPaths = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.fontPaths;
        this._objects.forEach(function add(object) {
            objects.push(object);
            if ($ab3f2a5cc6216ae5$var$isCollection(object)) object._objects.forEach(add);
        });
        objects.forEach((obj)=>{
            if (!$ab3f2a5cc6216ae5$var$isTextObject(obj)) return;
            const { styles: styles, fontFamily: fontFamily } = obj;
            if (fontList[fontFamily] || !fontPaths[fontFamily]) return;
            fontList[fontFamily] = true;
            if (!styles) return;
            Object.values(styles).forEach((styleRow)=>{
                Object.values(styleRow).forEach((_ref)=>{
                    let { fontFamily: fontFamily = "" } = _ref;
                    if (!fontList[fontFamily] && fontPaths[fontFamily]) fontList[fontFamily] = true;
                });
            });
        });
        const fontListMarkup = Object.keys(fontList).map((fontFamily)=>"		@font-face {\n			font-family: '".concat(fontFamily, "';\n			src: url('").concat(fontPaths[fontFamily], "');\n		}\n")).join("");
        if (fontListMarkup) return '	<style type="text/css"><![CDATA[\n'.concat(fontListMarkup, "]]></style>\n");
        return "";
    }
    /**
   * @private
   */ _setSVGObjects(markup, reviver) {
        this.forEachObject((fabricObject)=>{
            if (fabricObject.excludeFromExport) return;
            this._setSVGObject(markup, fabricObject, reviver);
        });
    }
    /**
   * This is its own function because the Canvas ( non static ) requires extra code here
   * @private
   */ _setSVGObject(markup, instance, reviver) {
        markup.push(instance.toSVG(reviver));
    }
    /**
   * @private
   */ _setSVGBgOverlayImage(markup, property, reviver) {
        const bgOrOverlay = this[property];
        if (bgOrOverlay && !bgOrOverlay.excludeFromExport && bgOrOverlay.toSVG) markup.push(bgOrOverlay.toSVG(reviver));
    }
    /**
   * @TODO this seems to handle patterns but fail at gradients.
   * @private
   */ _setSVGBgOverlayColor(markup, property) {
        const filler = this["".concat(property, "Color")];
        if (!filler) return;
        if ($ab3f2a5cc6216ae5$var$isFiller(filler)) {
            const repeat = filler.repeat || "", finalWidth = this.width, finalHeight = this.height, shouldInvert = this["".concat(property, "Vpt")], additionalTransform = shouldInvert ? $ab3f2a5cc6216ae5$var$matrixToSVG($ab3f2a5cc6216ae5$var$invertTransform(this.viewportTransform)) : "";
            markup.push('<rect transform="'.concat(additionalTransform, " translate(").concat(finalWidth / 2, ",").concat(finalHeight / 2, ')" x="').concat(filler.offsetX - finalWidth / 2, '" y="').concat(filler.offsetY - finalHeight / 2, '" width="').concat((repeat === "repeat-y" || repeat === "no-repeat") && $ab3f2a5cc6216ae5$var$isPattern(filler) ? filler.source.width : finalWidth, '" height="').concat((repeat === "repeat-x" || repeat === "no-repeat") && $ab3f2a5cc6216ae5$var$isPattern(filler) ? filler.source.height : finalHeight, '" fill="url(#SVGID_').concat(filler.id, ')"></rect>\n'));
        } else markup.push('<rect x="0" y="0" width="100%" height="100%" ', 'fill="', filler, '"', "></rect>\n");
    }
    /* _TO_SVG_END_ */ /**
   * Populates canvas with data from the specified JSON.
   * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
   *
   * **IMPORTANT**: It is recommended to abort loading tasks before calling this method to prevent race conditions and unnecessary networking
   *
   * @param {String|Object} json JSON string or object
   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
   * @param {Object} [options] options
   * @param {AbortSignal} [options.signal] see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @return {Promise<Canvas | StaticCanvas>} instance
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
   * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
   * @example <caption>loadFromJSON</caption>
   * canvas.loadFromJSON(json).then((canvas) => canvas.requestRenderAll());
   * @example <caption>loadFromJSON with reviver</caption>
   * canvas.loadFromJSON(json, function(o, object) {
   *   // `o` = json object
   *   // `object` = fabric.Object instance
   *   // ... do some stuff ...
   * }).then((canvas) => {
   *   ... canvas is restored, add your code.
   * });
   *
   */ loadFromJSON(json, reviver) {
        let { signal: signal } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!json) return Promise.reject(new $ab3f2a5cc6216ae5$var$FabricError("`json` is undefined"));
        // parse json if it wasn't already
        const serialized = typeof json === "string" ? JSON.parse(json) : json;
        const { objects: objects = [], backgroundImage: backgroundImage, background: background, overlayImage: overlayImage, overlay: overlay, clipPath: clipPath } = serialized;
        const renderOnAddRemove = this.renderOnAddRemove;
        this.renderOnAddRemove = false;
        return Promise.all([
            $ab3f2a5cc6216ae5$var$enlivenObjects(objects, {
                reviver: reviver,
                signal: signal
            }),
            $ab3f2a5cc6216ae5$var$enlivenObjectEnlivables({
                backgroundImage: backgroundImage,
                backgroundColor: background,
                overlayImage: overlayImage,
                overlayColor: overlay,
                clipPath: clipPath
            }, {
                signal: signal
            })
        ]).then((_ref2)=>{
            let [enlived, enlivedMap] = _ref2;
            this.clear();
            this.add(...enlived);
            this.set(serialized);
            this.set(enlivedMap);
            this.renderOnAddRemove = renderOnAddRemove;
            return this;
        });
    }
    /**
   * Clones canvas instance
   * @param {string[]} [properties] Array of properties to include in the cloned canvas and children
   */ clone(properties) {
        const data = this.toObject(properties);
        const canvas = this.cloneWithoutData();
        return canvas.loadFromJSON(data);
    }
    /**
   * Clones canvas instance without cloning existing data.
   * This essentially copies canvas dimensions since loadFromJSON does not affect canvas size.
   */ cloneWithoutData() {
        const el = $ab3f2a5cc6216ae5$var$createCanvasElement();
        el.width = this.width;
        el.height = this.height;
        return new this.constructor(el);
    }
    /**
   * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
   * @param {Object} [options] Options object
   * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
   * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
   * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
   * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
   * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
   * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
   * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
   * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
   * @param {(object: fabric.Object) => boolean} [options.filter] Function to filter objects.
   * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
   * @see {@link https://jsfiddle.net/xsjua1rd/ demo}
   * @example <caption>Generate jpeg dataURL with lower quality</caption>
   * var dataURL = canvas.toDataURL({
   *   format: 'jpeg',
   *   quality: 0.8
   * });
   * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
   * var dataURL = canvas.toDataURL({
   *   format: 'png',
   *   left: 100,
   *   top: 100,
   *   width: 200,
   *   height: 200
   * });
   * @example <caption>Generate double scaled png dataURL</caption>
   * var dataURL = canvas.toDataURL({
   *   format: 'png',
   *   multiplier: 2
   * });
   * @example <caption>Generate dataURL with objects that overlap a specified object</caption>
   * var myObject;
   * var dataURL = canvas.toDataURL({
   *   filter: (object) => object.isContainedWithinObject(myObject) || object.intersectsWithObject(myObject)
   * });
   */ toDataURL() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { format: format = "png", quality: quality = 1, multiplier: multiplier = 1, enableRetinaScaling: enableRetinaScaling = false } = options;
        const finalMultiplier = multiplier * (enableRetinaScaling ? this.getRetinaScaling() : 1);
        return $ab3f2a5cc6216ae5$var$toDataURL(this.toCanvasElement(finalMultiplier, options), format, quality);
    }
    /**
   * Create a new HTMLCanvas element painted with the current canvas content.
   * No need to resize the actual one or repaint it.
   * Will transfer object ownership to a new canvas, paint it, and set everything back.
   * This is an intermediary step used to get to a dataUrl but also it is useful to
   * create quick image copies of a canvas without passing for the dataUrl string
   * @param {Number} [multiplier] a zoom factor.
   * @param {Object} [options] Cropping informations
   * @param {Number} [options.left] Cropping left offset.
   * @param {Number} [options.top] Cropping top offset.
   * @param {Number} [options.width] Cropping width.
   * @param {Number} [options.height] Cropping height.
   * @param {(object: fabric.Object) => boolean} [options.filter] Function to filter objects.
   */ toCanvasElement() {
        let multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        let { width: width, height: height, left: left, top: top, filter: filter } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const scaledWidth = (width || this.width) * multiplier, scaledHeight = (height || this.height) * multiplier, zoom = this.getZoom(), originalWidth = this.width, originalHeight = this.height, originalSkipControlsDrawing = this.skipControlsDrawing, newZoom = zoom * multiplier, vp = this.viewportTransform, translateX = (vp[4] - (left || 0)) * multiplier, translateY = (vp[5] - (top || 0)) * multiplier, newVp = [
            newZoom,
            0,
            0,
            newZoom,
            translateX,
            translateY
        ], originalRetina = this.enableRetinaScaling, canvasEl = $ab3f2a5cc6216ae5$var$createCanvasElement(), objectsToRender = filter ? this._objects.filter((obj)=>filter(obj)) : this._objects;
        canvasEl.width = scaledWidth;
        canvasEl.height = scaledHeight;
        this.enableRetinaScaling = false;
        this.viewportTransform = newVp;
        this.width = scaledWidth;
        this.height = scaledHeight;
        this.skipControlsDrawing = true;
        this.calcViewportBoundaries();
        this.renderCanvas(canvasEl.getContext("2d"), objectsToRender);
        this.viewportTransform = vp;
        this.width = originalWidth;
        this.height = originalHeight;
        this.calcViewportBoundaries();
        this.enableRetinaScaling = originalRetina;
        this.skipControlsDrawing = originalSkipControlsDrawing;
        return canvasEl;
    }
    /**
   * Waits until rendering has settled to destroy the canvas
   * @returns {Promise<boolean>} a promise resolving to `true` once the canvas has been destroyed or to `false` if the canvas has was already destroyed
   * @throws if aborted by a consequent call
   */ dispose() {
        !this.disposed && this.elements.cleanupDOM({
            width: this.width,
            height: this.height
        });
        $ab3f2a5cc6216ae5$export$dc18923894d9e56a.cancelByCanvas(this);
        this.disposed = true;
        return new Promise((resolve, reject)=>{
            const task = ()=>{
                this.destroy();
                resolve(true);
            };
            task.kill = reject;
            if (this.__cleanupTask) this.__cleanupTask.kill("aborted");
            if (this.destroyed) resolve(false);
            else if (this.nextRenderHandle) this.__cleanupTask = task;
            else task();
        });
    }
    /**
   * Clears the canvas element, disposes objects and frees resources.
   *
   * Invoked as part of the **async** operation of {@link dispose}.
   *
   * **CAUTION**:
   *
   * This method is **UNSAFE**.
   * You may encounter a race condition using it if there's a requested render.
   * Call this method only if you are sure rendering has settled.
   * Consider using {@link dispose} as it is **SAFE**
   *
   * @private
   */ destroy() {
        this.destroyed = true;
        this.cancelRequestedRender();
        this.forEachObject((object)=>object.dispose());
        this._objects = [];
        if (this.backgroundImage) this.backgroundImage.dispose();
        this.backgroundImage = undefined;
        if (this.overlayImage) this.overlayImage.dispose();
        this.overlayImage = undefined;
        this.elements.dispose();
    }
    /**
   * Returns a string representation of an instance
   * @return {String} string representation of an instance
   */ toString() {
        return "#<Canvas (".concat(this.complexity(), "): { objects: ").concat(this._objects.length, " }>");
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$ad01921fb0b1386e, "ownDefaults", $ab3f2a5cc6216ae5$var$staticCanvasDefaults);
const $ab3f2a5cc6216ae5$var$touchEvents = [
    "touchstart",
    "touchmove",
    "touchend"
];
function $ab3f2a5cc6216ae5$var$getTouchInfo(event) {
    const touchProp = event.changedTouches;
    if (touchProp && touchProp[0]) return touchProp[0];
    return event;
}
const $ab3f2a5cc6216ae5$var$getPointer = (event)=>{
    const element = event.target, scroll = $ab3f2a5cc6216ae5$var$getScrollLeftTop(element), _evt = $ab3f2a5cc6216ae5$var$getTouchInfo(event);
    return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(_evt.clientX + scroll.left, _evt.clientY + scroll.top);
};
const $ab3f2a5cc6216ae5$var$isTouchEvent = (event)=>$ab3f2a5cc6216ae5$var$touchEvents.includes(event.type) || event.pointerType === "touch";
const $ab3f2a5cc6216ae5$var$stopEvent = (e)=>{
    e.preventDefault();
    e.stopPropagation();
};
/**
 * Calculates bounding box (left, top, width, height) from given `points`
 * @param {XY[]} points
 * @return {Object} Object with left, top, width, height properties
 */ const $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints = (points)=>{
    if (points.length === 0) return {
        left: 0,
        top: 0,
        width: 0,
        height: 0
    };
    const { min: min, max: max } = points.reduce((_ref, curr)=>{
        let { min: min, max: max } = _ref;
        return {
            min: min.min(curr),
            max: max.max(curr)
        };
    }, {
        min: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(points[0]),
        max: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(points[0])
    });
    const size = max.subtract(min);
    return {
        left: min.x,
        top: min.y,
        width: size.x,
        height: size.y
    };
};
const $ab3f2a5cc6216ae5$var$_excluded$i = [
    "translateX",
    "translateY",
    "scaleX",
    "scaleY"
];
/**
 * given an object and a transform, apply the inverse transform to the object,
 * this is equivalent to remove from that object that transformation, so that
 * added in a space with the removed transform, the object will be the same as before.
 * Removing from an object a transform that scale by 2 is like scaling it by 1/2.
 * Removing from an object a transform that rotate by 30deg is like rotating by 30deg
 * in the opposite direction.
 * This util is used to add objects inside transformed groups or nested groups.
 * @param {FabricObject} object the object you want to transform
 * @param {TMat2D} transform the destination transform
 */ const $ab3f2a5cc6216ae5$var$removeTransformFromObject = (object, transform)=>{
    const inverted = $ab3f2a5cc6216ae5$var$invertTransform(transform), finalTransform = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(inverted, object.calcOwnMatrix());
    $ab3f2a5cc6216ae5$var$applyTransformToObject(object, finalTransform);
};
/**
 * given an object and a transform, apply the transform to the object.
 * this is equivalent to change the space where the object is drawn.
 * Adding to an object a transform that scale by 2 is like scaling it by 2.
 * This is used when removing an object from an active selection for example.
 * @param {FabricObject} object the object you want to transform
 * @param {Array} transform the destination transform
 */ const $ab3f2a5cc6216ae5$var$addTransformToObject = (object, transform)=>$ab3f2a5cc6216ae5$var$applyTransformToObject(object, $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(transform, object.calcOwnMatrix()));
/**
 * discard an object transform state and apply the one from the matrix.
 * @param {FabricObject} object the object you want to transform
 * @param {Array} transform the destination transform
 */ const $ab3f2a5cc6216ae5$var$applyTransformToObject = (object, transform)=>{
    const _qrDecompose = $ab3f2a5cc6216ae5$var$qrDecompose(transform), { translateX: translateX, translateY: translateY, scaleX: scaleX, scaleY: scaleY } = _qrDecompose, otherOptions = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_qrDecompose, $ab3f2a5cc6216ae5$var$_excluded$i), center = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(translateX, translateY);
    object.flipX = false;
    object.flipY = false;
    Object.assign(object, otherOptions);
    object.set({
        scaleX: scaleX,
        scaleY: scaleY
    });
    object.setPositionByOrigin(center, $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER);
};
/**
 * reset an object transform state to neutral. Top and left are not accounted for
 * @param  {FabricObject} target object to transform
 */ const $ab3f2a5cc6216ae5$var$resetObjectTransform = (target)=>{
    target.scaleX = 1;
    target.scaleY = 1;
    target.skewX = 0;
    target.skewY = 0;
    target.flipX = false;
    target.flipY = false;
    target.rotate(0);
};
/**
 * Extract Object transform values
 * @param  {FabricObject} target object to read from
 * @return {Object} Components of transform
 */ const $ab3f2a5cc6216ae5$var$saveObjectTransform = (target)=>({
        scaleX: target.scaleX,
        scaleY: target.scaleY,
        skewX: target.skewX,
        skewY: target.skewY,
        angle: target.angle,
        left: target.left,
        flipX: target.flipX,
        flipY: target.flipY,
        top: target.top
    });
/**
 * given a width and height, return the size of the bounding box
 * that can contains the box with width/height with applied transform.
 * Use to calculate the boxes around objects for controls.
 * @param {Number} width
 * @param {Number} height
 * @param {TMat2D} t
 * @returns {Point} size
 */ const $ab3f2a5cc6216ae5$var$sizeAfterTransform = (width, height, t)=>{
    const dimX = width / 2, dimY = height / 2, points = [
        new $ab3f2a5cc6216ae5$export$baf26146a414f24a(-dimX, -dimY),
        new $ab3f2a5cc6216ae5$export$baf26146a414f24a(dimX, -dimY),
        new $ab3f2a5cc6216ae5$export$baf26146a414f24a(-dimX, dimY),
        new $ab3f2a5cc6216ae5$export$baf26146a414f24a(dimX, dimY)
    ].map((p)=>p.transform(t)), bbox = $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints(points);
    return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(bbox.width, bbox.height);
};
/**
 * We are actually looking for the transformation from the destination plane to the source plane (change of basis matrix)\
 * The object will exist on the destination plane and we want it to seem unchanged by it so we invert the destination matrix (`to`) and then apply the source matrix (`from`)
 * @param [from]
 * @param [to]
 * @returns
 */ const $ab3f2a5cc6216ae5$var$calcPlaneChangeMatrix = function() {
    let from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0;
    let to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0;
    return $ab3f2a5cc6216ae5$var$multiplyTransformMatrices($ab3f2a5cc6216ae5$var$invertTransform(to), from);
};
/**
 * Sends a point from the source coordinate plane to the destination coordinate plane.\
 * From the canvas/viewer's perspective the point remains unchanged.
 *
 * @example <caption>Send point from canvas plane to group plane</caption>
 * var obj = new Rect({ left: 20, top: 20, width: 60, height: 60, strokeWidth: 0 });
 * var group = new Group([obj], { strokeWidth: 0 });
 * var sentPoint1 = sendPointToPlane(new Point(50, 50), undefined, group.calcTransformMatrix());
 * var sentPoint2 = sendPointToPlane(new Point(50, 50), iMatrix, group.calcTransformMatrix());
 * console.log(sentPoint1, sentPoint2) //  both points print (0,0) which is the center of group
 *
 * @param {Point} point
 * @param {TMat2D} [from] plane matrix containing object. Passing `undefined` is equivalent to passing the identity matrix, which means `point` exists in the canvas coordinate plane.
 * @param {TMat2D} [to] destination plane matrix to contain object. Passing `undefined` means `point` should be sent to the canvas coordinate plane.
 * @returns {Point} transformed point
 */ const $ab3f2a5cc6216ae5$var$sendPointToPlane = function(point) {
    let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0;
    let to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0;
    return point.transform($ab3f2a5cc6216ae5$var$calcPlaneChangeMatrix(from, to));
};
/**
 * See {@link sendPointToPlane}
 */ const $ab3f2a5cc6216ae5$var$sendVectorToPlane = function(point) {
    let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0;
    let to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0;
    return point.transform($ab3f2a5cc6216ae5$var$calcPlaneChangeMatrix(from, to), true);
};
/**
 *
 * A util that abstracts applying transform to objects.\
 * Sends `object` to the destination coordinate plane by applying the relevant transformations.\
 * Changes the space/plane where `object` is drawn.\
 * From the canvas/viewer's perspective `object` remains unchanged.
 *
 * @example <caption>Move clip path from one object to another while preserving it's appearance as viewed by canvas/viewer</caption>
 * let obj, obj2;
 * let clipPath = new Circle({ radius: 50 });
 * obj.clipPath = clipPath;
 * // render
 * sendObjectToPlane(clipPath, obj.calcTransformMatrix(), obj2.calcTransformMatrix());
 * obj.clipPath = undefined;
 * obj2.clipPath = clipPath;
 * // render, clipPath now clips obj2 but seems unchanged from the eyes of the viewer
 *
 * @example <caption>Clip an object's clip path with an existing object</caption>
 * let obj, existingObj;
 * let clipPath = new Circle({ radius: 50 });
 * obj.clipPath = clipPath;
 * let transformTo = multiplyTransformMatrices(obj.calcTransformMatrix(), clipPath.calcTransformMatrix());
 * sendObjectToPlane(existingObj, existingObj.group?.calcTransformMatrix(), transformTo);
 * clipPath.clipPath = existingObj;
 *
 * @param {FabricObject} object
 * @param {Matrix} [from] plane matrix containing object. Passing `undefined` is equivalent to passing the identity matrix, which means `object` is a direct child of canvas.
 * @param {Matrix} [to] destination plane matrix to contain object. Passing `undefined` means `object` should be sent to the canvas coordinate plane.
 * @returns {Matrix} the transform matrix that was applied to `object`
 */ const $ab3f2a5cc6216ae5$var$sendObjectToPlane = (object, from, to)=>{
    const t = $ab3f2a5cc6216ae5$var$calcPlaneChangeMatrix(from, to);
    $ab3f2a5cc6216ae5$var$applyTransformToObject(object, $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(t, object.calcOwnMatrix()));
    return t;
};
const $ab3f2a5cc6216ae5$var$fireEvent = (eventName, options)=>{
    var _target$canvas;
    const { transform: { target: target } } = options;
    (_target$canvas = target.canvas) === null || _target$canvas === void 0 || _target$canvas.fire("object:".concat(eventName), $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), {}, {
        target: target
    }));
    target.fire(eventName, options);
};
const $ab3f2a5cc6216ae5$var$originOffset = {
    left: -0.5,
    top: -0.5,
    center: 0,
    bottom: 0.5,
    right: 0.5
};
/**
 * Resolves origin value relative to center
 * @private
 * @param {TOriginX | TOriginY} originValue originX / originY
 * @returns number
 */ const $ab3f2a5cc6216ae5$var$resolveOrigin = (originValue)=>typeof originValue === "string" ? $ab3f2a5cc6216ae5$var$originOffset[originValue] : originValue - 0.5;
const $ab3f2a5cc6216ae5$var$NOT_ALLOWED_CURSOR = "not-allowed";
/**
 * @param {Boolean} alreadySelected true if target is already selected
 * @param {String} corner a string representing the corner ml, mr, tl ...
 * @param {Event} e Event object
 * @param {FabricObject} [target] inserted back to help overriding. Unused
 */ const $ab3f2a5cc6216ae5$var$getActionFromCorner = (alreadySelected, corner, e, target)=>{
    if (!corner || !alreadySelected) return "drag";
    const control = target.controls[corner];
    return control.getActionName(e, control, target);
};
/**
 * Checks if transform is centered
 * @param {Object} transform transform data
 * @return {Boolean} true if transform is centered
 */ function $ab3f2a5cc6216ae5$var$isTransformCentered(transform) {
    return $ab3f2a5cc6216ae5$var$resolveOrigin(transform.originX) === $ab3f2a5cc6216ae5$var$resolveOrigin($ab3f2a5cc6216ae5$var$CENTER) && $ab3f2a5cc6216ae5$var$resolveOrigin(transform.originY) === $ab3f2a5cc6216ae5$var$resolveOrigin($ab3f2a5cc6216ae5$var$CENTER);
}
function $ab3f2a5cc6216ae5$var$invertOrigin(origin) {
    return -$ab3f2a5cc6216ae5$var$resolveOrigin(origin) + 0.5;
}
const $ab3f2a5cc6216ae5$var$isLocked = (target, lockingKey)=>target[lockingKey];
const $ab3f2a5cc6216ae5$var$commonEventInfo = (eventData, transform, x, y)=>{
    return {
        e: eventData,
        transform: transform,
        pointer: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(x, y)
    };
};
/**
 * Combine control position and object angle to find the control direction compared
 * to the object center.
 * @param {FabricObject} fabricObject the fabric object for which we are rendering controls
 * @param {Control} control the control class
 * @return {Number} 0 - 7 a quadrant number
 */ function $ab3f2a5cc6216ae5$var$findCornerQuadrant(fabricObject, control) {
    //  angle is relative to canvas plane
    const angle = fabricObject.getTotalAngle(), cornerAngle = angle + $ab3f2a5cc6216ae5$var$radiansToDegrees(Math.atan2(control.y, control.x)) + 360;
    return Math.round(cornerAngle % 360 / 45);
}
/**
 * @returns the normalized point (rotated relative to center) in local coordinates
 */ function $ab3f2a5cc6216ae5$var$normalizePoint(target, point, originX, originY) {
    const center = target.getRelativeCenterPoint(), p = typeof originX !== "undefined" && typeof originY !== "undefined" ? target.translateToGivenOrigin(center, $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER, originX, originY) : new $ab3f2a5cc6216ae5$export$baf26146a414f24a(target.left, target.top), p2 = target.angle ? point.rotate(-$ab3f2a5cc6216ae5$var$degreesToRadians(target.angle), center) : point;
    return p2.subtract(p);
}
/**
 * Transforms a point to the offset from the given origin
 * @param {Object} transform
 * @param {String} originX
 * @param {String} originY
 * @param {number} x
 * @param {number} y
 * @return {Fabric.Point} the normalized point
 */ function $ab3f2a5cc6216ae5$var$getLocalPoint(_ref, originX, originY, x, y) {
    var _target$canvas;
    let { target: target, corner: corner } = _ref;
    const control = target.controls[corner], zoom = ((_target$canvas = target.canvas) === null || _target$canvas === void 0 ? void 0 : _target$canvas.getZoom()) || 1, padding = target.padding / zoom, localPoint = $ab3f2a5cc6216ae5$var$normalizePoint(target, new $ab3f2a5cc6216ae5$export$baf26146a414f24a(x, y), originX, originY);
    if (localPoint.x >= padding) localPoint.x -= padding;
    if (localPoint.x <= -padding) localPoint.x += padding;
    if (localPoint.y >= padding) localPoint.y -= padding;
    if (localPoint.y <= padding) localPoint.y += padding;
    localPoint.x -= control.offsetX;
    localPoint.y -= control.offsetY;
    return localPoint;
}
/**
 * Action handler
 * @private
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if the translation occurred
 */ const $ab3f2a5cc6216ae5$var$dragHandler = (eventData, transform, x, y)=>{
    const { target: target, offsetX: offsetX, offsetY: offsetY } = transform, newLeft = x - offsetX, newTop = y - offsetY, moveX = !$ab3f2a5cc6216ae5$var$isLocked(target, "lockMovementX") && target.left !== newLeft, moveY = !$ab3f2a5cc6216ae5$var$isLocked(target, "lockMovementY") && target.top !== newTop;
    moveX && target.set($ab3f2a5cc6216ae5$var$LEFT, newLeft);
    moveY && target.set($ab3f2a5cc6216ae5$var$TOP, newTop);
    if (moveX || moveY) $ab3f2a5cc6216ae5$var$fireEvent($ab3f2a5cc6216ae5$var$MOVING, $ab3f2a5cc6216ae5$var$commonEventInfo(eventData, transform, x, y));
    return moveX || moveY;
};
class $ab3f2a5cc6216ae5$var$FabricObjectSVGExportMixin {
    /**
   * When an object is being exported as SVG as a clippath, a reference inside the SVG is needed.
   * This reference is a UID in the fabric namespace and is temporary stored here.
   * @type {String}
   */ /**
   * Returns styles-string for svg-export
   * @param {Boolean} skipShadow a boolean to skip shadow filter output
   * @return {String}
   */ getSvgStyles(skipShadow) {
        const fillRule = this.fillRule ? this.fillRule : "nonzero", strokeWidth = this.strokeWidth ? this.strokeWidth : "0", strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(" ") : $ab3f2a5cc6216ae5$var$NONE, strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : "0", strokeLineCap = this.strokeLineCap ? this.strokeLineCap : "butt", strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : "miter", strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : "4", opacity = typeof this.opacity !== "undefined" ? this.opacity : "1", visibility = this.visible ? "" : " visibility: hidden;", filter = skipShadow ? "" : this.getSvgFilter(), fill = $ab3f2a5cc6216ae5$var$colorPropToSVG($ab3f2a5cc6216ae5$var$FILL, this.fill), stroke = $ab3f2a5cc6216ae5$var$colorPropToSVG($ab3f2a5cc6216ae5$var$STROKE, this.stroke);
        return [
            stroke,
            "stroke-width: ",
            strokeWidth,
            "; ",
            "stroke-dasharray: ",
            strokeDashArray,
            "; ",
            "stroke-linecap: ",
            strokeLineCap,
            "; ",
            "stroke-dashoffset: ",
            strokeDashOffset,
            "; ",
            "stroke-linejoin: ",
            strokeLineJoin,
            "; ",
            "stroke-miterlimit: ",
            strokeMiterLimit,
            "; ",
            fill,
            "fill-rule: ",
            fillRule,
            "; ",
            "opacity: ",
            opacity,
            ";",
            filter,
            visibility
        ].join("");
    }
    /**
   * Returns filter for svg shadow
   * @return {String}
   */ getSvgFilter() {
        return this.shadow ? "filter: url(#SVGID_".concat(this.shadow.id, ");") : "";
    }
    /**
   * Returns id attribute for svg output
   * @return {String}
   */ getSvgCommons() {
        return [
            this.id ? 'id="'.concat(this.id, '" ') : "",
            this.clipPath ? 'clip-path="url(#'.concat(this.clipPath.clipPathId, ')" ') : ""
        ].join("");
    }
    /**
   * Returns transform-string for svg-export
   * @param {Boolean} use the full transform or the single object one.
   * @return {String}
   */ getSvgTransform(full) {
        let additionalTransform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(), svgTransform = 'transform="'.concat($ab3f2a5cc6216ae5$var$matrixToSVG(transform));
        return "".concat(svgTransform).concat(additionalTransform, '" ');
    }
    /**
   * Returns svg representation of an instance
   * This function is implemented in each subclass
   * This is just because typescript otherwise cryies all the time
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG(reviver) {
        return [
            ""
        ];
    }
    /**
   * Returns svg representation of an instance
   * @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
   * @return {String} svg representation of an instance
   */ toSVG(reviver) {
        return this._createBaseSVGMarkup(this._toSVG(reviver), {
            reviver: reviver
        });
    }
    /**
   * Returns svg clipPath representation of an instance
   * @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
   * @return {String} svg representation of an instance
   */ toClipPathSVG(reviver) {
        return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), {
            reviver: reviver
        });
    }
    /**
   * @private
   */ _createBaseClipPathSVGMarkup(objectMarkup) {
        let { reviver: reviver, additionalTransform: additionalTransform = "" } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const commonPieces = [
            this.getSvgTransform(true, additionalTransform),
            this.getSvgCommons()
        ].join(""), // insert commons in the markup, style and svgCommons
        index = objectMarkup.indexOf("COMMON_PARTS");
        objectMarkup[index] = commonPieces;
        return reviver ? reviver(objectMarkup.join("")) : objectMarkup.join("");
    }
    /**
   * @private
   */ _createBaseSVGMarkup(objectMarkup) {
        let { noStyle: noStyle, reviver: reviver, withShadow: withShadow, additionalTransform: additionalTransform } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const styleInfo = noStyle ? "" : 'style="'.concat(this.getSvgStyles(), '" '), shadowInfo = withShadow ? 'style="'.concat(this.getSvgFilter(), '" ') : "", clipPath = this.clipPath, vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : "", absoluteClipPath = clipPath && clipPath.absolutePositioned, stroke = this.stroke, fill = this.fill, shadow = this.shadow, markup = [], // insert commons in the markup, style and svgCommons
        index = objectMarkup.indexOf("COMMON_PARTS");
        let clipPathMarkup;
        if (clipPath) {
            clipPath.clipPathId = "CLIPPATH_".concat($ab3f2a5cc6216ae5$var$uid());
            clipPathMarkup = '<clipPath id="'.concat(clipPath.clipPathId, '" >\n').concat(clipPath.toClipPathSVG(reviver), "</clipPath>\n");
        }
        if (absoluteClipPath) markup.push("<g ", shadowInfo, this.getSvgCommons(), " >\n");
        markup.push("<g ", this.getSvgTransform(false), !absoluteClipPath ? shadowInfo + this.getSvgCommons() : "", " >\n");
        const commonPieces = [
            styleInfo,
            vectorEffect,
            noStyle ? "" : this.addPaintOrder(),
            " ",
            additionalTransform ? 'transform="'.concat(additionalTransform, '" ') : ""
        ].join("");
        objectMarkup[index] = commonPieces;
        if ($ab3f2a5cc6216ae5$var$isFiller(fill)) markup.push(fill.toSVG(this));
        if ($ab3f2a5cc6216ae5$var$isFiller(stroke)) markup.push(stroke.toSVG(this));
        if (shadow) markup.push(shadow.toSVG(this));
        if (clipPath) markup.push(clipPathMarkup);
        markup.push(objectMarkup.join(""));
        markup.push("</g>\n");
        absoluteClipPath && markup.push("</g>\n");
        return reviver ? reviver(markup.join("")) : markup.join("");
    }
    addPaintOrder() {
        return this.paintFirst !== $ab3f2a5cc6216ae5$var$FILL ? ' paint-order="'.concat(this.paintFirst, '" ') : "";
    }
}
/**
 * Easing functions
 * @see {@link http://gizma.com/easing/ Easing Equations by Robert Penner}
 */ const $ab3f2a5cc6216ae5$var$normalize = (a, c, p, s)=>{
    if (a < Math.abs(c)) {
        a = c;
        s = p / 4;
    } else //handle the 0/0 case:
    if (c === 0 && a === 0) s = p / $ab3f2a5cc6216ae5$var$twoMathPi * Math.asin(1);
    else s = p / $ab3f2a5cc6216ae5$var$twoMathPi * Math.asin(c / a);
    return {
        a: a,
        c: c,
        p: p,
        s: s
    };
};
const $ab3f2a5cc6216ae5$var$elastic = (a, s, p, t, d)=>a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * $ab3f2a5cc6216ae5$var$twoMathPi / p);
/**
 * Default sinusoidal easing
 */ const $ab3f2a5cc6216ae5$var$defaultEasing = (t, b, c, d)=>-c * Math.cos(t / d * $ab3f2a5cc6216ae5$var$halfPI) + c + b;
/**
 * Cubic easing in
 */ const $ab3f2a5cc6216ae5$var$easeInCubic = (t, b, c, d)=>c * (t / d) ** 3 + b;
/**
 * Cubic easing out
 */ const $ab3f2a5cc6216ae5$var$easeOutCubic = (t, b, c, d)=>c * ((t / d - 1) ** 3 + 1) + b;
/**
 * Cubic easing in and out
 */ const $ab3f2a5cc6216ae5$var$easeInOutCubic = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 3 + b;
    return c / 2 * ((t - 2) ** 3 + 2) + b;
};
/**
 * Quartic easing in
 */ const $ab3f2a5cc6216ae5$var$easeInQuart = (t, b, c, d)=>c * (t /= d) * t ** 3 + b;
/**
 * Quartic easing out
 */ const $ab3f2a5cc6216ae5$var$easeOutQuart = (t, b, c, d)=>-c * ((t = t / d - 1) * t ** 3 - 1) + b;
/**
 * Quartic easing in and out
 */ const $ab3f2a5cc6216ae5$var$easeInOutQuart = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 4 + b;
    return -c / 2 * ((t -= 2) * t ** 3 - 2) + b;
};
/**
 * Quintic easing in
 */ const $ab3f2a5cc6216ae5$var$easeInQuint = (t, b, c, d)=>c * (t / d) ** 5 + b;
/**
 * Quintic easing out
 */ const $ab3f2a5cc6216ae5$var$easeOutQuint = (t, b, c, d)=>c * ((t / d - 1) ** 5 + 1) + b;
/**
 * Quintic easing in and out
 */ const $ab3f2a5cc6216ae5$var$easeInOutQuint = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 5 + b;
    return c / 2 * ((t - 2) ** 5 + 2) + b;
};
/**
 * Sinusoidal easing in
 */ const $ab3f2a5cc6216ae5$var$easeInSine = (t, b, c, d)=>-c * Math.cos(t / d * $ab3f2a5cc6216ae5$var$halfPI) + c + b;
/**
 * Sinusoidal easing out
 */ const $ab3f2a5cc6216ae5$var$easeOutSine = (t, b, c, d)=>c * Math.sin(t / d * $ab3f2a5cc6216ae5$var$halfPI) + b;
/**
 * Sinusoidal easing in and out
 */ const $ab3f2a5cc6216ae5$var$easeInOutSine = (t, b, c, d)=>-c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
/**
 * Exponential easing in
 */ const $ab3f2a5cc6216ae5$var$easeInExpo = (t, b, c, d)=>t === 0 ? b : c * 2 ** (10 * (t / d - 1)) + b;
/**
 * Exponential easing out
 */ const $ab3f2a5cc6216ae5$var$easeOutExpo = (t, b, c, d)=>t === d ? b + c : c * -(2 ** (-10 * t / d) + 1) + b;
/**
 * Exponential easing in and out
 */ const $ab3f2a5cc6216ae5$var$easeInOutExpo = (t, b, c, d)=>{
    if (t === 0) return b;
    if (t === d) return b + c;
    t /= d / 2;
    if (t < 1) return c / 2 * 2 ** (10 * (t - 1)) + b;
    return c / 2 * -(2 ** (-10 * --t) + 2) + b;
};
/**
 * Circular easing in
 */ const $ab3f2a5cc6216ae5$var$easeInCirc = (t, b, c, d)=>-c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
/**
 * Circular easing out
 */ const $ab3f2a5cc6216ae5$var$easeOutCirc = (t, b, c, d)=>c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
/**
 * Circular easing in and out
 */ const $ab3f2a5cc6216ae5$var$easeInOutCirc = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return -c / 2 * (Math.sqrt(1 - t ** 2) - 1) + b;
    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
};
/**
 * Elastic easing in
 */ const $ab3f2a5cc6216ae5$var$easeInElastic = (t, b, c, d)=>{
    const s = 1.70158, a = c;
    let p = 0;
    if (t === 0) return b;
    t /= d;
    if (t === 1) return b + c;
    if (!p) p = d * 0.3;
    const { a: normA, s: normS, p: normP } = $ab3f2a5cc6216ae5$var$normalize(a, c, p, s);
    return -$ab3f2a5cc6216ae5$var$elastic(normA, normS, normP, t, d) + b;
};
/**
 * Elastic easing out
 */ const $ab3f2a5cc6216ae5$var$easeOutElastic = (t, b, c, d)=>{
    const s = 1.70158, a = c;
    let p = 0;
    if (t === 0) return b;
    t /= d;
    if (t === 1) return b + c;
    if (!p) p = d * 0.3;
    const { a: normA, s: normS, p: normP, c: normC } = $ab3f2a5cc6216ae5$var$normalize(a, c, p, s);
    return normA * 2 ** (-10 * t) * Math.sin((t * d - normS) * $ab3f2a5cc6216ae5$var$twoMathPi / normP) + normC + b;
};
/**
 * Elastic easing in and out
 */ const $ab3f2a5cc6216ae5$var$easeInOutElastic = (t, b, c, d)=>{
    const s = 1.70158, a = c;
    let p = 0;
    if (t === 0) return b;
    t /= d / 2;
    if (t === 2) return b + c;
    if (!p) p = d * (0.3 * 1.5);
    const { a: normA, s: normS, p: normP, c: normC } = $ab3f2a5cc6216ae5$var$normalize(a, c, p, s);
    if (t < 1) return -0.5 * $ab3f2a5cc6216ae5$var$elastic(normA, normS, normP, t, d) + b;
    return normA * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - normS) * $ab3f2a5cc6216ae5$var$twoMathPi / normP) * 0.5 + normC + b;
};
/**
 * Backwards easing in
 */ const $ab3f2a5cc6216ae5$var$easeInBack = function(t, b, c, d) {
    let s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.70158;
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
};
/**
 * Backwards easing out
 */ const $ab3f2a5cc6216ae5$var$easeOutBack = function(t, b, c, d) {
    let s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.70158;
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
};
/**
 * Backwards easing in and out
 */ const $ab3f2a5cc6216ae5$var$easeInOutBack = function(t, b, c, d) {
    let s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.70158;
    t /= d / 2;
    if (t < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
};
/**
 * Bouncing easing out
 */ const $ab3f2a5cc6216ae5$var$easeOutBounce = (t, b, c, d)=>{
    if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
    else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
    else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
    else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
};
/**
 * Bouncing easing in
 */ const $ab3f2a5cc6216ae5$var$easeInBounce = (t, b, c, d)=>c - $ab3f2a5cc6216ae5$var$easeOutBounce(d - t, 0, c, d) + b;
/**
 * Bouncing easing in and out
 */ const $ab3f2a5cc6216ae5$var$easeInOutBounce = (t, b, c, d)=>t < d / 2 ? $ab3f2a5cc6216ae5$var$easeInBounce(t * 2, 0, c, d) * 0.5 + b : $ab3f2a5cc6216ae5$var$easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
/**
 * Quadratic easing in
 */ const $ab3f2a5cc6216ae5$var$easeInQuad = (t, b, c, d)=>c * (t /= d) * t + b;
/**
 * Quadratic easing out
 */ const $ab3f2a5cc6216ae5$var$easeOutQuad = (t, b, c, d)=>-c * (t /= d) * (t - 2) + b;
/**
 * Quadratic easing in and out
 */ const $ab3f2a5cc6216ae5$var$easeInOutQuad = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 2 + b;
    return -c / 2 * (--t * (t - 2) - 1) + b;
};
var $ab3f2a5cc6216ae5$var$easing = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultEasing: $ab3f2a5cc6216ae5$var$defaultEasing,
    easeInBack: $ab3f2a5cc6216ae5$var$easeInBack,
    easeInBounce: $ab3f2a5cc6216ae5$var$easeInBounce,
    easeInCirc: $ab3f2a5cc6216ae5$var$easeInCirc,
    easeInCubic: $ab3f2a5cc6216ae5$var$easeInCubic,
    easeInElastic: $ab3f2a5cc6216ae5$var$easeInElastic,
    easeInExpo: $ab3f2a5cc6216ae5$var$easeInExpo,
    easeInOutBack: $ab3f2a5cc6216ae5$var$easeInOutBack,
    easeInOutBounce: $ab3f2a5cc6216ae5$var$easeInOutBounce,
    easeInOutCirc: $ab3f2a5cc6216ae5$var$easeInOutCirc,
    easeInOutCubic: $ab3f2a5cc6216ae5$var$easeInOutCubic,
    easeInOutElastic: $ab3f2a5cc6216ae5$var$easeInOutElastic,
    easeInOutExpo: $ab3f2a5cc6216ae5$var$easeInOutExpo,
    easeInOutQuad: $ab3f2a5cc6216ae5$var$easeInOutQuad,
    easeInOutQuart: $ab3f2a5cc6216ae5$var$easeInOutQuart,
    easeInOutQuint: $ab3f2a5cc6216ae5$var$easeInOutQuint,
    easeInOutSine: $ab3f2a5cc6216ae5$var$easeInOutSine,
    easeInQuad: $ab3f2a5cc6216ae5$var$easeInQuad,
    easeInQuart: $ab3f2a5cc6216ae5$var$easeInQuart,
    easeInQuint: $ab3f2a5cc6216ae5$var$easeInQuint,
    easeInSine: $ab3f2a5cc6216ae5$var$easeInSine,
    easeOutBack: $ab3f2a5cc6216ae5$var$easeOutBack,
    easeOutBounce: $ab3f2a5cc6216ae5$var$easeOutBounce,
    easeOutCirc: $ab3f2a5cc6216ae5$var$easeOutCirc,
    easeOutCubic: $ab3f2a5cc6216ae5$var$easeOutCubic,
    easeOutElastic: $ab3f2a5cc6216ae5$var$easeOutElastic,
    easeOutExpo: $ab3f2a5cc6216ae5$var$easeOutExpo,
    easeOutQuad: $ab3f2a5cc6216ae5$var$easeOutQuad,
    easeOutQuart: $ab3f2a5cc6216ae5$var$easeOutQuart,
    easeOutQuint: $ab3f2a5cc6216ae5$var$easeOutQuint,
    easeOutSine: $ab3f2a5cc6216ae5$var$easeOutSine
});
const $ab3f2a5cc6216ae5$var$defaultAbort = ()=>false;
class $ab3f2a5cc6216ae5$var$AnimationBase {
    /**
   * Current value
   */ /**
   * Animation start time ms
   */ constructor(_ref){
        let { startValue: startValue, byValue: byValue, duration: duration = 500, delay: delay = 0, easing: easing = $ab3f2a5cc6216ae5$var$defaultEasing, onStart: onStart = $ab3f2a5cc6216ae5$var$noop, onChange: onChange = $ab3f2a5cc6216ae5$var$noop, onComplete: onComplete = $ab3f2a5cc6216ae5$var$noop, abort: abort = $ab3f2a5cc6216ae5$var$defaultAbort, target: target } = _ref;
        /**
     * Used to register the animation to a target object
     * so that it can be cancelled within the object context
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_state", "pending");
        /**
     * Time %, or the ratio of `timeElapsed / duration`
     * @see tick
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "durationProgress", 0);
        /**
     * Value %, or the ratio of `(currentValue - startValue) / (endValue - startValue)`
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "valueProgress", 0);
        this.tick = this.tick.bind(this);
        this.duration = duration;
        this.delay = delay;
        this.easing = easing;
        this._onStart = onStart;
        this._onChange = onChange;
        this._onComplete = onComplete;
        this._abort = abort;
        this.target = target;
        this.startValue = startValue;
        this.byValue = byValue;
        this.value = this.startValue;
        this.endValue = Object.freeze(this.calculate(this.duration).value);
    }
    get state() {
        return this._state;
    }
    isDone() {
        return this._state === "aborted" || this._state === "completed";
    }
    /**
   * Calculate the current value based on the easing parameters
   * @param timeElapsed in ms
   * @protected
   */ start() {
        const firstTick = (timestamp)=>{
            if (this._state !== "pending") return;
            this.startTime = timestamp || +new Date();
            this._state = "running";
            this._onStart();
            this.tick(this.startTime);
        };
        this.register();
        // setTimeout(cb, 0) will run cb on the next frame, causing a delay
        // we don't want that
        if (this.delay > 0) setTimeout(()=>$ab3f2a5cc6216ae5$var$requestAnimFrame(firstTick), this.delay);
        else $ab3f2a5cc6216ae5$var$requestAnimFrame(firstTick);
    }
    tick(t) {
        const durationMs = (t || +new Date()) - this.startTime;
        const boundDurationMs = Math.min(durationMs, this.duration);
        this.durationProgress = boundDurationMs / this.duration;
        const { value: value, valueProgress: valueProgress } = this.calculate(boundDurationMs);
        this.value = Object.freeze(value);
        this.valueProgress = valueProgress;
        if (this._state === "aborted") return;
        else if (this._abort(this.value, this.valueProgress, this.durationProgress)) {
            this._state = "aborted";
            this.unregister();
        } else if (durationMs >= this.duration) {
            this.durationProgress = this.valueProgress = 1;
            this._onChange(this.endValue, this.valueProgress, this.durationProgress);
            this._state = "completed";
            this._onComplete(this.endValue, this.valueProgress, this.durationProgress);
            this.unregister();
        } else {
            this._onChange(this.value, this.valueProgress, this.durationProgress);
            $ab3f2a5cc6216ae5$var$requestAnimFrame(this.tick);
        }
    }
    register() {
        $ab3f2a5cc6216ae5$export$dc18923894d9e56a.push(this);
    }
    unregister() {
        $ab3f2a5cc6216ae5$export$dc18923894d9e56a.remove(this);
    }
    abort() {
        this._state = "aborted";
        this.unregister();
    }
}
const $ab3f2a5cc6216ae5$var$_excluded$h = [
    "startValue",
    "endValue"
];
class $ab3f2a5cc6216ae5$var$ValueAnimation extends $ab3f2a5cc6216ae5$var$AnimationBase {
    constructor(_ref){
        let { startValue: startValue = 0, endValue: endValue = 100 } = _ref, otherOptions = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref, $ab3f2a5cc6216ae5$var$_excluded$h);
        super($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, otherOptions), {}, {
            startValue: startValue,
            byValue: endValue - startValue
        }));
    }
    calculate(timeElapsed) {
        const value = this.easing(timeElapsed, this.startValue, this.byValue, this.duration);
        return {
            value: value,
            valueProgress: Math.abs((value - this.startValue) / this.byValue)
        };
    }
}
const $ab3f2a5cc6216ae5$var$_excluded$g = [
    "startValue",
    "endValue"
];
class $ab3f2a5cc6216ae5$var$ArrayAnimation extends $ab3f2a5cc6216ae5$var$AnimationBase {
    constructor(_ref){
        let { startValue: startValue = [
            0
        ], endValue: endValue = [
            100
        ] } = _ref, options = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref, $ab3f2a5cc6216ae5$var$_excluded$g);
        super($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), {}, {
            startValue: startValue,
            byValue: endValue.map((value, i)=>value - startValue[i])
        }));
    }
    calculate(timeElapsed) {
        const values = this.startValue.map((value, i)=>this.easing(timeElapsed, value, this.byValue[i], this.duration, i));
        return {
            value: values,
            valueProgress: Math.abs((values[0] - this.startValue[0]) / this.byValue[0])
        };
    }
}
const $ab3f2a5cc6216ae5$var$capValue = (min, value, max)=>Math.max(min, Math.min(value, max));
const $ab3f2a5cc6216ae5$var$_excluded$f = [
    "startValue",
    "endValue",
    "easing",
    "onChange",
    "onComplete",
    "abort"
];
const $ab3f2a5cc6216ae5$var$defaultColorEasing = (timeElapsed, startValue, byValue, duration)=>{
    const durationProgress = 1 - Math.cos(timeElapsed / duration * $ab3f2a5cc6216ae5$var$halfPI);
    return startValue + byValue * durationProgress;
};
const $ab3f2a5cc6216ae5$var$wrapColorCallback = (callback)=>callback && ((rgba, valueProgress, durationProgress)=>callback(new $ab3f2a5cc6216ae5$export$892596cec99bc70e(rgba).toRgba(), valueProgress, durationProgress));
class $ab3f2a5cc6216ae5$var$ColorAnimation extends $ab3f2a5cc6216ae5$var$AnimationBase {
    constructor(_ref){
        let { startValue: startValue, endValue: endValue, easing: easing = $ab3f2a5cc6216ae5$var$defaultColorEasing, onChange: onChange, onComplete: onComplete, abort: abort } = _ref, options = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref, $ab3f2a5cc6216ae5$var$_excluded$f);
        const startColor = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(startValue).getSource();
        const endColor = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(endValue).getSource();
        super($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), {}, {
            startValue: startColor,
            byValue: endColor.map((value, i)=>value - startColor[i]),
            easing: easing,
            onChange: $ab3f2a5cc6216ae5$var$wrapColorCallback(onChange),
            onComplete: $ab3f2a5cc6216ae5$var$wrapColorCallback(onComplete),
            abort: $ab3f2a5cc6216ae5$var$wrapColorCallback(abort)
        }));
    }
    calculate(timeElapsed) {
        const [r, g, b, a] = this.startValue.map((value, i)=>this.easing(timeElapsed, value, this.byValue[i], this.duration, i));
        const value = [
            ...[
                r,
                g,
                b
            ].map(Math.round),
            $ab3f2a5cc6216ae5$var$capValue(0, a, 1)
        ];
        return {
            value: value,
            valueProgress: // to correctly calculate the change ratio we must find a changed value
            value.map((p, i)=>this.byValue[i] !== 0 ? Math.abs((p - this.startValue[i]) / this.byValue[i]) : 0).find((p)=>p !== 0) || 0
        };
    }
}
const $ab3f2a5cc6216ae5$var$isArrayAnimation = (options)=>{
    return Array.isArray(options.startValue) || Array.isArray(options.endValue);
};
/**
 * Changes value(s) from startValue to endValue within a certain period of time,
 * invoking callbacks as the value(s) change.
 *
 * @example
 * animate({
 *   startValue: 1,
 *   endValue: 0,
 *   onChange: (v) => {
 *     obj.set('opacity', v);
 *     // since we are running in a requested frame we should call `renderAll` and not `requestRenderAll`
 *     canvas.renderAll();
 *   }
 * });
 *
 * @example Using lists:
 * animate({
 *   startValue: [1, 2, 3],
 *   endValue: [2, 4, 6],
 *   onChange: ([x, y, zoom]) => {
 *     canvas.zoomToPoint(new Point(x, y), zoom);
 *     canvas.renderAll();
 *   }
 * });
 *
 */ function $ab3f2a5cc6216ae5$var$animate(options) {
    const animation = $ab3f2a5cc6216ae5$var$isArrayAnimation(options) ? new $ab3f2a5cc6216ae5$var$ArrayAnimation(options) : new $ab3f2a5cc6216ae5$var$ValueAnimation(options);
    animation.start();
    return animation;
}
function $ab3f2a5cc6216ae5$var$animateColor(options) {
    const animation = new $ab3f2a5cc6216ae5$var$ColorAnimation(options);
    animation.start();
    return animation;
}
const $ab3f2a5cc6216ae5$var$unitVectorX = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(1, 0);
const $ab3f2a5cc6216ae5$var$zero = new $ab3f2a5cc6216ae5$export$baf26146a414f24a();
/**
 * Rotates `vector` with `radians`
 * @param {Point} vector The vector to rotate (x and y)
 * @param {Number} radians The radians of the angle for the rotation
 * @return {Point} The new rotated point
 */ const $ab3f2a5cc6216ae5$var$rotateVector = (vector, radians)=>vector.rotate(radians);
/**
 * Creates a vector from points represented as a point
 *
 * @param {Point} from
 * @param {Point} to
 * @returns {Point} vector
 */ const $ab3f2a5cc6216ae5$var$createVector = (from, to)=>new $ab3f2a5cc6216ae5$export$baf26146a414f24a(to).subtract(from);
/**
 * return the magnitude of a vector
 * @return {number}
 */ const $ab3f2a5cc6216ae5$var$magnitude = (point)=>point.distanceFrom($ab3f2a5cc6216ae5$var$zero);
/**
 * Calculates the angle between 2 vectors
 * @param {Point} a
 * @param {Point} b
 * @returns the angle in radians from `a` to `b`
 */ const $ab3f2a5cc6216ae5$var$calcAngleBetweenVectors = (a, b)=>Math.atan2($ab3f2a5cc6216ae5$var$crossProduct(a, b), $ab3f2a5cc6216ae5$var$dotProduct(a, b));
/**
 * Calculates the angle between the x axis and the vector
 * @param {Point} v
 * @returns the angle in radians of `v`
 */ const $ab3f2a5cc6216ae5$var$calcVectorRotation = (v)=>$ab3f2a5cc6216ae5$var$calcAngleBetweenVectors($ab3f2a5cc6216ae5$var$unitVectorX, v);
/**
 * @param {Point} v
 * @returns {Point} vector representing the unit vector pointing to the direction of `v`
 */ const $ab3f2a5cc6216ae5$var$getUnitVector = (v)=>v.eq($ab3f2a5cc6216ae5$var$zero) ? v : v.scalarDivide($ab3f2a5cc6216ae5$var$magnitude(v));
/**
 * @param {Point} v
 * @param {Boolean} [counterClockwise] the direction of the orthogonal vector, defaults to `true`
 * @returns {Point} the unit orthogonal vector
 */ const $ab3f2a5cc6216ae5$var$getOrthonormalVector = function(v) {
    let counterClockwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $ab3f2a5cc6216ae5$var$getUnitVector(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(-v.y, v.x).scalarMultiply(counterClockwise ? 1 : -1));
};
/**
 * Cross product of two vectors in 2D
 * @param {Point} a
 * @param {Point} b
 * @returns {number} the magnitude of Z vector
 */ const $ab3f2a5cc6216ae5$var$crossProduct = (a, b)=>a.x * b.y - a.y * b.x;
/**
 * Dot product of two vectors in 2D
 * @param {Point} a
 * @param {Point} b
 * @returns {number}
 */ const $ab3f2a5cc6216ae5$var$dotProduct = (a, b)=>a.x * b.x + a.y * b.y;
/**
 * Checks if the vector is between two others. It is considered
 * to be inside when the vector to be tested is between the
 * initial vector and the final vector (included) in a counterclockwise direction.
 * @param {Point} t vector to be tested
 * @param {Point} a initial vector
 * @param {Point} b final vector
 * @returns {boolean} true if the vector is among the others
 */ const $ab3f2a5cc6216ae5$var$isBetweenVectors = (t, a, b)=>{
    if (t.eq(a) || t.eq(b)) return true;
    const AxB = $ab3f2a5cc6216ae5$var$crossProduct(a, b), AxT = $ab3f2a5cc6216ae5$var$crossProduct(a, t), BxT = $ab3f2a5cc6216ae5$var$crossProduct(b, t);
    return AxB >= 0 ? AxT >= 0 && BxT <= 0 : !(AxT <= 0 && BxT >= 0);
};
/* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */ class $ab3f2a5cc6216ae5$export$869c896bf338bf5a {
    constructor(status){
        this.status = status;
        this.points = [];
    }
    /**
   * Used to verify if a point is alredy in the collection
   * @param {Point} point
   * @returns {boolean}
   */ includes(point) {
        return this.points.some((p)=>p.eq(point));
    }
    /**
   * Appends points of intersection
   * @param {...Point[]} points
   * @return {Intersection} thisArg
   * @chainable
   */ append() {
        for(var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++)points[_key] = arguments[_key];
        this.points = this.points.concat(points.filter((point)=>{
            return !this.includes(point);
        }));
        return this;
    }
    /**
   * check if point T is on the segment or line defined between A and B
   *
   * @param {Point} T the point we are checking for
   * @param {Point} A one extremity of the segment
   * @param {Point} B the other extremity of the segment
   * @param [infinite] if true checks if `T` is on the line defined by `A` and `B`
   * @returns true if `T` is contained
   */ static isPointContained(T, A, B) {
        let infinite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        if (A.eq(B)) // Edge case: the segment is a point, we check for coincidence,
        // infinite param has no meaning because there are infinite lines to consider
        return T.eq(A);
        else if (A.x === B.x) // Edge case: horizontal line.
        // we first check if T.x has the same value, and then if T.y is contained between A.y and B.y
        return T.x === A.x && (infinite || T.y >= Math.min(A.y, B.y) && T.y <= Math.max(A.y, B.y));
        else if (A.y === B.y) // Edge case: vertical line.
        // we first check if T.y has the same value, and then if T.x is contained between A.x and B.x
        return T.y === A.y && (infinite || T.x >= Math.min(A.x, B.x) && T.x <= Math.max(A.x, B.x));
        else {
            // Generic case: sloped line.
            // we check that AT has the same slope as AB
            // for the segment case we need both the vectors to have the same direction and for AT to be lte AB in size
            // for the infinite case we check the absolute value of the slope, since direction is meaningless
            const AB = $ab3f2a5cc6216ae5$var$createVector(A, B);
            const AT = $ab3f2a5cc6216ae5$var$createVector(A, T);
            const s = AT.divide(AB);
            return infinite ? Math.abs(s.x) === Math.abs(s.y) : s.x === s.y && s.x >= 0 && s.x <= 1;
        }
    }
    /**
   * Use the ray casting algorithm to determine if {@link point} is in the polygon defined by {@link points}
   * @see https://en.wikipedia.org/wiki/Point_in_polygon
   * @param point
   * @param points polygon points
   * @returns
   */ static isPointInPolygon(point, points) {
        const other = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(point).setX(Math.min(point.x - 1, ...points.map((p)=>p.x)));
        let hits = 0;
        for(let index = 0; index < points.length; index++){
            const inter = this.intersectSegmentSegment(// polygon side
            points[index], points[(index + 1) % points.length], // ray
            point, other);
            if (inter.includes(point)) // point is on the polygon side
            return true;
            hits += Number(inter.status === "Intersection");
        }
        return hits % 2 === 1;
    }
    /**
   * Checks if a line intersects another
   * @see {@link https://en.wikipedia.org/wiki/Line%E2%80%93line_intersection line intersection}
   * @see {@link https://en.wikipedia.org/wiki/Cramer%27s_rule Cramer's rule}
   * @static
   * @param {Point} a1
   * @param {Point} a2
   * @param {Point} b1
   * @param {Point} b2
   * @param {boolean} [aInfinite=true] check segment intersection by passing `false`
   * @param {boolean} [bInfinite=true] check segment intersection by passing `false`
   * @return {Intersection}
   */ static intersectLineLine(a1, a2, b1, b2) {
        let aInfinite = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        let bInfinite = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
        const a2xa1x = a2.x - a1.x, a2ya1y = a2.y - a1.y, b2xb1x = b2.x - b1.x, b2yb1y = b2.y - b1.y, a1xb1x = a1.x - b1.x, a1yb1y = a1.y - b1.y, uaT = b2xb1x * a1yb1y - b2yb1y * a1xb1x, ubT = a2xa1x * a1yb1y - a2ya1y * a1xb1x, uB = b2yb1y * a2xa1x - b2xb1x * a2ya1y;
        if (uB !== 0) {
            const ua = uaT / uB, ub = ubT / uB;
            if ((aInfinite || 0 <= ua && ua <= 1) && (bInfinite || 0 <= ub && ub <= 1)) return new $ab3f2a5cc6216ae5$export$869c896bf338bf5a("Intersection").append(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(a1.x + ua * a2xa1x, a1.y + ua * a2ya1y));
            else return new $ab3f2a5cc6216ae5$export$869c896bf338bf5a();
        } else {
            if (uaT === 0 || ubT === 0) {
                const segmentsCoincide = aInfinite || bInfinite || $ab3f2a5cc6216ae5$export$869c896bf338bf5a.isPointContained(a1, b1, b2) || $ab3f2a5cc6216ae5$export$869c896bf338bf5a.isPointContained(a2, b1, b2) || $ab3f2a5cc6216ae5$export$869c896bf338bf5a.isPointContained(b1, a1, a2) || $ab3f2a5cc6216ae5$export$869c896bf338bf5a.isPointContained(b2, a1, a2);
                return new $ab3f2a5cc6216ae5$export$869c896bf338bf5a(segmentsCoincide ? "Coincident" : undefined);
            } else return new $ab3f2a5cc6216ae5$export$869c896bf338bf5a("Parallel");
        }
    }
    /**
   * Checks if a segment intersects a line
   * @see {@link intersectLineLine} for line intersection
   * @static
   * @param {Point} s1 boundary point of segment
   * @param {Point} s2 other boundary point of segment
   * @param {Point} l1 point on line
   * @param {Point} l2 other point on line
   * @return {Intersection}
   */ static intersectSegmentLine(s1, s2, l1, l2) {
        return $ab3f2a5cc6216ae5$export$869c896bf338bf5a.intersectLineLine(s1, s2, l1, l2, false, true);
    }
    /**
   * Checks if a segment intersects another
   * @see {@link intersectLineLine} for line intersection
   * @static
   * @param {Point} a1 boundary point of segment
   * @param {Point} a2 other boundary point of segment
   * @param {Point} b1 boundary point of segment
   * @param {Point} b2 other boundary point of segment
   * @return {Intersection}
   */ static intersectSegmentSegment(a1, a2, b1, b2) {
        return $ab3f2a5cc6216ae5$export$869c896bf338bf5a.intersectLineLine(a1, a2, b1, b2, false, false);
    }
    /**
   * Checks if line intersects polygon
   *
   * @todo account for stroke
   *
   * @static
   * @see {@link intersectSegmentPolygon} for segment intersection
   * @param {Point} a1 point on line
   * @param {Point} a2 other point on line
   * @param {Point[]} points polygon points
   * @param {boolean} [infinite=true] check segment intersection by passing `false`
   * @return {Intersection}
   */ static intersectLinePolygon(a1, a2, points) {
        let infinite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        const result = new $ab3f2a5cc6216ae5$export$869c896bf338bf5a();
        const length = points.length;
        for(let i = 0, b1, b2, inter; i < length; i++){
            b1 = points[i];
            b2 = points[(i + 1) % length];
            inter = $ab3f2a5cc6216ae5$export$869c896bf338bf5a.intersectLineLine(a1, a2, b1, b2, infinite, false);
            if (inter.status === "Coincident") return inter;
            result.append(...inter.points);
        }
        if (result.points.length > 0) result.status = "Intersection";
        return result;
    }
    /**
   * Checks if segment intersects polygon
   * @static
   * @see {@link intersectLinePolygon} for line intersection
   * @param {Point} a1 boundary point of segment
   * @param {Point} a2 other boundary point of segment
   * @param {Point[]} points polygon points
   * @return {Intersection}
   */ static intersectSegmentPolygon(a1, a2, points) {
        return $ab3f2a5cc6216ae5$export$869c896bf338bf5a.intersectLinePolygon(a1, a2, points, false);
    }
    /**
   * Checks if polygon intersects another polygon
   *
   * @todo account for stroke
   *
   * @static
   * @param {Point[]} points1
   * @param {Point[]} points2
   * @return {Intersection}
   */ static intersectPolygonPolygon(points1, points2) {
        const result = new $ab3f2a5cc6216ae5$export$869c896bf338bf5a(), length = points1.length;
        const coincidences = [];
        for(let i = 0; i < length; i++){
            const a1 = points1[i], a2 = points1[(i + 1) % length], inter = $ab3f2a5cc6216ae5$export$869c896bf338bf5a.intersectSegmentPolygon(a1, a2, points2);
            if (inter.status === "Coincident") {
                coincidences.push(inter);
                result.append(a1, a2);
            } else result.append(...inter.points);
        }
        if (coincidences.length > 0 && coincidences.length === points1.length) return new $ab3f2a5cc6216ae5$export$869c896bf338bf5a("Coincident");
        else if (result.points.length > 0) result.status = "Intersection";
        return result;
    }
    /**
   * Checks if polygon intersects rectangle
   * @static
   * @see {@link intersectPolygonPolygon} for polygon intersection
   * @param {Point[]} points polygon points
   * @param {Point} r1 top left point of rect
   * @param {Point} r2 bottom right point of rect
   * @return {Intersection}
   */ static intersectPolygonRectangle(points, r1, r2) {
        const min = r1.min(r2), max = r1.max(r2), topRight = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(max.x, min.y), bottomLeft = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(min.x, max.y);
        return $ab3f2a5cc6216ae5$export$869c896bf338bf5a.intersectPolygonPolygon(points, [
            min,
            topRight,
            max,
            bottomLeft
        ]);
    }
}
class $ab3f2a5cc6216ae5$var$ObjectOrigin extends $ab3f2a5cc6216ae5$var$CommonMethods {
    /**
   * Object containing this object.
   * can influence its size and position
   */ /**
   * Calculate object bounding box dimensions from its properties scale, skew.
   * This bounding box is aligned with object angle and not with canvas axis or screen.
   * @param {Object} [options]
   * @param {Number} [options.scaleX]
   * @param {Number} [options.scaleY]
   * @param {Number} [options.skewX]
   * @param {Number} [options.skewY]
   * @private
   * @returns {Point} dimensions
   */ _getTransformedDimensions() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const dimOptions = $ab3f2a5cc6216ae5$var$_objectSpread2({
            // if scaleX or scaleY are negative numbers,
            // this will return dimensions that are negative.
            // and this will break assumptions around the codebase
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            width: this.width,
            height: this.height,
            strokeWidth: this.strokeWidth
        }, options);
        // stroke is applied before/after transformations are applied according to `strokeUniform`
        const strokeWidth = dimOptions.strokeWidth;
        let preScalingStrokeValue = strokeWidth, postScalingStrokeValue = 0;
        if (this.strokeUniform) {
            preScalingStrokeValue = 0;
            postScalingStrokeValue = strokeWidth;
        }
        const dimX = dimOptions.width + preScalingStrokeValue, dimY = dimOptions.height + preScalingStrokeValue, noSkew = dimOptions.skewX === 0 && dimOptions.skewY === 0;
        let finalDimensions;
        if (noSkew) finalDimensions = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(dimX * dimOptions.scaleX, dimY * dimOptions.scaleY);
        else finalDimensions = $ab3f2a5cc6216ae5$var$sizeAfterTransform(dimX, dimY, $ab3f2a5cc6216ae5$var$calcDimensionsMatrix(dimOptions));
        return finalDimensions.scalarAdd(postScalingStrokeValue);
    }
    /**
   * Translates the coordinates from a set of origin to another (based on the object's dimensions)
   * @param {Point} point The point which corresponds to the originX and originY params
   * @param {TOriginX} fromOriginX Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
   * @param {TOriginX} toOriginX Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} toOriginY Vertical origin: 'top', 'center' or 'bottom'
   * @return {Point}
   */ translateToGivenOrigin(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
        let x = point.x, y = point.y;
        const offsetX = $ab3f2a5cc6216ae5$var$resolveOrigin(toOriginX) - $ab3f2a5cc6216ae5$var$resolveOrigin(fromOriginX), offsetY = $ab3f2a5cc6216ae5$var$resolveOrigin(toOriginY) - $ab3f2a5cc6216ae5$var$resolveOrigin(fromOriginY);
        if (offsetX || offsetY) {
            const dim = this._getTransformedDimensions();
            x += offsetX * dim.x;
            y += offsetY * dim.y;
        }
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(x, y);
    }
    /**
   * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
   * @param {Point} point The point which corresponds to the originX and originY params
   * @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
   * @return {Point}
   */ translateToCenterPoint(point, originX, originY) {
        const p = this.translateToGivenOrigin(point, originX, originY, $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER);
        if (this.angle) return p.rotate($ab3f2a5cc6216ae5$var$degreesToRadians(this.angle), point);
        return p;
    }
    /**
   * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
   * @param {Point} center The point which corresponds to center of the object
   * @param {OriginX} originX Horizontal origin: 'left', 'center' or 'right'
   * @param {OriginY} originY Vertical origin: 'top', 'center' or 'bottom'
   * @return {Point}
   */ translateToOriginPoint(center, originX, originY) {
        const p = this.translateToGivenOrigin(center, $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER, originX, originY);
        if (this.angle) return p.rotate($ab3f2a5cc6216ae5$var$degreesToRadians(this.angle), center);
        return p;
    }
    /**
   * Returns the center coordinates of the object relative to canvas
   * @return {Point}
   */ getCenterPoint() {
        const relCenter = this.getRelativeCenterPoint();
        return this.group ? $ab3f2a5cc6216ae5$var$transformPoint(relCenter, this.group.calcTransformMatrix()) : relCenter;
    }
    /**
   * Returns the center coordinates of the object relative to it's parent
   * @return {Point}
   */ getRelativeCenterPoint() {
        return this.translateToCenterPoint(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.left, this.top), this.originX, this.originY);
    }
    /**
   * Returns the coordinates of the object as if it has a different origin
   * @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
   * @return {Point}
   */ getPointByOrigin(originX, originY) {
        return this.translateToOriginPoint(this.getRelativeCenterPoint(), originX, originY);
    }
    /**
   * Sets the position of the object taking into consideration the object's origin
   * @param {Point} pos The new position of the object
   * @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
   * @return {void}
   */ setPositionByOrigin(pos, originX, originY) {
        const center = this.translateToCenterPoint(pos, originX, originY), position = this.translateToOriginPoint(center, this.originX, this.originY);
        this.set({
            left: position.x,
            top: position.y
        });
    }
    /**
   * @private
   */ _getLeftTopCoords() {
        return this.translateToOriginPoint(this.getRelativeCenterPoint(), $ab3f2a5cc6216ae5$var$LEFT, $ab3f2a5cc6216ae5$var$TOP);
    }
}
class $ab3f2a5cc6216ae5$var$ObjectGeometry extends $ab3f2a5cc6216ae5$var$ObjectOrigin {
    /**
   * Describe object's corner position in scene coordinates.
   * The coordinates are derived from the following:
   * left, top, width, height, scaleX, scaleY, skewX, skewY, angle, strokeWidth.
   * The coordinates do not depend on viewport changes.
   * The coordinates get updated with {@link setCoords}.
   * You can calculate them without updating with {@link calcACoords()}
   */ /**
   * storage cache for object transform matrix
   */ /**
   * storage cache for object full transform matrix
   */ /**
   * A Reference of the Canvas where the object is actually added
   * @type StaticCanvas | Canvas;
   * @default undefined
   * @private
   */ /**
   * @returns {number} x position according to object's {@link originX} property in canvas coordinate plane
   */ getX() {
        return this.getXY().x;
    }
    /**
   * @param {number} value x position according to object's {@link originX} property in canvas coordinate plane
   */ setX(value) {
        this.setXY(this.getXY().setX(value));
    }
    /**
   * @returns {number} y position according to object's {@link originY} property in canvas coordinate plane
   */ getY() {
        return this.getXY().y;
    }
    /**
   * @param {number} value y position according to object's {@link originY} property in canvas coordinate plane
   */ setY(value) {
        this.setXY(this.getXY().setY(value));
    }
    /**
   * @returns {number} x position according to object's {@link originX} property in parent's coordinate plane\
   * if parent is canvas then this property is identical to {@link getX}
   */ getRelativeX() {
        return this.left;
    }
    /**
   * @param {number} value x position according to object's {@link originX} property in parent's coordinate plane\
   * if parent is canvas then this method is identical to {@link setX}
   */ setRelativeX(value) {
        this.left = value;
    }
    /**
   * @returns {number} y position according to object's {@link originY} property in parent's coordinate plane\
   * if parent is canvas then this property is identical to {@link getY}
   */ getRelativeY() {
        return this.top;
    }
    /**
   * @param {number} value y position according to object's {@link originY} property in parent's coordinate plane\
   * if parent is canvas then this property is identical to {@link setY}
   */ setRelativeY(value) {
        this.top = value;
    }
    /**
   * @returns {Point} x position according to object's {@link originX} {@link originY} properties in canvas coordinate plane
   */ getXY() {
        const relativePosition = this.getRelativeXY();
        return this.group ? $ab3f2a5cc6216ae5$var$transformPoint(relativePosition, this.group.calcTransformMatrix()) : relativePosition;
    }
    /**
   * Set an object position to a particular point, the point is intended in absolute ( canvas ) coordinate.
   * You can specify {@link originX} and {@link originY} values,
   * that otherwise are the object's current values.
   * @example <caption>Set object's bottom left corner to point (5,5) on canvas</caption>
   * object.setXY(new Point(5, 5), 'left', 'bottom').
   * @param {Point} point position in canvas coordinate plane
   * @param {TOriginX} [originX] Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} [originY] Vertical origin: 'top', 'center' or 'bottom'
   */ setXY(point, originX, originY) {
        if (this.group) point = $ab3f2a5cc6216ae5$var$transformPoint(point, $ab3f2a5cc6216ae5$var$invertTransform(this.group.calcTransformMatrix()));
        this.setRelativeXY(point, originX, originY);
    }
    /**
   * @returns {Point} x,y position according to object's {@link originX} {@link originY} properties in parent's coordinate plane
   */ getRelativeXY() {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.left, this.top);
    }
    /**
   * As {@link setXY}, but in current parent's coordinate plane (the current group if any or the canvas)
   * @param {Point} point position according to object's {@link originX} {@link originY} properties in parent's coordinate plane
   * @param {TOriginX} [originX] Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} [originY] Vertical origin: 'top', 'center' or 'bottom'
   */ setRelativeXY(point) {
        let originX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.originX;
        let originY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.originY;
        this.setPositionByOrigin(point, originX, originY);
    }
    /**
   * @deprecated intermidiate method to be removed, do not use
   */ isStrokeAccountedForInDimensions() {
        return false;
    }
    /**
   * @return {Point[]} [tl, tr, br, bl] in the scene plane
   */ getCoords() {
        const { tl: tl, tr: tr, br: br, bl: bl } = this.aCoords || (this.aCoords = this.calcACoords());
        const coords = [
            tl,
            tr,
            br,
            bl
        ];
        if (this.group) {
            const t = this.group.calcTransformMatrix();
            return coords.map((p)=>$ab3f2a5cc6216ae5$var$transformPoint(p, t));
        }
        return coords;
    }
    /**
   * Checks if object intersects with the scene rect formed by {@link tl} and {@link br}
   */ intersectsWithRect(tl, br) {
        const intersection = $ab3f2a5cc6216ae5$export$869c896bf338bf5a.intersectPolygonRectangle(this.getCoords(), tl, br);
        return intersection.status === "Intersection";
    }
    /**
   * Checks if object intersects with another object
   * @param {Object} other Object to test
   * @return {Boolean} true if object intersects with another object
   */ intersectsWithObject(other) {
        const intersection = $ab3f2a5cc6216ae5$export$869c896bf338bf5a.intersectPolygonPolygon(this.getCoords(), other.getCoords());
        return intersection.status === "Intersection" || intersection.status === "Coincident" || other.isContainedWithinObject(this) || this.isContainedWithinObject(other);
    }
    /**
   * Checks if object is fully contained within area of another object
   * @param {Object} other Object to test
   * @return {Boolean} true if object is fully contained within area of another object
   */ isContainedWithinObject(other) {
        const points = this.getCoords();
        return points.every((point)=>other.containsPoint(point));
    }
    /**
   * Checks if object is fully contained within the scene rect formed by {@link tl} and {@link br}
   */ isContainedWithinRect(tl, br) {
        const { left: left, top: top, width: width, height: height } = this.getBoundingRect();
        return left >= tl.x && left + width <= br.x && top >= tl.y && top + height <= br.y;
    }
    isOverlapping(other) {
        return this.intersectsWithObject(other) || this.isContainedWithinObject(other) || other.isContainedWithinObject(this);
    }
    /**
   * Checks if point is inside the object
   * @param {Point} point Point to check against
   * @return {Boolean} true if point is inside the object
   */ containsPoint(point) {
        return $ab3f2a5cc6216ae5$export$869c896bf338bf5a.isPointInPolygon(point, this.getCoords());
    }
    /**
   * Checks if object is contained within the canvas with current viewportTransform
   * the check is done stopping at first point that appears on screen
   * @return {Boolean} true if object is fully or partially contained within canvas
   */ isOnScreen() {
        if (!this.canvas) return false;
        const { tl: tl, br: br } = this.canvas.vptCoords;
        const points = this.getCoords();
        // if some point is on screen, the object is on screen.
        if (points.some((point)=>point.x <= br.x && point.x >= tl.x && point.y <= br.y && point.y >= tl.y)) return true;
        // no points on screen, check intersection with absolute coordinates
        if (this.intersectsWithRect(tl, br)) return true;
        // check if the object is so big that it contains the entire viewport
        return this.containsPoint(tl.midPointFrom(br));
    }
    /**
   * Checks if object is partially contained within the canvas with current viewportTransform
   * @return {Boolean} true if object is partially contained within canvas
   */ isPartiallyOnScreen() {
        if (!this.canvas) return false;
        const { tl: tl, br: br } = this.canvas.vptCoords;
        if (this.intersectsWithRect(tl, br)) return true;
        const allPointsAreOutside = this.getCoords().every((point)=>(point.x >= br.x || point.x <= tl.x) && (point.y >= br.y || point.y <= tl.y));
        // check if the object is so big that it contains the entire viewport
        return allPointsAreOutside && this.containsPoint(tl.midPointFrom(br));
    }
    /**
   * Returns coordinates of object's bounding rectangle (left, top, width, height)
   * the box is intended as aligned to axis of canvas.
   * @return {Object} Object with left, top, width, height properties
   */ getBoundingRect() {
        return $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints(this.getCoords());
    }
    /**
   * Returns width of an object's bounding box counting transformations
   * @todo shouldn't this account for group transform and return the actual size in canvas coordinate plane?
   * @return {Number} width value
   */ getScaledWidth() {
        return this._getTransformedDimensions().x;
    }
    /**
   * Returns height of an object bounding box counting transformations
   * @todo shouldn't this account for group transform and return the actual size in canvas coordinate plane?
   * @return {Number} height value
   */ getScaledHeight() {
        return this._getTransformedDimensions().y;
    }
    /**
   * Scales an object (equally by x and y)
   * @param {Number} value Scale factor
   * @return {void}
   */ scale(value) {
        this._set($ab3f2a5cc6216ae5$var$SCALE_X, value);
        this._set($ab3f2a5cc6216ae5$var$SCALE_Y, value);
        this.setCoords();
    }
    /**
   * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
   * @param {Number} value New width value
   * @return {void}
   */ scaleToWidth(value) {
        // adjust to bounding rect factor so that rotated shapes would fit as well
        const boundingRectFactor = this.getBoundingRect().width / this.getScaledWidth();
        return this.scale(value / this.width / boundingRectFactor);
    }
    /**
   * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
   * @param {Number} value New height value
   * @return {void}
   */ scaleToHeight(value) {
        // adjust to bounding rect factor so that rotated shapes would fit as well
        const boundingRectFactor = this.getBoundingRect().height / this.getScaledHeight();
        return this.scale(value / this.height / boundingRectFactor);
    }
    getCanvasRetinaScaling() {
        var _this$canvas;
        return ((_this$canvas = this.canvas) === null || _this$canvas === void 0 ? void 0 : _this$canvas.getRetinaScaling()) || 1;
    }
    /**
   * Returns the object angle relative to canvas counting also the group property
   * @returns {TDegree}
   */ getTotalAngle() {
        return this.group ? $ab3f2a5cc6216ae5$var$radiansToDegrees($ab3f2a5cc6216ae5$var$calcPlaneRotation(this.calcTransformMatrix())) : this.angle;
    }
    /**
   * Retrieves viewportTransform from Object's canvas if available
   * @return {TMat2D}
   */ getViewportTransform() {
        var _this$canvas2;
        return ((_this$canvas2 = this.canvas) === null || _this$canvas2 === void 0 ? void 0 : _this$canvas2.viewportTransform) || $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0.concat();
    }
    /**
   * Calculates the coordinates of the 4 corner of the bbox, in absolute coordinates.
   * those never change with zoom or viewport changes.
   * @return {TCornerPoint}
   */ calcACoords() {
        const rotateMatrix = $ab3f2a5cc6216ae5$var$createRotateMatrix({
            angle: this.angle
        }), { x: x, y: y } = this.getRelativeCenterPoint(), tMatrix = $ab3f2a5cc6216ae5$var$createTranslateMatrix(x, y), finalMatrix = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(tMatrix, rotateMatrix), dim = this._getTransformedDimensions(), w = dim.x / 2, h = dim.y / 2;
        return {
            // corners
            tl: $ab3f2a5cc6216ae5$var$transformPoint({
                x: -w,
                y: -h
            }, finalMatrix),
            tr: $ab3f2a5cc6216ae5$var$transformPoint({
                x: w,
                y: -h
            }, finalMatrix),
            bl: $ab3f2a5cc6216ae5$var$transformPoint({
                x: -w,
                y: h
            }, finalMatrix),
            br: $ab3f2a5cc6216ae5$var$transformPoint({
                x: w,
                y: h
            }, finalMatrix)
        };
    }
    /**
   * Sets corner and controls position coordinates based on current angle, width and height, left and top.
   * aCoords are used to quickly find an object on the canvas.
   * See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link http://fabricjs.com/fabric-gotchas}
   */ setCoords() {
        this.aCoords = this.calcACoords();
    }
    transformMatrixKey() {
        let skipGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        let prefix = [];
        if (!skipGroup && this.group) prefix = this.group.transformMatrixKey(skipGroup);
        prefix.push(this.top, this.left, this.width, this.height, this.scaleX, this.scaleY, this.angle, this.strokeWidth, this.skewX, this.skewY, +this.flipX, +this.flipY, $ab3f2a5cc6216ae5$var$resolveOrigin(this.originX), $ab3f2a5cc6216ae5$var$resolveOrigin(this.originY));
        return prefix;
    }
    /**
   * calculate transform matrix that represents the current transformations from the
   * object's properties.
   * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
   * There are some situation in which this is useful to avoid the fake rotation.
   * @return {TMat2D} transform matrix for the object
   */ calcTransformMatrix() {
        let skipGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        let matrix = this.calcOwnMatrix();
        if (skipGroup || !this.group) return matrix;
        const key = this.transformMatrixKey(skipGroup), cache = this.matrixCache;
        if (cache && cache.key.every((x, i)=>x === key[i])) return cache.value;
        if (this.group) matrix = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(this.group.calcTransformMatrix(false), matrix);
        this.matrixCache = {
            key: key,
            value: matrix
        };
        return matrix;
    }
    /**
   * calculate transform matrix that represents the current transformations from the
   * object's properties, this matrix does not include the group transformation
   * @return {TMat2D} transform matrix for the object
   */ calcOwnMatrix() {
        const key = this.transformMatrixKey(true), cache = this.ownMatrixCache;
        if (cache && cache.key === key) return cache.value;
        const center = this.getRelativeCenterPoint(), options = {
            angle: this.angle,
            translateX: center.x,
            translateY: center.y,
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            flipX: this.flipX,
            flipY: this.flipY
        }, value = $ab3f2a5cc6216ae5$var$composeMatrix(options);
        this.ownMatrixCache = {
            key: key,
            value: value
        };
        return value;
    }
    /**
   * Calculate object dimensions from its properties
   * @private
   * @returns {Point} dimensions
   */ _getNonTransformedDimensions() {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.width, this.height).scalarAdd(this.strokeWidth);
    }
    /**
   * Calculate object dimensions for controls box, including padding and canvas zoom.
   * and active selection
   * @private
   * @param {object} [options] transform options
   * @returns {Point} dimensions
   */ _calculateCurrentDimensions(options) {
        return this._getTransformedDimensions(options).transform(this.getViewportTransform(), true).scalarAdd(2 * this.padding);
    }
}
class $ab3f2a5cc6216ae5$var$StackedObject extends $ab3f2a5cc6216ae5$var$ObjectGeometry {
    /**
   * A reference to the parent of the object
   * Used to keep the original parent ref when the object has been added to an ActiveSelection, hence loosing the `group` ref
   */ /**
   * Checks if object is descendant of target
   * Should be used instead of {@link Group.contains} or {@link StaticCanvas.contains} for performance reasons
   * @param {TAncestor} target
   * @returns {boolean}
   */ isDescendantOf(target) {
        const { parent: parent, group: group } = this;
        return parent === target || group === target || this.canvas === target || // walk up
        !!parent && parent.isDescendantOf(target) || !!group && group !== parent && group.isDescendantOf(target);
    }
    /**
   * @returns {Ancestors} ancestors (excluding `ActiveSelection`) from bottom to top
   */ getAncestors() {
        const ancestors = [];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let parent = this;
        do {
            parent = parent instanceof $ab3f2a5cc6216ae5$var$StackedObject ? parent.parent : undefined;
            parent && ancestors.push(parent);
        }while (parent);
        return ancestors;
    }
    /**
   * Compare ancestors
   *
   * @param {StackedObject} other
   * @returns {AncestryComparison} an object that represent the ancestry situation.
   */ findCommonAncestors(other) {
        if (this === other) return {
            fork: [],
            otherFork: [],
            common: [
                this,
                ...this.getAncestors()
            ]
        };
        const ancestors = this.getAncestors();
        const otherAncestors = other.getAncestors();
        //  if `this` has no ancestors and `this` is top ancestor of `other` we must handle the following case
        if (ancestors.length === 0 && otherAncestors.length > 0 && this === otherAncestors[otherAncestors.length - 1]) return {
            fork: [],
            otherFork: [
                other,
                ...otherAncestors.slice(0, otherAncestors.length - 1)
            ],
            common: [
                this
            ]
        };
        //  compare ancestors
        for(let i = 0, ancestor; i < ancestors.length; i++){
            ancestor = ancestors[i];
            if (ancestor === other) return {
                fork: [
                    this,
                    ...ancestors.slice(0, i)
                ],
                otherFork: [],
                common: ancestors.slice(i)
            };
            for(let j = 0; j < otherAncestors.length; j++){
                if (this === otherAncestors[j]) return {
                    fork: [],
                    otherFork: [
                        other,
                        ...otherAncestors.slice(0, j)
                    ],
                    common: [
                        this,
                        ...ancestors
                    ]
                };
                if (ancestor === otherAncestors[j]) return {
                    fork: [
                        this,
                        ...ancestors.slice(0, i)
                    ],
                    otherFork: [
                        other,
                        ...otherAncestors.slice(0, j)
                    ],
                    common: ancestors.slice(i)
                };
            }
        }
        // nothing shared
        return {
            fork: [
                this,
                ...ancestors
            ],
            otherFork: [
                other,
                ...otherAncestors
            ],
            common: []
        };
    }
    /**
   *
   * @param {StackedObject} other
   * @returns {boolean}
   */ hasCommonAncestors(other) {
        const commonAncestors = this.findCommonAncestors(other);
        return commonAncestors && !!commonAncestors.common.length;
    }
    /**
   *
   * @param {FabricObject} other object to compare against
   * @returns {boolean | undefined} if objects do not share a common ancestor or they are strictly equal it is impossible to determine which is in front of the other; in such cases the function returns `undefined`
   */ isInFrontOf(other) {
        if (this === other) return undefined;
        const ancestorData = this.findCommonAncestors(other);
        if (ancestorData.fork.includes(other)) return true;
        if (ancestorData.otherFork.includes(this)) return false;
        // if there isn't a common ancestor, we take the canvas.
        // if there is no canvas, there is nothing to compare
        const firstCommonAncestor = ancestorData.common[0] || this.canvas;
        if (!firstCommonAncestor) return undefined;
        const headOfFork = ancestorData.fork.pop(), headOfOtherFork = ancestorData.otherFork.pop(), thisIndex = firstCommonAncestor._objects.indexOf(headOfFork), otherIndex = firstCommonAncestor._objects.indexOf(headOfOtherFork);
        return thisIndex > -1 && thisIndex > otherIndex;
    }
}
class $ab3f2a5cc6216ae5$var$AnimatableObject extends $ab3f2a5cc6216ae5$var$StackedObject {
    /**
   * Animates object's properties
   * @param {Record<string, number | number[] | TColorArg>} animatable map of keys and end values
   * @param {Partial<AnimationOptions<T>>} options
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
   * @return {Record<string, TAnimation<T>>} map of animation contexts
   *
   * As object — multiple properties
   *
   * object.animate({ left: ..., top: ... });
   * object.animate({ left: ..., top: ... }, { duration: ... });
   */ animate(animatable, options) {
        return Object.entries(animatable).reduce((acc, _ref)=>{
            let [key, endValue] = _ref;
            acc[key] = this._animate(key, endValue, options);
            return acc;
        }, {});
    }
    /**
   * @private
   * @param {String} key Property to animate
   * @param {String} to Value to animate to
   * @param {Object} [options] Options object
   */ _animate(key, endValue) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const path = key.split(".");
        const propIsColor = this.constructor.colorProperties.includes(path[path.length - 1]);
        const { abort: abort, startValue: startValue, onChange: onChange, onComplete: onComplete } = options;
        const animationOptions = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), {}, {
            target: this,
            // path.reduce... is the current value in case start value isn't provided
            startValue: startValue !== null && startValue !== void 0 ? startValue : path.reduce((deep, key)=>deep[key], this),
            endValue: endValue,
            abort: abort === null || abort === void 0 ? void 0 : abort.bind(this),
            onChange: (value, valueProgress, durationProgress)=>{
                path.reduce((deep, key, index)=>{
                    if (index === path.length - 1) deep[key] = value;
                    return deep[key];
                }, this);
                onChange && // @ts-expect-error generic callback arg0 is wrong
                onChange(value, valueProgress, durationProgress);
            },
            onComplete: (value, valueProgress, durationProgress)=>{
                this.setCoords();
                onComplete && // @ts-expect-error generic callback arg0 is wrong
                onComplete(value, valueProgress, durationProgress);
            }
        });
        return propIsColor ? $ab3f2a5cc6216ae5$var$animateColor(animationOptions) : $ab3f2a5cc6216ae5$var$animate(animationOptions);
    }
}
/**
 * List of properties to consider for animating colors.
 * @type String[]
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$AnimatableObject, "colorProperties", [
    $ab3f2a5cc6216ae5$var$FILL,
    $ab3f2a5cc6216ae5$var$STROKE,
    "backgroundColor"
]);
function $ab3f2a5cc6216ae5$var$getSvgRegex(arr) {
    return new RegExp("^(" + arr.join("|") + ")\\b", "i");
}
var $ab3f2a5cc6216ae5$var$_templateObject$2, $ab3f2a5cc6216ae5$var$_templateObject2$1;
const $ab3f2a5cc6216ae5$var$reNum = String.raw($ab3f2a5cc6216ae5$var$_templateObject$2 || ($ab3f2a5cc6216ae5$var$_templateObject$2 = $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral([
    "(?:[-+]?(?:d*.d+|d+.?)(?:[eE][-+]?d+)?)"
], [
    "(?:[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?)"
])));
const $ab3f2a5cc6216ae5$var$svgNS = "http://www.w3.org/2000/svg";
String.raw($ab3f2a5cc6216ae5$var$_templateObject2$1 || ($ab3f2a5cc6216ae5$var$_templateObject2$1 = $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral([
    "(?:s+,?s*|,s*|$)"
], [
    "(?:\\s+,?\\s*|,\\s*|$)"
])));
const $ab3f2a5cc6216ae5$var$reFontDeclaration = new RegExp("(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(" + $ab3f2a5cc6216ae5$var$reNum + "(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|" + $ab3f2a5cc6216ae5$var$reNum + "))?\\s+(.*)");
const $ab3f2a5cc6216ae5$var$svgValidTagNames = [
    "path",
    "circle",
    "polygon",
    "polyline",
    "ellipse",
    "rect",
    "line",
    "image",
    "text"
], $ab3f2a5cc6216ae5$var$svgViewBoxElements = [
    "symbol",
    "image",
    "marker",
    "pattern",
    "view",
    "svg"
], $ab3f2a5cc6216ae5$var$svgInvalidAncestors = [
    "pattern",
    "defs",
    "symbol",
    "metadata",
    "clipPath",
    "mask",
    "desc"
], $ab3f2a5cc6216ae5$var$svgValidParents = [
    "symbol",
    "g",
    "a",
    "svg",
    "clipPath",
    "defs"
], $ab3f2a5cc6216ae5$var$attributesMap = {
    cx: $ab3f2a5cc6216ae5$var$LEFT,
    x: $ab3f2a5cc6216ae5$var$LEFT,
    r: "radius",
    cy: $ab3f2a5cc6216ae5$var$TOP,
    y: $ab3f2a5cc6216ae5$var$TOP,
    display: "visible",
    visibility: "visible",
    transform: "transformMatrix",
    "fill-opacity": "fillOpacity",
    "fill-rule": "fillRule",
    "font-family": "fontFamily",
    "font-size": "fontSize",
    "font-style": "fontStyle",
    "font-weight": "fontWeight",
    "letter-spacing": "charSpacing",
    "paint-order": "paintFirst",
    "stroke-dasharray": "strokeDashArray",
    "stroke-dashoffset": "strokeDashOffset",
    "stroke-linecap": "strokeLineCap",
    "stroke-linejoin": "strokeLineJoin",
    "stroke-miterlimit": "strokeMiterLimit",
    "stroke-opacity": "strokeOpacity",
    "stroke-width": "strokeWidth",
    "text-decoration": "textDecoration",
    "text-anchor": "textAnchor",
    opacity: "opacity",
    "clip-path": "clipPath",
    "clip-rule": "clipRule",
    "vector-effect": "strokeUniform",
    "image-rendering": "imageSmoothing"
}, $ab3f2a5cc6216ae5$var$fSize = "font-size", $ab3f2a5cc6216ae5$var$cPath = "clip-path";
const $ab3f2a5cc6216ae5$var$svgValidTagNamesRegEx = $ab3f2a5cc6216ae5$var$getSvgRegex($ab3f2a5cc6216ae5$var$svgValidTagNames);
const $ab3f2a5cc6216ae5$var$svgViewBoxElementsRegEx = $ab3f2a5cc6216ae5$var$getSvgRegex($ab3f2a5cc6216ae5$var$svgViewBoxElements);
const $ab3f2a5cc6216ae5$var$svgValidParentsRegEx = $ab3f2a5cc6216ae5$var$getSvgRegex($ab3f2a5cc6216ae5$var$svgValidParents);
// http://www.w3.org/TR/SVG/coords.html#ViewBoxAttribute
// matches, e.g.: +14.56e-12, etc.
const $ab3f2a5cc6216ae5$var$reViewBoxAttrValue = new RegExp("^\\s*(" + $ab3f2a5cc6216ae5$var$reNum + "+)\\s*,?" + "\\s*(" + $ab3f2a5cc6216ae5$var$reNum + "+)\\s*,?" + "\\s*(" + $ab3f2a5cc6216ae5$var$reNum + "+)\\s*,?" + "\\s*(" + $ab3f2a5cc6216ae5$var$reNum + "+)\\s*" + "$");
/**
   * Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
   * - (?:\s|^): This part captures either a whitespace character (\s) or the beginning of a line (^). It's non-capturing (due to (?:...)), meaning it doesn't create a capturing group.
   * - (-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?: This captures the first component of the shadow, which is the horizontal offset. Breaking it down:
   *   - (-?\d+): Captures an optional minus sign followed by one or more digits (integer part of the number).
   *   - (?:\.\d*)?: Optionally captures a decimal point followed by zero or more digits (decimal part of the number).
   *   - (?:px)?: Optionally captures the "px" unit.
   *   - (?:\s?|$): Captures either an optional whitespace or the end of the line. This whole part is wrapped in a non-capturing group and marked as optional with ?.
   * - (-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?: Similar to the previous step, this captures the vertical offset.

(\d+(?:\.\d*)?(?:px)?)?: This captures the blur radius. It's similar to the horizontal offset but without the optional minus sign.

(?:\s+(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?){0,1}: This captures an optional part for the color. It allows for whitespace followed by a component with an optional minus sign, digits, decimal point, and "px" unit.

(?:$|\s): This captures either the end of the line or a whitespace character. It ensures that the match ends either at the end of the string or with a whitespace character.
   */ // eslint-disable-next-line max-len
const $ab3f2a5cc6216ae5$var$shadowOffsetRegex = "(-?\\d+(?:\\.\\d*)?(?:px)?(?:\\s?|$))?";
const $ab3f2a5cc6216ae5$var$reOffsetsAndBlur = new RegExp("(?:\\s|^)" + $ab3f2a5cc6216ae5$var$shadowOffsetRegex + $ab3f2a5cc6216ae5$var$shadowOffsetRegex + "(" + $ab3f2a5cc6216ae5$var$reNum + "?(?:px)?)?(?:\\s?|$)(?:$|\\s)");
const $ab3f2a5cc6216ae5$var$shadowDefaultValues = {
    color: "rgb(0,0,0)",
    blur: 0,
    offsetX: 0,
    offsetY: 0,
    affectStroke: false,
    includeDefaultValues: true,
    nonScaling: false
};
class $ab3f2a5cc6216ae5$export$a24c14443968327c {
    /**
   * @see {@link http://fabricjs.com/shadows|Shadow demo}
   * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
   */ constructor(arg0){
        const options = typeof arg0 === "string" ? $ab3f2a5cc6216ae5$export$a24c14443968327c.parseShadow(arg0) : arg0;
        Object.assign(this, $ab3f2a5cc6216ae5$export$a24c14443968327c.ownDefaults);
        for(const prop in options)// @ts-expect-error for loops are so messy in TS
        this[prop] = options[prop];
        this.id = $ab3f2a5cc6216ae5$var$uid();
    }
    /**
   * @param {String} value Shadow value to parse
   * @return {Object} Shadow object with color, offsetX, offsetY and blur
   */ static parseShadow(value) {
        const shadowStr = value.trim(), [, offsetX = 0, offsetY = 0, blur = 0] = ($ab3f2a5cc6216ae5$var$reOffsetsAndBlur.exec(shadowStr) || []).map((value)=>parseFloat(value) || 0), color = (shadowStr.replace($ab3f2a5cc6216ae5$var$reOffsetsAndBlur, "") || "rgb(0,0,0)").trim();
        return {
            color: color,
            offsetX: offsetX,
            offsetY: offsetY,
            blur: blur
        };
    }
    /**
   * Returns a string representation of an instance
   * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
   * @return {String} Returns CSS3 text-shadow declaration
   */ toString() {
        return [
            this.offsetX,
            this.offsetY,
            this.blur,
            this.color
        ].join("px ");
    }
    /**
   * Returns SVG representation of a shadow
   * @param {FabricObject} object
   * @return {String} SVG representation of a shadow
   */ toSVG(object) {
        const offset = $ab3f2a5cc6216ae5$var$rotateVector(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.offsetX, this.offsetY), $ab3f2a5cc6216ae5$var$degreesToRadians(-object.angle)), BLUR_BOX = 20, color = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(this.color);
        let fBoxX = 40, fBoxY = 40;
        if (object.width && object.height) {
            //http://www.w3.org/TR/SVG/filters.html#FilterEffectsRegion
            // we add some extra space to filter box to contain the blur ( 20 )
            fBoxX = $ab3f2a5cc6216ae5$var$toFixed((Math.abs(offset.x) + this.blur) / object.width, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
            fBoxY = $ab3f2a5cc6216ae5$var$toFixed((Math.abs(offset.y) + this.blur) / object.height, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
        }
        if (object.flipX) offset.x *= -1;
        if (object.flipY) offset.y *= -1;
        return '<filter id="SVGID_'.concat(this.id, '" y="-').concat(fBoxY, '%" height="').concat(100 + 2 * fBoxY, '%" x="-').concat(fBoxX, '%" width="').concat(100 + 2 * fBoxX, '%" >\n	<feGaussianBlur in="SourceAlpha" stdDeviation="').concat($ab3f2a5cc6216ae5$var$toFixed(this.blur ? this.blur / 2 : 0, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), '"></feGaussianBlur>\n	<feOffset dx="').concat($ab3f2a5cc6216ae5$var$toFixed(offset.x, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), '" dy="').concat($ab3f2a5cc6216ae5$var$toFixed(offset.y, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), '" result="oBlur" ></feOffset>\n	<feFlood flood-color="').concat(color.toRgb(), '" flood-opacity="').concat(color.getAlpha(), '"/>\n	<feComposite in2="oBlur" operator="in" />\n	<feMerge>\n		<feMergeNode></feMergeNode>\n		<feMergeNode in="SourceGraphic"></feMergeNode>\n	</feMerge>\n</filter>\n');
    }
    /**
   * Returns object representation of a shadow
   * @return {Object} Object representation of a shadow instance
   */ toObject() {
        const data = {
            color: this.color,
            blur: this.blur,
            offsetX: this.offsetX,
            offsetY: this.offsetY,
            affectStroke: this.affectStroke,
            nonScaling: this.nonScaling,
            type: this.constructor.type
        };
        const defaults = $ab3f2a5cc6216ae5$export$a24c14443968327c.ownDefaults;
        return !this.includeDefaultValues ? $ab3f2a5cc6216ae5$var$pickBy(data, (value, key)=>value !== defaults[key]) : data;
    }
    static async fromObject(options) {
        return new this(options);
    }
}
/**
 * Shadow color
 * @type String
 * @default
 */ /**
 * Shadow blur
 * @type Number
 */ /**
 * Shadow horizontal offset
 * @type Number
 * @default
 */ /**
 * Shadow vertical offset
 * @type Number
 * @default
 */ /**
 * Whether the shadow should affect stroke operations
 * @type Boolean
 * @default
 */ /**
 * Indicates whether toObject should include default values
 * @type Boolean
 * @default
 */ /**
 * When `false`, the shadow will scale with the object.
 * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
 * default to false
 * @type Boolean
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$a24c14443968327c, "ownDefaults", $ab3f2a5cc6216ae5$var$shadowDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$a24c14443968327c, "type", "shadow");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$a24c14443968327c, "shadow");
const $ab3f2a5cc6216ae5$var$cloneDeep = (object)=>JSON.parse(JSON.stringify(object));
const $ab3f2a5cc6216ae5$var$stateProperties = [
    $ab3f2a5cc6216ae5$var$TOP,
    $ab3f2a5cc6216ae5$var$LEFT,
    $ab3f2a5cc6216ae5$var$SCALE_X,
    $ab3f2a5cc6216ae5$var$SCALE_Y,
    "flipX",
    "flipY",
    "originX",
    "originY",
    "angle",
    "opacity",
    "globalCompositeOperation",
    "shadow",
    "visible",
    $ab3f2a5cc6216ae5$var$SKEW_X,
    $ab3f2a5cc6216ae5$var$SKEW_Y
];
const $ab3f2a5cc6216ae5$var$cacheProperties = [
    $ab3f2a5cc6216ae5$var$FILL,
    $ab3f2a5cc6216ae5$var$STROKE,
    "strokeWidth",
    "strokeDashArray",
    "width",
    "height",
    "paintFirst",
    "strokeUniform",
    "strokeLineCap",
    "strokeDashOffset",
    "strokeLineJoin",
    "strokeMiterLimit",
    "backgroundColor",
    "clipPath"
];
const $ab3f2a5cc6216ae5$var$fabricObjectDefaultValues = {
    // see composeMatrix() to see order of transforms. First defaults listed based on this
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    angle: 0,
    flipX: false,
    flipY: false,
    scaleX: 1,
    scaleY: 1,
    minScaleLimit: 0,
    skewX: 0,
    skewY: 0,
    originX: $ab3f2a5cc6216ae5$var$LEFT,
    originY: $ab3f2a5cc6216ae5$var$TOP,
    strokeWidth: 1,
    strokeUniform: false,
    padding: 0,
    opacity: 1,
    paintFirst: $ab3f2a5cc6216ae5$var$FILL,
    fill: "rgb(0,0,0)",
    fillRule: "nonzero",
    stroke: null,
    strokeDashArray: null,
    strokeDashOffset: 0,
    strokeLineCap: "butt",
    strokeLineJoin: "miter",
    strokeMiterLimit: 4,
    globalCompositeOperation: "source-over",
    backgroundColor: "",
    shadow: null,
    visible: true,
    includeDefaultValues: true,
    excludeFromExport: false,
    objectCaching: true,
    clipPath: undefined,
    inverted: false,
    absolutePositioned: false,
    centeredRotation: true,
    centeredScaling: false,
    dirty: true
};
const $ab3f2a5cc6216ae5$var$interactiveObjectDefaultValues = {
    noScaleCache: true,
    lockMovementX: false,
    lockMovementY: false,
    lockRotation: false,
    lockScalingX: false,
    lockScalingY: false,
    lockSkewingX: false,
    lockSkewingY: false,
    lockScalingFlip: false,
    cornerSize: 13,
    touchCornerSize: 24,
    transparentCorners: true,
    cornerColor: "rgb(178,204,255)",
    cornerStrokeColor: "",
    cornerStyle: "rect",
    cornerDashArray: null,
    hasControls: true,
    borderColor: "rgb(178,204,255)",
    borderDashArray: null,
    borderOpacityWhenMoving: 0.4,
    borderScaleFactor: 1,
    hasBorders: true,
    selectionBackgroundColor: "",
    selectable: true,
    evented: true,
    perPixelTargetFind: false,
    activeOn: "down",
    hoverCursor: null,
    moveCursor: null
};
const $ab3f2a5cc6216ae5$var$_excluded$e = [
    "type"
], $ab3f2a5cc6216ae5$var$_excluded2$4 = [
    "extraParam"
];
/**
 * Root object class from which all 2d shape classes inherit from
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#objects}
 *
 * @fires added
 * @fires removed
 *
 * @fires selected
 * @fires deselected
 *
 * @fires rotating
 * @fires scaling
 * @fires moving
 * @fires skewing
 * @fires modified
 *
 * @fires mousedown
 * @fires mouseup
 * @fires mouseover
 * @fires mouseout
 * @fires mousewheel
 * @fires mousedblclick
 *
 * @fires dragover
 * @fires dragenter
 * @fires dragleave
 * @fires drop
 */ let $ab3f2a5cc6216ae5$export$c2d2360b5ec84692 = class FabricObject extends $ab3f2a5cc6216ae5$var$AnimatableObject {
    static getDefaults() {
        return FabricObject.ownDefaults;
    }
    /**
   * The class type.
   * This is used for serialization and deserialization purposes and internally it can be used
   * to identify classes.
   * When we transform a class in a plain JS object we need a way to recognize which class it was,
   * and the type is the way we do that. It has no other purposes and you should not give one.
   * Hard to reach on instances and please do not use to drive instance's logic (this.constructor.type).
   * To idenfity a class use instanceof class ( instanceof Rect ).
   * We do not do that in fabricJS code because we want to try to have code splitting possible.
   */ /**
   * Legacy identifier of the class. Prefer using utils like isType or instanceOf
   * Will be removed in fabric 7 or 8.
   * The setter exists to avoid type errors in old code and possibly current deserialization code.
   * @TODO add sustainable warning message
   * @type string
   * @deprecated
   */ get type() {
        const name = this.constructor.type;
        if (name === "FabricObject") return "object";
        return name.toLowerCase();
    }
    set type(value) {
        $ab3f2a5cc6216ae5$var$log("warn", "Setting type has no effect", value);
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        /**
     * Quick access for the _cacheCanvas rendering context
     * This is part of the objectCaching feature
     * since 1.7.0
     * @type boolean
     * @default undefined
     * @private
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_cacheContext", null);
        Object.assign(this, FabricObject.ownDefaults);
        this.setOptions(options);
    }
    /**
   * Create a the canvas used to keep the cached copy of the object
   * @private
   */ _createCacheCanvas() {
        this._cacheCanvas = $ab3f2a5cc6216ae5$var$createCanvasElement();
        this._cacheContext = this._cacheCanvas.getContext("2d");
        this._updateCacheCanvas();
        // if canvas gets created, is empty, so dirty.
        this.dirty = true;
    }
    /**
   * Limit the cache dimensions so that X * Y do not cross config.perfLimitSizeTotal
   * and each side do not cross fabric.cacheSideLimit
   * those numbers are configurable so that you can get as much detail as you want
   * making bargain with performances.
   * @param {Object} dims
   * @param {Object} dims.width width of canvas
   * @param {Object} dims.height height of canvas
   * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
   * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
   * @return {Object}.width width of canvas
   * @return {Object}.height height of canvas
   * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
   * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
   */ _limitCacheSize(dims) {
        const width = dims.width, height = dims.height, max = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.maxCacheSideLimit, min = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.minCacheSideLimit;
        if (width <= max && height <= max && width * height <= $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.perfLimitSizeTotal) {
            if (width < min) dims.width = min;
            if (height < min) dims.height = min;
            return dims;
        }
        const ar = width / height, [limX, limY] = $ab3f2a5cc6216ae5$export$69a3209f1a06c04d.limitDimsByArea(ar), x = $ab3f2a5cc6216ae5$var$capValue(min, limX, max), y = $ab3f2a5cc6216ae5$var$capValue(min, limY, max);
        if (width > x) {
            dims.zoomX /= width / x;
            dims.width = x;
            dims.capped = true;
        }
        if (height > y) {
            dims.zoomY /= height / y;
            dims.height = y;
            dims.capped = true;
        }
        return dims;
    }
    /**
   * Return the dimension and the zoom level needed to create a cache canvas
   * big enough to host the object to be cached.
   * @private
   * @return {Object}.x width of object to be cached
   * @return {Object}.y height of object to be cached
   * @return {Object}.width width of canvas
   * @return {Object}.height height of canvas
   * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
   * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
   */ _getCacheCanvasDimensions() {
        const objectScale = this.getTotalObjectScaling(), // calculate dimensions without skewing
        dim = this._getTransformedDimensions({
            skewX: 0,
            skewY: 0
        }), neededX = dim.x * objectScale.x / this.scaleX, neededY = dim.y * objectScale.y / this.scaleY;
        return {
            // for sure this ALIASING_LIMIT is slightly creating problem
            // in situation in which the cache canvas gets an upper limit
            // also objectScale contains already scaleX and scaleY
            width: neededX + $ab3f2a5cc6216ae5$var$ALIASING_LIMIT,
            height: neededY + $ab3f2a5cc6216ae5$var$ALIASING_LIMIT,
            zoomX: objectScale.x,
            zoomY: objectScale.y,
            x: neededX,
            y: neededY
        };
    }
    /**
   * Update width and height of the canvas for cache
   * returns true or false if canvas needed resize.
   * @private
   * @return {Boolean} true if the canvas has been resized
   */ _updateCacheCanvas() {
        const canvas = this._cacheCanvas, context = this._cacheContext, dims = this._limitCacheSize(this._getCacheCanvasDimensions()), minCacheSize = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.minCacheSideLimit, width = dims.width, height = dims.height, zoomX = dims.zoomX, zoomY = dims.zoomY, dimensionsChanged = width !== canvas.width || height !== canvas.height, zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY;
        if (!canvas || !context) return false;
        let drawingWidth, drawingHeight, shouldRedraw = dimensionsChanged || zoomChanged, additionalWidth = 0, additionalHeight = 0, shouldResizeCanvas = false;
        if (dimensionsChanged) {
            const canvasWidth = this._cacheCanvas.width, canvasHeight = this._cacheCanvas.height, sizeGrowing = width > canvasWidth || height > canvasHeight, sizeShrinking = (width < canvasWidth * 0.9 || height < canvasHeight * 0.9) && canvasWidth > minCacheSize && canvasHeight > minCacheSize;
            shouldResizeCanvas = sizeGrowing || sizeShrinking;
            if (sizeGrowing && !dims.capped && (width > minCacheSize || height > minCacheSize)) {
                additionalWidth = width * 0.1;
                additionalHeight = height * 0.1;
            }
        }
        if ($ab3f2a5cc6216ae5$var$isTextObject(this) && this.path) {
            shouldRedraw = true;
            shouldResizeCanvas = true;
            // IMHO in those lines we are using zoomX and zoomY not the this version.
            additionalWidth += this.getHeightOfLine(0) * this.zoomX;
            additionalHeight += this.getHeightOfLine(0) * this.zoomY;
        }
        if (shouldRedraw) {
            if (shouldResizeCanvas) {
                canvas.width = Math.ceil(width + additionalWidth);
                canvas.height = Math.ceil(height + additionalHeight);
            } else {
                context.setTransform(1, 0, 0, 1, 0, 0);
                context.clearRect(0, 0, canvas.width, canvas.height);
            }
            drawingWidth = dims.x / 2;
            drawingHeight = dims.y / 2;
            this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
            this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
            context.translate(this.cacheTranslationX, this.cacheTranslationY);
            context.scale(zoomX, zoomY);
            this.zoomX = zoomX;
            this.zoomY = zoomY;
            return true;
        }
        return false;
    }
    /**
   * Sets object's properties from options, for class constructor only.
   * Needs to be overridden for different defaults.
   * @protected
   * @param {Object} [options] Options object
   */ setOptions() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this._setOptions(options);
    }
    /**
   * Transforms context when rendering an object
   * @param {CanvasRenderingContext2D} ctx Context
   */ transform(ctx) {
        const needFullTransform = this.group && !this.group._transformDone || this.group && this.canvas && ctx === this.canvas.contextTop;
        const m = this.calcTransformMatrix(!needFullTransform);
        ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
    }
    /**
   * Returns an object representation of an instance
   * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} Object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const NUM_FRACTION_DIGITS = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS, clipPathData = this.clipPath && !this.clipPath.excludeFromExport ? $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, this.clipPath.toObject(propertiesToInclude)), {}, {
            inverted: this.clipPath.inverted,
            absolutePositioned: this.clipPath.absolutePositioned
        }) : null, object = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$var$pick(this, propertiesToInclude)), {}, {
            type: this.constructor.type,
            version: $ab3f2a5cc6216ae5$export$83d89fbfd8236492,
            originX: this.originX,
            originY: this.originY,
            left: $ab3f2a5cc6216ae5$var$toFixed(this.left, NUM_FRACTION_DIGITS),
            top: $ab3f2a5cc6216ae5$var$toFixed(this.top, NUM_FRACTION_DIGITS),
            width: $ab3f2a5cc6216ae5$var$toFixed(this.width, NUM_FRACTION_DIGITS),
            height: $ab3f2a5cc6216ae5$var$toFixed(this.height, NUM_FRACTION_DIGITS),
            fill: $ab3f2a5cc6216ae5$var$isSerializableFiller(this.fill) ? this.fill.toObject() : this.fill,
            stroke: $ab3f2a5cc6216ae5$var$isSerializableFiller(this.stroke) ? this.stroke.toObject() : this.stroke,
            strokeWidth: $ab3f2a5cc6216ae5$var$toFixed(this.strokeWidth, NUM_FRACTION_DIGITS),
            strokeDashArray: this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
            strokeLineCap: this.strokeLineCap,
            strokeDashOffset: this.strokeDashOffset,
            strokeLineJoin: this.strokeLineJoin,
            strokeUniform: this.strokeUniform,
            strokeMiterLimit: $ab3f2a5cc6216ae5$var$toFixed(this.strokeMiterLimit, NUM_FRACTION_DIGITS),
            scaleX: $ab3f2a5cc6216ae5$var$toFixed(this.scaleX, NUM_FRACTION_DIGITS),
            scaleY: $ab3f2a5cc6216ae5$var$toFixed(this.scaleY, NUM_FRACTION_DIGITS),
            angle: $ab3f2a5cc6216ae5$var$toFixed(this.angle, NUM_FRACTION_DIGITS),
            flipX: this.flipX,
            flipY: this.flipY,
            opacity: $ab3f2a5cc6216ae5$var$toFixed(this.opacity, NUM_FRACTION_DIGITS),
            shadow: this.shadow && this.shadow.toObject ? this.shadow.toObject() : this.shadow,
            visible: this.visible,
            backgroundColor: this.backgroundColor,
            fillRule: this.fillRule,
            paintFirst: this.paintFirst,
            globalCompositeOperation: this.globalCompositeOperation,
            skewX: $ab3f2a5cc6216ae5$var$toFixed(this.skewX, NUM_FRACTION_DIGITS),
            skewY: $ab3f2a5cc6216ae5$var$toFixed(this.skewY, NUM_FRACTION_DIGITS)
        }, clipPathData ? {
            clipPath: clipPathData
        } : null);
        return !this.includeDefaultValues ? this._removeDefaultValues(object) : object;
    }
    /**
   * Returns (dataless) object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} Object representation of an instance
   */ toDatalessObject(propertiesToInclude) {
        // will be overwritten by subclasses
        return this.toObject(propertiesToInclude);
    }
    /**
   * @private
   * @param {Object} object
   */ _removeDefaultValues(object) {
        // getDefaults() ( get from static ownDefaults ) should win over prototype since anyway they get assigned to instance
        // ownDefault vs prototype is swappable only if you change all the fabric objects consistently.
        const defaults = this.constructor.getDefaults();
        const hasStaticDefaultValues = Object.keys(defaults).length > 0;
        const baseValues = hasStaticDefaultValues ? defaults : Object.getPrototypeOf(this);
        return $ab3f2a5cc6216ae5$var$pickBy(object, (value, key)=>{
            if (key === $ab3f2a5cc6216ae5$var$LEFT || key === $ab3f2a5cc6216ae5$var$TOP || key === "type") return true;
            const baseValue = baseValues[key];
            return value !== baseValue && // basically a check for [] === []
            !(Array.isArray(value) && Array.isArray(baseValue) && value.length === 0 && baseValue.length === 0);
        });
    }
    /**
   * Returns a string representation of an instance
   * @return {String}
   */ toString() {
        return "#<".concat(this.constructor.type, ">");
    }
    /**
   * Return the object scale factor counting also the group scaling
   * @return {Point}
   */ getObjectScaling() {
        // if the object is a top level one, on the canvas, we go for simple aritmetic
        // otherwise the complex method with angles will return approximations and decimals
        // and will likely kill the cache when not needed
        // https://github.com/fabricjs/fabric.js/issues/7157
        if (!this.group) return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(Math.abs(this.scaleX), Math.abs(this.scaleY));
        // if we are inside a group total zoom calculation is complex, we defer to generic matrices
        const options = $ab3f2a5cc6216ae5$var$qrDecompose(this.calcTransformMatrix());
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(Math.abs(options.scaleX), Math.abs(options.scaleY));
    }
    /**
   * Return the object scale factor counting also the group scaling, zoom and retina
   * @return {Object} object with scaleX and scaleY properties
   */ getTotalObjectScaling() {
        const scale = this.getObjectScaling();
        if (this.canvas) {
            const zoom = this.canvas.getZoom();
            const retina = this.getCanvasRetinaScaling();
            return scale.scalarMultiply(zoom * retina);
        }
        return scale;
    }
    /**
   * Return the object opacity counting also the group property
   * @return {Number}
   */ getObjectOpacity() {
        let opacity = this.opacity;
        if (this.group) opacity *= this.group.getObjectOpacity();
        return opacity;
    }
    /**
   * Makes sure the scale is valid and modifies it if necessary
   * @todo: this is a control action issue, not a geometry one
   * @private
   * @param {Number} value, unconstrained
   * @return {Number} constrained value;
   */ _constrainScale(value) {
        if (Math.abs(value) < this.minScaleLimit) {
            if (value < 0) return -this.minScaleLimit;
            else return this.minScaleLimit;
        } else if (value === 0) return 0.0001;
        return value;
    }
    /**
   * Handles setting values on the instance and handling internal side effects
   * @protected
   * @param {String} key
   * @param {*} value
   */ _set(key, value) {
        if (key === $ab3f2a5cc6216ae5$var$SCALE_X || key === $ab3f2a5cc6216ae5$var$SCALE_Y) value = this._constrainScale(value);
        if (key === $ab3f2a5cc6216ae5$var$SCALE_X && value < 0) {
            this.flipX = !this.flipX;
            value *= -1;
        } else if (key === "scaleY" && value < 0) {
            this.flipY = !this.flipY;
            value *= -1;
        // i don't like this automatic initialization here
        } else if (key === "shadow" && value && !(value instanceof $ab3f2a5cc6216ae5$export$a24c14443968327c)) value = new $ab3f2a5cc6216ae5$export$a24c14443968327c(value);
        const isChanged = this[key] !== value;
        this[key] = value;
        // invalidate caches
        if (isChanged && this.constructor.cacheProperties.includes(key)) this.dirty = true;
        // a dirty child makes the parent dirty.
        // but a non dirty child does not make the parent not dirty.
        // the parent could be dirty for some other reason.
        this.parent && (this.dirty || isChanged && this.constructor.stateProperties.includes(key)) && this.parent._set("dirty", true);
        return this;
    }
    /*
   * @private
   * return if the object would be visible in rendering
   * @memberOf FabricObject.prototype
   * @return {Boolean}
   */ isNotVisible() {
        return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
    }
    /**
   * Renders an object on a specified context
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ render(ctx) {
        // do not render if width/height are zeros or object is not visible
        if (this.isNotVisible()) return;
        if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) return;
        ctx.save();
        this._setupCompositeOperation(ctx);
        this.drawSelectionBackground(ctx);
        this.transform(ctx);
        this._setOpacity(ctx);
        this._setShadow(ctx);
        if (this.shouldCache()) {
            this.renderCache();
            this.drawCacheOnCanvas(ctx);
        } else {
            this._removeCacheCanvas();
            this.drawObject(ctx);
            this.dirty = false;
        }
        ctx.restore();
    }
    drawSelectionBackground(ctx) {
    /* no op */ }
    renderCache(options) {
        options = options || {};
        if (!this._cacheCanvas || !this._cacheContext) this._createCacheCanvas();
        if (this.isCacheDirty() && this._cacheContext) {
            this.drawObject(this._cacheContext, options.forClipping);
            this.dirty = false;
        }
    }
    /**
   * Remove cacheCanvas and its dimensions from the objects
   */ _removeCacheCanvas() {
        this._cacheCanvas = undefined;
        this._cacheContext = null;
    }
    /**
   * return true if the object will draw a stroke
   * Does not consider text styles. This is just a shortcut used at rendering time
   * We want it to be an approximation and be fast.
   * wrote to avoid extra caching, it has to return true when stroke happens,
   * can guess when it will not happen at 100% chance, does not matter if it misses
   * some use case where the stroke is invisible.
   * @since 3.0.0
   * @returns Boolean
   */ hasStroke() {
        return this.stroke && this.stroke !== "transparent" && this.strokeWidth !== 0;
    }
    /**
   * return true if the object will draw a fill
   * Does not consider text styles. This is just a shortcut used at rendering time
   * We want it to be an approximation and be fast.
   * wrote to avoid extra caching, it has to return true when fill happens,
   * can guess when it will not happen at 100% chance, does not matter if it misses
   * some use case where the fill is invisible.
   * @since 3.0.0
   * @returns Boolean
   */ hasFill() {
        return this.fill && this.fill !== "transparent";
    }
    /**
   * When set to `true`, force the object to have its own cache, even if it is inside a group
   * it may be needed when your object behave in a particular way on the cache and always needs
   * its own isolated canvas to render correctly.
   * Created to be overridden
   * since 1.7.12
   * @returns Boolean
   */ needsItsOwnCache() {
        if (this.paintFirst === $ab3f2a5cc6216ae5$var$STROKE && this.hasFill() && this.hasStroke() && !!this.shadow) return true;
        if (this.clipPath) return true;
        return false;
    }
    /**
   * Decide if the object should cache or not. Create its own cache level
   * objectCaching is a global flag, wins over everything
   * needsItsOwnCache should be used when the object drawing method requires
   * a cache step. None of the fabric classes requires it.
   * Generally you do not cache objects in groups because the group outside is cached.
   * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
   * @return {Boolean}
   */ shouldCache() {
        this.ownCaching = this.needsItsOwnCache() || this.objectCaching && (!this.parent || !this.parent.isOnACache());
        return this.ownCaching;
    }
    /**
   * Check if this object will cast a shadow with an offset.
   * used by Group.shouldCache to know if child has a shadow recursively
   * @return {Boolean}
   * @deprecated
   */ willDrawShadow() {
        return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
    }
    /**
   * Execute the drawing operation for an object clipPath
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {FabricObject} clipPath
   */ drawClipPathOnCache(ctx, clipPath) {
        ctx.save();
        // DEBUG: uncomment this line, comment the following
        // ctx.globalAlpha = 0.4
        if (clipPath.inverted) ctx.globalCompositeOperation = "destination-out";
        else ctx.globalCompositeOperation = "destination-in";
        //ctx.scale(1 / 2, 1 / 2);
        if (clipPath.absolutePositioned) {
            const m = $ab3f2a5cc6216ae5$var$invertTransform(this.calcTransformMatrix());
            ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        clipPath.transform(ctx);
        ctx.scale(1 / clipPath.zoomX, 1 / clipPath.zoomY);
        ctx.drawImage(clipPath._cacheCanvas, -clipPath.cacheTranslationX, -clipPath.cacheTranslationY);
        ctx.restore();
    }
    /**
   * Execute the drawing operation for an object on a specified context
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {boolean} forClipping apply clipping styles
   */ drawObject(ctx, forClipping) {
        const originalFill = this.fill, originalStroke = this.stroke;
        if (forClipping) {
            this.fill = "black";
            this.stroke = "";
            this._setClippingProperties(ctx);
        } else this._renderBackground(ctx);
        this._render(ctx);
        this._drawClipPath(ctx, this.clipPath);
        this.fill = originalFill;
        this.stroke = originalStroke;
    }
    /**
   * Prepare clipPath state and cache and draw it on instance's cache
   * @param {CanvasRenderingContext2D} ctx
   * @param {FabricObject} clipPath
   */ _drawClipPath(ctx, clipPath) {
        if (!clipPath) return;
        // needed to setup a couple of variables
        // path canvas gets overridden with this one.
        // TODO find a better solution?
        clipPath._set("canvas", this.canvas);
        clipPath.shouldCache();
        clipPath._transformDone = true;
        clipPath.renderCache({
            forClipping: true
        });
        this.drawClipPathOnCache(ctx, clipPath);
    }
    /**
   * Paint the cached copy of the object on the target context.
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ drawCacheOnCanvas(ctx) {
        ctx.scale(1 / this.zoomX, 1 / this.zoomY);
        ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
    }
    /**
   * Check if cache is dirty
   * @param {Boolean} skipCanvas skip canvas checks because this object is painted
   * on parent canvas.
   */ isCacheDirty() {
        let skipCanvas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (this.isNotVisible()) return false;
        const canvas = this._cacheCanvas;
        const ctx = this._cacheContext;
        if (canvas && ctx && !skipCanvas && this._updateCacheCanvas()) // in this case the context is already cleared.
        return true;
        else if (this.dirty || this.clipPath && this.clipPath.absolutePositioned) {
            if (canvas && ctx && !skipCanvas) {
                ctx.save();
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.restore();
            }
            return true;
        }
        return false;
    }
    /**
   * Draws a background for the object big as its untransformed dimensions
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderBackground(ctx) {
        if (!this.backgroundColor) return;
        const dim = this._getNonTransformedDimensions();
        ctx.fillStyle = this.backgroundColor;
        ctx.fillRect(-dim.x / 2, -dim.y / 2, dim.x, dim.y);
        // if there is background color no other shadows
        // should be casted
        this._removeShadow(ctx);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _setOpacity(ctx) {
        if (this.group && !this.group._transformDone) ctx.globalAlpha = this.getObjectOpacity();
        else ctx.globalAlpha *= this.opacity;
    }
    _setStrokeStyles(ctx, decl) {
        const stroke = decl.stroke;
        if (stroke) {
            ctx.lineWidth = decl.strokeWidth;
            ctx.lineCap = decl.strokeLineCap;
            ctx.lineDashOffset = decl.strokeDashOffset;
            ctx.lineJoin = decl.strokeLineJoin;
            ctx.miterLimit = decl.strokeMiterLimit;
            if ($ab3f2a5cc6216ae5$var$isFiller(stroke)) {
                if (stroke.gradientUnits === "percentage" || stroke.gradientTransform || stroke.patternTransform) // need to transform gradient in a pattern.
                // this is a slow process. If you are hitting this codepath, and the object
                // is not using caching, you should consider switching it on.
                // we need a canvas as big as the current object caching canvas.
                this._applyPatternForTransformedGradient(ctx, stroke);
                else {
                    // is a simple gradient or pattern
                    ctx.strokeStyle = stroke.toLive(ctx);
                    this._applyPatternGradientTransform(ctx, stroke);
                }
            } else // is a color
            ctx.strokeStyle = decl.stroke;
        }
    }
    _setFillStyles(ctx, _ref) {
        let { fill: fill } = _ref;
        if (fill) {
            if ($ab3f2a5cc6216ae5$var$isFiller(fill)) {
                ctx.fillStyle = fill.toLive(ctx);
                this._applyPatternGradientTransform(ctx, fill);
            } else ctx.fillStyle = fill;
        }
    }
    _setClippingProperties(ctx) {
        ctx.globalAlpha = 1;
        ctx.strokeStyle = "transparent";
        ctx.fillStyle = "#000000";
    }
    /**
   * @private
   * Sets line dash
   * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
   * @param {Array} dashArray array representing dashes
   */ _setLineDash(ctx, dashArray) {
        if (!dashArray || dashArray.length === 0) return;
        // Spec requires the concatenation of two copies of the dash array when the number of elements is odd
        if (1 & dashArray.length) dashArray.push(...dashArray);
        ctx.setLineDash(dashArray);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _setShadow(ctx) {
        if (!this.shadow) return;
        const shadow = this.shadow, canvas = this.canvas, retinaScaling = this.getCanvasRetinaScaling(), [sx, , , sy] = (canvas === null || canvas === void 0 ? void 0 : canvas.viewportTransform) || $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0, multX = sx * retinaScaling, multY = sy * retinaScaling, scaling = shadow.nonScaling ? new $ab3f2a5cc6216ae5$export$baf26146a414f24a(1, 1) : this.getObjectScaling();
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur * $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.browserShadowBlurConstant * (multX + multY) * (scaling.x + scaling.y) / 4;
        ctx.shadowOffsetX = shadow.offsetX * multX * scaling.x;
        ctx.shadowOffsetY = shadow.offsetY * multY * scaling.y;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _removeShadow(ctx) {
        if (!this.shadow) return;
        ctx.shadowColor = "";
        ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {TFiller} filler {@link Pattern} or {@link Gradient}
   */ _applyPatternGradientTransform(ctx, filler) {
        if (!$ab3f2a5cc6216ae5$var$isFiller(filler)) return {
            offsetX: 0,
            offsetY: 0
        };
        const t = filler.gradientTransform || filler.patternTransform;
        const offsetX = -this.width / 2 + filler.offsetX || 0, offsetY = -this.height / 2 + filler.offsetY || 0;
        if (filler.gradientUnits === "percentage") ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
        else ctx.transform(1, 0, 0, 1, offsetX, offsetY);
        if (t) ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderPaintInOrder(ctx) {
        if (this.paintFirst === $ab3f2a5cc6216ae5$var$STROKE) {
            this._renderStroke(ctx);
            this._renderFill(ctx);
        } else {
            this._renderFill(ctx);
            this._renderStroke(ctx);
        }
    }
    /**
   * @private
   * function that actually render something on the context.
   * empty here to allow Obects to work on tests to benchmark fabric functionalites
   * not related to rendering
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
    // placeholder to be overridden
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderFill(ctx) {
        if (!this.fill) return;
        ctx.save();
        this._setFillStyles(ctx, this);
        if (this.fillRule === "evenodd") ctx.fill("evenodd");
        else ctx.fill();
        ctx.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderStroke(ctx) {
        if (!this.stroke || this.strokeWidth === 0) return;
        if (this.shadow && !this.shadow.affectStroke) this._removeShadow(ctx);
        ctx.save();
        if (this.strokeUniform) {
            const scaling = this.getObjectScaling();
            ctx.scale(1 / scaling.x, 1 / scaling.y);
        }
        this._setLineDash(ctx, this.strokeDashArray);
        this._setStrokeStyles(ctx, this);
        ctx.stroke();
        ctx.restore();
    }
    /**
   * This function try to patch the missing gradientTransform on canvas gradients.
   * transforming a context to transform the gradient, is going to transform the stroke too.
   * we want to transform the gradient but not the stroke operation, so we create
   * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
   * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
   * is limited.
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Gradient} filler
   */ _applyPatternForTransformedGradient(ctx, filler) {
        var _pCtx$createPattern;
        const dims = this._limitCacheSize(this._getCacheCanvasDimensions()), pCanvas = $ab3f2a5cc6216ae5$var$createCanvasElement(), retinaScaling = this.getCanvasRetinaScaling(), width = dims.x / this.scaleX / retinaScaling, height = dims.y / this.scaleY / retinaScaling;
        // in case width and height are less than 1px, we have to round up.
        // since the pattern is no-repeat, this is fine
        pCanvas.width = Math.ceil(width);
        pCanvas.height = Math.ceil(height);
        const pCtx = pCanvas.getContext("2d");
        if (!pCtx) return;
        pCtx.beginPath();
        pCtx.moveTo(0, 0);
        pCtx.lineTo(width, 0);
        pCtx.lineTo(width, height);
        pCtx.lineTo(0, height);
        pCtx.closePath();
        pCtx.translate(width / 2, height / 2);
        pCtx.scale(dims.zoomX / this.scaleX / retinaScaling, dims.zoomY / this.scaleY / retinaScaling);
        this._applyPatternGradientTransform(pCtx, filler);
        pCtx.fillStyle = filler.toLive(ctx);
        pCtx.fill();
        ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
        ctx.scale(retinaScaling * this.scaleX / dims.zoomX, retinaScaling * this.scaleY / dims.zoomY);
        ctx.strokeStyle = (_pCtx$createPattern = pCtx.createPattern(pCanvas, "no-repeat")) !== null && _pCtx$createPattern !== void 0 ? _pCtx$createPattern : "";
    }
    /**
   * This function is an helper for svg import. it returns the center of the object in the svg
   * untransformed coordinates
   * @private
   * @return {Point} center point from element coordinates
   */ _findCenterFromElement() {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.left + this.width / 2, this.top + this.height / 2);
    }
    /**
   * Clones an instance.
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @returns {Promise<FabricObject>}
   */ clone(propertiesToInclude) {
        const objectForm = this.toObject(propertiesToInclude);
        return this.constructor.fromObject(objectForm);
    }
    /**
   * Creates an instance of Image out of an object
   * makes use of toCanvasElement.
   * Once this method was based on toDataUrl and loadImage, so it also had a quality
   * and format option. toCanvasElement is faster and produce no loss of quality.
   * If you need to get a real Jpeg or Png from an object, using toDataURL is the right way to do it.
   * toCanvasElement and then toBlob from the obtained canvas is also a good option.
   * @todo fix the export type, it could not be Image but the type that getClass return for 'image'.
   * @param {ObjectToCanvasElementOptions} [options] for clone as image, passed to toDataURL
   * @param {Number} [options.multiplier=1] Multiplier to scale by
   * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
   * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
   * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
   * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
   * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
   * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
   * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
   * @return {FabricImage} Object cloned as image.
   */ cloneAsImage(options) {
        const canvasEl = this.toCanvasElement(options);
        // TODO: how to import Image w/o an import cycle?
        const ImageClass = $ab3f2a5cc6216ae5$export$2792378e23a7920c.getClass("image");
        return new ImageClass(canvasEl);
    }
    /**
   * Converts an object into a HTMLCanvas element
   * @param {ObjectToCanvasElementOptions} options Options object
   * @param {Number} [options.multiplier=1] Multiplier to scale by
   * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
   * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
   * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
   * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
   * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
   * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
   * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
   * @param {Boolean} [options.viewportTransform] Account for canvas viewport transform
   * @param {(el?: HTMLCanvasElement) => StaticCanvas} [options.canvasProvider] Create the output canvas
   * @return {HTMLCanvasElement} Returns DOM element <canvas> with the FabricObject
   */ toCanvasElement() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const origParams = $ab3f2a5cc6216ae5$var$saveObjectTransform(this), originalGroup = this.group, originalShadow = this.shadow, abs = Math.abs, retinaScaling = options.enableRetinaScaling ? $ab3f2a5cc6216ae5$var$getDevicePixelRatio() : 1, multiplier = (options.multiplier || 1) * retinaScaling, canvasProvider = options.canvasProvider || ((el)=>new $ab3f2a5cc6216ae5$export$ad01921fb0b1386e(el, {
                enableRetinaScaling: false,
                renderOnAddRemove: false,
                skipOffscreen: false
            }));
        delete this.group;
        if (options.withoutTransform) $ab3f2a5cc6216ae5$var$resetObjectTransform(this);
        if (options.withoutShadow) this.shadow = null;
        if (options.viewportTransform) $ab3f2a5cc6216ae5$var$sendObjectToPlane(this, this.getViewportTransform());
        this.setCoords();
        const el = $ab3f2a5cc6216ae5$var$createCanvasElement(), boundingRect = this.getBoundingRect(), shadow = this.shadow, shadowOffset = new $ab3f2a5cc6216ae5$export$baf26146a414f24a();
        if (shadow) {
            const shadowBlur = shadow.blur;
            const scaling = shadow.nonScaling ? new $ab3f2a5cc6216ae5$export$baf26146a414f24a(1, 1) : this.getObjectScaling();
            // consider non scaling shadow.
            shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * abs(scaling.x);
            shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * abs(scaling.y);
        }
        const width = boundingRect.width + shadowOffset.x, height = boundingRect.height + shadowOffset.y;
        // if the current width/height is not an integer
        // we need to make it so.
        el.width = Math.ceil(width);
        el.height = Math.ceil(height);
        const canvas = canvasProvider(el);
        if (options.format === "jpeg") canvas.backgroundColor = "#fff";
        this.setPositionByOrigin(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(canvas.width / 2, canvas.height / 2), $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER);
        const originalCanvas = this.canvas;
        // static canvas and canvas have both an array of InteractiveObjects
        // @ts-expect-error this needs to be fixed somehow, or ignored globally
        canvas._objects = [
            this
        ];
        this.set("canvas", canvas);
        this.setCoords();
        const canvasEl = canvas.toCanvasElement(multiplier || 1, options);
        this.set("canvas", originalCanvas);
        this.shadow = originalShadow;
        if (originalGroup) this.group = originalGroup;
        this.set(origParams);
        this.setCoords();
        // canvas.dispose will call image.dispose that will nullify the elements
        // since this canvas is a simple element for the process, we remove references
        // to objects in this way in order to avoid object trashing.
        canvas._objects = [];
        // since render has settled it is safe to destroy canvas
        canvas.destroy();
        return canvasEl;
    }
    /**
   * Converts an object into a data-url-like string
   * @param {Object} options Options object
   * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
   * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
   * @param {Number} [options.multiplier=1] Multiplier to scale by
   * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
   * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
   * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
   * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
   * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
   * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
   * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
   * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
   */ toDataURL() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return $ab3f2a5cc6216ae5$var$toDataURL(this.toCanvasElement(options), options.format || "png", options.quality || 1);
    }
    /**
   * Returns true if any of the specified types is identical to the type of an instance
   * @param {String} type Type to check against
   * @return {Boolean}
   */ isType() {
        for(var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++)types[_key] = arguments[_key];
        return types.includes(this.constructor.type) || types.includes(this.type);
    }
    /**
   * Returns complexity of an instance
   * @return {Number} complexity of this instance (is 1 unless subclassed)
   */ complexity() {
        return 1;
    }
    /**
   * Returns a JSON representation of an instance
   * @return {Object} JSON
   */ toJSON() {
        // delegate, not alias
        return this.toObject();
    }
    /**
   * Sets "angle" of an instance with centered rotation
   * @param {TDegree} angle Angle value (in degrees)
   */ rotate(angle) {
        const { centeredRotation: centeredRotation, originX: originX, originY: originY } = this;
        if (centeredRotation) {
            const { x: x, y: y } = this.getRelativeCenterPoint();
            this.originX = $ab3f2a5cc6216ae5$var$CENTER;
            this.originY = $ab3f2a5cc6216ae5$var$CENTER;
            this.left = x;
            this.top = y;
        }
        this.set("angle", angle);
        if (centeredRotation) {
            const { x: x, y: y } = this.translateToOriginPoint(this.getRelativeCenterPoint(), originX, originY);
            this.left = x;
            this.top = y;
            this.originX = originX;
            this.originY = originY;
        }
    }
    /**
   * This callback function is called by the parent group of an object every
   * time a non-delegated property changes on the group. It is passed the key
   * and value as parameters. Not adding in this function's signature to avoid
   * Travis build error about unused variables.
   */ setOnGroup() {
    // implemented by sub-classes, as needed.
    }
    /**
   * Sets canvas globalCompositeOperation for specific object
   * custom composition operation for the particular object can be specified using globalCompositeOperation property
   * @param {CanvasRenderingContext2D} ctx Rendering canvas context
   */ _setupCompositeOperation(ctx) {
        if (this.globalCompositeOperation) ctx.globalCompositeOperation = this.globalCompositeOperation;
    }
    /**
   * cancel instance's running animations
   * override if necessary to dispose artifacts such as `clipPath`
   */ dispose() {
        $ab3f2a5cc6216ae5$export$dc18923894d9e56a.cancelByTarget(this);
        this.off();
        this._set("canvas", undefined);
        // clear caches
        this._cacheCanvas && $ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e().dispose(this._cacheCanvas);
        this._cacheCanvas = undefined;
        this._cacheContext = null;
    }
    /**
   *
   * @param {Function} klass
   * @param {object} object
   * @param {object} [options]
   * @param {string} [options.extraParam] property to pass as first argument to the constructor
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<FabricObject>}
   */ static _fromObject(_ref2) {
        let object = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref2, $ab3f2a5cc6216ae5$var$_excluded$e);
        let _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, { extraParam: extraParam } = _ref3, options = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref3, $ab3f2a5cc6216ae5$var$_excluded2$4);
        return $ab3f2a5cc6216ae5$var$enlivenObjectEnlivables($ab3f2a5cc6216ae5$var$cloneDeep(object), options).then((enlivedMap)=>{
            const allOptions = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), enlivedMap);
            // from the resulting enlived options, extract options.extraParam to arg0
            // to avoid accidental overrides later
            if (extraParam) {
                const { [extraParam]: arg0 } = allOptions, rest = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(allOptions, [
                    extraParam
                ].map($ab3f2a5cc6216ae5$var$_toPropertyKey));
                // @ts-expect-error different signature
                return new this(arg0, rest);
            } else return new this(allOptions);
        });
    }
    /**
   *
   * @param {object} object
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<FabricObject>}
   */ static fromObject(object, options) {
        return this._fromObject(object, options);
    }
};
/**
 * This list of properties is used to check if the state of an object is changed.
 * This state change now is only used for children of groups to understand if a group
 * needs its cache regenerated during a .set call
 * @type Array
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c2d2360b5ec84692, "stateProperties", $ab3f2a5cc6216ae5$var$stateProperties);
/**
 * List of properties to consider when checking if cache needs refresh
 * Those properties are checked by
 * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
 * and refreshed at the next render
 * @type Array
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c2d2360b5ec84692, "cacheProperties", $ab3f2a5cc6216ae5$var$cacheProperties);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c2d2360b5ec84692, "ownDefaults", $ab3f2a5cc6216ae5$var$fabricObjectDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c2d2360b5ec84692, "type", "FabricObject");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$c2d2360b5ec84692);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$c2d2360b5ec84692, "object");
/**
 * Wrap an action handler with firing an event if the action is performed
 * @param {Function} actionHandler the function to wrap
 * @return {Function} a function with an action handler signature
 */ const $ab3f2a5cc6216ae5$var$wrapWithFireEvent = (eventName, actionHandler)=>{
    return (eventData, transform, x, y)=>{
        const actionPerformed = actionHandler(eventData, transform, x, y);
        if (actionPerformed) $ab3f2a5cc6216ae5$var$fireEvent(eventName, $ab3f2a5cc6216ae5$var$commonEventInfo(eventData, transform, x, y));
        return actionPerformed;
    };
};
/**
 * Wrap an action handler with saving/restoring object position on the transform.
 * this is the code that permits to objects to keep their position while transforming.
 * @param {Function} actionHandler the function to wrap
 * @return {Function} a function with an action handler signature
 */ function $ab3f2a5cc6216ae5$var$wrapWithFixedAnchor(actionHandler) {
    return (eventData, transform, x, y)=>{
        const { target: target, originX: originX, originY: originY } = transform, centerPoint = target.getRelativeCenterPoint(), constraint = target.translateToOriginPoint(centerPoint, originX, originY), actionPerformed = actionHandler(eventData, transform, x, y);
        // flipping requires to change the transform origin, so we read from the mutated transform
        // instead of leveraging the one destructured before
        target.setPositionByOrigin(constraint, transform.originX, transform.originY);
        return actionPerformed;
    };
}
/**
 * Action handler to change object's width
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $ab3f2a5cc6216ae5$var$changeObjectWidth = (eventData, transform, x, y)=>{
    const localPoint = $ab3f2a5cc6216ae5$var$getLocalPoint(transform, transform.originX, transform.originY, x, y);
    //  make sure the control changes width ONLY from it's side of target
    if ($ab3f2a5cc6216ae5$var$resolveOrigin(transform.originX) === $ab3f2a5cc6216ae5$var$resolveOrigin($ab3f2a5cc6216ae5$var$CENTER) || $ab3f2a5cc6216ae5$var$resolveOrigin(transform.originX) === $ab3f2a5cc6216ae5$var$resolveOrigin($ab3f2a5cc6216ae5$var$RIGHT) && localPoint.x < 0 || $ab3f2a5cc6216ae5$var$resolveOrigin(transform.originX) === $ab3f2a5cc6216ae5$var$resolveOrigin($ab3f2a5cc6216ae5$var$LEFT) && localPoint.x > 0) {
        const { target: target } = transform, strokePadding = target.strokeWidth / (target.strokeUniform ? target.scaleX : 1), multiplier = $ab3f2a5cc6216ae5$var$isTransformCentered(transform) ? 2 : 1, oldWidth = target.width, newWidth = Math.ceil(Math.abs(localPoint.x * multiplier / target.scaleX) - strokePadding);
        target.set("width", Math.max(newWidth, 0));
        //  check against actual target width in case `newWidth` was rejected
        return oldWidth !== target.width;
    }
    return false;
};
const $ab3f2a5cc6216ae5$var$changeWidth = $ab3f2a5cc6216ae5$var$wrapWithFireEvent($ab3f2a5cc6216ae5$var$RESIZING, $ab3f2a5cc6216ae5$var$wrapWithFixedAnchor($ab3f2a5cc6216ae5$var$changeObjectWidth));
/**
 * Render a round control, as per fabric features.
 * This function is written to respect object properties like transparentCorners, cornerSize
 * cornerColor, cornerStrokeColor
 * plus the addition of offsetY and offsetX.
 * @param {CanvasRenderingContext2D} ctx context to render on
 * @param {Number} left x coordinate where the control center should be
 * @param {Number} top y coordinate where the control center should be
 * @param {Object} styleOverride override for FabricObject controls style
 * @param {FabricObject} fabricObject the fabric object for which we are rendering controls
 */ function $ab3f2a5cc6216ae5$var$renderCircleControl(ctx, left, top, styleOverride, fabricObject) {
    styleOverride = styleOverride || {};
    const xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize, ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize, transparentCorners = typeof styleOverride.transparentCorners !== "undefined" ? styleOverride.transparentCorners : fabricObject.transparentCorners, methodName = transparentCorners ? $ab3f2a5cc6216ae5$var$STROKE : $ab3f2a5cc6216ae5$var$FILL, stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor);
    let myLeft = left, myTop = top, size;
    ctx.save();
    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor || "";
    ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor || "";
    // TODO: use proper ellipse code.
    if (xSize > ySize) {
        size = xSize;
        ctx.scale(1.0, ySize / xSize);
        myTop = top * xSize / ySize;
    } else if (ySize > xSize) {
        size = ySize;
        ctx.scale(xSize / ySize, 1.0);
        myLeft = left * ySize / xSize;
    } else size = xSize;
    // this is still wrong
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.arc(myLeft, myTop, size / 2, 0, $ab3f2a5cc6216ae5$var$twoMathPi, false);
    ctx[methodName]();
    if (stroke) ctx.stroke();
    ctx.restore();
}
/**
 * Render a square control, as per fabric features.
 * This function is written to respect object properties like transparentCorners, cornerSize
 * cornerColor, cornerStrokeColor
 * plus the addition of offsetY and offsetX.
 * @param {CanvasRenderingContext2D} ctx context to render on
 * @param {Number} left x coordinate where the control center should be
 * @param {Number} top y coordinate where the control center should be
 * @param {Object} styleOverride override for FabricObject controls style
 * @param {FabricObject} fabricObject the fabric object for which we are rendering controls
 */ function $ab3f2a5cc6216ae5$var$renderSquareControl(ctx, left, top, styleOverride, fabricObject) {
    styleOverride = styleOverride || {};
    const xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize, ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize, transparentCorners = typeof styleOverride.transparentCorners !== "undefined" ? styleOverride.transparentCorners : fabricObject.transparentCorners, methodName = transparentCorners ? $ab3f2a5cc6216ae5$var$STROKE : $ab3f2a5cc6216ae5$var$FILL, stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor), xSizeBy2 = xSize / 2, ySizeBy2 = ySize / 2;
    ctx.save();
    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor || "";
    ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor || "";
    // this is still wrong
    ctx.lineWidth = 1;
    ctx.translate(left, top);
    //  angle is relative to canvas plane
    const angle = fabricObject.getTotalAngle();
    ctx.rotate($ab3f2a5cc6216ae5$var$degreesToRadians(angle));
    // this does not work, and fixed with ( && ) does not make sense.
    // to have real transparent corners we need the controls on upperCanvas
    // transparentCorners || ctx.clearRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
    ctx["".concat(methodName, "Rect")](-xSizeBy2, -ySizeBy2, xSize, ySize);
    if (stroke) ctx.strokeRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
    ctx.restore();
}
class $ab3f2a5cc6216ae5$export$7a7fa4424cb20976 {
    constructor(options){
        /**
     * keep track of control visibility.
     * mainly for backward compatibility.
     * if you do not want to see a control, you can remove it
     * from the control set.
     * @type {Boolean}
     * @default true
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "visible", true);
        /**
     * Name of the action that the control will likely execute.
     * This is optional. FabricJS uses to identify what the user is doing for some
     * extra optimizations. If you are writing a custom control and you want to know
     * somewhere else in the code what is going on, you can use this string here.
     * you can also provide a custom getActionName if your control run multiple actions
     * depending on some external state.
     * default to scale since is the most common, used on 4 corners by default
     * @type {String}
     * @default 'scale'
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "actionName", $ab3f2a5cc6216ae5$var$SCALE);
        /**
     * Drawing angle of the control.
     * NOT used for now, but name marked as needed for internal logic
     * example: to reuse the same drawing function for different rotated controls
     * @type {Number}
     * @default 0
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "angle", 0);
        /**
     * Relative position of the control. X
     * 0,0 is the center of the Object, while -0.5 (left) or 0.5 (right) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "x", 0);
        /**
     * Relative position of the control. Y
     * 0,0 is the center of the Object, while -0.5 (top) or 0.5 (bottom) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "y", 0);
        /**
     * Horizontal offset of the control from the defined position. In pixels
     * Positive offset moves the control to the right, negative to the left.
     * It used when you want to have position of control that does not scale with
     * the bounding box. Example: rotation control is placed at x:0, y: 0.5 on
     * the boundind box, with an offset of 30 pixels vertically. Those 30 pixels will
     * stay 30 pixels no matter how the object is big. Another example is having 2
     * controls in the corner, that stay in the same position when the object scale.
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "offsetX", 0);
        /**
     * Vertical offset of the control from the defined position. In pixels
     * Positive offset moves the control to the bottom, negative to the top.
     * @type {Number}
     * @default 0
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "offsetY", 0);
        /**
     * Sets the length of the control. If null, defaults to object's cornerSize.
     * Expects both sizeX and sizeY to be set when set.
     * @type {?Number}
     * @default null
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "sizeX", 0);
        /**
     * Sets the height of the control. If null, defaults to object's cornerSize.
     * Expects both sizeX and sizeY to be set when set.
     * @type {?Number}
     * @default null
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "sizeY", 0);
        /**
     * Sets the length of the touch area of the control. If null, defaults to object's touchCornerSize.
     * Expects both touchSizeX and touchSizeY to be set when set.
     * @type {?Number}
     * @default null
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "touchSizeX", 0);
        /**
     * Sets the height of the touch area of the control. If null, defaults to object's touchCornerSize.
     * Expects both touchSizeX and touchSizeY to be set when set.
     * @type {?Number}
     * @default null
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "touchSizeY", 0);
        /**
     * Css cursor style to display when the control is hovered.
     * if the method `cursorStyleHandler` is provided, this property is ignored.
     * @type {String}
     * @default 'crosshair'
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "cursorStyle", "crosshair");
        /**
     * If controls has an offsetY or offsetX, draw a line that connects
     * the control to the bounding box
     * @type {Boolean}
     * @default false
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "withConnection", false);
        Object.assign(this, options);
    }
    /**
   * The control actionHandler, provide one to handle action ( control being moved )
   * @param {Event} eventData the native mouse event
   * @param {Transform} transformData properties of the current transform
   * @param {Number} x x position of the cursor
   * @param {Number} y y position of the cursor
   * @return {Boolean} true if the action/event modified the object
   */ /**
   * The control handler for mouse down, provide one to handle mouse down on control
   * @param {Event} eventData the native mouse event
   * @param {Transform} transformData properties of the current transform
   * @param {Number} x x position of the cursor
   * @param {Number} y y position of the cursor
   * @return {Boolean} true if the action/event modified the object
   */ /**
   * The control mouseUpHandler, provide one to handle an effect on mouse up.
   * @param {Event} eventData the native mouse event
   * @param {Transform} transformData properties of the current transform
   * @param {Number} x x position of the cursor
   * @param {Number} y y position of the cursor
   * @return {Boolean} true if the action/event modified the object
   */ shouldActivate(controlKey, fabricObject, pointer, _ref) {
        var _fabricObject$canvas;
        let { tl: tl, tr: tr, br: br, bl: bl } = _ref;
        // TODO: locking logic can be handled here instead of in the control handler logic
        return ((_fabricObject$canvas = fabricObject.canvas) === null || _fabricObject$canvas === void 0 ? void 0 : _fabricObject$canvas.getActiveObject()) === fabricObject && fabricObject.isControlVisible(controlKey) && $ab3f2a5cc6216ae5$export$869c896bf338bf5a.isPointInPolygon(pointer, [
            tl,
            tr,
            br,
            bl
        ]);
    }
    /**
   * Returns control actionHandler
   * @param {Event} eventData the native mouse event
   * @param {FabricObject} fabricObject on which the control is displayed
   * @param {Control} control control for which the action handler is being asked
   * @return {Function} the action handler
   */ getActionHandler(eventData, fabricObject, control) {
        return this.actionHandler;
    }
    /**
   * Returns control mouseDown handler
   * @param {Event} eventData the native mouse event
   * @param {FabricObject} fabricObject on which the control is displayed
   * @param {Control} control control for which the action handler is being asked
   * @return {Function} the action handler
   */ getMouseDownHandler(eventData, fabricObject, control) {
        return this.mouseDownHandler;
    }
    /**
   * Returns control mouseUp handler.
   * During actions the fabricObject or the control can be of different obj
   * @param {Event} eventData the native mouse event
   * @param {FabricObject} fabricObject on which the control is displayed
   * @param {Control} control control for which the action handler is being asked
   * @return {Function} the action handler
   */ getMouseUpHandler(eventData, fabricObject, control) {
        return this.mouseUpHandler;
    }
    /**
   * Returns control cursorStyle for css using cursorStyle. If you need a more elaborate
   * function you can pass one in the constructor
   * the cursorStyle property
   * @param {Event} eventData the native mouse event
   * @param {Control} control the current control ( likely this)
   * @param {FabricObject} object on which the control is displayed
   * @return {String}
   */ cursorStyleHandler(eventData, control, fabricObject) {
        return control.cursorStyle;
    }
    /**
   * Returns the action name. The basic implementation just return the actionName property.
   * @param {Event} eventData the native mouse event
   * @param {Control} control the current control ( likely this)
   * @param {FabricObject} object on which the control is displayed
   * @return {String}
   */ getActionName(eventData, control, fabricObject) {
        return control.actionName;
    }
    /**
   * Returns controls visibility
   * @param {FabricObject} object on which the control is displayed
   * @param {String} controlKey key where the control is memorized on the
   * @return {Boolean}
   */ getVisibility(fabricObject, controlKey) {
        var _fabricObject$_contro, _fabricObject$_contro2;
        return (_fabricObject$_contro = (_fabricObject$_contro2 = fabricObject._controlsVisibility) === null || _fabricObject$_contro2 === void 0 ? void 0 : _fabricObject$_contro2[controlKey]) !== null && _fabricObject$_contro !== void 0 ? _fabricObject$_contro : this.visible;
    }
    /**
   * Sets controls visibility
   * @param {Boolean} visibility for the object
   * @return {Void}
   */ setVisibility(visibility, name, fabricObject) {
        this.visible = visibility;
    }
    positionHandler(dim, finalMatrix, fabricObject, currentControl) {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.x * dim.x + this.offsetX, this.y * dim.y + this.offsetY).transform(finalMatrix);
    }
    /**
   * Returns the coords for this control based on object values.
   * @param {Number} objectAngle angle from the fabric object holding the control
   * @param {Number} objectCornerSize cornerSize from the fabric object holding the control (or touchCornerSize if
   *   isTouch is true)
   * @param {Number} centerX x coordinate where the control center should be
   * @param {Number} centerY y coordinate where the control center should be
   * @param {boolean} isTouch true if touch corner, false if normal corner
   */ calcCornerCoords(angle, objectCornerSize, centerX, centerY, isTouch, fabricObject) {
        const t = $ab3f2a5cc6216ae5$var$multiplyTransformMatrixArray([
            $ab3f2a5cc6216ae5$var$createTranslateMatrix(centerX, centerY),
            $ab3f2a5cc6216ae5$var$createRotateMatrix({
                angle: angle
            }),
            $ab3f2a5cc6216ae5$var$createScaleMatrix((isTouch ? this.touchSizeX : this.sizeX) || objectCornerSize, (isTouch ? this.touchSizeY : this.sizeY) || objectCornerSize)
        ]);
        return {
            tl: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(-0.5, -0.5).transform(t),
            tr: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(0.5, -0.5).transform(t),
            br: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(0.5, 0.5).transform(t),
            bl: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(-0.5, 0.5).transform(t)
        };
    }
    /**
   * Render function for the control.
   * When this function runs the context is unscaled. unrotate. Just retina scaled.
   * all the functions will have to translate to the point left,top before starting Drawing
   * if they want to draw a control where the position is detected.
   * left and top are the result of the positionHandler function
   * @param {RenderingContext2D} ctx the context where the control will be drawn
   * @param {Number} left position of the canvas where we are about to render the control.
   * @param {Number} top position of the canvas where we are about to render the control.
   * @param {Object} styleOverride
   * @param {FabricObject} fabricObject the object where the control is about to be rendered
   */ render(ctx, left, top, styleOverride, fabricObject) {
        styleOverride = styleOverride || {};
        switch(styleOverride.cornerStyle || fabricObject.cornerStyle){
            case "circle":
                $ab3f2a5cc6216ae5$var$renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
                break;
            default:
                $ab3f2a5cc6216ae5$var$renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
        }
    }
}
/**
 * Find the correct style for the control that is used for rotation.
 * this function is very simple and it just take care of not-allowed or standard cursor
 * @param {Event} eventData the javascript event that is causing the scale
 * @param {Control} control the control that is interested in the action
 * @param {FabricObject} fabricObject the fabric object that is interested in the action
 * @return {String} a valid css string for the cursor
 */ const $ab3f2a5cc6216ae5$var$rotationStyleHandler = (eventData, control, fabricObject)=>{
    if (fabricObject.lockRotation) return $ab3f2a5cc6216ae5$var$NOT_ALLOWED_CURSOR;
    return control.cursorStyle;
};
/**
 * Action handler for rotation and snapping, without anchor point.
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 * @private
 */ const $ab3f2a5cc6216ae5$var$rotateObjectWithSnapping = (eventData, _ref, x, y)=>{
    let { target: target, ex: ex, ey: ey, theta: theta, originX: originX, originY: originY } = _ref;
    const pivotPoint = target.translateToOriginPoint(target.getRelativeCenterPoint(), originX, originY);
    if ($ab3f2a5cc6216ae5$var$isLocked(target, "lockRotation")) return false;
    const lastAngle = Math.atan2(ey - pivotPoint.y, ex - pivotPoint.x), curAngle = Math.atan2(y - pivotPoint.y, x - pivotPoint.x);
    let angle = $ab3f2a5cc6216ae5$var$radiansToDegrees(curAngle - lastAngle + theta);
    if (target.snapAngle && target.snapAngle > 0) {
        const snapAngle = target.snapAngle, snapThreshold = target.snapThreshold || snapAngle, rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle, leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;
        if (Math.abs(angle - leftAngleLocked) < snapThreshold) angle = leftAngleLocked;
        else if (Math.abs(angle - rightAngleLocked) < snapThreshold) angle = rightAngleLocked;
    }
    // normalize angle to positive value
    if (angle < 0) angle = 360 + angle;
    angle %= 360;
    const hasRotated = target.angle !== angle;
    // TODO: why aren't we using set?
    target.angle = angle;
    return hasRotated;
};
const $ab3f2a5cc6216ae5$var$rotationWithSnapping = $ab3f2a5cc6216ae5$var$wrapWithFireEvent($ab3f2a5cc6216ae5$var$ROTATING, $ab3f2a5cc6216ae5$var$wrapWithFixedAnchor($ab3f2a5cc6216ae5$var$rotateObjectWithSnapping));
/**
 * Inspect event and fabricObject properties to understand if the scaling action
 * @param {Event} eventData from the user action
 * @param {FabricObject} fabricObject the fabric object about to scale
 * @return {Boolean} true if scale is proportional
 */ function $ab3f2a5cc6216ae5$var$scaleIsProportional(eventData, fabricObject) {
    const canvas = fabricObject.canvas, uniformIsToggled = eventData[canvas.uniScaleKey];
    return canvas.uniformScaling && !uniformIsToggled || !canvas.uniformScaling && uniformIsToggled;
}
/**
 * Inspect fabricObject to understand if the current scaling action is allowed
 * @param {FabricObject} fabricObject the fabric object about to scale
 * @param {String} by 'x' or 'y' or ''
 * @param {Boolean} scaleProportionally true if we are trying to scale proportionally
 * @return {Boolean} true if scaling is not allowed at current conditions
 */ function $ab3f2a5cc6216ae5$var$scalingIsForbidden(fabricObject, by, scaleProportionally) {
    const lockX = $ab3f2a5cc6216ae5$var$isLocked(fabricObject, "lockScalingX"), lockY = $ab3f2a5cc6216ae5$var$isLocked(fabricObject, "lockScalingY");
    if (lockX && lockY) return true;
    if (!by && (lockX || lockY) && scaleProportionally) return true;
    if (lockX && by === "x") return true;
    if (lockY && by === "y") return true;
    // code crashes because of a division by 0 if a 0 sized object is scaled
    // forbid to prevent scaling to happen. ISSUE-9475
    const { width: width, height: height, strokeWidth: strokeWidth } = fabricObject;
    if (width === 0 && strokeWidth === 0 && by !== "y") return true;
    if (height === 0 && strokeWidth === 0 && by !== "x") return true;
    return false;
}
const $ab3f2a5cc6216ae5$var$scaleMap = [
    "e",
    "se",
    "s",
    "sw",
    "w",
    "nw",
    "n",
    "ne",
    "e"
];
/**
 * return the correct cursor style for the scale action
 * @param {Event} eventData the javascript event that is causing the scale
 * @param {Control} control the control that is interested in the action
 * @param {FabricObject} fabricObject the fabric object that is interested in the action
 * @return {String} a valid css string for the cursor
 */ const $ab3f2a5cc6216ae5$var$scaleCursorStyleHandler = (eventData, control, fabricObject)=>{
    const scaleProportionally = $ab3f2a5cc6216ae5$var$scaleIsProportional(eventData, fabricObject), by = control.x !== 0 && control.y === 0 ? "x" : control.x === 0 && control.y !== 0 ? "y" : "";
    if ($ab3f2a5cc6216ae5$var$scalingIsForbidden(fabricObject, by, scaleProportionally)) return $ab3f2a5cc6216ae5$var$NOT_ALLOWED_CURSOR;
    const n = $ab3f2a5cc6216ae5$var$findCornerQuadrant(fabricObject, control);
    return "".concat($ab3f2a5cc6216ae5$var$scaleMap[n], "-resize");
};
/**
 * Basic scaling logic, reused with different constrain for scaling X,Y, freely or equally.
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @param {Object} options additional information for scaling
 * @param {String} options.by 'x', 'y', 'equally' or '' to indicate type of scaling
 * @return {Boolean} true if some change happened
 * @private
 */ function $ab3f2a5cc6216ae5$var$scaleObject(eventData, transform, x, y) {
    let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    const target = transform.target, by = options.by, scaleProportionally = $ab3f2a5cc6216ae5$var$scaleIsProportional(eventData, target), forbidScaling = $ab3f2a5cc6216ae5$var$scalingIsForbidden(target, by, scaleProportionally);
    let newPoint, scaleX, scaleY, dim, signX, signY;
    if (forbidScaling) return false;
    if (transform.gestureScale) {
        scaleX = transform.scaleX * transform.gestureScale;
        scaleY = transform.scaleY * transform.gestureScale;
    } else {
        newPoint = $ab3f2a5cc6216ae5$var$getLocalPoint(transform, transform.originX, transform.originY, x, y);
        // use of sign: We use sign to detect change of direction of an action. sign usually change when
        // we cross the origin point with the mouse. So a scale flip for example. There is an issue when scaling
        // by center and scaling using one middle control ( default: mr, mt, ml, mb), the mouse movement can easily
        // cross many time the origin point and flip the object. so we need a way to filter out the noise.
        // This ternary here should be ok to filter out X scaling when we want Y only and vice versa.
        signX = by !== "y" ? Math.sign(newPoint.x || transform.signX || 1) : 1;
        signY = by !== "x" ? Math.sign(newPoint.y || transform.signY || 1) : 1;
        if (!transform.signX) transform.signX = signX;
        if (!transform.signY) transform.signY = signY;
        if ($ab3f2a5cc6216ae5$var$isLocked(target, "lockScalingFlip") && (transform.signX !== signX || transform.signY !== signY)) return false;
        dim = target._getTransformedDimensions();
        // missing detection of flip and logic to switch the origin
        if (scaleProportionally && !by) {
            // uniform scaling
            const distance = Math.abs(newPoint.x) + Math.abs(newPoint.y), { original: original } = transform, originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) + Math.abs(dim.y * original.scaleY / target.scaleY), scale = distance / originalDistance;
            scaleX = original.scaleX * scale;
            scaleY = original.scaleY * scale;
        } else {
            scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
            scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
        }
        // if we are scaling by center, we need to double the scale
        if ($ab3f2a5cc6216ae5$var$isTransformCentered(transform)) {
            scaleX *= 2;
            scaleY *= 2;
        }
        if (transform.signX !== signX && by !== "y") {
            transform.originX = $ab3f2a5cc6216ae5$var$invertOrigin(transform.originX);
            scaleX *= -1;
            transform.signX = signX;
        }
        if (transform.signY !== signY && by !== "x") {
            transform.originY = $ab3f2a5cc6216ae5$var$invertOrigin(transform.originY);
            scaleY *= -1;
            transform.signY = signY;
        }
    }
    // minScale is taken care of in the setter.
    const oldScaleX = target.scaleX, oldScaleY = target.scaleY;
    if (!by) {
        !$ab3f2a5cc6216ae5$var$isLocked(target, "lockScalingX") && target.set($ab3f2a5cc6216ae5$var$SCALE_X, scaleX);
        !$ab3f2a5cc6216ae5$var$isLocked(target, "lockScalingY") && target.set($ab3f2a5cc6216ae5$var$SCALE_Y, scaleY);
    } else {
        // forbidden cases already handled on top here.
        by === "x" && target.set($ab3f2a5cc6216ae5$var$SCALE_X, scaleX);
        by === "y" && target.set($ab3f2a5cc6216ae5$var$SCALE_Y, scaleY);
    }
    return oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
}
/**
 * Generic scaling logic, to scale from corners either equally or freely.
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $ab3f2a5cc6216ae5$var$scaleObjectFromCorner = (eventData, transform, x, y)=>{
    return $ab3f2a5cc6216ae5$var$scaleObject(eventData, transform, x, y);
};
/**
 * Scaling logic for the X axis.
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $ab3f2a5cc6216ae5$var$scaleObjectX = (eventData, transform, x, y)=>{
    return $ab3f2a5cc6216ae5$var$scaleObject(eventData, transform, x, y, {
        by: "x"
    });
};
/**
 * Scaling logic for the Y axis.
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $ab3f2a5cc6216ae5$var$scaleObjectY = (eventData, transform, x, y)=>{
    return $ab3f2a5cc6216ae5$var$scaleObject(eventData, transform, x, y, {
        by: "y"
    });
};
const $ab3f2a5cc6216ae5$var$scalingEqually = $ab3f2a5cc6216ae5$var$wrapWithFireEvent($ab3f2a5cc6216ae5$var$SCALING, $ab3f2a5cc6216ae5$var$wrapWithFixedAnchor($ab3f2a5cc6216ae5$var$scaleObjectFromCorner));
const $ab3f2a5cc6216ae5$var$scalingX = $ab3f2a5cc6216ae5$var$wrapWithFireEvent($ab3f2a5cc6216ae5$var$SCALING, $ab3f2a5cc6216ae5$var$wrapWithFixedAnchor($ab3f2a5cc6216ae5$var$scaleObjectX));
const $ab3f2a5cc6216ae5$var$scalingY = $ab3f2a5cc6216ae5$var$wrapWithFireEvent($ab3f2a5cc6216ae5$var$SCALING, $ab3f2a5cc6216ae5$var$wrapWithFixedAnchor($ab3f2a5cc6216ae5$var$scaleObjectY));
const $ab3f2a5cc6216ae5$var$_excluded$d = [
    "target",
    "ex",
    "ey",
    "skewingSide"
];
const $ab3f2a5cc6216ae5$var$AXIS_KEYS = {
    x: {
        counterAxis: "y",
        scale: $ab3f2a5cc6216ae5$var$SCALE_X,
        skew: $ab3f2a5cc6216ae5$var$SKEW_X,
        lockSkewing: "lockSkewingX",
        origin: "originX",
        flip: "flipX"
    },
    y: {
        counterAxis: "x",
        scale: $ab3f2a5cc6216ae5$var$SCALE_Y,
        skew: $ab3f2a5cc6216ae5$var$SKEW_Y,
        lockSkewing: "lockSkewingY",
        origin: "originY",
        flip: "flipY"
    }
};
const $ab3f2a5cc6216ae5$var$skewMap = [
    "ns",
    "nesw",
    "ew",
    "nwse"
];
/**
 * return the correct cursor style for the skew action
 * @param {Event} eventData the javascript event that is causing the scale
 * @param {Control} control the control that is interested in the action
 * @param {FabricObject} fabricObject the fabric object that is interested in the action
 * @return {String} a valid css string for the cursor
 */ const $ab3f2a5cc6216ae5$var$skewCursorStyleHandler = (eventData, control, fabricObject)=>{
    if (control.x !== 0 && $ab3f2a5cc6216ae5$var$isLocked(fabricObject, "lockSkewingY")) return $ab3f2a5cc6216ae5$var$NOT_ALLOWED_CURSOR;
    if (control.y !== 0 && $ab3f2a5cc6216ae5$var$isLocked(fabricObject, "lockSkewingX")) return $ab3f2a5cc6216ae5$var$NOT_ALLOWED_CURSOR;
    const n = $ab3f2a5cc6216ae5$var$findCornerQuadrant(fabricObject, control) % 4;
    return "".concat($ab3f2a5cc6216ae5$var$skewMap[n], "-resize");
};
/**
 * Since skewing is applied before scaling, calculations are done in a scaleless plane
 * @see https://github.com/fabricjs/fabric.js/pull/8380
 */ function $ab3f2a5cc6216ae5$var$skewObject(axis, _ref, pointer) {
    let { target: target, ex: ex, ey: ey, skewingSide: skewingSide } = _ref, transform = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref, $ab3f2a5cc6216ae5$var$_excluded$d);
    const { skew: skewKey } = $ab3f2a5cc6216ae5$var$AXIS_KEYS[axis], offset = pointer.subtract(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(ex, ey)).divide(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(target.scaleX, target.scaleY))[axis], skewingBefore = target[skewKey], skewingStart = transform[skewKey], shearingStart = Math.tan($ab3f2a5cc6216ae5$var$degreesToRadians(skewingStart)), // let a, b be the size of target
    // let a' be the value of a after applying skewing
    // then:
    // a' = a + b * skewA => skewA = (a' - a) / b
    // the value b is tricky since skewY is applied before skewX
    b = axis === "y" ? target._getTransformedDimensions({
        scaleX: 1,
        scaleY: 1,
        // since skewY is applied before skewX, b (=width) is not affected by skewX
        skewX: 0
    }).x : target._getTransformedDimensions({
        scaleX: 1,
        scaleY: 1
    }).y;
    const shearing = 2 * offset * skewingSide / // we max out fractions to safeguard from asymptotic behavior
    Math.max(b, 1) + // add starting state
    shearingStart;
    const skewing = $ab3f2a5cc6216ae5$var$radiansToDegrees(Math.atan(shearing));
    target.set(skewKey, skewing);
    const changed = skewingBefore !== target[skewKey];
    if (changed && axis === "y") {
        // we don't want skewing to affect scaleX
        // so we factor it by the inverse skewing diff to make it seem unchanged to the viewer
        const { skewX: skewX, scaleX: scaleX } = target, dimBefore = target._getTransformedDimensions({
            skewY: skewingBefore
        }), dimAfter = target._getTransformedDimensions(), compensationFactor = skewX !== 0 ? dimBefore.x / dimAfter.x : 1;
        compensationFactor !== 1 && target.set($ab3f2a5cc6216ae5$var$SCALE_X, compensationFactor * scaleX);
    }
    return changed;
}
/**
 * Wrapped Action handler for skewing on a given axis, takes care of the
 * skew direction and determines the correct transform origin for the anchor point
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ function $ab3f2a5cc6216ae5$var$skewHandler(axis, eventData, transform, x, y) {
    const { target: target } = transform, { counterAxis: counterAxis, origin: originKey, lockSkewing: lockSkewingKey, skew: skewKey, flip: flipKey } = $ab3f2a5cc6216ae5$var$AXIS_KEYS[axis];
    if ($ab3f2a5cc6216ae5$var$isLocked(target, lockSkewingKey)) return false;
    const { origin: counterOriginKey, flip: counterFlipKey } = $ab3f2a5cc6216ae5$var$AXIS_KEYS[counterAxis], counterOriginFactor = $ab3f2a5cc6216ae5$var$resolveOrigin(transform[counterOriginKey]) * (target[counterFlipKey] ? -1 : 1), // if the counter origin is top/left (= -0.5) then we are skewing x/y values on the bottom/right side of target respectively.
    // if the counter origin is bottom/right (= 0.5) then we are skewing x/y values on the top/left side of target respectively.
    // skewing direction on the top/left side of target is OPPOSITE to the direction of the movement of the pointer,
    // so we factor skewing direction by this value.
    skewingSide = -Math.sign(counterOriginFactor) * (target[flipKey] ? -1 : 1), skewingDirection = (target[skewKey] === 0 && // in case skewing equals 0 we use the pointer offset from target center to determine the direction of skewing
    $ab3f2a5cc6216ae5$var$getLocalPoint(transform, $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER, x, y)[axis] > 0 || // in case target has skewing we use that as the direction
    target[skewKey] > 0 ? 1 : -1) * skewingSide, // anchor to the opposite side of the skewing direction
    // normalize value from [-1, 1] to origin value [0, 1]
    origin = -skewingDirection * 0.5 + 0.5;
    const finalHandler = $ab3f2a5cc6216ae5$var$wrapWithFireEvent($ab3f2a5cc6216ae5$var$SKEWING, $ab3f2a5cc6216ae5$var$wrapWithFixedAnchor((eventData, transform, x, y)=>$ab3f2a5cc6216ae5$var$skewObject(axis, transform, new $ab3f2a5cc6216ae5$export$baf26146a414f24a(x, y))));
    return finalHandler(eventData, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, transform), {}, {
        [originKey]: origin,
        skewingSide: skewingSide
    }), x, y);
}
/**
 * Wrapped Action handler for skewing on the X axis, takes care of the
 * skew direction and determines the correct transform origin for the anchor point
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $ab3f2a5cc6216ae5$var$skewHandlerX = (eventData, transform, x, y)=>{
    return $ab3f2a5cc6216ae5$var$skewHandler("x", eventData, transform, x, y);
};
/**
 * Wrapped Action handler for skewing on the Y axis, takes care of the
 * skew direction and determines the correct transform origin for the anchor point
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $ab3f2a5cc6216ae5$var$skewHandlerY = (eventData, transform, x, y)=>{
    return $ab3f2a5cc6216ae5$var$skewHandler("y", eventData, transform, x, y);
};
function $ab3f2a5cc6216ae5$var$isAltAction(eventData, target) {
    return eventData[target.canvas.altActionKey];
}
/**
 * Inspect event, control and fabricObject to return the correct action name
 * @param {Event} eventData the javascript event that is causing the scale
 * @param {Control} control the control that is interested in the action
 * @param {FabricObject} fabricObject the fabric object that is interested in the action
 * @return {String} an action name
 */ const $ab3f2a5cc6216ae5$var$scaleOrSkewActionName = (eventData, control, fabricObject)=>{
    const isAlternative = $ab3f2a5cc6216ae5$var$isAltAction(eventData, fabricObject);
    if (control.x === 0) // then is scaleY or skewX
    return isAlternative ? $ab3f2a5cc6216ae5$var$SKEW_X : $ab3f2a5cc6216ae5$var$SCALE_Y;
    if (control.y === 0) // then is scaleY or skewX
    return isAlternative ? $ab3f2a5cc6216ae5$var$SKEW_Y : $ab3f2a5cc6216ae5$var$SCALE_X;
    return "";
};
/**
 * Combine skew and scale style handlers to cover fabric standard use case
 * @param {Event} eventData the javascript event that is causing the scale
 * @param {Control} control the control that is interested in the action
 * @param {FabricObject} fabricObject the fabric object that is interested in the action
 * @return {String} a valid css string for the cursor
 */ const $ab3f2a5cc6216ae5$var$scaleSkewCursorStyleHandler = (eventData, control, fabricObject)=>{
    return $ab3f2a5cc6216ae5$var$isAltAction(eventData, fabricObject) ? $ab3f2a5cc6216ae5$var$skewCursorStyleHandler(eventData, control, fabricObject) : $ab3f2a5cc6216ae5$var$scaleCursorStyleHandler(eventData, control, fabricObject);
};
/**
 * Composed action handler to either scale X or skew Y
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $ab3f2a5cc6216ae5$var$scalingXOrSkewingY = (eventData, transform, x, y)=>{
    return $ab3f2a5cc6216ae5$var$isAltAction(eventData, transform.target) ? $ab3f2a5cc6216ae5$var$skewHandlerY(eventData, transform, x, y) : $ab3f2a5cc6216ae5$var$scalingX(eventData, transform, x, y);
};
/**
 * Composed action handler to either scale Y or skew X
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $ab3f2a5cc6216ae5$var$scalingYOrSkewingX = (eventData, transform, x, y)=>{
    return $ab3f2a5cc6216ae5$var$isAltAction(eventData, transform.target) ? $ab3f2a5cc6216ae5$var$skewHandlerX(eventData, transform, x, y) : $ab3f2a5cc6216ae5$var$scalingY(eventData, transform, x, y);
};
// use this function if you want to generate new controls for every instance
const $ab3f2a5cc6216ae5$var$createObjectDefaultControls = ()=>({
        ml: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: -0.5,
            y: 0,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleSkewCursorStyleHandler,
            actionHandler: $ab3f2a5cc6216ae5$var$scalingXOrSkewingY,
            getActionName: $ab3f2a5cc6216ae5$var$scaleOrSkewActionName
        }),
        mr: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: 0.5,
            y: 0,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleSkewCursorStyleHandler,
            actionHandler: $ab3f2a5cc6216ae5$var$scalingXOrSkewingY,
            getActionName: $ab3f2a5cc6216ae5$var$scaleOrSkewActionName
        }),
        mb: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: 0,
            y: 0.5,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleSkewCursorStyleHandler,
            actionHandler: $ab3f2a5cc6216ae5$var$scalingYOrSkewingX,
            getActionName: $ab3f2a5cc6216ae5$var$scaleOrSkewActionName
        }),
        mt: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: 0,
            y: -0.5,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleSkewCursorStyleHandler,
            actionHandler: $ab3f2a5cc6216ae5$var$scalingYOrSkewingX,
            getActionName: $ab3f2a5cc6216ae5$var$scaleOrSkewActionName
        }),
        tl: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: -0.5,
            y: -0.5,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleCursorStyleHandler,
            actionHandler: $ab3f2a5cc6216ae5$var$scalingEqually
        }),
        tr: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: 0.5,
            y: -0.5,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleCursorStyleHandler,
            actionHandler: $ab3f2a5cc6216ae5$var$scalingEqually
        }),
        bl: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: -0.5,
            y: 0.5,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleCursorStyleHandler,
            actionHandler: $ab3f2a5cc6216ae5$var$scalingEqually
        }),
        br: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: 0.5,
            y: 0.5,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleCursorStyleHandler,
            actionHandler: $ab3f2a5cc6216ae5$var$scalingEqually
        }),
        mtr: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: 0,
            y: -0.5,
            actionHandler: $ab3f2a5cc6216ae5$var$rotationWithSnapping,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$rotationStyleHandler,
            offsetY: -40,
            withConnection: true,
            actionName: $ab3f2a5cc6216ae5$var$ROTATE
        })
    });
const $ab3f2a5cc6216ae5$var$createResizeControls = ()=>({
        mr: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: 0.5,
            y: 0,
            actionHandler: $ab3f2a5cc6216ae5$var$changeWidth,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleSkewCursorStyleHandler,
            actionName: $ab3f2a5cc6216ae5$var$RESIZING
        }),
        ml: new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976({
            x: -0.5,
            y: 0,
            actionHandler: $ab3f2a5cc6216ae5$var$changeWidth,
            cursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleSkewCursorStyleHandler,
            actionName: $ab3f2a5cc6216ae5$var$RESIZING
        })
    });
const $ab3f2a5cc6216ae5$var$createTextboxDefaultControls = ()=>$ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$var$createObjectDefaultControls()), $ab3f2a5cc6216ae5$var$createResizeControls());
class $ab3f2a5cc6216ae5$export$bee544043763fa88 extends $ab3f2a5cc6216ae5$export$c2d2360b5ec84692 {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$bee544043763fa88.ownDefaults);
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        Object.assign(this, this.constructor.createControls(), $ab3f2a5cc6216ae5$export$bee544043763fa88.ownDefaults);
        this.setOptions(options);
    }
    /**
   * Creates the default control object.
   * If you prefer to have on instance of controls shared among all objects
   * make this function return an empty object and add controls to the ownDefaults
   * @param {Object} [options] Options object
   */ static createControls() {
        return {
            controls: $ab3f2a5cc6216ae5$var$createObjectDefaultControls()
        };
    }
    /**
   * Update width and height of the canvas for cache
   * returns true or false if canvas needed resize.
   * @private
   * @return {Boolean} true if the canvas has been resized
   */ _updateCacheCanvas() {
        const targetCanvas = this.canvas;
        if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
            const transform = targetCanvas._currentTransform, target = transform.target, action = transform.action;
            if (this === target && action && action.startsWith($ab3f2a5cc6216ae5$var$SCALE)) return false;
        }
        return super._updateCacheCanvas();
    }
    getActiveControl() {
        const key = this.__corner;
        return key ? {
            key: key,
            control: this.controls[key],
            coord: this.oCoords[key]
        } : undefined;
    }
    /**
   * Determines which corner is under the mouse cursor, represented by `pointer`.
   * This function is return a corner only if the object is the active one.
   * This is done to avoid selecting corner of non active object and activating transformations
   * rather than drag action. The default behavior of fabricJS is that if you want to transform
   * an object, first you select it to show the control set
   * @private
   * @param {Object} pointer The pointer indicating the mouse position
   * @param {boolean} forTouch indicates if we are looking for interaction area with a touch action
   * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or 0 if nothing is found.
   */ findControl(pointer) {
        let forTouch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!this.hasControls || !this.canvas) return undefined;
        this.__corner = undefined;
        const cornerEntries = Object.entries(this.oCoords);
        for(let i = cornerEntries.length - 1; i >= 0; i--){
            const [key, corner] = cornerEntries[i];
            const control = this.controls[key];
            if (control.shouldActivate(key, this, pointer, forTouch ? corner.touchCorner : corner.corner)) {
                // this.canvas.contextTop.fillRect(pointer.x - 1, pointer.y - 1, 2, 2);
                this.__corner = key;
                return {
                    key: key,
                    control: control,
                    coord: this.oCoords[key]
                };
            }
        }
        return undefined;
    }
    /**
   * Calculates the coordinates of the center of each control plus the corners of the control itself
   * This basically just delegates to each control positionHandler
   * WARNING: changing what is passed to positionHandler is a breaking change, since position handler
   * is a public api and should be done just if extremely necessary
   * @return {Record<string, TOCoord>}
   */ calcOCoords() {
        const vpt = this.getViewportTransform(), center = this.getCenterPoint(), tMatrix = $ab3f2a5cc6216ae5$var$createTranslateMatrix(center.x, center.y), rMatrix = $ab3f2a5cc6216ae5$var$createRotateMatrix({
            angle: this.getTotalAngle() - (!!this.group && this.flipX ? 180 : 0)
        }), positionMatrix = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(tMatrix, rMatrix), startMatrix = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(vpt, positionMatrix), finalMatrix = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(startMatrix, [
            1 / vpt[0],
            0,
            0,
            1 / vpt[3],
            0,
            0
        ]), transformOptions = this.group ? $ab3f2a5cc6216ae5$var$qrDecompose(this.calcTransformMatrix()) : undefined;
        // decomposing could bring negative scaling and `_calculateCurrentDimensions` can't take it
        if (transformOptions) {
            transformOptions.scaleX = Math.abs(transformOptions.scaleX);
            transformOptions.scaleY = Math.abs(transformOptions.scaleY);
        }
        const dim = this._calculateCurrentDimensions(transformOptions), coords = {};
        this.forEachControl((control, key)=>{
            const position = control.positionHandler(dim, finalMatrix, this, control);
            // coords[key] are sometimes used as points. Those are points to which we add
            // the property corner and touchCorner from `_calcCornerCoords`.
            // don't remove this assign for an object spread.
            coords[key] = Object.assign(position, this._calcCornerCoords(control, position));
        });
        // debug code
        /*
      const canvas = this.canvas;
      setTimeout(function () {
      if (!canvas) return;
        canvas.contextTop.clearRect(0, 0, 700, 700);
        canvas.contextTop.fillStyle = 'green';
        Object.keys(coords).forEach(function(key) {
          const control = coords[key];
          canvas.contextTop.fillRect(control.x, control.y, 3, 3);
        });
      } 50);
    */ return coords;
    }
    /**
   * Sets the coordinates that determine the interaction area of each control
   * note: if we would switch to ROUND corner area, all of this would disappear.
   * everything would resolve to a single point and a pythagorean theorem for the distance
   * @todo evaluate simplification of code switching to circle interaction area at runtime
   * @private
   */ _calcCornerCoords(control, position) {
        const angle = this.getTotalAngle();
        const corner = control.calcCornerCoords(angle, this.cornerSize, position.x, position.y, false, this);
        const touchCorner = control.calcCornerCoords(angle, this.touchCornerSize, position.x, position.y, true, this);
        return {
            corner: corner,
            touchCorner: touchCorner
        };
    }
    /**
   * @override set controls' coordinates as well
   * See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link http://fabricjs.com/fabric-gotchas}
   * @return {void}
   */ setCoords() {
        super.setCoords();
        this.canvas && (this.oCoords = this.calcOCoords());
    }
    /**
   * Calls a function for each control. The function gets called,
   * with the control, the control's key and the object that is calling the iterator
   * @param {Function} fn function to iterate over the controls over
   */ forEachControl(fn) {
        for(const i in this.controls)fn(this.controls[i], i, this);
    }
    /**
   * Draws a colored layer behind the object, inside its selection borders.
   * Requires public options: padding, selectionBackgroundColor
   * this function is called when the context is transformed
   * has checks to be skipped when the object is on a staticCanvas
   * @todo evaluate if make this disappear in favor of a pre-render hook for objects
   * this was added by Andrea Bogazzi to make possible some feature for work reasons
   * it seemed a good option, now is an edge case
   * @param {CanvasRenderingContext2D} ctx Context to draw on
   */ drawSelectionBackground(ctx) {
        if (!this.selectionBackgroundColor || this.canvas && this.canvas._activeObject !== this) return;
        ctx.save();
        const center = this.getRelativeCenterPoint(), wh = this._calculateCurrentDimensions(), vpt = this.getViewportTransform();
        ctx.translate(center.x, center.y);
        ctx.scale(1 / vpt[0], 1 / vpt[3]);
        ctx.rotate($ab3f2a5cc6216ae5$var$degreesToRadians(this.angle));
        ctx.fillStyle = this.selectionBackgroundColor;
        ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
        ctx.restore();
    }
    /**
   * @public override this function in order to customize the drawing of the control box, e.g. rounded corners, different border style.
   * @param {CanvasRenderingContext2D} ctx ctx is rotated and translated so that (0,0) is at object's center
   * @param {Point} size the control box size used
   */ strokeBorders(ctx, size) {
        ctx.strokeRect(-size.x / 2, -size.y / 2, size.x, size.y);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to draw on
   * @param {Point} size
   * @param {TStyleOverride} styleOverride object to override the object style
   */ _drawBorders(ctx, size) {
        let styleOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const options = $ab3f2a5cc6216ae5$var$_objectSpread2({
            hasControls: this.hasControls,
            borderColor: this.borderColor,
            borderDashArray: this.borderDashArray
        }, styleOverride);
        ctx.save();
        ctx.strokeStyle = options.borderColor;
        this._setLineDash(ctx, options.borderDashArray);
        this.strokeBorders(ctx, size);
        options.hasControls && this.drawControlsConnectingLines(ctx, size);
        ctx.restore();
    }
    /**
   * Renders controls and borders for the object
   * the context here is not transformed
   * @todo move to interactivity
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {TStyleOverride} [styleOverride] properties to override the object style
   */ _renderControls(ctx) {
        let styleOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const { hasBorders: hasBorders, hasControls: hasControls } = this;
        const styleOptions = $ab3f2a5cc6216ae5$var$_objectSpread2({
            hasBorders: hasBorders,
            hasControls: hasControls
        }, styleOverride);
        const vpt = this.getViewportTransform(), shouldDrawBorders = styleOptions.hasBorders, shouldDrawControls = styleOptions.hasControls;
        const matrix = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(vpt, this.calcTransformMatrix());
        const options = $ab3f2a5cc6216ae5$var$qrDecompose(matrix);
        ctx.save();
        ctx.translate(options.translateX, options.translateY);
        ctx.lineWidth = 1 * this.borderScaleFactor;
        // since interactive groups have been introduced, an object could be inside a group and needing controls
        // the following equality check `this.group === this.parent` covers:
        // object without a group ( undefined === undefined )
        // object inside a group
        // excludes object inside a group but multi selected since group and parent will differ in value
        if (this.group === this.parent) ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
        if (this.flipX) options.angle -= 180;
        ctx.rotate($ab3f2a5cc6216ae5$var$degreesToRadians(this.group ? options.angle : this.angle));
        shouldDrawBorders && this.drawBorders(ctx, options, styleOverride);
        shouldDrawControls && this.drawControls(ctx, styleOverride);
        ctx.restore();
    }
    /**
   * Draws borders of an object's bounding box.
   * Requires public properties: width, height
   * Requires public options: padding, borderColor
   * @param {CanvasRenderingContext2D} ctx Context to draw on
   * @param {object} options object representing current object parameters
   * @param {TStyleOverride} [styleOverride] object to override the object style
   */ drawBorders(ctx, options, styleOverride) {
        let size;
        if (styleOverride && styleOverride.forActiveSelection || this.group) {
            const bbox = $ab3f2a5cc6216ae5$var$sizeAfterTransform(this.width, this.height, $ab3f2a5cc6216ae5$var$calcDimensionsMatrix(options)), stroke = !this.isStrokeAccountedForInDimensions() ? (this.strokeUniform ? new $ab3f2a5cc6216ae5$export$baf26146a414f24a().scalarAdd(this.canvas ? this.canvas.getZoom() : 1) : // this is extremely confusing. options comes from the upper function
            // and is the qrDecompose of a matrix that takes in account zoom too
            new $ab3f2a5cc6216ae5$export$baf26146a414f24a(options.scaleX, options.scaleY)).scalarMultiply(this.strokeWidth) : $ab3f2a5cc6216ae5$var$ZERO;
            size = bbox.add(stroke).scalarAdd(this.borderScaleFactor).scalarAdd(this.padding * 2);
        } else size = this._calculateCurrentDimensions().scalarAdd(this.borderScaleFactor);
        this._drawBorders(ctx, size, styleOverride);
    }
    /**
   * Draws lines from a borders of an object's bounding box to controls that have `withConnection` property set.
   * Requires public properties: width, height
   * Requires public options: padding, borderColor
   * @param {CanvasRenderingContext2D} ctx Context to draw on
   * @param {Point} size object size x = width, y = height
   */ drawControlsConnectingLines(ctx, size) {
        let shouldStroke = false;
        ctx.beginPath();
        this.forEachControl((control, key)=>{
            // in this moment, the ctx is centered on the object.
            // width and height of the above function are the size of the bbox.
            if (control.withConnection && control.getVisibility(this, key)) {
                // reset movement for each control
                shouldStroke = true;
                ctx.moveTo(control.x * size.x, control.y * size.y);
                ctx.lineTo(control.x * size.x + control.offsetX, control.y * size.y + control.offsetY);
            }
        });
        shouldStroke && ctx.stroke();
    }
    /**
   * Draws corners of an object's bounding box.
   * Requires public properties: width, height
   * Requires public options: cornerSize, padding
   * Be aware that since fabric 6.0 this function does not call setCoords anymore.
   * setCoords needs to be called manually if the object of which we are rendering controls
   * is outside the standard selection and transform process.
   * @param {CanvasRenderingContext2D} ctx Context to draw on
   * @param {ControlRenderingStyleOverride} styleOverride object to override the object style
   */ drawControls(ctx) {
        let styleOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        ctx.save();
        const retinaScaling = this.getCanvasRetinaScaling();
        const { cornerStrokeColor: cornerStrokeColor, cornerDashArray: cornerDashArray, cornerColor: cornerColor } = this;
        const options = $ab3f2a5cc6216ae5$var$_objectSpread2({
            cornerStrokeColor: cornerStrokeColor,
            cornerDashArray: cornerDashArray,
            cornerColor: cornerColor
        }, styleOverride);
        ctx.setTransform(retinaScaling, 0, 0, retinaScaling, 0, 0);
        ctx.strokeStyle = ctx.fillStyle = options.cornerColor;
        if (!this.transparentCorners) ctx.strokeStyle = options.cornerStrokeColor;
        this._setLineDash(ctx, options.cornerDashArray);
        this.forEachControl((control, key)=>{
            if (control.getVisibility(this, key)) {
                const p = this.oCoords[key];
                control.render(ctx, p.x, p.y, options, this);
            }
        });
        ctx.restore();
    }
    /**
   * Returns true if the specified control is visible, false otherwise.
   * @param {string} controlKey The key of the control. Possible values are usually 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr',
   * but since the control api allow for any control name, can be any string.
   * @returns {boolean} true if the specified control is visible, false otherwise
   */ isControlVisible(controlKey) {
        return this.controls[controlKey] && this.controls[controlKey].getVisibility(this, controlKey);
    }
    /**
   * Sets the visibility of the specified control.
   * please do not use.
   * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
   * but since the control api allow for any control name, can be any string.
   * @param {Boolean} visible true to set the specified control visible, false otherwise
   * @todo discuss this overlap of priority here with the team. Andrea Bogazzi for details
   */ setControlVisible(controlKey, visible) {
        if (!this._controlsVisibility) this._controlsVisibility = {};
        this._controlsVisibility[controlKey] = visible;
    }
    /**
   * Sets the visibility state of object controls, this is just a bulk option for setControlVisible;
   * @param {Record<string, boolean>} [options] with an optional key per control
   * example: {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
   */ setControlsVisibility() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        Object.entries(options).forEach((_ref)=>{
            let [controlKey, visibility] = _ref;
            return this.setControlVisible(controlKey, visibility);
        });
    }
    /**
   * Clears the canvas.contextTop in a specific area that corresponds to the object's bounding box
   * that is in the canvas.contextContainer.
   * This function is used to clear pieces of contextTop where we render ephemeral effects on top of the object.
   * Example: blinking cursor text selection, drag effects.
   * @todo discuss swapping restoreManually with a renderCallback, but think of async issues
   * @param {Boolean} [restoreManually] When true won't restore the context after clear, in order to draw something else.
   * @return {CanvasRenderingContext2D|undefined} canvas.contextTop that is either still transformed
   * with the object transformMatrix, or restored to neutral transform
   */ clearContextTop(restoreManually) {
        if (!this.canvas) return;
        const ctx = this.canvas.contextTop;
        if (!ctx) return;
        const v = this.canvas.viewportTransform;
        ctx.save();
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        this.transform(ctx);
        // we add 4 pixel, to be sure to do not leave any pixel out
        const width = this.width + 4, height = this.height + 4;
        ctx.clearRect(-width / 2, -height / 2, width, height);
        restoreManually || ctx.restore();
        return ctx;
    }
    /**
   * This callback function is called every time _discardActiveObject or _setActiveObject
   * try to to deselect this object. If the function returns true, the process is cancelled
   * @param {Object} [options] options sent from the upper functions
   * @param {TPointerEvent} [options.e] event if the process is generated by an event
   * @param {FabricObject} [options.object] next object we are setting as active, and reason why
   * this is being deselected
   */ onDeselect(options) {
        // implemented by sub-classes, as needed.
        return false;
    }
    /**
   * This callback function is called every time _discardActiveObject or _setActiveObject
   * try to to select this object. If the function returns true, the process is cancelled
   * @param {Object} [options] options sent from the upper functions
   * @param {Event} [options.e] event if the process is generated by an event
   */ onSelect(options) {
        // implemented by sub-classes, as needed.
        return false;
    }
    /**
   * Override to customize Drag behavior
   * Fired from {@link Canvas#_onMouseMove}
   * @returns true in order for the window to start a drag session
   */ shouldStartDragging(e) {
        return false;
    }
    /**
   * Override to customize Drag behavior\
   * Fired once a drag session has started
   * @returns true to handle the drag event
   */ onDragStart(e) {
        return false;
    }
    /**
   * Override to customize drag and drop behavior
   * @public
   * @param {DragEvent} e
   * @returns {boolean} true if the object currently dragged can be dropped on the target
   */ canDrop(e) {
        return false;
    }
    /**
   * Override to customize drag and drop behavior
   * render a specific effect when an object is the source of a drag event
   * example: render the selection status for the part of text that is being dragged from a text object
   * @public
   * @param {DragEvent} e
   */ renderDragSourceEffect(e) {
    // for subclasses
    }
    /**
   * Override to customize drag and drop behavior
   * render a specific effect when an object is the target of a drag event
   * used to show that the underly object can receive a drop, or to show how the
   * object will change when dropping. example: show the cursor where the text is about to be dropped
   * @public
   * @param {DragEvent} e
   */ renderDropTargetEffect(e) {
    // for subclasses
    }
}
/**
 * The object's controls' position in viewport coordinates
 * Calculated by {@link Control#positionHandler} and {@link Control#calcCornerCoords}, depending on {@link padding}.
 * `corner/touchCorner` describe the 4 points forming the interactive area of the corner.
 * Used to draw and locate controls.
 */ /**
 * keeps the value of the last hovered corner during mouse move.
 * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
 * It should be private, but there is no harm in using it as
 * a read-only property.
 * this isn't cleaned automatically. Non selected objects may have wrong values
 * @type [string]
 */ /**
 * a map of control visibility for this object.
 * this was left when controls were introduced to not break the api too much
 * this takes priority over the generic control visibility
 */ /**
 * holds the controls for the object.
 * controls are added by default_controls.js
 */ /**
 * internal boolean to signal the code that the object is
 * part of the move action.
 */ /**
 * A boolean used from the gesture module to keep tracking of a scaling
 * action when there is no scaling transform in place.
 * This is an edge case and is used twice in all codebase.
 * Probably added to keep track of some performance issues
 * @TODO use git blame to investigate why it was added
 * DON'T USE IT. WE WILL TRY TO REMOVE IT
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$bee544043763fa88, "ownDefaults", $ab3f2a5cc6216ae5$var$interactiveObjectDefaultValues);
/***
 * https://www.typescriptlang.org/docs/handbook/mixins.html#alternative-pattern
 */ function $ab3f2a5cc6216ae5$var$applyMixins(derivedCtor, constructors) {
    constructors.forEach((baseCtor)=>{
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name)=>{
            name !== "constructor" && Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name) || Object.create(null));
        });
    });
    return derivedCtor;
}
// TODO somehow we have to make a tree-shakeable import
// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-unused-vars
class $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1 extends $ab3f2a5cc6216ae5$export$bee544043763fa88 {
}
$ab3f2a5cc6216ae5$var$applyMixins($ab3f2a5cc6216ae5$export$5a5fba7eea6847b1, [
    $ab3f2a5cc6216ae5$var$FabricObjectSVGExportMixin
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$5a5fba7eea6847b1);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$5a5fba7eea6847b1, "object");
/**
 * Returns true if context has transparent pixel
 * at specified location (taking tolerance into account)
 * @param {CanvasRenderingContext2D} ctx context
 * @param {Number} x x coordinate in canvasElementCoordinate, not fabric space. integer
 * @param {Number} y y coordinate in canvasElementCoordinate, not fabric space. integer
 * @param {Number} tolerance Tolerance pixels around the point, not alpha tolerance, integer
 * @return {boolean} true if transparent
 */ const $ab3f2a5cc6216ae5$var$isTransparent = (ctx, x, y, tolerance)=>{
    tolerance = Math.round(tolerance);
    const size = tolerance * 2 + 1;
    const { data: data } = ctx.getImageData(x - tolerance, y - tolerance, size, size);
    // Split image data - for tolerance > 1, pixelDataSize = 4;
    for(let i = 3; i < data.length; i += 4){
        const alphaChannel = data[i];
        if (alphaChannel > 0) return false;
    }
    return true;
};
/**
 * Rotates `point` around `origin` with `radians`
 * @deprecated use the Point.rotate
 * @param {Point} origin The origin of the rotation
 * @param {Point} origin The origin of the rotation
 * @param {TRadian} radians The radians of the angle for the rotation
 * @return {Point} The new rotated point
 */ const $ab3f2a5cc6216ae5$var$rotatePoint = (point, origin, radians)=>point.rotate(radians, origin);
/**
 * @see https://github.com/fabricjs/fabric.js/pull/8344
 * @todo consider removing skewing from points before calculating stroke projection,
 * see https://github.com/fabricjs/fabric.js/commit/494a10ee2f8c2278ae9a55b20bf50cf6ee25b064#commitcomment-94751537
 */ class $ab3f2a5cc6216ae5$var$StrokeProjectionsBase {
    constructor(options){
        this.options = options;
        this.strokeProjectionMagnitude = this.options.strokeWidth / 2;
        this.scale = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.options.scaleX, this.options.scaleY);
        this.strokeUniformScalar = this.options.strokeUniform ? new $ab3f2a5cc6216ae5$export$baf26146a414f24a(1 / this.options.scaleX, 1 / this.options.scaleY) : new $ab3f2a5cc6216ae5$export$baf26146a414f24a(1, 1);
    }
    /**
   * When the stroke is uniform, scaling affects the arrangement of points. So we must take it into account.
   */ createSideVector(from, to) {
        const v = $ab3f2a5cc6216ae5$var$createVector(from, to);
        return this.options.strokeUniform ? v.multiply(this.scale) : v;
    }
    projectOrthogonally(from, to, magnitude) {
        return this.applySkew(from.add(this.calcOrthogonalProjection(from, to, magnitude)));
    }
    isSkewed() {
        return this.options.skewX !== 0 || this.options.skewY !== 0;
    }
    applySkew(point) {
        const p = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(point);
        // skewY must be applied before skewX as this distortion affects skewX calculation
        p.y += p.x * Math.tan($ab3f2a5cc6216ae5$var$degreesToRadians(this.options.skewY));
        p.x += p.y * Math.tan($ab3f2a5cc6216ae5$var$degreesToRadians(this.options.skewX));
        return p;
    }
    scaleUnitVector(unitVector, scalar) {
        return unitVector.multiply(this.strokeUniformScalar).scalarMultiply(scalar);
    }
}
const $ab3f2a5cc6216ae5$var$zeroVector = new $ab3f2a5cc6216ae5$export$baf26146a414f24a();
/**
 * class in charge of finding projections for each type of line join
 * @see {@link [Closed path projections at #8344](https://github.com/fabricjs/fabric.js/pull/8344#2-closed-path)}
 *
 * - MDN:
 *   - https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineJoin
 *   - https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-linejoin
 * - Spec: https://svgwg.org/svg2-draft/painting.html#StrokeLinejoinProperty
 * - Playground to understand how the line joins works: https://hypertolosana.github.io/efficient-webgl-stroking/index.html
 * - View the calculated projections for each of the control points: https://codesandbox.io/s/project-stroke-points-with-context-to-trace-b8jc4j?file=/src/index.js
 *
 */ class $ab3f2a5cc6216ae5$var$StrokeLineJoinProjections extends $ab3f2a5cc6216ae5$var$StrokeProjectionsBase {
    static getOrthogonalRotationFactor(vector1, vector2) {
        const angle = vector2 ? $ab3f2a5cc6216ae5$var$calcAngleBetweenVectors(vector1, vector2) : $ab3f2a5cc6216ae5$var$calcVectorRotation(vector1);
        return Math.abs(angle) < $ab3f2a5cc6216ae5$var$halfPI ? -1 : 1;
    }
    constructor(A, B, C, options){
        super(options);
        /**
     * The point being projected (the angle ∠BAC)
     */ /**
     * The point before A
     */ /**
     * The point after A
     */ /**
     * The AB vector
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "AB", void 0);
        /**
     * The AC vector
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "AC", void 0);
        /**
     * The angle of A (∠BAC)
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "alpha", void 0);
        /**
     * The bisector of A (∠BAC)
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "bisector", void 0);
        this.A = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(A);
        this.B = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(B);
        this.C = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(C);
        this.AB = this.createSideVector(this.A, this.B);
        this.AC = this.createSideVector(this.A, this.C);
        this.alpha = $ab3f2a5cc6216ae5$var$calcAngleBetweenVectors(this.AB, this.AC);
        this.bisector = $ab3f2a5cc6216ae5$var$getUnitVector(// if AC is also the zero vector nothing will be projected
        // in that case the next point will handle the projection
        $ab3f2a5cc6216ae5$var$rotateVector(this.AB.eq($ab3f2a5cc6216ae5$var$zeroVector) ? this.AC : this.AB, this.alpha / 2));
    }
    calcOrthogonalProjection(from, to) {
        let magnitude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.strokeProjectionMagnitude;
        const vector = this.createSideVector(from, to);
        const orthogonalProjection = $ab3f2a5cc6216ae5$var$getOrthonormalVector(vector);
        const correctSide = $ab3f2a5cc6216ae5$var$StrokeLineJoinProjections.getOrthogonalRotationFactor(orthogonalProjection, this.bisector);
        return this.scaleUnitVector(orthogonalProjection, magnitude * correctSide);
    }
    /**
   * BEVEL
   * Calculation: the projection points are formed by the vector orthogonal to the vertex.
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#2-2-bevel
   */ projectBevel() {
        const projections = [];
        // if `alpha` equals 0 or 2*PI, the projections are the same for `B` and `C`
        (this.alpha % $ab3f2a5cc6216ae5$var$twoMathPi === 0 ? [
            this.B
        ] : [
            this.B,
            this.C
        ]).forEach((to)=>{
            projections.push(this.projectOrthogonally(this.A, to));
            projections.push(this.projectOrthogonally(this.A, to, -this.strokeProjectionMagnitude));
        });
        return projections;
    }
    /**
   * MITER
   * Calculation: the corner is formed by extending the outer edges of the stroke
   * at the tangents of the path segments until they intersect.
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#2-1-miter
   */ projectMiter() {
        const projections = [], alpha = Math.abs(this.alpha), hypotUnitScalar = 1 / Math.sin(alpha / 2), miterVector = this.scaleUnitVector(this.bisector, -this.strokeProjectionMagnitude * hypotUnitScalar);
        // When two line segments meet at a sharp angle, it is possible for the join to extend,
        // far beyond the thickness of the line stroking the path. The stroke-miterlimit imposes
        // a limit on the extent of the line join.
        // MDN: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-miterlimit
        // When the stroke is uniform, scaling changes the arrangement of points, this changes the miter-limit
        const strokeMiterLimit = this.options.strokeUniform ? $ab3f2a5cc6216ae5$var$magnitude(this.scaleUnitVector(this.bisector, this.options.strokeMiterLimit)) : this.options.strokeMiterLimit;
        if ($ab3f2a5cc6216ae5$var$magnitude(miterVector) / this.strokeProjectionMagnitude <= strokeMiterLimit) projections.push(this.applySkew(this.A.add(miterVector)));
        /* when the miter-limit is reached, the stroke line join becomes of type bevel.
      We always need two orthogonal projections which are basically bevel-type projections,
      so regardless of whether the miter-limit was reached or not, we include these projections.
    */ projections.push(...this.projectBevel());
        return projections;
    }
    /**
   * ROUND (without skew)
   * Calculation: the projections are the two vectors parallel to X and Y axes
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#2-3-1-round-without-skew
   */ projectRoundNoSkew(startCircle, endCircle) {
        const projections = [], // correctSide is used to only consider projecting for the outer side
        correctSide = new $ab3f2a5cc6216ae5$export$baf26146a414f24a($ab3f2a5cc6216ae5$var$StrokeLineJoinProjections.getOrthogonalRotationFactor(this.bisector), $ab3f2a5cc6216ae5$var$StrokeLineJoinProjections.getOrthogonalRotationFactor(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.bisector.y, this.bisector.x))), radiusOnAxisX = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(1, 0).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(correctSide), radiusOnAxisY = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(0, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(correctSide);
        [
            radiusOnAxisX,
            radiusOnAxisY
        ].forEach((vector)=>{
            if ($ab3f2a5cc6216ae5$var$isBetweenVectors(vector, startCircle, endCircle)) projections.push(this.A.add(vector));
        });
        return projections;
    }
    /**
   * ROUND (with skew)
   * Calculation: the projections are the points furthest from the vertex in
   * the direction of the X and Y axes after distortion.
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#2-3-2-round-skew
   */ projectRoundWithSkew(startCircle, endCircle) {
        const projections = [];
        const { skewX: skewX, skewY: skewY, scaleX: scaleX, scaleY: scaleY, strokeUniform: strokeUniform } = this.options, shearing = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(Math.tan($ab3f2a5cc6216ae5$var$degreesToRadians(skewX)), Math.tan($ab3f2a5cc6216ae5$var$degreesToRadians(skewY)));
        // The points furthest from the vertex in the direction of the X and Y axes after distortion
        const circleRadius = this.strokeProjectionMagnitude, newY = strokeUniform ? circleRadius / scaleY / Math.sqrt(1 / scaleY ** 2 + 1 / scaleX ** 2 * shearing.y ** 2) : circleRadius / Math.sqrt(1 + shearing.y ** 2), furthestY = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(// Safe guard due to floating point precision. In some situations the square root
        // was returning NaN because of a negative number close to zero.
        Math.sqrt(Math.max(circleRadius ** 2 - newY ** 2, 0)), newY), newX = strokeUniform ? circleRadius / Math.sqrt(1 + shearing.x ** 2 * (1 / scaleY) ** 2 / (1 / scaleX + 1 / scaleX * shearing.x * shearing.y) ** 2) : circleRadius / Math.sqrt(1 + shearing.x ** 2 / (1 + shearing.x * shearing.y) ** 2), furthestX = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(newX, Math.sqrt(Math.max(circleRadius ** 2 - newX ** 2, 0)));
        [
            furthestX,
            furthestX.scalarMultiply(-1),
            furthestY,
            furthestY.scalarMultiply(-1)
        ]// We need to skew the vector here as this information is used to check if
        // it is between the start and end of the circle segment
        .map((vector)=>this.applySkew(strokeUniform ? vector.multiply(this.strokeUniformScalar) : vector)).forEach((vector)=>{
            if ($ab3f2a5cc6216ae5$var$isBetweenVectors(vector, startCircle, endCircle)) projections.push(this.applySkew(this.A).add(vector));
        });
        return projections;
    }
    projectRound() {
        const projections = [];
        /* Include the start and end points of the circle segment, so that only
      the projections contained within it are included */ // add the orthogonal projections (start and end points of circle segment)
        projections.push(...this.projectBevel());
        // let's determines which one of the orthogonal projection is the beginning and end of the circle segment.
        // when `alpha` equals 0 or 2*PI, we have a straight line, so the way to find the start/end is different.
        const isStraightLine = this.alpha % $ab3f2a5cc6216ae5$var$twoMathPi === 0, // change the origin of the projections to point A
        // so that the cross product calculation is correct
        newOrigin = this.applySkew(this.A), proj0 = projections[isStraightLine ? 0 : 2].subtract(newOrigin), proj1 = projections[isStraightLine ? 1 : 0].subtract(newOrigin), // when `isStraightLine` === true, we compare with the vector opposite AB, otherwise we compare with the bisector.
        comparisonVector = isStraightLine ? this.applySkew(this.AB.scalarMultiply(-1)) : this.applySkew(this.bisector.multiply(this.strokeUniformScalar).scalarMultiply(-1)), // the beginning of the circle segment is always to the right of the comparison vector (cross product > 0)
        isProj0Start = $ab3f2a5cc6216ae5$var$crossProduct(proj0, comparisonVector) > 0, startCircle = isProj0Start ? proj0 : proj1, endCircle = isProj0Start ? proj1 : proj0;
        if (!this.isSkewed()) projections.push(...this.projectRoundNoSkew(startCircle, endCircle));
        else projections.push(...this.projectRoundWithSkew(startCircle, endCircle));
        return projections;
    }
    /**
   * Project stroke width on points returning projections for each point as follows:
   * - `miter`: 1 point corresponding to the outer boundary. If the miter limit is exceeded, it will be 2 points (becomes bevel)
   * - `bevel`: 2 points corresponding to the bevel possible boundaries, orthogonal to the stroke.
   * - `round`: same as `bevel` when it has no skew, with skew are 4 points.
   */ projectPoints() {
        switch(this.options.strokeLineJoin){
            case "miter":
                return this.projectMiter();
            case "round":
                return this.projectRound();
            default:
                return this.projectBevel();
        }
    }
    project() {
        return this.projectPoints().map((point)=>({
                originPoint: this.A,
                projectedPoint: point,
                angle: this.alpha,
                bisector: this.bisector
            }));
    }
}
/**
 * class in charge of finding projections for each type of line cap for start/end of an open path
 * @see {@link [Open path projections at #8344](https://github.com/fabricjs/fabric.js/pull/8344#1-open-path)}
 *
 * Reference:
 * - MDN:
 *   - https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineCap
 *   - https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-linecap
 * - Spec: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-linecap-dev
 * - Playground to understand how the line joins works: https://hypertolosana.github.io/efficient-webgl-stroking/index.html
 * - View the calculated projections for each of the control points: https://codesandbox.io/s/project-stroke-points-with-context-to-trace-b8jc4j?file=/src/index.js
 */ class $ab3f2a5cc6216ae5$var$StrokeLineCapProjections extends $ab3f2a5cc6216ae5$var$StrokeProjectionsBase {
    /**
   * edge point
   */ /**
   * point next to edge point
   */ constructor(A, T, options){
        super(options);
        this.A = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(A);
        this.T = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(T);
    }
    calcOrthogonalProjection(from, to) {
        let magnitude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.strokeProjectionMagnitude;
        const vector = this.createSideVector(from, to);
        return this.scaleUnitVector($ab3f2a5cc6216ae5$var$getOrthonormalVector(vector), magnitude);
    }
    /**
   * OPEN PATH START/END - Line cap: Butt
   * Calculation: to find the projections, just find the points orthogonal to the stroke
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#1-1-butt
   */ projectButt() {
        return [
            this.projectOrthogonally(this.A, this.T, this.strokeProjectionMagnitude),
            this.projectOrthogonally(this.A, this.T, -this.strokeProjectionMagnitude)
        ];
    }
    /**
   * OPEN PATH START/END - Line cap: Round
   * Calculation: same as stroke line join `round`
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#1-2-round
   */ projectRound() {
        const projections = [];
        if (!this.isSkewed() && this.A.eq(this.T)) {
            /* 1 point case without `skew`
        When `strokeUniform` is true, scaling has no effect.
        So we divide by scale, to remove its effect.
      */ const projection = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
            projections.push(this.applySkew(this.A.add(projection)), this.applySkew(this.A.subtract(projection)));
        } else projections.push(...new $ab3f2a5cc6216ae5$var$StrokeLineJoinProjections(this.A, this.T, this.T, this.options).projectRound());
        return projections;
    }
    /**
   * OPEN PATH START/END - Line cap: Square
   * Calculation: project a rectangle of points on the stroke in the opposite direction of the vector `AT`
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#1-3-square
   */ projectSquare() {
        const projections = [];
        if (this.A.eq(this.T)) {
            /* 1 point case without `skew`
        When `strokeUniform` is true, scaling has no effect.
        So we divide by scale, to remove its effect.
      */ const projection = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
            projections.push(this.A.add(projection), this.A.subtract(projection));
        } else {
            const orthogonalProjection = this.calcOrthogonalProjection(this.A, this.T, this.strokeProjectionMagnitude);
            const strokePointingOut = this.scaleUnitVector($ab3f2a5cc6216ae5$var$getUnitVector(this.createSideVector(this.A, this.T)), -this.strokeProjectionMagnitude);
            const projectedA = this.A.add(strokePointingOut);
            projections.push(projectedA.add(orthogonalProjection), projectedA.subtract(orthogonalProjection));
        }
        return projections.map((p)=>this.applySkew(p));
    }
    projectPoints() {
        switch(this.options.strokeLineCap){
            case "round":
                return this.projectRound();
            case "square":
                return this.projectSquare();
            default:
                return this.projectButt();
        }
    }
    project() {
        return this.projectPoints().map((point)=>({
                originPoint: this.A,
                projectedPoint: point
            }));
    }
}
/**
 *
 * Used to calculate object's bounding box
 *
 * @see https://github.com/fabricjs/fabric.js/pull/8344
 *
 */ const $ab3f2a5cc6216ae5$var$projectStrokeOnPoints = function(points, options) {
    let openPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const projections = [];
    if (points.length === 0) return projections;
    // first we remove duplicate neighboring points
    const reduced = points.reduce((reduced, point)=>{
        if (!reduced[reduced.length - 1].eq(point)) reduced.push(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(point));
        return reduced;
    }, [
        new $ab3f2a5cc6216ae5$export$baf26146a414f24a(points[0])
    ]);
    if (reduced.length === 1) openPath = true;
    else if (!openPath) {
        // remove points from end in case they equal the first point
        // in order to correctly project the first point
        const start = reduced[0];
        const index = $ab3f2a5cc6216ae5$var$findIndexRight(reduced, (point)=>!point.eq(start));
        reduced.splice(index + 1);
    }
    reduced.forEach((A, index, points)=>{
        let B, C;
        if (index === 0) {
            C = points[1];
            B = openPath ? A : points[points.length - 1];
        } else if (index === points.length - 1) {
            B = points[index - 1];
            C = openPath ? A : points[0];
        } else {
            B = points[index - 1];
            C = points[index + 1];
        }
        if (openPath && points.length === 1) projections.push(...new $ab3f2a5cc6216ae5$var$StrokeLineCapProjections(A, A, options).project());
        else if (openPath && (index === 0 || index === points.length - 1)) projections.push(...new $ab3f2a5cc6216ae5$var$StrokeLineCapProjections(A, index === 0 ? C : B, options).project());
        else projections.push(...new $ab3f2a5cc6216ae5$var$StrokeLineJoinProjections(A, B, C, options).project());
    });
    return projections;
};
/**
 * Capitalizes a string
 * @param {String} string String to capitalize
 * @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
 * and other letters stay untouched, if false first letter is capitalized
 * and other letters are converted to lowercase.
 * @return {String} Capitalized version of a string
 */ const $ab3f2a5cc6216ae5$var$capitalize = function(string) {
    let firstLetterOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return "".concat(string.charAt(0).toUpperCase()).concat(firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase());
};
/**
 * Escapes XML in a string
 * @param {String} string String to escape
 * @return {String} Escaped version of a string
 */ const $ab3f2a5cc6216ae5$var$escapeXml = (string)=>string.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
/**
 * Divide a string in the user perceived single units
 * @param {String} textstring String to escape
 * @return {Array} array containing the graphemes
 */ const $ab3f2a5cc6216ae5$var$graphemeSplit = (textstring)=>{
    const graphemes = [];
    for(let i = 0, chr; i < textstring.length; i++){
        if ((chr = $ab3f2a5cc6216ae5$var$getWholeChar(textstring, i)) === false) continue;
        graphemes.push(chr);
    }
    return graphemes;
};
// taken from mdn in the charAt doc page.
const $ab3f2a5cc6216ae5$var$getWholeChar = (str, i)=>{
    const code = str.charCodeAt(i);
    if (isNaN(code)) return ""; // Position not found
    if (code < 0xd800 || code > 0xdfff) return str.charAt(i);
    // High surrogate (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)
    if (0xd800 <= code && code <= 0xdbff) {
        if (str.length <= i + 1) throw "High surrogate without following low surrogate";
        const next = str.charCodeAt(i + 1);
        if (0xdc00 > next || next > 0xdfff) throw "High surrogate without following low surrogate";
        return str.charAt(i) + str.charAt(i + 1);
    }
    // Low surrogate (0xDC00 <= code && code <= 0xDFFF)
    if (i === 0) throw "Low surrogate without preceding high surrogate";
    const prev = str.charCodeAt(i - 1);
    // (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)
    if (0xd800 > prev || prev > 0xdbff) throw "Low surrogate without preceding high surrogate";
    // We can pass over low surrogates now as the second component
    // in a pair which we have already processed
    return false;
};
var $ab3f2a5cc6216ae5$var$lang_string = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    capitalize: $ab3f2a5cc6216ae5$var$capitalize,
    escapeXml: $ab3f2a5cc6216ae5$var$escapeXml,
    graphemeSplit: $ab3f2a5cc6216ae5$var$graphemeSplit
});
/**
 * @param {Object} prevStyle first style to compare
 * @param {Object} thisStyle second style to compare
 * @param {boolean} forTextSpans whether to check overline, underline, and line-through properties
 * @return {boolean} true if the style changed
 */ const $ab3f2a5cc6216ae5$var$hasStyleChanged = function(prevStyle, thisStyle) {
    let forTextSpans = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return prevStyle.fill !== thisStyle.fill || prevStyle.stroke !== thisStyle.stroke || prevStyle.strokeWidth !== thisStyle.strokeWidth || prevStyle.fontSize !== thisStyle.fontSize || prevStyle.fontFamily !== thisStyle.fontFamily || prevStyle.fontWeight !== thisStyle.fontWeight || prevStyle.fontStyle !== thisStyle.fontStyle || prevStyle.textBackgroundColor !== thisStyle.textBackgroundColor || prevStyle.deltaY !== thisStyle.deltaY || forTextSpans && (prevStyle.overline !== thisStyle.overline || prevStyle.underline !== thisStyle.underline || prevStyle.linethrough !== thisStyle.linethrough);
};
/**
 * Returns the array form of a text object's inline styles property with styles grouped in ranges
 * rather than per character. This format is less verbose, and is better suited for storage
 * so it is used in serialization (not during runtime).
 * @param {object} styles per character styles for a text object
 * @param {String} text the text string that the styles are applied to
 * @return {{start: number, end: number, style: object}[]}
 */ const $ab3f2a5cc6216ae5$var$stylesToArray = (styles, text)=>{
    const textLines = text.split("\n"), stylesArray = [];
    let charIndex = -1, prevStyle = {};
    // clone style structure to prevent mutation
    styles = $ab3f2a5cc6216ae5$var$cloneDeep(styles);
    //loop through each textLine
    for(let i = 0; i < textLines.length; i++){
        const chars = $ab3f2a5cc6216ae5$var$graphemeSplit(textLines[i]);
        if (!styles[i]) {
            //no styles exist for this line, so add the line's length to the charIndex total and reset prevStyle
            charIndex += chars.length;
            prevStyle = {};
            continue;
        }
        //loop through each character of the current line
        for(let c = 0; c < chars.length; c++){
            charIndex++;
            const thisStyle = styles[i][c];
            //check if style exists for this character
            if (thisStyle && Object.keys(thisStyle).length > 0) {
                if ($ab3f2a5cc6216ae5$var$hasStyleChanged(prevStyle, thisStyle, true)) stylesArray.push({
                    start: charIndex,
                    end: charIndex + 1,
                    style: thisStyle
                });
                else //if style is the same as previous character, increase end index
                stylesArray[stylesArray.length - 1].end++;
            }
            prevStyle = thisStyle || {};
        }
    }
    return stylesArray;
};
/**
 * Returns the object form of the styles property with styles that are assigned per
 * character rather than grouped by range. This format is more verbose, and is
 * only used during runtime (not for serialization/storage)
 * @param {Array} styles the serialized form of a text object's styles
 * @param {String} text the text string that the styles are applied to
 * @return {Object}
 */ const $ab3f2a5cc6216ae5$var$stylesFromArray = (styles, text)=>{
    if (!Array.isArray(styles)) // clone to prevent mutation
    return $ab3f2a5cc6216ae5$var$cloneDeep(styles);
    const textLines = text.split($ab3f2a5cc6216ae5$var$reNewline), stylesObject = {};
    let charIndex = -1, styleIndex = 0;
    //loop through each textLine
    for(let i = 0; i < textLines.length; i++){
        const chars = $ab3f2a5cc6216ae5$var$graphemeSplit(textLines[i]);
        //loop through each character of the current line
        for(let c = 0; c < chars.length; c++){
            charIndex++;
            //check if there's a style collection that includes the current character
            if (styles[styleIndex] && styles[styleIndex].start <= charIndex && charIndex < styles[styleIndex].end) {
                //create object for line index if it doesn't exist
                stylesObject[i] = stylesObject[i] || {};
                //assign a style at this character's index
                stylesObject[i][c] = $ab3f2a5cc6216ae5$var$_objectSpread2({}, styles[styleIndex].style);
                //if character is at the end of the current style collection, move to the next
                if (charIndex === styles[styleIndex].end - 1) styleIndex++;
            }
        }
    }
    return stylesObject;
};
/**
 * Attributes parsed from all SVG elements
 * @type array
 */ const $ab3f2a5cc6216ae5$var$SHARED_ATTRIBUTES = [
    "display",
    "transform",
    $ab3f2a5cc6216ae5$var$FILL,
    "fill-opacity",
    "fill-rule",
    "opacity",
    $ab3f2a5cc6216ae5$var$STROKE,
    "stroke-dasharray",
    "stroke-linecap",
    "stroke-dashoffset",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "id",
    "paint-order",
    "vector-effect",
    "instantiated_by_use",
    "clip-path"
];
function $ab3f2a5cc6216ae5$var$selectorMatches(element, selector) {
    const nodeName = element.nodeName;
    const classNames = element.getAttribute("class");
    const id = element.getAttribute("id");
    const azAz = "(?![a-zA-Z\\-]+)";
    let matcher;
    // i check if a selector matches slicing away part from it.
    // if i get empty string i should match
    matcher = new RegExp("^" + nodeName, "i");
    selector = selector.replace(matcher, "");
    if (id && selector.length) {
        matcher = new RegExp("#" + id + azAz, "i");
        selector = selector.replace(matcher, "");
    }
    if (classNames && selector.length) {
        const splitClassNames = classNames.split(" ");
        for(let i = splitClassNames.length; i--;){
            matcher = new RegExp("\\." + splitClassNames[i] + azAz, "i");
            selector = selector.replace(matcher, "");
        }
    }
    return selector.length === 0;
}
function $ab3f2a5cc6216ae5$var$doesSomeParentMatch(element, selectors) {
    let selector, parentMatching = true;
    while(element.parentElement && element.parentElement.nodeType === 1 && selectors.length){
        if (parentMatching) selector = selectors.pop();
        element = element.parentElement;
        parentMatching = $ab3f2a5cc6216ae5$var$selectorMatches(element, selector);
    }
    return selectors.length === 0;
}
/**
 * @private
 */ function $ab3f2a5cc6216ae5$var$elementMatchesRule(element, selectors) {
    let parentMatching = true;
    // start from rightmost selector.
    const firstMatching = $ab3f2a5cc6216ae5$var$selectorMatches(element, selectors.pop());
    if (firstMatching && selectors.length) parentMatching = $ab3f2a5cc6216ae5$var$doesSomeParentMatch(element, selectors);
    return firstMatching && parentMatching && selectors.length === 0;
}
/**
 * @private
 */ function $ab3f2a5cc6216ae5$var$getGlobalStylesForElement(element) {
    let cssRules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let styles = {};
    for(const rule in cssRules)if ($ab3f2a5cc6216ae5$var$elementMatchesRule(element, rule.split(" "))) styles = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, styles), cssRules[rule]);
    return styles;
}
const $ab3f2a5cc6216ae5$var$normalizeAttr = (attr)=>{
    var _attributesMap;
    return (_attributesMap = $ab3f2a5cc6216ae5$var$attributesMap[attr]) !== null && _attributesMap !== void 0 ? _attributesMap : attr;
};
const $ab3f2a5cc6216ae5$var$regex$1 = new RegExp("(".concat($ab3f2a5cc6216ae5$var$reNum, ")"), "gi");
const $ab3f2a5cc6216ae5$var$cleanupSvgAttribute = (attributeValue)=>attributeValue.replace($ab3f2a5cc6216ae5$var$regex$1, " $1 ")// replace annoying commas and arbitrary whitespace with single spaces
    .replace(/,/gi, " ").replace(/\s+/gi, " ");
var $ab3f2a5cc6216ae5$var$_templateObject$1, $ab3f2a5cc6216ae5$var$_templateObject2, $ab3f2a5cc6216ae5$var$_templateObject3, $ab3f2a5cc6216ae5$var$_templateObject4, $ab3f2a5cc6216ae5$var$_templateObject5, $ab3f2a5cc6216ae5$var$_templateObject6, $ab3f2a5cc6216ae5$var$_templateObject7;
// == begin transform regexp
const $ab3f2a5cc6216ae5$var$p$1 = "(".concat($ab3f2a5cc6216ae5$var$reNum, ")");
const $ab3f2a5cc6216ae5$var$skewX = String.raw($ab3f2a5cc6216ae5$var$_templateObject$1 || ($ab3f2a5cc6216ae5$var$_templateObject$1 = $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral([
    "(skewX)(",
    ")"
], [
    "(skewX)\\(",
    "\\)"
])), $ab3f2a5cc6216ae5$var$p$1);
const $ab3f2a5cc6216ae5$var$skewY = String.raw($ab3f2a5cc6216ae5$var$_templateObject2 || ($ab3f2a5cc6216ae5$var$_templateObject2 = $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral([
    "(skewY)(",
    ")"
], [
    "(skewY)\\(",
    "\\)"
])), $ab3f2a5cc6216ae5$var$p$1);
const $ab3f2a5cc6216ae5$var$rotate = String.raw($ab3f2a5cc6216ae5$var$_templateObject3 || ($ab3f2a5cc6216ae5$var$_templateObject3 = $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral([
    "(rotate)(",
    "(?: ",
    " ",
    ")?)"
], [
    "(rotate)\\(",
    "(?: ",
    " ",
    ")?\\)"
])), $ab3f2a5cc6216ae5$var$p$1, $ab3f2a5cc6216ae5$var$p$1, $ab3f2a5cc6216ae5$var$p$1);
const $ab3f2a5cc6216ae5$var$scale = String.raw($ab3f2a5cc6216ae5$var$_templateObject4 || ($ab3f2a5cc6216ae5$var$_templateObject4 = $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral([
    "(scale)(",
    "(?: ",
    ")?)"
], [
    "(scale)\\(",
    "(?: ",
    ")?\\)"
])), $ab3f2a5cc6216ae5$var$p$1, $ab3f2a5cc6216ae5$var$p$1);
const $ab3f2a5cc6216ae5$var$translate = String.raw($ab3f2a5cc6216ae5$var$_templateObject5 || ($ab3f2a5cc6216ae5$var$_templateObject5 = $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral([
    "(translate)(",
    "(?: ",
    ")?)"
], [
    "(translate)\\(",
    "(?: ",
    ")?\\)"
])), $ab3f2a5cc6216ae5$var$p$1, $ab3f2a5cc6216ae5$var$p$1);
const $ab3f2a5cc6216ae5$var$matrix = String.raw($ab3f2a5cc6216ae5$var$_templateObject6 || ($ab3f2a5cc6216ae5$var$_templateObject6 = $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral([
    "(matrix)(",
    " ",
    " ",
    " ",
    " ",
    " ",
    ")"
], [
    "(matrix)\\(",
    " ",
    " ",
    " ",
    " ",
    " ",
    "\\)"
])), $ab3f2a5cc6216ae5$var$p$1, $ab3f2a5cc6216ae5$var$p$1, $ab3f2a5cc6216ae5$var$p$1, $ab3f2a5cc6216ae5$var$p$1, $ab3f2a5cc6216ae5$var$p$1, $ab3f2a5cc6216ae5$var$p$1);
const $ab3f2a5cc6216ae5$var$transform = "(?:".concat($ab3f2a5cc6216ae5$var$matrix, "|").concat($ab3f2a5cc6216ae5$var$translate, "|").concat($ab3f2a5cc6216ae5$var$rotate, "|").concat($ab3f2a5cc6216ae5$var$scale, "|").concat($ab3f2a5cc6216ae5$var$skewX, "|").concat($ab3f2a5cc6216ae5$var$skewY, ")");
const $ab3f2a5cc6216ae5$var$transforms = "(?:".concat($ab3f2a5cc6216ae5$var$transform, "*)");
const $ab3f2a5cc6216ae5$var$transformList = String.raw($ab3f2a5cc6216ae5$var$_templateObject7 || ($ab3f2a5cc6216ae5$var$_templateObject7 = $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral([
    "^s*(?:",
    "?)s*$"
], [
    "^\\s*(?:",
    "?)\\s*$"
])), $ab3f2a5cc6216ae5$var$transforms);
// http://www.w3.org/TR/SVG/coords.html#TransformAttribute
const $ab3f2a5cc6216ae5$var$reTransformList = new RegExp($ab3f2a5cc6216ae5$var$transformList);
const $ab3f2a5cc6216ae5$var$reTransform = new RegExp($ab3f2a5cc6216ae5$var$transform);
const $ab3f2a5cc6216ae5$var$reTransformAll = new RegExp($ab3f2a5cc6216ae5$var$transform, "g");
// == end transform regexp
/**
 * Parses "transform" attribute, returning an array of values
 * @static
 * @function
 * @memberOf fabric
 * @param {String} attributeValue String containing attribute value
 * @return {TTransformMatrix} Array of 6 elements representing transformation matrix
 */ function $ab3f2a5cc6216ae5$export$6655c0d22b13de1f(attributeValue) {
    // first we clean the string
    attributeValue = $ab3f2a5cc6216ae5$var$cleanupSvgAttribute(attributeValue)// remove spaces around front parentheses
    .replace(/\s*([()])\s*/gi, "$1");
    // start with identity matrix
    const matrices = [];
    // return if no argument was given or
    // an argument does not match transform attribute regexp
    if (!attributeValue || attributeValue && !$ab3f2a5cc6216ae5$var$reTransformList.test(attributeValue)) return [
        ...$ab3f2a5cc6216ae5$export$3c5a7f9475b116e0
    ];
    for (const match of attributeValue.matchAll($ab3f2a5cc6216ae5$var$reTransformAll)){
        const transformMatch = $ab3f2a5cc6216ae5$var$reTransform.exec(match[0]);
        if (!transformMatch) continue;
        let matrix = $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0;
        const matchedParams = transformMatch.filter((m)=>!!m);
        const [, operation, ...rawArgs] = matchedParams;
        const [arg0, arg1, arg2, arg3, arg4, arg5] = rawArgs.map((arg)=>parseFloat(arg));
        switch(operation){
            case "translate":
                matrix = $ab3f2a5cc6216ae5$var$createTranslateMatrix(arg0, arg1);
                break;
            case $ab3f2a5cc6216ae5$var$ROTATE:
                matrix = $ab3f2a5cc6216ae5$var$createRotateMatrix({
                    angle: arg0
                }, {
                    x: arg1,
                    y: arg2
                });
                break;
            case $ab3f2a5cc6216ae5$var$SCALE:
                matrix = $ab3f2a5cc6216ae5$var$createScaleMatrix(arg0, arg1);
                break;
            case $ab3f2a5cc6216ae5$var$SKEW_X:
                matrix = $ab3f2a5cc6216ae5$var$createSkewXMatrix(arg0);
                break;
            case $ab3f2a5cc6216ae5$var$SKEW_Y:
                matrix = $ab3f2a5cc6216ae5$var$createSkewYMatrix(arg0);
                break;
            case "matrix":
                matrix = [
                    arg0,
                    arg1,
                    arg2,
                    arg3,
                    arg4,
                    arg5
                ];
                break;
        }
        // snapshot current matrix into matrices array
        matrices.push(matrix);
    }
    return $ab3f2a5cc6216ae5$var$multiplyTransformMatrixArray(matrices);
}
function $ab3f2a5cc6216ae5$var$normalizeValue(attr, value, parentAttributes, fontSize) {
    const isArray = Array.isArray(value);
    let parsed;
    let ouputValue = value;
    if ((attr === $ab3f2a5cc6216ae5$var$FILL || attr === $ab3f2a5cc6216ae5$var$STROKE) && value === $ab3f2a5cc6216ae5$var$NONE) ouputValue = "";
    else if (attr === "strokeUniform") return value === "non-scaling-stroke";
    else if (attr === "strokeDashArray") {
        if (value === $ab3f2a5cc6216ae5$var$NONE) ouputValue = null;
        else ouputValue = value.replace(/,/g, " ").split(/\s+/).map(parseFloat);
    } else if (attr === "transformMatrix") {
        if (parentAttributes && parentAttributes.transformMatrix) ouputValue = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(parentAttributes.transformMatrix, $ab3f2a5cc6216ae5$export$6655c0d22b13de1f(value));
        else ouputValue = $ab3f2a5cc6216ae5$export$6655c0d22b13de1f(value);
    } else if (attr === "visible") {
        ouputValue = value !== $ab3f2a5cc6216ae5$var$NONE && value !== "hidden";
        // display=none on parent element always takes precedence over child element
        if (parentAttributes && parentAttributes.visible === false) ouputValue = false;
    } else if (attr === "opacity") {
        ouputValue = parseFloat(value);
        if (parentAttributes && typeof parentAttributes.opacity !== "undefined") ouputValue *= parentAttributes.opacity;
    } else if (attr === "textAnchor" /* text-anchor */ ) ouputValue = value === "start" ? $ab3f2a5cc6216ae5$var$LEFT : value === "end" ? $ab3f2a5cc6216ae5$var$RIGHT : $ab3f2a5cc6216ae5$var$CENTER;
    else if (attr === "charSpacing") // parseUnit returns px and we convert it to em
    parsed = $ab3f2a5cc6216ae5$var$parseUnit(value, fontSize) / fontSize * 1000;
    else if (attr === "paintFirst") {
        const fillIndex = value.indexOf($ab3f2a5cc6216ae5$var$FILL);
        const strokeIndex = value.indexOf($ab3f2a5cc6216ae5$var$STROKE);
        ouputValue = $ab3f2a5cc6216ae5$var$FILL;
        if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) ouputValue = $ab3f2a5cc6216ae5$var$STROKE;
        else if (fillIndex === -1 && strokeIndex > -1) ouputValue = $ab3f2a5cc6216ae5$var$STROKE;
    } else if (attr === "href" || attr === "xlink:href" || attr === "font") return value;
    else if (attr === "imageSmoothing") return value === "optimizeQuality";
    else parsed = isArray ? value.map($ab3f2a5cc6216ae5$var$parseUnit) : $ab3f2a5cc6216ae5$var$parseUnit(value, fontSize);
    return !isArray && isNaN(parsed) ? ouputValue : parsed;
}
/**
 * Parses a short font declaration, building adding its properties to a style object
 * @static
 * @function
 * @memberOf fabric
 * @param {String} value font declaration
 * @param {Object} oStyle definition
 */ function $ab3f2a5cc6216ae5$export$da5b8f587c2501a(value, oStyle) {
    const match = value.match($ab3f2a5cc6216ae5$var$reFontDeclaration);
    if (!match) return;
    const fontStyle = match[1], // font variant is not used
    // fontVariant = match[2],
    fontWeight = match[3], fontSize = match[4], lineHeight = match[5], fontFamily = match[6];
    if (fontStyle) oStyle.fontStyle = fontStyle;
    if (fontWeight) oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
    if (fontSize) oStyle.fontSize = $ab3f2a5cc6216ae5$var$parseUnit(fontSize);
    if (fontFamily) oStyle.fontFamily = fontFamily;
    if (lineHeight) oStyle.lineHeight = lineHeight === "normal" ? 1 : lineHeight;
}
/**
 * Takes a style object and parses it in one that has only defined values
 * and lowercases properties
 * @param style
 * @param oStyle
 */ function $ab3f2a5cc6216ae5$var$parseStyleObject(style, oStyle) {
    Object.entries(style).forEach((_ref)=>{
        let [prop, value] = _ref;
        if (value === undefined) return;
        oStyle[prop.toLowerCase()] = value;
    });
}
/**
 * Takes a style string and parses it in one that has only defined values
 * and lowercases properties
 * @param style
 * @param oStyle
 */ function $ab3f2a5cc6216ae5$var$parseStyleString(style, oStyle) {
    style.replace(/;\s*$/, "").split(";").forEach((chunk)=>{
        const [attr, value] = chunk.split(":");
        oStyle[attr.trim().toLowerCase()] = value.trim();
    });
}
/**
 * Parses "style" attribute, retuning an object with values
 * @static
 * @memberOf fabric
 * @param {SVGElement} element Element to parse
 * @return {Object} Objects with values parsed from style attribute of an element
 */ function $ab3f2a5cc6216ae5$export$d0c59994cd7c3b84(element) {
    const oStyle = {}, style = element.getAttribute("style");
    if (!style) return oStyle;
    if (typeof style === "string") $ab3f2a5cc6216ae5$var$parseStyleString(style, oStyle);
    else $ab3f2a5cc6216ae5$var$parseStyleObject(style, oStyle);
    return oStyle;
}
const $ab3f2a5cc6216ae5$var$colorAttributesMap = {
    stroke: "strokeOpacity",
    fill: "fillOpacity"
};
/**
 * @private
 * @param {Object} attributes Array of attributes to parse
 */ function $ab3f2a5cc6216ae5$var$setStrokeFillOpacity(attributes) {
    const defaults = $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1.getDefaults();
    Object.entries($ab3f2a5cc6216ae5$var$colorAttributesMap).forEach((_ref)=>{
        let [attr, colorAttr] = _ref;
        if (typeof attributes[colorAttr] === "undefined" || attributes[attr] === "") return;
        if (typeof attributes[attr] === "undefined") {
            if (!defaults[attr]) return;
            attributes[attr] = defaults[attr];
        }
        if (attributes[attr].indexOf("url(") === 0) return;
        const color = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(attributes[attr]);
        attributes[attr] = color.setAlpha($ab3f2a5cc6216ae5$var$toFixed(color.getAlpha() * attributes[colorAttr], 2)).toRgba();
    });
    return attributes;
}
/**
 * Returns an object of attributes' name/value, given element and an array of attribute names;
 * Parses parent "g" nodes recursively upwards.
 * @param {SVGElement | HTMLElement} element Element to parse
 * @param {Array} attributes Array of attributes to parse
 * @return {Object} object containing parsed attributes' names/values
 */ function $ab3f2a5cc6216ae5$export$fbe550151e406473(element, attributes, cssRules) {
    if (!element) return {};
    let parentAttributes = {}, fontSize, parentFontSize = $ab3f2a5cc6216ae5$var$DEFAULT_SVG_FONT_SIZE;
    // if there's a parent container (`g` or `a` or `symbol` node), parse its attributes recursively upwards
    if (element.parentNode && $ab3f2a5cc6216ae5$var$svgValidParentsRegEx.test(element.parentNode.nodeName)) {
        parentAttributes = $ab3f2a5cc6216ae5$export$fbe550151e406473(element.parentElement, attributes, cssRules);
        if (parentAttributes.fontSize) fontSize = parentFontSize = $ab3f2a5cc6216ae5$var$parseUnit(parentAttributes.fontSize);
    }
    const ownAttributes = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, attributes.reduce((memo, attr)=>{
        const value = element.getAttribute(attr);
        if (value) memo[attr] = value;
        return memo;
    }, {})), $ab3f2a5cc6216ae5$var$getGlobalStylesForElement(element, cssRules)), $ab3f2a5cc6216ae5$export$d0c59994cd7c3b84(element));
    if (ownAttributes[$ab3f2a5cc6216ae5$var$cPath]) element.setAttribute($ab3f2a5cc6216ae5$var$cPath, ownAttributes[$ab3f2a5cc6216ae5$var$cPath]);
    if (ownAttributes[$ab3f2a5cc6216ae5$var$fSize]) {
        // looks like the minimum should be 9px when dealing with ems. this is what looks like in browsers.
        fontSize = $ab3f2a5cc6216ae5$var$parseUnit(ownAttributes[$ab3f2a5cc6216ae5$var$fSize], parentFontSize);
        ownAttributes[$ab3f2a5cc6216ae5$var$fSize] = "".concat(fontSize);
    }
    // this should have its own complex type
    const normalizedStyle = {};
    for(const attr in ownAttributes){
        const normalizedAttr = $ab3f2a5cc6216ae5$var$normalizeAttr(attr);
        const normalizedValue = $ab3f2a5cc6216ae5$var$normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
        normalizedStyle[normalizedAttr] = normalizedValue;
    }
    if (normalizedStyle && normalizedStyle.font) $ab3f2a5cc6216ae5$export$da5b8f587c2501a(normalizedStyle.font, normalizedStyle);
    const mergedAttrs = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, parentAttributes), normalizedStyle);
    return $ab3f2a5cc6216ae5$var$svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : $ab3f2a5cc6216ae5$var$setStrokeFillOpacity(mergedAttrs);
}
const $ab3f2a5cc6216ae5$var$_excluded$c = [
    "left",
    "top",
    "width",
    "height",
    "visible"
];
const $ab3f2a5cc6216ae5$var$rectDefaultValues = {
    rx: 0,
    ry: 0
};
const $ab3f2a5cc6216ae5$var$RECT_PROPS = [
    "rx",
    "ry"
];
class $ab3f2a5cc6216ae5$export$c79fc6492f3af13d extends $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$c79fc6492f3af13d.ownDefaults);
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        Object.assign(this, $ab3f2a5cc6216ae5$export$c79fc6492f3af13d.ownDefaults);
        this.setOptions(options);
        this._initRxRy();
    }
    /**
   * Initializes rx/ry attributes
   * @private
   */ _initRxRy() {
        const { rx: rx, ry: ry } = this;
        if (rx && !ry) this.ry = rx;
        else if (ry && !rx) this.rx = ry;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        const { width: w, height: h } = this;
        const x = -w / 2;
        const y = -h / 2;
        const rx = this.rx ? Math.min(this.rx, w / 2) : 0;
        const ry = this.ry ? Math.min(this.ry, h / 2) : 0;
        const isRounded = rx !== 0 || ry !== 0;
        ctx.beginPath();
        ctx.moveTo(x + rx, y);
        ctx.lineTo(x + w - rx, y);
        isRounded && ctx.bezierCurveTo(x + w - $ab3f2a5cc6216ae5$var$kRect * rx, y, x + w, y + $ab3f2a5cc6216ae5$var$kRect * ry, x + w, y + ry);
        ctx.lineTo(x + w, y + h - ry);
        isRounded && ctx.bezierCurveTo(x + w, y + h - $ab3f2a5cc6216ae5$var$kRect * ry, x + w - $ab3f2a5cc6216ae5$var$kRect * rx, y + h, x + w - rx, y + h);
        ctx.lineTo(x + rx, y + h);
        isRounded && ctx.bezierCurveTo(x + $ab3f2a5cc6216ae5$var$kRect * rx, y + h, x, y + h - $ab3f2a5cc6216ae5$var$kRect * ry, x, y + h - ry);
        ctx.lineTo(x, y + ry);
        isRounded && ctx.bezierCurveTo(x, y + $ab3f2a5cc6216ae5$var$kRect * ry, x + $ab3f2a5cc6216ae5$var$kRect * rx, y, x + rx, y);
        ctx.closePath();
        this._renderPaintInOrder(ctx);
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return super.toObject([
            ...$ab3f2a5cc6216ae5$var$RECT_PROPS,
            ...propertiesToInclude
        ]);
    }
    /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const { width: width, height: height, rx: rx, ry: ry } = this;
        return [
            "<rect ",
            "COMMON_PARTS",
            'x="'.concat(-width / 2, '" y="').concat(-height / 2, '" rx="').concat(rx, '" ry="').concat(ry, '" width="').concat(width, '" height="').concat(height, '" />\n')
        ];
    }
    /**
   * List of attribute names to account for when parsing SVG element (used by `Rect.fromElement`)
   * @static
   * @memberOf Rect
   * @see: http://www.w3.org/TR/SVG/shapes.html#RectElement
   */ /* _FROM_SVG_START_ */ /**
   * Returns {@link Rect} instance from an SVG element
   * @static
   * @memberOf Rect
   * @param {HTMLElement} element Element to parse
   * @param {Object} [options] Options object
   */ static async fromElement(element, options, cssRules) {
        const _parseAttributes = $ab3f2a5cc6216ae5$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules), { left: left = 0, top: top = 0, width: width = 0, height: height = 0, visible: visible = true } = _parseAttributes, restOfparsedAttributes = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_parseAttributes, $ab3f2a5cc6216ae5$var$_excluded$c);
        return new this($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), restOfparsedAttributes), {}, {
            left: left,
            top: top,
            width: width,
            height: height,
            visible: Boolean(visible && width && height)
        }));
    }
}
/**
 * Horizontal border radius
 * @type Number
 * @default
 */ /**
 * Vertical border radius
 * @type Number
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c79fc6492f3af13d, "type", "Rect");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c79fc6492f3af13d, "cacheProperties", [
    ...$ab3f2a5cc6216ae5$var$cacheProperties,
    ...$ab3f2a5cc6216ae5$var$RECT_PROPS
]);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c79fc6492f3af13d, "ownDefaults", $ab3f2a5cc6216ae5$var$rectDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c79fc6492f3af13d, "ATTRIBUTE_NAMES", [
    ...$ab3f2a5cc6216ae5$var$SHARED_ATTRIBUTES,
    "x",
    "y",
    "rx",
    "ry",
    "width",
    "height"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$c79fc6492f3af13d);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setSVGClass($ab3f2a5cc6216ae5$export$c79fc6492f3af13d);
const $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_INITIALIZATION = "initialization";
const $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_ADDED = "added";
const $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_REMOVED = "removed";
const $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_IMPERATIVE = "imperative";
const $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_OBJECT_MODIFIED = "object_modified";
const $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_OBJECT_MODIFYING = "object_modifying";
/**
 * @returns 2 points, the tl and br corners of the non rotated bounding box of an object
 * in the {@link group} plane, taking into account objects that {@link group} is their parent
 * but also belong to the active selection.
 */ const $ab3f2a5cc6216ae5$var$getObjectBounds = (destinationGroup, object)=>{
    const { strokeUniform: strokeUniform, strokeWidth: strokeWidth, width: width, height: height, group: currentGroup } = object;
    const t = currentGroup && currentGroup !== destinationGroup ? $ab3f2a5cc6216ae5$var$calcPlaneChangeMatrix(currentGroup.calcTransformMatrix(), destinationGroup.calcTransformMatrix()) : null;
    const objectCenter = t ? object.getRelativeCenterPoint().transform(t) : object.getRelativeCenterPoint();
    const accountForStroke = !object["isStrokeAccountedForInDimensions"]();
    const strokeUniformVector = strokeUniform && accountForStroke ? $ab3f2a5cc6216ae5$var$sendVectorToPlane(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(strokeWidth, strokeWidth), undefined, destinationGroup.calcTransformMatrix()) : $ab3f2a5cc6216ae5$var$ZERO;
    const scalingStrokeWidth = !strokeUniform && accountForStroke ? strokeWidth : 0;
    const sizeVector = $ab3f2a5cc6216ae5$var$sizeAfterTransform(width + scalingStrokeWidth, height + scalingStrokeWidth, $ab3f2a5cc6216ae5$var$multiplyTransformMatrixArray([
        t,
        object.calcOwnMatrix()
    ], true)).add(strokeUniformVector).scalarDivide(2);
    return [
        objectCenter.subtract(sizeVector),
        objectCenter.add(sizeVector)
    ];
};
/**
 * Exposes a main public method {@link calcLayoutResult} that is used by the `LayoutManager` to perform layout.
 * Returning `undefined` signals the `LayoutManager` to skip the layout.
 *
 * In charge of calculating the bounding box of the passed objects.
 */ class $ab3f2a5cc6216ae5$export$f7b260234c293505 {
    /**
   * Used by the `LayoutManager` to perform layout
   * @TODO/fix: if this method is calcResult, should calc unconditionally.
   * the condition to not calc should be evaluated by the layoutManager.
   * @returns layout result **OR** `undefined` to skip layout
   */ calcLayoutResult(context, objects) {
        if (this.shouldPerformLayout(context)) return this.calcBoundingBox(objects, context);
    }
    shouldPerformLayout(_ref) {
        let { type: type, prevStrategy: prevStrategy, strategy: strategy } = _ref;
        return type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_INITIALIZATION || type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_IMPERATIVE || !!prevStrategy && strategy !== prevStrategy;
    }
    shouldLayoutClipPath(_ref2) {
        let { type: type, target: { clipPath: clipPath } } = _ref2;
        return type !== $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_INITIALIZATION && clipPath && !clipPath.absolutePositioned;
    }
    getInitialSize(context, result) {
        return result.size;
    }
    /**
   * Override this method to customize layout.
   */ calcBoundingBox(objects, context) {
        const { type: type, target: target } = context;
        if (type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_IMPERATIVE && context.overrides) return context.overrides;
        if (objects.length === 0) return;
        const { left: left, top: top, width: width, height: height } = $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints(objects.map((object)=>$ab3f2a5cc6216ae5$var$getObjectBounds(target, object)).reduce((coords, curr)=>coords.concat(curr), []));
        const bboxSize = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(width, height);
        const bboxLeftTop = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(left, top);
        const bboxCenter = bboxLeftTop.add(bboxSize.scalarDivide(2));
        if (type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_INITIALIZATION) {
            const actualSize = this.getInitialSize(context, {
                size: bboxSize,
                center: bboxCenter
            });
            return {
                // in `initialization` we do not account for target's transformation matrix
                center: bboxCenter,
                // TODO: investigate if this is still necessary
                relativeCorrection: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(0, 0),
                size: actualSize
            };
        } else {
            //  we send `relativeCenter` up to group's containing plane
            const center = bboxCenter.transform(target.calcOwnMatrix());
            return {
                center: center,
                size: bboxSize
            };
        }
    }
}
/**
 * override by subclass for persistence (TS does not support `static abstract`)
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$f7b260234c293505, "type", "strategy");
/**
 * Layout will adjust the bounding box to fit target's objects.
 */ class $ab3f2a5cc6216ae5$export$36cf2cf6e71f4d55 extends $ab3f2a5cc6216ae5$export$f7b260234c293505 {
    /**
   * @override layout on all triggers
   * Override at will
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shouldPerformLayout(context) {
        return true;
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$36cf2cf6e71f4d55, "type", "fit-content");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$36cf2cf6e71f4d55);
const $ab3f2a5cc6216ae5$var$_excluded$b = [
    "strategy"
], $ab3f2a5cc6216ae5$var$_excluded2$3 = [
    "target",
    "strategy",
    "bubbles",
    "prevStrategy"
];
const $ab3f2a5cc6216ae5$var$LAYOUT_MANAGER = "layoutManager";
class $ab3f2a5cc6216ae5$export$4a04ad01c410b415 {
    constructor(){
        let strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new $ab3f2a5cc6216ae5$export$36cf2cf6e71f4d55();
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "strategy", void 0);
        this.strategy = strategy;
        this._subscriptions = new Map();
    }
    performLayout(context) {
        const strictContext = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({
            bubbles: true,
            strategy: this.strategy
        }, context), {}, {
            prevStrategy: this._prevLayoutStrategy,
            stopPropagation () {
                this.bubbles = false;
            }
        });
        this.onBeforeLayout(strictContext);
        const layoutResult = this.getLayoutResult(strictContext);
        if (layoutResult) this.commitLayout(strictContext, layoutResult);
        this.onAfterLayout(strictContext, layoutResult);
        this._prevLayoutStrategy = strictContext.strategy;
    }
    /**
   * Attach handlers for events that we know will invalidate the layout when
   * performed on child objects ( general transforms ).
   * Returns the disposers for later unsubscribing and cleanup
   * @param {FabricObject} object
   * @param {RegistrationContext & Partial<StrictLayoutContext>} context
   * @returns {VoidFunction[]} disposers remove the handlers
   */ attachHandlers(object, context) {
        const { target: target } = context;
        return [
            $ab3f2a5cc6216ae5$var$MODIFIED,
            $ab3f2a5cc6216ae5$var$MOVING,
            $ab3f2a5cc6216ae5$var$RESIZING,
            $ab3f2a5cc6216ae5$var$ROTATING,
            $ab3f2a5cc6216ae5$var$SCALING,
            $ab3f2a5cc6216ae5$var$SKEWING,
            $ab3f2a5cc6216ae5$var$CHANGED,
            $ab3f2a5cc6216ae5$var$MODIFY_POLY
        ].map((key)=>object.on(key, (e)=>this.performLayout(key === $ab3f2a5cc6216ae5$var$MODIFIED ? {
                    type: $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_OBJECT_MODIFIED,
                    trigger: key,
                    e: e,
                    target: target
                } : {
                    type: $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_OBJECT_MODIFYING,
                    trigger: key,
                    e: e,
                    target: target
                })));
    }
    /**
   * Subscribe an object to transform events that will trigger a layout change on the parent
   * This is important only for interactive groups.
   * @param object
   * @param context
   */ subscribe(object, context) {
        this.unsubscribe(object, context);
        const disposers = this.attachHandlers(object, context);
        this._subscriptions.set(object, disposers);
    }
    /**
   * unsubscribe object layout triggers
   */ unsubscribe(object, context) {
        (this._subscriptions.get(object) || []).forEach((d)=>d());
        this._subscriptions.delete(object);
    }
    unsubscribeTargets(context) {
        context.targets.forEach((object)=>this.unsubscribe(object, context));
    }
    subscribeTargets(context) {
        context.targets.forEach((object)=>this.subscribe(object, context));
    }
    onBeforeLayout(context) {
        const { target: target, type: type } = context;
        const { canvas: canvas } = target;
        // handle layout triggers subscription
        // @TODO: gate the registration when the group is interactive
        if (type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_INITIALIZATION || type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_ADDED) this.subscribeTargets(context);
        else if (type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_REMOVED) this.unsubscribeTargets(context);
        // fire layout event (event will fire only for layouts after initialization layout)
        target.fire("layout:before", {
            context: context
        });
        canvas && canvas.fire("object:layout:before", {
            target: target,
            context: context
        });
        if (type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_IMPERATIVE && context.deep) {
            const tricklingContext = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(context, $ab3f2a5cc6216ae5$var$_excluded$b);
            // traverse the tree
            target.forEachObject((object)=>object.layoutManager && object.layoutManager.performLayout($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, tricklingContext), {}, {
                    bubbles: false,
                    target: object
                })));
        }
    }
    getLayoutResult(context) {
        const { target: target, strategy: strategy, type: type } = context;
        const result = strategy.calcLayoutResult(context, target.getObjects());
        if (!result) return;
        const prevCenter = type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_INITIALIZATION ? new $ab3f2a5cc6216ae5$export$baf26146a414f24a() : target.getRelativeCenterPoint();
        const { center: nextCenter, correction: correction = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(), relativeCorrection: relativeCorrection = new $ab3f2a5cc6216ae5$export$baf26146a414f24a() } = result;
        const offset = prevCenter.subtract(nextCenter).add(correction).transform(// in `initialization` we do not account for target's transformation matrix
        type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_INITIALIZATION ? $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0 : $ab3f2a5cc6216ae5$var$invertTransform(target.calcOwnMatrix()), true).add(relativeCorrection);
        return {
            result: result,
            prevCenter: prevCenter,
            nextCenter: nextCenter,
            offset: offset
        };
    }
    commitLayout(context, layoutResult) {
        const { target: target } = context;
        const { result: { size: size }, nextCenter: nextCenter } = layoutResult;
        // set dimensions
        target.set({
            width: size.x,
            height: size.y
        });
        // layout descendants
        this.layoutObjects(context, layoutResult);
        //  set position
        // in `initialization` we do not account for target's transformation matrix
        if (context.type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_INITIALIZATION) {
            var _context$x, _context$y;
            // TODO: what about strokeWidth?
            target.set({
                left: (_context$x = context.x) !== null && _context$x !== void 0 ? _context$x : nextCenter.x + size.x * $ab3f2a5cc6216ae5$var$resolveOrigin(target.originX),
                top: (_context$y = context.y) !== null && _context$y !== void 0 ? _context$y : nextCenter.y + size.y * $ab3f2a5cc6216ae5$var$resolveOrigin(target.originY)
            });
        } else {
            target.setPositionByOrigin(nextCenter, $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER);
            // invalidate
            target.setCoords();
            target.set("dirty", true);
        }
    }
    layoutObjects(context, layoutResult) {
        const { target: target } = context;
        //  adjust objects to account for new center
        target.forEachObject((object)=>{
            object.group === target && this.layoutObject(context, layoutResult, object);
        });
        // adjust clip path to account for new center
        context.strategy.shouldLayoutClipPath(context) && this.layoutObject(context, layoutResult, target.clipPath);
    }
    /**
   * @param {FabricObject} object
   * @param {Point} offset
   */ layoutObject(context, _ref, object) {
        let { offset: offset } = _ref;
        // TODO: this is here for cache invalidation.
        // verify if this is necessary since we have explicit
        // cache invalidation at the end of commitLayout
        object.set({
            left: object.left + offset.x,
            top: object.top + offset.y
        });
    }
    onAfterLayout(context, layoutResult) {
        const { target: target, strategy: strategy, bubbles: bubbles, prevStrategy: _ } = context, bubblingContext = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(context, $ab3f2a5cc6216ae5$var$_excluded2$3);
        const { canvas: canvas } = target;
        //  fire layout event (event will fire only for layouts after initialization layout)
        target.fire("layout:after", {
            context: context,
            result: layoutResult
        });
        canvas && canvas.fire("object:layout:after", {
            context: context,
            result: layoutResult,
            target: target
        });
        //  bubble
        const parent = target.parent;
        if (bubbles && parent !== null && parent !== void 0 && parent.layoutManager) {
            //  add target to context#path
            (bubblingContext.path || (bubblingContext.path = [])).push(target);
            //  all parents should invalidate their layout
            parent.layoutManager.performLayout($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, bubblingContext), {}, {
                target: parent
            }));
        }
        target.set("dirty", true);
    }
    dispose() {
        const { _subscriptions: _subscriptions } = this;
        _subscriptions.forEach((disposers)=>disposers.forEach((d)=>d()));
        _subscriptions.clear();
    }
    toObject() {
        return {
            type: $ab3f2a5cc6216ae5$var$LAYOUT_MANAGER,
            strategy: this.strategy.constructor.type
        };
    }
    toJSON() {
        return this.toObject();
    }
}
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$4a04ad01c410b415, $ab3f2a5cc6216ae5$var$LAYOUT_MANAGER);
const $ab3f2a5cc6216ae5$var$_excluded$a = [
    "type",
    "objects",
    "layoutManager"
];
/**
 * This class handles the specific case of creating a group using {@link Group#fromObject} and is not meant to be used in any other case.
 * We could have used a boolean in the constructor, as we did previously, but we think the boolean
 * would stay in the group's constructor interface and create confusion, therefore it was removed.
 * This layout manager doesn't do anything and therefore keeps the exact layout the group had when {@link Group#toObject} was called.
 */ class $ab3f2a5cc6216ae5$var$NoopLayoutManager extends $ab3f2a5cc6216ae5$export$4a04ad01c410b415 {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    performLayout() {}
}
const $ab3f2a5cc6216ae5$var$groupDefaultValues = {
    strokeWidth: 0,
    subTargetCheck: false,
    interactive: false
};
/**
 * @fires object:added
 * @fires object:removed
 * @fires layout:before
 * @fires layout:after
 */ class $ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4 extends $ab3f2a5cc6216ae5$export$f589b6d5b7ad4722($ab3f2a5cc6216ae5$export$5a5fba7eea6847b1) {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4.ownDefaults);
    }
    /**
   * Constructor
   *
   * @param {FabricObject[]} [objects] instance objects
   * @param {Object} [options] Options object
   */ constructor(){
        let objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        /**
     * Used to optimize performance
     * set to `false` if you don't need contained objects to be targets of events
     * @default
     * @type boolean
     */ /**
     * Used to allow targeting of object inside groups.
     * set to true if you want to select an object inside a group.\
     * **REQUIRES** `subTargetCheck` set to true
     * This will be not removed but slowly replaced with a method setInteractive
     * that will take care of enabling subTargetCheck and necessary object events.
     * There is too much attached to group interactivity to just be evaluated by a
     * boolean in the code
     * @default
     * @deprecated
     * @type boolean
     */ /**
     * Used internally to optimize performance
     * Once an object is selected, instance is rendered without the selected object.
     * This way instance is cached only once for the entire interaction with the selected object.
     * @private
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_activeObjects", []);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "__objectSelectionTracker", void 0);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "__objectSelectionDisposer", void 0);
        Object.assign(this, $ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4.ownDefaults);
        this.setOptions(options);
        this.groupInit(objects, options);
    }
    /**
   * Shared code between group and active selection
   * Meant to be used by the constructor.
   */ groupInit(objects, options) {
        var _options$layoutManage;
        this._objects = [
            ...objects
        ]; // Avoid unwanted mutations of Collection to affect the caller
        this.__objectSelectionTracker = this.__objectSelectionMonitor.bind(this, true);
        this.__objectSelectionDisposer = this.__objectSelectionMonitor.bind(this, false);
        this.forEachObject((object)=>{
            this.enterGroup(object, false);
        });
        // perform initial layout
        this.layoutManager = (_options$layoutManage = options.layoutManager) !== null && _options$layoutManage !== void 0 ? _options$layoutManage : new $ab3f2a5cc6216ae5$export$4a04ad01c410b415();
        this.layoutManager.performLayout({
            type: $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_INITIALIZATION,
            target: this,
            targets: [
                ...objects
            ],
            // @TODO remove this concept from the layout manager.
            // Layout manager will calculate the correct position,
            // group options can override it later.
            x: options.left,
            y: options.top
        });
    }
    /**
   * Checks if object can enter group and logs relevant warnings
   * @private
   * @param {FabricObject} object
   * @returns
   */ canEnterGroup(object) {
        if (object === this || this.isDescendantOf(object)) {
            //  prevent circular object tree
            $ab3f2a5cc6216ae5$var$log("error", "Group: circular object trees are not supported, this call has no effect");
            return false;
        } else if (this._objects.indexOf(object) !== -1) {
            // is already in the objects array
            $ab3f2a5cc6216ae5$var$log("error", "Group: duplicate objects are not supported inside group, this call has no effect");
            return false;
        }
        return true;
    }
    /**
   * Override this method to enhance performance (for groups with a lot of objects).
   * If Overriding, be sure not pass illegal objects to group - it will break your app.
   * @private
   */ _filterObjectsBeforeEnteringGroup(objects) {
        return objects.filter((object, index, array)=>{
            // can enter AND is the first occurrence of the object in the passed args (to prevent adding duplicates)
            return this.canEnterGroup(object) && array.indexOf(object) === index;
        });
    }
    /**
   * Add objects
   * @param {...FabricObject[]} objects
   */ add() {
        for(var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++)objects[_key] = arguments[_key];
        const allowedObjects = this._filterObjectsBeforeEnteringGroup(objects);
        const size = super.add(...allowedObjects);
        this._onAfterObjectsChange($ab3f2a5cc6216ae5$var$LAYOUT_TYPE_ADDED, allowedObjects);
        return size;
    }
    /**
   * Inserts an object into collection at specified index
   * @param {FabricObject[]} objects Object to insert
   * @param {Number} index Index to insert object at
   */ insertAt(index) {
        for(var _len2 = arguments.length, objects = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)objects[_key2 - 1] = arguments[_key2];
        const allowedObjects = this._filterObjectsBeforeEnteringGroup(objects);
        const size = super.insertAt(index, ...allowedObjects);
        this._onAfterObjectsChange($ab3f2a5cc6216ae5$var$LAYOUT_TYPE_ADDED, allowedObjects);
        return size;
    }
    /**
   * Remove objects
   * @param {...FabricObject[]} objects
   * @returns {FabricObject[]} removed objects
   */ remove() {
        const removed = super.remove(...arguments);
        this._onAfterObjectsChange($ab3f2a5cc6216ae5$var$LAYOUT_TYPE_REMOVED, removed);
        return removed;
    }
    _onObjectAdded(object) {
        this.enterGroup(object, true);
        this.fire("object:added", {
            target: object
        });
        object.fire("added", {
            target: this
        });
    }
    /**
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
   */ _onObjectRemoved(object, removeParentTransform) {
        this.exitGroup(object, removeParentTransform);
        this.fire("object:removed", {
            target: object
        });
        object.fire("removed", {
            target: this
        });
    }
    /**
   * @private
   * @param {'added'|'removed'} type
   * @param {FabricObject[]} targets
   */ _onAfterObjectsChange(type, targets) {
        this.layoutManager.performLayout({
            type: type,
            targets: targets,
            target: this
        });
    }
    _onStackOrderChanged() {
        this._set("dirty", true);
    }
    /**
   * @private
   * @param {string} key
   * @param {*} value
   */ _set(key, value) {
        const prev = this[key];
        super._set(key, value);
        if (key === "canvas" && prev !== value) (this._objects || []).forEach((object)=>{
            object._set(key, value);
        });
        return this;
    }
    /**
   * @private
   */ _shouldSetNestedCoords() {
        return this.subTargetCheck;
    }
    /**
   * Remove all objects
   * @returns {FabricObject[]} removed objects
   */ removeAll() {
        this._activeObjects = [];
        return this.remove(...this._objects);
    }
    /**
   * keeps track of the selected objects
   * @private
   */ __objectSelectionMonitor(selected, _ref) {
        let { target: object } = _ref;
        const activeObjects = this._activeObjects;
        if (selected) {
            activeObjects.push(object);
            this._set("dirty", true);
        } else if (activeObjects.length > 0) {
            const index = activeObjects.indexOf(object);
            if (index > -1) {
                activeObjects.splice(index, 1);
                this._set("dirty", true);
            }
        }
    }
    /**
   * @private
   * @param {boolean} watch
   * @param {FabricObject} object
   */ _watchObject(watch, object) {
        //  make sure we listen only once
        watch && this._watchObject(false, object);
        if (watch) {
            object.on("selected", this.__objectSelectionTracker);
            object.on("deselected", this.__objectSelectionDisposer);
        } else {
            object.off("selected", this.__objectSelectionTracker);
            object.off("deselected", this.__objectSelectionDisposer);
        }
    }
    /**
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
   */ enterGroup(object, removeParentTransform) {
        object.group && object.group.remove(object);
        object._set("parent", this);
        this._enterGroup(object, removeParentTransform);
    }
    /**
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
   */ _enterGroup(object, removeParentTransform) {
        if (removeParentTransform) // can this be converted to utils (sendObjectToPlane)?
        $ab3f2a5cc6216ae5$var$applyTransformToObject(object, $ab3f2a5cc6216ae5$var$multiplyTransformMatrices($ab3f2a5cc6216ae5$var$invertTransform(this.calcTransformMatrix()), object.calcTransformMatrix()));
        this._shouldSetNestedCoords() && object.setCoords();
        object._set("group", this);
        object._set("canvas", this.canvas);
        this._watchObject(true, object);
        const activeObject = this.canvas && this.canvas.getActiveObject && this.canvas.getActiveObject();
        // if we are adding the activeObject in a group
        if (activeObject && (activeObject === object || object.isDescendantOf(activeObject))) this._activeObjects.push(object);
    }
    /**
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
   */ exitGroup(object, removeParentTransform) {
        this._exitGroup(object, removeParentTransform);
        object._set("parent", undefined);
        object._set("canvas", undefined);
    }
    /**
   * Executes the inner fabric logic of exiting a group.
   * - Stop watching the object
   * - Remove the object from the optimization map this._activeObjects
   * - unset the group property of the object
   * @protected
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
   */ _exitGroup(object, removeParentTransform) {
        object._set("group", undefined);
        if (!removeParentTransform) {
            $ab3f2a5cc6216ae5$var$applyTransformToObject(object, $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(this.calcTransformMatrix(), object.calcTransformMatrix()));
            object.setCoords();
        }
        this._watchObject(false, object);
        const index = this._activeObjects.length > 0 ? this._activeObjects.indexOf(object) : -1;
        if (index > -1) this._activeObjects.splice(index, 1);
    }
    /**
   * Decide if the object should cache or not. Create its own cache level
   * needsItsOwnCache should be used when the object drawing method requires
   * a cache step. None of the fabric classes requires it.
   * Generally you do not cache objects in groups because the group is already cached.
   * @return {Boolean}
   */ shouldCache() {
        const ownCache = $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1.prototype.shouldCache.call(this);
        if (ownCache) {
            for(let i = 0; i < this._objects.length; i++)if (this._objects[i].willDrawShadow()) {
                this.ownCaching = false;
                return false;
            }
        }
        return ownCache;
    }
    /**
   * Check if this object or a child object will cast a shadow
   * @return {Boolean}
   */ willDrawShadow() {
        if (super.willDrawShadow()) return true;
        for(let i = 0; i < this._objects.length; i++){
            if (this._objects[i].willDrawShadow()) return true;
        }
        return false;
    }
    /**
   * Check if instance or its group are caching, recursively up
   * @return {Boolean}
   */ isOnACache() {
        return this.ownCaching || !!this.parent && this.parent.isOnACache();
    }
    /**
   * Execute the drawing operation for an object on a specified context
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ drawObject(ctx) {
        this._renderBackground(ctx);
        for(let i = 0; i < this._objects.length; i++){
            var _this$canvas;
            // TODO: handle rendering edge case somehow
            if ((_this$canvas = this.canvas) !== null && _this$canvas !== void 0 && _this$canvas.preserveObjectStacking && this._objects[i].group !== this) {
                ctx.save();
                ctx.transform(...$ab3f2a5cc6216ae5$var$invertTransform(this.calcTransformMatrix()));
                this._objects[i].render(ctx);
                ctx.restore();
            } else if (this._objects[i].group === this) this._objects[i].render(ctx);
        }
        this._drawClipPath(ctx, this.clipPath);
    }
    /**
   * @override
   * @return {Boolean}
   */ setCoords() {
        super.setCoords();
        this._shouldSetNestedCoords() && this.forEachObject((object)=>object.setCoords());
    }
    triggerLayout() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.layoutManager.performLayout($ab3f2a5cc6216ae5$var$_objectSpread2({
            target: this,
            type: $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_IMPERATIVE
        }, options));
    }
    /**
   * Renders instance on a given context
   * @param {CanvasRenderingContext2D} ctx context to render instance on
   */ render(ctx) {
        this._transformDone = true;
        super.render(ctx);
        this._transformDone = false;
    }
    /**
   *
   * @private
   * @param {'toObject'|'toDatalessObject'} [method]
   * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @returns {FabricObject[]} serialized objects
   */ __serializeObjects(method, propertiesToInclude) {
        const _includeDefaultValues = this.includeDefaultValues;
        return this._objects.filter(function(obj) {
            return !obj.excludeFromExport;
        }).map(function(obj) {
            const originalDefaults = obj.includeDefaultValues;
            obj.includeDefaultValues = _includeDefaultValues;
            const data = obj[method || "toObject"](propertiesToInclude);
            obj.includeDefaultValues = originalDefaults;
            // delete data.version;
            return data;
        });
    }
    /**
   * Returns object representation of an instance
   * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const layoutManager = this.layoutManager.toObject();
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.toObject([
            "subTargetCheck",
            "interactive",
            ...propertiesToInclude
        ])), layoutManager.strategy !== "fit-content" || this.includeDefaultValues ? {
            layoutManager: layoutManager
        } : {}), {}, {
            objects: this.__serializeObjects("toObject", propertiesToInclude)
        });
    }
    toString() {
        return "#<Group: (".concat(this.complexity(), ")>");
    }
    dispose() {
        this.layoutManager.unsubscribeTargets({
            targets: this.getObjects(),
            target: this
        });
        this._activeObjects = [];
        this.forEachObject((object)=>{
            this._watchObject(false, object);
            object.dispose();
        });
        super.dispose();
    }
    /**
   * @private
   */ _createSVGBgRect(reviver) {
        if (!this.backgroundColor) return "";
        const fillStroke = $ab3f2a5cc6216ae5$export$c79fc6492f3af13d.prototype._toSVG.call(this);
        const commons = fillStroke.indexOf("COMMON_PARTS");
        fillStroke[commons] = 'for="group" ';
        const markup = fillStroke.join("");
        return reviver ? reviver(markup) : markup;
    }
    /**
   * Returns svg representation of an instance
   * @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
   * @return {String} svg representation of an instance
   */ _toSVG(reviver) {
        const svgString = [
            "<g ",
            "COMMON_PARTS",
            " >\n"
        ];
        const bg = this._createSVGBgRect(reviver);
        bg && svgString.push("		", bg);
        for(let i = 0; i < this._objects.length; i++)svgString.push("		", this._objects[i].toSVG(reviver));
        svgString.push("</g>\n");
        return svgString;
    }
    /**
   * Returns styles-string for svg-export, specific version for group
   * @return {String}
   */ getSvgStyles() {
        const opacity = typeof this.opacity !== "undefined" && this.opacity !== 1 ? "opacity: ".concat(this.opacity, ";") : "", visibility = this.visible ? "" : " visibility: hidden;";
        return [
            opacity,
            this.getSvgFilter(),
            visibility
        ].join("");
    }
    /**
   * Returns svg clipPath representation of an instance
   * @param {Function} [reviver] Method for further parsing of svg representation.
   * @return {String} svg representation of an instance
   */ toClipPathSVG(reviver) {
        const svgString = [];
        const bg = this._createSVGBgRect(reviver);
        bg && svgString.push("	", bg);
        for(let i = 0; i < this._objects.length; i++)svgString.push("	", this._objects[i].toClipPathSVG(reviver));
        return this._createBaseClipPathSVGMarkup(svgString, {
            reviver: reviver
        });
    }
    /**
   * @todo support loading from svg
   * @private
   * @static
   * @memberOf Group
   * @param {Object} object Object to create a group from
   * @returns {Promise<Group>}
   */ static fromObject(_ref2, abortable) {
        let { type: type, objects: objects = [], layoutManager: layoutManager } = _ref2, options = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref2, $ab3f2a5cc6216ae5$var$_excluded$a);
        return Promise.all([
            $ab3f2a5cc6216ae5$var$enlivenObjects(objects, abortable),
            $ab3f2a5cc6216ae5$var$enlivenObjectEnlivables(options, abortable)
        ]).then((_ref3)=>{
            let [objects, hydratedOptions] = _ref3;
            const group = new this(objects, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), hydratedOptions), {}, {
                layoutManager: new $ab3f2a5cc6216ae5$var$NoopLayoutManager()
            }));
            if (layoutManager) {
                const layoutClass = $ab3f2a5cc6216ae5$export$2792378e23a7920c.getClass(layoutManager.type);
                const strategyClass = $ab3f2a5cc6216ae5$export$2792378e23a7920c.getClass(layoutManager.strategy);
                group.layoutManager = new layoutClass(new strategyClass());
            } else group.layoutManager = new $ab3f2a5cc6216ae5$export$4a04ad01c410b415();
            group.layoutManager.subscribeTargets({
                type: $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_INITIALIZATION,
                target: group,
                targets: group.getObjects()
            });
            group.setCoords();
            return group;
        });
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4, "type", "Group");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4, "ownDefaults", $ab3f2a5cc6216ae5$var$groupDefaultValues);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4);
/**
 * TODO experiment with different layout manager and svg results ( fixed fit content )
 * Groups SVG elements (usually those retrieved from SVG document)
 * @static
 * @param {FabricObject[]} elements FabricObject(s) parsed from svg, to group
 * @return {FabricObject | Group}
 */ const $ab3f2a5cc6216ae5$var$groupSVGElements = (elements, options)=>{
    if (elements && elements.length === 1) return elements[0];
    return new $ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4(elements, options);
};
/**
 * Finds the scale for the object source to fit inside the object destination,
 * keeping aspect ratio intact.
 * respect the total allowed area for the cache.
 * @param {TSize} source natural unscaled size of the object
 * @param {TSize} destination natural unscaled size of the object
 * @return {Number} scale factor to apply to source to fit into destination
 */ const $ab3f2a5cc6216ae5$var$findScaleToFit = (source, destination)=>Math.min(destination.width / source.width, destination.height / source.height);
/**
 * Finds the scale for the object source to cover entirely the object destination,
 * keeping aspect ratio intact.
 * respect the total allowed area for the cache.
 * @param {TSize} source natural unscaled size of the object
 * @param {TSize} destination natural unscaled size of the object
 * @return {Number} scale factor to apply to source to cover destination
 */ const $ab3f2a5cc6216ae5$var$findScaleToCover = (source, destination)=>Math.max(destination.width / source.width, destination.height / source.height);
var $ab3f2a5cc6216ae5$var$_templateObject;
/**
 * p for param
 * using "bad naming" here because it makes the regex much easier to read
 */ const $ab3f2a5cc6216ae5$var$p = "(".concat($ab3f2a5cc6216ae5$var$reNum, ")");
const $ab3f2a5cc6216ae5$var$reMoveToCommand = "(M) (?:".concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ?)+");
const $ab3f2a5cc6216ae5$var$reLineCommand = "(L) (?:".concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ?)+");
const $ab3f2a5cc6216ae5$var$reHorizontalLineCommand = "(H) (?:".concat($ab3f2a5cc6216ae5$var$p, " ?)+");
const $ab3f2a5cc6216ae5$var$reVerticalLineCommand = "(V) (?:".concat($ab3f2a5cc6216ae5$var$p, " ?)+");
const $ab3f2a5cc6216ae5$var$reClosePathCommand = String.raw($ab3f2a5cc6216ae5$var$_templateObject || ($ab3f2a5cc6216ae5$var$_templateObject = $ab3f2a5cc6216ae5$var$_taggedTemplateLiteral([
    "(Z)s*"
], [
    "(Z)\\s*"
])));
const $ab3f2a5cc6216ae5$var$reCubicCurveCommand = "(C) (?:".concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ?)+");
const $ab3f2a5cc6216ae5$var$reCubicCurveShortcutCommand = "(S) (?:".concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ?)+");
const $ab3f2a5cc6216ae5$var$reQuadraticCurveCommand = "(Q) (?:".concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ?)+");
const $ab3f2a5cc6216ae5$var$reQuadraticCurveShortcutCommand = "(T) (?:".concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ?)+");
const $ab3f2a5cc6216ae5$var$reArcCommand = "(A) (?:".concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ([01]) ?([01]) ").concat($ab3f2a5cc6216ae5$var$p, " ").concat($ab3f2a5cc6216ae5$var$p, " ?)+");
const $ab3f2a5cc6216ae5$var$rePathCommand = "(?:(?:".concat($ab3f2a5cc6216ae5$var$reMoveToCommand, ")") + "|(?:".concat($ab3f2a5cc6216ae5$var$reLineCommand, ")") + "|(?:".concat($ab3f2a5cc6216ae5$var$reHorizontalLineCommand, ")") + "|(?:".concat($ab3f2a5cc6216ae5$var$reVerticalLineCommand, ")") + "|(?:".concat($ab3f2a5cc6216ae5$var$reClosePathCommand, ")") + "|(?:".concat($ab3f2a5cc6216ae5$var$reCubicCurveCommand, ")") + "|(?:".concat($ab3f2a5cc6216ae5$var$reCubicCurveShortcutCommand, ")") + "|(?:".concat($ab3f2a5cc6216ae5$var$reQuadraticCurveCommand, ")") + "|(?:".concat($ab3f2a5cc6216ae5$var$reQuadraticCurveShortcutCommand, ")") + "|(?:".concat($ab3f2a5cc6216ae5$var$reArcCommand, "))");
/**
 * Commands that may be repeated
 */ const $ab3f2a5cc6216ae5$var$repeatedCommands = {
    m: "l",
    M: "L"
};
/**
 * Convert an arc of a rotated ellipse to a Bezier Curve
 * @param {TRadian} theta1 start of the arc
 * @param {TRadian} theta2 end of the arc
 * @param cosTh cosine of the angle of rotation
 * @param sinTh sine of the angle of rotation
 * @param rx x-axis radius (before rotation)
 * @param ry y-axis radius (before rotation)
 * @param cx1 center x of the ellipse
 * @param cy1 center y of the ellipse
 * @param mT
 * @param fromX starting point of arc x
 * @param fromY starting point of arc y
 */ const $ab3f2a5cc6216ae5$var$segmentToBezier = (theta1, theta2, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY)=>{
    const costh1 = $ab3f2a5cc6216ae5$var$cos(theta1), sinth1 = $ab3f2a5cc6216ae5$var$sin(theta1), costh2 = $ab3f2a5cc6216ae5$var$cos(theta2), sinth2 = $ab3f2a5cc6216ae5$var$sin(theta2), toX = cosTh * rx * costh2 - sinTh * ry * sinth2 + cx1, toY = sinTh * rx * costh2 + cosTh * ry * sinth2 + cy1, cp1X = fromX + mT * (-cosTh * rx * sinth1 - sinTh * ry * costh1), cp1Y = fromY + mT * (-sinTh * rx * sinth1 + cosTh * ry * costh1), cp2X = toX + mT * (cosTh * rx * sinth2 + sinTh * ry * costh2), cp2Y = toY + mT * (sinTh * rx * sinth2 - cosTh * ry * costh2);
    return [
        "C",
        cp1X,
        cp1Y,
        cp2X,
        cp2Y,
        toX,
        toY
    ];
};
/**
 * Adapted from {@link http://dxr.mozilla.org/mozilla-central/source/dom/svg/SVGPathDataParser.cpp}
 * by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
 * http://mozilla.org/MPL/2.0/
 * @param toX
 * @param toY
 * @param rx
 * @param ry
 * @param {number} large 0 or 1 flag
 * @param {number} sweep 0 or 1 flag
 * @param rotateX
 */ const $ab3f2a5cc6216ae5$var$arcToSegments = (toX, toY, rx, ry, large, sweep, rotateX)=>{
    if (rx === 0 || ry === 0) return [];
    let fromX = 0, fromY = 0, root = 0;
    const PI = Math.PI, theta = rotateX * $ab3f2a5cc6216ae5$var$PiBy180, sinTheta = $ab3f2a5cc6216ae5$var$sin(theta), cosTh = $ab3f2a5cc6216ae5$var$cos(theta), px = 0.5 * (-cosTh * toX - sinTheta * toY), py = 0.5 * (-cosTh * toY + sinTheta * toX), rx2 = rx ** 2, ry2 = ry ** 2, py2 = py ** 2, px2 = px ** 2, pl = rx2 * ry2 - rx2 * py2 - ry2 * px2;
    let _rx = Math.abs(rx);
    let _ry = Math.abs(ry);
    if (pl < 0) {
        const s = Math.sqrt(1 - pl / (rx2 * ry2));
        _rx *= s;
        _ry *= s;
    } else root = (large === sweep ? -1 : 1.0) * Math.sqrt(pl / (rx2 * py2 + ry2 * px2));
    const cx = root * _rx * py / _ry, cy = -root * _ry * px / _rx, cx1 = cosTh * cx - sinTheta * cy + toX * 0.5, cy1 = sinTheta * cx + cosTh * cy + toY * 0.5;
    let mTheta = $ab3f2a5cc6216ae5$var$calcVectorAngle(1, 0, (px - cx) / _rx, (py - cy) / _ry);
    let dtheta = $ab3f2a5cc6216ae5$var$calcVectorAngle((px - cx) / _rx, (py - cy) / _ry, (-px - cx) / _rx, (-py - cy) / _ry);
    if (sweep === 0 && dtheta > 0) dtheta -= 2 * PI;
    else if (sweep === 1 && dtheta < 0) dtheta += 2 * PI;
    // Convert into cubic bezier segments <= 90deg
    const segments = Math.ceil(Math.abs(dtheta / PI * 2)), result = new Array(segments), mDelta = dtheta / segments, mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2);
    let th3 = mTheta + mDelta;
    for(let i = 0; i < segments; i++){
        result[i] = $ab3f2a5cc6216ae5$var$segmentToBezier(mTheta, th3, cosTh, sinTheta, _rx, _ry, cx1, cy1, mT, fromX, fromY);
        fromX = result[i][5];
        fromY = result[i][6];
        mTheta = th3;
        th3 += mDelta;
    }
    return result;
};
/**
 * @private
 * Calculate the angle between two vectors
 * @param ux u endpoint x
 * @param uy u endpoint y
 * @param vx v endpoint x
 * @param vy v endpoint y
 */ const $ab3f2a5cc6216ae5$var$calcVectorAngle = (ux, uy, vx, vy)=>{
    const ta = Math.atan2(uy, ux), tb = Math.atan2(vy, vx);
    if (tb >= ta) return tb - ta;
    else return 2 * Math.PI - (ta - tb);
};
// functions for the Cubic beizer
// taken from: https://github.com/konvajs/konva/blob/7.0.5/src/shapes/Path.ts#L350
const $ab3f2a5cc6216ae5$var$CB1 = (t)=>t ** 3;
const $ab3f2a5cc6216ae5$var$CB2 = (t)=>3 * t ** 2 * (1 - t);
const $ab3f2a5cc6216ae5$var$CB3 = (t)=>3 * t * (1 - t) ** 2;
const $ab3f2a5cc6216ae5$var$CB4 = (t)=>(1 - t) ** 3;
/**
 * Calculate bounding box of a cubic Bezier curve
 * Taken from http://jsbin.com/ivomiq/56/edit (no credits available)
 * TODO: can we normalize this with the starting points set at 0 and then translated the bbox?
 * @param {number} begx starting point
 * @param {number} begy
 * @param {number} cp1x first control point
 * @param {number} cp1y
 * @param {number} cp2x second control point
 * @param {number} cp2y
 * @param {number} endx end of bezier
 * @param {number} endy
 * @return {TRectBounds} the rectangular bounds
 */ function $ab3f2a5cc6216ae5$var$getBoundsOfCurve(begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy) {
    let argsString;
    if ($ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.cachesBoundsOfCurve) {
        // eslint-disable-next-line
        argsString = [
            ...arguments
        ].join();
        if ($ab3f2a5cc6216ae5$export$69a3209f1a06c04d.boundsOfCurveCache[argsString]) return $ab3f2a5cc6216ae5$export$69a3209f1a06c04d.boundsOfCurveCache[argsString];
    }
    const sqrt = Math.sqrt, abs = Math.abs, tvalues = [], bounds = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    let b = 6 * begx - 12 * cp1x + 6 * cp2x;
    let a = -3 * begx + 9 * cp1x - 9 * cp2x + 3 * endx;
    let c = 3 * cp1x - 3 * begx;
    for(let i = 0; i < 2; ++i){
        if (i > 0) {
            b = 6 * begy - 12 * cp1y + 6 * cp2y;
            a = -3 * begy + 9 * cp1y - 9 * cp2y + 3 * endy;
            c = 3 * cp1y - 3 * begy;
        }
        if (abs(a) < 1e-12) {
            if (abs(b) < 1e-12) continue;
            const t = -c / b;
            if (0 < t && t < 1) tvalues.push(t);
            continue;
        }
        const b2ac = b * b - 4 * c * a;
        if (b2ac < 0) continue;
        const sqrtb2ac = sqrt(b2ac);
        const t1 = (-b + sqrtb2ac) / (2 * a);
        if (0 < t1 && t1 < 1) tvalues.push(t1);
        const t2 = (-b - sqrtb2ac) / (2 * a);
        if (0 < t2 && t2 < 1) tvalues.push(t2);
    }
    let j = tvalues.length;
    const jlen = j;
    const iterator = $ab3f2a5cc6216ae5$var$getPointOnCubicBezierIterator(begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy);
    while(j--){
        const { x: x, y: y } = iterator(tvalues[j]);
        bounds[0][j] = x;
        bounds[1][j] = y;
    }
    bounds[0][jlen] = begx;
    bounds[1][jlen] = begy;
    bounds[0][jlen + 1] = endx;
    bounds[1][jlen + 1] = endy;
    const result = [
        new $ab3f2a5cc6216ae5$export$baf26146a414f24a(Math.min(...bounds[0]), Math.min(...bounds[1])),
        new $ab3f2a5cc6216ae5$export$baf26146a414f24a(Math.max(...bounds[0]), Math.max(...bounds[1]))
    ];
    if ($ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.cachesBoundsOfCurve) $ab3f2a5cc6216ae5$export$69a3209f1a06c04d.boundsOfCurveCache[argsString] = result;
    return result;
}
/**
 * Converts arc to a bunch of cubic Bezier curves
 * @param {number} fx starting point x
 * @param {number} fy starting point y
 * @param {TParsedArcCommand} coords Arc command
 */ const $ab3f2a5cc6216ae5$var$fromArcToBeziers = (fx, fy, _ref)=>{
    let [_, rx, ry, rot, large, sweep, tx, ty] = _ref;
    const segsNorm = $ab3f2a5cc6216ae5$var$arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);
    for(let i = 0, len = segsNorm.length; i < len; i++){
        segsNorm[i][1] += fx;
        segsNorm[i][2] += fy;
        segsNorm[i][3] += fx;
        segsNorm[i][4] += fy;
        segsNorm[i][5] += fx;
        segsNorm[i][6] += fy;
    }
    return segsNorm;
};
/**
 * This function takes a parsed SVG path and makes it simpler for fabricJS logic.
 * Simplification consist of:
 * - All commands converted to absolute (lowercase to uppercase)
 * - S converted to C
 * - T converted to Q
 * - A converted to C
 * @param {TComplexPathData} path the array of commands of a parsed SVG path for `Path`
 * @return {TSimplePathData} the simplified array of commands of a parsed SVG path for `Path`
 * TODO: figure out how to remove the type assertions in a nice way
 */ const $ab3f2a5cc6216ae5$var$makePathSimpler = (path)=>{
    // x and y represent the last point of the path, AKA the previous command point.
    // we add them to each relative command to make it an absolute comment.
    // we also swap the v V h H with L, because are easier to transform.
    let x = 0, y = 0;
    // x1 and y1 represent the last point of the subpath. the subpath is started with
    // m or M command. When a z or Z command is drawn, x and y need to be resetted to
    // the last x1 and y1.
    let x1 = 0, y1 = 0;
    // previous will host the letter of the previous command, to handle S and T.
    // controlX and controlY will host the previous reflected control point
    const destinationPath = [];
    let previous, // placeholders
    controlX = 0, controlY = 0;
    for (const parsedCommand of path){
        const current = [
            ...parsedCommand
        ];
        let converted;
        switch(current[0] // first letter
        ){
            case "l":
                // lineto, relative
                current[1] += x;
                current[2] += y;
            // falls through
            case "L":
                x = current[1];
                y = current[2];
                converted = [
                    "L",
                    x,
                    y
                ];
                break;
            case "h":
                // horizontal lineto, relative
                current[1] += x;
            // falls through
            case "H":
                x = current[1];
                converted = [
                    "L",
                    x,
                    y
                ];
                break;
            case "v":
                // vertical lineto, relative
                current[1] += y;
            // falls through
            case "V":
                y = current[1];
                converted = [
                    "L",
                    x,
                    y
                ];
                break;
            case "m":
                // moveTo, relative
                current[1] += x;
                current[2] += y;
            // falls through
            case "M":
                x = current[1];
                y = current[2];
                x1 = current[1];
                y1 = current[2];
                converted = [
                    "M",
                    x,
                    y
                ];
                break;
            case "c":
                // bezierCurveTo, relative
                current[1] += x;
                current[2] += y;
                current[3] += x;
                current[4] += y;
                current[5] += x;
                current[6] += y;
            // falls through
            case "C":
                controlX = current[3];
                controlY = current[4];
                x = current[5];
                y = current[6];
                converted = [
                    "C",
                    current[1],
                    current[2],
                    controlX,
                    controlY,
                    x,
                    y
                ];
                break;
            case "s":
                // shorthand cubic bezierCurveTo, relative
                current[1] += x;
                current[2] += y;
                current[3] += x;
                current[4] += y;
            // falls through
            case "S":
                // would be sScC but since we are swapping sSc for C, we check just that.
                if (previous === "C") {
                    // calculate reflection of previous control points
                    controlX = 2 * x - controlX;
                    controlY = 2 * y - controlY;
                } else {
                    // If there is no previous command or if the previous command was not a C, c, S, or s,
                    // the control point is coincident with the current point
                    controlX = x;
                    controlY = y;
                }
                x = current[3];
                y = current[4];
                converted = [
                    "C",
                    controlX,
                    controlY,
                    current[1],
                    current[2],
                    x,
                    y
                ];
                // converted[3] and converted[4] are NOW the second control point.
                // we keep it for the next reflection.
                controlX = converted[3];
                controlY = converted[4];
                break;
            case "q":
                // quadraticCurveTo, relative
                current[1] += x;
                current[2] += y;
                current[3] += x;
                current[4] += y;
            // falls through
            case "Q":
                controlX = current[1];
                controlY = current[2];
                x = current[3];
                y = current[4];
                converted = [
                    "Q",
                    controlX,
                    controlY,
                    x,
                    y
                ];
                break;
            case "t":
                // shorthand quadraticCurveTo, relative
                current[1] += x;
                current[2] += y;
            // falls through
            case "T":
                if (previous === "Q") {
                    // calculate reflection of previous control point
                    controlX = 2 * x - controlX;
                    controlY = 2 * y - controlY;
                } else {
                    // If there is no previous command or if the previous command was not a Q, q, T or t,
                    // assume the control point is coincident with the current point
                    controlX = x;
                    controlY = y;
                }
                x = current[1];
                y = current[2];
                converted = [
                    "Q",
                    controlX,
                    controlY,
                    x,
                    y
                ];
                break;
            case "a":
                current[6] += x;
                current[7] += y;
            // falls through
            case "A":
                $ab3f2a5cc6216ae5$var$fromArcToBeziers(x, y, current).forEach((b)=>destinationPath.push(b));
                x = current[6];
                y = current[7];
                break;
            case "z":
            case "Z":
                x = x1;
                y = y1;
                converted = [
                    "Z"
                ];
                break;
        }
        if (converted) {
            destinationPath.push(converted);
            previous = converted[0];
        } else previous = "";
    }
    return destinationPath;
};
// todo verify if we can just use the point class here
/**
 * Calc length from point x1,y1 to x2,y2
 * @param {number} x1 starting point x
 * @param {number} y1 starting point y
 * @param {number} x2 starting point x
 * @param {number} y2 starting point y
 * @return {number} length of segment
 */ const $ab3f2a5cc6216ae5$var$calcLineLength = (x1, y1, x2, y2)=>Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
/**
 * Get an iterator that takes a percentage and returns a point
 * @param {number} begx
 * @param {number} begy
 * @param {number} cp1x
 * @param {number} cp1y
 * @param {number} cp2x
 * @param {number} cp2y
 * @param {number} endx
 * @param {number} endy
 */ const $ab3f2a5cc6216ae5$var$getPointOnCubicBezierIterator = (begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy)=>(pct)=>{
        const c1 = $ab3f2a5cc6216ae5$var$CB1(pct), c2 = $ab3f2a5cc6216ae5$var$CB2(pct), c3 = $ab3f2a5cc6216ae5$var$CB3(pct), c4 = $ab3f2a5cc6216ae5$var$CB4(pct);
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(endx * c1 + cp2x * c2 + cp1x * c3 + begx * c4, endy * c1 + cp2y * c2 + cp1y * c3 + begy * c4);
    };
const $ab3f2a5cc6216ae5$var$QB1 = (t)=>t ** 2;
const $ab3f2a5cc6216ae5$var$QB2 = (t)=>2 * t * (1 - t);
const $ab3f2a5cc6216ae5$var$QB3 = (t)=>(1 - t) ** 2;
const $ab3f2a5cc6216ae5$var$getTangentCubicIterator = (p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y)=>(pct)=>{
        const qb1 = $ab3f2a5cc6216ae5$var$QB1(pct), qb2 = $ab3f2a5cc6216ae5$var$QB2(pct), qb3 = $ab3f2a5cc6216ae5$var$QB3(pct), tangentX = 3 * (qb3 * (p2x - p1x) + qb2 * (p3x - p2x) + qb1 * (p4x - p3x)), tangentY = 3 * (qb3 * (p2y - p1y) + qb2 * (p3y - p2y) + qb1 * (p4y - p3y));
        return Math.atan2(tangentY, tangentX);
    };
const $ab3f2a5cc6216ae5$var$getPointOnQuadraticBezierIterator = (p1x, p1y, p2x, p2y, p3x, p3y)=>(pct)=>{
        const c1 = $ab3f2a5cc6216ae5$var$QB1(pct), c2 = $ab3f2a5cc6216ae5$var$QB2(pct), c3 = $ab3f2a5cc6216ae5$var$QB3(pct);
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(p3x * c1 + p2x * c2 + p1x * c3, p3y * c1 + p2y * c2 + p1y * c3);
    };
const $ab3f2a5cc6216ae5$var$getTangentQuadraticIterator = (p1x, p1y, p2x, p2y, p3x, p3y)=>(pct)=>{
        const invT = 1 - pct, tangentX = 2 * (invT * (p2x - p1x) + pct * (p3x - p2x)), tangentY = 2 * (invT * (p2y - p1y) + pct * (p3y - p2y));
        return Math.atan2(tangentY, tangentX);
    };
// this will run over a path segment (a cubic or quadratic segment) and approximate it
// with 100 segments. This will good enough to calculate the length of the curve
const $ab3f2a5cc6216ae5$var$pathIterator = (iterator, x1, y1)=>{
    let tempP = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(x1, y1), tmpLen = 0;
    for(let perc = 1; perc <= 100; perc += 1){
        const p = iterator(perc / 100);
        tmpLen += $ab3f2a5cc6216ae5$var$calcLineLength(tempP.x, tempP.y, p.x, p.y);
        tempP = p;
    }
    return tmpLen;
};
/**
 * Given a pathInfo, and a distance in pixels, find the percentage from 0 to 1
 * that correspond to that pixels run over the path.
 * The percentage will be then used to find the correct point on the canvas for the path.
 * @param {Array} segInfo fabricJS collection of information on a parsed path
 * @param {number} distance from starting point, in pixels.
 * @return {TPointAngle} info object with x and y ( the point on canvas ) and angle, the tangent on that point;
 */ const $ab3f2a5cc6216ae5$var$findPercentageForDistance = (segInfo, distance)=>{
    let perc = 0, tmpLen = 0, tempP = {
        x: segInfo.x,
        y: segInfo.y
    }, p = $ab3f2a5cc6216ae5$var$_objectSpread2({}, tempP), nextLen, nextStep = 0.01, lastPerc = 0;
    // nextStep > 0.0001 covers 0.00015625 that 1/64th of 1/100
    // the path
    const iterator = segInfo.iterator, angleFinder = segInfo.angleFinder;
    while(tmpLen < distance && nextStep > 0.0001){
        p = iterator(perc);
        lastPerc = perc;
        nextLen = $ab3f2a5cc6216ae5$var$calcLineLength(tempP.x, tempP.y, p.x, p.y);
        // compare tmpLen each cycle with distance, decide next perc to test.
        if (nextLen + tmpLen > distance) {
            // we discard this step and we make smaller steps.
            perc -= nextStep;
            nextStep /= 2;
        } else {
            tempP = p;
            perc += nextStep;
            tmpLen += nextLen;
        }
    }
    return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, p), {}, {
        angle: angleFinder(lastPerc)
    });
};
/**
 * Run over a parsed and simplified path and extract some information (length of each command and starting point)
 * @param {TSimplePathData} path parsed path commands
 * @return {TPathSegmentInfo[]} path commands information
 */ const $ab3f2a5cc6216ae5$var$getPathSegmentsInfo = (path)=>{
    let totalLength = 0, //x2 and y2 are the coords of segment start
    //x1 and y1 are the coords of the current point
    x1 = 0, y1 = 0, x2 = 0, y2 = 0, iterator, tempInfo;
    const info = [];
    for (const current of path){
        const basicInfo = {
            x: x1,
            y: y1,
            command: current[0],
            length: 0
        };
        switch(current[0] //first letter
        ){
            case "M":
                tempInfo = basicInfo;
                tempInfo.x = x2 = x1 = current[1];
                tempInfo.y = y2 = y1 = current[2];
                break;
            case "L":
                tempInfo = basicInfo;
                tempInfo.length = $ab3f2a5cc6216ae5$var$calcLineLength(x1, y1, current[1], current[2]);
                x1 = current[1];
                y1 = current[2];
                break;
            case "C":
                iterator = $ab3f2a5cc6216ae5$var$getPointOnCubicBezierIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
                tempInfo = basicInfo;
                tempInfo.iterator = iterator;
                tempInfo.angleFinder = $ab3f2a5cc6216ae5$var$getTangentCubicIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
                tempInfo.length = $ab3f2a5cc6216ae5$var$pathIterator(iterator, x1, y1);
                x1 = current[5];
                y1 = current[6];
                break;
            case "Q":
                iterator = $ab3f2a5cc6216ae5$var$getPointOnQuadraticBezierIterator(x1, y1, current[1], current[2], current[3], current[4]);
                tempInfo = basicInfo;
                tempInfo.iterator = iterator;
                tempInfo.angleFinder = $ab3f2a5cc6216ae5$var$getTangentQuadraticIterator(x1, y1, current[1], current[2], current[3], current[4]);
                tempInfo.length = $ab3f2a5cc6216ae5$var$pathIterator(iterator, x1, y1);
                x1 = current[3];
                y1 = current[4];
                break;
            case "Z":
                // we add those in order to ease calculations later
                tempInfo = basicInfo;
                tempInfo.destX = x2;
                tempInfo.destY = y2;
                tempInfo.length = $ab3f2a5cc6216ae5$var$calcLineLength(x1, y1, x2, y2);
                x1 = x2;
                y1 = y2;
                break;
        }
        totalLength += tempInfo.length;
        info.push(tempInfo);
    }
    info.push({
        length: totalLength,
        x: x1,
        y: y1
    });
    return info;
};
/**
 * Get the point on the path that is distance along the path
 * @param path
 * @param distance
 * @param infos
 */ const $ab3f2a5cc6216ae5$var$getPointOnPath = function(path, distance) {
    let infos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ab3f2a5cc6216ae5$var$getPathSegmentsInfo(path);
    let i = 0;
    while(distance - infos[i].length > 0 && i < infos.length - 2){
        distance -= infos[i].length;
        i++;
    }
    const segInfo = infos[i], segPercent = distance / segInfo.length, segment = path[i];
    switch(segInfo.command){
        case "M":
            return {
                x: segInfo.x,
                y: segInfo.y,
                angle: 0
            };
        case "Z":
            return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, new $ab3f2a5cc6216ae5$export$baf26146a414f24a(segInfo.x, segInfo.y).lerp(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(segInfo.destX, segInfo.destY), segPercent)), {}, {
                angle: Math.atan2(segInfo.destY - segInfo.y, segInfo.destX - segInfo.x)
            });
        case "L":
            return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, new $ab3f2a5cc6216ae5$export$baf26146a414f24a(segInfo.x, segInfo.y).lerp(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(segment[1], segment[2]), segPercent)), {}, {
                angle: Math.atan2(segment[2] - segInfo.y, segment[1] - segInfo.x)
            });
        case "C":
            return $ab3f2a5cc6216ae5$var$findPercentageForDistance(segInfo, distance);
        case "Q":
            return $ab3f2a5cc6216ae5$var$findPercentageForDistance(segInfo, distance);
    }
};
const $ab3f2a5cc6216ae5$var$rePathCmdAll = new RegExp($ab3f2a5cc6216ae5$var$rePathCommand, "gi");
const $ab3f2a5cc6216ae5$var$rePathCmd = new RegExp($ab3f2a5cc6216ae5$var$rePathCommand, "i");
/**
 *
 * @param {string} pathString
 * @return {TComplexPathData} An array of SVG path commands
 * @example <caption>Usage</caption>
 * parsePath('M 3 4 Q 3 5 2 1 4 0 Q 9 12 2 1 4 0') === [
 *   ['M', 3, 4],
 *   ['Q', 3, 5, 2, 1, 4, 0],
 *   ['Q', 9, 12, 2, 1, 4, 0],
 * ];
 *
 */ const $ab3f2a5cc6216ae5$var$parsePath = (pathString)=>{
    // clean the string
    // add spaces around the numbers
    pathString = $ab3f2a5cc6216ae5$var$cleanupSvgAttribute(pathString);
    const res = [];
    for (let [matchStr] of pathString.matchAll($ab3f2a5cc6216ae5$var$rePathCmdAll)){
        const chain = [];
        let paramArr;
        do {
            paramArr = $ab3f2a5cc6216ae5$var$rePathCmd.exec(matchStr);
            if (!paramArr) break;
            // ignore undefined match groups
            const filteredGroups = paramArr.filter((g)=>g);
            // remove the first element from the match array since it's just the whole command
            filteredGroups.shift();
            // if we can't parse the number, just interpret it as a string
            // (since it's probably the path command)
            const command = filteredGroups.map((g)=>{
                const numParse = Number.parseFloat(g);
                if (Number.isNaN(numParse)) return g;
                else return numParse;
            });
            chain.push(command);
            // stop now if it's a z command
            if (filteredGroups.length <= 1) break;
            // remove the last part of the chained command
            filteredGroups.shift();
            // ` ?` is to support commands with optional spaces between flags
            matchStr = matchStr.replace(new RegExp("".concat(filteredGroups.join(" ?"), " ?$")), "");
        }while (paramArr);
        // add the chain, convert multiple m's to l's in the process
        chain.reverse().forEach((c, idx)=>{
            const transformed = $ab3f2a5cc6216ae5$var$repeatedCommands[c[0]];
            if (idx > 0 && (transformed == "l" || transformed == "L")) c[0] = transformed;
            res.push(c);
        });
    }
    return res;
};
/**
 *
 * Converts points to a smooth SVG path
 * @param {XY[]} points Array of points
 * @param {number} [correction] Apply a correction to the path (usually we use `width / 1000`). If value is undefined 0 is used as the correction value.
 * @return {(string|number)[][]} An array of SVG path commands
 */ const $ab3f2a5cc6216ae5$var$getSmoothPathFromPoints = function(points) {
    let correction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let p1 = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(points[0]), p2 = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(points[1]), multSignX = 1, multSignY = 0;
    const path = [], len = points.length, manyPoints = len > 2;
    if (manyPoints) {
        multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
        multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
    }
    path.push([
        "M",
        p1.x - multSignX * correction,
        p1.y - multSignY * correction
    ]);
    let i;
    for(i = 1; i < len; i++){
        if (!p1.eq(p2)) {
            const midPoint = p1.midPointFrom(p2);
            // p1 is our bezier control point
            // midpoint is our endpoint
            // start point is p(i-1) value.
            path.push([
                "Q",
                p1.x,
                p1.y,
                midPoint.x,
                midPoint.y
            ]);
        }
        p1 = points[i];
        if (i + 1 < points.length) p2 = points[i + 1];
    }
    if (manyPoints) {
        multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
        multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
    }
    path.push([
        "L",
        p1.x + multSignX * correction,
        p1.y + multSignY * correction
    ]);
    return path;
};
/**
 * Transform a path by transforming each segment.
 * it has to be a simplified path or it won't work.
 * WARNING: this depends from pathOffset for correct operation
 * @param {TSimplePathData} path fabricJS parsed and simplified path commands
 * @param {TMat2D} transform matrix that represent the transformation
 * @param {Point} [pathOffset] `Path.pathOffset`
 * @returns {TSimplePathData} the transformed path
 */ const $ab3f2a5cc6216ae5$var$transformPath = (path, transform, pathOffset)=>{
    if (pathOffset) transform = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(transform, [
        1,
        0,
        0,
        1,
        -pathOffset.x,
        -pathOffset.y
    ]);
    return path.map((pathSegment)=>{
        const newSegment = [
            ...pathSegment
        ];
        for(let i = 1; i < pathSegment.length - 1; i += 2){
            // TODO: is there a way to get around casting to any?
            const { x: x, y: y } = $ab3f2a5cc6216ae5$var$transformPoint({
                x: pathSegment[i],
                y: pathSegment[i + 1]
            }, transform);
            newSegment[i] = x;
            newSegment[i + 1] = y;
        }
        return newSegment;
    });
};
/**
 * Returns an array of path commands to create a regular polygon
 * @param {number} numVertexes
 * @param {number} radius
 * @returns {TSimplePathData} An array of SVG path commands
 */ const $ab3f2a5cc6216ae5$var$getRegularPolygonPath = (numVertexes, radius)=>{
    const interiorAngle = Math.PI * 2 / numVertexes;
    // rotationAdjustment rotates the path by 1/2 the interior angle so that the polygon always has a flat side on the bottom
    // This isn't strictly necessary, but it's how we tend to think of and expect polygons to be drawn
    let rotationAdjustment = -$ab3f2a5cc6216ae5$var$halfPI;
    if (numVertexes % 2 === 0) rotationAdjustment += interiorAngle / 2;
    const d = new Array(numVertexes + 1);
    for(let i = 0; i < numVertexes; i++){
        const rad = i * interiorAngle + rotationAdjustment;
        const { x: x, y: y } = new $ab3f2a5cc6216ae5$export$baf26146a414f24a($ab3f2a5cc6216ae5$var$cos(rad), $ab3f2a5cc6216ae5$var$sin(rad)).scalarMultiply(radius);
        d[i] = [
            i === 0 ? "M" : "L",
            x,
            y
        ];
    }
    d[numVertexes] = [
        "Z"
    ];
    return d;
};
/**
 * Join path commands to go back to svg format
 * @param {TSimplePathData} pathData fabricJS parsed path commands
 * @param {number} fractionDigits number of fraction digits to "leave"
 * @return {String} joined path 'M 0 0 L 20 30'
 */ const $ab3f2a5cc6216ae5$var$joinPath = (pathData, fractionDigits)=>pathData.map((segment)=>{
        return segment.map((arg, i)=>{
            if (i === 0) return arg;
            return fractionDigits === undefined ? arg : $ab3f2a5cc6216ae5$var$toFixed(arg, fractionDigits);
        }).join(" ");
    }).join(" ");
/**
 * Merges 2 clip paths into one visually equal clip path
 *
 * **IMPORTANT**:\
 * Does **NOT** clone the arguments, clone them proir if necessary.
 *
 * Creates a wrapper (group) that contains one clip path and is clipped by the other so content is kept where both overlap.
 * Use this method if both the clip paths may have nested clip paths of their own, so assigning one to the other's clip path property is not possible.
 *
 * In order to handle the `inverted` property we follow logic described in the following cases:\
 * **(1)** both clip paths are inverted - the clip paths pass the inverted prop to the wrapper and loose it themselves.\
 * **(2)** one is inverted and the other isn't - the wrapper shouldn't become inverted and the inverted clip path must clip the non inverted one to produce an identical visual effect.\
 * **(3)** both clip paths are not inverted - wrapper and clip paths remain unchanged.
 *
 * @memberOf fabric.util
 * @param {fabric.Object} c1
 * @param {fabric.Object} c2
 * @returns {fabric.Object} merged clip path
 */ const $ab3f2a5cc6216ae5$var$mergeClipPaths = (c1, c2)=>{
    var _b$group;
    let a = c1, b = c2;
    if (a.inverted && !b.inverted) {
        //  case (2)
        a = c2;
        b = c1;
    }
    //  `b` becomes `a`'s clip path so we transform `b` to `a` coordinate plane
    $ab3f2a5cc6216ae5$var$sendObjectToPlane(b, (_b$group = b.group) === null || _b$group === void 0 ? void 0 : _b$group.calcTransformMatrix(), a.calcTransformMatrix());
    //  assign the `inverted` prop to the wrapping group
    const inverted = a.inverted && b.inverted;
    if (inverted) //  case (1)
    a.inverted = b.inverted = false;
    return new $ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4([
        a
    ], {
        clipPath: b,
        inverted: inverted
    });
};
/**
 * Cross-browser abstraction for sending XMLHttpRequest
 * @deprecated this has to go away, we can use a modern browser method to do the same.
 * @param {String} url URL to send XMLHttpRequest to
 * @param {Object} [options] Options object
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 * @param {Function} options.onComplete Callback to invoke when request is completed
 * @return {XMLHttpRequest} request
 */ function $ab3f2a5cc6216ae5$var$request(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const onComplete = options.onComplete || $ab3f2a5cc6216ae5$var$noop, xhr = new ($ab3f2a5cc6216ae5$export$4a3a3142573970c3()).XMLHttpRequest(), signal = options.signal, abort = function() {
        xhr.abort();
    }, removeListener = function() {
        signal && signal.removeEventListener("abort", abort);
        xhr.onerror = xhr.ontimeout = $ab3f2a5cc6216ae5$var$noop;
    };
    if (signal && signal.aborted) throw new $ab3f2a5cc6216ae5$var$SignalAbortedError("request");
    else if (signal) signal.addEventListener("abort", abort, {
        once: true
    });
    /** @ignore */ xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
            removeListener();
            onComplete(xhr);
            xhr.onreadystatechange = $ab3f2a5cc6216ae5$var$noop;
        }
    };
    xhr.onerror = xhr.ontimeout = removeListener;
    xhr.open("get", url, true);
    xhr.send();
    return xhr;
}
/**
 * This function is an helper for svg import. it decompose the transformMatrix
 * and assign properties to object.
 * untransformed coordinates
 * @private
 */ const $ab3f2a5cc6216ae5$var$_assignTransformMatrixProps = (object)=>{
    if (object.transformMatrix) {
        const { scaleX: scaleX, scaleY: scaleY, angle: angle, skewX: skewX } = $ab3f2a5cc6216ae5$var$qrDecompose(object.transformMatrix);
        object.flipX = false;
        object.flipY = false;
        object.set($ab3f2a5cc6216ae5$var$SCALE_X, scaleX);
        object.set($ab3f2a5cc6216ae5$var$SCALE_Y, scaleY);
        object.angle = angle;
        object.skewX = skewX;
        object.skewY = 0;
    }
};
/**
 * This function is an helper for svg import. it removes the transform matrix
 * and set to object properties that fabricjs can handle
 * @private
 * @param {Object} preserveAspectRatioOptions
 */ const $ab3f2a5cc6216ae5$var$removeTransformMatrixForSvgParsing = (object, preserveAspectRatioOptions)=>{
    let center = object._findCenterFromElement();
    if (object.transformMatrix) {
        $ab3f2a5cc6216ae5$var$_assignTransformMatrixProps(object);
        center = center.transform(object.transformMatrix);
    }
    delete object.transformMatrix;
    if (preserveAspectRatioOptions) {
        object.scaleX *= preserveAspectRatioOptions.scaleX;
        object.scaleY *= preserveAspectRatioOptions.scaleY;
        object.cropX = preserveAspectRatioOptions.cropX;
        object.cropY = preserveAspectRatioOptions.cropY;
        center.x += preserveAspectRatioOptions.offsetLeft;
        center.y += preserveAspectRatioOptions.offsetTop;
        object.width = preserveAspectRatioOptions.width;
        object.height = preserveAspectRatioOptions.height;
    }
    object.setPositionByOrigin(center, $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER);
};
var $ab3f2a5cc6216ae5$export$7debb50ef11d5e0b = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    addTransformToObject: $ab3f2a5cc6216ae5$var$addTransformToObject,
    animate: $ab3f2a5cc6216ae5$var$animate,
    animateColor: $ab3f2a5cc6216ae5$var$animateColor,
    applyTransformToObject: $ab3f2a5cc6216ae5$var$applyTransformToObject,
    calcAngleBetweenVectors: $ab3f2a5cc6216ae5$var$calcAngleBetweenVectors,
    calcDimensionsMatrix: $ab3f2a5cc6216ae5$var$calcDimensionsMatrix,
    calcPlaneChangeMatrix: $ab3f2a5cc6216ae5$var$calcPlaneChangeMatrix,
    calcVectorRotation: $ab3f2a5cc6216ae5$var$calcVectorRotation,
    cancelAnimFrame: $ab3f2a5cc6216ae5$var$cancelAnimFrame,
    capValue: $ab3f2a5cc6216ae5$var$capValue,
    composeMatrix: $ab3f2a5cc6216ae5$var$composeMatrix,
    copyCanvasElement: $ab3f2a5cc6216ae5$var$copyCanvasElement,
    cos: $ab3f2a5cc6216ae5$var$cos,
    createCanvasElement: $ab3f2a5cc6216ae5$var$createCanvasElement,
    createImage: $ab3f2a5cc6216ae5$var$createImage,
    createRotateMatrix: $ab3f2a5cc6216ae5$var$createRotateMatrix,
    createScaleMatrix: $ab3f2a5cc6216ae5$var$createScaleMatrix,
    createSkewXMatrix: $ab3f2a5cc6216ae5$var$createSkewXMatrix,
    createSkewYMatrix: $ab3f2a5cc6216ae5$var$createSkewYMatrix,
    createTranslateMatrix: $ab3f2a5cc6216ae5$var$createTranslateMatrix,
    createVector: $ab3f2a5cc6216ae5$var$createVector,
    crossProduct: $ab3f2a5cc6216ae5$var$crossProduct,
    degreesToRadians: $ab3f2a5cc6216ae5$var$degreesToRadians,
    dotProduct: $ab3f2a5cc6216ae5$var$dotProduct,
    ease: $ab3f2a5cc6216ae5$var$easing,
    enlivenObjectEnlivables: $ab3f2a5cc6216ae5$var$enlivenObjectEnlivables,
    enlivenObjects: $ab3f2a5cc6216ae5$var$enlivenObjects,
    findScaleToCover: $ab3f2a5cc6216ae5$var$findScaleToCover,
    findScaleToFit: $ab3f2a5cc6216ae5$var$findScaleToFit,
    getBoundsOfCurve: $ab3f2a5cc6216ae5$var$getBoundsOfCurve,
    getOrthonormalVector: $ab3f2a5cc6216ae5$var$getOrthonormalVector,
    getPathSegmentsInfo: $ab3f2a5cc6216ae5$var$getPathSegmentsInfo,
    getPointOnPath: $ab3f2a5cc6216ae5$var$getPointOnPath,
    getPointer: $ab3f2a5cc6216ae5$var$getPointer,
    getRandomInt: $ab3f2a5cc6216ae5$var$getRandomInt,
    getRegularPolygonPath: $ab3f2a5cc6216ae5$var$getRegularPolygonPath,
    getSmoothPathFromPoints: $ab3f2a5cc6216ae5$var$getSmoothPathFromPoints,
    getSvgAttributes: $ab3f2a5cc6216ae5$var$getSvgAttributes,
    getUnitVector: $ab3f2a5cc6216ae5$var$getUnitVector,
    groupSVGElements: $ab3f2a5cc6216ae5$var$groupSVGElements,
    hasStyleChanged: $ab3f2a5cc6216ae5$var$hasStyleChanged,
    invertTransform: $ab3f2a5cc6216ae5$var$invertTransform,
    isBetweenVectors: $ab3f2a5cc6216ae5$var$isBetweenVectors,
    isIdentityMatrix: $ab3f2a5cc6216ae5$var$isIdentityMatrix,
    isTouchEvent: $ab3f2a5cc6216ae5$var$isTouchEvent,
    isTransparent: $ab3f2a5cc6216ae5$var$isTransparent,
    joinPath: $ab3f2a5cc6216ae5$var$joinPath,
    loadImage: $ab3f2a5cc6216ae5$var$loadImage,
    magnitude: $ab3f2a5cc6216ae5$var$magnitude,
    makeBoundingBoxFromPoints: $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints,
    makePathSimpler: $ab3f2a5cc6216ae5$var$makePathSimpler,
    matrixToSVG: $ab3f2a5cc6216ae5$var$matrixToSVG,
    mergeClipPaths: $ab3f2a5cc6216ae5$var$mergeClipPaths,
    multiplyTransformMatrices: $ab3f2a5cc6216ae5$var$multiplyTransformMatrices,
    multiplyTransformMatrixArray: $ab3f2a5cc6216ae5$var$multiplyTransformMatrixArray,
    parsePath: $ab3f2a5cc6216ae5$var$parsePath,
    parsePreserveAspectRatioAttribute: $ab3f2a5cc6216ae5$var$parsePreserveAspectRatioAttribute,
    parseUnit: $ab3f2a5cc6216ae5$var$parseUnit,
    pick: $ab3f2a5cc6216ae5$var$pick,
    projectStrokeOnPoints: $ab3f2a5cc6216ae5$var$projectStrokeOnPoints,
    qrDecompose: $ab3f2a5cc6216ae5$var$qrDecompose,
    radiansToDegrees: $ab3f2a5cc6216ae5$var$radiansToDegrees,
    removeFromArray: $ab3f2a5cc6216ae5$var$removeFromArray,
    removeTransformFromObject: $ab3f2a5cc6216ae5$var$removeTransformFromObject,
    removeTransformMatrixForSvgParsing: $ab3f2a5cc6216ae5$var$removeTransformMatrixForSvgParsing,
    request: $ab3f2a5cc6216ae5$var$request,
    requestAnimFrame: $ab3f2a5cc6216ae5$var$requestAnimFrame,
    resetObjectTransform: $ab3f2a5cc6216ae5$var$resetObjectTransform,
    rotatePoint: $ab3f2a5cc6216ae5$var$rotatePoint,
    rotateVector: $ab3f2a5cc6216ae5$var$rotateVector,
    saveObjectTransform: $ab3f2a5cc6216ae5$var$saveObjectTransform,
    sendObjectToPlane: $ab3f2a5cc6216ae5$var$sendObjectToPlane,
    sendPointToPlane: $ab3f2a5cc6216ae5$var$sendPointToPlane,
    sendVectorToPlane: $ab3f2a5cc6216ae5$var$sendVectorToPlane,
    setStyle: $ab3f2a5cc6216ae5$var$setStyle,
    sin: $ab3f2a5cc6216ae5$var$sin,
    sizeAfterTransform: $ab3f2a5cc6216ae5$var$sizeAfterTransform,
    string: $ab3f2a5cc6216ae5$var$lang_string,
    stylesFromArray: $ab3f2a5cc6216ae5$var$stylesFromArray,
    stylesToArray: $ab3f2a5cc6216ae5$var$stylesToArray,
    toDataURL: $ab3f2a5cc6216ae5$var$toDataURL,
    toFixed: $ab3f2a5cc6216ae5$var$toFixed,
    transformPath: $ab3f2a5cc6216ae5$var$transformPath,
    transformPoint: $ab3f2a5cc6216ae5$var$transformPoint
});
class $ab3f2a5cc6216ae5$export$fc395a588fa002d0 extends $ab3f2a5cc6216ae5$export$cf489a44e232c033 {
    constructor(arg0){
        let { allowTouchScrolling: allowTouchScrolling = false, containerClass: containerClass = "" } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(arg0);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "upper", void 0);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "container", void 0);
        const { el: lowerCanvasEl } = this.lower;
        const upperCanvasEl = this.createUpperCanvas();
        this.upper = {
            el: upperCanvasEl,
            ctx: upperCanvasEl.getContext("2d")
        };
        this.applyCanvasStyle(lowerCanvasEl, {
            allowTouchScrolling: allowTouchScrolling
        });
        this.applyCanvasStyle(upperCanvasEl, {
            allowTouchScrolling: allowTouchScrolling
        });
        const container = this.createContainerElement();
        container.classList.add(containerClass);
        if (lowerCanvasEl.parentNode) lowerCanvasEl.parentNode.replaceChild(container, lowerCanvasEl);
        container.append(lowerCanvasEl, upperCanvasEl);
        this.container = container;
    }
    createUpperCanvas() {
        const { el: lowerCanvasEl } = this.lower;
        const el = $ab3f2a5cc6216ae5$var$createCanvasElement();
        // we assign the same classname of the lowerCanvas
        el.className = lowerCanvasEl.className;
        // but then we remove the lower-canvas specific className
        el.classList.remove("lower-canvas");
        // we add the specific upper-canvas class
        el.classList.add("upper-canvas");
        el.setAttribute("data-fabric", "top");
        el.style.cssText = lowerCanvasEl.style.cssText;
        el.setAttribute("draggable", "true");
        return el;
    }
    createContainerElement() {
        const container = $ab3f2a5cc6216ae5$export$91e93c41e950ddbb().createElement("div");
        container.setAttribute("data-fabric", "wrapper");
        $ab3f2a5cc6216ae5$var$setStyle(container, {
            position: "relative"
        });
        $ab3f2a5cc6216ae5$var$makeElementUnselectable(container);
        return container;
    }
    /**
   * @private
   * @param {HTMLCanvasElement} element canvas element to apply styles on
   */ applyCanvasStyle(element, _ref) {
        let { allowTouchScrolling: allow } = _ref;
        $ab3f2a5cc6216ae5$var$setStyle(element, {
            position: "absolute",
            left: "0",
            top: "0"
        });
        $ab3f2a5cc6216ae5$var$allowTouchScrolling(element, allow);
        $ab3f2a5cc6216ae5$var$makeElementUnselectable(element);
    }
    setDimensions(size, retinaScaling) {
        super.setDimensions(size, retinaScaling);
        const { el: el, ctx: ctx } = this.upper;
        $ab3f2a5cc6216ae5$var$setCanvasDimensions(el, ctx, size, retinaScaling);
    }
    setCSSDimensions(size) {
        super.setCSSDimensions(size);
        $ab3f2a5cc6216ae5$var$setCSSDimensions(this.upper.el, size);
        $ab3f2a5cc6216ae5$var$setCSSDimensions(this.container, size);
    }
    cleanupDOM(size) {
        const container = this.container, { el: lowerCanvasEl } = this.lower, { el: upperCanvasEl } = this.upper;
        super.cleanupDOM(size);
        container.removeChild(upperCanvasEl);
        container.removeChild(lowerCanvasEl);
        if (container.parentNode) container.parentNode.replaceChild(lowerCanvasEl, container);
    }
    dispose() {
        super.dispose();
        $ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e().dispose(this.upper.el);
        // @ts-expect-error disposing
        delete this.upper;
        // @ts-expect-error disposing
        delete this.container;
    }
}
const $ab3f2a5cc6216ae5$var$canvasDefaults = {
    uniformScaling: true,
    uniScaleKey: "shiftKey",
    centeredScaling: false,
    centeredRotation: false,
    centeredKey: "altKey",
    altActionKey: "shiftKey",
    selection: true,
    selectionKey: "shiftKey",
    selectionColor: "rgba(100, 100, 255, 0.3)",
    selectionDashArray: [],
    selectionBorderColor: "rgba(255, 255, 255, 0.3)",
    selectionLineWidth: 1,
    selectionFullyContained: false,
    hoverCursor: "move",
    moveCursor: "move",
    defaultCursor: "default",
    freeDrawingCursor: "crosshair",
    notAllowedCursor: "not-allowed",
    perPixelTargetFind: false,
    targetFindTolerance: 0,
    skipTargetFind: false,
    stopContextMenu: false,
    fireRightClick: false,
    fireMiddleClick: false,
    enablePointerEvents: false,
    containerClass: "canvas-container",
    preserveObjectStacking: false
};
/**
 * Canvas class
 * @class Canvas
 * @extends StaticCanvas
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#canvas}
 *
 * @fires object:modified at the end of a transform
 * @fires object:rotating while an object is being rotated from the control
 * @fires object:scaling while an object is being scaled by controls
 * @fires object:moving while an object is being dragged
 * @fires object:skewing while an object is being skewed from the controls
 *
 * @fires before:transform before a transform is is started
 * @fires before:selection:cleared
 * @fires selection:cleared
 * @fires selection:updated
 * @fires selection:created
 *
 * @fires path:created after a drawing operation ends and the path is added
 * @fires mouse:down
 * @fires mouse:move
 * @fires mouse:up
 * @fires mouse:down:before  on mouse down, before the inner fabric logic runs
 * @fires mouse:move:before on mouse move, before the inner fabric logic runs
 * @fires mouse:up:before on mouse up, before the inner fabric logic runs
 * @fires mouse:over
 * @fires mouse:out
 * @fires mouse:dblclick whenever a native dbl click event fires on the canvas.
 *
 * @fires dragover
 * @fires dragenter
 * @fires dragleave
 * @fires drag:enter object drag enter
 * @fires drag:leave object drag leave
 * @fires drop:before before drop event. Prepare for the drop event (same native event).
 * @fires drop
 * @fires drop:after after drop event. Run logic on canvas after event has been accepted/declined (same native event).
 * @example
 * let a: fabric.Object, b: fabric.Object;
 * let flag = false;
 * canvas.add(a, b);
 * a.on('drop:before', opt => {
 *  //  we want a to accept the drop even though it's below b in the stack
 *  flag = this.canDrop(opt.e);
 * });
 * b.canDrop = function(e) {
 *  !flag && this.draggableTextDelegate.canDrop(e);
 * }
 * b.on('dragover', opt => b.set('fill', opt.dropTarget === b ? 'pink' : 'black'));
 * a.on('drop', opt => {
 *  opt.e.defaultPrevented  //  drop occurred
 *  opt.didDrop             //  drop occurred on canvas
 *  opt.target              //  drop target
 *  opt.target !== a && a.set('text', 'I lost');
 * });
 * canvas.on('drop:after', opt => {
 *  //  inform user who won
 *  if(!opt.e.defaultPrevented) {
 *    // no winners
 *  }
 *  else if(!opt.didDrop) {
 *    //  my objects didn't win, some other lucky object
 *  }
 *  else {
 *    //  we have a winner it's opt.target!!
 *  }
 * })
 *
 * @fires after:render at the end of the render process, receives the context in the callback
 * @fires before:render at start the render process, receives the context in the callback
 *
 * @fires contextmenu:before
 * @fires contextmenu
 * @example
 * let handler;
 * targets.forEach(target => {
 *   target.on('contextmenu:before', opt => {
 *     //  decide which target should handle the event before canvas hijacks it
 *     if (someCaseHappens && opt.targets.includes(target)) {
 *       handler = target;
 *     }
 *   });
 *   target.on('contextmenu', opt => {
 *     //  do something fantastic
 *   });
 * });
 * canvas.on('contextmenu', opt => {
 *   if (!handler) {
 *     //  no one takes responsibility, it's always left to me
 *     //  let's show them how it's done!
 *   }
 * });
 *
 */ class $ab3f2a5cc6216ae5$var$SelectableCanvas extends $ab3f2a5cc6216ae5$export$ad01921fb0b1386e {
    constructor(){
        super(...arguments);
        // transform config
        // selection config
        // cursors
        // target find config
        /**
     * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
     * After mousedown, mousemove creates a shape,
     * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
     * @type Boolean
     * @default
     */ // event config
        /**
     * Keep track of the subTargets for Mouse Events, ordered bottom up from innermost nested subTarget
     * @type FabricObject[]
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "targets", []);
        /**
     * hold the list of nested targets hovered
     * @type FabricObject[]
     * @private
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_hoveredTargets", []);
        /**
     * hold the list of objects to render
     * @type FabricObject[]
     * @private
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_objectsToRender", void 0);
        /**
     * hold a reference to a data structure that contains information
     * on the current on going transform
     * @type
     * @private
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_currentTransform", null);
        /**
     * hold a reference to a data structure used to track the selection
     * box on canvas drag
     * on the current on going transform
     * x, y, deltaX and deltaY are in scene plane
     * @type
     * @private
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_groupSelector", null);
        /**
     * internal flag used to understand if the context top requires a cleanup
     * in case this is true, the contextTop will be cleared at the next render
     * @type boolean
     * @private
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "contextTopDirty", false);
    }
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$var$SelectableCanvas.ownDefaults);
    }
    get upperCanvasEl() {
        var _this$elements$upper;
        return (_this$elements$upper = this.elements.upper) === null || _this$elements$upper === void 0 ? void 0 : _this$elements$upper.el;
    }
    get contextTop() {
        var _this$elements$upper2;
        return (_this$elements$upper2 = this.elements.upper) === null || _this$elements$upper2 === void 0 ? void 0 : _this$elements$upper2.ctx;
    }
    get wrapperEl() {
        return this.elements.container;
    }
    initElements(el) {
        this.elements = new $ab3f2a5cc6216ae5$export$fc395a588fa002d0(el, {
            allowTouchScrolling: this.allowTouchScrolling,
            containerClass: this.containerClass
        });
        this._createCacheCanvas();
    }
    /**
   * @private
   * @param {FabricObject} obj Object that was added
   */ _onObjectAdded(obj) {
        this._objectsToRender = undefined;
        super._onObjectAdded(obj);
    }
    /**
   * @private
   * @param {FabricObject} obj Object that was removed
   */ _onObjectRemoved(obj) {
        this._objectsToRender = undefined;
        // removing active object should fire "selection:cleared" events
        if (obj === this._activeObject) {
            this.fire("before:selection:cleared", {
                deselected: [
                    obj
                ]
            });
            this._discardActiveObject();
            this.fire("selection:cleared", {
                deselected: [
                    obj
                ]
            });
            obj.fire("deselected", {
                target: obj
            });
        }
        if (obj === this._hoveredTarget) {
            this._hoveredTarget = undefined;
            this._hoveredTargets = [];
        }
        super._onObjectRemoved(obj);
    }
    _onStackOrderChanged() {
        this._objectsToRender = undefined;
        super._onStackOrderChanged();
    }
    /**
   * Divides objects in two groups, one to render immediately
   * and one to render as activeGroup.
   * @return {Array} objects to render immediately and pushes the other in the activeGroup.
   */ _chooseObjectsToRender() {
        const activeObject = this._activeObject;
        return !this.preserveObjectStacking && activeObject ? this._objects.filter((object)=>!object.group && object !== activeObject).concat(activeObject) : this._objects;
    }
    /**
   * Renders both the top canvas and the secondary container canvas.
   */ renderAll() {
        this.cancelRequestedRender();
        if (this.destroyed) return;
        if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
            this.clearContext(this.contextTop);
            this.contextTopDirty = false;
        }
        if (this.hasLostContext) {
            this.renderTopLayer(this.contextTop);
            this.hasLostContext = false;
        }
        !this._objectsToRender && (this._objectsToRender = this._chooseObjectsToRender());
        this.renderCanvas(this.getContext(), this._objectsToRender);
    }
    /**
   * text selection is rendered by the active text instance during the rendering cycle
   */ renderTopLayer(ctx) {
        ctx.save();
        if (this.isDrawingMode && this._isCurrentlyDrawing) {
            this.freeDrawingBrush && this.freeDrawingBrush._render();
            this.contextTopDirty = true;
        }
        // we render the top context - last object
        if (this.selection && this._groupSelector) {
            this._drawSelection(ctx);
            this.contextTopDirty = true;
        }
        ctx.restore();
    }
    /**
   * Method to render only the top canvas.
   * Also used to render the group selection box.
   * Does not render text selection.
   */ renderTop() {
        const ctx = this.contextTop;
        this.clearContext(ctx);
        this.renderTopLayer(ctx);
        // todo: how do i know if the after:render is for the top or normal contex?
        this.fire("after:render", {
            ctx: ctx
        });
    }
    /**
   * Set the canvas tolerance value for pixel taret find.
   * Use only integer numbers.
   * @private
   */ setTargetFindTolerance(value) {
        value = Math.round(value);
        this.targetFindTolerance = value;
        const retina = this.getRetinaScaling();
        const size = Math.ceil((value * 2 + 1) * retina);
        this.pixelFindCanvasEl.width = this.pixelFindCanvasEl.height = size;
        this.pixelFindContext.scale(retina, retina);
    }
    /**
   * Returns true if object is transparent at a certain location
   * Clarification: this is `is target transparent at location X or are controls there`
   * @TODO this seems dumb that we treat controls with transparency. we can find controls
   * programmatically without painting them, the cache canvas optimization is always valid
   * @param {FabricObject} target Object to check
   * @param {Number} x Left coordinate in viewport space
   * @param {Number} y Top coordinate in viewport space
   * @return {Boolean}
   */ isTargetTransparent(target, x, y) {
        const tolerance = this.targetFindTolerance;
        const ctx = this.pixelFindContext;
        this.clearContext(ctx);
        ctx.save();
        ctx.translate(-x + tolerance, -y + tolerance);
        ctx.transform(...this.viewportTransform);
        const selectionBgc = target.selectionBackgroundColor;
        target.selectionBackgroundColor = "";
        target.render(ctx);
        target.selectionBackgroundColor = selectionBgc;
        ctx.restore();
        // our canvas is square, and made around tolerance.
        // so tolerance in this case also represent the center of the canvas.
        const enhancedTolerance = Math.round(tolerance * this.getRetinaScaling());
        return $ab3f2a5cc6216ae5$var$isTransparent(ctx, enhancedTolerance, enhancedTolerance, enhancedTolerance);
    }
    /**
   * takes an event and determines if selection key has been pressed
   * @private
   * @param {TPointerEvent} e Event object
   */ _isSelectionKeyPressed(e) {
        const sKey = this.selectionKey;
        if (!sKey) return false;
        if (Array.isArray(sKey)) return !!sKey.find((key)=>!!key && e[key] === true);
        else return e[sKey];
    }
    /**
   * @private
   * @param {TPointerEvent} e Event object
   * @param {FabricObject} target
   */ _shouldClearSelection(e, target) {
        const activeObjects = this.getActiveObjects(), activeObject = this._activeObject;
        return !!(!target || target && activeObject && activeObjects.length > 1 && activeObjects.indexOf(target) === -1 && activeObject !== target && !this._isSelectionKeyPressed(e) || target && !target.evented || target && !target.selectable && activeObject && activeObject !== target);
    }
    /**
   * This method will take in consideration a modifier key pressed and the control we are
   * about to drag, and try to guess the anchor point ( origin ) of the transormation.
   * This should be really in the realm of controls, and we should remove specific code for legacy
   * embedded actions.
   * @TODO this probably deserve discussion/rediscovery and change/refactor
   * @private
   * @deprecated
   * @param {FabricObject} target
   * @param {string} action
   * @param {boolean} altKey
   * @returns {boolean} true if the transformation should be centered
   */ _shouldCenterTransform(target, action, modifierKeyPressed) {
        if (!target) return;
        let centerTransform;
        if (action === $ab3f2a5cc6216ae5$var$SCALE || action === $ab3f2a5cc6216ae5$var$SCALE_X || action === $ab3f2a5cc6216ae5$var$SCALE_Y || action === $ab3f2a5cc6216ae5$var$RESIZING) centerTransform = this.centeredScaling || target.centeredScaling;
        else if (action === $ab3f2a5cc6216ae5$var$ROTATE) centerTransform = this.centeredRotation || target.centeredRotation;
        return centerTransform ? !modifierKeyPressed : modifierKeyPressed;
    }
    /**
   * Given the control clicked, determine the origin of the transform.
   * This is bad because controls can totally have custom names
   * should disappear before release 4.0
   * @private
   * @deprecated
   */ _getOriginFromCorner(target, controlName) {
        const origin = {
            x: target.originX,
            y: target.originY
        };
        if (!controlName) return origin;
        // is a left control ?
        if ([
            "ml",
            "tl",
            "bl"
        ].includes(controlName)) origin.x = $ab3f2a5cc6216ae5$var$RIGHT;
        else if ([
            "mr",
            "tr",
            "br"
        ].includes(controlName)) origin.x = $ab3f2a5cc6216ae5$var$LEFT;
        // is a top control ?
        if ([
            "tl",
            "mt",
            "tr"
        ].includes(controlName)) origin.y = $ab3f2a5cc6216ae5$var$BOTTOM;
        else if ([
            "bl",
            "mb",
            "br"
        ].includes(controlName)) origin.y = $ab3f2a5cc6216ae5$var$TOP;
        return origin;
    }
    /**
   * @private
   * @param {Event} e Event object
   * @param {FabricObject} target
   * @param {boolean} [alreadySelected] pass true to setup the active control
   */ _setupCurrentTransform(e, target, alreadySelected) {
        var _control$getActionHan;
        const pointer = target.group ? // transform pointer to target's containing coordinate plane
        $ab3f2a5cc6216ae5$var$sendPointToPlane(this.getScenePoint(e), undefined, target.group.calcTransformMatrix()) : this.getScenePoint(e);
        const { key: corner = "", control: control } = target.getActiveControl() || {}, actionHandler = alreadySelected && control ? (_control$getActionHan = control.getActionHandler(e, target, control)) === null || _control$getActionHan === void 0 ? void 0 : _control$getActionHan.bind(control) : $ab3f2a5cc6216ae5$var$dragHandler, action = $ab3f2a5cc6216ae5$var$getActionFromCorner(alreadySelected, corner, e, target), altKey = e[this.centeredKey], origin = this._shouldCenterTransform(target, action, altKey) ? {
            x: $ab3f2a5cc6216ae5$var$CENTER,
            y: $ab3f2a5cc6216ae5$var$CENTER
        } : this._getOriginFromCorner(target, corner), /**
       * relative to target's containing coordinate plane
       * both agree on every point
       **/ transform = {
            target: target,
            action: action,
            actionHandler: actionHandler,
            actionPerformed: false,
            corner: corner,
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            skewX: target.skewX,
            skewY: target.skewY,
            offsetX: pointer.x - target.left,
            offsetY: pointer.y - target.top,
            originX: origin.x,
            originY: origin.y,
            ex: pointer.x,
            ey: pointer.y,
            lastX: pointer.x,
            lastY: pointer.y,
            theta: $ab3f2a5cc6216ae5$var$degreesToRadians(target.angle),
            width: target.width,
            height: target.height,
            shiftKey: e.shiftKey,
            altKey: altKey,
            original: $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$var$saveObjectTransform(target)), {}, {
                originX: origin.x,
                originY: origin.y
            })
        };
        this._currentTransform = transform;
        this.fire("before:transform", {
            e: e,
            transform: transform
        });
    }
    /**
   * Set the cursor type of the canvas element
   * @param {String} value Cursor type of the canvas element.
   * @see http://www.w3.org/TR/css3-ui/#cursor
   */ setCursor(value) {
        this.upperCanvasEl.style.cursor = value;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx to draw the selection on
   */ _drawSelection(ctx) {
        const { x: x, y: y, deltaX: deltaX, deltaY: deltaY } = this._groupSelector, start = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(x, y).transform(this.viewportTransform), extent = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(x + deltaX, y + deltaY).transform(this.viewportTransform), strokeOffset = this.selectionLineWidth / 2;
        let minX = Math.min(start.x, extent.x), minY = Math.min(start.y, extent.y), maxX = Math.max(start.x, extent.x), maxY = Math.max(start.y, extent.y);
        if (this.selectionColor) {
            ctx.fillStyle = this.selectionColor;
            ctx.fillRect(minX, minY, maxX - minX, maxY - minY);
        }
        if (!this.selectionLineWidth || !this.selectionBorderColor) return;
        ctx.lineWidth = this.selectionLineWidth;
        ctx.strokeStyle = this.selectionBorderColor;
        minX += strokeOffset;
        minY += strokeOffset;
        maxX -= strokeOffset;
        maxY -= strokeOffset;
        // selection border
        // @TODO: is _setLineDash still necessary on modern canvas?
        $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
        ctx.strokeRect(minX, minY, maxX - minX, maxY - minY);
    }
    /**
   * Method that determines what object we are clicking on
   * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
   * or the outside part of the corner.
   * @param {Event} e mouse event
   * @return {FabricObject | null} the target found
   */ findTarget(e) {
        if (this.skipTargetFind) return undefined;
        const pointer = this.getViewportPoint(e), activeObject = this._activeObject, aObjects = this.getActiveObjects();
        this.targets = [];
        if (activeObject && aObjects.length >= 1) {
            if (activeObject.findControl(pointer, $ab3f2a5cc6216ae5$var$isTouchEvent(e))) // if we hit the corner of the active object, let's return that.
            return activeObject;
            else if (aObjects.length > 1 && // check pointer is over active selection and possibly perform `subTargetCheck`
            this.searchPossibleTargets([
                activeObject
            ], pointer)) // active selection does not select sub targets like normal groups
            return activeObject;
            else if (activeObject === this.searchPossibleTargets([
                activeObject
            ], pointer)) {
                // active object is not an active selection
                if (!this.preserveObjectStacking) return activeObject;
                else {
                    const subTargets = this.targets;
                    this.targets = [];
                    const target = this.searchPossibleTargets(this._objects, pointer);
                    if (e[this.altSelectionKey] && target && target !== activeObject) {
                        // alt selection: select active object even though it is not the top most target
                        // restore targets
                        this.targets = subTargets;
                        return activeObject;
                    }
                    return target;
                }
            }
        }
        return this.searchPossibleTargets(this._objects, pointer);
    }
    /**
   * Checks if the point is inside the object selection area including padding
   * @param {FabricObject} obj Object to test against
   * @param {Object} [pointer] point in scene coordinates
   * @return {Boolean} true if point is contained within an area of given object
   * @private
   */ _pointIsInObjectSelectionArea(obj, point) {
        // getCoords will already take care of group de-nesting
        let coords = obj.getCoords();
        const viewportZoom = this.getZoom();
        const padding = obj.padding / viewportZoom;
        if (padding) {
            const [tl, tr, br, bl] = coords;
            // what is the angle of the object?
            // we could use getTotalAngle, but is way easier to look at it
            // from how coords are oriented, since if something went wrong
            // at least we are consistent.
            const angleRadians = Math.atan2(tr.y - tl.y, tr.x - tl.x), cosP = $ab3f2a5cc6216ae5$var$cos(angleRadians) * padding, sinP = $ab3f2a5cc6216ae5$var$sin(angleRadians) * padding, cosPSinP = cosP + sinP, cosPMinusSinP = cosP - sinP;
            coords = [
                new $ab3f2a5cc6216ae5$export$baf26146a414f24a(tl.x - cosPMinusSinP, tl.y - cosPSinP),
                new $ab3f2a5cc6216ae5$export$baf26146a414f24a(tr.x + cosPSinP, tr.y - cosPMinusSinP),
                new $ab3f2a5cc6216ae5$export$baf26146a414f24a(br.x + cosPMinusSinP, br.y + cosPSinP),
                new $ab3f2a5cc6216ae5$export$baf26146a414f24a(bl.x - cosPSinP, bl.y + cosPMinusSinP)
            ];
        // in case of padding we calculate the new coords on the fly.
        // otherwise we have to maintain 2 sets of coordinates for everything.
        // we can reiterate on storing them.
        // if this is slow, for now the semplification is large and doesn't impact
        // rendering.
        // the idea behind this is that outside target check we don't need ot know
        // where those coords are
        }
        return $ab3f2a5cc6216ae5$export$869c896bf338bf5a.isPointInPolygon(point, coords);
    }
    /**
   * Checks point is inside the object selection condition. Either area with padding
   * or over pixels if perPixelTargetFind is enabled
   * @param {FabricObject} obj Object to test against
   * @param {Object} [pointer] point from viewport.
   * @return {Boolean} true if point is contained within an area of given object
   * @private
   */ _checkTarget(obj, pointer) {
        if (obj && obj.visible && obj.evented && this._pointIsInObjectSelectionArea(obj, $ab3f2a5cc6216ae5$var$sendPointToPlane(pointer, undefined, this.viewportTransform))) {
            if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
                if (!this.isTargetTransparent(obj, pointer.x, pointer.y)) return true;
            } else return true;
        }
        return false;
    }
    /**
   * Internal Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
   * @param {Array} [objects] objects array to look into
   * @param {Object} [pointer] x,y object of point coordinates we want to check.
   * @return {FabricObject} **top most object from given `objects`** that contains pointer
   * @private
   */ _searchPossibleTargets(objects, pointer) {
        // Cache all targets where their bounding box contains point.
        let i = objects.length;
        // Do not check for currently grouped objects, since we check the parent group itself.
        // until we call this function specifically to search inside the activeGroup
        while(i--){
            const target = objects[i];
            if (this._checkTarget(target, pointer)) {
                if ($ab3f2a5cc6216ae5$var$isCollection(target) && target.subTargetCheck) {
                    const subTarget = this._searchPossibleTargets(target._objects, pointer);
                    subTarget && this.targets.push(subTarget);
                }
                return target;
            }
        }
    }
    /**
   * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
   * @see {@link _searchPossibleTargets}
   * @param {FabricObject[]} [objects] objects array to look into
   * @param {Point} [pointer] coordinates from viewport to check.
   * @return {FabricObject} **top most object on screen** that contains pointer
   */ searchPossibleTargets(objects, pointer) {
        const target = this._searchPossibleTargets(objects, pointer);
        // if we found something in this.targets, and the group is interactive, return the innermost subTarget
        // that is still interactive
        // TODO: reverify why interactive. the target should be returned always, but selected only
        // if interactive.
        if (target && $ab3f2a5cc6216ae5$var$isCollection(target) && target.interactive && this.targets[0]) {
            /** targets[0] is the innermost nested target, but it could be inside non interactive groups and so not a selection target */ const targets = this.targets;
            for(let i = targets.length - 1; i > 0; i--){
                const t = targets[i];
                if (!($ab3f2a5cc6216ae5$var$isCollection(t) && t.interactive)) // one of the subtargets was not interactive. that is the last subtarget we can return.
                // we can't dig more deep;
                return t;
            }
            return targets[0];
        }
        return target;
    }
    /**
   * @returns point existing in the same plane as the {@link HTMLCanvasElement},
   * `(0, 0)` being the top left corner of the {@link HTMLCanvasElement}.
   * This means that changes to the {@link viewportTransform} do not change the values of the point
   * and it remains unchanged from the viewer's perspective.
   *
   * @example
   * const scenePoint = sendPointToPlane(
   *  this.getViewportPoint(e),
   *  undefined,
   *  canvas.viewportTransform
   * );
   *
   */ getViewportPoint(e) {
        if (this._pointer) return this._pointer;
        return this.getPointer(e, true);
    }
    /**
   * @returns point existing in the scene (the same plane as the plane {@link FabricObject#getCenterPoint} exists in).
   * This means that changes to the {@link viewportTransform} do not change the values of the point,
   * however, from the viewer's perspective, the point is changed.
   *
   * @example
   * const viewportPoint = sendPointToPlane(
   *  this.getScenePoint(e),
   *  canvas.viewportTransform
   * );
   *
   */ getScenePoint(e) {
        if (this._absolutePointer) return this._absolutePointer;
        return this.getPointer(e);
    }
    /**
   * Returns pointer relative to canvas.
   *
   * @deprecated This method is deprecated since v6 to protect you from misuse.
   * Use {@link getViewportPoint} or {@link getScenePoint} instead.
   *
   * @param {Event} e
   * @param {Boolean} [fromViewport] whether to return the point from the viewport or in the scene
   * @return {Point}
   */ getPointer(e) {
        let fromViewport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const upperCanvasEl = this.upperCanvasEl, bounds = upperCanvasEl.getBoundingClientRect();
        let pointer = $ab3f2a5cc6216ae5$var$getPointer(e), boundsWidth = bounds.width || 0, boundsHeight = bounds.height || 0;
        if (!boundsWidth || !boundsHeight) {
            if ($ab3f2a5cc6216ae5$var$TOP in bounds && $ab3f2a5cc6216ae5$var$BOTTOM in bounds) boundsHeight = Math.abs(bounds.top - bounds.bottom);
            if ($ab3f2a5cc6216ae5$var$RIGHT in bounds && $ab3f2a5cc6216ae5$var$LEFT in bounds) boundsWidth = Math.abs(bounds.right - bounds.left);
        }
        this.calcOffset();
        pointer.x = pointer.x - this._offset.left;
        pointer.y = pointer.y - this._offset.top;
        if (!fromViewport) pointer = $ab3f2a5cc6216ae5$var$sendPointToPlane(pointer, undefined, this.viewportTransform);
        const retinaScaling = this.getRetinaScaling();
        if (retinaScaling !== 1) {
            pointer.x /= retinaScaling;
            pointer.y /= retinaScaling;
        }
        // If bounds are not available (i.e. not visible), do not apply scale.
        const cssScale = boundsWidth === 0 || boundsHeight === 0 ? new $ab3f2a5cc6216ae5$export$baf26146a414f24a(1, 1) : new $ab3f2a5cc6216ae5$export$baf26146a414f24a(upperCanvasEl.width / boundsWidth, upperCanvasEl.height / boundsHeight);
        return pointer.multiply(cssScale);
    }
    /**
   * Internal use only
   * @protected
   */ _setDimensionsImpl(dimensions, options) {
        // @ts-expect-error this method exists in the subclass - should be moved or declared as abstract
        this._resetTransformEventData();
        super._setDimensionsImpl(dimensions, options);
        if (this._isCurrentlyDrawing) this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
    }
    _createCacheCanvas() {
        this.pixelFindCanvasEl = $ab3f2a5cc6216ae5$var$createCanvasElement();
        this.pixelFindContext = this.pixelFindCanvasEl.getContext("2d", {
            willReadFrequently: true
        });
        this.setTargetFindTolerance(this.targetFindTolerance);
    }
    /**
   * Returns context of top canvas where interactions are drawn
   * @returns {CanvasRenderingContext2D}
   */ getTopContext() {
        return this.elements.upper.ctx;
    }
    /**
   * Returns context of canvas where object selection is drawn
   * @alias
   * @return {CanvasRenderingContext2D}
   */ getSelectionContext() {
        return this.elements.upper.ctx;
    }
    /**
   * Returns &lt;canvas> element on which object selection is drawn
   * @return {HTMLCanvasElement}
   */ getSelectionElement() {
        return this.elements.upper.el;
    }
    /**
   * Returns currently active object
   * @return {FabricObject | null} active object
   */ getActiveObject() {
        return this._activeObject;
    }
    /**
   * Returns an array with the current selected objects
   * @return {FabricObject[]} active objects array
   */ getActiveObjects() {
        const active = this._activeObject;
        return $ab3f2a5cc6216ae5$var$isActiveSelection(active) ? active.getObjects() : active ? [
            active
        ] : [];
    }
    /**
   * @private
   * Compares the old activeObject with the current one and fires correct events
   * @param {FabricObject[]} oldObjects old activeObject
   * @param {TPointerEvent} e mouse event triggering the selection events
   */ _fireSelectionEvents(oldObjects, e) {
        let somethingChanged = false, invalidate = false;
        const objects = this.getActiveObjects(), added = [], removed = [];
        oldObjects.forEach((target)=>{
            if (!objects.includes(target)) {
                somethingChanged = true;
                target.fire("deselected", {
                    e: e,
                    target: target
                });
                removed.push(target);
            }
        });
        objects.forEach((target)=>{
            if (!oldObjects.includes(target)) {
                somethingChanged = true;
                target.fire("selected", {
                    e: e,
                    target: target
                });
                added.push(target);
            }
        });
        if (oldObjects.length > 0 && objects.length > 0) {
            invalidate = true;
            somethingChanged && this.fire("selection:updated", {
                e: e,
                selected: added,
                deselected: removed
            });
        } else if (objects.length > 0) {
            invalidate = true;
            this.fire("selection:created", {
                e: e,
                selected: added
            });
        } else if (oldObjects.length > 0) {
            invalidate = true;
            this.fire("selection:cleared", {
                e: e,
                deselected: removed
            });
        }
        invalidate && (this._objectsToRender = undefined);
    }
    /**
   * Sets given object as the only active object on canvas
   * @param {FabricObject} object Object to set as an active one
   * @param {TPointerEvent} [e] Event (passed along when firing "object:selected")
   * @return {Boolean} true if the object has been selected
   */ setActiveObject(object, e) {
        // we can't inline this, since _setActiveObject will change what getActiveObjects returns
        const currentActives = this.getActiveObjects();
        const selected = this._setActiveObject(object, e);
        this._fireSelectionEvents(currentActives, e);
        return selected;
    }
    /**
   * This is supposed to be equivalent to setActiveObject but without firing
   * any event. There is commitment to have this stay this way.
   * This is the functional part of setActiveObject.
   * @param {Object} object to set as active
   * @param {Event} [e] Event (passed along when firing "object:selected")
   * @return {Boolean} true if the object has been selected
   */ _setActiveObject(object, e) {
        const prevActiveObject = this._activeObject;
        if (prevActiveObject === object) return false;
        // after calling this._discardActiveObject, this,_activeObject could be undefined
        if (!this._discardActiveObject(e, object) && this._activeObject) // refused to deselect
        return false;
        if (object.onSelect({
            e: e
        })) return false;
        this._activeObject = object;
        if ($ab3f2a5cc6216ae5$var$isActiveSelection(object) && prevActiveObject !== object) object.set("canvas", this);
        object.setCoords();
        return true;
    }
    /**
   * This is supposed to be equivalent to discardActiveObject but without firing
   * any selection events ( can still fire object transformation events ). There is commitment to have this stay this way.
   * This is the functional part of discardActiveObject.
   * @param {Event} [e] Event (passed along when firing "object:deselected")
   * @param {Object} object the next object to set as active, reason why we are discarding this
   * @return {Boolean} true if the active object has been discarded
   */ _discardActiveObject(e, object) {
        const obj = this._activeObject;
        if (obj) {
            // onDeselect return TRUE to cancel selection;
            if (obj.onDeselect({
                e: e,
                object: object
            })) return false;
            if (this._currentTransform && this._currentTransform.target === obj) this.endCurrentTransform(e);
            this._activeObject = undefined;
            return true;
        }
        return false;
    }
    /**
   * Discards currently active object and fire events. If the function is called by fabric
   * as a consequence of a mouse event, the event is passed as a parameter and
   * sent to the fire function for the custom events. When used as a method the
   * e param does not have any application.
   * @param {event} e
   * @return {Boolean} true if the active object has been discarded
   */ discardActiveObject(e) {
        const currentActives = this.getActiveObjects(), activeObject = this.getActiveObject();
        if (currentActives.length) this.fire("before:selection:cleared", {
            e: e,
            deselected: [
                activeObject
            ]
        });
        const discarded = this._discardActiveObject(e);
        this._fireSelectionEvents(currentActives, e);
        return discarded;
    }
    /**
   * End the current transform.
   * You don't usually need to call this method unless you are interrupting a user initiated transform
   * because of some other event ( a press of key combination, or something that block the user UX )
   * @param {Event} [e] send the mouse event that generate the finalize down, so it can be used in the event
   */ endCurrentTransform(e) {
        const transform = this._currentTransform;
        this._finalizeCurrentTransform(e);
        if (transform && transform.target) // this could probably go inside _finalizeCurrentTransform
        transform.target.isMoving = false;
        this._currentTransform = null;
    }
    /**
   * @private
   * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
   */ _finalizeCurrentTransform(e) {
        const transform = this._currentTransform, target = transform.target, options = {
            e: e,
            target: target,
            transform: transform,
            action: transform.action
        };
        if (target._scaling) target._scaling = false;
        target.setCoords();
        if (transform.actionPerformed) {
            this.fire("object:modified", options);
            target.fire($ab3f2a5cc6216ae5$var$MODIFIED, options);
        }
    }
    /**
   * Sets viewport transformation of this canvas instance
   * @param {Array} vpt a Canvas 2D API transform matrix
   */ setViewportTransform(vpt) {
        super.setViewportTransform(vpt);
        const activeObject = this._activeObject;
        if (activeObject) activeObject.setCoords();
    }
    /**
   * @override clears active selection ref and interactive canvas elements and contexts
   */ destroy() {
        // dispose of active selection
        const activeObject = this._activeObject;
        if ($ab3f2a5cc6216ae5$var$isActiveSelection(activeObject)) {
            activeObject.removeAll();
            activeObject.dispose();
        }
        delete this._activeObject;
        super.destroy();
        // free resources
        // pixel find canvas
        // @ts-expect-error disposing
        this.pixelFindContext = null;
        // @ts-expect-error disposing
        this.pixelFindCanvasEl = undefined;
    }
    /**
   * Clears all contexts (background, main, top) of an instance
   */ clear() {
        // discard active object and fire events
        this.discardActiveObject();
        // make sure we clear the active object in case it refused to be discarded
        this._activeObject = undefined;
        this.clearContext(this.contextTop);
        super.clear();
    }
    /**
   * Draws objects' controls (borders/controls)
   * @param {CanvasRenderingContext2D} ctx Context to render controls on
   */ drawControls(ctx) {
        const activeObject = this._activeObject;
        if (activeObject) activeObject._renderControls(ctx);
    }
    /**
   * @private
   */ _toObject(instance, methodName, propertiesToInclude) {
        // If the object is part of the current selection group, it should
        // be transformed appropriately
        // i.e. it should be serialised as it would appear if the selection group
        // were to be destroyed.
        const originalProperties = this._realizeGroupTransformOnObject(instance), object = super._toObject(instance, methodName, propertiesToInclude);
        //Undo the damage we did by changing all of its properties
        instance.set(originalProperties);
        return object;
    }
    /**
   * Realizes an object's group transformation on it
   * @private
   * @param {FabricObject} [instance] the object to transform (gets mutated)
   * @returns the original values of instance which were changed
   */ _realizeGroupTransformOnObject(instance) {
        const { group: group } = instance;
        if (group && $ab3f2a5cc6216ae5$var$isActiveSelection(group) && this._activeObject === group) {
            const layoutProps = [
                "angle",
                "flipX",
                "flipY",
                $ab3f2a5cc6216ae5$var$LEFT,
                $ab3f2a5cc6216ae5$var$SCALE_X,
                $ab3f2a5cc6216ae5$var$SCALE_Y,
                $ab3f2a5cc6216ae5$var$SKEW_X,
                $ab3f2a5cc6216ae5$var$SKEW_Y,
                $ab3f2a5cc6216ae5$var$TOP
            ];
            const originalValues = $ab3f2a5cc6216ae5$var$pick(instance, layoutProps);
            $ab3f2a5cc6216ae5$var$addTransformToObject(instance, group.calcOwnMatrix());
            return originalValues;
        } else return {};
    }
    /**
   * @private
   */ _setSVGObject(markup, instance, reviver) {
        // If the object is in a selection group, simulate what would happen to that
        // object when the group is deselected
        const originalProperties = this._realizeGroupTransformOnObject(instance);
        super._setSVGObject(markup, instance, reviver);
        instance.set(originalProperties);
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$SelectableCanvas, "ownDefaults", $ab3f2a5cc6216ae5$var$canvasDefaults);
/**
 * In charge of synchronizing all interactive text instances of a canvas
 */ class $ab3f2a5cc6216ae5$var$TextEditingManager {
    constructor(canvas){
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "targets", []);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "__disposer", void 0);
        const cb = ()=>{
            const { hiddenTextarea: hiddenTextarea } = canvas.getActiveObject() || {};
            hiddenTextarea && hiddenTextarea.focus();
        };
        const el = canvas.upperCanvasEl;
        el.addEventListener("click", cb);
        this.__disposer = ()=>el.removeEventListener("click", cb);
    }
    exitTextEditing() {
        this.target = undefined;
        this.targets.forEach((target)=>{
            if (target.isEditing) target.exitEditing();
        });
    }
    add(target) {
        this.targets.push(target);
    }
    remove(target) {
        this.unregister(target);
        $ab3f2a5cc6216ae5$var$removeFromArray(this.targets, target);
    }
    register(target) {
        this.target = target;
    }
    unregister(target) {
        if (target === this.target) this.target = undefined;
    }
    onMouseMove(e) {
        var _this$target;
        ((_this$target = this.target) === null || _this$target === void 0 ? void 0 : _this$target.isEditing) && this.target.updateSelectionOnMouseMove(e);
    }
    clear() {
        this.targets = [];
        this.target = undefined;
    }
    dispose() {
        this.clear();
        this.__disposer();
        // @ts-expect-error disposing
        delete this.__disposer;
    }
}
const $ab3f2a5cc6216ae5$var$_excluded$9 = [
    "target",
    "oldTarget",
    "fireCanvas",
    "e"
];
const $ab3f2a5cc6216ae5$var$addEventOptions = {
    passive: false
};
const $ab3f2a5cc6216ae5$var$getEventPoints = (canvas, e)=>{
    const viewportPoint = canvas.getViewportPoint(e);
    const scenePoint = canvas.getScenePoint(e);
    return {
        viewportPoint: viewportPoint,
        scenePoint: scenePoint,
        pointer: viewportPoint,
        absolutePointer: scenePoint
    };
};
// just to be clear, the utils are now deprecated and those are here exactly as minifier helpers
// because el.addEventListener can't me be minified while a const yes and we use it 47 times in this file.
// few bytes but why give it away.
const $ab3f2a5cc6216ae5$var$addListener = function(el) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return el.addEventListener(...args);
};
const $ab3f2a5cc6216ae5$var$removeListener = function(el) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return el.removeEventListener(...args);
};
const $ab3f2a5cc6216ae5$var$syntheticEventConfig = {
    mouse: {
        in: "over",
        out: "out",
        targetIn: "mouseover",
        targetOut: "mouseout",
        canvasIn: "mouse:over",
        canvasOut: "mouse:out"
    },
    drag: {
        in: "enter",
        out: "leave",
        targetIn: "dragenter",
        targetOut: "dragleave",
        canvasIn: "drag:enter",
        canvasOut: "drag:leave"
    }
};
class $ab3f2a5cc6216ae5$export$8d01c972ee8b14a9 extends $ab3f2a5cc6216ae5$var$SelectableCanvas {
    constructor(el){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(el, options);
        // bind event handlers
        /**
     * Contains the id of the touch event that owns the fabric transform
     * @type Number
     * @private
     */ /**
     * Holds a reference to a setTimeout timer for event synchronization
     * @type number
     * @private
     */ /**
     * Holds a reference to an object on the canvas that is receiving the drag over event.
     * @type FabricObject
     * @private
     */ /**
     * Holds a reference to an object on the canvas from where the drag operation started
     * @type FabricObject
     * @private
     */ /**
     * Holds a reference to an object on the canvas that is the current drop target
     * May differ from {@link _draggedoverTarget}
     * @todo inspect whether {@link _draggedoverTarget} and {@link _dropTarget} should be merged somehow
     * @type FabricObject
     * @private
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_isClick", void 0);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "textEditingManager", new $ab3f2a5cc6216ae5$var$TextEditingManager(this));
        [
            "_onMouseDown",
            "_onTouchStart",
            "_onMouseMove",
            "_onMouseUp",
            "_onTouchEnd",
            "_onResize",
            // '_onGesture',
            // '_onDrag',
            // '_onShake',
            // '_onLongPress',
            // '_onOrientationChange',
            "_onMouseWheel",
            "_onMouseOut",
            "_onMouseEnter",
            "_onContextMenu",
            "_onDoubleClick",
            "_onDragStart",
            "_onDragEnd",
            "_onDragProgress",
            "_onDragOver",
            "_onDragEnter",
            "_onDragLeave",
            "_onDrop"
        ].forEach((eventHandler)=>{
            this[eventHandler] = this[eventHandler].bind(this);
        });
        // register event handlers
        this.addOrRemove($ab3f2a5cc6216ae5$var$addListener, "add");
    }
    /**
   * return an event prefix pointer or mouse.
   * @private
   */ _getEventPrefix() {
        return this.enablePointerEvents ? "pointer" : "mouse";
    }
    addOrRemove(functor, eventjsFunctor) {
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        functor($ab3f2a5cc6216ae5$var$getWindowFromElement(canvasElement), "resize", this._onResize);
        functor(canvasElement, eventTypePrefix + "down", this._onMouseDown);
        functor(canvasElement, "".concat(eventTypePrefix, "move"), this._onMouseMove, $ab3f2a5cc6216ae5$var$addEventOptions);
        functor(canvasElement, "".concat(eventTypePrefix, "out"), this._onMouseOut);
        functor(canvasElement, "".concat(eventTypePrefix, "enter"), this._onMouseEnter);
        functor(canvasElement, "wheel", this._onMouseWheel);
        functor(canvasElement, "contextmenu", this._onContextMenu);
        functor(canvasElement, "dblclick", this._onDoubleClick);
        functor(canvasElement, "dragstart", this._onDragStart);
        functor(canvasElement, "dragend", this._onDragEnd);
        functor(canvasElement, "dragover", this._onDragOver);
        functor(canvasElement, "dragenter", this._onDragEnter);
        functor(canvasElement, "dragleave", this._onDragLeave);
        functor(canvasElement, "drop", this._onDrop);
        if (!this.enablePointerEvents) functor(canvasElement, "touchstart", this._onTouchStart, $ab3f2a5cc6216ae5$var$addEventOptions);
    // if (typeof eventjs !== 'undefined' && eventjsFunctor in eventjs) {
    //   eventjs[eventjsFunctor](canvasElement, 'gesture', this._onGesture);
    //   eventjs[eventjsFunctor](canvasElement, 'drag', this._onDrag);
    //   eventjs[eventjsFunctor](
    //     canvasElement,
    //     'orientation',
    //     this._onOrientationChange
    //   );
    //   eventjs[eventjsFunctor](canvasElement, 'shake', this._onShake);
    //   eventjs[eventjsFunctor](canvasElement, 'longpress', this._onLongPress);
    // }
    }
    /**
   * Removes all event listeners
   */ removeListeners() {
        this.addOrRemove($ab3f2a5cc6216ae5$var$removeListener, "remove");
        // if you dispose on a mouseDown, before mouse up, you need to clean document to...
        const eventTypePrefix = this._getEventPrefix();
        const doc = $ab3f2a5cc6216ae5$var$getDocumentFromElement(this.upperCanvasEl);
        $ab3f2a5cc6216ae5$var$removeListener(doc, "".concat(eventTypePrefix, "up"), this._onMouseUp);
        $ab3f2a5cc6216ae5$var$removeListener(doc, "touchend", this._onTouchEnd, $ab3f2a5cc6216ae5$var$addEventOptions);
        $ab3f2a5cc6216ae5$var$removeListener(doc, "".concat(eventTypePrefix, "move"), this._onMouseMove, $ab3f2a5cc6216ae5$var$addEventOptions);
        $ab3f2a5cc6216ae5$var$removeListener(doc, "touchmove", this._onMouseMove, $ab3f2a5cc6216ae5$var$addEventOptions);
    }
    /**
   * @private
   * @param {Event} [e] Event object fired on wheel event
   */ _onMouseWheel(e) {
        this.__onMouseWheel(e);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onMouseOut(e) {
        const target = this._hoveredTarget;
        const shared = $ab3f2a5cc6216ae5$var$_objectSpread2({
            e: e
        }, $ab3f2a5cc6216ae5$var$getEventPoints(this, e));
        this.fire("mouse:out", $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, shared), {}, {
            target: target
        }));
        this._hoveredTarget = undefined;
        target && target.fire("mouseout", $ab3f2a5cc6216ae5$var$_objectSpread2({}, shared));
        this._hoveredTargets.forEach((nestedTarget)=>{
            this.fire("mouse:out", $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, shared), {}, {
                target: nestedTarget
            }));
            nestedTarget && nestedTarget.fire("mouseout", $ab3f2a5cc6216ae5$var$_objectSpread2({}, shared));
        });
        this._hoveredTargets = [];
    }
    /**
   * @private
   * @param {Event} e Event object fired on mouseenter
   */ _onMouseEnter(e) {
        // This find target and consequent 'mouse:over' is used to
        // clear old instances on hovered target.
        // calling findTarget has the side effect of killing target.__corner.
        // as a short term fix we are not firing this if we are currently transforming.
        // as a long term fix we need to separate the action of finding a target with the
        // side effects we added to it.
        if (!this._currentTransform && !this.findTarget(e)) {
            this.fire("mouse:over", $ab3f2a5cc6216ae5$var$_objectSpread2({
                e: e
            }, $ab3f2a5cc6216ae5$var$getEventPoints(this, e)));
            this._hoveredTarget = undefined;
            this._hoveredTargets = [];
        }
    }
    /**
   * supports native like text dragging
   * @private
   * @param {DragEvent} e
   */ _onDragStart(e) {
        this._isClick = false;
        const activeObject = this.getActiveObject();
        if (activeObject && activeObject.onDragStart(e)) {
            this._dragSource = activeObject;
            const options = {
                e: e,
                target: activeObject
            };
            this.fire("dragstart", options);
            activeObject.fire("dragstart", options);
            $ab3f2a5cc6216ae5$var$addListener(this.upperCanvasEl, "drag", this._onDragProgress);
            return;
        }
        $ab3f2a5cc6216ae5$var$stopEvent(e);
    }
    /**
   * First we clear top context where the effects are being rendered.
   * Then we render the effects.
   * Doing so will render the correct effect for all cases including an overlap between `source` and `target`.
   * @private
   */ _renderDragEffects(e, source, target) {
        let dirty = false;
        // clear top context
        const dropTarget = this._dropTarget;
        if (dropTarget && dropTarget !== source && dropTarget !== target) {
            dropTarget.clearContextTop();
            dirty = true;
        }
        source === null || source === void 0 || source.clearContextTop();
        target !== source && (target === null || target === void 0 || target.clearContextTop());
        // render effects
        const ctx = this.contextTop;
        ctx.save();
        ctx.transform(...this.viewportTransform);
        if (source) {
            ctx.save();
            source.transform(ctx);
            source.renderDragSourceEffect(e);
            ctx.restore();
            dirty = true;
        }
        if (target) {
            ctx.save();
            target.transform(ctx);
            target.renderDropTargetEffect(e);
            ctx.restore();
            dirty = true;
        }
        ctx.restore();
        dirty && (this.contextTopDirty = true);
    }
    /**
   * supports native like text dragging
   * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#finishing_a_drag
   * @private
   * @param {DragEvent} e
   */ _onDragEnd(e) {
        const didDrop = !!e.dataTransfer && e.dataTransfer.dropEffect !== $ab3f2a5cc6216ae5$var$NONE, dropTarget = didDrop ? this._activeObject : undefined, options = {
            e: e,
            target: this._dragSource,
            subTargets: this.targets,
            dragSource: this._dragSource,
            didDrop: didDrop,
            dropTarget: dropTarget
        };
        $ab3f2a5cc6216ae5$var$removeListener(this.upperCanvasEl, "drag", this._onDragProgress);
        this.fire("dragend", options);
        this._dragSource && this._dragSource.fire("dragend", options);
        delete this._dragSource;
        // we need to call mouse up synthetically because the browser won't
        this._onMouseUp(e);
    }
    /**
   * fire `drag` event on canvas and drag source
   * @private
   * @param {DragEvent} e
   */ _onDragProgress(e) {
        const options = {
            e: e,
            target: this._dragSource,
            dragSource: this._dragSource,
            dropTarget: this._draggedoverTarget
        };
        this.fire("drag", options);
        this._dragSource && this._dragSource.fire("drag", options);
    }
    /**
   * As opposed to {@link findTarget} we want the top most object to be returned w/o the active object cutting in line.
   * Override at will
   */ findDragTargets(e) {
        this.targets = [];
        const target = this._searchPossibleTargets(this._objects, this.getViewportPoint(e));
        return {
            target: target,
            targets: [
                ...this.targets
            ]
        };
    }
    /**
   * prevent default to allow drop event to be fired
   * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#specifying_drop_targets
   * @private
   * @param {DragEvent} [e] Event object fired on Event.js shake
   */ _onDragOver(e) {
        const eventType = "dragover";
        const { target: target, targets: targets } = this.findDragTargets(e);
        const dragSource = this._dragSource;
        const options = {
            e: e,
            target: target,
            subTargets: targets,
            dragSource: dragSource,
            canDrop: false,
            dropTarget: undefined
        };
        let dropTarget;
        //  fire on canvas
        this.fire(eventType, options);
        //  make sure we fire dragenter events before dragover
        //  if dragleave is needed, object will not fire dragover so we don't need to trouble ourselves with it
        this._fireEnterLeaveEvents(target, options);
        if (target) {
            if (target.canDrop(e)) dropTarget = target;
            target.fire(eventType, options);
        }
        //  propagate the event to subtargets
        for(let i = 0; i < targets.length; i++){
            const subTarget = targets[i];
            // accept event only if previous targets didn't (the accepting target calls `preventDefault` to inform that the event is taken)
            // TODO: verify if those should loop in inverse order then?
            // what is the order of subtargets?
            if (subTarget.canDrop(e)) dropTarget = subTarget;
            subTarget.fire(eventType, options);
        }
        //  render drag effects now that relations between source and target is clear
        this._renderDragEffects(e, dragSource, dropTarget);
        this._dropTarget = dropTarget;
    }
    /**
   * fire `dragleave` on `dragover` targets
   * @private
   * @param {Event} [e] Event object fired on Event.js shake
   */ _onDragEnter(e) {
        const { target: target, targets: targets } = this.findDragTargets(e);
        const options = {
            e: e,
            target: target,
            subTargets: targets,
            dragSource: this._dragSource
        };
        this.fire("dragenter", options);
        //  fire dragenter on targets
        this._fireEnterLeaveEvents(target, options);
    }
    /**
   * fire `dragleave` on `dragover` targets
   * @private
   * @param {Event} [e] Event object fired on Event.js shake
   */ _onDragLeave(e) {
        const options = {
            e: e,
            target: this._draggedoverTarget,
            subTargets: this.targets,
            dragSource: this._dragSource
        };
        this.fire("dragleave", options);
        //  fire dragleave on targets
        this._fireEnterLeaveEvents(undefined, options);
        this._renderDragEffects(e, this._dragSource);
        this._dropTarget = undefined;
        //  clear targets
        this.targets = [];
        this._hoveredTargets = [];
    }
    /**
   * `drop:before` is a an event that allows you to schedule logic
   * before the `drop` event. Prefer `drop` event always, but if you need
   * to run some drop-disabling logic on an event, since there is no way
   * to handle event handlers ordering, use `drop:before`
   * @private
   * @param {Event} e
   */ _onDrop(e) {
        const { target: target, targets: targets } = this.findDragTargets(e);
        const options = this._basicEventHandler("drop:before", $ab3f2a5cc6216ae5$var$_objectSpread2({
            e: e,
            target: target,
            subTargets: targets,
            dragSource: this._dragSource
        }, $ab3f2a5cc6216ae5$var$getEventPoints(this, e)));
        //  will be set by the drop target
        options.didDrop = false;
        //  will be set by the drop target, used in case options.target refuses the drop
        options.dropTarget = undefined;
        //  fire `drop`
        this._basicEventHandler("drop", options);
        //  inform canvas of the drop
        //  we do this because canvas was unaware of what happened at the time the `drop` event was fired on it
        //  use for side effects
        this.fire("drop:after", options);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onContextMenu(e) {
        const target = this.findTarget(e), subTargets = this.targets || [];
        const options = this._basicEventHandler("contextmenu:before", {
            e: e,
            target: target,
            subTargets: subTargets
        });
        // TODO: this line is silly because the dev can subscribe to the event and prevent it themselves
        this.stopContextMenu && $ab3f2a5cc6216ae5$var$stopEvent(e);
        this._basicEventHandler("contextmenu", options);
        return false;
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onDoubleClick(e) {
        this._cacheTransformEventData(e);
        this._handleEvent(e, "dblclick");
        this._resetTransformEventData();
    }
    /**
   * Return a the id of an event.
   * returns either the pointerId or the identifier or 0 for the mouse event
   * @private
   * @param {Event} evt Event object
   */ getPointerId(evt) {
        const changedTouches = evt.changedTouches;
        if (changedTouches) return changedTouches[0] && changedTouches[0].identifier;
        if (this.enablePointerEvents) return evt.pointerId;
        return -1;
    }
    /**
   * Determines if an event has the id of the event that is considered main
   * @private
   * @param {evt} event Event object
   */ _isMainEvent(evt) {
        if (evt.isPrimary === true) return true;
        if (evt.isPrimary === false) return false;
        if (evt.type === "touchend" && evt.touches.length === 0) return true;
        if (evt.changedTouches) return evt.changedTouches[0].identifier === this.mainTouchId;
        return true;
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onTouchStart(e) {
        e.preventDefault();
        if (this.mainTouchId === undefined) this.mainTouchId = this.getPointerId(e);
        this.__onMouseDown(e);
        this._resetTransformEventData();
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        const doc = $ab3f2a5cc6216ae5$var$getDocumentFromElement(canvasElement);
        $ab3f2a5cc6216ae5$var$addListener(doc, "touchend", this._onTouchEnd, $ab3f2a5cc6216ae5$var$addEventOptions);
        $ab3f2a5cc6216ae5$var$addListener(doc, "touchmove", this._onMouseMove, $ab3f2a5cc6216ae5$var$addEventOptions);
        // Unbind mousedown to prevent double triggers from touch devices
        $ab3f2a5cc6216ae5$var$removeListener(canvasElement, "".concat(eventTypePrefix, "down"), this._onMouseDown);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onMouseDown(e) {
        this.__onMouseDown(e);
        this._resetTransformEventData();
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        $ab3f2a5cc6216ae5$var$removeListener(canvasElement, "".concat(eventTypePrefix, "move"), this._onMouseMove, $ab3f2a5cc6216ae5$var$addEventOptions);
        const doc = $ab3f2a5cc6216ae5$var$getDocumentFromElement(canvasElement);
        $ab3f2a5cc6216ae5$var$addListener(doc, "".concat(eventTypePrefix, "up"), this._onMouseUp);
        $ab3f2a5cc6216ae5$var$addListener(doc, "".concat(eventTypePrefix, "move"), this._onMouseMove, $ab3f2a5cc6216ae5$var$addEventOptions);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onTouchEnd(e) {
        if (e.touches.length > 0) // if there are still touches stop here
        return;
        this.__onMouseUp(e);
        this._resetTransformEventData();
        delete this.mainTouchId;
        const eventTypePrefix = this._getEventPrefix();
        const doc = $ab3f2a5cc6216ae5$var$getDocumentFromElement(this.upperCanvasEl);
        $ab3f2a5cc6216ae5$var$removeListener(doc, "touchend", this._onTouchEnd, $ab3f2a5cc6216ae5$var$addEventOptions);
        $ab3f2a5cc6216ae5$var$removeListener(doc, "touchmove", this._onMouseMove, $ab3f2a5cc6216ae5$var$addEventOptions);
        if (this._willAddMouseDown) clearTimeout(this._willAddMouseDown);
        this._willAddMouseDown = setTimeout(()=>{
            // Wait 400ms before rebinding mousedown to prevent double triggers
            // from touch devices
            $ab3f2a5cc6216ae5$var$addListener(this.upperCanvasEl, "".concat(eventTypePrefix, "down"), this._onMouseDown);
            this._willAddMouseDown = 0;
        }, 400);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mouseup
   */ _onMouseUp(e) {
        this.__onMouseUp(e);
        this._resetTransformEventData();
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        if (this._isMainEvent(e)) {
            const doc = $ab3f2a5cc6216ae5$var$getDocumentFromElement(this.upperCanvasEl);
            $ab3f2a5cc6216ae5$var$removeListener(doc, "".concat(eventTypePrefix, "up"), this._onMouseUp);
            $ab3f2a5cc6216ae5$var$removeListener(doc, "".concat(eventTypePrefix, "move"), this._onMouseMove, $ab3f2a5cc6216ae5$var$addEventOptions);
            $ab3f2a5cc6216ae5$var$addListener(canvasElement, "".concat(eventTypePrefix, "move"), this._onMouseMove, $ab3f2a5cc6216ae5$var$addEventOptions);
        }
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousemove
   */ _onMouseMove(e) {
        const activeObject = this.getActiveObject();
        !this.allowTouchScrolling && (!activeObject || // a drag event sequence is started by the active object flagging itself on mousedown / mousedown:before
        // we must not prevent the event's default behavior in order for the window to start dragging
        !activeObject.shouldStartDragging(e)) && e.preventDefault && e.preventDefault();
        this.__onMouseMove(e);
    }
    /**
   * @private
   */ _onResize() {
        this.calcOffset();
        this._resetTransformEventData();
    }
    /**
   * Decides whether the canvas should be redrawn in mouseup and mousedown events.
   * @private
   * @param {Object} target
   */ _shouldRender(target) {
        const activeObject = this.getActiveObject();
        // if just one of them is available or if they are both but are different objects
        // this covers: switch of target, from target to no target, selection of target
        // multiSelection with key and mouse
        return !!activeObject !== !!target || activeObject && target && activeObject !== target;
    }
    /**
   * Method that defines the actions when mouse is released on canvas.
   * The method resets the currentTransform parameters, store the image corner
   * position in the image object and render the canvas on top.
   * @private
   * @param {Event} e Event object fired on mouseup
   */ __onMouseUp(e) {
        var _this$_activeObject;
        this._cacheTransformEventData(e);
        this._handleEvent(e, "up:before");
        const transform = this._currentTransform;
        const isClick = this._isClick;
        const target = this._target;
        // if right/middle click just fire events and return
        // target undefined will make the _handleEvent search the target
        const { button: button } = e;
        if (button) {
            (this.fireMiddleClick && button === 1 || this.fireRightClick && button === 2) && this._handleEvent(e, "up");
            this._resetTransformEventData();
            return;
        }
        if (this.isDrawingMode && this._isCurrentlyDrawing) {
            this._onMouseUpInDrawingMode(e);
            return;
        }
        if (!this._isMainEvent(e)) return;
        let shouldRender = false;
        if (transform) {
            this._finalizeCurrentTransform(e);
            shouldRender = transform.actionPerformed;
        }
        if (!isClick) {
            const targetWasActive = target === this._activeObject;
            this.handleSelection(e);
            if (!shouldRender) shouldRender = this._shouldRender(target) || !targetWasActive && target === this._activeObject;
        }
        let pointer, corner;
        if (target) {
            const found = target.findControl(this.getViewportPoint(e), $ab3f2a5cc6216ae5$var$isTouchEvent(e));
            const { key: key, control: control } = found || {};
            corner = key;
            if (target.selectable && target !== this._activeObject && target.activeOn === "up") {
                this.setActiveObject(target, e);
                shouldRender = true;
            } else if (control) {
                const mouseUpHandler = control.getMouseUpHandler(e, target, control);
                if (mouseUpHandler) {
                    pointer = this.getScenePoint(e);
                    mouseUpHandler.call(control, e, transform, pointer.x, pointer.y);
                }
            }
            target.isMoving = false;
        }
        // if we are ending up a transform on a different control or a new object
        // fire the original mouse up from the corner that started the transform
        if (transform && (transform.target !== target || transform.corner !== corner)) {
            const originalControl = transform.target && transform.target.controls[transform.corner], originalMouseUpHandler = originalControl && originalControl.getMouseUpHandler(e, transform.target, originalControl);
            pointer = pointer || this.getScenePoint(e);
            originalMouseUpHandler && originalMouseUpHandler.call(originalControl, e, transform, pointer.x, pointer.y);
        }
        this._setCursorFromEvent(e, target);
        this._handleEvent(e, "up");
        this._groupSelector = null;
        this._currentTransform = null;
        // reset the target information about which corner is selected
        target && (target.__corner = undefined);
        if (shouldRender) this.requestRenderAll();
        else if (!isClick && !((_this$_activeObject = this._activeObject) !== null && _this$_activeObject !== void 0 && _this$_activeObject.isEditing)) this.renderTop();
    }
    _basicEventHandler(eventType, options) {
        const { target: target, subTargets: subTargets = [] } = options;
        this.fire(eventType, options);
        target && target.fire(eventType, options);
        for(let i = 0; i < subTargets.length; i++)subTargets[i] !== target && subTargets[i].fire(eventType, options);
        return options;
    }
    /**
   * @private
   * Handle event firing for target and subtargets
   * @param {TPointerEvent} e event from mouse
   * @param {TPointerEventNames} eventType
   */ _handleEvent(e, eventType) {
        const target = this._target, targets = this.targets || [], options = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({
            e: e,
            target: target,
            subTargets: targets
        }, $ab3f2a5cc6216ae5$var$getEventPoints(this, e)), {}, {
            transform: this._currentTransform
        }, eventType === "up:before" || eventType === "up" ? {
            isClick: this._isClick,
            currentTarget: this.findTarget(e),
            // set by the preceding `findTarget` call
            currentSubTargets: this.targets
        } : {});
        this.fire("mouse:".concat(eventType), options);
        // this may be a little be more complicated of what we want to handle
        target && target.fire("mouse".concat(eventType), options);
        for(let i = 0; i < targets.length; i++)targets[i] !== target && targets[i].fire("mouse".concat(eventType), options);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onMouseDownInDrawingMode(e) {
        this._isCurrentlyDrawing = true;
        if (this.getActiveObject()) {
            this.discardActiveObject(e);
            this.requestRenderAll();
        }
        // TODO: this is a scene point so it should be renamed
        const pointer = this.getScenePoint(e);
        this.freeDrawingBrush && this.freeDrawingBrush.onMouseDown(pointer, {
            e: e,
            pointer: pointer
        });
        this._handleEvent(e, "down");
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousemove
   */ _onMouseMoveInDrawingMode(e) {
        if (this._isCurrentlyDrawing) {
            const pointer = this.getScenePoint(e);
            this.freeDrawingBrush && this.freeDrawingBrush.onMouseMove(pointer, {
                e: e,
                pointer: // this is an absolute pointer, the naming is wrong
                pointer
            });
        }
        this.setCursor(this.freeDrawingCursor);
        this._handleEvent(e, "move");
    }
    /**
   * @private
   * @param {Event} e Event object fired on mouseup
   */ _onMouseUpInDrawingMode(e) {
        const pointer = this.getScenePoint(e);
        if (this.freeDrawingBrush) this._isCurrentlyDrawing = !!this.freeDrawingBrush.onMouseUp({
            e: e,
            pointer: // this is an absolute pointer, the naming is wrong
            pointer
        });
        else this._isCurrentlyDrawing = false;
        this._handleEvent(e, "up");
    }
    /**
   * Method that defines the actions when mouse is clicked on canvas.
   * The method inits the currentTransform parameters and renders all the
   * canvas so the current image can be placed on the top canvas and the rest
   * in on the container one.
   * @private
   * @param {Event} e Event object fired on mousedown
   */ __onMouseDown(e) {
        this._isClick = true;
        this._cacheTransformEventData(e);
        this._handleEvent(e, "down:before");
        let target = this._target;
        // if right/middle click just fire events
        const { button: button } = e;
        if (button) {
            (this.fireMiddleClick && button === 1 || this.fireRightClick && button === 2) && this._handleEvent(e, "down");
            this._resetTransformEventData();
            return;
        }
        if (this.isDrawingMode) {
            this._onMouseDownInDrawingMode(e);
            return;
        }
        if (!this._isMainEvent(e)) return;
        // ignore if some object is being transformed at this moment
        if (this._currentTransform) return;
        let shouldRender = this._shouldRender(target);
        let grouped = false;
        if (this.handleMultiSelection(e, target)) {
            // active object might have changed while grouping
            target = this._activeObject;
            grouped = true;
            shouldRender = true;
        } else if (this._shouldClearSelection(e, target)) this.discardActiveObject(e);
        // we start a group selector rectangle if
        // selection is enabled
        // and there is no target, or the following 3 conditions are satisfied:
        // target is not selectable ( otherwise we selected it )
        // target is not editing
        // target is not already selected ( otherwise we drag )
        if (this.selection && (!target || !target.selectable && !target.isEditing && target !== this._activeObject)) {
            const p = this.getScenePoint(e);
            this._groupSelector = {
                x: p.x,
                y: p.y,
                deltaY: 0,
                deltaX: 0
            };
        }
        if (target) {
            const alreadySelected = target === this._activeObject;
            if (target.selectable && target.activeOn === "down") this.setActiveObject(target, e);
            const handle = target.findControl(this.getViewportPoint(e), $ab3f2a5cc6216ae5$var$isTouchEvent(e));
            if (target === this._activeObject && (handle || !grouped)) {
                this._setupCurrentTransform(e, target, alreadySelected);
                const control = handle ? handle.control : undefined, pointer = this.getScenePoint(e), mouseDownHandler = control && control.getMouseDownHandler(e, target, control);
                mouseDownHandler && mouseDownHandler.call(control, e, this._currentTransform, pointer.x, pointer.y);
            }
        }
        //  we clear `_objectsToRender` in case of a change in order to repopulate it at rendering
        //  run before firing the `down` event to give the dev a chance to populate it themselves
        shouldRender && (this._objectsToRender = undefined);
        this._handleEvent(e, "down");
        // we must renderAll so that we update the visuals
        shouldRender && this.requestRenderAll();
    }
    /**
   * reset cache form common information needed during event processing
   * @private
   */ _resetTransformEventData() {
        this._target = undefined;
        this._pointer = undefined;
        this._absolutePointer = undefined;
    }
    /**
   * Cache common information needed during event processing
   * @private
   * @param {Event} e Event object fired on event
   */ _cacheTransformEventData(e) {
        // reset in order to avoid stale caching
        this._resetTransformEventData();
        this._pointer = this.getViewportPoint(e);
        this._absolutePointer = $ab3f2a5cc6216ae5$var$sendPointToPlane(this._pointer, undefined, this.viewportTransform);
        this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e);
    }
    /**
   * Method that defines the actions when mouse is hovering the canvas.
   * The currentTransform parameter will define whether the user is rotating/scaling/translating
   * an image or neither of them (only hovering). A group selection is also possible and would cancel
   * all any other type of action.
   * In case of an image transformation only the top canvas will be rendered.
   * @private
   * @param {Event} e Event object fired on mousemove
   */ __onMouseMove(e) {
        this._isClick = false;
        this._cacheTransformEventData(e);
        this._handleEvent(e, "move:before");
        if (this.isDrawingMode) {
            this._onMouseMoveInDrawingMode(e);
            return;
        }
        if (!this._isMainEvent(e)) return;
        const groupSelector = this._groupSelector;
        // We initially clicked in an empty area, so we draw a box for multiple selection
        if (groupSelector) {
            const pointer = this.getScenePoint(e);
            groupSelector.deltaX = pointer.x - groupSelector.x;
            groupSelector.deltaY = pointer.y - groupSelector.y;
            this.renderTop();
        } else if (!this._currentTransform) {
            const target = this.findTarget(e);
            this._setCursorFromEvent(e, target);
            this._fireOverOutEvents(e, target);
        } else this._transformObject(e);
        this.textEditingManager.onMouseMove(e);
        this._handleEvent(e, "move");
        this._resetTransformEventData();
    }
    /**
   * Manage the mouseout, mouseover events for the fabric object on the canvas
   * @param {Fabric.Object} target the target where the target from the mousemove event
   * @param {Event} e Event object fired on mousemove
   * @private
   */ _fireOverOutEvents(e, target) {
        const _hoveredTarget = this._hoveredTarget, _hoveredTargets = this._hoveredTargets, targets = this.targets, length = Math.max(_hoveredTargets.length, targets.length);
        this.fireSyntheticInOutEvents("mouse", {
            e: e,
            target: target,
            oldTarget: _hoveredTarget,
            fireCanvas: true
        });
        for(let i = 0; i < length; i++)this.fireSyntheticInOutEvents("mouse", {
            e: e,
            target: targets[i],
            oldTarget: _hoveredTargets[i]
        });
        this._hoveredTarget = target;
        this._hoveredTargets = this.targets.concat();
    }
    /**
   * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
   * @param {Fabric.Object} target the target where the target from the onDrag event
   * @param {Object} data Event object fired on dragover
   * @private
   */ _fireEnterLeaveEvents(target, data) {
        const draggedoverTarget = this._draggedoverTarget, _hoveredTargets = this._hoveredTargets, targets = this.targets, length = Math.max(_hoveredTargets.length, targets.length);
        this.fireSyntheticInOutEvents("drag", $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, data), {}, {
            target: target,
            oldTarget: draggedoverTarget,
            fireCanvas: true
        }));
        for(let i = 0; i < length; i++)this.fireSyntheticInOutEvents("drag", $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, data), {}, {
            target: targets[i],
            oldTarget: _hoveredTargets[i]
        }));
        this._draggedoverTarget = target;
    }
    /**
   * Manage the synthetic in/out events for the fabric objects on the canvas
   * @param {Fabric.Object} target the target where the target from the supported events
   * @param {Object} data Event object fired
   * @param {Object} config configuration for the function to work
   * @param {String} config.targetName property on the canvas where the old target is stored
   * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
   * @param {String} config.evtOut name of the event to fire for out
   * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
   * @param {String} config.evtIn name of the event to fire for in
   * @private
   */ fireSyntheticInOutEvents(type, _ref) {
        let { target: target, oldTarget: oldTarget, fireCanvas: fireCanvas, e: e } = _ref, data = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref, $ab3f2a5cc6216ae5$var$_excluded$9);
        const { targetIn: targetIn, targetOut: targetOut, canvasIn: canvasIn, canvasOut: canvasOut } = $ab3f2a5cc6216ae5$var$syntheticEventConfig[type];
        const targetChanged = oldTarget !== target;
        if (oldTarget && targetChanged) {
            const outOpt = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, data), {}, {
                e: e,
                target: oldTarget,
                nextTarget: target
            }, $ab3f2a5cc6216ae5$var$getEventPoints(this, e));
            fireCanvas && this.fire(canvasOut, outOpt);
            oldTarget.fire(targetOut, outOpt);
        }
        if (target && targetChanged) {
            const inOpt = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, data), {}, {
                e: e,
                target: target,
                previousTarget: oldTarget
            }, $ab3f2a5cc6216ae5$var$getEventPoints(this, e));
            fireCanvas && this.fire(canvasIn, inOpt);
            target.fire(targetIn, inOpt);
        }
    }
    /**
   * Method that defines actions when an Event Mouse Wheel
   * @param {Event} e Event object fired on mouseup
   */ __onMouseWheel(e) {
        this._cacheTransformEventData(e);
        this._handleEvent(e, "wheel");
        this._resetTransformEventData();
    }
    /**
   * @private
   * @param {Event} e Event fired on mousemove
   */ _transformObject(e) {
        const scenePoint = this.getScenePoint(e), transform = this._currentTransform, target = transform.target, //  transform pointer to target's containing coordinate plane
        //  both pointer and object should agree on every point
        localPointer = target.group ? $ab3f2a5cc6216ae5$var$sendPointToPlane(scenePoint, undefined, target.group.calcTransformMatrix()) : scenePoint;
        transform.shiftKey = e.shiftKey;
        transform.altKey = !!this.centeredKey && e[this.centeredKey];
        this._performTransformAction(e, transform, localPointer);
        transform.actionPerformed && this.requestRenderAll();
    }
    /**
   * @private
   */ _performTransformAction(e, transform, pointer) {
        const { action: action, actionHandler: actionHandler, target: target } = transform;
        const actionPerformed = !!actionHandler && actionHandler(e, transform, pointer.x, pointer.y);
        actionPerformed && target.setCoords();
        // this object could be created from the function in the control handlers
        if (action === "drag" && actionPerformed) {
            transform.target.isMoving = true;
            this.setCursor(transform.target.moveCursor || this.moveCursor);
        }
        transform.actionPerformed = transform.actionPerformed || actionPerformed;
    }
    /**
   * Sets the cursor depending on where the canvas is being hovered.
   * Note: very buggy in Opera
   * @param {Event} e Event object
   * @param {Object} target Object that the mouse is hovering, if so.
   */ _setCursorFromEvent(e, target) {
        if (!target) {
            this.setCursor(this.defaultCursor);
            return;
        }
        let hoverCursor = target.hoverCursor || this.hoverCursor;
        const activeSelection = $ab3f2a5cc6216ae5$var$isActiveSelection(this._activeObject) ? this._activeObject : null, // only show proper corner when group selection is not active
        corner = (!activeSelection || target.group !== activeSelection) && // here we call findTargetCorner always with undefined for the touch parameter.
        // we assume that if you are using a cursor you do not need to interact with
        // the bigger touch area.
        target.findControl(this.getViewportPoint(e));
        if (!corner) {
            if (target.subTargetCheck) // hoverCursor should come from top-most subTarget,
            // so we walk the array backwards
            this.targets.concat().reverse().map((_target)=>{
                hoverCursor = _target.hoverCursor || hoverCursor;
            });
            this.setCursor(hoverCursor);
        } else {
            const control = corner.control;
            this.setCursor(control.cursorStyleHandler(e, control, target));
        }
    }
    /**
   * ## Handles multiple selection
   * - toggles `target` selection (selects/deselects `target` if it isn't/is selected respectively)
   * - sets the active object in case it is not set or in case there is a single active object left under active selection.
   * ---
   * - If the active object is the active selection we add/remove `target` from it
   * - If not, add the active object and `target` to the active selection and make it the active object.
   * @private
   * @param {TPointerEvent} e Event object
   * @param {FabricObject} target target of event to select/deselect
   * @returns true if grouping occurred
   */ handleMultiSelection(e, target) {
        const activeObject = this._activeObject;
        const isAS = $ab3f2a5cc6216ae5$var$isActiveSelection(activeObject);
        if (// check if an active object exists on canvas and if the user is pressing the `selectionKey` while canvas supports multi selection.
        !!activeObject && this._isSelectionKeyPressed(e) && this.selection && // on top of that the user also has to hit a target that is selectable.
        !!target && target.selectable && // group target and active object only if they are different objects
        // else we try to find a subtarget of `ActiveSelection`
        (activeObject !== target || isAS) && //  make sure `activeObject` and `target` aren't ancestors of each other in case `activeObject` is not `ActiveSelection`
        // if it is then we want to remove `target` from it
        (isAS || !target.isDescendantOf(activeObject) && !activeObject.isDescendantOf(target)) && //  target accepts selection
        !target.onSelect({
            e: e
        }) && // make sure we are not on top of a control
        !activeObject.getActiveControl()) {
            if (isAS) {
                const prevActiveObjects = activeObject.getObjects();
                if (target === activeObject) {
                    const pointer = this.getViewportPoint(e);
                    target = // first search active objects for a target to remove
                    this.searchPossibleTargets(prevActiveObjects, pointer) || //  if not found, search under active selection for a target to add
                    // `prevActiveObjects` will be searched but we already know they will not be found
                    this.searchPossibleTargets(this._objects, pointer);
                    // if nothing is found bail out
                    if (!target || !target.selectable) return false;
                }
                if (target.group === activeObject) {
                    // `target` is part of active selection => remove it
                    activeObject.remove(target);
                    this._hoveredTarget = target;
                    this._hoveredTargets = [
                        ...this.targets
                    ];
                    // if after removing an object we are left with one only...
                    if (activeObject.size() === 1) // activate last remaining object
                    // deselecting the active selection will remove the remaining object from it
                    this._setActiveObject(activeObject.item(0), e);
                } else {
                    // `target` isn't part of active selection => add it
                    activeObject.multiSelectAdd(target);
                    this._hoveredTarget = activeObject;
                    this._hoveredTargets = [
                        ...this.targets
                    ];
                }
                this._fireSelectionEvents(prevActiveObjects, e);
            } else {
                activeObject.exitEditing && activeObject.exitEditing();
                // add the active object and the target to the active selection and set it as the active object
                const klass = $ab3f2a5cc6216ae5$export$2792378e23a7920c.getClass("ActiveSelection");
                const newActiveSelection = new klass([], {
                    /**
           * it is crucial to pass the canvas ref before calling {@link ActiveSelection#multiSelectAdd}
           * since it uses {@link FabricObject#isInFrontOf} which relies on the canvas ref
           */ canvas: this
                });
                newActiveSelection.multiSelectAdd(activeObject, target);
                this._hoveredTarget = newActiveSelection;
                // ISSUE 4115: should we consider subTargets here?
                // this._hoveredTargets = [];
                // this._hoveredTargets = this.targets.concat();
                this._setActiveObject(newActiveSelection, e);
                this._fireSelectionEvents([
                    activeObject
                ], e);
            }
            return true;
        }
        return false;
    }
    /**
   * ## Handles selection
   * - selects objects that are contained in (and possibly intersecting) the selection bounding box
   * - sets the active object
   * ---
   * runs on mouse up after a mouse move
   */ handleSelection(e) {
        if (!this.selection || !this._groupSelector) return false;
        const { x: x, y: y, deltaX: deltaX, deltaY: deltaY } = this._groupSelector, point1 = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(x, y), point2 = point1.add(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(deltaX, deltaY)), tl = point1.min(point2), br = point1.max(point2), size = br.subtract(tl);
        const collectedObjects = this.collectObjects({
            left: tl.x,
            top: tl.y,
            width: size.x,
            height: size.y
        }, {
            includeIntersecting: !this.selectionFullyContained
        });
        const objects = // though this method runs only after mouse move the pointer could do a mouse up on the same position as mouse down
        // should it be handled as is?
        point1.eq(point2) ? collectedObjects[0] ? [
            collectedObjects[0]
        ] : [] : collectedObjects.length > 1 ? collectedObjects.filter((object)=>!object.onSelect({
                e: e
            })).reverse() : // `setActiveObject` will call `onSelect(collectedObjects[0])` in this case
        collectedObjects;
        // set active object
        if (objects.length === 1) // set as active object
        this.setActiveObject(objects[0], e);
        else if (objects.length > 1) {
            // add to active selection and make it the active object
            const klass = $ab3f2a5cc6216ae5$export$2792378e23a7920c.getClass("ActiveSelection");
            this.setActiveObject(new klass(objects, {
                canvas: this
            }), e);
        }
        // cleanup
        this._groupSelector = null;
        return true;
    }
    /**
   * @override clear {@link textEditingManager}
   */ clear() {
        this.textEditingManager.clear();
        super.clear();
    }
    /**
   * @override clear {@link textEditingManager}
   */ destroy() {
        this.removeListeners();
        this.textEditingManager.dispose();
        super.destroy();
    }
}
const $ab3f2a5cc6216ae5$var$linearDefaultCoords = {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
};
const $ab3f2a5cc6216ae5$var$radialDefaultCoords = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$var$linearDefaultCoords), {}, {
    r1: 0,
    r2: 0
});
const $ab3f2a5cc6216ae5$var$RE_PERCENT = /^(\d+\.\d+)%|(\d+)%$/;
function $ab3f2a5cc6216ae5$var$isPercent(value) {
    return value && $ab3f2a5cc6216ae5$var$RE_PERCENT.test(value);
}
/**
 *
 * @param value
 * @param valueIfNaN
 * @returns ∈ [0, 1]
 */ function $ab3f2a5cc6216ae5$var$parsePercent(value, valueIfNaN) {
    const parsed = typeof value === "number" ? value : typeof value === "string" ? parseFloat(value) / ($ab3f2a5cc6216ae5$var$isPercent(value) ? 100 : 1) : NaN;
    return $ab3f2a5cc6216ae5$var$capValue(0, $ab3f2a5cc6216ae5$var$ifNaN(parsed, valueIfNaN), 1);
}
const $ab3f2a5cc6216ae5$var$RE_KEY_VALUE_PAIRS = /\s*;\s*/;
const $ab3f2a5cc6216ae5$var$RE_KEY_VALUE = /\s*:\s*/;
function $ab3f2a5cc6216ae5$var$parseColorStop(el, multiplier) {
    let colorValue, opacity;
    const style = el.getAttribute("style");
    if (style) {
        const keyValuePairs = style.split($ab3f2a5cc6216ae5$var$RE_KEY_VALUE_PAIRS);
        if (keyValuePairs[keyValuePairs.length - 1] === "") keyValuePairs.pop();
        for(let i = keyValuePairs.length; i--;){
            const [key, value] = keyValuePairs[i].split($ab3f2a5cc6216ae5$var$RE_KEY_VALUE).map((s)=>s.trim());
            if (key === "stop-color") colorValue = value;
            else if (key === "stop-opacity") opacity = value;
        }
    }
    const color = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(colorValue || el.getAttribute("stop-color") || "rgb(0,0,0)");
    return {
        offset: $ab3f2a5cc6216ae5$var$parsePercent(el.getAttribute("offset"), 0),
        color: color.toRgb(),
        opacity: $ab3f2a5cc6216ae5$var$ifNaN(parseFloat(opacity || el.getAttribute("stop-opacity") || ""), 1) * color.getAlpha() * multiplier
    };
}
function $ab3f2a5cc6216ae5$var$parseColorStops(el, opacityAttr) {
    const colorStops = [], colorStopEls = el.getElementsByTagName("stop"), multiplier = $ab3f2a5cc6216ae5$var$parsePercent(opacityAttr, 1);
    for(let i = colorStopEls.length; i--;)colorStops.push($ab3f2a5cc6216ae5$var$parseColorStop(colorStopEls[i], multiplier));
    return colorStops;
}
function $ab3f2a5cc6216ae5$var$parseType(el) {
    return el.nodeName === "linearGradient" || el.nodeName === "LINEARGRADIENT" ? "linear" : "radial";
}
function $ab3f2a5cc6216ae5$var$parseGradientUnits(el) {
    return el.getAttribute("gradientUnits") === "userSpaceOnUse" ? "pixels" : "percentage";
}
function $ab3f2a5cc6216ae5$var$convertPercentUnitsToValues(valuesToConvert, _ref) {
    let { width: width, height: height, gradientUnits: gradientUnits } = _ref;
    let finalValue;
    return Object.keys(valuesToConvert).reduce((acc, prop)=>{
        const propValue = valuesToConvert[prop];
        if (propValue === "Infinity") finalValue = 1;
        else if (propValue === "-Infinity") finalValue = 0;
        else {
            finalValue = typeof propValue === "string" ? parseFloat(propValue) : propValue;
            if (typeof propValue === "string" && $ab3f2a5cc6216ae5$var$isPercent(propValue)) {
                finalValue *= 0.01;
                if (gradientUnits === "pixels") {
                    // then we need to fix those percentages here in svg parsing
                    if (prop === "x1" || prop === "x2" || prop === "r2") finalValue *= width;
                    if (prop === "y1" || prop === "y2") finalValue *= height;
                }
            }
        }
        acc[prop] = finalValue;
        return acc;
    }, {});
}
function $ab3f2a5cc6216ae5$var$getValue(el, key) {
    return el.getAttribute(key);
}
function $ab3f2a5cc6216ae5$var$parseLinearCoords(el) {
    return {
        x1: $ab3f2a5cc6216ae5$var$getValue(el, "x1") || 0,
        y1: $ab3f2a5cc6216ae5$var$getValue(el, "y1") || 0,
        x2: $ab3f2a5cc6216ae5$var$getValue(el, "x2") || "100%",
        y2: $ab3f2a5cc6216ae5$var$getValue(el, "y2") || 0
    };
}
function $ab3f2a5cc6216ae5$var$parseRadialCoords(el) {
    return {
        x1: $ab3f2a5cc6216ae5$var$getValue(el, "fx") || $ab3f2a5cc6216ae5$var$getValue(el, "cx") || "50%",
        y1: $ab3f2a5cc6216ae5$var$getValue(el, "fy") || $ab3f2a5cc6216ae5$var$getValue(el, "cy") || "50%",
        r1: 0,
        x2: $ab3f2a5cc6216ae5$var$getValue(el, "cx") || "50%",
        y2: $ab3f2a5cc6216ae5$var$getValue(el, "cy") || "50%",
        r2: $ab3f2a5cc6216ae5$var$getValue(el, "r") || "50%"
    };
}
function $ab3f2a5cc6216ae5$var$parseCoords(el, size) {
    return $ab3f2a5cc6216ae5$var$convertPercentUnitsToValues($ab3f2a5cc6216ae5$var$parseType(el) === "linear" ? $ab3f2a5cc6216ae5$var$parseLinearCoords(el) : $ab3f2a5cc6216ae5$var$parseRadialCoords(el), $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, size), {}, {
        gradientUnits: $ab3f2a5cc6216ae5$var$parseGradientUnits(el)
    }));
}
/**
 * Gradient class
 * @class Gradient
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#gradients}
 */ class $ab3f2a5cc6216ae5$export$3d3dd8f63ff0f876 {
    constructor(_ref){
        let { type: type = "linear", gradientUnits: gradientUnits = "pixels", coords: coords = {}, colorStops: colorStops = [], offsetX: offsetX = 0, offsetY: offsetY = 0, gradientTransform: gradientTransform, id: id } = _ref;
        this.id = id ? "".concat(id, "_").concat($ab3f2a5cc6216ae5$var$uid()) : $ab3f2a5cc6216ae5$var$uid();
        this.type = type;
        this.gradientUnits = gradientUnits;
        this.gradientTransform = gradientTransform;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        this.coords = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, this.type === "radial" ? $ab3f2a5cc6216ae5$var$radialDefaultCoords : $ab3f2a5cc6216ae5$var$linearDefaultCoords), coords);
        this.colorStops = colorStops.slice();
    }
    // isType<S extends GradientType>(type: S): this is Gradient<S> {
    //   return (this.type as GradientType) === type;
    // }
    /**
   * Adds another colorStop
   * @param {Record<string, string>} colorStop Object with offset and color
   * @return {Gradient} thisArg
   */ addColorStop(colorStops) {
        for(const position in colorStops){
            const color = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(colorStops[position]);
            this.colorStops.push({
                offset: parseFloat(position),
                color: color.toRgb(),
                opacity: color.getAlpha()
            });
        }
        return this;
    }
    /**
   * Returns object representation of a gradient
   * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {object}
   */ toObject(propertiesToInclude) {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$var$pick(this, propertiesToInclude)), {}, {
            type: this.type,
            coords: this.coords,
            colorStops: this.colorStops,
            offsetX: this.offsetX,
            offsetY: this.offsetY,
            gradientUnits: this.gradientUnits,
            gradientTransform: this.gradientTransform ? [
                ...this.gradientTransform
            ] : undefined
        });
    }
    /* _TO_SVG_START_ */ /**
   * Returns SVG representation of an gradient
   * @param {FabricObject} object Object to create a gradient for
   * @return {String} SVG representation of an gradient (linear/radial)
   */ toSVG(object) {
        let { additionalTransform: preTransform } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const markup = [], transform = this.gradientTransform ? this.gradientTransform.concat() : $ab3f2a5cc6216ae5$export$3c5a7f9475b116e0.concat(), gradientUnits = this.gradientUnits === "pixels" ? "userSpaceOnUse" : "objectBoundingBox";
        // colorStops must be sorted ascending, and guarded against deep mutations
        const colorStops = this.colorStops.map((colorStop)=>$ab3f2a5cc6216ae5$var$_objectSpread2({}, colorStop)).sort((a, b)=>{
            return a.offset - b.offset;
        });
        let offsetX = -this.offsetX, offsetY = -this.offsetY;
        if (gradientUnits === "objectBoundingBox") {
            offsetX /= object.width;
            offsetY /= object.height;
        } else {
            offsetX += object.width / 2;
            offsetY += object.height / 2;
        }
        // todo what about polygon/polyline?
        if ($ab3f2a5cc6216ae5$var$isPath(object) && this.gradientUnits !== "percentage") {
            offsetX -= object.pathOffset.x;
            offsetY -= object.pathOffset.y;
        }
        transform[4] -= offsetX;
        transform[5] -= offsetY;
        const commonAttributes = [
            'id="SVGID_'.concat(this.id, '"'),
            'gradientUnits="'.concat(gradientUnits, '"'),
            'gradientTransform="'.concat(preTransform ? preTransform + " " : "").concat($ab3f2a5cc6216ae5$var$matrixToSVG(transform), '"'),
            ""
        ].join(" ");
        if (this.type === "linear") {
            const { x1: x1, y1: y1, x2: x2, y2: y2 } = this.coords;
            markup.push("<linearGradient ", commonAttributes, ' x1="', x1, '" y1="', y1, '" x2="', x2, '" y2="', y2, '">\n');
        } else if (this.type === "radial") {
            const { x1: x1, y1: y1, x2: x2, y2: y2, r1: r1, r2: r2 } = this.coords;
            const needsSwap = r1 > r2;
            // svg radial gradient has just 1 radius. the biggest.
            markup.push("<radialGradient ", commonAttributes, ' cx="', needsSwap ? x1 : x2, '" cy="', needsSwap ? y1 : y2, '" r="', needsSwap ? r1 : r2, '" fx="', needsSwap ? x2 : x1, '" fy="', needsSwap ? y2 : y1, '">\n');
            if (needsSwap) {
                // svg goes from internal to external radius. if radius are inverted, swap color stops.
                colorStops.reverse(); //  mutates array
                colorStops.forEach((colorStop)=>{
                    colorStop.offset = 1 - colorStop.offset;
                });
            }
            const minRadius = Math.min(r1, r2);
            if (minRadius > 0) {
                // i have to shift all colorStops and add new one in 0.
                const maxRadius = Math.max(r1, r2), percentageShift = minRadius / maxRadius;
                colorStops.forEach((colorStop)=>{
                    colorStop.offset += percentageShift * (1 - colorStop.offset);
                });
            }
        }
        colorStops.forEach((_ref2)=>{
            let { color: color, offset: offset, opacity: opacity } = _ref2;
            markup.push("<stop ", 'offset="', offset * 100 + "%", '" style="stop-color:', color, typeof opacity !== "undefined" ? ";stop-opacity: " + opacity : ";", '"/>\n');
        });
        markup.push(this.type === "linear" ? "</linearGradient>" : "</radialGradient>", "\n");
        return markup.join("");
    }
    /* _TO_SVG_END_ */ /**
   * Returns an instance of CanvasGradient
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @return {CanvasGradient}
   */ toLive(ctx) {
        const coords = this.coords;
        const gradient = this.type === "linear" ? ctx.createLinearGradient(coords.x1, coords.y1, coords.x2, coords.y2) : ctx.createRadialGradient(coords.x1, coords.y1, coords.r1, coords.x2, coords.y2, coords.r2);
        this.colorStops.forEach((_ref3)=>{
            let { color: color, opacity: opacity, offset: offset } = _ref3;
            gradient.addColorStop(offset, typeof opacity !== "undefined" ? new $ab3f2a5cc6216ae5$export$892596cec99bc70e(color).setAlpha(opacity).toRgba() : color);
        });
        return gradient;
    }
    static async fromObject(options) {
        return new this(options);
    }
    /* _FROM_SVG_START_ */ /**
   * Returns {@link Gradient} instance from an SVG element
   * @static
   * @memberOf Gradient
   * @param {SVGGradientElement} el SVG gradient element
   * @param {FabricObject} instance
   * @param {String} opacity A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
   * @param {SVGOptions} svgOptions an object containing the size of the SVG in order to parse correctly gradients
   * that uses gradientUnits as 'userSpaceOnUse' and percentages.
   * @return {Gradient} Gradient instance
   * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
   * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
   *
   *  @example
   *
   *  <linearGradient id="linearGrad1">
   *    <stop offset="0%" stop-color="white"/>
   *    <stop offset="100%" stop-color="black"/>
   *  </linearGradient>
   *
   *  OR
   *
   *  <linearGradient id="linearGrad2">
   *    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
   *    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
   *  </linearGradient>
   *
   *  OR
   *
   *  <radialGradient id="radialGrad1">
   *    <stop offset="0%" stop-color="white" stop-opacity="1" />
   *    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
   *    <stop offset="100%" stop-color="white" stop-opacity="1" />
   *  </radialGradient>
   *
   *  OR
   *
   *  <radialGradient id="radialGrad2">
   *    <stop offset="0" stop-color="rgb(255,255,255)" />
   *    <stop offset="0.5" stop-color="rgb(0,0,0)" />
   *    <stop offset="1" stop-color="rgb(255,255,255)" />
   *  </radialGradient>
   *
   */ static fromElement(el, instance, svgOptions) {
        const gradientUnits = $ab3f2a5cc6216ae5$var$parseGradientUnits(el);
        const center = instance._findCenterFromElement();
        return new this($ab3f2a5cc6216ae5$var$_objectSpread2({
            id: el.getAttribute("id") || undefined,
            type: $ab3f2a5cc6216ae5$var$parseType(el),
            coords: $ab3f2a5cc6216ae5$var$parseCoords(el, {
                width: svgOptions.viewBoxWidth || svgOptions.width,
                height: svgOptions.viewBoxHeight || svgOptions.height
            }),
            colorStops: $ab3f2a5cc6216ae5$var$parseColorStops(el, svgOptions.opacity),
            gradientUnits: gradientUnits,
            gradientTransform: $ab3f2a5cc6216ae5$export$6655c0d22b13de1f(el.getAttribute("gradientTransform") || "")
        }, gradientUnits === "pixels" ? {
            offsetX: instance.width / 2 - center.x,
            offsetY: instance.height / 2 - center.y
        } : {
            offsetX: 0,
            offsetY: 0
        }));
    }
}
/**
 * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
 * @type Number
 * @default 0
 */ /**
 * Vertical offset for aligning gradients coming from SVG when outside pathgroups
 * @type Number
 * @default 0
 */ /**
 * A transform matrix to apply to the gradient before painting.
 * Imported from svg gradients, is not applied with the current transform in the center.
 * Before this transform is applied, the origin point is at the top left corner of the object
 * plus the addition of offsetY and offsetX.
 * @type Number[]
 * @default null
 */ /**
 * coordinates units for coords.
 * If `pixels`, the number of coords are in the same unit of width / height.
 * If set as `percentage` the coords are still a number, but 1 means 100% of width
 * for the X and 100% of the height for the y. It can be bigger than 1 and negative.
 * allowed values pixels or percentage.
 * @type GradientUnits
 * @default 'pixels'
 */ /**
 * Gradient type linear or radial
 * @type GradientType
 * @default 'linear'
 */ /**
 * Defines how the gradient is located in space and spread
 * @type GradientCoords
 */ /**
 * Defines how many colors a gradient has and how they are located on the axis
 * defined by coords
 * @type GradientCoords
 */ /**
 * If true, this object will not be exported during the serialization of a canvas
 * @type boolean
 */ /**
 * ID used for SVG export functionalities
 * @type number | string
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$3d3dd8f63ff0f876, "type", "Gradient");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$3d3dd8f63ff0f876, "gradient");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$3d3dd8f63ff0f876, "linear");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$3d3dd8f63ff0f876, "radial");
const $ab3f2a5cc6216ae5$var$_excluded$8 = [
    "type",
    "source"
];
/**
 * @see {@link http://fabricjs.com/patterns demo}
 * @see {@link http://fabricjs.com/dynamic-patterns demo}
 */ class $ab3f2a5cc6216ae5$export$47606a6ae3eaed8e {
    /**
   * Legacy identifier of the class. Prefer using this.constructor.type 'Pattern'
   * or utils like isPattern, or instance of to indentify a pattern in your code.
   * Will be removed in future versiones
   * @TODO add sustainable warning message
   * @type string
   * @deprecated
   */ get type() {
        return "pattern";
    }
    set type(value) {
        $ab3f2a5cc6216ae5$var$log("warn", "Setting type has no effect", value);
    }
    /**
   * @type PatternRepeat
   * @defaults
   */ /**
   * The actual pixel source of the pattern
   */ /**
   * If true, this object will not be exported during the serialization of a canvas
   * @type boolean
   */ /**
   * ID used for SVG export functionalities
   * @type number
   */ /**
   * Constructor
   * @param {Object} [options] Options object
   * @param {option.source} [source] the pattern source, eventually empty or a drawable
   */ constructor(options){
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "repeat", "repeat");
        /**
     * Pattern horizontal offset from object's left/top corner
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "offsetX", 0);
        /**
     * Pattern vertical offset from object's left/top corner
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "offsetY", 0);
        /**
     * @type TCrossOrigin
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "crossOrigin", "");
        /**
     * transform matrix to change the pattern, imported from svgs.
     * @todo verify if using the identity matrix as default makes the rest of the code more easy
     * @type Array
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "patternTransform", null);
        this.id = $ab3f2a5cc6216ae5$var$uid();
        Object.assign(this, options);
    }
    /**
   * @returns true if {@link source} is an <img> element
   */ isImageSource() {
        return !!this.source && typeof this.source.src === "string";
    }
    /**
   * @returns true if {@link source} is a <canvas> element
   */ isCanvasSource() {
        return !!this.source && !!this.source.toDataURL;
    }
    sourceToString() {
        return this.isImageSource() ? this.source.src : this.isCanvasSource() ? this.source.toDataURL() : "";
    }
    /**
   * Returns an instance of CanvasPattern
   * @param {CanvasRenderingContext2D} ctx Context to create pattern
   * @return {CanvasPattern}
   */ toLive(ctx) {
        if (// if the image failed to load, return, and allow rest to continue loading
        !this.source || // if an image
        this.isImageSource() && (!this.source.complete || this.source.naturalWidth === 0 || this.source.naturalHeight === 0)) return null;
        return ctx.createPattern(this.source, this.repeat);
    }
    /**
   * Returns object representation of a pattern
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {object} Object representation of a pattern instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const { repeat: repeat, crossOrigin: crossOrigin } = this;
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$var$pick(this, propertiesToInclude)), {}, {
            type: "pattern",
            source: this.sourceToString(),
            repeat: repeat,
            crossOrigin: crossOrigin,
            offsetX: $ab3f2a5cc6216ae5$var$toFixed(this.offsetX, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS),
            offsetY: $ab3f2a5cc6216ae5$var$toFixed(this.offsetY, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS),
            patternTransform: this.patternTransform ? [
                ...this.patternTransform
            ] : null
        });
    }
    /* _TO_SVG_START_ */ /**
   * Returns SVG representation of a pattern
   */ toSVG(_ref) {
        let { width: width, height: height } = _ref;
        const { source: patternSource, repeat: repeat, id: id } = this, patternOffsetX = $ab3f2a5cc6216ae5$var$ifNaN(this.offsetX / width, 0), patternOffsetY = $ab3f2a5cc6216ae5$var$ifNaN(this.offsetY / height, 0), patternWidth = repeat === "repeat-y" || repeat === "no-repeat" ? 1 + Math.abs(patternOffsetX || 0) : $ab3f2a5cc6216ae5$var$ifNaN(patternSource.width / width, 0), patternHeight = repeat === "repeat-x" || repeat === "no-repeat" ? 1 + Math.abs(patternOffsetY || 0) : $ab3f2a5cc6216ae5$var$ifNaN(patternSource.height / height, 0);
        return [
            '<pattern id="SVGID_'.concat(id, '" x="').concat(patternOffsetX, '" y="').concat(patternOffsetY, '" width="').concat(patternWidth, '" height="').concat(patternHeight, '">'),
            '<image x="0" y="0" width="'.concat(patternSource.width, '" height="').concat(patternSource.height, '" xlink:href="').concat(this.sourceToString(), '"></image>'),
            "</pattern>",
            ""
        ].join("\n");
    }
    /* _TO_SVG_END_ */ static async fromObject(_ref2, options) {
        let { type: type, source: source } = _ref2, serialized = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref2, $ab3f2a5cc6216ae5$var$_excluded$8);
        const img = await $ab3f2a5cc6216ae5$var$loadImage(source, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), {}, {
            crossOrigin: serialized.crossOrigin
        }));
        return new this($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, serialized), {}, {
            source: img
        }));
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$47606a6ae3eaed8e, "type", "Pattern");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$47606a6ae3eaed8e);
// kept for compatibility reason
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$47606a6ae3eaed8e, "pattern");
/**
 * @see {@link http://fabricjs.com/freedrawing|Freedrawing demo}
 */ class $ab3f2a5cc6216ae5$export$c7531c1a025bcfe2 {
    /**
   * @todo add type
   */ constructor(canvas){
        /**
     * Color of a brush
     * @type String
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "color", "rgb(0, 0, 0)");
        /**
     * Width of a brush, has to be a Number, no string literals
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "width", 1);
        /**
     * Shadow object representing shadow of this shape.
     * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
     * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
     * @type Shadow
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "shadow", null);
        /**
     * Line endings style of a brush (one of "butt", "round", "square")
     * @type String
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "strokeLineCap", "round");
        /**
     * Corner style of a brush (one of "bevel", "round", "miter")
     * @type String
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "strokeLineJoin", "round");
        /**
     * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "strokeMiterLimit", 10);
        /**
     * Stroke Dash Array.
     * @type Array
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "strokeDashArray", null);
        /**
     * When `true`, the free drawing is limited to the whiteboard size. Default to false.
     * @type Boolean
     * @default false
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "limitedToCanvasSize", false);
        this.canvas = canvas;
    }
    /**
   * @returns true if brush should continue blocking interaction
   */ /**
   * Sets brush styles
   * @private
   * @param {CanvasRenderingContext2D} ctx
   */ _setBrushStyles(ctx) {
        ctx.strokeStyle = this.color;
        ctx.lineWidth = this.width;
        ctx.lineCap = this.strokeLineCap;
        ctx.miterLimit = this.strokeMiterLimit;
        ctx.lineJoin = this.strokeLineJoin;
        ctx.setLineDash(this.strokeDashArray || []);
    }
    /**
   * Sets the transformation on given context
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @private
   */ _saveAndTransform(ctx) {
        const v = this.canvas.viewportTransform;
        ctx.save();
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
    }
    needsFullRender() {
        const color = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(this.color);
        return color.getAlpha() < 1 || !!this.shadow;
    }
    /**
   * Sets brush shadow styles
   * @private
   */ _setShadow() {
        if (!this.shadow || !this.canvas) return;
        const canvas = this.canvas, shadow = this.shadow, ctx = canvas.contextTop, zoom = canvas.getZoom() * canvas.getRetinaScaling();
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur * zoom;
        ctx.shadowOffsetX = shadow.offsetX * zoom;
        ctx.shadowOffsetY = shadow.offsetY * zoom;
    }
    /**
   * Removes brush shadow styles
   * @private
   */ _resetShadow() {
        const ctx = this.canvas.contextTop;
        ctx.shadowColor = "";
        ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    }
    /**
   * Check is pointer is outside canvas boundaries
   * @param {Object} pointer
   * @private
   */ _isOutSideCanvas(pointer) {
        return pointer.x < 0 || pointer.x > this.canvas.getWidth() || pointer.y < 0 || pointer.y > this.canvas.getHeight();
    }
}
const $ab3f2a5cc6216ae5$var$_excluded$7 = [
    "path",
    "left",
    "top"
], $ab3f2a5cc6216ae5$var$_excluded2$2 = [
    "d"
];
class $ab3f2a5cc6216ae5$export$4b2950bdac9b6ee9 extends $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1 {
    /**
   * Constructor
   * @param {TComplexPathData} path Path data (sequence of coordinates and corresponding "command" tokens)
   * @param {Partial<PathProps>} [options] Options object
   * @return {Path} thisArg
   */ constructor(path){
        let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, { path: _, left: left, top: top } = _ref, options = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref, $ab3f2a5cc6216ae5$var$_excluded$7);
        super();
        Object.assign(this, $ab3f2a5cc6216ae5$export$4b2950bdac9b6ee9.ownDefaults);
        this.setOptions(options);
        this._setPath(path || [], true);
        typeof left === "number" && this.set($ab3f2a5cc6216ae5$var$LEFT, left);
        typeof top === "number" && this.set($ab3f2a5cc6216ae5$var$TOP, top);
    }
    /**
   * @private
   * @param {TComplexPathData | string} path Path data (sequence of coordinates and corresponding "command" tokens)
   * @param {boolean} [adjustPosition] pass true to reposition the object according to the bounding box
   * @returns {Point} top left position of the bounding box, useful for complementary positioning
   */ _setPath(path, adjustPosition) {
        this.path = $ab3f2a5cc6216ae5$var$makePathSimpler(Array.isArray(path) ? path : $ab3f2a5cc6216ae5$var$parsePath(path));
        this.setBoundingBox(adjustPosition);
    }
    /**
   * This function is an helper for svg import. it returns the center of the object in the svg
   * untransformed coordinates, by look at the polyline/polygon points.
   * @private
   * @return {Point} center point from element coordinates
   */ _findCenterFromElement() {
        const bbox = this._calcBoundsFromPath();
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx context to render path on
   */ _renderPathCommands(ctx) {
        const l = -this.pathOffset.x, t = -this.pathOffset.y;
        ctx.beginPath();
        for (const command of this.path)switch(command[0] // first letter
        ){
            case "L":
                // lineto, absolute
                ctx.lineTo(command[1] + l, command[2] + t);
                break;
            case "M":
                // moveTo, absolute
                ctx.moveTo(command[1] + l, command[2] + t);
                break;
            case "C":
                // bezierCurveTo, absolute
                ctx.bezierCurveTo(command[1] + l, command[2] + t, command[3] + l, command[4] + t, command[5] + l, command[6] + t);
                break;
            case "Q":
                // quadraticCurveTo, absolute
                ctx.quadraticCurveTo(command[1] + l, command[2] + t, command[3] + l, command[4] + t);
                break;
            case "Z":
                ctx.closePath();
                break;
        }
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx context to render path on
   */ _render(ctx) {
        this._renderPathCommands(ctx);
        this._renderPaintInOrder(ctx);
    }
    /**
   * Returns string representation of an instance
   * @return {string} string representation of an instance
   */ toString() {
        return "#<Path (".concat(this.complexity(), '): { "top": ').concat(this.top, ', "left": ').concat(this.left, " }>");
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.toObject(propertiesToInclude)), {}, {
            path: this.path.map((pathCmd)=>pathCmd.slice())
        });
    }
    /**
   * Returns dataless object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toDatalessObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const o = this.toObject(propertiesToInclude);
        if (this.sourcePath) {
            delete o.path;
            o.sourcePath = this.sourcePath;
        }
        return o;
    }
    /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const path = $ab3f2a5cc6216ae5$var$joinPath(this.path, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS);
        return [
            "<path ",
            "COMMON_PARTS",
            'd="'.concat(path, '" stroke-linecap="round" />\n')
        ];
    }
    /**
   * @private
   * @return the path command's translate transform attribute
   */ _getOffsetTransform() {
        const digits = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
        return " translate(".concat($ab3f2a5cc6216ae5$var$toFixed(-this.pathOffset.x, digits), ", ").concat($ab3f2a5cc6216ae5$var$toFixed(-this.pathOffset.y, digits), ")");
    }
    /**
   * Returns svg clipPath representation of an instance
   * @param {Function} [reviver] Method for further parsing of svg representation.
   * @return {string} svg representation of an instance
   */ toClipPathSVG(reviver) {
        const additionalTransform = this._getOffsetTransform();
        return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(), {
            reviver: reviver,
            additionalTransform: additionalTransform
        });
    }
    /**
   * Returns svg representation of an instance
   * @param {Function} [reviver] Method for further parsing of svg representation.
   * @return {string} svg representation of an instance
   */ toSVG(reviver) {
        const additionalTransform = this._getOffsetTransform();
        return this._createBaseSVGMarkup(this._toSVG(), {
            reviver: reviver,
            additionalTransform: additionalTransform
        });
    }
    /**
   * Returns number representation of an instance complexity
   * @return {number} complexity of this instance
   */ complexity() {
        return this.path.length;
    }
    setDimensions() {
        this.setBoundingBox();
    }
    setBoundingBox(adjustPosition) {
        const { width: width, height: height, pathOffset: pathOffset } = this._calcDimensions();
        this.set({
            width: width,
            height: height,
            pathOffset: pathOffset
        });
        // using pathOffset because it match the use case.
        // if pathOffset change here we need to use left + width/2 , top + height/2
        adjustPosition && this.setPositionByOrigin(pathOffset, $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER);
    }
    _calcBoundsFromPath() {
        const bounds = [];
        let subpathStartX = 0, subpathStartY = 0, x = 0, // current x
        y = 0; // current y
        for (const command of this.path)// current instruction
        switch(command[0] // first letter
        ){
            case "L":
                // lineto, absolute
                x = command[1];
                y = command[2];
                bounds.push(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(subpathStartX, subpathStartY), new $ab3f2a5cc6216ae5$export$baf26146a414f24a(x, y));
                break;
            case "M":
                // moveTo, absolute
                x = command[1];
                y = command[2];
                subpathStartX = x;
                subpathStartY = y;
                break;
            case "C":
                // bezierCurveTo, absolute
                bounds.push(...$ab3f2a5cc6216ae5$var$getBoundsOfCurve(x, y, command[1], command[2], command[3], command[4], command[5], command[6]));
                x = command[5];
                y = command[6];
                break;
            case "Q":
                // quadraticCurveTo, absolute
                bounds.push(...$ab3f2a5cc6216ae5$var$getBoundsOfCurve(x, y, command[1], command[2], command[1], command[2], command[3], command[4]));
                x = command[3];
                y = command[4];
                break;
            case "Z":
                x = subpathStartX;
                y = subpathStartY;
                break;
        }
        return $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints(bounds);
    }
    /**
   * @private
   */ _calcDimensions() {
        const bbox = this._calcBoundsFromPath();
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, bbox), {}, {
            pathOffset: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2)
        });
    }
    /**
   * List of attribute names to account for when parsing SVG element (used by `Path.fromElement`)
   * @static
   * @memberOf Path
   * @see http://www.w3.org/TR/SVG/paths.html#PathElement
   */ /**
   * Creates an instance of Path from an object
   * @static
   * @memberOf Path
   * @param {Object} object
   * @returns {Promise<Path>}
   */ static fromObject(object) {
        return this._fromObject(object, {
            extraParam: "path"
        });
    }
    /**
   * Creates an instance of Path from an SVG <path> element
   * @static
   * @memberOf Path
   * @param {HTMLElement} element to parse
   * @param {Partial<PathProps>} [options] Options object
   */ static async fromElement(element, options, cssRules) {
        const _parseAttributes = $ab3f2a5cc6216ae5$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules), { d: d } = _parseAttributes, parsedAttributes = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_parseAttributes, $ab3f2a5cc6216ae5$var$_excluded2$2);
        return new this(d, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, parsedAttributes), options), {}, {
            // we pass undefined to instruct the constructor to position the object using the bbox
            left: undefined,
            top: undefined
        }));
    }
}
/**
 * Array of path points
 * @type Array
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$4b2950bdac9b6ee9, "type", "Path");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$4b2950bdac9b6ee9, "cacheProperties", [
    ...$ab3f2a5cc6216ae5$var$cacheProperties,
    "path",
    "fillRule"
]);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$4b2950bdac9b6ee9, "ATTRIBUTE_NAMES", [
    ...$ab3f2a5cc6216ae5$var$SHARED_ATTRIBUTES,
    "d"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$4b2950bdac9b6ee9);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setSVGClass($ab3f2a5cc6216ae5$export$4b2950bdac9b6ee9);
/* _FROM_SVG_START_ */ /**
 * @private
 * @param {TSimplePathData} pathData SVG path commands
 * @returns {boolean}
 */ function $ab3f2a5cc6216ae5$var$isEmptySVGPath(pathData) {
    return $ab3f2a5cc6216ae5$var$joinPath(pathData) === "M 0 0 Q 0 0 0 0 L 0 0";
}
class $ab3f2a5cc6216ae5$export$672d658927d3b57b extends $ab3f2a5cc6216ae5$export$c7531c1a025bcfe2 {
    constructor(canvas){
        super(canvas);
        /**
     * Discard points that are less than `decimate` pixel distant from each other
     * @type Number
     * @default 0.4
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "decimate", 0.4);
        /**
     * Draws a straight line between last recorded point to current pointer
     * Used for `shift` functionality
     *
     * @type boolean
     * @default false
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "drawStraightLine", false);
        /**
     * The event modifier key that makes the brush draw a straight line.
     * If `null` or 'none' or any other string that is not a modifier key the feature is disabled.
     * @type {ModifierKey | undefined | null}
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "straightLineKey", "shiftKey");
        this._points = [];
        this._hasStraightLine = false;
    }
    needsFullRender() {
        return super.needsFullRender() || this._hasStraightLine;
    }
    static drawSegment(ctx, p1, p2) {
        const midPoint = p1.midPointFrom(p2);
        ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
        return midPoint;
    }
    /**
   * Invoked on mouse down
   * @param {Point} pointer
   */ onMouseDown(pointer, _ref) {
        let { e: e } = _ref;
        if (!this.canvas._isMainEvent(e)) return;
        this.drawStraightLine = !!this.straightLineKey && e[this.straightLineKey];
        this._prepareForDrawing(pointer);
        // capture coordinates immediately
        // this allows to draw dots (when movement never occurs)
        this._addPoint(pointer);
        this._render();
    }
    /**
   * Invoked on mouse move
   * @param {Point} pointer
   */ onMouseMove(pointer, _ref2) {
        let { e: e } = _ref2;
        if (!this.canvas._isMainEvent(e)) return;
        this.drawStraightLine = !!this.straightLineKey && e[this.straightLineKey];
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        if (this._addPoint(pointer) && this._points.length > 1) {
            if (this.needsFullRender()) {
                // redraw curve
                // clear top canvas
                this.canvas.clearContext(this.canvas.contextTop);
                this._render();
            } else {
                const points = this._points, length = points.length, ctx = this.canvas.contextTop;
                // draw the curve update
                this._saveAndTransform(ctx);
                if (this.oldEnd) {
                    ctx.beginPath();
                    ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
                }
                this.oldEnd = $ab3f2a5cc6216ae5$export$672d658927d3b57b.drawSegment(ctx, points[length - 2], points[length - 1]);
                ctx.stroke();
                ctx.restore();
            }
        }
    }
    /**
   * Invoked on mouse up
   */ onMouseUp(_ref3) {
        let { e: e } = _ref3;
        if (!this.canvas._isMainEvent(e)) return true;
        this.drawStraightLine = false;
        this.oldEnd = undefined;
        this._finalizeAndAddPath();
        return false;
    }
    /**
   * @private
   * @param {Point} pointer Actual mouse position related to the canvas.
   */ _prepareForDrawing(pointer) {
        this._reset();
        this._addPoint(pointer);
        this.canvas.contextTop.moveTo(pointer.x, pointer.y);
    }
    /**
   * @private
   * @param {Point} point Point to be added to points array
   */ _addPoint(point) {
        if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) return false;
        if (this.drawStraightLine && this._points.length > 1) {
            this._hasStraightLine = true;
            this._points.pop();
        }
        this._points.push(point);
        return true;
    }
    /**
   * Clear points array and set contextTop canvas style.
   * @private
   */ _reset() {
        this._points = [];
        this._setBrushStyles(this.canvas.contextTop);
        this._setShadow();
        this._hasStraightLine = false;
    }
    /**
   * Draw a smooth path on the topCanvas using quadraticCurveTo
   * @private
   * @param {CanvasRenderingContext2D} [ctx]
   */ _render() {
        let ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.canvas.contextTop;
        let p1 = this._points[0], p2 = this._points[1];
        this._saveAndTransform(ctx);
        ctx.beginPath();
        //if we only have 2 points in the path and they are the same
        //it means that the user only clicked the canvas without moving the mouse
        //then we should be drawing a dot. A path isn't drawn between two identical dots
        //that's why we set them apart a bit
        if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
            const width = this.width / 1000;
            p1.x -= width;
            p2.x += width;
        }
        ctx.moveTo(p1.x, p1.y);
        for(let i = 1; i < this._points.length; i++){
            // we pick the point between pi + 1 & pi + 2 as the
            // end point and p1 as our control point.
            $ab3f2a5cc6216ae5$export$672d658927d3b57b.drawSegment(ctx, p1, p2);
            p1 = this._points[i];
            p2 = this._points[i + 1];
        }
        // Draw last line as a straight line while
        // we wait for the next point to be able to calculate
        // the bezier control point
        ctx.lineTo(p1.x, p1.y);
        ctx.stroke();
        ctx.restore();
    }
    /**
   * Converts points to SVG path
   * @param {Point[]} points Array of points
   * @return {TSimplePathData} SVG path commands
   */ convertPointsToSVGPath(points) {
        const correction = this.width / 1000;
        return $ab3f2a5cc6216ae5$var$getSmoothPathFromPoints(points, correction);
    }
    /**
   * Creates a Path object to add on canvas
   * @param {TSimplePathData} pathData Path data
   * @return {Path} Path to add on canvas
   */ createPath(pathData) {
        const path = new $ab3f2a5cc6216ae5$export$4b2950bdac9b6ee9(pathData, {
            fill: null,
            stroke: this.color,
            strokeWidth: this.width,
            strokeLineCap: this.strokeLineCap,
            strokeMiterLimit: this.strokeMiterLimit,
            strokeLineJoin: this.strokeLineJoin,
            strokeDashArray: this.strokeDashArray
        });
        if (this.shadow) {
            this.shadow.affectStroke = true;
            path.shadow = new $ab3f2a5cc6216ae5$export$a24c14443968327c(this.shadow);
        }
        return path;
    }
    /**
   * Decimate points array with the decimate value
   */ decimatePoints(points, distance) {
        if (points.length <= 2) return points;
        let lastPoint = points[0], cDistance;
        const zoom = this.canvas.getZoom(), adjustedDistance = Math.pow(distance / zoom, 2), l = points.length - 1, newPoints = [
            lastPoint
        ];
        for(let i = 1; i < l - 1; i++){
            cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
            if (cDistance >= adjustedDistance) {
                lastPoint = points[i];
                newPoints.push(lastPoint);
            }
        }
        // Add the last point from the original line to the end of the array.
        // This ensures decimate doesn't delete the last point on the line, and ensures the line is > 1 point.
        newPoints.push(points[l]);
        return newPoints;
    }
    /**
   * On mouseup after drawing the path on contextTop canvas
   * we use the points captured to create an new Path object
   * and add it to the canvas.
   */ _finalizeAndAddPath() {
        const ctx = this.canvas.contextTop;
        ctx.closePath();
        if (this.decimate) this._points = this.decimatePoints(this._points, this.decimate);
        const pathData = this.convertPointsToSVGPath(this._points);
        if ($ab3f2a5cc6216ae5$var$isEmptySVGPath(pathData)) {
            // do not create 0 width/height paths, as they are
            // rendered inconsistently across browsers
            // Firefox 4, for example, renders a dot,
            // whereas Chrome 10 renders nothing
            this.canvas.requestRenderAll();
            return;
        }
        const path = this.createPath(pathData);
        this.canvas.clearContext(this.canvas.contextTop);
        this.canvas.fire("before:path:created", {
            path: path
        });
        this.canvas.add(path);
        this.canvas.requestRenderAll();
        path.setCoords();
        this._resetShadow();
        // fire event 'path' created
        this.canvas.fire("path:created", {
            path: path
        });
    }
}
const $ab3f2a5cc6216ae5$var$_excluded$6 = [
    "left",
    "top",
    "radius"
];
const $ab3f2a5cc6216ae5$var$CIRCLE_PROPS = [
    "radius",
    "startAngle",
    "endAngle",
    "counterClockwise"
];
const $ab3f2a5cc6216ae5$var$circleDefaultValues = {
    radius: 0,
    startAngle: 0,
    endAngle: 360,
    counterClockwise: false
};
class $ab3f2a5cc6216ae5$export$c89a927ffc67e6fa extends $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$c89a927ffc67e6fa.ownDefaults);
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        Object.assign(this, $ab3f2a5cc6216ae5$export$c89a927ffc67e6fa.ownDefaults);
        this.setOptions(options);
    }
    /**
   * @private
   * @param {String} key
   * @param {*} value
   */ _set(key, value) {
        super._set(key, value);
        if (key === "radius") this.setRadius(value);
        return this;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx context to render on
   */ _render(ctx) {
        ctx.beginPath();
        ctx.arc(0, 0, this.radius, $ab3f2a5cc6216ae5$var$degreesToRadians(this.startAngle), $ab3f2a5cc6216ae5$var$degreesToRadians(this.endAngle), this.counterClockwise);
        this._renderPaintInOrder(ctx);
    }
    /**
   * Returns horizontal radius of an object (according to how an object is scaled)
   * @return {Number}
   */ getRadiusX() {
        return this.get("radius") * this.get($ab3f2a5cc6216ae5$var$SCALE_X);
    }
    /**
   * Returns vertical radius of an object (according to how an object is scaled)
   * @return {Number}
   */ getRadiusY() {
        return this.get("radius") * this.get($ab3f2a5cc6216ae5$var$SCALE_Y);
    }
    /**
   * Sets radius of an object (and updates width accordingly)
   */ setRadius(value) {
        this.radius = value;
        this.set({
            width: value * 2,
            height: value * 2
        });
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return super.toObject([
            ...$ab3f2a5cc6216ae5$var$CIRCLE_PROPS,
            ...propertiesToInclude
        ]);
    }
    /* _TO_SVG_START_ */ /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const angle = (this.endAngle - this.startAngle) % 360;
        if (angle === 0) return [
            "<circle ",
            "COMMON_PARTS",
            'cx="0" cy="0" ',
            'r="',
            "".concat(this.radius),
            '" />\n'
        ];
        else {
            const { radius: radius } = this;
            const start = $ab3f2a5cc6216ae5$var$degreesToRadians(this.startAngle), end = $ab3f2a5cc6216ae5$var$degreesToRadians(this.endAngle), startX = $ab3f2a5cc6216ae5$var$cos(start) * radius, startY = $ab3f2a5cc6216ae5$var$sin(start) * radius, endX = $ab3f2a5cc6216ae5$var$cos(end) * radius, endY = $ab3f2a5cc6216ae5$var$sin(end) * radius, largeFlag = angle > 180 ? 1 : 0, sweepFlag = this.counterClockwise ? 0 : 1;
            return [
                '<path d="M '.concat(startX, " ").concat(startY, " A ").concat(radius, " ").concat(radius, " 0 ").concat(largeFlag, " ").concat(sweepFlag, " ").concat(endX, " ").concat(endY, '" '),
                "COMMON_PARTS",
                " />\n"
            ];
        }
    }
    /* _TO_SVG_END_ */ /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link Circle.fromElement})
   * @static
   * @memberOf Circle
   * @see: http://www.w3.org/TR/SVG/shapes.html#CircleElement
   */ /**
   * Returns {@link Circle} instance from an SVG element
   * @static
   * @memberOf Circle
   * @param {HTMLElement} element Element to parse
   * @param {Object} [options] Partial Circle object to default missing properties on the element.
   * @throws {Error} If value of `r` attribute is missing or invalid
   */ static async fromElement(element, options, cssRules) {
        const _ref = $ab3f2a5cc6216ae5$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules), { left: left = 0, top: top = 0, radius: radius = 0 } = _ref, otherParsedAttributes = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref, $ab3f2a5cc6216ae5$var$_excluded$6);
        // this probably requires to be fixed for default origins not being top/left.
        return new this($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, otherParsedAttributes), {}, {
            radius: radius,
            left: left - radius,
            top: top - radius
        }));
    }
    /* _FROM_SVG_END_ */ /**
   * @todo how do we declare this??
   */ static fromObject(object) {
        return super._fromObject(object);
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c89a927ffc67e6fa, "type", "Circle");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c89a927ffc67e6fa, "cacheProperties", [
    ...$ab3f2a5cc6216ae5$var$cacheProperties,
    ...$ab3f2a5cc6216ae5$var$CIRCLE_PROPS
]);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c89a927ffc67e6fa, "ownDefaults", $ab3f2a5cc6216ae5$var$circleDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c89a927ffc67e6fa, "ATTRIBUTE_NAMES", [
    "cx",
    "cy",
    "r",
    ...$ab3f2a5cc6216ae5$var$SHARED_ATTRIBUTES
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$c89a927ffc67e6fa);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setSVGClass($ab3f2a5cc6216ae5$export$c89a927ffc67e6fa);
class $ab3f2a5cc6216ae5$export$c5553759ab21b788 extends $ab3f2a5cc6216ae5$export$c7531c1a025bcfe2 {
    constructor(canvas){
        super(canvas);
        /**
     * Width of a brush
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "width", 10);
        this.points = [];
    }
    /**
   * Invoked inside on mouse down and mouse move
   * @param {Point} pointer
   */ drawDot(pointer) {
        const point = this.addPoint(pointer), ctx = this.canvas.contextTop;
        this._saveAndTransform(ctx);
        this.dot(ctx, point);
        ctx.restore();
    }
    dot(ctx, point) {
        ctx.fillStyle = point.fill;
        ctx.beginPath();
        ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
        ctx.closePath();
        ctx.fill();
    }
    /**
   * Invoked on mouse down
   */ onMouseDown(pointer) {
        this.points = [];
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.drawDot(pointer);
    }
    /**
   * Render the full state of the brush
   * @private
   */ _render() {
        const ctx = this.canvas.contextTop, points = this.points;
        this._saveAndTransform(ctx);
        for(let i = 0; i < points.length; i++)this.dot(ctx, points[i]);
        ctx.restore();
    }
    /**
   * Invoked on mouse move
   * @param {Point} pointer
   */ onMouseMove(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        if (this.needsFullRender()) {
            this.canvas.clearContext(this.canvas.contextTop);
            this.addPoint(pointer);
            this._render();
        } else this.drawDot(pointer);
    }
    /**
   * Invoked on mouse up
   */ onMouseUp() {
        const originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
        this.canvas.renderOnAddRemove = false;
        const circles = [];
        for(let i = 0; i < this.points.length; i++){
            const point = this.points[i], circle = new $ab3f2a5cc6216ae5$export$c89a927ffc67e6fa({
                radius: point.radius,
                left: point.x,
                top: point.y,
                originX: $ab3f2a5cc6216ae5$var$CENTER,
                originY: $ab3f2a5cc6216ae5$var$CENTER,
                fill: point.fill
            });
            this.shadow && (circle.shadow = new $ab3f2a5cc6216ae5$export$a24c14443968327c(this.shadow));
            circles.push(circle);
        }
        const group = new $ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4(circles, {
            canvas: this.canvas
        });
        this.canvas.fire("before:path:created", {
            path: group
        });
        this.canvas.add(group);
        this.canvas.fire("path:created", {
            path: group
        });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
    }
    /**
   * @param {Object} pointer
   * @return {Point} Just added pointer point
   */ addPoint(_ref) {
        let { x: x, y: y } = _ref;
        const pointerPoint = {
            x: x,
            y: y,
            radius: $ab3f2a5cc6216ae5$var$getRandomInt(Math.max(0, this.width - 20), this.width + 20) / 2,
            fill: new $ab3f2a5cc6216ae5$export$892596cec99bc70e(this.color).setAlpha($ab3f2a5cc6216ae5$var$getRandomInt(0, 100) / 100).toRgba()
        };
        this.points.push(pointerPoint);
        return pointerPoint;
    }
}
/**
 *
 * @param rects
 * @returns
 */ function $ab3f2a5cc6216ae5$var$getUniqueRects(rects) {
    const uniqueRects = {};
    const uniqueRectsArray = [];
    for(let i = 0, key; i < rects.length; i++){
        key = "".concat(rects[i].left).concat(rects[i].top);
        if (!uniqueRects[key]) {
            uniqueRects[key] = true;
            uniqueRectsArray.push(rects[i]);
        }
    }
    return uniqueRectsArray;
}
class $ab3f2a5cc6216ae5$export$6bbd078120d9a520 extends $ab3f2a5cc6216ae5$export$c7531c1a025bcfe2 {
    /**
   * Constructor
   * @param {Canvas} canvas
   * @return {SprayBrush} Instance of a spray brush
   */ constructor(canvas){
        super(canvas);
        /**
     * Width of a spray
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "width", 10);
        /**
     * Density of a spray (number of dots per chunk)
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "density", 20);
        /**
     * Width of spray dots
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "dotWidth", 1);
        /**
     * Width variance of spray dots
     * @type Number
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "dotWidthVariance", 1);
        /**
     * Whether opacity of a dot should be random
     * @type Boolean
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "randomOpacity", false);
        /**
     * Whether overlapping dots (rectangles) should be removed (for performance reasons)
     * @type Boolean
     * @default
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "optimizeOverlapping", true);
        this.sprayChunks = [];
        this.sprayChunk = [];
    }
    /**
   * Invoked on mouse down
   * @param {Point} pointer
   */ onMouseDown(pointer) {
        this.sprayChunks = [];
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.addSprayChunk(pointer);
        this.renderChunck(this.sprayChunk);
    }
    /**
   * Invoked on mouse move
   * @param {Point} pointer
   */ onMouseMove(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        this.addSprayChunk(pointer);
        this.renderChunck(this.sprayChunk);
    }
    /**
   * Invoked on mouse up
   */ onMouseUp() {
        const originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
        this.canvas.renderOnAddRemove = false;
        const rects = [];
        for(let i = 0; i < this.sprayChunks.length; i++){
            const sprayChunk = this.sprayChunks[i];
            for(let j = 0; j < sprayChunk.length; j++){
                const chunck = sprayChunk[j];
                const rect = new $ab3f2a5cc6216ae5$export$c79fc6492f3af13d({
                    width: chunck.width,
                    height: chunck.width,
                    left: chunck.x + 1,
                    top: chunck.y + 1,
                    originX: $ab3f2a5cc6216ae5$var$CENTER,
                    originY: $ab3f2a5cc6216ae5$var$CENTER,
                    fill: this.color
                });
                rects.push(rect);
            }
        }
        const group = new $ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4(this.optimizeOverlapping ? $ab3f2a5cc6216ae5$var$getUniqueRects(rects) : rects, {
            objectCaching: true,
            subTargetCheck: false,
            interactive: false
        });
        this.shadow && group.set("shadow", new $ab3f2a5cc6216ae5$export$a24c14443968327c(this.shadow));
        this.canvas.fire("before:path:created", {
            path: group
        });
        this.canvas.add(group);
        this.canvas.fire("path:created", {
            path: group
        });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
    }
    renderChunck(sprayChunck) {
        const ctx = this.canvas.contextTop;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for(let i = 0; i < sprayChunck.length; i++){
            const point = sprayChunck[i];
            ctx.globalAlpha = point.opacity;
            ctx.fillRect(point.x, point.y, point.width, point.width);
        }
        ctx.restore();
    }
    /**
   * Render all spray chunks
   */ _render() {
        const ctx = this.canvas.contextTop;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for(let i = 0; i < this.sprayChunks.length; i++)this.renderChunck(this.sprayChunks[i]);
        ctx.restore();
    }
    /**
   * @param {Point} pointer
   */ addSprayChunk(pointer) {
        this.sprayChunk = [];
        const radius = this.width / 2;
        for(let i = 0; i < this.density; i++)this.sprayChunk.push({
            x: $ab3f2a5cc6216ae5$var$getRandomInt(pointer.x - radius, pointer.x + radius),
            y: $ab3f2a5cc6216ae5$var$getRandomInt(pointer.y - radius, pointer.y + radius),
            width: this.dotWidthVariance ? $ab3f2a5cc6216ae5$var$getRandomInt(// bottom clamp width to 1
            Math.max(1, this.dotWidth - this.dotWidthVariance), this.dotWidth + this.dotWidthVariance) : this.dotWidth,
            opacity: this.randomOpacity ? $ab3f2a5cc6216ae5$var$getRandomInt(0, 100) / 100 : 1
        });
        this.sprayChunks.push(this.sprayChunk);
    }
}
class $ab3f2a5cc6216ae5$export$3c92be346cf41088 extends $ab3f2a5cc6216ae5$export$672d658927d3b57b {
    constructor(canvas){
        super(canvas);
    }
    getPatternSrc() {
        const dotWidth = 20, dotDistance = 5, patternCanvas = $ab3f2a5cc6216ae5$var$createCanvasElement(), patternCtx = patternCanvas.getContext("2d");
        patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;
        if (patternCtx) {
            patternCtx.fillStyle = this.color;
            patternCtx.beginPath();
            patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
            patternCtx.closePath();
            patternCtx.fill();
        }
        return patternCanvas;
    }
    /**
   * Creates "pattern" instance property
   * @param {CanvasRenderingContext2D} ctx
   */ getPattern(ctx) {
        return ctx.createPattern(this.source || this.getPatternSrc(), "repeat");
    }
    /**
   * Sets brush styles
   * @param {CanvasRenderingContext2D} ctx
   */ _setBrushStyles(ctx) {
        super._setBrushStyles(ctx);
        const pattern = this.getPattern(ctx);
        pattern && (ctx.strokeStyle = pattern);
    }
    /**
   * Creates path
   */ createPath(pathData) {
        const path = super.createPath(pathData), topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);
        path.stroke = new $ab3f2a5cc6216ae5$export$47606a6ae3eaed8e({
            source: this.source || this.getPatternSrc(),
            offsetX: -topLeft.x,
            offsetY: -topLeft.y
        });
        return path;
    }
}
const $ab3f2a5cc6216ae5$var$_excluded$5 = [
    "x1",
    "y1",
    "x2",
    "y2"
], $ab3f2a5cc6216ae5$var$_excluded2$1 = [
    "x1",
    "y1",
    "x2",
    "y2"
];
// @TODO this code is terrible and Line should be a special case of polyline.
const $ab3f2a5cc6216ae5$var$coordProps = [
    "x1",
    "x2",
    "y1",
    "y2"
];
class $ab3f2a5cc6216ae5$export$17d680238e50603e extends $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1 {
    /**
   * Constructor
   * @param {Array} [points] Array of points
   * @param {Object} [options] Options object
   * @return {Line} thisArg
   */ constructor(){
        let [x1, y1, x2, y2] = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            0,
            0,
            0,
            0
        ];
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        Object.assign(this, $ab3f2a5cc6216ae5$export$17d680238e50603e.ownDefaults);
        this.setOptions(options);
        this.x1 = x1;
        this.x2 = x2;
        this.y1 = y1;
        this.y2 = y2;
        this._setWidthHeight();
        const { left: left, top: top } = options;
        typeof left === "number" && this.set($ab3f2a5cc6216ae5$var$LEFT, left);
        typeof top === "number" && this.set($ab3f2a5cc6216ae5$var$TOP, top);
    }
    /**
   * @private
   * @param {Object} [options] Options
   */ _setWidthHeight() {
        const { x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        this.width = Math.abs(x2 - x1);
        this.height = Math.abs(y2 - y1);
        const { left: left, top: top, width: width, height: height } = $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints([
            {
                x: x1,
                y: y1
            },
            {
                x: x2,
                y: y2
            }
        ]);
        const position = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(left + width / 2, top + height / 2);
        this.setPositionByOrigin(position, $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER);
    }
    /**
   * @private
   * @param {String} key
   * @param {*} value
   */ _set(key, value) {
        super._set(key, value);
        if ($ab3f2a5cc6216ae5$var$coordProps.includes(key)) // this doesn't make sense very much, since setting x1 when top or left
        // are already set, is just going to show a strange result since the
        // line will move way more than the developer expect.
        // in fabric5 it worked only when the line didn't have extra transformations,
        // in fabric6 too. With extra transform they behave bad in different ways.
        // This needs probably a good rework or a tutorial if you have to create a dynamic line
        this._setWidthHeight();
        return this;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        ctx.beginPath();
        const p = this.calcLinePoints();
        ctx.moveTo(p.x1, p.y1);
        ctx.lineTo(p.x2, p.y2);
        ctx.lineWidth = this.strokeWidth;
        // TODO: test this
        // make sure setting "fill" changes color of a line
        // (by copying fillStyle to strokeStyle, since line is stroked, not filled)
        const origStrokeStyle = ctx.strokeStyle;
        if ($ab3f2a5cc6216ae5$var$isFiller(this.stroke)) ctx.strokeStyle = this.stroke.toLive(ctx);
        else {
            var _this$stroke;
            ctx.strokeStyle = (_this$stroke = this.stroke) !== null && _this$stroke !== void 0 ? _this$stroke : ctx.fillStyle;
        }
        this.stroke && this._renderStroke(ctx);
        ctx.strokeStyle = origStrokeStyle;
    }
    /**
   * This function is an helper for svg import. it returns the center of the object in the svg
   * untransformed coordinates
   * @private
   * @return {Point} center point from element coordinates
   */ _findCenterFromElement() {
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a((this.x1 + this.x2) / 2, (this.y1 + this.y2) / 2);
    }
    /**
   * Returns object representation of an instance
   * @method toObject
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.toObject(propertiesToInclude)), this.calcLinePoints());
    }
    /*
   * Calculate object dimensions from its properties
   * @private
   */ _getNonTransformedDimensions() {
        const dim = super._getNonTransformedDimensions();
        if (this.strokeLineCap === "butt") {
            if (this.width === 0) dim.y -= this.strokeWidth;
            if (this.height === 0) dim.x -= this.strokeWidth;
        }
        return dim;
    }
    /**
   * Recalculates line points given width and height
   * Those points are simply placed around the center,
   * This is not useful outside internal render functions and svg output
   * Is not meant to be for the developer.
   * @private
   */ calcLinePoints() {
        const { x1: _x1, x2: _x2, y1: _y1, y2: _y2, width: width, height: height } = this;
        const xMult = _x1 <= _x2 ? -1 : 1, yMult = _y1 <= _y2 ? -1 : 1, x1 = xMult * width / 2, y1 = yMult * height / 2, x2 = xMult * -width / 2, y2 = yMult * -height / 2;
        return {
            x1: x1,
            x2: x2,
            y1: y1,
            y2: y2
        };
    }
    /* _FROM_SVG_START_ */ /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const { x1: x1, x2: x2, y1: y1, y2: y2 } = this.calcLinePoints();
        return [
            "<line ",
            "COMMON_PARTS",
            'x1="'.concat(x1, '" y1="').concat(y1, '" x2="').concat(x2, '" y2="').concat(y2, '" />\n')
        ];
    }
    /**
   * List of attribute names to account for when parsing SVG element (used by {@link Line.fromElement})
   * @static
   * @memberOf Line
   * @see http://www.w3.org/TR/SVG/shapes.html#LineElement
   */ /**
   * Returns Line instance from an SVG element
   * @static
   * @memberOf Line
   * @param {HTMLElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} [callback] callback function invoked after parsing
   */ static async fromElement(element, options, cssRules) {
        const _parseAttributes = $ab3f2a5cc6216ae5$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules), { x1: x1 = 0, y1: y1 = 0, x2: x2 = 0, y2: y2 = 0 } = _parseAttributes, parsedAttributes = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_parseAttributes, $ab3f2a5cc6216ae5$var$_excluded$5);
        return new this([
            x1,
            y1,
            x2,
            y2
        ], parsedAttributes);
    }
    /* _FROM_SVG_END_ */ /**
   * Returns Line instance from an object representation
   * @static
   * @memberOf Line
   * @param {Object} object Object to create an instance from
   * @returns {Promise<Line>}
   */ static fromObject(_ref) {
        let { x1: x1, y1: y1, x2: x2, y2: y2 } = _ref, object = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref, $ab3f2a5cc6216ae5$var$_excluded2$1);
        return this._fromObject($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, object), {}, {
            points: [
                x1,
                y1,
                x2,
                y2
            ]
        }), {
            extraParam: "points"
        });
    }
}
/**
 * x value or first line edge
 * @type number
 * @default
 */ /**
 * y value or first line edge
 * @type number
 * @default
 */ /**
 * x value or second line edge
 * @type number
 * @default
 */ /**
 * y value or second line edge
 * @type number
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$17d680238e50603e, "type", "Line");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$17d680238e50603e, "cacheProperties", [
    ...$ab3f2a5cc6216ae5$var$cacheProperties,
    ...$ab3f2a5cc6216ae5$var$coordProps
]);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$17d680238e50603e, "ATTRIBUTE_NAMES", $ab3f2a5cc6216ae5$var$SHARED_ATTRIBUTES.concat($ab3f2a5cc6216ae5$var$coordProps));
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$17d680238e50603e);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setSVGClass($ab3f2a5cc6216ae5$export$17d680238e50603e);
const $ab3f2a5cc6216ae5$var$triangleDefaultValues = {
    width: 100,
    height: 100
};
class $ab3f2a5cc6216ae5$export$5a465592bfe74b48 extends $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$5a465592bfe74b48.ownDefaults);
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        Object.assign(this, $ab3f2a5cc6216ae5$export$5a465592bfe74b48.ownDefaults);
        this.setOptions(options);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        const widthBy2 = this.width / 2, heightBy2 = this.height / 2;
        ctx.beginPath();
        ctx.moveTo(-widthBy2, heightBy2);
        ctx.lineTo(0, -heightBy2);
        ctx.lineTo(widthBy2, heightBy2);
        ctx.closePath();
        this._renderPaintInOrder(ctx);
    }
    /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const widthBy2 = this.width / 2, heightBy2 = this.height / 2, points = "".concat(-widthBy2, " ").concat(heightBy2, ",0 ").concat(-heightBy2, ",").concat(widthBy2, " ").concat(heightBy2);
        return [
            "<polygon ",
            "COMMON_PARTS",
            'points="',
            points,
            '" />'
        ];
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$5a465592bfe74b48, "type", "Triangle");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$5a465592bfe74b48, "ownDefaults", $ab3f2a5cc6216ae5$var$triangleDefaultValues);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$5a465592bfe74b48);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setSVGClass($ab3f2a5cc6216ae5$export$5a465592bfe74b48);
const $ab3f2a5cc6216ae5$var$ellipseDefaultValues = {
    rx: 0,
    ry: 0
};
const $ab3f2a5cc6216ae5$var$ELLIPSE_PROPS = [
    "rx",
    "ry"
];
class $ab3f2a5cc6216ae5$export$80b0269ab108fa11 extends $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$80b0269ab108fa11.ownDefaults);
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        Object.assign(this, $ab3f2a5cc6216ae5$export$80b0269ab108fa11.ownDefaults);
        this.setOptions(options);
    }
    /**
   * @private
   * @param {String} key
   * @param {*} value
   * @return {Ellipse} thisArg
   */ _set(key, value) {
        super._set(key, value);
        switch(key){
            case "rx":
                this.rx = value;
                this.set("width", value * 2);
                break;
            case "ry":
                this.ry = value;
                this.set("height", value * 2);
                break;
        }
        return this;
    }
    /**
   * Returns horizontal radius of an object (according to how an object is scaled)
   * @return {Number}
   */ getRx() {
        return this.get("rx") * this.get($ab3f2a5cc6216ae5$var$SCALE_X);
    }
    /**
   * Returns Vertical radius of an object (according to how an object is scaled)
   * @return {Number}
   */ getRy() {
        return this.get("ry") * this.get($ab3f2a5cc6216ae5$var$SCALE_Y);
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return super.toObject([
            ...$ab3f2a5cc6216ae5$var$ELLIPSE_PROPS,
            ...propertiesToInclude
        ]);
    }
    /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        return [
            "<ellipse ",
            "COMMON_PARTS",
            'cx="0" cy="0" rx="'.concat(this.rx, '" ry="').concat(this.ry, '" />\n')
        ];
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx context to render on
   */ _render(ctx) {
        ctx.beginPath();
        ctx.save();
        ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
        ctx.arc(0, 0, this.rx, 0, $ab3f2a5cc6216ae5$var$twoMathPi, false);
        ctx.restore();
        this._renderPaintInOrder(ctx);
    }
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link Ellipse.fromElement})
   * @static
   * @memberOf Ellipse
   * @see http://www.w3.org/TR/SVG/shapes.html#EllipseElement
   */ /**
   * Returns {@link Ellipse} instance from an SVG element
   * @static
   * @memberOf Ellipse
   * @param {HTMLElement} element Element to parse
   * @return {Ellipse}
   */ static async fromElement(element, options, cssRules) {
        const parsedAttributes = $ab3f2a5cc6216ae5$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules);
        parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
        parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
        return new this(parsedAttributes);
    }
}
/**
 * Horizontal radius
 * @type Number
 * @default
 */ /**
 * Vertical radius
 * @type Number
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$80b0269ab108fa11, "type", "Ellipse");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$80b0269ab108fa11, "cacheProperties", [
    ...$ab3f2a5cc6216ae5$var$cacheProperties,
    ...$ab3f2a5cc6216ae5$var$ELLIPSE_PROPS
]);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$80b0269ab108fa11, "ownDefaults", $ab3f2a5cc6216ae5$var$ellipseDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$80b0269ab108fa11, "ATTRIBUTE_NAMES", [
    ...$ab3f2a5cc6216ae5$var$SHARED_ATTRIBUTES,
    "cx",
    "cy",
    "rx",
    "ry"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$80b0269ab108fa11);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setSVGClass($ab3f2a5cc6216ae5$export$80b0269ab108fa11);
/**
 * Parses "points" attribute, returning an array of values
 * @static
 * @memberOf fabric
 * @param {String} points points attribute string
 * @return {Array} array of points
 */ function $ab3f2a5cc6216ae5$export$809af63a824f9f55(points) {
    // points attribute is required and must not be empty
    if (!points) return [];
    // replace commas with whitespace and remove bookending whitespace
    const pointsSplit = points.replace(/,/g, " ").trim().split(/\s+/);
    const parsedPoints = [];
    for(let i = 0; i < pointsSplit.length; i += 2)parsedPoints.push({
        x: parseFloat(pointsSplit[i]),
        y: parseFloat(pointsSplit[i + 1])
    });
    // odd number of points is an error
    // if (parsedPoints.length % 2 !== 0) {
    //   return null;
    // }
    return parsedPoints;
}
const $ab3f2a5cc6216ae5$var$_excluded$4 = [
    "left",
    "top"
];
const $ab3f2a5cc6216ae5$var$polylineDefaultValues = {
    /**
   * @deprecated transient option soon to be removed in favor of a different design
   */ exactBoundingBox: false
};
class $ab3f2a5cc6216ae5$export$79f3ee03e63e7073 extends $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$79f3ee03e63e7073.ownDefaults);
    }
    /**
   * A list of properties that if changed trigger a recalculation of dimensions
   * @todo check if you really need to recalculate for all cases
   */ /**
   * Constructor
   * @param {Array} points Array of points (where each point is an object with x and y)
   * @param {Object} [options] Options object
   * @return {Polyline} thisArg
   * @example
   * var poly = new Polyline([
   *     { x: 10, y: 10 },
   *     { x: 50, y: 30 },
   *     { x: 40, y: 70 },
   *     { x: 60, y: 50 },
   *     { x: 100, y: 150 },
   *     { x: 40, y: 100 }
   *   ], {
   *   stroke: 'red',
   *   left: 100,
   *   top: 100
   * });
   */ constructor(){
        let points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "strokeDiff", void 0);
        Object.assign(this, $ab3f2a5cc6216ae5$export$79f3ee03e63e7073.ownDefaults);
        this.setOptions(options);
        this.points = points;
        const { left: left, top: top } = options;
        this.initialized = true;
        this.setBoundingBox(true);
        typeof left === "number" && this.set($ab3f2a5cc6216ae5$var$LEFT, left);
        typeof top === "number" && this.set($ab3f2a5cc6216ae5$var$TOP, top);
    }
    isOpen() {
        return true;
    }
    _projectStrokeOnPoints(options) {
        return $ab3f2a5cc6216ae5$var$projectStrokeOnPoints(this.points, options, this.isOpen());
    }
    /**
   * Calculate the polygon bounding box
   * @private
   */ _calcDimensions(options) {
        options = $ab3f2a5cc6216ae5$var$_objectSpread2({
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            strokeLineCap: this.strokeLineCap,
            strokeLineJoin: this.strokeLineJoin,
            strokeMiterLimit: this.strokeMiterLimit,
            strokeUniform: this.strokeUniform,
            strokeWidth: this.strokeWidth
        }, options || {});
        const points = this.exactBoundingBox ? this._projectStrokeOnPoints(options).map((projection)=>projection.projectedPoint) : this.points;
        if (points.length === 0) return {
            left: 0,
            top: 0,
            width: 0,
            height: 0,
            pathOffset: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(),
            strokeOffset: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(),
            strokeDiff: new $ab3f2a5cc6216ae5$export$baf26146a414f24a()
        };
        const bbox = $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints(points), // Remove scale effect, since it's applied after
        matrix = $ab3f2a5cc6216ae5$var$calcDimensionsMatrix($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), {}, {
            scaleX: 1,
            scaleY: 1
        })), bboxNoStroke = $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints(this.points.map((p)=>$ab3f2a5cc6216ae5$var$transformPoint(p, matrix, true))), scale = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.scaleX, this.scaleY);
        let offsetX = bbox.left + bbox.width / 2, offsetY = bbox.top + bbox.height / 2;
        if (this.exactBoundingBox) {
            offsetX = offsetX - offsetY * Math.tan($ab3f2a5cc6216ae5$var$degreesToRadians(this.skewX));
            // Order of those assignments is important.
            // offsetY relies on offsetX being already changed by the line above
            offsetY = offsetY - offsetX * Math.tan($ab3f2a5cc6216ae5$var$degreesToRadians(this.skewY));
        }
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, bbox), {}, {
            pathOffset: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(offsetX, offsetY),
            strokeOffset: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(bboxNoStroke.left, bboxNoStroke.top).subtract(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(bbox.left, bbox.top)).multiply(scale),
            strokeDiff: new $ab3f2a5cc6216ae5$export$baf26146a414f24a(bbox.width, bbox.height).subtract(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(bboxNoStroke.width, bboxNoStroke.height)).multiply(scale)
        });
    }
    /**
   * This function is an helper for svg import. it returns the center of the object in the svg
   * untransformed coordinates, by look at the polyline/polygon points.
   * @private
   * @return {Point} center point from element coordinates
   */ _findCenterFromElement() {
        const bbox = $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints(this.points);
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2);
    }
    setDimensions() {
        this.setBoundingBox();
    }
    setBoundingBox(adjustPosition) {
        const { left: left, top: top, width: width, height: height, pathOffset: pathOffset, strokeOffset: strokeOffset, strokeDiff: strokeDiff } = this._calcDimensions();
        this.set({
            width: width,
            height: height,
            pathOffset: pathOffset,
            strokeOffset: strokeOffset,
            strokeDiff: strokeDiff
        });
        adjustPosition && this.setPositionByOrigin(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(left + width / 2, top + height / 2), $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER);
    }
    /**
   * @deprecated intermidiate method to be removed, do not use
   */ isStrokeAccountedForInDimensions() {
        return this.exactBoundingBox;
    }
    /**
   * @override stroke is taken in account in size
   */ _getNonTransformedDimensions() {
        return this.exactBoundingBox ? // TODO: fix this
        new $ab3f2a5cc6216ae5$export$baf26146a414f24a(this.width, this.height) : super._getNonTransformedDimensions();
    }
    /**
   * @override stroke and skewing are taken into account when projecting stroke on points,
   * therefore we don't want the default calculation to account for skewing as well.
   * Though it is possible to pass `width` and `height` in `options`, doing so is very strange, use with discretion.
   *
   * @private
   */ _getTransformedDimensions() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (this.exactBoundingBox) {
            let size;
            /* When `strokeUniform = true`, any changes to the properties require recalculating the `width` and `height` because
        the stroke projections are affected.
        When `strokeUniform = false`, we don't need to recalculate for scale transformations, as the effect of scale on
        projections follows a linear function (e.g. scaleX of 2 just multiply width by 2)*/ if (Object.keys(options).some((key)=>this.strokeUniform || this.constructor.layoutProperties.includes(key))) {
                var _options$width, _options$height;
                const { width: width, height: height } = this._calcDimensions(options);
                size = new $ab3f2a5cc6216ae5$export$baf26146a414f24a((_options$width = options.width) !== null && _options$width !== void 0 ? _options$width : width, (_options$height = options.height) !== null && _options$height !== void 0 ? _options$height : height);
            } else {
                var _options$width2, _options$height2;
                size = new $ab3f2a5cc6216ae5$export$baf26146a414f24a((_options$width2 = options.width) !== null && _options$width2 !== void 0 ? _options$width2 : this.width, (_options$height2 = options.height) !== null && _options$height2 !== void 0 ? _options$height2 : this.height);
            }
            return size.multiply(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(options.scaleX || this.scaleX, options.scaleY || this.scaleY));
        } else return super._getTransformedDimensions(options);
    }
    /**
   * Recalculates dimensions when changing skew and scale
   * @private
   */ _set(key, value) {
        const changed = this.initialized && this[key] !== value;
        const output = super._set(key, value);
        if (this.exactBoundingBox && changed && ((key === $ab3f2a5cc6216ae5$var$SCALE_X || key === $ab3f2a5cc6216ae5$var$SCALE_Y) && this.strokeUniform && this.constructor.layoutProperties.includes("strokeUniform") || this.constructor.layoutProperties.includes(key))) this.setDimensions();
        return output;
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} Object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.toObject(propertiesToInclude)), {}, {
            points: $ab3f2a5cc6216ae5$var$cloneDeep(this.points)
        });
    }
    /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const points = [], diffX = this.pathOffset.x, diffY = this.pathOffset.y, NUM_FRACTION_DIGITS = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
        for(let i = 0, len = this.points.length; i < len; i++)points.push($ab3f2a5cc6216ae5$var$toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS), ",", $ab3f2a5cc6216ae5$var$toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS), " ");
        return [
            "<".concat(this.constructor.type.toLowerCase(), " "),
            "COMMON_PARTS",
            'points="'.concat(points.join(""), '" />\n')
        ];
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        const len = this.points.length, x = this.pathOffset.x, y = this.pathOffset.y;
        if (!len || isNaN(this.points[len - 1].y)) // do not draw if no points or odd points
        // NaN comes from parseFloat of a empty string in parser
        return;
        ctx.beginPath();
        ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
        for(let i = 0; i < len; i++){
            const point = this.points[i];
            ctx.lineTo(point.x - x, point.y - y);
        }
        !this.isOpen() && ctx.closePath();
        this._renderPaintInOrder(ctx);
    }
    /**
   * Returns complexity of an instance
   * @return {Number} complexity of this instance
   */ complexity() {
        return this.points.length;
    }
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link Polyline.fromElement})
   * @static
   * @memberOf Polyline
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolylineElement
   */ /**
   * Returns Polyline instance from an SVG element
   * @static
   * @memberOf Polyline
   * @param {HTMLElement} element Element to parser
   * @param {Object} [options] Options object
   */ static async fromElement(element, options, cssRules) {
        const points = $ab3f2a5cc6216ae5$export$809af63a824f9f55(element.getAttribute("points")), _parseAttributes = $ab3f2a5cc6216ae5$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules), parsedAttributes = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_parseAttributes, $ab3f2a5cc6216ae5$var$_excluded$4);
        return new this(points, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, parsedAttributes), options));
    }
    /* _FROM_SVG_END_ */ /**
   * Returns Polyline instance from an object representation
   * @static
   * @memberOf Polyline
   * @param {Object} object Object to create an instance from
   * @returns {Promise<Polyline>}
   */ static fromObject(object) {
        return this._fromObject(object, {
            extraParam: "points"
        });
    }
}
/**
 * Points array
 * @type Array
 * @default
 */ /**
 * WARNING: Feature in progress
 * Calculate the exact bounding box taking in account strokeWidth on acute angles
 * this will be turned to true by default on fabric 6.0
 * maybe will be left in as an optimization since calculations may be slow
 * @deprecated transient option soon to be removed in favor of a different design
 * @type Boolean
 * @default false
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$79f3ee03e63e7073, "ownDefaults", $ab3f2a5cc6216ae5$var$polylineDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$79f3ee03e63e7073, "type", "Polyline");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$79f3ee03e63e7073, "layoutProperties", [
    $ab3f2a5cc6216ae5$var$SKEW_X,
    $ab3f2a5cc6216ae5$var$SKEW_Y,
    "strokeLineCap",
    "strokeLineJoin",
    "strokeMiterLimit",
    "strokeWidth",
    "strokeUniform",
    "points"
]);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$79f3ee03e63e7073, "cacheProperties", [
    ...$ab3f2a5cc6216ae5$var$cacheProperties,
    "points"
]);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$79f3ee03e63e7073, "ATTRIBUTE_NAMES", [
    ...$ab3f2a5cc6216ae5$var$SHARED_ATTRIBUTES
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$79f3ee03e63e7073);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setSVGClass($ab3f2a5cc6216ae5$export$79f3ee03e63e7073);
class $ab3f2a5cc6216ae5$export$7d31b617c820d435 extends $ab3f2a5cc6216ae5$export$79f3ee03e63e7073 {
    isOpen() {
        return false;
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$7d31b617c820d435, "ownDefaults", $ab3f2a5cc6216ae5$var$polylineDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$7d31b617c820d435, "type", "Polygon");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$7d31b617c820d435);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setSVGClass($ab3f2a5cc6216ae5$export$7d31b617c820d435);
const $ab3f2a5cc6216ae5$var$fontProperties = [
    "fontSize",
    "fontWeight",
    "fontFamily",
    "fontStyle"
];
const $ab3f2a5cc6216ae5$var$textDecorationProperties = [
    "underline",
    "overline",
    "linethrough"
];
const $ab3f2a5cc6216ae5$var$textLayoutProperties = [
    ...$ab3f2a5cc6216ae5$var$fontProperties,
    "lineHeight",
    "text",
    "charSpacing",
    "textAlign",
    "styles",
    "path",
    "pathStartOffset",
    "pathSide",
    "pathAlign"
];
const $ab3f2a5cc6216ae5$var$additionalProps = [
    ...$ab3f2a5cc6216ae5$var$textLayoutProperties,
    ...$ab3f2a5cc6216ae5$var$textDecorationProperties,
    "textBackgroundColor",
    "direction"
];
const $ab3f2a5cc6216ae5$var$styleProperties = [
    ...$ab3f2a5cc6216ae5$var$fontProperties,
    ...$ab3f2a5cc6216ae5$var$textDecorationProperties,
    $ab3f2a5cc6216ae5$var$STROKE,
    "strokeWidth",
    $ab3f2a5cc6216ae5$var$FILL,
    "deltaY",
    "textBackgroundColor"
];
// @TODO: Many things here are configuration related and shouldn't be on the class nor prototype
// regexes, list of properties that are not suppose to change by instances, magic consts.
// this will be a separated effort
const $ab3f2a5cc6216ae5$var$textDefaultValues = {
    _reNewline: $ab3f2a5cc6216ae5$var$reNewline,
    _reSpacesAndTabs: /[ \t\r]/g,
    _reSpaceAndTab: /[ \t\r]/,
    _reWords: /\S+/g,
    fontSize: 40,
    fontWeight: "normal",
    fontFamily: "Times New Roman",
    underline: false,
    overline: false,
    linethrough: false,
    textAlign: $ab3f2a5cc6216ae5$var$LEFT,
    fontStyle: "normal",
    lineHeight: 1.16,
    superscript: {
        size: 0.6,
        // fontSize factor
        baseline: -0.35 // baseline-shift factor (upwards)
    },
    subscript: {
        size: 0.6,
        // fontSize factor
        baseline: 0.11 // baseline-shift factor (downwards)
    },
    textBackgroundColor: "",
    stroke: null,
    shadow: null,
    path: undefined,
    pathStartOffset: 0,
    pathSide: $ab3f2a5cc6216ae5$var$LEFT,
    pathAlign: "baseline",
    _fontSizeFraction: 0.222,
    offsets: {
        underline: 0.1,
        linethrough: -0.315,
        overline: -0.88
    },
    _fontSizeMult: 1.13,
    charSpacing: 0,
    deltaY: 0,
    direction: "ltr",
    CACHE_FONT_SIZE: 400,
    MIN_TEXT_WIDTH: 2
};
const $ab3f2a5cc6216ae5$var$JUSTIFY = "justify";
const $ab3f2a5cc6216ae5$var$JUSTIFY_LEFT = "justify-left";
const $ab3f2a5cc6216ae5$var$JUSTIFY_RIGHT = "justify-right";
const $ab3f2a5cc6216ae5$var$JUSTIFY_CENTER = "justify-center";
class $ab3f2a5cc6216ae5$var$StyledText extends $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1 {
    /**
   * Returns true if object has no styling or no styling in a line
   * @param {Number} lineIndex , lineIndex is on wrapped lines.
   * @return {Boolean}
   */ isEmptyStyles(lineIndex) {
        if (!this.styles) return true;
        if (typeof lineIndex !== "undefined" && !this.styles[lineIndex]) return true;
        const obj = typeof lineIndex === "undefined" ? this.styles : {
            line: this.styles[lineIndex]
        };
        for(const p1 in obj)for(const p2 in obj[p1]){
            // eslint-disable-next-line no-unused-vars
            for(const p3 in obj[p1][p2])return false;
        }
        return true;
    }
    /**
   * Returns true if object has a style property or has it ina specified line
   * This function is used to detect if a text will use a particular property or not.
   * @param {String} property to check for
   * @param {Number} lineIndex to check the style on
   * @return {Boolean}
   */ styleHas(property, lineIndex) {
        if (!this.styles) return false;
        if (typeof lineIndex !== "undefined" && !this.styles[lineIndex]) return false;
        const obj = typeof lineIndex === "undefined" ? this.styles : {
            0: this.styles[lineIndex]
        };
        // eslint-disable-next-line
        for(const p1 in obj)// eslint-disable-next-line
        for(const p2 in obj[p1]){
            if (typeof obj[p1][p2][property] !== "undefined") return true;
        }
        return false;
    }
    /**
   * Check if characters in a text have a value for a property
   * whose value matches the textbox's value for that property.  If so,
   * the character-level property is deleted.  If the character
   * has no other properties, then it is also deleted.  Finally,
   * if the line containing that character has no other characters
   * then it also is deleted.
   *
   * @param {string} property The property to compare between characters and text.
   */ cleanStyle(property) {
        if (!this.styles) return false;
        const obj = this.styles;
        let stylesCount = 0, letterCount, stylePropertyValue, allStyleObjectPropertiesMatch = true, graphemeCount = 0;
        for(const p1 in obj){
            letterCount = 0;
            for(const p2 in obj[p1]){
                const styleObject = obj[p1][p2] || {}, stylePropertyHasBeenSet = styleObject[property] !== undefined;
                stylesCount++;
                if (stylePropertyHasBeenSet) {
                    if (!stylePropertyValue) stylePropertyValue = styleObject[property];
                    else if (styleObject[property] !== stylePropertyValue) allStyleObjectPropertiesMatch = false;
                    if (styleObject[property] === this[property]) delete styleObject[property];
                } else allStyleObjectPropertiesMatch = false;
                if (Object.keys(styleObject).length !== 0) letterCount++;
                else delete obj[p1][p2];
            }
            if (letterCount === 0) delete obj[p1];
        }
        // if every grapheme has the same style set then
        // delete those styles and set it on the parent
        for(let i = 0; i < this._textLines.length; i++)graphemeCount += this._textLines[i].length;
        if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
            // @ts-expect-error conspiracy theory of TS
            this[property] = stylePropertyValue;
            this.removeStyle(property);
        }
    }
    /**
   * Remove a style property or properties from all individual character styles
   * in a text object.  Deletes the character style object if it contains no other style
   * props.  Deletes a line style object if it contains no other character styles.
   *
   * @param {String} props The property to remove from character styles.
   */ removeStyle(property) {
        if (!this.styles) return;
        const obj = this.styles;
        let line, lineNum, charNum;
        for(lineNum in obj){
            line = obj[lineNum];
            for(charNum in line){
                delete line[charNum][property];
                if (Object.keys(line[charNum]).length === 0) delete line[charNum];
            }
            if (Object.keys(line).length === 0) delete obj[lineNum];
        }
    }
    _extendStyles(index, style) {
        const { lineIndex: lineIndex, charIndex: charIndex } = this.get2DCursorLocation(index);
        if (!this._getLineStyle(lineIndex)) this._setLineStyle(lineIndex);
        const newStyle = $ab3f2a5cc6216ae5$var$pickBy($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, this._getStyleDeclaration(lineIndex, charIndex)), style), (value)=>value !== undefined);
        // finally assign to the old position the new style
        this._setStyleDeclaration(lineIndex, charIndex, newStyle);
    }
    /**
   * Gets style of a current selection/cursor (at the start position)
   * @param {Number} startIndex Start index to get styles at
   * @param {Number} endIndex End index to get styles at, if not specified startIndex + 1
   * @param {Boolean} [complete] get full style or not
   * @return {Array} styles an array with one, zero or more Style objects
   */ getSelectionStyles(startIndex, endIndex, complete) {
        const styles = [];
        for(let i = startIndex; i < (endIndex || startIndex); i++)styles.push(this.getStyleAtPosition(i, complete));
        return styles;
    }
    /**
   * Gets style of a current selection/cursor position
   * @param {Number} position  to get styles at
   * @param {Boolean} [complete] full style if true
   * @return {Object} style Style object at a specified index
   * @private
   */ getStyleAtPosition(position, complete) {
        const { lineIndex: lineIndex, charIndex: charIndex } = this.get2DCursorLocation(position);
        return complete ? this.getCompleteStyleDeclaration(lineIndex, charIndex) : this._getStyleDeclaration(lineIndex, charIndex);
    }
    /**
   * Sets style of a current selection, if no selection exist, do not set anything.
   * @param {Object} styles Styles object
   * @param {Number} startIndex Start index to get styles at
   * @param {Number} [endIndex] End index to get styles at, if not specified startIndex + 1
   */ setSelectionStyles(styles, startIndex, endIndex) {
        for(let i = startIndex; i < (endIndex || startIndex); i++)this._extendStyles(i, styles);
        /* not included in _extendStyles to avoid clearing cache more than once */ this._forceClearCache = true;
    }
    /**
   * Get a reference, not a clone, to the style object for a given character,
   * if no style is set for a line or char, return a new empty object.
   * This is tricky and confusing because when you get an empty object you can't
   * determine if it is a reference or a new one.
   * @TODO this should always return a reference or always a clone or undefined when necessary.
   * @protected
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {TextStyleDeclaration} a style object reference to the existing one or a new empty object when undefined
   */ _getStyleDeclaration(lineIndex, charIndex) {
        var _lineStyle$charIndex;
        const lineStyle = this.styles && this.styles[lineIndex];
        return lineStyle ? (_lineStyle$charIndex = lineStyle[charIndex]) !== null && _lineStyle$charIndex !== void 0 ? _lineStyle$charIndex : {} : {};
    }
    /**
   * return a new object that contains all the style property for a character
   * the object returned is newly created
   * @param {Number} lineIndex of the line where the character is
   * @param {Number} charIndex position of the character on the line
   * @return {Object} style object
   */ getCompleteStyleDeclaration(lineIndex, charIndex) {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$var$pick(this, this.constructor._styleProperties)), this._getStyleDeclaration(lineIndex, charIndex));
    }
    /**
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @param {Object} style
   * @private
   */ _setStyleDeclaration(lineIndex, charIndex, style) {
        this.styles[lineIndex][charIndex] = style;
    }
    /**
   *
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @private
   */ _deleteStyleDeclaration(lineIndex, charIndex) {
        delete this.styles[lineIndex][charIndex];
    }
    /**
   * @param {Number} lineIndex
   * @return {Boolean} if the line exists or not
   * @private
   */ _getLineStyle(lineIndex) {
        return !!this.styles[lineIndex];
    }
    /**
   * Set the line style to an empty object so that is initialized
   * @param {Number} lineIndex
   * @private
   */ _setLineStyle(lineIndex) {
        this.styles[lineIndex] = {};
    }
    _deleteLineStyle(lineIndex) {
        delete this.styles[lineIndex];
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$StyledText, "_styleProperties", $ab3f2a5cc6216ae5$var$styleProperties);
const $ab3f2a5cc6216ae5$var$multipleSpacesRegex = /  +/g;
const $ab3f2a5cc6216ae5$var$dblQuoteRegex = /"/g;
function $ab3f2a5cc6216ae5$var$createSVGInlineRect(color, left, top, width, height) {
    return "		".concat($ab3f2a5cc6216ae5$var$createSVGRect(color, {
        left: left,
        top: top,
        width: width,
        height: height
    }), "\n");
}
class $ab3f2a5cc6216ae5$var$TextSVGExportMixin extends $ab3f2a5cc6216ae5$var$FabricObjectSVGExportMixin {
    _toSVG() {
        const offsets = this._getSVGLeftTopOffsets(), textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
        return this._wrapSVGTextAndBg(textAndBg);
    }
    toSVG(reviver) {
        return this._createBaseSVGMarkup(this._toSVG(), {
            reviver: reviver,
            noStyle: true,
            withShadow: true
        });
    }
    _getSVGLeftTopOffsets() {
        return {
            textLeft: -this.width / 2,
            textTop: -this.height / 2,
            lineTop: this.getHeightOfLine(0)
        };
    }
    _wrapSVGTextAndBg(_ref) {
        let { textBgRects: textBgRects, textSpans: textSpans } = _ref;
        const noShadow = true, textDecoration = this.getSvgTextDecoration(this);
        return [
            textBgRects.join(""),
            '		<text xml:space="preserve" ',
            this.fontFamily ? 'font-family="'.concat(this.fontFamily.replace($ab3f2a5cc6216ae5$var$dblQuoteRegex, "'"), '" ') : "",
            this.fontSize ? 'font-size="'.concat(this.fontSize, '" ') : "",
            this.fontStyle ? 'font-style="'.concat(this.fontStyle, '" ') : "",
            this.fontWeight ? 'font-weight="'.concat(this.fontWeight, '" ') : "",
            textDecoration ? 'text-decoration="'.concat(textDecoration, '" ') : "",
            this.direction === "rtl" ? 'direction="'.concat(this.direction, '" ') : "",
            'style="',
            this.getSvgStyles(noShadow),
            '"',
            this.addPaintOrder(),
            " >",
            textSpans.join(""),
            "</text>\n"
        ];
    }
    /**
   * @private
   * @param {Number} textTopOffset Text top offset
   * @param {Number} textLeftOffset Text left offset
   * @return {Object}
   */ _getSVGTextAndBg(textTopOffset, textLeftOffset) {
        const textSpans = [], textBgRects = [];
        let height = textTopOffset, lineOffset;
        // bounding-box background
        this.backgroundColor && textBgRects.push(...$ab3f2a5cc6216ae5$var$createSVGInlineRect(this.backgroundColor, -this.width / 2, -this.height / 2, this.width, this.height));
        // text and text-background
        for(let i = 0, len = this._textLines.length; i < len; i++){
            lineOffset = this._getLineLeftOffset(i);
            if (this.direction === "rtl") lineOffset += this.width;
            if (this.textBackgroundColor || this.styleHas("textBackgroundColor", i)) this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
            this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
            height += this.getHeightOfLine(i);
        }
        return {
            textSpans: textSpans,
            textBgRects: textBgRects
        };
    }
    _createTextCharSpan(char, styleDecl, left, top) {
        const styleProps = this.getSvgSpanStyles(styleDecl, char !== char.trim() || !!char.match($ab3f2a5cc6216ae5$var$multipleSpacesRegex)), fillStyles = styleProps ? 'style="'.concat(styleProps, '"') : "", dy = styleDecl.deltaY, dySpan = dy ? ' dy="'.concat($ab3f2a5cc6216ae5$var$toFixed(dy, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), '" ') : "";
        return '<tspan x="'.concat($ab3f2a5cc6216ae5$var$toFixed(left, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), '" y="').concat($ab3f2a5cc6216ae5$var$toFixed(top, $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), '" ').concat(dySpan).concat(fillStyles, ">").concat($ab3f2a5cc6216ae5$var$escapeXml(char), "</tspan>");
    }
    _setSVGTextLineText(textSpans, lineIndex, textLeftOffset, textTopOffset) {
        const lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.includes($ab3f2a5cc6216ae5$var$JUSTIFY), line = this._textLines[lineIndex];
        let actualStyle, nextStyle, charsToRender = "", charBox, style, boxWidth = 0, timeToRender;
        textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
        for(let i = 0, len = line.length - 1; i <= len; i++){
            timeToRender = i === len || this.charSpacing;
            charsToRender += line[i];
            charBox = this.__charBounds[lineIndex][i];
            if (boxWidth === 0) {
                textLeftOffset += charBox.kernedWidth - charBox.width;
                boxWidth += charBox.width;
            } else boxWidth += charBox.kernedWidth;
            if (isJustify && !timeToRender) {
                if (this._reSpaceAndTab.test(line[i])) timeToRender = true;
            }
            if (!timeToRender) {
                // if we have charSpacing, we render char by char
                actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                timeToRender = $ab3f2a5cc6216ae5$var$hasStyleChanged(actualStyle, nextStyle, true);
            }
            if (timeToRender) {
                style = this._getStyleDeclaration(lineIndex, i);
                textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset));
                charsToRender = "";
                actualStyle = nextStyle;
                if (this.direction === "rtl") textLeftOffset -= boxWidth;
                else textLeftOffset += boxWidth;
                boxWidth = 0;
            }
        }
    }
    _setSVGTextLineBg(textBgRects, i, leftOffset, textTopOffset) {
        const line = this._textLines[i], heightOfLine = this.getHeightOfLine(i) / this.lineHeight;
        let boxWidth = 0, boxStart = 0, currentColor, lastColor = this.getValueOfPropertyAt(i, 0, "textBackgroundColor");
        for(let j = 0; j < line.length; j++){
            const { left: left, width: width, kernedWidth: kernedWidth } = this.__charBounds[i][j];
            currentColor = this.getValueOfPropertyAt(i, j, "textBackgroundColor");
            if (currentColor !== lastColor) {
                lastColor && textBgRects.push(...$ab3f2a5cc6216ae5$var$createSVGInlineRect(lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine));
                boxStart = left;
                boxWidth = width;
                lastColor = currentColor;
            } else boxWidth += kernedWidth;
        }
        currentColor && textBgRects.push(...$ab3f2a5cc6216ae5$var$createSVGInlineRect(lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine));
    }
    /**
   * @deprecated unused
   */ _getSVGLineTopOffset(lineIndex) {
        let lineTopOffset = 0, j;
        for(j = 0; j < lineIndex; j++)lineTopOffset += this.getHeightOfLine(j);
        const lastHeight = this.getHeightOfLine(j);
        return {
            lineTop: lineTopOffset,
            offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
        };
    }
    /**
   * Returns styles-string for svg-export
   * @param {Boolean} skipShadow a boolean to skip shadow filter output
   * @return {String}
   */ getSvgStyles(skipShadow) {
        // cant use ts-expect-error because of ts 5.3 cross check
        // @ts-ignore TS doesn't respect this type casting
        return "".concat(super.getSvgStyles(skipShadow), " white-space: pre;");
    }
    /**
   * Returns styles-string for svg-export
   * @param {Object} style the object from which to retrieve style properties
   * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
   * @return {String}
   */ getSvgSpanStyles(style, useWhiteSpace) {
        const { fontFamily: fontFamily, strokeWidth: strokeWidth, stroke: stroke, fill: fill, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, deltaY: deltaY } = style;
        const textDecoration = this.getSvgTextDecoration(style);
        return [
            stroke ? $ab3f2a5cc6216ae5$var$colorPropToSVG($ab3f2a5cc6216ae5$var$STROKE, stroke) : "",
            strokeWidth ? "stroke-width: ".concat(strokeWidth, "; ") : "",
            fontFamily ? "font-family: ".concat(!fontFamily.includes("'") && !fontFamily.includes('"') ? "'".concat(fontFamily, "'") : fontFamily, "; ") : "",
            fontSize ? "font-size: ".concat(fontSize, "px; ") : "",
            fontStyle ? "font-style: ".concat(fontStyle, "; ") : "",
            fontWeight ? "font-weight: ".concat(fontWeight, "; ") : "",
            textDecoration ? "text-decoration: ".concat(textDecoration, "; ") : textDecoration,
            fill ? $ab3f2a5cc6216ae5$var$colorPropToSVG($ab3f2a5cc6216ae5$var$FILL, fill) : "",
            deltaY ? "baseline-shift: ".concat(-deltaY, "; ") : "",
            useWhiteSpace ? "white-space: pre; " : ""
        ].join("");
    }
    /**
   * Returns text-decoration property for svg-export
   * @param {Object} style the object from which to retrieve style properties
   * @return {String}
   */ getSvgTextDecoration(style) {
        return [
            "overline",
            "underline",
            "line-through"
        ].filter((decoration)=>style[decoration.replace("-", "")]).join(" ");
    }
}
const $ab3f2a5cc6216ae5$var$_excluded$3 = [
    "textAnchor",
    "textDecoration",
    "dx",
    "dy",
    "top",
    "left",
    "fontSize",
    "strokeWidth"
];
let $ab3f2a5cc6216ae5$var$measuringContext;
/**
 * Return a context for measurement of text string.
 * if created it gets stored for reuse
 */ function $ab3f2a5cc6216ae5$var$getMeasuringContext() {
    if (!$ab3f2a5cc6216ae5$var$measuringContext) {
        const canvas = $ab3f2a5cc6216ae5$var$createCanvasElement();
        canvas.width = canvas.height = 0;
        $ab3f2a5cc6216ae5$var$measuringContext = canvas.getContext("2d");
    }
    return $ab3f2a5cc6216ae5$var$measuringContext;
}
/**
 * Measure and return the info of a single grapheme.
 * needs the the info of previous graphemes already filled
 * Override to customize measuring
 */ // @TODO this is not complete
/**
 * Text class
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#text}
 */ class $ab3f2a5cc6216ae5$export$72cf63a35cb577f7 extends $ab3f2a5cc6216ae5$var$StyledText {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$72cf63a35cb577f7.ownDefaults);
    }
    constructor(text, options){
        super();
        /**
     * contains characters bounding boxes
     * This variable is considered to be protected.
     * But for how mixins are implemented right now, we can't leave it private
     * @protected
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "__charBounds", []);
        Object.assign(this, $ab3f2a5cc6216ae5$export$72cf63a35cb577f7.ownDefaults);
        this.setOptions(options);
        if (!this.styles) this.styles = {};
        this.text = text;
        this.initialized = true;
        if (this.path) this.setPathInfo();
        this.initDimensions();
        this.setCoords();
    }
    /**
   * If text has a path, it will add the extra information needed
   * for path and text calculations
   */ setPathInfo() {
        const path = this.path;
        if (path) path.segmentsInfo = $ab3f2a5cc6216ae5$var$getPathSegmentsInfo(path.path);
    }
    /**
   * @private
   * Divides text into lines of text and lines of graphemes.
   */ _splitText() {
        const newLines = this._splitTextIntoLines(this.text);
        this.textLines = newLines.lines;
        this._textLines = newLines.graphemeLines;
        this._unwrappedTextLines = newLines._unwrappedLines;
        this._text = newLines.graphemeText;
        return newLines;
    }
    /**
   * Initialize or update text dimensions.
   * Updates this.width and this.height with the proper values.
   * Does not return dimensions.
   */ initDimensions() {
        this._splitText();
        this._clearCache();
        this.dirty = true;
        if (this.path) {
            this.width = this.path.width;
            this.height = this.path.height;
        } else {
            this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
            this.height = this.calcTextHeight();
        }
        if (this.textAlign.includes($ab3f2a5cc6216ae5$var$JUSTIFY)) // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
    }
    /**
   * Enlarge space boxes and shift the others
   */ enlargeSpaces() {
        let diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
        for(let i = 0, len = this._textLines.length; i < len; i++){
            if (this.textAlign !== $ab3f2a5cc6216ae5$var$JUSTIFY && (i === len - 1 || this.isEndOfWrapping(i))) continue;
            accumulatedSpace = 0;
            line = this._textLines[i];
            currentLineWidth = this.getLineWidth(i);
            if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
                numberOfSpaces = spaces.length;
                diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
                for(let j = 0; j <= line.length; j++){
                    charBound = this.__charBounds[i][j];
                    if (this._reSpaceAndTab.test(line[j])) {
                        charBound.width += diffSpace;
                        charBound.kernedWidth += diffSpace;
                        charBound.left += accumulatedSpace;
                        accumulatedSpace += diffSpace;
                    } else charBound.left += accumulatedSpace;
                }
            }
        }
    }
    /**
   * Detect if the text line is ended with an hard break
   * text and itext do not have wrapping, return false
   * @return {Boolean}
   */ isEndOfWrapping(lineIndex) {
        return lineIndex === this._textLines.length - 1;
    }
    /**
   * Detect if a line has a linebreak and so we need to account for it when moving
   * and counting style.
   * It return always 1 for text and Itext. Textbox has its own implementation
   * @return Number
   */ missingNewlineOffset(lineIndex) {
        return 1;
    }
    /**
   * Returns 2d representation (lineIndex and charIndex) of cursor
   * @param {Number} selectionStart
   * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
   */ get2DCursorLocation(selectionStart, skipWrapping) {
        const lines = skipWrapping ? this._unwrappedTextLines : this._textLines;
        let i;
        for(i = 0; i < lines.length; i++){
            if (selectionStart <= lines[i].length) return {
                lineIndex: i,
                charIndex: selectionStart
            };
            selectionStart -= lines[i].length + this.missingNewlineOffset(i, skipWrapping);
        }
        return {
            lineIndex: i - 1,
            charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
        };
    }
    /**
   * Returns string representation of an instance
   * @return {String} String representation of text object
   */ toString() {
        return "#<Text (".concat(this.complexity(), '): { "text": "').concat(this.text, '", "fontFamily": "').concat(this.fontFamily, '" }>');
    }
    /**
   * Return the dimension and the zoom level needed to create a cache canvas
   * big enough to host the object to be cached.
   * @private
   * @param {Object} dim.x width of object to be cached
   * @param {Object} dim.y height of object to be cached
   * @return {Object}.width width of canvas
   * @return {Object}.height height of canvas
   * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
   * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
   */ _getCacheCanvasDimensions() {
        const dims = super._getCacheCanvasDimensions();
        const fontSize = this.fontSize;
        dims.width += fontSize * dims.zoomX;
        dims.height += fontSize * dims.zoomY;
        return dims;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        const path = this.path;
        path && !path.isNotVisible() && path._render(ctx);
        this._setTextStyles(ctx);
        this._renderTextLinesBackground(ctx);
        this._renderTextDecoration(ctx, "underline");
        this._renderText(ctx);
        this._renderTextDecoration(ctx, "overline");
        this._renderTextDecoration(ctx, "linethrough");
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderText(ctx) {
        if (this.paintFirst === $ab3f2a5cc6216ae5$var$STROKE) {
            this._renderTextStroke(ctx);
            this._renderTextFill(ctx);
        } else {
            this._renderTextFill(ctx);
            this._renderTextStroke(ctx);
        }
    }
    /**
   * Set the font parameter of the context with the object properties or with charStyle
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Object} [charStyle] object with font style properties
   * @param {String} [charStyle.fontFamily] Font Family
   * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
   * @param {String} [charStyle.fontWeight] Font weight
   * @param {String} [charStyle.fontStyle] Font style (italic|normal)
   */ _setTextStyles(ctx, charStyle, forMeasuring) {
        ctx.textBaseline = "alphabetic";
        if (this.path) switch(this.pathAlign){
            case $ab3f2a5cc6216ae5$var$CENTER:
                ctx.textBaseline = "middle";
                break;
            case "ascender":
                ctx.textBaseline = $ab3f2a5cc6216ae5$var$TOP;
                break;
            case "descender":
                ctx.textBaseline = $ab3f2a5cc6216ae5$var$BOTTOM;
                break;
        }
        ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
    }
    /**
   * calculate and return the text Width measuring each line.
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @return {Number} Maximum width of Text object
   */ calcTextWidth() {
        let maxWidth = this.getLineWidth(0);
        for(let i = 1, len = this._textLines.length; i < len; i++){
            const currentLineWidth = this.getLineWidth(i);
            if (currentLineWidth > maxWidth) maxWidth = currentLineWidth;
        }
        return maxWidth;
    }
    /**
   * @private
   * @param {String} method Method name ("fillText" or "strokeText")
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {String} line Text to render
   * @param {Number} left Left position of text
   * @param {Number} top Top position of text
   * @param {Number} lineIndex Index of a line in a text
   */ _renderTextLine(method, ctx, line, left, top, lineIndex) {
        this._renderChars(method, ctx, line, left, top, lineIndex);
    }
    /**
   * Renders the text background for lines, taking care of style
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderTextLinesBackground(ctx) {
        if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor")) return;
        const originalFill = ctx.fillStyle, leftOffset = this._getLeftOffset();
        let lineTopOffset = this._getTopOffset();
        for(let i = 0, len = this._textLines.length; i < len; i++){
            const heightOfLine = this.getHeightOfLine(i);
            if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor", i)) {
                lineTopOffset += heightOfLine;
                continue;
            }
            const jlen = this._textLines[i].length;
            const lineLeftOffset = this._getLineLeftOffset(i);
            let boxWidth = 0;
            let boxStart = 0;
            let drawStart;
            let currentColor;
            let lastColor = this.getValueOfPropertyAt(i, 0, "textBackgroundColor");
            for(let j = 0; j < jlen; j++){
                // at this point charbox are either standard or full with pathInfo if there is a path.
                const charBox = this.__charBounds[i][j];
                currentColor = this.getValueOfPropertyAt(i, j, "textBackgroundColor");
                if (this.path) {
                    ctx.save();
                    ctx.translate(charBox.renderLeft, charBox.renderTop);
                    ctx.rotate(charBox.angle);
                    ctx.fillStyle = currentColor;
                    currentColor && ctx.fillRect(-charBox.width / 2, -heightOfLine / this.lineHeight * (1 - this._fontSizeFraction), charBox.width, heightOfLine / this.lineHeight);
                    ctx.restore();
                } else if (currentColor !== lastColor) {
                    drawStart = leftOffset + lineLeftOffset + boxStart;
                    if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
                    ctx.fillStyle = lastColor;
                    lastColor && ctx.fillRect(drawStart, lineTopOffset, boxWidth, heightOfLine / this.lineHeight);
                    boxStart = charBox.left;
                    boxWidth = charBox.width;
                    lastColor = currentColor;
                } else boxWidth += charBox.kernedWidth;
            }
            if (currentColor && !this.path) {
                drawStart = leftOffset + lineLeftOffset + boxStart;
                if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
                ctx.fillStyle = currentColor;
                ctx.fillRect(drawStart, lineTopOffset, boxWidth, heightOfLine / this.lineHeight);
            }
            lineTopOffset += heightOfLine;
        }
        ctx.fillStyle = originalFill;
        // if there is text background color no
        // other shadows should be casted
        this._removeShadow(ctx);
    }
    /**
   * measure and return the width of a single character.
   * possibly overridden to accommodate different measure logic or
   * to hook some external lib for character measurement
   * @private
   * @param {String} _char, char to be measured
   * @param {Object} charStyle style of char to be measured
   * @param {String} [previousChar] previous char
   * @param {Object} [prevCharStyle] style of previous char
   */ _measureChar(_char, charStyle, previousChar, prevCharStyle) {
        const fontCache = $ab3f2a5cc6216ae5$export$69a3209f1a06c04d.getFontCache(charStyle), fontDeclaration = this._getFontDeclaration(charStyle), couple = previousChar + _char, stylesAreEqual = previousChar && fontDeclaration === this._getFontDeclaration(prevCharStyle), fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE;
        let width, coupleWidth, previousWidth, kernedWidth;
        if (previousChar && fontCache[previousChar] !== undefined) previousWidth = fontCache[previousChar];
        if (fontCache[_char] !== undefined) kernedWidth = width = fontCache[_char];
        if (stylesAreEqual && fontCache[couple] !== undefined) {
            coupleWidth = fontCache[couple];
            kernedWidth = coupleWidth - previousWidth;
        }
        if (width === undefined || previousWidth === undefined || coupleWidth === undefined) {
            const ctx = $ab3f2a5cc6216ae5$var$getMeasuringContext();
            // send a TRUE to specify measuring font size CACHE_FONT_SIZE
            this._setTextStyles(ctx, charStyle, true);
            if (width === undefined) {
                kernedWidth = width = ctx.measureText(_char).width;
                fontCache[_char] = width;
            }
            if (previousWidth === undefined && stylesAreEqual && previousChar) {
                previousWidth = ctx.measureText(previousChar).width;
                fontCache[previousChar] = previousWidth;
            }
            if (stylesAreEqual && coupleWidth === undefined) {
                // we can measure the kerning couple and subtract the width of the previous character
                coupleWidth = ctx.measureText(couple).width;
                fontCache[couple] = coupleWidth;
                // safe to use the non-null since if undefined we defined it before.
                kernedWidth = coupleWidth - previousWidth;
            }
        }
        return {
            width: width * fontMultiplier,
            kernedWidth: kernedWidth * fontMultiplier
        };
    }
    /**
   * Computes height of character at given position
   * @param {Number} line the line index number
   * @param {Number} _char the character index number
   * @return {Number} fontSize of the character
   */ getHeightOfChar(line, _char) {
        return this.getValueOfPropertyAt(line, _char, "fontSize");
    }
    /**
   * measure a text line measuring all characters.
   * @param {Number} lineIndex line number
   */ measureLine(lineIndex) {
        const lineInfo = this._measureLine(lineIndex);
        if (this.charSpacing !== 0) lineInfo.width -= this._getWidthOfCharSpacing();
        if (lineInfo.width < 0) lineInfo.width = 0;
        return lineInfo;
    }
    /**
   * measure every grapheme of a line, populating __charBounds
   * @param {Number} lineIndex
   * @return {Object} object.width total width of characters
   * @return {Object} object.numOfSpaces length of chars that match this._reSpacesAndTabs
   */ _measureLine(lineIndex) {
        let width = 0, prevGrapheme, graphemeInfo;
        const reverse = this.pathSide === $ab3f2a5cc6216ae5$var$RIGHT, path = this.path, line = this._textLines[lineIndex], llength = line.length, lineBounds = new Array(llength);
        this.__charBounds[lineIndex] = lineBounds;
        for(let i = 0; i < llength; i++){
            const grapheme = line[i];
            graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
            lineBounds[i] = graphemeInfo;
            width += graphemeInfo.kernedWidth;
            prevGrapheme = grapheme;
        }
        // this latest bound box represent the last character of the line
        // to simplify cursor handling in interactive mode.
        lineBounds[llength] = {
            left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
            width: 0,
            kernedWidth: 0,
            height: this.fontSize,
            deltaY: 0
        };
        if (path && path.segmentsInfo) {
            let positionInPath = 0;
            const totalPathLength = path.segmentsInfo[path.segmentsInfo.length - 1].length;
            switch(this.textAlign){
                case $ab3f2a5cc6216ae5$var$LEFT:
                    positionInPath = reverse ? totalPathLength - width : 0;
                    break;
                case $ab3f2a5cc6216ae5$var$CENTER:
                    positionInPath = (totalPathLength - width) / 2;
                    break;
                case $ab3f2a5cc6216ae5$var$RIGHT:
                    positionInPath = reverse ? 0 : totalPathLength - width;
                    break;
            }
            positionInPath += this.pathStartOffset * (reverse ? -1 : 1);
            for(let i = reverse ? llength - 1 : 0; reverse ? i >= 0 : i < llength; reverse ? i-- : i++){
                graphemeInfo = lineBounds[i];
                if (positionInPath > totalPathLength) positionInPath %= totalPathLength;
                else if (positionInPath < 0) positionInPath += totalPathLength;
                // it would probably much faster to send all the grapheme position for a line
                // and calculate path position/angle at once.
                this._setGraphemeOnPath(positionInPath, graphemeInfo);
                positionInPath += graphemeInfo.kernedWidth;
            }
        }
        return {
            width: width,
            numOfSpaces: 0
        };
    }
    /**
   * Calculate the angle  and the left,top position of the char that follow a path.
   * It appends it to graphemeInfo to be reused later at rendering
   * @private
   * @param {Number} positionInPath to be measured
   * @param {GraphemeBBox} graphemeInfo current grapheme box information
   * @param {Object} startingPoint position of the point
   */ _setGraphemeOnPath(positionInPath, graphemeInfo) {
        const centerPosition = positionInPath + graphemeInfo.kernedWidth / 2, path = this.path;
        // we are at currentPositionOnPath. we want to know what point on the path is.
        const info = $ab3f2a5cc6216ae5$var$getPointOnPath(path.path, centerPosition, path.segmentsInfo);
        graphemeInfo.renderLeft = info.x - path.pathOffset.x;
        graphemeInfo.renderTop = info.y - path.pathOffset.y;
        graphemeInfo.angle = info.angle + (this.pathSide === $ab3f2a5cc6216ae5$var$RIGHT ? Math.PI : 0);
    }
    /**
   *
   * @param {String} grapheme to be measured
   * @param {Number} lineIndex index of the line where the char is
   * @param {Number} charIndex position in the line
   * @param {String} [prevGrapheme] character preceding the one to be measured
   * @returns {GraphemeBBox} grapheme bbox
   */ _getGraphemeBox(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
        const style = this.getCompleteStyleDeclaration(lineIndex, charIndex), prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : {}, info = this._measureChar(grapheme, style, prevGrapheme, prevStyle);
        let kernedWidth = info.kernedWidth, width = info.width, charSpacing;
        if (this.charSpacing !== 0) {
            charSpacing = this._getWidthOfCharSpacing();
            width += charSpacing;
            kernedWidth += charSpacing;
        }
        const box = {
            width: width,
            left: 0,
            height: style.fontSize,
            kernedWidth: kernedWidth,
            deltaY: style.deltaY
        };
        if (charIndex > 0 && !skipLeft) {
            const previousBox = this.__charBounds[lineIndex][charIndex - 1];
            box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
        }
        return box;
    }
    /**
   * Calculate height of line at 'lineIndex'
   * @param {Number} lineIndex index of line to calculate
   * @return {Number}
   */ getHeightOfLine(lineIndex) {
        if (this.__lineHeights[lineIndex]) return this.__lineHeights[lineIndex];
        // char 0 is measured before the line cycle because it needs to char
        // emptylines
        let maxHeight = this.getHeightOfChar(lineIndex, 0);
        for(let i = 1, len = this._textLines[lineIndex].length; i < len; i++)maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
        return this.__lineHeights[lineIndex] = maxHeight * this.lineHeight * this._fontSizeMult;
    }
    /**
   * Calculate text box height
   */ calcTextHeight() {
        let lineHeight, height = 0;
        for(let i = 0, len = this._textLines.length; i < len; i++){
            lineHeight = this.getHeightOfLine(i);
            height += i === len - 1 ? lineHeight / this.lineHeight : lineHeight;
        }
        return height;
    }
    /**
   * @private
   * @return {Number} Left offset
   */ _getLeftOffset() {
        return this.direction === "ltr" ? -this.width / 2 : this.width / 2;
    }
    /**
   * @private
   * @return {Number} Top offset
   */ _getTopOffset() {
        return -this.height / 2;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {String} method Method name ("fillText" or "strokeText")
   */ _renderTextCommon(ctx, method) {
        ctx.save();
        let lineHeights = 0;
        const left = this._getLeftOffset(), top = this._getTopOffset();
        for(let i = 0, len = this._textLines.length; i < len; i++){
            const heightOfLine = this.getHeightOfLine(i), maxHeight = heightOfLine / this.lineHeight, leftOffset = this._getLineLeftOffset(i);
            this._renderTextLine(method, ctx, this._textLines[i], left + leftOffset, top + lineHeights + maxHeight, i);
            lineHeights += heightOfLine;
        }
        ctx.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderTextFill(ctx) {
        if (!this.fill && !this.styleHas($ab3f2a5cc6216ae5$var$FILL)) return;
        this._renderTextCommon(ctx, "fillText");
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderTextStroke(ctx) {
        if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) return;
        if (this.shadow && !this.shadow.affectStroke) this._removeShadow(ctx);
        ctx.save();
        this._setLineDash(ctx, this.strokeDashArray);
        ctx.beginPath();
        this._renderTextCommon(ctx, "strokeText");
        ctx.closePath();
        ctx.restore();
    }
    /**
   * @private
   * @param {String} method fillText or strokeText.
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Array} line Content of the line, splitted in an array by grapheme
   * @param {Number} left
   * @param {Number} top
   * @param {Number} lineIndex
   */ _renderChars(method, ctx, line, left, top, lineIndex) {
        const lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.includes($ab3f2a5cc6216ae5$var$JUSTIFY), path = this.path, shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex) && !path, isLtr = this.direction === "ltr", sign = this.direction === "ltr" ? 1 : -1, // this was changed in the PR #7674
        // currentDirection = ctx.canvas.getAttribute('dir');
        currentDirection = ctx.direction;
        let actualStyle, nextStyle, charsToRender = "", charBox, boxWidth = 0, timeToRender, drawingLeft;
        ctx.save();
        if (currentDirection !== this.direction) {
            ctx.canvas.setAttribute("dir", isLtr ? "ltr" : "rtl");
            ctx.direction = isLtr ? "ltr" : "rtl";
            ctx.textAlign = isLtr ? $ab3f2a5cc6216ae5$var$LEFT : $ab3f2a5cc6216ae5$var$RIGHT;
        }
        top -= lineHeight * this._fontSizeFraction / this.lineHeight;
        if (shortCut) {
            // render all the line in one pass without checking
            // drawingLeft = isLtr ? left : left - this.getLineWidth(lineIndex);
            this._renderChar(method, ctx, lineIndex, 0, line.join(""), left, top);
            ctx.restore();
            return;
        }
        for(let i = 0, len = line.length - 1; i <= len; i++){
            timeToRender = i === len || this.charSpacing || path;
            charsToRender += line[i];
            charBox = this.__charBounds[lineIndex][i];
            if (boxWidth === 0) {
                left += sign * (charBox.kernedWidth - charBox.width);
                boxWidth += charBox.width;
            } else boxWidth += charBox.kernedWidth;
            if (isJustify && !timeToRender) {
                if (this._reSpaceAndTab.test(line[i])) timeToRender = true;
            }
            if (!timeToRender) {
                // if we have charSpacing, we render char by char
                actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                timeToRender = $ab3f2a5cc6216ae5$var$hasStyleChanged(actualStyle, nextStyle, false);
            }
            if (timeToRender) {
                if (path) {
                    ctx.save();
                    ctx.translate(charBox.renderLeft, charBox.renderTop);
                    ctx.rotate(charBox.angle);
                    this._renderChar(method, ctx, lineIndex, i, charsToRender, -boxWidth / 2, 0);
                    ctx.restore();
                } else {
                    drawingLeft = left;
                    this._renderChar(method, ctx, lineIndex, i, charsToRender, drawingLeft, top);
                }
                charsToRender = "";
                actualStyle = nextStyle;
                left += sign * boxWidth;
                boxWidth = 0;
            }
        }
        ctx.restore();
    }
    /**
   * This function try to patch the missing gradientTransform on canvas gradients.
   * transforming a context to transform the gradient, is going to transform the stroke too.
   * we want to transform the gradient but not the stroke operation, so we create
   * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
   * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
   * is limited.
   * @private
   * @param {TFiller} filler a fabric gradient instance
   * @return {CanvasPattern} a pattern to use as fill/stroke style
   */ _applyPatternGradientTransformText(filler) {
        const pCanvas = $ab3f2a5cc6216ae5$var$createCanvasElement(), // TODO: verify compatibility with strokeUniform
        width = this.width + this.strokeWidth, height = this.height + this.strokeWidth, pCtx = pCanvas.getContext("2d");
        pCanvas.width = width;
        pCanvas.height = height;
        pCtx.beginPath();
        pCtx.moveTo(0, 0);
        pCtx.lineTo(width, 0);
        pCtx.lineTo(width, height);
        pCtx.lineTo(0, height);
        pCtx.closePath();
        pCtx.translate(width / 2, height / 2);
        pCtx.fillStyle = filler.toLive(pCtx);
        this._applyPatternGradientTransform(pCtx, filler);
        pCtx.fill();
        return pCtx.createPattern(pCanvas, "no-repeat");
    }
    handleFiller(ctx, property, filler) {
        let offsetX, offsetY;
        if ($ab3f2a5cc6216ae5$var$isFiller(filler)) {
            if (filler.gradientUnits === "percentage" || filler.gradientTransform || filler.patternTransform) {
                // need to transform gradient in a pattern.
                // this is a slow process. If you are hitting this codepath, and the object
                // is not using caching, you should consider switching it on.
                // we need a canvas as big as the current object caching canvas.
                offsetX = -this.width / 2;
                offsetY = -this.height / 2;
                ctx.translate(offsetX, offsetY);
                ctx[property] = this._applyPatternGradientTransformText(filler);
                return {
                    offsetX: offsetX,
                    offsetY: offsetY
                };
            } else {
                // is a simple gradient or pattern
                ctx[property] = filler.toLive(ctx);
                return this._applyPatternGradientTransform(ctx, filler);
            }
        } else // is a color
        ctx[property] = filler;
        return {
            offsetX: 0,
            offsetY: 0
        };
    }
    /**
   * This function prepare the canvas for a stroke style, and stroke and strokeWidth
   * need to be sent in as defined
   * @param {CanvasRenderingContext2D} ctx
   * @param {CompleteTextStyleDeclaration} style with stroke and strokeWidth defined
   * @returns
   */ _setStrokeStyles(ctx, _ref) {
        let { stroke: stroke, strokeWidth: strokeWidth } = _ref;
        ctx.lineWidth = strokeWidth;
        ctx.lineCap = this.strokeLineCap;
        ctx.lineDashOffset = this.strokeDashOffset;
        ctx.lineJoin = this.strokeLineJoin;
        ctx.miterLimit = this.strokeMiterLimit;
        return this.handleFiller(ctx, "strokeStyle", stroke);
    }
    /**
   * This function prepare the canvas for a ill style, and fill
   * need to be sent in as defined
   * @param {CanvasRenderingContext2D} ctx
   * @param {CompleteTextStyleDeclaration} style with ill defined
   * @returns
   */ _setFillStyles(ctx, _ref2) {
        let { fill: fill } = _ref2;
        return this.handleFiller(ctx, "fillStyle", fill);
    }
    /**
   * @private
   * @param {String} method
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @param {String} _char
   * @param {Number} left Left coordinate
   * @param {Number} top Top coordinate
   * @param {Number} lineHeight Height of the line
   */ _renderChar(method, ctx, lineIndex, charIndex, _char, left, top) {
        const decl = this._getStyleDeclaration(lineIndex, charIndex), fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex), shouldFill = method === "fillText" && fullDecl.fill, shouldStroke = method === "strokeText" && fullDecl.stroke && fullDecl.strokeWidth;
        if (!shouldStroke && !shouldFill) return;
        ctx.save();
        ctx.font = this._getFontDeclaration(fullDecl);
        if (decl.textBackgroundColor) this._removeShadow(ctx);
        if (decl.deltaY) top += decl.deltaY;
        if (shouldFill) {
            const fillOffsets = this._setFillStyles(ctx, fullDecl);
            ctx.fillText(_char, left - fillOffsets.offsetX, top - fillOffsets.offsetY);
        }
        if (shouldStroke) {
            const strokeOffsets = this._setStrokeStyles(ctx, fullDecl);
            ctx.strokeText(_char, left - strokeOffsets.offsetX, top - strokeOffsets.offsetY);
        }
        ctx.restore();
    }
    /**
   * Turns the character into a 'superior figure' (i.e. 'superscript')
   * @param {Number} start selection start
   * @param {Number} end selection end
   */ setSuperscript(start, end) {
        this._setScript(start, end, this.superscript);
    }
    /**
   * Turns the character into an 'inferior figure' (i.e. 'subscript')
   * @param {Number} start selection start
   * @param {Number} end selection end
   */ setSubscript(start, end) {
        this._setScript(start, end, this.subscript);
    }
    /**
   * Applies 'schema' at given position
   * @private
   * @param {Number} start selection start
   * @param {Number} end selection end
   * @param {Number} schema
   */ _setScript(start, end, schema) {
        const loc = this.get2DCursorLocation(start, true), fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, "fontSize"), dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, "deltaY"), style = {
            fontSize: fontSize * schema.size,
            deltaY: dy + fontSize * schema.baseline
        };
        this.setSelectionStyles(style, start, end);
    }
    /**
   * @private
   * @param {Number} lineIndex index text line
   * @return {Number} Line left offset
   */ _getLineLeftOffset(lineIndex) {
        const lineWidth = this.getLineWidth(lineIndex), lineDiff = this.width - lineWidth, textAlign = this.textAlign, direction = this.direction, isEndOfWrapping = this.isEndOfWrapping(lineIndex);
        let leftOffset = 0;
        if (textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY || textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_CENTER && !isEndOfWrapping || textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_RIGHT && !isEndOfWrapping || textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_LEFT && !isEndOfWrapping) return 0;
        if (textAlign === $ab3f2a5cc6216ae5$var$CENTER) leftOffset = lineDiff / 2;
        if (textAlign === $ab3f2a5cc6216ae5$var$RIGHT) leftOffset = lineDiff;
        if (textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_CENTER) leftOffset = lineDiff / 2;
        if (textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_RIGHT) leftOffset = lineDiff;
        if (direction === "rtl") {
            if (textAlign === $ab3f2a5cc6216ae5$var$RIGHT || textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY || textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_RIGHT) leftOffset = 0;
            else if (textAlign === $ab3f2a5cc6216ae5$var$LEFT || textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_LEFT) leftOffset = -lineDiff;
            else if (textAlign === $ab3f2a5cc6216ae5$var$CENTER || textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_CENTER) leftOffset = -lineDiff / 2;
        }
        return leftOffset;
    }
    /**
   * @private
   */ _clearCache() {
        this._forceClearCache = false;
        this.__lineWidths = [];
        this.__lineHeights = [];
        this.__charBounds = [];
    }
    /**
   * Measure a single line given its index. Used to calculate the initial
   * text bounding box. The values are calculated and stored in __lineWidths cache.
   * @private
   * @param {Number} lineIndex line number
   * @return {Number} Line width
   */ getLineWidth(lineIndex) {
        if (this.__lineWidths[lineIndex] !== undefined) return this.__lineWidths[lineIndex];
        const { width: width } = this.measureLine(lineIndex);
        this.__lineWidths[lineIndex] = width;
        return width;
    }
    _getWidthOfCharSpacing() {
        if (this.charSpacing !== 0) return this.fontSize * this.charSpacing / 1000;
        return 0;
    }
    /**
   * Retrieves the value of property at given character position
   * @param {Number} lineIndex the line number
   * @param {Number} charIndex the character number
   * @param {String} property the property name
   * @returns the value of 'property'
   */ getValueOfPropertyAt(lineIndex, charIndex, property) {
        var _charStyle$property;
        const charStyle = this._getStyleDeclaration(lineIndex, charIndex);
        return (_charStyle$property = charStyle[property]) !== null && _charStyle$property !== void 0 ? _charStyle$property : this[property];
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderTextDecoration(ctx, type) {
        if (!this[type] && !this.styleHas(type)) return;
        let topOffset = this._getTopOffset();
        const leftOffset = this._getLeftOffset(), path = this.path, charSpacing = this._getWidthOfCharSpacing(), offsetY = this.offsets[type];
        for(let i = 0, len = this._textLines.length; i < len; i++){
            const heightOfLine = this.getHeightOfLine(i);
            if (!this[type] && !this.styleHas(type, i)) {
                topOffset += heightOfLine;
                continue;
            }
            const line = this._textLines[i];
            const maxHeight = heightOfLine / this.lineHeight;
            const lineLeftOffset = this._getLineLeftOffset(i);
            let boxStart = 0;
            let boxWidth = 0;
            let lastDecoration = this.getValueOfPropertyAt(i, 0, type);
            let lastFill = this.getValueOfPropertyAt(i, 0, $ab3f2a5cc6216ae5$var$FILL);
            let currentDecoration;
            let currentFill;
            const top = topOffset + maxHeight * (1 - this._fontSizeFraction);
            let size = this.getHeightOfChar(i, 0);
            let dy = this.getValueOfPropertyAt(i, 0, "deltaY");
            for(let j = 0, jlen = line.length; j < jlen; j++){
                const charBox = this.__charBounds[i][j];
                currentDecoration = this.getValueOfPropertyAt(i, j, type);
                currentFill = this.getValueOfPropertyAt(i, j, $ab3f2a5cc6216ae5$var$FILL);
                const currentSize = this.getHeightOfChar(i, j);
                const currentDy = this.getValueOfPropertyAt(i, j, "deltaY");
                if (path && currentDecoration && currentFill) {
                    ctx.save();
                    // bug? verify lastFill is a valid fill here.
                    ctx.fillStyle = lastFill;
                    ctx.translate(charBox.renderLeft, charBox.renderTop);
                    ctx.rotate(charBox.angle);
                    ctx.fillRect(-charBox.kernedWidth / 2, offsetY * currentSize + currentDy, charBox.kernedWidth, this.fontSize / 15);
                    ctx.restore();
                } else if ((currentDecoration !== lastDecoration || currentFill !== lastFill || currentSize !== size || currentDy !== dy) && boxWidth > 0) {
                    let drawStart = leftOffset + lineLeftOffset + boxStart;
                    if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
                    if (lastDecoration && lastFill) {
                        // bug? verify lastFill is a valid fill here.
                        ctx.fillStyle = lastFill;
                        ctx.fillRect(drawStart, top + offsetY * size + dy, boxWidth, this.fontSize / 15);
                    }
                    boxStart = charBox.left;
                    boxWidth = charBox.width;
                    lastDecoration = currentDecoration;
                    lastFill = currentFill;
                    size = currentSize;
                    dy = currentDy;
                } else boxWidth += charBox.kernedWidth;
            }
            let drawStart = leftOffset + lineLeftOffset + boxStart;
            if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
            ctx.fillStyle = currentFill;
            currentDecoration && currentFill && ctx.fillRect(drawStart, top + offsetY * size + dy, boxWidth - charSpacing, this.fontSize / 15);
            topOffset += heightOfLine;
        }
        // if there is text background color no
        // other shadows should be casted
        this._removeShadow(ctx);
    }
    /**
   * return font declaration string for canvas context
   * @param {Object} [styleObject] object
   * @returns {String} font declaration formatted for canvas context.
   */ _getFontDeclaration() {
        let { fontFamily: fontFamily = this.fontFamily, fontStyle: fontStyle = this.fontStyle, fontWeight: fontWeight = this.fontWeight, fontSize: fontSize = this.fontSize } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let forMeasuring = arguments.length > 1 ? arguments[1] : undefined;
        const parsedFontFamily = fontFamily.includes("'") || fontFamily.includes('"') || fontFamily.includes(",") || $ab3f2a5cc6216ae5$export$72cf63a35cb577f7.genericFonts.includes(fontFamily.toLowerCase()) ? fontFamily : '"'.concat(fontFamily, '"');
        return [
            fontStyle,
            fontWeight,
            "".concat(forMeasuring ? this.CACHE_FONT_SIZE : fontSize, "px"),
            parsedFontFamily
        ].join(" ");
    }
    /**
   * Renders text instance on a specified context
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ render(ctx) {
        if (!this.visible) return;
        if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) return;
        if (this._forceClearCache) this.initDimensions();
        super.render(ctx);
    }
    /**
   * Override this method to customize grapheme splitting
   * @todo the util `graphemeSplit` needs to be injectable in some way.
   * is more comfortable to inject the correct util rather than having to override text
   * in the middle of the prototype chain
   * @param {string} value
   * @returns {string[]} array of graphemes
   */ graphemeSplit(value) {
        return $ab3f2a5cc6216ae5$var$graphemeSplit(value);
    }
    /**
   * Returns the text as an array of lines.
   * @param {String} text text to split
   * @returns  Lines in the text
   */ _splitTextIntoLines(text) {
        const lines = text.split(this._reNewline), newLines = new Array(lines.length), newLine = [
            "\n"
        ];
        let newText = [];
        for(let i = 0; i < lines.length; i++){
            newLines[i] = this.graphemeSplit(lines[i]);
            newText = newText.concat(newLines[i], newLine);
        }
        newText.pop();
        return {
            _unwrappedLines: newLines,
            lines: lines,
            graphemeText: newText,
            graphemeLines: newLines
        };
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} Object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.toObject([
            ...$ab3f2a5cc6216ae5$var$additionalProps,
            ...propertiesToInclude
        ])), {}, {
            styles: $ab3f2a5cc6216ae5$var$stylesToArray(this.styles, this.text)
        }, this.path ? {
            path: this.path.toObject()
        } : {});
    }
    set(key, value) {
        const { textLayoutProperties: textLayoutProperties } = this.constructor;
        super.set(key, value);
        let needsDims = false;
        let isAddingPath = false;
        if (typeof key === "object") for(const _key in key){
            if (_key === "path") this.setPathInfo();
            needsDims = needsDims || textLayoutProperties.includes(_key);
            isAddingPath = isAddingPath || _key === "path";
        }
        else {
            needsDims = textLayoutProperties.includes(key);
            isAddingPath = key === "path";
        }
        if (isAddingPath) this.setPathInfo();
        if (needsDims && this.initialized) {
            this.initDimensions();
            this.setCoords();
        }
        return this;
    }
    /**
   * Returns complexity of an instance
   * @return {Number} complexity
   */ complexity() {
        return 1;
    }
    /**
   * Returns FabricText instance from an SVG element (<b>not yet implemented</b>)
   * @static
   * @memberOf Text
   * @param {HTMLElement} element Element to parse
   * @param {Object} [options] Options object
   */ static async fromElement(element, options, cssRules) {
        const parsedAttributes = $ab3f2a5cc6216ae5$export$fbe550151e406473(element, $ab3f2a5cc6216ae5$export$72cf63a35cb577f7.ATTRIBUTE_NAMES, cssRules);
        const _options$parsedAttrib = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), parsedAttributes), { textAnchor: textAnchor = $ab3f2a5cc6216ae5$var$LEFT, textDecoration: textDecoration = "", dx: dx = 0, dy: dy = 0, top: top = 0, left: left = 0, fontSize: fontSize = $ab3f2a5cc6216ae5$var$DEFAULT_SVG_FONT_SIZE, strokeWidth: strokeWidth = 1 } = _options$parsedAttrib, restOfOptions = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_options$parsedAttrib, $ab3f2a5cc6216ae5$var$_excluded$3);
        const textContent = (element.textContent || "").replace(/^\s+|\s+$|\n+/g, "").replace(/\s+/g, " ");
        // this code here is probably the usual issue for SVG center find
        // this can later looked at again and probably removed.
        const text = new this(textContent, $ab3f2a5cc6216ae5$var$_objectSpread2({
            left: left + dx,
            top: top + dy,
            underline: textDecoration.includes("underline"),
            overline: textDecoration.includes("overline"),
            linethrough: textDecoration.includes("line-through"),
            // we initialize this as 0
            strokeWidth: 0,
            fontSize: fontSize
        }, restOfOptions)), textHeightScaleFactor = text.getScaledHeight() / text.height, lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height, scaledDiff = lineHeightDiff * textHeightScaleFactor, textHeight = text.getScaledHeight() + scaledDiff;
        let offX = 0;
        /*
      Adjust positioning:
        x/y attributes in SVG correspond to the bottom-left corner of text bounding box
        fabric output by default at top, left.
    */ if (textAnchor === $ab3f2a5cc6216ae5$var$CENTER) offX = text.getScaledWidth() / 2;
        if (textAnchor === $ab3f2a5cc6216ae5$var$RIGHT) offX = text.getScaledWidth();
        text.set({
            left: text.left - offX,
            top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
            strokeWidth: strokeWidth
        });
        return text;
    }
    /* _FROM_SVG_END_ */ /**
   * Returns FabricText instance from an object representation
   * @param {Object} object plain js Object to create an instance from
   * @returns {Promise<FabricText>}
   */ static fromObject(object) {
        return this._fromObject($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, object), {}, {
            styles: $ab3f2a5cc6216ae5$var$stylesFromArray(object.styles || {}, object.text)
        }), {
            extraParam: "text"
        });
    }
}
/**
 * Properties that requires a text layout recalculation when changed
 * @type string[]
 * @protected
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$72cf63a35cb577f7, "textLayoutProperties", $ab3f2a5cc6216ae5$var$textLayoutProperties);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$72cf63a35cb577f7, "cacheProperties", [
    ...$ab3f2a5cc6216ae5$var$cacheProperties,
    ...$ab3f2a5cc6216ae5$var$additionalProps
]);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$72cf63a35cb577f7, "ownDefaults", $ab3f2a5cc6216ae5$var$textDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$72cf63a35cb577f7, "type", "Text");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$72cf63a35cb577f7, "genericFonts", [
    "sans-serif",
    "serif",
    "cursive",
    "fantasy",
    "monospace"
]);
/* _FROM_SVG_START_ */ /**
 * List of attribute names to account for when parsing SVG element (used by {@link FabricText.fromElement})
 * @static
 * @memberOf Text
 * @see: http://www.w3.org/TR/SVG/text.html#TextElement
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$72cf63a35cb577f7, "ATTRIBUTE_NAMES", $ab3f2a5cc6216ae5$var$SHARED_ATTRIBUTES.concat("x", "y", "dx", "dy", "font-family", "font-style", "font-weight", "font-size", "letter-spacing", "text-decoration", "text-anchor"));
$ab3f2a5cc6216ae5$var$applyMixins($ab3f2a5cc6216ae5$export$72cf63a35cb577f7, [
    $ab3f2a5cc6216ae5$var$TextSVGExportMixin
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$72cf63a35cb577f7);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setSVGClass($ab3f2a5cc6216ae5$export$72cf63a35cb577f7);
/**
 * #### Dragging IText/Textbox Lifecycle
 * - {@link start} is called from `mousedown` {@link IText#_mouseDownHandler} and determines if dragging should start by testing {@link isPointerOverSelection}
 * - if true `mousedown` {@link IText#_mouseDownHandler} is blocked to keep selection
 * - if the pointer moves, canvas fires numerous mousemove {@link Canvas#_onMouseMove} that we make sure **aren't** prevented ({@link IText#shouldStartDragging}) in order for the window to start a drag session
 * - once/if the session starts canvas calls {@link onDragStart} on the active object to determine if dragging should occur
 * - canvas fires relevant drag events that are handled by the handlers defined in this scope
 * - {@link end} is called from `mouseup` {@link IText#mouseUpHandler}, blocking IText default click behavior
 * - in case the drag session didn't occur, {@link end} handles a click, since logic to do so was blocked during `mousedown`
 */ class $ab3f2a5cc6216ae5$var$DraggableTextDelegate {
    constructor(target){
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "target", void 0);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "__mouseDownInPlace", false);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "__dragStartFired", false);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "__isDraggingOver", false);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "__dragStartSelection", void 0);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "__dragImageDisposer", void 0);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "_dispose", void 0);
        this.target = target;
        const disposers = [
            this.target.on("dragenter", this.dragEnterHandler.bind(this)),
            this.target.on("dragover", this.dragOverHandler.bind(this)),
            this.target.on("dragleave", this.dragLeaveHandler.bind(this)),
            this.target.on("dragend", this.dragEndHandler.bind(this)),
            this.target.on("drop", this.dropHandler.bind(this))
        ];
        this._dispose = ()=>{
            disposers.forEach((d)=>d());
            this._dispose = undefined;
        };
    }
    isPointerOverSelection(e) {
        const target = this.target;
        const newSelection = target.getSelectionStartFromPointer(e);
        return target.isEditing && newSelection >= target.selectionStart && newSelection <= target.selectionEnd && target.selectionStart < target.selectionEnd;
    }
    /**
   * @public override this method to disable dragging and default to mousedown logic
   */ start(e) {
        return this.__mouseDownInPlace = this.isPointerOverSelection(e);
    }
    /**
   * @public override this method to disable dragging without discarding selection
   */ isActive() {
        return this.__mouseDownInPlace;
    }
    /**
   * Ends interaction and sets cursor in case of a click
   * @returns true if was active
   */ end(e) {
        const active = this.isActive();
        if (active && !this.__dragStartFired) {
            // mousedown has been blocked since `active` is true => cursor has not been set.
            // `__dragStartFired` is false => dragging didn't occur, pointer didn't move and is over selection.
            // meaning this is actually a click, `active` is a false positive.
            this.target.setCursorByClick(e);
            this.target.initDelayedCursor(true);
        }
        this.__mouseDownInPlace = false;
        this.__dragStartFired = false;
        this.__isDraggingOver = false;
        return active;
    }
    getDragStartSelection() {
        return this.__dragStartSelection;
    }
    /**
   * Override to customize the drag image
   * https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage
   */ setDragImage(e, _ref) {
        var _e$dataTransfer;
        let { selectionStart: selectionStart, selectionEnd: selectionEnd } = _ref;
        const target = this.target;
        const canvas = target.canvas;
        const flipFactor = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(target.flipX ? -1 : 1, target.flipY ? -1 : 1);
        const boundaries = target._getCursorBoundaries(selectionStart);
        const selectionPosition = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(boundaries.left + boundaries.leftOffset, boundaries.top + boundaries.topOffset).multiply(flipFactor);
        const pos = selectionPosition.transform(target.calcTransformMatrix());
        const pointer = canvas.getScenePoint(e);
        const diff = pointer.subtract(pos);
        const retinaScaling = target.getCanvasRetinaScaling();
        const bbox = target.getBoundingRect();
        const correction = pos.subtract(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(bbox.left, bbox.top));
        const vpt = canvas.viewportTransform;
        const offset = correction.add(diff).transform(vpt, true);
        //  prepare instance for drag image snapshot by making all non selected text invisible
        const bgc = target.backgroundColor;
        const styles = $ab3f2a5cc6216ae5$var$cloneDeep(target.styles);
        target.backgroundColor = "";
        const styleOverride = {
            stroke: "transparent",
            fill: "transparent",
            textBackgroundColor: "transparent"
        };
        target.setSelectionStyles(styleOverride, 0, selectionStart);
        target.setSelectionStyles(styleOverride, selectionEnd, target.text.length);
        target.dirty = true;
        const dragImage = target.toCanvasElement({
            enableRetinaScaling: canvas.enableRetinaScaling,
            viewportTransform: true
        });
        // restore values
        target.backgroundColor = bgc;
        target.styles = styles;
        target.dirty = true;
        //  position drag image offscreen
        $ab3f2a5cc6216ae5$var$setStyle(dragImage, {
            position: "fixed",
            left: "".concat(-dragImage.width, "px"),
            border: $ab3f2a5cc6216ae5$var$NONE,
            width: "".concat(dragImage.width / retinaScaling, "px"),
            height: "".concat(dragImage.height / retinaScaling, "px")
        });
        this.__dragImageDisposer && this.__dragImageDisposer();
        this.__dragImageDisposer = ()=>{
            dragImage.remove();
        };
        $ab3f2a5cc6216ae5$var$getDocumentFromElement(e.target || this.target.hiddenTextarea).body.appendChild(dragImage);
        (_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 || _e$dataTransfer.setDragImage(dragImage, offset.x, offset.y);
    }
    /**
   * @returns {boolean} determines whether {@link target} should/shouldn't become a drag source
   */ onDragStart(e) {
        this.__dragStartFired = true;
        const target = this.target;
        const active = this.isActive();
        if (active && e.dataTransfer) {
            const selection = this.__dragStartSelection = {
                selectionStart: target.selectionStart,
                selectionEnd: target.selectionEnd
            };
            const value = target._text.slice(selection.selectionStart, selection.selectionEnd).join("");
            const data = $ab3f2a5cc6216ae5$var$_objectSpread2({
                text: target.text,
                value: value
            }, selection);
            e.dataTransfer.setData("text/plain", value);
            e.dataTransfer.setData("application/fabric", JSON.stringify({
                value: value,
                styles: target.getSelectionStyles(selection.selectionStart, selection.selectionEnd, true)
            }));
            e.dataTransfer.effectAllowed = "copyMove";
            this.setDragImage(e, data);
        }
        target.abortCursorAnimation();
        return active;
    }
    /**
   * use {@link targetCanDrop} to respect overriding
   * @returns {boolean} determines whether {@link target} should/shouldn't become a drop target
   */ canDrop(e) {
        if (this.target.editable && !this.target.getActiveControl() && !e.defaultPrevented) {
            if (this.isActive() && this.__dragStartSelection) {
                //  drag source trying to drop over itself
                //  allow dropping only outside of drag start selection
                const index = this.target.getSelectionStartFromPointer(e);
                const dragStartSelection = this.__dragStartSelection;
                return index < dragStartSelection.selectionStart || index > dragStartSelection.selectionEnd;
            }
            return true;
        }
        return false;
    }
    /**
   * in order to respect overriding {@link IText#canDrop} we call that instead of calling {@link canDrop} directly
   */ targetCanDrop(e) {
        return this.target.canDrop(e);
    }
    dragEnterHandler(_ref2) {
        let { e: e } = _ref2;
        const canDrop = this.targetCanDrop(e);
        if (!this.__isDraggingOver && canDrop) this.__isDraggingOver = true;
    }
    dragOverHandler(ev) {
        const { e: e } = ev;
        const canDrop = this.targetCanDrop(e);
        if (!this.__isDraggingOver && canDrop) this.__isDraggingOver = true;
        else if (this.__isDraggingOver && !canDrop) //  drop state has changed
        this.__isDraggingOver = false;
        if (this.__isDraggingOver) {
            //  can be dropped, inform browser
            e.preventDefault();
            //  inform event subscribers
            ev.canDrop = true;
            ev.dropTarget = this.target;
        }
    }
    dragLeaveHandler() {
        if (this.__isDraggingOver || this.isActive()) this.__isDraggingOver = false;
    }
    /**
   * Override the `text/plain | application/fabric` types of {@link DragEvent#dataTransfer}
   * in order to change the drop value or to customize styling respectively, by listening to the `drop:before` event
   * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#performing_a_drop
   */ dropHandler(ev) {
        var _e$dataTransfer2;
        const { e: e } = ev;
        const didDrop = e.defaultPrevented;
        this.__isDraggingOver = false;
        // inform browser that the drop has been accepted
        e.preventDefault();
        let insert = (_e$dataTransfer2 = e.dataTransfer) === null || _e$dataTransfer2 === void 0 ? void 0 : _e$dataTransfer2.getData("text/plain");
        if (insert && !didDrop) {
            const target = this.target;
            const canvas = target.canvas;
            let insertAt = target.getSelectionStartFromPointer(e);
            const { styles: styles } = e.dataTransfer.types.includes("application/fabric") ? JSON.parse(e.dataTransfer.getData("application/fabric")) : {};
            const trailing = insert[Math.max(0, insert.length - 1)];
            const selectionStartOffset = 0;
            //  drag and drop in same instance
            if (this.__dragStartSelection) {
                const selectionStart = this.__dragStartSelection.selectionStart;
                const selectionEnd = this.__dragStartSelection.selectionEnd;
                if (insertAt > selectionStart && insertAt <= selectionEnd) insertAt = selectionStart;
                else if (insertAt > selectionEnd) insertAt -= selectionEnd - selectionStart;
                target.removeChars(selectionStart, selectionEnd);
                // prevent `dragend` from handling event
                delete this.__dragStartSelection;
            }
            //  remove redundant line break
            if (target._reNewline.test(trailing) && (target._reNewline.test(target._text[insertAt]) || insertAt === target._text.length)) insert = insert.trimEnd();
            //  inform subscribers
            ev.didDrop = true;
            ev.dropTarget = target;
            //  finalize
            target.insertChars(insert, styles, insertAt);
            // can this part be moved in an outside event? andrea to check.
            canvas.setActiveObject(target);
            target.enterEditing(e);
            target.selectionStart = Math.min(insertAt + selectionStartOffset, target._text.length);
            target.selectionEnd = Math.min(target.selectionStart + insert.length, target._text.length);
            target.hiddenTextarea.value = target.text;
            target._updateTextarea();
            target.hiddenTextarea.focus();
            target.fire($ab3f2a5cc6216ae5$var$CHANGED, {
                index: insertAt + selectionStartOffset,
                action: "drop"
            });
            canvas.fire("text:changed", {
                target: target
            });
            canvas.contextTopDirty = true;
            canvas.requestRenderAll();
        }
    }
    /**
   * fired only on the drag source after drop (if occurred)
   * handle changes to the drag source in case of a drop on another object or a cancellation
   * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#finishing_a_drag
   */ dragEndHandler(_ref3) {
        let { e: e } = _ref3;
        if (this.isActive() && this.__dragStartFired) //  once the drop event finishes we check if we need to change the drag source
        //  if the drag source received the drop we bail out since the drop handler has already handled logic
        {
            if (this.__dragStartSelection) {
                var _e$dataTransfer3;
                const target = this.target;
                const canvas = this.target.canvas;
                const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.__dragStartSelection;
                const dropEffect = ((_e$dataTransfer3 = e.dataTransfer) === null || _e$dataTransfer3 === void 0 ? void 0 : _e$dataTransfer3.dropEffect) || $ab3f2a5cc6216ae5$var$NONE;
                if (dropEffect === $ab3f2a5cc6216ae5$var$NONE) {
                    // pointer is back over selection
                    target.selectionStart = selectionStart;
                    target.selectionEnd = selectionEnd;
                    target._updateTextarea();
                    target.hiddenTextarea.focus();
                } else {
                    target.clearContextTop();
                    if (dropEffect === "move") {
                        target.removeChars(selectionStart, selectionEnd);
                        target.selectionStart = target.selectionEnd = selectionStart;
                        target.hiddenTextarea && (target.hiddenTextarea.value = target.text);
                        target._updateTextarea();
                        target.fire($ab3f2a5cc6216ae5$var$CHANGED, {
                            index: selectionStart,
                            action: "dragend"
                        });
                        canvas.fire("text:changed", {
                            target: target
                        });
                        canvas.requestRenderAll();
                    }
                    target.exitEditing();
                }
            }
        }
        this.__dragImageDisposer && this.__dragImageDisposer();
        delete this.__dragImageDisposer;
        delete this.__dragStartSelection;
        this.__isDraggingOver = false;
    }
    dispose() {
        this._dispose && this._dispose();
    }
}
/**
 *  extend this regex to support non english languages
 *
 *  - ` `      Matches a SPACE character (char code 32).
 *  - `\n`     Matches a LINE FEED character (char code 10).
 *  - `\.`     Matches a "." character (char code 46).
 *  - `,`      Matches a "," character (char code 44).
 *  - `;`      Matches a ";" character (char code 59).
 *  - `!`      Matches a "!" character (char code 33).
 *  - `\?`     Matches a "?" character (char code 63).
 *  - `\-`     Matches a "-" character (char code 45).
 */ // eslint-disable-next-line no-useless-escape
const $ab3f2a5cc6216ae5$var$reNonWord = /[ \n\.,;!\?\-]/;
class $ab3f2a5cc6216ae5$var$ITextBehavior extends $ab3f2a5cc6216ae5$export$72cf63a35cb577f7 {
    constructor(){
        super(...arguments);
        /**
     * Helps determining when the text is in composition, so that the cursor
     * rendering is altered.
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_currentCursorOpacity", 1);
    }
    /**
   * Initializes all the interactive behavior of IText
   */ initBehavior() {
        this._tick = this._tick.bind(this);
        this._onTickComplete = this._onTickComplete.bind(this);
        this.updateSelectionOnMouseMove = this.updateSelectionOnMouseMove.bind(this);
    }
    onDeselect(options) {
        this.isEditing && this.exitEditing();
        this.selected = false;
        return super.onDeselect(options);
    }
    /**
   * @private
   */ _animateCursor(_ref) {
        let { toValue: toValue, duration: duration, delay: delay, onComplete: onComplete } = _ref;
        return $ab3f2a5cc6216ae5$var$animate({
            startValue: this._currentCursorOpacity,
            endValue: toValue,
            duration: duration,
            delay: delay,
            onComplete: onComplete,
            abort: ()=>!this.canvas || // we do not want to animate a selection, only cursor
                this.selectionStart !== this.selectionEnd,
            onChange: (value)=>{
                this._currentCursorOpacity = value;
                this.renderCursorOrSelection();
            }
        });
    }
    /**
   * changes the cursor from visible to invisible
   */ _tick(delay) {
        this._currentTickState = this._animateCursor({
            toValue: 0,
            duration: this.cursorDuration / 2,
            delay: Math.max(delay || 0, 100),
            onComplete: this._onTickComplete
        });
    }
    /**
   * Changes the cursor from invisible to visible
   */ _onTickComplete() {
        var _this$_currentTickCom;
        (_this$_currentTickCom = this._currentTickCompleteState) === null || _this$_currentTickCom === void 0 || _this$_currentTickCom.abort();
        this._currentTickCompleteState = this._animateCursor({
            toValue: 1,
            duration: this.cursorDuration,
            onComplete: this._tick
        });
    }
    /**
   * Initializes delayed cursor
   */ initDelayedCursor(restart) {
        this.abortCursorAnimation();
        this._tick(restart ? 0 : this.cursorDelay);
    }
    /**
   * Aborts cursor animation, clears all timeouts and clear textarea context if necessary
   */ abortCursorAnimation() {
        let shouldClear = false;
        [
            this._currentTickState,
            this._currentTickCompleteState
        ].forEach((cursorAnimation)=>{
            if (cursorAnimation && !cursorAnimation.isDone()) {
                shouldClear = true;
                cursorAnimation.abort();
            }
        });
        this._currentCursorOpacity = 1;
        //  make sure we clear context even if instance is not editing
        if (shouldClear) this.clearContextTop();
    }
    /**
   * Restart tue cursor animation if either is in complete state ( between animations )
   * or if it never started before
   */ restartCursorIfNeeded() {
        if ([
            this._currentTickState,
            this._currentTickCompleteState
        ].some((cursorAnimation)=>!cursorAnimation || cursorAnimation.isDone())) this.initDelayedCursor();
    }
    /**
   * Selects entire text
   */ selectAll() {
        this.selectionStart = 0;
        this.selectionEnd = this._text.length;
        this._fireSelectionChanged();
        this._updateTextarea();
        return this;
    }
    /**
   * Returns selected text
   * @return {String}
   */ getSelectedText() {
        return this._text.slice(this.selectionStart, this.selectionEnd).join("");
    }
    /**
   * Find new selection index representing start of current word according to current selection index
   * @param {Number} startFrom Current selection index
   * @return {Number} New selection index
   */ findWordBoundaryLeft(startFrom) {
        let offset = 0, index = startFrom - 1;
        // remove space before cursor first
        if (this._reSpace.test(this._text[index])) while(this._reSpace.test(this._text[index])){
            offset++;
            index--;
        }
        while(/\S/.test(this._text[index]) && index > -1){
            offset++;
            index--;
        }
        return startFrom - offset;
    }
    /**
   * Find new selection index representing end of current word according to current selection index
   * @param {Number} startFrom Current selection index
   * @return {Number} New selection index
   */ findWordBoundaryRight(startFrom) {
        let offset = 0, index = startFrom;
        // remove space after cursor first
        if (this._reSpace.test(this._text[index])) while(this._reSpace.test(this._text[index])){
            offset++;
            index++;
        }
        while(/\S/.test(this._text[index]) && index < this._text.length){
            offset++;
            index++;
        }
        return startFrom + offset;
    }
    /**
   * Find new selection index representing start of current line according to current selection index
   * @param {Number} startFrom Current selection index
   * @return {Number} New selection index
   */ findLineBoundaryLeft(startFrom) {
        let offset = 0, index = startFrom - 1;
        while(!/\n/.test(this._text[index]) && index > -1){
            offset++;
            index--;
        }
        return startFrom - offset;
    }
    /**
   * Find new selection index representing end of current line according to current selection index
   * @param {Number} startFrom Current selection index
   * @return {Number} New selection index
   */ findLineBoundaryRight(startFrom) {
        let offset = 0, index = startFrom;
        while(!/\n/.test(this._text[index]) && index < this._text.length){
            offset++;
            index++;
        }
        return startFrom + offset;
    }
    /**
   * Finds index corresponding to beginning or end of a word
   * @param {Number} selectionStart Index of a character
   * @param {Number} direction 1 or -1
   * @return {Number} Index of the beginning or end of a word
   */ searchWordBoundary(selectionStart, direction) {
        const text = this._text;
        // if we land on a space we move the cursor backwards
        // if we are searching boundary end we move the cursor backwards ONLY if we don't land on a line break
        let index = selectionStart > 0 && this._reSpace.test(text[selectionStart]) && (direction === -1 || !$ab3f2a5cc6216ae5$var$reNewline.test(text[selectionStart - 1])) ? selectionStart - 1 : selectionStart, _char = text[index];
        while(index > 0 && index < text.length && !$ab3f2a5cc6216ae5$var$reNonWord.test(_char)){
            index += direction;
            _char = text[index];
        }
        if (direction === -1 && $ab3f2a5cc6216ae5$var$reNonWord.test(_char)) index++;
        return index;
    }
    /**
   * TODO fix: selectionStart set as 0 will be ignored?
   * Selects a word based on the index
   * @param {Number} selectionStart Index of a character
   */ selectWord(selectionStart) {
        selectionStart = selectionStart || this.selectionStart;
        // search backwards
        const newSelectionStart = this.searchWordBoundary(selectionStart, -1), // search forward
        newSelectionEnd = Math.max(newSelectionStart, this.searchWordBoundary(selectionStart, 1));
        this.selectionStart = newSelectionStart;
        this.selectionEnd = newSelectionEnd;
        this._fireSelectionChanged();
        this._updateTextarea();
        this.renderCursorOrSelection();
    }
    /**
   * TODO fix: selectionStart set as 0 will be ignored?
   * Selects a line based on the index
   * @param {Number} selectionStart Index of a character
   */ selectLine(selectionStart) {
        selectionStart = selectionStart || this.selectionStart;
        const newSelectionStart = this.findLineBoundaryLeft(selectionStart), newSelectionEnd = this.findLineBoundaryRight(selectionStart);
        this.selectionStart = newSelectionStart;
        this.selectionEnd = newSelectionEnd;
        this._fireSelectionChanged();
        this._updateTextarea();
        return this;
    }
    /**
   * Enters editing state
   */ enterEditing(e) {
        if (this.isEditing || !this.editable) return;
        if (this.canvas) {
            this.canvas.calcOffset();
            this.canvas.textEditingManager.exitTextEditing();
        }
        this.isEditing = true;
        this.initHiddenTextarea();
        this.hiddenTextarea.focus();
        this.hiddenTextarea.value = this.text;
        this._updateTextarea();
        this._saveEditingProps();
        this._setEditingProps();
        this._textBeforeEdit = this.text;
        this._tick();
        this.fire("editing:entered", e ? {
            e: e
        } : undefined);
        this._fireSelectionChanged();
        if (this.canvas) {
            // @ts-expect-error in reality it is an IText instance
            this.canvas.fire("text:editing:entered", {
                target: this,
                e: e
            });
            this.canvas.requestRenderAll();
        }
    }
    /**
   * called by {@link Canvas#textEditingManager}
   */ updateSelectionOnMouseMove(e) {
        if (this.getActiveControl()) return;
        const el = this.hiddenTextarea;
        // regain focus
        $ab3f2a5cc6216ae5$var$getDocumentFromElement(el).activeElement !== el && el.focus();
        const newSelectionStart = this.getSelectionStartFromPointer(e), currentStart = this.selectionStart, currentEnd = this.selectionEnd;
        if ((newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd) && (currentStart === newSelectionStart || currentEnd === newSelectionStart)) return;
        if (newSelectionStart > this.__selectionStartOnMouseDown) {
            this.selectionStart = this.__selectionStartOnMouseDown;
            this.selectionEnd = newSelectionStart;
        } else {
            this.selectionStart = newSelectionStart;
            this.selectionEnd = this.__selectionStartOnMouseDown;
        }
        if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
            this._fireSelectionChanged();
            this._updateTextarea();
            this.renderCursorOrSelection();
        }
    }
    /**
   * @private
   */ _setEditingProps() {
        this.hoverCursor = "text";
        if (this.canvas) this.canvas.defaultCursor = this.canvas.moveCursor = "text";
        this.borderColor = this.editingBorderColor;
        this.hasControls = this.selectable = false;
        this.lockMovementX = this.lockMovementY = true;
    }
    /**
   * convert from textarea to grapheme indexes
   */ fromStringToGraphemeSelection(start, end, text) {
        const smallerTextStart = text.slice(0, start), graphemeStart = this.graphemeSplit(smallerTextStart).length;
        if (start === end) return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart
        };
        const smallerTextEnd = text.slice(start, end), graphemeEnd = this.graphemeSplit(smallerTextEnd).length;
        return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart + graphemeEnd
        };
    }
    /**
   * convert from fabric to textarea values
   */ fromGraphemeToStringSelection(start, end, graphemes) {
        const smallerTextStart = graphemes.slice(0, start), graphemeStart = smallerTextStart.join("").length;
        if (start === end) return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart
        };
        const smallerTextEnd = graphemes.slice(start, end), graphemeEnd = smallerTextEnd.join("").length;
        return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart + graphemeEnd
        };
    }
    /**
   * @private
   */ _updateTextarea() {
        this.cursorOffsetCache = {};
        if (!this.hiddenTextarea) return;
        if (!this.inCompositionMode) {
            const newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
            this.hiddenTextarea.selectionStart = newSelection.selectionStart;
            this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
        }
        this.updateTextareaPosition();
    }
    /**
   * @private
   */ updateFromTextArea() {
        if (!this.hiddenTextarea) return;
        this.cursorOffsetCache = {};
        const textarea = this.hiddenTextarea;
        this.text = textarea.value;
        this.set("dirty", true);
        this.initDimensions();
        this.setCoords();
        const newSelection = this.fromStringToGraphemeSelection(textarea.selectionStart, textarea.selectionEnd, textarea.value);
        this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
        if (!this.inCompositionMode) this.selectionStart = newSelection.selectionStart;
        this.updateTextareaPosition();
    }
    /**
   * @private
   */ updateTextareaPosition() {
        if (this.selectionStart === this.selectionEnd) {
            const style = this._calcTextareaPosition();
            this.hiddenTextarea.style.left = style.left;
            this.hiddenTextarea.style.top = style.top;
        }
    }
    /**
   * @private
   * @return {Object} style contains style for hiddenTextarea
   */ _calcTextareaPosition() {
        if (!this.canvas) return {
            left: "1px",
            top: "1px"
        };
        const desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart, boundaries = this._getCursorBoundaries(desiredPosition), cursorLocation = this.get2DCursorLocation(desiredPosition), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, "fontSize") * this.lineHeight, leftOffset = boundaries.leftOffset, retinaScaling = this.getCanvasRetinaScaling(), upperCanvas = this.canvas.upperCanvasEl, upperCanvasWidth = upperCanvas.width / retinaScaling, upperCanvasHeight = upperCanvas.height / retinaScaling, maxWidth = upperCanvasWidth - charHeight, maxHeight = upperCanvasHeight - charHeight;
        const p = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(boundaries.left + leftOffset, boundaries.top + boundaries.topOffset + charHeight).transform(this.calcTransformMatrix()).transform(this.canvas.viewportTransform).multiply(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(upperCanvas.clientWidth / upperCanvasWidth, upperCanvas.clientHeight / upperCanvasHeight));
        if (p.x < 0) p.x = 0;
        if (p.x > maxWidth) p.x = maxWidth;
        if (p.y < 0) p.y = 0;
        if (p.y > maxHeight) p.y = maxHeight;
        // add canvas offset on document
        p.x += this.canvas._offset.left;
        p.y += this.canvas._offset.top;
        return {
            left: "".concat(p.x, "px"),
            top: "".concat(p.y, "px"),
            fontSize: "".concat(charHeight, "px"),
            charHeight: charHeight
        };
    }
    /**
   * @private
   */ _saveEditingProps() {
        this._savedProps = {
            hasControls: this.hasControls,
            borderColor: this.borderColor,
            lockMovementX: this.lockMovementX,
            lockMovementY: this.lockMovementY,
            hoverCursor: this.hoverCursor,
            selectable: this.selectable,
            defaultCursor: this.canvas && this.canvas.defaultCursor,
            moveCursor: this.canvas && this.canvas.moveCursor
        };
    }
    /**
   * @private
   */ _restoreEditingProps() {
        if (!this._savedProps) return;
        this.hoverCursor = this._savedProps.hoverCursor;
        this.hasControls = this._savedProps.hasControls;
        this.borderColor = this._savedProps.borderColor;
        this.selectable = this._savedProps.selectable;
        this.lockMovementX = this._savedProps.lockMovementX;
        this.lockMovementY = this._savedProps.lockMovementY;
        if (this.canvas) {
            this.canvas.defaultCursor = this._savedProps.defaultCursor || this.canvas.defaultCursor;
            this.canvas.moveCursor = this._savedProps.moveCursor || this.canvas.moveCursor;
        }
        delete this._savedProps;
    }
    /**
   * runs the actual logic that exits from editing state, see {@link exitEditing}
   */ _exitEditing() {
        const hiddenTextarea = this.hiddenTextarea;
        this.selected = false;
        this.isEditing = false;
        if (hiddenTextarea) {
            hiddenTextarea.blur && hiddenTextarea.blur();
            hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
        }
        this.hiddenTextarea = null;
        this.abortCursorAnimation();
        this.selectionStart !== this.selectionEnd && this.clearContextTop();
    }
    /**
   * Exits from editing state and fires relevant events
   */ exitEditing() {
        const isTextChanged = this._textBeforeEdit !== this.text;
        this._exitEditing();
        this.selectionEnd = this.selectionStart;
        this._restoreEditingProps();
        if (this._forceClearCache) {
            this.initDimensions();
            this.setCoords();
        }
        this.fire("editing:exited");
        isTextChanged && this.fire($ab3f2a5cc6216ae5$var$MODIFIED);
        if (this.canvas) {
            this.canvas.fire("text:editing:exited", {
                target: this
            });
            // todo: evaluate add an action to this event
            isTextChanged && this.canvas.fire("object:modified", {
                target: this
            });
        }
        return this;
    }
    /**
   * @private
   */ _removeExtraneousStyles() {
        for(const prop in this.styles)if (!this._textLines[prop]) delete this.styles[prop];
    }
    /**
   * remove and reflow a style block from start to end.
   * @param {Number} start linear start position for removal (included in removal)
   * @param {Number} end linear end position for removal ( excluded from removal )
   */ removeStyleFromTo(start, end) {
        const { lineIndex: lineStart, charIndex: charStart } = this.get2DCursorLocation(start, true), { lineIndex: lineEnd, charIndex: charEnd } = this.get2DCursorLocation(end, true);
        if (lineStart !== lineEnd) {
            // step1 remove the trailing of lineStart
            if (this.styles[lineStart]) for(let i = charStart; i < this._unwrappedTextLines[lineStart].length; i++)delete this.styles[lineStart][i];
            // step2 move the trailing of lineEnd to lineStart if needed
            if (this.styles[lineEnd]) for(let i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++){
                const styleObj = this.styles[lineEnd][i];
                if (styleObj) {
                    this.styles[lineStart] || (this.styles[lineStart] = {});
                    this.styles[lineStart][charStart + i - charEnd] = styleObj;
                }
            }
            // step3 detects lines will be completely removed.
            for(let i = lineStart + 1; i <= lineEnd; i++)delete this.styles[i];
            // step4 shift remaining lines.
            this.shiftLineStyles(lineEnd, lineStart - lineEnd);
        } else // remove and shift left on the same line
        if (this.styles[lineStart]) {
            const styleObj = this.styles[lineStart];
            const diff = charEnd - charStart;
            for(let i = charStart; i < charEnd; i++)delete styleObj[i];
            for(const char in this.styles[lineStart]){
                const numericChar = parseInt(char, 10);
                if (numericChar >= charEnd) {
                    styleObj[numericChar - diff] = styleObj[char];
                    delete styleObj[char];
                }
            }
        }
    }
    /**
   * Shifts line styles up or down
   * @param {Number} lineIndex Index of a line
   * @param {Number} offset Can any number?
   */ shiftLineStyles(lineIndex, offset) {
        const clonedStyles = Object.assign({}, this.styles);
        for(const line in this.styles){
            const numericLine = parseInt(line, 10);
            if (numericLine > lineIndex) {
                this.styles[numericLine + offset] = clonedStyles[numericLine];
                if (!clonedStyles[numericLine - offset]) delete this.styles[numericLine];
            }
        }
    }
    /**
   * Handle insertion of more consecutive style lines for when one or more
   * newlines gets added to the text. Since current style needs to be shifted
   * first we shift the current style of the number lines needed, then we add
   * new lines from the last to the first.
   * @param {Number} lineIndex Index of a line
   * @param {Number} charIndex Index of a char
   * @param {Number} qty number of lines to add
   * @param {Array} copiedStyle Array of objects styles
   */ insertNewlineStyleObject(lineIndex, charIndex, qty, copiedStyle) {
        const newLineStyles = {};
        const originalLineLength = this._unwrappedTextLines[lineIndex].length;
        const isEndOfLine = originalLineLength === charIndex;
        let someStyleIsCarryingOver = false;
        qty || (qty = 1);
        this.shiftLineStyles(lineIndex, qty);
        const currentCharStyle = this.styles[lineIndex] ? this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1] : undefined;
        // we clone styles of all chars
        // after cursor onto the current line
        for(const index in this.styles[lineIndex]){
            const numIndex = parseInt(index, 10);
            if (numIndex >= charIndex) {
                someStyleIsCarryingOver = true;
                newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
                // remove lines from the previous line since they're on a new line now
                if (!(isEndOfLine && charIndex === 0)) delete this.styles[lineIndex][index];
            }
        }
        let styleCarriedOver = false;
        if (someStyleIsCarryingOver && !isEndOfLine) {
            // if is end of line, the extra style we copied
            // is probably not something we want
            this.styles[lineIndex + qty] = newLineStyles;
            styleCarriedOver = true;
        }
        if (styleCarriedOver || originalLineLength > charIndex) // skip the last line of since we already prepared it.
        // or contains text without style that we don't want to style
        // just because it changed lines
        qty--;
        // for the all the lines or all the other lines
        // we clone current char style onto the next (otherwise empty) line
        while(qty > 0){
            if (copiedStyle && copiedStyle[qty - 1]) this.styles[lineIndex + qty] = {
                0: $ab3f2a5cc6216ae5$var$_objectSpread2({}, copiedStyle[qty - 1])
            };
            else if (currentCharStyle) this.styles[lineIndex + qty] = {
                0: $ab3f2a5cc6216ae5$var$_objectSpread2({}, currentCharStyle)
            };
            else delete this.styles[lineIndex + qty];
            qty--;
        }
        this._forceClearCache = true;
    }
    /**
   * Inserts style object for a given line/char index
   * @param {Number} lineIndex Index of a line
   * @param {Number} charIndex Index of a char
   * @param {Number} quantity number Style object to insert, if given
   * @param {Array} copiedStyle array of style objects
   */ insertCharStyleObject(lineIndex, charIndex, quantity, copiedStyle) {
        if (!this.styles) this.styles = {};
        const currentLineStyles = this.styles[lineIndex], currentLineStylesCloned = currentLineStyles ? $ab3f2a5cc6216ae5$var$_objectSpread2({}, currentLineStyles) : {};
        quantity || (quantity = 1);
        // shift all char styles by quantity forward
        // 0,1,2,3 -> (charIndex=2) -> 0,1,3,4 -> (insert 2) -> 0,1,2,3,4
        for(const index in currentLineStylesCloned){
            const numericIndex = parseInt(index, 10);
            if (numericIndex >= charIndex) {
                currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
                // only delete the style if there was nothing moved there
                if (!currentLineStylesCloned[numericIndex - quantity]) delete currentLineStyles[numericIndex];
            }
        }
        this._forceClearCache = true;
        if (copiedStyle) {
            while(quantity--){
                if (!Object.keys(copiedStyle[quantity]).length) continue;
                if (!this.styles[lineIndex]) this.styles[lineIndex] = {};
                this.styles[lineIndex][charIndex + quantity] = $ab3f2a5cc6216ae5$var$_objectSpread2({}, copiedStyle[quantity]);
            }
            return;
        }
        if (!currentLineStyles) return;
        const newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
        while(newStyle && quantity--)this.styles[lineIndex][charIndex + quantity] = $ab3f2a5cc6216ae5$var$_objectSpread2({}, newStyle);
    }
    /**
   * Inserts style object(s)
   * @param {Array} insertedText Characters at the location where style is inserted
   * @param {Number} start cursor index for inserting style
   * @param {Array} [copiedStyle] array of style objects to insert.
   */ insertNewStyleBlock(insertedText, start, copiedStyle) {
        const cursorLoc = this.get2DCursorLocation(start, true), addedLines = [
            0
        ];
        let linesLength = 0;
        // get an array of how many char per lines are being added.
        for(let i = 0; i < insertedText.length; i++)if (insertedText[i] === "\n") {
            linesLength++;
            addedLines[linesLength] = 0;
        } else addedLines[linesLength]++;
        // for the first line copy the style from the current char position.
        if (addedLines[0] > 0) {
            this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
            copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
        }
        linesLength && this.insertNewlineStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);
        let i;
        for(i = 1; i < linesLength; i++){
            if (addedLines[i] > 0) this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
            else if (copiedStyle) // this test is required in order to close #6841
            // when a pasted buffer begins with a newline then
            // this.styles[cursorLoc.lineIndex + i] and copiedStyle[0]
            // may be undefined for some reason
            {
                if (this.styles[cursorLoc.lineIndex + i] && copiedStyle[0]) this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
            }
            copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
        }
        if (addedLines[i] > 0) this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
    }
    /**
   * Removes characters from start/end
   * start/end ar per grapheme position in _text array.
   *
   * @param {Number} start
   * @param {Number} end default to start + 1
   */ removeChars(start) {
        let end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : start + 1;
        this.removeStyleFromTo(start, end);
        this._text.splice(start, end - start);
        this.text = this._text.join("");
        this.set("dirty", true);
        this.initDimensions();
        this.setCoords();
        this._removeExtraneousStyles();
    }
    /**
   * insert characters at start position, before start position.
   * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
   * if style array is provided, it must be as the same length of text in graphemes
   * if end is provided and is bigger than start, old text is replaced.
   * start/end ar per grapheme position in _text array.
   *
   * @param {String} text text to insert
   * @param {Array} style array of style objects
   * @param {Number} start
   * @param {Number} end default to start + 1
   */ insertChars(text, style, start) {
        let end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : start;
        if (end > start) this.removeStyleFromTo(start, end);
        const graphemes = this.graphemeSplit(text);
        this.insertNewStyleBlock(graphemes, start, style);
        this._text = [
            ...this._text.slice(0, start),
            ...graphemes,
            ...this._text.slice(end)
        ];
        this.text = this._text.join("");
        this.set("dirty", true);
        this.initDimensions();
        this.setCoords();
        this._removeExtraneousStyles();
    }
    /**
   * Set the selectionStart and selectionEnd according to the new position of cursor
   * mimic the key - mouse navigation when shift is pressed.
   */ setSelectionStartEndWithShift(start, end, newSelection) {
        if (newSelection <= start) {
            if (end === start) this._selectionDirection = $ab3f2a5cc6216ae5$var$LEFT;
            else if (this._selectionDirection === $ab3f2a5cc6216ae5$var$RIGHT) {
                this._selectionDirection = $ab3f2a5cc6216ae5$var$LEFT;
                this.selectionEnd = start;
            }
            this.selectionStart = newSelection;
        } else if (newSelection > start && newSelection < end) {
            if (this._selectionDirection === $ab3f2a5cc6216ae5$var$RIGHT) this.selectionEnd = newSelection;
            else this.selectionStart = newSelection;
        } else {
            // newSelection is > selection start and end
            if (end === start) this._selectionDirection = $ab3f2a5cc6216ae5$var$RIGHT;
            else if (this._selectionDirection === $ab3f2a5cc6216ae5$var$LEFT) {
                this._selectionDirection = $ab3f2a5cc6216ae5$var$RIGHT;
                this.selectionStart = end;
            }
            this.selectionEnd = newSelection;
        }
    }
}
class $ab3f2a5cc6216ae5$var$ITextKeyBehavior extends $ab3f2a5cc6216ae5$var$ITextBehavior {
    /**
   * For functionalities on keyDown
   * Map a special key to a function of the instance/prototype
   * If you need different behavior for ESC or TAB or arrows, you have to change
   * this map setting the name of a function that you build on the IText or
   * your prototype.
   * the map change will affect all Instances unless you need for only some text Instances
   * in that case you have to clone this object and assign your Instance.
   * this.keysMap = Object.assign({}, this.keysMap);
   * The function must be in IText.prototype.myFunction And will receive event as args[0]
   */ /**
   * For functionalities on keyUp + ctrl || cmd
   */ /**
   * For functionalities on keyDown + ctrl || cmd
   */ /**
   * DOM container to append the hiddenTextarea.
   * An alternative to attaching to the document.body.
   * Useful to reduce laggish redraw of the full document.body tree and
   * also with modals event capturing that won't let the textarea take focus.
   * @type HTMLElement
   * @default
   */ /**
   * Initializes hidden textarea (needed to bring up keyboard in iOS)
   */ initHiddenTextarea() {
        const doc = this.canvas && $ab3f2a5cc6216ae5$var$getDocumentFromElement(this.canvas.getElement()) || $ab3f2a5cc6216ae5$export$91e93c41e950ddbb();
        const textarea = doc.createElement("textarea");
        Object.entries({
            autocapitalize: "off",
            autocorrect: "off",
            autocomplete: "off",
            spellcheck: "false",
            "data-fabric": "textarea",
            wrap: "off"
        }).map((_ref)=>{
            let [attribute, value] = _ref;
            return textarea.setAttribute(attribute, value);
        });
        const { top: top, left: left, fontSize: fontSize } = this._calcTextareaPosition();
        // line-height: 1px; was removed from the style to fix this:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=870966
        textarea.style.cssText = "position: absolute; top: ".concat(top, "; left: ").concat(left, "; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; padding-top: ").concat(fontSize, ";");
        (this.hiddenTextareaContainer || doc.body).appendChild(textarea);
        Object.entries({
            blur: "blur",
            keydown: "onKeyDown",
            keyup: "onKeyUp",
            input: "onInput",
            copy: "copy",
            cut: "copy",
            paste: "paste",
            compositionstart: "onCompositionStart",
            compositionupdate: "onCompositionUpdate",
            compositionend: "onCompositionEnd"
        }).map((_ref2)=>{
            let [eventName, handler] = _ref2;
            return textarea.addEventListener(eventName, this[handler].bind(this));
        });
        this.hiddenTextarea = textarea;
    }
    /**
   * Override this method to customize cursor behavior on textbox blur
   */ blur() {
        this.abortCursorAnimation();
    }
    /**
   * Handles keydown event
   * only used for arrows and combination of modifier keys.
   * @param {KeyboardEvent} e Event object
   */ onKeyDown(e) {
        if (!this.isEditing) return;
        const keyMap = this.direction === "rtl" ? this.keysMapRtl : this.keysMap;
        if (e.keyCode in keyMap) // @ts-expect-error legacy method calling pattern
        this[keyMap[e.keyCode]](e);
        else if (e.keyCode in this.ctrlKeysMapDown && (e.ctrlKey || e.metaKey)) // @ts-expect-error legacy method calling pattern
        this[this.ctrlKeysMapDown[e.keyCode]](e);
        else return;
        e.stopImmediatePropagation();
        e.preventDefault();
        if (e.keyCode >= 33 && e.keyCode <= 40) {
            // if i press an arrow key just update selection
            this.inCompositionMode = false;
            this.clearContextTop();
            this.renderCursorOrSelection();
        } else this.canvas && this.canvas.requestRenderAll();
    }
    /**
   * Handles keyup event
   * We handle KeyUp because ie11 and edge have difficulties copy/pasting
   * if a copy/cut event fired, keyup is dismissed
   * @param {KeyboardEvent} e Event object
   */ onKeyUp(e) {
        if (!this.isEditing || this._copyDone || this.inCompositionMode) {
            this._copyDone = false;
            return;
        }
        if (e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey)) // @ts-expect-error legacy method calling pattern
        this[this.ctrlKeysMapUp[e.keyCode]](e);
        else return;
        e.stopImmediatePropagation();
        e.preventDefault();
        this.canvas && this.canvas.requestRenderAll();
    }
    /**
   * Handles onInput event
   * @param {Event} e Event object
   */ onInput(e) {
        const fromPaste = this.fromPaste;
        this.fromPaste = false;
        e && e.stopPropagation();
        if (!this.isEditing) return;
        const updateAndFire = ()=>{
            this.updateFromTextArea();
            this.fire($ab3f2a5cc6216ae5$var$CHANGED);
            if (this.canvas) {
                this.canvas.fire("text:changed", {
                    target: this
                });
                this.canvas.requestRenderAll();
            }
        };
        if (this.hiddenTextarea.value === "") {
            this.styles = {};
            updateAndFire();
            return;
        }
        // decisions about style changes.
        const nextText = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText, charCount = this._text.length, nextCharCount = nextText.length, selectionStart = this.selectionStart, selectionEnd = this.selectionEnd, selection = selectionStart !== selectionEnd;
        let copiedStyle, removedText, charDiff = nextCharCount - charCount, removeFrom, removeTo;
        const textareaSelection = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
        const backDelete = selectionStart > textareaSelection.selectionStart;
        if (selection) {
            removedText = this._text.slice(selectionStart, selectionEnd);
            charDiff += selectionEnd - selectionStart;
        } else if (nextCharCount < charCount) {
            if (backDelete) removedText = this._text.slice(selectionEnd + charDiff, selectionEnd);
            else removedText = this._text.slice(selectionStart, selectionStart - charDiff);
        }
        const insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
        if (removedText && removedText.length) {
            if (insertedText.length) {
                // let's copy some style before deleting.
                // we want to copy the style before the cursor OR the style at the cursor if selection
                // is bigger than 0.
                copiedStyle = this.getSelectionStyles(selectionStart, selectionStart + 1, false);
                // now duplicate the style one for each inserted text.
                copiedStyle = insertedText.map(()=>// this return an array of references, but that is fine since we are
                    // copying the style later.
                    copiedStyle[0]);
            }
            if (selection) {
                removeFrom = selectionStart;
                removeTo = selectionEnd;
            } else if (backDelete) {
                // detect differences between forwardDelete and backDelete
                removeFrom = selectionEnd - removedText.length;
                removeTo = selectionEnd;
            } else {
                removeFrom = selectionEnd;
                removeTo = selectionEnd + removedText.length;
            }
            this.removeStyleFromTo(removeFrom, removeTo);
        }
        if (insertedText.length) {
            const { copyPasteData: copyPasteData } = $ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e();
            if (fromPaste && insertedText.join("") === copyPasteData.copiedText && !$ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.disableStyleCopyPaste) copiedStyle = copyPasteData.copiedTextStyle;
            this.insertNewStyleBlock(insertedText, selectionStart, copiedStyle);
        }
        updateAndFire();
    }
    /**
   * Composition start
   */ onCompositionStart() {
        this.inCompositionMode = true;
    }
    /**
   * Composition end
   */ onCompositionEnd() {
        this.inCompositionMode = false;
    }
    onCompositionUpdate(_ref3) {
        let { target: target } = _ref3;
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = target;
        this.compositionStart = selectionStart;
        this.compositionEnd = selectionEnd;
        this.updateTextareaPosition();
    }
    /**
   * Copies selected text
   */ copy() {
        if (this.selectionStart === this.selectionEnd) //do not cut-copy if no selection
        return;
        const { copyPasteData: copyPasteData } = $ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e();
        copyPasteData.copiedText = this.getSelectedText();
        if (!$ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.disableStyleCopyPaste) copyPasteData.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
        else copyPasteData.copiedTextStyle = undefined;
        this._copyDone = true;
    }
    /**
   * Pastes text
   */ paste() {
        this.fromPaste = true;
    }
    /**
   * Finds the width in pixels before the cursor on the same line
   * @private
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {Number} widthBeforeCursor width before cursor
   */ _getWidthBeforeCursor(lineIndex, charIndex) {
        let widthBeforeCursor = this._getLineLeftOffset(lineIndex), bound;
        if (charIndex > 0) {
            bound = this.__charBounds[lineIndex][charIndex - 1];
            widthBeforeCursor += bound.left + bound.width;
        }
        return widthBeforeCursor;
    }
    /**
   * Gets start offset of a selection
   * @param {KeyboardEvent} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ getDownCursorOffset(e, isRight) {
        const selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        // if on last line, down cursor goes to end of line
        if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) // move to the end of a text
        return this._text.length - selectionProp;
        const charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor), textAfterCursor = this._textLines[lineIndex].slice(charIndex);
        return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
    }
    /**
   * private
   * Helps finding if the offset should be counted from Start or End
   * @param {KeyboardEvent} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ _getSelectionForOffset(e, isRight) {
        if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) return this.selectionEnd;
        else return this.selectionStart;
    }
    /**
   * @param {KeyboardEvent} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ getUpCursorOffset(e, isRight) {
        const selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        if (lineIndex === 0 || e.metaKey || e.keyCode === 33) // if on first line, up cursor goes to start of line
        return -selectionProp;
        const charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor), textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex), missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
        // return a negative offset
        return -this._textLines[lineIndex - 1].length + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
    }
    /**
   * for a given width it founds the matching character.
   * @private
   */ _getIndexOnLine(lineIndex, width) {
        const line = this._textLines[lineIndex], lineLeftOffset = this._getLineLeftOffset(lineIndex);
        let widthOfCharsOnLine = lineLeftOffset, indexOnLine = 0, charWidth, foundMatch;
        for(let j = 0, jlen = line.length; j < jlen; j++){
            charWidth = this.__charBounds[lineIndex][j].width;
            widthOfCharsOnLine += charWidth;
            if (widthOfCharsOnLine > width) {
                foundMatch = true;
                const leftEdge = widthOfCharsOnLine - charWidth, rightEdge = widthOfCharsOnLine, offsetFromLeftEdge = Math.abs(leftEdge - width), offsetFromRightEdge = Math.abs(rightEdge - width);
                indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : j - 1;
                break;
            }
        }
        // reached end
        if (!foundMatch) indexOnLine = line.length - 1;
        return indexOnLine;
    }
    /**
   * Moves cursor down
   * @param {KeyboardEvent} e Event object
   */ moveCursorDown(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) return;
        this._moveCursorUpOrDown("Down", e);
    }
    /**
   * Moves cursor up
   * @param {KeyboardEvent} e Event object
   */ moveCursorUp(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) return;
        this._moveCursorUpOrDown("Up", e);
    }
    /**
   * Moves cursor up or down, fires the events
   * @param {String} direction 'Up' or 'Down'
   * @param {KeyboardEvent} e Event object
   */ _moveCursorUpOrDown(direction, e) {
        const offset = this["get".concat(direction, "CursorOffset")](e, this._selectionDirection === $ab3f2a5cc6216ae5$var$RIGHT);
        if (e.shiftKey) this.moveCursorWithShift(offset);
        else this.moveCursorWithoutShift(offset);
        if (offset !== 0) {
            const max = this.text.length;
            this.selectionStart = $ab3f2a5cc6216ae5$var$capValue(0, this.selectionStart, max);
            this.selectionEnd = $ab3f2a5cc6216ae5$var$capValue(0, this.selectionEnd, max);
            // TODO fix: abort and init should be an alternative depending
            // on selectionStart/End being equal or different
            this.abortCursorAnimation();
            this.initDelayedCursor();
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    }
    /**
   * Moves cursor with shift
   * @param {Number} offset
   */ moveCursorWithShift(offset) {
        const newSelection = this._selectionDirection === $ab3f2a5cc6216ae5$var$LEFT ? this.selectionStart + offset : this.selectionEnd + offset;
        this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
        return offset !== 0;
    }
    /**
   * Moves cursor up without shift
   * @param {Number} offset
   */ moveCursorWithoutShift(offset) {
        if (offset < 0) {
            this.selectionStart += offset;
            this.selectionEnd = this.selectionStart;
        } else {
            this.selectionEnd += offset;
            this.selectionStart = this.selectionEnd;
        }
        return offset !== 0;
    }
    /**
   * Moves cursor left
   * @param {KeyboardEvent} e Event object
   */ moveCursorLeft(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) return;
        this._moveCursorLeftOrRight("Left", e);
    }
    /**
   * @private
   * @return {Boolean} true if a change happened
   *
   * @todo refactor not to use method name composition
   */ _move(e, prop, direction) {
        let newValue;
        if (e.altKey) newValue = this["findWordBoundary".concat(direction)](this[prop]);
        else if (e.metaKey || e.keyCode === 35 || e.keyCode === 36) newValue = this["findLineBoundary".concat(direction)](this[prop]);
        else {
            this[prop] += direction === "Left" ? -1 : 1;
            return true;
        }
        if (typeof newValue !== "undefined" && this[prop] !== newValue) {
            this[prop] = newValue;
            return true;
        }
        return false;
    }
    /**
   * @private
   */ _moveLeft(e, prop) {
        return this._move(e, prop, "Left");
    }
    /**
   * @private
   */ _moveRight(e, prop) {
        return this._move(e, prop, "Right");
    }
    /**
   * Moves cursor left without keeping selection
   * @param {KeyboardEvent} e
   */ moveCursorLeftWithoutShift(e) {
        let change = true;
        this._selectionDirection = $ab3f2a5cc6216ae5$var$LEFT;
        // only move cursor when there is no selection,
        // otherwise we discard it, and leave cursor on same place
        if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) change = this._moveLeft(e, "selectionStart");
        this.selectionEnd = this.selectionStart;
        return change;
    }
    /**
   * Moves cursor left while keeping selection
   * @param {KeyboardEvent} e
   */ moveCursorLeftWithShift(e) {
        if (this._selectionDirection === $ab3f2a5cc6216ae5$var$RIGHT && this.selectionStart !== this.selectionEnd) return this._moveLeft(e, "selectionEnd");
        else if (this.selectionStart !== 0) {
            this._selectionDirection = $ab3f2a5cc6216ae5$var$LEFT;
            return this._moveLeft(e, "selectionStart");
        }
    }
    /**
   * Moves cursor right
   * @param {KeyboardEvent} e Event object
   */ moveCursorRight(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) return;
        this._moveCursorLeftOrRight("Right", e);
    }
    /**
   * Moves cursor right or Left, fires event
   * @param {String} direction 'Left', 'Right'
   * @param {KeyboardEvent} e Event object
   */ _moveCursorLeftOrRight(direction, e) {
        const actionName = "moveCursor".concat(direction).concat(e.shiftKey ? "WithShift" : "WithoutShift");
        this._currentCursorOpacity = 1;
        if (this[actionName](e)) {
            // TODO fix: abort and init should be an alternative depending
            // on selectionStart/End being equal or different
            this.abortCursorAnimation();
            this.initDelayedCursor();
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    }
    /**
   * Moves cursor right while keeping selection
   * @param {KeyboardEvent} e
   */ moveCursorRightWithShift(e) {
        if (this._selectionDirection === $ab3f2a5cc6216ae5$var$LEFT && this.selectionStart !== this.selectionEnd) return this._moveRight(e, "selectionStart");
        else if (this.selectionEnd !== this._text.length) {
            this._selectionDirection = $ab3f2a5cc6216ae5$var$RIGHT;
            return this._moveRight(e, "selectionEnd");
        }
    }
    /**
   * Moves cursor right without keeping selection
   * @param {KeyboardEvent} e Event object
   */ moveCursorRightWithoutShift(e) {
        let changed = true;
        this._selectionDirection = $ab3f2a5cc6216ae5$var$RIGHT;
        if (this.selectionStart === this.selectionEnd) {
            changed = this._moveRight(e, "selectionStart");
            this.selectionEnd = this.selectionStart;
        } else this.selectionStart = this.selectionEnd;
        return changed;
    }
}
/**
 * `LEFT_CLICK === 0`
 */ const $ab3f2a5cc6216ae5$var$notALeftClick = (e)=>!!e.button;
class $ab3f2a5cc6216ae5$var$ITextClickBehavior extends $ab3f2a5cc6216ae5$var$ITextKeyBehavior {
    constructor(){
        super(...arguments);
        $ab3f2a5cc6216ae5$var$_defineProperty(this, "draggableTextDelegate", void 0);
    }
    initBehavior() {
        // Initializes event handlers related to cursor or selection
        this.on("mousedown", this._mouseDownHandler);
        this.on("mousedown:before", this._mouseDownHandlerBefore);
        this.on("mouseup", this.mouseUpHandler);
        this.on("mousedblclick", this.doubleClickHandler);
        this.on("tripleclick", this.tripleClickHandler);
        // Initializes "dbclick" event handler
        this.__lastClickTime = +new Date();
        // for triple click
        this.__lastLastClickTime = +new Date();
        this.__lastPointer = {};
        this.on("mousedown", this.onMouseDown);
        // @ts-expect-error in reality it is an IText instance
        this.draggableTextDelegate = new $ab3f2a5cc6216ae5$var$DraggableTextDelegate(this);
        super.initBehavior();
    }
    /**
   * If this method returns true a mouse move operation over a text selection
   * will not prevent the native mouse event allowing the browser to start a drag operation.
   * shouldStartDragging can be read 'do not prevent default for mouse move event'
   * To prevent drag and drop between objects both shouldStartDragging and onDragStart should return false
   * @returns
   */ shouldStartDragging() {
        return this.draggableTextDelegate.isActive();
    }
    /**
   * @public override this method to control whether instance should/shouldn't become a drag source,
   * @see also {@link DraggableTextDelegate#isActive}
   * To prevent drag and drop between objects both shouldStartDragging and onDragStart should return false
   * @returns {boolean} should handle event
   */ onDragStart(e) {
        return this.draggableTextDelegate.onDragStart(e);
    }
    /**
   * @public override this method to control whether instance should/shouldn't become a drop target
   */ canDrop(e) {
        return this.draggableTextDelegate.canDrop(e);
    }
    /**
   * Default event handler to simulate triple click
   * @private
   */ onMouseDown(options) {
        if (!this.canvas) return;
        this.__newClickTime = +new Date();
        const newPointer = options.pointer;
        if (this.isTripleClick(newPointer)) {
            this.fire("tripleclick", options);
            $ab3f2a5cc6216ae5$var$stopEvent(options.e);
        }
        this.__lastLastClickTime = this.__lastClickTime;
        this.__lastClickTime = this.__newClickTime;
        this.__lastPointer = newPointer;
        this.__lastSelected = this.selected && !this.getActiveControl();
    }
    isTripleClick(newPointer) {
        return this.__newClickTime - this.__lastClickTime < 500 && this.__lastClickTime - this.__lastLastClickTime < 500 && this.__lastPointer.x === newPointer.x && this.__lastPointer.y === newPointer.y;
    }
    /**
   * Default handler for double click, select a word
   */ doubleClickHandler(options) {
        if (!this.isEditing) return;
        this.selectWord(this.getSelectionStartFromPointer(options.e));
    }
    /**
   * Default handler for triple click, select a line
   */ tripleClickHandler(options) {
        if (!this.isEditing) return;
        this.selectLine(this.getSelectionStartFromPointer(options.e));
    }
    /**
   * Default event handler for the basic functionalities needed on _mouseDown
   * can be overridden to do something different.
   * Scope of this implementation is: find the click position, set selectionStart
   * find selectionEnd, initialize the drawing of either cursor or selection area
   * initializing a mousedDown on a text area will cancel fabricjs knowledge of
   * current compositionMode. It will be set to false.
   */ _mouseDownHandler(_ref) {
        let { e: e } = _ref;
        if (!this.canvas || !this.editable || $ab3f2a5cc6216ae5$var$notALeftClick(e) || this.getActiveControl()) return;
        if (this.draggableTextDelegate.start(e)) return;
        this.canvas.textEditingManager.register(this);
        if (this.selected) {
            this.inCompositionMode = false;
            this.setCursorByClick(e);
        }
        if (this.isEditing) {
            this.__selectionStartOnMouseDown = this.selectionStart;
            if (this.selectionStart === this.selectionEnd) this.abortCursorAnimation();
            this.renderCursorOrSelection();
        }
    }
    /**
   * Default event handler for the basic functionalities needed on mousedown:before
   * can be overridden to do something different.
   * Scope of this implementation is: verify the object is already selected when mousing down
   */ _mouseDownHandlerBefore(_ref2) {
        let { e: e } = _ref2;
        if (!this.canvas || !this.editable || $ab3f2a5cc6216ae5$var$notALeftClick(e)) return;
        // we want to avoid that an object that was selected and then becomes unselectable,
        // may trigger editing mode in some way.
        this.selected = this === this.canvas._activeObject;
    }
    /**
   * standard handler for mouse up, overridable
   * @private
   */ mouseUpHandler(_ref3) {
        let { e: e, transform: transform } = _ref3;
        const didDrag = this.draggableTextDelegate.end(e);
        if (this.canvas) {
            this.canvas.textEditingManager.unregister(this);
            const activeObject = this.canvas._activeObject;
            if (activeObject && activeObject !== this) // avoid running this logic when there is an active object
            // this because is possible with shift click and fast clicks,
            // to rapidly deselect and reselect this object and trigger an enterEdit
            return;
        }
        if (!this.editable || this.group && !this.group.interactive || transform && transform.actionPerformed || $ab3f2a5cc6216ae5$var$notALeftClick(e) || didDrag) return;
        if (this.__lastSelected && !this.getActiveControl()) {
            this.selected = false;
            this.__lastSelected = false;
            this.enterEditing(e);
            if (this.selectionStart === this.selectionEnd) this.initDelayedCursor(true);
            else this.renderCursorOrSelection();
        } else this.selected = true;
    }
    /**
   * Changes cursor location in a text depending on passed pointer (x/y) object
   * @param {TPointerEvent} e Event object
   */ setCursorByClick(e) {
        const newSelection = this.getSelectionStartFromPointer(e), start = this.selectionStart, end = this.selectionEnd;
        if (e.shiftKey) this.setSelectionStartEndWithShift(start, end, newSelection);
        else {
            this.selectionStart = newSelection;
            this.selectionEnd = newSelection;
        }
        if (this.isEditing) {
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    }
    /**
   * Returns index of a character corresponding to where an object was clicked
   * @param {TPointerEvent} e Event object
   * @return {Number} Index of a character
   */ getSelectionStartFromPointer(e) {
        const mouseOffset = this.canvas.getScenePoint(e).transform($ab3f2a5cc6216ae5$var$invertTransform(this.calcTransformMatrix())).add(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(-this._getLeftOffset(), -this._getTopOffset()));
        let height = 0, charIndex = 0, lineIndex = 0;
        for(let i = 0; i < this._textLines.length; i++){
            if (height <= mouseOffset.y) {
                height += this.getHeightOfLine(i);
                lineIndex = i;
                if (i > 0) charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
            } else break;
        }
        const lineLeftOffset = Math.abs(this._getLineLeftOffset(lineIndex));
        let width = lineLeftOffset;
        const charLength = this._textLines[lineIndex].length;
        const chars = this.__charBounds[lineIndex];
        for(let j = 0; j < charLength; j++){
            // i removed something about flipX here, check.
            const charWidth = chars[j].kernedWidth;
            const widthAfter = width + charWidth;
            if (mouseOffset.x <= widthAfter) {
                // if the pointer is closer to the end of the char we increment charIndex
                // in order to position the cursor after the char
                if (Math.abs(mouseOffset.x - widthAfter) <= Math.abs(mouseOffset.x - width)) charIndex++;
                break;
            }
            width = widthAfter;
            charIndex++;
        }
        return Math.min(// if object is horizontally flipped, mirror cursor location from the end
        this.flipX ? charLength - charIndex : charIndex, this._text.length);
    }
}
const $ab3f2a5cc6216ae5$var$MOVE_CURSOR_UP = "moveCursorUp";
const $ab3f2a5cc6216ae5$var$MOVE_CURSOR_DOWN = "moveCursorDown";
const $ab3f2a5cc6216ae5$var$MOVE_CURSOR_LEFT = "moveCursorLeft";
const $ab3f2a5cc6216ae5$var$MOVE_CURSOR_RIGHT = "moveCursorRight";
const $ab3f2a5cc6216ae5$var$EXIT_EDITING = "exitEditing";
// @TODO look into import { Key } from 'ts-key-enum';
// and transition from keyCode to Key
// also reduce string duplication
const $ab3f2a5cc6216ae5$var$keysMap = {
    9: $ab3f2a5cc6216ae5$var$EXIT_EDITING,
    27: $ab3f2a5cc6216ae5$var$EXIT_EDITING,
    33: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_UP,
    34: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_DOWN,
    35: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_RIGHT,
    36: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_LEFT,
    37: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_LEFT,
    38: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_UP,
    39: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_RIGHT,
    40: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_DOWN
};
const $ab3f2a5cc6216ae5$var$keysMapRtl = {
    9: $ab3f2a5cc6216ae5$var$EXIT_EDITING,
    27: $ab3f2a5cc6216ae5$var$EXIT_EDITING,
    33: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_UP,
    34: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_DOWN,
    35: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_LEFT,
    36: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_RIGHT,
    37: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_RIGHT,
    38: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_UP,
    39: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_LEFT,
    40: $ab3f2a5cc6216ae5$var$MOVE_CURSOR_DOWN
};
/**
 * For functionalities on keyUp + ctrl || cmd
 */ const $ab3f2a5cc6216ae5$var$ctrlKeysMapUp = {
    67: "copy",
    // there was a reason this wasn't deleted. for now leave it here
    88: "cut"
};
/**
 * For functionalities on keyDown + ctrl || cmd
 */ const $ab3f2a5cc6216ae5$var$ctrlKeysMapDown = {
    65: "selectAll"
};
// Declare IText protected properties to workaround TS
const $ab3f2a5cc6216ae5$var$protectedDefaultValues = {
    _selectionDirection: null,
    _reSpace: /\s|\r?\n/,
    inCompositionMode: false
};
const $ab3f2a5cc6216ae5$var$iTextDefaultValues = $ab3f2a5cc6216ae5$var$_objectSpread2({
    selectionStart: 0,
    selectionEnd: 0,
    selectionColor: "rgba(17,119,255,0.3)",
    isEditing: false,
    editable: true,
    editingBorderColor: "rgba(102,153,255,0.25)",
    cursorWidth: 2,
    cursorColor: "",
    cursorDelay: 1000,
    cursorDuration: 600,
    caching: true,
    hiddenTextareaContainer: null,
    keysMap: $ab3f2a5cc6216ae5$var$keysMap,
    keysMapRtl: $ab3f2a5cc6216ae5$var$keysMapRtl,
    ctrlKeysMapDown: $ab3f2a5cc6216ae5$var$ctrlKeysMapDown,
    ctrlKeysMapUp: $ab3f2a5cc6216ae5$var$ctrlKeysMapUp
}, $ab3f2a5cc6216ae5$var$protectedDefaultValues);
// @TODO this is not complete
/**
 * @fires changed
 * @fires selection:changed
 * @fires editing:entered
 * @fires editing:exited
 * @fires dragstart
 * @fires drag drag event firing on the drag source
 * @fires dragend
 * @fires copy
 * @fires cut
 * @fires paste
 *
 * #### Supported key combinations
 * ```
 *   Move cursor:                    left, right, up, down
 *   Select character:               shift + left, shift + right
 *   Select text vertically:         shift + up, shift + down
 *   Move cursor by word:            alt + left, alt + right
 *   Select words:                   shift + alt + left, shift + alt + right
 *   Move cursor to line start/end:  cmd + left, cmd + right or home, end
 *   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
 *   Jump to start/end of text:      cmd + up, cmd + down
 *   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
 *   Delete character:               backspace
 *   Delete word:                    alt + backspace
 *   Delete line:                    cmd + backspace
 *   Forward delete:                 delete
 *   Copy text:                      ctrl/cmd + c
 *   Paste text:                     ctrl/cmd + v
 *   Cut text:                       ctrl/cmd + x
 *   Select entire text:             ctrl/cmd + a
 *   Quit editing                    tab or esc
 * ```
 *
 * #### Supported mouse/touch combination
 * ```
 *   Position cursor:                click/touch
 *   Create selection:               click/touch & drag
 *   Create selection:               click & shift + click
 *   Select word:                    double click
 *   Select line:                    triple click
 * ```
 */ class $ab3f2a5cc6216ae5$export$6e837253f56cbab0 extends $ab3f2a5cc6216ae5$var$ITextClickBehavior {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$6e837253f56cbab0.ownDefaults);
    }
    get type() {
        const type = super.type;
        // backward compatibility
        return type === "itext" ? "i-text" : type;
    }
    /**
   * Constructor
   * @param {String} text Text string
   * @param {Object} [options] Options object
   */ constructor(text, options){
        super(text, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$export$6e837253f56cbab0.ownDefaults), options));
        this.initBehavior();
    }
    /**
   * While editing handle differently
   * @private
   * @param {string} key
   * @param {*} value
   */ _set(key, value) {
        if (this.isEditing && this._savedProps && key in this._savedProps) {
            // @ts-expect-error irritating TS
            this._savedProps[key] = value;
            return this;
        }
        if (key === "canvas") {
            this.canvas instanceof $ab3f2a5cc6216ae5$export$8d01c972ee8b14a9 && this.canvas.textEditingManager.remove(this);
            value instanceof $ab3f2a5cc6216ae5$export$8d01c972ee8b14a9 && value.textEditingManager.add(this);
        }
        return super._set(key, value);
    }
    /**
   * Sets selection start (left boundary of a selection)
   * @param {Number} index Index to set selection start to
   */ setSelectionStart(index) {
        index = Math.max(index, 0);
        this._updateAndFire("selectionStart", index);
    }
    /**
   * Sets selection end (right boundary of a selection)
   * @param {Number} index Index to set selection end to
   */ setSelectionEnd(index) {
        index = Math.min(index, this.text.length);
        this._updateAndFire("selectionEnd", index);
    }
    /**
   * @private
   * @param {String} property 'selectionStart' or 'selectionEnd'
   * @param {Number} index new position of property
   */ _updateAndFire(property, index) {
        if (this[property] !== index) {
            this._fireSelectionChanged();
            this[property] = index;
        }
        this._updateTextarea();
    }
    /**
   * Fires the even of selection changed
   * @private
   */ _fireSelectionChanged() {
        this.fire("selection:changed");
        this.canvas && this.canvas.fire("text:selection:changed", {
            target: this
        });
    }
    /**
   * Initialize text dimensions. Render all text on given context
   * or on a offscreen canvas to get the text width with measureText.
   * Updates this.width and this.height with the proper values.
   * Does not return dimensions.
   * @private
   */ initDimensions() {
        this.isEditing && this.initDelayedCursor();
        super.initDimensions();
    }
    /**
   * Gets style of a current selection/cursor (at the start position)
   * if startIndex or endIndex are not provided, selectionStart or selectionEnd will be used.
   * @param {Number} startIndex Start index to get styles at
   * @param {Number} endIndex End index to get styles at, if not specified selectionEnd or startIndex + 1
   * @param {Boolean} [complete] get full style or not
   * @return {Array} styles an array with one, zero or more Style objects
   */ getSelectionStyles() {
        let startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart || 0;
        let endIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selectionEnd;
        let complete = arguments.length > 2 ? arguments[2] : undefined;
        return super.getSelectionStyles(startIndex, endIndex, complete);
    }
    /**
   * Sets style of a current selection, if no selection exist, do not set anything.
   * @param {Object} [styles] Styles object
   * @param {Number} [startIndex] Start index to get styles at
   * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
   */ setSelectionStyles(styles) {
        let startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selectionStart || 0;
        let endIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.selectionEnd;
        return super.setSelectionStyles(styles, startIndex, endIndex);
    }
    /**
   * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
   * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
   * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
   */ get2DCursorLocation() {
        let selectionStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart;
        let skipWrapping = arguments.length > 1 ? arguments[1] : undefined;
        return super.get2DCursorLocation(selectionStart, skipWrapping);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ render(ctx) {
        super.render(ctx);
        // clear the cursorOffsetCache, so we ensure to calculate once per renderCursor
        // the correct position but not at every cursor animation.
        this.cursorOffsetCache = {};
        this.renderCursorOrSelection();
    }
    /**
   * @override block cursor/selection logic while rendering the exported canvas
   * @todo this workaround should be replaced with a more robust solution
   */ toCanvasElement(options) {
        const isEditing = this.isEditing;
        this.isEditing = false;
        const canvas = super.toCanvasElement(options);
        this.isEditing = isEditing;
        return canvas;
    }
    /**
   * Renders cursor or selection (depending on what exists)
   * it does on the contextTop. If contextTop is not available, do nothing.
   */ renderCursorOrSelection() {
        if (!this.isEditing) return;
        const ctx = this.clearContextTop(true);
        if (!ctx) return;
        const boundaries = this._getCursorBoundaries();
        if (this.selectionStart === this.selectionEnd) this.renderCursor(ctx, boundaries);
        else this.renderSelection(ctx, boundaries);
        this.canvas.contextTopDirty = true;
        ctx.restore();
    }
    /**
   * Returns cursor boundaries (left, top, leftOffset, topOffset)
   * left/top are left/top of entire text box
   * leftOffset/topOffset are offset from that left/top point of a text box
   * @private
   * @param {number} [index] index from start
   * @param {boolean} [skipCaching]
   */ _getCursorBoundaries() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart;
        let skipCaching = arguments.length > 1 ? arguments[1] : undefined;
        const left = this._getLeftOffset(), top = this._getTopOffset(), offsets = this._getCursorBoundariesOffsets(index, skipCaching);
        return {
            left: left,
            top: top,
            leftOffset: offsets.left,
            topOffset: offsets.top
        };
    }
    /**
   * Caches and returns cursor left/top offset relative to instance's center point
   * @private
   * @param {number} index index from start
   * @param {boolean} [skipCaching]
   */ _getCursorBoundariesOffsets(index, skipCaching) {
        if (skipCaching) return this.__getCursorBoundariesOffsets(index);
        if (this.cursorOffsetCache && "top" in this.cursorOffsetCache) return this.cursorOffsetCache;
        return this.cursorOffsetCache = this.__getCursorBoundariesOffsets(index);
    }
    /**
   * Calculates cursor left/top offset relative to instance's center point
   * @private
   * @param {number} index index from start
   */ __getCursorBoundariesOffsets(index) {
        let topOffset = 0, leftOffset = 0;
        const { charIndex: charIndex, lineIndex: lineIndex } = this.get2DCursorLocation(index);
        for(let i = 0; i < lineIndex; i++)topOffset += this.getHeightOfLine(i);
        const lineLeftOffset = this._getLineLeftOffset(lineIndex);
        const bound = this.__charBounds[lineIndex][charIndex];
        bound && (leftOffset = bound.left);
        if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) leftOffset -= this._getWidthOfCharSpacing();
        const boundaries = {
            top: topOffset,
            left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0)
        };
        if (this.direction === "rtl") {
            if (this.textAlign === $ab3f2a5cc6216ae5$var$RIGHT || this.textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY || this.textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_RIGHT) boundaries.left *= -1;
            else if (this.textAlign === $ab3f2a5cc6216ae5$var$LEFT || this.textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_LEFT) boundaries.left = lineLeftOffset - (leftOffset > 0 ? leftOffset : 0);
            else if (this.textAlign === $ab3f2a5cc6216ae5$var$CENTER || this.textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_CENTER) boundaries.left = lineLeftOffset - (leftOffset > 0 ? leftOffset : 0);
        }
        return boundaries;
    }
    /**
   * Renders cursor on context Top, outside the animation cycle, on request
   * Used for the drag/drop effect.
   * If contextTop is not available, do nothing.
   */ renderCursorAt(selectionStart) {
        const boundaries = this._getCursorBoundaries(selectionStart, true);
        this._renderCursor(this.canvas.contextTop, boundaries, selectionStart);
    }
    /**
   * Renders cursor
   * @param {Object} boundaries
   * @param {CanvasRenderingContext2D} ctx transformed context to draw on
   */ renderCursor(ctx, boundaries) {
        this._renderCursor(ctx, boundaries, this.selectionStart);
    }
    _renderCursor(ctx, boundaries, selectionStart) {
        const cursorLocation = this.get2DCursorLocation(selectionStart), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, "fontSize"), multiplier = this.getObjectScaling().x * this.canvas.getZoom(), cursorWidth = this.cursorWidth / multiplier, dy = this.getValueOfPropertyAt(lineIndex, charIndex, "deltaY"), topOffset = boundaries.topOffset + (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight - charHeight * (1 - this._fontSizeFraction);
        if (this.inCompositionMode) // TODO: investigate why there isn't a return inside the if,
        // and why can't happen at the top of the function
        this.renderSelection(ctx, boundaries);
        ctx.fillStyle = this.cursorColor || this.getValueOfPropertyAt(lineIndex, charIndex, $ab3f2a5cc6216ae5$var$FILL);
        ctx.globalAlpha = this._currentCursorOpacity;
        ctx.fillRect(boundaries.left + boundaries.leftOffset - cursorWidth / 2, topOffset + boundaries.top + dy, cursorWidth, charHeight);
    }
    /**
   * Renders text selection
   * @param {Object} boundaries Object with left/top/leftOffset/topOffset
   * @param {CanvasRenderingContext2D} ctx transformed context to draw on
   */ renderSelection(ctx, boundaries) {
        const selection = {
            selectionStart: this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart,
            selectionEnd: this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd
        };
        this._renderSelection(ctx, selection, boundaries);
    }
    /**
   * Renders drag start text selection
   */ renderDragSourceEffect() {
        const dragStartSelection = this.draggableTextDelegate.getDragStartSelection();
        this._renderSelection(this.canvas.contextTop, dragStartSelection, this._getCursorBoundaries(dragStartSelection.selectionStart, true));
    }
    renderDropTargetEffect(e) {
        const dragSelection = this.getSelectionStartFromPointer(e);
        this.renderCursorAt(dragSelection);
    }
    /**
   * Renders text selection
   * @private
   * @param {{ selectionStart: number, selectionEnd: number }} selection
   * @param {Object} boundaries Object with left/top/leftOffset/topOffset
   * @param {CanvasRenderingContext2D} ctx transformed context to draw on
   */ _renderSelection(ctx, selection, boundaries) {
        const selectionStart = selection.selectionStart, selectionEnd = selection.selectionEnd, isJustify = this.textAlign.includes($ab3f2a5cc6216ae5$var$JUSTIFY), start = this.get2DCursorLocation(selectionStart), end = this.get2DCursorLocation(selectionEnd), startLine = start.lineIndex, endLine = end.lineIndex, startChar = start.charIndex < 0 ? 0 : start.charIndex, endChar = end.charIndex < 0 ? 0 : end.charIndex;
        for(let i = startLine; i <= endLine; i++){
            const lineOffset = this._getLineLeftOffset(i) || 0;
            let lineHeight = this.getHeightOfLine(i), realLineHeight = 0, boxStart = 0, boxEnd = 0;
            if (i === startLine) boxStart = this.__charBounds[startLine][startChar].left;
            if (i >= startLine && i < endLine) boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5; // WTF is this 5?
            else if (i === endLine) {
                if (endChar === 0) boxEnd = this.__charBounds[endLine][endChar].left;
                else {
                    const charSpacing = this._getWidthOfCharSpacing();
                    boxEnd = this.__charBounds[endLine][endChar - 1].left + this.__charBounds[endLine][endChar - 1].width - charSpacing;
                }
            }
            realLineHeight = lineHeight;
            if (this.lineHeight < 1 || i === endLine && this.lineHeight > 1) lineHeight /= this.lineHeight;
            let drawStart = boundaries.left + lineOffset + boxStart, drawHeight = lineHeight, extraTop = 0;
            const drawWidth = boxEnd - boxStart;
            if (this.inCompositionMode) {
                ctx.fillStyle = this.compositionColor || "black";
                drawHeight = 1;
                extraTop = lineHeight;
            } else ctx.fillStyle = this.selectionColor;
            if (this.direction === "rtl") {
                if (this.textAlign === $ab3f2a5cc6216ae5$var$RIGHT || this.textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY || this.textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_RIGHT) drawStart = this.width - drawStart - drawWidth;
                else if (this.textAlign === $ab3f2a5cc6216ae5$var$LEFT || this.textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_LEFT) drawStart = boundaries.left + lineOffset - boxEnd;
                else if (this.textAlign === $ab3f2a5cc6216ae5$var$CENTER || this.textAlign === $ab3f2a5cc6216ae5$var$JUSTIFY_CENTER) drawStart = boundaries.left + lineOffset - boxEnd;
            }
            ctx.fillRect(drawStart, boundaries.top + boundaries.topOffset + extraTop, drawWidth, drawHeight);
            boundaries.topOffset += realLineHeight;
        }
    }
    /**
   * High level function to know the height of the cursor.
   * the currentChar is the one that precedes the cursor
   * Returns fontSize of char at the current cursor
   * Unused from the library, is for the end user
   * @return {Number} Character font size
   */ getCurrentCharFontSize() {
        const cp = this._getCurrentCharIndex();
        return this.getValueOfPropertyAt(cp.l, cp.c, "fontSize");
    }
    /**
   * High level function to know the color of the cursor.
   * the currentChar is the one that precedes the cursor
   * Returns color (fill) of char at the current cursor
   * if the text object has a pattern or gradient for filler, it will return that.
   * Unused by the library, is for the end user
   * @return {String | TFiller} Character color (fill)
   */ getCurrentCharColor() {
        const cp = this._getCurrentCharIndex();
        return this.getValueOfPropertyAt(cp.l, cp.c, $ab3f2a5cc6216ae5$var$FILL);
    }
    /**
   * Returns the cursor position for the getCurrent.. functions
   * @private
   */ _getCurrentCharIndex() {
        const cursorPosition = this.get2DCursorLocation(this.selectionStart, true), charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
        return {
            l: cursorPosition.lineIndex,
            c: charIndex
        };
    }
    dispose() {
        this._exitEditing();
        this.draggableTextDelegate.dispose();
        super.dispose();
    }
}
/**
 * Index where text selection starts (or where cursor is when there is no selection)
 * @type Number
 * @default
 */ /**
 * Index where text selection ends
 * @type Number
 * @default
 */ /**
 * Color of text selection
 * @type String
 * @default
 */ /**
 * Indicates whether text is in editing mode
 * @type Boolean
 * @default
 */ /**
 * Indicates whether a text can be edited
 * @type Boolean
 * @default
 */ /**
 * Border color of text object while it's in editing mode
 * @type String
 * @default
 */ /**
 * Width of cursor (in px)
 * @type Number
 * @default
 */ /**
 * Color of text cursor color in editing mode.
 * if not set (default) will take color from the text.
 * if set to a color value that fabric can understand, it will
 * be used instead of the color of the text at the current position.
 * @type String
 * @default
 */ /**
 * Delay between cursor blink (in ms)
 * @type Number
 * @default
 */ /**
 * Duration of cursor fade in (in ms)
 * @type Number
 * @default
 */ /**
 * Indicates whether internal text char widths can be cached
 * @type Boolean
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$6e837253f56cbab0, "ownDefaults", $ab3f2a5cc6216ae5$var$iTextDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$6e837253f56cbab0, "type", "IText");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$6e837253f56cbab0);
// legacy
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$6e837253f56cbab0, "i-text");
// @TODO: Many things here are configuration related and shouldn't be on the class nor prototype
// regexes, list of properties that are not suppose to change by instances, magic consts.
// this will be a separated effort
const $ab3f2a5cc6216ae5$var$textboxDefaultValues = {
    minWidth: 20,
    dynamicMinWidth: 2,
    lockScalingFlip: true,
    noScaleCache: false,
    _wordJoiners: /[ \t\r]/,
    splitByGrapheme: false
};
// @TODO this is not complete
/**
 * Textbox class, based on IText, allows the user to resize the text rectangle
 * and wraps lines automatically. Textboxes have their Y scaling locked, the
 * user can only change width. Height is adjusted automatically based on the
 * wrapping of lines.
 */ class $ab3f2a5cc6216ae5$export$8e3dca5fa4d5f04b extends $ab3f2a5cc6216ae5$export$6e837253f56cbab0 {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$8e3dca5fa4d5f04b.ownDefaults);
    }
    /**
   * Constructor
   * @param {String} text Text string
   * @param {Object} [options] Options object
   */ constructor(text, options){
        super(text, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$export$8e3dca5fa4d5f04b.ownDefaults), options));
    }
    /**
   * Creates the default control object.
   * If you prefer to have on instance of controls shared among all objects
   * make this function return an empty object and add controls to the ownDefaults object
   */ static createControls() {
        return {
            controls: $ab3f2a5cc6216ae5$var$createTextboxDefaultControls()
        };
    }
    /**
   * Unlike superclass's version of this function, Textbox does not update
   * its width.
   * @private
   * @override
   */ initDimensions() {
        if (!this.initialized) return;
        this.isEditing && this.initDelayedCursor();
        this._clearCache();
        // clear dynamicMinWidth as it will be different after we re-wrap line
        this.dynamicMinWidth = 0;
        // wrap lines
        this._styleMap = this._generateStyleMap(this._splitText());
        // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap
        if (this.dynamicMinWidth > this.width) this._set("width", this.dynamicMinWidth);
        if (this.textAlign.includes($ab3f2a5cc6216ae5$var$JUSTIFY)) // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
        // clear cache and re-calculate height
        this.height = this.calcTextHeight();
    }
    /**
   * Generate an object that translates the style object so that it is
   * broken up by visual lines (new lines and automatic wrapping).
   * The original text styles object is broken up by actual lines (new lines only),
   * which is only sufficient for Text / IText
   * @private
   */ _generateStyleMap(textInfo) {
        let realLineCount = 0, realLineCharCount = 0, charCount = 0;
        const map = {};
        for(let i = 0; i < textInfo.graphemeLines.length; i++){
            if (textInfo.graphemeText[charCount] === "\n" && i > 0) {
                realLineCharCount = 0;
                charCount++;
                realLineCount++;
            } else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
                // this case deals with space's that are removed from end of lines when wrapping
                realLineCharCount++;
                charCount++;
            }
            map[i] = {
                line: realLineCount,
                offset: realLineCharCount
            };
            charCount += textInfo.graphemeLines[i].length;
            realLineCharCount += textInfo.graphemeLines[i].length;
        }
        return map;
    }
    /**
   * Returns true if object has a style property or has it on a specified line
   * @param {Number} lineIndex
   * @return {Boolean}
   */ styleHas(property, lineIndex) {
        if (this._styleMap && !this.isWrapping) {
            const map = this._styleMap[lineIndex];
            if (map) lineIndex = map.line;
        }
        return super.styleHas(property, lineIndex);
    }
    /**
   * Returns true if object has no styling or no styling in a line
   * @param {Number} lineIndex , lineIndex is on wrapped lines.
   * @return {Boolean}
   */ isEmptyStyles(lineIndex) {
        if (!this.styles) return true;
        let offset = 0, nextLineIndex = lineIndex + 1, nextOffset, shouldLimit = false;
        const map = this._styleMap[lineIndex], mapNextLine = this._styleMap[lineIndex + 1];
        if (map) {
            lineIndex = map.line;
            offset = map.offset;
        }
        if (mapNextLine) {
            nextLineIndex = mapNextLine.line;
            shouldLimit = nextLineIndex === lineIndex;
            nextOffset = mapNextLine.offset;
        }
        const obj = typeof lineIndex === "undefined" ? this.styles : {
            line: this.styles[lineIndex]
        };
        for(const p1 in obj)for(const p2 in obj[p1]){
            const p2Number = parseInt(p2, 10);
            if (p2Number >= offset && (!shouldLimit || p2Number < nextOffset)) {
                // eslint-disable-next-line no-unused-vars
                for(const p3 in obj[p1][p2])return false;
            }
        }
        return true;
    }
    /**
   * @protected
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {TextStyleDeclaration} a style object reference to the existing one or a new empty object when undefined
   */ _getStyleDeclaration(lineIndex, charIndex) {
        if (this._styleMap && !this.isWrapping) {
            const map = this._styleMap[lineIndex];
            if (!map) return {};
            lineIndex = map.line;
            charIndex = map.offset + charIndex;
        }
        return super._getStyleDeclaration(lineIndex, charIndex);
    }
    /**
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @param {Object} style
   * @private
   */ _setStyleDeclaration(lineIndex, charIndex, style) {
        const map = this._styleMap[lineIndex];
        super._setStyleDeclaration(map.line, map.offset + charIndex, style);
    }
    /**
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @private
   */ _deleteStyleDeclaration(lineIndex, charIndex) {
        const map = this._styleMap[lineIndex];
        super._deleteStyleDeclaration(map.line, map.offset + charIndex);
    }
    /**
   * probably broken need a fix
   * Returns the real style line that correspond to the wrapped lineIndex line
   * Used just to verify if the line does exist or not.
   * @param {Number} lineIndex
   * @returns {Boolean} if the line exists or not
   * @private
   */ _getLineStyle(lineIndex) {
        const map = this._styleMap[lineIndex];
        return !!this.styles[map.line];
    }
    /**
   * Set the line style to an empty object so that is initialized
   * @param {Number} lineIndex
   * @param {Object} style
   * @private
   */ _setLineStyle(lineIndex) {
        const map = this._styleMap[lineIndex];
        super._setLineStyle(map.line);
    }
    /**
   * Wraps text using the 'width' property of Textbox. First this function
   * splits text on newlines, so we preserve newlines entered by the user.
   * Then it wraps each line using the width of the Textbox by calling
   * _wrapLine().
   * @param {Array} lines The string array of text that is split into lines
   * @param {Number} desiredWidth width you want to wrap to
   * @returns {Array} Array of lines
   */ _wrapText(lines, desiredWidth) {
        this.isWrapping = true;
        // extract all thewords and the widths to optimally wrap lines.
        const data = this.getGraphemeDataForRender(lines);
        const wrapped = [];
        for(let i = 0; i < data.wordsData.length; i++)wrapped.push(...this._wrapLine(i, desiredWidth, data));
        this.isWrapping = false;
        return wrapped;
    }
    /**
   * For each line of text terminated by an hard line stop,
   * measure each word width and extract the largest word from all.
   * The returned words here are the one that at the end will be rendered.
   * @param {string[]} lines the lines we need to measure
   *
   */ getGraphemeDataForRender(lines) {
        const splitByGrapheme = this.splitByGrapheme, infix = splitByGrapheme ? "" : " ";
        let largestWordWidth = 0;
        const data = lines.map((line, lineIndex)=>{
            let offset = 0;
            const wordsOrGraphemes = splitByGrapheme ? this.graphemeSplit(line) : this.wordSplit(line);
            if (wordsOrGraphemes.length === 0) return [
                {
                    word: [],
                    width: 0
                }
            ];
            return wordsOrGraphemes.map((word)=>{
                // if using splitByGrapheme words are already in graphemes.
                const graphemeArray = splitByGrapheme ? [
                    word
                ] : this.graphemeSplit(word);
                const width = this._measureWord(graphemeArray, lineIndex, offset);
                largestWordWidth = Math.max(width, largestWordWidth);
                offset += graphemeArray.length + infix.length;
                return {
                    word: graphemeArray,
                    width: width
                };
            });
        });
        return {
            wordsData: data,
            largestWordWidth: largestWordWidth
        };
    }
    /**
   * Helper function to measure a string of text, given its lineIndex and charIndex offset
   * It gets called when charBounds are not available yet.
   * Override if necessary
   * Use with {@link Textbox#wordSplit}
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {String} text
   * @param {number} lineIndex
   * @param {number} charOffset
   * @returns {number}
   */ _measureWord(word, lineIndex) {
        let charOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        let width = 0, prevGrapheme;
        const skipLeft = true;
        for(let i = 0, len = word.length; i < len; i++){
            const box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
            width += box.kernedWidth;
            prevGrapheme = word[i];
        }
        return width;
    }
    /**
   * Override this method to customize word splitting
   * Use with {@link Textbox#_measureWord}
   * @param {string} value
   * @returns {string[]} array of words
   */ wordSplit(value) {
        return value.split(this._wordJoiners);
    }
    /**
   * Wraps a line of text using the width of the Textbox as desiredWidth
   * and leveraging the known width o words from GraphemeData
   * @private
   * @param {Number} lineIndex
   * @param {Number} desiredWidth width you want to wrap the line to
   * @param {GraphemeData} graphemeData an object containing all the lines' words width.
   * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
   * @returns {Array} Array of line(s) into which the given text is wrapped
   * to.
   */ _wrapLine(lineIndex, desiredWidth, _ref) {
        let { largestWordWidth: largestWordWidth, wordsData: wordsData } = _ref;
        let reservedSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        const additionalSpace = this._getWidthOfCharSpacing(), splitByGrapheme = this.splitByGrapheme, graphemeLines = [], infix = splitByGrapheme ? "" : " ";
        let lineWidth = 0, line = [], // spaces in different languages?
        offset = 0, infixWidth = 0, lineJustStarted = true;
        desiredWidth -= reservedSpace;
        const maxWidth = Math.max(desiredWidth, largestWordWidth, this.dynamicMinWidth);
        // layout words
        const data = wordsData[lineIndex];
        offset = 0;
        let i;
        for(i = 0; i < data.length; i++){
            const { word: word, width: wordWidth } = data[i];
            offset += word.length;
            lineWidth += infixWidth + wordWidth - additionalSpace;
            if (lineWidth > maxWidth && !lineJustStarted) {
                graphemeLines.push(line);
                line = [];
                lineWidth = wordWidth;
                lineJustStarted = true;
            } else lineWidth += additionalSpace;
            if (!lineJustStarted && !splitByGrapheme) line.push(infix);
            line = line.concat(word);
            infixWidth = splitByGrapheme ? 0 : this._measureWord([
                infix
            ], lineIndex, offset);
            offset++;
            lineJustStarted = false;
        }
        i && graphemeLines.push(line);
        // TODO: this code is probably not necessary anymore.
        // it can be moved out of this function since largestWordWidth is now
        // known in advance
        if (largestWordWidth + reservedSpace > this.dynamicMinWidth) this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
        return graphemeLines;
    }
    /**
   * Detect if the text line is ended with an hard break
   * text and itext do not have wrapping, return false
   * @param {Number} lineIndex text to split
   * @return {Boolean}
   */ isEndOfWrapping(lineIndex) {
        if (!this._styleMap[lineIndex + 1]) // is last line, return true;
        return true;
        if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) // this is last line before a line break, return true;
        return true;
        return false;
    }
    /**
   * Detect if a line has a linebreak and so we need to account for it when moving
   * and counting style.
   * This is important only for splitByGrapheme at the end of wrapping.
   * If we are not wrapping the offset is always 1
   * @return Number
   */ missingNewlineOffset(lineIndex, skipWrapping) {
        if (this.splitByGrapheme && !skipWrapping) return this.isEndOfWrapping(lineIndex) ? 1 : 0;
        return 1;
    }
    /**
   * Gets lines of text to render in the Textbox. This function calculates
   * text wrapping on the fly every time it is called.
   * @param {String} text text to split
   * @returns {Array} Array of lines in the Textbox.
   * @override
   */ _splitTextIntoLines(text) {
        const newText = super._splitTextIntoLines(text), graphemeLines = this._wrapText(newText.lines, this.width), lines = new Array(graphemeLines.length);
        for(let i = 0; i < graphemeLines.length; i++)lines[i] = graphemeLines[i].join("");
        newText.lines = lines;
        newText.graphemeLines = graphemeLines;
        return newText;
    }
    getMinWidth() {
        return Math.max(this.minWidth, this.dynamicMinWidth);
    }
    _removeExtraneousStyles() {
        const linesToKeep = new Map();
        for(const prop in this._styleMap){
            const propNumber = parseInt(prop, 10);
            if (this._textLines[propNumber]) {
                const lineIndex = this._styleMap[prop].line;
                linesToKeep.set("".concat(lineIndex), true);
            }
        }
        for(const prop in this.styles)if (!linesToKeep.has(prop)) delete this.styles[prop];
    }
    /**
   * Returns object representation of an instance
   * @method toObject
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ // cant use ts-expect-error because of ts 5.3 cross check
    // @ts-ignore TS this typing limitations
    toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return super.toObject([
            "minWidth",
            "splitByGrapheme",
            ...propertiesToInclude
        ]);
    }
}
/**
 * Minimum width of textbox, in pixels.
 * @type Number
 * @default
 */ /**
 * Minimum calculated width of a textbox, in pixels.
 * fixed to 2 so that an empty textbox cannot go to 0
 * and is still selectable without text.
 * @type Number
 * @default
 */ /**
 * Use this boolean property in order to split strings that have no white space concept.
 * this is a cheap way to help with chinese/japanese
 * @type Boolean
 * @since 2.6.0
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$8e3dca5fa4d5f04b, "type", "Textbox");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$8e3dca5fa4d5f04b, "textLayoutProperties", [
    ...$ab3f2a5cc6216ae5$export$6e837253f56cbab0.textLayoutProperties,
    "width"
]);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$8e3dca5fa4d5f04b, "ownDefaults", $ab3f2a5cc6216ae5$var$textboxDefaultValues);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$8e3dca5fa4d5f04b);
/**
 * Layout will adjust the bounding box to match the clip path bounding box.
 */ class $ab3f2a5cc6216ae5$export$73ee6802ebd70462 extends $ab3f2a5cc6216ae5$export$f7b260234c293505 {
    shouldPerformLayout(context) {
        return !!context.target.clipPath && super.shouldPerformLayout(context);
    }
    shouldLayoutClipPath() {
        return false;
    }
    calcLayoutResult(context, objects) {
        const { target: target } = context;
        const { clipPath: clipPath, group: group } = target;
        if (!clipPath || !this.shouldPerformLayout(context)) return;
        // TODO: remove stroke calculation from this case
        const { width: width, height: height } = $ab3f2a5cc6216ae5$var$makeBoundingBoxFromPoints($ab3f2a5cc6216ae5$var$getObjectBounds(target, clipPath));
        const size = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(width, height);
        if (clipPath.absolutePositioned) {
            //  we want the center point to exist in group's containing plane
            const clipPathCenter = $ab3f2a5cc6216ae5$var$sendPointToPlane(clipPath.getRelativeCenterPoint(), undefined, group ? group.calcTransformMatrix() : undefined);
            return {
                center: clipPathCenter,
                size: size
            };
        } else {
            //  we want the center point to exist in group's containing plane, so we send it upwards
            const clipPathCenter = clipPath.getRelativeCenterPoint().transform(target.calcOwnMatrix(), true);
            if (this.shouldPerformLayout(context)) {
                // the clip path is positioned relative to the group's center which is affected by the bbox
                // so we first calculate the bbox
                const { center: center = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(), correction: correction = new $ab3f2a5cc6216ae5$export$baf26146a414f24a() } = this.calcBoundingBox(objects, context) || {};
                return {
                    center: center.add(clipPathCenter),
                    correction: correction.subtract(clipPathCenter),
                    size: size
                };
            } else return {
                center: target.getRelativeCenterPoint().add(clipPathCenter),
                size: size
            };
        }
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$73ee6802ebd70462, "type", "clip-path");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$73ee6802ebd70462);
/**
 * Layout will keep target's initial size.
 */ class $ab3f2a5cc6216ae5$export$50774ba6edfcc9a extends $ab3f2a5cc6216ae5$export$f7b260234c293505 {
    /**
   * @override respect target's initial size
   */ getInitialSize(_ref, _ref2) {
        let { target: target } = _ref;
        let { size: size } = _ref2;
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(target.width || size.x, target.height || size.y);
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$50774ba6edfcc9a, "type", "fixed");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$50774ba6edfcc9a);
/**
 * Today the LayoutManager class also takes care of subscribing event handlers
 * to update the group layout when the group is interactive and a transform is applied
 * to a child object.
 * The ActiveSelection is never interactive, but it could contain objects from
 * groups that are.
 * The standard LayoutManager would subscribe the children of the activeSelection to
 * perform layout changes to the active selection itself, what we need instead is that
 * the transformation applied to the active selection will trigger changes to the
 * original group of the children ( the one referenced under the parent property )
 * This subclass of the LayoutManager has a single duty to fill the gap of this difference.`
 */ class $ab3f2a5cc6216ae5$var$ActiveSelectionLayoutManager extends $ab3f2a5cc6216ae5$export$4a04ad01c410b415 {
    subscribeTargets(context) {
        const activeSelection = context.target;
        const parents = context.targets.reduce((parents, target)=>{
            target.parent && parents.add(target.parent);
            return parents;
        }, new Set());
        parents.forEach((parent)=>{
            parent.layoutManager.subscribeTargets({
                target: parent,
                targets: [
                    activeSelection
                ]
            });
        });
    }
    /**
   * unsubscribe from parent only if all its children were deselected
   */ unsubscribeTargets(context) {
        const activeSelection = context.target;
        const selectedObjects = activeSelection.getObjects();
        const parents = context.targets.reduce((parents, target)=>{
            target.parent && parents.add(target.parent);
            return parents;
        }, new Set());
        parents.forEach((parent)=>{
            !selectedObjects.some((object)=>object.parent === parent) && parent.layoutManager.unsubscribeTargets({
                target: parent,
                targets: [
                    activeSelection
                ]
            });
        });
    }
}
const $ab3f2a5cc6216ae5$var$activeSelectionDefaultValues = {
    multiSelectionStacking: "canvas-stacking"
};
/**
 * Used by Canvas to manage selection.
 *
 * @example
 * class MyActiveSelection extends ActiveSelection {
 *   ...
 * }
 *
 * // override the default `ActiveSelection` class
 * classRegistry.setClass(MyActiveSelection)
 */ class $ab3f2a5cc6216ae5$export$c57a942eef0ccd19 extends $ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4 {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$c57a942eef0ccd19.ownDefaults);
    }
    /**
   * The ActiveSelection needs to use the ActiveSelectionLayoutManager
   * or selections on interactive groups may be broken
   */ /**
   * controls how selected objects are added during a multiselection event
   * - `canvas-stacking` adds the selected object to the active selection while respecting canvas object stacking order
   * - `selection-order` adds the selected object to the top of the stack,
   * meaning that the stack is ordered by the order in which objects were selected
   * @default `canvas-stacking`
   */ constructor(){
        let objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        Object.assign(this, $ab3f2a5cc6216ae5$export$c57a942eef0ccd19.ownDefaults);
        this.setOptions(options);
        const { left: left, top: top, layoutManager: layoutManager } = options;
        this.groupInit(objects, {
            left: left,
            top: top,
            layoutManager: layoutManager !== null && layoutManager !== void 0 ? layoutManager : new $ab3f2a5cc6216ae5$var$ActiveSelectionLayoutManager()
        });
    }
    /**
   * @private
   */ _shouldSetNestedCoords() {
        return true;
    }
    /**
   * @private
   * @override we don't want the selection monitor to be active
   */ __objectSelectionMonitor() {
    //  noop
    }
    /**
   * Adds objects with respect to {@link multiSelectionStacking}
   * @param targets object to add to selection
   */ multiSelectAdd() {
        for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++)targets[_key] = arguments[_key];
        if (this.multiSelectionStacking === "selection-order") this.add(...targets);
        else //  respect object stacking as it is on canvas
        //  perf enhancement for large ActiveSelection: consider a binary search of `isInFrontOf`
        targets.forEach((target)=>{
            const index = this._objects.findIndex((obj)=>obj.isInFrontOf(target));
            const insertAt = index === -1 ? //  `target` is in front of all other objects
            this.size() : index;
            this.insertAt(insertAt, target);
        });
    }
    /**
   * @override block ancestors/descendants of selected objects from being selected to prevent a circular object tree
   */ canEnterGroup(object) {
        if (this.getObjects().some((o)=>o.isDescendantOf(object) || object.isDescendantOf(o))) {
            //  prevent circular object tree
            $ab3f2a5cc6216ae5$var$log("error", "ActiveSelection: circular object trees are not supported, this call has no effect");
            return false;
        }
        return super.canEnterGroup(object);
    }
    /**
   * Change an object so that it can be part of an active selection.
   * this method is called by multiselectAdd from canvas code.
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
   */ enterGroup(object, removeParentTransform) {
        // This condition check that the object has currently a group, and the group
        // is also its parent, meaning that is not in an active selection, but is
        // in a normal group.
        if (object.parent && object.parent === object.group) // Disconnect the object from the group functionalities, but keep the ref parent intact
        // for later re-enter
        object.parent._exitGroup(object);
        else if (object.group && object.parent !== object.group) // in this case group.remove will also clear the old parent reference.
        object.group.remove(object);
        // enter the active selection from a render perspective
        // the object will be in the objects array of both the ActiveSelection and the Group
        // but referenced in the group's _activeObjects so that it won't be rendered twice.
        this._enterGroup(object, removeParentTransform);
    }
    /**
   * we want objects to retain their canvas ref when exiting instance
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
   */ exitGroup(object, removeParentTransform) {
        this._exitGroup(object, removeParentTransform);
        // return to parent
        object.parent && object.parent._enterGroup(object, true);
    }
    /**
   * @private
   * @param {'added'|'removed'} type
   * @param {FabricObject[]} targets
   */ _onAfterObjectsChange(type, targets) {
        super._onAfterObjectsChange(type, targets);
        const groups = new Set();
        targets.forEach((object)=>{
            const { parent: parent } = object;
            parent && groups.add(parent);
        });
        if (type === $ab3f2a5cc6216ae5$var$LAYOUT_TYPE_REMOVED) //  invalidate groups' layout and mark as dirty
        groups.forEach((group)=>{
            group._onAfterObjectsChange($ab3f2a5cc6216ae5$var$LAYOUT_TYPE_ADDED, targets);
        });
        else //  mark groups as dirty
        groups.forEach((group)=>{
            group._set("dirty", true);
        });
    }
    /**
   * @override remove all objects
   */ onDeselect() {
        this.removeAll();
        return false;
    }
    /**
   * Returns string representation of a group
   * @return {String}
   */ toString() {
        return "#<ActiveSelection: (".concat(this.complexity(), ")>");
    }
    /**
   * Decide if the object should cache or not. Create its own cache level
   * objectCaching is a global flag, wins over everything
   * needsItsOwnCache should be used when the object drawing method requires
   * a cache step. None of the fabric classes requires it.
   * Generally you do not cache objects in groups because the group outside is cached.
   * @return {Boolean}
   */ shouldCache() {
        return false;
    }
    /**
   * Check if this group or its parent group are caching, recursively up
   * @return {Boolean}
   */ isOnACache() {
        return false;
    }
    /**
   * Renders controls and borders for the object
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Object} [styleOverride] properties to override the object style
   * @param {Object} [childrenOverride] properties to override the children overrides
   */ _renderControls(ctx, styleOverride, childrenOverride) {
        ctx.save();
        ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
        const options = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({
            hasControls: false
        }, childrenOverride), {}, {
            forActiveSelection: true
        });
        for(let i = 0; i < this._objects.length; i++)this._objects[i]._renderControls(ctx, options);
        super._renderControls(ctx, styleOverride);
        ctx.restore();
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c57a942eef0ccd19, "type", "ActiveSelection");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$c57a942eef0ccd19, "ownDefaults", $ab3f2a5cc6216ae5$var$activeSelectionDefaultValues);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$c57a942eef0ccd19);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$c57a942eef0ccd19, "activeSelection");
/**
 * Canvas 2D filter backend.
 */ class $ab3f2a5cc6216ae5$export$eaf5984e5c8f09c5 {
    constructor(){
        /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/ $ab3f2a5cc6216ae5$var$_defineProperty(this, "resources", {});
    }
    /**
   * Apply a set of filters against a source image and draw the filtered output
   * to the provided destination canvas.
   *
   * @param {EnhancedFilter} filters The filter to apply.
   * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
   * @param {Number} sourceWidth The width of the source input.
   * @param {Number} sourceHeight The height of the source input.
   * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
   */ applyFilters(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
        const ctx = targetCanvas.getContext("2d");
        if (!ctx) return;
        ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
        const imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
        const originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
        const pipelineState = {
            sourceWidth: sourceWidth,
            sourceHeight: sourceHeight,
            imageData: imageData,
            originalEl: sourceElement,
            originalImageData: originalImageData,
            canvasEl: targetCanvas,
            ctx: ctx,
            filterBackend: this
        };
        filters.forEach((filter)=>{
            filter.applyTo(pipelineState);
        });
        const { imageData: imageDataPostFilter } = pipelineState;
        if (imageDataPostFilter.width !== sourceWidth || imageDataPostFilter.height !== sourceHeight) {
            targetCanvas.width = imageDataPostFilter.width;
            targetCanvas.height = imageDataPostFilter.height;
        }
        ctx.putImageData(imageDataPostFilter, 0, 0);
        return pipelineState;
    }
}
class $ab3f2a5cc6216ae5$export$42da2a27efef173b {
    constructor(){
        let { tileSize: tileSize = $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.textureSize } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        /**
     * Define ...
     **/ $ab3f2a5cc6216ae5$var$_defineProperty(this, "aPosition", new Float32Array([
            0,
            0,
            0,
            1,
            1,
            0,
            1,
            1
        ]));
        /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/ $ab3f2a5cc6216ae5$var$_defineProperty(this, "resources", {});
        this.tileSize = tileSize;
        this.setupGLContext(tileSize, tileSize);
        this.captureGPUInfo();
    }
    /**
   * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
   */ setupGLContext(width, height) {
        this.dispose();
        this.createWebGLCanvas(width, height);
    }
    /**
   * Create a canvas element and associated WebGL context and attaches them as
   * class properties to the GLFilterBackend class.
   */ createWebGLCanvas(width, height) {
        const canvas = $ab3f2a5cc6216ae5$var$createCanvasElement();
        canvas.width = width;
        canvas.height = height;
        const glOptions = {
            alpha: true,
            premultipliedAlpha: false,
            depth: false,
            stencil: false,
            antialias: false
        }, gl = canvas.getContext("webgl", glOptions);
        if (!gl) return;
        gl.clearColor(0, 0, 0, 0);
        // this canvas can fire webglcontextlost and webglcontextrestored
        this.canvas = canvas;
        this.gl = gl;
    }
    /**
   * Attempts to apply the requested filters to the source provided, drawing the filtered output
   * to the provided target canvas.
   *
   * @param {Array} filters The filters to apply.
   * @param {TexImageSource} source The source to be filtered.
   * @param {Number} width The width of the source input.
   * @param {Number} height The height of the source input.
   * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
   * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
   * omitted, caching will be skipped.
   */ applyFilters(filters, source, width, height, targetCanvas, cacheKey) {
        const gl = this.gl;
        const ctx = targetCanvas.getContext("2d");
        if (!gl || !ctx) return;
        let cachedTexture;
        if (cacheKey) cachedTexture = this.getCachedTexture(cacheKey, source);
        const pipelineState = {
            originalWidth: source.width || // @ts-expect-error is this a bug? should this be naturalWidth? or is this the pipeline state?
            source.originalWidth || 0,
            originalHeight: source.height || // @ts-expect-error is this a bug? should this be naturalHeight? or is this the pipeline state?
            source.originalHeight || 0,
            sourceWidth: width,
            sourceHeight: height,
            destinationWidth: width,
            destinationHeight: height,
            context: gl,
            sourceTexture: this.createTexture(gl, width, height, !cachedTexture ? source : undefined),
            targetTexture: this.createTexture(gl, width, height),
            originalTexture: cachedTexture || this.createTexture(gl, width, height, !cachedTexture ? source : undefined),
            passes: filters.length,
            webgl: true,
            aPosition: this.aPosition,
            programCache: this.programCache,
            pass: 0,
            filterBackend: this,
            targetCanvas: targetCanvas
        };
        const tempFbo = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
        filters.forEach((filter)=>{
            filter && filter.applyTo(pipelineState);
        });
        $ab3f2a5cc6216ae5$var$resizeCanvasIfNeeded(pipelineState);
        this.copyGLTo2D(gl, pipelineState);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.deleteTexture(pipelineState.sourceTexture);
        gl.deleteTexture(pipelineState.targetTexture);
        gl.deleteFramebuffer(tempFbo);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        return pipelineState;
    }
    /**
   * Detach event listeners, remove references, and clean up caches.
   */ dispose() {
        if (this.canvas) {
            // we are disposing, we don't care about the fact
            // that the canvas shouldn't be null.
            // @ts-expect-error disposing
            this.canvas = null;
            // @ts-expect-error disposing
            this.gl = null;
        }
        this.clearWebGLCaches();
    }
    /**
   * Wipe out WebGL-related caches.
   */ clearWebGLCaches() {
        this.programCache = {};
        this.textureCache = {};
    }
    /**
   * Create a WebGL texture object.
   *
   * Accepts specific dimensions to initialize the texture to or a source image.
   *
   * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
   * @param {number} width The width to initialize the texture at.
   * @param {number} height The height to initialize the texture.
   * @param {TexImageSource} textureImageSource A source for the texture data.
   * @param {number} filter gl.NEAREST default or gl.LINEAR filters for the texture.
   * This filter is very useful for LUTs filters. If you need interpolation use gl.LINEAR
   * @returns {WebGLTexture}
   */ createTexture(gl, width, height, textureImageSource, filter) {
        const { NEAREST: NEAREST, TEXTURE_2D: TEXTURE_2D, RGBA: RGBA, UNSIGNED_BYTE: UNSIGNED_BYTE, CLAMP_TO_EDGE: CLAMP_TO_EDGE, TEXTURE_MAG_FILTER: TEXTURE_MAG_FILTER, TEXTURE_MIN_FILTER: TEXTURE_MIN_FILTER, TEXTURE_WRAP_S: TEXTURE_WRAP_S, TEXTURE_WRAP_T: TEXTURE_WRAP_T } = gl;
        const texture = gl.createTexture();
        gl.bindTexture(TEXTURE_2D, texture);
        gl.texParameteri(TEXTURE_2D, TEXTURE_MAG_FILTER, filter || NEAREST);
        gl.texParameteri(TEXTURE_2D, TEXTURE_MIN_FILTER, filter || NEAREST);
        gl.texParameteri(TEXTURE_2D, TEXTURE_WRAP_S, CLAMP_TO_EDGE);
        gl.texParameteri(TEXTURE_2D, TEXTURE_WRAP_T, CLAMP_TO_EDGE);
        if (textureImageSource) gl.texImage2D(TEXTURE_2D, 0, RGBA, RGBA, UNSIGNED_BYTE, textureImageSource);
        else gl.texImage2D(TEXTURE_2D, 0, RGBA, width, height, 0, RGBA, UNSIGNED_BYTE, null);
        return texture;
    }
    /**
   * Can be optionally used to get a texture from the cache array
   *
   * If an existing texture is not found, a new texture is created and cached.
   *
   * @param {String} uniqueId A cache key to use to find an existing texture.
   * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
   * texture cache entry if one does not already exist.
   */ getCachedTexture(uniqueId, textureImageSource, filter) {
        const { textureCache: textureCache } = this;
        if (textureCache[uniqueId]) return textureCache[uniqueId];
        else {
            const texture = this.createTexture(this.gl, textureImageSource.width, textureImageSource.height, textureImageSource, filter);
            if (texture) textureCache[uniqueId] = texture;
            return texture;
        }
    }
    /**
   * Clear out cached resources related to a source image that has been
   * filtered previously.
   *
   * @param {String} cacheKey The cache key provided when the source image was filtered.
   */ evictCachesForKey(cacheKey) {
        if (this.textureCache[cacheKey]) {
            this.gl.deleteTexture(this.textureCache[cacheKey]);
            delete this.textureCache[cacheKey];
        }
    }
    /**
   * Copy an input WebGL canvas on to an output 2D canvas.
   *
   * The WebGL canvas is assumed to be upside down, with the top-left pixel of the
   * desired output image appearing in the bottom-left corner of the WebGL canvas.
   *
   * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
   * @param {Object} pipelineState The 2D target canvas to copy on to.
   */ copyGLTo2D(gl, pipelineState) {
        const glCanvas = gl.canvas, targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext("2d");
        if (!ctx) return;
        ctx.translate(0, targetCanvas.height); // move it down again
        ctx.scale(1, -1); // vertical flip
        // where is my image on the big glcanvas?
        const sourceY = glCanvas.height - targetCanvas.height;
        ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0, targetCanvas.width, targetCanvas.height);
    }
    /**
   * Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
   * API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
   *
   * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
   * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
   * @param {Object} pipelineState The 2D target canvas to copy on to.
   */ copyGLTo2DPutImageData(gl, pipelineState) {
        const targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext("2d"), dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight, numBytes = dWidth * dHeight * 4;
        if (!ctx) return;
        const u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
        const u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);
        gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
        const imgData = new ImageData(u8Clamped, dWidth, dHeight);
        ctx.putImageData(imgData, 0, 0);
    }
    /**
   * Attempt to extract GPU information strings from a WebGL context.
   *
   * Useful information when debugging or blacklisting specific GPUs.
   *
   * @returns {Object} A GPU info object with renderer and vendor strings.
   */ captureGPUInfo() {
        if (this.gpuInfo) return this.gpuInfo;
        const gl = this.gl, gpuInfo = {
            renderer: "",
            vendor: ""
        };
        if (!gl) return gpuInfo;
        const ext = gl.getExtension("WEBGL_debug_renderer_info");
        if (ext) {
            const renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
            const vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
            if (renderer) gpuInfo.renderer = renderer.toLowerCase();
            if (vendor) gpuInfo.vendor = vendor.toLowerCase();
        }
        this.gpuInfo = gpuInfo;
        return gpuInfo;
    }
}
function $ab3f2a5cc6216ae5$var$resizeCanvasIfNeeded(pipelineState) {
    const targetCanvas = pipelineState.targetCanvas, width = targetCanvas.width, height = targetCanvas.height, dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight;
    if (width !== dWidth || height !== dHeight) {
        targetCanvas.width = dWidth;
        targetCanvas.height = dHeight;
    }
}
let $ab3f2a5cc6216ae5$var$filterBackend;
/**
 * Verifies if it is possible to initialize webgl or fallback on a canvas2d filtering backend
 */ function $ab3f2a5cc6216ae5$export$4747bee7c8857651() {
    const { WebGLProbe: WebGLProbe } = $ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e();
    WebGLProbe.queryWebGL($ab3f2a5cc6216ae5$var$createCanvasElement());
    if ($ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.enableGLFiltering && WebGLProbe.isSupported($ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.textureSize)) return new $ab3f2a5cc6216ae5$export$42da2a27efef173b({
        tileSize: $ab3f2a5cc6216ae5$export$e506a1d27d1eaa20.textureSize
    });
    else return new $ab3f2a5cc6216ae5$export$eaf5984e5c8f09c5();
}
/**
 * Get the current fabricJS filter backend  or initialize one if not available yet
 * @param [strict] pass `true` to create the backend if it wasn't created yet (default behavior),
 * pass `false` to get the backend ref without mutating it
 */ function $ab3f2a5cc6216ae5$export$8c3a6bdf56bdf106() {
    let strict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!$ab3f2a5cc6216ae5$var$filterBackend && strict) $ab3f2a5cc6216ae5$var$filterBackend = $ab3f2a5cc6216ae5$export$4747bee7c8857651();
    return $ab3f2a5cc6216ae5$var$filterBackend;
}
function $ab3f2a5cc6216ae5$export$99b8b463935976a6(backend) {
    $ab3f2a5cc6216ae5$var$filterBackend = backend;
}
const $ab3f2a5cc6216ae5$var$_excluded$2 = [
    "filters",
    "resizeFilter",
    "src",
    "crossOrigin",
    "type"
];
// @todo Would be nice to have filtering code not imported directly.
const $ab3f2a5cc6216ae5$var$imageDefaultValues = {
    strokeWidth: 0,
    srcFromAttribute: false,
    minimumScaleTrigger: 0.5,
    cropX: 0,
    cropY: 0,
    imageSmoothing: true
};
const $ab3f2a5cc6216ae5$var$IMAGE_PROPS = [
    "cropX",
    "cropY"
];
/**
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#images}
 */ class $ab3f2a5cc6216ae5$export$3148ec5c6497ddc8 extends $ab3f2a5cc6216ae5$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.getDefaults()), $ab3f2a5cc6216ae5$export$3148ec5c6497ddc8.ownDefaults);
    }
    /**
   * Constructor
   * Image can be initialized with any canvas drawable or a string.
   * The string should be a url and will be loaded as an image.
   * Canvas and Image element work out of the box, while videos require extra code to work.
   * Please check video element events for seeking.
   * @param {ImageSource | string} element Image element
   * @param {Object} [options] Options object
   */ constructor(arg0, options){
        super();
        /**
     * When calling {@link FabricImage.getSrc}, return value from element src with `element.getAttribute('src')`.
     * This allows for relative urls as image src.
     * @since 2.7.0
     * @type Boolean
     * @default false
     */ /**
     * private
     * contains last value of scaleX to detect
     * if the Image got resized after the last Render
     * @type Number
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_lastScaleX", 1);
        /**
     * private
     * contains last value of scaleY to detect
     * if the Image got resized after the last Render
     * @type Number
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_lastScaleY", 1);
        /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_filterScalingX", 1);
        /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */ $ab3f2a5cc6216ae5$var$_defineProperty(this, "_filterScalingY", 1);
        this.filters = [];
        Object.assign(this, $ab3f2a5cc6216ae5$export$3148ec5c6497ddc8.ownDefaults);
        this.setOptions(options);
        this.cacheKey = "texture".concat($ab3f2a5cc6216ae5$var$uid());
        this.setElement(typeof arg0 === "string" ? (this.canvas && $ab3f2a5cc6216ae5$var$getDocumentFromElement(this.canvas.getElement()) || $ab3f2a5cc6216ae5$export$91e93c41e950ddbb()).getElementById(arg0) : arg0, options);
    }
    /**
   * Returns image element which this instance if based on
   */ getElement() {
        return this._element;
    }
    /**
   * Sets image element for this instance to a specified one.
   * If filters defined they are applied to new image.
   * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
   * @param {HTMLImageElement} element
   * @param {Partial<TSize>} [size] Options object
   */ setElement(element) {
        let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.removeTexture(this.cacheKey);
        this.removeTexture("".concat(this.cacheKey, "_filtered"));
        this._element = element;
        this._originalElement = element;
        this._setWidthHeight(size);
        element.classList.add($ab3f2a5cc6216ae5$export$3148ec5c6497ddc8.CSS_CANVAS);
        if (this.filters.length !== 0) this.applyFilters();
        // resizeFilters work on the already filtered copy.
        // we need to apply resizeFilters AFTER normal filters.
        // applyResizeFilters is run more often than normal filters
        // and is triggered by user interactions rather than dev code
        if (this.resizeFilter) this.applyResizeFilters();
    }
    /**
   * Delete a single texture if in webgl mode
   */ removeTexture(key) {
        const backend = $ab3f2a5cc6216ae5$export$8c3a6bdf56bdf106(false);
        if (backend instanceof $ab3f2a5cc6216ae5$export$42da2a27efef173b) backend.evictCachesForKey(key);
    }
    /**
   * Delete textures, reference to elements and eventually JSDOM cleanup
   */ dispose() {
        super.dispose();
        this.removeTexture(this.cacheKey);
        this.removeTexture("".concat(this.cacheKey, "_filtered"));
        this._cacheContext = null;
        [
            "_originalElement",
            "_element",
            "_filteredEl",
            "_cacheCanvas"
        ].forEach((elementKey)=>{
            const el = this[elementKey];
            el && $ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e().dispose(el);
            // @ts-expect-error disposing
            this[elementKey] = undefined;
        });
    }
    /**
   * Get the crossOrigin value (of the corresponding image element)
   */ getCrossOrigin() {
        return this._originalElement && (this._originalElement.crossOrigin || null);
    }
    /**
   * Returns original size of an image
   */ getOriginalSize() {
        const element = this.getElement();
        if (!element) return {
            width: 0,
            height: 0
        };
        return {
            width: element.naturalWidth || element.width,
            height: element.naturalHeight || element.height
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _stroke(ctx) {
        if (!this.stroke || this.strokeWidth === 0) return;
        const w = this.width / 2, h = this.height / 2;
        ctx.beginPath();
        ctx.moveTo(-w, -h);
        ctx.lineTo(w, -h);
        ctx.lineTo(w, h);
        ctx.lineTo(-w, h);
        ctx.lineTo(-w, -h);
        ctx.closePath();
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} Object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const filters = [];
        this.filters.forEach((filterObj)=>{
            filterObj && filters.push(filterObj.toObject());
        });
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.toObject([
            ...$ab3f2a5cc6216ae5$var$IMAGE_PROPS,
            ...propertiesToInclude
        ])), {}, {
            src: this.getSrc(),
            crossOrigin: this.getCrossOrigin(),
            filters: filters
        }, this.resizeFilter ? {
            resizeFilter: this.resizeFilter.toObject()
        } : {});
    }
    /**
   * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,height.
   * @return {Boolean}
   */ hasCrop() {
        return !!this.cropX || !!this.cropY || this.width < this._element.width || this.height < this._element.height;
    }
    /**
   * Returns svg representation of an instance
   * @return {string[]} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const imageMarkup = [], element = this._element, x = -this.width / 2, y = -this.height / 2;
        let svgString = [], strokeSvg = [], clipPath = "", imageRendering = "";
        if (!element) return [];
        if (this.hasCrop()) {
            const clipPathId = $ab3f2a5cc6216ae5$var$uid();
            svgString.push('<clipPath id="imageCrop_' + clipPathId + '">\n', '	<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n', "</clipPath>\n");
            clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
        }
        if (!this.imageSmoothing) imageRendering = ' image-rendering="optimizeSpeed"';
        imageMarkup.push("	<image ", "COMMON_PARTS", 'xlink:href="'.concat(this.getSvgSrc(true), '" x="').concat(x - this.cropX, '" y="').concat(y - this.cropY, '" width="').concat(element.width || element.naturalWidth, '" height="').concat(element.height || element.naturalHeight, '"').concat(imageRendering).concat(clipPath, "></image>\n"));
        if (this.stroke || this.strokeDashArray) {
            const origFill = this.fill;
            this.fill = null;
            strokeSvg = [
                '	<rect x="'.concat(x, '" y="').concat(y, '" width="').concat(this.width, '" height="').concat(this.height, '" style="').concat(this.getSvgStyles(), '" />\n')
            ];
            this.fill = origFill;
        }
        if (this.paintFirst !== $ab3f2a5cc6216ae5$var$FILL) svgString = svgString.concat(strokeSvg, imageMarkup);
        else svgString = svgString.concat(imageMarkup, strokeSvg);
        return svgString;
    }
    /**
   * Returns source of an image
   * @param {Boolean} filtered indicates if the src is needed for svg
   * @return {String} Source of an image
   */ getSrc(filtered) {
        const element = filtered ? this._element : this._originalElement;
        if (element) {
            if (element.toDataURL) return element.toDataURL();
            if (this.srcFromAttribute) return element.getAttribute("src") || "";
            else return element.src;
        } else return this.src || "";
    }
    /**
   * Alias for getSrc
   * @param filtered
   * @deprecated
   */ getSvgSrc(filtered) {
        return this.getSrc(filtered);
    }
    /**
   * Loads and sets source of an image\
   * **IMPORTANT**: It is recommended to abort loading tasks before calling this method to prevent race conditions and unnecessary networking
   * @param {String} src Source string (URL)
   * @param {LoadImageOptions} [options] Options object
   */ setSrc(src) {
        let { crossOrigin: crossOrigin, signal: signal } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return $ab3f2a5cc6216ae5$var$loadImage(src, {
            crossOrigin: crossOrigin,
            signal: signal
        }).then((img)=>{
            typeof crossOrigin !== "undefined" && this.set({
                crossOrigin: crossOrigin
            });
            this.setElement(img);
        });
    }
    /**
   * Returns string representation of an instance
   * @return {String} String representation of an instance
   */ toString() {
        return '#<Image: { src: "'.concat(this.getSrc(), '" }>');
    }
    applyResizeFilters() {
        const filter = this.resizeFilter, minimumScale = this.minimumScaleTrigger, objectScale = this.getTotalObjectScaling(), scaleX = objectScale.x, scaleY = objectScale.y, elementToFilter = this._filteredEl || this._originalElement;
        if (this.group) this.set("dirty", true);
        if (!filter || scaleX > minimumScale && scaleY > minimumScale) {
            this._element = elementToFilter;
            this._filterScalingX = 1;
            this._filterScalingY = 1;
            this._lastScaleX = scaleX;
            this._lastScaleY = scaleY;
            return;
        }
        const canvasEl = $ab3f2a5cc6216ae5$var$createCanvasElement(), sourceWidth = elementToFilter.width, sourceHeight = elementToFilter.height;
        canvasEl.width = sourceWidth;
        canvasEl.height = sourceHeight;
        this._element = canvasEl;
        this._lastScaleX = filter.scaleX = scaleX;
        this._lastScaleY = filter.scaleY = scaleY;
        $ab3f2a5cc6216ae5$export$8c3a6bdf56bdf106().applyFilters([
            filter
        ], elementToFilter, sourceWidth, sourceHeight, this._element);
        this._filterScalingX = canvasEl.width / this._originalElement.width;
        this._filterScalingY = canvasEl.height / this._originalElement.height;
    }
    /**
   * Applies filters assigned to this image (from "filters" array) or from filter param
   * @method applyFilters
   * @param {Array} filters to be applied
   * @param {Boolean} forResizing specify if the filter operation is a resize operation
   */ applyFilters() {
        let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.filters || [];
        filters = filters.filter((filter)=>filter && !filter.isNeutralState());
        this.set("dirty", true);
        // needs to clear out or WEBGL will not resize correctly
        this.removeTexture("".concat(this.cacheKey, "_filtered"));
        if (filters.length === 0) {
            this._element = this._originalElement;
            // this is unsafe and needs to be rethinkend
            this._filteredEl = undefined;
            this._filterScalingX = 1;
            this._filterScalingY = 1;
            return;
        }
        const imgElement = this._originalElement, sourceWidth = imgElement.naturalWidth || imgElement.width, sourceHeight = imgElement.naturalHeight || imgElement.height;
        if (this._element === this._originalElement) {
            // if the _element a reference to _originalElement
            // we need to create a new element to host the filtered pixels
            const canvasEl = $ab3f2a5cc6216ae5$var$createCanvasElement();
            canvasEl.width = sourceWidth;
            canvasEl.height = sourceHeight;
            this._element = canvasEl;
            this._filteredEl = canvasEl;
        } else if (this._filteredEl) {
            // if the _element is it own element,
            // and we also have a _filteredEl, then we clean up _filteredEl
            // and we assign it to _element.
            // in this way we invalidate the eventual old resize filtered element
            this._element = this._filteredEl;
            this._filteredEl.getContext("2d").clearRect(0, 0, sourceWidth, sourceHeight);
            // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y
            this._lastScaleX = 1;
            this._lastScaleY = 1;
        }
        $ab3f2a5cc6216ae5$export$8c3a6bdf56bdf106().applyFilters(filters, this._originalElement, sourceWidth, sourceHeight, this._element);
        if (this._originalElement.width !== this._element.width || this._originalElement.height !== this._element.height) {
            this._filterScalingX = this._element.width / this._originalElement.width;
            this._filterScalingY = this._element.height / this._originalElement.height;
        }
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        ctx.imageSmoothingEnabled = this.imageSmoothing;
        if (this.isMoving !== true && this.resizeFilter && this._needsResize()) this.applyResizeFilters();
        this._stroke(ctx);
        this._renderPaintInOrder(ctx);
    }
    /**
   * Paint the cached copy of the object on the target context.
   * it will set the imageSmoothing for the draw operation
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ drawCacheOnCanvas(ctx) {
        ctx.imageSmoothingEnabled = this.imageSmoothing;
        // cant use ts-expect-error because of ts 5.3 cross check
        // @ts-ignore TS doesn't respect this type casting
        super.drawCacheOnCanvas(ctx);
    }
    /**
   * Decide if the object should cache or not. Create its own cache level
   * needsItsOwnCache should be used when the object drawing method requires
   * a cache step. None of the fabric classes requires it.
   * Generally you do not cache objects in groups because the group outside is cached.
   * This is the special image version where we would like to avoid caching where possible.
   * Essentially images do not benefit from caching. They may require caching, and in that
   * case we do it. Also caching an image usually ends in a loss of details.
   * A full performance audit should be done.
   * @return {Boolean}
   */ shouldCache() {
        return this.needsItsOwnCache();
    }
    _renderFill(ctx) {
        const elementToDraw = this._element;
        if (!elementToDraw) return;
        const scaleX = this._filterScalingX, scaleY = this._filterScalingY, w = this.width, h = this.height, // crop values cannot be lesser than 0.
        cropX = Math.max(this.cropX, 0), cropY = Math.max(this.cropY, 0), elWidth = elementToDraw.naturalWidth || elementToDraw.width, elHeight = elementToDraw.naturalHeight || elementToDraw.height, sX = cropX * scaleX, sY = cropY * scaleY, // the width height cannot exceed element width/height, starting from the crop offset.
        sW = Math.min(w * scaleX, elWidth - sX), sH = Math.min(h * scaleY, elHeight - sY), x = -w / 2, y = -h / 2, maxDestW = Math.min(w, elWidth / scaleX - cropX), maxDestH = Math.min(h, elHeight / scaleY - cropY);
        elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
    }
    /**
   * needed to check if image needs resize
   * @private
   */ _needsResize() {
        const scale = this.getTotalObjectScaling();
        return scale.x !== this._lastScaleX || scale.y !== this._lastScaleY;
    }
    /**
   * @private
   * @deprecated unused
   */ _resetWidthHeight() {
        this.set(this.getOriginalSize());
    }
    /**
   * @private
   * Set the width and the height of the image object, using the element or the
   * options.
   */ _setWidthHeight() {
        let { width: width, height: height } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const size = this.getOriginalSize();
        this.width = width || size.width;
        this.height = height || size.height;
    }
    /**
   * Calculate offset for center and scale factor for the image in order to respect
   * the preserveAspectRatio attribute
   * @private
   */ parsePreserveAspectRatioAttribute() {
        const pAR = $ab3f2a5cc6216ae5$var$parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ""), pWidth = this.width, pHeight = this.height, parsedAttributes = {
            width: pWidth,
            height: pHeight
        };
        let rWidth = this._element.width, rHeight = this._element.height, scaleX = 1, scaleY = 1, offsetLeft = 0, offsetTop = 0, cropX = 0, cropY = 0, offset;
        if (pAR && (pAR.alignX !== $ab3f2a5cc6216ae5$var$NONE || pAR.alignY !== $ab3f2a5cc6216ae5$var$NONE)) {
            if (pAR.meetOrSlice === "meet") {
                scaleX = scaleY = $ab3f2a5cc6216ae5$var$findScaleToFit(this._element, parsedAttributes);
                offset = (pWidth - rWidth * scaleX) / 2;
                if (pAR.alignX === "Min") offsetLeft = -offset;
                if (pAR.alignX === "Max") offsetLeft = offset;
                offset = (pHeight - rHeight * scaleY) / 2;
                if (pAR.alignY === "Min") offsetTop = -offset;
                if (pAR.alignY === "Max") offsetTop = offset;
            }
            if (pAR.meetOrSlice === "slice") {
                scaleX = scaleY = $ab3f2a5cc6216ae5$var$findScaleToCover(this._element, parsedAttributes);
                offset = rWidth - pWidth / scaleX;
                if (pAR.alignX === "Mid") cropX = offset / 2;
                if (pAR.alignX === "Max") cropX = offset;
                offset = rHeight - pHeight / scaleY;
                if (pAR.alignY === "Mid") cropY = offset / 2;
                if (pAR.alignY === "Max") cropY = offset;
                rWidth = pWidth / scaleX;
                rHeight = pHeight / scaleY;
            }
        } else {
            scaleX = pWidth / rWidth;
            scaleY = pHeight / rHeight;
        }
        return {
            width: rWidth,
            height: rHeight,
            scaleX: scaleX,
            scaleY: scaleY,
            offsetLeft: offsetLeft,
            offsetTop: offsetTop,
            cropX: cropX,
            cropY: cropY
        };
    }
    /**
   * Default CSS class name for canvas
   * @static
   * @type String
   * @default
   */ /**
   * Creates an instance of FabricImage from its object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {object} [options] Options object
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<FabricImage>}
   */ static fromObject(_ref, options) {
        let { filters: f, resizeFilter: rf, src: src, crossOrigin: crossOrigin, type: type } = _ref, object = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref, $ab3f2a5cc6216ae5$var$_excluded$2);
        return Promise.all([
            $ab3f2a5cc6216ae5$var$loadImage(src, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, options), {}, {
                crossOrigin: crossOrigin
            })),
            f && $ab3f2a5cc6216ae5$var$enlivenObjects(f, options),
            // TODO: redundant - handled by enlivenObjectEnlivables
            rf && $ab3f2a5cc6216ae5$var$enlivenObjects([
                rf
            ], options),
            $ab3f2a5cc6216ae5$var$enlivenObjectEnlivables(object, options)
        ]).then((_ref2)=>{
            let [el, filters = [], [resizeFilter] = [], hydratedProps = {}] = _ref2;
            return new this(el, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, object), {}, {
                src: // TODO: this creates a difference between image creation and restoring from JSON
                src,
                filters: filters,
                resizeFilter: resizeFilter
            }, hydratedProps));
        });
    }
    /**
   * Creates an instance of Image from an URL string
   * @static
   * @param {String} url URL to create an image from
   * @param {LoadImageOptions} [options] Options object
   * @returns {Promise<FabricImage>}
   */ static fromURL(url) {
        let { crossOrigin: crossOrigin = null, signal: signal } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let imageOptions = arguments.length > 2 ? arguments[2] : undefined;
        return $ab3f2a5cc6216ae5$var$loadImage(url, {
            crossOrigin: crossOrigin,
            signal: signal
        }).then((img)=>new this(img, imageOptions));
    }
    /**
   * Returns {@link FabricImage} instance from an SVG element
   * @static
   * @param {HTMLElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @param {Function} callback Callback to execute when Image object is created
   */ static async fromElement(element) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let cssRules = arguments.length > 2 ? arguments[2] : undefined;
        const parsedAttributes = $ab3f2a5cc6216ae5$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules);
        return this.fromURL(parsedAttributes["xlink:href"], options, parsedAttributes).catch((err)=>{
            $ab3f2a5cc6216ae5$var$log("log", "Unable to parse Image", err);
            return null;
        });
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$3148ec5c6497ddc8, "type", "Image");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$3148ec5c6497ddc8, "cacheProperties", [
    ...$ab3f2a5cc6216ae5$var$cacheProperties,
    ...$ab3f2a5cc6216ae5$var$IMAGE_PROPS
]);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$3148ec5c6497ddc8, "ownDefaults", $ab3f2a5cc6216ae5$var$imageDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$3148ec5c6497ddc8, "CSS_CANVAS", "canvas-img");
/**
 * List of attribute names to account for when parsing SVG element (used by {@link FabricImage.fromElement})
 * @static
 * @see {@link http://www.w3.org/TR/SVG/struct.html#ImageElement}
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$export$3148ec5c6497ddc8, "ATTRIBUTE_NAMES", [
    ...$ab3f2a5cc6216ae5$var$SHARED_ATTRIBUTES,
    "x",
    "y",
    "width",
    "height",
    "preserveAspectRatio",
    "xlink:href",
    "crossOrigin",
    "image-rendering"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$export$3148ec5c6497ddc8);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setSVGClass($ab3f2a5cc6216ae5$export$3148ec5c6497ddc8);
/**
 * Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
 */ function $ab3f2a5cc6216ae5$var$applyViewboxTransform(element) {
    if (!$ab3f2a5cc6216ae5$var$svgViewBoxElementsRegEx.test(element.nodeName)) return {};
    const viewBoxAttr = element.getAttribute("viewBox");
    let scaleX = 1;
    let scaleY = 1;
    let minX = 0;
    let minY = 0;
    let matrix;
    let el;
    const widthAttr = element.getAttribute("width");
    const heightAttr = element.getAttribute("height");
    const x = element.getAttribute("x") || 0;
    const y = element.getAttribute("y") || 0;
    const goodViewbox = viewBoxAttr && $ab3f2a5cc6216ae5$var$reViewBoxAttrValue.test(viewBoxAttr);
    const missingViewBox = !goodViewbox;
    const missingDimAttr = !widthAttr || !heightAttr || widthAttr === "100%" || heightAttr === "100%";
    let translateMatrix = "";
    let widthDiff = 0;
    let heightDiff = 0;
    if (missingViewBox) {
        if ((x || y) && element.parentNode && element.parentNode.nodeName !== "#document") {
            translateMatrix = " translate(" + $ab3f2a5cc6216ae5$var$parseUnit(x || "0") + " " + $ab3f2a5cc6216ae5$var$parseUnit(y || "0") + ") ";
            matrix = (element.getAttribute("transform") || "") + translateMatrix;
            element.setAttribute("transform", matrix);
            element.removeAttribute("x");
            element.removeAttribute("y");
        }
    }
    if (missingViewBox && missingDimAttr) return {
        width: 0,
        height: 0
    };
    const parsedDim = {
        width: 0,
        height: 0
    };
    if (missingViewBox) {
        parsedDim.width = $ab3f2a5cc6216ae5$var$parseUnit(widthAttr);
        parsedDim.height = $ab3f2a5cc6216ae5$var$parseUnit(heightAttr);
        // set a transform for elements that have x y and are inner(only) SVGs
        return parsedDim;
    }
    const pasedViewBox = viewBoxAttr.match($ab3f2a5cc6216ae5$var$reViewBoxAttrValue);
    minX = -parseFloat(pasedViewBox[1]);
    minY = -parseFloat(pasedViewBox[2]);
    const viewBoxWidth = parseFloat(pasedViewBox[3]);
    const viewBoxHeight = parseFloat(pasedViewBox[4]);
    parsedDim.minX = minX;
    parsedDim.minY = minY;
    parsedDim.viewBoxWidth = viewBoxWidth;
    parsedDim.viewBoxHeight = viewBoxHeight;
    if (!missingDimAttr) {
        parsedDim.width = $ab3f2a5cc6216ae5$var$parseUnit(widthAttr);
        parsedDim.height = $ab3f2a5cc6216ae5$var$parseUnit(heightAttr);
        scaleX = parsedDim.width / viewBoxWidth;
        scaleY = parsedDim.height / viewBoxHeight;
    } else {
        parsedDim.width = viewBoxWidth;
        parsedDim.height = viewBoxHeight;
    }
    // default is to preserve aspect ratio
    const preserveAspectRatio = $ab3f2a5cc6216ae5$var$parsePreserveAspectRatioAttribute(element.getAttribute("preserveAspectRatio") || "");
    if (preserveAspectRatio.alignX !== $ab3f2a5cc6216ae5$var$NONE) {
        //translate all container for the effect of Mid, Min, Max
        if (preserveAspectRatio.meetOrSlice === "meet") scaleY = scaleX = scaleX > scaleY ? scaleY : scaleX;
        if (preserveAspectRatio.meetOrSlice === "slice") scaleY = scaleX = scaleX > scaleY ? scaleX : scaleY;
        widthDiff = parsedDim.width - viewBoxWidth * scaleX;
        heightDiff = parsedDim.height - viewBoxHeight * scaleX;
        if (preserveAspectRatio.alignX === "Mid") widthDiff /= 2;
        if (preserveAspectRatio.alignY === "Mid") heightDiff /= 2;
        if (preserveAspectRatio.alignX === "Min") widthDiff = 0;
        if (preserveAspectRatio.alignY === "Min") heightDiff = 0;
    }
    if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) return parsedDim;
    if ((x || y) && element.parentNode.nodeName !== "#document") translateMatrix = " translate(" + $ab3f2a5cc6216ae5$var$parseUnit(x || "0") + " " + $ab3f2a5cc6216ae5$var$parseUnit(y || "0") + ") ";
    matrix = translateMatrix + " matrix(" + scaleX + " 0" + " 0 " + scaleY + " " + (minX * scaleX + widthDiff) + " " + (minY * scaleY + heightDiff) + ") ";
    // seems unused.
    // parsedDim.viewboxTransform = parseTransformAttribute(matrix);
    if (element.nodeName === "svg") {
        el = element.ownerDocument.createElementNS($ab3f2a5cc6216ae5$var$svgNS, "g");
        // element.firstChild != null
        while(element.firstChild)el.appendChild(element.firstChild);
        element.appendChild(el);
    } else {
        el = element;
        el.removeAttribute("x");
        el.removeAttribute("y");
        matrix = el.getAttribute("transform") + matrix;
    }
    el.setAttribute("transform", matrix);
    return parsedDim;
}
const $ab3f2a5cc6216ae5$var$getTagName = (node)=>node.tagName.replace("svg:", "");
const $ab3f2a5cc6216ae5$var$svgInvalidAncestorsRegEx = $ab3f2a5cc6216ae5$var$getSvgRegex($ab3f2a5cc6216ae5$var$svgInvalidAncestors);
function $ab3f2a5cc6216ae5$var$hasInvalidAncestor(element) {
    let _element = element;
    while(_element && (_element = _element.parentElement)){
        if (_element && _element.nodeName && $ab3f2a5cc6216ae5$var$svgInvalidAncestorsRegEx.test($ab3f2a5cc6216ae5$var$getTagName(_element)) && !_element.getAttribute("instantiated_by_use")) return true;
    }
    return false;
}
function $ab3f2a5cc6216ae5$var$getMultipleNodes(doc, nodeNames) {
    let nodeName, nodeArray = [], nodeList, i, len;
    for(i = 0, len = nodeNames.length; i < len; i++){
        nodeName = nodeNames[i];
        nodeList = doc.getElementsByTagNameNS("http://www.w3.org/2000/svg", nodeName);
        nodeArray = nodeArray.concat(Array.from(nodeList));
    }
    return nodeArray;
}
function $ab3f2a5cc6216ae5$var$parseUseDirectives(doc) {
    const nodelist = $ab3f2a5cc6216ae5$var$getMultipleNodes(doc, [
        "use",
        "svg:use"
    ]);
    let i = 0;
    while(nodelist.length && i < nodelist.length){
        const el = nodelist[i], xlinkAttribute = el.getAttribute("xlink:href") || el.getAttribute("href");
        if (xlinkAttribute === null) return;
        const xlink = xlinkAttribute.slice(1);
        const x = el.getAttribute("x") || 0;
        const y = el.getAttribute("y") || 0;
        const el2Orig = doc.getElementById(xlink);
        if (el2Orig === null) // if we can't find the target of the xlink, consider this use tag bad, similar to no xlink
        return;
        let el2 = el2Orig.cloneNode(true);
        let currentTrans = (el2.getAttribute("transform") || "") + " translate(" + x + ", " + y + ")";
        const oldLength = nodelist.length;
        const namespace = $ab3f2a5cc6216ae5$var$svgNS;
        $ab3f2a5cc6216ae5$var$applyViewboxTransform(el2);
        if (/^svg$/i.test(el2.nodeName)) {
            const el3 = el2.ownerDocument.createElementNS(namespace, "g");
            for(let j = 0, attrs = el2.attributes, len = attrs.length; j < len; j++){
                const attr = attrs.item(j);
                attr && el3.setAttributeNS(namespace, attr.nodeName, attr.nodeValue);
            }
            // el2.firstChild != null
            while(el2.firstChild)el3.appendChild(el2.firstChild);
            el2 = el3;
        }
        for(let j = 0, attrs = el.attributes, len = attrs.length; j < len; j++){
            const attr = attrs.item(j);
            if (!attr) continue;
            const { nodeName: nodeName, nodeValue: nodeValue } = attr;
            if (nodeName === "x" || nodeName === "y" || nodeName === "xlink:href" || nodeName === "href") continue;
            if (nodeName === "transform") currentTrans = nodeValue + " " + currentTrans;
            else el2.setAttribute(nodeName, nodeValue);
        }
        el2.setAttribute("transform", currentTrans);
        el2.setAttribute("instantiated_by_use", "1");
        el2.removeAttribute("id");
        const parentNode = el.parentNode;
        parentNode.replaceChild(el2, el);
        // some browsers do not shorten nodelist after replaceChild (IE8)
        if (nodelist.length === oldLength) i++;
    }
}
const $ab3f2a5cc6216ae5$var$gradientsAttrs = [
    "gradientTransform",
    "x1",
    "x2",
    "y1",
    "y2",
    "gradientUnits",
    "cx",
    "cy",
    "r",
    "fx",
    "fy"
];
const $ab3f2a5cc6216ae5$var$xlinkAttr = "xlink:href";
function $ab3f2a5cc6216ae5$var$recursivelyParseGradientsXlink(doc, gradient) {
    var _gradient$getAttribut;
    const xLink = ((_gradient$getAttribut = gradient.getAttribute($ab3f2a5cc6216ae5$var$xlinkAttr)) === null || _gradient$getAttribut === void 0 ? void 0 : _gradient$getAttribut.slice(1)) || "", referencedGradient = doc.getElementById(xLink);
    if (referencedGradient && referencedGradient.getAttribute($ab3f2a5cc6216ae5$var$xlinkAttr)) $ab3f2a5cc6216ae5$var$recursivelyParseGradientsXlink(doc, referencedGradient);
    if (referencedGradient) {
        $ab3f2a5cc6216ae5$var$gradientsAttrs.forEach((attr)=>{
            const value = referencedGradient.getAttribute(attr);
            if (!gradient.hasAttribute(attr) && value) gradient.setAttribute(attr, value);
        });
        if (!gradient.children.length) {
            const referenceClone = referencedGradient.cloneNode(true);
            while(referenceClone.firstChild)gradient.appendChild(referenceClone.firstChild);
        }
    }
    gradient.removeAttribute($ab3f2a5cc6216ae5$var$xlinkAttr);
}
const $ab3f2a5cc6216ae5$var$tagArray = [
    "linearGradient",
    "radialGradient",
    "svg:linearGradient",
    "svg:radialGradient"
];
/**
 * Parses an SVG document, returning all of the gradient declarations found in it
 * @param {SVGDocument} doc SVG document to parse
 * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
 */ function $ab3f2a5cc6216ae5$var$getGradientDefs(doc) {
    const elList = $ab3f2a5cc6216ae5$var$getMultipleNodes(doc, $ab3f2a5cc6216ae5$var$tagArray);
    const gradientDefs = {};
    let j = elList.length;
    while(j--){
        const el = elList[j];
        if (el.getAttribute("xlink:href")) $ab3f2a5cc6216ae5$var$recursivelyParseGradientsXlink(doc, el);
        const id = el.getAttribute("id");
        if (id) gradientDefs[id] = el;
    }
    return gradientDefs;
}
/**
 * Returns CSS rules for a given SVG document
 * @param {HTMLElement} doc SVG document to parse
 * @return {Object} CSS rules of this document
 */ function $ab3f2a5cc6216ae5$export$4277ecee4fbb0012(doc) {
    const styles = doc.getElementsByTagName("style");
    let i;
    let len;
    const allRules = {};
    // very crude parsing of style contents
    for(i = 0, len = styles.length; i < len; i++){
        const styleContents = (styles[i].textContent || "").replace(// remove comments
        /\/\*[\s\S]*?\*\//g, "");
        if (styleContents.trim() === "") continue;
        // recovers all the rule in this form `body { style code... }`
        // rules = styleContents.match(/[^{]*\{[\s\S]*?\}/g);
        styleContents.split("}")// remove empty rules and remove everything if we didn't split in at least 2 pieces
        .filter((rule, index, array)=>array.length > 1 && rule.trim())// at this point we have hopefully an array of rules `body { style code... `
        .forEach((rule)=>{
            // if there is more than one opening bracket and the rule starts with '@', it is likely
            // a nested at-rule like @media, @supports, @scope, etc. Ignore these as the code below
            // can not handle it.
            if ((rule.match(/{/g) || []).length > 1 && rule.trim().startsWith("@")) return;
            const match = rule.split("{"), ruleObj = {}, declaration = match[1].trim(), propertyValuePairs = declaration.split(";").filter(function(pair) {
                return pair.trim();
            });
            for(i = 0, len = propertyValuePairs.length; i < len; i++){
                const pair = propertyValuePairs[i].split(":"), property = pair[0].trim(), value = pair[1].trim();
                ruleObj[property] = value;
            }
            rule = match[0].trim();
            rule.split(",").forEach((_rule)=>{
                _rule = _rule.replace(/^svg/i, "").trim();
                if (_rule === "") return;
                allRules[_rule] = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, allRules[_rule] || {}), ruleObj);
            });
        });
    }
    return allRules;
}
const $ab3f2a5cc6216ae5$var$findTag = (el)=>$ab3f2a5cc6216ae5$export$2792378e23a7920c.getSVGClass($ab3f2a5cc6216ae5$var$getTagName(el).toLowerCase());
class $ab3f2a5cc6216ae5$var$ElementsParser {
    constructor(elements, options, reviver, doc, clipPaths){
        this.elements = elements;
        this.options = options;
        this.reviver = reviver;
        this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
        this.doc = doc;
        this.clipPaths = clipPaths;
        this.gradientDefs = $ab3f2a5cc6216ae5$var$getGradientDefs(doc);
        this.cssRules = $ab3f2a5cc6216ae5$export$4277ecee4fbb0012(doc);
    }
    parse() {
        return Promise.all(this.elements.map((element)=>this.createObject(element)));
    }
    async createObject(el) {
        const klass = $ab3f2a5cc6216ae5$var$findTag(el);
        if (klass) {
            const obj = await klass.fromElement(el, this.options, this.cssRules);
            this.resolveGradient(obj, el, $ab3f2a5cc6216ae5$var$FILL);
            this.resolveGradient(obj, el, $ab3f2a5cc6216ae5$var$STROKE);
            if (obj instanceof $ab3f2a5cc6216ae5$export$3148ec5c6497ddc8 && obj._originalElement) $ab3f2a5cc6216ae5$var$removeTransformMatrixForSvgParsing(obj, obj.parsePreserveAspectRatioAttribute());
            else $ab3f2a5cc6216ae5$var$removeTransformMatrixForSvgParsing(obj);
            await this.resolveClipPath(obj, el);
            this.reviver && this.reviver(el, obj);
            return obj;
        }
        return null;
    }
    extractPropertyDefinition(obj, property, storage) {
        const value = obj[property], regex = this.regexUrl;
        if (!regex.test(value)) return undefined;
        // verify: can we remove the 'g' flag? and remove lastIndex changes?
        regex.lastIndex = 0;
        // we passed the regex test, so we know is not null;
        const id = regex.exec(value)[1];
        regex.lastIndex = 0;
        // @todo fix this
        return storage[id];
    }
    resolveGradient(obj, el, property) {
        const gradientDef = this.extractPropertyDefinition(obj, property, this.gradientDefs);
        if (gradientDef) {
            const opacityAttr = el.getAttribute(property + "-opacity");
            const gradient = $ab3f2a5cc6216ae5$export$3d3dd8f63ff0f876.fromElement(gradientDef, obj, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, this.options), {}, {
                opacity: opacityAttr
            }));
            obj.set(property, gradient);
        }
    }
    // TODO: resolveClipPath could be run once per clippath with minor work per object.
    // is a refactor that i m not sure is worth on this code
    async resolveClipPath(obj, usingElement) {
        const clipPathElements = this.extractPropertyDefinition(obj, "clipPath", this.clipPaths);
        if (clipPathElements) {
            const objTransformInv = $ab3f2a5cc6216ae5$var$invertTransform(obj.calcTransformMatrix());
            const clipPathTag = clipPathElements[0].parentElement;
            let clipPathOwner = usingElement;
            while(clipPathOwner.parentElement && clipPathOwner.getAttribute("clip-path") !== obj.clipPath)clipPathOwner = clipPathOwner.parentElement;
            // move the clipPath tag as sibling to the real element that is using it
            clipPathOwner.parentElement.appendChild(clipPathTag);
            // this multiplication order could be opposite.
            // but i don't have an svg to test it
            // at the first SVG that has a transform on both places and is misplaced
            // try to invert this multiplication order
            const finalTransform = $ab3f2a5cc6216ae5$export$6655c0d22b13de1f("".concat(clipPathOwner.getAttribute("transform") || "", " ").concat(clipPathTag.getAttribute("originalTransform") || ""));
            clipPathTag.setAttribute("transform", "matrix(".concat(finalTransform.join(","), ")"));
            const container = await Promise.all(clipPathElements.map((clipPathElement)=>{
                return $ab3f2a5cc6216ae5$var$findTag(clipPathElement).fromElement(clipPathElement, this.options, this.cssRules).then((enlivedClippath)=>{
                    $ab3f2a5cc6216ae5$var$removeTransformMatrixForSvgParsing(enlivedClippath);
                    enlivedClippath.fillRule = enlivedClippath.clipRule;
                    delete enlivedClippath.clipRule;
                    return enlivedClippath;
                });
            }));
            const clipPath = container.length === 1 ? container[0] : new $ab3f2a5cc6216ae5$export$eb2fcfdbd7ba97d4(container);
            const gTransform = $ab3f2a5cc6216ae5$var$multiplyTransformMatrices(objTransformInv, clipPath.calcTransformMatrix());
            if (clipPath.clipPath) await this.resolveClipPath(clipPath, clipPathOwner);
            const { scaleX: scaleX, scaleY: scaleY, angle: angle, skewX: skewX, translateX: translateX, translateY: translateY } = $ab3f2a5cc6216ae5$var$qrDecompose(gTransform);
            clipPath.set({
                flipX: false,
                flipY: false
            });
            clipPath.set({
                scaleX: scaleX,
                scaleY: scaleY,
                angle: angle,
                skewX: skewX,
                skewY: 0
            });
            clipPath.setPositionByOrigin(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(translateX, translateY), $ab3f2a5cc6216ae5$var$CENTER, $ab3f2a5cc6216ae5$var$CENTER);
            obj.clipPath = clipPath;
        } else {
            // if clip-path does not resolve to any element, delete the property.
            delete obj.clipPath;
            return;
        }
    }
}
const $ab3f2a5cc6216ae5$var$isValidSvgTag = (el)=>$ab3f2a5cc6216ae5$var$svgValidTagNamesRegEx.test($ab3f2a5cc6216ae5$var$getTagName(el));
const $ab3f2a5cc6216ae5$var$createEmptyResponse = ()=>({
        objects: [],
        elements: [],
        options: {},
        allElements: []
    });
/**
 * Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
 * @static
 * @function
 * @memberOf fabric
 * @param {HTMLElement} doc SVG document to parse
 * @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
 * @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
 * Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
 * or extra custom manipulation
 * @param {Object} [options] Object containing options for parsing
 * @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 * @return {SVGParsingOutput}
 * {@link SVGParsingOutput} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
 * You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
 */ async function $ab3f2a5cc6216ae5$export$7489c3bacab04ae5(doc, reviver) {
    let { crossOrigin: crossOrigin, signal: signal } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (signal && signal.aborted) {
        $ab3f2a5cc6216ae5$var$log("log", new $ab3f2a5cc6216ae5$var$SignalAbortedError("parseSVGDocument"));
        // this is an unhappy path, we dont care about speed
        return $ab3f2a5cc6216ae5$var$createEmptyResponse();
    }
    const documentElement = doc.documentElement;
    $ab3f2a5cc6216ae5$var$parseUseDirectives(doc);
    const descendants = Array.from(documentElement.getElementsByTagName("*")), options = $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$var$applyViewboxTransform(documentElement)), {}, {
        crossOrigin: crossOrigin,
        signal: signal
    });
    const elements = descendants.filter((el)=>{
        $ab3f2a5cc6216ae5$var$applyViewboxTransform(el);
        return $ab3f2a5cc6216ae5$var$isValidSvgTag(el) && !$ab3f2a5cc6216ae5$var$hasInvalidAncestor(el); // http://www.w3.org/TR/SVG/struct.html#DefsElement
    });
    if (!elements || elements && !elements.length) return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, $ab3f2a5cc6216ae5$var$createEmptyResponse()), {}, {
        options: options,
        allElements: descendants
    });
    const localClipPaths = {};
    descendants.filter((el)=>$ab3f2a5cc6216ae5$var$getTagName(el) === "clipPath").forEach((el)=>{
        el.setAttribute("originalTransform", el.getAttribute("transform") || "");
        const id = el.getAttribute("id");
        localClipPaths[id] = Array.from(el.getElementsByTagName("*")).filter((el)=>$ab3f2a5cc6216ae5$var$isValidSvgTag(el));
    });
    // Precedence of rules:   style > class > attribute
    const elementParser = new $ab3f2a5cc6216ae5$var$ElementsParser(elements, options, reviver, doc, localClipPaths);
    const instances = await elementParser.parse();
    return {
        objects: instances,
        elements: elements,
        options: options,
        allElements: descendants
    };
}
/**
 * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
 * @memberOf fabric
 * @param {String} string representing the svg
 * @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
 * {@link TSvgParsedCallback} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
 * You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
 * @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
 * Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
 * or extra custom manipulation
 * @param {Object} [options] Object containing options for parsing
 * @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 */ function $ab3f2a5cc6216ae5$export$a0c5917fb6a8d612(string, reviver, options) {
    const parser = new ($ab3f2a5cc6216ae5$export$4a3a3142573970c3()).DOMParser(), // should we use `image/svg+xml` here?
    doc = parser.parseFromString(string.trim(), "text/xml");
    return $ab3f2a5cc6216ae5$export$7489c3bacab04ae5(doc, reviver, options);
}
/**
 * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
 * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
 * @memberOf fabric
 * @param {string} url where the SVG is
 * @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
 * {@link TSvgParsedCallback} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
 * You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
 * @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
 * Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
 * or extra custom manipulation
 * @param {Object} [options] Object containing options for parsing
 * @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 */ function $ab3f2a5cc6216ae5$export$2b20e5519a374(url, reviver) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // need to handle error properly
    return new Promise((resolve, reject)=>{
        const onComplete = (r)=>{
            const xml = r.responseXML;
            if (xml) resolve(xml);
            reject();
        };
        $ab3f2a5cc6216ae5$var$request(url.replace(/^\n\s*/, "").trim(), {
            onComplete: onComplete,
            signal: options.signal
        });
    }).then((parsedDoc)=>$ab3f2a5cc6216ae5$export$7489c3bacab04ae5(parsedDoc, reviver, options)).catch(()=>{
        // this is an unhappy path, we dont care about speed
        return $ab3f2a5cc6216ae5$var$createEmptyResponse();
    });
}
const $ab3f2a5cc6216ae5$var$ACTION_NAME = $ab3f2a5cc6216ae5$var$MODIFY_POLY;
/**
 * This function locates the controls.
 * It'll be used both for drawing and for interaction.
 */ const $ab3f2a5cc6216ae5$var$createPolyPositionHandler = (pointIndex)=>{
    return function(dim, finalMatrix, polyObject) {
        const { points: points, pathOffset: pathOffset } = polyObject;
        return new $ab3f2a5cc6216ae5$export$baf26146a414f24a(points[pointIndex]).subtract(pathOffset).transform($ab3f2a5cc6216ae5$var$multiplyTransformMatrices(polyObject.getViewportTransform(), polyObject.calcTransformMatrix()));
    };
};
/**
 * This function defines what the control does.
 * It'll be called on every mouse move after a control has been clicked and is being dragged.
 * The function receives as argument the mouse event, the current transform object
 * and the current position in canvas coordinate `transform.target` is a reference to the
 * current object being transformed.
 */ const $ab3f2a5cc6216ae5$var$polyActionHandler = (eventData, transform, x, y)=>{
    const { target: target, pointIndex: pointIndex } = transform;
    const poly = target;
    const mouseLocalPosition = $ab3f2a5cc6216ae5$var$sendPointToPlane(new $ab3f2a5cc6216ae5$export$baf26146a414f24a(x, y), undefined, poly.calcOwnMatrix());
    poly.points[pointIndex] = mouseLocalPosition.add(poly.pathOffset);
    poly.setDimensions();
    return true;
};
/**
 * Keep the polygon in the same position when we change its `width`/`height`/`top`/`left`.
 */ const $ab3f2a5cc6216ae5$var$factoryPolyActionHandler = (pointIndex, fn)=>{
    return function(eventData, transform, x, y) {
        const poly = transform.target, anchorPoint = new $ab3f2a5cc6216ae5$export$baf26146a414f24a(poly.points[(pointIndex > 0 ? pointIndex : poly.points.length) - 1]), anchorPointInParentPlane = anchorPoint.subtract(poly.pathOffset).transform(poly.calcOwnMatrix()), actionPerformed = fn(eventData, $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, transform), {}, {
            pointIndex: pointIndex
        }), x, y);
        const newAnchorPointInParentPlane = anchorPoint.subtract(poly.pathOffset).transform(poly.calcOwnMatrix());
        const diff = newAnchorPointInParentPlane.subtract(anchorPointInParentPlane);
        poly.left -= diff.x;
        poly.top -= diff.y;
        return actionPerformed;
    };
};
const $ab3f2a5cc6216ae5$var$createPolyActionHandler = (pointIndex)=>$ab3f2a5cc6216ae5$var$wrapWithFireEvent($ab3f2a5cc6216ae5$var$ACTION_NAME, $ab3f2a5cc6216ae5$var$factoryPolyActionHandler(pointIndex, $ab3f2a5cc6216ae5$var$polyActionHandler));
function $ab3f2a5cc6216ae5$var$createPolyControls(arg0) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const controls = {};
    for(let idx = 0; idx < (typeof arg0 === "number" ? arg0 : arg0.points.length); idx++)controls["p".concat(idx)] = new $ab3f2a5cc6216ae5$export$7a7fa4424cb20976($ab3f2a5cc6216ae5$var$_objectSpread2({
        actionName: $ab3f2a5cc6216ae5$var$ACTION_NAME,
        positionHandler: $ab3f2a5cc6216ae5$var$createPolyPositionHandler(idx),
        actionHandler: $ab3f2a5cc6216ae5$var$createPolyActionHandler(idx)
    }, options));
    return controls;
}
var $ab3f2a5cc6216ae5$export$d13a0d9b79355c3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    changeWidth: $ab3f2a5cc6216ae5$var$changeWidth,
    createObjectDefaultControls: $ab3f2a5cc6216ae5$var$createObjectDefaultControls,
    createPolyActionHandler: $ab3f2a5cc6216ae5$var$createPolyActionHandler,
    createPolyControls: $ab3f2a5cc6216ae5$var$createPolyControls,
    createPolyPositionHandler: $ab3f2a5cc6216ae5$var$createPolyPositionHandler,
    createResizeControls: $ab3f2a5cc6216ae5$var$createResizeControls,
    createTextboxDefaultControls: $ab3f2a5cc6216ae5$var$createTextboxDefaultControls,
    dragHandler: $ab3f2a5cc6216ae5$var$dragHandler,
    factoryPolyActionHandler: $ab3f2a5cc6216ae5$var$factoryPolyActionHandler,
    getLocalPoint: $ab3f2a5cc6216ae5$var$getLocalPoint,
    polyActionHandler: $ab3f2a5cc6216ae5$var$polyActionHandler,
    renderCircleControl: $ab3f2a5cc6216ae5$var$renderCircleControl,
    renderSquareControl: $ab3f2a5cc6216ae5$var$renderSquareControl,
    rotationStyleHandler: $ab3f2a5cc6216ae5$var$rotationStyleHandler,
    rotationWithSnapping: $ab3f2a5cc6216ae5$var$rotationWithSnapping,
    scaleCursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleCursorStyleHandler,
    scaleOrSkewActionName: $ab3f2a5cc6216ae5$var$scaleOrSkewActionName,
    scaleSkewCursorStyleHandler: $ab3f2a5cc6216ae5$var$scaleSkewCursorStyleHandler,
    scalingEqually: $ab3f2a5cc6216ae5$var$scalingEqually,
    scalingX: $ab3f2a5cc6216ae5$var$scalingX,
    scalingXOrSkewingY: $ab3f2a5cc6216ae5$var$scalingXOrSkewingY,
    scalingY: $ab3f2a5cc6216ae5$var$scalingY,
    scalingYOrSkewingX: $ab3f2a5cc6216ae5$var$scalingYOrSkewingX,
    skewCursorStyleHandler: $ab3f2a5cc6216ae5$var$skewCursorStyleHandler,
    skewHandlerX: $ab3f2a5cc6216ae5$var$skewHandlerX,
    skewHandlerY: $ab3f2a5cc6216ae5$var$skewHandlerY,
    wrapWithFireEvent: $ab3f2a5cc6216ae5$var$wrapWithFireEvent,
    wrapWithFixedAnchor: $ab3f2a5cc6216ae5$var$wrapWithFixedAnchor
});
const $ab3f2a5cc6216ae5$export$ec9091584da1706b = (options)=>{
    return options.webgl !== undefined;
};
/**
 * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
 * drawImage should be faster, but is also bugged for a small combination of old hardware
 * and drivers.
 * putImageData is faster than drawImage for that specific operation.
 */ const $ab3f2a5cc6216ae5$export$be5e33ed1f656bf4 = (width, height)=>{
    const targetCanvas = $ab3f2a5cc6216ae5$var$createCanvasElement();
    const sourceCanvas = $ab3f2a5cc6216ae5$var$createCanvasElement();
    const gl = sourceCanvas.getContext("webgl");
    // eslint-disable-next-line no-undef
    const imageBuffer = new ArrayBuffer(width * height * 4);
    const testContext = {
        imageBuffer: imageBuffer
    };
    const testPipelineState = {
        destinationWidth: width,
        destinationHeight: height,
        targetCanvas: targetCanvas
    };
    let startTime;
    targetCanvas.width = width;
    targetCanvas.height = height;
    startTime = $ab3f2a5cc6216ae5$export$4a3a3142573970c3().performance.now();
    $ab3f2a5cc6216ae5$export$42da2a27efef173b.prototype.copyGLTo2D.call(testContext, gl, testPipelineState);
    const drawImageTime = $ab3f2a5cc6216ae5$export$4a3a3142573970c3().performance.now() - startTime;
    startTime = $ab3f2a5cc6216ae5$export$4a3a3142573970c3().performance.now();
    $ab3f2a5cc6216ae5$export$42da2a27efef173b.prototype.copyGLTo2DPutImageData.call(testContext, gl, testPipelineState);
    const putImageDataTime = $ab3f2a5cc6216ae5$export$4a3a3142573970c3().performance.now() - startTime;
    return drawImageTime > putImageDataTime;
};
const $ab3f2a5cc6216ae5$var$highPsourceCode = "precision highp float";
const $ab3f2a5cc6216ae5$var$identityFragmentShader = "\n    ".concat($ab3f2a5cc6216ae5$var$highPsourceCode, ";\n    varying vec2 vTexCoord;\n    uniform sampler2D uTexture;\n    void main() {\n      gl_FragColor = texture2D(uTexture, vTexCoord);\n    }");
const $ab3f2a5cc6216ae5$var$vertexSource$1 = "\n    attribute vec2 aPosition;\n    varying vec2 vTexCoord;\n    void main() {\n      vTexCoord = aPosition;\n      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n    }";
const $ab3f2a5cc6216ae5$var$_excluded$1 = [
    "type"
], $ab3f2a5cc6216ae5$var$_excluded2 = [
    "type"
];
const $ab3f2a5cc6216ae5$var$regex = new RegExp($ab3f2a5cc6216ae5$var$highPsourceCode, "g");
class $ab3f2a5cc6216ae5$var$BaseFilter {
    /**
   * Filter type
   * @param {String} type
   * @default
   */ get type() {
        return this.constructor.type;
    }
    /**
   * The class type. Used to identify which class this is.
   * This is used for serialization purposes and internally it can be used
   * to identify classes. As a developer you could use `instance of Class`
   * but to avoid importing all the code and blocking tree shaking we try
   * to avoid doing that.
   */ /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(){
        let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, options = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref, $ab3f2a5cc6216ae5$var$_excluded$1);
        Object.assign(this, this.constructor.defaults, options);
    }
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$identityFragmentShader;
    }
    getVertexSource() {
        return $ab3f2a5cc6216ae5$var$vertexSource$1;
    }
    /**
   * Compile this filter's shader program.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
   * @param {String} fragmentSource fragmentShader source for compilation
   * @param {String} vertexSource vertexShader source for compilation
   */ createProgram(gl) {
        let fragmentSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getFragmentSource();
        let vertexSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.getVertexSource();
        const { WebGLProbe: { GLPrecision: GLPrecision = "highp" } } = $ab3f2a5cc6216ae5$export$4bd44a2aa29d3d6e();
        if (GLPrecision !== "highp") fragmentSource = fragmentSource.replace($ab3f2a5cc6216ae5$var$regex, $ab3f2a5cc6216ae5$var$highPsourceCode.replace("highp", GLPrecision));
        const vertexShader = gl.createShader(gl.VERTEX_SHADER);
        const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        const program = gl.createProgram();
        if (!vertexShader || !fragmentShader || !program) throw new $ab3f2a5cc6216ae5$var$FabricError("Vertex, fragment shader or program creation error");
        gl.shaderSource(vertexShader, vertexSource);
        gl.compileShader(vertexShader);
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) throw new $ab3f2a5cc6216ae5$var$FabricError("Vertex shader compile error for ".concat(this.type, ": ").concat(gl.getShaderInfoLog(vertexShader)));
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) throw new $ab3f2a5cc6216ae5$var$FabricError("Fragment shader compile error for ".concat(this.type, ": ").concat(gl.getShaderInfoLog(fragmentShader)));
        gl.attachShader(program, vertexShader);
        gl.attachShader(program, fragmentShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new $ab3f2a5cc6216ae5$var$FabricError('Shader link error for "'.concat(this.type, '" ').concat(gl.getProgramInfoLog(program)));
        const uniformLocations = this.getUniformLocations(gl, program) || {};
        uniformLocations.uStepW = gl.getUniformLocation(program, "uStepW");
        uniformLocations.uStepH = gl.getUniformLocation(program, "uStepH");
        return {
            program: program,
            attributeLocations: this.getAttributeLocations(gl, program),
            uniformLocations: uniformLocations
        };
    }
    /**
   * Return a map of attribute names to WebGLAttributeLocation objects.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
   * @returns {Object} A map of attribute names to attribute locations.
   */ getAttributeLocations(gl, program) {
        return {
            aPosition: gl.getAttribLocation(program, "aPosition")
        };
    }
    /**
   * Return a map of uniform names to WebGLUniformLocation objects.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
   * @returns {Object} A map of uniform names to uniform locations.
   */ getUniformLocations(gl, program) {
        const locations = this.constructor.uniformLocations;
        const uniformLocations = {};
        for(let i = 0; i < locations.length; i++)uniformLocations[locations[i]] = gl.getUniformLocation(program, locations[i]);
        return uniformLocations;
    }
    /**
   * Send attribute data from this filter to its shader program on the GPU.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} attributeLocations A map of shader attribute names to their locations.
   */ sendAttributeData(gl, attributeLocations, aPositionData) {
        const attributeLocation = attributeLocations.aPosition;
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.enableVertexAttribArray(attributeLocation);
        gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
        gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
    }
    _setupFrameBuffer(options) {
        const gl = options.context;
        if (options.passes > 1) {
            const width = options.destinationWidth;
            const height = options.destinationHeight;
            if (options.sourceWidth !== width || options.sourceHeight !== height) {
                gl.deleteTexture(options.targetTexture);
                options.targetTexture = options.filterBackend.createTexture(gl, width, height);
            }
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, options.targetTexture, 0);
        } else {
            // draw last filter on canvas and not to framebuffer.
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            gl.finish();
        }
    }
    _swapTextures(options) {
        options.passes--;
        options.pass++;
        const temp = options.targetTexture;
        options.targetTexture = options.sourceTexture;
        options.sourceTexture = temp;
    }
    /**
   * Generic isNeutral implementation for one parameter based filters.
   * Used only in image applyFilters to discard filters that will not have an effect
   * on the image
   * Other filters may need their own version ( ColorMatrix, HueRotation, gamma, ComposedFilter )
   * @param {Object} options
   **/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isNeutralState(options) {
        return false;
    }
    /**
   * Apply this filter to the input image data provided.
   *
   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ applyTo(options) {
        if ($ab3f2a5cc6216ae5$export$ec9091584da1706b(options)) {
            this._setupFrameBuffer(options);
            this.applyToWebGL(options);
            this._swapTextures(options);
        } else this.applyTo2d(options);
    }
    applyTo2d(options) {
    // override by subclass
    }
    /**
   * Returns a string that represent the current selected shader code for the filter.
   * Used to force recompilation when parameters change or to retrieve the shader from cache
   * @type string
   **/ getCacheKey() {
        return this.type;
    }
    /**
   * Retrieves the cached shader.
   * @param {Object} options
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   * @return {WebGLProgram} the compiled program shader
   */ retrieveShader(options) {
        const key = this.getCacheKey();
        if (!options.programCache[key]) options.programCache[key] = this.createProgram(options.context);
        return options.programCache[key];
    }
    /**
   * Apply this filter using webgl.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.originalTexture The texture of the original input image.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ applyToWebGL(options) {
        const gl = options.context;
        const shader = this.retrieveShader(options);
        if (options.pass === 0 && options.originalTexture) gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
        else gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
        gl.useProgram(shader.program);
        this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);
        gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
        gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);
        this.sendUniformData(gl, shader.uniformLocations);
        gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    bindAdditionalTexture(gl, texture, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        // reset active texture to 0 as usual
        gl.activeTexture(gl.TEXTURE0);
    }
    unbindAdditionalTexture(gl, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.activeTexture(gl.TEXTURE0);
    }
    /**
   * Send uniform data from this filter to its shader program on the GPU.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} uniformLocations A map of shader uniform names to their locations.
   */ sendUniformData(gl, uniformLocations) {
    // override by subclass
    }
    /**
   * If needed by a 2d filter, this functions can create an helper canvas to be used
   * remember that options.targetCanvas is available for use till end of chain.
   */ createHelpLayer(options) {
        if (!options.helpLayer) {
            const helpLayer = $ab3f2a5cc6216ae5$var$createCanvasElement();
            helpLayer.width = options.sourceWidth;
            helpLayer.height = options.sourceHeight;
            options.helpLayer = helpLayer;
        }
    }
    /**
   * Returns object representation of an instance
   * @return {Object} Object representation of an instance
   */ toObject() {
        const defaultKeys = Object.keys(this.constructor.defaults);
        return $ab3f2a5cc6216ae5$var$_objectSpread2({
            type: this.type
        }, defaultKeys.reduce((acc, key)=>{
            //@ts-expect-error TS doesn't get i want an object that looks like this
            acc[key] = this[key];
            return acc;
        }, {}));
    }
    /**
   * Returns a JSON representation of an instance
   * @return {Object} JSON
   */ toJSON() {
        // delegate, not alias
        return this.toObject();
    }
    static async fromObject(_ref2, options) {
        let filterOptions = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref2, $ab3f2a5cc6216ae5$var$_excluded2);
        return new this(filterOptions);
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$BaseFilter, "type", "BaseFilter");
/**
 * Contains the uniform locations for the fragment shader.
 * uStepW and uStepH are handled by the BaseFilter, each filter class
 * needs to specify all the one that are needed
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$BaseFilter, "uniformLocations", []);
const $ab3f2a5cc6216ae5$var$blendColorFragmentSource = {
    multiply: "gl_FragColor.rgb *= uColor.rgb;\n",
    screen: "gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n",
    add: "gl_FragColor.rgb += uColor.rgb;\n",
    difference: "gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n",
    subtract: "gl_FragColor.rgb -= uColor.rgb;\n",
    lighten: "gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n",
    darken: "gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n",
    exclusion: "gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n",
    overlay: "\n    if (uColor.r < 0.5) {\n      gl_FragColor.r *= 2.0 * uColor.r;\n    } else {\n      gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n    }\n    if (uColor.g < 0.5) {\n      gl_FragColor.g *= 2.0 * uColor.g;\n    } else {\n      gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n    }\n    if (uColor.b < 0.5) {\n      gl_FragColor.b *= 2.0 * uColor.b;\n    } else {\n      gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n    }\n    ",
    tint: "\n    gl_FragColor.rgb *= (1.0 - uColor.a);\n    gl_FragColor.rgb += uColor.rgb;\n    "
};
const $ab3f2a5cc6216ae5$var$blendColorDefaultValues = {
    color: "#F95C63",
    mode: "multiply",
    alpha: 1
};
/**
 * Color Blend filter class
 * @example
 * const filter = new BlendColor({
 *  color: '#000',
 *  mode: 'multiply'
 * });
 *
 * const filter = new BlendImage({
 *  image: fabricImageObject,
 *  mode: 'multiply'
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $ab3f2a5cc6216ae5$var$BlendColor extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getCacheKey() {
        return "".concat(this.type, "_").concat(this.mode);
    }
    getFragmentSource() {
        return "\n      precision highp float;\n      uniform sampler2D uTexture;\n      uniform vec4 uColor;\n      varying vec2 vTexCoord;\n      void main() {\n        vec4 color = texture2D(uTexture, vTexCoord);\n        gl_FragColor = color;\n        if (color.a > 0.0) {\n          ".concat($ab3f2a5cc6216ae5$var$blendColorFragmentSource[this.mode], "\n        }\n      }\n      ");
    }
    /**
   * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const source = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(this.color).getSource();
        const tr = source[0] * this.alpha;
        const tg = source[1] * this.alpha;
        const tb = source[2] * this.alpha;
        const alpha1 = 1 - this.alpha;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            switch(this.mode){
                case "multiply":
                    data[i] = r * tr / 255;
                    data[i + 1] = g * tg / 255;
                    data[i + 2] = b * tb / 255;
                    break;
                case "screen":
                    data[i] = 255 - (255 - r) * (255 - tr) / 255;
                    data[i + 1] = 255 - (255 - g) * (255 - tg) / 255;
                    data[i + 2] = 255 - (255 - b) * (255 - tb) / 255;
                    break;
                case "add":
                    data[i] = r + tr;
                    data[i + 1] = g + tg;
                    data[i + 2] = b + tb;
                    break;
                case "difference":
                    data[i] = Math.abs(r - tr);
                    data[i + 1] = Math.abs(g - tg);
                    data[i + 2] = Math.abs(b - tb);
                    break;
                case "subtract":
                    data[i] = r - tr;
                    data[i + 1] = g - tg;
                    data[i + 2] = b - tb;
                    break;
                case "darken":
                    data[i] = Math.min(r, tr);
                    data[i + 1] = Math.min(g, tg);
                    data[i + 2] = Math.min(b, tb);
                    break;
                case "lighten":
                    data[i] = Math.max(r, tr);
                    data[i + 1] = Math.max(g, tg);
                    data[i + 2] = Math.max(b, tb);
                    break;
                case "overlay":
                    data[i] = tr < 128 ? 2 * r * tr / 255 : 255 - 2 * (255 - r) * (255 - tr) / 255;
                    data[i + 1] = tg < 128 ? 2 * g * tg / 255 : 255 - 2 * (255 - g) * (255 - tg) / 255;
                    data[i + 2] = tb < 128 ? 2 * b * tb / 255 : 255 - 2 * (255 - b) * (255 - tb) / 255;
                    break;
                case "exclusion":
                    data[i] = tr + r - 2 * tr * r / 255;
                    data[i + 1] = tg + g - 2 * tg * g / 255;
                    data[i + 2] = tb + b - 2 * tb * b / 255;
                    break;
                case "tint":
                    data[i] = tr + r * alpha1;
                    data[i + 1] = tg + g * alpha1;
                    data[i + 2] = tb + b * alpha1;
            }
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const source = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(this.color).getSource();
        source[0] = this.alpha * source[0] / 255;
        source[1] = this.alpha * source[1] / 255;
        source[2] = this.alpha * source[2] / 255;
        source[3] = this.alpha;
        gl.uniform4fv(uniformLocations.uColor, source);
    }
}
/**
 * Color to make the blend operation with. default to a reddish color since black or white
 * gives always strong result.
 * @type String
 * @default
 **/ /**
 * Blend mode for the filter: one of multiply, add, difference, screen, subtract,
 * darken, lighten, overlay, exclusion, tint.
 * @type String
 * @default
 **/ /**
 * alpha value. represent the strength of the blend color operation.
 * @type Number
 * @default
 **/ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$BlendColor, "defaults", $ab3f2a5cc6216ae5$var$blendColorDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$BlendColor, "type", "BlendColor");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$BlendColor, "uniformLocations", [
    "uColor"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$BlendColor);
const $ab3f2a5cc6216ae5$var$fragmentSource$c = {
    multiply: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform sampler2D uImage;\n    uniform vec4 uColor;\n    varying vec2 vTexCoord;\n    varying vec2 vTexCoord2;\n    void main() {\n      vec4 color = texture2D(uTexture, vTexCoord);\n      vec4 color2 = texture2D(uImage, vTexCoord2);\n      color.rgba *= color2.rgba;\n      gl_FragColor = color;\n    }\n    ",
    mask: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform sampler2D uImage;\n    uniform vec4 uColor;\n    varying vec2 vTexCoord;\n    varying vec2 vTexCoord2;\n    void main() {\n      vec4 color = texture2D(uTexture, vTexCoord);\n      vec4 color2 = texture2D(uImage, vTexCoord2);\n      color.a = color2.a;\n      gl_FragColor = color;\n    }\n    "
};
const $ab3f2a5cc6216ae5$var$vertexSource = "\n    attribute vec2 aPosition;\n    varying vec2 vTexCoord;\n    varying vec2 vTexCoord2;\n    uniform mat3 uTransformMatrix;\n    void main() {\n      vTexCoord = aPosition;\n      vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\n      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n    }\n    ";
const $ab3f2a5cc6216ae5$var$_excluded = [
    "type",
    "image"
];
const $ab3f2a5cc6216ae5$var$blendImageDefaultValues = {
    mode: "multiply",
    alpha: 1
};
/**
 * Image Blend filter class
 * @example
 * const filter = new filters.BlendColor({
 *  color: '#000',
 *  mode: 'multiply'
 * });
 *
 * const filter = new BlendImage({
 *  image: fabricImageObject,
 *  mode: 'multiply'
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $ab3f2a5cc6216ae5$var$BlendImage extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getCacheKey() {
        return "".concat(this.type, "_").concat(this.mode);
    }
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$c[this.mode];
    }
    getVertexSource() {
        return $ab3f2a5cc6216ae5$var$vertexSource;
    }
    applyToWebGL(options) {
        const gl = options.context, texture = this.createTexture(options.filterBackend, this.image);
        this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
        super.applyToWebGL(options);
        this.unbindAdditionalTexture(gl, gl.TEXTURE1);
    }
    createTexture(backend, image) {
        return backend.getCachedTexture(image.cacheKey, image.getElement());
    }
    /**
   * Calculate a transformMatrix to adapt the image to blend over
   * @param {Object} options
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ calculateMatrix() {
        const image = this.image, { width: width, height: height } = image.getElement();
        return [
            1 / image.scaleX,
            0,
            0,
            0,
            1 / image.scaleY,
            0,
            -image.left / width,
            -image.top / height,
            1
        ];
    }
    /**
   * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data, width: width, height: height }, filterBackend: { resources: resources } } = _ref;
        const image = this.image;
        if (!resources.blendImage) resources.blendImage = $ab3f2a5cc6216ae5$var$createCanvasElement();
        const canvas1 = resources.blendImage;
        const context = canvas1.getContext("2d");
        if (canvas1.width !== width || canvas1.height !== height) {
            canvas1.width = width;
            canvas1.height = height;
        } else context.clearRect(0, 0, width, height);
        context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
        context.drawImage(image.getElement(), 0, 0, width, height);
        const blendData = context.getImageData(0, 0, width, height).data;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];
            const tr = blendData[i];
            const tg = blendData[i + 1];
            const tb = blendData[i + 2];
            const ta = blendData[i + 3];
            switch(this.mode){
                case "multiply":
                    data[i] = r * tr / 255;
                    data[i + 1] = g * tg / 255;
                    data[i + 2] = b * tb / 255;
                    data[i + 3] = a * ta / 255;
                    break;
                case "mask":
                    data[i + 3] = ta;
                    break;
            }
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const matrix = this.calculateMatrix();
        gl.uniform1i(uniformLocations.uImage, 1); // texture unit 1.
        gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
    }
    /**
   * Returns object representation of an instance
   * TODO: Handle the possibility of missing image better.
   * As of now a BlendImage filter without image can't be used with fromObject
   * @return {Object} Object representation of an instance
   */ toObject() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.toObject()), {}, {
            image: this.image && this.image.toObject()
        });
    }
    /**
   * Create filter instance from an object representation
   * @static
   * @param {object} object Object to create an instance from
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] handle aborting image loading, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<BlendImage>}
   */ static async fromObject(_ref2, options) {
        let { type: type, image: image } = _ref2, filterOptions = $ab3f2a5cc6216ae5$var$_objectWithoutProperties(_ref2, $ab3f2a5cc6216ae5$var$_excluded);
        return $ab3f2a5cc6216ae5$export$3148ec5c6497ddc8.fromObject(image, options).then((enlivedImage)=>new this($ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, filterOptions), {}, {
                image: enlivedImage
            })));
    }
}
/**
 * Image to make the blend operation with.
 **/ /**
 * Blend mode for the filter: either 'multiply' or 'mask'. 'multiply' will
 * multiply the values of each channel (R, G, B, and A) of the filter image by
 * their corresponding values in the base image. 'mask' will only look at the
 * alpha channel of the filter image, and apply those values to the base
 * image's alpha channel.
 * @type String
 * @default
 **/ /**
 * alpha value. represent the strength of the blend image operation.
 * not implemented.
 **/ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$BlendImage, "type", "BlendImage");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$BlendImage, "defaults", $ab3f2a5cc6216ae5$var$blendImageDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$BlendImage, "uniformLocations", [
    "uTransformMatrix",
    "uImage"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$BlendImage);
const $ab3f2a5cc6216ae5$var$fragmentSource$b = "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform vec2 uDelta;\n    varying vec2 vTexCoord;\n    const float nSamples = 15.0;\n    vec3 v3offset = vec3(12.9898, 78.233, 151.7182);\n    float random(vec3 scale) {\n      /* use the fragment position for a different seed per-pixel */\n      return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n    }\n    void main() {\n      vec4 color = vec4(0.0);\n      float total = 0.0;\n      float offset = random(v3offset);\n      for (float t = -nSamples; t <= nSamples; t++) {\n        float percent = (t + offset - 0.5) / nSamples;\n        float weight = 1.0 - abs(percent);\n        color += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\n        total += weight;\n      }\n      gl_FragColor = color / total;\n    }\n  ";
const $ab3f2a5cc6216ae5$var$blurDefaultValues = {
    blur: 0
};
/**
 * Blur filter class
 * @example
 * const filter = new Blur({
 *   blur: 0.5
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $ab3f2a5cc6216ae5$var$Blur extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$b;
    }
    applyTo(options) {
        if ($ab3f2a5cc6216ae5$export$ec9091584da1706b(options)) {
            // this aspectRatio is used to give the same blur to vertical and horizontal
            this.aspectRatio = options.sourceWidth / options.sourceHeight;
            options.passes++;
            this._setupFrameBuffer(options);
            this.horizontal = true;
            this.applyToWebGL(options);
            this._swapTextures(options);
            this._setupFrameBuffer(options);
            this.horizontal = false;
            this.applyToWebGL(options);
            this._swapTextures(options);
        } else this.applyTo2d(options);
    }
    applyTo2d(options) {
        options.imageData = this.simpleBlur(options);
    }
    simpleBlur(_ref) {
        let { ctx: ctx, imageData: imageData, filterBackend: { resources: resources } } = _ref;
        const { width: width, height: height } = imageData;
        if (!resources.blurLayer1) {
            resources.blurLayer1 = $ab3f2a5cc6216ae5$var$createCanvasElement();
            resources.blurLayer2 = $ab3f2a5cc6216ae5$var$createCanvasElement();
        }
        const canvas1 = resources.blurLayer1;
        const canvas2 = resources.blurLayer2;
        if (canvas1.width !== width || canvas1.height !== height) {
            canvas2.width = canvas1.width = width;
            canvas2.height = canvas1.height = height;
        }
        const ctx1 = canvas1.getContext("2d"), ctx2 = canvas2.getContext("2d"), nSamples = 15, blur = this.blur * 0.03;
        let random, percent, j, i;
        // load first canvas
        ctx1.putImageData(imageData, 0, 0);
        ctx2.clearRect(0, 0, width, height);
        for(i = -nSamples; i <= nSamples; i++){
            random = (Math.random() - 0.5) / 4;
            percent = i / nSamples;
            j = blur * percent * width + random;
            ctx2.globalAlpha = 1 - Math.abs(percent);
            ctx2.drawImage(canvas1, j, random);
            ctx1.drawImage(canvas2, 0, 0);
            ctx2.globalAlpha = 1;
            ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
        }
        for(i = -nSamples; i <= nSamples; i++){
            random = (Math.random() - 0.5) / 4;
            percent = i / nSamples;
            j = blur * percent * height + random;
            ctx2.globalAlpha = 1 - Math.abs(percent);
            ctx2.drawImage(canvas1, random, j);
            ctx1.drawImage(canvas2, 0, 0);
            ctx2.globalAlpha = 1;
            ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
        }
        ctx.drawImage(canvas1, 0, 0);
        const newImageData = ctx.getImageData(0, 0, canvas1.width, canvas1.height);
        ctx1.globalAlpha = 1;
        ctx1.clearRect(0, 0, canvas1.width, canvas1.height);
        return newImageData;
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const delta = this.chooseRightDelta();
        gl.uniform2fv(uniformLocations.uDelta, delta);
    }
    isNeutralState() {
        return this.blur === 0;
    }
    /**
   * choose right value of image percentage to blur with
   * @returns {Array} a numeric array with delta values
   */ chooseRightDelta() {
        let blurScale = 1;
        const delta = [
            0,
            0
        ];
        if (this.horizontal) {
            if (this.aspectRatio > 1) // image is wide, i want to shrink radius horizontal
            blurScale = 1 / this.aspectRatio;
        } else if (this.aspectRatio < 1) // image is tall, i want to shrink radius vertical
        blurScale = this.aspectRatio;
        const blur = blurScale * this.blur * 0.12;
        if (this.horizontal) delta[0] = blur;
        else delta[1] = blur;
        return delta;
    }
}
/**
 * blur value, in percentage of image dimensions.
 * specific to keep the image blur constant at different resolutions
 * range between 0 and 1.
 * @type Number
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Blur, "type", "Blur");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Blur, "defaults", $ab3f2a5cc6216ae5$var$blurDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Blur, "uniformLocations", [
    "uDelta"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Blur);
const $ab3f2a5cc6216ae5$var$fragmentSource$a = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uBrightness;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    color.rgb += uBrightness;\n    gl_FragColor = color;\n  }\n";
const $ab3f2a5cc6216ae5$var$brightnessDefaultValues = {
    brightness: 0
};
/**
 * Brightness filter class
 * @example
 * const filter = new Brightness({
 *   brightness: 0.05
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $ab3f2a5cc6216ae5$var$Brightness extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$a;
    }
    /**
   * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const brightness = Math.round(this.brightness * 255);
        for(let i = 0; i < data.length; i += 4){
            data[i] = data[i] + brightness;
            data[i + 1] = data[i + 1] + brightness;
            data[i + 2] = data[i + 2] + brightness;
        }
    }
    isNeutralState() {
        return this.brightness === 0;
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uBrightness, this.brightness);
    }
}
/**
 * Brightness value, from -1 to 1.
 * translated to -255 to 255 for 2d
 * 0.0039215686 is the part of 1 that get translated to 1 in 2d
 * @param {Number} brightness
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Brightness, "type", "Brightness");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Brightness, "defaults", $ab3f2a5cc6216ae5$var$brightnessDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Brightness, "uniformLocations", [
    "uBrightness"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Brightness);
const $ab3f2a5cc6216ae5$var$fragmentSource$9 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  varying vec2 vTexCoord;\n  uniform mat4 uColorMatrix;\n  uniform vec4 uConstants;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    color *= uColorMatrix;\n    color += uConstants;\n    gl_FragColor = color;\n  }";
const $ab3f2a5cc6216ae5$var$colorMatrixDefaultValues = {
    matrix: [
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0
    ],
    colorsOnly: true
};
/**
   * Color Matrix filter class
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @see {@Link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl demo}
   * @example <caption>Kodachrome filter</caption>
   * const filter = new ColorMatrix({
   *  matrix: [
       1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
       -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
       -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
       0, 0, 0, 1, 0
      ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ class $ab3f2a5cc6216ae5$var$ColorMatrix extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$9;
    }
    /**
   * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8Array to be filtered.
   */ applyTo2d(options) {
        const imageData = options.imageData, data = imageData.data, m = this.matrix, colorsOnly = this.colorsOnly;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            if (colorsOnly) {
                data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
                data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
                data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
            } else {
                const a = data[i + 3];
                data[i] = r * m[0] + g * m[1] + b * m[2] + a * m[3] + m[4] * 255;
                data[i + 1] = r * m[5] + g * m[6] + b * m[7] + a * m[8] + m[9] * 255;
                data[i + 2] = r * m[10] + g * m[11] + b * m[12] + a * m[13] + m[14] * 255;
                data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
            }
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const m = this.matrix, matrix = [
            m[0],
            m[1],
            m[2],
            m[3],
            m[5],
            m[6],
            m[7],
            m[8],
            m[10],
            m[11],
            m[12],
            m[13],
            m[15],
            m[16],
            m[17],
            m[18]
        ], constants = [
            m[4],
            m[9],
            m[14],
            m[19]
        ];
        gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
        gl.uniform4fv(uniformLocations.uConstants, constants);
    }
    toObject() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.toObject()), {}, {
            matrix: [
                ...this.matrix
            ]
        });
    }
}
/**
 * Colormatrix for pixels.
 * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
 * outside the -1, 1 range.
 * 0.0039215686 is the part of 1 that get translated to 1 in 2d
 * @param {Array} matrix array of 20 numbers.
 * @default
 */ /**
 * Lock the colormatrix on the color part, skipping alpha, mainly for non webgl scenario
 * to save some calculation
 * @type Boolean
 * @default true
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$ColorMatrix, "type", "ColorMatrix");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$ColorMatrix, "defaults", $ab3f2a5cc6216ae5$var$colorMatrixDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$ColorMatrix, "uniformLocations", [
    "uColorMatrix",
    "uConstants"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$ColorMatrix);
function $ab3f2a5cc6216ae5$var$createColorMatrixFilter(key, matrix) {
    var _Class;
    const newClass = (_Class = class newClass extends $ab3f2a5cc6216ae5$var$ColorMatrix {
        //@ts-expect-error TS wants matrix to be exported.
        toObject() {
            return {
                type: this.type,
                colorsOnly: this.colorsOnly
            };
        }
    }, $ab3f2a5cc6216ae5$var$_defineProperty(_Class, "type", key), $ab3f2a5cc6216ae5$var$_defineProperty(_Class, "defaults", {
        colorsOnly: false,
        matrix: matrix
    }), _Class);
    $ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass(newClass, key);
    return newClass;
}
const $ab3f2a5cc6216ae5$var$Brownie = $ab3f2a5cc6216ae5$var$createColorMatrixFilter("Brownie", [
    0.5997,
    0.34553,
    -0.27082,
    0,
    0.186,
    -0.0377,
    0.86095,
    0.15059,
    0,
    -0.1449,
    0.24113,
    -0.07441,
    0.44972,
    0,
    -0.02965,
    0,
    0,
    0,
    1,
    0
]);
const $ab3f2a5cc6216ae5$var$Vintage = $ab3f2a5cc6216ae5$var$createColorMatrixFilter("Vintage", [
    0.62793,
    0.32021,
    -0.03965,
    0,
    0.03784,
    0.02578,
    0.64411,
    0.03259,
    0,
    0.02926,
    0.0466,
    -0.08512,
    0.52416,
    0,
    0.02023,
    0,
    0,
    0,
    1,
    0
]);
const $ab3f2a5cc6216ae5$var$Kodachrome = $ab3f2a5cc6216ae5$var$createColorMatrixFilter("Kodachrome", [
    1.12855,
    -0.39673,
    -0.03992,
    0,
    0.24991,
    -0.16404,
    1.08352,
    -0.05498,
    0,
    0.09698,
    -0.16786,
    -0.56034,
    1.60148,
    0,
    0.13972,
    0,
    0,
    0,
    1,
    0
]);
const $ab3f2a5cc6216ae5$var$Technicolor = $ab3f2a5cc6216ae5$var$createColorMatrixFilter("Technicolor", [
    1.91252,
    -0.85453,
    -0.09155,
    0,
    0.04624,
    -0.30878,
    1.76589,
    -0.10601,
    0,
    -0.27589,
    -0.2311,
    -0.75018,
    1.84759,
    0,
    0.12137,
    0,
    0,
    0,
    1,
    0
]);
const $ab3f2a5cc6216ae5$var$Polaroid = $ab3f2a5cc6216ae5$var$createColorMatrixFilter("Polaroid", [
    1.438,
    -0.062,
    -0.062,
    0,
    0,
    -0.122,
    1.378,
    -0.122,
    0,
    0,
    -0.016,
    -0.016,
    1.483,
    0,
    0,
    0,
    0,
    0,
    1,
    0
]);
const $ab3f2a5cc6216ae5$var$Sepia = $ab3f2a5cc6216ae5$var$createColorMatrixFilter("Sepia", [
    0.393,
    0.769,
    0.189,
    0,
    0,
    0.349,
    0.686,
    0.168,
    0,
    0,
    0.272,
    0.534,
    0.131,
    0,
    0,
    0,
    0,
    0,
    1,
    0
]);
const $ab3f2a5cc6216ae5$var$BlackWhite = $ab3f2a5cc6216ae5$var$createColorMatrixFilter("BlackWhite", [
    1.5,
    1.5,
    1.5,
    0,
    -1,
    1.5,
    1.5,
    1.5,
    0,
    -1,
    1.5,
    1.5,
    1.5,
    0,
    -1,
    0,
    0,
    0,
    1,
    0
]);
/**
 * A container class that knows how to apply a sequence of filters to an input image.
 */ class $ab3f2a5cc6216ae5$var$Composed extends $ab3f2a5cc6216ae5$var$BaseFilter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        super(options);
        this.subFilters = options.subFilters || [];
    }
    /**
   * Apply this container's filters to the input image provided.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be applied.
   */ applyTo(options) {
        if ($ab3f2a5cc6216ae5$export$ec9091584da1706b(options)) options.passes += this.subFilters.length - 1;
        this.subFilters.forEach((filter)=>{
            filter.applyTo(options);
        });
    }
    /**
   * Serialize this filter into JSON.
   * @returns {Object} A JSON representation of this filter.
   */ //@ts-expect-error TS doesn't like this toObject
    toObject() {
        return {
            type: this.type,
            subFilters: this.subFilters.map((filter)=>filter.toObject())
        };
    }
    isNeutralState() {
        return !this.subFilters.some((filter)=>!filter.isNeutralState());
    }
    /**
   * Deserialize a JSON definition of a ComposedFilter into a concrete instance.
   * @static
   * @param {oject} object Object to create an instance from
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] handle aborting `BlendImage` filter loading, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<Composed>}
   */ static fromObject(object, options) {
        return Promise.all((object.subFilters || []).map((filter)=>$ab3f2a5cc6216ae5$export$2792378e23a7920c.getClass(filter.type).fromObject(filter, options))).then((enlivedFilters)=>new this({
                subFilters: enlivedFilters
            }));
    }
}
/**
 * A non sparse array of filters to apply
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Composed, "type", "Composed");
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Composed);
const $ab3f2a5cc6216ae5$var$fragmentSource$8 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uContrast;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\n    color.rgb = contrastF * (color.rgb - 0.5) + 0.5;\n    gl_FragColor = color;\n  }";
const $ab3f2a5cc6216ae5$var$contrastDefaultValues = {
    contrast: 0
};
/**
 * Contrast filter class
 * @example
 * const filter = new Contrast({
 *   contrast: 0.25
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $ab3f2a5cc6216ae5$var$Contrast extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$8;
    }
    isNeutralState() {
        return this.contrast === 0;
    }
    /**
   * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8Array to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const contrast = Math.floor(this.contrast * 255), contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));
        for(let i = 0; i < data.length; i += 4){
            data[i] = contrastF * (data[i] - 128) + 128;
            data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
            data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uContrast, this.contrast);
    }
}
/**
 * contrast value, range from -1 to 1.
 * @param {Number} contrast
 * @default 0
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Contrast, "type", "Contrast");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Contrast, "defaults", $ab3f2a5cc6216ae5$var$contrastDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Contrast, "uniformLocations", [
    "uContrast"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Contrast);
const $ab3f2a5cc6216ae5$var$fragmentSource$7 = {
    Convolute_3_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[9];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 3.0; h+=1.0) {\n        for (float w = 0.0; w < 3.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_3_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[9];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 3.0; h+=1.0) {\n        for (float w = 0.0; w < 3.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    ",
    Convolute_5_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[25];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 5.0; h+=1.0) {\n        for (float w = 0.0; w < 5.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_5_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[25];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 5.0; h+=1.0) {\n        for (float w = 0.0; w < 5.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    ",
    Convolute_7_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[49];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 7.0; h+=1.0) {\n        for (float w = 0.0; w < 7.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_7_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[49];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 7.0; h+=1.0) {\n        for (float w = 0.0; w < 7.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    ",
    Convolute_9_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[81];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 9.0; h+=1.0) {\n        for (float w = 0.0; w < 9.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_9_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[81];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 9.0; h+=1.0) {\n        for (float w = 0.0; w < 9.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    "
};
const $ab3f2a5cc6216ae5$var$convoluteDefaultValues = {
    opaque: false,
    matrix: [
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0
    ]
};
/**
 * Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
 * @example <caption>Sharpen filter</caption>
 * const filter = new Convolute({
 *   matrix: [ 0, -1,  0,
 *            -1,  5, -1,
 *             0, -1,  0 ]
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 * @example <caption>Blur filter</caption>
 * const filter = new Convolute({
 *   matrix: [ 1/9, 1/9, 1/9,
 *             1/9, 1/9, 1/9,
 *             1/9, 1/9, 1/9 ]
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 * @example <caption>Emboss filter</caption>
 * const filter = new Convolute({
 *   matrix: [ 1,   1,  1,
 *             1, 0.7, -1,
 *            -1,  -1, -1 ]
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 * @example <caption>Emboss filter with opaqueness</caption>
 * const filter = new Convolute({
 *   opaque: true,
 *   matrix: [ 1,   1,  1,
 *             1, 0.7, -1,
 *            -1,  -1, -1 ]
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $ab3f2a5cc6216ae5$var$Convolute extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getCacheKey() {
        return "".concat(this.type, "_").concat(Math.sqrt(this.matrix.length), "_").concat(this.opaque ? 1 : 0);
    }
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$7[this.getCacheKey()];
    }
    /**
   * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(options) {
        const imageData = options.imageData, data = imageData.data, weights = this.matrix, side = Math.round(Math.sqrt(weights.length)), halfSide = Math.floor(side / 2), sw = imageData.width, sh = imageData.height, output = options.ctx.createImageData(sw, sh), dst = output.data, // go through the destination image pixels
        alphaFac = this.opaque ? 1 : 0;
        let r, g, b, a, dstOff, scx, scy, srcOff, wt, x, y, cx, cy;
        for(y = 0; y < sh; y++)for(x = 0; x < sw; x++){
            dstOff = (y * sw + x) * 4;
            // calculate the weighed sum of the source image pixels that
            // fall under the convolution matrix
            r = 0;
            g = 0;
            b = 0;
            a = 0;
            for(cy = 0; cy < side; cy++)for(cx = 0; cx < side; cx++){
                scy = y + cy - halfSide;
                scx = x + cx - halfSide;
                // eslint-disable-next-line max-depth
                if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) continue;
                srcOff = (scy * sw + scx) * 4;
                wt = weights[cy * side + cx];
                r += data[srcOff] * wt;
                g += data[srcOff + 1] * wt;
                b += data[srcOff + 2] * wt;
                // eslint-disable-next-line max-depth
                if (!alphaFac) a += data[srcOff + 3] * wt;
            }
            dst[dstOff] = r;
            dst[dstOff + 1] = g;
            dst[dstOff + 2] = b;
            if (!alphaFac) dst[dstOff + 3] = a;
            else dst[dstOff + 3] = data[dstOff + 3];
        }
        options.imageData = output;
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
    }
    /**
   * Returns object representation of an instance
   * @return {Object} Object representation of an instance
   */ toObject() {
        return $ab3f2a5cc6216ae5$var$_objectSpread2($ab3f2a5cc6216ae5$var$_objectSpread2({}, super.toObject()), {}, {
            opaque: this.opaque,
            matrix: [
                ...this.matrix
            ]
        });
    }
}
/*
 * Opaque value (true/false)
 */ /*
 * matrix for the filter, max 9x9
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Convolute, "type", "Convolute");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Convolute, "defaults", $ab3f2a5cc6216ae5$var$convoluteDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Convolute, "uniformLocations", [
    "uMatrix",
    "uOpaque",
    "uHalfSize",
    "uSize"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Convolute);
const $ab3f2a5cc6216ae5$var$fragmentSource$6 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform vec3 uGamma;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    vec3 correction = (1.0 / uGamma);\n    color.r = pow(color.r, correction.r);\n    color.g = pow(color.g, correction.g);\n    color.b = pow(color.b, correction.b);\n    gl_FragColor = color;\n    gl_FragColor.rgb *= color.a;\n  }\n";
const $ab3f2a5cc6216ae5$var$GAMMA = "Gamma";
const $ab3f2a5cc6216ae5$var$gammaDefaultValues = {
    gamma: [
        1,
        1,
        1
    ]
};
/**
 * Gamma filter class
 * @example
 * const filter = new Gamma({
 *   gamma: [1, 0.5, 2.1]
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $ab3f2a5cc6216ae5$var$Gamma extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$6;
    }
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        super(options);
        this.gamma = options.gamma || this.constructor.defaults.gamma.concat();
    }
    /**
   * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8Array to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const gamma = this.gamma, rInv = 1 / gamma[0], gInv = 1 / gamma[1], bInv = 1 / gamma[2];
        if (!this.rgbValues) this.rgbValues = {
            r: new Uint8Array(256),
            g: new Uint8Array(256),
            b: new Uint8Array(256)
        };
        // This is an optimization - pre-compute a look-up table for each color channel
        // instead of performing these pow calls for each pixel in the image.
        const rgb = this.rgbValues;
        for(let i = 0; i < 256; i++){
            rgb.r[i] = Math.pow(i / 255, rInv) * 255;
            rgb.g[i] = Math.pow(i / 255, gInv) * 255;
            rgb.b[i] = Math.pow(i / 255, bInv) * 255;
        }
        for(let i = 0; i < data.length; i += 4){
            data[i] = rgb.r[data[i]];
            data[i + 1] = rgb.g[data[i + 1]];
            data[i + 2] = rgb.b[data[i + 2]];
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform3fv(uniformLocations.uGamma, this.gamma);
    }
    isNeutralState() {
        const { gamma: gamma } = this;
        return gamma[0] === 1 && gamma[1] === 1 && gamma[2] === 1;
    }
    toObject() {
        return {
            type: $ab3f2a5cc6216ae5$var$GAMMA,
            gamma: this.gamma.concat()
        };
    }
}
/**
 * Gamma array value, from 0.01 to 2.2.
 * @param {Array} gamma
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Gamma, "type", $ab3f2a5cc6216ae5$var$GAMMA);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Gamma, "defaults", $ab3f2a5cc6216ae5$var$gammaDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Gamma, "uniformLocations", [
    "uGamma"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Gamma);
const $ab3f2a5cc6216ae5$var$fragmentSource$5 = {
    average: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = texture2D(uTexture, vTexCoord);\n      float average = (color.r + color.b + color.g) / 3.0;\n      gl_FragColor = vec4(average, average, average, color.a);\n    }\n    ",
    lightness: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform int uMode;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 col = texture2D(uTexture, vTexCoord);\n      float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\n      gl_FragColor = vec4(average, average, average, col.a);\n    }\n    ",
    luminosity: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform int uMode;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 col = texture2D(uTexture, vTexCoord);\n      float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\n      gl_FragColor = vec4(average, average, average, col.a);\n    }\n    "
};
const $ab3f2a5cc6216ae5$var$grayscaleDefaultValues = {
    mode: "average"
};
/**
 * Grayscale image filter class
 * @example
 * const filter = new Grayscale();
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $ab3f2a5cc6216ae5$var$Grayscale extends $ab3f2a5cc6216ae5$var$BaseFilter {
    /**
   * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8Array to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        for(let i = 0, value; i < data.length; i += 4){
            switch(this.mode){
                case "average":
                    value = (data[i] + data[i + 1] + data[i + 2]) / 3;
                    break;
                case "lightness":
                    value = (Math.min(data[i], data[i + 1], data[i + 2]) + Math.max(data[i], data[i + 1], data[i + 2])) / 2;
                    break;
                case "luminosity":
                    value = 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
                    break;
            }
            data[i] = value;
            data[i + 1] = value;
            data[i + 2] = value;
        }
    }
    getCacheKey() {
        return "".concat(this.type, "_").concat(this.mode);
    }
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$5[this.mode];
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const mode = 1;
        gl.uniform1i(uniformLocations.uMode, mode);
    }
    /**
   * Grayscale filter isNeutralState implementation
   * The filter is never neutral
   * on the image
   **/ isNeutralState() {
        return false;
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Grayscale, "type", "Grayscale");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Grayscale, "defaults", $ab3f2a5cc6216ae5$var$grayscaleDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Grayscale, "uniformLocations", [
    "uMode"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Grayscale);
const $ab3f2a5cc6216ae5$var$hueRotationDefaultValues = {
    rotation: 0
};
/**
 * HueRotation filter class
 * @example
 * const filter = new HueRotation({
 *   rotation: -0.5
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $ab3f2a5cc6216ae5$var$HueRotation extends $ab3f2a5cc6216ae5$var$ColorMatrix {
    calculateMatrix() {
        const rad = this.rotation * Math.PI, cosine = $ab3f2a5cc6216ae5$var$cos(rad), sine = $ab3f2a5cc6216ae5$var$sin(rad), aThird = 1 / 3, aThirdSqtSin = Math.sqrt(aThird) * sine, OneMinusCos = 1 - cosine;
        this.matrix = [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this.matrix[0] = cosine + OneMinusCos / 3;
        this.matrix[1] = aThird * OneMinusCos - aThirdSqtSin;
        this.matrix[2] = aThird * OneMinusCos + aThirdSqtSin;
        this.matrix[5] = aThird * OneMinusCos + aThirdSqtSin;
        this.matrix[6] = cosine + aThird * OneMinusCos;
        this.matrix[7] = aThird * OneMinusCos - aThirdSqtSin;
        this.matrix[10] = aThird * OneMinusCos - aThirdSqtSin;
        this.matrix[11] = aThird * OneMinusCos + aThirdSqtSin;
        this.matrix[12] = cosine + aThird * OneMinusCos;
    }
    isNeutralState() {
        return this.rotation === 0;
    }
    applyTo(options) {
        this.calculateMatrix();
        super.applyTo(options);
    }
    //@ts-expect-error TS and classes with different methods
    toObject() {
        return {
            type: this.type,
            rotation: this.rotation
        };
    }
}
/**
 * HueRotation value, from -1 to 1.
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$HueRotation, "type", "HueRotation");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$HueRotation, "defaults", $ab3f2a5cc6216ae5$var$hueRotationDefaultValues);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$HueRotation);
const $ab3f2a5cc6216ae5$var$fragmentSource$4 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform int uInvert;\n  uniform int uAlpha;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    if (uInvert == 1) {\n      if (uAlpha == 1) {\n        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,1.0 -color.a);\n      } else {\n        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n      }\n    } else {\n      gl_FragColor = color;\n    }\n  }\n";
const $ab3f2a5cc6216ae5$var$invertDefaultValues = {
    alpha: false,
    invert: true
};
/**
 * @example
 * const filter = new Invert();
 * object.filters.push(filter);
 * object.applyFilters(canvas.renderAll.bind(canvas));
 */ class $ab3f2a5cc6216ae5$var$Invert extends $ab3f2a5cc6216ae5$var$BaseFilter {
    /**
   * Apply the Invert operation to a Uint8Array representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8Array to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        for(let i = 0; i < data.length; i += 4){
            data[i] = 255 - data[i];
            data[i + 1] = 255 - data[i + 1];
            data[i + 2] = 255 - data[i + 2];
            if (this.alpha) data[i + 3] = 255 - data[i + 3];
        }
    }
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$4;
    }
    /**
   * Invert filter isNeutralState implementation
   * Used only in image applyFilters to discard filters that will not have an effect
   * on the image
   * @param {Object} options
   **/ isNeutralState() {
        return !this.invert;
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1i(uniformLocations.uInvert, Number(this.invert));
        gl.uniform1i(uniformLocations.uAlpha, Number(this.alpha));
    }
}
/**
 * Invert also alpha.
 * @param {Boolean} alpha
 * @default
 **/ /**
 * Filter invert. if false, does nothing
 * @param {Boolean} invert
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Invert, "type", "Invert");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Invert, "defaults", $ab3f2a5cc6216ae5$var$invertDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Invert, "uniformLocations", [
    "uInvert",
    "uAlpha"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Invert);
const $ab3f2a5cc6216ae5$var$fragmentSource$3 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uStepH;\n  uniform float uNoise;\n  uniform float uSeed;\n  varying vec2 vTexCoord;\n  float rand(vec2 co, float seed, float vScale) {\n    return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n  }\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\n    gl_FragColor = color;\n  }\n";
const $ab3f2a5cc6216ae5$var$noiseDefaultValues = {
    noise: 0
};
/**
 * Noise filter class
 * @example
 * const filter = new Noise({
 *   noise: 700
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $ab3f2a5cc6216ae5$var$Noise extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$3;
    }
    /**
   * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const noise = this.noise;
        for(let i = 0; i < data.length; i += 4){
            const rand = (0.5 - Math.random()) * noise;
            data[i] += rand;
            data[i + 1] += rand;
            data[i + 2] += rand;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
        gl.uniform1f(uniformLocations.uSeed, Math.random());
    }
    isNeutralState() {
        return this.noise === 0;
    }
}
/**
 * Noise value, from
 * @param {Number} noise
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Noise, "type", "Noise");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Noise, "defaults", $ab3f2a5cc6216ae5$var$noiseDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Noise, "uniformLocations", [
    "uNoise",
    "uSeed"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Noise);
const $ab3f2a5cc6216ae5$var$fragmentSource$2 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uBlocksize;\n  uniform float uStepW;\n  uniform float uStepH;\n  varying vec2 vTexCoord;\n  void main() {\n    float blockW = uBlocksize * uStepW;\n    float blockH = uBlocksize * uStepW;\n    int posX = int(vTexCoord.x / blockW);\n    int posY = int(vTexCoord.y / blockH);\n    float fposX = float(posX);\n    float fposY = float(posY);\n    vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\n    vec4 color = texture2D(uTexture, squareCoords);\n    gl_FragColor = color;\n  }\n";
const $ab3f2a5cc6216ae5$var$pixelateDefaultValues = {
    blocksize: 4
};
/**
 * Pixelate filter class
 * @example
 * const filter = new Pixelate({
 *   blocksize: 8
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $ab3f2a5cc6216ae5$var$Pixelate extends $ab3f2a5cc6216ae5$var$BaseFilter {
    /**
   * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data, width: width, height: height } } = _ref;
        for(let i = 0; i < height; i += this.blocksize)for(let j = 0; j < width; j += this.blocksize){
            const index = i * 4 * width + j * 4;
            const r = data[index];
            const g = data[index + 1];
            const b = data[index + 2];
            const a = data[index + 3];
            for(let _i = i; _i < Math.min(i + this.blocksize, height); _i++)for(let _j = j; _j < Math.min(j + this.blocksize, width); _j++){
                const index = _i * 4 * width + _j * 4;
                data[index] = r;
                data[index + 1] = g;
                data[index + 2] = b;
                data[index + 3] = a;
            }
        }
    }
    /**
   * Indicate when the filter is not gonna apply changes to the image
   **/ isNeutralState() {
        return this.blocksize === 1;
    }
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$2;
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
    }
}
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Pixelate, "type", "Pixelate");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Pixelate, "defaults", $ab3f2a5cc6216ae5$var$pixelateDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Pixelate, "uniformLocations", [
    "uBlocksize"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Pixelate);
const $ab3f2a5cc6216ae5$var$fragmentShader = "\nprecision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uLow;\nuniform vec4 uHigh;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_FragColor = texture2D(uTexture, vTexCoord);\n  if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\n    gl_FragColor.a = 0.0;\n  }\n}\n";
const $ab3f2a5cc6216ae5$var$removeColorDefaultValues = {
    color: "#FFFFFF",
    distance: 0.02,
    useAlpha: false
};
/**
 * Remove white filter class
 * @example
 * const filter = new RemoveColor({
 *   threshold: 0.2,
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $ab3f2a5cc6216ae5$var$RemoveColor extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentShader;
    }
    /**
   * Applies filter to canvas element
   * @param {Object} canvasEl Canvas element to apply filter to
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const distance = this.distance * 255, source = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(this.color).getSource(), lowC = [
            source[0] - distance,
            source[1] - distance,
            source[2] - distance
        ], highC = [
            source[0] + distance,
            source[1] + distance,
            source[2] + distance
        ];
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            if (r > lowC[0] && g > lowC[1] && b > lowC[2] && r < highC[0] && g < highC[1] && b < highC[2]) data[i + 3] = 0;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const source = new $ab3f2a5cc6216ae5$export$892596cec99bc70e(this.color).getSource(), distance = this.distance, lowC = [
            0 + source[0] / 255 - distance,
            0 + source[1] / 255 - distance,
            0 + source[2] / 255 - distance,
            1
        ], highC = [
            source[0] / 255 + distance,
            source[1] / 255 + distance,
            source[2] / 255 + distance,
            1
        ];
        gl.uniform4fv(uniformLocations.uLow, lowC);
        gl.uniform4fv(uniformLocations.uHigh, highC);
    }
}
/**
 * Color to remove, in any format understood by {@link Color}.
 * @param {String} type
 * @default
 */ /**
 * distance to actual color, as value up or down from each r,g,b
 * between 0 and 1
 **/ /**
 * For color to remove inside distance, use alpha channel for a smoother deletion
 * NOT IMPLEMENTED YET
 **/ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$RemoveColor, "type", "RemoveColor");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$RemoveColor, "defaults", $ab3f2a5cc6216ae5$var$removeColorDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$RemoveColor, "uniformLocations", [
    "uLow",
    "uHigh"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$RemoveColor);
const $ab3f2a5cc6216ae5$var$resizeDefaultValues = {
    resizeType: "hermite",
    scaleX: 1,
    scaleY: 1,
    lanczosLobes: 3
};
/**
 * Resize image filter class
 * @example
 * const filter = new Resize();
 * object.filters.push(filter);
 * object.applyFilters(canvas.renderAll.bind(canvas));
 */ class $ab3f2a5cc6216ae5$var$Resize extends $ab3f2a5cc6216ae5$var$BaseFilter {
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [
            1 / this.width,
            0
        ] : [
            0,
            1 / this.height
        ]);
        gl.uniform1fv(uniformLocations.uTaps, this.taps);
    }
    getFilterWindow() {
        const scale = this.tempScale;
        return Math.ceil(this.lanczosLobes / scale);
    }
    getCacheKey() {
        const filterWindow = this.getFilterWindow();
        return "".concat(this.type, "_").concat(filterWindow);
    }
    getFragmentSource() {
        const filterWindow = this.getFilterWindow();
        return this.generateShader(filterWindow);
    }
    getTaps() {
        const lobeFunction = this.lanczosCreate(this.lanczosLobes), scale = this.tempScale, filterWindow = this.getFilterWindow(), taps = new Array(filterWindow);
        for(let i = 1; i <= filterWindow; i++)taps[i - 1] = lobeFunction(i * scale);
        return taps;
    }
    /**
   * Generate vertex and shader sources from the necessary steps numbers
   * @param {Number} filterWindow
   */ generateShader(filterWindow) {
        const offsets = new Array(filterWindow);
        for(let i = 1; i <= filterWindow; i++)offsets[i - 1] = "".concat(i, ".0 * uDelta");
        return "\n      precision highp float;\n      uniform sampler2D uTexture;\n      uniform vec2 uDelta;\n      varying vec2 vTexCoord;\n      uniform float uTaps[".concat(filterWindow, "];\n      void main() {\n        vec4 color = texture2D(uTexture, vTexCoord);\n        float sum = 1.0;\n        ").concat(offsets.map((offset, i)=>"\n              color += texture2D(uTexture, vTexCoord + ".concat(offset, ") * uTaps[").concat(i, "] + texture2D(uTexture, vTexCoord - ").concat(offset, ") * uTaps[").concat(i, "];\n              sum += 2.0 * uTaps[").concat(i, "];\n            ")).join("\n"), "\n        gl_FragColor = color / sum;\n      }\n    ");
    }
    applyToForWebgl(options) {
        options.passes++;
        this.width = options.sourceWidth;
        this.horizontal = true;
        this.dW = Math.round(this.width * this.scaleX);
        this.dH = options.sourceHeight;
        this.tempScale = this.dW / this.width;
        this.taps = this.getTaps();
        options.destinationWidth = this.dW;
        super.applyTo(options);
        options.sourceWidth = options.destinationWidth;
        this.height = options.sourceHeight;
        this.horizontal = false;
        this.dH = Math.round(this.height * this.scaleY);
        this.tempScale = this.dH / this.height;
        this.taps = this.getTaps();
        options.destinationHeight = this.dH;
        super.applyTo(options);
        options.sourceHeight = options.destinationHeight;
    }
    /**
   * Apply the resize filter to the image
   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ applyTo(options) {
        if ($ab3f2a5cc6216ae5$export$ec9091584da1706b(options)) this.applyToForWebgl(options);
        else this.applyTo2d(options);
    }
    isNeutralState() {
        return this.scaleX === 1 && this.scaleY === 1;
    }
    lanczosCreate(lobes) {
        return (x)=>{
            if (x >= lobes || x <= -lobes) return 0.0;
            if (x < 1.1920929e-7 && x > -0.00000011920929) return 1.0;
            x *= Math.PI;
            const xx = x / lobes;
            return Math.sin(x) / x * Math.sin(xx) / xx;
        };
    }
    applyTo2d(options) {
        const imageData = options.imageData, scaleX = this.scaleX, scaleY = this.scaleY;
        this.rcpScaleX = 1 / scaleX;
        this.rcpScaleY = 1 / scaleY;
        const oW = imageData.width;
        const oH = imageData.height;
        const dW = Math.round(oW * scaleX);
        const dH = Math.round(oH * scaleY);
        let newData;
        if (this.resizeType === "sliceHack") newData = this.sliceByTwo(options, oW, oH, dW, dH);
        else if (this.resizeType === "hermite") newData = this.hermiteFastResize(options, oW, oH, dW, dH);
        else if (this.resizeType === "bilinear") newData = this.bilinearFiltering(options, oW, oH, dW, dH);
        else if (this.resizeType === "lanczos") newData = this.lanczosResize(options, oW, oH, dW, dH);
        else // this should never trigger, is here just for safety net.
        newData = new ImageData(dW, dH);
        options.imageData = newData;
    }
    /**
   * Filter sliceByTwo
   * @param {Object} canvasEl Canvas element to apply filter to
   * @param {Number} oW Original Width
   * @param {Number} oH Original Height
   * @param {Number} dW Destination Width
   * @param {Number} dH Destination Height
   * @returns {ImageData}
   */ sliceByTwo(options, oW, oH, dW, dH) {
        const imageData = options.imageData;
        const mult = 0.5;
        let doneW = false;
        let doneH = false;
        let stepW = oW * mult;
        let stepH = oH * mult;
        const resources = options.filterBackend.resources;
        let sX = 0;
        let sY = 0;
        const dX = oW;
        let dY = 0;
        if (!resources.sliceByTwo) resources.sliceByTwo = $ab3f2a5cc6216ae5$var$createCanvasElement();
        const tmpCanvas = resources.sliceByTwo;
        if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
            tmpCanvas.width = oW * 1.5;
            tmpCanvas.height = oH;
        }
        const ctx = tmpCanvas.getContext("2d");
        ctx.clearRect(0, 0, oW * 1.5, oH);
        ctx.putImageData(imageData, 0, 0);
        dW = Math.floor(dW);
        dH = Math.floor(dH);
        while(!doneW || !doneH){
            oW = stepW;
            oH = stepH;
            if (dW < Math.floor(stepW * mult)) stepW = Math.floor(stepW * mult);
            else {
                stepW = dW;
                doneW = true;
            }
            if (dH < Math.floor(stepH * mult)) stepH = Math.floor(stepH * mult);
            else {
                stepH = dH;
                doneH = true;
            }
            ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
            sX = dX;
            sY = dY;
            dY += stepH;
        }
        return ctx.getImageData(sX, sY, dW, dH);
    }
    /**
   * Filter lanczosResize
   * @param {Object} canvasEl Canvas element to apply filter to
   * @param {Number} oW Original Width
   * @param {Number} oH Original Height
   * @param {Number} dW Destination Width
   * @param {Number} dH Destination Height
   * @returns {ImageData}
   */ lanczosResize(options, oW, oH, dW, dH) {
        function process(u) {
            let v, i, weight, idx, a, red, green, blue, alpha, fX, fY;
            center.x = (u + 0.5) * ratioX;
            icenter.x = Math.floor(center.x);
            for(v = 0; v < dH; v++){
                center.y = (v + 0.5) * ratioY;
                icenter.y = Math.floor(center.y);
                a = 0;
                red = 0;
                green = 0;
                blue = 0;
                alpha = 0;
                for(i = icenter.x - range2X; i <= icenter.x + range2X; i++){
                    if (i < 0 || i >= oW) continue;
                    fX = Math.floor(1000 * Math.abs(i - center.x));
                    if (!cacheLanc[fX]) cacheLanc[fX] = {};
                    for(let j = icenter.y - range2Y; j <= icenter.y + range2Y; j++){
                        if (j < 0 || j >= oH) continue;
                        fY = Math.floor(1000 * Math.abs(j - center.y));
                        if (!cacheLanc[fX][fY]) cacheLanc[fX][fY] = lanczos(Math.sqrt(Math.pow(fX * rcpRatioX, 2) + Math.pow(fY * rcpRatioY, 2)) / 1000);
                        weight = cacheLanc[fX][fY];
                        if (weight > 0) {
                            idx = (j * oW + i) * 4;
                            a += weight;
                            red += weight * srcData[idx];
                            green += weight * srcData[idx + 1];
                            blue += weight * srcData[idx + 2];
                            alpha += weight * srcData[idx + 3];
                        }
                    }
                }
                idx = (v * dW + u) * 4;
                destData[idx] = red / a;
                destData[idx + 1] = green / a;
                destData[idx + 2] = blue / a;
                destData[idx + 3] = alpha / a;
            }
            if (++u < dW) return process(u);
            else return destImg;
        }
        const srcData = options.imageData.data, destImg = options.ctx.createImageData(dW, dH), destData = destImg.data, lanczos = this.lanczosCreate(this.lanczosLobes), ratioX = this.rcpScaleX, ratioY = this.rcpScaleY, rcpRatioX = 2 / this.rcpScaleX, rcpRatioY = 2 / this.rcpScaleY, range2X = Math.ceil(ratioX * this.lanczosLobes / 2), range2Y = Math.ceil(ratioY * this.lanczosLobes / 2), cacheLanc = {}, center = {
            x: 0,
            y: 0
        }, icenter = {
            x: 0,
            y: 0
        };
        return process(0);
    }
    /**
   * bilinearFiltering
   * @param {Object} canvasEl Canvas element to apply filter to
   * @param {Number} oW Original Width
   * @param {Number} oH Original Height
   * @param {Number} dW Destination Width
   * @param {Number} dH Destination Height
   * @returns {ImageData}
   */ bilinearFiltering(options, oW, oH, dW, dH) {
        let a;
        let b;
        let c;
        let d;
        let x;
        let y;
        let i;
        let j;
        let xDiff;
        let yDiff;
        let chnl;
        let color;
        let offset = 0;
        let origPix;
        const ratioX = this.rcpScaleX;
        const ratioY = this.rcpScaleY;
        const w4 = 4 * (oW - 1);
        const img = options.imageData;
        const pixels = img.data;
        const destImage = options.ctx.createImageData(dW, dH);
        const destPixels = destImage.data;
        for(i = 0; i < dH; i++)for(j = 0; j < dW; j++){
            x = Math.floor(ratioX * j);
            y = Math.floor(ratioY * i);
            xDiff = ratioX * j - x;
            yDiff = ratioY * i - y;
            origPix = 4 * (y * oW + x);
            for(chnl = 0; chnl < 4; chnl++){
                a = pixels[origPix + chnl];
                b = pixels[origPix + 4 + chnl];
                c = pixels[origPix + w4 + chnl];
                d = pixels[origPix + w4 + 4 + chnl];
                color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) + c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
                destPixels[offset++] = color;
            }
        }
        return destImage;
    }
    /**
   * hermiteFastResize
   * @param {Object} canvasEl Canvas element to apply filter to
   * @param {Number} oW Original Width
   * @param {Number} oH Original Height
   * @param {Number} dW Destination Width
   * @param {Number} dH Destination Height
   * @returns {ImageData}
   */ hermiteFastResize(options, oW, oH, dW, dH) {
        const ratioW = this.rcpScaleX, ratioH = this.rcpScaleY, ratioWHalf = Math.ceil(ratioW / 2), ratioHHalf = Math.ceil(ratioH / 2), img = options.imageData, data = img.data, img2 = options.ctx.createImageData(dW, dH), data2 = img2.data;
        for(let j = 0; j < dH; j++)for(let i = 0; i < dW; i++){
            const x2 = (i + j * dW) * 4;
            let weight = 0;
            let weights = 0;
            let weightsAlpha = 0;
            let gxR = 0;
            let gxG = 0;
            let gxB = 0;
            let gxA = 0;
            const centerY = (j + 0.5) * ratioH;
            for(let yy = Math.floor(j * ratioH); yy < (j + 1) * ratioH; yy++){
                const dy = Math.abs(centerY - (yy + 0.5)) / ratioHHalf, centerX = (i + 0.5) * ratioW, w0 = dy * dy;
                for(let xx = Math.floor(i * ratioW); xx < (i + 1) * ratioW; xx++){
                    let dx = Math.abs(centerX - (xx + 0.5)) / ratioWHalf;
                    const w = Math.sqrt(w0 + dx * dx);
                    /* eslint-disable max-depth */ if (w > 1 && w < -1) continue;
                    //hermite filter
                    weight = 2 * w * w * w - 3 * w * w + 1;
                    if (weight > 0) {
                        dx = 4 * (xx + yy * oW);
                        //alpha
                        gxA += weight * data[dx + 3];
                        weightsAlpha += weight;
                        //colors
                        if (data[dx + 3] < 255) weight = weight * data[dx + 3] / 250;
                        gxR += weight * data[dx];
                        gxG += weight * data[dx + 1];
                        gxB += weight * data[dx + 2];
                        weights += weight;
                    }
                /* eslint-enable max-depth */ }
            }
            data2[x2] = gxR / weights;
            data2[x2 + 1] = gxG / weights;
            data2[x2 + 2] = gxB / weights;
            data2[x2 + 3] = gxA / weightsAlpha;
        }
        return img2;
    }
}
/**
 * Resize type
 * for webgl resizeType is just lanczos, for canvas2d can be:
 * bilinear, hermite, sliceHack, lanczos.
 * @default
 */ /**
 * Scale factor for resizing, x axis
 * @param {Number} scaleX
 * @default
 */ /**
 * Scale factor for resizing, y axis
 * @param {Number} scaleY
 * @default
 */ /**
 * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
 * @param {Number} lanczosLobes
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Resize, "type", "Resize");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Resize, "defaults", $ab3f2a5cc6216ae5$var$resizeDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Resize, "uniformLocations", [
    "uDelta",
    "uTaps"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Resize);
const $ab3f2a5cc6216ae5$var$fragmentSource$1 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uSaturation;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    float rgMax = max(color.r, color.g);\n    float rgbMax = max(rgMax, color.b);\n    color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\n    color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\n    color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\n    gl_FragColor = color;\n  }\n";
const $ab3f2a5cc6216ae5$var$saturationDefaultValues = {
    saturation: 0
};
/**
 * Saturate filter class
 * @example
 * const filter = new Saturation({
 *   saturation: 1
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $ab3f2a5cc6216ae5$var$Saturation extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource$1;
    }
    /**
   * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const adjust = -this.saturation;
        for(let i = 0; i < data.length; i += 4){
            const max = Math.max(data[i], data[i + 1], data[i + 2]);
            data[i] += max !== data[i] ? (max - data[i]) * adjust : 0;
            data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * adjust : 0;
            data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * adjust : 0;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
    }
    isNeutralState() {
        return this.saturation === 0;
    }
}
/**
 * Saturation value, from -1 to 1.
 * Increases/decreases the color saturation.
 * A value of 0 has no effect.
 *
 * @param {Number} saturation
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Saturation, "type", "Saturation");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Saturation, "defaults", $ab3f2a5cc6216ae5$var$saturationDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Saturation, "uniformLocations", [
    "uSaturation"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Saturation);
const $ab3f2a5cc6216ae5$var$fragmentSource = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uVibrance;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    float max = max(color.r, max(color.g, color.b));\n    float avg = (color.r + color.g + color.b) / 3.0;\n    float amt = (abs(max - avg) * 2.0) * uVibrance;\n    color.r += max != color.r ? (max - color.r) * amt : 0.00;\n    color.g += max != color.g ? (max - color.g) * amt : 0.00;\n    color.b += max != color.b ? (max - color.b) * amt : 0.00;\n    gl_FragColor = color;\n  }\n";
const $ab3f2a5cc6216ae5$var$vibranceDefaultValues = {
    vibrance: 0
};
/**
 * Vibrance filter class
 * @example
 * const filter = new Vibrance({
 *   vibrance: 1
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $ab3f2a5cc6216ae5$var$Vibrance extends $ab3f2a5cc6216ae5$var$BaseFilter {
    getFragmentSource() {
        return $ab3f2a5cc6216ae5$var$fragmentSource;
    }
    /**
   * Apply the Vibrance operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const adjust = -this.vibrance;
        for(let i = 0; i < data.length; i += 4){
            const max = Math.max(data[i], data[i + 1], data[i + 2]);
            const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
            const amt = Math.abs(max - avg) * 2 / 255 * adjust;
            data[i] += max !== data[i] ? (max - data[i]) * amt : 0;
            data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * amt : 0;
            data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * amt : 0;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {TWebGLUniformLocationMap} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uVibrance, -this.vibrance);
    }
    isNeutralState() {
        return this.vibrance === 0;
    }
}
/**
 * Vibrance value, from -1 to 1.
 * Increases/decreases the saturation of more muted colors with less effect on saturated colors.
 * A value of 0 has no effect.
 *
 * @param {Number} vibrance
 * @default
 */ $ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Vibrance, "type", "Vibrance");
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Vibrance, "defaults", $ab3f2a5cc6216ae5$var$vibranceDefaultValues);
$ab3f2a5cc6216ae5$var$_defineProperty($ab3f2a5cc6216ae5$var$Vibrance, "uniformLocations", [
    "uVibrance"
]);
$ab3f2a5cc6216ae5$export$2792378e23a7920c.setClass($ab3f2a5cc6216ae5$var$Vibrance);
var $ab3f2a5cc6216ae5$export$82462a21aead86ed = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BaseFilter: $ab3f2a5cc6216ae5$var$BaseFilter,
    BlackWhite: $ab3f2a5cc6216ae5$var$BlackWhite,
    BlendColor: $ab3f2a5cc6216ae5$var$BlendColor,
    BlendImage: $ab3f2a5cc6216ae5$var$BlendImage,
    Blur: $ab3f2a5cc6216ae5$var$Blur,
    Brightness: $ab3f2a5cc6216ae5$var$Brightness,
    Brownie: $ab3f2a5cc6216ae5$var$Brownie,
    ColorMatrix: $ab3f2a5cc6216ae5$var$ColorMatrix,
    Composed: $ab3f2a5cc6216ae5$var$Composed,
    Contrast: $ab3f2a5cc6216ae5$var$Contrast,
    Convolute: $ab3f2a5cc6216ae5$var$Convolute,
    Gamma: $ab3f2a5cc6216ae5$var$Gamma,
    Grayscale: $ab3f2a5cc6216ae5$var$Grayscale,
    HueRotation: $ab3f2a5cc6216ae5$var$HueRotation,
    Invert: $ab3f2a5cc6216ae5$var$Invert,
    Kodachrome: $ab3f2a5cc6216ae5$var$Kodachrome,
    Noise: $ab3f2a5cc6216ae5$var$Noise,
    Pixelate: $ab3f2a5cc6216ae5$var$Pixelate,
    Polaroid: $ab3f2a5cc6216ae5$var$Polaroid,
    RemoveColor: $ab3f2a5cc6216ae5$var$RemoveColor,
    Resize: $ab3f2a5cc6216ae5$var$Resize,
    Saturation: $ab3f2a5cc6216ae5$var$Saturation,
    Sepia: $ab3f2a5cc6216ae5$var$Sepia,
    Technicolor: $ab3f2a5cc6216ae5$var$Technicolor,
    Vibrance: $ab3f2a5cc6216ae5$var$Vibrance,
    Vintage: $ab3f2a5cc6216ae5$var$Vintage
});



let $86029c5ac9017061$export$c944a4526d4ed4f3 = ()=>({
        emit (event, ...args) {
            for(let i = 0, callbacks = this.events[event] || [], length = callbacks.length; i < length; i++)callbacks[i](...args);
        },
        events: {},
        on (event, cb) {
            (this.events[event] ||= []).push(cb);
            return ()=>{
                this.events[event] = this.events[event]?.filter((i)=>cb !== i);
            };
        }
    });


var $7d25ac3a95a01df6$export$2e2bcd8739ae039 = (0, $86029c5ac9017061$export$c944a4526d4ed4f3)();


// https://github.com/Yahweasel/mkvdemuxjs
var $a32c94edd9349cd4$var$mkvdemuxjs = function(mkvdemuxjs) {
    // A few IDs we repeat, as "globals"
    var ID_CLUSTER = 0x1f43b675;
    var ID_TRACKENTRY = 0xae;
    // The main MKV demuxer type
    function MkvDemux() {
        // Queue of data to be demuxed
        this.queue = [];
        this.peekHi = 0;
        this.peekLo = 0;
        // Our overall position in the document
        this.pos = 0;
        // Our entire context
        this.context = [];
        // Our current context
        this.block = null;
        // Extra info used during demuxing
        this.ex = {};
    }
    MkvDemux.prototype = {
        // Push ArrayBuffer data in the queue
        push: function(data) {
            this.queue.push(data);
        },
        // Peek this many bytes from the queue
        peek: function(count) {
            if (this.queue.length <= this.peekHi) return null;
            // Special case for peeking at the beginning
            var q = this.queue[this.peekHi];
            if (this.peekLo === 0 && q.byteLength >= count) {
                this.peekLo += count;
                if (this.peekLo >= q.byteLength) {
                    this.peekHi++;
                    this.peekLo = 0;
                }
                return q;
            }
            // Special case for peeking with enough data left
            if (q.byteLength >= this.peekLo + count) {
                var ret = new Uint8Array(q).slice(this.peekLo, this.peekLo + count);
                this.peekLo += count;
                if (this.peekLo >= q.byteLength) {
                    this.peekHi++;
                    this.peekLo = 0;
                }
                return ret.buffer;
            }
            // Otherwise, construct our return
            var ret = new Uint8Array(count);
            ret.set(new Uint8Array(q).slice(this.peekLo));
            var pos = q.byteLength - this.peekLo;
            var left = count - pos;
            var i = this.peekHi + 1;
            while(left){
                if (i >= this.queue.length) return null;
                // Pull out another buffer
                var next = new Uint8Array(this.queue[i++]);
                if (next.length >= left) {
                    // This has enough to fill out the remainder
                    if (next.length === left) {
                        // Exactly enough
                        ret.set(next, pos);
                        this.peekHi = i + 1;
                        this.peekLo = 0;
                        left = 0;
                    } else {
                        // More than enough
                        ret.set(next.slice(0, left), pos);
                        this.peekHi = i;
                        this.peekLo = left;
                        left = 0;
                    }
                } else {
                    // Not enough, need the whole thing
                    ret.set(next, pos);
                    left -= next.length;
                    pos += next.length;
                }
            }
            return ret.buffer;
        },
        // Commit whatever we've peeked
        commit: function() {
            // Remove entire elements
            while(this.peekHi){
                this.pos += this.queue[0].byteLength;
                this.queue.shift();
                this.peekHi--;
            }
            // And truncate the last one
            if (this.peekLo) {
                this.pos += this.peekLo;
                var nq = new Uint8Array(this.queue[0]).slice(this.peekLo);
                if (nq.length === 0) this.queue.shift();
                else this.queue[0] = nq.buffer;
                this.peekLo = 0;
            }
            // If we've moved beyond any elements, pop them from our context
            while(this.context.length && this.context[this.context.length - 1].end <= this.pos)this.context.pop();
            if (this.context.length) this.block = this.context[this.context.length - 1];
            else this.block = null;
        },
        // Save our peek position
        savePeek: function() {
            return {
                hi: this.peekHi,
                lo: this.peekLo
            };
        },
        // Restore our peek position
        restorePeek: function(from) {
            this.peekHi = from.hi;
            this.peekLo = from.lo;
        },
        // Peek a variable-sized int (VINT)
        peekVint: function(keepMarker) {
            /* variable-size ints have a header that describes the width, then
            * the data across multiple bytes */ var pre = this.savePeek();
            var header = this.peek(1);
            if (header === null) return null;
            header = new Uint8Array(header)[0];
            // Determine how many bytes are represented by this header
            var bytes = 1;
            while(!(header & 0x80)){
                bytes++;
                header = header << 1 & 0xFF;
            }
            // Get rid of the 1 bit
            header &= 0x7F;
            header >>>= bytes - 1;
            // Now read in the whole thing
            this.restorePeek(pre);
            var whole = this.peek(bytes);
            if (whole === null) return null;
            // Then convert it
            whole = new Uint8Array(whole).slice(0, bytes);
            if (!keepMarker) whole[0] = header;
            var ret = 0;
            for(var i = 0; i < whole.length; i++){
                ret *= 0x100;
                ret += whole[i];
            }
            return ret;
        },
        // Read an EBML header
        readEBMLHeader: function() {
            var pre = this.savePeek();
            var prePos = this.pos;
            // ID
            var id = this.peekVint(true);
            if (id === null) return null;
            var length;
            // Check for the special case of unknown length, which we just ignore in our context
            var pre2 = this.savePeek();
            var x = this.peek(1);
            if (x === null) {
                this.restorePeek(pre);
                return null;
            }
            x = new Uint8Array(x)[0];
            if (x === 0xBF) // Unknown length
            length = -1;
            else {
                // Normal VINT
                this.restorePeek(pre2);
                length = this.peekVint();
                if (length === null) {
                    this.restorePeek(pre);
                    return null;
                }
            }
            // Update our context
            this.commit();
            var ret = new EBML(id, length, prePos, this.pos);
            if (length >= 0) {
                this.context.push(ret);
                this.block = ret;
            }
            return ret;
        },
        // Read the entire content of the current EBML element
        readEBMLBody: function() {
            if (this.block.length === 0) {
                this.context.pop();
                if (this.context.length) this.block = this.context[this.context.length - 1];
                else this.block = null;
                return null;
            }
            // Read it in
            var hdr = this.block;
            var len = hdr.end - this.pos;
            var ret = this.peek(len);
            if (ret === null) return null;
            // Read it, so commit
            this.commit();
            return ret;
        },
        // Read the content of the current EBML element as an unsigned integer
        readUInt: function() {
            var len = this.block.length;
            // Read it in
            var val = this.readEBMLBody();
            if (len === 0) return 0;
            if (val === null) return null;
            // Convert it
            val = new DataView(val);
            switch(len){
                case 1:
                    return val.getUint8(0);
                case 2:
                    return val.getUint16(0);
                case 4:
                    return val.getUint32(0);
                default:
                    var ret = 0;
                    val = new Uint8Array(val.buffer);
                    for(var i = 0; i < len; i++){
                        ret *= 0x100;
                        ret += val[i];
                    }
                    return ret;
            }
        },
        // Read the content of the current EBML element as a float
        readFloat: function() {
            var len = this.block.length;
            // Read it in
            var val = this.readEBMLBody();
            if (len === 0) return 0;
            if (val === null) return null;
            // Convert it
            val = new DataView(val);
            if (len === 4) return val.getFloat32(0);
            else if (len === 8) return val.getFloat64(0);
            else return 0;
        },
        /* The main demuxer. Can return one of several structures:
        * If there's not enough data to demux, returns null.
        * If it received a track entry, returns
        *  {track: {...}}
        * If it received packets, returns
        *  {frames: array({data: [data], track: [track number], timestamp: [timestamp]})}
        * If it received anything else, returns the EBML context
        */ demux: function() {
            var el;
            while(true){
                // Figure out our current context
                if (!this.context.length) this.readEBMLHeader();
                if (!this.context.length) return null;
                el = this.block;
                // We should know what to read based on that context
                switch(el.id){
                    case 0x1a45dfa3:
                    case 0x114d9b74:
                    case 0x1549a966:
                    case 0x1254c367:
                    case 0x75a2:
                    case 0xec:
                    case 0xbf:
                        // Elements we don't care about. Skip them.
                        var ct = this.readEBMLBody();
                        if (ct === null) return null;
                        el.ex.content = ct;
                        return el;
                    case 0x18538067:
                    case 0x1654ae6b:
                    case ID_CLUSTER:
                    case 0xa0:
                        // Surrounding elements we need to dig into
                        if (this.readEBMLHeader() === null) return null;
                        this.ex = {};
                        break;
                    case ID_TRACKENTRY:
                        // A track description. Read it fully.
                        return this.readTrackEntry();
                    case 0xe7:
                        var val = this.readUInt();
                        if (val === null) return null;
                        this.ex.clusterTimestamp = val;
                        break;
                    case 0xa1:
                    case 0xa3:
                        return this.decodeBlock();
                    default:
                        // We don't know what this is!
                        var ct = this.readEBMLBody();
                        if (ct === null) return null;
                        //console.log("Unrecognized element " + el.id.toString(16) + " at " + el.start.toString(16) + " to " + el.end.toString(16));
                        //console.log("Context:");
                        //for (var i = 0; i < this.context.length; i++)
                        //    console.log("  " + this.context[i].id.toString(16));
                        el.ex.content = ct;
                        return el;
                }
            }
        },
        // Read and decode a track entry
        readTrackEntry: function() {
            var te = this.block;
            var len = te.end - this.pos;
            // Make sure it's all here
            var pre = this.savePeek();
            if (this.peek(len) === null) return null;
            this.restorePeek(pre);
            var ret = {
                track: {}
            };
            // Now read in each of the parts
            while(this.block === te){
                var hdr = this.readEBMLHeader();
                if (hdr === null) return null;
                switch(hdr.id){
                    case 0x9c:
                    case 0x22b59c:
                    case 0x56bb:
                    case 0x63a2:
                        // Irrelevant for us, just skip it
                        this.readEBMLBody();
                        break;
                    case 0xe1:
                        // We need the actual body of this
                        this.context.pop();
                        this.block = te;
                        break;
                    case 0xd7:
                        ret.track.number = this.readUInt();
                        break;
                    case 0x73c5:
                        ret.track.uid = this.readUInt();
                        break;
                    case 0x86:
                        ret.track.codec = this.readUInt();
                        break;
                    case 0x56aa:
                        ret.track.codecDelay = this.readUInt() / 1000000000;
                        break;
                    case 0x83:
                        var ct = ret.track.codecType = this.readUInt();
                        var t = "unknown";
                        switch(ct){
                            case 1:
                                t = "video";
                                break;
                            case 2:
                                t = "audio";
                                break;
                        }
                        ret.track.type = t;
                        break;
                    case 0x9f:
                        ret.track.channels = this.readUInt();
                        break;
                    case 0xb5:
                        ret.track.sampleRate = this.readFloat();
                        break;
                    case 0x6264:
                        ret.track.bitDepth = this.readUInt();
                        break;
                    default:
                        //console.log("Unrecognized track entry component " + hdr.id.toString(16));
                        this.readEBMLBody();
                }
            }
            return ret;
        },
        // Decode a single Block or SimpleBlock
        decodeBlock: function() {
            var len = this.block.length;
            var cont = this.readEBMLBody();
            if (cont === null) return null;
            cont = new DataView(cont);
            // Surrounding data
            var ret = {};
            var clusterTimestamp = this.ex.clusterTimestamp;
            if (!clusterTimestamp) clusterTimestamp = 0;
            // Byte 0: Track number
            var track = cont.getUint8(0);
            //if (!(track & 0x80))
            //    console.log("ERROR: Track #s greater than 127 are not supported!");
            track &= 0x7F;
            // Bytes 1 and 2: Timecode offset
            var timeOff = cont.getInt16(1);
            var timestamp = (clusterTimestamp + timeOff) / 1000;
            // Byte 3: Flags
            var flags = cont.getUint8(3);
            //if ((flags & 0x6) !== 0)
            //    console.log("ERROR: Lacing is not supported!");
            // Rest: The actual data
            var frame = {
                data: new Uint8Array(cont.buffer).slice(4, len).buffer,
                track: track,
                timestamp: timestamp
            };
            ret.frames = [
                frame
            ];
            return ret;
        }
    };
    // An EBML "tag"
    function EBML(id, length, start, bodyStart) {
        this.id = id;
        this.length = length;
        this.start = start;
        this.bodyStart = bodyStart;
        if (length >= 0) this.end = bodyStart + length;
        else this.end = Infinity;
        this.ex = {}; // Extra context stored by the main demuxer
    }
    mkvdemuxjs.MkvDemux = MkvDemux;
    return mkvdemuxjs;
}($a32c94edd9349cd4$var$mkvdemuxjs || {});
var $a32c94edd9349cd4$export$2e2bcd8739ae039 = $a32c94edd9349cd4$var$mkvdemuxjs;


var $c9a1fd49277acae3$exports = {};

$parcel$export($c9a1fd49277acae3$exports, "Log", () => $c9a1fd49277acae3$export$ce30dbb46644d06c, (v) => $c9a1fd49277acae3$export$ce30dbb46644d06c = v);
$parcel$export($c9a1fd49277acae3$exports, "MP4BoxStream", () => $c9a1fd49277acae3$export$356b3738302e5719, (v) => $c9a1fd49277acae3$export$356b3738302e5719 = v);
$parcel$export($c9a1fd49277acae3$exports, "DataStream", () => $c9a1fd49277acae3$export$521135ae501c2f0e, (v) => $c9a1fd49277acae3$export$521135ae501c2f0e = v);
$parcel$export($c9a1fd49277acae3$exports, "MultiBufferStream", () => $c9a1fd49277acae3$export$333a810def2b997b, (v) => $c9a1fd49277acae3$export$333a810def2b997b = v);
$parcel$export($c9a1fd49277acae3$exports, "MPEG4DescriptorParser", () => $c9a1fd49277acae3$export$1d8aeb4422bb5a36, (v) => $c9a1fd49277acae3$export$1d8aeb4422bb5a36 = v);
$parcel$export($c9a1fd49277acae3$exports, "BoxParser", () => $c9a1fd49277acae3$export$b57d5724b61aff09, (v) => $c9a1fd49277acae3$export$b57d5724b61aff09 = v);
$parcel$export($c9a1fd49277acae3$exports, "XMLSubtitlein4Parser", () => $c9a1fd49277acae3$export$43507abd4cdcd72e, (v) => $c9a1fd49277acae3$export$43507abd4cdcd72e = v);
$parcel$export($c9a1fd49277acae3$exports, "Textin4Parser", () => $c9a1fd49277acae3$export$2093b46416a25787, (v) => $c9a1fd49277acae3$export$2093b46416a25787 = v);
$parcel$export($c9a1fd49277acae3$exports, "ISOFile", () => $c9a1fd49277acae3$export$b0b6eee45040a3ad, (v) => $c9a1fd49277acae3$export$b0b6eee45040a3ad = v);
$parcel$export($c9a1fd49277acae3$exports, "createFile", () => $c9a1fd49277acae3$export$982c3a0b9a5cde94, (v) => $c9a1fd49277acae3$export$982c3a0b9a5cde94 = v);
// file:src/log.js
/* 
 * Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */ var $c9a1fd49277acae3$export$ce30dbb46644d06c;
var $c9a1fd49277acae3$export$356b3738302e5719;
var $c9a1fd49277acae3$export$521135ae501c2f0e;
var $c9a1fd49277acae3$export$333a810def2b997b;
var $c9a1fd49277acae3$export$1d8aeb4422bb5a36;
var $c9a1fd49277acae3$export$b57d5724b61aff09;
var $c9a1fd49277acae3$export$43507abd4cdcd72e;
var $c9a1fd49277acae3$export$2093b46416a25787;
var $c9a1fd49277acae3$export$b0b6eee45040a3ad;
var $c9a1fd49277acae3$export$982c3a0b9a5cde94;
var $c9a1fd49277acae3$var$Log = function() {
    var start = new Date();
    var LOG_LEVEL_ERROR = 4;
    var LOG_LEVEL_WARNING = 3;
    var LOG_LEVEL_INFO = 2;
    var LOG_LEVEL_DEBUG = 1;
    var log_level = LOG_LEVEL_ERROR;
    var logObject = {
        setLogLevel: function(level) {
            if (level == this.debug) log_level = LOG_LEVEL_DEBUG;
            else if (level == this.info) log_level = LOG_LEVEL_INFO;
            else if (level == this.warn) log_level = LOG_LEVEL_WARNING;
            else if (level == this.error) log_level = LOG_LEVEL_ERROR;
            else log_level = LOG_LEVEL_ERROR;
        },
        debug: function(module, msg) {
            if (console.debug === undefined) console.debug = console.log;
            if (LOG_LEVEL_DEBUG >= log_level) console.debug("[" + $c9a1fd49277acae3$var$Log.getDurationString(new Date() - start, 1000) + "]", "[" + module + "]", msg);
        },
        log: function(module, msg) {
            this.debug(module.msg);
        },
        info: function(module, msg) {
            if (LOG_LEVEL_INFO >= log_level) console.info("[" + $c9a1fd49277acae3$var$Log.getDurationString(new Date() - start, 1000) + "]", "[" + module + "]", msg);
        },
        warn: function(module, msg) {
            if (LOG_LEVEL_WARNING >= log_level) console.warn("[" + $c9a1fd49277acae3$var$Log.getDurationString(new Date() - start, 1000) + "]", "[" + module + "]", msg);
        },
        error: function(module, msg) {
            if (LOG_LEVEL_ERROR >= log_level) console.error("[" + $c9a1fd49277acae3$var$Log.getDurationString(new Date() - start, 1000) + "]", "[" + module + "]", msg);
        }
    };
    return logObject;
}();
/* Helper function to print a duration value in the form H:MM:SS.MS */ $c9a1fd49277acae3$var$Log.getDurationString = function(duration, _timescale) {
    var neg;
    /* Helper function to print a number on a fixed number of digits */ function pad(number, length) {
        var str = "" + number;
        var a = str.split(".");
        while(a[0].length < length)a[0] = "0" + a[0];
        return a.join(".");
    }
    if (duration < 0) {
        neg = true;
        duration = -duration;
    } else neg = false;
    var timescale = _timescale || 1;
    var duration_sec = duration / timescale;
    var hours = Math.floor(duration_sec / 3600);
    duration_sec -= hours * 3600;
    var minutes = Math.floor(duration_sec / 60);
    duration_sec -= minutes * 60;
    var msec = duration_sec * 1000;
    duration_sec = Math.floor(duration_sec);
    msec -= duration_sec * 1000;
    msec = Math.floor(msec);
    return (neg ? "-" : "") + hours + ":" + pad(minutes, 2) + ":" + pad(duration_sec, 2) + "." + pad(msec, 3);
};
/* Helper function to stringify HTML5 TimeRanges objects */ $c9a1fd49277acae3$var$Log.printRanges = function(ranges) {
    var length = ranges.length;
    if (length > 0) {
        var str = "";
        for(var i1 = 0; i1 < length; i1++){
            if (i1 > 0) str += ",";
            str += "[" + $c9a1fd49277acae3$var$Log.getDurationString(ranges.start(i1)) + "," + $c9a1fd49277acae3$var$Log.getDurationString(ranges.end(i1)) + "]";
        }
        return str;
    } else return "(empty)";
};
$c9a1fd49277acae3$export$ce30dbb46644d06c = $c9a1fd49277acae3$var$Log;
// file:src/stream.js
var $c9a1fd49277acae3$var$MP4BoxStream = function(arrayBuffer) {
    if (arrayBuffer instanceof ArrayBuffer) {
        this.buffer = arrayBuffer;
        this.dataview = new DataView(arrayBuffer);
    } else throw "Needs an array buffer";
    this.position = 0;
};
/*************************************************************************
Common API between MultiBufferStream and SimpleStream
*************************************************************************/ $c9a1fd49277acae3$var$MP4BoxStream.prototype.getPosition = function() {
    return this.position;
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.getEndPosition = function() {
    return this.buffer.byteLength;
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.getLength = function() {
    return this.buffer.byteLength;
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.seek = function(pos) {
    var npos = Math.max(0, Math.min(this.buffer.byteLength, pos));
    this.position = isNaN(npos) || !isFinite(npos) ? 0 : npos;
    return true;
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.isEos = function() {
    return this.getPosition() >= this.getEndPosition();
};
/*************************************************************************
Read methods, simimar to DataStream but simpler
*************************************************************************/ $c9a1fd49277acae3$var$MP4BoxStream.prototype.readAnyInt = function(size, signed) {
    var res = 0;
    if (this.position + size <= this.buffer.byteLength) {
        switch(size){
            case 1:
                if (signed) res = this.dataview.getInt8(this.position);
                else res = this.dataview.getUint8(this.position);
                break;
            case 2:
                if (signed) res = this.dataview.getInt16(this.position);
                else res = this.dataview.getUint16(this.position);
                break;
            case 3:
                if (signed) throw "No method for reading signed 24 bits values";
                else {
                    res = this.dataview.getUint8(this.position) << 16;
                    res |= this.dataview.getUint8(this.position + 1) << 8;
                    res |= this.dataview.getUint8(this.position + 2);
                }
                break;
            case 4:
                if (signed) res = this.dataview.getInt32(this.position);
                else res = this.dataview.getUint32(this.position);
                break;
            case 8:
                if (signed) throw "No method for reading signed 64 bits values";
                else {
                    res = this.dataview.getUint32(this.position) << 32;
                    res |= this.dataview.getUint32(this.position + 4);
                }
                break;
            default:
                throw "readInt method not implemented for size: " + size;
        }
        this.position += size;
        return res;
    } else throw "Not enough bytes in buffer";
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readUint8 = function() {
    return this.readAnyInt(1, false);
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readUint16 = function() {
    return this.readAnyInt(2, false);
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readUint24 = function() {
    return this.readAnyInt(3, false);
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readUint32 = function() {
    return this.readAnyInt(4, false);
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readUint64 = function() {
    return this.readAnyInt(8, false);
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readString = function(length) {
    if (this.position + length <= this.buffer.byteLength) {
        var s = "";
        for(var i1 = 0; i1 < length; i1++)s += String.fromCharCode(this.readUint8());
        return s;
    } else throw "Not enough bytes in buffer";
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readCString = function() {
    var arr = [];
    while(true){
        var b = this.readUint8();
        if (b !== 0) arr.push(b);
        else break;
    }
    return String.fromCharCode.apply(null, arr);
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readInt8 = function() {
    return this.readAnyInt(1, true);
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readInt16 = function() {
    return this.readAnyInt(2, true);
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readInt32 = function() {
    return this.readAnyInt(4, true);
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readInt64 = function() {
    return this.readAnyInt(8, false);
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readUint8Array = function(length) {
    var arr = new Uint8Array(length);
    for(var i1 = 0; i1 < length; i1++)arr[i1] = this.readUint8();
    return arr;
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readInt16Array = function(length) {
    var arr = new Int16Array(length);
    for(var i1 = 0; i1 < length; i1++)arr[i1] = this.readInt16();
    return arr;
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readUint16Array = function(length) {
    var arr = new Int16Array(length);
    for(var i1 = 0; i1 < length; i1++)arr[i1] = this.readUint16();
    return arr;
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readUint32Array = function(length) {
    var arr = new Uint32Array(length);
    for(var i1 = 0; i1 < length; i1++)arr[i1] = this.readUint32();
    return arr;
};
$c9a1fd49277acae3$var$MP4BoxStream.prototype.readInt32Array = function(length) {
    var arr = new Int32Array(length);
    for(var i1 = 0; i1 < length; i1++)arr[i1] = this.readInt32();
    return arr;
};
$c9a1fd49277acae3$export$356b3738302e5719 = $c9a1fd49277acae3$var$MP4BoxStream;
/**
DataStream reads scalars, arrays and structs of data from an ArrayBuffer.
It's like a file-like DataView on steroids.

@param {ArrayBuffer} arrayBuffer ArrayBuffer to read from.
@param {?Number} byteOffset Offset from arrayBuffer beginning for the DataStream.
@param {?Boolean} endianness DataStream.BIG_ENDIAN or DataStream.LITTLE_ENDIAN (the default).
*/ var $c9a1fd49277acae3$var$DataStream = function(arrayBuffer, byteOffset, endianness) {
    this._byteOffset = byteOffset || 0;
    if (arrayBuffer instanceof ArrayBuffer) this.buffer = arrayBuffer;
    else if (typeof arrayBuffer == "object") {
        this.dataView = arrayBuffer;
        if (byteOffset) this._byteOffset += byteOffset;
    } else this.buffer = new ArrayBuffer(arrayBuffer || 0);
    this.position = 0;
    this.endianness = endianness == null ? $c9a1fd49277acae3$var$DataStream.LITTLE_ENDIAN : endianness;
};
$c9a1fd49277acae3$var$DataStream.prototype = {};
$c9a1fd49277acae3$var$DataStream.prototype.getPosition = function() {
    return this.position;
};
/**
Internal function to resize the DataStream buffer when required.
@param {number} extra Number of bytes to add to the buffer allocation.
@return {null}
*/ $c9a1fd49277acae3$var$DataStream.prototype._realloc = function(extra) {
    if (!this._dynamicSize) return;
    var req = this._byteOffset + this.position + extra;
    var blen = this._buffer.byteLength;
    if (req <= blen) {
        if (req > this._byteLength) this._byteLength = req;
        return;
    }
    if (blen < 1) blen = 1;
    while(req > blen)blen *= 2;
    var buf = new ArrayBuffer(blen);
    var src = new Uint8Array(this._buffer);
    var dst = new Uint8Array(buf, 0, src.length);
    dst.set(src);
    this.buffer = buf;
    this._byteLength = req;
};
/**
Internal function to trim the DataStream buffer when required.
Used for stripping out the extra bytes from the backing buffer when
the virtual byteLength is smaller than the buffer byteLength (happens after
growing the buffer with writes and not filling the extra space completely).

@return {null}
*/ $c9a1fd49277acae3$var$DataStream.prototype._trimAlloc = function() {
    if (this._byteLength == this._buffer.byteLength) return;
    var buf = new ArrayBuffer(this._byteLength);
    var dst = new Uint8Array(buf);
    var src = new Uint8Array(this._buffer, 0, dst.length);
    dst.set(src);
    this.buffer = buf;
};
/**
Big-endian const to use as default endianness.
@type {boolean}
*/ $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN = false;
/**
Little-endian const to use as default endianness.
@type {boolean}
*/ $c9a1fd49277acae3$var$DataStream.LITTLE_ENDIAN = true;
/**
Virtual byte length of the DataStream backing buffer.
Updated to be max of original buffer size and last written size.
If dynamicSize is false is set to buffer size.
@type {number}
*/ $c9a1fd49277acae3$var$DataStream.prototype._byteLength = 0;
/**
Returns the byte length of the DataStream object.
@type {number}
*/ Object.defineProperty($c9a1fd49277acae3$var$DataStream.prototype, "byteLength", {
    get: function() {
        return this._byteLength - this._byteOffset;
    }
});
/**
Set/get the backing ArrayBuffer of the DataStream object.
The setter updates the DataView to point to the new buffer.
@type {Object}
*/ Object.defineProperty($c9a1fd49277acae3$var$DataStream.prototype, "buffer", {
    get: function() {
        this._trimAlloc();
        return this._buffer;
    },
    set: function(v) {
        this._buffer = v;
        this._dataView = new DataView(this._buffer, this._byteOffset);
        this._byteLength = this._buffer.byteLength;
    }
});
/**
Set/get the byteOffset of the DataStream object.
The setter updates the DataView to point to the new byteOffset.
@type {number}
*/ Object.defineProperty($c9a1fd49277acae3$var$DataStream.prototype, "byteOffset", {
    get: function() {
        return this._byteOffset;
    },
    set: function(v) {
        this._byteOffset = v;
        this._dataView = new DataView(this._buffer, this._byteOffset);
        this._byteLength = this._buffer.byteLength;
    }
});
/**
Set/get the backing DataView of the DataStream object.
The setter updates the buffer and byteOffset to point to the DataView values.
@type {Object}
*/ Object.defineProperty($c9a1fd49277acae3$var$DataStream.prototype, "dataView", {
    get: function() {
        return this._dataView;
    },
    set: function(v) {
        this._byteOffset = v.byteOffset;
        this._buffer = v.buffer;
        this._dataView = new DataView(this._buffer, this._byteOffset);
        this._byteLength = this._byteOffset + v.byteLength;
    }
});
/**
Sets the DataStream read/write position to given position.
Clamps between 0 and DataStream length.

@param {number} pos Position to seek to.
@return {null}
*/ $c9a1fd49277acae3$var$DataStream.prototype.seek = function(pos) {
    var npos = Math.max(0, Math.min(this.byteLength, pos));
    this.position = isNaN(npos) || !isFinite(npos) ? 0 : npos;
};
/**
Returns true if the DataStream seek pointer is at the end of buffer and
there's no more data to read.

@return {boolean} True if the seek pointer is at the end of the buffer.
*/ $c9a1fd49277acae3$var$DataStream.prototype.isEof = function() {
    return this.position >= this._byteLength;
};
/**
Maps a Uint8Array into the DataStream buffer.

Nice for quickly reading in data.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} Uint8Array to the DataStream backing buffer.
*/ $c9a1fd49277acae3$var$DataStream.prototype.mapUint8Array = function(length) {
    this._realloc(length * 1);
    var arr = new Uint8Array(this._buffer, this.byteOffset + this.position, length);
    this.position += length * 1;
    return arr;
};
/**
Reads an Int32Array of desired length and endianness from the DataStream.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} The read Int32Array.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readInt32Array = function(length, e) {
    length = length == null ? this.byteLength - this.position / 4 : length;
    var arr = new Int32Array(length);
    $c9a1fd49277acae3$var$DataStream.memcpy(arr.buffer, 0, this.buffer, this.byteOffset + this.position, length * arr.BYTES_PER_ELEMENT);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += arr.byteLength;
    return arr;
};
/**
Reads an Int16Array of desired length and endianness from the DataStream.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} The read Int16Array.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readInt16Array = function(length, e) {
    length = length == null ? this.byteLength - this.position / 2 : length;
    var arr = new Int16Array(length);
    $c9a1fd49277acae3$var$DataStream.memcpy(arr.buffer, 0, this.buffer, this.byteOffset + this.position, length * arr.BYTES_PER_ELEMENT);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += arr.byteLength;
    return arr;
};
/**
Reads an Int8Array of desired length from the DataStream.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} The read Int8Array.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readInt8Array = function(length) {
    length = length == null ? this.byteLength - this.position : length;
    var arr = new Int8Array(length);
    $c9a1fd49277acae3$var$DataStream.memcpy(arr.buffer, 0, this.buffer, this.byteOffset + this.position, length * arr.BYTES_PER_ELEMENT);
    this.position += arr.byteLength;
    return arr;
};
/**
Reads a Uint32Array of desired length and endianness from the DataStream.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} The read Uint32Array.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readUint32Array = function(length, e) {
    length = length == null ? this.byteLength - this.position / 4 : length;
    var arr = new Uint32Array(length);
    $c9a1fd49277acae3$var$DataStream.memcpy(arr.buffer, 0, this.buffer, this.byteOffset + this.position, length * arr.BYTES_PER_ELEMENT);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += arr.byteLength;
    return arr;
};
/**
Reads a Uint16Array of desired length and endianness from the DataStream.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} The read Uint16Array.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readUint16Array = function(length, e) {
    length = length == null ? this.byteLength - this.position / 2 : length;
    var arr = new Uint16Array(length);
    $c9a1fd49277acae3$var$DataStream.memcpy(arr.buffer, 0, this.buffer, this.byteOffset + this.position, length * arr.BYTES_PER_ELEMENT);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += arr.byteLength;
    return arr;
};
/**
Reads a Uint8Array of desired length from the DataStream.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} The read Uint8Array.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readUint8Array = function(length) {
    length = length == null ? this.byteLength - this.position : length;
    var arr = new Uint8Array(length);
    $c9a1fd49277acae3$var$DataStream.memcpy(arr.buffer, 0, this.buffer, this.byteOffset + this.position, length * arr.BYTES_PER_ELEMENT);
    this.position += arr.byteLength;
    return arr;
};
/**
Reads a Float64Array of desired length and endianness from the DataStream.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} The read Float64Array.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readFloat64Array = function(length, e) {
    length = length == null ? this.byteLength - this.position / 8 : length;
    var arr = new Float64Array(length);
    $c9a1fd49277acae3$var$DataStream.memcpy(arr.buffer, 0, this.buffer, this.byteOffset + this.position, length * arr.BYTES_PER_ELEMENT);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += arr.byteLength;
    return arr;
};
/**
Reads a Float32Array of desired length and endianness from the DataStream.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} The read Float32Array.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readFloat32Array = function(length, e) {
    length = length == null ? this.byteLength - this.position / 4 : length;
    var arr = new Float32Array(length);
    $c9a1fd49277acae3$var$DataStream.memcpy(arr.buffer, 0, this.buffer, this.byteOffset + this.position, length * arr.BYTES_PER_ELEMENT);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += arr.byteLength;
    return arr;
};
/**
Reads a 32-bit int from the DataStream with the desired endianness.

@param {?boolean} e Endianness of the number.
@return {number} The read number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readInt32 = function(e) {
    var v = this._dataView.getInt32(this.position, e == null ? this.endianness : e);
    this.position += 4;
    return v;
};
/**
Reads a 16-bit int from the DataStream with the desired endianness.

@param {?boolean} e Endianness of the number.
@return {number} The read number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readInt16 = function(e) {
    var v = this._dataView.getInt16(this.position, e == null ? this.endianness : e);
    this.position += 2;
    return v;
};
/**
Reads an 8-bit int from the DataStream.

@return {number} The read number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readInt8 = function() {
    var v = this._dataView.getInt8(this.position);
    this.position += 1;
    return v;
};
/**
Reads a 32-bit unsigned int from the DataStream with the desired endianness.

@param {?boolean} e Endianness of the number.
@return {number} The read number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readUint32 = function(e) {
    var v = this._dataView.getUint32(this.position, e == null ? this.endianness : e);
    this.position += 4;
    return v;
};
/**
Reads a 16-bit unsigned int from the DataStream with the desired endianness.

@param {?boolean} e Endianness of the number.
@return {number} The read number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readUint16 = function(e) {
    var v = this._dataView.getUint16(this.position, e == null ? this.endianness : e);
    this.position += 2;
    return v;
};
/**
Reads an 8-bit unsigned int from the DataStream.

@return {number} The read number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readUint8 = function() {
    var v = this._dataView.getUint8(this.position);
    this.position += 1;
    return v;
};
/**
Reads a 32-bit float from the DataStream with the desired endianness.

@param {?boolean} e Endianness of the number.
@return {number} The read number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readFloat32 = function(e) {
    var v = this._dataView.getFloat32(this.position, e == null ? this.endianness : e);
    this.position += 4;
    return v;
};
/**
Reads a 64-bit float from the DataStream with the desired endianness.

@param {?boolean} e Endianness of the number.
@return {number} The read number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readFloat64 = function(e) {
    var v = this._dataView.getFloat64(this.position, e == null ? this.endianness : e);
    this.position += 8;
    return v;
};
/**
Native endianness. Either DataStream.BIG_ENDIAN or DataStream.LITTLE_ENDIAN
depending on the platform endianness.

@type {boolean}
*/ $c9a1fd49277acae3$var$DataStream.endianness = new Int8Array(new Int16Array([
    1
]).buffer)[0] > 0;
/**
Copies byteLength bytes from the src buffer at srcOffset to the
dst buffer at dstOffset.

@param {Object} dst Destination ArrayBuffer to write to.
@param {number} dstOffset Offset to the destination ArrayBuffer.
@param {Object} src Source ArrayBuffer to read from.
@param {number} srcOffset Offset to the source ArrayBuffer.
@param {number} byteLength Number of bytes to copy.
*/ $c9a1fd49277acae3$var$DataStream.memcpy = function(dst, dstOffset, src, srcOffset, byteLength) {
    var dstU8 = new Uint8Array(dst, dstOffset, byteLength);
    var srcU8 = new Uint8Array(src, srcOffset, byteLength);
    dstU8.set(srcU8);
};
/**
Converts array to native endianness in-place.

@param {Object} array Typed array to convert.
@param {boolean} arrayIsLittleEndian True if the data in the array is
                                   little-endian. Set false for big-endian.
@return {Object} The converted typed array.
*/ $c9a1fd49277acae3$var$DataStream.arrayToNative = function(array, arrayIsLittleEndian) {
    if (arrayIsLittleEndian == this.endianness) return array;
    else return this.flipArrayEndianness(array);
};
/**
Converts native endianness array to desired endianness in-place.

@param {Object} array Typed array to convert.
@param {boolean} littleEndian True if the converted array should be
                            little-endian. Set false for big-endian.
@return {Object} The converted typed array.
*/ $c9a1fd49277acae3$var$DataStream.nativeToEndian = function(array, littleEndian) {
    if (this.endianness == littleEndian) return array;
    else return this.flipArrayEndianness(array);
};
/**
Flips typed array endianness in-place.

@param {Object} array Typed array to flip.
@return {Object} The converted typed array.
*/ $c9a1fd49277acae3$var$DataStream.flipArrayEndianness = function(array) {
    var u8 = new Uint8Array(array.buffer, array.byteOffset, array.byteLength);
    for(var i1 = 0; i1 < array.byteLength; i1 += array.BYTES_PER_ELEMENT)for(var j = i1 + array.BYTES_PER_ELEMENT - 1, k = i1; j > k; j--, k++){
        var tmp = u8[k];
        u8[k] = u8[j];
        u8[j] = tmp;
    }
    return array;
};
/**
Seek position where DataStream#readStruct ran into a problem.
Useful for debugging struct parsing.

@type {number}
*/ $c9a1fd49277acae3$var$DataStream.prototype.failurePosition = 0;
String.fromCharCodeUint8 = function(uint8arr) {
    var arr = [];
    for(var i1 = 0; i1 < uint8arr.length; i1++)arr[i1] = uint8arr[i1];
    return String.fromCharCode.apply(null, arr);
};
/**
Read a string of desired length and encoding from the DataStream.

@param {number} length The length of the string to read in bytes.
@param {?string} encoding The encoding of the string data in the DataStream.
                        Defaults to ASCII.
@return {string} The read string.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readString = function(length, encoding) {
    if (encoding == null || encoding == "ASCII") return String.fromCharCodeUint8.apply(null, [
        this.mapUint8Array(length == null ? this.byteLength - this.position : length)
    ]);
    else return new TextDecoder(encoding).decode(this.mapUint8Array(length));
};
/**
Read null-terminated string of desired length from the DataStream. Truncates
the returned string so that the null byte is not a part of it.

@param {?number} length The length of the string to read.
@return {string} The read string.
*/ $c9a1fd49277acae3$var$DataStream.prototype.readCString = function(length) {
    var blen = this.byteLength - this.position;
    var u8 = new Uint8Array(this._buffer, this._byteOffset + this.position);
    var len = blen;
    if (length != null) len = Math.min(length, blen);
    for(var i1 = 0; i1 < len && u8[i1] !== 0; i1++); // find first zero byte
    var s = String.fromCharCodeUint8.apply(null, [
        this.mapUint8Array(i1)
    ]);
    if (length != null) this.position += len - i1;
    else if (i1 != blen) this.position += 1; // trailing zero if not at end of buffer
    return s;
};
/* 
TODO: fix endianness for 24/64-bit fields
TODO: check range/support for 64-bits numbers in JavaScript
*/ var $c9a1fd49277acae3$var$MAX_SIZE = Math.pow(2, 32);
$c9a1fd49277acae3$var$DataStream.prototype.readInt64 = function() {
    return this.readInt32() * $c9a1fd49277acae3$var$MAX_SIZE + this.readUint32();
};
$c9a1fd49277acae3$var$DataStream.prototype.readUint64 = function() {
    return this.readUint32() * $c9a1fd49277acae3$var$MAX_SIZE + this.readUint32();
};
$c9a1fd49277acae3$var$DataStream.prototype.readInt64 = function() {
    return this.readUint32() * $c9a1fd49277acae3$var$MAX_SIZE + this.readUint32();
};
$c9a1fd49277acae3$var$DataStream.prototype.readUint24 = function() {
    return (this.readUint8() << 16) + (this.readUint8() << 8) + this.readUint8();
};
$c9a1fd49277acae3$export$521135ae501c2f0e = $c9a1fd49277acae3$var$DataStream;
// file:src/DataStream-write.js
/**
Saves the DataStream contents to the given filename.
Uses Chrome's anchor download property to initiate download.

@param {string} filename Filename to save as.
@return {null}
*/ $c9a1fd49277acae3$var$DataStream.prototype.save = function(filename) {
    var blob = new Blob([
        this.buffer
    ]);
    if (window.URL && URL.createObjectURL) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        // Required in Firefox:
        document.body.appendChild(a);
        a.setAttribute("href", url);
        a.setAttribute("download", filename);
        // Required in Firefox:
        a.setAttribute("target", "_self");
        a.click();
        window.URL.revokeObjectURL(url);
    } else throw "DataStream.save: Can't create object URL.";
};
/**
Whether to extend DataStream buffer when trying to write beyond its size.
If set, the buffer is reallocated to twice its current size until the
requested write fits the buffer.
@type {boolean}
*/ $c9a1fd49277acae3$var$DataStream.prototype._dynamicSize = true;
Object.defineProperty($c9a1fd49277acae3$var$DataStream.prototype, "dynamicSize", {
    get: function() {
        return this._dynamicSize;
    },
    set: function(v) {
        if (!v) this._trimAlloc();
        this._dynamicSize = v;
    }
});
/**
Internal function to trim the DataStream buffer when required.
Used for stripping out the first bytes when not needed anymore.

@return {null}
*/ $c9a1fd49277acae3$var$DataStream.prototype.shift = function(offset) {
    var buf = new ArrayBuffer(this._byteLength - offset);
    var dst = new Uint8Array(buf);
    var src = new Uint8Array(this._buffer, offset, dst.length);
    dst.set(src);
    this.buffer = buf;
    this.position -= offset;
};
/**
Writes an Int32Array of specified endianness to the DataStream.

@param {Object} arr The array to write.
@param {?boolean} e Endianness of the data to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeInt32Array = function(arr, e) {
    this._realloc(arr.length * 4);
    if (arr instanceof Int32Array && this.byteOffset + this.position % arr.BYTES_PER_ELEMENT === 0) {
        $c9a1fd49277acae3$var$DataStream.memcpy(this._buffer, this.byteOffset + this.position, arr.buffer, 0, arr.byteLength);
        this.mapInt32Array(arr.length, e);
    } else for(var i1 = 0; i1 < arr.length; i1++)this.writeInt32(arr[i1], e);
};
/**
Writes an Int16Array of specified endianness to the DataStream.

@param {Object} arr The array to write.
@param {?boolean} e Endianness of the data to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeInt16Array = function(arr, e) {
    this._realloc(arr.length * 2);
    if (arr instanceof Int16Array && this.byteOffset + this.position % arr.BYTES_PER_ELEMENT === 0) {
        $c9a1fd49277acae3$var$DataStream.memcpy(this._buffer, this.byteOffset + this.position, arr.buffer, 0, arr.byteLength);
        this.mapInt16Array(arr.length, e);
    } else for(var i1 = 0; i1 < arr.length; i1++)this.writeInt16(arr[i1], e);
};
/**
Writes an Int8Array to the DataStream.

@param {Object} arr The array to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeInt8Array = function(arr) {
    this._realloc(arr.length * 1);
    if (arr instanceof Int8Array && this.byteOffset + this.position % arr.BYTES_PER_ELEMENT === 0) {
        $c9a1fd49277acae3$var$DataStream.memcpy(this._buffer, this.byteOffset + this.position, arr.buffer, 0, arr.byteLength);
        this.mapInt8Array(arr.length);
    } else for(var i1 = 0; i1 < arr.length; i1++)this.writeInt8(arr[i1]);
};
/**
Writes a Uint32Array of specified endianness to the DataStream.

@param {Object} arr The array to write.
@param {?boolean} e Endianness of the data to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeUint32Array = function(arr, e) {
    this._realloc(arr.length * 4);
    if (arr instanceof Uint32Array && this.byteOffset + this.position % arr.BYTES_PER_ELEMENT === 0) {
        $c9a1fd49277acae3$var$DataStream.memcpy(this._buffer, this.byteOffset + this.position, arr.buffer, 0, arr.byteLength);
        this.mapUint32Array(arr.length, e);
    } else for(var i1 = 0; i1 < arr.length; i1++)this.writeUint32(arr[i1], e);
};
/**
Writes a Uint16Array of specified endianness to the DataStream.

@param {Object} arr The array to write.
@param {?boolean} e Endianness of the data to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeUint16Array = function(arr, e) {
    this._realloc(arr.length * 2);
    if (arr instanceof Uint16Array && this.byteOffset + this.position % arr.BYTES_PER_ELEMENT === 0) {
        $c9a1fd49277acae3$var$DataStream.memcpy(this._buffer, this.byteOffset + this.position, arr.buffer, 0, arr.byteLength);
        this.mapUint16Array(arr.length, e);
    } else for(var i1 = 0; i1 < arr.length; i1++)this.writeUint16(arr[i1], e);
};
/**
Writes a Uint8Array to the DataStream.

@param {Object} arr The array to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeUint8Array = function(arr) {
    this._realloc(arr.length * 1);
    if (arr instanceof Uint8Array && this.byteOffset + this.position % arr.BYTES_PER_ELEMENT === 0) {
        $c9a1fd49277acae3$var$DataStream.memcpy(this._buffer, this.byteOffset + this.position, arr.buffer, 0, arr.byteLength);
        this.mapUint8Array(arr.length);
    } else for(var i1 = 0; i1 < arr.length; i1++)this.writeUint8(arr[i1]);
};
/**
Writes a Float64Array of specified endianness to the DataStream.

@param {Object} arr The array to write.
@param {?boolean} e Endianness of the data to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeFloat64Array = function(arr, e) {
    this._realloc(arr.length * 8);
    if (arr instanceof Float64Array && this.byteOffset + this.position % arr.BYTES_PER_ELEMENT === 0) {
        $c9a1fd49277acae3$var$DataStream.memcpy(this._buffer, this.byteOffset + this.position, arr.buffer, 0, arr.byteLength);
        this.mapFloat64Array(arr.length, e);
    } else for(var i1 = 0; i1 < arr.length; i1++)this.writeFloat64(arr[i1], e);
};
/**
Writes a Float32Array of specified endianness to the DataStream.

@param {Object} arr The array to write.
@param {?boolean} e Endianness of the data to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeFloat32Array = function(arr, e) {
    this._realloc(arr.length * 4);
    if (arr instanceof Float32Array && this.byteOffset + this.position % arr.BYTES_PER_ELEMENT === 0) {
        $c9a1fd49277acae3$var$DataStream.memcpy(this._buffer, this.byteOffset + this.position, arr.buffer, 0, arr.byteLength);
        this.mapFloat32Array(arr.length, e);
    } else for(var i1 = 0; i1 < arr.length; i1++)this.writeFloat32(arr[i1], e);
};
/**
Writes a 32-bit int to the DataStream with the desired endianness.

@param {number} v Number to write.
@param {?boolean} e Endianness of the number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeInt32 = function(v, e) {
    this._realloc(4);
    this._dataView.setInt32(this.position, v, e == null ? this.endianness : e);
    this.position += 4;
};
/**
Writes a 16-bit int to the DataStream with the desired endianness.

@param {number} v Number to write.
@param {?boolean} e Endianness of the number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeInt16 = function(v, e) {
    this._realloc(2);
    this._dataView.setInt16(this.position, v, e == null ? this.endianness : e);
    this.position += 2;
};
/**
Writes an 8-bit int to the DataStream.

@param {number} v Number to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeInt8 = function(v) {
    this._realloc(1);
    this._dataView.setInt8(this.position, v);
    this.position += 1;
};
/**
Writes a 32-bit unsigned int to the DataStream with the desired endianness.

@param {number} v Number to write.
@param {?boolean} e Endianness of the number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeUint32 = function(v, e) {
    this._realloc(4);
    this._dataView.setUint32(this.position, v, e == null ? this.endianness : e);
    this.position += 4;
};
/**
Writes a 16-bit unsigned int to the DataStream with the desired endianness.

@param {number} v Number to write.
@param {?boolean} e Endianness of the number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeUint16 = function(v, e) {
    this._realloc(2);
    this._dataView.setUint16(this.position, v, e == null ? this.endianness : e);
    this.position += 2;
};
/**
Writes an 8-bit unsigned  int to the DataStream.

@param {number} v Number to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeUint8 = function(v) {
    this._realloc(1);
    this._dataView.setUint8(this.position, v);
    this.position += 1;
};
/**
Writes a 32-bit float to the DataStream with the desired endianness.

@param {number} v Number to write.
@param {?boolean} e Endianness of the number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeFloat32 = function(v, e) {
    this._realloc(4);
    this._dataView.setFloat32(this.position, v, e == null ? this.endianness : e);
    this.position += 4;
};
/**
Writes a 64-bit float to the DataStream with the desired endianness.

@param {number} v Number to write.
@param {?boolean} e Endianness of the number.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeFloat64 = function(v, e) {
    this._realloc(8);
    this._dataView.setFloat64(this.position, v, e == null ? this.endianness : e);
    this.position += 8;
};
/**
Write a UCS-2 string of desired endianness to the DataStream. The
lengthOverride argument lets you define the number of characters to write.
If the string is shorter than lengthOverride, the extra space is padded with
zeroes.

@param {string} str The string to write.
@param {?boolean} endianness The endianness to use for the written string data.
@param {?number} lengthOverride The number of characters to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeUCS2String = function(str, endianness, lengthOverride) {
    if (lengthOverride == null) lengthOverride = str.length;
    for(var i1 = 0; i1 < str.length && i1 < lengthOverride; i1++)this.writeUint16(str.charCodeAt(i1), endianness);
    for(; i1 < lengthOverride; i1++)this.writeUint16(0);
};
/**
Writes a string of desired length and encoding to the DataStream.

@param {string} s The string to write.
@param {?string} encoding The encoding for the written string data.
                        Defaults to ASCII.
@param {?number} length The number of characters to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeString = function(s, encoding, length) {
    var i1 = 0;
    if (encoding == null || encoding == "ASCII") {
        if (length != null) {
            var len = Math.min(s.length, length);
            for(i1 = 0; i1 < len; i1++)this.writeUint8(s.charCodeAt(i1));
            for(; i1 < length; i1++)this.writeUint8(0);
        } else for(i1 = 0; i1 < s.length; i1++)this.writeUint8(s.charCodeAt(i1));
    } else this.writeUint8Array(new TextEncoder(encoding).encode(s.substring(0, length)));
};
/**
Writes a null-terminated string to DataStream and zero-pads it to length
bytes. If length is not given, writes the string followed by a zero.
If string is longer than length, the written part of the string does not have
a trailing zero.

@param {string} s The string to write.
@param {?number} length The number of characters to write.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeCString = function(s, length) {
    var i1 = 0;
    if (length != null) {
        var len = Math.min(s.length, length);
        for(i1 = 0; i1 < len; i1++)this.writeUint8(s.charCodeAt(i1));
        for(; i1 < length; i1++)this.writeUint8(0);
    } else {
        for(i1 = 0; i1 < s.length; i1++)this.writeUint8(s.charCodeAt(i1));
        this.writeUint8(0);
    }
};
/**
Writes a struct to the DataStream. Takes a structDefinition that gives the
types and a struct object that gives the values. Refer to readStruct for the
structure of structDefinition.

@param {Object} structDefinition Type definition of the struct.
@param {Object} struct The struct data object.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeStruct = function(structDefinition, struct) {
    for(var i1 = 0; i1 < structDefinition.length; i1 += 2){
        var t = structDefinition[i1 + 1];
        this.writeType(t, struct[structDefinition[i1]], struct);
    }
};
/**
Writes object v of type t to the DataStream.

@param {Object} t Type of data to write.
@param {Object} v Value of data to write.
@param {Object} struct Struct to pass to write callback functions.
*/ $c9a1fd49277acae3$var$DataStream.prototype.writeType = function(t, v, struct) {
    var tp;
    if (typeof t == "function") return t(this, v);
    else if (typeof t == "object" && !(t instanceof Array)) return t.set(this, v, struct);
    var lengthOverride = null;
    var charset = "ASCII";
    var pos = this.position;
    if (typeof t == "string" && /:/.test(t)) {
        tp = t.split(":");
        t = tp[0];
        lengthOverride = parseInt(tp[1]);
    }
    if (typeof t == "string" && /,/.test(t)) {
        tp = t.split(",");
        t = tp[0];
        charset = parseInt(tp[1]);
    }
    switch(t){
        case "uint8":
            this.writeUint8(v);
            break;
        case "int8":
            this.writeInt8(v);
            break;
        case "uint16":
            this.writeUint16(v, this.endianness);
            break;
        case "int16":
            this.writeInt16(v, this.endianness);
            break;
        case "uint32":
            this.writeUint32(v, this.endianness);
            break;
        case "int32":
            this.writeInt32(v, this.endianness);
            break;
        case "float32":
            this.writeFloat32(v, this.endianness);
            break;
        case "float64":
            this.writeFloat64(v, this.endianness);
            break;
        case "uint16be":
            this.writeUint16(v, $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN);
            break;
        case "int16be":
            this.writeInt16(v, $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN);
            break;
        case "uint32be":
            this.writeUint32(v, $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN);
            break;
        case "int32be":
            this.writeInt32(v, $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN);
            break;
        case "float32be":
            this.writeFloat32(v, $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN);
            break;
        case "float64be":
            this.writeFloat64(v, $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN);
            break;
        case "uint16le":
            this.writeUint16(v, $c9a1fd49277acae3$var$DataStream.LITTLE_ENDIAN);
            break;
        case "int16le":
            this.writeInt16(v, $c9a1fd49277acae3$var$DataStream.LITTLE_ENDIAN);
            break;
        case "uint32le":
            this.writeUint32(v, $c9a1fd49277acae3$var$DataStream.LITTLE_ENDIAN);
            break;
        case "int32le":
            this.writeInt32(v, $c9a1fd49277acae3$var$DataStream.LITTLE_ENDIAN);
            break;
        case "float32le":
            this.writeFloat32(v, $c9a1fd49277acae3$var$DataStream.LITTLE_ENDIAN);
            break;
        case "float64le":
            this.writeFloat64(v, $c9a1fd49277acae3$var$DataStream.LITTLE_ENDIAN);
            break;
        case "cstring":
            this.writeCString(v, lengthOverride);
            break;
        case "string":
            this.writeString(v, charset, lengthOverride);
            break;
        case "u16string":
            this.writeUCS2String(v, this.endianness, lengthOverride);
            break;
        case "u16stringle":
            this.writeUCS2String(v, $c9a1fd49277acae3$var$DataStream.LITTLE_ENDIAN, lengthOverride);
            break;
        case "u16stringbe":
            this.writeUCS2String(v, $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN, lengthOverride);
            break;
        default:
            if (t.length == 3) {
                var ta = t[1];
                for(var i1 = 0; i1 < v.length; i1++)this.writeType(ta, v[i1]);
                break;
            } else {
                this.writeStruct(t, v);
                break;
            }
    }
    if (lengthOverride != null) {
        this.position = pos;
        this._realloc(lengthOverride);
        this.position = pos + lengthOverride;
    }
};
$c9a1fd49277acae3$var$DataStream.prototype.writeUint64 = function(v) {
    var h = Math.floor(v / $c9a1fd49277acae3$var$MAX_SIZE);
    this.writeUint32(h);
    this.writeUint32(v & 0xFFFFFFFF);
};
$c9a1fd49277acae3$var$DataStream.prototype.writeUint24 = function(v) {
    this.writeUint8((v & 0x00FF0000) >> 16);
    this.writeUint8((v & 0x0000FF00) >> 8);
    this.writeUint8(v & 0x000000FF);
};
$c9a1fd49277acae3$var$DataStream.prototype.adjustUint32 = function(position, value) {
    var pos = this.position;
    this.seek(position);
    this.writeUint32(value);
    this.seek(pos);
};
// file:src/DataStream-map.js
/**
Maps an Int32Array into the DataStream buffer, swizzling it to native
endianness in-place. The current offset from the start of the buffer needs to
be a multiple of element size, just like with typed array views.

Nice for quickly reading in data. Warning: potentially modifies the buffer
contents.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} Int32Array to the DataStream backing buffer.
*/ $c9a1fd49277acae3$var$DataStream.prototype.mapInt32Array = function(length, e) {
    this._realloc(length * 4);
    var arr = new Int32Array(this._buffer, this.byteOffset + this.position, length);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += length * 4;
    return arr;
};
/**
Maps an Int16Array into the DataStream buffer, swizzling it to native
endianness in-place. The current offset from the start of the buffer needs to
be a multiple of element size, just like with typed array views.

Nice for quickly reading in data. Warning: potentially modifies the buffer
contents.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} Int16Array to the DataStream backing buffer.
*/ $c9a1fd49277acae3$var$DataStream.prototype.mapInt16Array = function(length, e) {
    this._realloc(length * 2);
    var arr = new Int16Array(this._buffer, this.byteOffset + this.position, length);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += length * 2;
    return arr;
};
/**
Maps an Int8Array into the DataStream buffer.

Nice for quickly reading in data.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} Int8Array to the DataStream backing buffer.
*/ $c9a1fd49277acae3$var$DataStream.prototype.mapInt8Array = function(length) {
    this._realloc(length * 1);
    var arr = new Int8Array(this._buffer, this.byteOffset + this.position, length);
    this.position += length * 1;
    return arr;
};
/**
Maps a Uint32Array into the DataStream buffer, swizzling it to native
endianness in-place. The current offset from the start of the buffer needs to
be a multiple of element size, just like with typed array views.

Nice for quickly reading in data. Warning: potentially modifies the buffer
contents.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} Uint32Array to the DataStream backing buffer.
*/ $c9a1fd49277acae3$var$DataStream.prototype.mapUint32Array = function(length, e) {
    this._realloc(length * 4);
    var arr = new Uint32Array(this._buffer, this.byteOffset + this.position, length);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += length * 4;
    return arr;
};
/**
Maps a Uint16Array into the DataStream buffer, swizzling it to native
endianness in-place. The current offset from the start of the buffer needs to
be a multiple of element size, just like with typed array views.

Nice for quickly reading in data. Warning: potentially modifies the buffer
contents.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} Uint16Array to the DataStream backing buffer.
*/ $c9a1fd49277acae3$var$DataStream.prototype.mapUint16Array = function(length, e) {
    this._realloc(length * 2);
    var arr = new Uint16Array(this._buffer, this.byteOffset + this.position, length);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += length * 2;
    return arr;
};
/**
Maps a Float64Array into the DataStream buffer, swizzling it to native
endianness in-place. The current offset from the start of the buffer needs to
be a multiple of element size, just like with typed array views.

Nice for quickly reading in data. Warning: potentially modifies the buffer
contents.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} Float64Array to the DataStream backing buffer.
*/ $c9a1fd49277acae3$var$DataStream.prototype.mapFloat64Array = function(length, e) {
    this._realloc(length * 8);
    var arr = new Float64Array(this._buffer, this.byteOffset + this.position, length);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += length * 8;
    return arr;
};
/**
Maps a Float32Array into the DataStream buffer, swizzling it to native
endianness in-place. The current offset from the start of the buffer needs to
be a multiple of element size, just like with typed array views.

Nice for quickly reading in data. Warning: potentially modifies the buffer
contents.

@param {number} length Number of elements to map.
@param {?boolean} e Endianness of the data to read.
@return {Object} Float32Array to the DataStream backing buffer.
*/ $c9a1fd49277acae3$var$DataStream.prototype.mapFloat32Array = function(length, e) {
    this._realloc(length * 4);
    var arr = new Float32Array(this._buffer, this.byteOffset + this.position, length);
    $c9a1fd49277acae3$var$DataStream.arrayToNative(arr, e == null ? this.endianness : e);
    this.position += length * 4;
    return arr;
};
// file:src/buffer.js
/**
* MultiBufferStream is a class that acts as a SimpleStream for parsing 
* It holds several, possibly non-contiguous ArrayBuffer objects, each with a fileStart property 
* containing the offset for the buffer data in an original/virtual file 
*
* It inherits also from DataStream for all read/write/alloc operations
*/ /**
* Constructor
*/ var $c9a1fd49277acae3$var$MultiBufferStream = function(buffer) {
    /* List of ArrayBuffers, with a fileStart property, sorted in fileStart order and non overlapping */ this.buffers = [];
    this.bufferIndex = -1;
    if (buffer) {
        this.insertBuffer(buffer);
        this.bufferIndex = 0;
    }
};
$c9a1fd49277acae3$var$MultiBufferStream.prototype = new $c9a1fd49277acae3$var$DataStream(new ArrayBuffer(), 0, $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN);
/************************************************************************************
Methods for the managnement of the buffers (insertion, removal, concatenation, ...)
***********************************************************************************/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.initialized = function() {
    var firstBuffer;
    if (this.bufferIndex > -1) return true;
    else if (this.buffers.length > 0) {
        firstBuffer = this.buffers[0];
        if (firstBuffer.fileStart === 0) {
            this.buffer = firstBuffer;
            this.bufferIndex = 0;
            $c9a1fd49277acae3$var$Log.debug("MultiBufferStream", "Stream ready for parsing");
            return true;
        } else {
            $c9a1fd49277acae3$var$Log.warn("MultiBufferStream", "The first buffer should have a fileStart of 0");
            this.logBufferLevel();
            return false;
        }
    } else {
        $c9a1fd49277acae3$var$Log.warn("MultiBufferStream", "No buffer to start parsing from");
        this.logBufferLevel();
        return false;
    }
};
/**
* helper functions to concatenate two ArrayBuffer objects
* @param  {ArrayBuffer} buffer1 
* @param  {ArrayBuffer} buffer2 
* @return {ArrayBuffer} the concatenation of buffer1 and buffer2 in that order
*/ ArrayBuffer.concat = function(buffer1, buffer2) {
    $c9a1fd49277acae3$var$Log.debug("ArrayBuffer", "Trying to create a new buffer of size: " + (buffer1.byteLength + buffer2.byteLength));
    var tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(new Uint8Array(buffer1), 0);
    tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
    return tmp.buffer;
};
/**
* Reduces the size of a given buffer, but taking the part between offset and offset+newlength
* @param  {ArrayBuffer} buffer    
* @param  {Number}      offset    the start of new buffer
* @param  {Number}      newLength the length of the new buffer
* @return {ArrayBuffer}           the new buffer
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.reduceBuffer = function(buffer, offset, newLength) {
    var smallB;
    smallB = new Uint8Array(newLength);
    smallB.set(new Uint8Array(buffer, offset, newLength));
    smallB.buffer.fileStart = buffer.fileStart + offset;
    smallB.buffer.usedBytes = 0;
    return smallB.buffer;
};
/**
* Inserts the new buffer in the sorted list of buffers,
*  making sure, it is not overlapping with existing ones (possibly reducing its size).
*  if the new buffer overrides/replaces the 0-th buffer (for instance because it is bigger), 
*  updates the DataStream buffer for parsing 
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.insertBuffer = function(ab) {
    var to_add = true;
    /* TODO: improve insertion if many buffers */ for(var i1 = 0; i1 < this.buffers.length; i1++){
        var b = this.buffers[i1];
        if (ab.fileStart <= b.fileStart) {
            /* the insertion position is found */ if (ab.fileStart === b.fileStart) {
                /* The new buffer overlaps with an existing buffer */ if (ab.byteLength > b.byteLength) {
                    /* the new buffer is bigger than the existing one
                   remove the existing buffer and try again to insert 
                   the new buffer to check overlap with the next ones */ this.buffers.splice(i1, 1);
                    i1--;
                    continue;
                } else /* the new buffer is smaller than the existing one, just drop it */ $c9a1fd49277acae3$var$Log.warn("MultiBufferStream", "Buffer (fileStart: " + ab.fileStart + " - Length: " + ab.byteLength + ") already appended, ignoring");
            } else {
                /* The beginning of the new buffer is not overlapping with an existing buffer
               let's check the end of it */ if (ab.fileStart + ab.byteLength <= b.fileStart) ;
                else /* There is some overlap, cut the new buffer short, and add it*/ ab = this.reduceBuffer(ab, 0, b.fileStart - ab.fileStart);
                $c9a1fd49277acae3$var$Log.debug("MultiBufferStream", "Appending new buffer (fileStart: " + ab.fileStart + " - Length: " + ab.byteLength + ")");
                this.buffers.splice(i1, 0, ab);
                /* if this new buffer is inserted in the first place in the list of the buffer, 
               and the DataStream is initialized, make it the buffer used for parsing */ if (i1 === 0) this.buffer = ab;
            }
            to_add = false;
            break;
        } else if (ab.fileStart < b.fileStart + b.byteLength) {
            /* the new buffer overlaps its beginning with the end of the current buffer */ var offset = b.fileStart + b.byteLength - ab.fileStart;
            var newLength = ab.byteLength - offset;
            if (newLength > 0) /* the new buffer is bigger than the current overlap, drop the overlapping part and try again inserting the remaining buffer */ ab = this.reduceBuffer(ab, offset, newLength);
            else {
                /* the content of the new buffer is entirely contained in the existing buffer, drop it entirely */ to_add = false;
                break;
            }
        }
    }
    /* if the buffer has not been added, we can add it at the end */ if (to_add) {
        $c9a1fd49277acae3$var$Log.debug("MultiBufferStream", "Appending new buffer (fileStart: " + ab.fileStart + " - Length: " + ab.byteLength + ")");
        this.buffers.push(ab);
        /* if this new buffer is inserted in the first place in the list of the buffer, 
       and the DataStream is initialized, make it the buffer used for parsing */ if (i1 === 0) this.buffer = ab;
    }
};
/**
* Displays the status of the buffers (number and used bytes)
* @param  {Object} info callback method for display
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.logBufferLevel = function(info) {
    var i1;
    var buffer;
    var used, total;
    var ranges = [];
    var range;
    var bufferedString = "";
    used = 0;
    total = 0;
    for(i1 = 0; i1 < this.buffers.length; i1++){
        buffer = this.buffers[i1];
        if (i1 === 0) {
            range = {};
            ranges.push(range);
            range.start = buffer.fileStart;
            range.end = buffer.fileStart + buffer.byteLength;
            bufferedString += "[" + range.start + "-";
        } else if (range.end === buffer.fileStart) range.end = buffer.fileStart + buffer.byteLength;
        else {
            range = {};
            range.start = buffer.fileStart;
            bufferedString += ranges[ranges.length - 1].end - 1 + "], [" + range.start + "-";
            range.end = buffer.fileStart + buffer.byteLength;
            ranges.push(range);
        }
        used += buffer.usedBytes;
        total += buffer.byteLength;
    }
    if (ranges.length > 0) bufferedString += range.end - 1 + "]";
    var log = info ? $c9a1fd49277acae3$var$Log.info : $c9a1fd49277acae3$var$Log.debug;
    if (this.buffers.length === 0) log("MultiBufferStream", "No more buffer in memory");
    else log("MultiBufferStream", "" + this.buffers.length + " stored buffer(s) (" + used + "/" + total + " bytes), continuous ranges: " + bufferedString);
};
$c9a1fd49277acae3$var$MultiBufferStream.prototype.cleanBuffers = function() {
    var i1;
    var buffer;
    for(i1 = 0; i1 < this.buffers.length; i1++){
        buffer = this.buffers[i1];
        if (buffer.usedBytes === buffer.byteLength) {
            $c9a1fd49277acae3$var$Log.debug("MultiBufferStream", "Removing buffer #" + i1);
            this.buffers.splice(i1, 1);
            i1--;
        }
    }
};
$c9a1fd49277acae3$var$MultiBufferStream.prototype.mergeNextBuffer = function() {
    var next_buffer;
    if (this.bufferIndex + 1 < this.buffers.length) {
        next_buffer = this.buffers[this.bufferIndex + 1];
        if (next_buffer.fileStart === this.buffer.fileStart + this.buffer.byteLength) {
            var oldLength = this.buffer.byteLength;
            var oldUsedBytes = this.buffer.usedBytes;
            var oldFileStart = this.buffer.fileStart;
            this.buffers[this.bufferIndex] = ArrayBuffer.concat(this.buffer, next_buffer);
            this.buffer = this.buffers[this.bufferIndex];
            this.buffers.splice(this.bufferIndex + 1, 1);
            this.buffer.usedBytes = oldUsedBytes; /* TODO: should it be += ? */ 
            this.buffer.fileStart = oldFileStart;
            $c9a1fd49277acae3$var$Log.debug("ISOFile", "Concatenating buffer for box parsing (length: " + oldLength + "->" + this.buffer.byteLength + ")");
            return true;
        } else return false;
    } else return false;
};
/*************************************************************************
Seek-related functions
*************************************************************************/ /**
* Finds the buffer that holds the given file position
* @param  {Boolean} fromStart    indicates if the search should start from the current buffer (false) 
*                                or from the first buffer (true)
* @param  {Number}  filePosition position in the file to seek to
* @param  {Boolean} markAsUsed   indicates if the bytes in between the current position and the seek position 
*                                should be marked as used for garbage collection
* @return {Number}               the index of the buffer holding the seeked file position, -1 if not found.
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.findPosition = function(fromStart, filePosition, markAsUsed) {
    var i1;
    var abuffer = null;
    var index = -1;
    /* find the buffer with the largest position smaller than the given position */ if (fromStart === true) /* the reposition can be in the past, we need to check from the beginning of the list of buffers */ i1 = 0;
    else i1 = this.bufferIndex;
    while(i1 < this.buffers.length){
        abuffer = this.buffers[i1];
        if (abuffer.fileStart <= filePosition) {
            index = i1;
            if (markAsUsed) {
                if (abuffer.fileStart + abuffer.byteLength <= filePosition) abuffer.usedBytes = abuffer.byteLength;
                else abuffer.usedBytes = filePosition - abuffer.fileStart;
                this.logBufferLevel();
            }
        } else break;
        i1++;
    }
    if (index !== -1) {
        abuffer = this.buffers[index];
        if (abuffer.fileStart + abuffer.byteLength >= filePosition) {
            $c9a1fd49277acae3$var$Log.debug("MultiBufferStream", "Found position in existing buffer #" + index);
            return index;
        } else return -1;
    } else return -1;
};
/**
* Finds the largest file position contained in a buffer or in the next buffers if they are contiguous (no gap)
* starting from the given buffer index or from the current buffer if the index is not given
*
* @param  {Number} inputindex Index of the buffer to start from
* @return {Number}            The largest file position found in the buffers
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.findEndContiguousBuf = function(inputindex) {
    var i1;
    var currentBuf;
    var nextBuf;
    var index = inputindex !== undefined ? inputindex : this.bufferIndex;
    currentBuf = this.buffers[index];
    /* find the end of the contiguous range of data */ if (this.buffers.length > index + 1) for(i1 = index + 1; i1 < this.buffers.length; i1++){
        nextBuf = this.buffers[i1];
        if (nextBuf.fileStart === currentBuf.fileStart + currentBuf.byteLength) currentBuf = nextBuf;
        else break;
    }
    /* return the position of last byte in the file that we have */ return currentBuf.fileStart + currentBuf.byteLength;
};
/**
* Returns the largest file position contained in the buffers, larger than the given position
* @param  {Number} pos the file position to start from
* @return {Number}     the largest position in the current buffer or in the buffer and the next contiguous 
*                      buffer that holds the given position
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.getEndFilePositionAfter = function(pos) {
    var index = this.findPosition(true, pos, false);
    if (index !== -1) return this.findEndContiguousBuf(index);
    else return pos;
};
/*************************************************************************
Garbage collection related functions
*************************************************************************/ /**
* Marks a given number of bytes as used in the current buffer for garbage collection
* @param {Number} nbBytes 
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.addUsedBytes = function(nbBytes) {
    this.buffer.usedBytes += nbBytes;
    this.logBufferLevel();
};
/**
* Marks the entire current buffer as used, ready for garbage collection
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.setAllUsedBytes = function() {
    this.buffer.usedBytes = this.buffer.byteLength;
    this.logBufferLevel();
};
/*************************************************************************
Common API between MultiBufferStream and SimpleStream
*************************************************************************/ /**
* Tries to seek to a given file position
* if possible, repositions the parsing from there and returns true 
* if not possible, does not change anything and returns false 
* @param  {Number}  filePosition position in the file to seek to
* @param  {Boolean} fromStart    indicates if the search should start from the current buffer (false) 
*                                or from the first buffer (true)
* @param  {Boolean} markAsUsed   indicates if the bytes in between the current position and the seek position 
*                                should be marked as used for garbage collection
* @return {Boolean}              true if the seek succeeded, false otherwise
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.seek = function(filePosition, fromStart, markAsUsed) {
    var index;
    index = this.findPosition(fromStart, filePosition, markAsUsed);
    if (index !== -1) {
        this.buffer = this.buffers[index];
        this.bufferIndex = index;
        this.position = filePosition - this.buffer.fileStart;
        $c9a1fd49277acae3$var$Log.debug("MultiBufferStream", "Repositioning parser at buffer position: " + this.position);
        return true;
    } else {
        $c9a1fd49277acae3$var$Log.debug("MultiBufferStream", "Position " + filePosition + " not found in buffered data");
        return false;
    }
};
/**
* Returns the current position in the file
* @return {Number} the position in the file
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.getPosition = function() {
    if (this.bufferIndex === -1 || this.buffers[this.bufferIndex] === null) throw "Error accessing position in the MultiBufferStream";
    return this.buffers[this.bufferIndex].fileStart + this.position;
};
/**
* Returns the length of the current buffer
* @return {Number} the length of the current buffer
*/ $c9a1fd49277acae3$var$MultiBufferStream.prototype.getLength = function() {
    return this.byteLength;
};
$c9a1fd49277acae3$var$MultiBufferStream.prototype.getEndPosition = function() {
    if (this.bufferIndex === -1 || this.buffers[this.bufferIndex] === null) throw "Error accessing position in the MultiBufferStream";
    return this.buffers[this.bufferIndex].fileStart + this.byteLength;
};
$c9a1fd49277acae3$export$333a810def2b997b = $c9a1fd49277acae3$var$MultiBufferStream;
/*
* Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
* License: BSD-3-Clause (see LICENSE file)
*/ var $c9a1fd49277acae3$var$MPEG4DescriptorParser = function() {
    var ES_DescrTag = 0x03;
    var DecoderConfigDescrTag = 0x04;
    var DecSpecificInfoTag = 0x05;
    var SLConfigDescrTag = 0x06;
    var descTagToName = [];
    descTagToName[ES_DescrTag] = "ES_Descriptor";
    descTagToName[DecoderConfigDescrTag] = "DecoderConfigDescriptor";
    descTagToName[DecSpecificInfoTag] = "DecoderSpecificInfo";
    descTagToName[SLConfigDescrTag] = "SLConfigDescriptor";
    this.getDescriptorName = function(tag) {
        return descTagToName[tag];
    };
    var that = this;
    var classes = {};
    this.parseOneDescriptor = function(stream) {
        var hdrSize = 0;
        var size = 0;
        var tag;
        var desc;
        var byteRead;
        tag = stream.readUint8();
        hdrSize++;
        byteRead = stream.readUint8();
        hdrSize++;
        while(byteRead & 0x80){
            size = (byteRead & 0x7F) << 7;
            byteRead = stream.readUint8();
            hdrSize++;
        }
        size += byteRead & 0x7F;
        $c9a1fd49277acae3$var$Log.debug("MPEG4DescriptorParser", "Found " + (descTagToName[tag] || "Descriptor " + tag) + ", size " + size + " at position " + stream.getPosition());
        if (descTagToName[tag]) desc = new classes[descTagToName[tag]](size);
        else desc = new classes.Descriptor(size);
        desc.parse(stream);
        return desc;
    };
    classes.Descriptor = function(_tag, _size) {
        this.tag = _tag;
        this.size = _size;
        this.descs = [];
    };
    classes.Descriptor.prototype.parse = function(stream) {
        this.data = stream.readUint8Array(this.size);
    };
    classes.Descriptor.prototype.findDescriptor = function(tag) {
        for(var i1 = 0; i1 < this.descs.length; i1++){
            if (this.descs[i1].tag == tag) return this.descs[i1];
        }
        return null;
    };
    classes.Descriptor.prototype.parseRemainingDescriptors = function(stream) {
        var start = stream.position;
        while(stream.position < start + this.size){
            var desc = that.parseOneDescriptor(stream);
            this.descs.push(desc);
        }
    };
    classes.ES_Descriptor = function(size) {
        classes.Descriptor.call(this, ES_DescrTag, size);
    };
    classes.ES_Descriptor.prototype = new classes.Descriptor();
    classes.ES_Descriptor.prototype.parse = function(stream) {
        this.ES_ID = stream.readUint16();
        this.flags = stream.readUint8();
        this.size -= 3;
        if (this.flags & 0x80) {
            this.dependsOn_ES_ID = stream.readUint16();
            this.size -= 2;
        } else this.dependsOn_ES_ID = 0;
        if (this.flags & 0x40) {
            var l = stream.readUint8();
            this.URL = stream.readString(l);
            this.size -= l + 1;
        } else this.URL = "";
        if (this.flags & 0x20) {
            this.OCR_ES_ID = stream.readUint16();
            this.size -= 2;
        } else this.OCR_ES_ID = 0;
        this.parseRemainingDescriptors(stream);
    };
    classes.ES_Descriptor.prototype.getOTI = function(stream) {
        var dcd = this.findDescriptor(DecoderConfigDescrTag);
        if (dcd) return dcd.oti;
        else return 0;
    };
    classes.ES_Descriptor.prototype.getAudioConfig = function(stream) {
        var dcd = this.findDescriptor(DecoderConfigDescrTag);
        if (!dcd) return null;
        var dsi = dcd.findDescriptor(DecSpecificInfoTag);
        if (dsi && dsi.data) {
            var audioObjectType = (dsi.data[0] & 0xF8) >> 3;
            if (audioObjectType === 31 && dsi.data.length >= 2) audioObjectType = 32 + ((dsi.data[0] & 0x7) << 3) + ((dsi.data[1] & 0xE0) >> 5);
            return audioObjectType;
        } else return null;
    };
    classes.DecoderConfigDescriptor = function(size) {
        classes.Descriptor.call(this, DecoderConfigDescrTag, size);
    };
    classes.DecoderConfigDescriptor.prototype = new classes.Descriptor();
    classes.DecoderConfigDescriptor.prototype.parse = function(stream) {
        this.oti = stream.readUint8();
        this.streamType = stream.readUint8();
        this.upStream = (this.streamType >> 1 & 1) !== 0;
        this.streamType = this.streamType >>> 2;
        this.bufferSize = stream.readUint24();
        this.maxBitrate = stream.readUint32();
        this.avgBitrate = stream.readUint32();
        this.size -= 13;
        this.parseRemainingDescriptors(stream);
    };
    classes.DecoderSpecificInfo = function(size) {
        classes.Descriptor.call(this, DecSpecificInfoTag, size);
    };
    classes.DecoderSpecificInfo.prototype = new classes.Descriptor();
    classes.SLConfigDescriptor = function(size) {
        classes.Descriptor.call(this, SLConfigDescrTag, size);
    };
    classes.SLConfigDescriptor.prototype = new classes.Descriptor();
    return this;
};
$c9a1fd49277acae3$export$1d8aeb4422bb5a36 = $c9a1fd49277acae3$var$MPEG4DescriptorParser;
// file:src/box.js
/*
* Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
* License: BSD-3-Clause (see LICENSE file)
*/ var $c9a1fd49277acae3$var$BoxParser = {
    ERR_INVALID_DATA: -1,
    ERR_NOT_ENOUGH_DATA: 0,
    OK: 1,
    // Boxes to be created with default parsing
    BASIC_BOXES: [
        "mdat",
        "idat",
        "free",
        "skip",
        "meco",
        "strk"
    ],
    FULL_BOXES: [
        "hmhd",
        "nmhd",
        "iods",
        "xml ",
        "bxml",
        "ipro",
        "mere"
    ],
    CONTAINER_BOXES: [
        [
            "moov",
            [
                "trak",
                "pssh"
            ]
        ],
        [
            "trak"
        ],
        [
            "edts"
        ],
        [
            "mdia"
        ],
        [
            "minf"
        ],
        [
            "dinf"
        ],
        [
            "stbl",
            [
                "sgpd",
                "sbgp"
            ]
        ],
        [
            "mvex",
            [
                "trex"
            ]
        ],
        [
            "moof",
            [
                "traf"
            ]
        ],
        [
            "traf",
            [
                "trun",
                "sgpd",
                "sbgp"
            ]
        ],
        [
            "vttc"
        ],
        [
            "tref"
        ],
        [
            "iref"
        ],
        [
            "mfra",
            [
                "tfra"
            ]
        ],
        [
            "meco"
        ],
        [
            "hnti"
        ],
        [
            "hinf"
        ],
        [
            "strk"
        ],
        [
            "strd"
        ],
        [
            "sinf"
        ],
        [
            "rinf"
        ],
        [
            "schi"
        ],
        [
            "trgr"
        ],
        [
            "udta",
            [
                "kind"
            ]
        ],
        [
            "iprp",
            [
                "ipma"
            ]
        ],
        [
            "ipco"
        ],
        [
            "grpl"
        ],
        [
            "j2kH"
        ],
        [
            "etyp",
            [
                "tyco"
            ]
        ]
    ],
    // Boxes effectively created
    boxCodes: [],
    fullBoxCodes: [],
    containerBoxCodes: [],
    sampleEntryCodes: {},
    sampleGroupEntryCodes: [],
    trackGroupTypes: [],
    UUIDBoxes: {},
    UUIDs: [],
    initialize: function() {
        $c9a1fd49277acae3$var$BoxParser.FullBox.prototype = new $c9a1fd49277acae3$var$BoxParser.Box();
        $c9a1fd49277acae3$var$BoxParser.ContainerBox.prototype = new $c9a1fd49277acae3$var$BoxParser.Box();
        $c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype = new $c9a1fd49277acae3$var$BoxParser.Box();
        $c9a1fd49277acae3$var$BoxParser.TrackGroupTypeBox.prototype = new $c9a1fd49277acae3$var$BoxParser.FullBox();
        /* creating constructors for simple boxes */ $c9a1fd49277acae3$var$BoxParser.BASIC_BOXES.forEach(function(type) {
            $c9a1fd49277acae3$var$BoxParser.createBoxCtor(type);
        });
        $c9a1fd49277acae3$var$BoxParser.FULL_BOXES.forEach(function(type) {
            $c9a1fd49277acae3$var$BoxParser.createFullBoxCtor(type);
        });
        $c9a1fd49277acae3$var$BoxParser.CONTAINER_BOXES.forEach(function(types) {
            $c9a1fd49277acae3$var$BoxParser.createContainerBoxCtor(types[0], null, types[1]);
        });
    },
    Box: function(_type, _size, _uuid) {
        this.type = _type;
        this.size = _size;
        this.uuid = _uuid;
    },
    FullBox: function(type, size, uuid) {
        $c9a1fd49277acae3$var$BoxParser.Box.call(this, type, size, uuid);
        this.flags = 0;
        this.version = 0;
    },
    ContainerBox: function(type, size, uuid) {
        $c9a1fd49277acae3$var$BoxParser.Box.call(this, type, size, uuid);
        this.boxes = [];
    },
    SampleEntry: function(type, size, hdr_size, start) {
        $c9a1fd49277acae3$var$BoxParser.ContainerBox.call(this, type, size);
        this.hdr_size = hdr_size;
        this.start = start;
    },
    SampleGroupEntry: function(type) {
        this.grouping_type = type;
    },
    TrackGroupTypeBox: function(type, size) {
        $c9a1fd49277acae3$var$BoxParser.FullBox.call(this, type, size);
    },
    createBoxCtor: function(type, parseMethod) {
        $c9a1fd49277acae3$var$BoxParser.boxCodes.push(type);
        $c9a1fd49277acae3$var$BoxParser[type + "Box"] = function(size) {
            $c9a1fd49277acae3$var$BoxParser.Box.call(this, type, size);
        };
        $c9a1fd49277acae3$var$BoxParser[type + "Box"].prototype = new $c9a1fd49277acae3$var$BoxParser.Box();
        if (parseMethod) $c9a1fd49277acae3$var$BoxParser[type + "Box"].prototype.parse = parseMethod;
    },
    createFullBoxCtor: function(type, parseMethod) {
        //BoxParser.fullBoxCodes.push(type);
        $c9a1fd49277acae3$var$BoxParser[type + "Box"] = function(size) {
            $c9a1fd49277acae3$var$BoxParser.FullBox.call(this, type, size);
        };
        $c9a1fd49277acae3$var$BoxParser[type + "Box"].prototype = new $c9a1fd49277acae3$var$BoxParser.FullBox();
        $c9a1fd49277acae3$var$BoxParser[type + "Box"].prototype.parse = function(stream) {
            this.parseFullHeader(stream);
            if (parseMethod) parseMethod.call(this, stream);
        };
    },
    addSubBoxArrays: function(subBoxNames) {
        if (subBoxNames) {
            this.subBoxNames = subBoxNames;
            var nbSubBoxes = subBoxNames.length;
            for(var k = 0; k < nbSubBoxes; k++)this[subBoxNames[k] + "s"] = [];
        }
    },
    createContainerBoxCtor: function(type, parseMethod, subBoxNames) {
        //BoxParser.containerBoxCodes.push(type);
        $c9a1fd49277acae3$var$BoxParser[type + "Box"] = function(size) {
            $c9a1fd49277acae3$var$BoxParser.ContainerBox.call(this, type, size);
            $c9a1fd49277acae3$var$BoxParser.addSubBoxArrays.call(this, subBoxNames);
        };
        $c9a1fd49277acae3$var$BoxParser[type + "Box"].prototype = new $c9a1fd49277acae3$var$BoxParser.ContainerBox();
        if (parseMethod) $c9a1fd49277acae3$var$BoxParser[type + "Box"].prototype.parse = parseMethod;
    },
    createMediaSampleEntryCtor: function(mediaType, parseMethod, subBoxNames) {
        $c9a1fd49277acae3$var$BoxParser.sampleEntryCodes[mediaType] = [];
        $c9a1fd49277acae3$var$BoxParser[mediaType + "SampleEntry"] = function(type, size) {
            $c9a1fd49277acae3$var$BoxParser.SampleEntry.call(this, type, size);
            $c9a1fd49277acae3$var$BoxParser.addSubBoxArrays.call(this, subBoxNames);
        };
        $c9a1fd49277acae3$var$BoxParser[mediaType + "SampleEntry"].prototype = new $c9a1fd49277acae3$var$BoxParser.SampleEntry();
        if (parseMethod) $c9a1fd49277acae3$var$BoxParser[mediaType + "SampleEntry"].prototype.parse = parseMethod;
    },
    createSampleEntryCtor: function(mediaType, type, parseMethod, subBoxNames) {
        $c9a1fd49277acae3$var$BoxParser.sampleEntryCodes[mediaType].push(type);
        $c9a1fd49277acae3$var$BoxParser[type + "SampleEntry"] = function(size) {
            $c9a1fd49277acae3$var$BoxParser[mediaType + "SampleEntry"].call(this, type, size);
            $c9a1fd49277acae3$var$BoxParser.addSubBoxArrays.call(this, subBoxNames);
        };
        $c9a1fd49277acae3$var$BoxParser[type + "SampleEntry"].prototype = new $c9a1fd49277acae3$var$BoxParser[mediaType + "SampleEntry"]();
        if (parseMethod) $c9a1fd49277acae3$var$BoxParser[type + "SampleEntry"].prototype.parse = parseMethod;
    },
    createEncryptedSampleEntryCtor: function(mediaType, type, parseMethod) {
        $c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor.call(this, mediaType, type, parseMethod, [
            "sinf"
        ]);
    },
    createSampleGroupCtor: function(type, parseMethod) {
        //BoxParser.sampleGroupEntryCodes.push(type);
        $c9a1fd49277acae3$var$BoxParser[type + "SampleGroupEntry"] = function(size) {
            $c9a1fd49277acae3$var$BoxParser.SampleGroupEntry.call(this, type, size);
        };
        $c9a1fd49277acae3$var$BoxParser[type + "SampleGroupEntry"].prototype = new $c9a1fd49277acae3$var$BoxParser.SampleGroupEntry();
        if (parseMethod) $c9a1fd49277acae3$var$BoxParser[type + "SampleGroupEntry"].prototype.parse = parseMethod;
    },
    createTrackGroupCtor: function(type, parseMethod) {
        //BoxParser.trackGroupTypes.push(type);
        $c9a1fd49277acae3$var$BoxParser[type + "TrackGroupTypeBox"] = function(size) {
            $c9a1fd49277acae3$var$BoxParser.TrackGroupTypeBox.call(this, type, size);
        };
        $c9a1fd49277acae3$var$BoxParser[type + "TrackGroupTypeBox"].prototype = new $c9a1fd49277acae3$var$BoxParser.TrackGroupTypeBox();
        if (parseMethod) $c9a1fd49277acae3$var$BoxParser[type + "TrackGroupTypeBox"].prototype.parse = parseMethod;
    },
    createUUIDBox: function(uuid, isFullBox, isContainerBox, parseMethod) {
        $c9a1fd49277acae3$var$BoxParser.UUIDs.push(uuid);
        $c9a1fd49277acae3$var$BoxParser.UUIDBoxes[uuid] = function(size) {
            if (isFullBox) $c9a1fd49277acae3$var$BoxParser.FullBox.call(this, "uuid", size, uuid);
            else if (isContainerBox) $c9a1fd49277acae3$var$BoxParser.ContainerBox.call(this, "uuid", size, uuid);
            else $c9a1fd49277acae3$var$BoxParser.Box.call(this, "uuid", size, uuid);
        };
        $c9a1fd49277acae3$var$BoxParser.UUIDBoxes[uuid].prototype = isFullBox ? new $c9a1fd49277acae3$var$BoxParser.FullBox() : isContainerBox ? new $c9a1fd49277acae3$var$BoxParser.ContainerBox() : new $c9a1fd49277acae3$var$BoxParser.Box();
        if (parseMethod) {
            if (isFullBox) $c9a1fd49277acae3$var$BoxParser.UUIDBoxes[uuid].prototype.parse = function(stream) {
                this.parseFullHeader(stream);
                if (parseMethod) parseMethod.call(this, stream);
            };
            else $c9a1fd49277acae3$var$BoxParser.UUIDBoxes[uuid].prototype.parse = parseMethod;
        }
    }
};
$c9a1fd49277acae3$var$BoxParser.initialize();
$c9a1fd49277acae3$var$BoxParser.TKHD_FLAG_ENABLED = 0x000001;
$c9a1fd49277acae3$var$BoxParser.TKHD_FLAG_IN_MOVIE = 0x000002;
$c9a1fd49277acae3$var$BoxParser.TKHD_FLAG_IN_PREVIEW = 0x000004;
$c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_BASE_DATA_OFFSET = 0x01;
$c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_DESC = 0x02;
$c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_DUR = 0x08;
$c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_SIZE = 0x10;
$c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_FLAGS = 0x20;
$c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_DUR_EMPTY = 0x10000;
$c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_DEFAULT_BASE_IS_MOOF = 0x20000;
$c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DATA_OFFSET = 0x01;
$c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FIRST_FLAG = 0x04;
$c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DURATION = 0x100;
$c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_SIZE = 0x200;
$c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FLAGS = 0x400;
$c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_CTS_OFFSET = 0x800;
$c9a1fd49277acae3$var$BoxParser.Box.prototype.add = function(name) {
    return this.addBox(new $c9a1fd49277acae3$var$BoxParser[name + "Box"]());
};
$c9a1fd49277acae3$var$BoxParser.Box.prototype.addBox = function(box1) {
    this.boxes.push(box1);
    if (this[box1.type + "s"]) this[box1.type + "s"].push(box1);
    else this[box1.type] = box1;
    return box1;
};
$c9a1fd49277acae3$var$BoxParser.Box.prototype.set = function(prop, value) {
    this[prop] = value;
    return this;
};
$c9a1fd49277acae3$var$BoxParser.Box.prototype.addEntry = function(value, _prop) {
    var prop = _prop || "entries";
    if (!this[prop]) this[prop] = [];
    this[prop].push(value);
    return this;
};
$c9a1fd49277acae3$export$b57d5724b61aff09 = $c9a1fd49277acae3$var$BoxParser;
// file:src/box-parse.js
/* 
* Copyright (c) Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
* License: BSD-3-Clause (see LICENSE file)
*/ $c9a1fd49277acae3$var$BoxParser.parseUUID = function(stream) {
    return $c9a1fd49277acae3$var$BoxParser.parseHex16(stream);
};
$c9a1fd49277acae3$var$BoxParser.parseHex16 = function(stream) {
    var hex16 = "";
    for(var i1 = 0; i1 < 16; i1++){
        var hex = stream.readUint8().toString(16);
        hex16 += hex.length === 1 ? "0" + hex : hex;
    }
    return hex16;
};
$c9a1fd49277acae3$var$BoxParser.parseOneBox = function(stream, headerOnly, parentSize) {
    var box1;
    var start = stream.getPosition();
    var hdr_size = 0;
    var diff;
    var uuid;
    if (stream.getEndPosition() - start < 8) {
        $c9a1fd49277acae3$var$Log.debug("BoxParser", "Not enough data in stream to parse the type and size of the box");
        return {
            code: $c9a1fd49277acae3$var$BoxParser.ERR_NOT_ENOUGH_DATA
        };
    }
    if (parentSize && parentSize < 8) {
        $c9a1fd49277acae3$var$Log.debug("BoxParser", "Not enough bytes left in the parent box to parse a new box");
        return {
            code: $c9a1fd49277acae3$var$BoxParser.ERR_NOT_ENOUGH_DATA
        };
    }
    var size = stream.readUint32();
    var type = stream.readString(4);
    var box_type = type;
    $c9a1fd49277acae3$var$Log.debug("BoxParser", "Found box of type '" + type + "' and size " + size + " at position " + start);
    hdr_size = 8;
    if (type == "uuid") {
        if (stream.getEndPosition() - stream.getPosition() < 16 || parentSize - hdr_size < 16) {
            stream.seek(start);
            $c9a1fd49277acae3$var$Log.debug("BoxParser", "Not enough bytes left in the parent box to parse a UUID box");
            return {
                code: $c9a1fd49277acae3$var$BoxParser.ERR_NOT_ENOUGH_DATA
            };
        }
        uuid = $c9a1fd49277acae3$var$BoxParser.parseUUID(stream);
        hdr_size += 16;
        box_type = uuid;
    }
    if (size == 1) {
        if (stream.getEndPosition() - stream.getPosition() < 8 || parentSize && parentSize - hdr_size < 8) {
            stream.seek(start);
            $c9a1fd49277acae3$var$Log.warn("BoxParser", 'Not enough data in stream to parse the extended size of the "' + type + '" box');
            return {
                code: $c9a1fd49277acae3$var$BoxParser.ERR_NOT_ENOUGH_DATA
            };
        }
        size = stream.readUint64();
        hdr_size += 8;
    } else if (size === 0) {
        /* box extends till the end of file or invalid file */ if (parentSize) size = parentSize;
        else /* box extends till the end of file */ if (type !== "mdat") {
            $c9a1fd49277acae3$var$Log.error("BoxParser", "Unlimited box size not supported for type: '" + type + "'");
            box1 = new $c9a1fd49277acae3$var$BoxParser.Box(type, size);
            return {
                code: $c9a1fd49277acae3$var$BoxParser.OK,
                box: box1,
                size: box1.size
            };
        }
    }
    if (size !== 0 && size < hdr_size) {
        $c9a1fd49277acae3$var$Log.error("BoxParser", "Box of type " + type + " has an invalid size " + size + " (too small to be a box)");
        return {
            code: $c9a1fd49277acae3$var$BoxParser.ERR_NOT_ENOUGH_DATA,
            type: type,
            size: size,
            hdr_size: hdr_size,
            start: start
        };
    }
    if (size !== 0 && parentSize && size > parentSize) {
        $c9a1fd49277acae3$var$Log.error("BoxParser", "Box of type '" + type + "' has a size " + size + " greater than its container size " + parentSize);
        return {
            code: $c9a1fd49277acae3$var$BoxParser.ERR_NOT_ENOUGH_DATA,
            type: type,
            size: size,
            hdr_size: hdr_size,
            start: start
        };
    }
    if (size !== 0 && start + size > stream.getEndPosition()) {
        stream.seek(start);
        $c9a1fd49277acae3$var$Log.info("BoxParser", "Not enough data in stream to parse the entire '" + type + "' box");
        return {
            code: $c9a1fd49277acae3$var$BoxParser.ERR_NOT_ENOUGH_DATA,
            type: type,
            size: size,
            hdr_size: hdr_size,
            start: start
        };
    }
    if (headerOnly) return {
        code: $c9a1fd49277acae3$var$BoxParser.OK,
        type: type,
        size: size,
        hdr_size: hdr_size,
        start: start
    };
    else if ($c9a1fd49277acae3$var$BoxParser[type + "Box"]) box1 = new $c9a1fd49277acae3$var$BoxParser[type + "Box"](size);
    else {
        if (type !== "uuid") {
            $c9a1fd49277acae3$var$Log.warn("BoxParser", "Unknown box type: '" + type + "'");
            box1 = new $c9a1fd49277acae3$var$BoxParser.Box(type, size);
            box1.has_unparsed_data = true;
        } else if ($c9a1fd49277acae3$var$BoxParser.UUIDBoxes[uuid]) box1 = new $c9a1fd49277acae3$var$BoxParser.UUIDBoxes[uuid](size);
        else {
            $c9a1fd49277acae3$var$Log.warn("BoxParser", "Unknown uuid type: '" + uuid + "'");
            box1 = new $c9a1fd49277acae3$var$BoxParser.Box(type, size);
            box1.uuid = uuid;
            box1.has_unparsed_data = true;
        }
    }
    box1.hdr_size = hdr_size;
    /* recording the position of the box in the input stream */ box1.start = start;
    if (box1.write === $c9a1fd49277acae3$var$BoxParser.Box.prototype.write && box1.type !== "mdat") {
        $c9a1fd49277acae3$var$Log.info("BoxParser", "'" + box_type + "' box writing not yet implemented, keeping unparsed data in memory for later write");
        box1.parseDataAndRewind(stream);
    }
    box1.parse(stream);
    diff = stream.getPosition() - (box1.start + box1.size);
    if (diff < 0) {
        $c9a1fd49277acae3$var$Log.warn("BoxParser", "Parsing of box '" + box_type + "' did not read the entire indicated box data size (missing " + -diff + " bytes), seeking forward");
        stream.seek(box1.start + box1.size);
    } else if (diff > 0) {
        $c9a1fd49277acae3$var$Log.error("BoxParser", "Parsing of box '" + box_type + "' read " + diff + " more bytes than the indicated box data size, seeking backwards");
        if (box1.size !== 0) stream.seek(box1.start + box1.size);
    }
    return {
        code: $c9a1fd49277acae3$var$BoxParser.OK,
        box: box1,
        size: box1.size
    };
};
$c9a1fd49277acae3$var$BoxParser.Box.prototype.parse = function(stream) {
    if (this.type != "mdat") this.data = stream.readUint8Array(this.size - this.hdr_size);
    else if (this.size === 0) stream.seek(stream.getEndPosition());
    else stream.seek(this.start + this.size);
};
/* Used to parse a box without consuming its data, to allow detailled parsing
Useful for boxes for which a write method is not yet implemented */ $c9a1fd49277acae3$var$BoxParser.Box.prototype.parseDataAndRewind = function(stream) {
    this.data = stream.readUint8Array(this.size - this.hdr_size);
    // rewinding
    stream.position -= this.size - this.hdr_size;
};
$c9a1fd49277acae3$var$BoxParser.FullBox.prototype.parseDataAndRewind = function(stream) {
    this.parseFullHeader(stream);
    this.data = stream.readUint8Array(this.size - this.hdr_size);
    // restore the header size as if the full header had not been parsed
    this.hdr_size -= 4;
    // rewinding
    stream.position -= this.size - this.hdr_size;
};
$c9a1fd49277acae3$var$BoxParser.FullBox.prototype.parseFullHeader = function(stream) {
    this.version = stream.readUint8();
    this.flags = stream.readUint24();
    this.hdr_size += 4;
};
$c9a1fd49277acae3$var$BoxParser.FullBox.prototype.parse = function(stream) {
    this.parseFullHeader(stream);
    this.data = stream.readUint8Array(this.size - this.hdr_size);
};
$c9a1fd49277acae3$var$BoxParser.ContainerBox.prototype.parse = function(stream) {
    var ret1;
    var box1;
    while(stream.getPosition() < this.start + this.size){
        ret1 = $c9a1fd49277acae3$var$BoxParser.parseOneBox(stream, false, this.size - (stream.getPosition() - this.start));
        if (ret1.code === $c9a1fd49277acae3$var$BoxParser.OK) {
            box1 = ret1.box;
            /* store the box in the 'boxes' array to preserve box order (for offset) but also store box in a property for more direct access */ this.boxes.push(box1);
            if (this.subBoxNames && this.subBoxNames.indexOf(box1.type) != -1) this[this.subBoxNames[this.subBoxNames.indexOf(box1.type)] + "s"].push(box1);
            else {
                var box_type = box1.type !== "uuid" ? box1.type : box1.uuid;
                if (this[box_type]) $c9a1fd49277acae3$var$Log.warn("Box of type " + box_type + " already stored in field of this type");
                else this[box_type] = box1;
            }
        } else return;
    }
};
$c9a1fd49277acae3$var$BoxParser.Box.prototype.parseLanguage = function(stream) {
    this.language = stream.readUint16();
    var chars = [];
    chars[0] = this.language >> 10 & 0x1F;
    chars[1] = this.language >> 5 & 0x1F;
    chars[2] = this.language & 0x1F;
    this.languageString = String.fromCharCode(chars[0] + 0x60, chars[1] + 0x60, chars[2] + 0x60);
};
// file:src/parsing/sampleentries/sampleentry.js
$c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL = "Visual";
$c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO = "Audio";
$c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_HINT = "Hint";
$c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_METADATA = "Metadata";
$c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE = "Subtitle";
$c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_SYSTEM = "System";
$c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_TEXT = "Text";
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.parseHeader = function(stream) {
    stream.readUint8Array(6);
    this.data_reference_index = stream.readUint16();
    this.hdr_size += 8;
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.parse = function(stream) {
    this.parseHeader(stream);
    this.data = stream.readUint8Array(this.size - this.hdr_size);
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.parseDataAndRewind = function(stream) {
    this.parseHeader(stream);
    this.data = stream.readUint8Array(this.size - this.hdr_size);
    // restore the header size as if the sample entry header had not been parsed
    this.hdr_size -= 8;
    // rewinding
    stream.position -= this.size - this.hdr_size;
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.parseFooter = function(stream) {
    $c9a1fd49277acae3$var$BoxParser.ContainerBox.prototype.parse.call(this, stream);
};
// Base SampleEntry types with default parsing
$c9a1fd49277acae3$var$BoxParser.createMediaSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_HINT);
$c9a1fd49277acae3$var$BoxParser.createMediaSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_METADATA);
$c9a1fd49277acae3$var$BoxParser.createMediaSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE);
$c9a1fd49277acae3$var$BoxParser.createMediaSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_SYSTEM);
$c9a1fd49277acae3$var$BoxParser.createMediaSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_TEXT);
//Base SampleEntry types for Audio and Video with specific parsing
$c9a1fd49277acae3$var$BoxParser.createMediaSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, function(stream) {
    var compressorname_length;
    this.parseHeader(stream);
    stream.readUint16();
    stream.readUint16();
    stream.readUint32Array(3);
    this.width = stream.readUint16();
    this.height = stream.readUint16();
    this.horizresolution = stream.readUint32();
    this.vertresolution = stream.readUint32();
    stream.readUint32();
    this.frame_count = stream.readUint16();
    compressorname_length = Math.min(31, stream.readUint8());
    this.compressorname = stream.readString(compressorname_length);
    if (compressorname_length < 31) stream.readString(31 - compressorname_length);
    this.depth = stream.readUint16();
    stream.readUint16();
    this.parseFooter(stream);
});
$c9a1fd49277acae3$var$BoxParser.createMediaSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, function(stream) {
    this.parseHeader(stream);
    stream.readUint32Array(2);
    this.channel_count = stream.readUint16();
    this.samplesize = stream.readUint16();
    stream.readUint16();
    stream.readUint16();
    this.samplerate = stream.readUint32() / 65536;
    this.parseFooter(stream);
});
// Sample entries inheriting from Audio and Video
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "avc1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "avc2");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "avc3");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "avc4");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "av01");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "dav1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "hvc1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "hev1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "hvt1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "lhe1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "dvh1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "dvhe");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "vvc1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "vvi1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "vvs1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "vvcN");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "vp08");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "vp09");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "avs3");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "j2ki");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "mjp2");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "mjpg");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "uncv");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, "mp4a");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, "ac-3");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, "ac-4");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, "ec-3");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, "Opus");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, "mha1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, "mha2");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, "mhm1");
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, "mhm2");
// Encrypted sample entries
$c9a1fd49277acae3$var$BoxParser.createEncryptedSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "encv");
$c9a1fd49277acae3$var$BoxParser.createEncryptedSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, "enca");
$c9a1fd49277acae3$var$BoxParser.createEncryptedSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE, "encu");
$c9a1fd49277acae3$var$BoxParser.createEncryptedSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_SYSTEM, "encs");
$c9a1fd49277acae3$var$BoxParser.createEncryptedSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_TEXT, "enct");
$c9a1fd49277acae3$var$BoxParser.createEncryptedSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_METADATA, "encm");
// file:src/parsing/a1lx.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("a1lx", function(stream) {
    var large_size = stream.readUint8() & 1;
    var FieldLength = ((large_size & 1) + 1) * 16;
    this.layer_size = [];
    for(var i1 = 0; i1 < 3; i1++)if (FieldLength == 16) this.layer_size[i1] = stream.readUint16();
    else this.layer_size[i1] = stream.readUint32();
}); // file:src/parsing/a1op.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("a1op", function(stream) {
    this.op_index = stream.readUint8();
}); // file:src/parsing/auxC.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("auxC", function(stream) {
    this.aux_type = stream.readCString();
    var aux_subtype_length = this.size - this.hdr_size - (this.aux_type.length + 1);
    this.aux_subtype = stream.readUint8Array(aux_subtype_length);
}); // file:src/parsing/av1C.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("av1C", function(stream) {
    var i1;
    var toparse;
    var tmp = stream.readUint8();
    this.version = tmp & 0x7F;
    if (this.version !== 1) {
        $c9a1fd49277acae3$var$Log.error("av1C version " + this.version + " not supported");
        return;
    }
    tmp = stream.readUint8();
    this.seq_profile = tmp >> 5 & 0x7;
    this.seq_level_idx_0 = tmp & 0x1F;
    tmp = stream.readUint8();
    this.seq_tier_0 = tmp >> 7 & 0x1;
    this.high_bitdepth = tmp >> 6 & 0x1;
    this.twelve_bit = tmp >> 5 & 0x1;
    this.monochrome = tmp >> 4 & 0x1;
    this.chroma_subsampling_x = tmp >> 3 & 0x1;
    this.chroma_subsampling_y = tmp >> 2 & 0x1;
    this.chroma_sample_position = tmp & 0x3;
    tmp = stream.readUint8();
    this.reserved_1 = tmp >> 5 & 0x7;
    if (this.reserved_1 !== 0) {
        $c9a1fd49277acae3$var$Log.error("av1C reserved_1 parsing problem");
        return;
    }
    this.initial_presentation_delay_present = tmp >> 4 & 0x1;
    if (this.initial_presentation_delay_present === 1) this.initial_presentation_delay_minus_one = tmp & 0xF;
    else {
        this.reserved_2 = tmp & 0xF;
        if (this.reserved_2 !== 0) {
            $c9a1fd49277acae3$var$Log.error("av1C reserved_2 parsing problem");
            return;
        }
    }
    var configOBUs_length = this.size - this.hdr_size - 4;
    this.configOBUs = stream.readUint8Array(configOBUs_length);
});
// file:src/parsing/avcC.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("avcC", function(stream) {
    var i1;
    var toparse;
    this.configurationVersion = stream.readUint8();
    this.AVCProfileIndication = stream.readUint8();
    this.profile_compatibility = stream.readUint8();
    this.AVCLevelIndication = stream.readUint8();
    this.lengthSizeMinusOne = stream.readUint8() & 0x3;
    this.nb_SPS_nalus = stream.readUint8() & 0x1F;
    toparse = this.size - this.hdr_size - 6;
    this.SPS = [];
    for(i1 = 0; i1 < this.nb_SPS_nalus; i1++){
        this.SPS[i1] = {};
        this.SPS[i1].length = stream.readUint16();
        this.SPS[i1].nalu = stream.readUint8Array(this.SPS[i1].length);
        toparse -= 2 + this.SPS[i1].length;
    }
    this.nb_PPS_nalus = stream.readUint8();
    toparse--;
    this.PPS = [];
    for(i1 = 0; i1 < this.nb_PPS_nalus; i1++){
        this.PPS[i1] = {};
        this.PPS[i1].length = stream.readUint16();
        this.PPS[i1].nalu = stream.readUint8Array(this.PPS[i1].length);
        toparse -= 2 + this.PPS[i1].length;
    }
    if (toparse > 0) this.ext = stream.readUint8Array(toparse);
});
// file:src/parsing/btrt.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("btrt", function(stream) {
    this.bufferSizeDB = stream.readUint32();
    this.maxBitrate = stream.readUint32();
    this.avgBitrate = stream.readUint32();
});
// file:src/parsing/ccst.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("ccst", function(stream) {
    var flags = stream.readUint8();
    this.all_ref_pics_intra = (flags & 0x80) == 0x80;
    this.intra_pred_used = (flags & 0x40) == 0x40;
    this.max_ref_per_pic = (flags & 0x3f) >> 2;
    stream.readUint24();
});
// file:src/parsing/cdef.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("cdef", function(stream) {
    var i1;
    this.channel_count = stream.readUint16();
    this.channel_indexes = [];
    this.channel_types = [];
    this.channel_associations = [];
    for(i1 = 0; i1 < this.channel_count; i1++){
        this.channel_indexes.push(stream.readUint16());
        this.channel_types.push(stream.readUint16());
        this.channel_associations.push(stream.readUint16());
    }
});
// file:src/parsing/clap.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("clap", function(stream) {
    this.cleanApertureWidthN = stream.readUint32();
    this.cleanApertureWidthD = stream.readUint32();
    this.cleanApertureHeightN = stream.readUint32();
    this.cleanApertureHeightD = stream.readUint32();
    this.horizOffN = stream.readUint32();
    this.horizOffD = stream.readUint32();
    this.vertOffN = stream.readUint32();
    this.vertOffD = stream.readUint32();
}); // file:src/parsing/clli.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("clli", function(stream) {
    this.max_content_light_level = stream.readUint16();
    this.max_pic_average_light_level = stream.readUint16();
});
// file:src/parsing/cmex.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("cmex", function(stream) {
    if (this.flags & 0x1) this.pos_x = stream.readInt32();
    if (this.flags & 0x2) this.pos_y = stream.readInt32();
    if (this.flags & 0x4) this.pos_z = stream.readInt32();
    if (this.flags & 0x8) {
        if (this.version == 0) {
            if (this.flags & 0x10) {
                this.quat_x = stream.readInt32();
                this.quat_y = stream.readInt32();
                this.quat_z = stream.readInt32();
            } else {
                this.quat_x = stream.readInt16();
                this.quat_y = stream.readInt16();
                this.quat_z = stream.readInt16();
            }
        } else this.version;
    }
    if (this.flags & 0x20) this.id = stream.readUint32();
});
// file:src/parsing/cmin.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("cmin", function(stream) {
    this.focal_length_x = stream.readInt32();
    this.principal_point_x = stream.readInt32();
    this.principal_point_y = stream.readInt32();
    if (this.flags & 0x1) {
        this.focal_length_y = stream.readInt32();
        this.skew_factor = stream.readInt32();
    }
}); // file:src/parsing/cmpd.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("cmpd", function(stream) {
    this.component_count = stream.readUint32();
    this.component_types = [];
    this.component_type_urls = [];
    for(i = 0; i < this.component_count; i++){
        var component_type = stream.readUint16();
        this.component_types.push(component_type);
        if (component_type >= 0x8000) this.component_type_urls.push(stream.readCString());
    }
}); // file:src/parsing/co64.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("co64", function(stream) {
    var entry_count1;
    var i1;
    entry_count1 = stream.readUint32();
    this.chunk_offsets = [];
    if (this.version === 0) for(i1 = 0; i1 < entry_count1; i1++)this.chunk_offsets.push(stream.readUint64());
});
// file:src/parsing/CoLL.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("CoLL", function(stream) {
    this.maxCLL = stream.readUint16();
    this.maxFALL = stream.readUint16();
});
// file:src/parsing/colr.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("colr", function(stream) {
    this.colour_type = stream.readString(4);
    if (this.colour_type === "nclx") {
        this.colour_primaries = stream.readUint16();
        this.transfer_characteristics = stream.readUint16();
        this.matrix_coefficients = stream.readUint16();
        var tmp = stream.readUint8();
        this.full_range_flag = tmp >> 7;
    } else if (this.colour_type === "rICC") this.ICC_profile = stream.readUint8Array(this.size - 4);
    else if (this.colour_type === "prof") this.ICC_profile = stream.readUint8Array(this.size - 4);
}); // file:src/parsing/cprt.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("cprt", function(stream) {
    this.parseLanguage(stream);
    this.notice = stream.readCString();
});
// file:src/parsing/cslg.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("cslg", function(stream) {
    var entry_count1;
    if (this.version === 0) {
        this.compositionToDTSShift = stream.readInt32(); /* signed */ 
        this.leastDecodeToDisplayDelta = stream.readInt32(); /* signed */ 
        this.greatestDecodeToDisplayDelta = stream.readInt32(); /* signed */ 
        this.compositionStartTime = stream.readInt32(); /* signed */ 
        this.compositionEndTime = stream.readInt32(); /* signed */ 
    }
});
// file:src/parsing/ctts.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("ctts", function(stream) {
    var entry_count1;
    var i1;
    entry_count1 = stream.readUint32();
    this.sample_counts = [];
    this.sample_offsets = [];
    if (this.version === 0) for(i1 = 0; i1 < entry_count1; i1++){
        this.sample_counts.push(stream.readUint32());
        /* some files are buggy and declare version=0 while using signed offsets.
           The likelyhood of using the most significant bit in a 32-bits time offset is very low,
           so using signed value here as well */ var value = stream.readInt32();
        if (value < 0) $c9a1fd49277acae3$var$Log.warn("BoxParser", "ctts box uses negative values without using version 1");
        this.sample_offsets.push(value);
    }
    else if (this.version == 1) for(i1 = 0; i1 < entry_count1; i1++){
        this.sample_counts.push(stream.readUint32());
        this.sample_offsets.push(stream.readInt32()); /* signed */ 
    }
});
// file:src/parsing/dac3.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("dac3", function(stream) {
    var tmp_byte1 = stream.readUint8();
    var tmp_byte2 = stream.readUint8();
    var tmp_byte3 = stream.readUint8();
    this.fscod = tmp_byte1 >> 6;
    this.bsid = tmp_byte1 >> 1 & 0x1F;
    this.bsmod = (tmp_byte1 & 0x1) << 2 | tmp_byte2 >> 6 & 0x3;
    this.acmod = tmp_byte2 >> 3 & 0x7;
    this.lfeon = tmp_byte2 >> 2 & 0x1;
    this.bit_rate_code = tmp_byte2 & 0x3 | tmp_byte3 >> 5 & 0x7;
});
// file:src/parsing/dec3.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("dec3", function(stream) {
    var tmp_16 = stream.readUint16();
    this.data_rate = tmp_16 >> 3;
    this.num_ind_sub = tmp_16 & 0x7;
    this.ind_subs = [];
    for(var i1 = 0; i1 < this.num_ind_sub + 1; i1++){
        var ind_sub = {};
        this.ind_subs.push(ind_sub);
        var tmp_byte1 = stream.readUint8();
        var tmp_byte2 = stream.readUint8();
        var tmp_byte3 = stream.readUint8();
        ind_sub.fscod = tmp_byte1 >> 6;
        ind_sub.bsid = tmp_byte1 >> 1 & 0x1F;
        ind_sub.bsmod = (tmp_byte1 & 0x1) << 4 | tmp_byte2 >> 4 & 0xF;
        ind_sub.acmod = tmp_byte2 >> 1 & 0x7;
        ind_sub.lfeon = tmp_byte2 & 0x1;
        ind_sub.num_dep_sub = tmp_byte3 >> 1 & 0xF;
        if (ind_sub.num_dep_sub > 0) ind_sub.chan_loc = (tmp_byte3 & 0x1) << 8 | stream.readUint8();
    }
});
// file:src/parsing/dfLa.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("dfLa", function(stream) {
    var BLOCKTYPE_MASK = 0x7F;
    var LASTMETADATABLOCKFLAG_MASK = 0x80;
    var boxesFound = [];
    var knownBlockTypes = [
        "STREAMINFO",
        "PADDING",
        "APPLICATION",
        "SEEKTABLE",
        "VORBIS_COMMENT",
        "CUESHEET",
        "PICTURE",
        "RESERVED"
    ];
    // dfLa is a FullBox
    this.parseFullHeader(stream);
    // for (i=0; ; i++) { // to end of box
    do {
        var flagAndType = stream.readUint8();
        var type = Math.min(flagAndType & BLOCKTYPE_MASK, knownBlockTypes.length - 1);
        // if this is a STREAMINFO block, read the true samplerate since this
        // can be different to the AudioSampleEntry samplerate.
        if (!type) {
            // read past all the other stuff
            stream.readUint8Array(13);
            // extract samplerate
            this.samplerate = stream.readUint32() >> 12;
            // read to end of STREAMINFO
            stream.readUint8Array(20);
        } else // not interested in other block types so just discard length bytes
        stream.readUint8Array(stream.readUint24());
        boxesFound.push(knownBlockTypes[type]);
        if (!!(flagAndType & LASTMETADATABLOCKFLAG_MASK)) break;
    }while (true);
    this.numMetadataBlocks = boxesFound.length + " (" + boxesFound.join(", ") + ")";
});
// file:src/parsing/dimm.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("dimm", function(stream) {
    this.bytessent = stream.readUint64();
});
// file:src/parsing/dmax.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("dmax", function(stream) {
    this.time = stream.readUint32();
});
// file:src/parsing/dmed.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("dmed", function(stream) {
    this.bytessent = stream.readUint64();
});
// file:src/parsing/dOps.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("dOps", function(stream) {
    this.Version = stream.readUint8();
    this.OutputChannelCount = stream.readUint8();
    this.PreSkip = stream.readUint16();
    this.InputSampleRate = stream.readUint32();
    this.OutputGain = stream.readInt16();
    this.ChannelMappingFamily = stream.readUint8();
    if (this.ChannelMappingFamily !== 0) {
        this.StreamCount = stream.readUint8();
        this.CoupledCount = stream.readUint8();
        this.ChannelMapping = [];
        for(var i1 = 0; i1 < this.OutputChannelCount; i1++)this.ChannelMapping[i1] = stream.readUint8();
    }
});
// file:src/parsing/dref.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("dref", function(stream) {
    var ret1;
    var box1;
    this.entries = [];
    var entry_count1 = stream.readUint32();
    for(var i1 = 0; i1 < entry_count1; i1++){
        ret1 = $c9a1fd49277acae3$var$BoxParser.parseOneBox(stream, false, this.size - (stream.getPosition() - this.start));
        if (ret1.code === $c9a1fd49277acae3$var$BoxParser.OK) {
            box1 = ret1.box;
            this.entries.push(box1);
        } else return;
    }
});
// file:src/parsing/drep.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("drep", function(stream) {
    this.bytessent = stream.readUint64();
});
// file:src/parsing/elng.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("elng", function(stream) {
    this.extended_language = stream.readString(this.size - this.hdr_size);
});
// file:src/parsing/elst.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("elst", function(stream) {
    this.entries = [];
    var entry_count1 = stream.readUint32();
    for(var i1 = 0; i1 < entry_count1; i1++){
        var entry = {};
        this.entries.push(entry);
        if (this.version === 1) {
            entry.segment_duration = stream.readUint64();
            entry.media_time = stream.readInt64();
        } else {
            entry.segment_duration = stream.readUint32();
            entry.media_time = stream.readInt32();
        }
        entry.media_rate_integer = stream.readInt16();
        entry.media_rate_fraction = stream.readInt16();
    }
});
// file:src/parsing/emsg.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("emsg", function(stream) {
    if (this.version == 1) {
        this.timescale = stream.readUint32();
        this.presentation_time = stream.readUint64();
        this.event_duration = stream.readUint32();
        this.id = stream.readUint32();
        this.scheme_id_uri = stream.readCString();
        this.value = stream.readCString();
    } else {
        this.scheme_id_uri = stream.readCString();
        this.value = stream.readCString();
        this.timescale = stream.readUint32();
        this.presentation_time_delta = stream.readUint32();
        this.event_duration = stream.readUint32();
        this.id = stream.readUint32();
    }
    var message_size = this.size - this.hdr_size - (16 + (this.scheme_id_uri.length + 1) + (this.value.length + 1));
    if (this.version == 1) message_size -= 4;
    this.message_data = stream.readUint8Array(message_size);
});
// file:src/parsing/EntityToGroup.js
// ISO/IEC 14496-12:2022 Section 8.18.3 Entity to group box
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor = function(type, parseMethod) {
    $c9a1fd49277acae3$var$BoxParser[type + "Box"] = function(size) {
        $c9a1fd49277acae3$var$BoxParser.FullBox.call(this, type, size);
    };
    $c9a1fd49277acae3$var$BoxParser[type + "Box"].prototype = new $c9a1fd49277acae3$var$BoxParser.FullBox();
    $c9a1fd49277acae3$var$BoxParser[type + "Box"].prototype.parse = function(stream) {
        this.parseFullHeader(stream);
        if (parseMethod) parseMethod.call(this, stream);
        else {
            this.group_id = stream.readUint32();
            this.num_entities_in_group = stream.readUint32();
            this.entity_ids = [];
            for(i = 0; i < this.num_entities_in_group; i++){
                var entity_id = stream.readUint32();
                this.entity_ids.push(entity_id);
            }
        }
    };
};
// Auto exposure bracketing (ISO/IEC 23008-12:2022 Section 6.8.6.2.1)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("aebr");
// Flash exposure bracketing (ISO/IEC 23008-12:2022 Section 6.8.6.5.1)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("afbr");
// Album collection (ISO/IEC 23008-12:2022 Section 6.8.7.1)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("albc");
// Alternative entity (ISO/IEC 14496-12:2022 Section 8.18.3.1)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("altr");
// Burst image entity group (ISO/IEC 23008-12:2022 Section 6.8.2.2)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("brst");
// Depth of field bracketing (ISO/IEC 23008-12:2022 Section 6.8.6.6.1)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("dobr");
// Equivalent entity (ISO/IEC 23008-12:2022 Section 6.8.1.1)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("eqiv");
// Favourites collection (ISO/IEC 23008-12:2022 Section 6.8.7.2)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("favc");
// Focus bracketing (ISO/IEC 23008-12:2022 Section 6.8.6.4.1)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("fobr");
// Audio to image entity group (ISO/IEC 23008-12:2022 Section 6.8.4)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("iaug");
// Panorama (ISO/IEC 23008-12:2022 Section 6.8.8.1)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("pano");
// Slideshow (ISO/IEC 23008-12:2022 Section 6.8.9.1)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("slid");
// Stereo pair (ISO/IEC 23008-12:2022 Section 6.8.5)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("ster");
// Time-synchronised capture entity group (ISO/IEC 23008-12:2022 Section 6.8.3)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("tsyn");
// White balance bracketing (ISO/IEC 23008-12:2022 Section 6.8.6.3.1)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("wbbr");
// Alternative entity (ISO/IEC 23008-12:2022 AMD1 Section 6.8.10)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("prgr");
// Image Pyramid entity group (ISO/IEC 23008-12:20xx Section 6.8.11)
$c9a1fd49277acae3$var$BoxParser.createEntityToGroupCtor("pymd", function(stream) {
    this.group_id = stream.readUint32();
    this.num_entities_in_group = stream.readUint32();
    this.entity_ids = [];
    for(var i1 = 0; i1 < this.num_entities_in_group; i1++){
        var entity_id = stream.readUint32();
        this.entity_ids.push(entity_id);
    }
    this.tile_size_x = stream.readUint16();
    this.tile_size_y = stream.readUint16();
    this.layer_binning = [];
    this.tiles_in_layer_column_minus1 = [];
    this.tiles_in_layer_row_minus1 = [];
    for(i1 = 0; i1 < this.num_entities_in_group; i1++){
        this.layer_binning[i1] = stream.readUint16();
        this.tiles_in_layer_row_minus1[i1] = stream.readUint16();
        this.tiles_in_layer_column_minus1[i1] = stream.readUint16();
    }
});
// file:src/parsing/esds.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("esds", function(stream) {
    var esd_data = stream.readUint8Array(this.size - this.hdr_size);
    if (typeof $c9a1fd49277acae3$var$MPEG4DescriptorParser !== "undefined") {
        var esd_parser = new $c9a1fd49277acae3$var$MPEG4DescriptorParser();
        this.esd = esd_parser.parseOneDescriptor(new $c9a1fd49277acae3$var$DataStream(esd_data.buffer, 0, $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN));
    }
});
// file:src/parsing/fiel.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("fiel", function(stream) {
    this.fieldCount = stream.readUint8();
    this.fieldOrdering = stream.readUint8();
});
// file:src/parsing/frma.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("frma", function(stream) {
    this.data_format = stream.readString(4);
});
// file:src/parsing/ftyp.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("ftyp", function(stream) {
    var toparse = this.size - this.hdr_size;
    this.major_brand = stream.readString(4);
    this.minor_version = stream.readUint32();
    toparse -= 8;
    this.compatible_brands = [];
    var i1 = 0;
    while(toparse >= 4){
        this.compatible_brands[i1] = stream.readString(4);
        toparse -= 4;
        i1++;
    }
});
// file:src/parsing/hdlr.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("hdlr", function(stream) {
    if (this.version === 0) {
        stream.readUint32();
        this.handler = stream.readString(4);
        stream.readUint32Array(3);
        this.name = stream.readString(this.size - this.hdr_size - 20);
        if (this.name[this.name.length - 1] === "\0") this.name = this.name.slice(0, -1);
    }
});
// file:src/parsing/hvcC.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("hvcC", function(stream) {
    var i1, j;
    var nb_nalus;
    var length;
    var tmp_byte;
    this.configurationVersion = stream.readUint8();
    tmp_byte = stream.readUint8();
    this.general_profile_space = tmp_byte >> 6;
    this.general_tier_flag = (tmp_byte & 0x20) >> 5;
    this.general_profile_idc = tmp_byte & 0x1F;
    this.general_profile_compatibility = stream.readUint32();
    this.general_constraint_indicator = stream.readUint8Array(6);
    this.general_level_idc = stream.readUint8();
    this.min_spatial_segmentation_idc = stream.readUint16() & 0xFFF;
    this.parallelismType = stream.readUint8() & 0x3;
    this.chroma_format_idc = stream.readUint8() & 0x3;
    this.bit_depth_luma_minus8 = stream.readUint8() & 0x7;
    this.bit_depth_chroma_minus8 = stream.readUint8() & 0x7;
    this.avgFrameRate = stream.readUint16();
    tmp_byte = stream.readUint8();
    this.constantFrameRate = tmp_byte >> 6;
    this.numTemporalLayers = (tmp_byte & 0XD) >> 3;
    this.temporalIdNested = (tmp_byte & 0X4) >> 2;
    this.lengthSizeMinusOne = tmp_byte & 0X3;
    this.nalu_arrays = [];
    var numOfArrays = stream.readUint8();
    for(i1 = 0; i1 < numOfArrays; i1++){
        var nalu_array = [];
        this.nalu_arrays.push(nalu_array);
        tmp_byte = stream.readUint8();
        nalu_array.completeness = (tmp_byte & 0x80) >> 7;
        nalu_array.nalu_type = tmp_byte & 0x3F;
        var numNalus = stream.readUint16();
        for(j = 0; j < numNalus; j++){
            var nalu = {};
            nalu_array.push(nalu);
            length = stream.readUint16();
            nalu.data = stream.readUint8Array(length);
        }
    }
});
// file:src/parsing/iinf.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("iinf", function(stream) {
    var ret1;
    if (this.version === 0) this.entry_count = stream.readUint16();
    else this.entry_count = stream.readUint32();
    this.item_infos = [];
    for(var i1 = 0; i1 < this.entry_count; i1++){
        ret1 = $c9a1fd49277acae3$var$BoxParser.parseOneBox(stream, false, this.size - (stream.getPosition() - this.start));
        if (ret1.code === $c9a1fd49277acae3$var$BoxParser.OK) {
            if (ret1.box.type !== "infe") $c9a1fd49277acae3$var$Log.error("BoxParser", "Expected 'infe' box, got " + ret1.box.type);
            this.item_infos[i1] = ret1.box;
        } else return;
    }
});
// file:src/parsing/iloc.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("iloc", function(stream) {
    var byte;
    byte = stream.readUint8();
    this.offset_size = byte >> 4 & 0xF;
    this.length_size = byte & 0xF;
    byte = stream.readUint8();
    this.base_offset_size = byte >> 4 & 0xF;
    if (this.version === 1 || this.version === 2) this.index_size = byte & 0xF;
    else this.index_size = 0;
    this.items = [];
    var item_count = 0;
    if (this.version < 2) item_count = stream.readUint16();
    else if (this.version === 2) item_count = stream.readUint32();
    else throw "version of iloc box not supported";
    for(var i1 = 0; i1 < item_count; i1++){
        var item = {};
        this.items.push(item);
        if (this.version < 2) item.item_ID = stream.readUint16();
        else if (this.version === 2) item.item_ID = stream.readUint32();
        else throw "version of iloc box not supported";
        if (this.version === 1 || this.version === 2) item.construction_method = stream.readUint16() & 0xF;
        else item.construction_method = 0;
        item.data_reference_index = stream.readUint16();
        switch(this.base_offset_size){
            case 0:
                item.base_offset = 0;
                break;
            case 4:
                item.base_offset = stream.readUint32();
                break;
            case 8:
                item.base_offset = stream.readUint64();
                break;
            default:
                throw "Error reading base offset size";
        }
        var extent_count = stream.readUint16();
        item.extents = [];
        for(var j = 0; j < extent_count; j++){
            var extent = {};
            item.extents.push(extent);
            if (this.version === 1 || this.version === 2) switch(this.index_size){
                case 0:
                    extent.extent_index = 0;
                    break;
                case 4:
                    extent.extent_index = stream.readUint32();
                    break;
                case 8:
                    extent.extent_index = stream.readUint64();
                    break;
                default:
                    throw "Error reading extent index";
            }
            switch(this.offset_size){
                case 0:
                    extent.extent_offset = 0;
                    break;
                case 4:
                    extent.extent_offset = stream.readUint32();
                    break;
                case 8:
                    extent.extent_offset = stream.readUint64();
                    break;
                default:
                    throw "Error reading extent index";
            }
            switch(this.length_size){
                case 0:
                    extent.extent_length = 0;
                    break;
                case 4:
                    extent.extent_length = stream.readUint32();
                    break;
                case 8:
                    extent.extent_length = stream.readUint64();
                    break;
                default:
                    throw "Error reading extent index";
            }
        }
    }
});
// file:src/parsing/imir.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("imir", function(stream) {
    var tmp = stream.readUint8();
    this.reserved = tmp >> 7;
    this.axis = tmp & 1;
}); // file:src/parsing/infe.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("infe", function(stream) {
    if (this.version === 0 || this.version === 1) {
        this.item_ID = stream.readUint16();
        this.item_protection_index = stream.readUint16();
        this.item_name = stream.readCString();
        this.content_type = stream.readCString();
        this.content_encoding = stream.readCString();
    }
    if (this.version === 1) {
        this.extension_type = stream.readString(4);
        $c9a1fd49277acae3$var$Log.warn("BoxParser", "Cannot parse extension type");
        stream.seek(this.start + this.size);
        return;
    }
    if (this.version >= 2) {
        if (this.version === 2) this.item_ID = stream.readUint16();
        else if (this.version === 3) this.item_ID = stream.readUint32();
        this.item_protection_index = stream.readUint16();
        this.item_type = stream.readString(4);
        this.item_name = stream.readCString();
        if (this.item_type === "mime") {
            this.content_type = stream.readCString();
            this.content_encoding = stream.readCString();
        } else if (this.item_type === "uri ") this.item_uri_type = stream.readCString();
    }
});
// file:src/parsing/ipma.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("ipma", function(stream) {
    var i1, j;
    entry_count = stream.readUint32();
    this.associations = [];
    for(i1 = 0; i1 < entry_count; i1++){
        var item_assoc = {};
        this.associations.push(item_assoc);
        if (this.version < 1) item_assoc.id = stream.readUint16();
        else item_assoc.id = stream.readUint32();
        var association_count = stream.readUint8();
        item_assoc.props = [];
        for(j = 0; j < association_count; j++){
            var tmp = stream.readUint8();
            var p = {};
            item_assoc.props.push(p);
            p.essential = (tmp & 0x80) >> 7 === 1;
            if (this.flags & 0x1) p.property_index = (tmp & 0x7F) << 8 | stream.readUint8();
            else p.property_index = tmp & 0x7F;
        }
    }
});
// file:src/parsing/iref.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("iref", function(stream) {
    var ret1;
    var entryCount;
    var box1;
    this.references = [];
    while(stream.getPosition() < this.start + this.size){
        ret1 = $c9a1fd49277acae3$var$BoxParser.parseOneBox(stream, true, this.size - (stream.getPosition() - this.start));
        if (ret1.code === $c9a1fd49277acae3$var$BoxParser.OK) {
            if (this.version === 0) box1 = new $c9a1fd49277acae3$var$BoxParser.SingleItemTypeReferenceBox(ret1.type, ret1.size, ret1.hdr_size, ret1.start);
            else box1 = new $c9a1fd49277acae3$var$BoxParser.SingleItemTypeReferenceBoxLarge(ret1.type, ret1.size, ret1.hdr_size, ret1.start);
            if (box1.write === $c9a1fd49277acae3$var$BoxParser.Box.prototype.write && box1.type !== "mdat") {
                $c9a1fd49277acae3$var$Log.warn("BoxParser", box1.type + " box writing not yet implemented, keeping unparsed data in memory for later write");
                box1.parseDataAndRewind(stream);
            }
            box1.parse(stream);
            this.references.push(box1);
        } else return;
    }
});
// file:src/parsing/irot.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("irot", function(stream) {
    this.angle = stream.readUint8() & 0x3;
});
// file:src/parsing/ispe.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("ispe", function(stream) {
    this.image_width = stream.readUint32();
    this.image_height = stream.readUint32();
}); // file:src/parsing/kind.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("kind", function(stream) {
    this.schemeURI = stream.readCString();
    this.value = stream.readCString();
});
// file:src/parsing/leva.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("leva", function(stream) {
    var count = stream.readUint8();
    this.levels = [];
    for(var i1 = 0; i1 < count; i1++){
        var level = {};
        this.levels[i1] = level;
        level.track_ID = stream.readUint32();
        var tmp_byte = stream.readUint8();
        level.padding_flag = tmp_byte >> 7;
        level.assignment_type = tmp_byte & 0x7F;
        switch(level.assignment_type){
            case 0:
                level.grouping_type = stream.readString(4);
                break;
            case 1:
                level.grouping_type = stream.readString(4);
                level.grouping_type_parameter = stream.readUint32();
                break;
            case 2:
                break;
            case 3:
                break;
            case 4:
                level.sub_track_id = stream.readUint32();
                break;
            default:
                $c9a1fd49277acae3$var$Log.warn("BoxParser", "Unknown leva assignement type");
        }
    }
});
// file:src/parsing/lhvC.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("lhvC", function(stream) {
    var i1, j;
    var tmp_byte;
    this.configurationVersion = stream.readUint8();
    this.min_spatial_segmentation_idc = stream.readUint16() & 0xFFF;
    this.parallelismType = stream.readUint8() & 0x3;
    tmp_byte = stream.readUint8();
    this.numTemporalLayers = (tmp_byte & 0XD) >> 3;
    this.temporalIdNested = (tmp_byte & 0X4) >> 2;
    this.lengthSizeMinusOne = tmp_byte & 0X3;
    this.nalu_arrays = [];
    var numOfArrays = stream.readUint8();
    for(i1 = 0; i1 < numOfArrays; i1++){
        var nalu_array = [];
        this.nalu_arrays.push(nalu_array);
        tmp_byte = stream.readUint8();
        nalu_array.completeness = (tmp_byte & 0x80) >> 7;
        nalu_array.nalu_type = tmp_byte & 0x3F;
        var numNalus = stream.readUint16();
        for(j = 0; j < numNalus; j++){
            var nalu = {};
            nalu_array.push(nalu);
            var length = stream.readUint16();
            nalu.data = stream.readUint8Array(length);
        }
    }
});
// file:src/parsing/lsel.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("lsel", function(stream) {
    this.layer_id = stream.readUint16();
}); // file:src/parsing/maxr.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("maxr", function(stream) {
    this.period = stream.readUint32();
    this.bytes = stream.readUint32();
});
// file:src/parsing/mdcv.js
function $c9a1fd49277acae3$var$ColorPoint(x, y) {
    this.x = x;
    this.y = y;
}
$c9a1fd49277acae3$var$ColorPoint.prototype.toString = function() {
    return "(" + this.x + "," + this.y + ")";
};
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("mdcv", function(stream) {
    this.display_primaries = [];
    this.display_primaries[0] = new $c9a1fd49277acae3$var$ColorPoint(stream.readUint16(), stream.readUint16());
    this.display_primaries[1] = new $c9a1fd49277acae3$var$ColorPoint(stream.readUint16(), stream.readUint16());
    this.display_primaries[2] = new $c9a1fd49277acae3$var$ColorPoint(stream.readUint16(), stream.readUint16());
    this.white_point = new $c9a1fd49277acae3$var$ColorPoint(stream.readUint16(), stream.readUint16());
    this.max_display_mastering_luminance = stream.readUint32();
    this.min_display_mastering_luminance = stream.readUint32();
});
// file:src/parsing/mdhd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("mdhd", function(stream) {
    if (this.version == 1) {
        this.creation_time = stream.readUint64();
        this.modification_time = stream.readUint64();
        this.timescale = stream.readUint32();
        this.duration = stream.readUint64();
    } else {
        this.creation_time = stream.readUint32();
        this.modification_time = stream.readUint32();
        this.timescale = stream.readUint32();
        this.duration = stream.readUint32();
    }
    this.parseLanguage(stream);
    stream.readUint16();
});
// file:src/parsing/mehd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("mehd", function(stream) {
    if (this.flags & 0x1) {
        $c9a1fd49277acae3$var$Log.warn("BoxParser", "mehd box incorrectly uses flags set to 1, converting version to 1");
        this.version = 1;
    }
    if (this.version == 1) this.fragment_duration = stream.readUint64();
    else this.fragment_duration = stream.readUint32();
});
// file:src/parsing/meta.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("meta", function(stream) {
    this.boxes = [];
    $c9a1fd49277acae3$var$BoxParser.ContainerBox.prototype.parse.call(this, stream);
});
// file:src/parsing/mfhd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("mfhd", function(stream) {
    this.sequence_number = stream.readUint32();
});
// file:src/parsing/mfro.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("mfro", function(stream) {
    this._size = stream.readUint32();
});
// file:src/parsing/mskC.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("mskC", function(stream) {
    this.bits_per_pixel = stream.readUint8();
});
// file:src/parsing/mvhd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("mvhd", function(stream) {
    if (this.version == 1) {
        this.creation_time = stream.readUint64();
        this.modification_time = stream.readUint64();
        this.timescale = stream.readUint32();
        this.duration = stream.readUint64();
    } else {
        this.creation_time = stream.readUint32();
        this.modification_time = stream.readUint32();
        this.timescale = stream.readUint32();
        this.duration = stream.readUint32();
    }
    this.rate = stream.readUint32();
    this.volume = stream.readUint16() >> 8;
    stream.readUint16();
    stream.readUint32Array(2);
    this.matrix = stream.readUint32Array(9);
    stream.readUint32Array(6);
    this.next_track_id = stream.readUint32();
});
// file:src/parsing/npck.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("npck", function(stream) {
    this.packetssent = stream.readUint32();
});
// file:src/parsing/nump.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("nump", function(stream) {
    this.packetssent = stream.readUint64();
});
// file:src/parsing/padb.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("padb", function(stream) {
    var sample_count = stream.readUint32();
    this.padbits = [];
    for(var i1 = 0; i1 < Math.floor((sample_count + 1) / 2); i1++)this.padbits = stream.readUint8();
});
// file:src/parsing/pasp.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("pasp", function(stream) {
    this.hSpacing = stream.readUint32();
    this.vSpacing = stream.readUint32();
}); // file:src/parsing/payl.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("payl", function(stream) {
    this.text = stream.readString(this.size - this.hdr_size);
});
// file:src/parsing/payt.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("payt", function(stream) {
    this.payloadID = stream.readUint32();
    var count = stream.readUint8();
    this.rtpmap_string = stream.readString(count);
});
// file:src/parsing/pdin.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("pdin", function(stream) {
    var count = (this.size - this.hdr_size) / 8;
    this.rate = [];
    this.initial_delay = [];
    for(var i1 = 0; i1 < count; i1++){
        this.rate[i1] = stream.readUint32();
        this.initial_delay[i1] = stream.readUint32();
    }
});
// file:src/parsing/pitm.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("pitm", function(stream) {
    if (this.version === 0) this.item_id = stream.readUint16();
    else this.item_id = stream.readUint32();
});
// file:src/parsing/pixi.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("pixi", function(stream) {
    var i1;
    this.num_channels = stream.readUint8();
    this.bits_per_channels = [];
    for(i1 = 0; i1 < this.num_channels; i1++)this.bits_per_channels[i1] = stream.readUint8();
});
// file:src/parsing/pmax.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("pmax", function(stream) {
    this.bytes = stream.readUint32();
});
// file:src/parsing/prdi.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("prdi", function(stream) {
    this.step_count = stream.readUint16();
    this.item_count = [];
    if (this.flags & 0x2) for(var i1 = 0; i1 < this.step_count; i1++)this.item_count[i1] = stream.readUint16();
}); // file:src/parsing/prft.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("prft", function(stream) {
    this.ref_track_id = stream.readUint32();
    this.ntp_timestamp = stream.readUint64();
    if (this.version === 0) this.media_time = stream.readUint32();
    else this.media_time = stream.readUint64();
});
// file:src/parsing/pssh.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("pssh", function(stream) {
    this.system_id = $c9a1fd49277acae3$var$BoxParser.parseHex16(stream);
    if (this.version > 0) {
        var count = stream.readUint32();
        this.kid = [];
        for(var i1 = 0; i1 < count; i1++)this.kid[i1] = $c9a1fd49277acae3$var$BoxParser.parseHex16(stream);
    }
    var datasize = stream.readUint32();
    if (datasize > 0) this.data = stream.readUint8Array(datasize);
});
// file:src/parsing/qt/clef.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("clef", function(stream) {
    this.width = stream.readUint32();
    this.height = stream.readUint32();
}); // file:src/parsing/qt/enof.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("enof", function(stream) {
    this.width = stream.readUint32();
    this.height = stream.readUint32();
}); // file:src/parsing/qt/prof.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("prof", function(stream) {
    this.width = stream.readUint32();
    this.height = stream.readUint32();
}); // file:src/parsing/qt/tapt.js
$c9a1fd49277acae3$var$BoxParser.createContainerBoxCtor("tapt", null, [
    "clef",
    "prof",
    "enof"
]); // file:src/parsing/rtp.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("rtp ", function(stream) {
    this.descriptionformat = stream.readString(4);
    this.sdptext = stream.readString(this.size - this.hdr_size - 4);
});
// file:src/parsing/saio.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("saio", function(stream) {
    if (this.flags & 0x1) {
        this.aux_info_type = stream.readUint32();
        this.aux_info_type_parameter = stream.readUint32();
    }
    var count = stream.readUint32();
    this.offset = [];
    for(var i1 = 0; i1 < count; i1++)if (this.version === 0) this.offset[i1] = stream.readUint32();
    else this.offset[i1] = stream.readUint64();
});
// file:src/parsing/saiz.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("saiz", function(stream) {
    if (this.flags & 0x1) {
        this.aux_info_type = stream.readUint32();
        this.aux_info_type_parameter = stream.readUint32();
    }
    this.default_sample_info_size = stream.readUint8();
    var count = stream.readUint32();
    this.sample_info_size = [];
    if (this.default_sample_info_size === 0) for(var i1 = 0; i1 < count; i1++)this.sample_info_size[i1] = stream.readUint8();
});
// file:src/parsing/sampleentries/mett.js
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_METADATA, "mett", function(stream) {
    this.parseHeader(stream);
    this.content_encoding = stream.readCString();
    this.mime_format = stream.readCString();
    this.parseFooter(stream);
});
// file:src/parsing/sampleentries/metx.js
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_METADATA, "metx", function(stream) {
    this.parseHeader(stream);
    this.content_encoding = stream.readCString();
    this.namespace = stream.readCString();
    this.schema_location = stream.readCString();
    this.parseFooter(stream);
});
// file:src/parsing/sampleentries/sbtt.js
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE, "sbtt", function(stream) {
    this.parseHeader(stream);
    this.content_encoding = stream.readCString();
    this.mime_format = stream.readCString();
    this.parseFooter(stream);
});
// file:src/parsing/sampleentries/stpp.js
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE, "stpp", function(stream) {
    this.parseHeader(stream);
    this.namespace = stream.readCString();
    this.schema_location = stream.readCString();
    this.auxiliary_mime_types = stream.readCString();
    this.parseFooter(stream);
});
// file:src/parsing/sampleentries/stxt.js
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE, "stxt", function(stream) {
    this.parseHeader(stream);
    this.content_encoding = stream.readCString();
    this.mime_format = stream.readCString();
    this.parseFooter(stream);
});
// file:src/parsing/sampleentries/tx3g.js
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE, "tx3g", function(stream) {
    this.parseHeader(stream);
    this.displayFlags = stream.readUint32();
    this.horizontal_justification = stream.readInt8();
    this.vertical_justification = stream.readInt8();
    this.bg_color_rgba = stream.readUint8Array(4);
    this.box_record = stream.readInt16Array(4);
    this.style_record = stream.readUint8Array(12);
    this.parseFooter(stream);
});
// file:src/parsing/sampleentries/wvtt.js
$c9a1fd49277acae3$var$BoxParser.createSampleEntryCtor($c9a1fd49277acae3$var$BoxParser.SAMPLE_ENTRY_TYPE_METADATA, "wvtt", function(stream) {
    this.parseHeader(stream);
    this.parseFooter(stream);
});
// file:src/parsing/samplegroups/alst.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("alst", function(stream) {
    var i1;
    var roll_count = stream.readUint16();
    this.first_output_sample = stream.readUint16();
    this.sample_offset = [];
    for(i1 = 0; i1 < roll_count; i1++)this.sample_offset[i1] = stream.readUint32();
    var remaining = this.description_length - 4 - 4 * roll_count;
    this.num_output_samples = [];
    this.num_total_samples = [];
    for(i1 = 0; i1 < remaining / 4; i1++){
        this.num_output_samples[i1] = stream.readUint16();
        this.num_total_samples[i1] = stream.readUint16();
    }
});
// file:src/parsing/samplegroups/avll.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("avll", function(stream) {
    this.layerNumber = stream.readUint8();
    this.accurateStatisticsFlag = stream.readUint8();
    this.avgBitRate = stream.readUint16();
    this.avgFrameRate = stream.readUint16();
});
// file:src/parsing/samplegroups/avss.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("avss", function(stream) {
    this.subSequenceIdentifier = stream.readUint16();
    this.layerNumber = stream.readUint8();
    var tmp_byte = stream.readUint8();
    this.durationFlag = tmp_byte >> 7;
    this.avgRateFlag = tmp_byte >> 6 & 0x1;
    if (this.durationFlag) this.duration = stream.readUint32();
    if (this.avgRateFlag) {
        this.accurateStatisticsFlag = stream.readUint8();
        this.avgBitRate = stream.readUint16();
        this.avgFrameRate = stream.readUint16();
    }
    this.dependency = [];
    var numReferences = stream.readUint8();
    for(var i1 = 0; i1 < numReferences; i1++){
        var dependencyInfo = {};
        this.dependency.push(dependencyInfo);
        dependencyInfo.subSeqDirectionFlag = stream.readUint8();
        dependencyInfo.layerNumber = stream.readUint8();
        dependencyInfo.subSequenceIdentifier = stream.readUint16();
    }
});
// file:src/parsing/samplegroups/dtrt.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("dtrt", function(stream) {
    $c9a1fd49277acae3$var$Log.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
});
// file:src/parsing/samplegroups/mvif.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("mvif", function(stream) {
    $c9a1fd49277acae3$var$Log.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
});
// file:src/parsing/samplegroups/prol.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("prol", function(stream) {
    this.roll_distance = stream.readInt16();
});
// file:src/parsing/samplegroups/rap.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("rap ", function(stream) {
    var tmp_byte = stream.readUint8();
    this.num_leading_samples_known = tmp_byte >> 7;
    this.num_leading_samples = tmp_byte & 0x7F;
});
// file:src/parsing/samplegroups/rash.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("rash", function(stream) {
    this.operation_point_count = stream.readUint16();
    if (this.description_length !== 2 + (this.operation_point_count === 1 ? 2 : this.operation_point_count * 6) + 9) {
        $c9a1fd49277acae3$var$Log.warn("BoxParser", "Mismatch in " + this.grouping_type + " sample group length");
        this.data = stream.readUint8Array(this.description_length - 2);
    } else {
        if (this.operation_point_count === 1) this.target_rate_share = stream.readUint16();
        else {
            this.target_rate_share = [];
            this.available_bitrate = [];
            for(var i1 = 0; i1 < this.operation_point_count; i1++){
                this.available_bitrate[i1] = stream.readUint32();
                this.target_rate_share[i1] = stream.readUint16();
            }
        }
        this.maximum_bitrate = stream.readUint32();
        this.minimum_bitrate = stream.readUint32();
        this.discard_priority = stream.readUint8();
    }
});
// file:src/parsing/samplegroups/roll.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("roll", function(stream) {
    this.roll_distance = stream.readInt16();
});
// file:src/parsing/samplegroups/samplegroup.js
$c9a1fd49277acae3$var$BoxParser.SampleGroupEntry.prototype.parse = function(stream) {
    $c9a1fd49277acae3$var$Log.warn("BoxParser", "Unknown Sample Group type: " + this.grouping_type);
    this.data = stream.readUint8Array(this.description_length);
};
// file:src/parsing/samplegroups/scif.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("scif", function(stream) {
    $c9a1fd49277acae3$var$Log.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
});
// file:src/parsing/samplegroups/scnm.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("scnm", function(stream) {
    $c9a1fd49277acae3$var$Log.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
});
// file:src/parsing/samplegroups/seig.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("seig", function(stream) {
    this.reserved = stream.readUint8();
    var tmp = stream.readUint8();
    this.crypt_byte_block = tmp >> 4;
    this.skip_byte_block = tmp & 0xF;
    this.isProtected = stream.readUint8();
    this.Per_Sample_IV_Size = stream.readUint8();
    this.KID = $c9a1fd49277acae3$var$BoxParser.parseHex16(stream);
    this.constant_IV_size = 0;
    this.constant_IV = 0;
    if (this.isProtected === 1 && this.Per_Sample_IV_Size === 0) {
        this.constant_IV_size = stream.readUint8();
        this.constant_IV = stream.readUint8Array(this.constant_IV_size);
    }
});
// file:src/parsing/samplegroups/stsa.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("stsa", function(stream) {
    $c9a1fd49277acae3$var$Log.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
});
// file:src/parsing/samplegroups/sync.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("sync", function(stream) {
    var tmp_byte = stream.readUint8();
    this.NAL_unit_type = tmp_byte & 0x3F;
});
// file:src/parsing/samplegroups/tele.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("tele", function(stream) {
    var tmp_byte = stream.readUint8();
    this.level_independently_decodable = tmp_byte >> 7;
});
// file:src/parsing/samplegroups/tsas.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("tsas", function(stream) {
    $c9a1fd49277acae3$var$Log.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
});
// file:src/parsing/samplegroups/tscl.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("tscl", function(stream) {
    $c9a1fd49277acae3$var$Log.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
});
// file:src/parsing/samplegroups/vipr.js
$c9a1fd49277acae3$var$BoxParser.createSampleGroupCtor("vipr", function(stream) {
    $c9a1fd49277acae3$var$Log.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
});
// file:src/parsing/sbgp.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("sbgp", function(stream) {
    this.grouping_type = stream.readString(4);
    if (this.version === 1) this.grouping_type_parameter = stream.readUint32();
    else this.grouping_type_parameter = 0;
    this.entries = [];
    var entry_count1 = stream.readUint32();
    for(var i1 = 0; i1 < entry_count1; i1++){
        var entry = {};
        this.entries.push(entry);
        entry.sample_count = stream.readInt32();
        entry.group_description_index = stream.readInt32();
    }
});
// file:src/parsing/sbpm.js
function $c9a1fd49277acae3$var$Pixel(row, col) {
    this.bad_pixel_row = row;
    this.bad_pixel_column = col;
}
$c9a1fd49277acae3$var$Pixel.prototype.toString = function pixelToString() {
    return "[row: " + this.bad_pixel_row + ", column: " + this.bad_pixel_column + "]";
};
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("sbpm", function(stream) {
    var i1;
    this.component_count = stream.readUint16();
    this.component_index = [];
    for(i1 = 0; i1 < this.component_count; i1++)this.component_index.push(stream.readUint16());
    var flags = stream.readUint8();
    this.correction_applied = 0x80 == (flags & 0x80);
    this.num_bad_rows = stream.readUint32();
    this.num_bad_cols = stream.readUint32();
    this.num_bad_pixels = stream.readUint32();
    this.bad_rows = [];
    this.bad_columns = [];
    this.bad_pixels = [];
    for(i1 = 0; i1 < this.num_bad_rows; i1++)this.bad_rows.push(stream.readUint32());
    for(i1 = 0; i1 < this.num_bad_cols; i1++)this.bad_columns.push(stream.readUint32());
    for(i1 = 0; i1 < this.num_bad_pixels; i1++){
        var row = stream.readUint32();
        var col = stream.readUint32();
        this.bad_pixels.push(new $c9a1fd49277acae3$var$Pixel(row, col));
    }
});
// file:src/parsing/schm.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("schm", function(stream) {
    this.scheme_type = stream.readString(4);
    this.scheme_version = stream.readUint32();
    if (this.flags & 0x000001) this.scheme_uri = stream.readString(this.size - this.hdr_size - 8);
});
// file:src/parsing/sdp.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("sdp ", function(stream) {
    this.sdptext = stream.readString(this.size - this.hdr_size);
});
// file:src/parsing/sdtp.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("sdtp", function(stream) {
    var tmp_byte;
    var count = this.size - this.hdr_size;
    this.is_leading = [];
    this.sample_depends_on = [];
    this.sample_is_depended_on = [];
    this.sample_has_redundancy = [];
    for(var i1 = 0; i1 < count; i1++){
        tmp_byte = stream.readUint8();
        this.is_leading[i1] = tmp_byte >> 6;
        this.sample_depends_on[i1] = tmp_byte >> 4 & 0x3;
        this.sample_is_depended_on[i1] = tmp_byte >> 2 & 0x3;
        this.sample_has_redundancy[i1] = tmp_byte & 0x3;
    }
});
// file:src/parsing/senc.js
// Cannot be fully parsed because Per_Sample_IV_Size needs to be known
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("senc" /*, function(stream) {
this.parseFullHeader(stream);
var sample_count = stream.readUint32();
this.samples = [];
for (var i = 0; i < sample_count; i++) {
    var sample = {};
    // tenc.default_Per_Sample_IV_Size or seig.Per_Sample_IV_Size
    sample.InitializationVector = this.readUint8Array(Per_Sample_IV_Size*8);
    if (this.flags & 0x2) {
        sample.subsamples = [];
        subsample_count = stream.readUint16();
        for (var j = 0; j < subsample_count; j++) {
            var subsample = {};
            subsample.BytesOfClearData = stream.readUint16();
            subsample.BytesOfProtectedData = stream.readUint32();
            sample.subsamples.push(subsample);
        }
    }
    // TODO
    this.samples.push(sample);
}
}*/ );
// file:src/parsing/sgpd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("sgpd", function(stream) {
    this.grouping_type = stream.readString(4);
    $c9a1fd49277acae3$var$Log.debug("BoxParser", "Found Sample Groups of type " + this.grouping_type);
    if (this.version === 1) this.default_length = stream.readUint32();
    else this.default_length = 0;
    if (this.version >= 2) this.default_group_description_index = stream.readUint32();
    this.entries = [];
    var entry_count1 = stream.readUint32();
    for(var i1 = 0; i1 < entry_count1; i1++){
        var entry;
        if ($c9a1fd49277acae3$var$BoxParser[this.grouping_type + "SampleGroupEntry"]) entry = new $c9a1fd49277acae3$var$BoxParser[this.grouping_type + "SampleGroupEntry"](this.grouping_type);
        else entry = new $c9a1fd49277acae3$var$BoxParser.SampleGroupEntry(this.grouping_type);
        this.entries.push(entry);
        if (this.version === 1) {
            if (this.default_length === 0) entry.description_length = stream.readUint32();
            else entry.description_length = this.default_length;
        } else entry.description_length = this.default_length;
        if (entry.write === $c9a1fd49277acae3$var$BoxParser.SampleGroupEntry.prototype.write) {
            $c9a1fd49277acae3$var$Log.info("BoxParser", "SampleGroup for type " + this.grouping_type + " writing not yet implemented, keeping unparsed data in memory for later write");
            // storing data
            entry.data = stream.readUint8Array(entry.description_length);
            // rewinding
            stream.position -= entry.description_length;
        }
        entry.parse(stream);
    }
});
// file:src/parsing/sidx.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("sidx", function(stream) {
    this.reference_ID = stream.readUint32();
    this.timescale = stream.readUint32();
    if (this.version === 0) {
        this.earliest_presentation_time = stream.readUint32();
        this.first_offset = stream.readUint32();
    } else {
        this.earliest_presentation_time = stream.readUint64();
        this.first_offset = stream.readUint64();
    }
    stream.readUint16();
    this.references = [];
    var count = stream.readUint16();
    for(var i1 = 0; i1 < count; i1++){
        var ref = {};
        this.references.push(ref);
        var tmp_32 = stream.readUint32();
        ref.reference_type = tmp_32 >> 31 & 0x1;
        ref.referenced_size = tmp_32 & 0x7FFFFFFF;
        ref.subsegment_duration = stream.readUint32();
        tmp_32 = stream.readUint32();
        ref.starts_with_SAP = tmp_32 >> 31 & 0x1;
        ref.SAP_type = tmp_32 >> 28 & 0x7;
        ref.SAP_delta_time = tmp_32 & 0xFFFFFFF;
    }
});
// file:src/parsing/singleitemtypereference.js
$c9a1fd49277acae3$var$BoxParser.SingleItemTypeReferenceBox = function(type, size, hdr_size, start) {
    $c9a1fd49277acae3$var$BoxParser.Box.call(this, type, size);
    this.hdr_size = hdr_size;
    this.start = start;
};
$c9a1fd49277acae3$var$BoxParser.SingleItemTypeReferenceBox.prototype = new $c9a1fd49277acae3$var$BoxParser.Box();
$c9a1fd49277acae3$var$BoxParser.SingleItemTypeReferenceBox.prototype.parse = function(stream) {
    this.from_item_ID = stream.readUint16();
    var count = stream.readUint16();
    this.references = [];
    for(var i1 = 0; i1 < count; i1++){
        this.references[i1] = {};
        this.references[i1].to_item_ID = stream.readUint16();
    }
};
// file:src/parsing/singleitemtypereferencelarge.js
$c9a1fd49277acae3$var$BoxParser.SingleItemTypeReferenceBoxLarge = function(type, size, hdr_size, start) {
    $c9a1fd49277acae3$var$BoxParser.Box.call(this, type, size);
    this.hdr_size = hdr_size;
    this.start = start;
};
$c9a1fd49277acae3$var$BoxParser.SingleItemTypeReferenceBoxLarge.prototype = new $c9a1fd49277acae3$var$BoxParser.Box();
$c9a1fd49277acae3$var$BoxParser.SingleItemTypeReferenceBoxLarge.prototype.parse = function(stream) {
    this.from_item_ID = stream.readUint32();
    var count = stream.readUint16();
    this.references = [];
    for(var i1 = 0; i1 < count; i1++){
        this.references[i1] = {};
        this.references[i1].to_item_ID = stream.readUint32();
    }
};
// file:src/parsing/SmDm.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("SmDm", function(stream) {
    this.primaryRChromaticity_x = stream.readUint16();
    this.primaryRChromaticity_y = stream.readUint16();
    this.primaryGChromaticity_x = stream.readUint16();
    this.primaryGChromaticity_y = stream.readUint16();
    this.primaryBChromaticity_x = stream.readUint16();
    this.primaryBChromaticity_y = stream.readUint16();
    this.whitePointChromaticity_x = stream.readUint16();
    this.whitePointChromaticity_y = stream.readUint16();
    this.luminanceMax = stream.readUint32();
    this.luminanceMin = stream.readUint32();
});
// file:src/parsing/smhd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("smhd", function(stream) {
    this.balance = stream.readUint16();
    stream.readUint16();
});
// file:src/parsing/ssix.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("ssix", function(stream) {
    this.subsegments = [];
    var subsegment_count = stream.readUint32();
    for(var i1 = 0; i1 < subsegment_count; i1++){
        var subsegment = {};
        this.subsegments.push(subsegment);
        subsegment.ranges = [];
        var range_count = stream.readUint32();
        for(var j = 0; j < range_count; j++){
            var range = {};
            subsegment.ranges.push(range);
            range.level = stream.readUint8();
            range.range_size = stream.readUint24();
        }
    }
});
// file:src/parsing/stco.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stco", function(stream) {
    var entry_count1;
    entry_count1 = stream.readUint32();
    this.chunk_offsets = [];
    if (this.version === 0) for(var i1 = 0; i1 < entry_count1; i1++)this.chunk_offsets.push(stream.readUint32());
});
// file:src/parsing/stdp.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stdp", function(stream) {
    var count = (this.size - this.hdr_size) / 2;
    this.priority = [];
    for(var i1 = 0; i1 < count; i1++)this.priority[i1] = stream.readUint16();
});
// file:src/parsing/sthd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("sthd");
// file:src/parsing/stri.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stri", function(stream) {
    this.switch_group = stream.readUint16();
    this.alternate_group = stream.readUint16();
    this.sub_track_id = stream.readUint32();
    var count = (this.size - this.hdr_size - 8) / 4;
    this.attribute_list = [];
    for(var i1 = 0; i1 < count; i1++)this.attribute_list[i1] = stream.readUint32();
});
// file:src/parsing/stsc.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stsc", function(stream) {
    var entry_count1;
    var i1;
    entry_count1 = stream.readUint32();
    this.first_chunk = [];
    this.samples_per_chunk = [];
    this.sample_description_index = [];
    if (this.version === 0) for(i1 = 0; i1 < entry_count1; i1++){
        this.first_chunk.push(stream.readUint32());
        this.samples_per_chunk.push(stream.readUint32());
        this.sample_description_index.push(stream.readUint32());
    }
});
// file:src/parsing/stsd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stsd", function(stream) {
    var i1;
    var ret1;
    var entryCount;
    var box1;
    this.entries = [];
    entryCount = stream.readUint32();
    for(i1 = 1; i1 <= entryCount; i1++){
        ret1 = $c9a1fd49277acae3$var$BoxParser.parseOneBox(stream, true, this.size - (stream.getPosition() - this.start));
        if (ret1.code === $c9a1fd49277acae3$var$BoxParser.OK) {
            if ($c9a1fd49277acae3$var$BoxParser[ret1.type + "SampleEntry"]) {
                box1 = new $c9a1fd49277acae3$var$BoxParser[ret1.type + "SampleEntry"](ret1.size);
                box1.hdr_size = ret1.hdr_size;
                box1.start = ret1.start;
            } else {
                $c9a1fd49277acae3$var$Log.warn("BoxParser", "Unknown sample entry type: " + ret1.type);
                box1 = new $c9a1fd49277acae3$var$BoxParser.SampleEntry(ret1.type, ret1.size, ret1.hdr_size, ret1.start);
            }
            if (box1.write === $c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.write) {
                $c9a1fd49277acae3$var$Log.info("BoxParser", "SampleEntry " + box1.type + " box writing not yet implemented, keeping unparsed data in memory for later write");
                box1.parseDataAndRewind(stream);
            }
            box1.parse(stream);
            this.entries.push(box1);
        } else return;
    }
});
// file:src/parsing/stsg.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stsg", function(stream) {
    this.grouping_type = stream.readUint32();
    var count = stream.readUint16();
    this.group_description_index = [];
    for(var i1 = 0; i1 < count; i1++)this.group_description_index[i1] = stream.readUint32();
});
// file:src/parsing/stsh.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stsh", function(stream) {
    var entry_count1;
    var i1;
    entry_count1 = stream.readUint32();
    this.shadowed_sample_numbers = [];
    this.sync_sample_numbers = [];
    if (this.version === 0) for(i1 = 0; i1 < entry_count1; i1++){
        this.shadowed_sample_numbers.push(stream.readUint32());
        this.sync_sample_numbers.push(stream.readUint32());
    }
});
// file:src/parsing/stss.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stss", function(stream) {
    var i1;
    var entry_count1;
    entry_count1 = stream.readUint32();
    if (this.version === 0) {
        this.sample_numbers = [];
        for(i1 = 0; i1 < entry_count1; i1++)this.sample_numbers.push(stream.readUint32());
    }
});
// file:src/parsing/stsz.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stsz", function(stream) {
    var i1;
    this.sample_sizes = [];
    if (this.version === 0) {
        this.sample_size = stream.readUint32();
        this.sample_count = stream.readUint32();
        for(i1 = 0; i1 < this.sample_count; i1++)if (this.sample_size === 0) this.sample_sizes.push(stream.readUint32());
        else this.sample_sizes[i1] = this.sample_size;
    }
});
// file:src/parsing/stts.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stts", function(stream) {
    var entry_count1;
    var i1;
    var delta;
    entry_count1 = stream.readUint32();
    this.sample_counts = [];
    this.sample_deltas = [];
    if (this.version === 0) for(i1 = 0; i1 < entry_count1; i1++){
        this.sample_counts.push(stream.readUint32());
        delta = stream.readInt32();
        if (delta < 0) {
            $c9a1fd49277acae3$var$Log.warn("BoxParser", "File uses negative stts sample delta, using value 1 instead, sync may be lost!");
            delta = 1;
        }
        this.sample_deltas.push(delta);
    }
});
// file:src/parsing/stvi.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stvi", function(stream) {
    var tmp32 = stream.readUint32();
    this.single_view_allowed = tmp32 & 0x3;
    this.stereo_scheme = stream.readUint32();
    var length = stream.readUint32();
    this.stereo_indication_type = stream.readString(length);
    var ret1;
    var box1;
    this.boxes = [];
    while(stream.getPosition() < this.start + this.size){
        ret1 = $c9a1fd49277acae3$var$BoxParser.parseOneBox(stream, false, this.size - (stream.getPosition() - this.start));
        if (ret1.code === $c9a1fd49277acae3$var$BoxParser.OK) {
            box1 = ret1.box;
            this.boxes.push(box1);
            this[box1.type] = box1;
        } else return;
    }
});
// file:src/parsing/styp.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("styp", function(stream) {
    $c9a1fd49277acae3$var$BoxParser.ftypBox.prototype.parse.call(this, stream);
});
// file:src/parsing/stz2.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("stz2", function(stream) {
    var i1;
    var sample_size;
    var sample_count;
    this.sample_sizes = [];
    if (this.version === 0) {
        this.reserved = stream.readUint24();
        this.field_size = stream.readUint8();
        sample_count = stream.readUint32();
        if (this.field_size === 4) for(i1 = 0; i1 < sample_count; i1 += 2){
            var tmp = stream.readUint8();
            this.sample_sizes[i1] = tmp >> 4 & 0xF;
            this.sample_sizes[i1 + 1] = tmp & 0xF;
        }
        else if (this.field_size === 8) for(i1 = 0; i1 < sample_count; i1++)this.sample_sizes[i1] = stream.readUint8();
        else if (this.field_size === 16) for(i1 = 0; i1 < sample_count; i1++)this.sample_sizes[i1] = stream.readUint16();
        else $c9a1fd49277acae3$var$Log.error("BoxParser", "Error in length field in stz2 box");
    }
});
// file:src/parsing/subs.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("subs", function(stream) {
    var i1, j;
    var entry_count1;
    var subsample_count;
    entry_count1 = stream.readUint32();
    this.entries = [];
    for(i1 = 0; i1 < entry_count1; i1++){
        var sampleInfo = {};
        this.entries[i1] = sampleInfo;
        sampleInfo.sample_delta = stream.readUint32();
        sampleInfo.subsamples = [];
        subsample_count = stream.readUint16();
        if (subsample_count > 0) for(j = 0; j < subsample_count; j++){
            var subsample = {};
            sampleInfo.subsamples.push(subsample);
            if (this.version == 1) subsample.size = stream.readUint32();
            else subsample.size = stream.readUint16();
            subsample.priority = stream.readUint8();
            subsample.discardable = stream.readUint8();
            subsample.codec_specific_parameters = stream.readUint32();
        }
    }
});
// file:src/parsing/tenc.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("tenc", function(stream) {
    stream.readUint8(); // reserved
    if (this.version === 0) stream.readUint8();
    else {
        var tmp = stream.readUint8();
        this.default_crypt_byte_block = tmp >> 4 & 0xF;
        this.default_skip_byte_block = tmp & 0xF;
    }
    this.default_isProtected = stream.readUint8();
    this.default_Per_Sample_IV_Size = stream.readUint8();
    this.default_KID = $c9a1fd49277acae3$var$BoxParser.parseHex16(stream);
    if (this.default_isProtected === 1 && this.default_Per_Sample_IV_Size === 0) {
        this.default_constant_IV_size = stream.readUint8();
        this.default_constant_IV = stream.readUint8Array(this.default_constant_IV_size);
    }
}); // file:src/parsing/tfdt.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("tfdt", function(stream) {
    if (this.version == 1) this.baseMediaDecodeTime = stream.readUint64();
    else this.baseMediaDecodeTime = stream.readUint32();
});
// file:src/parsing/tfhd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("tfhd", function(stream) {
    var readBytes = 0;
    this.track_id = stream.readUint32();
    if (this.size - this.hdr_size > readBytes && this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_BASE_DATA_OFFSET) {
        this.base_data_offset = stream.readUint64();
        readBytes += 8;
    } else this.base_data_offset = 0;
    if (this.size - this.hdr_size > readBytes && this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_DESC) {
        this.default_sample_description_index = stream.readUint32();
        readBytes += 4;
    } else this.default_sample_description_index = 0;
    if (this.size - this.hdr_size > readBytes && this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_DUR) {
        this.default_sample_duration = stream.readUint32();
        readBytes += 4;
    } else this.default_sample_duration = 0;
    if (this.size - this.hdr_size > readBytes && this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_SIZE) {
        this.default_sample_size = stream.readUint32();
        readBytes += 4;
    } else this.default_sample_size = 0;
    if (this.size - this.hdr_size > readBytes && this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_FLAGS) {
        this.default_sample_flags = stream.readUint32();
        readBytes += 4;
    } else this.default_sample_flags = 0;
});
// file:src/parsing/tfra.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("tfra", function(stream) {
    this.track_ID = stream.readUint32();
    stream.readUint24();
    var tmp_byte = stream.readUint8();
    this.length_size_of_traf_num = tmp_byte >> 4 & 0x3;
    this.length_size_of_trun_num = tmp_byte >> 2 & 0x3;
    this.length_size_of_sample_num = tmp_byte & 0x3;
    this.entries = [];
    var number_of_entries = stream.readUint32();
    for(var i1 = 0; i1 < number_of_entries; i1++){
        if (this.version === 1) {
            this.time = stream.readUint64();
            this.moof_offset = stream.readUint64();
        } else {
            this.time = stream.readUint32();
            this.moof_offset = stream.readUint32();
        }
        this.traf_number = stream["readUint" + 8 * (this.length_size_of_traf_num + 1)]();
        this.trun_number = stream["readUint" + 8 * (this.length_size_of_trun_num + 1)]();
        this.sample_number = stream["readUint" + 8 * (this.length_size_of_sample_num + 1)]();
    }
});
// file:src/parsing/tkhd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("tkhd", function(stream) {
    if (this.version == 1) {
        this.creation_time = stream.readUint64();
        this.modification_time = stream.readUint64();
        this.track_id = stream.readUint32();
        stream.readUint32();
        this.duration = stream.readUint64();
    } else {
        this.creation_time = stream.readUint32();
        this.modification_time = stream.readUint32();
        this.track_id = stream.readUint32();
        stream.readUint32();
        this.duration = stream.readUint32();
    }
    stream.readUint32Array(2);
    this.layer = stream.readInt16();
    this.alternate_group = stream.readInt16();
    this.volume = stream.readInt16() >> 8;
    stream.readUint16();
    this.matrix = stream.readInt32Array(9);
    this.width = stream.readUint32();
    this.height = stream.readUint32();
});
// file:src/parsing/tmax.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("tmax", function(stream) {
    this.time = stream.readUint32();
});
// file:src/parsing/tmin.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("tmin", function(stream) {
    this.time = stream.readUint32();
});
// file:src/parsing/totl.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("totl", function(stream) {
    this.bytessent = stream.readUint32();
});
// file:src/parsing/tpay.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("tpay", function(stream) {
    this.bytessent = stream.readUint32();
});
// file:src/parsing/tpyl.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("tpyl", function(stream) {
    this.bytessent = stream.readUint64();
});
// file:src/parsing/TrackGroup.js
$c9a1fd49277acae3$var$BoxParser.TrackGroupTypeBox.prototype.parse = function(stream) {
    this.parseFullHeader(stream);
    this.track_group_id = stream.readUint32();
};
// file:src/parsing/trackgroups/msrc.js
$c9a1fd49277acae3$var$BoxParser.createTrackGroupCtor("msrc"); // file:src/parsing/TrakReference.js
$c9a1fd49277acae3$var$BoxParser.TrackReferenceTypeBox = function(type, size, hdr_size, start) {
    $c9a1fd49277acae3$var$BoxParser.Box.call(this, type, size);
    this.hdr_size = hdr_size;
    this.start = start;
};
$c9a1fd49277acae3$var$BoxParser.TrackReferenceTypeBox.prototype = new $c9a1fd49277acae3$var$BoxParser.Box();
$c9a1fd49277acae3$var$BoxParser.TrackReferenceTypeBox.prototype.parse = function(stream) {
    this.track_ids = stream.readUint32Array((this.size - this.hdr_size) / 4);
};
// file:src/parsing/tref.js
$c9a1fd49277acae3$var$BoxParser.trefBox.prototype.parse = function(stream) {
    var ret1;
    var box1;
    while(stream.getPosition() < this.start + this.size){
        ret1 = $c9a1fd49277acae3$var$BoxParser.parseOneBox(stream, true, this.size - (stream.getPosition() - this.start));
        if (ret1.code === $c9a1fd49277acae3$var$BoxParser.OK) {
            box1 = new $c9a1fd49277acae3$var$BoxParser.TrackReferenceTypeBox(ret1.type, ret1.size, ret1.hdr_size, ret1.start);
            if (box1.write === $c9a1fd49277acae3$var$BoxParser.Box.prototype.write && box1.type !== "mdat") {
                $c9a1fd49277acae3$var$Log.info("BoxParser", "TrackReference " + box1.type + " box writing not yet implemented, keeping unparsed data in memory for later write");
                box1.parseDataAndRewind(stream);
            }
            box1.parse(stream);
            this.boxes.push(box1);
        } else return;
    }
};
// file:src/parsing/trep.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("trep", function(stream) {
    this.track_ID = stream.readUint32();
    this.boxes = [];
    while(stream.getPosition() < this.start + this.size){
        ret = $c9a1fd49277acae3$var$BoxParser.parseOneBox(stream, false, this.size - (stream.getPosition() - this.start));
        if (ret.code === $c9a1fd49277acae3$var$BoxParser.OK) {
            box = ret.box;
            this.boxes.push(box);
        } else return;
    }
});
// file:src/parsing/trex.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("trex", function(stream) {
    this.track_id = stream.readUint32();
    this.default_sample_description_index = stream.readUint32();
    this.default_sample_duration = stream.readUint32();
    this.default_sample_size = stream.readUint32();
    this.default_sample_flags = stream.readUint32();
});
// file:src/parsing/trpy.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("trpy", function(stream) {
    this.bytessent = stream.readUint64();
});
// file:src/parsing/trun.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("trun", function(stream) {
    var readBytes = 0;
    this.sample_count = stream.readUint32();
    readBytes += 4;
    if (this.size - this.hdr_size > readBytes && this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DATA_OFFSET) {
        this.data_offset = stream.readInt32(); //signed
        readBytes += 4;
    } else this.data_offset = 0;
    if (this.size - this.hdr_size > readBytes && this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FIRST_FLAG) {
        this.first_sample_flags = stream.readUint32();
        readBytes += 4;
    } else this.first_sample_flags = 0;
    this.sample_duration = [];
    this.sample_size = [];
    this.sample_flags = [];
    this.sample_composition_time_offset = [];
    if (this.size - this.hdr_size > readBytes) for(var i1 = 0; i1 < this.sample_count; i1++){
        if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DURATION) this.sample_duration[i1] = stream.readUint32();
        if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_SIZE) this.sample_size[i1] = stream.readUint32();
        if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FLAGS) this.sample_flags[i1] = stream.readUint32();
        if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_CTS_OFFSET) {
            if (this.version === 0) this.sample_composition_time_offset[i1] = stream.readUint32();
            else this.sample_composition_time_offset[i1] = stream.readInt32(); //signed
        }
    }
});
// file:src/parsing/tsel.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("tsel", function(stream) {
    this.switch_group = stream.readUint32();
    var count = (this.size - this.hdr_size - 4) / 4;
    this.attribute_list = [];
    for(var i1 = 0; i1 < count; i1++)this.attribute_list[i1] = stream.readUint32();
});
// file:src/parsing/txtC.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("txtC", function(stream) {
    this.config = stream.readCString();
});
// file:src/parsing/tyco.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("tyco", function(stream) {
    var count = (this.size - this.hdr_size) / 4;
    this.compatible_brands = [];
    for(var i1 = 0; i1 < count; i1++)this.compatible_brands[i1] = stream.readString(4);
});
// file:src/parsing/udes.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("udes", function(stream) {
    this.lang = stream.readCString();
    this.name = stream.readCString();
    this.description = stream.readCString();
    this.tags = stream.readCString();
});
// file:src/parsing/uncC.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("uncC", function(stream) {
    var i1;
    this.profile = stream.readUint32();
    if (this.version == 1) ;
    else if (this.version == 0) {
        this.component_count = stream.readUint32();
        this.component_index = [];
        this.component_bit_depth_minus_one = [];
        this.component_format = [];
        this.component_align_size = [];
        for(i1 = 0; i1 < this.component_count; i1++){
            this.component_index.push(stream.readUint16());
            this.component_bit_depth_minus_one.push(stream.readUint8());
            this.component_format.push(stream.readUint8());
            this.component_align_size.push(stream.readUint8());
        }
        this.sampling_type = stream.readUint8();
        this.interleave_type = stream.readUint8();
        this.block_size = stream.readUint8();
        var flags = stream.readUint8();
        this.component_little_endian = flags >> 7 & 0x1;
        this.block_pad_lsb = flags >> 6 & 0x1;
        this.block_little_endian = flags >> 5 & 0x1;
        this.block_reversed = flags >> 4 & 0x1;
        this.pad_unknown = flags >> 3 & 0x1;
        this.pixel_size = stream.readUint32();
        this.row_align_size = stream.readUint32();
        this.tile_align_size = stream.readUint32();
        this.num_tile_cols_minus_one = stream.readUint32();
        this.num_tile_rows_minus_one = stream.readUint32();
    }
});
// file:src/parsing/url.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("url ", function(stream) {
    if (this.flags !== 0x000001) this.location = stream.readCString();
});
// file:src/parsing/urn.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("urn ", function(stream) {
    this.name = stream.readCString();
    if (this.size - this.hdr_size - this.name.length - 1 > 0) this.location = stream.readCString();
});
// file:src/parsing/uuid/piff/piffLsm.js
$c9a1fd49277acae3$var$BoxParser.createUUIDBox("a5d40b30e81411ddba2f0800200c9a66", true, false, function(stream) {
    this.LiveServerManifest = stream.readString(this.size - this.hdr_size).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}); // file:src/parsing/uuid/piff/piffPssh.js
$c9a1fd49277acae3$var$BoxParser.createUUIDBox("d08a4f1810f34a82b6c832d8aba183d3", true, false, function(stream) {
    this.system_id = $c9a1fd49277acae3$var$BoxParser.parseHex16(stream);
    var datasize = stream.readUint32();
    if (datasize > 0) this.data = stream.readUint8Array(datasize);
});
// file:src/parsing/uuid/piff/piffSenc.js
$c9a1fd49277acae3$var$BoxParser.createUUIDBox("a2394f525a9b4f14a2446c427c648df4", true, false);
// file:src/parsing/uuid/piff/piffTenc.js
$c9a1fd49277acae3$var$BoxParser.createUUIDBox("8974dbce7be74c5184f97148f9882554", true, false, function(stream) {
    this.default_AlgorithmID = stream.readUint24();
    this.default_IV_size = stream.readUint8();
    this.default_KID = $c9a1fd49277acae3$var$BoxParser.parseHex16(stream);
}); // file:src/parsing/uuid/piff/piffTfrf.js
$c9a1fd49277acae3$var$BoxParser.createUUIDBox("d4807ef2ca3946958e5426cb9e46a79f", true, false, function(stream) {
    this.fragment_count = stream.readUint8();
    this.entries = [];
    for(var i1 = 0; i1 < this.fragment_count; i1++){
        var entry = {};
        var absolute_time = 0;
        var absolute_duration = 0;
        if (this.version === 1) {
            absolute_time = stream.readUint64();
            absolute_duration = stream.readUint64();
        } else {
            absolute_time = stream.readUint32();
            absolute_duration = stream.readUint32();
        }
        entry.absolute_time = absolute_time;
        entry.absolute_duration = absolute_duration;
        this.entries.push(entry);
    }
}); // file:src/parsing/uuid/piff/piffTfxd.js
$c9a1fd49277acae3$var$BoxParser.createUUIDBox("6d1d9b0542d544e680e2141daff757b2", true, false, function(stream) {
    if (this.version === 1) {
        this.absolute_time = stream.readUint64();
        this.duration = stream.readUint64();
    } else {
        this.absolute_time = stream.readUint32();
        this.duration = stream.readUint32();
    }
}); // file:src/parsing/vmhd.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("vmhd", function(stream) {
    this.graphicsmode = stream.readUint16();
    this.opcolor = stream.readUint16Array(3);
});
// file:src/parsing/vpcC.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("vpcC", function(stream) {
    var tmp;
    if (this.version === 1) {
        this.profile = stream.readUint8();
        this.level = stream.readUint8();
        tmp = stream.readUint8();
        this.bitDepth = tmp >> 4;
        this.chromaSubsampling = tmp >> 1 & 0x7;
        this.videoFullRangeFlag = tmp & 0x1;
        this.colourPrimaries = stream.readUint8();
        this.transferCharacteristics = stream.readUint8();
        this.matrixCoefficients = stream.readUint8();
        this.codecIntializationDataSize = stream.readUint16();
        this.codecIntializationData = stream.readUint8Array(this.codecIntializationDataSize);
    } else {
        this.profile = stream.readUint8();
        this.level = stream.readUint8();
        tmp = stream.readUint8();
        this.bitDepth = tmp >> 4 & 0xF;
        this.colorSpace = tmp & 0xF;
        tmp = stream.readUint8();
        this.chromaSubsampling = tmp >> 4 & 0xF;
        this.transferFunction = tmp >> 1 & 0x7;
        this.videoFullRangeFlag = tmp & 0x1;
        this.codecIntializationDataSize = stream.readUint16();
        this.codecIntializationData = stream.readUint8Array(this.codecIntializationDataSize);
    }
}); // file:src/parsing/vttC.js
$c9a1fd49277acae3$var$BoxParser.createBoxCtor("vttC", function(stream) {
    this.text = stream.readString(this.size - this.hdr_size);
});
// file:src/parsing/vvcC.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("vvcC", function(stream) {
    var i1, j;
    // helper object to simplify extracting individual bits
    var bitReader = {
        held_bits: undefined,
        num_held_bits: 0,
        stream_read_1_bytes: function(strm1) {
            this.held_bits = strm1.readUint8();
            this.num_held_bits = 8;
        },
        stream_read_2_bytes: function(strm1) {
            this.held_bits = strm1.readUint16();
            this.num_held_bits = 16;
        },
        extract_bits: function(num_bits) {
            var ret1 = this.held_bits >> this.num_held_bits - num_bits & (1 << num_bits) - 1;
            this.num_held_bits -= num_bits;
            return ret1;
        }
    };
    // VvcDecoderConfigurationRecord
    bitReader.stream_read_1_bytes(stream);
    bitReader.extract_bits(5); // reserved
    this.lengthSizeMinusOne = bitReader.extract_bits(2);
    this.ptl_present_flag = bitReader.extract_bits(1);
    if (this.ptl_present_flag) {
        bitReader.stream_read_2_bytes(stream);
        this.ols_idx = bitReader.extract_bits(9);
        this.num_sublayers = bitReader.extract_bits(3);
        this.constant_frame_rate = bitReader.extract_bits(2);
        this.chroma_format_idc = bitReader.extract_bits(2);
        bitReader.stream_read_1_bytes(stream);
        this.bit_depth_minus8 = bitReader.extract_bits(3);
        bitReader.extract_bits(5); // reserved
        bitReader.stream_read_2_bytes(stream);
        bitReader.extract_bits(2); // reserved
        this.num_bytes_constraint_info = bitReader.extract_bits(6);
        this.general_profile_idc = bitReader.extract_bits(7);
        this.general_tier_flag = bitReader.extract_bits(1);
        this.general_level_idc = stream.readUint8();
        bitReader.stream_read_1_bytes(stream);
        this.ptl_frame_only_constraint_flag = bitReader.extract_bits(1);
        this.ptl_multilayer_enabled_flag = bitReader.extract_bits(1);
        this.general_constraint_info = new Uint8Array(this.num_bytes_constraint_info);
        if (this.num_bytes_constraint_info) {
            for(i1 = 0; i1 < this.num_bytes_constraint_info - 1; i1++){
                var cnstr1 = bitReader.extract_bits(6);
                bitReader.stream_read_1_bytes(stream);
                var cnstr2 = bitReader.extract_bits(2);
                this.general_constraint_info[i1] = cnstr1 << 2 | cnstr2;
            }
            this.general_constraint_info[this.num_bytes_constraint_info - 1] = bitReader.extract_bits(6);
        } else //forbidden in spec!
        bitReader.extract_bits(6);
        if (this.num_sublayers > 1) {
            bitReader.stream_read_1_bytes(stream);
            this.ptl_sublayer_present_mask = 0;
            for(j = this.num_sublayers - 2; j >= 0; --j){
                var val = bitReader.extract_bits(1);
                this.ptl_sublayer_present_mask |= val << j;
            }
            for(j = this.num_sublayers; j <= 8 && this.num_sublayers > 1; ++j)bitReader.extract_bits(1); // ptl_reserved_zero_bit
            this.sublayer_level_idc = [];
            for(j = this.num_sublayers - 2; j >= 0; --j)if (this.ptl_sublayer_present_mask & 1 << j) this.sublayer_level_idc[j] = stream.readUint8();
        }
        this.ptl_num_sub_profiles = stream.readUint8();
        this.general_sub_profile_idc = [];
        if (this.ptl_num_sub_profiles) for(i1 = 0; i1 < this.ptl_num_sub_profiles; i1++)this.general_sub_profile_idc.push(stream.readUint32());
        this.max_picture_width = stream.readUint16();
        this.max_picture_height = stream.readUint16();
        this.avg_frame_rate = stream.readUint16();
    }
    var VVC_NALU_OPI = 12;
    var VVC_NALU_DEC_PARAM = 13;
    this.nalu_arrays = [];
    var num_of_arrays = stream.readUint8();
    for(i1 = 0; i1 < num_of_arrays; i1++){
        var nalu_array = [];
        this.nalu_arrays.push(nalu_array);
        bitReader.stream_read_1_bytes(stream);
        nalu_array.completeness = bitReader.extract_bits(1);
        bitReader.extract_bits(2); // reserved
        nalu_array.nalu_type = bitReader.extract_bits(5);
        var numNalus = 1;
        if (nalu_array.nalu_type != VVC_NALU_DEC_PARAM && nalu_array.nalu_type != VVC_NALU_OPI) numNalus = stream.readUint16();
        for(j = 0; j < numNalus; j++){
            var len = stream.readUint16();
            nalu_array.push({
                data: stream.readUint8Array(len),
                length: len
            });
        }
    }
});
// file:src/parsing/vvnC.js
$c9a1fd49277acae3$var$BoxParser.createFullBoxCtor("vvnC", function(stream) {
    // VvcNALUConfigBox
    var tmp = strm.readUint8();
    this.lengthSizeMinusOne = tmp & 0x3;
});
// file:src/box-codecs.js
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.isVideo = function() {
    return false;
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.isAudio = function() {
    return false;
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.isSubtitle = function() {
    return false;
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.isMetadata = function() {
    return false;
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.isHint = function() {
    return false;
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getCodec = function() {
    return this.type.replace(".", "");
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getWidth = function() {
    return "";
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getHeight = function() {
    return "";
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getChannelCount = function() {
    return "";
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getSampleRate = function() {
    return "";
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getSampleSize = function() {
    return "";
};
$c9a1fd49277acae3$var$BoxParser.VisualSampleEntry.prototype.isVideo = function() {
    return true;
};
$c9a1fd49277acae3$var$BoxParser.VisualSampleEntry.prototype.getWidth = function() {
    return this.width;
};
$c9a1fd49277acae3$var$BoxParser.VisualSampleEntry.prototype.getHeight = function() {
    return this.height;
};
$c9a1fd49277acae3$var$BoxParser.AudioSampleEntry.prototype.isAudio = function() {
    return true;
};
$c9a1fd49277acae3$var$BoxParser.AudioSampleEntry.prototype.getChannelCount = function() {
    return this.channel_count;
};
$c9a1fd49277acae3$var$BoxParser.AudioSampleEntry.prototype.getSampleRate = function() {
    return this.samplerate;
};
$c9a1fd49277acae3$var$BoxParser.AudioSampleEntry.prototype.getSampleSize = function() {
    return this.samplesize;
};
$c9a1fd49277acae3$var$BoxParser.SubtitleSampleEntry.prototype.isSubtitle = function() {
    return true;
};
$c9a1fd49277acae3$var$BoxParser.MetadataSampleEntry.prototype.isMetadata = function() {
    return true;
};
$c9a1fd49277acae3$var$BoxParser.decimalToHex = function(d, padding) {
    var hex = Number(d).toString(16);
    padding = typeof padding === "undefined" || padding === null ? padding = 2 : padding;
    while(hex.length < padding)hex = "0" + hex;
    return hex;
};
$c9a1fd49277acae3$var$BoxParser.avc1SampleEntry.prototype.getCodec = $c9a1fd49277acae3$var$BoxParser.avc2SampleEntry.prototype.getCodec = $c9a1fd49277acae3$var$BoxParser.avc3SampleEntry.prototype.getCodec = $c9a1fd49277acae3$var$BoxParser.avc4SampleEntry.prototype.getCodec = function() {
    var baseCodec = $c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getCodec.call(this);
    if (this.avcC) return baseCodec + "." + $c9a1fd49277acae3$var$BoxParser.decimalToHex(this.avcC.AVCProfileIndication) + "" + $c9a1fd49277acae3$var$BoxParser.decimalToHex(this.avcC.profile_compatibility) + "" + $c9a1fd49277acae3$var$BoxParser.decimalToHex(this.avcC.AVCLevelIndication);
    else return baseCodec;
};
$c9a1fd49277acae3$var$BoxParser.hev1SampleEntry.prototype.getCodec = $c9a1fd49277acae3$var$BoxParser.hvc1SampleEntry.prototype.getCodec = function() {
    var i1;
    var baseCodec = $c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getCodec.call(this);
    if (this.hvcC) {
        baseCodec += ".";
        switch(this.hvcC.general_profile_space){
            case 0:
                baseCodec += "";
                break;
            case 1:
                baseCodec += "A";
                break;
            case 2:
                baseCodec += "B";
                break;
            case 3:
                baseCodec += "C";
                break;
        }
        baseCodec += this.hvcC.general_profile_idc;
        baseCodec += ".";
        var val = this.hvcC.general_profile_compatibility;
        var reversed = 0;
        for(i1 = 0; i1 < 32; i1++){
            reversed |= val & 1;
            if (i1 == 31) break;
            reversed <<= 1;
            val >>= 1;
        }
        baseCodec += $c9a1fd49277acae3$var$BoxParser.decimalToHex(reversed, 0);
        baseCodec += ".";
        if (this.hvcC.general_tier_flag === 0) baseCodec += "L";
        else baseCodec += "H";
        baseCodec += this.hvcC.general_level_idc;
        var hasByte = false;
        var constraint_string = "";
        for(i1 = 5; i1 >= 0; i1--)if (this.hvcC.general_constraint_indicator[i1] || hasByte) {
            constraint_string = "." + $c9a1fd49277acae3$var$BoxParser.decimalToHex(this.hvcC.general_constraint_indicator[i1], 0) + constraint_string;
            hasByte = true;
        }
        baseCodec += constraint_string;
    }
    return baseCodec;
};
$c9a1fd49277acae3$var$BoxParser.vvc1SampleEntry.prototype.getCodec = $c9a1fd49277acae3$var$BoxParser.vvi1SampleEntry.prototype.getCodec = function() {
    var i1;
    var baseCodec = $c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getCodec.call(this);
    if (this.vvcC) {
        baseCodec += "." + this.vvcC.general_profile_idc;
        if (this.vvcC.general_tier_flag) baseCodec += ".H";
        else baseCodec += ".L";
        baseCodec += this.vvcC.general_level_idc;
        var constraint_string = "";
        if (this.vvcC.general_constraint_info) {
            var bytes = [];
            var byte = 0;
            byte |= this.vvcC.ptl_frame_only_constraint << 7;
            byte |= this.vvcC.ptl_multilayer_enabled << 6;
            var last_nonzero;
            for(i1 = 0; i1 < this.vvcC.general_constraint_info.length; ++i1){
                byte |= this.vvcC.general_constraint_info[i1] >> 2 & 0x3f;
                bytes.push(byte);
                if (byte) last_nonzero = i1;
                byte = this.vvcC.general_constraint_info[i1] >> 2 & 0x03;
            }
            if (last_nonzero === undefined) constraint_string = ".CA";
            else {
                constraint_string = ".C";
                var base32_chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
                var held_bits = 0;
                var num_held_bits = 0;
                for(i1 = 0; i1 <= last_nonzero; ++i1){
                    held_bits = held_bits << 8 | bytes[i1];
                    num_held_bits += 8;
                    while(num_held_bits >= 5){
                        var val = held_bits >> num_held_bits - 5 & 0x1f;
                        constraint_string += base32_chars[val];
                        num_held_bits -= 5;
                        held_bits &= (1 << num_held_bits) - 1;
                    }
                }
                if (num_held_bits) {
                    held_bits <<= 5 - num_held_bits; // right-pad with zeros to 5 bits (is this correct?)
                    constraint_string += base32_chars[held_bits & 0x1f];
                }
            }
        }
        baseCodec += constraint_string;
    }
    return baseCodec;
};
$c9a1fd49277acae3$var$BoxParser.mp4aSampleEntry.prototype.getCodec = function() {
    var baseCodec = $c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getCodec.call(this);
    if (this.esds && this.esds.esd) {
        var oti = this.esds.esd.getOTI();
        var dsi = this.esds.esd.getAudioConfig();
        return baseCodec + "." + $c9a1fd49277acae3$var$BoxParser.decimalToHex(oti) + (dsi ? "." + dsi : "");
    } else return baseCodec;
};
$c9a1fd49277acae3$var$BoxParser.stxtSampleEntry.prototype.getCodec = function() {
    var baseCodec = $c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getCodec.call(this);
    if (this.mime_format) return baseCodec + "." + this.mime_format;
    else return baseCodec;
};
$c9a1fd49277acae3$var$BoxParser.vp08SampleEntry.prototype.getCodec = $c9a1fd49277acae3$var$BoxParser.vp09SampleEntry.prototype.getCodec = function() {
    var baseCodec = $c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getCodec.call(this);
    var level = this.vpcC.level;
    if (level == 0) level = "00";
    var bitDepth = this.vpcC.bitDepth;
    if (bitDepth == 8) bitDepth = "08";
    return baseCodec + ".0" + this.vpcC.profile + "." + level + "." + bitDepth;
};
$c9a1fd49277acae3$var$BoxParser.av01SampleEntry.prototype.getCodec = function() {
    var baseCodec = $c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.getCodec.call(this);
    var level = this.av1C.seq_level_idx_0;
    if (level < 10) level = "0" + level;
    var bitdepth;
    if (this.av1C.seq_profile === 2 && this.av1C.high_bitdepth === 1) bitdepth = this.av1C.twelve_bit === 1 ? "12" : "10";
    else if (this.av1C.seq_profile <= 2) bitdepth = this.av1C.high_bitdepth === 1 ? "10" : "08";
    // TODO need to parse the SH to find color config
    return baseCodec + "." + this.av1C.seq_profile + "." + level + (this.av1C.seq_tier_0 ? "H" : "M") + "." + bitdepth; //+"."+this.av1C.monochrome+"."+this.av1C.chroma_subsampling_x+""+this.av1C.chroma_subsampling_y+""+this.av1C.chroma_sample_position;
};
// file:src/box-write.js
/* 
* Copyright (c) Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
* License: BSD-3-Clause (see LICENSE file)
*/ $c9a1fd49277acae3$var$BoxParser.Box.prototype.writeHeader = function(stream, msg) {
    this.size += 8;
    if (this.size > $c9a1fd49277acae3$var$MAX_SIZE) this.size += 8;
    if (this.type === "uuid") this.size += 16;
    $c9a1fd49277acae3$var$Log.debug("BoxWriter", "Writing box " + this.type + " of size: " + this.size + " at position " + stream.getPosition() + (msg || ""));
    if (this.size > $c9a1fd49277acae3$var$MAX_SIZE) stream.writeUint32(1);
    else {
        this.sizePosition = stream.getPosition();
        stream.writeUint32(this.size);
    }
    stream.writeString(this.type, null, 4);
    if (this.type === "uuid") stream.writeUint8Array(this.uuid);
    if (this.size > $c9a1fd49277acae3$var$MAX_SIZE) stream.writeUint64(this.size);
};
$c9a1fd49277acae3$var$BoxParser.FullBox.prototype.writeHeader = function(stream) {
    this.size += 4;
    $c9a1fd49277acae3$var$BoxParser.Box.prototype.writeHeader.call(this, stream, " v=" + this.version + " f=" + this.flags);
    stream.writeUint8(this.version);
    stream.writeUint24(this.flags);
};
$c9a1fd49277acae3$var$BoxParser.Box.prototype.write = function(stream) {
    if (this.type === "mdat") /* TODO: fix this */ {
        if (this.data) {
            this.size = this.data.length;
            this.writeHeader(stream);
            stream.writeUint8Array(this.data);
        }
    } else {
        this.size = this.data ? this.data.length : 0;
        this.writeHeader(stream);
        if (this.data) stream.writeUint8Array(this.data);
    }
};
$c9a1fd49277acae3$var$BoxParser.ContainerBox.prototype.write = function(stream) {
    this.size = 0;
    this.writeHeader(stream);
    for(var i1 = 0; i1 < this.boxes.length; i1++)if (this.boxes[i1]) {
        this.boxes[i1].write(stream);
        this.size += this.boxes[i1].size;
    }
    /* adjusting the size, now that all sub-boxes are known */ $c9a1fd49277acae3$var$Log.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size);
    stream.adjustUint32(this.sizePosition, this.size);
};
$c9a1fd49277acae3$var$BoxParser.TrackReferenceTypeBox.prototype.write = function(stream) {
    this.size = this.track_ids.length * 4;
    this.writeHeader(stream);
    stream.writeUint32Array(this.track_ids);
};
// file:src/writing/avcC.js
$c9a1fd49277acae3$var$BoxParser.avcCBox.prototype.write = function(stream) {
    var i1;
    this.size = 7;
    for(i1 = 0; i1 < this.SPS.length; i1++)this.size += 2 + this.SPS[i1].length;
    for(i1 = 0; i1 < this.PPS.length; i1++)this.size += 2 + this.PPS[i1].length;
    if (this.ext) this.size += this.ext.length;
    this.writeHeader(stream);
    stream.writeUint8(this.configurationVersion);
    stream.writeUint8(this.AVCProfileIndication);
    stream.writeUint8(this.profile_compatibility);
    stream.writeUint8(this.AVCLevelIndication);
    stream.writeUint8(this.lengthSizeMinusOne + 252);
    stream.writeUint8(this.SPS.length + 224);
    for(i1 = 0; i1 < this.SPS.length; i1++){
        stream.writeUint16(this.SPS[i1].length);
        stream.writeUint8Array(this.SPS[i1].nalu);
    }
    stream.writeUint8(this.PPS.length);
    for(i1 = 0; i1 < this.PPS.length; i1++){
        stream.writeUint16(this.PPS[i1].length);
        stream.writeUint8Array(this.PPS[i1].nalu);
    }
    if (this.ext) stream.writeUint8Array(this.ext);
};
// file:src/writing/co64.js
$c9a1fd49277acae3$var$BoxParser.co64Box.prototype.write = function(stream) {
    var i1;
    this.version = 0;
    this.flags = 0;
    this.size = 4 + 8 * this.chunk_offsets.length;
    this.writeHeader(stream);
    stream.writeUint32(this.chunk_offsets.length);
    for(i1 = 0; i1 < this.chunk_offsets.length; i1++)stream.writeUint64(this.chunk_offsets[i1]);
};
// file:src/writing/cslg.js
$c9a1fd49277acae3$var$BoxParser.cslgBox.prototype.write = function(stream) {
    var i1;
    this.version = 0;
    this.flags = 0;
    this.size = 20;
    this.writeHeader(stream);
    stream.writeInt32(this.compositionToDTSShift);
    stream.writeInt32(this.leastDecodeToDisplayDelta);
    stream.writeInt32(this.greatestDecodeToDisplayDelta);
    stream.writeInt32(this.compositionStartTime);
    stream.writeInt32(this.compositionEndTime);
};
// file:src/writing/ctts.js
$c9a1fd49277acae3$var$BoxParser.cttsBox.prototype.write = function(stream) {
    var i1;
    this.version = 0;
    this.flags = 0;
    this.size = 4 + 8 * this.sample_counts.length;
    this.writeHeader(stream);
    stream.writeUint32(this.sample_counts.length);
    for(i1 = 0; i1 < this.sample_counts.length; i1++){
        stream.writeUint32(this.sample_counts[i1]);
        if (this.version === 1) stream.writeInt32(this.sample_offsets[i1]); /* signed */ 
        else stream.writeUint32(this.sample_offsets[i1]); /* unsigned */ 
    }
};
// file:src/writing/dref.js
$c9a1fd49277acae3$var$BoxParser.drefBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = 4; //
    this.writeHeader(stream);
    stream.writeUint32(this.entries.length);
    for(var i1 = 0; i1 < this.entries.length; i1++){
        this.entries[i1].write(stream);
        this.size += this.entries[i1].size;
    }
    /* adjusting the size, now that all sub-boxes are known */ $c9a1fd49277acae3$var$Log.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size);
    stream.adjustUint32(this.sizePosition, this.size);
};
// file:src/writing/elng.js
$c9a1fd49277acae3$var$BoxParser.elngBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = this.extended_language.length;
    this.writeHeader(stream);
    stream.writeString(this.extended_language);
};
// file:src/writing/elst.js
$c9a1fd49277acae3$var$BoxParser.elstBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = 4 + 12 * this.entries.length;
    this.writeHeader(stream);
    stream.writeUint32(this.entries.length);
    for(var i1 = 0; i1 < this.entries.length; i1++){
        var entry = this.entries[i1];
        stream.writeUint32(entry.segment_duration);
        stream.writeInt32(entry.media_time);
        stream.writeInt16(entry.media_rate_integer);
        stream.writeInt16(entry.media_rate_fraction);
    }
};
// file:src/writing/emsg.js
$c9a1fd49277acae3$var$BoxParser.emsgBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = 16 + this.message_data.length + (this.scheme_id_uri.length + 1) + (this.value.length + 1);
    this.writeHeader(stream);
    stream.writeCString(this.scheme_id_uri);
    stream.writeCString(this.value);
    stream.writeUint32(this.timescale);
    stream.writeUint32(this.presentation_time_delta);
    stream.writeUint32(this.event_duration);
    stream.writeUint32(this.id);
    stream.writeUint8Array(this.message_data);
};
// file:src/writing/ftyp.js
$c9a1fd49277acae3$var$BoxParser.ftypBox.prototype.write = function(stream) {
    this.size = 8 + 4 * this.compatible_brands.length;
    this.writeHeader(stream);
    stream.writeString(this.major_brand, null, 4);
    stream.writeUint32(this.minor_version);
    for(var i1 = 0; i1 < this.compatible_brands.length; i1++)stream.writeString(this.compatible_brands[i1], null, 4);
};
// file:src/writing/hdlr.js
$c9a1fd49277acae3$var$BoxParser.hdlrBox.prototype.write = function(stream) {
    this.size = 20 + this.name.length + 1;
    this.version = 0;
    this.flags = 0;
    this.writeHeader(stream);
    stream.writeUint32(0);
    stream.writeString(this.handler, null, 4);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeCString(this.name);
};
// file:src/writing/hvcC.js
$c9a1fd49277acae3$var$BoxParser.hvcCBox.prototype.write = function(stream) {
    var i1, j;
    this.size = 23;
    for(i1 = 0; i1 < this.nalu_arrays.length; i1++){
        this.size += 3;
        for(j = 0; j < this.nalu_arrays[i1].length; j++)this.size += 2 + this.nalu_arrays[i1][j].data.length;
    }
    this.writeHeader(stream);
    stream.writeUint8(this.configurationVersion);
    stream.writeUint8(this.general_profile_space << 6 + this.general_tier_flag << 5 + this.general_profile_idc);
    stream.writeUint32(this.general_profile_compatibility);
    stream.writeUint8Array(this.general_constraint_indicator);
    stream.writeUint8(this.general_level_idc);
    stream.writeUint16(this.min_spatial_segmentation_idc + 251658240);
    stream.writeUint8(this.parallelismType + 252);
    stream.writeUint8(this.chroma_format_idc + 252);
    stream.writeUint8(this.bit_depth_luma_minus8 + 248);
    stream.writeUint8(this.bit_depth_chroma_minus8 + 248);
    stream.writeUint16(this.avgFrameRate);
    stream.writeUint8((this.constantFrameRate << 6) + (this.numTemporalLayers << 3) + (this.temporalIdNested << 2) + this.lengthSizeMinusOne);
    stream.writeUint8(this.nalu_arrays.length);
    for(i1 = 0; i1 < this.nalu_arrays.length; i1++){
        // bit(1) array_completeness + bit(1) reserved = 0 + bit(6) nal_unit_type
        stream.writeUint8((this.nalu_arrays[i1].completeness << 7) + this.nalu_arrays[i1].nalu_type);
        stream.writeUint16(this.nalu_arrays[i1].length);
        for(j = 0; j < this.nalu_arrays[i1].length; j++){
            stream.writeUint16(this.nalu_arrays[i1][j].data.length);
            stream.writeUint8Array(this.nalu_arrays[i1][j].data);
        }
    }
};
// file:src/writing/kind.js
$c9a1fd49277acae3$var$BoxParser.kindBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = this.schemeURI.length + 1 + (this.value.length + 1);
    this.writeHeader(stream);
    stream.writeCString(this.schemeURI);
    stream.writeCString(this.value);
};
// file:src/writing/mdhd.js
$c9a1fd49277acae3$var$BoxParser.mdhdBox.prototype.write = function(stream) {
    this.size = 20;
    this.flags = 0;
    this.version = 0;
    this.writeHeader(stream);
    stream.writeUint32(this.creation_time);
    stream.writeUint32(this.modification_time);
    stream.writeUint32(this.timescale);
    stream.writeUint32(this.duration);
    stream.writeUint16(this.language);
    stream.writeUint16(0);
};
// file:src/writing/mehd.js
$c9a1fd49277acae3$var$BoxParser.mehdBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = 4;
    this.writeHeader(stream);
    stream.writeUint32(this.fragment_duration);
};
// file:src/writing/mfhd.js
$c9a1fd49277acae3$var$BoxParser.mfhdBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = 4;
    this.writeHeader(stream);
    stream.writeUint32(this.sequence_number);
};
// file:src/writing/mvhd.js
$c9a1fd49277acae3$var$BoxParser.mvhdBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = 96;
    this.writeHeader(stream);
    stream.writeUint32(this.creation_time);
    stream.writeUint32(this.modification_time);
    stream.writeUint32(this.timescale);
    stream.writeUint32(this.duration);
    stream.writeUint32(this.rate);
    stream.writeUint16(this.volume << 8);
    stream.writeUint16(0);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeUint32Array(this.matrix);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeUint32(this.next_track_id);
};
// file:src/writing/sampleentry.js
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.writeHeader = function(stream) {
    this.size = 8;
    $c9a1fd49277acae3$var$BoxParser.Box.prototype.writeHeader.call(this, stream);
    stream.writeUint8(0);
    stream.writeUint8(0);
    stream.writeUint8(0);
    stream.writeUint8(0);
    stream.writeUint8(0);
    stream.writeUint8(0);
    stream.writeUint16(this.data_reference_index);
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.writeFooter = function(stream) {
    for(var i1 = 0; i1 < this.boxes.length; i1++){
        this.boxes[i1].write(stream);
        this.size += this.boxes[i1].size;
    }
    $c9a1fd49277acae3$var$Log.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size);
    stream.adjustUint32(this.sizePosition, this.size);
};
$c9a1fd49277acae3$var$BoxParser.SampleEntry.prototype.write = function(stream) {
    this.writeHeader(stream);
    stream.writeUint8Array(this.data);
    this.size += this.data.length;
    $c9a1fd49277acae3$var$Log.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size);
    stream.adjustUint32(this.sizePosition, this.size);
};
$c9a1fd49277acae3$var$BoxParser.VisualSampleEntry.prototype.write = function(stream) {
    this.writeHeader(stream);
    this.size += 70;
    stream.writeUint16(0);
    stream.writeUint16(0);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeUint16(this.width);
    stream.writeUint16(this.height);
    stream.writeUint32(this.horizresolution);
    stream.writeUint32(this.vertresolution);
    stream.writeUint32(0);
    stream.writeUint16(this.frame_count);
    stream.writeUint8(Math.min(31, this.compressorname.length));
    stream.writeString(this.compressorname, null, 31);
    stream.writeUint16(this.depth);
    stream.writeInt16(-1);
    this.writeFooter(stream);
};
$c9a1fd49277acae3$var$BoxParser.AudioSampleEntry.prototype.write = function(stream) {
    this.writeHeader(stream);
    this.size += 20;
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeUint16(this.channel_count);
    stream.writeUint16(this.samplesize);
    stream.writeUint16(0);
    stream.writeUint16(0);
    stream.writeUint32(this.samplerate << 16);
    this.writeFooter(stream);
};
$c9a1fd49277acae3$var$BoxParser.stppSampleEntry.prototype.write = function(stream) {
    this.writeHeader(stream);
    this.size += this.namespace.length + 1 + this.schema_location.length + 1 + this.auxiliary_mime_types.length + 1;
    stream.writeCString(this.namespace);
    stream.writeCString(this.schema_location);
    stream.writeCString(this.auxiliary_mime_types);
    this.writeFooter(stream);
};
// file:src/writing/samplegroups/samplegroup.js
$c9a1fd49277acae3$var$BoxParser.SampleGroupEntry.prototype.write = function(stream) {
    stream.writeUint8Array(this.data);
};
// file:src/writing/sbgp.js
$c9a1fd49277acae3$var$BoxParser.sbgpBox.prototype.write = function(stream) {
    this.version = 1;
    this.flags = 0;
    this.size = 12 + 8 * this.entries.length;
    this.writeHeader(stream);
    stream.writeString(this.grouping_type, null, 4);
    stream.writeUint32(this.grouping_type_parameter);
    stream.writeUint32(this.entries.length);
    for(var i1 = 0; i1 < this.entries.length; i1++){
        var entry = this.entries[i1];
        stream.writeInt32(entry.sample_count);
        stream.writeInt32(entry.group_description_index);
    }
};
// file:src/writing/sgpd.js
$c9a1fd49277acae3$var$BoxParser.sgpdBox.prototype.write = function(stream) {
    var i1;
    var entry;
    // leave version as read
    // this.version;
    this.flags = 0;
    this.size = 12;
    for(i1 = 0; i1 < this.entries.length; i1++){
        entry = this.entries[i1];
        if (this.version === 1) {
            if (this.default_length === 0) this.size += 4;
            this.size += entry.data.length;
        }
    }
    this.writeHeader(stream);
    stream.writeString(this.grouping_type, null, 4);
    if (this.version === 1) stream.writeUint32(this.default_length);
    if (this.version >= 2) stream.writeUint32(this.default_sample_description_index);
    stream.writeUint32(this.entries.length);
    for(i1 = 0; i1 < this.entries.length; i1++){
        entry = this.entries[i1];
        if (this.version === 1) {
            if (this.default_length === 0) stream.writeUint32(entry.description_length);
        }
        entry.write(stream);
    }
};
// file:src/writing/sidx.js
$c9a1fd49277acae3$var$BoxParser.sidxBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = 20 + 12 * this.references.length;
    this.writeHeader(stream);
    stream.writeUint32(this.reference_ID);
    stream.writeUint32(this.timescale);
    stream.writeUint32(this.earliest_presentation_time);
    stream.writeUint32(this.first_offset);
    stream.writeUint16(0);
    stream.writeUint16(this.references.length);
    for(var i1 = 0; i1 < this.references.length; i1++){
        var ref = this.references[i1];
        stream.writeUint32(ref.reference_type << 31 | ref.referenced_size);
        stream.writeUint32(ref.subsegment_duration);
        stream.writeUint32(ref.starts_with_SAP << 31 | ref.SAP_type << 28 | ref.SAP_delta_time);
    }
};
// file:src/writing/smhd.js
$c9a1fd49277acae3$var$BoxParser.smhdBox.prototype.write = function(stream) {
    var i1;
    this.version = 0;
    this.flags = 1;
    this.size = 4;
    this.writeHeader(stream);
    stream.writeUint16(this.balance);
    stream.writeUint16(0);
};
// file:src/writing/stco.js
$c9a1fd49277acae3$var$BoxParser.stcoBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = 4 + 4 * this.chunk_offsets.length;
    this.writeHeader(stream);
    stream.writeUint32(this.chunk_offsets.length);
    stream.writeUint32Array(this.chunk_offsets);
};
// file:src/writing/stsc.js
$c9a1fd49277acae3$var$BoxParser.stscBox.prototype.write = function(stream) {
    var i1;
    this.version = 0;
    this.flags = 0;
    this.size = 4 + 12 * this.first_chunk.length;
    this.writeHeader(stream);
    stream.writeUint32(this.first_chunk.length);
    for(i1 = 0; i1 < this.first_chunk.length; i1++){
        stream.writeUint32(this.first_chunk[i1]);
        stream.writeUint32(this.samples_per_chunk[i1]);
        stream.writeUint32(this.sample_description_index[i1]);
    }
};
// file:src/writing/stsd.js
$c9a1fd49277acae3$var$BoxParser.stsdBox.prototype.write = function(stream) {
    var i1;
    this.version = 0;
    this.flags = 0;
    this.size = 0;
    this.writeHeader(stream);
    stream.writeUint32(this.entries.length);
    this.size += 4;
    for(i1 = 0; i1 < this.entries.length; i1++){
        this.entries[i1].write(stream);
        this.size += this.entries[i1].size;
    }
    /* adjusting the size, now that all sub-boxes are known */ $c9a1fd49277acae3$var$Log.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size);
    stream.adjustUint32(this.sizePosition, this.size);
};
// file:src/writing/stsh.js
$c9a1fd49277acae3$var$BoxParser.stshBox.prototype.write = function(stream) {
    var i1;
    this.version = 0;
    this.flags = 0;
    this.size = 4 + 8 * this.shadowed_sample_numbers.length;
    this.writeHeader(stream);
    stream.writeUint32(this.shadowed_sample_numbers.length);
    for(i1 = 0; i1 < this.shadowed_sample_numbers.length; i1++){
        stream.writeUint32(this.shadowed_sample_numbers[i1]);
        stream.writeUint32(this.sync_sample_numbers[i1]);
    }
};
// file:src/writing/stss.js
$c9a1fd49277acae3$var$BoxParser.stssBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = 4 + 4 * this.sample_numbers.length;
    this.writeHeader(stream);
    stream.writeUint32(this.sample_numbers.length);
    stream.writeUint32Array(this.sample_numbers);
};
// file:src/writing/stsz.js
$c9a1fd49277acae3$var$BoxParser.stszBox.prototype.write = function(stream) {
    var i1;
    var constant = true;
    this.version = 0;
    this.flags = 0;
    if (this.sample_sizes.length > 0) {
        i1 = 0;
        while(i1 + 1 < this.sample_sizes.length)if (this.sample_sizes[i1 + 1] !== this.sample_sizes[0]) {
            constant = false;
            break;
        } else i1++;
    } else constant = false;
    this.size = 8;
    if (!constant) this.size += 4 * this.sample_sizes.length;
    this.writeHeader(stream);
    if (!constant) stream.writeUint32(0);
    else stream.writeUint32(this.sample_sizes[0]);
    stream.writeUint32(this.sample_sizes.length);
    if (!constant) stream.writeUint32Array(this.sample_sizes);
};
// file:src/writing/stts.js
$c9a1fd49277acae3$var$BoxParser.sttsBox.prototype.write = function(stream) {
    var i1;
    this.version = 0;
    this.flags = 0;
    this.size = 4 + 8 * this.sample_counts.length;
    this.writeHeader(stream);
    stream.writeUint32(this.sample_counts.length);
    for(i1 = 0; i1 < this.sample_counts.length; i1++){
        stream.writeUint32(this.sample_counts[i1]);
        stream.writeUint32(this.sample_deltas[i1]);
    }
};
// file:src/writing/tfdt.js
$c9a1fd49277acae3$var$BoxParser.tfdtBox.prototype.write = function(stream) {
    var UINT32_MAX = Math.pow(2, 32) - 1;
    // use version 1 if baseMediaDecodeTime does not fit 32 bits
    this.version = this.baseMediaDecodeTime > UINT32_MAX ? 1 : 0;
    this.flags = 0;
    this.size = 4;
    if (this.version === 1) this.size += 4;
    this.writeHeader(stream);
    if (this.version === 1) stream.writeUint64(this.baseMediaDecodeTime);
    else stream.writeUint32(this.baseMediaDecodeTime);
};
// file:src/writing/tfhd.js
$c9a1fd49277acae3$var$BoxParser.tfhdBox.prototype.write = function(stream) {
    this.version = 0;
    this.size = 4;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_BASE_DATA_OFFSET) this.size += 8;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_DESC) this.size += 4;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_DUR) this.size += 4;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_SIZE) this.size += 4;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_FLAGS) this.size += 4;
    this.writeHeader(stream);
    stream.writeUint32(this.track_id);
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_BASE_DATA_OFFSET) stream.writeUint64(this.base_data_offset);
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_DESC) stream.writeUint32(this.default_sample_description_index);
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_DUR) stream.writeUint32(this.default_sample_duration);
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_SIZE) stream.writeUint32(this.default_sample_size);
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_FLAGS) stream.writeUint32(this.default_sample_flags);
};
// file:src/writing/tkhd.js
$c9a1fd49277acae3$var$BoxParser.tkhdBox.prototype.write = function(stream) {
    this.version = 0;
    //this.flags = 0;
    this.size = 80;
    this.writeHeader(stream);
    stream.writeUint32(this.creation_time);
    stream.writeUint32(this.modification_time);
    stream.writeUint32(this.track_id);
    stream.writeUint32(0);
    stream.writeUint32(this.duration);
    stream.writeUint32(0);
    stream.writeUint32(0);
    stream.writeInt16(this.layer);
    stream.writeInt16(this.alternate_group);
    stream.writeInt16(this.volume << 8);
    stream.writeUint16(0);
    stream.writeInt32Array(this.matrix);
    stream.writeUint32(this.width);
    stream.writeUint32(this.height);
};
// file:src/writing/trex.js
$c9a1fd49277acae3$var$BoxParser.trexBox.prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = 20;
    this.writeHeader(stream);
    stream.writeUint32(this.track_id);
    stream.writeUint32(this.default_sample_description_index);
    stream.writeUint32(this.default_sample_duration);
    stream.writeUint32(this.default_sample_size);
    stream.writeUint32(this.default_sample_flags);
};
// file:src/writing/trun.js
$c9a1fd49277acae3$var$BoxParser.trunBox.prototype.write = function(stream) {
    this.version = 0;
    this.size = 4;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DATA_OFFSET) this.size += 4;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FIRST_FLAG) this.size += 4;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DURATION) this.size += 4 * this.sample_duration.length;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_SIZE) this.size += 4 * this.sample_size.length;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FLAGS) this.size += 4 * this.sample_flags.length;
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_CTS_OFFSET) this.size += 4 * this.sample_composition_time_offset.length;
    this.writeHeader(stream);
    stream.writeUint32(this.sample_count);
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DATA_OFFSET) {
        this.data_offset_position = stream.getPosition();
        stream.writeInt32(this.data_offset); //signed
    }
    if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FIRST_FLAG) stream.writeUint32(this.first_sample_flags);
    for(var i1 = 0; i1 < this.sample_count; i1++){
        if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DURATION) stream.writeUint32(this.sample_duration[i1]);
        if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_SIZE) stream.writeUint32(this.sample_size[i1]);
        if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FLAGS) stream.writeUint32(this.sample_flags[i1]);
        if (this.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_CTS_OFFSET) {
            if (this.version === 0) stream.writeUint32(this.sample_composition_time_offset[i1]);
            else stream.writeInt32(this.sample_composition_time_offset[i1]); //signed
        }
    }
};
// file:src/writing/url.js
$c9a1fd49277acae3$var$BoxParser["url Box"].prototype.write = function(stream) {
    this.version = 0;
    if (this.location) {
        this.flags = 0;
        this.size = this.location.length + 1;
    } else {
        this.flags = 0x000001;
        this.size = 0;
    }
    this.writeHeader(stream);
    if (this.location) stream.writeCString(this.location);
};
// file:src/writing/urn.js
$c9a1fd49277acae3$var$BoxParser["urn Box"].prototype.write = function(stream) {
    this.version = 0;
    this.flags = 0;
    this.size = this.name.length + 1 + (this.location ? this.location.length + 1 : 0);
    this.writeHeader(stream);
    stream.writeCString(this.name);
    if (this.location) stream.writeCString(this.location);
};
// file:src/writing/vmhd.js
$c9a1fd49277acae3$var$BoxParser.vmhdBox.prototype.write = function(stream) {
    var i1;
    this.version = 0;
    this.flags = 1;
    this.size = 8;
    this.writeHeader(stream);
    stream.writeUint16(this.graphicsmode);
    stream.writeUint16Array(this.opcolor);
};
// file:src/box-unpack.js
/* 
* Copyright (c) Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
* License: BSD-3-Clause (see LICENSE file)
*/ $c9a1fd49277acae3$var$BoxParser.cttsBox.prototype.unpack = function(samples) {
    var i1, j, k;
    k = 0;
    for(i1 = 0; i1 < this.sample_counts.length; i1++)for(j = 0; j < this.sample_counts[i1]; j++){
        samples[k].pts = samples[k].dts + this.sample_offsets[i1];
        k++;
    }
};
$c9a1fd49277acae3$var$BoxParser.sttsBox.prototype.unpack = function(samples) {
    var i1, j, k;
    k = 0;
    for(i1 = 0; i1 < this.sample_counts.length; i1++)for(j = 0; j < this.sample_counts[i1]; j++){
        if (k === 0) samples[k].dts = 0;
        else samples[k].dts = samples[k - 1].dts + this.sample_deltas[i1];
        k++;
    }
};
$c9a1fd49277acae3$var$BoxParser.stcoBox.prototype.unpack = function(samples) {
    var i1;
    for(i1 = 0; i1 < this.chunk_offsets.length; i1++)samples[i1].offset = this.chunk_offsets[i1];
};
$c9a1fd49277acae3$var$BoxParser.stscBox.prototype.unpack = function(samples) {
    var i1, j, k, l, m;
    l = 0;
    m = 0;
    for(i1 = 0; i1 < this.first_chunk.length; i1++)for(j = 0; j < (i1 + 1 < this.first_chunk.length ? this.first_chunk[i1 + 1] : Infinity); j++){
        m++;
        for(k = 0; k < this.samples_per_chunk[i1]; k++){
            if (samples[l]) {
                samples[l].description_index = this.sample_description_index[i1];
                samples[l].chunk_index = m;
            } else return;
            l++;
        }
    }
};
$c9a1fd49277acae3$var$BoxParser.stszBox.prototype.unpack = function(samples) {
    var i1;
    for(i1 = 0; i1 < this.sample_sizes.length; i1++)samples[i1].size = this.sample_sizes[i1];
};
// file:src/box-diff.js
$c9a1fd49277acae3$var$BoxParser.DIFF_BOXES_PROP_NAMES = [
    "boxes",
    "entries",
    "references",
    "subsamples",
    "items",
    "item_infos",
    "extents",
    "associations",
    "subsegments",
    "ranges",
    "seekLists",
    "seekPoints",
    "esd",
    "levels"
];
$c9a1fd49277acae3$var$BoxParser.DIFF_PRIMITIVE_ARRAY_PROP_NAMES = [
    "compatible_brands",
    "matrix",
    "opcolor",
    "sample_counts",
    "sample_counts",
    "sample_deltas",
    "first_chunk",
    "samples_per_chunk",
    "sample_sizes",
    "chunk_offsets",
    "sample_offsets",
    "sample_description_index",
    "sample_duration"
];
$c9a1fd49277acae3$var$BoxParser.boxEqualFields = function(box_a, box_b) {
    if (box_a && !box_b) return false;
    var prop;
    for(prop in box_a){
        if ($c9a1fd49277acae3$var$BoxParser.DIFF_BOXES_PROP_NAMES.indexOf(prop) > -1) continue;
        else if (box_a[prop] instanceof $c9a1fd49277acae3$var$BoxParser.Box || box_b[prop] instanceof $c9a1fd49277acae3$var$BoxParser.Box) continue;
        else if (typeof box_a[prop] === "undefined" || typeof box_b[prop] === "undefined") continue;
        else if (typeof box_a[prop] === "function" || typeof box_b[prop] === "function") continue;
        else if (box_a.subBoxNames && box_a.subBoxNames.indexOf(prop.slice(0, 4)) > -1 || box_b.subBoxNames && box_b.subBoxNames.indexOf(prop.slice(0, 4)) > -1) continue;
        else {
            if (prop === "data" || prop === "start" || prop === "size" || prop === "creation_time" || prop === "modification_time") continue;
            else if ($c9a1fd49277acae3$var$BoxParser.DIFF_PRIMITIVE_ARRAY_PROP_NAMES.indexOf(prop) > -1) continue;
            else {
                if (box_a[prop] !== box_b[prop]) return false;
            }
        }
    }
    return true;
};
$c9a1fd49277acae3$var$BoxParser.boxEqual = function(box_a, box_b) {
    if (!$c9a1fd49277acae3$var$BoxParser.boxEqualFields(box_a, box_b)) return false;
    for(var j = 0; j < $c9a1fd49277acae3$var$BoxParser.DIFF_BOXES_PROP_NAMES.length; j++){
        var name = $c9a1fd49277acae3$var$BoxParser.DIFF_BOXES_PROP_NAMES[j];
        if (box_a[name] && box_b[name]) {
            if (!$c9a1fd49277acae3$var$BoxParser.boxEqual(box_a[name], box_b[name])) return false;
        }
    }
    return true;
} // file:src/text-mp4.js
;
/* 
* Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
* License: BSD-3-Clause (see LICENSE file)
*/ var $c9a1fd49277acae3$var$VTTin4Parser = function() {};
$c9a1fd49277acae3$var$VTTin4Parser.prototype.parseSample = function(data) {
    var cues, cue;
    var stream = new $c9a1fd49277acae3$var$MP4BoxStream(data.buffer);
    cues = [];
    while(!stream.isEos()){
        cue = $c9a1fd49277acae3$var$BoxParser.parseOneBox(stream, false);
        if (cue.code === $c9a1fd49277acae3$var$BoxParser.OK && cue.box.type === "vttc") cues.push(cue.box);
    }
    return cues;
};
$c9a1fd49277acae3$var$VTTin4Parser.prototype.getText = function(startTime, endTime, data) {
    function pad(n, width, z) {
        z = z || "0";
        n = n + "";
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
    function secToTimestamp(insec) {
        var h = Math.floor(insec / 3600);
        var m = Math.floor((insec - h * 3600) / 60);
        var s = Math.floor(insec - h * 3600 - m * 60);
        var ms = Math.floor((insec - h * 3600 - m * 60 - s) * 1000);
        return "" + pad(h, 2) + ":" + pad(m, 2) + ":" + pad(s, 2) + "." + pad(ms, 3);
    }
    var cues = this.parseSample(data);
    var string = "";
    for(var i1 = 0; i1 < cues.length; i1++){
        var cueIn4 = cues[i1];
        string += secToTimestamp(startTime) + " --> " + secToTimestamp(endTime) + "\r\n";
        string += cueIn4.payl.text;
    }
    return string;
};
var $c9a1fd49277acae3$var$XMLSubtitlein4Parser = function() {};
$c9a1fd49277acae3$var$XMLSubtitlein4Parser.prototype.parseSample = function(sample) {
    var res = {};
    var i1;
    res.resources = [];
    var stream = new $c9a1fd49277acae3$var$MP4BoxStream(sample.data.buffer);
    if (!sample.subsamples || sample.subsamples.length === 0) res.documentString = stream.readString(sample.data.length);
    else {
        res.documentString = stream.readString(sample.subsamples[0].size);
        if (sample.subsamples.length > 1) for(i1 = 1; i1 < sample.subsamples.length; i1++)res.resources[i1] = stream.readUint8Array(sample.subsamples[i1].size);
    }
    if (typeof DOMParser !== "undefined") res.document = new DOMParser().parseFromString(res.documentString, "application/xml");
    return res;
};
var $c9a1fd49277acae3$var$Textin4Parser = function() {};
$c9a1fd49277acae3$var$Textin4Parser.prototype.parseSample = function(sample) {
    var textString;
    var stream = new $c9a1fd49277acae3$var$MP4BoxStream(sample.data.buffer);
    textString = stream.readString(sample.data.length);
    return textString;
};
$c9a1fd49277acae3$var$Textin4Parser.prototype.parseConfig = function(data) {
    var textString;
    var stream = new $c9a1fd49277acae3$var$MP4BoxStream(data.buffer);
    stream.readUint32(); // version & flags
    textString = stream.readCString();
    return textString;
};
$c9a1fd49277acae3$export$43507abd4cdcd72e = $c9a1fd49277acae3$var$XMLSubtitlein4Parser;
$c9a1fd49277acae3$export$2093b46416a25787 = $c9a1fd49277acae3$var$Textin4Parser;
// file:src/isofile.js
/*
* Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
* License: BSD-3-Clause (see LICENSE file)
*/ var $c9a1fd49277acae3$var$ISOFile = function(stream) {
    /* MutiBufferStream object used to parse boxes */ this.stream = stream || new $c9a1fd49277acae3$var$MultiBufferStream();
    /* Array of all boxes (in order) found in the file */ this.boxes = [];
    /* Array of all mdats */ this.mdats = [];
    /* Array of all moofs */ this.moofs = [];
    /* Boolean indicating if the file is compatible with progressive parsing (moov first) */ this.isProgressive = false;
    /* Boolean used to fire moov start event only once */ this.moovStartFound = false;
    /* Callback called when the moov parsing starts */ this.onMoovStart = null;
    /* Boolean keeping track of the call to onMoovStart, to avoid double calls */ this.moovStartSent = false;
    /* Callback called when the moov is entirely parsed */ this.onReady = null;
    /* Boolean keeping track of the call to onReady, to avoid double calls */ this.readySent = false;
    /* Callback to call when segments are ready */ this.onSegment = null;
    /* Callback to call when samples are ready */ this.onSamples = null;
    /* Callback to call when there is an error in the parsing or processing of samples */ this.onError = null;
    /* Boolean indicating if the moov box run-length encoded tables of sample information have been processed */ this.sampleListBuilt = false;
    /* Array of Track objects for which fragmentation of samples is requested */ this.fragmentedTracks = [];
    /* Array of Track objects for which extraction of samples is requested */ this.extractedTracks = [];
    /* Boolean indicating that fragmention is ready */ this.isFragmentationInitialized = false;
    /* Boolean indicating that fragmented has started */ this.sampleProcessingStarted = false;
    /* Number of the next 'moof' to generate when fragmenting */ this.nextMoofNumber = 0;
    /* Boolean indicating if the initial list of items has been produced */ this.itemListBuilt = false;
    /* Callback called when the sidx box is entirely parsed */ this.onSidx = null;
    /* Boolean keeping track of the call to onSidx, to avoid double calls */ this.sidxSent = false;
};
$c9a1fd49277acae3$var$ISOFile.prototype.setSegmentOptions = function(id, user, options) {
    var trak = this.getTrackById(id);
    if (trak) {
        var fragTrack = {};
        this.fragmentedTracks.push(fragTrack);
        fragTrack.id = id;
        fragTrack.user = user;
        fragTrack.trak = trak;
        trak.nextSample = 0;
        fragTrack.segmentStream = null;
        fragTrack.nb_samples = 1000;
        fragTrack.rapAlignement = true;
        if (options) {
            if (options.nbSamples) fragTrack.nb_samples = options.nbSamples;
            if (options.rapAlignement) fragTrack.rapAlignement = options.rapAlignement;
        }
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.unsetSegmentOptions = function(id) {
    var index = -1;
    for(var i1 = 0; i1 < this.fragmentedTracks.length; i1++){
        var fragTrack = this.fragmentedTracks[i1];
        if (fragTrack.id == id) index = i1;
    }
    if (index > -1) this.fragmentedTracks.splice(index, 1);
};
$c9a1fd49277acae3$var$ISOFile.prototype.setExtractionOptions = function(id, user, options) {
    var trak = this.getTrackById(id);
    if (trak) {
        var extractTrack = {};
        this.extractedTracks.push(extractTrack);
        extractTrack.id = id;
        extractTrack.user = user;
        extractTrack.trak = trak;
        trak.nextSample = 0;
        extractTrack.nb_samples = 1000;
        extractTrack.samples = [];
        if (options) {
            if (options.nbSamples) extractTrack.nb_samples = options.nbSamples;
        }
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.unsetExtractionOptions = function(id) {
    var index = -1;
    for(var i1 = 0; i1 < this.extractedTracks.length; i1++){
        var extractTrack = this.extractedTracks[i1];
        if (extractTrack.id == id) index = i1;
    }
    if (index > -1) this.extractedTracks.splice(index, 1);
};
$c9a1fd49277acae3$var$ISOFile.prototype.parse = function() {
    var found;
    var ret1;
    var box1;
    var parseBoxHeadersOnly = false;
    if (this.restoreParsePosition) {
        if (!this.restoreParsePosition()) return;
    }
    while(true)if (this.hasIncompleteMdat && this.hasIncompleteMdat()) {
        if (this.processIncompleteMdat()) continue;
        else return;
    } else {
        if (this.saveParsePosition) this.saveParsePosition();
        ret1 = $c9a1fd49277acae3$var$BoxParser.parseOneBox(this.stream, parseBoxHeadersOnly);
        if (ret1.code === $c9a1fd49277acae3$var$BoxParser.ERR_NOT_ENOUGH_DATA) {
            if (this.processIncompleteBox) {
                if (this.processIncompleteBox(ret1)) continue;
                else return;
            } else return;
        } else {
            var box_type;
            /* the box is entirely parsed */ box1 = ret1.box;
            box_type = box1.type !== "uuid" ? box1.type : box1.uuid;
            /* store the box in the 'boxes' array to preserve box order (for file rewrite if needed)  */ this.boxes.push(box1);
            /* but also store box in a property for more direct access */ switch(box_type){
                case "mdat":
                    this.mdats.push(box1);
                    break;
                case "moof":
                    this.moofs.push(box1);
                    break;
                case "moov":
                    this.moovStartFound = true;
                    if (this.mdats.length === 0) this.isProgressive = true;
                /* no break */ /* falls through */ default:
                    if (this[box_type] !== undefined) $c9a1fd49277acae3$var$Log.warn("ISOFile", "Duplicate Box of type: " + box_type + ", overriding previous occurrence");
                    this[box_type] = box1;
                    break;
            }
            if (this.updateUsedBytes) this.updateUsedBytes(box1, ret1);
        }
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.checkBuffer = function(ab) {
    if (ab === null || ab === undefined) throw "Buffer must be defined and non empty";
    if (ab.fileStart === undefined) throw "Buffer must have a fileStart property";
    if (ab.byteLength === 0) {
        $c9a1fd49277acae3$var$Log.warn("ISOFile", "Ignoring empty buffer (fileStart: " + ab.fileStart + ")");
        this.stream.logBufferLevel();
        return false;
    }
    $c9a1fd49277acae3$var$Log.info("ISOFile", "Processing buffer (fileStart: " + ab.fileStart + ")");
    /* mark the bytes in the buffer as not being used yet */ ab.usedBytes = 0;
    this.stream.insertBuffer(ab);
    this.stream.logBufferLevel();
    if (!this.stream.initialized()) {
        $c9a1fd49277acae3$var$Log.warn("ISOFile", "Not ready to start parsing");
        return false;
    }
    return true;
};
/* Processes a new ArrayBuffer (with a fileStart property)
Returns the next expected file position, or undefined if not ready to parse */ $c9a1fd49277acae3$var$ISOFile.prototype.appendBuffer = function(ab, last) {
    var nextFileStart;
    if (!this.checkBuffer(ab)) return;
    /* Parse whatever is in the existing buffers */ this.parse();
    /* Check if the moovStart callback needs to be called */ if (this.moovStartFound && !this.moovStartSent) {
        this.moovStartSent = true;
        if (this.onMoovStart) this.onMoovStart();
    }
    if (this.moov) {
        /* A moov box has been entirely parsed */ /* if this is the first call after the moov is found we initialize the list of samples (may be empty in fragmented files) */ if (!this.sampleListBuilt) {
            this.buildSampleLists();
            this.sampleListBuilt = true;
        }
        /* We update the sample information if there are any new moof boxes */ this.updateSampleLists();
        /* If the application needs to be informed that the 'moov' has been found,
       we create the information object and callback the application */ if (this.onReady && !this.readySent) {
            this.readySent = true;
            this.onReady(this.getInfo());
        }
        /* See if any sample extraction or segment creation needs to be done with the available samples */ this.processSamples(last);
        /* Inform about the best range to fetch next */ if (this.nextSeekPosition) {
            nextFileStart = this.nextSeekPosition;
            this.nextSeekPosition = undefined;
        } else nextFileStart = this.nextParsePosition;
        if (this.stream.getEndFilePositionAfter) nextFileStart = this.stream.getEndFilePositionAfter(nextFileStart);
    } else if (this.nextParsePosition) /* moov has not been parsed but the first buffer was received,
           the next fetch should probably be the next box start */ nextFileStart = this.nextParsePosition;
    else /* No valid buffer has been parsed yet, we cannot know what to parse next */ nextFileStart = 0;
    if (this.sidx) {
        if (this.onSidx && !this.sidxSent) {
            this.onSidx(this.sidx);
            this.sidxSent = true;
        }
    }
    if (this.meta) {
        if (this.flattenItemInfo && !this.itemListBuilt) {
            this.flattenItemInfo();
            this.itemListBuilt = true;
        }
        if (this.processItems) this.processItems(this.onItem);
    }
    if (this.stream.cleanBuffers) {
        $c9a1fd49277acae3$var$Log.info("ISOFile", "Done processing buffer (fileStart: " + ab.fileStart + ") - next buffer to fetch should have a fileStart position of " + nextFileStart);
        this.stream.logBufferLevel();
        this.stream.cleanBuffers();
        this.stream.logBufferLevel(true);
        $c9a1fd49277acae3$var$Log.info("ISOFile", "Sample data size in memory: " + this.getAllocatedSampleDataSize());
    }
    return nextFileStart;
};
$c9a1fd49277acae3$var$ISOFile.prototype.getInfo = function() {
    var i1, j;
    var movie = {};
    var trak;
    var track;
    var ref;
    var sample_desc;
    var _1904 = new Date("1904-01-01T00:00:00Z").getTime();
    if (this.moov) {
        movie.hasMoov = true;
        movie.duration = this.moov.mvhd.duration;
        movie.timescale = this.moov.mvhd.timescale;
        movie.isFragmented = this.moov.mvex != null;
        if (movie.isFragmented && this.moov.mvex.mehd) movie.fragment_duration = this.moov.mvex.mehd.fragment_duration;
        movie.isProgressive = this.isProgressive;
        movie.hasIOD = this.moov.iods != null;
        movie.brands = [];
        movie.brands.push(this.ftyp.major_brand);
        movie.brands = movie.brands.concat(this.ftyp.compatible_brands);
        movie.created = new Date(_1904 + this.moov.mvhd.creation_time * 1000);
        movie.modified = new Date(_1904 + this.moov.mvhd.modification_time * 1000);
        movie.tracks = [];
        movie.audioTracks = [];
        movie.videoTracks = [];
        movie.subtitleTracks = [];
        movie.metadataTracks = [];
        movie.hintTracks = [];
        movie.otherTracks = [];
        for(i1 = 0; i1 < this.moov.traks.length; i1++){
            trak = this.moov.traks[i1];
            sample_desc = trak.mdia.minf.stbl.stsd.entries[0];
            track = {};
            movie.tracks.push(track);
            track.id = trak.tkhd.track_id;
            track.name = trak.mdia.hdlr.name;
            track.references = [];
            if (trak.tref) for(j = 0; j < trak.tref.boxes.length; j++){
                ref = {};
                track.references.push(ref);
                ref.type = trak.tref.boxes[j].type;
                ref.track_ids = trak.tref.boxes[j].track_ids;
            }
            if (trak.edts) track.edits = trak.edts.elst.entries;
            track.created = new Date(_1904 + trak.tkhd.creation_time * 1000);
            track.modified = new Date(_1904 + trak.tkhd.modification_time * 1000);
            track.movie_duration = trak.tkhd.duration;
            track.movie_timescale = movie.timescale;
            track.layer = trak.tkhd.layer;
            track.alternate_group = trak.tkhd.alternate_group;
            track.volume = trak.tkhd.volume;
            track.matrix = trak.tkhd.matrix;
            track.track_width = trak.tkhd.width / 65536;
            track.track_height = trak.tkhd.height / 65536;
            track.timescale = trak.mdia.mdhd.timescale;
            track.cts_shift = trak.mdia.minf.stbl.cslg;
            track.duration = trak.mdia.mdhd.duration;
            track.samples_duration = trak.samples_duration;
            track.codec = sample_desc.getCodec();
            track.kind = trak.udta && trak.udta.kinds.length ? trak.udta.kinds[0] : {
                schemeURI: "",
                value: ""
            };
            track.language = trak.mdia.elng ? trak.mdia.elng.extended_language : trak.mdia.mdhd.languageString;
            track.nb_samples = trak.samples.length;
            track.size = trak.samples_size;
            track.bitrate = track.size * 8 * track.timescale / track.samples_duration;
            if (sample_desc.isAudio()) {
                track.type = "audio";
                movie.audioTracks.push(track);
                track.audio = {};
                track.audio.sample_rate = sample_desc.getSampleRate();
                track.audio.channel_count = sample_desc.getChannelCount();
                track.audio.sample_size = sample_desc.getSampleSize();
            } else if (sample_desc.isVideo()) {
                track.type = "video";
                movie.videoTracks.push(track);
                track.video = {};
                track.video.width = sample_desc.getWidth();
                track.video.height = sample_desc.getHeight();
            } else if (sample_desc.isSubtitle()) {
                track.type = "subtitles";
                movie.subtitleTracks.push(track);
            } else if (sample_desc.isHint()) {
                track.type = "metadata";
                movie.hintTracks.push(track);
            } else if (sample_desc.isMetadata()) {
                track.type = "metadata";
                movie.metadataTracks.push(track);
            } else {
                track.type = "metadata";
                movie.otherTracks.push(track);
            }
        }
    } else movie.hasMoov = false;
    movie.mime = "";
    if (movie.hasMoov && movie.tracks) {
        if (movie.videoTracks && movie.videoTracks.length > 0) movie.mime += 'video/mp4; codecs="';
        else if (movie.audioTracks && movie.audioTracks.length > 0) movie.mime += 'audio/mp4; codecs="';
        else movie.mime += 'application/mp4; codecs="';
        for(i1 = 0; i1 < movie.tracks.length; i1++){
            if (i1 !== 0) movie.mime += ",";
            movie.mime += movie.tracks[i1].codec;
        }
        movie.mime += '"; profiles="';
        movie.mime += this.ftyp.compatible_brands.join();
        movie.mime += '"';
    }
    return movie;
};
$c9a1fd49277acae3$var$ISOFile.prototype.setNextSeekPositionFromSample = function(sample) {
    if (!sample) return;
    if (this.nextSeekPosition) this.nextSeekPosition = Math.min(sample.offset + sample.alreadyRead, this.nextSeekPosition);
    else this.nextSeekPosition = sample.offset + sample.alreadyRead;
};
$c9a1fd49277acae3$var$ISOFile.prototype.processSamples = function(last) {
    var i1;
    var trak;
    if (!this.sampleProcessingStarted) return;
    /* For each track marked for fragmentation,
   check if the next sample is there (i.e. if the sample information is known (i.e. moof has arrived) and if it has been downloaded)
   and create a fragment with it */ if (this.isFragmentationInitialized && this.onSegment !== null) for(i1 = 0; i1 < this.fragmentedTracks.length; i1++){
        var fragTrak = this.fragmentedTracks[i1];
        trak = fragTrak.trak;
        while(trak.nextSample < trak.samples.length && this.sampleProcessingStarted){
            /* The sample information is there (either because the file is not fragmented and this is not the last sample,
            or because the file is fragmented and the moof for that sample has been received */ $c9a1fd49277acae3$var$Log.debug("ISOFile", "Creating media fragment on track #" + fragTrak.id + " for sample " + trak.nextSample);
            var result = this.createFragment(fragTrak.id, trak.nextSample, fragTrak.segmentStream);
            if (result) {
                fragTrak.segmentStream = result;
                trak.nextSample++;
            } else break;
            /* A fragment is created by sample, but the segment is the accumulation in the buffer of these fragments.
               It is flushed only as requested by the application (nb_samples) to avoid too many callbacks */ if (trak.nextSample % fragTrak.nb_samples === 0 || last || trak.nextSample >= trak.samples.length) {
                $c9a1fd49277acae3$var$Log.info("ISOFile", "Sending fragmented data on track #" + fragTrak.id + " for samples [" + Math.max(0, trak.nextSample - fragTrak.nb_samples) + "," + (trak.nextSample - 1) + "]");
                $c9a1fd49277acae3$var$Log.info("ISOFile", "Sample data size in memory: " + this.getAllocatedSampleDataSize());
                if (this.onSegment) this.onSegment(fragTrak.id, fragTrak.user, fragTrak.segmentStream.buffer, trak.nextSample, last || trak.nextSample >= trak.samples.length);
                /* force the creation of a new buffer */ fragTrak.segmentStream = null;
                if (fragTrak !== this.fragmentedTracks[i1]) break;
            }
        }
    }
    if (this.onSamples !== null) /* For each track marked for data export,
       check if the next sample is there (i.e. has been downloaded) and send it */ for(i1 = 0; i1 < this.extractedTracks.length; i1++){
        var extractTrak = this.extractedTracks[i1];
        trak = extractTrak.trak;
        while(trak.nextSample < trak.samples.length && this.sampleProcessingStarted){
            $c9a1fd49277acae3$var$Log.debug("ISOFile", "Exporting on track #" + extractTrak.id + " sample #" + trak.nextSample);
            var sample = this.getSample(trak, trak.nextSample);
            if (sample) {
                trak.nextSample++;
                extractTrak.samples.push(sample);
            } else {
                this.setNextSeekPositionFromSample(trak.samples[trak.nextSample]);
                break;
            }
            if (trak.nextSample % extractTrak.nb_samples === 0 || trak.nextSample >= trak.samples.length) {
                $c9a1fd49277acae3$var$Log.debug("ISOFile", "Sending samples on track #" + extractTrak.id + " for sample " + trak.nextSample);
                if (this.onSamples) this.onSamples(extractTrak.id, extractTrak.user, extractTrak.samples);
                extractTrak.samples = [];
                if (extractTrak !== this.extractedTracks[i1]) break;
            }
        }
    }
};
/* Find and return specific boxes using recursion and early return */ $c9a1fd49277acae3$var$ISOFile.prototype.getBox = function(type) {
    var result = this.getBoxes(type, true);
    return result.length ? result[0] : null;
};
$c9a1fd49277acae3$var$ISOFile.prototype.getBoxes = function(type, returnEarly) {
    var result = [];
    $c9a1fd49277acae3$var$ISOFile._sweep.call(this, type, result, returnEarly);
    return result;
};
$c9a1fd49277acae3$var$ISOFile._sweep = function(type, result, returnEarly) {
    if (this.type && this.type == type) result.push(this);
    for(var box1 in this.boxes){
        if (result.length && returnEarly) return;
        $c9a1fd49277acae3$var$ISOFile._sweep.call(this.boxes[box1], type, result, returnEarly);
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.getTrackSamplesInfo = function(track_id) {
    var track = this.getTrackById(track_id);
    if (track) return track.samples;
    else return;
};
$c9a1fd49277acae3$var$ISOFile.prototype.getTrackSample = function(track_id, number) {
    var track = this.getTrackById(track_id);
    var sample = this.getSample(track, number);
    return sample;
};
/* Called by the application to release the resources associated to samples already forwarded to the application */ $c9a1fd49277acae3$var$ISOFile.prototype.releaseUsedSamples = function(id, sampleNum) {
    var size = 0;
    var trak = this.getTrackById(id);
    if (!trak.lastValidSample) trak.lastValidSample = 0;
    for(var i1 = trak.lastValidSample; i1 < sampleNum; i1++)size += this.releaseSample(trak, i1);
    $c9a1fd49277acae3$var$Log.info("ISOFile", "Track #" + id + " released samples up to " + sampleNum + " (released size: " + size + ", remaining: " + this.samplesDataSize + ")");
    trak.lastValidSample = sampleNum;
};
$c9a1fd49277acae3$var$ISOFile.prototype.start = function() {
    this.sampleProcessingStarted = true;
    this.processSamples(false);
};
$c9a1fd49277acae3$var$ISOFile.prototype.stop = function() {
    this.sampleProcessingStarted = false;
};
/* Called by the application to flush the remaining samples (e.g. once the download is finished or when no more samples will be added) */ $c9a1fd49277acae3$var$ISOFile.prototype.flush = function() {
    $c9a1fd49277acae3$var$Log.info("ISOFile", "Flushing remaining samples");
    this.updateSampleLists();
    this.processSamples(true);
    this.stream.cleanBuffers();
    this.stream.logBufferLevel(true);
};
/* Finds the byte offset for a given time on a given track
also returns the time of the previous rap */ $c9a1fd49277acae3$var$ISOFile.prototype.seekTrack = function(time, useRap, trak) {
    var j;
    var sample;
    var seek_offset = Infinity;
    var rap_seek_sample_num = 0;
    var seek_sample_num = 0;
    var timescale;
    if (trak.samples.length === 0) {
        $c9a1fd49277acae3$var$Log.info("ISOFile", "No sample in track, cannot seek! Using time " + $c9a1fd49277acae3$var$Log.getDurationString(0, 1) + " and offset: " + 0);
        return {
            offset: 0,
            time: 0
        };
    }
    for(j = 0; j < trak.samples.length; j++){
        sample = trak.samples[j];
        if (j === 0) {
            seek_sample_num = 0;
            timescale = sample.timescale;
        } else if (sample.cts > time * sample.timescale) {
            seek_sample_num = j - 1;
            break;
        }
        if (useRap && sample.is_sync) rap_seek_sample_num = j;
    }
    if (useRap) seek_sample_num = rap_seek_sample_num;
    time = trak.samples[seek_sample_num].cts;
    trak.nextSample = seek_sample_num;
    while(trak.samples[seek_sample_num].alreadyRead === trak.samples[seek_sample_num].size){
        // No remaining samples to look for, all are downloaded.
        if (!trak.samples[seek_sample_num + 1]) break;
        seek_sample_num++;
    }
    seek_offset = trak.samples[seek_sample_num].offset + trak.samples[seek_sample_num].alreadyRead;
    $c9a1fd49277acae3$var$Log.info("ISOFile", "Seeking to " + (useRap ? "RAP" : "") + " sample #" + trak.nextSample + " on track " + trak.tkhd.track_id + ", time " + $c9a1fd49277acae3$var$Log.getDurationString(time, timescale) + " and offset: " + seek_offset);
    return {
        offset: seek_offset,
        time: time / timescale
    };
};
$c9a1fd49277acae3$var$ISOFile.prototype.getTrackDuration = function(trak) {
    var sample;
    if (!trak.samples) return Infinity;
    sample = trak.samples[trak.samples.length - 1];
    return (sample.cts + sample.duration) / sample.timescale;
};
/* Finds the byte offset in the file corresponding to the given time or to the time of the previous RAP */ $c9a1fd49277acae3$var$ISOFile.prototype.seek = function(time, useRap) {
    var moov = this.moov;
    var trak;
    var trak_seek_info;
    var i1;
    var seek_info = {
        offset: Infinity,
        time: Infinity
    };
    if (!this.moov) throw "Cannot seek: moov not received!";
    else {
        for(i1 = 0; i1 < moov.traks.length; i1++){
            trak = moov.traks[i1];
            if (time > this.getTrackDuration(trak)) continue;
            trak_seek_info = this.seekTrack(time, useRap, trak);
            if (trak_seek_info.offset < seek_info.offset) seek_info.offset = trak_seek_info.offset;
            if (trak_seek_info.time < seek_info.time) seek_info.time = trak_seek_info.time;
        }
        $c9a1fd49277acae3$var$Log.info("ISOFile", "Seeking at time " + $c9a1fd49277acae3$var$Log.getDurationString(seek_info.time, 1) + " needs a buffer with a fileStart position of " + seek_info.offset);
        if (seek_info.offset === Infinity) /* No sample info, in all tracks, cannot seek */ seek_info = {
            offset: this.nextParsePosition,
            time: 0
        };
        else /* check if the seek position is already in some buffer and
         in that case return the end of that buffer (or of the last contiguous buffer) */ /* TODO: Should wait until append operations are done */ seek_info.offset = this.stream.getEndFilePositionAfter(seek_info.offset);
        $c9a1fd49277acae3$var$Log.info("ISOFile", "Adjusted seek position (after checking data already in buffer): " + seek_info.offset);
        return seek_info;
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.equal = function(b) {
    var box_index = 0;
    while(box_index < this.boxes.length && box_index < b.boxes.length){
        var a_box = this.boxes[box_index];
        var b_box = b.boxes[box_index];
        if (!$c9a1fd49277acae3$var$BoxParser.boxEqual(a_box, b_box)) return false;
        box_index++;
    }
    return true;
};
$c9a1fd49277acae3$export$b0b6eee45040a3ad = $c9a1fd49277acae3$var$ISOFile;
// file:src/isofile-advanced-parsing.js
/* position in the current buffer of the beginning of the last box parsed */ $c9a1fd49277acae3$var$ISOFile.prototype.lastBoxStartPosition = 0;
/* indicator if the parsing is stuck in the middle of an mdat box */ $c9a1fd49277acae3$var$ISOFile.prototype.parsingMdat = null;
/* next file position that the parser needs:
- 0 until the first buffer (i.e. fileStart ===0) has been received 
- otherwise, the next box start until the moov box has been parsed
- otherwise, the position of the next sample to fetch
*/ $c9a1fd49277acae3$var$ISOFile.prototype.nextParsePosition = 0;
/* keep mdat data */ $c9a1fd49277acae3$var$ISOFile.prototype.discardMdatData = false;
$c9a1fd49277acae3$var$ISOFile.prototype.processIncompleteBox = function(ret1) {
    var box1;
    var merged;
    var found;
    /* we did not have enough bytes in the current buffer to parse the entire box */ if (ret1.type === "mdat") {
        /* we had enough bytes to get its type and size and it's an 'mdat' */ /* special handling for mdat boxes, since we don't actually need to parse it linearly 
       we create the box */ box1 = new $c9a1fd49277acae3$var$BoxParser[ret1.type + "Box"](ret1.size);
        this.parsingMdat = box1;
        this.boxes.push(box1);
        this.mdats.push(box1);
        box1.start = ret1.start;
        box1.hdr_size = ret1.hdr_size;
        this.stream.addUsedBytes(box1.hdr_size);
        /* indicate that the parsing should start from the end of the box */ this.lastBoxStartPosition = box1.start + box1.size;
        /* let's see if we have the end of the box in the other buffers */ found = this.stream.seek(box1.start + box1.size, false, this.discardMdatData);
        if (found) {
            /* found the end of the box */ this.parsingMdat = null;
            /* let's see if we can parse more in this buffer */ return true;
        } else {
            /* 'mdat' end not found in the existing buffers */ /* determine the next position in the file to start parsing from */ if (!this.moovStartFound) /* moov not find yet, 
               the file probably has 'mdat' at the beginning, and 'moov' at the end, 
               indicate that the downloader should not try to download those bytes now */ this.nextParsePosition = box1.start + box1.size;
            else /* we have the start of the moov box, 
               the next bytes should try to complete the current 'mdat' */ this.nextParsePosition = this.stream.findEndContiguousBuf();
            /* not much we can do, wait for more buffers to arrive */ return false;
        }
    } else {
        /* box is incomplete, we may not even know its type */ if (ret1.type === "moov") {
            /* the incomplete box is a 'moov' box */ this.moovStartFound = true;
            if (this.mdats.length === 0) this.isProgressive = true;
        }
        /* either it's not an mdat box (and we need to parse it, we cannot skip it)
       (TODO: we could skip 'free' boxes ...)
           or we did not have enough data to parse the type and size of the box, 
       we try to concatenate the current buffer with the next buffer to restart parsing */ merged = this.stream.mergeNextBuffer ? this.stream.mergeNextBuffer() : false;
        if (merged) {
            /* The next buffer was contiguous, the merging succeeded,
           we can now continue parsing, 
           the next best position to parse is at the end of this new buffer */ this.nextParsePosition = this.stream.getEndPosition();
            return true;
        } else {
            /* we cannot concatenate existing buffers because they are not contiguous or because there is no additional buffer */ /* The next best position to parse is still at the end of this old buffer */ if (!ret1.type) /* There were not enough bytes in the buffer to parse the box type and length,
               the next fetch should retrieve those missing bytes, i.e. the next bytes after this buffer */ this.nextParsePosition = this.stream.getEndPosition();
            else /* we had enough bytes to parse size and type of the incomplete box
               if we haven't found yet the moov box, skip this one and try the next one 
               if we have found the moov box, let's continue linear parsing */ if (this.moovStartFound) this.nextParsePosition = this.stream.getEndPosition();
            else this.nextParsePosition = this.stream.getPosition() + ret1.size;
            return false;
        }
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.hasIncompleteMdat = function() {
    return this.parsingMdat !== null;
};
$c9a1fd49277acae3$var$ISOFile.prototype.processIncompleteMdat = function() {
    var box1;
    var found;
    /* we are in the parsing of an incomplete mdat box */ box1 = this.parsingMdat;
    found = this.stream.seek(box1.start + box1.size, false, this.discardMdatData);
    if (found) {
        $c9a1fd49277acae3$var$Log.debug("ISOFile", "Found 'mdat' end in buffered data");
        /* the end of the mdat has been found */ this.parsingMdat = null;
        /* we can parse more in this buffer */ return true;
    } else {
        /* we don't have the end of this mdat yet, 
       indicate that the next byte to fetch is the end of the buffers we have so far, 
       return and wait for more buffer to come */ this.nextParsePosition = this.stream.findEndContiguousBuf();
        return false;
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.restoreParsePosition = function() {
    /* Reposition at the start position of the previous box not entirely parsed */ return this.stream.seek(this.lastBoxStartPosition, true, this.discardMdatData);
};
$c9a1fd49277acae3$var$ISOFile.prototype.saveParsePosition = function() {
    /* remember the position of the box start in case we need to roll back (if the box is incomplete) */ this.lastBoxStartPosition = this.stream.getPosition();
};
$c9a1fd49277acae3$var$ISOFile.prototype.updateUsedBytes = function(box1, ret1) {
    if (this.stream.addUsedBytes) {
        if (box1.type === "mdat") {
            /* for an mdat box, only its header is considered used, other bytes will be used when sample data is requested */ this.stream.addUsedBytes(box1.hdr_size);
            if (this.discardMdatData) this.stream.addUsedBytes(box1.size - box1.hdr_size);
        } else /* for all other boxes, the entire box data is considered used */ this.stream.addUsedBytes(box1.size);
    }
};
// file:src/isofile-advanced-creation.js
$c9a1fd49277acae3$var$ISOFile.prototype.add = $c9a1fd49277acae3$var$BoxParser.Box.prototype.add;
$c9a1fd49277acae3$var$ISOFile.prototype.addBox = $c9a1fd49277acae3$var$BoxParser.Box.prototype.addBox;
$c9a1fd49277acae3$var$ISOFile.prototype.init = function(_options) {
    var options = _options || {};
    var ftyp = this.add("ftyp").set("major_brand", options.brands && options.brands[0] || "iso4").set("minor_version", 0).set("compatible_brands", options.brands || [
        "iso4"
    ]);
    var moov = this.add("moov");
    moov.add("mvhd").set("timescale", options.timescale || 600).set("rate", options.rate || 65536).set("creation_time", 0).set("modification_time", 0).set("duration", options.duration || 0).set("volume", options.width ? 0 : 0x0100).set("matrix", [
        65536,
        0,
        0,
        0,
        65536,
        0,
        0,
        0,
        0x40000000
    ]).set("next_track_id", 1);
    moov.add("mvex");
    return this;
};
$c9a1fd49277acae3$var$ISOFile.prototype.addTrack = function(_options) {
    if (!this.moov) this.init(_options);
    var options = _options || {};
    options.width = options.width || 320;
    options.height = options.height || 320;
    options.id = options.id || this.moov.mvhd.next_track_id;
    options.type = options.type || "avc1";
    var trak = this.moov.add("trak");
    this.moov.mvhd.next_track_id = options.id + 1;
    trak.add("tkhd").set("flags", $c9a1fd49277acae3$var$BoxParser.TKHD_FLAG_ENABLED | $c9a1fd49277acae3$var$BoxParser.TKHD_FLAG_IN_MOVIE | $c9a1fd49277acae3$var$BoxParser.TKHD_FLAG_IN_PREVIEW).set("creation_time", 0).set("modification_time", 0).set("track_id", options.id).set("duration", options.duration || 0).set("layer", options.layer || 0).set("alternate_group", 0).set("volume", 1).set("matrix", [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]).set("width", options.width << 16).set("height", options.height << 16);
    var mdia = trak.add("mdia");
    mdia.add("mdhd").set("creation_time", 0).set("modification_time", 0).set("timescale", options.timescale || 1).set("duration", options.media_duration || 0).set("language", options.language || "und");
    mdia.add("hdlr").set("handler", options.hdlr || "vide").set("name", options.name || "Track created with MP4Box.js");
    mdia.add("elng").set("extended_language", options.language || "fr-FR");
    var minf = mdia.add("minf");
    if ($c9a1fd49277acae3$var$BoxParser[options.type + "SampleEntry"] === undefined) return;
    var sample_description_entry = new $c9a1fd49277acae3$var$BoxParser[options.type + "SampleEntry"]();
    sample_description_entry.data_reference_index = 1;
    var media_type = "";
    for(var mediaType in $c9a1fd49277acae3$var$BoxParser.sampleEntryCodes){
        var codes = $c9a1fd49277acae3$var$BoxParser.sampleEntryCodes[mediaType];
        for(var i1 = 0; i1 < codes.length; i1++)if (codes.indexOf(options.type) > -1) {
            media_type = mediaType;
            break;
        }
    }
    switch(media_type){
        case "Visual":
            minf.add("vmhd").set("graphicsmode", 0).set("opcolor", [
                0,
                0,
                0
            ]);
            sample_description_entry.set("width", options.width).set("height", options.height).set("horizresolution", 4718592).set("vertresolution", 4718592).set("frame_count", 1).set("compressorname", options.type + " Compressor").set("depth", 0x18);
            if (options.avcDecoderConfigRecord) {
                var avcC = new $c9a1fd49277acae3$var$BoxParser.avcCBox();
                avcC.parse(new $c9a1fd49277acae3$var$MP4BoxStream(options.avcDecoderConfigRecord));
                sample_description_entry.addBox(avcC);
            } else if (options.hevcDecoderConfigRecord) {
                var hvcC = new $c9a1fd49277acae3$var$BoxParser.hvcCBox();
                hvcC.parse(new $c9a1fd49277acae3$var$MP4BoxStream(options.hevcDecoderConfigRecord));
                sample_description_entry.addBox(hvcC);
            }
            break;
        case "Audio":
            minf.add("smhd").set("balance", options.balance || 0);
            sample_description_entry.set("channel_count", options.channel_count || 2).set("samplesize", options.samplesize || 16).set("samplerate", options.samplerate || 65536);
            break;
        case "Hint":
            minf.add("hmhd"); // TODO: add properties
            break;
        case "Subtitle":
            minf.add("sthd");
            switch(options.type){
                case "stpp":
                    sample_description_entry.set("namespace", options.namespace || "nonamespace").set("schema_location", options.schema_location || "").set("auxiliary_mime_types", options.auxiliary_mime_types || "");
                    break;
            }
            break;
        case "Metadata":
            minf.add("nmhd");
            break;
        case "System":
            minf.add("nmhd");
            break;
        default:
            minf.add("nmhd");
            break;
    }
    if (options.description) sample_description_entry.addBox(options.description);
    if (options.description_boxes) options.description_boxes.forEach(function(b) {
        sample_description_entry.addBox(b);
    });
    minf.add("dinf").add("dref").addEntry(new $c9a1fd49277acae3$var$BoxParser["url Box"]().set("flags", 0x1));
    var stbl = minf.add("stbl");
    stbl.add("stsd").addEntry(sample_description_entry);
    stbl.add("stts").set("sample_counts", []).set("sample_deltas", []);
    stbl.add("stsc").set("first_chunk", []).set("samples_per_chunk", []).set("sample_description_index", []);
    stbl.add("stco").set("chunk_offsets", []);
    stbl.add("stsz").set("sample_sizes", []);
    this.moov.mvex.add("trex").set("track_id", options.id).set("default_sample_description_index", options.default_sample_description_index || 1).set("default_sample_duration", options.default_sample_duration || 0).set("default_sample_size", options.default_sample_size || 0).set("default_sample_flags", options.default_sample_flags || 0);
    this.buildTrakSampleLists(trak);
    return options.id;
};
$c9a1fd49277acae3$var$BoxParser.Box.prototype.computeSize = function(stream_) {
    var stream = stream_ || new $c9a1fd49277acae3$var$DataStream();
    stream.endianness = $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN;
    this.write(stream);
};
$c9a1fd49277acae3$var$ISOFile.prototype.addSample = function(track_id, data, _options) {
    var options = _options || {};
    var sample = {};
    var trak = this.getTrackById(track_id);
    if (trak === null) return;
    sample.number = trak.samples.length;
    sample.track_id = trak.tkhd.track_id;
    sample.timescale = trak.mdia.mdhd.timescale;
    sample.description_index = options.sample_description_index ? options.sample_description_index - 1 : 0;
    sample.description = trak.mdia.minf.stbl.stsd.entries[sample.description_index];
    sample.data = data;
    sample.size = data.byteLength;
    sample.alreadyRead = sample.size;
    sample.duration = options.duration || 1;
    sample.cts = options.cts || 0;
    sample.dts = options.dts || 0;
    sample.is_sync = options.is_sync || false;
    sample.is_leading = options.is_leading || 0;
    sample.depends_on = options.depends_on || 0;
    sample.is_depended_on = options.is_depended_on || 0;
    sample.has_redundancy = options.has_redundancy || 0;
    sample.degradation_priority = options.degradation_priority || 0;
    sample.offset = 0;
    sample.subsamples = options.subsamples;
    trak.samples.push(sample);
    trak.samples_size += sample.size;
    trak.samples_duration += sample.duration;
    if (trak.first_dts === undefined) trak.first_dts = options.dts;
    this.processSamples();
    var moof = this.createSingleSampleMoof(sample);
    this.addBox(moof);
    moof.computeSize();
    /* adjusting the data_offset now that the moof size is known*/ moof.trafs[0].truns[0].data_offset = moof.size + 8; //8 is mdat header
    this.add("mdat").data = new Uint8Array(data);
    return sample;
};
$c9a1fd49277acae3$var$ISOFile.prototype.createSingleSampleMoof = function(sample) {
    var sample_flags = 0;
    if (sample.is_sync) sample_flags = 33554432; // sample_depends_on_none (I picture)
    else sample_flags = 65536; // non-sync
    var moof = new $c9a1fd49277acae3$var$BoxParser.moofBox();
    moof.add("mfhd").set("sequence_number", this.nextMoofNumber);
    this.nextMoofNumber++;
    var traf = moof.add("traf");
    var trak = this.getTrackById(sample.track_id);
    traf.add("tfhd").set("track_id", sample.track_id).set("flags", $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_DEFAULT_BASE_IS_MOOF);
    traf.add("tfdt").set("baseMediaDecodeTime", sample.dts - (trak.first_dts || 0));
    traf.add("trun").set("flags", $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DATA_OFFSET | $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DURATION | $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_SIZE | $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FLAGS | $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_CTS_OFFSET).set("data_offset", 0).set("first_sample_flags", 0).set("sample_count", 1).set("sample_duration", [
        sample.duration
    ]).set("sample_size", [
        sample.size
    ]).set("sample_flags", [
        sample_flags
    ]).set("sample_composition_time_offset", [
        sample.cts - sample.dts
    ]);
    return moof;
};
// file:src/isofile-sample-processing.js
/* Index of the last moof box received */ $c9a1fd49277acae3$var$ISOFile.prototype.lastMoofIndex = 0;
/* size of the buffers allocated for samples */ $c9a1fd49277acae3$var$ISOFile.prototype.samplesDataSize = 0;
/* Resets all sample tables */ $c9a1fd49277acae3$var$ISOFile.prototype.resetTables = function() {
    var i1;
    var trak, stco, stsc, stsz, stts, ctts, stss;
    this.initial_duration = this.moov.mvhd.duration;
    this.moov.mvhd.duration = 0;
    for(i1 = 0; i1 < this.moov.traks.length; i1++){
        trak = this.moov.traks[i1];
        trak.tkhd.duration = 0;
        trak.mdia.mdhd.duration = 0;
        stco = trak.mdia.minf.stbl.stco || trak.mdia.minf.stbl.co64;
        stco.chunk_offsets = [];
        stsc = trak.mdia.minf.stbl.stsc;
        stsc.first_chunk = [];
        stsc.samples_per_chunk = [];
        stsc.sample_description_index = [];
        stsz = trak.mdia.minf.stbl.stsz || trak.mdia.minf.stbl.stz2;
        stsz.sample_sizes = [];
        stts = trak.mdia.minf.stbl.stts;
        stts.sample_counts = [];
        stts.sample_deltas = [];
        ctts = trak.mdia.minf.stbl.ctts;
        if (ctts) {
            ctts.sample_counts = [];
            ctts.sample_offsets = [];
        }
        stss = trak.mdia.minf.stbl.stss;
        var k = trak.mdia.minf.stbl.boxes.indexOf(stss);
        if (k != -1) trak.mdia.minf.stbl.boxes[k] = null;
    }
};
$c9a1fd49277acae3$var$ISOFile.initSampleGroups = function(trak, traf, sbgps, trak_sgpds, traf_sgpds) {
    var l;
    var k;
    var sample_groups_info;
    var sample_group_info;
    var sample_group_key;
    function SampleGroupInfo(_type, _parameter, _sbgp) {
        this.grouping_type = _type;
        this.grouping_type_parameter = _parameter;
        this.sbgp = _sbgp;
        this.last_sample_in_run = -1;
        this.entry_index = -1;
    }
    if (traf) traf.sample_groups_info = [];
    if (!trak.sample_groups_info) trak.sample_groups_info = [];
    for(k = 0; k < sbgps.length; k++){
        sample_group_key = sbgps[k].grouping_type + "/" + sbgps[k].grouping_type_parameter;
        sample_group_info = new SampleGroupInfo(sbgps[k].grouping_type, sbgps[k].grouping_type_parameter, sbgps[k]);
        if (traf) traf.sample_groups_info[sample_group_key] = sample_group_info;
        if (!trak.sample_groups_info[sample_group_key]) trak.sample_groups_info[sample_group_key] = sample_group_info;
        for(l = 0; l < trak_sgpds.length; l++)if (trak_sgpds[l].grouping_type === sbgps[k].grouping_type) {
            sample_group_info.description = trak_sgpds[l];
            sample_group_info.description.used = true;
        }
        if (traf_sgpds) {
            for(l = 0; l < traf_sgpds.length; l++)if (traf_sgpds[l].grouping_type === sbgps[k].grouping_type) {
                sample_group_info.fragment_description = traf_sgpds[l];
                sample_group_info.fragment_description.used = true;
                sample_group_info.is_fragment = true;
            }
        }
    }
    if (!traf) {
        for(k = 0; k < trak_sgpds.length; k++)if (!trak_sgpds[k].used && trak_sgpds[k].version >= 2) {
            sample_group_key = trak_sgpds[k].grouping_type + "/0";
            sample_group_info = new SampleGroupInfo(trak_sgpds[k].grouping_type, 0);
            if (!trak.sample_groups_info[sample_group_key]) trak.sample_groups_info[sample_group_key] = sample_group_info;
        }
    } else if (traf_sgpds) {
        for(k = 0; k < traf_sgpds.length; k++)if (!traf_sgpds[k].used && traf_sgpds[k].version >= 2) {
            sample_group_key = traf_sgpds[k].grouping_type + "/0";
            sample_group_info = new SampleGroupInfo(traf_sgpds[k].grouping_type, 0);
            sample_group_info.is_fragment = true;
            if (!traf.sample_groups_info[sample_group_key]) traf.sample_groups_info[sample_group_key] = sample_group_info;
        }
    }
};
$c9a1fd49277acae3$var$ISOFile.setSampleGroupProperties = function(trak, sample, sample_number, sample_groups_info) {
    var k;
    var index;
    sample.sample_groups = [];
    for(k in sample_groups_info){
        sample.sample_groups[k] = {};
        sample.sample_groups[k].grouping_type = sample_groups_info[k].grouping_type;
        sample.sample_groups[k].grouping_type_parameter = sample_groups_info[k].grouping_type_parameter;
        if (sample_number >= sample_groups_info[k].last_sample_in_run) {
            if (sample_groups_info[k].last_sample_in_run < 0) sample_groups_info[k].last_sample_in_run = 0;
            sample_groups_info[k].entry_index++;
            if (sample_groups_info[k].entry_index <= sample_groups_info[k].sbgp.entries.length - 1) sample_groups_info[k].last_sample_in_run += sample_groups_info[k].sbgp.entries[sample_groups_info[k].entry_index].sample_count;
        }
        if (sample_groups_info[k].entry_index <= sample_groups_info[k].sbgp.entries.length - 1) sample.sample_groups[k].group_description_index = sample_groups_info[k].sbgp.entries[sample_groups_info[k].entry_index].group_description_index;
        else sample.sample_groups[k].group_description_index = -1; // special value for not defined
        if (sample.sample_groups[k].group_description_index !== 0) {
            var description;
            if (sample_groups_info[k].fragment_description) description = sample_groups_info[k].fragment_description;
            else description = sample_groups_info[k].description;
            if (sample.sample_groups[k].group_description_index > 0) {
                if (sample.sample_groups[k].group_description_index > 65535) index = (sample.sample_groups[k].group_description_index >> 16) - 1;
                else index = sample.sample_groups[k].group_description_index - 1;
                if (description && index >= 0) sample.sample_groups[k].description = description.entries[index];
            } else {
                if (description && description.version >= 2) {
                    if (description.default_group_description_index > 0) sample.sample_groups[k].description = description.entries[description.default_group_description_index - 1];
                }
            }
        }
    }
};
$c9a1fd49277acae3$var$ISOFile.process_sdtp = function(sdtp, sample, number) {
    if (!sample) return;
    if (sdtp) {
        sample.is_leading = sdtp.is_leading[number];
        sample.depends_on = sdtp.sample_depends_on[number];
        sample.is_depended_on = sdtp.sample_is_depended_on[number];
        sample.has_redundancy = sdtp.sample_has_redundancy[number];
    } else {
        sample.is_leading = 0;
        sample.depends_on = 0;
        sample.is_depended_on = 0;
        sample.has_redundancy = 0;
    }
};
/* Build initial sample list from  sample tables */ $c9a1fd49277acae3$var$ISOFile.prototype.buildSampleLists = function() {
    var i1;
    var trak;
    for(i1 = 0; i1 < this.moov.traks.length; i1++){
        trak = this.moov.traks[i1];
        this.buildTrakSampleLists(trak);
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.buildTrakSampleLists = function(trak) {
    var j, k;
    var stco, stsc, stsz, stts, ctts, stss, stsd, subs, sbgps, sgpds, stdp;
    var chunk_run_index, chunk_index, last_chunk_in_run, offset_in_chunk, last_sample_in_chunk;
    var last_sample_in_stts_run, stts_run_index, last_sample_in_ctts_run, ctts_run_index, last_stss_index, last_subs_index, subs_entry_index, last_subs_sample_index;
    trak.samples = [];
    trak.samples_duration = 0;
    trak.samples_size = 0;
    stco = trak.mdia.minf.stbl.stco || trak.mdia.minf.stbl.co64;
    stsc = trak.mdia.minf.stbl.stsc;
    stsz = trak.mdia.minf.stbl.stsz || trak.mdia.minf.stbl.stz2;
    stts = trak.mdia.minf.stbl.stts;
    ctts = trak.mdia.minf.stbl.ctts;
    stss = trak.mdia.minf.stbl.stss;
    stsd = trak.mdia.minf.stbl.stsd;
    subs = trak.mdia.minf.stbl.subs;
    stdp = trak.mdia.minf.stbl.stdp;
    sbgps = trak.mdia.minf.stbl.sbgps;
    sgpds = trak.mdia.minf.stbl.sgpds;
    last_sample_in_stts_run = -1;
    stts_run_index = -1;
    last_sample_in_ctts_run = -1;
    ctts_run_index = -1;
    last_stss_index = 0;
    subs_entry_index = 0;
    last_subs_sample_index = 0;
    $c9a1fd49277acae3$var$ISOFile.initSampleGroups(trak, null, sbgps, sgpds);
    if (typeof stsz === "undefined") return;
    /* we build the samples one by one and compute their properties */ for(j = 0; j < stsz.sample_sizes.length; j++){
        var sample = {};
        sample.number = j;
        sample.track_id = trak.tkhd.track_id;
        sample.timescale = trak.mdia.mdhd.timescale;
        sample.alreadyRead = 0;
        trak.samples[j] = sample;
        /* size can be known directly */ sample.size = stsz.sample_sizes[j];
        trak.samples_size += sample.size;
        /* computing chunk-based properties (offset, sample description index)*/ if (j === 0) {
            chunk_index = 1; /* the first sample is in the first chunk (chunk indexes are 1-based) */ 
            chunk_run_index = 0; /* the first chunk is the first entry in the first_chunk table */ 
            sample.chunk_index = chunk_index;
            sample.chunk_run_index = chunk_run_index;
            last_sample_in_chunk = stsc.samples_per_chunk[chunk_run_index];
            offset_in_chunk = 0;
            /* Is there another entry in the first_chunk table ? */ if (chunk_run_index + 1 < stsc.first_chunk.length) /* The last chunk in the run is the chunk before the next first chunk */ last_chunk_in_run = stsc.first_chunk[chunk_run_index + 1] - 1;
            else /* There is only one entry in the table, it is valid for all future chunks*/ last_chunk_in_run = Infinity;
        } else if (j < last_sample_in_chunk) {
            /* the sample is still in the current chunk */ sample.chunk_index = chunk_index;
            sample.chunk_run_index = chunk_run_index;
        } else {
            /* the sample is in the next chunk */ chunk_index++;
            sample.chunk_index = chunk_index;
            /* reset the accumulated offset in the chunk */ offset_in_chunk = 0;
            if (chunk_index <= last_chunk_in_run) ;
            else {
                chunk_run_index++;
                /* Is there another entry in the first_chunk table ? */ if (chunk_run_index + 1 < stsc.first_chunk.length) /* The last chunk in the run is the chunk before the next first chunk */ last_chunk_in_run = stsc.first_chunk[chunk_run_index + 1] - 1;
                else /* There is only one entry in the table, it is valid for all future chunks*/ last_chunk_in_run = Infinity;
            }
            sample.chunk_run_index = chunk_run_index;
            last_sample_in_chunk += stsc.samples_per_chunk[chunk_run_index];
        }
        sample.description_index = stsc.sample_description_index[sample.chunk_run_index] - 1;
        sample.description = stsd.entries[sample.description_index];
        sample.offset = stco.chunk_offsets[sample.chunk_index - 1] + offset_in_chunk; /* chunk indexes are 1-based */ 
        offset_in_chunk += sample.size;
        /* setting dts, cts, duration and rap flags */ if (j > last_sample_in_stts_run) {
            stts_run_index++;
            if (last_sample_in_stts_run < 0) last_sample_in_stts_run = 0;
            last_sample_in_stts_run += stts.sample_counts[stts_run_index];
        }
        if (j > 0) {
            trak.samples[j - 1].duration = stts.sample_deltas[stts_run_index];
            trak.samples_duration += trak.samples[j - 1].duration;
            sample.dts = trak.samples[j - 1].dts + trak.samples[j - 1].duration;
        } else sample.dts = 0;
        if (ctts) {
            if (j >= last_sample_in_ctts_run) {
                ctts_run_index++;
                if (last_sample_in_ctts_run < 0) last_sample_in_ctts_run = 0;
                last_sample_in_ctts_run += ctts.sample_counts[ctts_run_index];
            }
            sample.cts = trak.samples[j].dts + ctts.sample_offsets[ctts_run_index];
        } else sample.cts = sample.dts;
        if (stss) {
            if (j == stss.sample_numbers[last_stss_index] - 1) {
                sample.is_sync = true;
                last_stss_index++;
            } else {
                sample.is_sync = false;
                sample.degradation_priority = 0;
            }
            if (subs) {
                if (subs.entries[subs_entry_index].sample_delta + last_subs_sample_index == j + 1) {
                    sample.subsamples = subs.entries[subs_entry_index].subsamples;
                    last_subs_sample_index += subs.entries[subs_entry_index].sample_delta;
                    subs_entry_index++;
                }
            }
        } else sample.is_sync = true;
        $c9a1fd49277acae3$var$ISOFile.process_sdtp(trak.mdia.minf.stbl.sdtp, sample, sample.number);
        if (stdp) sample.degradation_priority = stdp.priority[j];
        else sample.degradation_priority = 0;
        if (subs) {
            if (subs.entries[subs_entry_index].sample_delta + last_subs_sample_index == j) {
                sample.subsamples = subs.entries[subs_entry_index].subsamples;
                last_subs_sample_index += subs.entries[subs_entry_index].sample_delta;
            }
        }
        if (sbgps.length > 0 || sgpds.length > 0) $c9a1fd49277acae3$var$ISOFile.setSampleGroupProperties(trak, sample, j, trak.sample_groups_info);
    }
    if (j > 0) {
        trak.samples[j - 1].duration = Math.max(trak.mdia.mdhd.duration - trak.samples[j - 1].dts, 0);
        trak.samples_duration += trak.samples[j - 1].duration;
    }
};
/* Update sample list when new 'moof' boxes are received */ $c9a1fd49277acae3$var$ISOFile.prototype.updateSampleLists = function() {
    var i1, j, k;
    var default_sample_description_index, default_sample_duration, default_sample_size, default_sample_flags;
    var last_run_position;
    var box1, moof, traf, trak, trex;
    var sample;
    var sample_flags;
    if (this.moov === undefined) return;
    /* if the input file is fragmented and fetched in multiple downloads, we need to update the list of samples */ while(this.lastMoofIndex < this.moofs.length){
        box1 = this.moofs[this.lastMoofIndex];
        this.lastMoofIndex++;
        if (box1.type == "moof") {
            moof = box1;
            for(i1 = 0; i1 < moof.trafs.length; i1++){
                traf = moof.trafs[i1];
                trak = this.getTrackById(traf.tfhd.track_id);
                trex = this.getTrexById(traf.tfhd.track_id);
                if (traf.tfhd.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_DESC) default_sample_description_index = traf.tfhd.default_sample_description_index;
                else default_sample_description_index = trex ? trex.default_sample_description_index : 1;
                if (traf.tfhd.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_DUR) default_sample_duration = traf.tfhd.default_sample_duration;
                else default_sample_duration = trex ? trex.default_sample_duration : 0;
                if (traf.tfhd.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_SIZE) default_sample_size = traf.tfhd.default_sample_size;
                else default_sample_size = trex ? trex.default_sample_size : 0;
                if (traf.tfhd.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_SAMPLE_FLAGS) default_sample_flags = traf.tfhd.default_sample_flags;
                else default_sample_flags = trex ? trex.default_sample_flags : 0;
                traf.sample_number = 0;
                /* process sample groups */ if (traf.sbgps.length > 0) $c9a1fd49277acae3$var$ISOFile.initSampleGroups(trak, traf, traf.sbgps, trak.mdia.minf.stbl.sgpds, traf.sgpds);
                for(j = 0; j < traf.truns.length; j++){
                    var trun = traf.truns[j];
                    for(k = 0; k < trun.sample_count; k++){
                        sample = {};
                        sample.moof_number = this.lastMoofIndex;
                        sample.number_in_traf = traf.sample_number;
                        traf.sample_number++;
                        sample.number = trak.samples.length;
                        traf.first_sample_index = trak.samples.length;
                        trak.samples.push(sample);
                        sample.track_id = trak.tkhd.track_id;
                        sample.timescale = trak.mdia.mdhd.timescale;
                        sample.description_index = default_sample_description_index - 1;
                        sample.description = trak.mdia.minf.stbl.stsd.entries[sample.description_index];
                        sample.size = default_sample_size;
                        if (trun.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_SIZE) sample.size = trun.sample_size[k];
                        trak.samples_size += sample.size;
                        sample.duration = default_sample_duration;
                        if (trun.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DURATION) sample.duration = trun.sample_duration[k];
                        trak.samples_duration += sample.duration;
                        if (trak.first_traf_merged || k > 0) sample.dts = trak.samples[trak.samples.length - 2].dts + trak.samples[trak.samples.length - 2].duration;
                        else {
                            if (traf.tfdt) sample.dts = traf.tfdt.baseMediaDecodeTime;
                            else sample.dts = 0;
                            trak.first_traf_merged = true;
                        }
                        sample.cts = sample.dts;
                        if (trun.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_CTS_OFFSET) sample.cts = sample.dts + trun.sample_composition_time_offset[k];
                        sample_flags = default_sample_flags;
                        if (trun.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FLAGS) sample_flags = trun.sample_flags[k];
                        else if (k === 0 && trun.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_FIRST_FLAG) sample_flags = trun.first_sample_flags;
                        sample.is_sync = sample_flags >> 16 & 0x1 ? false : true;
                        sample.is_leading = sample_flags >> 26 & 0x3;
                        sample.depends_on = sample_flags >> 24 & 0x3;
                        sample.is_depended_on = sample_flags >> 22 & 0x3;
                        sample.has_redundancy = sample_flags >> 20 & 0x3;
                        sample.degradation_priority = sample_flags & 0xFFFF;
                        //ISOFile.process_sdtp(traf.sdtp, sample, sample.number_in_traf);
                        var bdop = traf.tfhd.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_BASE_DATA_OFFSET ? true : false;
                        var dbim = traf.tfhd.flags & $c9a1fd49277acae3$var$BoxParser.TFHD_FLAG_DEFAULT_BASE_IS_MOOF ? true : false;
                        var dop = trun.flags & $c9a1fd49277acae3$var$BoxParser.TRUN_FLAGS_DATA_OFFSET ? true : false;
                        var bdo = 0;
                        if (!bdop) {
                            if (!dbim) {
                                if (j === 0) bdo = moof.start; // the position of the first byte of the enclosing Movie Fragment Box
                                else bdo = last_run_position; // end of the data defined by the preceding *track* (irrespective of the track id) fragment in the moof
                            } else bdo = moof.start;
                        } else bdo = traf.tfhd.base_data_offset;
                        if (j === 0 && k === 0) {
                            if (dop) sample.offset = bdo + trun.data_offset; // If the data-offset is present, it is relative to the base-data-offset established in the track fragment header
                            else sample.offset = bdo; // the data for this run starts the base-data-offset defined by the track fragment header
                        } else sample.offset = last_run_position; // this run starts immediately after the data of the previous run
                        last_run_position = sample.offset + sample.size;
                        if (traf.sbgps.length > 0 || traf.sgpds.length > 0 || trak.mdia.minf.stbl.sbgps.length > 0 || trak.mdia.minf.stbl.sgpds.length > 0) $c9a1fd49277acae3$var$ISOFile.setSampleGroupProperties(trak, sample, sample.number_in_traf, traf.sample_groups_info);
                    }
                }
                if (traf.subs) {
                    trak.has_fragment_subsamples = true;
                    var sample_index = traf.first_sample_index;
                    for(j = 0; j < traf.subs.entries.length; j++){
                        sample_index += traf.subs.entries[j].sample_delta;
                        sample = trak.samples[sample_index - 1];
                        sample.subsamples = traf.subs.entries[j].subsamples;
                    }
                }
            }
        }
    }
};
/* Try to get sample data for a given sample:
returns null if not found
returns the same sample if already requested
*/ $c9a1fd49277acae3$var$ISOFile.prototype.getSample = function(trak, sampleNum) {
    var buffer;
    var sample = trak.samples[sampleNum];
    if (!this.moov) return null;
    if (!sample.data) {
        /* Not yet fetched */ sample.data = new Uint8Array(sample.size);
        sample.alreadyRead = 0;
        this.samplesDataSize += sample.size;
        $c9a1fd49277acae3$var$Log.debug("ISOFile", "Allocating sample #" + sampleNum + " on track #" + trak.tkhd.track_id + " of size " + sample.size + " (total: " + this.samplesDataSize + ")");
    } else if (sample.alreadyRead == sample.size) /* Already fetched entirely */ return sample;
    /* The sample has only been partially fetched, we need to check in all buffers */ while(true){
        var index = this.stream.findPosition(true, sample.offset + sample.alreadyRead, false);
        if (index > -1) {
            buffer = this.stream.buffers[index];
            var lengthAfterStart = buffer.byteLength - (sample.offset + sample.alreadyRead - buffer.fileStart);
            if (sample.size - sample.alreadyRead <= lengthAfterStart) {
                /* the (rest of the) sample is entirely contained in this buffer */ $c9a1fd49277acae3$var$Log.debug("ISOFile", "Getting sample #" + sampleNum + " data (alreadyRead: " + sample.alreadyRead + " offset: " + (sample.offset + sample.alreadyRead - buffer.fileStart) + " read size: " + (sample.size - sample.alreadyRead) + " full size: " + sample.size + ")");
                $c9a1fd49277acae3$var$DataStream.memcpy(sample.data.buffer, sample.alreadyRead, buffer, sample.offset + sample.alreadyRead - buffer.fileStart, sample.size - sample.alreadyRead);
                /* update the number of bytes used in this buffer and check if it needs to be removed */ buffer.usedBytes += sample.size - sample.alreadyRead;
                this.stream.logBufferLevel();
                sample.alreadyRead = sample.size;
                return sample;
            } else {
                /* the sample does not end in this buffer */ if (lengthAfterStart === 0) return null;
                $c9a1fd49277acae3$var$Log.debug("ISOFile", "Getting sample #" + sampleNum + " partial data (alreadyRead: " + sample.alreadyRead + " offset: " + (sample.offset + sample.alreadyRead - buffer.fileStart) + " read size: " + lengthAfterStart + " full size: " + sample.size + ")");
                $c9a1fd49277acae3$var$DataStream.memcpy(sample.data.buffer, sample.alreadyRead, buffer, sample.offset + sample.alreadyRead - buffer.fileStart, lengthAfterStart);
                sample.alreadyRead += lengthAfterStart;
                /* update the number of bytes used in this buffer and check if it needs to be removed */ buffer.usedBytes += lengthAfterStart;
                this.stream.logBufferLevel();
            /* keep looking in the next buffer */ }
        } else return null;
    }
};
/* Release the memory used to store the data of the sample */ $c9a1fd49277acae3$var$ISOFile.prototype.releaseSample = function(trak, sampleNum) {
    var sample = trak.samples[sampleNum];
    if (sample.data) {
        this.samplesDataSize -= sample.size;
        sample.data = null;
        sample.alreadyRead = 0;
        return sample.size;
    } else return 0;
};
$c9a1fd49277acae3$var$ISOFile.prototype.getAllocatedSampleDataSize = function() {
    return this.samplesDataSize;
};
/* Builds the MIME Type 'codecs' sub-parameters for the whole file */ $c9a1fd49277acae3$var$ISOFile.prototype.getCodecs = function() {
    var i1;
    var codecs = "";
    for(i1 = 0; i1 < this.moov.traks.length; i1++){
        var trak = this.moov.traks[i1];
        if (i1 > 0) codecs += ",";
        codecs += trak.mdia.minf.stbl.stsd.entries[0].getCodec();
    }
    return codecs;
};
/* Helper function */ $c9a1fd49277acae3$var$ISOFile.prototype.getTrexById = function(id) {
    var i1;
    if (!this.moov || !this.moov.mvex) return null;
    for(i1 = 0; i1 < this.moov.mvex.trexs.length; i1++){
        var trex = this.moov.mvex.trexs[i1];
        if (trex.track_id == id) return trex;
    }
    return null;
};
/* Helper function */ $c9a1fd49277acae3$var$ISOFile.prototype.getTrackById = function(id) {
    if (this.moov === undefined) return null;
    for(var j = 0; j < this.moov.traks.length; j++){
        var trak = this.moov.traks[j];
        if (trak.tkhd.track_id == id) return trak;
    }
    return null;
};
// file:src/isofile-item-processing.js
$c9a1fd49277acae3$var$ISOFile.prototype.items = [];
$c9a1fd49277acae3$var$ISOFile.prototype.entity_groups = [];
/* size of the buffers allocated for samples */ $c9a1fd49277acae3$var$ISOFile.prototype.itemsDataSize = 0;
$c9a1fd49277acae3$var$ISOFile.prototype.flattenItemInfo = function() {
    var items = this.items;
    var entity_groups = this.entity_groups;
    var i1, j;
    var item;
    var meta = this.meta;
    if (meta === null || meta === undefined) return;
    if (meta.hdlr === undefined) return;
    if (meta.iinf === undefined) return;
    for(i1 = 0; i1 < meta.iinf.item_infos.length; i1++){
        item = {};
        item.id = meta.iinf.item_infos[i1].item_ID;
        items[item.id] = item;
        item.ref_to = [];
        item.name = meta.iinf.item_infos[i1].item_name;
        if (meta.iinf.item_infos[i1].protection_index > 0) item.protection = meta.ipro.protections[meta.iinf.item_infos[i1].protection_index - 1];
        if (meta.iinf.item_infos[i1].item_type) item.type = meta.iinf.item_infos[i1].item_type;
        else item.type = "mime";
        item.content_type = meta.iinf.item_infos[i1].content_type;
        item.content_encoding = meta.iinf.item_infos[i1].content_encoding;
    }
    if (meta.grpl) for(i1 = 0; i1 < meta.grpl.boxes.length; i1++){
        entity_group = {};
        entity_group.id = meta.grpl.boxes[i1].group_id;
        entity_group.entity_ids = meta.grpl.boxes[i1].entity_ids;
        entity_group.type = meta.grpl.boxes[i1].type;
        entity_groups[entity_group.id] = entity_group;
    }
    if (meta.iloc) for(i1 = 0; i1 < meta.iloc.items.length; i1++){
        var offset;
        var itemloc = meta.iloc.items[i1];
        item = items[itemloc.item_ID];
        if (itemloc.data_reference_index !== 0) {
            $c9a1fd49277acae3$var$Log.warn("Item storage with reference to other files: not supported");
            item.source = meta.dinf.boxes[itemloc.data_reference_index - 1];
        }
        switch(itemloc.construction_method){
            case 0:
                break;
            case 1:
                $c9a1fd49277acae3$var$Log.warn("Item storage with construction_method : not supported");
                break;
            case 2:
                $c9a1fd49277acae3$var$Log.warn("Item storage with construction_method : not supported");
                break;
        }
        item.extents = [];
        item.size = 0;
        for(j = 0; j < itemloc.extents.length; j++){
            item.extents[j] = {};
            item.extents[j].offset = itemloc.extents[j].extent_offset + itemloc.base_offset;
            item.extents[j].length = itemloc.extents[j].extent_length;
            item.extents[j].alreadyRead = 0;
            item.size += item.extents[j].length;
        }
    }
    if (meta.pitm) items[meta.pitm.item_id].primary = true;
    if (meta.iref) for(i1 = 0; i1 < meta.iref.references.length; i1++){
        var ref = meta.iref.references[i1];
        for(j = 0; j < ref.references.length; j++)items[ref.from_item_ID].ref_to.push({
            type: ref.type,
            id: ref.references[j]
        });
    }
    if (meta.iprp) for(var k = 0; k < meta.iprp.ipmas.length; k++){
        var ipma = meta.iprp.ipmas[k];
        for(i1 = 0; i1 < ipma.associations.length; i1++){
            var association = ipma.associations[i1];
            item = items[association.id];
            if (!item) item = entity_groups[association.id];
            if (item) {
                if (item.properties === undefined) {
                    item.properties = {};
                    item.properties.boxes = [];
                }
                for(j = 0; j < association.props.length; j++){
                    var propEntry = association.props[j];
                    if (propEntry.property_index > 0 && propEntry.property_index - 1 < meta.iprp.ipco.boxes.length) {
                        var propbox = meta.iprp.ipco.boxes[propEntry.property_index - 1];
                        item.properties[propbox.type] = propbox;
                        item.properties.boxes.push(propbox);
                    }
                }
            }
        }
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.getItem = function(item_id) {
    var buffer;
    var item;
    if (!this.meta) return null;
    item = this.items[item_id];
    if (!item.data && item.size) {
        /* Not yet fetched */ item.data = new Uint8Array(item.size);
        item.alreadyRead = 0;
        this.itemsDataSize += item.size;
        $c9a1fd49277acae3$var$Log.debug("ISOFile", "Allocating item #" + item_id + " of size " + item.size + " (total: " + this.itemsDataSize + ")");
    } else if (item.alreadyRead === item.size) /* Already fetched entirely */ return item;
    /* The item has only been partially fetched, we need to check in all buffers to find the remaining extents*/ for(var i1 = 0; i1 < item.extents.length; i1++){
        var extent = item.extents[i1];
        if (extent.alreadyRead === extent.length) continue;
        else {
            var index = this.stream.findPosition(true, extent.offset + extent.alreadyRead, false);
            if (index > -1) {
                buffer = this.stream.buffers[index];
                var lengthAfterStart = buffer.byteLength - (extent.offset + extent.alreadyRead - buffer.fileStart);
                if (extent.length - extent.alreadyRead <= lengthAfterStart) {
                    /* the (rest of the) extent is entirely contained in this buffer */ $c9a1fd49277acae3$var$Log.debug("ISOFile", "Getting item #" + item_id + " extent #" + i1 + " data (alreadyRead: " + extent.alreadyRead + " offset: " + (extent.offset + extent.alreadyRead - buffer.fileStart) + " read size: " + (extent.length - extent.alreadyRead) + " full extent size: " + extent.length + " full item size: " + item.size + ")");
                    $c9a1fd49277acae3$var$DataStream.memcpy(item.data.buffer, item.alreadyRead, buffer, extent.offset + extent.alreadyRead - buffer.fileStart, extent.length - extent.alreadyRead);
                    /* update the number of bytes used in this buffer and check if it needs to be removed */ buffer.usedBytes += extent.length - extent.alreadyRead;
                    this.stream.logBufferLevel();
                    item.alreadyRead += extent.length - extent.alreadyRead;
                    extent.alreadyRead = extent.length;
                } else {
                    /* the sample does not end in this buffer */ $c9a1fd49277acae3$var$Log.debug("ISOFile", "Getting item #" + item_id + " extent #" + i1 + " partial data (alreadyRead: " + extent.alreadyRead + " offset: " + (extent.offset + extent.alreadyRead - buffer.fileStart) + " read size: " + lengthAfterStart + " full extent size: " + extent.length + " full item size: " + item.size + ")");
                    $c9a1fd49277acae3$var$DataStream.memcpy(item.data.buffer, item.alreadyRead, buffer, extent.offset + extent.alreadyRead - buffer.fileStart, lengthAfterStart);
                    extent.alreadyRead += lengthAfterStart;
                    item.alreadyRead += lengthAfterStart;
                    /* update the number of bytes used in this buffer and check if it needs to be removed */ buffer.usedBytes += lengthAfterStart;
                    this.stream.logBufferLevel();
                    return null;
                }
            } else return null;
        }
    }
    if (item.alreadyRead === item.size) /* fetched entirely */ return item;
    else return null;
};
/* Release the memory used to store the data of the item */ $c9a1fd49277acae3$var$ISOFile.prototype.releaseItem = function(item_id) {
    var item = this.items[item_id];
    if (item.data) {
        this.itemsDataSize -= item.size;
        item.data = null;
        item.alreadyRead = 0;
        for(var i1 = 0; i1 < item.extents.length; i1++){
            var extent = item.extents[i1];
            extent.alreadyRead = 0;
        }
        return item.size;
    } else return 0;
};
$c9a1fd49277acae3$var$ISOFile.prototype.processItems = function(callback) {
    for(var i1 in this.items){
        var item = this.items[i1];
        this.getItem(item.id);
        if (callback && !item.sent) {
            callback(item);
            item.sent = true;
            item.data = null;
        }
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.hasItem = function(name) {
    for(var i1 in this.items){
        var item = this.items[i1];
        if (item.name === name) return item.id;
    }
    return -1;
};
$c9a1fd49277acae3$var$ISOFile.prototype.getMetaHandler = function() {
    if (!this.meta) return null;
    else return this.meta.hdlr.handler;
};
$c9a1fd49277acae3$var$ISOFile.prototype.getPrimaryItem = function() {
    if (!this.meta || !this.meta.pitm) return null;
    else return this.getItem(this.meta.pitm.item_id);
};
$c9a1fd49277acae3$var$ISOFile.prototype.itemToFragmentedTrackFile = function(_options) {
    var options = _options || {};
    var item = null;
    if (options.itemId) item = this.getItem(options.itemId);
    else item = this.getPrimaryItem();
    if (item == null) return null;
    var file = new $c9a1fd49277acae3$var$ISOFile();
    file.discardMdatData = false;
    // assuming the track type is the same as the item type
    var trackOptions = {
        type: item.type,
        description_boxes: item.properties.boxes
    };
    if (item.properties.ispe) {
        trackOptions.width = item.properties.ispe.image_width;
        trackOptions.height = item.properties.ispe.image_height;
    }
    var trackId = file.addTrack(trackOptions);
    if (trackId) {
        file.addSample(trackId, item.data);
        return file;
    } else return null;
};
// file:src/isofile-write.js
/* Rewrite the entire file */ $c9a1fd49277acae3$var$ISOFile.prototype.write = function(outstream) {
    for(var i1 = 0; i1 < this.boxes.length; i1++)this.boxes[i1].write(outstream);
};
$c9a1fd49277acae3$var$ISOFile.prototype.createFragment = function(track_id, sampleNumber, stream_) {
    var trak = this.getTrackById(track_id);
    var sample = this.getSample(trak, sampleNumber);
    if (sample == null) {
        this.setNextSeekPositionFromSample(trak.samples[sampleNumber]);
        return null;
    }
    var stream = stream_ || new $c9a1fd49277acae3$var$DataStream();
    stream.endianness = $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN;
    var moof = this.createSingleSampleMoof(sample);
    moof.write(stream);
    /* adjusting the data_offset now that the moof size is known*/ moof.trafs[0].truns[0].data_offset = moof.size + 8; //8 is mdat header
    $c9a1fd49277acae3$var$Log.debug("MP4Box", "Adjusting data_offset with new value " + moof.trafs[0].truns[0].data_offset);
    stream.adjustUint32(moof.trafs[0].truns[0].data_offset_position, moof.trafs[0].truns[0].data_offset);
    var mdat = new $c9a1fd49277acae3$var$BoxParser.mdatBox();
    mdat.data = sample.data;
    mdat.write(stream);
    return stream;
};
/* Modify the file and create the initialization segment */ $c9a1fd49277acae3$var$ISOFile.writeInitializationSegment = function(ftyp, moov, total_duration, sample_duration) {
    var i1;
    var index;
    var mehd;
    var trex;
    var box1;
    $c9a1fd49277acae3$var$Log.debug("ISOFile", "Generating initialization segment");
    var stream = new $c9a1fd49277acae3$var$DataStream();
    stream.endianness = $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN;
    ftyp.write(stream);
    /* we can now create the new mvex box */ var mvex = moov.add("mvex");
    if (total_duration) mvex.add("mehd").set("fragment_duration", total_duration);
    for(i1 = 0; i1 < moov.traks.length; i1++)mvex.add("trex").set("track_id", moov.traks[i1].tkhd.track_id).set("default_sample_description_index", 1).set("default_sample_duration", sample_duration).set("default_sample_size", 0).set("default_sample_flags", 65536);
    moov.write(stream);
    return stream.buffer;
};
$c9a1fd49277acae3$var$ISOFile.prototype.save = function(name) {
    var stream = new $c9a1fd49277acae3$var$DataStream();
    stream.endianness = $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN;
    this.write(stream);
    stream.save(name);
};
$c9a1fd49277acae3$var$ISOFile.prototype.getBuffer = function() {
    var stream = new $c9a1fd49277acae3$var$DataStream();
    stream.endianness = $c9a1fd49277acae3$var$DataStream.BIG_ENDIAN;
    this.write(stream);
    return stream.buffer;
};
$c9a1fd49277acae3$var$ISOFile.prototype.initializeSegmentation = function() {
    var i1;
    var j;
    var box1;
    var initSegs;
    var trak;
    var seg;
    if (this.onSegment === null) $c9a1fd49277acae3$var$Log.warn("MP4Box", "No segmentation callback set!");
    if (!this.isFragmentationInitialized) {
        this.isFragmentationInitialized = true;
        this.nextMoofNumber = 0;
        this.resetTables();
    }
    initSegs = [];
    for(i1 = 0; i1 < this.fragmentedTracks.length; i1++){
        var moov = new $c9a1fd49277acae3$var$BoxParser.moovBox();
        moov.mvhd = this.moov.mvhd;
        moov.boxes.push(moov.mvhd);
        trak = this.getTrackById(this.fragmentedTracks[i1].id);
        moov.boxes.push(trak);
        moov.traks.push(trak);
        seg = {};
        seg.id = trak.tkhd.track_id;
        seg.user = this.fragmentedTracks[i1].user;
        seg.buffer = $c9a1fd49277acae3$var$ISOFile.writeInitializationSegment(this.ftyp, moov, this.moov.mvex && this.moov.mvex.mehd ? this.moov.mvex.mehd.fragment_duration : undefined, this.moov.traks[i1].samples.length > 0 ? this.moov.traks[i1].samples[0].duration : 0);
        initSegs.push(seg);
    }
    return initSegs;
};
// file:src/box-print.js
/* 
* Copyright (c) Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
* License: BSD-3-Clause (see LICENSE file)
*/ $c9a1fd49277acae3$var$BoxParser.Box.prototype.printHeader = function(output) {
    this.size += 8;
    if (this.size > $c9a1fd49277acae3$var$MAX_SIZE) this.size += 8;
    if (this.type === "uuid") this.size += 16;
    output.log(output.indent + "size:" + this.size);
    output.log(output.indent + "type:" + this.type);
};
$c9a1fd49277acae3$var$BoxParser.FullBox.prototype.printHeader = function(output) {
    this.size += 4;
    $c9a1fd49277acae3$var$BoxParser.Box.prototype.printHeader.call(this, output);
    output.log(output.indent + "version:" + this.version);
    output.log(output.indent + "flags:" + this.flags);
};
$c9a1fd49277acae3$var$BoxParser.Box.prototype.print = function(output) {
    this.printHeader(output);
};
$c9a1fd49277acae3$var$BoxParser.ContainerBox.prototype.print = function(output) {
    this.printHeader(output);
    for(var i1 = 0; i1 < this.boxes.length; i1++)if (this.boxes[i1]) {
        var prev_indent = output.indent;
        output.indent += " ";
        this.boxes[i1].print(output);
        output.indent = prev_indent;
    }
};
$c9a1fd49277acae3$var$ISOFile.prototype.print = function(output) {
    output.indent = "";
    for(var i1 = 0; i1 < this.boxes.length; i1++)if (this.boxes[i1]) this.boxes[i1].print(output);
};
$c9a1fd49277acae3$var$BoxParser.mvhdBox.prototype.print = function(output) {
    $c9a1fd49277acae3$var$BoxParser.FullBox.prototype.printHeader.call(this, output);
    output.log(output.indent + "creation_time: " + this.creation_time);
    output.log(output.indent + "modification_time: " + this.modification_time);
    output.log(output.indent + "timescale: " + this.timescale);
    output.log(output.indent + "duration: " + this.duration);
    output.log(output.indent + "rate: " + this.rate);
    output.log(output.indent + "volume: " + (this.volume >> 8));
    output.log(output.indent + "matrix: " + this.matrix.join(", "));
    output.log(output.indent + "next_track_id: " + this.next_track_id);
};
$c9a1fd49277acae3$var$BoxParser.tkhdBox.prototype.print = function(output) {
    $c9a1fd49277acae3$var$BoxParser.FullBox.prototype.printHeader.call(this, output);
    output.log(output.indent + "creation_time: " + this.creation_time);
    output.log(output.indent + "modification_time: " + this.modification_time);
    output.log(output.indent + "track_id: " + this.track_id);
    output.log(output.indent + "duration: " + this.duration);
    output.log(output.indent + "volume: " + (this.volume >> 8));
    output.log(output.indent + "matrix: " + this.matrix.join(", "));
    output.log(output.indent + "layer: " + this.layer);
    output.log(output.indent + "alternate_group: " + this.alternate_group);
    output.log(output.indent + "width: " + this.width);
    output.log(output.indent + "height: " + this.height);
} // file:src/mp4box.js
;
/*
* Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
* License: BSD-3-Clause (see LICENSE file)
*/ var $c9a1fd49277acae3$var$MP4Box = {};
$c9a1fd49277acae3$var$MP4Box.createFile = function(_keepMdatData, _stream) {
    /* Boolean indicating if bytes containing media data should be kept in memory */ var keepMdatData = _keepMdatData !== undefined ? _keepMdatData : true;
    var file = new $c9a1fd49277acae3$var$ISOFile(_stream);
    file.discardMdatData = keepMdatData ? false : true;
    return file;
};
$c9a1fd49277acae3$export$982c3a0b9a5cde94 = $c9a1fd49277acae3$var$MP4Box.createFile;


async function $58fcfb7627188bbc$export$9c2d25d8fa57be53(data) {
    const start = performance.now();
    const { video: video, container: container, codec: codec, fps: fps, width: displayWidth, height: displayHeight } = data;
    const frames = [];
    let codedWidth = displayWidth;
    let codedHeight = displayHeight;
    if (codedWidth % 2 !== 0) codedWidth++;
    if (codedHeight % 2 !== 0) codedHeight++;
    console.info("%cPOKI_REPLAY:%c new video", "font-weight: bold", "", video.byteLength, container, codec, fps, displayWidth, displayHeight, codedWidth, codedHeight);
    const needResize = displayWidth !== codedWidth || displayHeight !== codedHeight;
    if (needResize) console.info(`%cPOKI_REPLAY:%c resizing video from ${displayWidth}x${displayHeight} to ${codedWidth}x${codedHeight}`, "font-weight: bold", "");
    let loggedVideoResize = false;
    const canvas = new OffscreenCanvas(codedWidth, codedHeight);
    const ctx = canvas.getContext("2d", {
        willReadFrequently: true
    });
    const decoder = new VideoDecoder({
        output: async (frame)=>{
            const frameNeedsResize = frame.displayWidth != displayWidth || frame.displayHeight != displayHeight || frame.codedWidth != codedWidth || frame.codedHeight != codedHeight;
            if (frameNeedsResize && !loggedVideoResize) {
                console.info(`%cPOKI_REPLAY:%c resizing video frame from ${frame.displayWidth}x${frame.displayHeight} (${frame.codedWidth}x${frame.codedHeight}) to ${displayWidth}x${displayHeight} (${codedWidth}x${codedHeight})`, "font-weight: bold", "");
                loggedVideoResize = true;
            }
            if (needResize || frameNeedsResize) {
                ctx.drawImage(frame, 0, 0, displayWidth, displayHeight);
                const newFrame = new VideoFrame(canvas, {
                    timestamp: frame.timestamp,
                    duration: frame.duration,
                    codedWidth: codedWidth,
                    codedHeight: codedHeight,
                    displayWidth: displayWidth,
                    displayHeight: displayHeight
                });
                frame.close();
                frame = newFrame;
            }
            let buffer = new Uint8Array(frame.allocationSize());
            let layout = await frame.copyTo(buffer);
            frames.push({
                buffer: buffer,
                layout: layout,
                format: frame.format,
                timestamp: frame.timestamp,
                duration: frame.duration,
                codedWidth: codedWidth,
                codedHeight: codedHeight,
                displayWidth: displayWidth,
                displayHeight: displayHeight,
                colorSpace: frame.colorSpace
            });
            frame.close();
        },
        error: (e)=>{
            console.error(`%cPOKI_REPLAY:%c error decoding video`, "font-weight: bold", "", e);
        }
    });
    if (container == "video/webm") {
        decoder.configure({
            codec: codec,
            codedHeight: codedHeight,
            codedWidth: codedWidth
        });
        let mkvDemuxer = new (0, $a32c94edd9349cd4$export$2e2bcd8739ae039).MkvDemux();
        mkvDemuxer.push(video);
        const demuxedFrames = [];
        while(true){
            const part = mkvDemuxer.demux();
            if (!part) break;
            if (part.frames) for(let i = 0; i < part.frames.length; i++)demuxedFrames.push(part.frames[i]);
        }
        let timestampOffset = 0;
        let previousTimestamp = 0;
        for(let i = 0; i < demuxedFrames.length; i++){
            const frame = demuxedFrames[i];
            if (frame.timestamp === 0) timestampOffset += previousTimestamp;
            previousTimestamp = frame.timestamp;
            frame.timestamp += timestampOffset;
        }
        for(let i = 0; i < demuxedFrames.length; i++){
            const frame = demuxedFrames[i];
            const chunk = new EncodedVideoChunk({
                type: "key",
                data: frame.data,
                timestamp: frame.timestamp * 1e6,
                duration: 1e6 / fps
            });
            decoder.decode(chunk);
        }
    } else if (container === "video/mp4") {
        const file = (0, (/*@__PURE__*/$parcel$interopDefault($c9a1fd49277acae3$exports))).createFile();
        file.onError = (err)=>{
            console.error(`%cPOKI_REPLAY:%c error parsing video`, "font-weight: bold", "", err);
        };
        file.onReady = (info)=>{
            const track = info.videoTracks[0];
            const description = (()=>{
                const trak = file.getTrackById(track.id);
                for (const entry of trak.mdia.minf.stbl.stsd.entries)if (entry.avcC || entry.hvcC) {
                    const stream = new (0, (/*@__PURE__*/$parcel$interopDefault($c9a1fd49277acae3$exports))).DataStream(undefined, 0, (0, (/*@__PURE__*/$parcel$interopDefault($c9a1fd49277acae3$exports))).DataStream.BIG_ENDIAN);
                    if (entry.avcC) entry.avcC.write(stream);
                    else entry.hvcC.write(stream);
                    return new Uint8Array(stream.buffer, 8); // Remove the box header.
                }
                throw new Error("avcC or hvcC not found");
            })();
            console.log("track", track);
            const config = {
                codec: track.codec,
                codedWidth: codedWidth,
                codedHeight: codedHeight,
                description: description,
                info: info
            };
            decoder.configure(config);
            file.setExtractionOptions(track.id);
            file.start();
        };
        file.onSamples = (track_id, ref, samples)=>{
            for(let i = 0; i < samples.length; i++){
                const sample = samples[i];
                const chunk = new EncodedVideoChunk({
                    type: sample.is_sync ? "key" : "delta",
                    timestamp: 1e6 * sample.cts / sample.timescale,
                    duration: 1e6 * sample.duration / sample.timescale,
                    data: sample.data
                });
                decoder.decode(chunk);
            }
        };
        video.fileStart = 0;
        file.appendBuffer(video);
        file.flush();
    } else throw new Error(`Unsupported container: ${container}`);
    await decoder.flush();
    decoder.close();
    console.info(`%cPOKI_REPLAY:%c decoding took ${Math.round(performance.now() - start)} ms`, "font-weight: bold", "");
    return frames;
}


var $7b75c0b7b180e80d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7b75c0b7b180e80d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7b75c0b7b180e80d$var$_a;
window.addEventListener("message", function(event) {
    return $7b75c0b7b180e80d$var$__awaiter(void 0, void 0, void 0, function() {
        var _a, video, fps, container, width, height, frames, keep;
        return $7b75c0b7b180e80d$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (event.data.type !== "poki/game/fetched_replay") return [
                        2 /*return*/ 
                    ];
                    _a = event.data, video = _a.video, fps = _a.fps, container = _a.container, width = _a.width, height = _a.height;
                    console.log(event.data);
                    return [
                        4 /*yield*/ ,
                        (0, $58fcfb7627188bbc$export$9c2d25d8fa57be53)(event.data)
                    ];
                case 1:
                    frames = _b.sent();
                    keep = 30 * fps;
                    if (frames.length > keep) frames.splice(0, frames.length - keep);
                    (0, $7d25ac3a95a01df6$export$2e2bcd8739ae039).emit("receiveVideo", {
                        video: video,
                        fps: fps,
                        frames: frames,
                        container: container,
                        width: width,
                        height: height
                    });
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
});
// Kick off the fetch
($7b75c0b7b180e80d$var$_a = window.opener) === null || $7b75c0b7b180e80d$var$_a === void 0 || $7b75c0b7b180e80d$var$_a.postMessage({
    type: "fetchReplay"
}, "*");




var $58d0c38a67229bbf$var$__assign = undefined && undefined.__assign || function() {
    $58d0c38a67229bbf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $58d0c38a67229bbf$var$__assign.apply(this, arguments);
};
var $58d0c38a67229bbf$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $58d0c38a67229bbf$var$TimeRangeSlider = /** @class */ function() {
    function TimeRangeSlider(selector, props) {
        if (props === void 0) props = {};
        var _a, _b;
        this.defaultProps = {
            values: [
                25,
                75
            ],
            step: 1,
            min: 0,
            max: 100,
            colors: {
                points: "rgb(25, 118, 210)",
                rail: "rgba(25, 118, 210, 0.4)",
                tracks: "rgb(25, 118, 210)"
            },
            pointRadius: 15,
            railHeight: 5,
            trackHeight: 5
        };
        this.allProps = $58d0c38a67229bbf$var$__assign($58d0c38a67229bbf$var$__assign($58d0c38a67229bbf$var$__assign({}, this.defaultProps), props), {
            values: $58d0c38a67229bbf$var$__spreadArray([], (_b = (_a = props.values) !== null && _a !== void 0 ? _a : this.defaultProps.values) !== null && _b !== void 0 ? _b : [], true),
            colors: $58d0c38a67229bbf$var$__assign($58d0c38a67229bbf$var$__assign({}, this.defaultProps.colors), props.colors)
        });
        this.container = this.initContainer(selector);
        this.pointPositions = this.generatePointPositions();
        this.possibleValues = this.generatePossibleValues();
        this.jump = this.container.offsetWidth / Math.ceil((this.allProps.max - this.allProps.min) / this.allProps.step);
        this.rail = this.initRail();
        this.tracks = this.initTracks(this.allProps.values.length - 1);
        this.tooltip = this.initTooltip();
        this.points = this.initPoints(this.allProps.values.length);
        this.drawScene();
        this.documentMouseupHandler = this.documentMouseupHandler.bind(this);
        this.documentMouseMoveHandler = this.documentMouseMoveHandler.bind(this);
        this.selectedPointIndex = -1;
        this.changeHandlers = [];
        this.frameDuration = props.frameDuration;
        // move the middle point above the other points to make sure its always selectable
        this.points[1].style.zIndex = "1";
        this.oldValues = this.allProps.values.slice();
        return this;
    }
    TimeRangeSlider.prototype.drawScene = function() {
        var _this = this;
        this.container.classList.add("range-slider__container");
        this.container.appendChild(this.rail);
        this.container.appendChild(this.tooltip);
        this.tracks.forEach(function(track) {
            return _this.container.appendChild(track);
        });
        this.points.forEach(function(point) {
            return _this.container.appendChild(point);
        });
    };
    TimeRangeSlider.prototype.generatePointPositions = function() {
        var _this = this;
        return this.allProps.values.map(function(value) {
            var percentage = value / _this.allProps.max * 100;
            return Math.floor(percentage / 100 * _this.container.offsetWidth);
        });
    };
    TimeRangeSlider.prototype.generatePossibleValues = function() {
        var values = [];
        for(var i = this.allProps.min; i <= this.allProps.max; i += this.allProps.step)values.push(Math.round(i * 100) / 100);
        if (this.allProps.max % this.allProps.step > 0) values.push(Math.round(this.allProps.max * 100) / 100);
        return values;
    };
    TimeRangeSlider.prototype.initContainer = function(selector) {
        var container = document.querySelector(selector);
        container.classList.add("range-slider__container");
        container.style.height = this.allProps.pointRadius * 2 + "px";
        return container;
    };
    TimeRangeSlider.prototype.initRail = function() {
        var _this = this;
        var rail = document.createElement("span");
        rail.classList.add("range-slider__rail");
        rail.style.background = this.allProps.colors.rail;
        rail.style.height = this.allProps.railHeight + "px";
        rail.style.top = this.allProps.pointRadius + "px";
        rail.addEventListener("pointerdown", function(e) {
            return _this.railClickHandler(e);
        });
        return rail;
    };
    TimeRangeSlider.prototype.initTracks = function(count) {
        var tracks = [];
        for(var i = 0; i < count; i++)tracks.push(this.initTrack(i));
        return tracks;
    };
    TimeRangeSlider.prototype.initTrack = function(index) {
        var _this = this;
        var track = document.createElement("span");
        track.classList.add("range-slider__track");
        var trackPointPositions = this.pointPositions.slice(index, index + 2);
        track.style.left = Math.min.apply(Math, trackPointPositions) + "px";
        track.style.top = this.allProps.pointRadius + "px";
        track.style.width = Math.max.apply(Math, trackPointPositions) - Math.min.apply(Math, trackPointPositions) + "px";
        track.style.height = this.allProps.trackHeight + "px";
        var trackColors = this.allProps.colors.tracks;
        track.style.background = Array.isArray(trackColors) ? trackColors[index] || trackColors[trackColors.length - 1] : trackColors;
        track.addEventListener("pointerdown", function(e) {
            return _this.railClickHandler(e);
        });
        return track;
    };
    TimeRangeSlider.prototype.initPoints = function(count) {
        var points = [];
        for(var i = 0; i < count; i++)points.push(this.initPoint(i));
        return points;
    };
    TimeRangeSlider.prototype.initPoint = function(index) {
        var _this = this;
        var point = document.createElement("span");
        point.classList.add("range-slider__point");
        point.style.width = this.allProps.pointRadius * 2 + "px";
        point.style.height = this.allProps.pointRadius * 2 + "px";
        point.style.left = "".concat(this.pointPositions[index] / this.container.offsetWidth * 100, "%");
        var pointColors = this.allProps.colors.points;
        point.style.background = Array.isArray(pointColors) ? pointColors[index] || pointColors[pointColors.length - 1] : pointColors;
        point.addEventListener("pointerdown", function(e) {
            return _this.pointClickHandler(e, index);
        });
        point.addEventListener("pointerover", function(e) {
            return _this.pointMouseoverHandler(e, index);
        });
        point.addEventListener("pointerout", function(e) {
            return _this.pointMouseOutHandler(e, index);
        });
        return point;
    };
    TimeRangeSlider.prototype.initTooltip = function() {
        var tooltip = document.createElement("span");
        tooltip.classList.add("range-slider__tooltip");
        tooltip.style.fontSize = this.allProps.pointRadius + "px";
        return tooltip;
    };
    TimeRangeSlider.prototype.draw = function() {
        var _this = this;
        this.points.forEach(function(point, i) {
            point.style.left = "".concat(_this.pointPositions[i] / _this.container.offsetWidth * 100, "%");
        });
        this.tracks.forEach(function(track, i) {
            var trackPointPositions = _this.pointPositions.slice(i, i + 2);
            track.style.left = Math.min.apply(Math, trackPointPositions) + "px";
            track.style.width = Math.max.apply(Math, trackPointPositions) - Math.min.apply(Math, trackPointPositions) + "px";
        });
        this.tooltip.style.left = this.pointPositions[this.selectedPointIndex] + "px";
        this.tooltip.textContent = this.getSelectedPointTime(this.selectedPointIndex);
    };
    TimeRangeSlider.prototype.railClickHandler = function(e) {
        var oldSelectedPointIndex = this.selectedPointIndex;
        this.selectedPointIndex = 1; // always move the cue on click
        this.documentMouseMoveHandler(e);
        this.selectedPointIndex = oldSelectedPointIndex;
        this.pointClickHandler(e, 1);
        this.draw();
    };
    TimeRangeSlider.prototype.getClosestPointIndex = function(mousePosition) {
        var shortestDistance = Infinity;
        var index = 0;
        for(var i in this.pointPositions){
            var dist = Math.abs(mousePosition - this.pointPositions[i]);
            if (shortestDistance > dist) {
                shortestDistance = dist;
                index = parseInt(i);
            }
        }
        return index;
    };
    TimeRangeSlider.prototype.documentMouseupHandler = function() {
        var _this = this;
        this.changeHandlers.forEach(function(func) {
            return func(_this.allProps.values);
        });
        this.points[this.selectedPointIndex].style.boxShadow = "none";
        this.selectedPointIndex = -1;
        this.tooltip.style.transform = "translate(-50%, -60%) scale(0)";
        document.removeEventListener("pointerup", this.documentMouseupHandler);
        document.removeEventListener("pointermove", this.documentMouseMoveHandler);
    };
    TimeRangeSlider.prototype.documentMouseMoveHandler = function(e) {
        var _this = this;
        var newPoisition = this.getMouseRelativePosition(e.pageX);
        var extra = Math.floor(newPoisition % this.jump);
        if (extra > this.jump / 2) newPoisition += this.jump - extra;
        else newPoisition -= extra;
        if (newPoisition < 0) newPoisition = 0;
        else if (newPoisition > this.container.offsetWidth) newPoisition = this.container.offsetWidth;
        if (this.selectedPointIndex < this.pointPositions.length - 1) {
            var nextPosition = this.pointPositions[this.selectedPointIndex + 1];
            if (newPoisition >= nextPosition) newPoisition = nextPosition;
        }
        if (this.selectedPointIndex > 0) {
            var previousPosition_1 = this.pointPositions[this.selectedPointIndex - 1];
            if (newPoisition <= previousPosition_1) newPoisition = previousPosition_1;
        }
        var previousPosition = this.pointPositions[this.selectedPointIndex];
        this.pointPositions[this.selectedPointIndex] = newPoisition;
        if (previousPosition !== newPoisition) this.changeHandlers.forEach(function(func) {
            return func(_this.allProps.values, true);
        });
        this.allProps.values[this.selectedPointIndex] = this.possibleValues[Math.floor(newPoisition / this.jump)];
        this.draw();
        e.preventDefault();
        e.stopPropagation();
        return false;
    };
    TimeRangeSlider.prototype.pointClickHandler = function(e, index) {
        e.preventDefault();
        this.selectedPointIndex = index;
        document.addEventListener("pointerup", this.documentMouseupHandler);
        document.addEventListener("pointermove", this.documentMouseMoveHandler);
    };
    TimeRangeSlider.prototype.pointMouseoverHandler = function(e, index) {
        var transparentColor = TimeRangeSlider.addTransparencyToColor(this.points[index].style.backgroundColor, 16);
        if (this.selectedPointIndex < 0) this.points[index].style.boxShadow = "0px 0px 0px ".concat(Math.floor(this.allProps.pointRadius / 1.5), "px ").concat(transparentColor);
        this.tooltip.style.transform = "translate(-50%, -60%) scale(1)";
        this.tooltip.style.left = this.pointPositions[index] + "px";
        this.tooltip.textContent = this.getSelectedPointTime(index);
    };
    TimeRangeSlider.addTransparencyToColor = function(color, percentage) {
        if (color.startsWith("rgba")) return color.replace(/(\d+)(?!.*\d)/, percentage + "%");
        if (color.startsWith("rgb")) {
            var newColor = color.replace(/(\))(?!.*\))/, ", ".concat(percentage, "%)"));
            return newColor.replace("rgb", "rgba");
        }
        if (color.startsWith("#")) return color + percentage.toString(16);
        return color;
    };
    TimeRangeSlider.prototype.pointMouseOutHandler = function(e, index) {
        if (this.selectedPointIndex < 0) {
            this.points[index].style.boxShadow = "none";
            this.tooltip.style.transform = "translate(-50%, -60%) scale(0)";
        }
    };
    TimeRangeSlider.prototype.getMouseRelativePosition = function(pageX) {
        return pageX - this.container.offsetLeft;
    };
    TimeRangeSlider.prototype.onChange = function(func) {
        if (typeof func !== "function") throw new Error("Please provide function as onChange callback");
        this.changeHandlers.push(func);
        return this;
    };
    TimeRangeSlider.prototype.setPointValue = function(index, value) {
        this.allProps.values[index] = value;
        this.pointPositions[index] = value * this.jump;
        this.draw();
    };
    TimeRangeSlider.prototype.getSelectedPointTime = function(index) {
        var time = this.allProps.values[index] * this.frameDuration;
        var minutes = Math.floor(time / 60000);
        var seconds = (time % 60000 / 1000).toFixed(0);
        return "".concat(minutes, ":").concat(seconds.padStart(2, "0"));
    };
    return TimeRangeSlider;
}();
var $58d0c38a67229bbf$export$2e2bcd8739ae039 = $58d0c38a67229bbf$var$TimeRangeSlider;



var $c17b7bec70f4fcd5$var$CanvasVideoPlayer = /** @class */ function() {
    function CanvasVideoPlayer(frames, fps, width, height) {
        this.playing = false;
        this.currentTimestamp = 0;
        this.currentFrameIndex = -1;
        this.trimStart = 0;
        this.trimEnd = 0;
        this.frames = frames;
        this.fps = fps;
        this.frameDuration = 1000 / fps;
        this.container = document.createElement("div");
        this.container.classList.add("canvas-video-player");
        this.canvas = document.createElement("canvas");
        this.canvas.width = width;
        this.canvas.height = height;
        this.canvas.style.width = "100%";
        this.canvas.style.height = "100%";
        this.ctx = this.canvas.getContext("2d");
        this.container.appendChild(this.canvas);
        this.trimEnd = frames.length - 1;
        this.drawFrame(0);
        this.controls = document.createElement("div");
        this.controls.classList.add("canvas-video-player-controls");
        this.container.appendChild(this.controls);
        this.buildControls();
    }
    CanvasVideoPlayer.prototype.play = function() {
        var _this = this;
        if (this.playing) {
            this.pause();
            return;
        }
        this.playing = true;
        this.playButton.classList.remove("pause");
        var previousTimestamp = 0;
        var renderFrame = function(time) {
            if (!previousTimestamp) previousTimestamp = time;
            var timeDiff = time - previousTimestamp;
            _this.currentTimestamp += timeDiff;
            var frameIndex = Math.floor(_this.currentTimestamp / _this.frameDuration);
            _this.trimBarSlider.setPointValue(1, frameIndex);
            if (frameIndex >= _this.trimEnd) {
                _this.stop();
                return;
            }
            if (frameIndex !== _this.currentFrameIndex) _this.drawFrame(frameIndex);
            previousTimestamp = time;
            _this.raf = requestAnimationFrame(renderFrame);
        };
        renderFrame(0);
    };
    CanvasVideoPlayer.prototype.drawFrame = function(frameIndex) {
        var frame = new VideoFrame(this.frames[frameIndex].buffer, this.frames[frameIndex]);
        this.ctx.drawImage(frame, 0, 0);
        this.currentFrameIndex = frameIndex;
        // close the frame to release the memory
        frame.close();
    };
    CanvasVideoPlayer.prototype.pause = function() {
        this.playing = false;
        this.playButton.classList.add("pause");
        cancelAnimationFrame(this.raf);
    // show play button
    };
    CanvasVideoPlayer.prototype.stop = function() {
        this.pause();
        this.currentTimestamp = this.trimStart * this.frameDuration;
    };
    CanvasVideoPlayer.prototype.buildControls = function() {
        var _this = this;
        this.playButton = document.createElement("button");
        this.playButton.classList.add("canvas-video-player-play", "pause");
        this.playButton.addEventListener("click", function() {
            return _this.play();
        });
        this.controls.appendChild(this.playButton);
        this.container.appendChild(this.controls);
        setTimeout(function() {
            // we need the dom to be ready before we can build the seek bar
            _this.buildSeekBar();
        }, 0);
    };
    CanvasVideoPlayer.prototype.buildSeekBar = function() {
        var _this = this;
        var trimBar = document.createElement("div");
        this.controls.appendChild(trimBar);
        trimBar.classList.add("canvas-video-player-trim-bar");
        this.trimBarSlider = new (0, $58d0c38a67229bbf$export$2e2bcd8739ae039)(".canvas-video-player-trim-bar", {
            values: [
                0,
                0,
                this.frames.length - 1
            ],
            min: 0,
            max: this.frames.length - 1,
            frameDuration: this.frameDuration,
            railHeight: 5,
            trackHeight: 6,
            pointRadius: 10,
            colors: {
                points: [
                    "#009CFF",
                    "#009CFF",
                    "#009CFF"
                ],
                rail: "#F0F5FC",
                tracks: "#009CFF"
            }
        });
        this.trimBarSlider.onChange(function(values, down) {
            var start = values[0], cue = values[1], end = values[2];
            // if values is equal to oldValues return
            if (down && values.toString() === _this.trimBarSlider.oldValues.toString()) return;
            if (!down && (_this.trimStart !== start || _this.trimEnd !== end)) {
                _this.trimStart = start;
                _this.trimEnd = end;
                (0, $7d25ac3a95a01df6$export$2e2bcd8739ae039).emit("trimChange", {
                    start: start,
                    end: end
                });
            }
            var frameToDraw = cue;
            if (down) {
                if (start !== _this.trimBarSlider.oldValues[0]) frameToDraw = start;
                else if (end !== _this.trimBarSlider.oldValues[2]) frameToDraw = end;
            }
            _this.currentTimestamp = frameToDraw * _this.frameDuration;
            _this.drawFrame(frameToDraw);
            _this.trimBarSlider.oldValues = values.slice();
        });
    };
    return CanvasVideoPlayer;
}();
var $c17b7bec70f4fcd5$export$2e2bcd8739ae039 = $c17b7bec70f4fcd5$var$CanvasVideoPlayer;



var $cf74ec4da4573f1f$export$2e2bcd8739ae039 = {
    videoFrames: [],
    bakedVideoFrames: new Promise(function() {}),
    fabricCanvas: null,
    fabricCanvasDirty: false,
    trimStart: 0,
    trimEnd: 0,
    videoAspectRatio: 0
};



var $6b7460ce312a4142$var$__assign = undefined && undefined.__assign || function() {
    $6b7460ce312a4142$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6b7460ce312a4142$var$__assign.apply(this, arguments);
};
function $6b7460ce312a4142$export$d7db3f915c162767(frames) {
    return frames.map(function(frame) {
        return $6b7460ce312a4142$var$__assign($6b7460ce312a4142$var$__assign({}, frame), {
            colorSpace: {
                // Serialize the VideoColorSpace properties, since it can't be transferred directly
                fullRange: frame.colorSpace.fullRange,
                matrix: frame.colorSpace.matrix,
                primaries: frame.colorSpace.primaries,
                transfer: frame.colorSpace.transfer
            }
        });
    });
}
function $6b7460ce312a4142$export$2444a1889e54953a(frames) {
    return frames.map(function(frame) {
        return $6b7460ce312a4142$var$__assign($6b7460ce312a4142$var$__assign({}, frame), {
            colorSpace: new VideoColorSpace({
                fullRange: frame.colorSpace.fullRange,
                matrix: frame.colorSpace.matrix,
                primaries: frame.colorSpace.primaries,
                transfer: frame.colorSpace.transfer
            })
        });
    });
}


var $ca669a4f1ef5f7e9$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $ca669a4f1ef5f7e9$var$url = new URL("worker.27dfd01d.js", import.meta.url);
$ca669a4f1ef5f7e9$exports = $56b621a6dd25b2cb$exports($ca669a4f1ef5f7e9$var$url.toString(), $ca669a4f1ef5f7e9$var$url.origin, true);


var $b53765e5fbe92ac9$var$worker = new Worker($ca669a4f1ef5f7e9$exports);
function $b53765e5fbe92ac9$export$715facf17dc37e45() {
    console.info("%cPOKI_REPLAY:%c baking video frames", "font-weight: bold", "");
    var start = performance.now();
    (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).bakedVideoFrames = new Promise(function(resolve) {
        var fabricCanvas = (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).fabricCanvas, videoFrames = (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).videoFrames, trimStart = (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).trimStart, trimEnd = (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).trimEnd;
        if (!fabricCanvas || !videoFrames.length) return;
        var framesToProcess = videoFrames.slice(trimStart, trimEnd + 1);
        var fabricCanvasElement = fabricCanvas.toCanvasElement();
        var context = fabricCanvasElement.getContext("2d");
        var imageData = context.getImageData(0, 0, fabricCanvasElement.width, fabricCanvasElement.height);
        $b53765e5fbe92ac9$var$worker.postMessage({
            frames: (0, $6b7460ce312a4142$export$d7db3f915c162767)(framesToProcess),
            imageData: imageData
        });
        $b53765e5fbe92ac9$var$worker.onmessage = function(e) {
            var took = performance.now() - start;
            console.info("%cPOKI_REPLAY:%c video baked in ", "font-weight: bold", "", took.toFixed(2), "ms");
            resolve(e.data);
        };
    });
}


// https://github.com/Vanilagy/mp4-muxer
var $429c9424af8192b8$var$Mp4Muxer = (()=>{
    var __defProp = Object.defineProperty;
    var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames = Object.getOwnPropertyNames;
    var __hasOwnProp = Object.prototype.hasOwnProperty;
    var __export = (target, all)=>{
        for(var name in all)__defProp(target, name, {
            get: all[name],
            enumerable: true
        });
    };
    var __copyProps = (to, from, except, desc)=>{
        if (from && typeof from === "object" || typeof from === "function") {
            for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                get: ()=>from[key],
                enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
            });
        }
        return to;
    };
    var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
            value: true
        }), mod);
    var __accessCheck = (obj, member, msg)=>{
        if (!member.has(obj)) throw TypeError("Cannot " + msg);
    };
    var __privateGet = (obj, member, getter)=>{
        __accessCheck(obj, member, "read from private field");
        return getter ? getter.call(obj) : member.get(obj);
    };
    var __privateAdd = (obj, member, value1)=>{
        if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
        member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
    };
    var __privateSet = (obj, member, value1, setter)=>{
        __accessCheck(obj, member, "write to private field");
        setter ? setter.call(obj, value1) : member.set(obj, value1);
        return value1;
    };
    var __privateWrapper = (obj, member, setter, getter)=>({
            set _ (value){
                __privateSet(obj, member, value, setter);
            },
            get _ () {
                return __privateGet(obj, member, getter);
            }
        });
    var __privateMethod = (obj, member, method)=>{
        __accessCheck(obj, member, "access private method");
        return method;
    };
    // src/index.ts
    var src_exports = {};
    __export(src_exports, {
        ArrayBufferTarget: ()=>ArrayBufferTarget,
        FileSystemWritableFileStreamTarget: ()=>FileSystemWritableFileStreamTarget,
        Muxer: ()=>Muxer,
        StreamTarget: ()=>StreamTarget
    });
    // src/misc.ts
    var bytes = new Uint8Array(8);
    var view = new DataView(bytes.buffer);
    var u8 = (value1)=>{
        return [
            (value1 % 256 + 256) % 256
        ];
    };
    var u16 = (value1)=>{
        view.setUint16(0, value1, false);
        return [
            bytes[0],
            bytes[1]
        ];
    };
    var i16 = (value1)=>{
        view.setInt16(0, value1, false);
        return [
            bytes[0],
            bytes[1]
        ];
    };
    var u24 = (value1)=>{
        view.setUint32(0, value1, false);
        return [
            bytes[1],
            bytes[2],
            bytes[3]
        ];
    };
    var u32 = (value1)=>{
        view.setUint32(0, value1, false);
        return [
            bytes[0],
            bytes[1],
            bytes[2],
            bytes[3]
        ];
    };
    var i32 = (value1)=>{
        view.setInt32(0, value1, false);
        return [
            bytes[0],
            bytes[1],
            bytes[2],
            bytes[3]
        ];
    };
    var u64 = (value1)=>{
        view.setUint32(0, Math.floor(value1 / 2 ** 32), false);
        view.setUint32(4, value1, false);
        return [
            bytes[0],
            bytes[1],
            bytes[2],
            bytes[3],
            bytes[4],
            bytes[5],
            bytes[6],
            bytes[7]
        ];
    };
    var fixed_8_8 = (value1)=>{
        view.setInt16(0, 256 * value1, false);
        return [
            bytes[0],
            bytes[1]
        ];
    };
    var fixed_16_16 = (value1)=>{
        view.setInt32(0, 2 ** 16 * value1, false);
        return [
            bytes[0],
            bytes[1],
            bytes[2],
            bytes[3]
        ];
    };
    var fixed_2_30 = (value1)=>{
        view.setInt32(0, 2 ** 30 * value1, false);
        return [
            bytes[0],
            bytes[1],
            bytes[2],
            bytes[3]
        ];
    };
    var ascii = (text, nullTerminated = false)=>{
        let bytes2 = Array(text.length).fill(null).map((_, i)=>text.charCodeAt(i));
        if (nullTerminated) bytes2.push(0);
        return bytes2;
    };
    var last = (arr)=>{
        return arr && arr[arr.length - 1];
    };
    var lastPresentedSample = (samples)=>{
        let result = void 0;
        for (let sample of samples)if (!result || sample.presentationTimestamp > result.presentationTimestamp) result = sample;
        return result;
    };
    var intoTimescale = (timeInSeconds, timescale, round = true)=>{
        let value1 = timeInSeconds * timescale;
        return round ? Math.round(value1) : value1;
    };
    var rotationMatrix = (rotationInDegrees)=>{
        let theta = rotationInDegrees * (Math.PI / 180);
        let cosTheta = Math.cos(theta);
        let sinTheta = Math.sin(theta);
        return [
            cosTheta,
            sinTheta,
            0,
            -sinTheta,
            cosTheta,
            0,
            0,
            0,
            1
        ];
    };
    var IDENTITY_MATRIX = rotationMatrix(0);
    var matrixToBytes = (matrix)=>{
        return [
            fixed_16_16(matrix[0]),
            fixed_16_16(matrix[1]),
            fixed_2_30(matrix[2]),
            fixed_16_16(matrix[3]),
            fixed_16_16(matrix[4]),
            fixed_2_30(matrix[5]),
            fixed_16_16(matrix[6]),
            fixed_16_16(matrix[7]),
            fixed_2_30(matrix[8])
        ];
    };
    var deepClone = (x)=>{
        if (!x) return x;
        if (typeof x !== "object") return x;
        if (Array.isArray(x)) return x.map(deepClone);
        return Object.fromEntries(Object.entries(x).map(([key, value1])=>[
                key,
                deepClone(value1)
            ]));
    };
    var isU32 = (value1)=>{
        return value1 >= 0 && value1 < 2 ** 32;
    };
    // src/box.ts
    var box = (type, contents, children)=>({
            type: type,
            contents: contents && new Uint8Array(contents.flat(10)),
            children: children
        });
    var fullBox = (type, version, flags, contents, children)=>box(type, [
            u8(version),
            u24(flags),
            contents ?? []
        ], children);
    var ftyp = (details)=>{
        let minorVersion = 512;
        if (details.fragmented) return box("ftyp", [
            ascii("iso5"),
            // Major brand
            u32(minorVersion),
            // Minor version
            // Compatible brands
            ascii("iso5"),
            ascii("iso6"),
            ascii("mp41")
        ]);
        return box("ftyp", [
            ascii("isom"),
            // Major brand
            u32(minorVersion),
            // Minor version
            // Compatible brands
            ascii("isom"),
            details.holdsAvc ? ascii("avc1") : [],
            ascii("mp41")
        ]);
    };
    var mdat = (reserveLargeSize)=>({
            type: "mdat",
            largeSize: reserveLargeSize
        });
    var free = (size)=>({
            type: "free",
            size: size
        });
    var moov = (tracks, creationTime, fragmented = false)=>box("moov", null, [
            mvhd(creationTime, tracks),
            ...tracks.map((x)=>trak(x, creationTime)),
            fragmented ? mvex(tracks) : null
        ]);
    var mvhd = (creationTime, tracks)=>{
        let duration = intoTimescale(Math.max(0, ...tracks.filter((x)=>x.samples.length > 0).map((x)=>{
            const lastSample = lastPresentedSample(x.samples);
            return lastSample.presentationTimestamp + lastSample.duration;
        })), GLOBAL_TIMESCALE);
        let nextTrackId = Math.max(...tracks.map((x)=>x.id)) + 1;
        let needsU64 = !isU32(creationTime) || !isU32(duration);
        let u32OrU64 = needsU64 ? u64 : u32;
        return fullBox("mvhd", +needsU64, 0, [
            u32OrU64(creationTime),
            // Creation time
            u32OrU64(creationTime),
            // Modification time
            u32(GLOBAL_TIMESCALE),
            // Timescale
            u32OrU64(duration),
            // Duration
            fixed_16_16(1),
            // Preferred rate
            fixed_8_8(1),
            // Preferred volume
            Array(10).fill(0),
            // Reserved
            matrixToBytes(IDENTITY_MATRIX),
            // Matrix
            Array(24).fill(0),
            // Pre-defined
            u32(nextTrackId)
        ]);
    };
    var trak = (track, creationTime)=>box("trak", null, [
            tkhd(track, creationTime),
            mdia(track, creationTime)
        ]);
    var tkhd = (track, creationTime)=>{
        let lastSample = lastPresentedSample(track.samples);
        let durationInGlobalTimescale = intoTimescale(lastSample ? lastSample.presentationTimestamp + lastSample.duration : 0, GLOBAL_TIMESCALE);
        let needsU64 = !isU32(creationTime) || !isU32(durationInGlobalTimescale);
        let u32OrU64 = needsU64 ? u64 : u32;
        let matrix;
        if (track.info.type === "video") matrix = typeof track.info.rotation === "number" ? rotationMatrix(track.info.rotation) : track.info.rotation;
        else matrix = IDENTITY_MATRIX;
        return fullBox("tkhd", +needsU64, 3, [
            u32OrU64(creationTime),
            // Creation time
            u32OrU64(creationTime),
            // Modification time
            u32(track.id),
            // Track ID
            u32(0),
            // Reserved
            u32OrU64(durationInGlobalTimescale),
            // Duration
            Array(8).fill(0),
            // Reserved
            u16(0),
            // Layer
            u16(0),
            // Alternate group
            fixed_8_8(track.info.type === "audio" ? 1 : 0),
            // Volume
            u16(0),
            // Reserved
            matrixToBytes(matrix),
            // Matrix
            fixed_16_16(track.info.type === "video" ? track.info.width : 0),
            // Track width
            fixed_16_16(track.info.type === "video" ? track.info.height : 0)
        ]);
    };
    var mdia = (track, creationTime)=>box("mdia", null, [
            mdhd(track, creationTime),
            hdlr(track.info.type === "video" ? "vide" : "soun"),
            minf(track)
        ]);
    var mdhd = (track, creationTime)=>{
        let lastSample = lastPresentedSample(track.samples);
        let localDuration = intoTimescale(lastSample ? lastSample.presentationTimestamp + lastSample.duration : 0, track.timescale);
        let needsU64 = !isU32(creationTime) || !isU32(localDuration);
        let u32OrU64 = needsU64 ? u64 : u32;
        return fullBox("mdhd", +needsU64, 0, [
            u32OrU64(creationTime),
            // Creation time
            u32OrU64(creationTime),
            // Modification time
            u32(track.timescale),
            // Timescale
            u32OrU64(localDuration),
            // Duration
            u16(21956),
            // Language ("und", undetermined)
            u16(0)
        ]);
    };
    var hdlr = (componentSubtype)=>fullBox("hdlr", 0, 0, [
            ascii("mhlr"),
            // Component type
            ascii(componentSubtype),
            // Component subtype
            u32(0),
            // Component manufacturer
            u32(0),
            // Component flags
            u32(0),
            // Component flags mask
            ascii("mp4-muxer-hdlr", true)
        ]);
    var minf = (track)=>box("minf", null, [
            track.info.type === "video" ? vmhd() : smhd(),
            dinf(),
            stbl(track)
        ]);
    var vmhd = ()=>fullBox("vmhd", 0, 1, [
            u16(0),
            // Graphics mode
            u16(0),
            // Opcolor R
            u16(0),
            // Opcolor G
            u16(0)
        ]);
    var smhd = ()=>fullBox("smhd", 0, 0, [
            u16(0),
            // Balance
            u16(0)
        ]);
    var dinf = ()=>box("dinf", null, [
            dref()
        ]);
    var dref = ()=>fullBox("dref", 0, 0, [
            u32(1)
        ], [
            url()
        ]);
    var url = ()=>fullBox("url ", 0, 1);
    var stbl = (track)=>{
        const needsCtts = track.compositionTimeOffsetTable.length > 1 || track.compositionTimeOffsetTable.some((x)=>x.sampleCompositionTimeOffset !== 0);
        return box("stbl", null, [
            stsd(track),
            stts(track),
            stss(track),
            stsc(track),
            stsz(track),
            stco(track),
            needsCtts ? ctts(track) : null
        ]);
    };
    var stsd = (track)=>fullBox("stsd", 0, 0, [
            u32(1)
        ], [
            track.info.type === "video" ? videoSampleDescription(VIDEO_CODEC_TO_BOX_NAME[track.info.codec], track) : soundSampleDescription(AUDIO_CODEC_TO_BOX_NAME[track.info.codec], track)
        ]);
    var videoSampleDescription = (compressionType, track)=>box(compressionType, [
            Array(6).fill(0),
            // Reserved
            u16(1),
            // Data reference index
            u16(0),
            // Pre-defined
            u16(0),
            // Reserved
            Array(12).fill(0),
            // Pre-defined
            u16(track.info.width),
            // Width
            u16(track.info.height),
            // Height
            u32(4718592),
            // Horizontal resolution
            u32(4718592),
            // Vertical resolution
            u32(0),
            // Reserved
            u16(1),
            // Frame count
            Array(32).fill(0),
            // Compressor name
            u16(24),
            // Depth
            i16(65535)
        ], [
            VIDEO_CODEC_TO_CONFIGURATION_BOX[track.info.codec](track)
        ]);
    var avcC = (track)=>track.info.decoderConfig && box("avcC", [
            // For AVC, description is an AVCDecoderConfigurationRecord, so nothing else to do here
            ...new Uint8Array(track.info.decoderConfig.description)
        ]);
    var hvcC = (track)=>track.info.decoderConfig && box("hvcC", [
            // For HEVC, description is a HEVCDecoderConfigurationRecord, so nothing else to do here
            ...new Uint8Array(track.info.decoderConfig.description)
        ]);
    var vpcC = (track)=>{
        if (!track.info.decoderConfig) return null;
        let decoderConfig = track.info.decoderConfig;
        if (!decoderConfig.colorSpace) throw new Error(`'colorSpace' is required in the decoder config for VP9.`);
        let parts = decoderConfig.codec.split(".");
        let profile = Number(parts[1]);
        let level = Number(parts[2]);
        let bitDepth = Number(parts[3]);
        let chromaSubsampling = 0;
        let thirdByte = (bitDepth << 4) + (chromaSubsampling << 1) + Number(decoderConfig.colorSpace.fullRange);
        let colourPrimaries = 2;
        let transferCharacteristics = 2;
        let matrixCoefficients = 2;
        return fullBox("vpcC", 1, 0, [
            u8(profile),
            // Profile
            u8(level),
            // Level
            u8(thirdByte),
            // Bit depth, chroma subsampling, full range
            u8(colourPrimaries),
            // Colour primaries
            u8(transferCharacteristics),
            // Transfer characteristics
            u8(matrixCoefficients),
            // Matrix coefficients
            u16(0)
        ]);
    };
    var av1C = ()=>{
        let marker = 1;
        let version = 1;
        let firstByte = (marker << 7) + version;
        return box("av1C", [
            firstByte,
            0,
            0,
            0
        ]);
    };
    var soundSampleDescription = (compressionType, track)=>box(compressionType, [
            Array(6).fill(0),
            // Reserved
            u16(1),
            // Data reference index
            u16(0),
            // Version
            u16(0),
            // Revision level
            u32(0),
            // Vendor
            u16(track.info.numberOfChannels),
            // Number of channels
            u16(16),
            // Sample size (bits)
            u16(0),
            // Compression ID
            u16(0),
            // Packet size
            fixed_16_16(track.info.sampleRate)
        ], [
            AUDIO_CODEC_TO_CONFIGURATION_BOX[track.info.codec](track)
        ]);
    var esds = (track)=>{
        let description = new Uint8Array(track.info.decoderConfig.description);
        return fullBox("esds", 0, 0, [
            // https://stackoverflow.com/a/54803118
            u32(58753152),
            // TAG(3) = Object Descriptor ([2])
            u8(32 + description.byteLength),
            // length of this OD (which includes the next 2 tags)
            u16(1),
            // ES_ID = 1
            u8(0),
            // flags etc = 0
            u32(75530368),
            // TAG(4) = ES Descriptor ([2]) embedded in above OD
            u8(18 + description.byteLength),
            // length of this ESD
            u8(64),
            // MPEG-4 Audio
            u8(21),
            // stream type(6bits)=5 audio, flags(2bits)=1
            u24(0),
            // 24bit buffer size
            u32(130071),
            // max bitrate
            u32(130071),
            // avg bitrate
            u32(92307584),
            // TAG(5) = ASC ([2],[3]) embedded in above OD
            u8(description.byteLength),
            // length
            ...description,
            u32(109084800),
            // TAG(6)
            u8(1),
            // length
            u8(2)
        ]);
    };
    var dOps = (track)=>box("dOps", [
            u8(0),
            // Version
            u8(track.info.numberOfChannels),
            // OutputChannelCount
            u16(3840),
            // PreSkip, should be at least 80 milliseconds worth of playback, measured in 48000 Hz samples
            u32(track.info.sampleRate),
            // InputSampleRate
            fixed_8_8(0),
            // OutputGain
            u8(0)
        ]);
    var stts = (track)=>{
        return fullBox("stts", 0, 0, [
            u32(track.timeToSampleTable.length),
            // Number of entries
            track.timeToSampleTable.map((x)=>[
                    // Time-to-sample table
                    u32(x.sampleCount),
                    // Sample count
                    u32(x.sampleDelta)
                ])
        ]);
    };
    var stss = (track)=>{
        if (track.samples.every((x)=>x.type === "key")) return null;
        let keySamples = [
            ...track.samples.entries()
        ].filter(([, sample])=>sample.type === "key");
        return fullBox("stss", 0, 0, [
            u32(keySamples.length),
            // Number of entries
            keySamples.map(([index])=>u32(index + 1))
        ]);
    };
    var stsc = (track)=>{
        return fullBox("stsc", 0, 0, [
            u32(track.compactlyCodedChunkTable.length),
            // Number of entries
            track.compactlyCodedChunkTable.map((x)=>[
                    // Sample-to-chunk table
                    u32(x.firstChunk),
                    // First chunk
                    u32(x.samplesPerChunk),
                    // Samples per chunk
                    u32(1)
                ])
        ]);
    };
    var stsz = (track)=>fullBox("stsz", 0, 0, [
            u32(0),
            // Sample size (0 means non-constant size)
            u32(track.samples.length),
            // Number of entries
            track.samples.map((x)=>u32(x.size))
        ]);
    var stco = (track)=>{
        if (track.finalizedChunks.length > 0 && last(track.finalizedChunks).offset >= 2 ** 32) return fullBox("co64", 0, 0, [
            u32(track.finalizedChunks.length),
            // Number of entries
            track.finalizedChunks.map((x)=>u64(x.offset))
        ]);
        return fullBox("stco", 0, 0, [
            u32(track.finalizedChunks.length),
            // Number of entries
            track.finalizedChunks.map((x)=>u32(x.offset))
        ]);
    };
    var ctts = (track)=>{
        return fullBox("ctts", 0, 0, [
            u32(track.compositionTimeOffsetTable.length),
            // Number of entries
            track.compositionTimeOffsetTable.map((x)=>[
                    // Time-to-sample table
                    u32(x.sampleCount),
                    // Sample count
                    u32(x.sampleCompositionTimeOffset)
                ])
        ]);
    };
    var mvex = (tracks)=>{
        return box("mvex", null, tracks.map(trex));
    };
    var trex = (track)=>{
        return fullBox("trex", 0, 0, [
            u32(track.id),
            // Track ID
            u32(1),
            // Default sample description index
            u32(0),
            // Default sample duration
            u32(0),
            // Default sample size
            u32(0)
        ]);
    };
    var moof = (sequenceNumber, tracks)=>{
        return box("moof", null, [
            mfhd(sequenceNumber),
            ...tracks.map(traf)
        ]);
    };
    var mfhd = (sequenceNumber)=>{
        return fullBox("mfhd", 0, 0, [
            u32(sequenceNumber)
        ]);
    };
    var fragmentSampleFlags = (sample)=>{
        let byte1 = 0;
        let byte2 = 0;
        let byte3 = 0;
        let byte4 = 0;
        let sampleIsDifferenceSample = sample.type === "delta";
        byte2 |= +sampleIsDifferenceSample;
        if (sampleIsDifferenceSample) byte1 |= 1;
        else byte1 |= 2;
        return byte1 << 24 | byte2 << 16 | byte3 << 8 | byte4;
    };
    var traf = (track)=>{
        return box("traf", null, [
            tfhd(track),
            tfdt(track),
            trun(track)
        ]);
    };
    var tfhd = (track)=>{
        let tfFlags = 0;
        tfFlags |= 8;
        tfFlags |= 16;
        tfFlags |= 32;
        tfFlags |= 131072;
        let referenceSample = track.currentChunk.samples[1] ?? track.currentChunk.samples[0];
        let referenceSampleInfo = {
            duration: referenceSample.timescaleUnitsToNextSample,
            size: referenceSample.size,
            flags: fragmentSampleFlags(referenceSample)
        };
        return fullBox("tfhd", 0, tfFlags, [
            u32(track.id),
            // Track ID
            u32(referenceSampleInfo.duration),
            // Default sample duration
            u32(referenceSampleInfo.size),
            // Default sample size
            u32(referenceSampleInfo.flags)
        ]);
    };
    var tfdt = (track)=>{
        return fullBox("tfdt", 1, 0, [
            u64(intoTimescale(track.currentChunk.startTimestamp, track.timescale))
        ]);
    };
    var trun = (track)=>{
        let allSampleDurations = track.currentChunk.samples.map((x)=>x.timescaleUnitsToNextSample);
        let allSampleSizes = track.currentChunk.samples.map((x)=>x.size);
        let allSampleFlags = track.currentChunk.samples.map(fragmentSampleFlags);
        let allSampleCompositionTimeOffsets = track.currentChunk.samples.map((x)=>intoTimescale(x.presentationTimestamp - x.decodeTimestamp, track.timescale));
        let uniqueSampleDurations = new Set(allSampleDurations);
        let uniqueSampleSizes = new Set(allSampleSizes);
        let uniqueSampleFlags = new Set(allSampleFlags);
        let uniqueSampleCompositionTimeOffsets = new Set(allSampleCompositionTimeOffsets);
        let firstSampleFlagsPresent = uniqueSampleFlags.size === 2 && allSampleFlags[0] !== allSampleFlags[1];
        let sampleDurationPresent = uniqueSampleDurations.size > 1;
        let sampleSizePresent = uniqueSampleSizes.size > 1;
        let sampleFlagsPresent = !firstSampleFlagsPresent && uniqueSampleFlags.size > 1;
        let sampleCompositionTimeOffsetsPresent = uniqueSampleCompositionTimeOffsets.size > 1 || [
            ...uniqueSampleCompositionTimeOffsets
        ].some((x)=>x !== 0);
        let flags = 0;
        flags |= 1;
        flags |= 4 * +firstSampleFlagsPresent;
        flags |= 256 * +sampleDurationPresent;
        flags |= 512 * +sampleSizePresent;
        flags |= 1024 * +sampleFlagsPresent;
        flags |= 2048 * +sampleCompositionTimeOffsetsPresent;
        return fullBox("trun", 1, flags, [
            u32(track.currentChunk.samples.length),
            // Sample count
            u32(track.currentChunk.offset - track.currentChunk.moofOffset || 0),
            // Data offset
            firstSampleFlagsPresent ? u32(allSampleFlags[0]) : [],
            track.currentChunk.samples.map((_, i)=>[
                    sampleDurationPresent ? u32(allSampleDurations[i]) : [],
                    // Sample duration
                    sampleSizePresent ? u32(allSampleSizes[i]) : [],
                    // Sample size
                    sampleFlagsPresent ? u32(allSampleFlags[i]) : [],
                    // Sample flags
                    // Sample composition time offsets
                    sampleCompositionTimeOffsetsPresent ? i32(allSampleCompositionTimeOffsets[i]) : []
                ])
        ]);
    };
    var mfra = (tracks)=>{
        return box("mfra", null, [
            ...tracks.map(tfra),
            mfro()
        ]);
    };
    var tfra = (track, trackIndex)=>{
        let version = 1;
        return fullBox("tfra", version, 0, [
            u32(track.id),
            // Track ID
            u32(63),
            // This specifies that traf number, trun number and sample number are 32-bit ints
            u32(track.finalizedChunks.length),
            // Number of entries
            track.finalizedChunks.map((chunk)=>[
                    u64(intoTimescale(chunk.startTimestamp, track.timescale)),
                    // Time
                    u64(chunk.moofOffset),
                    // moof offset
                    u32(trackIndex + 1),
                    // traf number
                    u32(1),
                    // trun number
                    u32(1)
                ])
        ]);
    };
    var mfro = ()=>{
        return fullBox("mfro", 0, 0, [
            // This value needs to be overwritten manually from the outside, where the actual size of the enclosing mfra box
            // is known
            u32(0)
        ]);
    };
    var VIDEO_CODEC_TO_BOX_NAME = {
        "avc": "avc1",
        "hevc": "hvc1",
        "vp9": "vp09",
        "av1": "av01"
    };
    var VIDEO_CODEC_TO_CONFIGURATION_BOX = {
        "avc": avcC,
        "hevc": hvcC,
        "vp9": vpcC,
        "av1": av1C
    };
    var AUDIO_CODEC_TO_BOX_NAME = {
        "aac": "mp4a",
        "opus": "Opus"
    };
    var AUDIO_CODEC_TO_CONFIGURATION_BOX = {
        "aac": esds,
        "opus": dOps
    };
    // src/target.ts
    var ArrayBufferTarget = class {
        constructor(){
            this.buffer = null;
        }
    };
    var StreamTarget = class {
        constructor(options){
            this.options = options;
        }
    };
    var FileSystemWritableFileStreamTarget = class {
        constructor(stream, options){
            this.stream = stream;
            this.options = options;
        }
    };
    // src/writer.ts
    var _helper, _helperView;
    var Writer = class {
        constructor(){
            this.pos = 0;
            __privateAdd(this, _helper, new Uint8Array(8));
            __privateAdd(this, _helperView, new DataView(__privateGet(this, _helper).buffer));
            /**
         * Stores the position from the start of the file to where boxes elements have been written. This is used to
         * rewrite/edit elements that were already added before, and to measure sizes of things.
         */ this.offsets = /* @__PURE__ */ new WeakMap();
        }
        /** Sets the current position for future writes to a new one. */ seek(newPos) {
            this.pos = newPos;
        }
        writeU32(value1) {
            __privateGet(this, _helperView).setUint32(0, value1, false);
            this.write(__privateGet(this, _helper).subarray(0, 4));
        }
        writeU64(value1) {
            __privateGet(this, _helperView).setUint32(0, Math.floor(value1 / 2 ** 32), false);
            __privateGet(this, _helperView).setUint32(4, value1, false);
            this.write(__privateGet(this, _helper).subarray(0, 8));
        }
        writeAscii(text) {
            for(let i = 0; i < text.length; i++){
                __privateGet(this, _helperView).setUint8(i % 8, text.charCodeAt(i));
                if (i % 8 === 7) this.write(__privateGet(this, _helper));
            }
            if (text.length % 8 !== 0) this.write(__privateGet(this, _helper).subarray(0, text.length % 8));
        }
        writeBox(box2) {
            this.offsets.set(box2, this.pos);
            if (box2.contents && !box2.children) {
                this.writeBoxHeader(box2, box2.size ?? box2.contents.byteLength + 8);
                this.write(box2.contents);
            } else {
                let startPos = this.pos;
                this.writeBoxHeader(box2, 0);
                if (box2.contents) this.write(box2.contents);
                if (box2.children) {
                    for (let child of box2.children)if (child) this.writeBox(child);
                }
                let endPos = this.pos;
                let size = box2.size ?? endPos - startPos;
                this.seek(startPos);
                this.writeBoxHeader(box2, size);
                this.seek(endPos);
            }
        }
        writeBoxHeader(box2, size) {
            this.writeU32(box2.largeSize ? 1 : size);
            this.writeAscii(box2.type);
            if (box2.largeSize) this.writeU64(size);
        }
        measureBoxHeader(box2) {
            return 8 + (box2.largeSize ? 8 : 0);
        }
        patchBox(box2) {
            let endPos = this.pos;
            this.seek(this.offsets.get(box2));
            this.writeBox(box2);
            this.seek(endPos);
        }
        measureBox(box2) {
            if (box2.contents && !box2.children) {
                let headerSize = this.measureBoxHeader(box2);
                return headerSize + box2.contents.byteLength;
            } else {
                let result = this.measureBoxHeader(box2);
                if (box2.contents) result += box2.contents.byteLength;
                if (box2.children) {
                    for (let child of box2.children)if (child) result += this.measureBox(child);
                }
                return result;
            }
        }
    };
    _helper = new WeakMap();
    _helperView = new WeakMap();
    var _target, _buffer, _bytes, _maxPos, _ensureSize, ensureSize_fn;
    var ArrayBufferTargetWriter = class extends Writer {
        constructor(target){
            super();
            __privateAdd(this, _ensureSize);
            __privateAdd(this, _target, void 0);
            __privateAdd(this, _buffer, new ArrayBuffer(2 ** 16));
            __privateAdd(this, _bytes, new Uint8Array(__privateGet(this, _buffer)));
            __privateAdd(this, _maxPos, 0);
            __privateSet(this, _target, target);
        }
        write(data) {
            __privateMethod(this, _ensureSize, ensureSize_fn).call(this, this.pos + data.byteLength);
            __privateGet(this, _bytes).set(data, this.pos);
            this.pos += data.byteLength;
            __privateSet(this, _maxPos, Math.max(__privateGet(this, _maxPos), this.pos));
        }
        finalize() {
            __privateMethod(this, _ensureSize, ensureSize_fn).call(this, this.pos);
            __privateGet(this, _target).buffer = __privateGet(this, _buffer).slice(0, Math.max(__privateGet(this, _maxPos), this.pos));
        }
    };
    _target = new WeakMap();
    _buffer = new WeakMap();
    _bytes = new WeakMap();
    _maxPos = new WeakMap();
    _ensureSize = new WeakSet();
    ensureSize_fn = function(size) {
        let newLength = __privateGet(this, _buffer).byteLength;
        while(newLength < size)newLength *= 2;
        if (newLength === __privateGet(this, _buffer).byteLength) return;
        let newBuffer = new ArrayBuffer(newLength);
        let newBytes = new Uint8Array(newBuffer);
        newBytes.set(__privateGet(this, _bytes), 0);
        __privateSet(this, _buffer, newBuffer);
        __privateSet(this, _bytes, newBytes);
    };
    var _target2, _sections;
    var StreamTargetWriter = class extends Writer {
        constructor(target){
            super();
            __privateAdd(this, _target2, void 0);
            __privateAdd(this, _sections, []);
            __privateSet(this, _target2, target);
        }
        write(data) {
            __privateGet(this, _sections).push({
                data: data.slice(),
                start: this.pos
            });
            this.pos += data.byteLength;
        }
        flush() {
            if (__privateGet(this, _sections).length === 0) return;
            let chunks = [];
            let sorted = [
                ...__privateGet(this, _sections)
            ].sort((a, b)=>a.start - b.start);
            chunks.push({
                start: sorted[0].start,
                size: sorted[0].data.byteLength
            });
            for(let i = 1; i < sorted.length; i++){
                let lastChunk = chunks[chunks.length - 1];
                let section = sorted[i];
                if (section.start <= lastChunk.start + lastChunk.size) lastChunk.size = Math.max(lastChunk.size, section.start + section.data.byteLength - lastChunk.start);
                else chunks.push({
                    start: section.start,
                    size: section.data.byteLength
                });
            }
            for (let chunk of chunks){
                chunk.data = new Uint8Array(chunk.size);
                for (let section of __privateGet(this, _sections))if (chunk.start <= section.start && section.start < chunk.start + chunk.size) chunk.data.set(section.data, section.start - chunk.start);
                __privateGet(this, _target2).options.onData?.(chunk.data, chunk.start);
            }
            __privateGet(this, _sections).length = 0;
        }
        finalize() {}
    };
    _target2 = new WeakMap();
    _sections = new WeakMap();
    var DEFAULT_CHUNK_SIZE = 2 ** 24;
    var MAX_CHUNKS_AT_ONCE = 2;
    var _target3, _chunkSize, _chunks, _writeDataIntoChunks, writeDataIntoChunks_fn, _insertSectionIntoChunk, insertSectionIntoChunk_fn, _createChunk, createChunk_fn, _flushChunks, flushChunks_fn;
    var ChunkedStreamTargetWriter = class extends Writer {
        constructor(target){
            super();
            __privateAdd(this, _writeDataIntoChunks);
            __privateAdd(this, _insertSectionIntoChunk);
            __privateAdd(this, _createChunk);
            __privateAdd(this, _flushChunks);
            __privateAdd(this, _target3, void 0);
            __privateAdd(this, _chunkSize, void 0);
            /**
         * The data is divided up into fixed-size chunks, whose contents are first filled in RAM and then flushed out.
         * A chunk is flushed if all of its contents have been written.
         */ __privateAdd(this, _chunks, []);
            __privateSet(this, _target3, target);
            __privateSet(this, _chunkSize, target.options?.chunkSize ?? DEFAULT_CHUNK_SIZE);
            if (!Number.isInteger(__privateGet(this, _chunkSize)) || __privateGet(this, _chunkSize) < 1024) throw new Error("Invalid StreamTarget options: chunkSize must be an integer not smaller than 1024.");
        }
        write(data) {
            __privateMethod(this, _writeDataIntoChunks, writeDataIntoChunks_fn).call(this, data, this.pos);
            __privateMethod(this, _flushChunks, flushChunks_fn).call(this);
            this.pos += data.byteLength;
        }
        finalize() {
            __privateMethod(this, _flushChunks, flushChunks_fn).call(this, true);
        }
    };
    _target3 = new WeakMap();
    _chunkSize = new WeakMap();
    _chunks = new WeakMap();
    _writeDataIntoChunks = new WeakSet();
    writeDataIntoChunks_fn = function(data, position) {
        let chunkIndex = __privateGet(this, _chunks).findIndex((x)=>x.start <= position && position < x.start + __privateGet(this, _chunkSize));
        if (chunkIndex === -1) chunkIndex = __privateMethod(this, _createChunk, createChunk_fn).call(this, position);
        let chunk = __privateGet(this, _chunks)[chunkIndex];
        let relativePosition = position - chunk.start;
        let toWrite = data.subarray(0, Math.min(__privateGet(this, _chunkSize) - relativePosition, data.byteLength));
        chunk.data.set(toWrite, relativePosition);
        let section = {
            start: relativePosition,
            end: relativePosition + toWrite.byteLength
        };
        __privateMethod(this, _insertSectionIntoChunk, insertSectionIntoChunk_fn).call(this, chunk, section);
        if (chunk.written[0].start === 0 && chunk.written[0].end === __privateGet(this, _chunkSize)) chunk.shouldFlush = true;
        if (__privateGet(this, _chunks).length > MAX_CHUNKS_AT_ONCE) {
            for(let i = 0; i < __privateGet(this, _chunks).length - 1; i++)__privateGet(this, _chunks)[i].shouldFlush = true;
            __privateMethod(this, _flushChunks, flushChunks_fn).call(this);
        }
        if (toWrite.byteLength < data.byteLength) __privateMethod(this, _writeDataIntoChunks, writeDataIntoChunks_fn).call(this, data.subarray(toWrite.byteLength), position + toWrite.byteLength);
    };
    _insertSectionIntoChunk = new WeakSet();
    insertSectionIntoChunk_fn = function(chunk, section) {
        let low = 0;
        let high = chunk.written.length - 1;
        let index = -1;
        while(low <= high){
            let mid = Math.floor(low + (high - low + 1) / 2);
            if (chunk.written[mid].start <= section.start) {
                low = mid + 1;
                index = mid;
            } else high = mid - 1;
        }
        chunk.written.splice(index + 1, 0, section);
        if (index === -1 || chunk.written[index].end < section.start) index++;
        while(index < chunk.written.length - 1 && chunk.written[index].end >= chunk.written[index + 1].start){
            chunk.written[index].end = Math.max(chunk.written[index].end, chunk.written[index + 1].end);
            chunk.written.splice(index + 1, 1);
        }
    };
    _createChunk = new WeakSet();
    createChunk_fn = function(includesPosition) {
        let start = Math.floor(includesPosition / __privateGet(this, _chunkSize)) * __privateGet(this, _chunkSize);
        let chunk = {
            start: start,
            data: new Uint8Array(__privateGet(this, _chunkSize)),
            written: [],
            shouldFlush: false
        };
        __privateGet(this, _chunks).push(chunk);
        __privateGet(this, _chunks).sort((a, b)=>a.start - b.start);
        return __privateGet(this, _chunks).indexOf(chunk);
    };
    _flushChunks = new WeakSet();
    flushChunks_fn = function(force = false) {
        for(let i = 0; i < __privateGet(this, _chunks).length; i++){
            let chunk = __privateGet(this, _chunks)[i];
            if (!chunk.shouldFlush && !force) continue;
            for (let section of chunk.written)__privateGet(this, _target3).options.onData?.(chunk.data.subarray(section.start, section.end), chunk.start + section.start);
            __privateGet(this, _chunks).splice(i--, 1);
        }
    };
    var FileSystemWritableFileStreamTargetWriter = class extends ChunkedStreamTargetWriter {
        constructor(target){
            super(new StreamTarget({
                onData: (data, position)=>target.stream.write({
                        type: "write",
                        data: data,
                        position: position
                    }),
                chunkSize: target.options?.chunkSize
            }));
        }
    };
    // src/muxer.ts
    var GLOBAL_TIMESCALE = 1e3;
    var SUPPORTED_VIDEO_CODECS2 = [
        "avc",
        "hevc",
        "vp9",
        "av1"
    ];
    var SUPPORTED_AUDIO_CODECS2 = [
        "aac",
        "opus"
    ];
    var TIMESTAMP_OFFSET = 2082844800;
    var FIRST_TIMESTAMP_BEHAVIORS = [
        "strict",
        "offset",
        "cross-track-offset"
    ];
    var _options, _writer, _ftypSize, _mdat, _videoTrack, _audioTrack, _creationTime, _finalizedChunks, _nextFragmentNumber, _videoSampleQueue, _audioSampleQueue, _finalized, _validateOptions, validateOptions_fn, _writeHeader, writeHeader_fn, _computeMoovSizeUpperBound, computeMoovSizeUpperBound_fn, _prepareTracks, prepareTracks_fn, _generateMpeg4AudioSpecificConfig, generateMpeg4AudioSpecificConfig_fn, _createSampleForTrack, createSampleForTrack_fn, _addSampleToTrack, addSampleToTrack_fn, _validateTimestamp, validateTimestamp_fn, _finalizeCurrentChunk, finalizeCurrentChunk_fn, _finalizeFragment, finalizeFragment_fn, _maybeFlushStreamingTargetWriter, maybeFlushStreamingTargetWriter_fn, _ensureNotFinalized, ensureNotFinalized_fn;
    var Muxer = class {
        constructor(options){
            __privateAdd(this, _validateOptions);
            __privateAdd(this, _writeHeader);
            __privateAdd(this, _computeMoovSizeUpperBound);
            __privateAdd(this, _prepareTracks);
            // https://wiki.multimedia.cx/index.php/MPEG-4_Audio
            __privateAdd(this, _generateMpeg4AudioSpecificConfig);
            __privateAdd(this, _createSampleForTrack);
            __privateAdd(this, _addSampleToTrack);
            __privateAdd(this, _validateTimestamp);
            __privateAdd(this, _finalizeCurrentChunk);
            __privateAdd(this, _finalizeFragment);
            __privateAdd(this, _maybeFlushStreamingTargetWriter);
            __privateAdd(this, _ensureNotFinalized);
            __privateAdd(this, _options, void 0);
            __privateAdd(this, _writer, void 0);
            __privateAdd(this, _ftypSize, void 0);
            __privateAdd(this, _mdat, void 0);
            __privateAdd(this, _videoTrack, null);
            __privateAdd(this, _audioTrack, null);
            __privateAdd(this, _creationTime, Math.floor(Date.now() / 1e3) + TIMESTAMP_OFFSET);
            __privateAdd(this, _finalizedChunks, []);
            // Fields for fragmented MP4:
            __privateAdd(this, _nextFragmentNumber, 1);
            __privateAdd(this, _videoSampleQueue, []);
            __privateAdd(this, _audioSampleQueue, []);
            __privateAdd(this, _finalized, false);
            __privateMethod(this, _validateOptions, validateOptions_fn).call(this, options);
            options.video = deepClone(options.video);
            options.audio = deepClone(options.audio);
            options.fastStart = deepClone(options.fastStart);
            this.target = options.target;
            __privateSet(this, _options, {
                firstTimestampBehavior: "strict",
                ...options
            });
            if (options.target instanceof ArrayBufferTarget) __privateSet(this, _writer, new ArrayBufferTargetWriter(options.target));
            else if (options.target instanceof StreamTarget) __privateSet(this, _writer, options.target.options?.chunked ? new ChunkedStreamTargetWriter(options.target) : new StreamTargetWriter(options.target));
            else if (options.target instanceof FileSystemWritableFileStreamTarget) __privateSet(this, _writer, new FileSystemWritableFileStreamTargetWriter(options.target));
            else throw new Error(`Invalid target: ${options.target}`);
            __privateMethod(this, _prepareTracks, prepareTracks_fn).call(this);
            __privateMethod(this, _writeHeader, writeHeader_fn).call(this);
        }
        addVideoChunk(sample, meta, timestamp, compositionTimeOffset) {
            let data = new Uint8Array(sample.byteLength);
            sample.copyTo(data);
            this.addVideoChunkRaw(data, sample.type, timestamp ?? sample.timestamp, sample.duration, meta, compositionTimeOffset);
        }
        addVideoChunkRaw(data, type, timestamp, duration, meta, compositionTimeOffset) {
            __privateMethod(this, _ensureNotFinalized, ensureNotFinalized_fn).call(this);
            if (!__privateGet(this, _options).video) throw new Error("No video track declared.");
            if (typeof __privateGet(this, _options).fastStart === "object" && __privateGet(this, _videoTrack).samples.length === __privateGet(this, _options).fastStart.expectedVideoChunks) throw new Error(`Cannot add more video chunks than specified in 'fastStart' (${__privateGet(this, _options).fastStart.expectedVideoChunks}).`);
            let videoSample = __privateMethod(this, _createSampleForTrack, createSampleForTrack_fn).call(this, __privateGet(this, _videoTrack), data, type, timestamp, duration, meta, compositionTimeOffset);
            if (__privateGet(this, _options).fastStart === "fragmented" && __privateGet(this, _audioTrack)) {
                while(__privateGet(this, _audioSampleQueue).length > 0 && __privateGet(this, _audioSampleQueue)[0].decodeTimestamp <= videoSample.decodeTimestamp){
                    let audioSample = __privateGet(this, _audioSampleQueue).shift();
                    __privateMethod(this, _addSampleToTrack, addSampleToTrack_fn).call(this, __privateGet(this, _audioTrack), audioSample);
                }
                if (videoSample.decodeTimestamp <= __privateGet(this, _audioTrack).lastDecodeTimestamp) __privateMethod(this, _addSampleToTrack, addSampleToTrack_fn).call(this, __privateGet(this, _videoTrack), videoSample);
                else __privateGet(this, _videoSampleQueue).push(videoSample);
            } else __privateMethod(this, _addSampleToTrack, addSampleToTrack_fn).call(this, __privateGet(this, _videoTrack), videoSample);
        }
        addAudioChunk(sample, meta, timestamp) {
            let data = new Uint8Array(sample.byteLength);
            sample.copyTo(data);
            this.addAudioChunkRaw(data, sample.type, timestamp ?? sample.timestamp, sample.duration, meta);
        }
        addAudioChunkRaw(data, type, timestamp, duration, meta) {
            __privateMethod(this, _ensureNotFinalized, ensureNotFinalized_fn).call(this);
            if (!__privateGet(this, _options).audio) throw new Error("No audio track declared.");
            if (typeof __privateGet(this, _options).fastStart === "object" && __privateGet(this, _audioTrack).samples.length === __privateGet(this, _options).fastStart.expectedAudioChunks) throw new Error(`Cannot add more audio chunks than specified in 'fastStart' (${__privateGet(this, _options).fastStart.expectedAudioChunks}).`);
            let audioSample = __privateMethod(this, _createSampleForTrack, createSampleForTrack_fn).call(this, __privateGet(this, _audioTrack), data, type, timestamp, duration, meta);
            if (__privateGet(this, _options).fastStart === "fragmented" && __privateGet(this, _videoTrack)) {
                while(__privateGet(this, _videoSampleQueue).length > 0 && __privateGet(this, _videoSampleQueue)[0].decodeTimestamp <= audioSample.decodeTimestamp){
                    let videoSample = __privateGet(this, _videoSampleQueue).shift();
                    __privateMethod(this, _addSampleToTrack, addSampleToTrack_fn).call(this, __privateGet(this, _videoTrack), videoSample);
                }
                if (audioSample.decodeTimestamp <= __privateGet(this, _videoTrack).lastDecodeTimestamp) __privateMethod(this, _addSampleToTrack, addSampleToTrack_fn).call(this, __privateGet(this, _audioTrack), audioSample);
                else __privateGet(this, _audioSampleQueue).push(audioSample);
            } else __privateMethod(this, _addSampleToTrack, addSampleToTrack_fn).call(this, __privateGet(this, _audioTrack), audioSample);
        }
        /** Finalizes the file, making it ready for use. Must be called after all video and audio chunks have been added. */ finalize() {
            if (__privateGet(this, _finalized)) throw new Error("Cannot finalize a muxer more than once.");
            if (__privateGet(this, _options).fastStart === "fragmented") {
                for (let videoSample of __privateGet(this, _videoSampleQueue))__privateMethod(this, _addSampleToTrack, addSampleToTrack_fn).call(this, __privateGet(this, _videoTrack), videoSample);
                for (let audioSample of __privateGet(this, _audioSampleQueue))__privateMethod(this, _addSampleToTrack, addSampleToTrack_fn).call(this, __privateGet(this, _audioTrack), audioSample);
                __privateMethod(this, _finalizeFragment, finalizeFragment_fn).call(this, false);
            } else {
                if (__privateGet(this, _videoTrack)) __privateMethod(this, _finalizeCurrentChunk, finalizeCurrentChunk_fn).call(this, __privateGet(this, _videoTrack));
                if (__privateGet(this, _audioTrack)) __privateMethod(this, _finalizeCurrentChunk, finalizeCurrentChunk_fn).call(this, __privateGet(this, _audioTrack));
            }
            let tracks = [
                __privateGet(this, _videoTrack),
                __privateGet(this, _audioTrack)
            ].filter(Boolean);
            if (__privateGet(this, _options).fastStart === "in-memory") {
                let mdatSize;
                for(let i = 0; i < 2; i++){
                    let movieBox2 = moov(tracks, __privateGet(this, _creationTime));
                    let movieBoxSize = __privateGet(this, _writer).measureBox(movieBox2);
                    mdatSize = __privateGet(this, _writer).measureBox(__privateGet(this, _mdat));
                    let currentChunkPos = __privateGet(this, _writer).pos + movieBoxSize + mdatSize;
                    for (let chunk of __privateGet(this, _finalizedChunks)){
                        chunk.offset = currentChunkPos;
                        for (let { data: data } of chunk.samples){
                            currentChunkPos += data.byteLength;
                            mdatSize += data.byteLength;
                        }
                    }
                    if (currentChunkPos < 2 ** 32) break;
                    if (mdatSize >= 2 ** 32) __privateGet(this, _mdat).largeSize = true;
                }
                let movieBox = moov(tracks, __privateGet(this, _creationTime));
                __privateGet(this, _writer).writeBox(movieBox);
                __privateGet(this, _mdat).size = mdatSize;
                __privateGet(this, _writer).writeBox(__privateGet(this, _mdat));
                for (let chunk of __privateGet(this, _finalizedChunks))for (let sample of chunk.samples){
                    __privateGet(this, _writer).write(sample.data);
                    sample.data = null;
                }
            } else if (__privateGet(this, _options).fastStart === "fragmented") {
                let startPos = __privateGet(this, _writer).pos;
                let mfraBox = mfra(tracks);
                __privateGet(this, _writer).writeBox(mfraBox);
                let mfraBoxSize = __privateGet(this, _writer).pos - startPos;
                __privateGet(this, _writer).seek(__privateGet(this, _writer).pos - 4);
                __privateGet(this, _writer).writeU32(mfraBoxSize);
            } else {
                let mdatPos = __privateGet(this, _writer).offsets.get(__privateGet(this, _mdat));
                let mdatSize = __privateGet(this, _writer).pos - mdatPos;
                __privateGet(this, _mdat).size = mdatSize;
                __privateGet(this, _mdat).largeSize = mdatSize >= 2 ** 32;
                __privateGet(this, _writer).patchBox(__privateGet(this, _mdat));
                let movieBox = moov(tracks, __privateGet(this, _creationTime));
                if (typeof __privateGet(this, _options).fastStart === "object") {
                    __privateGet(this, _writer).seek(__privateGet(this, _ftypSize));
                    __privateGet(this, _writer).writeBox(movieBox);
                    let remainingBytes = mdatPos - __privateGet(this, _writer).pos;
                    __privateGet(this, _writer).writeBox(free(remainingBytes));
                } else __privateGet(this, _writer).writeBox(movieBox);
            }
            __privateMethod(this, _maybeFlushStreamingTargetWriter, maybeFlushStreamingTargetWriter_fn).call(this);
            __privateGet(this, _writer).finalize();
            __privateSet(this, _finalized, true);
        }
    };
    _options = new WeakMap();
    _writer = new WeakMap();
    _ftypSize = new WeakMap();
    _mdat = new WeakMap();
    _videoTrack = new WeakMap();
    _audioTrack = new WeakMap();
    _creationTime = new WeakMap();
    _finalizedChunks = new WeakMap();
    _nextFragmentNumber = new WeakMap();
    _videoSampleQueue = new WeakMap();
    _audioSampleQueue = new WeakMap();
    _finalized = new WeakMap();
    _validateOptions = new WeakSet();
    validateOptions_fn = function(options) {
        if (options.video) {
            if (!SUPPORTED_VIDEO_CODECS2.includes(options.video.codec)) throw new Error(`Unsupported video codec: ${options.video.codec}`);
            const videoRotation = options.video.rotation;
            if (typeof videoRotation === "number" && ![
                0,
                90,
                180,
                270
            ].includes(videoRotation)) throw new Error(`Invalid video rotation: ${videoRotation}. Has to be 0, 90, 180 or 270.`);
            else if (Array.isArray(videoRotation) && (videoRotation.length !== 9 || videoRotation.some((value1)=>typeof value1 !== "number"))) throw new Error(`Invalid video transformation matrix: ${videoRotation.join()}`);
        }
        if (options.audio && !SUPPORTED_AUDIO_CODECS2.includes(options.audio.codec)) throw new Error(`Unsupported audio codec: ${options.audio.codec}`);
        if (options.firstTimestampBehavior && !FIRST_TIMESTAMP_BEHAVIORS.includes(options.firstTimestampBehavior)) throw new Error(`Invalid first timestamp behavior: ${options.firstTimestampBehavior}`);
        if (typeof options.fastStart === "object") {
            if (options.video && options.fastStart.expectedVideoChunks === void 0) throw new Error(`'fastStart' is an object but is missing property 'expectedVideoChunks'.`);
            if (options.audio && options.fastStart.expectedAudioChunks === void 0) throw new Error(`'fastStart' is an object but is missing property 'expectedAudioChunks'.`);
        } else if (![
            false,
            "in-memory",
            "fragmented"
        ].includes(options.fastStart)) throw new Error(`'fastStart' option must be false, 'in-memory', 'fragmented' or an object.`);
    };
    _writeHeader = new WeakSet();
    writeHeader_fn = function() {
        __privateGet(this, _writer).writeBox(ftyp({
            holdsAvc: __privateGet(this, _options).video?.codec === "avc",
            fragmented: __privateGet(this, _options).fastStart === "fragmented"
        }));
        __privateSet(this, _ftypSize, __privateGet(this, _writer).pos);
        if (__privateGet(this, _options).fastStart === "in-memory") __privateSet(this, _mdat, mdat(false));
        else if (__privateGet(this, _options).fastStart === "fragmented") ;
        else {
            if (typeof __privateGet(this, _options).fastStart === "object") {
                let moovSizeUpperBound = __privateMethod(this, _computeMoovSizeUpperBound, computeMoovSizeUpperBound_fn).call(this);
                __privateGet(this, _writer).seek(__privateGet(this, _writer).pos + moovSizeUpperBound);
            }
            __privateSet(this, _mdat, mdat(true));
            __privateGet(this, _writer).writeBox(__privateGet(this, _mdat));
        }
        __privateMethod(this, _maybeFlushStreamingTargetWriter, maybeFlushStreamingTargetWriter_fn).call(this);
    };
    _computeMoovSizeUpperBound = new WeakSet();
    computeMoovSizeUpperBound_fn = function() {
        if (typeof __privateGet(this, _options).fastStart !== "object") return;
        let upperBound = 0;
        let sampleCounts = [
            __privateGet(this, _options).fastStart.expectedVideoChunks,
            __privateGet(this, _options).fastStart.expectedAudioChunks
        ];
        for (let n of sampleCounts){
            if (!n) continue;
            upperBound += 8 * Math.ceil(2 / 3 * n);
            upperBound += 4 * n;
            upperBound += 12 * Math.ceil(2 / 3 * n);
            upperBound += 4 * n;
            upperBound += 8 * n;
        }
        upperBound += 4096;
        return upperBound;
    };
    _prepareTracks = new WeakSet();
    prepareTracks_fn = function() {
        if (__privateGet(this, _options).video) __privateSet(this, _videoTrack, {
            id: 1,
            info: {
                type: "video",
                codec: __privateGet(this, _options).video.codec,
                width: __privateGet(this, _options).video.width,
                height: __privateGet(this, _options).video.height,
                rotation: __privateGet(this, _options).video.rotation ?? 0,
                decoderConfig: null
            },
            timescale: 11520,
            // Timescale used by FFmpeg, contains many common frame rates as factors
            samples: [],
            finalizedChunks: [],
            currentChunk: null,
            firstDecodeTimestamp: void 0,
            lastDecodeTimestamp: -1,
            timeToSampleTable: [],
            compositionTimeOffsetTable: [],
            lastTimescaleUnits: null,
            lastSample: null,
            compactlyCodedChunkTable: []
        });
        if (__privateGet(this, _options).audio) {
            let guessedCodecPrivate = __privateMethod(this, _generateMpeg4AudioSpecificConfig, generateMpeg4AudioSpecificConfig_fn).call(this, 2, // Object type for AAC-LC, since it's the most common
            __privateGet(this, _options).audio.sampleRate, __privateGet(this, _options).audio.numberOfChannels);
            __privateSet(this, _audioTrack, {
                id: __privateGet(this, _options).video ? 2 : 1,
                info: {
                    type: "audio",
                    codec: __privateGet(this, _options).audio.codec,
                    numberOfChannels: __privateGet(this, _options).audio.numberOfChannels,
                    sampleRate: __privateGet(this, _options).audio.sampleRate,
                    decoderConfig: {
                        codec: __privateGet(this, _options).audio.codec,
                        description: guessedCodecPrivate,
                        numberOfChannels: __privateGet(this, _options).audio.numberOfChannels,
                        sampleRate: __privateGet(this, _options).audio.sampleRate
                    }
                },
                timescale: __privateGet(this, _options).audio.sampleRate,
                samples: [],
                finalizedChunks: [],
                currentChunk: null,
                firstDecodeTimestamp: void 0,
                lastDecodeTimestamp: -1,
                timeToSampleTable: [],
                compositionTimeOffsetTable: [],
                lastTimescaleUnits: null,
                lastSample: null,
                compactlyCodedChunkTable: []
            });
        }
    };
    _generateMpeg4AudioSpecificConfig = new WeakSet();
    generateMpeg4AudioSpecificConfig_fn = function(objectType, sampleRate, numberOfChannels) {
        let frequencyIndices = [
            96e3,
            88200,
            64e3,
            48e3,
            44100,
            32e3,
            24e3,
            22050,
            16e3,
            12e3,
            11025,
            8e3,
            7350
        ];
        let frequencyIndex = frequencyIndices.indexOf(sampleRate);
        let channelConfig = numberOfChannels;
        let configBits = "";
        configBits += objectType.toString(2).padStart(5, "0");
        configBits += frequencyIndex.toString(2).padStart(4, "0");
        if (frequencyIndex === 15) configBits += sampleRate.toString(2).padStart(24, "0");
        configBits += channelConfig.toString(2).padStart(4, "0");
        let paddingLength = Math.ceil(configBits.length / 8) * 8;
        configBits = configBits.padEnd(paddingLength, "0");
        let configBytes = new Uint8Array(configBits.length / 8);
        for(let i = 0; i < configBits.length; i += 8)configBytes[i / 8] = parseInt(configBits.slice(i, i + 8), 2);
        return configBytes;
    };
    _createSampleForTrack = new WeakSet();
    createSampleForTrack_fn = function(track, data, type, timestamp, duration, meta, compositionTimeOffset) {
        let presentationTimestampInSeconds = timestamp / 1e6;
        let decodeTimestampInSeconds = (timestamp - (compositionTimeOffset ?? 0)) / 1e6;
        let durationInSeconds = duration / 1e6;
        let adjusted = __privateMethod(this, _validateTimestamp, validateTimestamp_fn).call(this, presentationTimestampInSeconds, decodeTimestampInSeconds, track);
        presentationTimestampInSeconds = adjusted.presentationTimestamp;
        decodeTimestampInSeconds = adjusted.decodeTimestamp;
        if (meta?.decoderConfig) {
            if (track.info.decoderConfig === null) track.info.decoderConfig = meta.decoderConfig;
            else Object.assign(track.info.decoderConfig, meta.decoderConfig);
        }
        let sample = {
            presentationTimestamp: presentationTimestampInSeconds,
            decodeTimestamp: decodeTimestampInSeconds,
            duration: durationInSeconds,
            data: data,
            size: data.byteLength,
            type: type,
            // Will be refined once the next sample comes in
            timescaleUnitsToNextSample: intoTimescale(durationInSeconds, track.timescale)
        };
        return sample;
    };
    _addSampleToTrack = new WeakSet();
    addSampleToTrack_fn = function(track, sample) {
        if (__privateGet(this, _options).fastStart !== "fragmented") track.samples.push(sample);
        const sampleCompositionTimeOffset = intoTimescale(sample.presentationTimestamp - sample.decodeTimestamp, track.timescale);
        if (track.lastTimescaleUnits !== null) {
            let timescaleUnits = intoTimescale(sample.decodeTimestamp, track.timescale, false);
            let delta = Math.round(timescaleUnits - track.lastTimescaleUnits);
            track.lastTimescaleUnits += delta;
            track.lastSample.timescaleUnitsToNextSample = delta;
            if (__privateGet(this, _options).fastStart !== "fragmented") {
                let lastTableEntry = last(track.timeToSampleTable);
                if (lastTableEntry.sampleCount === 1) {
                    lastTableEntry.sampleDelta = delta;
                    lastTableEntry.sampleCount++;
                } else if (lastTableEntry.sampleDelta === delta) lastTableEntry.sampleCount++;
                else {
                    lastTableEntry.sampleCount--;
                    track.timeToSampleTable.push({
                        sampleCount: 2,
                        sampleDelta: delta
                    });
                }
                const lastCompositionTimeOffsetTableEntry = last(track.compositionTimeOffsetTable);
                if (lastCompositionTimeOffsetTableEntry.sampleCompositionTimeOffset === sampleCompositionTimeOffset) lastCompositionTimeOffsetTableEntry.sampleCount++;
                else track.compositionTimeOffsetTable.push({
                    sampleCount: 1,
                    sampleCompositionTimeOffset: sampleCompositionTimeOffset
                });
            }
        } else {
            track.lastTimescaleUnits = 0;
            if (__privateGet(this, _options).fastStart !== "fragmented") {
                track.timeToSampleTable.push({
                    sampleCount: 1,
                    sampleDelta: intoTimescale(sample.duration, track.timescale)
                });
                track.compositionTimeOffsetTable.push({
                    sampleCount: 1,
                    sampleCompositionTimeOffset: sampleCompositionTimeOffset
                });
            }
        }
        track.lastSample = sample;
        let beginNewChunk = false;
        if (!track.currentChunk) beginNewChunk = true;
        else {
            let currentChunkDuration = sample.presentationTimestamp - track.currentChunk.startTimestamp;
            if (__privateGet(this, _options).fastStart === "fragmented") {
                let mostImportantTrack = __privateGet(this, _videoTrack) ?? __privateGet(this, _audioTrack);
                if (track === mostImportantTrack && sample.type === "key" && currentChunkDuration >= 1) {
                    beginNewChunk = true;
                    __privateMethod(this, _finalizeFragment, finalizeFragment_fn).call(this);
                }
            } else beginNewChunk = currentChunkDuration >= 0.5;
        }
        if (beginNewChunk) {
            if (track.currentChunk) __privateMethod(this, _finalizeCurrentChunk, finalizeCurrentChunk_fn).call(this, track);
            track.currentChunk = {
                startTimestamp: sample.presentationTimestamp,
                samples: []
            };
        }
        track.currentChunk.samples.push(sample);
    };
    _validateTimestamp = new WeakSet();
    validateTimestamp_fn = function(presentationTimestamp, decodeTimestamp, track) {
        const strictTimestampBehavior = __privateGet(this, _options).firstTimestampBehavior === "strict";
        const noLastDecodeTimestamp = track.lastDecodeTimestamp === -1;
        const timestampNonZero = decodeTimestamp !== 0;
        if (strictTimestampBehavior && noLastDecodeTimestamp && timestampNonZero) throw new Error(`The first chunk for your media track must have a timestamp of 0 (received DTS=${decodeTimestamp}).Non-zero first timestamps are often caused by directly piping frames or audio data from a MediaStreamTrack into the encoder. Their timestamps are typically relative to the age of thedocument, which is probably what you want.

    If you want to offset all timestamps of a track such that the first one is zero, set firstTimestampBehavior: 'offset' in the options.
    `);
        else if (__privateGet(this, _options).firstTimestampBehavior === "offset" || __privateGet(this, _options).firstTimestampBehavior === "cross-track-offset") {
            if (track.firstDecodeTimestamp === void 0) track.firstDecodeTimestamp = decodeTimestamp;
            let baseDecodeTimestamp;
            if (__privateGet(this, _options).firstTimestampBehavior === "offset") baseDecodeTimestamp = track.firstDecodeTimestamp;
            else baseDecodeTimestamp = Math.min(__privateGet(this, _videoTrack)?.firstDecodeTimestamp ?? Infinity, __privateGet(this, _audioTrack)?.firstDecodeTimestamp ?? Infinity);
            decodeTimestamp -= baseDecodeTimestamp;
            presentationTimestamp -= baseDecodeTimestamp;
        }
        if (decodeTimestamp < track.lastDecodeTimestamp) throw new Error(`Timestamps must be monotonically increasing (DTS went from ${track.lastDecodeTimestamp * 1e6} to ${decodeTimestamp * 1e6}).`);
        track.lastDecodeTimestamp = decodeTimestamp;
        return {
            presentationTimestamp: presentationTimestamp,
            decodeTimestamp: decodeTimestamp
        };
    };
    _finalizeCurrentChunk = new WeakSet();
    finalizeCurrentChunk_fn = function(track) {
        if (__privateGet(this, _options).fastStart === "fragmented") throw new Error("Can't finalize individual chunks 'fastStart' is set to 'fragmented'.");
        if (!track.currentChunk) return;
        track.finalizedChunks.push(track.currentChunk);
        __privateGet(this, _finalizedChunks).push(track.currentChunk);
        if (track.compactlyCodedChunkTable.length === 0 || last(track.compactlyCodedChunkTable).samplesPerChunk !== track.currentChunk.samples.length) track.compactlyCodedChunkTable.push({
            firstChunk: track.finalizedChunks.length,
            // 1-indexed
            samplesPerChunk: track.currentChunk.samples.length
        });
        if (__privateGet(this, _options).fastStart === "in-memory") {
            track.currentChunk.offset = 0;
            return;
        }
        track.currentChunk.offset = __privateGet(this, _writer).pos;
        for (let sample of track.currentChunk.samples){
            __privateGet(this, _writer).write(sample.data);
            sample.data = null;
        }
        __privateMethod(this, _maybeFlushStreamingTargetWriter, maybeFlushStreamingTargetWriter_fn).call(this);
    };
    _finalizeFragment = new WeakSet();
    finalizeFragment_fn = function(flushStreamingWriter = true) {
        if (__privateGet(this, _options).fastStart !== "fragmented") throw new Error("Can't finalize a fragment unless 'fastStart' is set to 'fragmented'.");
        let tracks = [
            __privateGet(this, _videoTrack),
            __privateGet(this, _audioTrack)
        ].filter((track)=>track && track.currentChunk);
        if (tracks.length === 0) return;
        let fragmentNumber = __privateWrapper(this, _nextFragmentNumber)._++;
        if (fragmentNumber === 1) {
            let movieBox = moov(tracks, __privateGet(this, _creationTime), true);
            __privateGet(this, _writer).writeBox(movieBox);
        }
        let moofOffset = __privateGet(this, _writer).pos;
        let moofBox = moof(fragmentNumber, tracks);
        __privateGet(this, _writer).writeBox(moofBox);
        {
            let mdatBox = mdat(false);
            let totalTrackSampleSize = 0;
            for (let track of tracks)for (let sample of track.currentChunk.samples)totalTrackSampleSize += sample.size;
            let mdatSize = __privateGet(this, _writer).measureBox(mdatBox) + totalTrackSampleSize;
            if (mdatSize >= 2 ** 32) {
                mdatBox.largeSize = true;
                mdatSize = __privateGet(this, _writer).measureBox(mdatBox) + totalTrackSampleSize;
            }
            mdatBox.size = mdatSize;
            __privateGet(this, _writer).writeBox(mdatBox);
        }
        for (let track of tracks){
            track.currentChunk.offset = __privateGet(this, _writer).pos;
            track.currentChunk.moofOffset = moofOffset;
            for (let sample of track.currentChunk.samples){
                __privateGet(this, _writer).write(sample.data);
                sample.data = null;
            }
        }
        let endPos = __privateGet(this, _writer).pos;
        __privateGet(this, _writer).seek(__privateGet(this, _writer).offsets.get(moofBox));
        let newMoofBox = moof(fragmentNumber, tracks);
        __privateGet(this, _writer).writeBox(newMoofBox);
        __privateGet(this, _writer).seek(endPos);
        for (let track of tracks){
            track.finalizedChunks.push(track.currentChunk);
            __privateGet(this, _finalizedChunks).push(track.currentChunk);
            track.currentChunk = null;
        }
        if (flushStreamingWriter) __privateMethod(this, _maybeFlushStreamingTargetWriter, maybeFlushStreamingTargetWriter_fn).call(this);
    };
    _maybeFlushStreamingTargetWriter = new WeakSet();
    maybeFlushStreamingTargetWriter_fn = function() {
        if (__privateGet(this, _writer) instanceof StreamTargetWriter) __privateGet(this, _writer).flush();
    };
    _ensureNotFinalized = new WeakSet();
    ensureNotFinalized_fn = function() {
        if (__privateGet(this, _finalized)) throw new Error("Cannot add new video or audio chunks after the file has been finalized.");
    };
    return __toCommonJS(src_exports);
})();
var $429c9424af8192b8$export$2e2bcd8739ae039 = $429c9424af8192b8$var$Mp4Muxer;


async function $73780af2e1c5e77c$export$fb609dbfb0d8ccc7(data) {
    const { frames: frames, fps: fps, width: displayWidth, height: displayHeight } = data;
    let outputVideoWidth = displayWidth;
    let outputVideoHeight = displayHeight;
    const start = performance.now();
    // If it's bigger than 720p?
    if (outputVideoWidth > 1280 || outputVideoHeight > 720) {
        // Scale down to 720p.
        const scale = Math.min(1280 / outputVideoWidth, 720 / outputVideoHeight);
        outputVideoWidth = Math.round(outputVideoWidth * scale);
        outputVideoHeight = Math.round(outputVideoHeight * scale);
    }
    // Some browsers require even dimensions.
    if (outputVideoWidth % 2 !== 0) outputVideoWidth++;
    if (outputVideoHeight % 2 !== 0) outputVideoHeight++;
    if (outputVideoWidth !== displayWidth || outputVideoHeight !== displayHeight) console.info(`%cPOKI_REPLAY:%c resizing video from ${displayWidth}x${displayHeight} to ${outputVideoWidth}x${outputVideoHeight}`, "font-weight: bold", "");
    let muxer = new (0, $429c9424af8192b8$export$2e2bcd8739ae039).Muxer({
        target: new (0, $429c9424af8192b8$export$2e2bcd8739ae039).ArrayBufferTarget(),
        video: {
            codec: "avc",
            width: outputVideoWidth,
            height: outputVideoHeight
        },
        fastStart: "in-memory",
        firstTimestampBehavior: "offset"
    });
    let videoEncoder = new VideoEncoder({
        output: (chunk, meta)=>{
            muxer.addVideoChunk(chunk, meta);
        },
        error: (e)=>console.error("%cPOKI_REPLAY:%c error encoding video", "font-weight: bold", "", e)
    });
    videoEncoder.configure({
        codec: "avc1.42001f",
        width: outputVideoWidth,
        height: outputVideoHeight,
        bitrate: 1e6,
        framerate: fps
    });
    let lastKeyframe = -1;
    for(let i = 0; i < frames.length; i++){
        const frame = new VideoFrame(frames[i].buffer, frames[i]);
        let needsKeyFrame = frame.timestamp > lastKeyframe + 1 * 1e6; // Every second.
        if (needsKeyFrame) lastKeyframe = frame.timestamp;
        videoEncoder.encode(frame, {
            keyFrame: needsKeyFrame
        });
        frame.close();
    }
    await videoEncoder.flush();
    videoEncoder.close();
    muxer.finalize();
    let { buffer: buffer } = muxer.target;
    console.info(`%cPOKI_REPLAY:%c encoding took ${Math.round(performance.now() - start)} ms`, "font-weight: bold", "");
    const blob = new Blob([
        buffer
    ], {
        type: "video/mp4"
    });
    return blob;
}


var $cebfe6726e901212$exports = {};
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */ (function(window1, document1, exportName, undefined) {
    "use strict";
    var VENDOR_PREFIXES = [
        "",
        "webkit",
        "Moz",
        "MS",
        "ms",
        "o"
    ];
    var TEST_ELEMENT = document1.createElement("div");
    var TYPE_FUNCTION = "function";
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */ function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
    }
    /**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    /**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function each(obj, iterator, context) {
        var i;
        if (!obj) return;
        if (obj.forEach) obj.forEach(iterator, context);
        else if (obj.length !== undefined) {
            i = 0;
            while(i < obj.length){
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
    /**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function deprecate(method, name, message) {
        var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
        return function() {
            var e = new Error("get-stack-trace");
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace";
            var log = window1.console && (window1.console.warn || window1.console.log);
            if (log) log.call(window1.console, deprecationMessage, stack);
            return method.apply(this, arguments);
        };
    }
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var assign;
    if (typeof Object.assign !== "function") assign = function assign(target) {
        if (target === undefined || target === null) throw new TypeError("Cannot convert undefined or null to object");
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
            }
        }
        return output;
    };
    else assign = Object.assign;
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var extend = deprecate(function extend(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while(i < keys.length){
            if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
            i++;
        }
        return dest;
    }, "extend", "Use `assign`.");
    /**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var merge = deprecate(function merge(dest, src) {
        return extend(dest, src, true);
    }, "merge", "Use `assign`.");
    /**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) assign(childP, properties);
    }
    /**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
        return val;
    }
    /**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */ function ifUndefined(val1, val2) {
        return val1 === undefined ? val2 : val1;
    }
    /**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function hasParent(node, parent) {
        while(node){
            if (node == parent) return true;
            node = node.parentNode;
        }
        return false;
    }
    /**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) return src.indexOf(find);
        else {
            var i = 0;
            while(i < src.length){
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) return i;
                i++;
            }
            return -1;
        }
    }
    /**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while(i < src.length){
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) results.push(src[i]);
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) results = results.sort();
            else results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
        return results;
    }
    /**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while(i < VENDOR_PREFIXES.length){
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;
            if (prop in obj) return prop;
            i++;
        }
        return undefined;
    }
    /**
 * get a unique id
 * @returns {number} uniqueId
 */ var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window1;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = "ontouchstart" in window1;
    var SUPPORT_POINTER_EVENTS = prefixed(window1, "PointerEvent") !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = "touch";
    var INPUT_TYPE_PEN = "pen";
    var INPUT_TYPE_MOUSE = "mouse";
    var INPUT_TYPE_KINECT = "kinect";
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = [
        "x",
        "y"
    ];
    var PROPS_CLIENT_XY = [
        "clientX",
        "clientY"
    ];
    /**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if (boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    Input.prototype = {
        /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */ handler: function() {},
        /**
     * bind the events
     */ init: function() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        },
        /**
     * unbind the events
     */ destroy: function() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        }
    };
    /**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) Type = inputClass;
        else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
        else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
        else if (!SUPPORT_TOUCH) Type = MouseInput;
        else Type = TouchMouseInput;
        return new Type(manager, inputHandler);
    }
    /**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) manager.session = {};
        // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType;
        // compute scale, rotation etc
        computeInputData(manager, input);
        // emit secret event
        manager.emit("hammer.input", input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        // store the first input to calculate the distance and direction
        if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
        // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
        else if (pointersLength === 1) session.firstMultiple = false;
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input);
        // find the correct target
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) target = input.srcEvent.target;
        input.target = target;
    }
    function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while(i < input.pointers.length){
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function getCenter(pointers) {
        var pointersLength = pointers.length;
        // no need to loop when only one touch
        if (pointersLength === 1) return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
        var x = 0, y = 0, i = 0;
        while(i < pointersLength){
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function getDirection(x, y) {
        if (x === y) return DIRECTION_NONE;
        if (abs(x) >= abs(y)) return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function getDistance(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function getAngle(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = "mousedown";
    var MOUSE_WINDOW_EVENTS = "mousemove mouseup";
    /**
 * Mouse events input
 * @constructor
 * @extends Input
 */ function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.pressed = false; // mousedown state
        Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function MEhandler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type];
            // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
            if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
            // mouse must be down
            if (!this.pressed) return;
            if (eventType & INPUT_END) this.pressed = false;
            this.callback(this.manager, eventType, {
                pointers: [
                    ev
                ],
                changedPointers: [
                    ev
                ],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        }
    });
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    };
    // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = "pointerdown";
    var POINTER_WINDOW_EVENTS = "pointermove pointerup pointercancel";
    // IE10 has prefixed support, and case-sensitive
    if (window1.MSPointerEvent && !window1.PointerEvent) {
        POINTER_ELEMENT_EVENTS = "MSPointerDown";
        POINTER_WINDOW_EVENTS = "MSPointerMove MSPointerUp MSPointerCancel";
    }
    /**
 * Pointer events input
 * @constructor
 * @extends Input
 */ function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function PEhandler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace("ms", "");
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType == INPUT_TYPE_TOUCH;
            // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, "pointerId");
            // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
            // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) return;
            // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [
                    ev
                ],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) // remove from the store
            store.splice(storeIndex, 1);
        }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = "touchstart";
    var SINGLE_TOUCH_WINDOW_EVENTS = "touchstart touchmove touchend touchcancel";
    /**
 * Touch events input
 * @constructor
 * @extends Input
 */ function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
            // should we handle the touch events?
            if (type === INPUT_START) this.started = true;
            if (!this.started) return;
            var touches = normalizeSingleTouches.call(this, ev, type);
            // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), "identifier", true);
        return [
            all,
            changed
        ];
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = "touchstart touchmove touchend touchcancel";
    /**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) return;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [
                allTouches,
                allTouches
            ];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
        // get target touches from touches
        targetTouches = allTouches.filter(function(touch) {
            return hasParent(touch.target, target);
        });
        // collect touches
        if (type === INPUT_START) {
            i = 0;
            while(i < targetTouches.length){
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        }
        // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while(i < changedTouches.length){
            if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
            // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
            i++;
        }
        if (!changedTargetTouches.length) return;
        return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), "identifier", true),
            changedTargetTouches
        ];
    }
    /**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
        this.primaryTouch = null;
        this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input, {
        /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ handler: function TMEhandler(manager, inputEvent, inputData) {
            var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
            if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
            // when we're in a touch event, record touches to  de-dupe synthetic mouse event
            if (isTouch) recordTouches.call(this, inputEvent, inputData);
            else if (isMouse && isSyntheticEvent.call(this, inputData)) return;
            this.callback(manager, inputEvent, inputData);
        },
        /**
     * remove the event listeners
     */ destroy: function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        }
    });
    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) setLastTouch.call(this, eventData);
    }
    function setLastTouch(eventData) {
        var touch = eventData.changedPointers[0];
        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            this.lastTouches.push(lastTouch);
            var lts = this.lastTouches;
            var removeLastTouch = function() {
                var i = lts.indexOf(lastTouch);
                if (i > -1) lts.splice(i, 1);
            };
            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }
    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
        for(var i = 0; i < this.lastTouches.length; i++){
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) return true;
        }
        return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, "touchAction");
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    // magical touchAction value
    var TOUCH_ACTION_COMPUTE = "compute";
    var TOUCH_ACTION_AUTO = "auto";
    var TOUCH_ACTION_MANIPULATION = "manipulation"; // not implemented
    var TOUCH_ACTION_NONE = "none";
    var TOUCH_ACTION_PAN_X = "pan-x";
    var TOUCH_ACTION_PAN_Y = "pan-y";
    var TOUCH_ACTION_MAP = getTouchActionProps();
    /**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    TouchAction.prototype = {
        /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */ set: function(value) {
            // find out the touch-action by the event handlers
            if (value == TOUCH_ACTION_COMPUTE) value = this.compute();
            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            this.actions = value.toLowerCase().trim();
        },
        /**
     * just re-set the touchAction value
     */ update: function() {
            this.set(this.manager.options.touchAction);
        },
        /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */ compute: function() {
            var actions = [];
            each(this.manager.recognizers, function(recognizer) {
                if (boolOrFn(recognizer.options.enable, [
                    recognizer
                ])) actions = actions.concat(recognizer.getTouchAction());
            });
            return cleanTouchActions(actions.join(" "));
        },
        /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */ preventDefaults: function(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection;
            // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
            if (hasNone) {
                //do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;
                if (isTapPointer && isTapMovement && isTapTouchTime) return;
            }
            if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
        },
        /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */ preventSrc: function(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        }
    };
    /**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning
        if (hasPanX && hasPanY) return TOUCH_ACTION_NONE;
        // pan-x OR pan-y
        if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
        return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) return false;
        var touchMap = {};
        var cssSupports = window1.CSS && window1.CSS.supports;
        [
            "auto",
            "manipulation",
            "pan-y",
            "pan-x",
            "pan-x pan-y",
            "none"
        ].forEach(function(val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            touchMap[val] = cssSupports ? window1.CSS.supports("touch-action", val) : true;
        });
        return touchMap;
    }
    /**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ function Recognizer(options) {
        this.options = assign({}, this.defaults, options || {});
        this.id = uniqueId();
        this.manager = null;
        // default is enable true
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    Recognizer.prototype = {
        /**
     * @virtual
     * @type {Object}
     */ defaults: {},
        /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */ set: function(options) {
            assign(this.options, options);
            // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        },
        /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ recognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "recognizeWith", this)) return this;
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        },
        /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRecognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "dropRecognizeWith", this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        },
        /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ requireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "requireFailure", this)) return this;
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        },
        /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRequireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "dropRequireFailure", this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
            return this;
        },
        /**
     * has require failures boolean
     * @returns {boolean}
     */ hasRequireFailures: function() {
            return this.requireFail.length > 0;
        },
        /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */ canRecognizeWith: function(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        },
        /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */ emit: function(input) {
            var self1 = this;
            var state = this.state;
            function emit(event) {
                self1.manager.emit(event, input);
            }
            // 'panstart' and 'panmove'
            if (state < STATE_ENDED) emit(self1.options.event + stateStr(state));
            emit(self1.options.event); // simple 'eventName' events
            if (input.additionalEvent) emit(input.additionalEvent);
            // panend and pancancel
            if (state >= STATE_ENDED) emit(self1.options.event + stateStr(state));
        },
        /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */ tryEmit: function(input) {
            if (this.canEmit()) return this.emit(input);
            // it's failing anyway
            this.state = STATE_FAILED;
        },
        /**
     * can we emit?
     * @returns {boolean}
     */ canEmit: function() {
            var i = 0;
            while(i < this.requireFail.length){
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
                i++;
            }
            return true;
        },
        /**
     * update the recognizer
     * @param {Object} inputData
     */ recognize: function(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign({}, inputData);
            // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [
                this,
                inputDataClone
            ])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            }
            // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
            this.state = this.process(inputDataClone);
            // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
        },
        /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */ process: function(inputData) {},
        /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */ getTouchAction: function() {},
        /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */ reset: function() {}
    };
    /**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */ function stateStr(state) {
        if (state & STATE_CANCELLED) return "cancel";
        else if (state & STATE_ENDED) return "end";
        else if (state & STATE_CHANGED) return "move";
        else if (state & STATE_BEGAN) return "start";
        return "";
    }
    /**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */ function directionStr(direction) {
        if (direction == DIRECTION_DOWN) return "down";
        else if (direction == DIRECTION_UP) return "up";
        else if (direction == DIRECTION_LEFT) return "left";
        else if (direction == DIRECTION_RIGHT) return "right";
        return "";
    }
    /**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) return manager.get(otherRecognizer);
        return otherRecognizer;
    }
    /**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ function AttrRecognizer() {
        Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof AttrRecognizer
     */ defaults: {
            /**
         * @type {Number}
         * @default 1
         */ pointers: 1
        },
        /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */ attrTest: function(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */ process: function(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input);
            // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) return state | STATE_ENDED;
                else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        }
    });
    /**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PanRecognizer
     */ defaults: {
            event: "pan",
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        },
        getTouchAction: function() {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
            if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
            return actions;
        },
        directionTest: function(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY;
            // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x != this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y != this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        },
        emit: function(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) input.additionalEvent = this.options.event + direction;
            this._super.emit.call(this, input);
        }
    });
    /**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: "pinch",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? "in" : "out";
                input.additionalEvent = this.options.event + inOut;
            }
            this._super.emit.call(this, input);
        }
    });
    /**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PressRecognizer
     */ defaults: {
            event: "press",
            pointers: 1,
            time: 251,
            threshold: 9 // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_AUTO
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input;
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeoutContext(function() {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                }, options.time, this);
            } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function(input) {
            if (this.state !== STATE_RECOGNIZED) return;
            if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + "up", input);
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof RotateRecognizer
     */ defaults: {
            event: "rotate",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
    });
    /**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof SwipeRecognizer
     */ defaults: {
            event: "swipe",
            threshold: 10,
            velocity: 0.3,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        },
        getTouchAction: function() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function(input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.overallVelocity;
            else if (direction & DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
            else if (direction & DIRECTION_VERTICAL) velocity = input.overallVelocityY;
            return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function(input) {
            var direction = directionStr(input.offsetDirection);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this.manager.emit(this.options.event, input);
        }
    });
    /**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ function TapRecognizer() {
        Recognizer.apply(this, arguments);
        // previous time and center,
        // used for tap counting
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: "tap",
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10 // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_MANIPULATION
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType != INPUT_END) return this.failTimeout();
                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) this.count = 1;
                else this.count += 1;
                this._input = input;
                // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                    else {
                        this._timer = setTimeoutContext(function() {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.interval, this);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        },
        failTimeout: function() {
            this._timer = setTimeoutContext(function() {
                this.state = STATE_FAILED;
            }, this.options.interval, this);
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function() {
            if (this.state == STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Hammer(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
        return new Manager(element, options);
    }
    /**
 * @const {string}
 */ Hammer.VERSION = "2.0.7";
    /**
 * default settings
 * @namespace
 */ Hammer.defaults = {
        /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */ domEvents: false,
        /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */ touchAction: TOUCH_ACTION_COMPUTE,
        /**
     * @type {Boolean}
     * @default true
     */ enable: true,
        /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */ inputTarget: null,
        /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */ inputClass: null,
        /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */ preset: [
            // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
            [
                RotateRecognizer,
                {
                    enable: false
                }
            ],
            [
                PinchRecognizer,
                {
                    enable: false
                },
                [
                    "rotate"
                ]
            ],
            [
                SwipeRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                }
            ],
            [
                PanRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                },
                [
                    "swipe"
                ]
            ],
            [
                TapRecognizer
            ],
            [
                TapRecognizer,
                {
                    event: "doubletap",
                    taps: 2
                },
                [
                    "tap"
                ]
            ],
            [
                PressRecognizer
            ]
        ],
        /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */ cssProps: {
            /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userSelect: "none",
            /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */ touchSelect: "none",
            /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */ touchCallout: "none",
            /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */ contentZooming: "none",
            /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userDrag: "none",
            /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */ tapHighlightColor: "rgba(0,0,0,0)"
        }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Manager(element, options) {
        this.options = assign({}, Hammer.defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(this.options.recognizers, function(item) {
            var recognizer = this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    Manager.prototype = {
        /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */ set: function(options) {
            assign(this.options, options);
            // Options that need a little more setup
            if (options.touchAction) this.touchAction.update();
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        },
        /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */ stop: function(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */ recognize: function(inputData) {
            var session = this.session;
            if (session.stopped) return;
            // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers;
            // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer;
            // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) curRecognizer = session.curRecognizer = null;
            var i = 0;
            while(i < recognizers.length){
                recognizer = recognizers[i];
                // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || // 2
                recognizer.canRecognizeWith(curRecognizer))) recognizer.recognize(inputData);
                else recognizer.reset();
                // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) curRecognizer = session.curRecognizer = recognizer;
                i++;
            }
        },
        /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */ get: function(recognizer) {
            if (recognizer instanceof Recognizer) return recognizer;
            var recognizers = this.recognizers;
            for(var i = 0; i < recognizers.length; i++){
                if (recognizers[i].options.event == recognizer) return recognizers[i];
            }
            return null;
        },
        /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */ add: function(recognizer) {
            if (invokeArrayArg(recognizer, "add", this)) return this;
            // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) this.remove(existing);
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        },
        /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */ remove: function(recognizer) {
            if (invokeArrayArg(recognizer, "remove", this)) return this;
            recognizer = this.get(recognizer);
            // let's make sure this recognizer exists
            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, recognizer);
                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }
            return this;
        },
        /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */ on: function(events, handler) {
            if (events === undefined) return;
            if (handler === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        },
        /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */ off: function(events, handler) {
            if (events === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                if (!handler) delete handlers[event];
                else handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            });
            return this;
        },
        /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */ emit: function(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) triggerDomEvent(event, data);
            // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) return;
            data.type = event;
            data.preventDefault = function() {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while(i < handlers.length){
                handlers[i](data);
                i++;
            }
        },
        /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ destroy: function() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        }
    };
    /**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) return;
        var prop;
        each(manager.options.cssProps, function(value, name) {
            prop = prefixed(element.style, name);
            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else element.style[prop] = manager.oldCssProps[prop] || "";
        });
        if (!add) manager.oldCssProps = {};
    }
    /**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function triggerDomEvent(event, data) {
        var gestureEvent = document1.createEvent("Event");
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    assign(Hammer, {
        INPUT_START: INPUT_START,
        INPUT_MOVE: INPUT_MOVE,
        INPUT_END: INPUT_END,
        INPUT_CANCEL: INPUT_CANCEL,
        STATE_POSSIBLE: STATE_POSSIBLE,
        STATE_BEGAN: STATE_BEGAN,
        STATE_CHANGED: STATE_CHANGED,
        STATE_ENDED: STATE_ENDED,
        STATE_RECOGNIZED: STATE_RECOGNIZED,
        STATE_CANCELLED: STATE_CANCELLED,
        STATE_FAILED: STATE_FAILED,
        DIRECTION_NONE: DIRECTION_NONE,
        DIRECTION_LEFT: DIRECTION_LEFT,
        DIRECTION_RIGHT: DIRECTION_RIGHT,
        DIRECTION_UP: DIRECTION_UP,
        DIRECTION_DOWN: DIRECTION_DOWN,
        DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL: DIRECTION_VERTICAL,
        DIRECTION_ALL: DIRECTION_ALL,
        Manager: Manager,
        Input: Input,
        TouchAction: TouchAction,
        TouchInput: TouchInput,
        MouseInput: MouseInput,
        PointerEventInput: PointerEventInput,
        TouchMouseInput: TouchMouseInput,
        SingleTouchInput: SingleTouchInput,
        Recognizer: Recognizer,
        AttrRecognizer: AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each: each,
        merge: merge,
        extend: extend,
        assign: assign,
        inherit: inherit,
        bindFn: bindFn,
        prefixed: prefixed
    });
    // this prevents errors when Hammer is loaded in the presence of an AMD
    //  style loader but by script tag, not by the loader.
    var freeGlobal = typeof window1 !== "undefined" ? window1 : typeof self !== "undefined" ? self : {}; // jshint ignore:line
    freeGlobal.Hammer = Hammer;
    if (typeof define === "function" && define.amd) define(function() {
        return Hammer;
    });
    else if (0, $cebfe6726e901212$exports) $cebfe6726e901212$exports = Hammer;
    else window1[exportName] = Hammer;
})(window, document, "Hammer");



var $2dbde92a00aadffa$var$lastActiveObject = null;
function $2dbde92a00aadffa$var$setLastActiveObject() {
    var fabricCanvas = (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).fabricCanvas;
    var activeObject = fabricCanvas.getActiveObject();
    if (activeObject) $2dbde92a00aadffa$var$lastActiveObject = activeObject;
    // deselect all objects to prevent them from being moved, use timeout to prevent tap from selecting object
    setTimeout(function() {
        fabricCanvas.discardActiveObject();
        fabricCanvas.requestRenderAll();
    }, 0);
}
function $2dbde92a00aadffa$var$setActiveObject() {
    var fabricCanvas = (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).fabricCanvas;
    if ($2dbde92a00aadffa$var$lastActiveObject) setTimeout(function() {
        fabricCanvas.setActiveObject($2dbde92a00aadffa$var$lastActiveObject);
        fabricCanvas.requestRenderAll();
        $2dbde92a00aadffa$var$lastActiveObject = null;
    }, 0);
}
function $2dbde92a00aadffa$export$72c03c4379b553() {
    var fabricCanvas = (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).fabricCanvas;
    // get canvas element from fabricCanvas
    var canvasElement = fabricCanvas.getElement();
    var mc = new (0, (/*@__PURE__*/$parcel$interopDefault($cebfe6726e901212$exports))).Manager(document.documentElement);
    // Add Pinch and Rotate recognizers
    var pinch = new (0, (/*@__PURE__*/$parcel$interopDefault($cebfe6726e901212$exports))).Pinch();
    var rotate = new (0, (/*@__PURE__*/$parcel$interopDefault($cebfe6726e901212$exports))).Rotate();
    pinch.recognizeWith(rotate);
    mc.add([
        pinch,
        rotate
    ]);
    var initialScale = 1;
    var initialRotation = 0;
    var initialAngle = 0;
    var initialPosition = {
        x: 0,
        y: 0
    };
    // Add pinch event listener
    mc.on("pinchstart pinchend pinchmove", function(ev) {
        if (ev.type === "pinchstart" && !$2dbde92a00aadffa$var$lastActiveObject) $2dbde92a00aadffa$var$setLastActiveObject();
        if (ev.type === "pinchend") {
            $2dbde92a00aadffa$var$setActiveObject();
            return;
        }
        if ($2dbde92a00aadffa$var$lastActiveObject) {
            if (ev.type === "pinchstart") {
                initialScale = $2dbde92a00aadffa$var$lastActiveObject.scaleX;
                var pointer_1 = fabricCanvas.getScenePoint(ev.center);
                initialPosition = {
                    x: pointer_1.x,
                    y: pointer_1.y
                };
            }
            // Calculate scale and position
            var newScale = initialScale * ev.scale;
            $2dbde92a00aadffa$var$lastActiveObject.scale(newScale);
            // set object center at the start of pinch
            var pointer = fabricCanvas.getScenePoint(ev.center);
            var dx = pointer.x - initialPosition.x;
            var dy = pointer.y - initialPosition.y;
            // lastActiveObject.set({
            // 	left: lastActiveObject.left + dx,
            // 	top: lastActiveObject.top + dy
            // }).setCoords();
            fabricCanvas.requestRenderAll();
            // Update initial position for smooth dragging
            initialPosition = {
                x: pointer.x,
                y: pointer.y
            };
        }
    });
    // Add rotate event listener
    mc.on("rotatestart rotatemove", function(ev) {
        if (ev.type === "rotatestart" && !$2dbde92a00aadffa$var$lastActiveObject) $2dbde92a00aadffa$var$setLastActiveObject();
        if (ev.type === "rotatestart") {
            initialRotation = $2dbde92a00aadffa$var$lastActiveObject.angle;
            initialAngle = ev.rotation;
            var pointer = fabricCanvas.getScenePoint(ev.center);
            initialPosition = {
                x: pointer.x,
                y: pointer.y
            };
        }
        if ($2dbde92a00aadffa$var$lastActiveObject) {
            // Calculate rotation and position
            var angleOffset = ev.rotation - initialAngle;
            console.log("rotate", angleOffset);
            var newAngle = initialRotation + angleOffset;
            $2dbde92a00aadffa$var$lastActiveObject.rotate(newAngle);
            var pointer = fabricCanvas.getScenePoint(ev.center);
            var dx = pointer.x - initialPosition.x;
            var dy = pointer.y - initialPosition.y;
            // lastActiveObject.set({
            // 	left: lastActiveObject.left + dx,
            // 	top: lastActiveObject.top + dy
            // }).setCoords();
            fabricCanvas.requestRenderAll();
            // Update initial position for smooth dragging
            initialPosition = {
                x: pointer.x,
                y: pointer.y
            };
        }
    });
}



var $c6f037291b4db98a$exports = {};
$c6f037291b4db98a$exports = JSON.parse('{"categories":[{"id":"people","emojis":["grinning","smiley","smile","grin","laughing","sweat_smile","rolling_on_the_floor_laughing","joy","slightly_smiling_face","upside_down_face","melting_face","wink","blush","innocent","smiling_face_with_3_hearts","heart_eyes","star-struck","kissing_heart","kissing","relaxed","kissing_closed_eyes","kissing_smiling_eyes","smiling_face_with_tear","yum","stuck_out_tongue","stuck_out_tongue_winking_eye","zany_face","stuck_out_tongue_closed_eyes","money_mouth_face","hugging_face","face_with_hand_over_mouth","face_with_open_eyes_and_hand_over_mouth","face_with_peeking_eye","shushing_face","thinking_face","saluting_face","zipper_mouth_face","face_with_raised_eyebrow","neutral_face","expressionless","no_mouth","dotted_line_face","face_in_clouds","smirk","unamused","face_with_rolling_eyes","grimacing","face_exhaling","lying_face","shaking_face","relieved","pensive","sleepy","drooling_face","sleeping","mask","face_with_thermometer","face_with_head_bandage","nauseated_face","face_vomiting","sneezing_face","hot_face","cold_face","woozy_face","dizzy_face","face_with_spiral_eyes","exploding_head","face_with_cowboy_hat","partying_face","disguised_face","sunglasses","nerd_face","face_with_monocle","confused","face_with_diagonal_mouth","worried","slightly_frowning_face","white_frowning_face","open_mouth","hushed","astonished","flushed","pleading_face","face_holding_back_tears","frowning","anguished","fearful","cold_sweat","disappointed_relieved","cry","sob","scream","confounded","persevere","disappointed","sweat","weary","tired_face","yawning_face","triumph","rage","angry","face_with_symbols_on_mouth","smiling_imp","imp","skull","skull_and_crossbones","hankey","clown_face","japanese_ogre","japanese_goblin","ghost","alien","space_invader","wave","raised_back_of_hand","raised_hand_with_fingers_splayed","hand","spock-hand","rightwards_hand","leftwards_hand","palm_down_hand","palm_up_hand","leftwards_pushing_hand","rightwards_pushing_hand","ok_hand","pinched_fingers","pinching_hand","v","crossed_fingers","hand_with_index_finger_and_thumb_crossed","i_love_you_hand_sign","the_horns","call_me_hand","point_left","point_right","point_up_2","middle_finger","point_down","point_up","index_pointing_at_the_viewer","+1","-1","fist","facepunch","left-facing_fist","right-facing_fist","clap","raised_hands","heart_hands","open_hands","palms_up_together","handshake","pray","writing_hand","nail_care","selfie","muscle","mechanical_arm","mechanical_leg","leg","foot","ear","ear_with_hearing_aid","nose","brain","anatomical_heart","lungs","tooth","bone","eyes","eye","tongue","lips","biting_lip","baby","child","boy","girl","adult","person_with_blond_hair","man","bearded_person","man_with_beard","woman_with_beard","red_haired_man","curly_haired_man","white_haired_man","bald_man","woman","red_haired_woman","red_haired_person","curly_haired_woman","curly_haired_person","white_haired_woman","white_haired_person","bald_woman","bald_person","blond-haired-woman","blond-haired-man","older_adult","older_man","older_woman","person_frowning","man-frowning","woman-frowning","person_with_pouting_face","man-pouting","woman-pouting","no_good","man-gesturing-no","woman-gesturing-no","ok_woman","man-gesturing-ok","woman-gesturing-ok","information_desk_person","man-tipping-hand","woman-tipping-hand","raising_hand","man-raising-hand","woman-raising-hand","deaf_person","deaf_man","deaf_woman","bow","man-bowing","woman-bowing","face_palm","man-facepalming","woman-facepalming","shrug","man-shrugging","woman-shrugging","health_worker","male-doctor","female-doctor","student","male-student","female-student","teacher","male-teacher","female-teacher","judge","male-judge","female-judge","farmer","male-farmer","female-farmer","cook","male-cook","female-cook","mechanic","male-mechanic","female-mechanic","factory_worker","male-factory-worker","female-factory-worker","office_worker","male-office-worker","female-office-worker","scientist","male-scientist","female-scientist","technologist","male-technologist","female-technologist","singer","male-singer","female-singer","artist","male-artist","female-artist","pilot","male-pilot","female-pilot","astronaut","male-astronaut","female-astronaut","firefighter","male-firefighter","female-firefighter","cop","male-police-officer","female-police-officer","sleuth_or_spy","male-detective","female-detective","guardsman","male-guard","female-guard","ninja","construction_worker","male-construction-worker","female-construction-worker","person_with_crown","prince","princess","man_with_turban","man-wearing-turban","woman-wearing-turban","man_with_gua_pi_mao","person_with_headscarf","person_in_tuxedo","man_in_tuxedo","woman_in_tuxedo","bride_with_veil","man_with_veil","woman_with_veil","pregnant_woman","pregnant_man","pregnant_person","breast-feeding","woman_feeding_baby","man_feeding_baby","person_feeding_baby","angel","santa","mrs_claus","mx_claus","superhero","male_superhero","female_superhero","supervillain","male_supervillain","female_supervillain","mage","male_mage","female_mage","fairy","male_fairy","female_fairy","vampire","male_vampire","female_vampire","merperson","merman","mermaid","elf","male_elf","female_elf","genie","male_genie","female_genie","zombie","male_zombie","female_zombie","troll","massage","man-getting-massage","woman-getting-massage","haircut","man-getting-haircut","woman-getting-haircut","walking","man-walking","woman-walking","standing_person","man_standing","woman_standing","kneeling_person","man_kneeling","woman_kneeling","person_with_probing_cane","man_with_probing_cane","woman_with_probing_cane","person_in_motorized_wheelchair","man_in_motorized_wheelchair","woman_in_motorized_wheelchair","person_in_manual_wheelchair","man_in_manual_wheelchair","woman_in_manual_wheelchair","runner","man-running","woman-running","dancer","man_dancing","man_in_business_suit_levitating","dancers","men-with-bunny-ears-partying","women-with-bunny-ears-partying","person_in_steamy_room","man_in_steamy_room","woman_in_steamy_room","person_climbing","man_climbing","woman_climbing","fencer","horse_racing","skier","snowboarder","golfer","man-golfing","woman-golfing","surfer","man-surfing","woman-surfing","rowboat","man-rowing-boat","woman-rowing-boat","swimmer","man-swimming","woman-swimming","person_with_ball","man-bouncing-ball","woman-bouncing-ball","weight_lifter","man-lifting-weights","woman-lifting-weights","bicyclist","man-biking","woman-biking","mountain_bicyclist","man-mountain-biking","woman-mountain-biking","person_doing_cartwheel","man-cartwheeling","woman-cartwheeling","wrestlers","man-wrestling","woman-wrestling","water_polo","man-playing-water-polo","woman-playing-water-polo","handball","man-playing-handball","woman-playing-handball","juggling","man-juggling","woman-juggling","person_in_lotus_position","man_in_lotus_position","woman_in_lotus_position","bath","sleeping_accommodation","people_holding_hands","two_women_holding_hands","man_and_woman_holding_hands","two_men_holding_hands","couplekiss","woman-kiss-man","man-kiss-man","woman-kiss-woman","couple_with_heart","woman-heart-man","man-heart-man","woman-heart-woman","family","man-woman-boy","man-woman-girl","man-woman-girl-boy","man-woman-boy-boy","man-woman-girl-girl","man-man-boy","man-man-girl","man-man-girl-boy","man-man-boy-boy","man-man-girl-girl","woman-woman-boy","woman-woman-girl","woman-woman-girl-boy","woman-woman-boy-boy","woman-woman-girl-girl","man-boy","man-boy-boy","man-girl","man-girl-boy","man-girl-girl","woman-boy","woman-boy-boy","woman-girl","woman-girl-boy","woman-girl-girl","speaking_head_in_silhouette","bust_in_silhouette","busts_in_silhouette","people_hugging","footprints","robot_face","smiley_cat","smile_cat","joy_cat","heart_eyes_cat","smirk_cat","kissing_cat","scream_cat","crying_cat_face","pouting_cat","see_no_evil","hear_no_evil","speak_no_evil","love_letter","cupid","gift_heart","sparkling_heart","heartpulse","heartbeat","revolving_hearts","two_hearts","heart_decoration","heavy_heart_exclamation_mark_ornament","broken_heart","heart_on_fire","mending_heart","heart","pink_heart","orange_heart","yellow_heart","green_heart","blue_heart","light_blue_heart","purple_heart","brown_heart","black_heart","grey_heart","white_heart","kiss","100","anger","boom","dizzy","sweat_drops","dash","hole","speech_balloon","eye-in-speech-bubble","left_speech_bubble","right_anger_bubble","thought_balloon","zzz"]},{"id":"nature","emojis":["monkey_face","monkey","gorilla","orangutan","dog","dog2","guide_dog","service_dog","poodle","wolf","fox_face","raccoon","cat","cat2","black_cat","lion_face","tiger","tiger2","leopard","horse","moose","donkey","racehorse","unicorn_face","zebra_face","deer","bison","cow","ox","water_buffalo","cow2","pig","pig2","boar","pig_nose","ram","sheep","goat","dromedary_camel","camel","llama","giraffe_face","elephant","mammoth","rhinoceros","hippopotamus","mouse","mouse2","rat","hamster","rabbit","rabbit2","chipmunk","beaver","hedgehog","bat","bear","polar_bear","koala","panda_face","sloth","otter","skunk","kangaroo","badger","feet","turkey","chicken","rooster","hatching_chick","baby_chick","hatched_chick","bird","penguin","dove_of_peace","eagle","duck","swan","owl","dodo","feather","flamingo","peacock","parrot","wing","black_bird","goose","frog","crocodile","turtle","lizard","snake","dragon_face","dragon","sauropod","t-rex","whale","whale2","dolphin","seal","fish","tropical_fish","blowfish","shark","octopus","shell","coral","jellyfish","snail","butterfly","bug","ant","bee","beetle","ladybug","cricket","cockroach","spider","spider_web","scorpion","mosquito","fly","worm","microbe","bouquet","cherry_blossom","white_flower","lotus","rosette","rose","wilted_flower","hibiscus","sunflower","blossom","tulip","hyacinth","seedling","potted_plant","evergreen_tree","deciduous_tree","palm_tree","cactus","ear_of_rice","herb","shamrock","four_leaf_clover","maple_leaf","fallen_leaf","leaves","empty_nest","nest_with_eggs","mushroom"]},{"id":"foods","emojis":["grapes","melon","watermelon","tangerine","lemon","banana","pineapple","mango","apple","green_apple","pear","peach","cherries","strawberry","blueberries","kiwifruit","tomato","olive","coconut","avocado","eggplant","potato","carrot","corn","hot_pepper","bell_pepper","cucumber","leafy_green","broccoli","garlic","onion","peanuts","beans","chestnut","ginger_root","pea_pod","bread","croissant","baguette_bread","flatbread","pretzel","bagel","pancakes","waffle","cheese_wedge","meat_on_bone","poultry_leg","cut_of_meat","bacon","hamburger","fries","pizza","hotdog","sandwich","taco","burrito","tamale","stuffed_flatbread","falafel","egg","fried_egg","shallow_pan_of_food","stew","fondue","bowl_with_spoon","green_salad","popcorn","butter","salt","canned_food","bento","rice_cracker","rice_ball","rice","curry","ramen","spaghetti","sweet_potato","oden","sushi","fried_shrimp","fish_cake","moon_cake","dango","dumpling","fortune_cookie","takeout_box","crab","lobster","shrimp","squid","oyster","icecream","shaved_ice","ice_cream","doughnut","cookie","birthday","cake","cupcake","pie","chocolate_bar","candy","lollipop","custard","honey_pot","baby_bottle","glass_of_milk","coffee","teapot","tea","sake","champagne","wine_glass","cocktail","tropical_drink","beer","beers","clinking_glasses","tumbler_glass","pouring_liquid","cup_with_straw","bubble_tea","beverage_box","mate_drink","ice_cube","chopsticks","knife_fork_plate","fork_and_knife","spoon","hocho","jar","amphora"]},{"id":"activity","emojis":["jack_o_lantern","christmas_tree","fireworks","sparkler","firecracker","sparkles","balloon","tada","confetti_ball","tanabata_tree","bamboo","dolls","flags","wind_chime","rice_scene","red_envelope","ribbon","gift","reminder_ribbon","admission_tickets","ticket","medal","trophy","sports_medal","first_place_medal","second_place_medal","third_place_medal","soccer","baseball","softball","basketball","volleyball","football","rugby_football","tennis","flying_disc","bowling","cricket_bat_and_ball","field_hockey_stick_and_ball","ice_hockey_stick_and_puck","lacrosse","table_tennis_paddle_and_ball","badminton_racquet_and_shuttlecock","boxing_glove","martial_arts_uniform","goal_net","golf","ice_skate","fishing_pole_and_fish","diving_mask","running_shirt_with_sash","ski","sled","curling_stone","dart","yo-yo","kite","gun","8ball","crystal_ball","magic_wand","video_game","joystick","slot_machine","game_die","jigsaw","teddy_bear","pinata","mirror_ball","nesting_dolls","spades","hearts","diamonds","clubs","chess_pawn","black_joker","mahjong","flower_playing_cards","performing_arts","frame_with_picture","art","thread","sewing_needle","yarn","knot"]},{"id":"places","emojis":["earth_africa","earth_americas","earth_asia","globe_with_meridians","world_map","japan","compass","snow_capped_mountain","mountain","volcano","mount_fuji","camping","beach_with_umbrella","desert","desert_island","national_park","stadium","classical_building","building_construction","bricks","rock","wood","hut","house_buildings","derelict_house_building","house","house_with_garden","office","post_office","european_post_office","hospital","bank","hotel","love_hotel","convenience_store","school","department_store","factory","japanese_castle","european_castle","wedding","tokyo_tower","statue_of_liberty","church","mosque","hindu_temple","synagogue","shinto_shrine","kaaba","fountain","tent","foggy","night_with_stars","cityscape","sunrise_over_mountains","sunrise","city_sunset","city_sunrise","bridge_at_night","hotsprings","carousel_horse","playground_slide","ferris_wheel","roller_coaster","barber","circus_tent","steam_locomotive","railway_car","bullettrain_side","bullettrain_front","train2","metro","light_rail","station","tram","monorail","mountain_railway","train","bus","oncoming_bus","trolleybus","minibus","ambulance","fire_engine","police_car","oncoming_police_car","taxi","oncoming_taxi","car","oncoming_automobile","blue_car","pickup_truck","truck","articulated_lorry","tractor","racing_car","racing_motorcycle","motor_scooter","manual_wheelchair","motorized_wheelchair","auto_rickshaw","bike","scooter","skateboard","roller_skate","busstop","motorway","railway_track","oil_drum","fuelpump","wheel","rotating_light","traffic_light","vertical_traffic_light","octagonal_sign","construction","anchor","ring_buoy","boat","canoe","speedboat","passenger_ship","ferry","motor_boat","ship","airplane","small_airplane","airplane_departure","airplane_arriving","parachute","seat","helicopter","suspension_railway","mountain_cableway","aerial_tramway","satellite","rocket","flying_saucer","bellhop_bell","luggage","hourglass","hourglass_flowing_sand","watch","alarm_clock","stopwatch","timer_clock","mantelpiece_clock","clock12","clock1230","clock1","clock130","clock2","clock230","clock3","clock330","clock4","clock430","clock5","clock530","clock6","clock630","clock7","clock730","clock8","clock830","clock9","clock930","clock10","clock1030","clock11","clock1130","new_moon","waxing_crescent_moon","first_quarter_moon","moon","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","crescent_moon","new_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","thermometer","sunny","full_moon_with_face","sun_with_face","ringed_planet","star","star2","stars","milky_way","cloud","partly_sunny","thunder_cloud_and_rain","mostly_sunny","barely_sunny","partly_sunny_rain","rain_cloud","snow_cloud","lightning","tornado","fog","wind_blowing_face","cyclone","rainbow","closed_umbrella","umbrella","umbrella_with_rain_drops","umbrella_on_ground","zap","snowflake","snowman","snowman_without_snow","comet","fire","droplet","ocean"]},{"id":"objects","emojis":["eyeglasses","dark_sunglasses","goggles","lab_coat","safety_vest","necktie","shirt","jeans","scarf","gloves","coat","socks","dress","kimono","sari","one-piece_swimsuit","briefs","shorts","bikini","womans_clothes","folding_hand_fan","purse","handbag","pouch","shopping_bags","school_satchel","thong_sandal","mans_shoe","athletic_shoe","hiking_boot","womans_flat_shoe","high_heel","sandal","ballet_shoes","boot","hair_pick","crown","womans_hat","tophat","mortar_board","billed_cap","military_helmet","helmet_with_white_cross","prayer_beads","lipstick","ring","gem","mute","speaker","sound","loud_sound","loudspeaker","mega","postal_horn","bell","no_bell","musical_score","musical_note","notes","studio_microphone","level_slider","control_knobs","microphone","headphones","radio","saxophone","accordion","guitar","musical_keyboard","trumpet","violin","banjo","drum_with_drumsticks","long_drum","maracas","flute","iphone","calling","phone","telephone_receiver","pager","fax","battery","low_battery","electric_plug","computer","desktop_computer","printer","keyboard","three_button_mouse","trackball","minidisc","floppy_disk","cd","dvd","abacus","movie_camera","film_frames","film_projector","clapper","tv","camera","camera_with_flash","video_camera","vhs","mag","mag_right","candle","bulb","flashlight","izakaya_lantern","diya_lamp","notebook_with_decorative_cover","closed_book","book","green_book","blue_book","orange_book","books","notebook","ledger","page_with_curl","scroll","page_facing_up","newspaper","rolled_up_newspaper","bookmark_tabs","bookmark","label","moneybag","coin","yen","dollar","euro","pound","money_with_wings","credit_card","receipt","chart","email","e-mail","incoming_envelope","envelope_with_arrow","outbox_tray","inbox_tray","package","mailbox","mailbox_closed","mailbox_with_mail","mailbox_with_no_mail","postbox","ballot_box_with_ballot","pencil2","black_nib","lower_left_fountain_pen","lower_left_ballpoint_pen","lower_left_paintbrush","lower_left_crayon","memo","briefcase","file_folder","open_file_folder","card_index_dividers","date","calendar","spiral_note_pad","spiral_calendar_pad","card_index","chart_with_upwards_trend","chart_with_downwards_trend","bar_chart","clipboard","pushpin","round_pushpin","paperclip","linked_paperclips","straight_ruler","triangular_ruler","scissors","card_file_box","file_cabinet","wastebasket","lock","unlock","lock_with_ink_pen","closed_lock_with_key","key","old_key","hammer","axe","pick","hammer_and_pick","hammer_and_wrench","dagger_knife","crossed_swords","bomb","boomerang","bow_and_arrow","shield","carpentry_saw","wrench","screwdriver","nut_and_bolt","gear","compression","scales","probing_cane","link","chains","hook","toolbox","magnet","ladder","alembic","test_tube","petri_dish","dna","microscope","telescope","satellite_antenna","syringe","drop_of_blood","pill","adhesive_bandage","crutch","stethoscope","x-ray","door","elevator","mirror","window","bed","couch_and_lamp","chair","toilet","plunger","shower","bathtub","mouse_trap","razor","lotion_bottle","safety_pin","broom","basket","roll_of_paper","bucket","soap","bubbles","toothbrush","sponge","fire_extinguisher","shopping_trolley","smoking","coffin","headstone","funeral_urn","nazar_amulet","hamsa","moyai","placard","identification_card"]},{"id":"symbols","emojis":["atm","put_litter_in_its_place","potable_water","wheelchair","mens","womens","restroom","baby_symbol","wc","passport_control","customs","baggage_claim","left_luggage","warning","children_crossing","no_entry","no_entry_sign","no_bicycles","no_smoking","do_not_litter","non-potable_water","no_pedestrians","no_mobile_phones","underage","radioactive_sign","biohazard_sign","arrow_up","arrow_upper_right","arrow_right","arrow_lower_right","arrow_down","arrow_lower_left","arrow_left","arrow_upper_left","arrow_up_down","left_right_arrow","leftwards_arrow_with_hook","arrow_right_hook","arrow_heading_up","arrow_heading_down","arrows_clockwise","arrows_counterclockwise","back","end","on","soon","top","place_of_worship","atom_symbol","om_symbol","star_of_david","wheel_of_dharma","yin_yang","latin_cross","orthodox_cross","star_and_crescent","peace_symbol","menorah_with_nine_branches","six_pointed_star","khanda","aries","taurus","gemini","cancer","leo","virgo","libra","scorpius","sagittarius","capricorn","aquarius","pisces","ophiuchus","twisted_rightwards_arrows","repeat","repeat_one","arrow_forward","fast_forward","black_right_pointing_double_triangle_with_vertical_bar","black_right_pointing_triangle_with_double_vertical_bar","arrow_backward","rewind","black_left_pointing_double_triangle_with_vertical_bar","arrow_up_small","arrow_double_up","arrow_down_small","arrow_double_down","double_vertical_bar","black_square_for_stop","black_circle_for_record","eject","cinema","low_brightness","high_brightness","signal_strength","wireless","vibration_mode","mobile_phone_off","female_sign","male_sign","transgender_symbol","heavy_multiplication_x","heavy_plus_sign","heavy_minus_sign","heavy_division_sign","heavy_equals_sign","infinity","bangbang","interrobang","question","grey_question","grey_exclamation","exclamation","wavy_dash","currency_exchange","heavy_dollar_sign","medical_symbol","recycle","fleur_de_lis","trident","name_badge","beginner","o","white_check_mark","ballot_box_with_check","heavy_check_mark","x","negative_squared_cross_mark","curly_loop","loop","part_alternation_mark","eight_spoked_asterisk","eight_pointed_black_star","sparkle","copyright","registered","tm","hash","keycap_star","zero","one","two","three","four","five","six","seven","eight","nine","keycap_ten","capital_abcd","abcd","1234","symbols","abc","a","ab","b","cl","cool","free","information_source","id","m","new","ng","o2","ok","parking","sos","up","vs","koko","sa","u6708","u6709","u6307","ideograph_advantage","u5272","u7121","u7981","accept","u7533","u5408","u7a7a","congratulations","secret","u55b6","u6e80","red_circle","large_orange_circle","large_yellow_circle","large_green_circle","large_blue_circle","large_purple_circle","large_brown_circle","black_circle","white_circle","large_red_square","large_orange_square","large_yellow_square","large_green_square","large_blue_square","large_purple_square","large_brown_square","black_large_square","white_large_square","black_medium_square","white_medium_square","black_medium_small_square","white_medium_small_square","black_small_square","white_small_square","large_orange_diamond","large_blue_diamond","small_orange_diamond","small_blue_diamond","small_red_triangle","small_red_triangle_down","diamond_shape_with_a_dot_inside","radio_button","white_square_button","black_square_button"]},{"id":"flags","emojis":["checkered_flag","cn","crossed_flags","de","es","flag-ac","flag-ad","flag-ae","flag-af","flag-ag","flag-ai","flag-al","flag-am","flag-ao","flag-aq","flag-ar","flag-as","flag-at","flag-au","flag-aw","flag-ax","flag-az","flag-ba","flag-bb","flag-bd","flag-be","flag-bf","flag-bg","flag-bh","flag-bi","flag-bj","flag-bl","flag-bm","flag-bn","flag-bo","flag-bq","flag-br","flag-bs","flag-bt","flag-bv","flag-bw","flag-by","flag-bz","flag-ca","flag-cc","flag-cd","flag-cf","flag-cg","flag-ch","flag-ci","flag-ck","flag-cl","flag-cm","flag-co","flag-cp","flag-cr","flag-cu","flag-cv","flag-cw","flag-cx","flag-cy","flag-cz","flag-dg","flag-dj","flag-dk","flag-dm","flag-do","flag-dz","flag-ea","flag-ec","flag-ee","flag-eg","flag-eh","flag-england","flag-er","flag-et","flag-eu","flag-fi","flag-fj","flag-fk","flag-fm","flag-fo","flag-ga","flag-gd","flag-ge","flag-gf","flag-gg","flag-gh","flag-gi","flag-gl","flag-gm","flag-gn","flag-gp","flag-gq","flag-gr","flag-gs","flag-gt","flag-gu","flag-gw","flag-gy","flag-hk","flag-hm","flag-hn","flag-hr","flag-ht","flag-hu","flag-ic","flag-id","flag-ie","flag-il","flag-im","flag-in","flag-io","flag-iq","flag-ir","flag-is","flag-je","flag-jm","flag-jo","flag-ke","flag-kg","flag-kh","flag-ki","flag-km","flag-kn","flag-kp","flag-kw","flag-ky","flag-kz","flag-la","flag-lb","flag-lc","flag-li","flag-lk","flag-lr","flag-ls","flag-lt","flag-lu","flag-lv","flag-ly","flag-ma","flag-mc","flag-md","flag-me","flag-mf","flag-mg","flag-mh","flag-mk","flag-ml","flag-mm","flag-mn","flag-mo","flag-mp","flag-mq","flag-mr","flag-ms","flag-mt","flag-mu","flag-mv","flag-mw","flag-mx","flag-my","flag-mz","flag-na","flag-nc","flag-ne","flag-nf","flag-ng","flag-ni","flag-nl","flag-no","flag-np","flag-nr","flag-nu","flag-nz","flag-om","flag-pa","flag-pe","flag-pf","flag-pg","flag-ph","flag-pk","flag-pl","flag-pm","flag-pn","flag-pr","flag-ps","flag-pt","flag-pw","flag-py","flag-qa","flag-re","flag-ro","flag-rs","flag-rw","flag-sa","flag-sb","flag-sc","flag-scotland","flag-sd","flag-se","flag-sg","flag-sh","flag-si","flag-sj","flag-sk","flag-sl","flag-sm","flag-sn","flag-so","flag-sr","flag-ss","flag-st","flag-sv","flag-sx","flag-sy","flag-sz","flag-ta","flag-tc","flag-td","flag-tf","flag-tg","flag-th","flag-tj","flag-tk","flag-tl","flag-tm","flag-tn","flag-to","flag-tr","flag-tt","flag-tv","flag-tw","flag-tz","flag-ua","flag-ug","flag-um","flag-un","flag-uy","flag-uz","flag-va","flag-vc","flag-ve","flag-vg","flag-vi","flag-vn","flag-vu","flag-wales","flag-wf","flag-ws","flag-xk","flag-ye","flag-yt","flag-za","flag-zm","flag-zw","fr","gb","it","jp","kr","pirate_flag","rainbow-flag","ru","transgender_flag","triangular_flag_on_post","us","waving_black_flag","waving_white_flag"]}],"emojis":{"100":{"id":"100","name":"Hundred Points","keywords":["100","score","perfect","numbers","century","exam","quiz","test","pass"],"skins":[{"unified":"1f4af","native":"\uD83D\uDCAF"}],"version":1},"1234":{"id":"1234","name":"Input Numbers","keywords":["1234","blue","square","1","2","3","4"],"skins":[{"unified":"1f522","native":"\uD83D\uDD22"}],"version":1},"grinning":{"id":"grinning","name":"Grinning Face","emoticons":[":D"],"keywords":["smile","happy","joy",":D","grin"],"skins":[{"unified":"1f600","native":"\uD83D\uDE00"}],"version":1},"smiley":{"id":"smiley","name":"Grinning Face with Big Eyes","emoticons":[":)","=)","=-)"],"keywords":["smiley","happy","joy","haha",":D",":)","smile","funny"],"skins":[{"unified":"1f603","native":"\uD83D\uDE03"}],"version":1},"smile":{"id":"smile","name":"Grinning Face with Smiling Eyes","emoticons":[":)","C:","c:",":D",":-D"],"keywords":["smile","happy","joy","funny","haha","laugh","like",":D",":)"],"skins":[{"unified":"1f604","native":"\uD83D\uDE04"}],"version":1},"grin":{"id":"grin","name":"Beaming Face with Smiling Eyes","keywords":["grin","happy","smile","joy","kawaii"],"skins":[{"unified":"1f601","native":"\uD83D\uDE01"}],"version":1},"laughing":{"id":"laughing","name":"Grinning Squinting Face","emoticons":[":>",":->"],"keywords":["laughing","satisfied","happy","joy","lol","haha","glad","XD","laugh"],"skins":[{"unified":"1f606","native":"\uD83D\uDE06"}],"version":1},"sweat_smile":{"id":"sweat_smile","name":"Grinning Face with Sweat","keywords":["smile","hot","happy","laugh","relief"],"skins":[{"unified":"1f605","native":"\uD83D\uDE05"}],"version":1},"rolling_on_the_floor_laughing":{"id":"rolling_on_the_floor_laughing","name":"Rolling on the Floor Laughing","keywords":["face","lol","haha","rofl"],"skins":[{"unified":"1f923","native":"\uD83E\uDD23"}],"version":3},"joy":{"id":"joy","name":"Face with Tears of Joy","keywords":["cry","weep","happy","happytears","haha"],"skins":[{"unified":"1f602","native":"\uD83D\uDE02"}],"version":1},"slightly_smiling_face":{"id":"slightly_smiling_face","name":"Slightly Smiling Face","emoticons":[":)","(:",":-)"],"keywords":["smile"],"skins":[{"unified":"1f642","native":"\uD83D\uDE42"}],"version":1},"upside_down_face":{"id":"upside_down_face","name":"Upside-Down Face","keywords":["upside","down","flipped","silly","smile"],"skins":[{"unified":"1f643","native":"\uD83D\uDE43"}],"version":1},"melting_face":{"id":"melting_face","name":"Melting Face","keywords":["hot","heat"],"skins":[{"unified":"1fae0","native":"\uD83E\uDEE0"}],"version":14},"wink":{"id":"wink","name":"Winking Face","emoticons":[";)",";-)"],"keywords":["wink","happy","mischievous","secret",";)","smile","eye"],"skins":[{"unified":"1f609","native":"\uD83D\uDE09"}],"version":1},"blush":{"id":"blush","name":"Smiling Face with Smiling Eyes","emoticons":[":)"],"keywords":["blush","smile","happy","flushed","crush","embarrassed","shy","joy"],"skins":[{"unified":"1f60a","native":"\uD83D\uDE0A"}],"version":1},"innocent":{"id":"innocent","name":"Smiling Face with Halo","keywords":["innocent","angel","heaven"],"skins":[{"unified":"1f607","native":"\uD83D\uDE07"}],"version":1},"smiling_face_with_3_hearts":{"id":"smiling_face_with_3_hearts","name":"Smiling Face with Hearts","keywords":["3","love","like","affection","valentines","infatuation","crush","adore"],"skins":[{"unified":"1f970","native":"\uD83E\uDD70"}],"version":11},"heart_eyes":{"id":"heart_eyes","name":"Smiling Face with Heart-Eyes","keywords":["heart","eyes","love","like","affection","valentines","infatuation","crush"],"skins":[{"unified":"1f60d","native":"\uD83D\uDE0D"}],"version":1},"star-struck":{"id":"star-struck","name":"Star-Struck","keywords":["star","struck","grinning","face","with","eyes","smile","starry"],"skins":[{"unified":"1f929","native":"\uD83E\uDD29"}],"version":5},"kissing_heart":{"id":"kissing_heart","name":"Face Blowing a Kiss","emoticons":[":*",":-*"],"keywords":["kissing","heart","love","like","affection","valentines","infatuation"],"skins":[{"unified":"1f618","native":"\uD83D\uDE18"}],"version":1},"kissing":{"id":"kissing","name":"Kissing Face","keywords":["love","like","3","valentines","infatuation","kiss"],"skins":[{"unified":"1f617","native":"\uD83D\uDE17"}],"version":1},"relaxed":{"id":"relaxed","name":"Smiling Face","keywords":["relaxed","blush","massage","happiness"],"skins":[{"unified":"263a-fe0f","native":"\u263A\uFE0F"}],"version":1},"kissing_closed_eyes":{"id":"kissing_closed_eyes","name":"Kissing Face with Closed Eyes","keywords":["love","like","affection","valentines","infatuation","kiss"],"skins":[{"unified":"1f61a","native":"\uD83D\uDE1A"}],"version":1},"kissing_smiling_eyes":{"id":"kissing_smiling_eyes","name":"Kissing Face with Smiling Eyes","keywords":["affection","valentines","infatuation","kiss"],"skins":[{"unified":"1f619","native":"\uD83D\uDE19"}],"version":1},"smiling_face_with_tear":{"id":"smiling_face_with_tear","name":"Smiling Face with Tear","keywords":["sad","cry","pretend"],"skins":[{"unified":"1f972","native":"\uD83E\uDD72"}],"version":13},"yum":{"id":"yum","name":"Face Savoring Food","keywords":["yum","happy","joy","tongue","smile","silly","yummy","nom","delicious","savouring"],"skins":[{"unified":"1f60b","native":"\uD83D\uDE0B"}],"version":1},"stuck_out_tongue":{"id":"stuck_out_tongue","name":"Face with Tongue","emoticons":[":p",":-p",":P",":-P",":b",":-b"],"keywords":["stuck","out","prank","childish","playful","mischievous","smile"],"skins":[{"unified":"1f61b","native":"\uD83D\uDE1B"}],"version":1},"stuck_out_tongue_winking_eye":{"id":"stuck_out_tongue_winking_eye","name":"Winking Face with Tongue","emoticons":[";p",";-p",";b",";-b",";P",";-P"],"keywords":["stuck","out","eye","prank","childish","playful","mischievous","smile","wink"],"skins":[{"unified":"1f61c","native":"\uD83D\uDE1C"}],"version":1},"zany_face":{"id":"zany_face","name":"Zany Face","keywords":["grinning","with","one","large","and","small","eye","goofy","crazy"],"skins":[{"unified":"1f92a","native":"\uD83E\uDD2A"}],"version":5},"stuck_out_tongue_closed_eyes":{"id":"stuck_out_tongue_closed_eyes","name":"Squinting Face with Tongue","keywords":["stuck","out","closed","eyes","prank","playful","mischievous","smile"],"skins":[{"unified":"1f61d","native":"\uD83D\uDE1D"}],"version":1},"money_mouth_face":{"id":"money_mouth_face","name":"Money-Mouth Face","keywords":["money","mouth","rich","dollar"],"skins":[{"unified":"1f911","native":"\uD83E\uDD11"}],"version":1},"hugging_face":{"id":"hugging_face","name":"Hugging Face","keywords":["smile","hug"],"skins":[{"unified":"1f917","native":"\uD83E\uDD17"}],"version":1},"face_with_hand_over_mouth":{"id":"face_with_hand_over_mouth","name":"Face with Hand over Mouth","keywords":["smiling","eyes","and","covering","whoops","shock","surprise"],"skins":[{"unified":"1f92d","native":"\uD83E\uDD2D"}],"version":5},"face_with_open_eyes_and_hand_over_mouth":{"id":"face_with_open_eyes_and_hand_over_mouth","name":"Face with Open Eyes and Hand over Mouth","keywords":["silence","secret","shock","surprise"],"skins":[{"unified":"1fae2","native":"\uD83E\uDEE2"}],"version":14},"face_with_peeking_eye":{"id":"face_with_peeking_eye","name":"Face with Peeking Eye","keywords":["scared","frightening","embarrassing","shy"],"skins":[{"unified":"1fae3","native":"\uD83E\uDEE3"}],"version":14},"shushing_face":{"id":"shushing_face","name":"Shushing Face","keywords":["with","finger","covering","closed","lips","quiet","shhh"],"skins":[{"unified":"1f92b","native":"\uD83E\uDD2B"}],"version":5},"thinking_face":{"id":"thinking_face","name":"Thinking Face","keywords":["hmmm","think","consider"],"skins":[{"unified":"1f914","native":"\uD83E\uDD14"}],"version":1},"saluting_face":{"id":"saluting_face","name":"Saluting Face","keywords":["respect","salute"],"skins":[{"unified":"1fae1","native":"\uD83E\uDEE1"}],"version":14},"zipper_mouth_face":{"id":"zipper_mouth_face","name":"Zipper-Mouth Face","keywords":["zipper","mouth","sealed","secret"],"skins":[{"unified":"1f910","native":"\uD83E\uDD10"}],"version":1},"face_with_raised_eyebrow":{"id":"face_with_raised_eyebrow","name":"Face with Raised Eyebrow","keywords":["one","distrust","scepticism","disapproval","disbelief","surprise"],"skins":[{"unified":"1f928","native":"\uD83E\uDD28"}],"version":5},"neutral_face":{"id":"neutral_face","name":"Neutral Face","emoticons":[":|",":-|"],"keywords":["indifference","meh",":",""],"skins":[{"unified":"1f610","native":"\uD83D\uDE10"}],"version":1},"expressionless":{"id":"expressionless","name":"Expressionless Face","emoticons":["-_-"],"keywords":["indifferent","-","","meh","deadpan"],"skins":[{"unified":"1f611","native":"\uD83D\uDE11"}],"version":1},"no_mouth":{"id":"no_mouth","name":"Face Without Mouth","keywords":["no","hellokitty"],"skins":[{"unified":"1f636","native":"\uD83D\uDE36"}],"version":1},"dotted_line_face":{"id":"dotted_line_face","name":"Dotted Line Face","keywords":["invisible","lonely","isolation","depression"],"skins":[{"unified":"1fae5","native":"\uD83E\uDEE5"}],"version":14},"face_in_clouds":{"id":"face_in_clouds","name":"Face in Clouds","keywords":["shower","steam","dream"],"skins":[{"unified":"1f636-200d-1f32b-fe0f","native":"\uD83D\uDE36\u200D\uD83C\uDF2B\uFE0F"}],"version":13.1},"smirk":{"id":"smirk","name":"Smirking Face","keywords":["smirk","smile","mean","prank","smug","sarcasm"],"skins":[{"unified":"1f60f","native":"\uD83D\uDE0F"}],"version":1},"unamused":{"id":"unamused","name":"Unamused Face","emoticons":[":("],"keywords":["indifference","bored","straight","serious","sarcasm","unimpressed","skeptical","dubious","side","eye"],"skins":[{"unified":"1f612","native":"\uD83D\uDE12"}],"version":1},"face_with_rolling_eyes":{"id":"face_with_rolling_eyes","name":"Face with Rolling Eyes","keywords":["eyeroll","frustrated"],"skins":[{"unified":"1f644","native":"\uD83D\uDE44"}],"version":1},"grimacing":{"id":"grimacing","name":"Grimacing Face","keywords":["grimace","teeth"],"skins":[{"unified":"1f62c","native":"\uD83D\uDE2C"}],"version":1},"face_exhaling":{"id":"face_exhaling","name":"Face Exhaling","keywords":["relieve","relief","tired","sigh"],"skins":[{"unified":"1f62e-200d-1f4a8","native":"\uD83D\uDE2E\u200D\uD83D\uDCA8"}],"version":13.1},"lying_face":{"id":"lying_face","name":"Lying Face","keywords":["lie","pinocchio"],"skins":[{"unified":"1f925","native":"\uD83E\uDD25"}],"version":3},"shaking_face":{"id":"shaking_face","name":"Shaking Face","keywords":["dizzy","shock","blurry","earthquake"],"skins":[{"unified":"1fae8","native":"\uD83E\uDEE8"}],"version":15},"relieved":{"id":"relieved","name":"Relieved Face","keywords":["relaxed","phew","massage","happiness"],"skins":[{"unified":"1f60c","native":"\uD83D\uDE0C"}],"version":1},"pensive":{"id":"pensive","name":"Pensive Face","keywords":["sad","depressed","upset"],"skins":[{"unified":"1f614","native":"\uD83D\uDE14"}],"version":1},"sleepy":{"id":"sleepy","name":"Sleepy Face","keywords":["tired","rest","nap"],"skins":[{"unified":"1f62a","native":"\uD83D\uDE2A"}],"version":1},"drooling_face":{"id":"drooling_face","name":"Drooling Face","keywords":[],"skins":[{"unified":"1f924","native":"\uD83E\uDD24"}],"version":3},"sleeping":{"id":"sleeping","name":"Sleeping Face","keywords":["tired","sleepy","night","zzz"],"skins":[{"unified":"1f634","native":"\uD83D\uDE34"}],"version":1},"mask":{"id":"mask","name":"Face with Medical Mask","keywords":["sick","ill","disease","covid"],"skins":[{"unified":"1f637","native":"\uD83D\uDE37"}],"version":1},"face_with_thermometer":{"id":"face_with_thermometer","name":"Face with Thermometer","keywords":["sick","temperature","cold","fever","covid"],"skins":[{"unified":"1f912","native":"\uD83E\uDD12"}],"version":1},"face_with_head_bandage":{"id":"face_with_head_bandage","name":"Face with Head-Bandage","keywords":["head","bandage","injured","clumsy","hurt"],"skins":[{"unified":"1f915","native":"\uD83E\uDD15"}],"version":1},"nauseated_face":{"id":"nauseated_face","name":"Nauseated Face","keywords":["vomit","gross","green","sick","throw","up","ill"],"skins":[{"unified":"1f922","native":"\uD83E\uDD22"}],"version":3},"face_vomiting":{"id":"face_vomiting","name":"Face Vomiting","keywords":["with","open","mouth","sick"],"skins":[{"unified":"1f92e","native":"\uD83E\uDD2E"}],"version":5},"sneezing_face":{"id":"sneezing_face","name":"Sneezing Face","keywords":["gesundheit","sneeze","sick","allergy"],"skins":[{"unified":"1f927","native":"\uD83E\uDD27"}],"version":3},"hot_face":{"id":"hot_face","name":"Hot Face","keywords":["feverish","heat","red","sweating"],"skins":[{"unified":"1f975","native":"\uD83E\uDD75"}],"version":11},"cold_face":{"id":"cold_face","name":"Cold Face","keywords":["blue","freezing","frozen","frostbite","icicles"],"skins":[{"unified":"1f976","native":"\uD83E\uDD76"}],"version":11},"woozy_face":{"id":"woozy_face","name":"Woozy Face","keywords":["dizzy","intoxicated","tipsy","wavy"],"skins":[{"unified":"1f974","native":"\uD83E\uDD74"}],"version":11},"dizzy_face":{"id":"dizzy_face","name":"Dizzy Face","keywords":["spent","unconscious","xox"],"skins":[{"unified":"1f635","native":"\uD83D\uDE35"}],"version":1},"face_with_spiral_eyes":{"id":"face_with_spiral_eyes","name":"Face with Spiral Eyes","keywords":["sick","ill","confused","nauseous","nausea"],"skins":[{"unified":"1f635-200d-1f4ab","native":"\uD83D\uDE35\u200D\uD83D\uDCAB"}],"version":13.1},"exploding_head":{"id":"exploding_head","name":"Exploding Head","keywords":["shocked","face","with","mind","blown"],"skins":[{"unified":"1f92f","native":"\uD83E\uDD2F"}],"version":5},"face_with_cowboy_hat":{"id":"face_with_cowboy_hat","name":"Cowboy Hat Face","keywords":["with","cowgirl"],"skins":[{"unified":"1f920","native":"\uD83E\uDD20"}],"version":3},"partying_face":{"id":"partying_face","name":"Partying Face","keywords":["celebration","woohoo"],"skins":[{"unified":"1f973","native":"\uD83E\uDD73"}],"version":11},"disguised_face":{"id":"disguised_face","name":"Disguised Face","keywords":["pretent","brows","glasses","moustache"],"skins":[{"unified":"1f978","native":"\uD83E\uDD78"}],"version":13},"sunglasses":{"id":"sunglasses","name":"Smiling Face with Sunglasses","emoticons":["8)"],"keywords":["cool","smile","summer","beach","sunglass"],"skins":[{"unified":"1f60e","native":"\uD83D\uDE0E"}],"version":1},"nerd_face":{"id":"nerd_face","name":"Nerd Face","keywords":["nerdy","geek","dork"],"skins":[{"unified":"1f913","native":"\uD83E\uDD13"}],"version":1},"face_with_monocle":{"id":"face_with_monocle","name":"Face with Monocle","keywords":["stuffy","wealthy"],"skins":[{"unified":"1f9d0","native":"\uD83E\uDDD0"}],"version":5},"confused":{"id":"confused","name":"Confused Face","emoticons":[":\\\\",":-\\\\",":/",":-/"],"keywords":["indifference","huh","weird","hmmm",":/"],"skins":[{"unified":"1f615","native":"\uD83D\uDE15"}],"version":1},"face_with_diagonal_mouth":{"id":"face_with_diagonal_mouth","name":"Face with Diagonal Mouth","keywords":["skeptic","confuse","frustrated","indifferent"],"skins":[{"unified":"1fae4","native":"\uD83E\uDEE4"}],"version":14},"worried":{"id":"worried","name":"Worried Face","keywords":["concern","nervous",":("],"skins":[{"unified":"1f61f","native":"\uD83D\uDE1F"}],"version":1},"slightly_frowning_face":{"id":"slightly_frowning_face","name":"Slightly Frowning Face","keywords":["disappointed","sad","upset"],"skins":[{"unified":"1f641","native":"\uD83D\uDE41"}],"version":1},"white_frowning_face":{"id":"white_frowning_face","name":"Frowning Face","keywords":["white","sad","upset","frown"],"skins":[{"unified":"2639-fe0f","native":"\u2639\uFE0F"}],"version":1},"open_mouth":{"id":"open_mouth","name":"Face with Open Mouth","emoticons":[":o",":-o",":O",":-O"],"keywords":["surprise","impressed","wow","whoa",":O"],"skins":[{"unified":"1f62e","native":"\uD83D\uDE2E"}],"version":1},"hushed":{"id":"hushed","name":"Hushed Face","keywords":["woo","shh"],"skins":[{"unified":"1f62f","native":"\uD83D\uDE2F"}],"version":1},"astonished":{"id":"astonished","name":"Astonished Face","keywords":["xox","surprised","poisoned"],"skins":[{"unified":"1f632","native":"\uD83D\uDE32"}],"version":1},"flushed":{"id":"flushed","name":"Flushed Face","keywords":["blush","shy","flattered"],"skins":[{"unified":"1f633","native":"\uD83D\uDE33"}],"version":1},"pleading_face":{"id":"pleading_face","name":"Pleading Face","keywords":["begging","mercy","cry","tears","sad","grievance"],"skins":[{"unified":"1f97a","native":"\uD83E\uDD7A"}],"version":11},"face_holding_back_tears":{"id":"face_holding_back_tears","name":"Face Holding Back Tears","keywords":["touched","gratitude","cry"],"skins":[{"unified":"1f979","native":"\uD83E\uDD79"}],"version":14},"frowning":{"id":"frowning","name":"Frowning Face with Open Mouth","keywords":["aw","what"],"skins":[{"unified":"1f626","native":"\uD83D\uDE26"}],"version":1},"anguished":{"id":"anguished","name":"Anguished Face","emoticons":["D:"],"keywords":["stunned","nervous"],"skins":[{"unified":"1f627","native":"\uD83D\uDE27"}],"version":1},"fearful":{"id":"fearful","name":"Fearful Face","keywords":["scared","terrified","nervous"],"skins":[{"unified":"1f628","native":"\uD83D\uDE28"}],"version":1},"cold_sweat":{"id":"cold_sweat","name":"Anxious Face with Sweat","keywords":["cold","nervous"],"skins":[{"unified":"1f630","native":"\uD83D\uDE30"}],"version":1},"disappointed_relieved":{"id":"disappointed_relieved","name":"Sad but Relieved Face","keywords":["disappointed","phew","sweat","nervous"],"skins":[{"unified":"1f625","native":"\uD83D\uDE25"}],"version":1},"cry":{"id":"cry","name":"Crying Face","emoticons":[":\'("],"keywords":["cry","tears","sad","depressed","upset",":\'("],"skins":[{"unified":"1f622","native":"\uD83D\uDE22"}],"version":1},"sob":{"id":"sob","name":"Loudly Crying Face","emoticons":[":\'("],"keywords":["sob","cry","tears","sad","upset","depressed"],"skins":[{"unified":"1f62d","native":"\uD83D\uDE2D"}],"version":1},"scream":{"id":"scream","name":"Face Screaming in Fear","keywords":["scream","munch","scared","omg"],"skins":[{"unified":"1f631","native":"\uD83D\uDE31"}],"version":1},"confounded":{"id":"confounded","name":"Confounded Face","keywords":["confused","sick","unwell","oops",":S"],"skins":[{"unified":"1f616","native":"\uD83D\uDE16"}],"version":1},"persevere":{"id":"persevere","name":"Persevering Face","keywords":["persevere","sick","no","upset","oops"],"skins":[{"unified":"1f623","native":"\uD83D\uDE23"}],"version":1},"disappointed":{"id":"disappointed","name":"Disappointed Face","emoticons":["):",":(",":-("],"keywords":["sad","upset","depressed",":("],"skins":[{"unified":"1f61e","native":"\uD83D\uDE1E"}],"version":1},"sweat":{"id":"sweat","name":"Face with Cold Sweat","keywords":["downcast","hot","sad","tired","exercise"],"skins":[{"unified":"1f613","native":"\uD83D\uDE13"}],"version":1},"weary":{"id":"weary","name":"Weary Face","keywords":["tired","sleepy","sad","frustrated","upset"],"skins":[{"unified":"1f629","native":"\uD83D\uDE29"}],"version":1},"tired_face":{"id":"tired_face","name":"Tired Face","keywords":["sick","whine","upset","frustrated"],"skins":[{"unified":"1f62b","native":"\uD83D\uDE2B"}],"version":1},"yawning_face":{"id":"yawning_face","name":"Yawning Face","keywords":["tired","sleepy"],"skins":[{"unified":"1f971","native":"\uD83E\uDD71"}],"version":12},"triumph":{"id":"triumph","name":"Face with Look of Triumph","keywords":["steam","from","nose","gas","phew","proud","pride"],"skins":[{"unified":"1f624","native":"\uD83D\uDE24"}],"version":1},"rage":{"id":"rage","name":"Pouting Face","keywords":["rage","angry","mad","hate","despise"],"skins":[{"unified":"1f621","native":"\uD83D\uDE21"}],"version":1},"angry":{"id":"angry","name":"Angry Face","emoticons":[">:(",">:-("],"keywords":["mad","annoyed","frustrated"],"skins":[{"unified":"1f620","native":"\uD83D\uDE20"}],"version":1},"face_with_symbols_on_mouth":{"id":"face_with_symbols_on_mouth","name":"Face with Symbols on Mouth","keywords":["serious","covering","swearing","cursing","cussing","profanity","expletive"],"skins":[{"unified":"1f92c","native":"\uD83E\uDD2C"}],"version":5},"smiling_imp":{"id":"smiling_imp","name":"Smiling Face with Horns","keywords":["imp","devil"],"skins":[{"unified":"1f608","native":"\uD83D\uDE08"}],"version":1},"imp":{"id":"imp","name":"Imp","keywords":["angry","face","with","horns","devil"],"skins":[{"unified":"1f47f","native":"\uD83D\uDC7F"}],"version":1},"skull":{"id":"skull","name":"Skull","keywords":["dead","skeleton","creepy","death"],"skins":[{"unified":"1f480","native":"\uD83D\uDC80"}],"version":1},"skull_and_crossbones":{"id":"skull_and_crossbones","name":"Skull and Crossbones","keywords":["poison","danger","deadly","scary","death","pirate","evil"],"skins":[{"unified":"2620-fe0f","native":"\u2620\uFE0F"}],"version":1},"hankey":{"id":"hankey","name":"Pile of Poo","keywords":["hankey","poop","shit","shitface","fail","turd"],"skins":[{"unified":"1f4a9","native":"\uD83D\uDCA9"}],"version":1},"clown_face":{"id":"clown_face","name":"Clown Face","keywords":[],"skins":[{"unified":"1f921","native":"\uD83E\uDD21"}],"version":3},"japanese_ogre":{"id":"japanese_ogre","name":"Ogre","keywords":["japanese","monster","red","mask","halloween","scary","creepy","devil","demon"],"skins":[{"unified":"1f479","native":"\uD83D\uDC79"}],"version":1},"japanese_goblin":{"id":"japanese_goblin","name":"Goblin","keywords":["japanese","red","evil","mask","monster","scary","creepy"],"skins":[{"unified":"1f47a","native":"\uD83D\uDC7A"}],"version":1},"ghost":{"id":"ghost","name":"Ghost","keywords":["halloween","spooky","scary"],"skins":[{"unified":"1f47b","native":"\uD83D\uDC7B"}],"version":1},"alien":{"id":"alien","name":"Alien","keywords":["UFO","paul","weird","outer","space"],"skins":[{"unified":"1f47d","native":"\uD83D\uDC7D"}],"version":1},"space_invader":{"id":"space_invader","name":"Alien Monster","keywords":["space","invader","game","arcade","play"],"skins":[{"unified":"1f47e","native":"\uD83D\uDC7E"}],"version":1},"robot_face":{"id":"robot_face","name":"Robot","keywords":["face","computer","machine","bot"],"skins":[{"unified":"1f916","native":"\uD83E\uDD16"}],"version":1},"smiley_cat":{"id":"smiley_cat","name":"Grinning Cat","keywords":["smiley","animal","cats","happy","smile"],"skins":[{"unified":"1f63a","native":"\uD83D\uDE3A"}],"version":1},"smile_cat":{"id":"smile_cat","name":"Grinning Cat with Smiling Eyes","keywords":["smile","animal","cats"],"skins":[{"unified":"1f638","native":"\uD83D\uDE38"}],"version":1},"joy_cat":{"id":"joy_cat","name":"Cat with Tears of Joy","keywords":["animal","cats","haha","happy"],"skins":[{"unified":"1f639","native":"\uD83D\uDE39"}],"version":1},"heart_eyes_cat":{"id":"heart_eyes_cat","name":"Smiling Cat with Heart-Eyes","keywords":["heart","eyes","animal","love","like","affection","cats","valentines"],"skins":[{"unified":"1f63b","native":"\uD83D\uDE3B"}],"version":1},"smirk_cat":{"id":"smirk_cat","name":"Cat with Wry Smile","keywords":["smirk","animal","cats"],"skins":[{"unified":"1f63c","native":"\uD83D\uDE3C"}],"version":1},"kissing_cat":{"id":"kissing_cat","name":"Kissing Cat","keywords":["animal","cats","kiss"],"skins":[{"unified":"1f63d","native":"\uD83D\uDE3D"}],"version":1},"scream_cat":{"id":"scream_cat","name":"Weary Cat","keywords":["scream","animal","cats","munch","scared"],"skins":[{"unified":"1f640","native":"\uD83D\uDE40"}],"version":1},"crying_cat_face":{"id":"crying_cat_face","name":"Crying Cat","keywords":["face","animal","tears","weep","sad","cats","upset","cry"],"skins":[{"unified":"1f63f","native":"\uD83D\uDE3F"}],"version":1},"pouting_cat":{"id":"pouting_cat","name":"Pouting Cat","keywords":["animal","cats"],"skins":[{"unified":"1f63e","native":"\uD83D\uDE3E"}],"version":1},"see_no_evil":{"id":"see_no_evil","name":"See-No-Evil Monkey","keywords":["see","no","evil","animal","nature","haha"],"skins":[{"unified":"1f648","native":"\uD83D\uDE48"}],"version":1},"hear_no_evil":{"id":"hear_no_evil","name":"Hear-No-Evil Monkey","keywords":["hear","no","evil","animal","nature"],"skins":[{"unified":"1f649","native":"\uD83D\uDE49"}],"version":1},"speak_no_evil":{"id":"speak_no_evil","name":"Speak-No-Evil Monkey","keywords":["speak","no","evil","animal","nature","omg"],"skins":[{"unified":"1f64a","native":"\uD83D\uDE4A"}],"version":1},"love_letter":{"id":"love_letter","name":"Love Letter","keywords":["email","like","affection","envelope","valentines"],"skins":[{"unified":"1f48c","native":"\uD83D\uDC8C"}],"version":1},"cupid":{"id":"cupid","name":"Heart with Arrow","keywords":["cupid","love","like","affection","valentines"],"skins":[{"unified":"1f498","native":"\uD83D\uDC98"}],"version":1},"gift_heart":{"id":"gift_heart","name":"Heart with Ribbon","keywords":["gift","love","valentines"],"skins":[{"unified":"1f49d","native":"\uD83D\uDC9D"}],"version":1},"sparkling_heart":{"id":"sparkling_heart","name":"Sparkling Heart","keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f496","native":"\uD83D\uDC96"}],"version":1},"heartpulse":{"id":"heartpulse","name":"Growing Heart","keywords":["heartpulse","like","love","affection","valentines","pink"],"skins":[{"unified":"1f497","native":"\uD83D\uDC97"}],"version":1},"heartbeat":{"id":"heartbeat","name":"Beating Heart","keywords":["heartbeat","love","like","affection","valentines","pink"],"skins":[{"unified":"1f493","native":"\uD83D\uDC93"}],"version":1},"revolving_hearts":{"id":"revolving_hearts","name":"Revolving Hearts","keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49e","native":"\uD83D\uDC9E"}],"version":1},"two_hearts":{"id":"two_hearts","name":"Two Hearts","keywords":["love","like","affection","valentines","heart"],"skins":[{"unified":"1f495","native":"\uD83D\uDC95"}],"version":1},"heart_decoration":{"id":"heart_decoration","name":"Heart Decoration","keywords":["purple","square","love","like"],"skins":[{"unified":"1f49f","native":"\uD83D\uDC9F"}],"version":1},"heavy_heart_exclamation_mark_ornament":{"id":"heavy_heart_exclamation_mark_ornament","name":"Heart Exclamation","keywords":["heavy","mark","ornament","decoration","love"],"skins":[{"unified":"2763-fe0f","native":"\u2763\uFE0F"}],"version":1},"broken_heart":{"id":"broken_heart","name":"Broken Heart","emoticons":["</3"],"keywords":["sad","sorry","break","heartbreak"],"skins":[{"unified":"1f494","native":"\uD83D\uDC94"}],"version":1},"heart_on_fire":{"id":"heart_on_fire","name":"Heart on Fire","keywords":["passionate","enthusiastic"],"skins":[{"unified":"2764-fe0f-200d-1f525","native":"\u2764\uFE0F\u200D\uD83D\uDD25"}],"version":13.1},"mending_heart":{"id":"mending_heart","name":"Mending Heart","keywords":["broken","bandage","wounded"],"skins":[{"unified":"2764-fe0f-200d-1fa79","native":"\u2764\uFE0F\u200D\uD83E\uDE79"}],"version":13.1},"heart":{"id":"heart","name":"Red Heart","emoticons":["<3"],"keywords":["love","like","valentines"],"skins":[{"unified":"2764-fe0f","native":"\u2764\uFE0F"}],"version":1},"pink_heart":{"id":"pink_heart","name":"Pink Heart","keywords":["valentines"],"skins":[{"unified":"1fa77","native":"\uD83E\uDE77"}],"version":15},"orange_heart":{"id":"orange_heart","name":"Orange Heart","keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f9e1","native":"\uD83E\uDDE1"}],"version":5},"yellow_heart":{"id":"yellow_heart","name":"Yellow Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49b","native":"\uD83D\uDC9B"}],"version":1},"green_heart":{"id":"green_heart","name":"Green Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49a","native":"\uD83D\uDC9A"}],"version":1},"blue_heart":{"id":"blue_heart","name":"Blue Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f499","native":"\uD83D\uDC99"}],"version":1},"light_blue_heart":{"id":"light_blue_heart","name":"Light Blue Heart","keywords":["ice","baby"],"skins":[{"unified":"1fa75","native":"\uD83E\uDE75"}],"version":15},"purple_heart":{"id":"purple_heart","name":"Purple Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49c","native":"\uD83D\uDC9C"}],"version":1},"brown_heart":{"id":"brown_heart","name":"Brown Heart","keywords":["coffee"],"skins":[{"unified":"1f90e","native":"\uD83E\uDD0E"}],"version":12},"black_heart":{"id":"black_heart","name":"Black Heart","keywords":["evil"],"skins":[{"unified":"1f5a4","native":"\uD83D\uDDA4"}],"version":3},"grey_heart":{"id":"grey_heart","name":"Grey Heart","keywords":["silver","monochrome"],"skins":[{"unified":"1fa76","native":"\uD83E\uDE76"}],"version":15},"white_heart":{"id":"white_heart","name":"White Heart","keywords":["pure"],"skins":[{"unified":"1f90d","native":"\uD83E\uDD0D"}],"version":12},"kiss":{"id":"kiss","name":"Kiss Mark","keywords":["face","lips","love","like","affection","valentines"],"skins":[{"unified":"1f48b","native":"\uD83D\uDC8B"}],"version":1},"anger":{"id":"anger","name":"Anger Symbol","keywords":["angry","mad"],"skins":[{"unified":"1f4a2","native":"\uD83D\uDCA2"}],"version":1},"boom":{"id":"boom","name":"Collision","keywords":["boom","bomb","explode","explosion","blown"],"skins":[{"unified":"1f4a5","native":"\uD83D\uDCA5"}],"version":1},"dizzy":{"id":"dizzy","name":"Dizzy","keywords":["star","sparkle","shoot","magic"],"skins":[{"unified":"1f4ab","native":"\uD83D\uDCAB"}],"version":1},"sweat_drops":{"id":"sweat_drops","name":"Sweat Droplets","keywords":["drops","water","drip","oops"],"skins":[{"unified":"1f4a6","native":"\uD83D\uDCA6"}],"version":1},"dash":{"id":"dash","name":"Dash Symbol","keywords":["dashing","away","wind","air","fast","shoo","fart","smoke","puff"],"skins":[{"unified":"1f4a8","native":"\uD83D\uDCA8"}],"version":1},"hole":{"id":"hole","name":"Hole","keywords":["embarrassing"],"skins":[{"unified":"1f573-fe0f","native":"\uD83D\uDD73\uFE0F"}],"version":1},"speech_balloon":{"id":"speech_balloon","name":"Speech Balloon","keywords":["bubble","words","message","talk","chatting"],"skins":[{"unified":"1f4ac","native":"\uD83D\uDCAC"}],"version":1},"eye-in-speech-bubble":{"id":"eye-in-speech-bubble","name":"Eye in Speech Bubble","keywords":["in-speech-bubble","info"],"skins":[{"unified":"1f441-fe0f-200d-1f5e8-fe0f","native":"\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F"}],"version":2},"left_speech_bubble":{"id":"left_speech_bubble","name":"Left Speech Bubble","keywords":["words","message","talk","chatting"],"skins":[{"unified":"1f5e8-fe0f","native":"\uD83D\uDDE8\uFE0F"}],"version":2},"right_anger_bubble":{"id":"right_anger_bubble","name":"Right Anger Bubble","keywords":["caption","speech","thinking","mad"],"skins":[{"unified":"1f5ef-fe0f","native":"\uD83D\uDDEF\uFE0F"}],"version":1},"thought_balloon":{"id":"thought_balloon","name":"Thought Balloon","keywords":["bubble","cloud","speech","thinking","dream"],"skins":[{"unified":"1f4ad","native":"\uD83D\uDCAD"}],"version":1},"zzz":{"id":"zzz","name":"Zzz","keywords":["sleepy","tired","dream"],"skins":[{"unified":"1f4a4","native":"\uD83D\uDCA4"}],"version":1},"wave":{"id":"wave","name":"Waving Hand","keywords":["wave","hands","gesture","goodbye","solong","farewell","hello","hi","palm"],"skins":[{"unified":"1f44b","native":"\uD83D\uDC4B"},{"unified":"1f44b-1f3fb","native":"\uD83D\uDC4B\uD83C\uDFFB"},{"unified":"1f44b-1f3fc","native":"\uD83D\uDC4B\uD83C\uDFFC"},{"unified":"1f44b-1f3fd","native":"\uD83D\uDC4B\uD83C\uDFFD"},{"unified":"1f44b-1f3fe","native":"\uD83D\uDC4B\uD83C\uDFFE"},{"unified":"1f44b-1f3ff","native":"\uD83D\uDC4B\uD83C\uDFFF"}],"version":1},"raised_back_of_hand":{"id":"raised_back_of_hand","name":"Raised Back of Hand","keywords":["fingers","backhand"],"skins":[{"unified":"1f91a","native":"\uD83E\uDD1A"},{"unified":"1f91a-1f3fb","native":"\uD83E\uDD1A\uD83C\uDFFB"},{"unified":"1f91a-1f3fc","native":"\uD83E\uDD1A\uD83C\uDFFC"},{"unified":"1f91a-1f3fd","native":"\uD83E\uDD1A\uD83C\uDFFD"},{"unified":"1f91a-1f3fe","native":"\uD83E\uDD1A\uD83C\uDFFE"},{"unified":"1f91a-1f3ff","native":"\uD83E\uDD1A\uD83C\uDFFF"}],"version":3},"raised_hand_with_fingers_splayed":{"id":"raised_hand_with_fingers_splayed","name":"Hand with Fingers Splayed","keywords":["raised","palm"],"skins":[{"unified":"1f590-fe0f","native":"\uD83D\uDD90\uFE0F"},{"unified":"1f590-1f3fb","native":"\uD83D\uDD90\uD83C\uDFFB"},{"unified":"1f590-1f3fc","native":"\uD83D\uDD90\uD83C\uDFFC"},{"unified":"1f590-1f3fd","native":"\uD83D\uDD90\uD83C\uDFFD"},{"unified":"1f590-1f3fe","native":"\uD83D\uDD90\uD83C\uDFFE"},{"unified":"1f590-1f3ff","native":"\uD83D\uDD90\uD83C\uDFFF"}],"version":1},"hand":{"id":"hand","name":"Raised Hand","keywords":["fingers","stop","highfive","high","five","palm","ban"],"skins":[{"unified":"270b","native":"\u270B"},{"unified":"270b-1f3fb","native":"\u270B\uD83C\uDFFB"},{"unified":"270b-1f3fc","native":"\u270B\uD83C\uDFFC"},{"unified":"270b-1f3fd","native":"\u270B\uD83C\uDFFD"},{"unified":"270b-1f3fe","native":"\u270B\uD83C\uDFFE"},{"unified":"270b-1f3ff","native":"\u270B\uD83C\uDFFF"}],"version":1},"spock-hand":{"id":"spock-hand","name":"Vulcan Salute","keywords":["spock","hand","fingers","star","trek"],"skins":[{"unified":"1f596","native":"\uD83D\uDD96"},{"unified":"1f596-1f3fb","native":"\uD83D\uDD96\uD83C\uDFFB"},{"unified":"1f596-1f3fc","native":"\uD83D\uDD96\uD83C\uDFFC"},{"unified":"1f596-1f3fd","native":"\uD83D\uDD96\uD83C\uDFFD"},{"unified":"1f596-1f3fe","native":"\uD83D\uDD96\uD83C\uDFFE"},{"unified":"1f596-1f3ff","native":"\uD83D\uDD96\uD83C\uDFFF"}],"version":1},"rightwards_hand":{"id":"rightwards_hand","name":"Rightwards Hand","keywords":["palm","offer"],"skins":[{"unified":"1faf1","native":"\uD83E\uDEF1"},{"unified":"1faf1-1f3fb","native":"\uD83E\uDEF1\uD83C\uDFFB"},{"unified":"1faf1-1f3fc","native":"\uD83E\uDEF1\uD83C\uDFFC"},{"unified":"1faf1-1f3fd","native":"\uD83E\uDEF1\uD83C\uDFFD"},{"unified":"1faf1-1f3fe","native":"\uD83E\uDEF1\uD83C\uDFFE"},{"unified":"1faf1-1f3ff","native":"\uD83E\uDEF1\uD83C\uDFFF"}],"version":14},"leftwards_hand":{"id":"leftwards_hand","name":"Leftwards Hand","keywords":["palm","offer"],"skins":[{"unified":"1faf2","native":"\uD83E\uDEF2"},{"unified":"1faf2-1f3fb","native":"\uD83E\uDEF2\uD83C\uDFFB"},{"unified":"1faf2-1f3fc","native":"\uD83E\uDEF2\uD83C\uDFFC"},{"unified":"1faf2-1f3fd","native":"\uD83E\uDEF2\uD83C\uDFFD"},{"unified":"1faf2-1f3fe","native":"\uD83E\uDEF2\uD83C\uDFFE"},{"unified":"1faf2-1f3ff","native":"\uD83E\uDEF2\uD83C\uDFFF"}],"version":14},"palm_down_hand":{"id":"palm_down_hand","name":"Palm Down Hand","keywords":["drop"],"skins":[{"unified":"1faf3","native":"\uD83E\uDEF3"},{"unified":"1faf3-1f3fb","native":"\uD83E\uDEF3\uD83C\uDFFB"},{"unified":"1faf3-1f3fc","native":"\uD83E\uDEF3\uD83C\uDFFC"},{"unified":"1faf3-1f3fd","native":"\uD83E\uDEF3\uD83C\uDFFD"},{"unified":"1faf3-1f3fe","native":"\uD83E\uDEF3\uD83C\uDFFE"},{"unified":"1faf3-1f3ff","native":"\uD83E\uDEF3\uD83C\uDFFF"}],"version":14},"palm_up_hand":{"id":"palm_up_hand","name":"Palm Up Hand","keywords":["lift","offer","demand"],"skins":[{"unified":"1faf4","native":"\uD83E\uDEF4"},{"unified":"1faf4-1f3fb","native":"\uD83E\uDEF4\uD83C\uDFFB"},{"unified":"1faf4-1f3fc","native":"\uD83E\uDEF4\uD83C\uDFFC"},{"unified":"1faf4-1f3fd","native":"\uD83E\uDEF4\uD83C\uDFFD"},{"unified":"1faf4-1f3fe","native":"\uD83E\uDEF4\uD83C\uDFFE"},{"unified":"1faf4-1f3ff","native":"\uD83E\uDEF4\uD83C\uDFFF"}],"version":14},"leftwards_pushing_hand":{"id":"leftwards_pushing_hand","name":"Leftwards Pushing Hand","keywords":["highfive","high","five","pressing","stop"],"skins":[{"unified":"1faf7","native":"\uD83E\uDEF7"},{"unified":"1faf7-1f3fb","native":"\uD83E\uDEF7\uD83C\uDFFB"},{"unified":"1faf7-1f3fc","native":"\uD83E\uDEF7\uD83C\uDFFC"},{"unified":"1faf7-1f3fd","native":"\uD83E\uDEF7\uD83C\uDFFD"},{"unified":"1faf7-1f3fe","native":"\uD83E\uDEF7\uD83C\uDFFE"},{"unified":"1faf7-1f3ff","native":"\uD83E\uDEF7\uD83C\uDFFF"}],"version":15},"rightwards_pushing_hand":{"id":"rightwards_pushing_hand","name":"Rightwards Pushing Hand","keywords":["highfive","high","five","pressing","stop"],"skins":[{"unified":"1faf8","native":"\uD83E\uDEF8"},{"unified":"1faf8-1f3fb","native":"\uD83E\uDEF8\uD83C\uDFFB"},{"unified":"1faf8-1f3fc","native":"\uD83E\uDEF8\uD83C\uDFFC"},{"unified":"1faf8-1f3fd","native":"\uD83E\uDEF8\uD83C\uDFFD"},{"unified":"1faf8-1f3fe","native":"\uD83E\uDEF8\uD83C\uDFFE"},{"unified":"1faf8-1f3ff","native":"\uD83E\uDEF8\uD83C\uDFFF"}],"version":15},"ok_hand":{"id":"ok_hand","name":"Ok Hand","keywords":["fingers","limbs","perfect","okay"],"skins":[{"unified":"1f44c","native":"\uD83D\uDC4C"},{"unified":"1f44c-1f3fb","native":"\uD83D\uDC4C\uD83C\uDFFB"},{"unified":"1f44c-1f3fc","native":"\uD83D\uDC4C\uD83C\uDFFC"},{"unified":"1f44c-1f3fd","native":"\uD83D\uDC4C\uD83C\uDFFD"},{"unified":"1f44c-1f3fe","native":"\uD83D\uDC4C\uD83C\uDFFE"},{"unified":"1f44c-1f3ff","native":"\uD83D\uDC4C\uD83C\uDFFF"}],"version":1},"pinched_fingers":{"id":"pinched_fingers","name":"Pinched Fingers","keywords":["size","tiny","small"],"skins":[{"unified":"1f90c","native":"\uD83E\uDD0C"},{"unified":"1f90c-1f3fb","native":"\uD83E\uDD0C\uD83C\uDFFB"},{"unified":"1f90c-1f3fc","native":"\uD83E\uDD0C\uD83C\uDFFC"},{"unified":"1f90c-1f3fd","native":"\uD83E\uDD0C\uD83C\uDFFD"},{"unified":"1f90c-1f3fe","native":"\uD83E\uDD0C\uD83C\uDFFE"},{"unified":"1f90c-1f3ff","native":"\uD83E\uDD0C\uD83C\uDFFF"}],"version":13},"pinching_hand":{"id":"pinching_hand","name":"Pinching Hand","keywords":["tiny","small","size"],"skins":[{"unified":"1f90f","native":"\uD83E\uDD0F"},{"unified":"1f90f-1f3fb","native":"\uD83E\uDD0F\uD83C\uDFFB"},{"unified":"1f90f-1f3fc","native":"\uD83E\uDD0F\uD83C\uDFFC"},{"unified":"1f90f-1f3fd","native":"\uD83E\uDD0F\uD83C\uDFFD"},{"unified":"1f90f-1f3fe","native":"\uD83E\uDD0F\uD83C\uDFFE"},{"unified":"1f90f-1f3ff","native":"\uD83E\uDD0F\uD83C\uDFFF"}],"version":12},"v":{"id":"v","name":"Victory Hand","keywords":["v","fingers","ohyeah","peace","two"],"skins":[{"unified":"270c-fe0f","native":"\u270C\uFE0F"},{"unified":"270c-1f3fb","native":"\u270C\uD83C\uDFFB"},{"unified":"270c-1f3fc","native":"\u270C\uD83C\uDFFC"},{"unified":"270c-1f3fd","native":"\u270C\uD83C\uDFFD"},{"unified":"270c-1f3fe","native":"\u270C\uD83C\uDFFE"},{"unified":"270c-1f3ff","native":"\u270C\uD83C\uDFFF"}],"version":1},"crossed_fingers":{"id":"crossed_fingers","name":"Crossed Fingers","keywords":["hand","with","index","and","middle","good","lucky"],"skins":[{"unified":"1f91e","native":"\uD83E\uDD1E"},{"unified":"1f91e-1f3fb","native":"\uD83E\uDD1E\uD83C\uDFFB"},{"unified":"1f91e-1f3fc","native":"\uD83E\uDD1E\uD83C\uDFFC"},{"unified":"1f91e-1f3fd","native":"\uD83E\uDD1E\uD83C\uDFFD"},{"unified":"1f91e-1f3fe","native":"\uD83E\uDD1E\uD83C\uDFFE"},{"unified":"1f91e-1f3ff","native":"\uD83E\uDD1E\uD83C\uDFFF"}],"version":3},"hand_with_index_finger_and_thumb_crossed":{"id":"hand_with_index_finger_and_thumb_crossed","name":"Hand with Index Finger and Thumb Crossed","keywords":["heart","love","money","expensive"],"skins":[{"unified":"1faf0","native":"\uD83E\uDEF0"},{"unified":"1faf0-1f3fb","native":"\uD83E\uDEF0\uD83C\uDFFB"},{"unified":"1faf0-1f3fc","native":"\uD83E\uDEF0\uD83C\uDFFC"},{"unified":"1faf0-1f3fd","native":"\uD83E\uDEF0\uD83C\uDFFD"},{"unified":"1faf0-1f3fe","native":"\uD83E\uDEF0\uD83C\uDFFE"},{"unified":"1faf0-1f3ff","native":"\uD83E\uDEF0\uD83C\uDFFF"}],"version":14},"i_love_you_hand_sign":{"id":"i_love_you_hand_sign","name":"Love-You Gesture","keywords":["i","love","you","hand","sign","fingers"],"skins":[{"unified":"1f91f","native":"\uD83E\uDD1F"},{"unified":"1f91f-1f3fb","native":"\uD83E\uDD1F\uD83C\uDFFB"},{"unified":"1f91f-1f3fc","native":"\uD83E\uDD1F\uD83C\uDFFC"},{"unified":"1f91f-1f3fd","native":"\uD83E\uDD1F\uD83C\uDFFD"},{"unified":"1f91f-1f3fe","native":"\uD83E\uDD1F\uD83C\uDFFE"},{"unified":"1f91f-1f3ff","native":"\uD83E\uDD1F\uD83C\uDFFF"}],"version":5},"the_horns":{"id":"the_horns","name":"Sign of the Horns","keywords":["hand","fingers","evil","eye","rock","on"],"skins":[{"unified":"1f918","native":"\uD83E\uDD18"},{"unified":"1f918-1f3fb","native":"\uD83E\uDD18\uD83C\uDFFB"},{"unified":"1f918-1f3fc","native":"\uD83E\uDD18\uD83C\uDFFC"},{"unified":"1f918-1f3fd","native":"\uD83E\uDD18\uD83C\uDFFD"},{"unified":"1f918-1f3fe","native":"\uD83E\uDD18\uD83C\uDFFE"},{"unified":"1f918-1f3ff","native":"\uD83E\uDD18\uD83C\uDFFF"}],"version":1},"call_me_hand":{"id":"call_me_hand","name":"Call Me Hand","keywords":["hands","gesture","shaka"],"skins":[{"unified":"1f919","native":"\uD83E\uDD19"},{"unified":"1f919-1f3fb","native":"\uD83E\uDD19\uD83C\uDFFB"},{"unified":"1f919-1f3fc","native":"\uD83E\uDD19\uD83C\uDFFC"},{"unified":"1f919-1f3fd","native":"\uD83E\uDD19\uD83C\uDFFD"},{"unified":"1f919-1f3fe","native":"\uD83E\uDD19\uD83C\uDFFE"},{"unified":"1f919-1f3ff","native":"\uD83E\uDD19\uD83C\uDFFF"}],"version":3},"point_left":{"id":"point_left","name":"Backhand Index Pointing Left","keywords":["point","direction","fingers","hand"],"skins":[{"unified":"1f448","native":"\uD83D\uDC48"},{"unified":"1f448-1f3fb","native":"\uD83D\uDC48\uD83C\uDFFB"},{"unified":"1f448-1f3fc","native":"\uD83D\uDC48\uD83C\uDFFC"},{"unified":"1f448-1f3fd","native":"\uD83D\uDC48\uD83C\uDFFD"},{"unified":"1f448-1f3fe","native":"\uD83D\uDC48\uD83C\uDFFE"},{"unified":"1f448-1f3ff","native":"\uD83D\uDC48\uD83C\uDFFF"}],"version":1},"point_right":{"id":"point_right","name":"Backhand Index Pointing Right","keywords":["point","fingers","hand","direction"],"skins":[{"unified":"1f449","native":"\uD83D\uDC49"},{"unified":"1f449-1f3fb","native":"\uD83D\uDC49\uD83C\uDFFB"},{"unified":"1f449-1f3fc","native":"\uD83D\uDC49\uD83C\uDFFC"},{"unified":"1f449-1f3fd","native":"\uD83D\uDC49\uD83C\uDFFD"},{"unified":"1f449-1f3fe","native":"\uD83D\uDC49\uD83C\uDFFE"},{"unified":"1f449-1f3ff","native":"\uD83D\uDC49\uD83C\uDFFF"}],"version":1},"point_up_2":{"id":"point_up_2","name":"Backhand Index Pointing Up","keywords":["point","2","fingers","hand","direction"],"skins":[{"unified":"1f446","native":"\uD83D\uDC46"},{"unified":"1f446-1f3fb","native":"\uD83D\uDC46\uD83C\uDFFB"},{"unified":"1f446-1f3fc","native":"\uD83D\uDC46\uD83C\uDFFC"},{"unified":"1f446-1f3fd","native":"\uD83D\uDC46\uD83C\uDFFD"},{"unified":"1f446-1f3fe","native":"\uD83D\uDC46\uD83C\uDFFE"},{"unified":"1f446-1f3ff","native":"\uD83D\uDC46\uD83C\uDFFF"}],"version":1},"middle_finger":{"id":"middle_finger","name":"Middle Finger","keywords":["reversed","hand","with","extended","fingers","rude","flipping"],"skins":[{"unified":"1f595","native":"\uD83D\uDD95"},{"unified":"1f595-1f3fb","native":"\uD83D\uDD95\uD83C\uDFFB"},{"unified":"1f595-1f3fc","native":"\uD83D\uDD95\uD83C\uDFFC"},{"unified":"1f595-1f3fd","native":"\uD83D\uDD95\uD83C\uDFFD"},{"unified":"1f595-1f3fe","native":"\uD83D\uDD95\uD83C\uDFFE"},{"unified":"1f595-1f3ff","native":"\uD83D\uDD95\uD83C\uDFFF"}],"version":1},"point_down":{"id":"point_down","name":"Backhand Index Pointing Down","keywords":["point","fingers","hand","direction"],"skins":[{"unified":"1f447","native":"\uD83D\uDC47"},{"unified":"1f447-1f3fb","native":"\uD83D\uDC47\uD83C\uDFFB"},{"unified":"1f447-1f3fc","native":"\uD83D\uDC47\uD83C\uDFFC"},{"unified":"1f447-1f3fd","native":"\uD83D\uDC47\uD83C\uDFFD"},{"unified":"1f447-1f3fe","native":"\uD83D\uDC47\uD83C\uDFFE"},{"unified":"1f447-1f3ff","native":"\uD83D\uDC47\uD83C\uDFFF"}],"version":1},"point_up":{"id":"point_up","name":"Index Pointing Up","keywords":["point","hand","fingers","direction"],"skins":[{"unified":"261d-fe0f","native":"\u261D\uFE0F"},{"unified":"261d-1f3fb","native":"\u261D\uD83C\uDFFB"},{"unified":"261d-1f3fc","native":"\u261D\uD83C\uDFFC"},{"unified":"261d-1f3fd","native":"\u261D\uD83C\uDFFD"},{"unified":"261d-1f3fe","native":"\u261D\uD83C\uDFFE"},{"unified":"261d-1f3ff","native":"\u261D\uD83C\uDFFF"}],"version":1},"index_pointing_at_the_viewer":{"id":"index_pointing_at_the_viewer","name":"Index Pointing at the Viewer","keywords":["you","recruit"],"skins":[{"unified":"1faf5","native":"\uD83E\uDEF5"},{"unified":"1faf5-1f3fb","native":"\uD83E\uDEF5\uD83C\uDFFB"},{"unified":"1faf5-1f3fc","native":"\uD83E\uDEF5\uD83C\uDFFC"},{"unified":"1faf5-1f3fd","native":"\uD83E\uDEF5\uD83C\uDFFD"},{"unified":"1faf5-1f3fe","native":"\uD83E\uDEF5\uD83C\uDFFE"},{"unified":"1faf5-1f3ff","native":"\uD83E\uDEF5\uD83C\uDFFF"}],"version":14},"+1":{"id":"+1","name":"Thumbs Up","keywords":["+1","thumbsup","yes","awesome","good","agree","accept","cool","hand","like"],"skins":[{"unified":"1f44d","native":"\uD83D\uDC4D"},{"unified":"1f44d-1f3fb","native":"\uD83D\uDC4D\uD83C\uDFFB"},{"unified":"1f44d-1f3fc","native":"\uD83D\uDC4D\uD83C\uDFFC"},{"unified":"1f44d-1f3fd","native":"\uD83D\uDC4D\uD83C\uDFFD"},{"unified":"1f44d-1f3fe","native":"\uD83D\uDC4D\uD83C\uDFFE"},{"unified":"1f44d-1f3ff","native":"\uD83D\uDC4D\uD83C\uDFFF"}],"version":1},"-1":{"id":"-1","name":"Thumbs Down","keywords":["-1","thumbsdown","no","dislike","hand"],"skins":[{"unified":"1f44e","native":"\uD83D\uDC4E"},{"unified":"1f44e-1f3fb","native":"\uD83D\uDC4E\uD83C\uDFFB"},{"unified":"1f44e-1f3fc","native":"\uD83D\uDC4E\uD83C\uDFFC"},{"unified":"1f44e-1f3fd","native":"\uD83D\uDC4E\uD83C\uDFFD"},{"unified":"1f44e-1f3fe","native":"\uD83D\uDC4E\uD83C\uDFFE"},{"unified":"1f44e-1f3ff","native":"\uD83D\uDC4E\uD83C\uDFFF"}],"version":1},"fist":{"id":"fist","name":"Raised Fist","keywords":["fingers","hand","grasp"],"skins":[{"unified":"270a","native":"\u270A"},{"unified":"270a-1f3fb","native":"\u270A\uD83C\uDFFB"},{"unified":"270a-1f3fc","native":"\u270A\uD83C\uDFFC"},{"unified":"270a-1f3fd","native":"\u270A\uD83C\uDFFD"},{"unified":"270a-1f3fe","native":"\u270A\uD83C\uDFFE"},{"unified":"270a-1f3ff","native":"\u270A\uD83C\uDFFF"}],"version":1},"facepunch":{"id":"facepunch","name":"Oncoming Fist","keywords":["facepunch","punch","angry","violence","hit","attack","hand"],"skins":[{"unified":"1f44a","native":"\uD83D\uDC4A"},{"unified":"1f44a-1f3fb","native":"\uD83D\uDC4A\uD83C\uDFFB"},{"unified":"1f44a-1f3fc","native":"\uD83D\uDC4A\uD83C\uDFFC"},{"unified":"1f44a-1f3fd","native":"\uD83D\uDC4A\uD83C\uDFFD"},{"unified":"1f44a-1f3fe","native":"\uD83D\uDC4A\uD83C\uDFFE"},{"unified":"1f44a-1f3ff","native":"\uD83D\uDC4A\uD83C\uDFFF"}],"version":1},"left-facing_fist":{"id":"left-facing_fist","name":"Left-Facing Fist","keywords":["left","facing","hand","fistbump"],"skins":[{"unified":"1f91b","native":"\uD83E\uDD1B"},{"unified":"1f91b-1f3fb","native":"\uD83E\uDD1B\uD83C\uDFFB"},{"unified":"1f91b-1f3fc","native":"\uD83E\uDD1B\uD83C\uDFFC"},{"unified":"1f91b-1f3fd","native":"\uD83E\uDD1B\uD83C\uDFFD"},{"unified":"1f91b-1f3fe","native":"\uD83E\uDD1B\uD83C\uDFFE"},{"unified":"1f91b-1f3ff","native":"\uD83E\uDD1B\uD83C\uDFFF"}],"version":3},"right-facing_fist":{"id":"right-facing_fist","name":"Right-Facing Fist","keywords":["right","facing","hand","fistbump"],"skins":[{"unified":"1f91c","native":"\uD83E\uDD1C"},{"unified":"1f91c-1f3fb","native":"\uD83E\uDD1C\uD83C\uDFFB"},{"unified":"1f91c-1f3fc","native":"\uD83E\uDD1C\uD83C\uDFFC"},{"unified":"1f91c-1f3fd","native":"\uD83E\uDD1C\uD83C\uDFFD"},{"unified":"1f91c-1f3fe","native":"\uD83E\uDD1C\uD83C\uDFFE"},{"unified":"1f91c-1f3ff","native":"\uD83E\uDD1C\uD83C\uDFFF"}],"version":3},"clap":{"id":"clap","name":"Clapping Hands","keywords":["clap","praise","applause","congrats","yay"],"skins":[{"unified":"1f44f","native":"\uD83D\uDC4F"},{"unified":"1f44f-1f3fb","native":"\uD83D\uDC4F\uD83C\uDFFB"},{"unified":"1f44f-1f3fc","native":"\uD83D\uDC4F\uD83C\uDFFC"},{"unified":"1f44f-1f3fd","native":"\uD83D\uDC4F\uD83C\uDFFD"},{"unified":"1f44f-1f3fe","native":"\uD83D\uDC4F\uD83C\uDFFE"},{"unified":"1f44f-1f3ff","native":"\uD83D\uDC4F\uD83C\uDFFF"}],"version":1},"raised_hands":{"id":"raised_hands","name":"Raising Hands","keywords":["raised","gesture","hooray","yea","celebration"],"skins":[{"unified":"1f64c","native":"\uD83D\uDE4C"},{"unified":"1f64c-1f3fb","native":"\uD83D\uDE4C\uD83C\uDFFB"},{"unified":"1f64c-1f3fc","native":"\uD83D\uDE4C\uD83C\uDFFC"},{"unified":"1f64c-1f3fd","native":"\uD83D\uDE4C\uD83C\uDFFD"},{"unified":"1f64c-1f3fe","native":"\uD83D\uDE4C\uD83C\uDFFE"},{"unified":"1f64c-1f3ff","native":"\uD83D\uDE4C\uD83C\uDFFF"}],"version":1},"heart_hands":{"id":"heart_hands","name":"Heart Hands","keywords":["love","appreciation","support"],"skins":[{"unified":"1faf6","native":"\uD83E\uDEF6"},{"unified":"1faf6-1f3fb","native":"\uD83E\uDEF6\uD83C\uDFFB"},{"unified":"1faf6-1f3fc","native":"\uD83E\uDEF6\uD83C\uDFFC"},{"unified":"1faf6-1f3fd","native":"\uD83E\uDEF6\uD83C\uDFFD"},{"unified":"1faf6-1f3fe","native":"\uD83E\uDEF6\uD83C\uDFFE"},{"unified":"1faf6-1f3ff","native":"\uD83E\uDEF6\uD83C\uDFFF"}],"version":14},"open_hands":{"id":"open_hands","name":"Open Hands","keywords":["fingers","butterfly"],"skins":[{"unified":"1f450","native":"\uD83D\uDC50"},{"unified":"1f450-1f3fb","native":"\uD83D\uDC50\uD83C\uDFFB"},{"unified":"1f450-1f3fc","native":"\uD83D\uDC50\uD83C\uDFFC"},{"unified":"1f450-1f3fd","native":"\uD83D\uDC50\uD83C\uDFFD"},{"unified":"1f450-1f3fe","native":"\uD83D\uDC50\uD83C\uDFFE"},{"unified":"1f450-1f3ff","native":"\uD83D\uDC50\uD83C\uDFFF"}],"version":1},"palms_up_together":{"id":"palms_up_together","name":"Palms Up Together","keywords":["hands","gesture","cupped","prayer"],"skins":[{"unified":"1f932","native":"\uD83E\uDD32"},{"unified":"1f932-1f3fb","native":"\uD83E\uDD32\uD83C\uDFFB"},{"unified":"1f932-1f3fc","native":"\uD83E\uDD32\uD83C\uDFFC"},{"unified":"1f932-1f3fd","native":"\uD83E\uDD32\uD83C\uDFFD"},{"unified":"1f932-1f3fe","native":"\uD83E\uDD32\uD83C\uDFFE"},{"unified":"1f932-1f3ff","native":"\uD83E\uDD32\uD83C\uDFFF"}],"version":5},"handshake":{"id":"handshake","name":"Handshake","keywords":["agreement","shake"],"skins":[{"unified":"1f91d","native":"\uD83E\uDD1D"},{"unified":"1f91d-1f3fb","native":"\uD83E\uDD1D\uD83C\uDFFB"},{"unified":"1f91d-1f3fc","native":"\uD83E\uDD1D\uD83C\uDFFC"},{"unified":"1f91d-1f3fd","native":"\uD83E\uDD1D\uD83C\uDFFD"},{"unified":"1f91d-1f3fe","native":"\uD83E\uDD1D\uD83C\uDFFE"},{"unified":"1f91d-1f3ff","native":"\uD83E\uDD1D\uD83C\uDFFF"}],"version":3},"pray":{"id":"pray","name":"Folded Hands","keywords":["pray","please","hope","wish","namaste","highfive","high","five","thank","you","thanks","appreciate"],"skins":[{"unified":"1f64f","native":"\uD83D\uDE4F"},{"unified":"1f64f-1f3fb","native":"\uD83D\uDE4F\uD83C\uDFFB"},{"unified":"1f64f-1f3fc","native":"\uD83D\uDE4F\uD83C\uDFFC"},{"unified":"1f64f-1f3fd","native":"\uD83D\uDE4F\uD83C\uDFFD"},{"unified":"1f64f-1f3fe","native":"\uD83D\uDE4F\uD83C\uDFFE"},{"unified":"1f64f-1f3ff","native":"\uD83D\uDE4F\uD83C\uDFFF"}],"version":1},"writing_hand":{"id":"writing_hand","name":"Writing Hand","keywords":["lower","left","ballpoint","pen","stationery","write","compose"],"skins":[{"unified":"270d-fe0f","native":"\u270D\uFE0F"},{"unified":"270d-1f3fb","native":"\u270D\uD83C\uDFFB"},{"unified":"270d-1f3fc","native":"\u270D\uD83C\uDFFC"},{"unified":"270d-1f3fd","native":"\u270D\uD83C\uDFFD"},{"unified":"270d-1f3fe","native":"\u270D\uD83C\uDFFE"},{"unified":"270d-1f3ff","native":"\u270D\uD83C\uDFFF"}],"version":1},"nail_care":{"id":"nail_care","name":"Nail Polish","keywords":["care","beauty","manicure","finger","fashion"],"skins":[{"unified":"1f485","native":"\uD83D\uDC85"},{"unified":"1f485-1f3fb","native":"\uD83D\uDC85\uD83C\uDFFB"},{"unified":"1f485-1f3fc","native":"\uD83D\uDC85\uD83C\uDFFC"},{"unified":"1f485-1f3fd","native":"\uD83D\uDC85\uD83C\uDFFD"},{"unified":"1f485-1f3fe","native":"\uD83D\uDC85\uD83C\uDFFE"},{"unified":"1f485-1f3ff","native":"\uD83D\uDC85\uD83C\uDFFF"}],"version":1},"selfie":{"id":"selfie","name":"Selfie","keywords":["camera","phone"],"skins":[{"unified":"1f933","native":"\uD83E\uDD33"},{"unified":"1f933-1f3fb","native":"\uD83E\uDD33\uD83C\uDFFB"},{"unified":"1f933-1f3fc","native":"\uD83E\uDD33\uD83C\uDFFC"},{"unified":"1f933-1f3fd","native":"\uD83E\uDD33\uD83C\uDFFD"},{"unified":"1f933-1f3fe","native":"\uD83E\uDD33\uD83C\uDFFE"},{"unified":"1f933-1f3ff","native":"\uD83E\uDD33\uD83C\uDFFF"}],"version":3},"muscle":{"id":"muscle","name":"Flexed Biceps","keywords":["muscle","arm","flex","hand","summer","strong"],"skins":[{"unified":"1f4aa","native":"\uD83D\uDCAA"},{"unified":"1f4aa-1f3fb","native":"\uD83D\uDCAA\uD83C\uDFFB"},{"unified":"1f4aa-1f3fc","native":"\uD83D\uDCAA\uD83C\uDFFC"},{"unified":"1f4aa-1f3fd","native":"\uD83D\uDCAA\uD83C\uDFFD"},{"unified":"1f4aa-1f3fe","native":"\uD83D\uDCAA\uD83C\uDFFE"},{"unified":"1f4aa-1f3ff","native":"\uD83D\uDCAA\uD83C\uDFFF"}],"version":1},"mechanical_arm":{"id":"mechanical_arm","name":"Mechanical Arm","keywords":["accessibility"],"skins":[{"unified":"1f9be","native":"\uD83E\uDDBE"}],"version":12},"mechanical_leg":{"id":"mechanical_leg","name":"Mechanical Leg","keywords":["accessibility"],"skins":[{"unified":"1f9bf","native":"\uD83E\uDDBF"}],"version":12},"leg":{"id":"leg","name":"Leg","keywords":["kick","limb"],"skins":[{"unified":"1f9b5","native":"\uD83E\uDDB5"},{"unified":"1f9b5-1f3fb","native":"\uD83E\uDDB5\uD83C\uDFFB"},{"unified":"1f9b5-1f3fc","native":"\uD83E\uDDB5\uD83C\uDFFC"},{"unified":"1f9b5-1f3fd","native":"\uD83E\uDDB5\uD83C\uDFFD"},{"unified":"1f9b5-1f3fe","native":"\uD83E\uDDB5\uD83C\uDFFE"},{"unified":"1f9b5-1f3ff","native":"\uD83E\uDDB5\uD83C\uDFFF"}],"version":11},"foot":{"id":"foot","name":"Foot","keywords":["kick","stomp"],"skins":[{"unified":"1f9b6","native":"\uD83E\uDDB6"},{"unified":"1f9b6-1f3fb","native":"\uD83E\uDDB6\uD83C\uDFFB"},{"unified":"1f9b6-1f3fc","native":"\uD83E\uDDB6\uD83C\uDFFC"},{"unified":"1f9b6-1f3fd","native":"\uD83E\uDDB6\uD83C\uDFFD"},{"unified":"1f9b6-1f3fe","native":"\uD83E\uDDB6\uD83C\uDFFE"},{"unified":"1f9b6-1f3ff","native":"\uD83E\uDDB6\uD83C\uDFFF"}],"version":11},"ear":{"id":"ear","name":"Ear","keywords":["face","hear","sound","listen"],"skins":[{"unified":"1f442","native":"\uD83D\uDC42"},{"unified":"1f442-1f3fb","native":"\uD83D\uDC42\uD83C\uDFFB"},{"unified":"1f442-1f3fc","native":"\uD83D\uDC42\uD83C\uDFFC"},{"unified":"1f442-1f3fd","native":"\uD83D\uDC42\uD83C\uDFFD"},{"unified":"1f442-1f3fe","native":"\uD83D\uDC42\uD83C\uDFFE"},{"unified":"1f442-1f3ff","native":"\uD83D\uDC42\uD83C\uDFFF"}],"version":1},"ear_with_hearing_aid":{"id":"ear_with_hearing_aid","name":"Ear with Hearing Aid","keywords":["accessibility"],"skins":[{"unified":"1f9bb","native":"\uD83E\uDDBB"},{"unified":"1f9bb-1f3fb","native":"\uD83E\uDDBB\uD83C\uDFFB"},{"unified":"1f9bb-1f3fc","native":"\uD83E\uDDBB\uD83C\uDFFC"},{"unified":"1f9bb-1f3fd","native":"\uD83E\uDDBB\uD83C\uDFFD"},{"unified":"1f9bb-1f3fe","native":"\uD83E\uDDBB\uD83C\uDFFE"},{"unified":"1f9bb-1f3ff","native":"\uD83E\uDDBB\uD83C\uDFFF"}],"version":12},"nose":{"id":"nose","name":"Nose","keywords":["smell","sniff"],"skins":[{"unified":"1f443","native":"\uD83D\uDC43"},{"unified":"1f443-1f3fb","native":"\uD83D\uDC43\uD83C\uDFFB"},{"unified":"1f443-1f3fc","native":"\uD83D\uDC43\uD83C\uDFFC"},{"unified":"1f443-1f3fd","native":"\uD83D\uDC43\uD83C\uDFFD"},{"unified":"1f443-1f3fe","native":"\uD83D\uDC43\uD83C\uDFFE"},{"unified":"1f443-1f3ff","native":"\uD83D\uDC43\uD83C\uDFFF"}],"version":1},"brain":{"id":"brain","name":"Brain","keywords":["smart","intelligent"],"skins":[{"unified":"1f9e0","native":"\uD83E\uDDE0"}],"version":5},"anatomical_heart":{"id":"anatomical_heart","name":"Anatomical Heart","keywords":["health","heartbeat"],"skins":[{"unified":"1fac0","native":"\uD83E\uDEC0"}],"version":13},"lungs":{"id":"lungs","name":"Lungs","keywords":["breathe"],"skins":[{"unified":"1fac1","native":"\uD83E\uDEC1"}],"version":13},"tooth":{"id":"tooth","name":"Tooth","keywords":["teeth","dentist"],"skins":[{"unified":"1f9b7","native":"\uD83E\uDDB7"}],"version":11},"bone":{"id":"bone","name":"Bone","keywords":["skeleton"],"skins":[{"unified":"1f9b4","native":"\uD83E\uDDB4"}],"version":11},"eyes":{"id":"eyes","name":"Eyes","keywords":["look","watch","stalk","peek","see"],"skins":[{"unified":"1f440","native":"\uD83D\uDC40"}],"version":1},"eye":{"id":"eye","name":"Eye","keywords":["face","look","see","watch","stare"],"skins":[{"unified":"1f441-fe0f","native":"\uD83D\uDC41\uFE0F"}],"version":1},"tongue":{"id":"tongue","name":"Tongue","keywords":["mouth","playful"],"skins":[{"unified":"1f445","native":"\uD83D\uDC45"}],"version":1},"lips":{"id":"lips","name":"Mouth","keywords":["lips","kiss"],"skins":[{"unified":"1f444","native":"\uD83D\uDC44"}],"version":1},"biting_lip":{"id":"biting_lip","name":"Biting Lip","keywords":["flirt","sexy","pain","worry"],"skins":[{"unified":"1fae6","native":"\uD83E\uDEE6"}],"version":14},"baby":{"id":"baby","name":"Baby","keywords":["child","boy","girl","toddler"],"skins":[{"unified":"1f476","native":"\uD83D\uDC76"},{"unified":"1f476-1f3fb","native":"\uD83D\uDC76\uD83C\uDFFB"},{"unified":"1f476-1f3fc","native":"\uD83D\uDC76\uD83C\uDFFC"},{"unified":"1f476-1f3fd","native":"\uD83D\uDC76\uD83C\uDFFD"},{"unified":"1f476-1f3fe","native":"\uD83D\uDC76\uD83C\uDFFE"},{"unified":"1f476-1f3ff","native":"\uD83D\uDC76\uD83C\uDFFF"}],"version":1},"child":{"id":"child","name":"Child","keywords":["gender","neutral","young"],"skins":[{"unified":"1f9d2","native":"\uD83E\uDDD2"},{"unified":"1f9d2-1f3fb","native":"\uD83E\uDDD2\uD83C\uDFFB"},{"unified":"1f9d2-1f3fc","native":"\uD83E\uDDD2\uD83C\uDFFC"},{"unified":"1f9d2-1f3fd","native":"\uD83E\uDDD2\uD83C\uDFFD"},{"unified":"1f9d2-1f3fe","native":"\uD83E\uDDD2\uD83C\uDFFE"},{"unified":"1f9d2-1f3ff","native":"\uD83E\uDDD2\uD83C\uDFFF"}],"version":5},"boy":{"id":"boy","name":"Boy","keywords":["man","male","guy","teenager"],"skins":[{"unified":"1f466","native":"\uD83D\uDC66"},{"unified":"1f466-1f3fb","native":"\uD83D\uDC66\uD83C\uDFFB"},{"unified":"1f466-1f3fc","native":"\uD83D\uDC66\uD83C\uDFFC"},{"unified":"1f466-1f3fd","native":"\uD83D\uDC66\uD83C\uDFFD"},{"unified":"1f466-1f3fe","native":"\uD83D\uDC66\uD83C\uDFFE"},{"unified":"1f466-1f3ff","native":"\uD83D\uDC66\uD83C\uDFFF"}],"version":1},"girl":{"id":"girl","name":"Girl","keywords":["female","woman","teenager"],"skins":[{"unified":"1f467","native":"\uD83D\uDC67"},{"unified":"1f467-1f3fb","native":"\uD83D\uDC67\uD83C\uDFFB"},{"unified":"1f467-1f3fc","native":"\uD83D\uDC67\uD83C\uDFFC"},{"unified":"1f467-1f3fd","native":"\uD83D\uDC67\uD83C\uDFFD"},{"unified":"1f467-1f3fe","native":"\uD83D\uDC67\uD83C\uDFFE"},{"unified":"1f467-1f3ff","native":"\uD83D\uDC67\uD83C\uDFFF"}],"version":1},"adult":{"id":"adult","name":"Adult","keywords":["person","gender","neutral"],"skins":[{"unified":"1f9d1","native":"\uD83E\uDDD1"},{"unified":"1f9d1-1f3fb","native":"\uD83E\uDDD1\uD83C\uDFFB"},{"unified":"1f9d1-1f3fc","native":"\uD83E\uDDD1\uD83C\uDFFC"},{"unified":"1f9d1-1f3fd","native":"\uD83E\uDDD1\uD83C\uDFFD"},{"unified":"1f9d1-1f3fe","native":"\uD83E\uDDD1\uD83C\uDFFE"},{"unified":"1f9d1-1f3ff","native":"\uD83E\uDDD1\uD83C\uDFFF"}],"version":5},"person_with_blond_hair":{"id":"person_with_blond_hair","name":"Person Blond Hair","keywords":["with","hairstyle"],"skins":[{"unified":"1f471","native":"\uD83D\uDC71"},{"unified":"1f471-1f3fb","native":"\uD83D\uDC71\uD83C\uDFFB"},{"unified":"1f471-1f3fc","native":"\uD83D\uDC71\uD83C\uDFFC"},{"unified":"1f471-1f3fd","native":"\uD83D\uDC71\uD83C\uDFFD"},{"unified":"1f471-1f3fe","native":"\uD83D\uDC71\uD83C\uDFFE"},{"unified":"1f471-1f3ff","native":"\uD83D\uDC71\uD83C\uDFFF"}],"version":1},"man":{"id":"man","name":"Man","keywords":["mustache","father","dad","guy","classy","sir","moustache"],"skins":[{"unified":"1f468","native":"\uD83D\uDC68"},{"unified":"1f468-1f3fb","native":"\uD83D\uDC68\uD83C\uDFFB"},{"unified":"1f468-1f3fc","native":"\uD83D\uDC68\uD83C\uDFFC"},{"unified":"1f468-1f3fd","native":"\uD83D\uDC68\uD83C\uDFFD"},{"unified":"1f468-1f3fe","native":"\uD83D\uDC68\uD83C\uDFFE"},{"unified":"1f468-1f3ff","native":"\uD83D\uDC68\uD83C\uDFFF"}],"version":1},"bearded_person":{"id":"bearded_person","name":"Person Beard","keywords":["bearded","man","bewhiskered"],"skins":[{"unified":"1f9d4","native":"\uD83E\uDDD4"},{"unified":"1f9d4-1f3fb","native":"\uD83E\uDDD4\uD83C\uDFFB"},{"unified":"1f9d4-1f3fc","native":"\uD83E\uDDD4\uD83C\uDFFC"},{"unified":"1f9d4-1f3fd","native":"\uD83E\uDDD4\uD83C\uDFFD"},{"unified":"1f9d4-1f3fe","native":"\uD83E\uDDD4\uD83C\uDFFE"},{"unified":"1f9d4-1f3ff","native":"\uD83E\uDDD4\uD83C\uDFFF"}],"version":5},"man_with_beard":{"id":"man_with_beard","name":"Man: Beard","keywords":["man","with","facial","hair"],"skins":[{"unified":"1f9d4-200d-2642-fe0f","native":"\uD83E\uDDD4\u200D\u2642\uFE0F"},{"unified":"1f9d4-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9d4-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9d4-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9d4-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9d4-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":13.1},"woman_with_beard":{"id":"woman_with_beard","name":"Woman: Beard","keywords":["woman","with","facial","hair"],"skins":[{"unified":"1f9d4-200d-2640-fe0f","native":"\uD83E\uDDD4\u200D\u2640\uFE0F"},{"unified":"1f9d4-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9d4-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9d4-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9d4-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9d4-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":13.1},"red_haired_man":{"id":"red_haired_man","name":"Man: Red Hair","keywords":["haired","man","hairstyle"],"skins":[{"unified":"1f468-200d-1f9b0","native":"\uD83D\uDC68\u200D\uD83E\uDDB0"},{"unified":"1f468-1f3fb-200d-1f9b0","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB0"},{"unified":"1f468-1f3fc-200d-1f9b0","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB0"},{"unified":"1f468-1f3fd-200d-1f9b0","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB0"},{"unified":"1f468-1f3fe-200d-1f9b0","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB0"},{"unified":"1f468-1f3ff-200d-1f9b0","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB0"}],"version":11},"curly_haired_man":{"id":"curly_haired_man","name":"Man: Curly Hair","keywords":["haired","man","hairstyle"],"skins":[{"unified":"1f468-200d-1f9b1","native":"\uD83D\uDC68\u200D\uD83E\uDDB1"},{"unified":"1f468-1f3fb-200d-1f9b1","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB1"},{"unified":"1f468-1f3fc-200d-1f9b1","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB1"},{"unified":"1f468-1f3fd-200d-1f9b1","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB1"},{"unified":"1f468-1f3fe-200d-1f9b1","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB1"},{"unified":"1f468-1f3ff-200d-1f9b1","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB1"}],"version":11},"white_haired_man":{"id":"white_haired_man","name":"Man: White Hair","keywords":["haired","man","old","elder"],"skins":[{"unified":"1f468-200d-1f9b3","native":"\uD83D\uDC68\u200D\uD83E\uDDB3"},{"unified":"1f468-1f3fb-200d-1f9b3","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB3"},{"unified":"1f468-1f3fc-200d-1f9b3","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB3"},{"unified":"1f468-1f3fd-200d-1f9b3","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB3"},{"unified":"1f468-1f3fe-200d-1f9b3","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB3"},{"unified":"1f468-1f3ff-200d-1f9b3","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB3"}],"version":11},"bald_man":{"id":"bald_man","name":"Man: Bald","keywords":["man","hairless"],"skins":[{"unified":"1f468-200d-1f9b2","native":"\uD83D\uDC68\u200D\uD83E\uDDB2"},{"unified":"1f468-1f3fb-200d-1f9b2","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB2"},{"unified":"1f468-1f3fc-200d-1f9b2","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB2"},{"unified":"1f468-1f3fd-200d-1f9b2","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB2"},{"unified":"1f468-1f3fe-200d-1f9b2","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB2"},{"unified":"1f468-1f3ff-200d-1f9b2","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB2"}],"version":11},"woman":{"id":"woman","name":"Woman","keywords":["female","girls","lady"],"skins":[{"unified":"1f469","native":"\uD83D\uDC69"},{"unified":"1f469-1f3fb","native":"\uD83D\uDC69\uD83C\uDFFB"},{"unified":"1f469-1f3fc","native":"\uD83D\uDC69\uD83C\uDFFC"},{"unified":"1f469-1f3fd","native":"\uD83D\uDC69\uD83C\uDFFD"},{"unified":"1f469-1f3fe","native":"\uD83D\uDC69\uD83C\uDFFE"},{"unified":"1f469-1f3ff","native":"\uD83D\uDC69\uD83C\uDFFF"}],"version":1},"red_haired_woman":{"id":"red_haired_woman","name":"Woman: Red Hair","keywords":["haired","woman","hairstyle"],"skins":[{"unified":"1f469-200d-1f9b0","native":"\uD83D\uDC69\u200D\uD83E\uDDB0"},{"unified":"1f469-1f3fb-200d-1f9b0","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB0"},{"unified":"1f469-1f3fc-200d-1f9b0","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB0"},{"unified":"1f469-1f3fd-200d-1f9b0","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB0"},{"unified":"1f469-1f3fe-200d-1f9b0","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB0"},{"unified":"1f469-1f3ff-200d-1f9b0","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB0"}],"version":11},"red_haired_person":{"id":"red_haired_person","name":"Person: Red Hair","keywords":["haired","person","hairstyle"],"skins":[{"unified":"1f9d1-200d-1f9b0","native":"\uD83E\uDDD1\u200D\uD83E\uDDB0"},{"unified":"1f9d1-1f3fb-200d-1f9b0","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB0"},{"unified":"1f9d1-1f3fc-200d-1f9b0","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB0"},{"unified":"1f9d1-1f3fd-200d-1f9b0","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB0"},{"unified":"1f9d1-1f3fe-200d-1f9b0","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB0"},{"unified":"1f9d1-1f3ff-200d-1f9b0","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB0"}],"version":12.1},"curly_haired_woman":{"id":"curly_haired_woman","name":"Woman: Curly Hair","keywords":["haired","woman","hairstyle"],"skins":[{"unified":"1f469-200d-1f9b1","native":"\uD83D\uDC69\u200D\uD83E\uDDB1"},{"unified":"1f469-1f3fb-200d-1f9b1","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB1"},{"unified":"1f469-1f3fc-200d-1f9b1","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB1"},{"unified":"1f469-1f3fd-200d-1f9b1","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB1"},{"unified":"1f469-1f3fe-200d-1f9b1","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB1"},{"unified":"1f469-1f3ff-200d-1f9b1","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB1"}],"version":11},"curly_haired_person":{"id":"curly_haired_person","name":"Person: Curly Hair","keywords":["haired","person","hairstyle"],"skins":[{"unified":"1f9d1-200d-1f9b1","native":"\uD83E\uDDD1\u200D\uD83E\uDDB1"},{"unified":"1f9d1-1f3fb-200d-1f9b1","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB1"},{"unified":"1f9d1-1f3fc-200d-1f9b1","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB1"},{"unified":"1f9d1-1f3fd-200d-1f9b1","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB1"},{"unified":"1f9d1-1f3fe-200d-1f9b1","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB1"},{"unified":"1f9d1-1f3ff-200d-1f9b1","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB1"}],"version":12.1},"white_haired_woman":{"id":"white_haired_woman","name":"Woman: White Hair","keywords":["haired","woman","old","elder"],"skins":[{"unified":"1f469-200d-1f9b3","native":"\uD83D\uDC69\u200D\uD83E\uDDB3"},{"unified":"1f469-1f3fb-200d-1f9b3","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB3"},{"unified":"1f469-1f3fc-200d-1f9b3","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB3"},{"unified":"1f469-1f3fd-200d-1f9b3","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB3"},{"unified":"1f469-1f3fe-200d-1f9b3","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB3"},{"unified":"1f469-1f3ff-200d-1f9b3","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB3"}],"version":11},"white_haired_person":{"id":"white_haired_person","name":"Person: White Hair","keywords":["haired","person","elder","old"],"skins":[{"unified":"1f9d1-200d-1f9b3","native":"\uD83E\uDDD1\u200D\uD83E\uDDB3"},{"unified":"1f9d1-1f3fb-200d-1f9b3","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB3"},{"unified":"1f9d1-1f3fc-200d-1f9b3","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB3"},{"unified":"1f9d1-1f3fd-200d-1f9b3","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB3"},{"unified":"1f9d1-1f3fe-200d-1f9b3","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB3"},{"unified":"1f9d1-1f3ff-200d-1f9b3","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB3"}],"version":12.1},"bald_woman":{"id":"bald_woman","name":"Woman: Bald","keywords":["woman","hairless"],"skins":[{"unified":"1f469-200d-1f9b2","native":"\uD83D\uDC69\u200D\uD83E\uDDB2"},{"unified":"1f469-1f3fb-200d-1f9b2","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB2"},{"unified":"1f469-1f3fc-200d-1f9b2","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB2"},{"unified":"1f469-1f3fd-200d-1f9b2","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB2"},{"unified":"1f469-1f3fe-200d-1f9b2","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB2"},{"unified":"1f469-1f3ff-200d-1f9b2","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB2"}],"version":11},"bald_person":{"id":"bald_person","name":"Person: Bald","keywords":["person","hairless"],"skins":[{"unified":"1f9d1-200d-1f9b2","native":"\uD83E\uDDD1\u200D\uD83E\uDDB2"},{"unified":"1f9d1-1f3fb-200d-1f9b2","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB2"},{"unified":"1f9d1-1f3fc-200d-1f9b2","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB2"},{"unified":"1f9d1-1f3fd-200d-1f9b2","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB2"},{"unified":"1f9d1-1f3fe-200d-1f9b2","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB2"},{"unified":"1f9d1-1f3ff-200d-1f9b2","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB2"}],"version":12.1},"blond-haired-woman":{"id":"blond-haired-woman","name":"Woman: Blond Hair","keywords":["haired-woman","woman","female","girl","blonde","person"],"skins":[{"unified":"1f471-200d-2640-fe0f","native":"\uD83D\uDC71\u200D\u2640\uFE0F"},{"unified":"1f471-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC71\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f471-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC71\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f471-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC71\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f471-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC71\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f471-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC71\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"blond-haired-man":{"id":"blond-haired-man","name":"Man: Blond Hair","keywords":["haired-man","man","male","boy","blonde","guy","person"],"skins":[{"unified":"1f471-200d-2642-fe0f","native":"\uD83D\uDC71\u200D\u2642\uFE0F"},{"unified":"1f471-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC71\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f471-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC71\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f471-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC71\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f471-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC71\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f471-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC71\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"older_adult":{"id":"older_adult","name":"Older Adult","keywords":["person","human","elder","senior","gender","neutral"],"skins":[{"unified":"1f9d3","native":"\uD83E\uDDD3"},{"unified":"1f9d3-1f3fb","native":"\uD83E\uDDD3\uD83C\uDFFB"},{"unified":"1f9d3-1f3fc","native":"\uD83E\uDDD3\uD83C\uDFFC"},{"unified":"1f9d3-1f3fd","native":"\uD83E\uDDD3\uD83C\uDFFD"},{"unified":"1f9d3-1f3fe","native":"\uD83E\uDDD3\uD83C\uDFFE"},{"unified":"1f9d3-1f3ff","native":"\uD83E\uDDD3\uD83C\uDFFF"}],"version":5},"older_man":{"id":"older_man","name":"Old Man","keywords":["older","human","male","men","elder","senior"],"skins":[{"unified":"1f474","native":"\uD83D\uDC74"},{"unified":"1f474-1f3fb","native":"\uD83D\uDC74\uD83C\uDFFB"},{"unified":"1f474-1f3fc","native":"\uD83D\uDC74\uD83C\uDFFC"},{"unified":"1f474-1f3fd","native":"\uD83D\uDC74\uD83C\uDFFD"},{"unified":"1f474-1f3fe","native":"\uD83D\uDC74\uD83C\uDFFE"},{"unified":"1f474-1f3ff","native":"\uD83D\uDC74\uD83C\uDFFF"}],"version":1},"older_woman":{"id":"older_woman","name":"Old Woman","keywords":["older","human","female","women","lady","elder","senior"],"skins":[{"unified":"1f475","native":"\uD83D\uDC75"},{"unified":"1f475-1f3fb","native":"\uD83D\uDC75\uD83C\uDFFB"},{"unified":"1f475-1f3fc","native":"\uD83D\uDC75\uD83C\uDFFC"},{"unified":"1f475-1f3fd","native":"\uD83D\uDC75\uD83C\uDFFD"},{"unified":"1f475-1f3fe","native":"\uD83D\uDC75\uD83C\uDFFE"},{"unified":"1f475-1f3ff","native":"\uD83D\uDC75\uD83C\uDFFF"}],"version":1},"person_frowning":{"id":"person_frowning","name":"Person Frowning","keywords":["worried"],"skins":[{"unified":"1f64d","native":"\uD83D\uDE4D"},{"unified":"1f64d-1f3fb","native":"\uD83D\uDE4D\uD83C\uDFFB"},{"unified":"1f64d-1f3fc","native":"\uD83D\uDE4D\uD83C\uDFFC"},{"unified":"1f64d-1f3fd","native":"\uD83D\uDE4D\uD83C\uDFFD"},{"unified":"1f64d-1f3fe","native":"\uD83D\uDE4D\uD83C\uDFFE"},{"unified":"1f64d-1f3ff","native":"\uD83D\uDE4D\uD83C\uDFFF"}],"version":1},"man-frowning":{"id":"man-frowning","name":"Man Frowning","keywords":["male","boy","sad","depressed","discouraged","unhappy"],"skins":[{"unified":"1f64d-200d-2642-fe0f","native":"\uD83D\uDE4D\u200D\u2642\uFE0F"},{"unified":"1f64d-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f64d-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f64d-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f64d-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f64d-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-frowning":{"id":"woman-frowning","name":"Woman Frowning","keywords":["female","girl","sad","depressed","discouraged","unhappy"],"skins":[{"unified":"1f64d-200d-2640-fe0f","native":"\uD83D\uDE4D\u200D\u2640\uFE0F"},{"unified":"1f64d-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f64d-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f64d-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f64d-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f64d-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"person_with_pouting_face":{"id":"person_with_pouting_face","name":"Person Pouting","keywords":["with","face","upset"],"skins":[{"unified":"1f64e","native":"\uD83D\uDE4E"},{"unified":"1f64e-1f3fb","native":"\uD83D\uDE4E\uD83C\uDFFB"},{"unified":"1f64e-1f3fc","native":"\uD83D\uDE4E\uD83C\uDFFC"},{"unified":"1f64e-1f3fd","native":"\uD83D\uDE4E\uD83C\uDFFD"},{"unified":"1f64e-1f3fe","native":"\uD83D\uDE4E\uD83C\uDFFE"},{"unified":"1f64e-1f3ff","native":"\uD83D\uDE4E\uD83C\uDFFF"}],"version":1},"man-pouting":{"id":"man-pouting","name":"Man Pouting","keywords":["male","boy"],"skins":[{"unified":"1f64e-200d-2642-fe0f","native":"\uD83D\uDE4E\u200D\u2642\uFE0F"},{"unified":"1f64e-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f64e-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f64e-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f64e-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f64e-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-pouting":{"id":"woman-pouting","name":"Woman Pouting","keywords":["female","girl"],"skins":[{"unified":"1f64e-200d-2640-fe0f","native":"\uD83D\uDE4E\u200D\u2640\uFE0F"},{"unified":"1f64e-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f64e-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f64e-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f64e-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f64e-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"no_good":{"id":"no_good","name":"Person Gesturing No","keywords":["good","decline"],"skins":[{"unified":"1f645","native":"\uD83D\uDE45"},{"unified":"1f645-1f3fb","native":"\uD83D\uDE45\uD83C\uDFFB"},{"unified":"1f645-1f3fc","native":"\uD83D\uDE45\uD83C\uDFFC"},{"unified":"1f645-1f3fd","native":"\uD83D\uDE45\uD83C\uDFFD"},{"unified":"1f645-1f3fe","native":"\uD83D\uDE45\uD83C\uDFFE"},{"unified":"1f645-1f3ff","native":"\uD83D\uDE45\uD83C\uDFFF"}],"version":1},"man-gesturing-no":{"id":"man-gesturing-no","name":"Man Gesturing No","keywords":["gesturing-no","male","boy","nope"],"skins":[{"unified":"1f645-200d-2642-fe0f","native":"\uD83D\uDE45\u200D\u2642\uFE0F"},{"unified":"1f645-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE45\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f645-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE45\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f645-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE45\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f645-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE45\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f645-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE45\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-gesturing-no":{"id":"woman-gesturing-no","name":"Woman Gesturing No","keywords":["gesturing-no","female","girl","nope"],"skins":[{"unified":"1f645-200d-2640-fe0f","native":"\uD83D\uDE45\u200D\u2640\uFE0F"},{"unified":"1f645-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE45\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f645-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE45\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f645-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE45\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f645-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE45\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f645-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE45\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"ok_woman":{"id":"ok_woman","name":"Person Gesturing Ok","keywords":["woman","agree"],"skins":[{"unified":"1f646","native":"\uD83D\uDE46"},{"unified":"1f646-1f3fb","native":"\uD83D\uDE46\uD83C\uDFFB"},{"unified":"1f646-1f3fc","native":"\uD83D\uDE46\uD83C\uDFFC"},{"unified":"1f646-1f3fd","native":"\uD83D\uDE46\uD83C\uDFFD"},{"unified":"1f646-1f3fe","native":"\uD83D\uDE46\uD83C\uDFFE"},{"unified":"1f646-1f3ff","native":"\uD83D\uDE46\uD83C\uDFFF"}],"version":1},"man-gesturing-ok":{"id":"man-gesturing-ok","name":"Man Gesturing Ok","keywords":["gesturing-ok","men","boy","male","blue","human"],"skins":[{"unified":"1f646-200d-2642-fe0f","native":"\uD83D\uDE46\u200D\u2642\uFE0F"},{"unified":"1f646-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE46\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f646-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE46\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f646-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE46\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f646-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE46\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f646-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE46\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-gesturing-ok":{"id":"woman-gesturing-ok","name":"Woman Gesturing Ok","keywords":["gesturing-ok","women","girl","female","pink","human"],"skins":[{"unified":"1f646-200d-2640-fe0f","native":"\uD83D\uDE46\u200D\u2640\uFE0F"},{"unified":"1f646-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE46\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f646-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE46\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f646-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE46\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f646-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE46\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f646-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE46\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"information_desk_person":{"id":"information_desk_person","name":"Person Tipping Hand","keywords":["information","desk"],"skins":[{"unified":"1f481","native":"\uD83D\uDC81"},{"unified":"1f481-1f3fb","native":"\uD83D\uDC81\uD83C\uDFFB"},{"unified":"1f481-1f3fc","native":"\uD83D\uDC81\uD83C\uDFFC"},{"unified":"1f481-1f3fd","native":"\uD83D\uDC81\uD83C\uDFFD"},{"unified":"1f481-1f3fe","native":"\uD83D\uDC81\uD83C\uDFFE"},{"unified":"1f481-1f3ff","native":"\uD83D\uDC81\uD83C\uDFFF"}],"version":1},"man-tipping-hand":{"id":"man-tipping-hand","name":"Man Tipping Hand","keywords":["tipping-hand","male","boy","human","information"],"skins":[{"unified":"1f481-200d-2642-fe0f","native":"\uD83D\uDC81\u200D\u2642\uFE0F"},{"unified":"1f481-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC81\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f481-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC81\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f481-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC81\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f481-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC81\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f481-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC81\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-tipping-hand":{"id":"woman-tipping-hand","name":"Woman Tipping Hand","keywords":["tipping-hand","female","girl","human","information"],"skins":[{"unified":"1f481-200d-2640-fe0f","native":"\uD83D\uDC81\u200D\u2640\uFE0F"},{"unified":"1f481-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC81\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f481-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC81\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f481-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC81\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f481-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC81\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f481-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC81\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"raising_hand":{"id":"raising_hand","name":"Person Raising Hand","keywords":["question"],"skins":[{"unified":"1f64b","native":"\uD83D\uDE4B"},{"unified":"1f64b-1f3fb","native":"\uD83D\uDE4B\uD83C\uDFFB"},{"unified":"1f64b-1f3fc","native":"\uD83D\uDE4B\uD83C\uDFFC"},{"unified":"1f64b-1f3fd","native":"\uD83D\uDE4B\uD83C\uDFFD"},{"unified":"1f64b-1f3fe","native":"\uD83D\uDE4B\uD83C\uDFFE"},{"unified":"1f64b-1f3ff","native":"\uD83D\uDE4B\uD83C\uDFFF"}],"version":1},"man-raising-hand":{"id":"man-raising-hand","name":"Man Raising Hand","keywords":["raising-hand","male","boy"],"skins":[{"unified":"1f64b-200d-2642-fe0f","native":"\uD83D\uDE4B\u200D\u2642\uFE0F"},{"unified":"1f64b-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f64b-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f64b-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f64b-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f64b-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-raising-hand":{"id":"woman-raising-hand","name":"Woman Raising Hand","keywords":["raising-hand","female","girl"],"skins":[{"unified":"1f64b-200d-2640-fe0f","native":"\uD83D\uDE4B\u200D\u2640\uFE0F"},{"unified":"1f64b-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f64b-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f64b-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f64b-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f64b-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"deaf_person":{"id":"deaf_person","name":"Deaf Person","keywords":["accessibility"],"skins":[{"unified":"1f9cf","native":"\uD83E\uDDCF"},{"unified":"1f9cf-1f3fb","native":"\uD83E\uDDCF\uD83C\uDFFB"},{"unified":"1f9cf-1f3fc","native":"\uD83E\uDDCF\uD83C\uDFFC"},{"unified":"1f9cf-1f3fd","native":"\uD83E\uDDCF\uD83C\uDFFD"},{"unified":"1f9cf-1f3fe","native":"\uD83E\uDDCF\uD83C\uDFFE"},{"unified":"1f9cf-1f3ff","native":"\uD83E\uDDCF\uD83C\uDFFF"}],"version":12},"deaf_man":{"id":"deaf_man","name":"Deaf Man","keywords":["accessibility"],"skins":[{"unified":"1f9cf-200d-2642-fe0f","native":"\uD83E\uDDCF\u200D\u2642\uFE0F"},{"unified":"1f9cf-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9cf-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9cf-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9cf-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9cf-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":12},"deaf_woman":{"id":"deaf_woman","name":"Deaf Woman","keywords":["accessibility"],"skins":[{"unified":"1f9cf-200d-2640-fe0f","native":"\uD83E\uDDCF\u200D\u2640\uFE0F"},{"unified":"1f9cf-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9cf-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9cf-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9cf-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9cf-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":12},"bow":{"id":"bow","name":"Person Bowing","keywords":["bow","respectiful"],"skins":[{"unified":"1f647","native":"\uD83D\uDE47"},{"unified":"1f647-1f3fb","native":"\uD83D\uDE47\uD83C\uDFFB"},{"unified":"1f647-1f3fc","native":"\uD83D\uDE47\uD83C\uDFFC"},{"unified":"1f647-1f3fd","native":"\uD83D\uDE47\uD83C\uDFFD"},{"unified":"1f647-1f3fe","native":"\uD83D\uDE47\uD83C\uDFFE"},{"unified":"1f647-1f3ff","native":"\uD83D\uDE47\uD83C\uDFFF"}],"version":1},"man-bowing":{"id":"man-bowing","name":"Man Bowing","keywords":["male","boy"],"skins":[{"unified":"1f647-200d-2642-fe0f","native":"\uD83D\uDE47\u200D\u2642\uFE0F"},{"unified":"1f647-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE47\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f647-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE47\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f647-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE47\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f647-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE47\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f647-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE47\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-bowing":{"id":"woman-bowing","name":"Woman Bowing","keywords":["female","girl"],"skins":[{"unified":"1f647-200d-2640-fe0f","native":"\uD83D\uDE47\u200D\u2640\uFE0F"},{"unified":"1f647-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE47\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f647-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE47\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f647-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE47\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f647-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE47\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f647-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE47\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"face_palm":{"id":"face_palm","name":"Face Palm","keywords":["person","facepalming","disappointed"],"skins":[{"unified":"1f926","native":"\uD83E\uDD26"},{"unified":"1f926-1f3fb","native":"\uD83E\uDD26\uD83C\uDFFB"},{"unified":"1f926-1f3fc","native":"\uD83E\uDD26\uD83C\uDFFC"},{"unified":"1f926-1f3fd","native":"\uD83E\uDD26\uD83C\uDFFD"},{"unified":"1f926-1f3fe","native":"\uD83E\uDD26\uD83C\uDFFE"},{"unified":"1f926-1f3ff","native":"\uD83E\uDD26\uD83C\uDFFF"}],"version":3},"man-facepalming":{"id":"man-facepalming","name":"Man Facepalming","keywords":["male","boy","disbelief"],"skins":[{"unified":"1f926-200d-2642-fe0f","native":"\uD83E\uDD26\u200D\u2642\uFE0F"},{"unified":"1f926-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD26\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f926-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD26\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f926-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD26\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f926-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD26\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f926-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD26\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-facepalming":{"id":"woman-facepalming","name":"Woman Facepalming","keywords":["female","girl","disbelief"],"skins":[{"unified":"1f926-200d-2640-fe0f","native":"\uD83E\uDD26\u200D\u2640\uFE0F"},{"unified":"1f926-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD26\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f926-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD26\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f926-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD26\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f926-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD26\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f926-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD26\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"shrug":{"id":"shrug","name":"Shrug","keywords":["person","shrugging","regardless"],"skins":[{"unified":"1f937","native":"\uD83E\uDD37"},{"unified":"1f937-1f3fb","native":"\uD83E\uDD37\uD83C\uDFFB"},{"unified":"1f937-1f3fc","native":"\uD83E\uDD37\uD83C\uDFFC"},{"unified":"1f937-1f3fd","native":"\uD83E\uDD37\uD83C\uDFFD"},{"unified":"1f937-1f3fe","native":"\uD83E\uDD37\uD83C\uDFFE"},{"unified":"1f937-1f3ff","native":"\uD83E\uDD37\uD83C\uDFFF"}],"version":3},"man-shrugging":{"id":"man-shrugging","name":"Man Shrugging","keywords":["male","boy","confused","indifferent","doubt"],"skins":[{"unified":"1f937-200d-2642-fe0f","native":"\uD83E\uDD37\u200D\u2642\uFE0F"},{"unified":"1f937-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD37\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f937-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD37\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f937-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD37\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f937-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD37\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f937-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD37\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-shrugging":{"id":"woman-shrugging","name":"Woman Shrugging","keywords":["female","girl","confused","indifferent","doubt"],"skins":[{"unified":"1f937-200d-2640-fe0f","native":"\uD83E\uDD37\u200D\u2640\uFE0F"},{"unified":"1f937-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD37\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f937-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD37\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f937-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD37\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f937-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD37\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f937-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD37\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"health_worker":{"id":"health_worker","name":"Health Worker","keywords":["hospital"],"skins":[{"unified":"1f9d1-200d-2695-fe0f","native":"\uD83E\uDDD1\u200D\u2695\uFE0F"},{"unified":"1f9d1-1f3fb-200d-2695-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\u2695\uFE0F"},{"unified":"1f9d1-1f3fc-200d-2695-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\u2695\uFE0F"},{"unified":"1f9d1-1f3fd-200d-2695-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\u2695\uFE0F"},{"unified":"1f9d1-1f3fe-200d-2695-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\u2695\uFE0F"},{"unified":"1f9d1-1f3ff-200d-2695-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\u2695\uFE0F"}],"version":12.1},"male-doctor":{"id":"male-doctor","name":"Man Health Worker","keywords":["male","doctor","nurse","therapist","healthcare","human"],"skins":[{"unified":"1f468-200d-2695-fe0f","native":"\uD83D\uDC68\u200D\u2695\uFE0F"},{"unified":"1f468-1f3fb-200d-2695-fe0f","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\u2695\uFE0F"},{"unified":"1f468-1f3fc-200d-2695-fe0f","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\u2695\uFE0F"},{"unified":"1f468-1f3fd-200d-2695-fe0f","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\u2695\uFE0F"},{"unified":"1f468-1f3fe-200d-2695-fe0f","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\u2695\uFE0F"},{"unified":"1f468-1f3ff-200d-2695-fe0f","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\u2695\uFE0F"}],"version":4},"female-doctor":{"id":"female-doctor","name":"Woman Health Worker","keywords":["female","doctor","nurse","therapist","healthcare","human"],"skins":[{"unified":"1f469-200d-2695-fe0f","native":"\uD83D\uDC69\u200D\u2695\uFE0F"},{"unified":"1f469-1f3fb-200d-2695-fe0f","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2695\uFE0F"},{"unified":"1f469-1f3fc-200d-2695-fe0f","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2695\uFE0F"},{"unified":"1f469-1f3fd-200d-2695-fe0f","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2695\uFE0F"},{"unified":"1f469-1f3fe-200d-2695-fe0f","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2695\uFE0F"},{"unified":"1f469-1f3ff-200d-2695-fe0f","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2695\uFE0F"}],"version":4},"student":{"id":"student","name":"Student","keywords":["learn"],"skins":[{"unified":"1f9d1-200d-1f393","native":"\uD83E\uDDD1\u200D\uD83C\uDF93"},{"unified":"1f9d1-1f3fb-200d-1f393","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF93"},{"unified":"1f9d1-1f3fc-200d-1f393","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF93"},{"unified":"1f9d1-1f3fd-200d-1f393","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF93"},{"unified":"1f9d1-1f3fe-200d-1f393","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF93"},{"unified":"1f9d1-1f3ff-200d-1f393","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF93"}],"version":12.1},"male-student":{"id":"male-student","name":"Man Student","keywords":["male","graduate","human"],"skins":[{"unified":"1f468-200d-1f393","native":"\uD83D\uDC68\u200D\uD83C\uDF93"},{"unified":"1f468-1f3fb-200d-1f393","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF93"},{"unified":"1f468-1f3fc-200d-1f393","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF93"},{"unified":"1f468-1f3fd-200d-1f393","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF93"},{"unified":"1f468-1f3fe-200d-1f393","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF93"},{"unified":"1f468-1f3ff-200d-1f393","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF93"}],"version":4},"female-student":{"id":"female-student","name":"Woman Student","keywords":["female","graduate","human"],"skins":[{"unified":"1f469-200d-1f393","native":"\uD83D\uDC69\u200D\uD83C\uDF93"},{"unified":"1f469-1f3fb-200d-1f393","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF93"},{"unified":"1f469-1f3fc-200d-1f393","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF93"},{"unified":"1f469-1f3fd-200d-1f393","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF93"},{"unified":"1f469-1f3fe-200d-1f393","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF93"},{"unified":"1f469-1f3ff-200d-1f393","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF93"}],"version":4},"teacher":{"id":"teacher","name":"Teacher","keywords":["professor"],"skins":[{"unified":"1f9d1-200d-1f3eb","native":"\uD83E\uDDD1\u200D\uD83C\uDFEB"},{"unified":"1f9d1-1f3fb-200d-1f3eb","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFEB"},{"unified":"1f9d1-1f3fc-200d-1f3eb","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFEB"},{"unified":"1f9d1-1f3fd-200d-1f3eb","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFEB"},{"unified":"1f9d1-1f3fe-200d-1f3eb","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFEB"},{"unified":"1f9d1-1f3ff-200d-1f3eb","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFEB"}],"version":12.1},"male-teacher":{"id":"male-teacher","name":"Man Teacher","keywords":["male","instructor","professor","human"],"skins":[{"unified":"1f468-200d-1f3eb","native":"\uD83D\uDC68\u200D\uD83C\uDFEB"},{"unified":"1f468-1f3fb-200d-1f3eb","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFEB"},{"unified":"1f468-1f3fc-200d-1f3eb","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFEB"},{"unified":"1f468-1f3fd-200d-1f3eb","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFEB"},{"unified":"1f468-1f3fe-200d-1f3eb","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFEB"},{"unified":"1f468-1f3ff-200d-1f3eb","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFEB"}],"version":4},"female-teacher":{"id":"female-teacher","name":"Woman Teacher","keywords":["female","instructor","professor","human"],"skins":[{"unified":"1f469-200d-1f3eb","native":"\uD83D\uDC69\u200D\uD83C\uDFEB"},{"unified":"1f469-1f3fb-200d-1f3eb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFEB"},{"unified":"1f469-1f3fc-200d-1f3eb","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFEB"},{"unified":"1f469-1f3fd-200d-1f3eb","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFEB"},{"unified":"1f469-1f3fe-200d-1f3eb","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFEB"},{"unified":"1f469-1f3ff-200d-1f3eb","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFEB"}],"version":4},"judge":{"id":"judge","name":"Judge","keywords":["law"],"skins":[{"unified":"1f9d1-200d-2696-fe0f","native":"\uD83E\uDDD1\u200D\u2696\uFE0F"},{"unified":"1f9d1-1f3fb-200d-2696-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\u2696\uFE0F"},{"unified":"1f9d1-1f3fc-200d-2696-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\u2696\uFE0F"},{"unified":"1f9d1-1f3fd-200d-2696-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\u2696\uFE0F"},{"unified":"1f9d1-1f3fe-200d-2696-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\u2696\uFE0F"},{"unified":"1f9d1-1f3ff-200d-2696-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\u2696\uFE0F"}],"version":12.1},"male-judge":{"id":"male-judge","name":"Man Judge","keywords":["male","justice","court","human"],"skins":[{"unified":"1f468-200d-2696-fe0f","native":"\uD83D\uDC68\u200D\u2696\uFE0F"},{"unified":"1f468-1f3fb-200d-2696-fe0f","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\u2696\uFE0F"},{"unified":"1f468-1f3fc-200d-2696-fe0f","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\u2696\uFE0F"},{"unified":"1f468-1f3fd-200d-2696-fe0f","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\u2696\uFE0F"},{"unified":"1f468-1f3fe-200d-2696-fe0f","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\u2696\uFE0F"},{"unified":"1f468-1f3ff-200d-2696-fe0f","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\u2696\uFE0F"}],"version":4},"female-judge":{"id":"female-judge","name":"Woman Judge","keywords":["female","justice","court","human"],"skins":[{"unified":"1f469-200d-2696-fe0f","native":"\uD83D\uDC69\u200D\u2696\uFE0F"},{"unified":"1f469-1f3fb-200d-2696-fe0f","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2696\uFE0F"},{"unified":"1f469-1f3fc-200d-2696-fe0f","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2696\uFE0F"},{"unified":"1f469-1f3fd-200d-2696-fe0f","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2696\uFE0F"},{"unified":"1f469-1f3fe-200d-2696-fe0f","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2696\uFE0F"},{"unified":"1f469-1f3ff-200d-2696-fe0f","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2696\uFE0F"}],"version":4},"farmer":{"id":"farmer","name":"Farmer","keywords":["crops"],"skins":[{"unified":"1f9d1-200d-1f33e","native":"\uD83E\uDDD1\u200D\uD83C\uDF3E"},{"unified":"1f9d1-1f3fb-200d-1f33e","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF3E"},{"unified":"1f9d1-1f3fc-200d-1f33e","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF3E"},{"unified":"1f9d1-1f3fd-200d-1f33e","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF3E"},{"unified":"1f9d1-1f3fe-200d-1f33e","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF3E"},{"unified":"1f9d1-1f3ff-200d-1f33e","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF3E"}],"version":12.1},"male-farmer":{"id":"male-farmer","name":"Man Farmer","keywords":["male","rancher","gardener","human"],"skins":[{"unified":"1f468-200d-1f33e","native":"\uD83D\uDC68\u200D\uD83C\uDF3E"},{"unified":"1f468-1f3fb-200d-1f33e","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF3E"},{"unified":"1f468-1f3fc-200d-1f33e","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF3E"},{"unified":"1f468-1f3fd-200d-1f33e","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF3E"},{"unified":"1f468-1f3fe-200d-1f33e","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF3E"},{"unified":"1f468-1f3ff-200d-1f33e","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF3E"}],"version":4},"female-farmer":{"id":"female-farmer","name":"Woman Farmer","keywords":["female","rancher","gardener","human"],"skins":[{"unified":"1f469-200d-1f33e","native":"\uD83D\uDC69\u200D\uD83C\uDF3E"},{"unified":"1f469-1f3fb-200d-1f33e","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF3E"},{"unified":"1f469-1f3fc-200d-1f33e","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF3E"},{"unified":"1f469-1f3fd-200d-1f33e","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF3E"},{"unified":"1f469-1f3fe-200d-1f33e","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF3E"},{"unified":"1f469-1f3ff-200d-1f33e","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF3E"}],"version":4},"cook":{"id":"cook","name":"Cook","keywords":["food","kitchen","culinary"],"skins":[{"unified":"1f9d1-200d-1f373","native":"\uD83E\uDDD1\u200D\uD83C\uDF73"},{"unified":"1f9d1-1f3fb-200d-1f373","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF73"},{"unified":"1f9d1-1f3fc-200d-1f373","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF73"},{"unified":"1f9d1-1f3fd-200d-1f373","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF73"},{"unified":"1f9d1-1f3fe-200d-1f373","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF73"},{"unified":"1f9d1-1f3ff-200d-1f373","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF73"}],"version":12.1},"male-cook":{"id":"male-cook","name":"Man Cook","keywords":["male","chef","human"],"skins":[{"unified":"1f468-200d-1f373","native":"\uD83D\uDC68\u200D\uD83C\uDF73"},{"unified":"1f468-1f3fb-200d-1f373","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF73"},{"unified":"1f468-1f3fc-200d-1f373","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF73"},{"unified":"1f468-1f3fd-200d-1f373","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF73"},{"unified":"1f468-1f3fe-200d-1f373","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF73"},{"unified":"1f468-1f3ff-200d-1f373","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF73"}],"version":4},"female-cook":{"id":"female-cook","name":"Woman Cook","keywords":["female","chef","human"],"skins":[{"unified":"1f469-200d-1f373","native":"\uD83D\uDC69\u200D\uD83C\uDF73"},{"unified":"1f469-1f3fb-200d-1f373","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF73"},{"unified":"1f469-1f3fc-200d-1f373","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF73"},{"unified":"1f469-1f3fd-200d-1f373","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF73"},{"unified":"1f469-1f3fe-200d-1f373","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF73"},{"unified":"1f469-1f3ff-200d-1f373","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF73"}],"version":4},"mechanic":{"id":"mechanic","name":"Mechanic","keywords":["worker","technician"],"skins":[{"unified":"1f9d1-200d-1f527","native":"\uD83E\uDDD1\u200D\uD83D\uDD27"},{"unified":"1f9d1-1f3fb-200d-1f527","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDD27"},{"unified":"1f9d1-1f3fc-200d-1f527","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDD27"},{"unified":"1f9d1-1f3fd-200d-1f527","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDD27"},{"unified":"1f9d1-1f3fe-200d-1f527","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDD27"},{"unified":"1f9d1-1f3ff-200d-1f527","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDD27"}],"version":12.1},"male-mechanic":{"id":"male-mechanic","name":"Man Mechanic","keywords":["male","plumber","human","wrench"],"skins":[{"unified":"1f468-200d-1f527","native":"\uD83D\uDC68\u200D\uD83D\uDD27"},{"unified":"1f468-1f3fb-200d-1f527","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD27"},{"unified":"1f468-1f3fc-200d-1f527","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD27"},{"unified":"1f468-1f3fd-200d-1f527","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD27"},{"unified":"1f468-1f3fe-200d-1f527","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD27"},{"unified":"1f468-1f3ff-200d-1f527","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD27"}],"version":4},"female-mechanic":{"id":"female-mechanic","name":"Woman Mechanic","keywords":["female","plumber","human","wrench"],"skins":[{"unified":"1f469-200d-1f527","native":"\uD83D\uDC69\u200D\uD83D\uDD27"},{"unified":"1f469-1f3fb-200d-1f527","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD27"},{"unified":"1f469-1f3fc-200d-1f527","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD27"},{"unified":"1f469-1f3fd-200d-1f527","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD27"},{"unified":"1f469-1f3fe-200d-1f527","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD27"},{"unified":"1f469-1f3ff-200d-1f527","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD27"}],"version":4},"factory_worker":{"id":"factory_worker","name":"Factory Worker","keywords":["labor"],"skins":[{"unified":"1f9d1-200d-1f3ed","native":"\uD83E\uDDD1\u200D\uD83C\uDFED"},{"unified":"1f9d1-1f3fb-200d-1f3ed","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFED"},{"unified":"1f9d1-1f3fc-200d-1f3ed","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFED"},{"unified":"1f9d1-1f3fd-200d-1f3ed","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFED"},{"unified":"1f9d1-1f3fe-200d-1f3ed","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFED"},{"unified":"1f9d1-1f3ff-200d-1f3ed","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFED"}],"version":12.1},"male-factory-worker":{"id":"male-factory-worker","name":"Man Factory Worker","keywords":["male","factory-worker","assembly","industrial","human"],"skins":[{"unified":"1f468-200d-1f3ed","native":"\uD83D\uDC68\u200D\uD83C\uDFED"},{"unified":"1f468-1f3fb-200d-1f3ed","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFED"},{"unified":"1f468-1f3fc-200d-1f3ed","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFED"},{"unified":"1f468-1f3fd-200d-1f3ed","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFED"},{"unified":"1f468-1f3fe-200d-1f3ed","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFED"},{"unified":"1f468-1f3ff-200d-1f3ed","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFED"}],"version":4},"female-factory-worker":{"id":"female-factory-worker","name":"Woman Factory Worker","keywords":["female","factory-worker","assembly","industrial","human"],"skins":[{"unified":"1f469-200d-1f3ed","native":"\uD83D\uDC69\u200D\uD83C\uDFED"},{"unified":"1f469-1f3fb-200d-1f3ed","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFED"},{"unified":"1f469-1f3fc-200d-1f3ed","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFED"},{"unified":"1f469-1f3fd-200d-1f3ed","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFED"},{"unified":"1f469-1f3fe-200d-1f3ed","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFED"},{"unified":"1f469-1f3ff-200d-1f3ed","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFED"}],"version":4},"office_worker":{"id":"office_worker","name":"Office Worker","keywords":["business"],"skins":[{"unified":"1f9d1-200d-1f4bc","native":"\uD83E\uDDD1\u200D\uD83D\uDCBC"},{"unified":"1f9d1-1f3fb-200d-1f4bc","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDCBC"},{"unified":"1f9d1-1f3fc-200d-1f4bc","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDCBC"},{"unified":"1f9d1-1f3fd-200d-1f4bc","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDCBC"},{"unified":"1f9d1-1f3fe-200d-1f4bc","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDCBC"},{"unified":"1f9d1-1f3ff-200d-1f4bc","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDCBC"}],"version":12.1},"male-office-worker":{"id":"male-office-worker","name":"Man Office Worker","keywords":["male","office-worker","business","manager","human"],"skins":[{"unified":"1f468-200d-1f4bc","native":"\uD83D\uDC68\u200D\uD83D\uDCBC"},{"unified":"1f468-1f3fb-200d-1f4bc","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBC"},{"unified":"1f468-1f3fc-200d-1f4bc","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBC"},{"unified":"1f468-1f3fd-200d-1f4bc","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBC"},{"unified":"1f468-1f3fe-200d-1f4bc","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBC"},{"unified":"1f468-1f3ff-200d-1f4bc","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBC"}],"version":4},"female-office-worker":{"id":"female-office-worker","name":"Woman Office Worker","keywords":["female","office-worker","business","manager","human"],"skins":[{"unified":"1f469-200d-1f4bc","native":"\uD83D\uDC69\u200D\uD83D\uDCBC"},{"unified":"1f469-1f3fb-200d-1f4bc","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBC"},{"unified":"1f469-1f3fc-200d-1f4bc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBC"},{"unified":"1f469-1f3fd-200d-1f4bc","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBC"},{"unified":"1f469-1f3fe-200d-1f4bc","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBC"},{"unified":"1f469-1f3ff-200d-1f4bc","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBC"}],"version":4},"scientist":{"id":"scientist","name":"Scientist","keywords":["chemistry"],"skins":[{"unified":"1f9d1-200d-1f52c","native":"\uD83E\uDDD1\u200D\uD83D\uDD2C"},{"unified":"1f9d1-1f3fb-200d-1f52c","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDD2C"},{"unified":"1f9d1-1f3fc-200d-1f52c","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDD2C"},{"unified":"1f9d1-1f3fd-200d-1f52c","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDD2C"},{"unified":"1f9d1-1f3fe-200d-1f52c","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDD2C"},{"unified":"1f9d1-1f3ff-200d-1f52c","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDD2C"}],"version":12.1},"male-scientist":{"id":"male-scientist","name":"Man Scientist","keywords":["male","biologist","chemist","engineer","physicist","human"],"skins":[{"unified":"1f468-200d-1f52c","native":"\uD83D\uDC68\u200D\uD83D\uDD2C"},{"unified":"1f468-1f3fb-200d-1f52c","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD2C"},{"unified":"1f468-1f3fc-200d-1f52c","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD2C"},{"unified":"1f468-1f3fd-200d-1f52c","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD2C"},{"unified":"1f468-1f3fe-200d-1f52c","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD2C"},{"unified":"1f468-1f3ff-200d-1f52c","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD2C"}],"version":4},"female-scientist":{"id":"female-scientist","name":"Woman Scientist","keywords":["female","biologist","chemist","engineer","physicist","human"],"skins":[{"unified":"1f469-200d-1f52c","native":"\uD83D\uDC69\u200D\uD83D\uDD2C"},{"unified":"1f469-1f3fb-200d-1f52c","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD2C"},{"unified":"1f469-1f3fc-200d-1f52c","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD2C"},{"unified":"1f469-1f3fd-200d-1f52c","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD2C"},{"unified":"1f469-1f3fe-200d-1f52c","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD2C"},{"unified":"1f469-1f3ff-200d-1f52c","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD2C"}],"version":4},"technologist":{"id":"technologist","name":"Technologist","keywords":["computer"],"skins":[{"unified":"1f9d1-200d-1f4bb","native":"\uD83E\uDDD1\u200D\uD83D\uDCBB"},{"unified":"1f9d1-1f3fb-200d-1f4bb","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDCBB"},{"unified":"1f9d1-1f3fc-200d-1f4bb","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDCBB"},{"unified":"1f9d1-1f3fd-200d-1f4bb","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDCBB"},{"unified":"1f9d1-1f3fe-200d-1f4bb","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDCBB"},{"unified":"1f9d1-1f3ff-200d-1f4bb","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDCBB"}],"version":12.1},"male-technologist":{"id":"male-technologist","name":"Man Technologist","keywords":["male","coder","developer","engineer","programmer","software","human","laptop","computer"],"skins":[{"unified":"1f468-200d-1f4bb","native":"\uD83D\uDC68\u200D\uD83D\uDCBB"},{"unified":"1f468-1f3fb-200d-1f4bb","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBB"},{"unified":"1f468-1f3fc-200d-1f4bb","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBB"},{"unified":"1f468-1f3fd-200d-1f4bb","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBB"},{"unified":"1f468-1f3fe-200d-1f4bb","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBB"},{"unified":"1f468-1f3ff-200d-1f4bb","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBB"}],"version":4},"female-technologist":{"id":"female-technologist","name":"Woman Technologist","keywords":["female","coder","developer","engineer","programmer","software","human","laptop","computer"],"skins":[{"unified":"1f469-200d-1f4bb","native":"\uD83D\uDC69\u200D\uD83D\uDCBB"},{"unified":"1f469-1f3fb-200d-1f4bb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBB"},{"unified":"1f469-1f3fc-200d-1f4bb","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBB"},{"unified":"1f469-1f3fd-200d-1f4bb","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBB"},{"unified":"1f469-1f3fe-200d-1f4bb","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBB"},{"unified":"1f469-1f3ff-200d-1f4bb","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBB"}],"version":4},"singer":{"id":"singer","name":"Singer","keywords":["song","artist","performer"],"skins":[{"unified":"1f9d1-200d-1f3a4","native":"\uD83E\uDDD1\u200D\uD83C\uDFA4"},{"unified":"1f9d1-1f3fb-200d-1f3a4","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFA4"},{"unified":"1f9d1-1f3fc-200d-1f3a4","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFA4"},{"unified":"1f9d1-1f3fd-200d-1f3a4","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFA4"},{"unified":"1f9d1-1f3fe-200d-1f3a4","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFA4"},{"unified":"1f9d1-1f3ff-200d-1f3a4","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFA4"}],"version":12.1},"male-singer":{"id":"male-singer","name":"Man Singer","keywords":["male","rockstar","entertainer","human"],"skins":[{"unified":"1f468-200d-1f3a4","native":"\uD83D\uDC68\u200D\uD83C\uDFA4"},{"unified":"1f468-1f3fb-200d-1f3a4","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA4"},{"unified":"1f468-1f3fc-200d-1f3a4","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA4"},{"unified":"1f468-1f3fd-200d-1f3a4","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA4"},{"unified":"1f468-1f3fe-200d-1f3a4","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA4"},{"unified":"1f468-1f3ff-200d-1f3a4","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA4"}],"version":4},"female-singer":{"id":"female-singer","name":"Woman Singer","keywords":["female","rockstar","entertainer","human"],"skins":[{"unified":"1f469-200d-1f3a4","native":"\uD83D\uDC69\u200D\uD83C\uDFA4"},{"unified":"1f469-1f3fb-200d-1f3a4","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA4"},{"unified":"1f469-1f3fc-200d-1f3a4","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA4"},{"unified":"1f469-1f3fd-200d-1f3a4","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA4"},{"unified":"1f469-1f3fe-200d-1f3a4","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA4"},{"unified":"1f469-1f3ff-200d-1f3a4","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA4"}],"version":4},"artist":{"id":"artist","name":"Artist","keywords":["painting","draw","creativity"],"skins":[{"unified":"1f9d1-200d-1f3a8","native":"\uD83E\uDDD1\u200D\uD83C\uDFA8"},{"unified":"1f9d1-1f3fb-200d-1f3a8","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFA8"},{"unified":"1f9d1-1f3fc-200d-1f3a8","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFA8"},{"unified":"1f9d1-1f3fd-200d-1f3a8","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFA8"},{"unified":"1f9d1-1f3fe-200d-1f3a8","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFA8"},{"unified":"1f9d1-1f3ff-200d-1f3a8","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFA8"}],"version":12.1},"male-artist":{"id":"male-artist","name":"Man Artist","keywords":["male","painter","human"],"skins":[{"unified":"1f468-200d-1f3a8","native":"\uD83D\uDC68\u200D\uD83C\uDFA8"},{"unified":"1f468-1f3fb-200d-1f3a8","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA8"},{"unified":"1f468-1f3fc-200d-1f3a8","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA8"},{"unified":"1f468-1f3fd-200d-1f3a8","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA8"},{"unified":"1f468-1f3fe-200d-1f3a8","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA8"},{"unified":"1f468-1f3ff-200d-1f3a8","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA8"}],"version":4},"female-artist":{"id":"female-artist","name":"Woman Artist","keywords":["female","painter","human"],"skins":[{"unified":"1f469-200d-1f3a8","native":"\uD83D\uDC69\u200D\uD83C\uDFA8"},{"unified":"1f469-1f3fb-200d-1f3a8","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA8"},{"unified":"1f469-1f3fc-200d-1f3a8","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA8"},{"unified":"1f469-1f3fd-200d-1f3a8","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA8"},{"unified":"1f469-1f3fe-200d-1f3a8","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA8"},{"unified":"1f469-1f3ff-200d-1f3a8","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA8"}],"version":4},"pilot":{"id":"pilot","name":"Pilot","keywords":["fly","plane","airplane"],"skins":[{"unified":"1f9d1-200d-2708-fe0f","native":"\uD83E\uDDD1\u200D\u2708\uFE0F"},{"unified":"1f9d1-1f3fb-200d-2708-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\u2708\uFE0F"},{"unified":"1f9d1-1f3fc-200d-2708-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\u2708\uFE0F"},{"unified":"1f9d1-1f3fd-200d-2708-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\u2708\uFE0F"},{"unified":"1f9d1-1f3fe-200d-2708-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\u2708\uFE0F"},{"unified":"1f9d1-1f3ff-200d-2708-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\u2708\uFE0F"}],"version":12.1},"male-pilot":{"id":"male-pilot","name":"Man Pilot","keywords":["male","aviator","plane","human"],"skins":[{"unified":"1f468-200d-2708-fe0f","native":"\uD83D\uDC68\u200D\u2708\uFE0F"},{"unified":"1f468-1f3fb-200d-2708-fe0f","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\u2708\uFE0F"},{"unified":"1f468-1f3fc-200d-2708-fe0f","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\u2708\uFE0F"},{"unified":"1f468-1f3fd-200d-2708-fe0f","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\u2708\uFE0F"},{"unified":"1f468-1f3fe-200d-2708-fe0f","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\u2708\uFE0F"},{"unified":"1f468-1f3ff-200d-2708-fe0f","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\u2708\uFE0F"}],"version":4},"female-pilot":{"id":"female-pilot","name":"Woman Pilot","keywords":["female","aviator","plane","human"],"skins":[{"unified":"1f469-200d-2708-fe0f","native":"\uD83D\uDC69\u200D\u2708\uFE0F"},{"unified":"1f469-1f3fb-200d-2708-fe0f","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2708\uFE0F"},{"unified":"1f469-1f3fc-200d-2708-fe0f","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2708\uFE0F"},{"unified":"1f469-1f3fd-200d-2708-fe0f","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2708\uFE0F"},{"unified":"1f469-1f3fe-200d-2708-fe0f","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2708\uFE0F"},{"unified":"1f469-1f3ff-200d-2708-fe0f","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2708\uFE0F"}],"version":4},"astronaut":{"id":"astronaut","name":"Astronaut","keywords":["outerspace"],"skins":[{"unified":"1f9d1-200d-1f680","native":"\uD83E\uDDD1\u200D\uD83D\uDE80"},{"unified":"1f9d1-1f3fb-200d-1f680","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDE80"},{"unified":"1f9d1-1f3fc-200d-1f680","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDE80"},{"unified":"1f9d1-1f3fd-200d-1f680","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDE80"},{"unified":"1f9d1-1f3fe-200d-1f680","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDE80"},{"unified":"1f9d1-1f3ff-200d-1f680","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDE80"}],"version":12.1},"male-astronaut":{"id":"male-astronaut","name":"Man Astronaut","keywords":["male","space","rocket","human"],"skins":[{"unified":"1f468-200d-1f680","native":"\uD83D\uDC68\u200D\uD83D\uDE80"},{"unified":"1f468-1f3fb-200d-1f680","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE80"},{"unified":"1f468-1f3fc-200d-1f680","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE80"},{"unified":"1f468-1f3fd-200d-1f680","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE80"},{"unified":"1f468-1f3fe-200d-1f680","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE80"},{"unified":"1f468-1f3ff-200d-1f680","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE80"}],"version":4},"female-astronaut":{"id":"female-astronaut","name":"Woman Astronaut","keywords":["female","space","rocket","human"],"skins":[{"unified":"1f469-200d-1f680","native":"\uD83D\uDC69\u200D\uD83D\uDE80"},{"unified":"1f469-1f3fb-200d-1f680","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE80"},{"unified":"1f469-1f3fc-200d-1f680","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE80"},{"unified":"1f469-1f3fd-200d-1f680","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE80"},{"unified":"1f469-1f3fe-200d-1f680","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE80"},{"unified":"1f469-1f3ff-200d-1f680","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE80"}],"version":4},"firefighter":{"id":"firefighter","name":"Firefighter","keywords":["fire"],"skins":[{"unified":"1f9d1-200d-1f692","native":"\uD83E\uDDD1\u200D\uD83D\uDE92"},{"unified":"1f9d1-1f3fb-200d-1f692","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDE92"},{"unified":"1f9d1-1f3fc-200d-1f692","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDE92"},{"unified":"1f9d1-1f3fd-200d-1f692","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDE92"},{"unified":"1f9d1-1f3fe-200d-1f692","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDE92"},{"unified":"1f9d1-1f3ff-200d-1f692","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDE92"}],"version":12.1},"male-firefighter":{"id":"male-firefighter","name":"Man Firefighter","keywords":["male","fireman","human"],"skins":[{"unified":"1f468-200d-1f692","native":"\uD83D\uDC68\u200D\uD83D\uDE92"},{"unified":"1f468-1f3fb-200d-1f692","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE92"},{"unified":"1f468-1f3fc-200d-1f692","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE92"},{"unified":"1f468-1f3fd-200d-1f692","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE92"},{"unified":"1f468-1f3fe-200d-1f692","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE92"},{"unified":"1f468-1f3ff-200d-1f692","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE92"}],"version":4},"female-firefighter":{"id":"female-firefighter","name":"Woman Firefighter","keywords":["female","fireman","human"],"skins":[{"unified":"1f469-200d-1f692","native":"\uD83D\uDC69\u200D\uD83D\uDE92"},{"unified":"1f469-1f3fb-200d-1f692","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE92"},{"unified":"1f469-1f3fc-200d-1f692","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE92"},{"unified":"1f469-1f3fd-200d-1f692","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE92"},{"unified":"1f469-1f3fe-200d-1f692","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE92"},{"unified":"1f469-1f3ff-200d-1f692","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE92"}],"version":4},"cop":{"id":"cop","name":"Police Officer","keywords":["cop"],"skins":[{"unified":"1f46e","native":"\uD83D\uDC6E"},{"unified":"1f46e-1f3fb","native":"\uD83D\uDC6E\uD83C\uDFFB"},{"unified":"1f46e-1f3fc","native":"\uD83D\uDC6E\uD83C\uDFFC"},{"unified":"1f46e-1f3fd","native":"\uD83D\uDC6E\uD83C\uDFFD"},{"unified":"1f46e-1f3fe","native":"\uD83D\uDC6E\uD83C\uDFFE"},{"unified":"1f46e-1f3ff","native":"\uD83D\uDC6E\uD83C\uDFFF"}],"version":1},"male-police-officer":{"id":"male-police-officer","name":"Man Police Officer","keywords":["male","police-officer","law","legal","enforcement","arrest","911"],"skins":[{"unified":"1f46e-200d-2642-fe0f","native":"\uD83D\uDC6E\u200D\u2642\uFE0F"},{"unified":"1f46e-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f46e-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f46e-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f46e-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f46e-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"female-police-officer":{"id":"female-police-officer","name":"Woman Police Officer","keywords":["female","police-officer","law","legal","enforcement","arrest","911"],"skins":[{"unified":"1f46e-200d-2640-fe0f","native":"\uD83D\uDC6E\u200D\u2640\uFE0F"},{"unified":"1f46e-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f46e-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f46e-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f46e-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f46e-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"sleuth_or_spy":{"id":"sleuth_or_spy","name":"Detective","keywords":["sleuth","or","spy","human"],"skins":[{"unified":"1f575-fe0f","native":"\uD83D\uDD75\uFE0F"},{"unified":"1f575-1f3fb","native":"\uD83D\uDD75\uD83C\uDFFB"},{"unified":"1f575-1f3fc","native":"\uD83D\uDD75\uD83C\uDFFC"},{"unified":"1f575-1f3fd","native":"\uD83D\uDD75\uD83C\uDFFD"},{"unified":"1f575-1f3fe","native":"\uD83D\uDD75\uD83C\uDFFE"},{"unified":"1f575-1f3ff","native":"\uD83D\uDD75\uD83C\uDFFF"}],"version":1},"male-detective":{"id":"male-detective","name":"Man Detective","keywords":["male","crime"],"skins":[{"unified":"1f575-fe0f-200d-2642-fe0f","native":"\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F"},{"unified":"1f575-1f3fb-200d-2642-fe0f","native":"\uD83D\uDD75\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f575-1f3fc-200d-2642-fe0f","native":"\uD83D\uDD75\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f575-1f3fd-200d-2642-fe0f","native":"\uD83D\uDD75\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f575-1f3fe-200d-2642-fe0f","native":"\uD83D\uDD75\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f575-1f3ff-200d-2642-fe0f","native":"\uD83D\uDD75\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"female-detective":{"id":"female-detective","name":"Woman Detective","keywords":["female","human","spy"],"skins":[{"unified":"1f575-fe0f-200d-2640-fe0f","native":"\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F"},{"unified":"1f575-1f3fb-200d-2640-fe0f","native":"\uD83D\uDD75\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f575-1f3fc-200d-2640-fe0f","native":"\uD83D\uDD75\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f575-1f3fd-200d-2640-fe0f","native":"\uD83D\uDD75\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f575-1f3fe-200d-2640-fe0f","native":"\uD83D\uDD75\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f575-1f3ff-200d-2640-fe0f","native":"\uD83D\uDD75\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"guardsman":{"id":"guardsman","name":"Guard","keywords":["guardsman","protect"],"skins":[{"unified":"1f482","native":"\uD83D\uDC82"},{"unified":"1f482-1f3fb","native":"\uD83D\uDC82\uD83C\uDFFB"},{"unified":"1f482-1f3fc","native":"\uD83D\uDC82\uD83C\uDFFC"},{"unified":"1f482-1f3fd","native":"\uD83D\uDC82\uD83C\uDFFD"},{"unified":"1f482-1f3fe","native":"\uD83D\uDC82\uD83C\uDFFE"},{"unified":"1f482-1f3ff","native":"\uD83D\uDC82\uD83C\uDFFF"}],"version":1},"male-guard":{"id":"male-guard","name":"Man Guard","keywords":["male","uk","gb","british","guy","royal"],"skins":[{"unified":"1f482-200d-2642-fe0f","native":"\uD83D\uDC82\u200D\u2642\uFE0F"},{"unified":"1f482-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC82\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f482-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC82\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f482-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC82\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f482-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC82\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f482-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC82\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"female-guard":{"id":"female-guard","name":"Woman Guard","keywords":["female","uk","gb","british","royal"],"skins":[{"unified":"1f482-200d-2640-fe0f","native":"\uD83D\uDC82\u200D\u2640\uFE0F"},{"unified":"1f482-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC82\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f482-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC82\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f482-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC82\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f482-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC82\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f482-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC82\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"ninja":{"id":"ninja","name":"Ninja","keywords":["ninjutsu","skills","japanese"],"skins":[{"unified":"1f977","native":"\uD83E\uDD77"},{"unified":"1f977-1f3fb","native":"\uD83E\uDD77\uD83C\uDFFB"},{"unified":"1f977-1f3fc","native":"\uD83E\uDD77\uD83C\uDFFC"},{"unified":"1f977-1f3fd","native":"\uD83E\uDD77\uD83C\uDFFD"},{"unified":"1f977-1f3fe","native":"\uD83E\uDD77\uD83C\uDFFE"},{"unified":"1f977-1f3ff","native":"\uD83E\uDD77\uD83C\uDFFF"}],"version":13},"construction_worker":{"id":"construction_worker","name":"Construction Worker","keywords":["labor","build"],"skins":[{"unified":"1f477","native":"\uD83D\uDC77"},{"unified":"1f477-1f3fb","native":"\uD83D\uDC77\uD83C\uDFFB"},{"unified":"1f477-1f3fc","native":"\uD83D\uDC77\uD83C\uDFFC"},{"unified":"1f477-1f3fd","native":"\uD83D\uDC77\uD83C\uDFFD"},{"unified":"1f477-1f3fe","native":"\uD83D\uDC77\uD83C\uDFFE"},{"unified":"1f477-1f3ff","native":"\uD83D\uDC77\uD83C\uDFFF"}],"version":1},"male-construction-worker":{"id":"male-construction-worker","name":"Man Construction Worker","keywords":["male","construction-worker","human","wip","guy","build","labor"],"skins":[{"unified":"1f477-200d-2642-fe0f","native":"\uD83D\uDC77\u200D\u2642\uFE0F"},{"unified":"1f477-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC77\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f477-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC77\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f477-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC77\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f477-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC77\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f477-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC77\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"female-construction-worker":{"id":"female-construction-worker","name":"Woman Construction Worker","keywords":["female","construction-worker","human","wip","build","labor"],"skins":[{"unified":"1f477-200d-2640-fe0f","native":"\uD83D\uDC77\u200D\u2640\uFE0F"},{"unified":"1f477-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC77\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f477-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC77\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f477-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC77\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f477-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC77\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f477-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC77\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"person_with_crown":{"id":"person_with_crown","name":"Person with Crown","keywords":["royalty","power"],"skins":[{"unified":"1fac5","native":"\uD83E\uDEC5"},{"unified":"1fac5-1f3fb","native":"\uD83E\uDEC5\uD83C\uDFFB"},{"unified":"1fac5-1f3fc","native":"\uD83E\uDEC5\uD83C\uDFFC"},{"unified":"1fac5-1f3fd","native":"\uD83E\uDEC5\uD83C\uDFFD"},{"unified":"1fac5-1f3fe","native":"\uD83E\uDEC5\uD83C\uDFFE"},{"unified":"1fac5-1f3ff","native":"\uD83E\uDEC5\uD83C\uDFFF"}],"version":14},"prince":{"id":"prince","name":"Prince","keywords":["boy","man","male","crown","royal","king"],"skins":[{"unified":"1f934","native":"\uD83E\uDD34"},{"unified":"1f934-1f3fb","native":"\uD83E\uDD34\uD83C\uDFFB"},{"unified":"1f934-1f3fc","native":"\uD83E\uDD34\uD83C\uDFFC"},{"unified":"1f934-1f3fd","native":"\uD83E\uDD34\uD83C\uDFFD"},{"unified":"1f934-1f3fe","native":"\uD83E\uDD34\uD83C\uDFFE"},{"unified":"1f934-1f3ff","native":"\uD83E\uDD34\uD83C\uDFFF"}],"version":3},"princess":{"id":"princess","name":"Princess","keywords":["girl","woman","female","blond","crown","royal","queen"],"skins":[{"unified":"1f478","native":"\uD83D\uDC78"},{"unified":"1f478-1f3fb","native":"\uD83D\uDC78\uD83C\uDFFB"},{"unified":"1f478-1f3fc","native":"\uD83D\uDC78\uD83C\uDFFC"},{"unified":"1f478-1f3fd","native":"\uD83D\uDC78\uD83C\uDFFD"},{"unified":"1f478-1f3fe","native":"\uD83D\uDC78\uD83C\uDFFE"},{"unified":"1f478-1f3ff","native":"\uD83D\uDC78\uD83C\uDFFF"}],"version":1},"man_with_turban":{"id":"man_with_turban","name":"Man with Turban","keywords":["person","wearing","headdress"],"skins":[{"unified":"1f473","native":"\uD83D\uDC73"},{"unified":"1f473-1f3fb","native":"\uD83D\uDC73\uD83C\uDFFB"},{"unified":"1f473-1f3fc","native":"\uD83D\uDC73\uD83C\uDFFC"},{"unified":"1f473-1f3fd","native":"\uD83D\uDC73\uD83C\uDFFD"},{"unified":"1f473-1f3fe","native":"\uD83D\uDC73\uD83C\uDFFE"},{"unified":"1f473-1f3ff","native":"\uD83D\uDC73\uD83C\uDFFF"}],"version":1},"man-wearing-turban":{"id":"man-wearing-turban","name":"Man Wearing Turban","keywords":["wearing-turban","male","indian","hinduism","arabs"],"skins":[{"unified":"1f473-200d-2642-fe0f","native":"\uD83D\uDC73\u200D\u2642\uFE0F"},{"unified":"1f473-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC73\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f473-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC73\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f473-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC73\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f473-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC73\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f473-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC73\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-wearing-turban":{"id":"woman-wearing-turban","name":"Woman Wearing Turban","keywords":["wearing-turban","female","indian","hinduism","arabs"],"skins":[{"unified":"1f473-200d-2640-fe0f","native":"\uD83D\uDC73\u200D\u2640\uFE0F"},{"unified":"1f473-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC73\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f473-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC73\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f473-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC73\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f473-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC73\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f473-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC73\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"man_with_gua_pi_mao":{"id":"man_with_gua_pi_mao","name":"Man with Gua Pi Mao","keywords":["skullcap","male","boy","chinese"],"skins":[{"unified":"1f472","native":"\uD83D\uDC72"},{"unified":"1f472-1f3fb","native":"\uD83D\uDC72\uD83C\uDFFB"},{"unified":"1f472-1f3fc","native":"\uD83D\uDC72\uD83C\uDFFC"},{"unified":"1f472-1f3fd","native":"\uD83D\uDC72\uD83C\uDFFD"},{"unified":"1f472-1f3fe","native":"\uD83D\uDC72\uD83C\uDFFE"},{"unified":"1f472-1f3ff","native":"\uD83D\uDC72\uD83C\uDFFF"}],"version":1},"person_with_headscarf":{"id":"person_with_headscarf","name":"Woman with Headscarf","keywords":["person","female","hijab","mantilla","tichel"],"skins":[{"unified":"1f9d5","native":"\uD83E\uDDD5"},{"unified":"1f9d5-1f3fb","native":"\uD83E\uDDD5\uD83C\uDFFB"},{"unified":"1f9d5-1f3fc","native":"\uD83E\uDDD5\uD83C\uDFFC"},{"unified":"1f9d5-1f3fd","native":"\uD83E\uDDD5\uD83C\uDFFD"},{"unified":"1f9d5-1f3fe","native":"\uD83E\uDDD5\uD83C\uDFFE"},{"unified":"1f9d5-1f3ff","native":"\uD83E\uDDD5\uD83C\uDFFF"}],"version":5},"person_in_tuxedo":{"id":"person_in_tuxedo","name":"Man in Tuxedo","keywords":["person","couple","marriage","wedding","groom"],"skins":[{"unified":"1f935","native":"\uD83E\uDD35"},{"unified":"1f935-1f3fb","native":"\uD83E\uDD35\uD83C\uDFFB"},{"unified":"1f935-1f3fc","native":"\uD83E\uDD35\uD83C\uDFFC"},{"unified":"1f935-1f3fd","native":"\uD83E\uDD35\uD83C\uDFFD"},{"unified":"1f935-1f3fe","native":"\uD83E\uDD35\uD83C\uDFFE"},{"unified":"1f935-1f3ff","native":"\uD83E\uDD35\uD83C\uDFFF"}],"version":3},"man_in_tuxedo":{"id":"man_in_tuxedo","name":"Man in Tuxedo","keywords":["formal","fashion"],"skins":[{"unified":"1f935-200d-2642-fe0f","native":"\uD83E\uDD35\u200D\u2642\uFE0F"},{"unified":"1f935-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD35\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f935-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD35\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f935-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD35\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f935-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD35\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f935-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD35\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":13},"woman_in_tuxedo":{"id":"woman_in_tuxedo","name":"Woman in Tuxedo","keywords":["formal","fashion"],"skins":[{"unified":"1f935-200d-2640-fe0f","native":"\uD83E\uDD35\u200D\u2640\uFE0F"},{"unified":"1f935-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD35\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f935-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD35\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f935-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD35\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f935-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD35\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f935-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD35\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":13},"bride_with_veil":{"id":"bride_with_veil","name":"Bride with Veil","keywords":["couple","marriage","wedding","woman"],"skins":[{"unified":"1f470","native":"\uD83D\uDC70"},{"unified":"1f470-1f3fb","native":"\uD83D\uDC70\uD83C\uDFFB"},{"unified":"1f470-1f3fc","native":"\uD83D\uDC70\uD83C\uDFFC"},{"unified":"1f470-1f3fd","native":"\uD83D\uDC70\uD83C\uDFFD"},{"unified":"1f470-1f3fe","native":"\uD83D\uDC70\uD83C\uDFFE"},{"unified":"1f470-1f3ff","native":"\uD83D\uDC70\uD83C\uDFFF"}],"version":1},"man_with_veil":{"id":"man_with_veil","name":"Man with Veil","keywords":["wedding","marriage"],"skins":[{"unified":"1f470-200d-2642-fe0f","native":"\uD83D\uDC70\u200D\u2642\uFE0F"},{"unified":"1f470-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC70\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f470-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC70\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f470-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC70\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f470-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC70\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f470-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC70\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":13},"woman_with_veil":{"id":"woman_with_veil","name":"Woman with Veil","keywords":["wedding","marriage"],"skins":[{"unified":"1f470-200d-2640-fe0f","native":"\uD83D\uDC70\u200D\u2640\uFE0F"},{"unified":"1f470-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC70\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f470-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC70\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f470-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC70\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f470-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC70\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f470-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC70\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":13},"pregnant_woman":{"id":"pregnant_woman","name":"Pregnant Woman","keywords":["baby"],"skins":[{"unified":"1f930","native":"\uD83E\uDD30"},{"unified":"1f930-1f3fb","native":"\uD83E\uDD30\uD83C\uDFFB"},{"unified":"1f930-1f3fc","native":"\uD83E\uDD30\uD83C\uDFFC"},{"unified":"1f930-1f3fd","native":"\uD83E\uDD30\uD83C\uDFFD"},{"unified":"1f930-1f3fe","native":"\uD83E\uDD30\uD83C\uDFFE"},{"unified":"1f930-1f3ff","native":"\uD83E\uDD30\uD83C\uDFFF"}],"version":3},"pregnant_man":{"id":"pregnant_man","name":"Pregnant Man","keywords":["baby","belly"],"skins":[{"unified":"1fac3","native":"\uD83E\uDEC3"},{"unified":"1fac3-1f3fb","native":"\uD83E\uDEC3\uD83C\uDFFB"},{"unified":"1fac3-1f3fc","native":"\uD83E\uDEC3\uD83C\uDFFC"},{"unified":"1fac3-1f3fd","native":"\uD83E\uDEC3\uD83C\uDFFD"},{"unified":"1fac3-1f3fe","native":"\uD83E\uDEC3\uD83C\uDFFE"},{"unified":"1fac3-1f3ff","native":"\uD83E\uDEC3\uD83C\uDFFF"}],"version":14},"pregnant_person":{"id":"pregnant_person","name":"Pregnant Person","keywords":["baby","belly"],"skins":[{"unified":"1fac4","native":"\uD83E\uDEC4"},{"unified":"1fac4-1f3fb","native":"\uD83E\uDEC4\uD83C\uDFFB"},{"unified":"1fac4-1f3fc","native":"\uD83E\uDEC4\uD83C\uDFFC"},{"unified":"1fac4-1f3fd","native":"\uD83E\uDEC4\uD83C\uDFFD"},{"unified":"1fac4-1f3fe","native":"\uD83E\uDEC4\uD83C\uDFFE"},{"unified":"1fac4-1f3ff","native":"\uD83E\uDEC4\uD83C\uDFFF"}],"version":14},"breast-feeding":{"id":"breast-feeding","name":"Breast-Feeding","keywords":["breast","feeding","nursing","baby"],"skins":[{"unified":"1f931","native":"\uD83E\uDD31"},{"unified":"1f931-1f3fb","native":"\uD83E\uDD31\uD83C\uDFFB"},{"unified":"1f931-1f3fc","native":"\uD83E\uDD31\uD83C\uDFFC"},{"unified":"1f931-1f3fd","native":"\uD83E\uDD31\uD83C\uDFFD"},{"unified":"1f931-1f3fe","native":"\uD83E\uDD31\uD83C\uDFFE"},{"unified":"1f931-1f3ff","native":"\uD83E\uDD31\uD83C\uDFFF"}],"version":5},"woman_feeding_baby":{"id":"woman_feeding_baby","name":"Woman Feeding Baby","keywords":["birth","food"],"skins":[{"unified":"1f469-200d-1f37c","native":"\uD83D\uDC69\u200D\uD83C\uDF7C"},{"unified":"1f469-1f3fb-200d-1f37c","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF7C"},{"unified":"1f469-1f3fc-200d-1f37c","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF7C"},{"unified":"1f469-1f3fd-200d-1f37c","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF7C"},{"unified":"1f469-1f3fe-200d-1f37c","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF7C"},{"unified":"1f469-1f3ff-200d-1f37c","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF7C"}],"version":13},"man_feeding_baby":{"id":"man_feeding_baby","name":"Man Feeding Baby","keywords":["birth","food"],"skins":[{"unified":"1f468-200d-1f37c","native":"\uD83D\uDC68\u200D\uD83C\uDF7C"},{"unified":"1f468-1f3fb-200d-1f37c","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF7C"},{"unified":"1f468-1f3fc-200d-1f37c","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF7C"},{"unified":"1f468-1f3fd-200d-1f37c","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF7C"},{"unified":"1f468-1f3fe-200d-1f37c","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF7C"},{"unified":"1f468-1f3ff-200d-1f37c","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF7C"}],"version":13},"person_feeding_baby":{"id":"person_feeding_baby","name":"Person Feeding Baby","keywords":["birth","food"],"skins":[{"unified":"1f9d1-200d-1f37c","native":"\uD83E\uDDD1\u200D\uD83C\uDF7C"},{"unified":"1f9d1-1f3fb-200d-1f37c","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF7C"},{"unified":"1f9d1-1f3fc-200d-1f37c","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF7C"},{"unified":"1f9d1-1f3fd-200d-1f37c","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF7C"},{"unified":"1f9d1-1f3fe-200d-1f37c","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF7C"},{"unified":"1f9d1-1f3ff-200d-1f37c","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF7C"}],"version":13},"angel":{"id":"angel","name":"Baby Angel","keywords":["heaven","wings","halo"],"skins":[{"unified":"1f47c","native":"\uD83D\uDC7C"},{"unified":"1f47c-1f3fb","native":"\uD83D\uDC7C\uD83C\uDFFB"},{"unified":"1f47c-1f3fc","native":"\uD83D\uDC7C\uD83C\uDFFC"},{"unified":"1f47c-1f3fd","native":"\uD83D\uDC7C\uD83C\uDFFD"},{"unified":"1f47c-1f3fe","native":"\uD83D\uDC7C\uD83C\uDFFE"},{"unified":"1f47c-1f3ff","native":"\uD83D\uDC7C\uD83C\uDFFF"}],"version":1},"santa":{"id":"santa","name":"Santa Claus","keywords":["festival","man","male","xmas","father","christmas"],"skins":[{"unified":"1f385","native":"\uD83C\uDF85"},{"unified":"1f385-1f3fb","native":"\uD83C\uDF85\uD83C\uDFFB"},{"unified":"1f385-1f3fc","native":"\uD83C\uDF85\uD83C\uDFFC"},{"unified":"1f385-1f3fd","native":"\uD83C\uDF85\uD83C\uDFFD"},{"unified":"1f385-1f3fe","native":"\uD83C\uDF85\uD83C\uDFFE"},{"unified":"1f385-1f3ff","native":"\uD83C\uDF85\uD83C\uDFFF"}],"version":1},"mrs_claus":{"id":"mrs_claus","name":"Mrs. Claus","keywords":["mrs","mother","christmas","woman","female","xmas"],"skins":[{"unified":"1f936","native":"\uD83E\uDD36"},{"unified":"1f936-1f3fb","native":"\uD83E\uDD36\uD83C\uDFFB"},{"unified":"1f936-1f3fc","native":"\uD83E\uDD36\uD83C\uDFFC"},{"unified":"1f936-1f3fd","native":"\uD83E\uDD36\uD83C\uDFFD"},{"unified":"1f936-1f3fe","native":"\uD83E\uDD36\uD83C\uDFFE"},{"unified":"1f936-1f3ff","native":"\uD83E\uDD36\uD83C\uDFFF"}],"version":3},"mx_claus":{"id":"mx_claus","name":"Mx Claus","keywords":["christmas"],"skins":[{"unified":"1f9d1-200d-1f384","native":"\uD83E\uDDD1\u200D\uD83C\uDF84"},{"unified":"1f9d1-1f3fb-200d-1f384","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF84"},{"unified":"1f9d1-1f3fc-200d-1f384","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF84"},{"unified":"1f9d1-1f3fd-200d-1f384","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF84"},{"unified":"1f9d1-1f3fe-200d-1f384","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF84"},{"unified":"1f9d1-1f3ff-200d-1f384","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF84"}],"version":13},"superhero":{"id":"superhero","name":"Superhero","keywords":["marvel"],"skins":[{"unified":"1f9b8","native":"\uD83E\uDDB8"},{"unified":"1f9b8-1f3fb","native":"\uD83E\uDDB8\uD83C\uDFFB"},{"unified":"1f9b8-1f3fc","native":"\uD83E\uDDB8\uD83C\uDFFC"},{"unified":"1f9b8-1f3fd","native":"\uD83E\uDDB8\uD83C\uDFFD"},{"unified":"1f9b8-1f3fe","native":"\uD83E\uDDB8\uD83C\uDFFE"},{"unified":"1f9b8-1f3ff","native":"\uD83E\uDDB8\uD83C\uDFFF"}],"version":11},"male_superhero":{"id":"male_superhero","name":"Man Superhero","keywords":["male","good","hero","superpowers"],"skins":[{"unified":"1f9b8-200d-2642-fe0f","native":"\uD83E\uDDB8\u200D\u2642\uFE0F"},{"unified":"1f9b8-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9b8-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9b8-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9b8-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9b8-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":11},"female_superhero":{"id":"female_superhero","name":"Woman Superhero","keywords":["female","good","heroine","superpowers"],"skins":[{"unified":"1f9b8-200d-2640-fe0f","native":"\uD83E\uDDB8\u200D\u2640\uFE0F"},{"unified":"1f9b8-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9b8-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9b8-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9b8-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9b8-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":11},"supervillain":{"id":"supervillain","name":"Supervillain","keywords":["marvel"],"skins":[{"unified":"1f9b9","native":"\uD83E\uDDB9"},{"unified":"1f9b9-1f3fb","native":"\uD83E\uDDB9\uD83C\uDFFB"},{"unified":"1f9b9-1f3fc","native":"\uD83E\uDDB9\uD83C\uDFFC"},{"unified":"1f9b9-1f3fd","native":"\uD83E\uDDB9\uD83C\uDFFD"},{"unified":"1f9b9-1f3fe","native":"\uD83E\uDDB9\uD83C\uDFFE"},{"unified":"1f9b9-1f3ff","native":"\uD83E\uDDB9\uD83C\uDFFF"}],"version":11},"male_supervillain":{"id":"male_supervillain","name":"Man Supervillain","keywords":["male","evil","bad","criminal","hero","superpowers"],"skins":[{"unified":"1f9b9-200d-2642-fe0f","native":"\uD83E\uDDB9\u200D\u2642\uFE0F"},{"unified":"1f9b9-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9b9-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9b9-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9b9-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9b9-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":11},"female_supervillain":{"id":"female_supervillain","name":"Woman Supervillain","keywords":["female","evil","bad","criminal","heroine","superpowers"],"skins":[{"unified":"1f9b9-200d-2640-fe0f","native":"\uD83E\uDDB9\u200D\u2640\uFE0F"},{"unified":"1f9b9-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9b9-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9b9-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9b9-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9b9-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":11},"mage":{"id":"mage","name":"Mage","keywords":["magic"],"skins":[{"unified":"1f9d9","native":"\uD83E\uDDD9"},{"unified":"1f9d9-1f3fb","native":"\uD83E\uDDD9\uD83C\uDFFB"},{"unified":"1f9d9-1f3fc","native":"\uD83E\uDDD9\uD83C\uDFFC"},{"unified":"1f9d9-1f3fd","native":"\uD83E\uDDD9\uD83C\uDFFD"},{"unified":"1f9d9-1f3fe","native":"\uD83E\uDDD9\uD83C\uDFFE"},{"unified":"1f9d9-1f3ff","native":"\uD83E\uDDD9\uD83C\uDFFF"}],"version":5},"male_mage":{"id":"male_mage","name":"Man Mage","keywords":["male","sorcerer"],"skins":[{"unified":"1f9d9-200d-2642-fe0f","native":"\uD83E\uDDD9\u200D\u2642\uFE0F"},{"unified":"1f9d9-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9d9-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9d9-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9d9-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9d9-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"female_mage":{"id":"female_mage","name":"Woman Mage","keywords":["female","witch"],"skins":[{"unified":"1f9d9-200d-2640-fe0f","native":"\uD83E\uDDD9\u200D\u2640\uFE0F"},{"unified":"1f9d9-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9d9-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9d9-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9d9-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9d9-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"fairy":{"id":"fairy","name":"Fairy","keywords":["wings","magical"],"skins":[{"unified":"1f9da","native":"\uD83E\uDDDA"},{"unified":"1f9da-1f3fb","native":"\uD83E\uDDDA\uD83C\uDFFB"},{"unified":"1f9da-1f3fc","native":"\uD83E\uDDDA\uD83C\uDFFC"},{"unified":"1f9da-1f3fd","native":"\uD83E\uDDDA\uD83C\uDFFD"},{"unified":"1f9da-1f3fe","native":"\uD83E\uDDDA\uD83C\uDFFE"},{"unified":"1f9da-1f3ff","native":"\uD83E\uDDDA\uD83C\uDFFF"}],"version":5},"male_fairy":{"id":"male_fairy","name":"Man Fairy","keywords":["male"],"skins":[{"unified":"1f9da-200d-2642-fe0f","native":"\uD83E\uDDDA\u200D\u2642\uFE0F"},{"unified":"1f9da-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9da-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9da-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9da-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9da-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"female_fairy":{"id":"female_fairy","name":"Woman Fairy","keywords":["female"],"skins":[{"unified":"1f9da-200d-2640-fe0f","native":"\uD83E\uDDDA\u200D\u2640\uFE0F"},{"unified":"1f9da-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9da-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9da-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9da-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9da-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"vampire":{"id":"vampire","name":"Vampire","keywords":["blood","twilight"],"skins":[{"unified":"1f9db","native":"\uD83E\uDDDB"},{"unified":"1f9db-1f3fb","native":"\uD83E\uDDDB\uD83C\uDFFB"},{"unified":"1f9db-1f3fc","native":"\uD83E\uDDDB\uD83C\uDFFC"},{"unified":"1f9db-1f3fd","native":"\uD83E\uDDDB\uD83C\uDFFD"},{"unified":"1f9db-1f3fe","native":"\uD83E\uDDDB\uD83C\uDFFE"},{"unified":"1f9db-1f3ff","native":"\uD83E\uDDDB\uD83C\uDFFF"}],"version":5},"male_vampire":{"id":"male_vampire","name":"Man Vampire","keywords":["male","dracula"],"skins":[{"unified":"1f9db-200d-2642-fe0f","native":"\uD83E\uDDDB\u200D\u2642\uFE0F"},{"unified":"1f9db-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9db-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9db-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9db-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9db-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"female_vampire":{"id":"female_vampire","name":"Woman Vampire","keywords":["female"],"skins":[{"unified":"1f9db-200d-2640-fe0f","native":"\uD83E\uDDDB\u200D\u2640\uFE0F"},{"unified":"1f9db-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9db-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9db-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9db-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9db-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"merperson":{"id":"merperson","name":"Merperson","keywords":["sea"],"skins":[{"unified":"1f9dc","native":"\uD83E\uDDDC"},{"unified":"1f9dc-1f3fb","native":"\uD83E\uDDDC\uD83C\uDFFB"},{"unified":"1f9dc-1f3fc","native":"\uD83E\uDDDC\uD83C\uDFFC"},{"unified":"1f9dc-1f3fd","native":"\uD83E\uDDDC\uD83C\uDFFD"},{"unified":"1f9dc-1f3fe","native":"\uD83E\uDDDC\uD83C\uDFFE"},{"unified":"1f9dc-1f3ff","native":"\uD83E\uDDDC\uD83C\uDFFF"}],"version":5},"merman":{"id":"merman","name":"Merman","keywords":["man","male","triton"],"skins":[{"unified":"1f9dc-200d-2642-fe0f","native":"\uD83E\uDDDC\u200D\u2642\uFE0F"},{"unified":"1f9dc-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9dc-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9dc-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9dc-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9dc-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"mermaid":{"id":"mermaid","name":"Mermaid","keywords":["woman","female","merwoman","ariel"],"skins":[{"unified":"1f9dc-200d-2640-fe0f","native":"\uD83E\uDDDC\u200D\u2640\uFE0F"},{"unified":"1f9dc-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9dc-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9dc-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9dc-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9dc-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"elf":{"id":"elf","name":"Elf","keywords":["magical"],"skins":[{"unified":"1f9dd","native":"\uD83E\uDDDD"},{"unified":"1f9dd-1f3fb","native":"\uD83E\uDDDD\uD83C\uDFFB"},{"unified":"1f9dd-1f3fc","native":"\uD83E\uDDDD\uD83C\uDFFC"},{"unified":"1f9dd-1f3fd","native":"\uD83E\uDDDD\uD83C\uDFFD"},{"unified":"1f9dd-1f3fe","native":"\uD83E\uDDDD\uD83C\uDFFE"},{"unified":"1f9dd-1f3ff","native":"\uD83E\uDDDD\uD83C\uDFFF"}],"version":5},"male_elf":{"id":"male_elf","name":"Man Elf","keywords":["male"],"skins":[{"unified":"1f9dd-200d-2642-fe0f","native":"\uD83E\uDDDD\u200D\u2642\uFE0F"},{"unified":"1f9dd-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9dd-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9dd-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9dd-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9dd-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"female_elf":{"id":"female_elf","name":"Woman Elf","keywords":["female"],"skins":[{"unified":"1f9dd-200d-2640-fe0f","native":"\uD83E\uDDDD\u200D\u2640\uFE0F"},{"unified":"1f9dd-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9dd-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9dd-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9dd-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9dd-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"genie":{"id":"genie","name":"Genie","keywords":["magical","wishes"],"skins":[{"unified":"1f9de","native":"\uD83E\uDDDE"}],"version":5},"male_genie":{"id":"male_genie","name":"Man Genie","keywords":["male"],"skins":[{"unified":"1f9de-200d-2642-fe0f","native":"\uD83E\uDDDE\u200D\u2642\uFE0F"}],"version":5},"female_genie":{"id":"female_genie","name":"Woman Genie","keywords":["female"],"skins":[{"unified":"1f9de-200d-2640-fe0f","native":"\uD83E\uDDDE\u200D\u2640\uFE0F"}],"version":5},"zombie":{"id":"zombie","name":"Zombie","keywords":["dead"],"skins":[{"unified":"1f9df","native":"\uD83E\uDDDF"}],"version":5},"male_zombie":{"id":"male_zombie","name":"Man Zombie","keywords":["male","dracula","undead","walking","dead"],"skins":[{"unified":"1f9df-200d-2642-fe0f","native":"\uD83E\uDDDF\u200D\u2642\uFE0F"}],"version":5},"female_zombie":{"id":"female_zombie","name":"Woman Zombie","keywords":["female","undead","walking","dead"],"skins":[{"unified":"1f9df-200d-2640-fe0f","native":"\uD83E\uDDDF\u200D\u2640\uFE0F"}],"version":5},"troll":{"id":"troll","name":"Troll","keywords":["mystical","monster"],"skins":[{"unified":"1f9cc","native":"\uD83E\uDDCC"}],"version":14},"massage":{"id":"massage","name":"Face Massage","keywords":["person","getting","relax"],"skins":[{"unified":"1f486","native":"\uD83D\uDC86"},{"unified":"1f486-1f3fb","native":"\uD83D\uDC86\uD83C\uDFFB"},{"unified":"1f486-1f3fc","native":"\uD83D\uDC86\uD83C\uDFFC"},{"unified":"1f486-1f3fd","native":"\uD83D\uDC86\uD83C\uDFFD"},{"unified":"1f486-1f3fe","native":"\uD83D\uDC86\uD83C\uDFFE"},{"unified":"1f486-1f3ff","native":"\uD83D\uDC86\uD83C\uDFFF"}],"version":1},"man-getting-massage":{"id":"man-getting-massage","name":"Man Getting Massage","keywords":["getting-massage","male","boy","head"],"skins":[{"unified":"1f486-200d-2642-fe0f","native":"\uD83D\uDC86\u200D\u2642\uFE0F"},{"unified":"1f486-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC86\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f486-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC86\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f486-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC86\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f486-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC86\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f486-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC86\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-getting-massage":{"id":"woman-getting-massage","name":"Woman Getting Massage","keywords":["getting-massage","female","girl","head"],"skins":[{"unified":"1f486-200d-2640-fe0f","native":"\uD83D\uDC86\u200D\u2640\uFE0F"},{"unified":"1f486-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC86\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f486-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC86\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f486-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC86\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f486-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC86\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f486-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC86\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"haircut":{"id":"haircut","name":"Haircut","keywords":["person","getting","hairstyle"],"skins":[{"unified":"1f487","native":"\uD83D\uDC87"},{"unified":"1f487-1f3fb","native":"\uD83D\uDC87\uD83C\uDFFB"},{"unified":"1f487-1f3fc","native":"\uD83D\uDC87\uD83C\uDFFC"},{"unified":"1f487-1f3fd","native":"\uD83D\uDC87\uD83C\uDFFD"},{"unified":"1f487-1f3fe","native":"\uD83D\uDC87\uD83C\uDFFE"},{"unified":"1f487-1f3ff","native":"\uD83D\uDC87\uD83C\uDFFF"}],"version":1},"man-getting-haircut":{"id":"man-getting-haircut","name":"Man Getting Haircut","keywords":["getting-haircut","male","boy"],"skins":[{"unified":"1f487-200d-2642-fe0f","native":"\uD83D\uDC87\u200D\u2642\uFE0F"},{"unified":"1f487-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC87\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f487-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC87\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f487-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC87\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f487-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC87\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f487-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC87\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-getting-haircut":{"id":"woman-getting-haircut","name":"Woman Getting Haircut","keywords":["getting-haircut","female","girl"],"skins":[{"unified":"1f487-200d-2640-fe0f","native":"\uD83D\uDC87\u200D\u2640\uFE0F"},{"unified":"1f487-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC87\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f487-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC87\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f487-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC87\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f487-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC87\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f487-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC87\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"walking":{"id":"walking","name":"Pedestrian","keywords":["walking","person","move"],"skins":[{"unified":"1f6b6","native":"\uD83D\uDEB6"},{"unified":"1f6b6-1f3fb","native":"\uD83D\uDEB6\uD83C\uDFFB"},{"unified":"1f6b6-1f3fc","native":"\uD83D\uDEB6\uD83C\uDFFC"},{"unified":"1f6b6-1f3fd","native":"\uD83D\uDEB6\uD83C\uDFFD"},{"unified":"1f6b6-1f3fe","native":"\uD83D\uDEB6\uD83C\uDFFE"},{"unified":"1f6b6-1f3ff","native":"\uD83D\uDEB6\uD83C\uDFFF"}],"version":1},"man-walking":{"id":"man-walking","name":"Man Walking","keywords":["human","feet","steps"],"skins":[{"unified":"1f6b6-200d-2642-fe0f","native":"\uD83D\uDEB6\u200D\u2642\uFE0F"},{"unified":"1f6b6-1f3fb-200d-2642-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f6b6-1f3fc-200d-2642-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f6b6-1f3fd-200d-2642-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f6b6-1f3fe-200d-2642-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f6b6-1f3ff-200d-2642-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-walking":{"id":"woman-walking","name":"Woman Walking","keywords":["human","feet","steps","female"],"skins":[{"unified":"1f6b6-200d-2640-fe0f","native":"\uD83D\uDEB6\u200D\u2640\uFE0F"},{"unified":"1f6b6-1f3fb-200d-2640-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f6b6-1f3fc-200d-2640-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f6b6-1f3fd-200d-2640-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f6b6-1f3fe-200d-2640-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f6b6-1f3ff-200d-2640-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"standing_person":{"id":"standing_person","name":"Standing Person","keywords":["still"],"skins":[{"unified":"1f9cd","native":"\uD83E\uDDCD"},{"unified":"1f9cd-1f3fb","native":"\uD83E\uDDCD\uD83C\uDFFB"},{"unified":"1f9cd-1f3fc","native":"\uD83E\uDDCD\uD83C\uDFFC"},{"unified":"1f9cd-1f3fd","native":"\uD83E\uDDCD\uD83C\uDFFD"},{"unified":"1f9cd-1f3fe","native":"\uD83E\uDDCD\uD83C\uDFFE"},{"unified":"1f9cd-1f3ff","native":"\uD83E\uDDCD\uD83C\uDFFF"}],"version":12},"man_standing":{"id":"man_standing","name":"Man Standing","keywords":["still"],"skins":[{"unified":"1f9cd-200d-2642-fe0f","native":"\uD83E\uDDCD\u200D\u2642\uFE0F"},{"unified":"1f9cd-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9cd-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9cd-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9cd-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9cd-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":12},"woman_standing":{"id":"woman_standing","name":"Woman Standing","keywords":["still"],"skins":[{"unified":"1f9cd-200d-2640-fe0f","native":"\uD83E\uDDCD\u200D\u2640\uFE0F"},{"unified":"1f9cd-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9cd-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9cd-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9cd-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9cd-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":12},"kneeling_person":{"id":"kneeling_person","name":"Kneeling Person","keywords":["pray","respectful"],"skins":[{"unified":"1f9ce","native":"\uD83E\uDDCE"},{"unified":"1f9ce-1f3fb","native":"\uD83E\uDDCE\uD83C\uDFFB"},{"unified":"1f9ce-1f3fc","native":"\uD83E\uDDCE\uD83C\uDFFC"},{"unified":"1f9ce-1f3fd","native":"\uD83E\uDDCE\uD83C\uDFFD"},{"unified":"1f9ce-1f3fe","native":"\uD83E\uDDCE\uD83C\uDFFE"},{"unified":"1f9ce-1f3ff","native":"\uD83E\uDDCE\uD83C\uDFFF"}],"version":12},"man_kneeling":{"id":"man_kneeling","name":"Man Kneeling","keywords":["pray","respectful"],"skins":[{"unified":"1f9ce-200d-2642-fe0f","native":"\uD83E\uDDCE\u200D\u2642\uFE0F"},{"unified":"1f9ce-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9ce-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9ce-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9ce-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9ce-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":12},"woman_kneeling":{"id":"woman_kneeling","name":"Woman Kneeling","keywords":["respectful","pray"],"skins":[{"unified":"1f9ce-200d-2640-fe0f","native":"\uD83E\uDDCE\u200D\u2640\uFE0F"},{"unified":"1f9ce-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9ce-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9ce-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9ce-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9ce-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":12},"person_with_probing_cane":{"id":"person_with_probing_cane","name":"Person with White Cane","keywords":["probing","blind"],"skins":[{"unified":"1f9d1-200d-1f9af","native":"\uD83E\uDDD1\u200D\uD83E\uDDAF"},{"unified":"1f9d1-1f3fb-200d-1f9af","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDAF"},{"unified":"1f9d1-1f3fc-200d-1f9af","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDAF"},{"unified":"1f9d1-1f3fd-200d-1f9af","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDAF"},{"unified":"1f9d1-1f3fe-200d-1f9af","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDAF"},{"unified":"1f9d1-1f3ff-200d-1f9af","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDAF"}],"version":12.1},"man_with_probing_cane":{"id":"man_with_probing_cane","name":"Man with White Cane","keywords":["probing","blind"],"skins":[{"unified":"1f468-200d-1f9af","native":"\uD83D\uDC68\u200D\uD83E\uDDAF"},{"unified":"1f468-1f3fb-200d-1f9af","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDAF"},{"unified":"1f468-1f3fc-200d-1f9af","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDAF"},{"unified":"1f468-1f3fd-200d-1f9af","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDAF"},{"unified":"1f468-1f3fe-200d-1f9af","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDAF"},{"unified":"1f468-1f3ff-200d-1f9af","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDAF"}],"version":12},"woman_with_probing_cane":{"id":"woman_with_probing_cane","name":"Woman with White Cane","keywords":["probing","blind"],"skins":[{"unified":"1f469-200d-1f9af","native":"\uD83D\uDC69\u200D\uD83E\uDDAF"},{"unified":"1f469-1f3fb-200d-1f9af","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDAF"},{"unified":"1f469-1f3fc-200d-1f9af","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDAF"},{"unified":"1f469-1f3fd-200d-1f9af","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDAF"},{"unified":"1f469-1f3fe-200d-1f9af","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDAF"},{"unified":"1f469-1f3ff-200d-1f9af","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDAF"}],"version":12},"person_in_motorized_wheelchair":{"id":"person_in_motorized_wheelchair","name":"Person in Motorized Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f9d1-200d-1f9bc","native":"\uD83E\uDDD1\u200D\uD83E\uDDBC"},{"unified":"1f9d1-1f3fb-200d-1f9bc","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBC"},{"unified":"1f9d1-1f3fc-200d-1f9bc","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBC"},{"unified":"1f9d1-1f3fd-200d-1f9bc","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBC"},{"unified":"1f9d1-1f3fe-200d-1f9bc","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBC"},{"unified":"1f9d1-1f3ff-200d-1f9bc","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBC"}],"version":12.1},"man_in_motorized_wheelchair":{"id":"man_in_motorized_wheelchair","name":"Man in Motorized Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f468-200d-1f9bc","native":"\uD83D\uDC68\u200D\uD83E\uDDBC"},{"unified":"1f468-1f3fb-200d-1f9bc","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBC"},{"unified":"1f468-1f3fc-200d-1f9bc","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBC"},{"unified":"1f468-1f3fd-200d-1f9bc","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBC"},{"unified":"1f468-1f3fe-200d-1f9bc","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBC"},{"unified":"1f468-1f3ff-200d-1f9bc","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBC"}],"version":12},"woman_in_motorized_wheelchair":{"id":"woman_in_motorized_wheelchair","name":"Woman in Motorized Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f469-200d-1f9bc","native":"\uD83D\uDC69\u200D\uD83E\uDDBC"},{"unified":"1f469-1f3fb-200d-1f9bc","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBC"},{"unified":"1f469-1f3fc-200d-1f9bc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBC"},{"unified":"1f469-1f3fd-200d-1f9bc","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBC"},{"unified":"1f469-1f3fe-200d-1f9bc","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBC"},{"unified":"1f469-1f3ff-200d-1f9bc","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBC"}],"version":12},"person_in_manual_wheelchair":{"id":"person_in_manual_wheelchair","name":"Person in Manual Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f9d1-200d-1f9bd","native":"\uD83E\uDDD1\u200D\uD83E\uDDBD"},{"unified":"1f9d1-1f3fb-200d-1f9bd","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBD"},{"unified":"1f9d1-1f3fc-200d-1f9bd","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBD"},{"unified":"1f9d1-1f3fd-200d-1f9bd","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBD"},{"unified":"1f9d1-1f3fe-200d-1f9bd","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBD"},{"unified":"1f9d1-1f3ff-200d-1f9bd","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBD"}],"version":12.1},"man_in_manual_wheelchair":{"id":"man_in_manual_wheelchair","name":"Man in Manual Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f468-200d-1f9bd","native":"\uD83D\uDC68\u200D\uD83E\uDDBD"},{"unified":"1f468-1f3fb-200d-1f9bd","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBD"},{"unified":"1f468-1f3fc-200d-1f9bd","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBD"},{"unified":"1f468-1f3fd-200d-1f9bd","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBD"},{"unified":"1f468-1f3fe-200d-1f9bd","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBD"},{"unified":"1f468-1f3ff-200d-1f9bd","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBD"}],"version":12},"woman_in_manual_wheelchair":{"id":"woman_in_manual_wheelchair","name":"Woman in Manual Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f469-200d-1f9bd","native":"\uD83D\uDC69\u200D\uD83E\uDDBD"},{"unified":"1f469-1f3fb-200d-1f9bd","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBD"},{"unified":"1f469-1f3fc-200d-1f9bd","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBD"},{"unified":"1f469-1f3fd-200d-1f9bd","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBD"},{"unified":"1f469-1f3fe-200d-1f9bd","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBD"},{"unified":"1f469-1f3ff-200d-1f9bd","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBD"}],"version":12},"runner":{"id":"runner","name":"Runner","keywords":["running","person","move"],"skins":[{"unified":"1f3c3","native":"\uD83C\uDFC3"},{"unified":"1f3c3-1f3fb","native":"\uD83C\uDFC3\uD83C\uDFFB"},{"unified":"1f3c3-1f3fc","native":"\uD83C\uDFC3\uD83C\uDFFC"},{"unified":"1f3c3-1f3fd","native":"\uD83C\uDFC3\uD83C\uDFFD"},{"unified":"1f3c3-1f3fe","native":"\uD83C\uDFC3\uD83C\uDFFE"},{"unified":"1f3c3-1f3ff","native":"\uD83C\uDFC3\uD83C\uDFFF"}],"version":1},"man-running":{"id":"man-running","name":"Man Running","keywords":["walking","exercise","race"],"skins":[{"unified":"1f3c3-200d-2642-fe0f","native":"\uD83C\uDFC3\u200D\u2642\uFE0F"},{"unified":"1f3c3-1f3fb-200d-2642-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f3c3-1f3fc-200d-2642-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f3c3-1f3fd-200d-2642-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f3c3-1f3fe-200d-2642-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f3c3-1f3ff-200d-2642-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-running":{"id":"woman-running","name":"Woman Running","keywords":["walking","exercise","race","female"],"skins":[{"unified":"1f3c3-200d-2640-fe0f","native":"\uD83C\uDFC3\u200D\u2640\uFE0F"},{"unified":"1f3c3-1f3fb-200d-2640-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f3c3-1f3fc-200d-2640-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f3c3-1f3fd-200d-2640-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f3c3-1f3fe-200d-2640-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f3c3-1f3ff-200d-2640-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"dancer":{"id":"dancer","name":"Dancer","keywords":["woman","dancing","female","girl","fun"],"skins":[{"unified":"1f483","native":"\uD83D\uDC83"},{"unified":"1f483-1f3fb","native":"\uD83D\uDC83\uD83C\uDFFB"},{"unified":"1f483-1f3fc","native":"\uD83D\uDC83\uD83C\uDFFC"},{"unified":"1f483-1f3fd","native":"\uD83D\uDC83\uD83C\uDFFD"},{"unified":"1f483-1f3fe","native":"\uD83D\uDC83\uD83C\uDFFE"},{"unified":"1f483-1f3ff","native":"\uD83D\uDC83\uD83C\uDFFF"}],"version":1},"man_dancing":{"id":"man_dancing","name":"Man Dancing","keywords":["male","boy","fun","dancer"],"skins":[{"unified":"1f57a","native":"\uD83D\uDD7A"},{"unified":"1f57a-1f3fb","native":"\uD83D\uDD7A\uD83C\uDFFB"},{"unified":"1f57a-1f3fc","native":"\uD83D\uDD7A\uD83C\uDFFC"},{"unified":"1f57a-1f3fd","native":"\uD83D\uDD7A\uD83C\uDFFD"},{"unified":"1f57a-1f3fe","native":"\uD83D\uDD7A\uD83C\uDFFE"},{"unified":"1f57a-1f3ff","native":"\uD83D\uDD7A\uD83C\uDFFF"}],"version":3},"man_in_business_suit_levitating":{"id":"man_in_business_suit_levitating","name":"Person in Suit Levitating","keywords":["man","business","levitate","hover","jump"],"skins":[{"unified":"1f574-fe0f","native":"\uD83D\uDD74\uFE0F"},{"unified":"1f574-1f3fb","native":"\uD83D\uDD74\uD83C\uDFFB"},{"unified":"1f574-1f3fc","native":"\uD83D\uDD74\uD83C\uDFFC"},{"unified":"1f574-1f3fd","native":"\uD83D\uDD74\uD83C\uDFFD"},{"unified":"1f574-1f3fe","native":"\uD83D\uDD74\uD83C\uDFFE"},{"unified":"1f574-1f3ff","native":"\uD83D\uDD74\uD83C\uDFFF"}],"version":1},"dancers":{"id":"dancers","name":"Woman with Bunny Ears","keywords":["dancers","people","perform","costume"],"skins":[{"unified":"1f46f","native":"\uD83D\uDC6F"}],"version":1},"men-with-bunny-ears-partying":{"id":"men-with-bunny-ears-partying","name":"Men with Bunny Ears","keywords":["with-bunny-ears-partying","man","male","boys"],"skins":[{"unified":"1f46f-200d-2642-fe0f","native":"\uD83D\uDC6F\u200D\u2642\uFE0F"}],"version":4},"women-with-bunny-ears-partying":{"id":"women-with-bunny-ears-partying","name":"Women with Bunny Ears","keywords":["with-bunny-ears-partying","woman","female","girls"],"skins":[{"unified":"1f46f-200d-2640-fe0f","native":"\uD83D\uDC6F\u200D\u2640\uFE0F"}],"version":4},"person_in_steamy_room":{"id":"person_in_steamy_room","name":"Person in Steamy Room","keywords":["relax","spa"],"skins":[{"unified":"1f9d6","native":"\uD83E\uDDD6"},{"unified":"1f9d6-1f3fb","native":"\uD83E\uDDD6\uD83C\uDFFB"},{"unified":"1f9d6-1f3fc","native":"\uD83E\uDDD6\uD83C\uDFFC"},{"unified":"1f9d6-1f3fd","native":"\uD83E\uDDD6\uD83C\uDFFD"},{"unified":"1f9d6-1f3fe","native":"\uD83E\uDDD6\uD83C\uDFFE"},{"unified":"1f9d6-1f3ff","native":"\uD83E\uDDD6\uD83C\uDFFF"}],"version":5},"man_in_steamy_room":{"id":"man_in_steamy_room","name":"Man in Steamy Room","keywords":["male","spa","steamroom","sauna"],"skins":[{"unified":"1f9d6-200d-2642-fe0f","native":"\uD83E\uDDD6\u200D\u2642\uFE0F"},{"unified":"1f9d6-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9d6-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9d6-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9d6-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9d6-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"woman_in_steamy_room":{"id":"woman_in_steamy_room","name":"Woman in Steamy Room","keywords":["female","spa","steamroom","sauna"],"skins":[{"unified":"1f9d6-200d-2640-fe0f","native":"\uD83E\uDDD6\u200D\u2640\uFE0F"},{"unified":"1f9d6-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9d6-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9d6-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9d6-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9d6-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"person_climbing":{"id":"person_climbing","name":"Person Climbing","keywords":["sport"],"skins":[{"unified":"1f9d7","native":"\uD83E\uDDD7"},{"unified":"1f9d7-1f3fb","native":"\uD83E\uDDD7\uD83C\uDFFB"},{"unified":"1f9d7-1f3fc","native":"\uD83E\uDDD7\uD83C\uDFFC"},{"unified":"1f9d7-1f3fd","native":"\uD83E\uDDD7\uD83C\uDFFD"},{"unified":"1f9d7-1f3fe","native":"\uD83E\uDDD7\uD83C\uDFFE"},{"unified":"1f9d7-1f3ff","native":"\uD83E\uDDD7\uD83C\uDFFF"}],"version":5},"man_climbing":{"id":"man_climbing","name":"Man Climbing","keywords":["sports","hobby","male","rock"],"skins":[{"unified":"1f9d7-200d-2642-fe0f","native":"\uD83E\uDDD7\u200D\u2642\uFE0F"},{"unified":"1f9d7-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9d7-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9d7-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9d7-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9d7-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"woman_climbing":{"id":"woman_climbing","name":"Woman Climbing","keywords":["sports","hobby","female","rock"],"skins":[{"unified":"1f9d7-200d-2640-fe0f","native":"\uD83E\uDDD7\u200D\u2640\uFE0F"},{"unified":"1f9d7-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9d7-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9d7-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9d7-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9d7-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"fencer":{"id":"fencer","name":"Fencer","keywords":["person","fencing","sports","sword"],"skins":[{"unified":"1f93a","native":"\uD83E\uDD3A"}],"version":3},"horse_racing":{"id":"horse_racing","name":"Horse Racing","keywords":["animal","betting","competition","gambling","luck"],"skins":[{"unified":"1f3c7","native":"\uD83C\uDFC7"},{"unified":"1f3c7-1f3fb","native":"\uD83C\uDFC7\uD83C\uDFFB"},{"unified":"1f3c7-1f3fc","native":"\uD83C\uDFC7\uD83C\uDFFC"},{"unified":"1f3c7-1f3fd","native":"\uD83C\uDFC7\uD83C\uDFFD"},{"unified":"1f3c7-1f3fe","native":"\uD83C\uDFC7\uD83C\uDFFE"},{"unified":"1f3c7-1f3ff","native":"\uD83C\uDFC7\uD83C\uDFFF"}],"version":1},"skier":{"id":"skier","name":"Skier","keywords":["sports","winter","snow"],"skins":[{"unified":"26f7-fe0f","native":"\u26F7\uFE0F"}],"version":1},"snowboarder":{"id":"snowboarder","name":"Snowboarder","keywords":["sports","winter"],"skins":[{"unified":"1f3c2","native":"\uD83C\uDFC2"},{"unified":"1f3c2-1f3fb","native":"\uD83C\uDFC2\uD83C\uDFFB"},{"unified":"1f3c2-1f3fc","native":"\uD83C\uDFC2\uD83C\uDFFC"},{"unified":"1f3c2-1f3fd","native":"\uD83C\uDFC2\uD83C\uDFFD"},{"unified":"1f3c2-1f3fe","native":"\uD83C\uDFC2\uD83C\uDFFE"},{"unified":"1f3c2-1f3ff","native":"\uD83C\uDFC2\uD83C\uDFFF"}],"version":1},"golfer":{"id":"golfer","name":"Person Golfing","keywords":["golfer","sports","business"],"skins":[{"unified":"1f3cc-fe0f","native":"\uD83C\uDFCC\uFE0F"},{"unified":"1f3cc-1f3fb","native":"\uD83C\uDFCC\uD83C\uDFFB"},{"unified":"1f3cc-1f3fc","native":"\uD83C\uDFCC\uD83C\uDFFC"},{"unified":"1f3cc-1f3fd","native":"\uD83C\uDFCC\uD83C\uDFFD"},{"unified":"1f3cc-1f3fe","native":"\uD83C\uDFCC\uD83C\uDFFE"},{"unified":"1f3cc-1f3ff","native":"\uD83C\uDFCC\uD83C\uDFFF"}],"version":1},"man-golfing":{"id":"man-golfing","name":"Man Golfing","keywords":["sport"],"skins":[{"unified":"1f3cc-fe0f-200d-2642-fe0f","native":"\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F"},{"unified":"1f3cc-1f3fb-200d-2642-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f3cc-1f3fc-200d-2642-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f3cc-1f3fd-200d-2642-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f3cc-1f3fe-200d-2642-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f3cc-1f3ff-200d-2642-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-golfing":{"id":"woman-golfing","name":"Woman Golfing","keywords":["sports","business","female"],"skins":[{"unified":"1f3cc-fe0f-200d-2640-fe0f","native":"\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F"},{"unified":"1f3cc-1f3fb-200d-2640-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f3cc-1f3fc-200d-2640-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f3cc-1f3fd-200d-2640-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f3cc-1f3fe-200d-2640-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f3cc-1f3ff-200d-2640-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"surfer":{"id":"surfer","name":"Surfer","keywords":["person","surfing","sport","sea"],"skins":[{"unified":"1f3c4","native":"\uD83C\uDFC4"},{"unified":"1f3c4-1f3fb","native":"\uD83C\uDFC4\uD83C\uDFFB"},{"unified":"1f3c4-1f3fc","native":"\uD83C\uDFC4\uD83C\uDFFC"},{"unified":"1f3c4-1f3fd","native":"\uD83C\uDFC4\uD83C\uDFFD"},{"unified":"1f3c4-1f3fe","native":"\uD83C\uDFC4\uD83C\uDFFE"},{"unified":"1f3c4-1f3ff","native":"\uD83C\uDFC4\uD83C\uDFFF"}],"version":1},"man-surfing":{"id":"man-surfing","name":"Man Surfing","keywords":["sports","ocean","sea","summer","beach"],"skins":[{"unified":"1f3c4-200d-2642-fe0f","native":"\uD83C\uDFC4\u200D\u2642\uFE0F"},{"unified":"1f3c4-1f3fb-200d-2642-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f3c4-1f3fc-200d-2642-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f3c4-1f3fd-200d-2642-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f3c4-1f3fe-200d-2642-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f3c4-1f3ff-200d-2642-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-surfing":{"id":"woman-surfing","name":"Woman Surfing","keywords":["sports","ocean","sea","summer","beach","female"],"skins":[{"unified":"1f3c4-200d-2640-fe0f","native":"\uD83C\uDFC4\u200D\u2640\uFE0F"},{"unified":"1f3c4-1f3fb-200d-2640-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f3c4-1f3fc-200d-2640-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f3c4-1f3fd-200d-2640-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f3c4-1f3fe-200d-2640-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f3c4-1f3ff-200d-2640-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"rowboat":{"id":"rowboat","name":"Rowboat","keywords":["person","rowing","boat","sport","move"],"skins":[{"unified":"1f6a3","native":"\uD83D\uDEA3"},{"unified":"1f6a3-1f3fb","native":"\uD83D\uDEA3\uD83C\uDFFB"},{"unified":"1f6a3-1f3fc","native":"\uD83D\uDEA3\uD83C\uDFFC"},{"unified":"1f6a3-1f3fd","native":"\uD83D\uDEA3\uD83C\uDFFD"},{"unified":"1f6a3-1f3fe","native":"\uD83D\uDEA3\uD83C\uDFFE"},{"unified":"1f6a3-1f3ff","native":"\uD83D\uDEA3\uD83C\uDFFF"}],"version":1},"man-rowing-boat":{"id":"man-rowing-boat","name":"Man Rowing Boat","keywords":["rowing-boat","sports","hobby","water","ship"],"skins":[{"unified":"1f6a3-200d-2642-fe0f","native":"\uD83D\uDEA3\u200D\u2642\uFE0F"},{"unified":"1f6a3-1f3fb-200d-2642-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f6a3-1f3fc-200d-2642-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f6a3-1f3fd-200d-2642-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f6a3-1f3fe-200d-2642-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f6a3-1f3ff-200d-2642-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-rowing-boat":{"id":"woman-rowing-boat","name":"Woman Rowing Boat","keywords":["rowing-boat","sports","hobby","water","ship","female"],"skins":[{"unified":"1f6a3-200d-2640-fe0f","native":"\uD83D\uDEA3\u200D\u2640\uFE0F"},{"unified":"1f6a3-1f3fb-200d-2640-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f6a3-1f3fc-200d-2640-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f6a3-1f3fd-200d-2640-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f6a3-1f3fe-200d-2640-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f6a3-1f3ff-200d-2640-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"swimmer":{"id":"swimmer","name":"Swimmer","keywords":["person","swimming","sport","pool"],"skins":[{"unified":"1f3ca","native":"\uD83C\uDFCA"},{"unified":"1f3ca-1f3fb","native":"\uD83C\uDFCA\uD83C\uDFFB"},{"unified":"1f3ca-1f3fc","native":"\uD83C\uDFCA\uD83C\uDFFC"},{"unified":"1f3ca-1f3fd","native":"\uD83C\uDFCA\uD83C\uDFFD"},{"unified":"1f3ca-1f3fe","native":"\uD83C\uDFCA\uD83C\uDFFE"},{"unified":"1f3ca-1f3ff","native":"\uD83C\uDFCA\uD83C\uDFFF"}],"version":1},"man-swimming":{"id":"man-swimming","name":"Man Swimming","keywords":["sports","exercise","human","athlete","water","summer"],"skins":[{"unified":"1f3ca-200d-2642-fe0f","native":"\uD83C\uDFCA\u200D\u2642\uFE0F"},{"unified":"1f3ca-1f3fb-200d-2642-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f3ca-1f3fc-200d-2642-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f3ca-1f3fd-200d-2642-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f3ca-1f3fe-200d-2642-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f3ca-1f3ff-200d-2642-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-swimming":{"id":"woman-swimming","name":"Woman Swimming","keywords":["sports","exercise","human","athlete","water","summer","female"],"skins":[{"unified":"1f3ca-200d-2640-fe0f","native":"\uD83C\uDFCA\u200D\u2640\uFE0F"},{"unified":"1f3ca-1f3fb-200d-2640-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f3ca-1f3fc-200d-2640-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f3ca-1f3fd-200d-2640-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f3ca-1f3fe-200d-2640-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f3ca-1f3ff-200d-2640-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"person_with_ball":{"id":"person_with_ball","name":"Person Bouncing Ball","keywords":["with","sports","human"],"skins":[{"unified":"26f9-fe0f","native":"\u26F9\uFE0F"},{"unified":"26f9-1f3fb","native":"\u26F9\uD83C\uDFFB"},{"unified":"26f9-1f3fc","native":"\u26F9\uD83C\uDFFC"},{"unified":"26f9-1f3fd","native":"\u26F9\uD83C\uDFFD"},{"unified":"26f9-1f3fe","native":"\u26F9\uD83C\uDFFE"},{"unified":"26f9-1f3ff","native":"\u26F9\uD83C\uDFFF"}],"version":1},"man-bouncing-ball":{"id":"man-bouncing-ball","name":"Man Bouncing Ball","keywords":["bouncing-ball","sport"],"skins":[{"unified":"26f9-fe0f-200d-2642-fe0f","native":"\u26F9\uFE0F\u200D\u2642\uFE0F"},{"unified":"26f9-1f3fb-200d-2642-fe0f","native":"\u26F9\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"26f9-1f3fc-200d-2642-fe0f","native":"\u26F9\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"26f9-1f3fd-200d-2642-fe0f","native":"\u26F9\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"26f9-1f3fe-200d-2642-fe0f","native":"\u26F9\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"26f9-1f3ff-200d-2642-fe0f","native":"\u26F9\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-bouncing-ball":{"id":"woman-bouncing-ball","name":"Woman Bouncing Ball","keywords":["bouncing-ball","sports","human","female"],"skins":[{"unified":"26f9-fe0f-200d-2640-fe0f","native":"\u26F9\uFE0F\u200D\u2640\uFE0F"},{"unified":"26f9-1f3fb-200d-2640-fe0f","native":"\u26F9\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"26f9-1f3fc-200d-2640-fe0f","native":"\u26F9\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"26f9-1f3fd-200d-2640-fe0f","native":"\u26F9\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"26f9-1f3fe-200d-2640-fe0f","native":"\u26F9\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"26f9-1f3ff-200d-2640-fe0f","native":"\u26F9\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"weight_lifter":{"id":"weight_lifter","name":"Person Lifting Weights","keywords":["weight","lifter","sports","training","exercise"],"skins":[{"unified":"1f3cb-fe0f","native":"\uD83C\uDFCB\uFE0F"},{"unified":"1f3cb-1f3fb","native":"\uD83C\uDFCB\uD83C\uDFFB"},{"unified":"1f3cb-1f3fc","native":"\uD83C\uDFCB\uD83C\uDFFC"},{"unified":"1f3cb-1f3fd","native":"\uD83C\uDFCB\uD83C\uDFFD"},{"unified":"1f3cb-1f3fe","native":"\uD83C\uDFCB\uD83C\uDFFE"},{"unified":"1f3cb-1f3ff","native":"\uD83C\uDFCB\uD83C\uDFFF"}],"version":1},"man-lifting-weights":{"id":"man-lifting-weights","name":"Man Lifting Weights","keywords":["lifting-weights","sport"],"skins":[{"unified":"1f3cb-fe0f-200d-2642-fe0f","native":"\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F"},{"unified":"1f3cb-1f3fb-200d-2642-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f3cb-1f3fc-200d-2642-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f3cb-1f3fd-200d-2642-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f3cb-1f3fe-200d-2642-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f3cb-1f3ff-200d-2642-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-lifting-weights":{"id":"woman-lifting-weights","name":"Woman Lifting Weights","keywords":["lifting-weights","sports","training","exercise","female"],"skins":[{"unified":"1f3cb-fe0f-200d-2640-fe0f","native":"\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F"},{"unified":"1f3cb-1f3fb-200d-2640-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f3cb-1f3fc-200d-2640-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f3cb-1f3fd-200d-2640-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f3cb-1f3fe-200d-2640-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f3cb-1f3ff-200d-2640-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"bicyclist":{"id":"bicyclist","name":"Bicyclist","keywords":["person","biking","sport","move"],"skins":[{"unified":"1f6b4","native":"\uD83D\uDEB4"},{"unified":"1f6b4-1f3fb","native":"\uD83D\uDEB4\uD83C\uDFFB"},{"unified":"1f6b4-1f3fc","native":"\uD83D\uDEB4\uD83C\uDFFC"},{"unified":"1f6b4-1f3fd","native":"\uD83D\uDEB4\uD83C\uDFFD"},{"unified":"1f6b4-1f3fe","native":"\uD83D\uDEB4\uD83C\uDFFE"},{"unified":"1f6b4-1f3ff","native":"\uD83D\uDEB4\uD83C\uDFFF"}],"version":1},"man-biking":{"id":"man-biking","name":"Man Biking","keywords":["sports","bike","exercise","hipster"],"skins":[{"unified":"1f6b4-200d-2642-fe0f","native":"\uD83D\uDEB4\u200D\u2642\uFE0F"},{"unified":"1f6b4-1f3fb-200d-2642-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f6b4-1f3fc-200d-2642-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f6b4-1f3fd-200d-2642-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f6b4-1f3fe-200d-2642-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f6b4-1f3ff-200d-2642-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-biking":{"id":"woman-biking","name":"Woman Biking","keywords":["sports","bike","exercise","hipster","female"],"skins":[{"unified":"1f6b4-200d-2640-fe0f","native":"\uD83D\uDEB4\u200D\u2640\uFE0F"},{"unified":"1f6b4-1f3fb-200d-2640-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f6b4-1f3fc-200d-2640-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f6b4-1f3fd-200d-2640-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f6b4-1f3fe-200d-2640-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f6b4-1f3ff-200d-2640-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"mountain_bicyclist":{"id":"mountain_bicyclist","name":"Mountain Bicyclist","keywords":["person","biking","sport","move"],"skins":[{"unified":"1f6b5","native":"\uD83D\uDEB5"},{"unified":"1f6b5-1f3fb","native":"\uD83D\uDEB5\uD83C\uDFFB"},{"unified":"1f6b5-1f3fc","native":"\uD83D\uDEB5\uD83C\uDFFC"},{"unified":"1f6b5-1f3fd","native":"\uD83D\uDEB5\uD83C\uDFFD"},{"unified":"1f6b5-1f3fe","native":"\uD83D\uDEB5\uD83C\uDFFE"},{"unified":"1f6b5-1f3ff","native":"\uD83D\uDEB5\uD83C\uDFFF"}],"version":1},"man-mountain-biking":{"id":"man-mountain-biking","name":"Man Mountain Biking","keywords":["mountain-biking","transportation","sports","human","race","bike"],"skins":[{"unified":"1f6b5-200d-2642-fe0f","native":"\uD83D\uDEB5\u200D\u2642\uFE0F"},{"unified":"1f6b5-1f3fb-200d-2642-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f6b5-1f3fc-200d-2642-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f6b5-1f3fd-200d-2642-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f6b5-1f3fe-200d-2642-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f6b5-1f3ff-200d-2642-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-mountain-biking":{"id":"woman-mountain-biking","name":"Woman Mountain Biking","keywords":["mountain-biking","transportation","sports","human","race","bike","female"],"skins":[{"unified":"1f6b5-200d-2640-fe0f","native":"\uD83D\uDEB5\u200D\u2640\uFE0F"},{"unified":"1f6b5-1f3fb-200d-2640-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f6b5-1f3fc-200d-2640-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f6b5-1f3fd-200d-2640-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f6b5-1f3fe-200d-2640-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f6b5-1f3ff-200d-2640-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"person_doing_cartwheel":{"id":"person_doing_cartwheel","name":"Person Cartwheeling","keywords":["doing","cartwheel","sport","gymnastic"],"skins":[{"unified":"1f938","native":"\uD83E\uDD38"},{"unified":"1f938-1f3fb","native":"\uD83E\uDD38\uD83C\uDFFB"},{"unified":"1f938-1f3fc","native":"\uD83E\uDD38\uD83C\uDFFC"},{"unified":"1f938-1f3fd","native":"\uD83E\uDD38\uD83C\uDFFD"},{"unified":"1f938-1f3fe","native":"\uD83E\uDD38\uD83C\uDFFE"},{"unified":"1f938-1f3ff","native":"\uD83E\uDD38\uD83C\uDFFF"}],"version":3},"man-cartwheeling":{"id":"man-cartwheeling","name":"Man Cartwheeling","keywords":["gymnastics"],"skins":[{"unified":"1f938-200d-2642-fe0f","native":"\uD83E\uDD38\u200D\u2642\uFE0F"},{"unified":"1f938-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD38\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f938-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD38\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f938-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD38\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f938-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD38\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f938-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD38\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-cartwheeling":{"id":"woman-cartwheeling","name":"Woman Cartwheeling","keywords":["gymnastics"],"skins":[{"unified":"1f938-200d-2640-fe0f","native":"\uD83E\uDD38\u200D\u2640\uFE0F"},{"unified":"1f938-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD38\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f938-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD38\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f938-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD38\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f938-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD38\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f938-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD38\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"wrestlers":{"id":"wrestlers","name":"Wrestlers","keywords":["people","wrestling","sport"],"skins":[{"unified":"1f93c","native":"\uD83E\uDD3C"}],"version":3},"man-wrestling":{"id":"man-wrestling","name":"Men Wrestling","keywords":["man","sports","wrestlers"],"skins":[{"unified":"1f93c-200d-2642-fe0f","native":"\uD83E\uDD3C\u200D\u2642\uFE0F"}],"version":4},"woman-wrestling":{"id":"woman-wrestling","name":"Women Wrestling","keywords":["woman","sports","wrestlers"],"skins":[{"unified":"1f93c-200d-2640-fe0f","native":"\uD83E\uDD3C\u200D\u2640\uFE0F"}],"version":4},"water_polo":{"id":"water_polo","name":"Water Polo","keywords":["person","playing","sport"],"skins":[{"unified":"1f93d","native":"\uD83E\uDD3D"},{"unified":"1f93d-1f3fb","native":"\uD83E\uDD3D\uD83C\uDFFB"},{"unified":"1f93d-1f3fc","native":"\uD83E\uDD3D\uD83C\uDFFC"},{"unified":"1f93d-1f3fd","native":"\uD83E\uDD3D\uD83C\uDFFD"},{"unified":"1f93d-1f3fe","native":"\uD83E\uDD3D\uD83C\uDFFE"},{"unified":"1f93d-1f3ff","native":"\uD83E\uDD3D\uD83C\uDFFF"}],"version":3},"man-playing-water-polo":{"id":"man-playing-water-polo","name":"Man Playing Water Polo","keywords":["playing-water-polo","sports","pool"],"skins":[{"unified":"1f93d-200d-2642-fe0f","native":"\uD83E\uDD3D\u200D\u2642\uFE0F"},{"unified":"1f93d-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f93d-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f93d-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f93d-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f93d-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-playing-water-polo":{"id":"woman-playing-water-polo","name":"Woman Playing Water Polo","keywords":["playing-water-polo","sports","pool"],"skins":[{"unified":"1f93d-200d-2640-fe0f","native":"\uD83E\uDD3D\u200D\u2640\uFE0F"},{"unified":"1f93d-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f93d-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f93d-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f93d-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f93d-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"handball":{"id":"handball","name":"Handball","keywords":["person","playing","sport"],"skins":[{"unified":"1f93e","native":"\uD83E\uDD3E"},{"unified":"1f93e-1f3fb","native":"\uD83E\uDD3E\uD83C\uDFFB"},{"unified":"1f93e-1f3fc","native":"\uD83E\uDD3E\uD83C\uDFFC"},{"unified":"1f93e-1f3fd","native":"\uD83E\uDD3E\uD83C\uDFFD"},{"unified":"1f93e-1f3fe","native":"\uD83E\uDD3E\uD83C\uDFFE"},{"unified":"1f93e-1f3ff","native":"\uD83E\uDD3E\uD83C\uDFFF"}],"version":3},"man-playing-handball":{"id":"man-playing-handball","name":"Man Playing Handball","keywords":["playing-handball","sports"],"skins":[{"unified":"1f93e-200d-2642-fe0f","native":"\uD83E\uDD3E\u200D\u2642\uFE0F"},{"unified":"1f93e-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f93e-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f93e-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f93e-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f93e-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-playing-handball":{"id":"woman-playing-handball","name":"Woman Playing Handball","keywords":["playing-handball","sports"],"skins":[{"unified":"1f93e-200d-2640-fe0f","native":"\uD83E\uDD3E\u200D\u2640\uFE0F"},{"unified":"1f93e-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f93e-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f93e-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f93e-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f93e-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"juggling":{"id":"juggling","name":"Juggling","keywords":["person","performance","balance"],"skins":[{"unified":"1f939","native":"\uD83E\uDD39"},{"unified":"1f939-1f3fb","native":"\uD83E\uDD39\uD83C\uDFFB"},{"unified":"1f939-1f3fc","native":"\uD83E\uDD39\uD83C\uDFFC"},{"unified":"1f939-1f3fd","native":"\uD83E\uDD39\uD83C\uDFFD"},{"unified":"1f939-1f3fe","native":"\uD83E\uDD39\uD83C\uDFFE"},{"unified":"1f939-1f3ff","native":"\uD83E\uDD39\uD83C\uDFFF"}],"version":3},"man-juggling":{"id":"man-juggling","name":"Man Juggling","keywords":["juggle","balance","skill","multitask"],"skins":[{"unified":"1f939-200d-2642-fe0f","native":"\uD83E\uDD39\u200D\u2642\uFE0F"},{"unified":"1f939-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD39\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f939-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD39\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f939-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD39\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f939-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD39\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f939-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD39\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-juggling":{"id":"woman-juggling","name":"Woman Juggling","keywords":["juggle","balance","skill","multitask"],"skins":[{"unified":"1f939-200d-2640-fe0f","native":"\uD83E\uDD39\u200D\u2640\uFE0F"},{"unified":"1f939-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD39\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f939-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD39\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f939-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD39\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f939-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD39\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f939-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD39\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"person_in_lotus_position":{"id":"person_in_lotus_position","name":"Person in Lotus Position","keywords":["meditate"],"skins":[{"unified":"1f9d8","native":"\uD83E\uDDD8"},{"unified":"1f9d8-1f3fb","native":"\uD83E\uDDD8\uD83C\uDFFB"},{"unified":"1f9d8-1f3fc","native":"\uD83E\uDDD8\uD83C\uDFFC"},{"unified":"1f9d8-1f3fd","native":"\uD83E\uDDD8\uD83C\uDFFD"},{"unified":"1f9d8-1f3fe","native":"\uD83E\uDDD8\uD83C\uDFFE"},{"unified":"1f9d8-1f3ff","native":"\uD83E\uDDD8\uD83C\uDFFF"}],"version":5},"man_in_lotus_position":{"id":"man_in_lotus_position","name":"Man in Lotus Position","keywords":["male","meditation","yoga","serenity","zen","mindfulness"],"skins":[{"unified":"1f9d8-200d-2642-fe0f","native":"\uD83E\uDDD8\u200D\u2642\uFE0F"},{"unified":"1f9d8-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9d8-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9d8-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9d8-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9d8-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"woman_in_lotus_position":{"id":"woman_in_lotus_position","name":"Woman in Lotus Position","keywords":["female","meditation","yoga","serenity","zen","mindfulness"],"skins":[{"unified":"1f9d8-200d-2640-fe0f","native":"\uD83E\uDDD8\u200D\u2640\uFE0F"},{"unified":"1f9d8-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9d8-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9d8-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9d8-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9d8-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"bath":{"id":"bath","name":"Bath","keywords":["person","taking","clean","shower","bathroom"],"skins":[{"unified":"1f6c0","native":"\uD83D\uDEC0"},{"unified":"1f6c0-1f3fb","native":"\uD83D\uDEC0\uD83C\uDFFB"},{"unified":"1f6c0-1f3fc","native":"\uD83D\uDEC0\uD83C\uDFFC"},{"unified":"1f6c0-1f3fd","native":"\uD83D\uDEC0\uD83C\uDFFD"},{"unified":"1f6c0-1f3fe","native":"\uD83D\uDEC0\uD83C\uDFFE"},{"unified":"1f6c0-1f3ff","native":"\uD83D\uDEC0\uD83C\uDFFF"}],"version":1},"sleeping_accommodation":{"id":"sleeping_accommodation","name":"Person in Bed","keywords":["sleeping","accommodation","rest"],"skins":[{"unified":"1f6cc","native":"\uD83D\uDECC"},{"unified":"1f6cc-1f3fb","native":"\uD83D\uDECC\uD83C\uDFFB"},{"unified":"1f6cc-1f3fc","native":"\uD83D\uDECC\uD83C\uDFFC"},{"unified":"1f6cc-1f3fd","native":"\uD83D\uDECC\uD83C\uDFFD"},{"unified":"1f6cc-1f3fe","native":"\uD83D\uDECC\uD83C\uDFFE"},{"unified":"1f6cc-1f3ff","native":"\uD83D\uDECC\uD83C\uDFFF"}],"version":1},"people_holding_hands":{"id":"people_holding_hands","name":"People Holding Hands","keywords":["friendship"],"skins":[{"unified":"1f9d1-200d-1f91d-200d-1f9d1","native":"\uD83E\uDDD1\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1"},{"unified":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"},{"unified":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"},{"unified":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"},{"unified":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"},{"unified":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"}],"version":12},"two_women_holding_hands":{"id":"two_women_holding_hands","name":"Women Holding Hands","keywords":["two","pair","friendship","couple","love","like","female","people","human"],"skins":[{"unified":"1f46d","native":"\uD83D\uDC6D"},{"unified":"1f46d-1f3fb","native":"\uD83D\uDC6D\uD83C\uDFFB"},{"unified":"1f46d-1f3fc","native":"\uD83D\uDC6D\uD83C\uDFFC"},{"unified":"1f46d-1f3fd","native":"\uD83D\uDC6D\uD83C\uDFFD"},{"unified":"1f46d-1f3fe","native":"\uD83D\uDC6D\uD83C\uDFFE"},{"unified":"1f46d-1f3ff","native":"\uD83D\uDC6D\uD83C\uDFFF"}],"version":1},"man_and_woman_holding_hands":{"id":"man_and_woman_holding_hands","name":"Man and Woman Holding Hands","keywords":["couple","pair","people","human","love","date","dating","like","affection","valentines","marriage"],"skins":[{"unified":"1f46b","native":"\uD83D\uDC6B"},{"unified":"1f46b-1f3fb","native":"\uD83D\uDC6B\uD83C\uDFFB"},{"unified":"1f46b-1f3fc","native":"\uD83D\uDC6B\uD83C\uDFFC"},{"unified":"1f46b-1f3fd","native":"\uD83D\uDC6B\uD83C\uDFFD"},{"unified":"1f46b-1f3fe","native":"\uD83D\uDC6B\uD83C\uDFFE"},{"unified":"1f46b-1f3ff","native":"\uD83D\uDC6B\uD83C\uDFFF"}],"version":1},"two_men_holding_hands":{"id":"two_men_holding_hands","name":"Men Holding Hands","keywords":["two","pair","couple","love","like","bromance","friendship","people","human"],"skins":[{"unified":"1f46c","native":"\uD83D\uDC6C"},{"unified":"1f46c-1f3fb","native":"\uD83D\uDC6C\uD83C\uDFFB"},{"unified":"1f46c-1f3fc","native":"\uD83D\uDC6C\uD83C\uDFFC"},{"unified":"1f46c-1f3fd","native":"\uD83D\uDC6C\uD83C\uDFFD"},{"unified":"1f46c-1f3fe","native":"\uD83D\uDC6C\uD83C\uDFFE"},{"unified":"1f46c-1f3ff","native":"\uD83D\uDC6C\uD83C\uDFFF"}],"version":1},"couplekiss":{"id":"couplekiss","name":"Kiss","keywords":["couplekiss","pair","valentines","love","like","dating","marriage"],"skins":[{"unified":"1f48f","native":"\uD83D\uDC8F"},{"unified":"1f48f-1f3fb","native":"\uD83D\uDC8F\uD83C\uDFFB"},{"unified":"1f48f-1f3fc","native":"\uD83D\uDC8F\uD83C\uDFFC"},{"unified":"1f48f-1f3fd","native":"\uD83D\uDC8F\uD83C\uDFFD"},{"unified":"1f48f-1f3fe","native":"\uD83D\uDC8F\uD83C\uDFFE"},{"unified":"1f48f-1f3ff","native":"\uD83D\uDC8F\uD83C\uDFFF"}],"version":1},"woman-kiss-man":{"id":"woman-kiss-man","name":"Kiss: Woman, Man","keywords":["woman","kiss-man","kiss","love"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f468","native":"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68"},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"}],"version":2},"man-kiss-man":{"id":"man-kiss-man","name":"Kiss: Man, Man","keywords":["kiss-man","kiss","pair","valentines","love","like","dating","marriage"],"skins":[{"unified":"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","native":"\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68"},{"unified":"1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"},{"unified":"1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"},{"unified":"1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"},{"unified":"1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"},{"unified":"1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"}],"version":2},"woman-kiss-woman":{"id":"woman-kiss-woman","name":"Kiss: Woman, Woman","keywords":["kiss-woman","kiss","pair","valentines","love","like","dating","marriage"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","native":"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69"},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"}],"version":2},"couple_with_heart":{"id":"couple_with_heart","name":"Couple with Heart","keywords":["pair","love","like","affection","human","dating","valentines","marriage"],"skins":[{"unified":"1f491","native":"\uD83D\uDC91"},{"unified":"1f491-1f3fb","native":"\uD83D\uDC91\uD83C\uDFFB"},{"unified":"1f491-1f3fc","native":"\uD83D\uDC91\uD83C\uDFFC"},{"unified":"1f491-1f3fd","native":"\uD83D\uDC91\uD83C\uDFFD"},{"unified":"1f491-1f3fe","native":"\uD83D\uDC91\uD83C\uDFFE"},{"unified":"1f491-1f3ff","native":"\uD83D\uDC91\uD83C\uDFFF"}],"version":1},"woman-heart-man":{"id":"woman-heart-man","name":"Couple with Heart: Woman, Man","keywords":["woman","heart-man","heart","love"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f468","native":"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68"},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"}],"version":2},"man-heart-man":{"id":"man-heart-man","name":"Couple with Heart: Man, Man","keywords":["heart-man","heart","pair","love","like","affection","human","dating","valentines","marriage"],"skins":[{"unified":"1f468-200d-2764-fe0f-200d-1f468","native":"\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68"},{"unified":"1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"},{"unified":"1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"},{"unified":"1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"},{"unified":"1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"},{"unified":"1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"}],"version":2},"woman-heart-woman":{"id":"woman-heart-woman","name":"Couple with Heart: Woman, Woman","keywords":["heart-woman","heart","pair","love","like","affection","human","dating","valentines","marriage"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f469","native":"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69"},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"}],"version":2},"family":{"id":"family","name":"Family","keywords":["home","parents","child","mom","dad","father","mother","people","human"],"skins":[{"unified":"1f46a","native":"\uD83D\uDC6A"}],"version":1},"man-woman-boy":{"id":"man-woman-boy","name":"Family: Man, Woman, Boy","keywords":["man","woman-boy","family","woman","love"],"skins":[{"unified":"1f468-200d-1f469-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66"}],"version":2},"man-woman-girl":{"id":"man-woman-girl","name":"Family: Man, Woman, Girl","keywords":["man","woman-girl","family","woman","home","parents","people","human","child"],"skins":[{"unified":"1f468-200d-1f469-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67"}],"version":2},"man-woman-girl-boy":{"id":"man-woman-girl-boy","name":"Family: Man, Woman, Girl, Boy","keywords":["man","woman-girl-boy","family","woman","girl","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f469-200d-1f467-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"}],"version":2},"man-woman-boy-boy":{"id":"man-woman-boy-boy","name":"Family: Man, Woman, Boy, Boy","keywords":["man","woman-boy-boy","family","woman","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f469-200d-1f466-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"}],"version":2},"man-woman-girl-girl":{"id":"man-woman-girl-girl","name":"Family: Man, Woman, Girl, Girl","keywords":["man","woman-girl-girl","family","woman","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f469-200d-1f467-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"}],"version":2},"man-man-boy":{"id":"man-man-boy","name":"Family: Man, Man, Boy","keywords":["man","man-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66"}],"version":2},"man-man-girl":{"id":"man-man-girl","name":"Family: Man, Man, Girl","keywords":["man","man-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67"}],"version":2},"man-man-girl-boy":{"id":"man-man-girl-boy","name":"Family: Man, Man, Girl, Boy","keywords":["man","man-girl-boy","family","girl","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f467-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66"}],"version":2},"man-man-boy-boy":{"id":"man-man-boy-boy","name":"Family: Man, Man, Boy, Boy","keywords":["man","man-boy-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f466-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66"}],"version":2},"man-man-girl-girl":{"id":"man-man-girl-girl","name":"Family: Man, Man, Girl, Girl","keywords":["man","man-girl-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f467-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67"}],"version":2},"woman-woman-boy":{"id":"woman-woman-boy","name":"Family: Woman, Woman, Boy","keywords":["woman","woman-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66"}],"version":2},"woman-woman-girl":{"id":"woman-woman-girl","name":"Family: Woman, Woman, Girl","keywords":["woman","woman-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f467","native":"\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67"}],"version":2},"woman-woman-girl-boy":{"id":"woman-woman-girl-boy","name":"Family: Woman, Woman, Girl, Boy","keywords":["woman","woman-girl-boy","family","girl","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f467-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"}],"version":2},"woman-woman-boy-boy":{"id":"woman-woman-boy-boy","name":"Family: Woman, Woman, Boy, Boy","keywords":["woman","woman-boy-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f466-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"}],"version":2},"woman-woman-girl-girl":{"id":"woman-woman-girl-girl","name":"Family: Woman, Woman, Girl, Girl","keywords":["woman","woman-girl-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f467-200d-1f467","native":"\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"}],"version":2},"man-boy":{"id":"man-boy","name":"Family: Man, Boy","keywords":["man","family","home","parent","people","human","child"],"skins":[{"unified":"1f468-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC66"}],"version":4},"man-boy-boy":{"id":"man-boy-boy","name":"Family: Man, Boy, Boy","keywords":["man","boy-boy","family","home","parent","people","human","children"],"skins":[{"unified":"1f468-200d-1f466-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66"}],"version":4},"man-girl":{"id":"man-girl","name":"Family: Man, Girl","keywords":["man","family","home","parent","people","human","child"],"skins":[{"unified":"1f468-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC67"}],"version":4},"man-girl-boy":{"id":"man-girl-boy","name":"Family: Man, Girl, Boy","keywords":["man","girl-boy","family","girl","home","parent","people","human","children"],"skins":[{"unified":"1f468-200d-1f467-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66"}],"version":4},"man-girl-girl":{"id":"man-girl-girl","name":"Family: Man, Girl, Girl","keywords":["man","girl-girl","family","home","parent","people","human","children"],"skins":[{"unified":"1f468-200d-1f467-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67"}],"version":4},"woman-boy":{"id":"woman-boy","name":"Family: Woman, Boy","keywords":["woman","family","home","parent","people","human","child"],"skins":[{"unified":"1f469-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC66"}],"version":4},"woman-boy-boy":{"id":"woman-boy-boy","name":"Family: Woman, Boy, Boy","keywords":["woman","boy-boy","family","home","parent","people","human","children"],"skins":[{"unified":"1f469-200d-1f466-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"}],"version":4},"woman-girl":{"id":"woman-girl","name":"Family: Woman, Girl","keywords":["woman","family","home","parent","people","human","child"],"skins":[{"unified":"1f469-200d-1f467","native":"\uD83D\uDC69\u200D\uD83D\uDC67"}],"version":4},"woman-girl-boy":{"id":"woman-girl-boy","name":"Family: Woman, Girl, Boy","keywords":["woman","girl-boy","family","girl","home","parent","people","human","children"],"skins":[{"unified":"1f469-200d-1f467-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"}],"version":4},"woman-girl-girl":{"id":"woman-girl-girl","name":"Family: Woman, Girl, Girl","keywords":["woman","girl-girl","family","home","parent","people","human","children"],"skins":[{"unified":"1f469-200d-1f467-200d-1f467","native":"\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"}],"version":4},"speaking_head_in_silhouette":{"id":"speaking_head_in_silhouette","name":"Speaking Head","keywords":["in","silhouette","user","person","human","sing","say","talk"],"skins":[{"unified":"1f5e3-fe0f","native":"\uD83D\uDDE3\uFE0F"}],"version":1},"bust_in_silhouette":{"id":"bust_in_silhouette","name":"Bust in Silhouette","keywords":["user","person","human"],"skins":[{"unified":"1f464","native":"\uD83D\uDC64"}],"version":1},"busts_in_silhouette":{"id":"busts_in_silhouette","name":"Busts in Silhouette","keywords":["user","person","human","group","team"],"skins":[{"unified":"1f465","native":"\uD83D\uDC65"}],"version":1},"people_hugging":{"id":"people_hugging","name":"People Hugging","keywords":["care"],"skins":[{"unified":"1fac2","native":"\uD83E\uDEC2"}],"version":13},"footprints":{"id":"footprints","name":"Footprints","keywords":["feet","tracking","walking","beach"],"skins":[{"unified":"1f463","native":"\uD83D\uDC63"}],"version":1},"monkey_face":{"id":"monkey_face","name":"Monkey Face","emoticons":[":o)"],"keywords":["animal","nature","circus"],"skins":[{"unified":"1f435","native":"\uD83D\uDC35"}],"version":1},"monkey":{"id":"monkey","name":"Monkey","keywords":["animal","nature","banana","circus"],"skins":[{"unified":"1f412","native":"\uD83D\uDC12"}],"version":1},"gorilla":{"id":"gorilla","name":"Gorilla","keywords":["animal","nature","circus"],"skins":[{"unified":"1f98d","native":"\uD83E\uDD8D"}],"version":3},"orangutan":{"id":"orangutan","name":"Orangutan","keywords":["animal"],"skins":[{"unified":"1f9a7","native":"\uD83E\uDDA7"}],"version":12},"dog":{"id":"dog","name":"Dog Face","keywords":["animal","friend","nature","woof","puppy","pet","faithful"],"skins":[{"unified":"1f436","native":"\uD83D\uDC36"}],"version":1},"dog2":{"id":"dog2","name":"Dog","keywords":["dog2","animal","nature","friend","doge","pet","faithful"],"skins":[{"unified":"1f415","native":"\uD83D\uDC15"}],"version":1},"guide_dog":{"id":"guide_dog","name":"Guide Dog","keywords":["animal","blind"],"skins":[{"unified":"1f9ae","native":"\uD83E\uDDAE"}],"version":12},"service_dog":{"id":"service_dog","name":"Service Dog","keywords":["blind","animal"],"skins":[{"unified":"1f415-200d-1f9ba","native":"\uD83D\uDC15\u200D\uD83E\uDDBA"}],"version":12},"poodle":{"id":"poodle","name":"Poodle","keywords":["dog","animal","101","nature","pet"],"skins":[{"unified":"1f429","native":"\uD83D\uDC29"}],"version":1},"wolf":{"id":"wolf","name":"Wolf","keywords":["animal","nature","wild"],"skins":[{"unified":"1f43a","native":"\uD83D\uDC3A"}],"version":1},"fox_face":{"id":"fox_face","name":"Fox","keywords":["face","animal","nature"],"skins":[{"unified":"1f98a","native":"\uD83E\uDD8A"}],"version":3},"raccoon":{"id":"raccoon","name":"Raccoon","keywords":["animal","nature"],"skins":[{"unified":"1f99d","native":"\uD83E\uDD9D"}],"version":11},"cat":{"id":"cat","name":"Cat Face","keywords":["animal","meow","nature","pet","kitten"],"skins":[{"unified":"1f431","native":"\uD83D\uDC31"}],"version":1},"cat2":{"id":"cat2","name":"Cat","keywords":["cat2","animal","meow","pet","cats"],"skins":[{"unified":"1f408","native":"\uD83D\uDC08"}],"version":1},"black_cat":{"id":"black_cat","name":"Black Cat","keywords":["superstition","luck"],"skins":[{"unified":"1f408-200d-2b1b","native":"\uD83D\uDC08\u200D\u2B1B"}],"version":13},"lion_face":{"id":"lion_face","name":"Lion","keywords":["face","animal","nature"],"skins":[{"unified":"1f981","native":"\uD83E\uDD81"}],"version":1},"tiger":{"id":"tiger","name":"Tiger Face","keywords":["animal","cat","danger","wild","nature","roar"],"skins":[{"unified":"1f42f","native":"\uD83D\uDC2F"}],"version":1},"tiger2":{"id":"tiger2","name":"Tiger","keywords":["tiger2","animal","nature","roar"],"skins":[{"unified":"1f405","native":"\uD83D\uDC05"}],"version":1},"leopard":{"id":"leopard","name":"Leopard","keywords":["animal","nature"],"skins":[{"unified":"1f406","native":"\uD83D\uDC06"}],"version":1},"horse":{"id":"horse","name":"Horse Face","keywords":["animal","brown","nature"],"skins":[{"unified":"1f434","native":"\uD83D\uDC34"}],"version":1},"moose":{"id":"moose","name":"Moose","keywords":["shrek","canada","sweden","sven","cool"],"skins":[{"unified":"1face","native":"\uD83E\uDECE"}],"version":15},"donkey":{"id":"donkey","name":"Donkey","keywords":["eeyore","mule"],"skins":[{"unified":"1facf","native":"\uD83E\uDECF"}],"version":15},"racehorse":{"id":"racehorse","name":"Horse","keywords":["racehorse","animal","gamble","luck"],"skins":[{"unified":"1f40e","native":"\uD83D\uDC0E"}],"version":1},"unicorn_face":{"id":"unicorn_face","name":"Unicorn","keywords":["face","animal","nature","mystical"],"skins":[{"unified":"1f984","native":"\uD83E\uDD84"}],"version":1},"zebra_face":{"id":"zebra_face","name":"Zebra","keywords":["face","animal","nature","stripes","safari"],"skins":[{"unified":"1f993","native":"\uD83E\uDD93"}],"version":5},"deer":{"id":"deer","name":"Deer","keywords":["animal","nature","horns","venison"],"skins":[{"unified":"1f98c","native":"\uD83E\uDD8C"}],"version":3},"bison":{"id":"bison","name":"Bison","keywords":["ox"],"skins":[{"unified":"1f9ac","native":"\uD83E\uDDAC"}],"version":13},"cow":{"id":"cow","name":"Cow Face","keywords":["beef","ox","animal","nature","moo","milk"],"skins":[{"unified":"1f42e","native":"\uD83D\uDC2E"}],"version":1},"ox":{"id":"ox","name":"Ox","keywords":["animal","cow","beef"],"skins":[{"unified":"1f402","native":"\uD83D\uDC02"}],"version":1},"water_buffalo":{"id":"water_buffalo","name":"Water Buffalo","keywords":["animal","nature","ox","cow"],"skins":[{"unified":"1f403","native":"\uD83D\uDC03"}],"version":1},"cow2":{"id":"cow2","name":"Cow","keywords":["cow2","beef","ox","animal","nature","moo","milk"],"skins":[{"unified":"1f404","native":"\uD83D\uDC04"}],"version":1},"pig":{"id":"pig","name":"Pig Face","keywords":["animal","oink","nature"],"skins":[{"unified":"1f437","native":"\uD83D\uDC37"}],"version":1},"pig2":{"id":"pig2","name":"Pig","keywords":["pig2","animal","nature"],"skins":[{"unified":"1f416","native":"\uD83D\uDC16"}],"version":1},"boar":{"id":"boar","name":"Boar","keywords":["animal","nature"],"skins":[{"unified":"1f417","native":"\uD83D\uDC17"}],"version":1},"pig_nose":{"id":"pig_nose","name":"Pig Nose","keywords":["animal","oink"],"skins":[{"unified":"1f43d","native":"\uD83D\uDC3D"}],"version":1},"ram":{"id":"ram","name":"Ram","keywords":["animal","sheep","nature"],"skins":[{"unified":"1f40f","native":"\uD83D\uDC0F"}],"version":1},"sheep":{"id":"sheep","name":"Ewe","keywords":["sheep","animal","nature","wool","shipit"],"skins":[{"unified":"1f411","native":"\uD83D\uDC11"}],"version":1},"goat":{"id":"goat","name":"Goat","keywords":["animal","nature"],"skins":[{"unified":"1f410","native":"\uD83D\uDC10"}],"version":1},"dromedary_camel":{"id":"dromedary_camel","name":"Camel","keywords":["dromedary","animal","hot","desert","hump"],"skins":[{"unified":"1f42a","native":"\uD83D\uDC2A"}],"version":1},"camel":{"id":"camel","name":"Bactrian Camel","keywords":["two","hump","animal","nature","hot","desert"],"skins":[{"unified":"1f42b","native":"\uD83D\uDC2B"}],"version":1},"llama":{"id":"llama","name":"Llama","keywords":["animal","nature","alpaca"],"skins":[{"unified":"1f999","native":"\uD83E\uDD99"}],"version":11},"giraffe_face":{"id":"giraffe_face","name":"Giraffe","keywords":["face","animal","nature","spots","safari"],"skins":[{"unified":"1f992","native":"\uD83E\uDD92"}],"version":5},"elephant":{"id":"elephant","name":"Elephant","keywords":["animal","nature","nose","th","circus"],"skins":[{"unified":"1f418","native":"\uD83D\uDC18"}],"version":1},"mammoth":{"id":"mammoth","name":"Mammoth","keywords":["elephant","tusks"],"skins":[{"unified":"1f9a3","native":"\uD83E\uDDA3"}],"version":13},"rhinoceros":{"id":"rhinoceros","name":"Rhinoceros","keywords":["animal","nature","horn"],"skins":[{"unified":"1f98f","native":"\uD83E\uDD8F"}],"version":3},"hippopotamus":{"id":"hippopotamus","name":"Hippopotamus","keywords":["animal","nature"],"skins":[{"unified":"1f99b","native":"\uD83E\uDD9B"}],"version":11},"mouse":{"id":"mouse","name":"Mouse Face","keywords":["animal","nature","cheese","wedge","rodent"],"skins":[{"unified":"1f42d","native":"\uD83D\uDC2D"}],"version":1},"mouse2":{"id":"mouse2","name":"Mouse","keywords":["mouse2","animal","nature","rodent"],"skins":[{"unified":"1f401","native":"\uD83D\uDC01"}],"version":1},"rat":{"id":"rat","name":"Rat","keywords":["animal","mouse","rodent"],"skins":[{"unified":"1f400","native":"\uD83D\uDC00"}],"version":1},"hamster":{"id":"hamster","name":"Hamster","keywords":["animal","nature"],"skins":[{"unified":"1f439","native":"\uD83D\uDC39"}],"version":1},"rabbit":{"id":"rabbit","name":"Rabbit Face","keywords":["animal","nature","pet","spring","magic","bunny"],"skins":[{"unified":"1f430","native":"\uD83D\uDC30"}],"version":1},"rabbit2":{"id":"rabbit2","name":"Rabbit","keywords":["rabbit2","animal","nature","pet","magic","spring"],"skins":[{"unified":"1f407","native":"\uD83D\uDC07"}],"version":1},"chipmunk":{"id":"chipmunk","name":"Chipmunk","keywords":["animal","nature","rodent","squirrel"],"skins":[{"unified":"1f43f-fe0f","native":"\uD83D\uDC3F\uFE0F"}],"version":1},"beaver":{"id":"beaver","name":"Beaver","keywords":["animal","rodent"],"skins":[{"unified":"1f9ab","native":"\uD83E\uDDAB"}],"version":13},"hedgehog":{"id":"hedgehog","name":"Hedgehog","keywords":["animal","nature","spiny"],"skins":[{"unified":"1f994","native":"\uD83E\uDD94"}],"version":5},"bat":{"id":"bat","name":"Bat","keywords":["animal","nature","blind","vampire"],"skins":[{"unified":"1f987","native":"\uD83E\uDD87"}],"version":3},"bear":{"id":"bear","name":"Bear","keywords":["animal","nature","wild"],"skins":[{"unified":"1f43b","native":"\uD83D\uDC3B"}],"version":1},"polar_bear":{"id":"polar_bear","name":"Polar Bear","keywords":["animal","arctic"],"skins":[{"unified":"1f43b-200d-2744-fe0f","native":"\uD83D\uDC3B\u200D\u2744\uFE0F"}],"version":13},"koala":{"id":"koala","name":"Koala","keywords":["animal","nature"],"skins":[{"unified":"1f428","native":"\uD83D\uDC28"}],"version":1},"panda_face":{"id":"panda_face","name":"Panda","keywords":["face","animal","nature"],"skins":[{"unified":"1f43c","native":"\uD83D\uDC3C"}],"version":1},"sloth":{"id":"sloth","name":"Sloth","keywords":["animal"],"skins":[{"unified":"1f9a5","native":"\uD83E\uDDA5"}],"version":12},"otter":{"id":"otter","name":"Otter","keywords":["animal"],"skins":[{"unified":"1f9a6","native":"\uD83E\uDDA6"}],"version":12},"skunk":{"id":"skunk","name":"Skunk","keywords":["animal"],"skins":[{"unified":"1f9a8","native":"\uD83E\uDDA8"}],"version":12},"kangaroo":{"id":"kangaroo","name":"Kangaroo","keywords":["animal","nature","australia","joey","hop","marsupial"],"skins":[{"unified":"1f998","native":"\uD83E\uDD98"}],"version":11},"badger":{"id":"badger","name":"Badger","keywords":["animal","nature","honey"],"skins":[{"unified":"1f9a1","native":"\uD83E\uDDA1"}],"version":11},"feet":{"id":"feet","name":"Paw Prints","keywords":["feet","animal","tracking","footprints","dog","cat","pet"],"skins":[{"unified":"1f43e","native":"\uD83D\uDC3E"}],"version":1},"turkey":{"id":"turkey","name":"Turkey","keywords":["animal","bird"],"skins":[{"unified":"1f983","native":"\uD83E\uDD83"}],"version":1},"chicken":{"id":"chicken","name":"Chicken","keywords":["animal","cluck","nature","bird"],"skins":[{"unified":"1f414","native":"\uD83D\uDC14"}],"version":1},"rooster":{"id":"rooster","name":"Rooster","keywords":["animal","nature","chicken"],"skins":[{"unified":"1f413","native":"\uD83D\uDC13"}],"version":1},"hatching_chick":{"id":"hatching_chick","name":"Hatching Chick","keywords":["animal","chicken","egg","born","baby","bird"],"skins":[{"unified":"1f423","native":"\uD83D\uDC23"}],"version":1},"baby_chick":{"id":"baby_chick","name":"Baby Chick","keywords":["animal","chicken","bird"],"skins":[{"unified":"1f424","native":"\uD83D\uDC24"}],"version":1},"hatched_chick":{"id":"hatched_chick","name":"Front-Facing Baby Chick","keywords":["hatched","front","facing","animal","chicken","bird"],"skins":[{"unified":"1f425","native":"\uD83D\uDC25"}],"version":1},"bird":{"id":"bird","name":"Bird","keywords":["animal","nature","fly","tweet","spring"],"skins":[{"unified":"1f426","native":"\uD83D\uDC26"}],"version":1},"penguin":{"id":"penguin","name":"Penguin","keywords":["animal","nature"],"skins":[{"unified":"1f427","native":"\uD83D\uDC27"}],"version":1},"dove_of_peace":{"id":"dove_of_peace","name":"Dove","keywords":["of","peace","animal","bird"],"skins":[{"unified":"1f54a-fe0f","native":"\uD83D\uDD4A\uFE0F"}],"version":1},"eagle":{"id":"eagle","name":"Eagle","keywords":["animal","nature","bird"],"skins":[{"unified":"1f985","native":"\uD83E\uDD85"}],"version":3},"duck":{"id":"duck","name":"Duck","keywords":["animal","nature","bird","mallard"],"skins":[{"unified":"1f986","native":"\uD83E\uDD86"}],"version":3},"swan":{"id":"swan","name":"Swan","keywords":["animal","nature","bird"],"skins":[{"unified":"1f9a2","native":"\uD83E\uDDA2"}],"version":11},"owl":{"id":"owl","name":"Owl","keywords":["animal","nature","bird","hoot"],"skins":[{"unified":"1f989","native":"\uD83E\uDD89"}],"version":3},"dodo":{"id":"dodo","name":"Dodo","keywords":["animal","bird"],"skins":[{"unified":"1f9a4","native":"\uD83E\uDDA4"}],"version":13},"feather":{"id":"feather","name":"Feather","keywords":["bird","fly"],"skins":[{"unified":"1fab6","native":"\uD83E\uDEB6"}],"version":13},"flamingo":{"id":"flamingo","name":"Flamingo","keywords":["animal"],"skins":[{"unified":"1f9a9","native":"\uD83E\uDDA9"}],"version":12},"peacock":{"id":"peacock","name":"Peacock","keywords":["animal","nature","peahen","bird"],"skins":[{"unified":"1f99a","native":"\uD83E\uDD9A"}],"version":11},"parrot":{"id":"parrot","name":"Parrot","keywords":["animal","nature","bird","pirate","talk"],"skins":[{"unified":"1f99c","native":"\uD83E\uDD9C"}],"version":11},"wing":{"id":"wing","name":"Wing","keywords":["angel","birds","flying"],"skins":[{"unified":"1fabd","native":"\uD83E\uDEBD"}],"version":15},"black_bird":{"id":"black_bird","name":"Black Bird","keywords":["crow"],"skins":[{"unified":"1f426-200d-2b1b","native":"\uD83D\uDC26\u200D\u2B1B"}],"version":15},"goose":{"id":"goose","name":"Goose","keywords":["silly","jemima","goosebumps"],"skins":[{"unified":"1fabf","native":"\uD83E\uDEBF"}],"version":15},"frog":{"id":"frog","name":"Frog","keywords":["animal","nature","croak","toad"],"skins":[{"unified":"1f438","native":"\uD83D\uDC38"}],"version":1},"crocodile":{"id":"crocodile","name":"Crocodile","keywords":["animal","nature","reptile","lizard","alligator"],"skins":[{"unified":"1f40a","native":"\uD83D\uDC0A"}],"version":1},"turtle":{"id":"turtle","name":"Turtle","keywords":["animal","slow","nature","tortoise"],"skins":[{"unified":"1f422","native":"\uD83D\uDC22"}],"version":1},"lizard":{"id":"lizard","name":"Lizard","keywords":["animal","nature","reptile"],"skins":[{"unified":"1f98e","native":"\uD83E\uDD8E"}],"version":3},"snake":{"id":"snake","name":"Snake","keywords":["animal","evil","nature","hiss","python"],"skins":[{"unified":"1f40d","native":"\uD83D\uDC0D"}],"version":1},"dragon_face":{"id":"dragon_face","name":"Dragon Face","keywords":["animal","myth","nature","chinese","green"],"skins":[{"unified":"1f432","native":"\uD83D\uDC32"}],"version":1},"dragon":{"id":"dragon","name":"Dragon","keywords":["animal","myth","nature","chinese","green"],"skins":[{"unified":"1f409","native":"\uD83D\uDC09"}],"version":1},"sauropod":{"id":"sauropod","name":"Sauropod","keywords":["animal","nature","dinosaur","brachiosaurus","brontosaurus","diplodocus","extinct"],"skins":[{"unified":"1f995","native":"\uD83E\uDD95"}],"version":5},"t-rex":{"id":"t-rex","name":"T-Rex","keywords":["t","rex","animal","nature","dinosaur","tyrannosaurus","extinct"],"skins":[{"unified":"1f996","native":"\uD83E\uDD96"}],"version":5},"whale":{"id":"whale","name":"Spouting Whale","keywords":["animal","nature","sea","ocean"],"skins":[{"unified":"1f433","native":"\uD83D\uDC33"}],"version":1},"whale2":{"id":"whale2","name":"Whale","keywords":["whale2","animal","nature","sea","ocean"],"skins":[{"unified":"1f40b","native":"\uD83D\uDC0B"}],"version":1},"dolphin":{"id":"dolphin","name":"Dolphin","keywords":["flipper","animal","nature","fish","sea","ocean","fins","beach"],"skins":[{"unified":"1f42c","native":"\uD83D\uDC2C"}],"version":1},"seal":{"id":"seal","name":"Seal","keywords":["animal","creature","sea"],"skins":[{"unified":"1f9ad","native":"\uD83E\uDDAD"}],"version":13},"fish":{"id":"fish","name":"Fish","keywords":["animal","food","nature"],"skins":[{"unified":"1f41f","native":"\uD83D\uDC1F"}],"version":1},"tropical_fish":{"id":"tropical_fish","name":"Tropical Fish","keywords":["animal","swim","ocean","beach","nemo"],"skins":[{"unified":"1f420","native":"\uD83D\uDC20"}],"version":1},"blowfish":{"id":"blowfish","name":"Blowfish","keywords":["animal","nature","food","sea","ocean"],"skins":[{"unified":"1f421","native":"\uD83D\uDC21"}],"version":1},"shark":{"id":"shark","name":"Shark","keywords":["animal","nature","fish","sea","ocean","jaws","fins","beach"],"skins":[{"unified":"1f988","native":"\uD83E\uDD88"}],"version":3},"octopus":{"id":"octopus","name":"Octopus","keywords":["animal","creature","ocean","sea","nature","beach"],"skins":[{"unified":"1f419","native":"\uD83D\uDC19"}],"version":1},"shell":{"id":"shell","name":"Spiral Shell","keywords":["nature","sea","beach"],"skins":[{"unified":"1f41a","native":"\uD83D\uDC1A"}],"version":1},"coral":{"id":"coral","name":"Coral","keywords":["ocean","sea","reef"],"skins":[{"unified":"1fab8","native":"\uD83E\uDEB8"}],"version":14},"jellyfish":{"id":"jellyfish","name":"Jellyfish","keywords":["sting","tentacles"],"skins":[{"unified":"1fabc","native":"\uD83E\uDEBC"}],"version":15},"snail":{"id":"snail","name":"Snail","keywords":["slow","animal","shell"],"skins":[{"unified":"1f40c","native":"\uD83D\uDC0C"}],"version":1},"butterfly":{"id":"butterfly","name":"Butterfly","keywords":["animal","insect","nature","caterpillar"],"skins":[{"unified":"1f98b","native":"\uD83E\uDD8B"}],"version":3},"bug":{"id":"bug","name":"Bug","keywords":["animal","insect","nature","worm"],"skins":[{"unified":"1f41b","native":"\uD83D\uDC1B"}],"version":1},"ant":{"id":"ant","name":"Ant","keywords":["animal","insect","nature","bug"],"skins":[{"unified":"1f41c","native":"\uD83D\uDC1C"}],"version":1},"bee":{"id":"bee","name":"Honeybee","keywords":["bee","animal","insect","nature","bug","spring","honey"],"skins":[{"unified":"1f41d","native":"\uD83D\uDC1D"}],"version":1},"beetle":{"id":"beetle","name":"Beetle","keywords":["insect"],"skins":[{"unified":"1fab2","native":"\uD83E\uDEB2"}],"version":13},"ladybug":{"id":"ladybug","name":"Lady Beetle","keywords":["ladybug","animal","insect","nature"],"skins":[{"unified":"1f41e","native":"\uD83D\uDC1E"}],"version":1},"cricket":{"id":"cricket","name":"Cricket","keywords":["animal","chirp"],"skins":[{"unified":"1f997","native":"\uD83E\uDD97"}],"version":5},"cockroach":{"id":"cockroach","name":"Cockroach","keywords":["insect","pests"],"skins":[{"unified":"1fab3","native":"\uD83E\uDEB3"}],"version":13},"spider":{"id":"spider","name":"Spider","keywords":["animal","arachnid"],"skins":[{"unified":"1f577-fe0f","native":"\uD83D\uDD77\uFE0F"}],"version":1},"spider_web":{"id":"spider_web","name":"Spider Web","keywords":["animal","insect","arachnid","silk"],"skins":[{"unified":"1f578-fe0f","native":"\uD83D\uDD78\uFE0F"}],"version":1},"scorpion":{"id":"scorpion","name":"Scorpion","keywords":["animal","arachnid"],"skins":[{"unified":"1f982","native":"\uD83E\uDD82"}],"version":1},"mosquito":{"id":"mosquito","name":"Mosquito","keywords":["animal","nature","insect","malaria"],"skins":[{"unified":"1f99f","native":"\uD83E\uDD9F"}],"version":11},"fly":{"id":"fly","name":"Fly","keywords":["insect"],"skins":[{"unified":"1fab0","native":"\uD83E\uDEB0"}],"version":13},"worm":{"id":"worm","name":"Worm","keywords":["animal"],"skins":[{"unified":"1fab1","native":"\uD83E\uDEB1"}],"version":13},"microbe":{"id":"microbe","name":"Microbe","keywords":["amoeba","bacteria","germs","virus","covid"],"skins":[{"unified":"1f9a0","native":"\uD83E\uDDA0"}],"version":11},"bouquet":{"id":"bouquet","name":"Bouquet","keywords":["flowers","nature","spring"],"skins":[{"unified":"1f490","native":"\uD83D\uDC90"}],"version":1},"cherry_blossom":{"id":"cherry_blossom","name":"Cherry Blossom","keywords":["nature","plant","spring","flower"],"skins":[{"unified":"1f338","native":"\uD83C\uDF38"}],"version":1},"white_flower":{"id":"white_flower","name":"White Flower","keywords":["japanese","spring"],"skins":[{"unified":"1f4ae","native":"\uD83D\uDCAE"}],"version":1},"lotus":{"id":"lotus","name":"Lotus","keywords":["flower","calm","meditation"],"skins":[{"unified":"1fab7","native":"\uD83E\uDEB7"}],"version":14},"rosette":{"id":"rosette","name":"Rosette","keywords":["flower","decoration","military"],"skins":[{"unified":"1f3f5-fe0f","native":"\uD83C\uDFF5\uFE0F"}],"version":1},"rose":{"id":"rose","name":"Rose","keywords":["flowers","valentines","love","spring"],"skins":[{"unified":"1f339","native":"\uD83C\uDF39"}],"version":1},"wilted_flower":{"id":"wilted_flower","name":"Wilted Flower","keywords":["plant","nature","rose"],"skins":[{"unified":"1f940","native":"\uD83E\uDD40"}],"version":3},"hibiscus":{"id":"hibiscus","name":"Hibiscus","keywords":["plant","vegetable","flowers","beach"],"skins":[{"unified":"1f33a","native":"\uD83C\uDF3A"}],"version":1},"sunflower":{"id":"sunflower","name":"Sunflower","keywords":["nature","plant","fall"],"skins":[{"unified":"1f33b","native":"\uD83C\uDF3B"}],"version":1},"blossom":{"id":"blossom","name":"Blossom","keywords":["nature","flowers","yellow"],"skins":[{"unified":"1f33c","native":"\uD83C\uDF3C"}],"version":1},"tulip":{"id":"tulip","name":"Tulip","keywords":["flowers","plant","nature","summer","spring"],"skins":[{"unified":"1f337","native":"\uD83C\uDF37"}],"version":1},"hyacinth":{"id":"hyacinth","name":"Hyacinth","keywords":["flower","lavender"],"skins":[{"unified":"1fabb","native":"\uD83E\uDEBB"}],"version":15},"seedling":{"id":"seedling","name":"Seedling","keywords":["plant","nature","grass","lawn","spring"],"skins":[{"unified":"1f331","native":"\uD83C\uDF31"}],"version":1},"potted_plant":{"id":"potted_plant","name":"Potted Plant","keywords":["greenery","house"],"skins":[{"unified":"1fab4","native":"\uD83E\uDEB4"}],"version":13},"evergreen_tree":{"id":"evergreen_tree","name":"Evergreen Tree","keywords":["plant","nature"],"skins":[{"unified":"1f332","native":"\uD83C\uDF32"}],"version":1},"deciduous_tree":{"id":"deciduous_tree","name":"Deciduous Tree","keywords":["plant","nature"],"skins":[{"unified":"1f333","native":"\uD83C\uDF33"}],"version":1},"palm_tree":{"id":"palm_tree","name":"Palm Tree","keywords":["plant","vegetable","nature","summer","beach","mojito","tropical"],"skins":[{"unified":"1f334","native":"\uD83C\uDF34"}],"version":1},"cactus":{"id":"cactus","name":"Cactus","keywords":["vegetable","plant","nature"],"skins":[{"unified":"1f335","native":"\uD83C\uDF35"}],"version":1},"ear_of_rice":{"id":"ear_of_rice","name":"Ear of Rice","keywords":["sheaf","nature","plant"],"skins":[{"unified":"1f33e","native":"\uD83C\uDF3E"}],"version":1},"herb":{"id":"herb","name":"Herb","keywords":["vegetable","plant","medicine","weed","grass","lawn"],"skins":[{"unified":"1f33f","native":"\uD83C\uDF3F"}],"version":1},"shamrock":{"id":"shamrock","name":"Shamrock","keywords":["vegetable","plant","nature","irish","clover"],"skins":[{"unified":"2618-fe0f","native":"\u2618\uFE0F"}],"version":1},"four_leaf_clover":{"id":"four_leaf_clover","name":"Four Leaf Clover","keywords":["vegetable","plant","nature","lucky","irish"],"skins":[{"unified":"1f340","native":"\uD83C\uDF40"}],"version":1},"maple_leaf":{"id":"maple_leaf","name":"Maple Leaf","keywords":["nature","plant","vegetable","ca","fall"],"skins":[{"unified":"1f341","native":"\uD83C\uDF41"}],"version":1},"fallen_leaf":{"id":"fallen_leaf","name":"Fallen Leaf","keywords":["nature","plant","vegetable","leaves"],"skins":[{"unified":"1f342","native":"\uD83C\uDF42"}],"version":1},"leaves":{"id":"leaves","name":"Leaf Fluttering in Wind","keywords":["leaves","nature","plant","tree","vegetable","grass","lawn","spring"],"skins":[{"unified":"1f343","native":"\uD83C\uDF43"}],"version":1},"empty_nest":{"id":"empty_nest","name":"Empty Nest","keywords":["bird"],"skins":[{"unified":"1fab9","native":"\uD83E\uDEB9"}],"version":14},"nest_with_eggs":{"id":"nest_with_eggs","name":"Nest with Eggs","keywords":["bird"],"skins":[{"unified":"1faba","native":"\uD83E\uDEBA"}],"version":14},"mushroom":{"id":"mushroom","name":"Mushroom","keywords":["plant","vegetable"],"skins":[{"unified":"1f344","native":"\uD83C\uDF44"}],"version":1},"grapes":{"id":"grapes","name":"Grapes","keywords":["fruit","food","wine"],"skins":[{"unified":"1f347","native":"\uD83C\uDF47"}],"version":1},"melon":{"id":"melon","name":"Melon","keywords":["fruit","nature","food"],"skins":[{"unified":"1f348","native":"\uD83C\uDF48"}],"version":1},"watermelon":{"id":"watermelon","name":"Watermelon","keywords":["fruit","food","picnic","summer"],"skins":[{"unified":"1f349","native":"\uD83C\uDF49"}],"version":1},"tangerine":{"id":"tangerine","name":"Tangerine","keywords":["food","fruit","nature","orange"],"skins":[{"unified":"1f34a","native":"\uD83C\uDF4A"}],"version":1},"lemon":{"id":"lemon","name":"Lemon","keywords":["fruit","nature"],"skins":[{"unified":"1f34b","native":"\uD83C\uDF4B"}],"version":1},"banana":{"id":"banana","name":"Banana","keywords":["fruit","food","monkey"],"skins":[{"unified":"1f34c","native":"\uD83C\uDF4C"}],"version":1},"pineapple":{"id":"pineapple","name":"Pineapple","keywords":["fruit","nature","food"],"skins":[{"unified":"1f34d","native":"\uD83C\uDF4D"}],"version":1},"mango":{"id":"mango","name":"Mango","keywords":["fruit","food","tropical"],"skins":[{"unified":"1f96d","native":"\uD83E\uDD6D"}],"version":11},"apple":{"id":"apple","name":"Red Apple","keywords":["fruit","mac","school"],"skins":[{"unified":"1f34e","native":"\uD83C\uDF4E"}],"version":1},"green_apple":{"id":"green_apple","name":"Green Apple","keywords":["fruit","nature"],"skins":[{"unified":"1f34f","native":"\uD83C\uDF4F"}],"version":1},"pear":{"id":"pear","name":"Pear","keywords":["fruit","nature","food"],"skins":[{"unified":"1f350","native":"\uD83C\uDF50"}],"version":1},"peach":{"id":"peach","name":"Peach","keywords":["fruit","nature","food"],"skins":[{"unified":"1f351","native":"\uD83C\uDF51"}],"version":1},"cherries":{"id":"cherries","name":"Cherries","keywords":["food","fruit"],"skins":[{"unified":"1f352","native":"\uD83C\uDF52"}],"version":1},"strawberry":{"id":"strawberry","name":"Strawberry","keywords":["fruit","food","nature"],"skins":[{"unified":"1f353","native":"\uD83C\uDF53"}],"version":1},"blueberries":{"id":"blueberries","name":"Blueberries","keywords":["fruit"],"skins":[{"unified":"1fad0","native":"\uD83E\uDED0"}],"version":13},"kiwifruit":{"id":"kiwifruit","name":"Kiwifruit","keywords":["kiwi","fruit","food"],"skins":[{"unified":"1f95d","native":"\uD83E\uDD5D"}],"version":3},"tomato":{"id":"tomato","name":"Tomato","keywords":["fruit","vegetable","nature","food"],"skins":[{"unified":"1f345","native":"\uD83C\uDF45"}],"version":1},"olive":{"id":"olive","name":"Olive","keywords":["fruit"],"skins":[{"unified":"1fad2","native":"\uD83E\uDED2"}],"version":13},"coconut":{"id":"coconut","name":"Coconut","keywords":["fruit","nature","food","palm"],"skins":[{"unified":"1f965","native":"\uD83E\uDD65"}],"version":5},"avocado":{"id":"avocado","name":"Avocado","keywords":["fruit","food"],"skins":[{"unified":"1f951","native":"\uD83E\uDD51"}],"version":3},"eggplant":{"id":"eggplant","name":"Eggplant","keywords":["vegetable","nature","food","aubergine"],"skins":[{"unified":"1f346","native":"\uD83C\uDF46"}],"version":1},"potato":{"id":"potato","name":"Potato","keywords":["food","tuber","vegatable","starch"],"skins":[{"unified":"1f954","native":"\uD83E\uDD54"}],"version":3},"carrot":{"id":"carrot","name":"Carrot","keywords":["vegetable","food","orange"],"skins":[{"unified":"1f955","native":"\uD83E\uDD55"}],"version":3},"corn":{"id":"corn","name":"Ear of Corn","keywords":["food","vegetable","plant"],"skins":[{"unified":"1f33d","native":"\uD83C\uDF3D"}],"version":1},"hot_pepper":{"id":"hot_pepper","name":"Hot Pepper","keywords":["food","spicy","chilli","chili"],"skins":[{"unified":"1f336-fe0f","native":"\uD83C\uDF36\uFE0F"}],"version":1},"bell_pepper":{"id":"bell_pepper","name":"Bell Pepper","keywords":["fruit","plant"],"skins":[{"unified":"1fad1","native":"\uD83E\uDED1"}],"version":13},"cucumber":{"id":"cucumber","name":"Cucumber","keywords":["fruit","food","pickle"],"skins":[{"unified":"1f952","native":"\uD83E\uDD52"}],"version":3},"leafy_green":{"id":"leafy_green","name":"Leafy Green","keywords":["food","vegetable","plant","bok","choy","cabbage","kale","lettuce"],"skins":[{"unified":"1f96c","native":"\uD83E\uDD6C"}],"version":11},"broccoli":{"id":"broccoli","name":"Broccoli","keywords":["fruit","food","vegetable"],"skins":[{"unified":"1f966","native":"\uD83E\uDD66"}],"version":5},"garlic":{"id":"garlic","name":"Garlic","keywords":["food","spice","cook"],"skins":[{"unified":"1f9c4","native":"\uD83E\uDDC4"}],"version":12},"onion":{"id":"onion","name":"Onion","keywords":["cook","food","spice"],"skins":[{"unified":"1f9c5","native":"\uD83E\uDDC5"}],"version":12},"peanuts":{"id":"peanuts","name":"Peanuts","keywords":["food","nut"],"skins":[{"unified":"1f95c","native":"\uD83E\uDD5C"}],"version":3},"beans":{"id":"beans","name":"Beans","keywords":["food"],"skins":[{"unified":"1fad8","native":"\uD83E\uDED8"}],"version":14},"chestnut":{"id":"chestnut","name":"Chestnut","keywords":["food","squirrel"],"skins":[{"unified":"1f330","native":"\uD83C\uDF30"}],"version":1},"ginger_root":{"id":"ginger_root","name":"Ginger Root","keywords":["spice","yellow","cooking","gingerbread"],"skins":[{"unified":"1fada","native":"\uD83E\uDEDA"}],"version":15},"pea_pod":{"id":"pea_pod","name":"Pea Pod","keywords":["cozy","green"],"skins":[{"unified":"1fadb","native":"\uD83E\uDEDB"}],"version":15},"bread":{"id":"bread","name":"Bread","keywords":["food","wheat","breakfast","toast"],"skins":[{"unified":"1f35e","native":"\uD83C\uDF5E"}],"version":1},"croissant":{"id":"croissant","name":"Croissant","keywords":["food","bread","french"],"skins":[{"unified":"1f950","native":"\uD83E\uDD50"}],"version":3},"baguette_bread":{"id":"baguette_bread","name":"Baguette Bread","keywords":["food","french","france","bakery"],"skins":[{"unified":"1f956","native":"\uD83E\uDD56"}],"version":3},"flatbread":{"id":"flatbread","name":"Flatbread","keywords":["flour","food","bakery"],"skins":[{"unified":"1fad3","native":"\uD83E\uDED3"}],"version":13},"pretzel":{"id":"pretzel","name":"Pretzel","keywords":["food","bread","twisted","germany","bakery"],"skins":[{"unified":"1f968","native":"\uD83E\uDD68"}],"version":5},"bagel":{"id":"bagel","name":"Bagel","keywords":["food","bread","bakery","schmear","jewish"],"skins":[{"unified":"1f96f","native":"\uD83E\uDD6F"}],"version":11},"pancakes":{"id":"pancakes","name":"Pancakes","keywords":["food","breakfast","flapjacks","hotcakes","brunch"],"skins":[{"unified":"1f95e","native":"\uD83E\uDD5E"}],"version":3},"waffle":{"id":"waffle","name":"Waffle","keywords":["food","breakfast","brunch"],"skins":[{"unified":"1f9c7","native":"\uD83E\uDDC7"}],"version":12},"cheese_wedge":{"id":"cheese_wedge","name":"Cheese Wedge","keywords":["food","chadder","swiss"],"skins":[{"unified":"1f9c0","native":"\uD83E\uDDC0"}],"version":1},"meat_on_bone":{"id":"meat_on_bone","name":"Meat on Bone","keywords":["good","food","drumstick"],"skins":[{"unified":"1f356","native":"\uD83C\uDF56"}],"version":1},"poultry_leg":{"id":"poultry_leg","name":"Poultry Leg","keywords":["food","meat","drumstick","bird","chicken","turkey"],"skins":[{"unified":"1f357","native":"\uD83C\uDF57"}],"version":1},"cut_of_meat":{"id":"cut_of_meat","name":"Cut of Meat","keywords":["food","cow","chop","lambchop","porkchop"],"skins":[{"unified":"1f969","native":"\uD83E\uDD69"}],"version":5},"bacon":{"id":"bacon","name":"Bacon","keywords":["food","breakfast","pork","pig","meat","brunch"],"skins":[{"unified":"1f953","native":"\uD83E\uDD53"}],"version":3},"hamburger":{"id":"hamburger","name":"Hamburger","keywords":["meat","fast","food","beef","cheeseburger","mcdonalds","burger","king"],"skins":[{"unified":"1f354","native":"\uD83C\uDF54"}],"version":1},"fries":{"id":"fries","name":"French Fries","keywords":["chips","snack","fast","food","potato"],"skins":[{"unified":"1f35f","native":"\uD83C\uDF5F"}],"version":1},"pizza":{"id":"pizza","name":"Pizza","keywords":["food","party","italy"],"skins":[{"unified":"1f355","native":"\uD83C\uDF55"}],"version":1},"hotdog":{"id":"hotdog","name":"Hot Dog","keywords":["hotdog","food","frankfurter","america"],"skins":[{"unified":"1f32d","native":"\uD83C\uDF2D"}],"version":1},"sandwich":{"id":"sandwich","name":"Sandwich","keywords":["food","lunch","bread","toast","bakery"],"skins":[{"unified":"1f96a","native":"\uD83E\uDD6A"}],"version":5},"taco":{"id":"taco","name":"Taco","keywords":["food","mexican"],"skins":[{"unified":"1f32e","native":"\uD83C\uDF2E"}],"version":1},"burrito":{"id":"burrito","name":"Burrito","keywords":["food","mexican"],"skins":[{"unified":"1f32f","native":"\uD83C\uDF2F"}],"version":1},"tamale":{"id":"tamale","name":"Tamale","keywords":["food","masa"],"skins":[{"unified":"1fad4","native":"\uD83E\uDED4"}],"version":13},"stuffed_flatbread":{"id":"stuffed_flatbread","name":"Stuffed Flatbread","keywords":["food","gyro","mediterranean"],"skins":[{"unified":"1f959","native":"\uD83E\uDD59"}],"version":3},"falafel":{"id":"falafel","name":"Falafel","keywords":["food","mediterranean"],"skins":[{"unified":"1f9c6","native":"\uD83E\uDDC6"}],"version":12},"egg":{"id":"egg","name":"Egg","keywords":["food","chicken","breakfast"],"skins":[{"unified":"1f95a","native":"\uD83E\uDD5A"}],"version":3},"fried_egg":{"id":"fried_egg","name":"Cooking","keywords":["fried","egg","food","breakfast","kitchen","skillet"],"skins":[{"unified":"1f373","native":"\uD83C\uDF73"}],"version":1},"shallow_pan_of_food":{"id":"shallow_pan_of_food","name":"Shallow Pan of Food","keywords":["cooking","casserole","paella","skillet"],"skins":[{"unified":"1f958","native":"\uD83E\uDD58"}],"version":3},"stew":{"id":"stew","name":"Pot of Food","keywords":["stew","meat","soup","hot"],"skins":[{"unified":"1f372","native":"\uD83C\uDF72"}],"version":1},"fondue":{"id":"fondue","name":"Fondue","keywords":["cheese","pot","food"],"skins":[{"unified":"1fad5","native":"\uD83E\uDED5"}],"version":13},"bowl_with_spoon":{"id":"bowl_with_spoon","name":"Bowl with Spoon","keywords":["food","breakfast","cereal","oatmeal","porridge"],"skins":[{"unified":"1f963","native":"\uD83E\uDD63"}],"version":5},"green_salad":{"id":"green_salad","name":"Green Salad","keywords":["food","healthy","lettuce","vegetable"],"skins":[{"unified":"1f957","native":"\uD83E\uDD57"}],"version":3},"popcorn":{"id":"popcorn","name":"Popcorn","keywords":["food","movie","theater","films","snack","drama"],"skins":[{"unified":"1f37f","native":"\uD83C\uDF7F"}],"version":1},"butter":{"id":"butter","name":"Butter","keywords":["food","cook"],"skins":[{"unified":"1f9c8","native":"\uD83E\uDDC8"}],"version":12},"salt":{"id":"salt","name":"Salt","keywords":["condiment","shaker"],"skins":[{"unified":"1f9c2","native":"\uD83E\uDDC2"}],"version":11},"canned_food":{"id":"canned_food","name":"Canned Food","keywords":["soup","tomatoes"],"skins":[{"unified":"1f96b","native":"\uD83E\uDD6B"}],"version":5},"bento":{"id":"bento","name":"Bento Box","keywords":["food","japanese","lunch"],"skins":[{"unified":"1f371","native":"\uD83C\uDF71"}],"version":1},"rice_cracker":{"id":"rice_cracker","name":"Rice Cracker","keywords":["food","japanese","snack"],"skins":[{"unified":"1f358","native":"\uD83C\uDF58"}],"version":1},"rice_ball":{"id":"rice_ball","name":"Rice Ball","keywords":["food","japanese"],"skins":[{"unified":"1f359","native":"\uD83C\uDF59"}],"version":1},"rice":{"id":"rice","name":"Cooked Rice","keywords":["food","asian"],"skins":[{"unified":"1f35a","native":"\uD83C\uDF5A"}],"version":1},"curry":{"id":"curry","name":"Curry Rice","keywords":["food","spicy","hot","indian"],"skins":[{"unified":"1f35b","native":"\uD83C\uDF5B"}],"version":1},"ramen":{"id":"ramen","name":"Steaming Bowl","keywords":["ramen","food","japanese","noodle","chopsticks"],"skins":[{"unified":"1f35c","native":"\uD83C\uDF5C"}],"version":1},"spaghetti":{"id":"spaghetti","name":"Spaghetti","keywords":["food","italian","pasta","noodle"],"skins":[{"unified":"1f35d","native":"\uD83C\uDF5D"}],"version":1},"sweet_potato":{"id":"sweet_potato","name":"Roasted Sweet Potato","keywords":["food","nature","plant"],"skins":[{"unified":"1f360","native":"\uD83C\uDF60"}],"version":1},"oden":{"id":"oden","name":"Oden","keywords":["food","japanese"],"skins":[{"unified":"1f362","native":"\uD83C\uDF62"}],"version":1},"sushi":{"id":"sushi","name":"Sushi","keywords":["food","fish","japanese","rice"],"skins":[{"unified":"1f363","native":"\uD83C\uDF63"}],"version":1},"fried_shrimp":{"id":"fried_shrimp","name":"Fried Shrimp","keywords":["food","animal","appetizer","summer"],"skins":[{"unified":"1f364","native":"\uD83C\uDF64"}],"version":1},"fish_cake":{"id":"fish_cake","name":"Fish Cake with Swirl","keywords":["food","japan","sea","beach","narutomaki","pink","kamaboko","surimi","ramen"],"skins":[{"unified":"1f365","native":"\uD83C\uDF65"}],"version":1},"moon_cake":{"id":"moon_cake","name":"Moon Cake","keywords":["food","autumn","dessert"],"skins":[{"unified":"1f96e","native":"\uD83E\uDD6E"}],"version":11},"dango":{"id":"dango","name":"Dango","keywords":["food","dessert","sweet","japanese","barbecue","meat"],"skins":[{"unified":"1f361","native":"\uD83C\uDF61"}],"version":1},"dumpling":{"id":"dumpling","name":"Dumpling","keywords":["food","empanada","pierogi","potsticker","gyoza"],"skins":[{"unified":"1f95f","native":"\uD83E\uDD5F"}],"version":5},"fortune_cookie":{"id":"fortune_cookie","name":"Fortune Cookie","keywords":["food","prophecy","dessert"],"skins":[{"unified":"1f960","native":"\uD83E\uDD60"}],"version":5},"takeout_box":{"id":"takeout_box","name":"Takeout Box","keywords":["food","leftovers"],"skins":[{"unified":"1f961","native":"\uD83E\uDD61"}],"version":5},"crab":{"id":"crab","name":"Crab","keywords":["animal","crustacean"],"skins":[{"unified":"1f980","native":"\uD83E\uDD80"}],"version":1},"lobster":{"id":"lobster","name":"Lobster","keywords":["animal","nature","bisque","claws","seafood"],"skins":[{"unified":"1f99e","native":"\uD83E\uDD9E"}],"version":11},"shrimp":{"id":"shrimp","name":"Shrimp","keywords":["animal","ocean","nature","seafood"],"skins":[{"unified":"1f990","native":"\uD83E\uDD90"}],"version":3},"squid":{"id":"squid","name":"Squid","keywords":["animal","nature","ocean","sea"],"skins":[{"unified":"1f991","native":"\uD83E\uDD91"}],"version":3},"oyster":{"id":"oyster","name":"Oyster","keywords":["food"],"skins":[{"unified":"1f9aa","native":"\uD83E\uDDAA"}],"version":12},"icecream":{"id":"icecream","name":"Soft Ice Cream","keywords":["icecream","food","hot","dessert","summer"],"skins":[{"unified":"1f366","native":"\uD83C\uDF66"}],"version":1},"shaved_ice":{"id":"shaved_ice","name":"Shaved Ice","keywords":["hot","dessert","summer"],"skins":[{"unified":"1f367","native":"\uD83C\uDF67"}],"version":1},"ice_cream":{"id":"ice_cream","name":"Ice Cream","keywords":["food","hot","dessert"],"skins":[{"unified":"1f368","native":"\uD83C\uDF68"}],"version":1},"doughnut":{"id":"doughnut","name":"Doughnut","keywords":["food","dessert","snack","sweet","donut"],"skins":[{"unified":"1f369","native":"\uD83C\uDF69"}],"version":1},"cookie":{"id":"cookie","name":"Cookie","keywords":["food","snack","oreo","chocolate","sweet","dessert"],"skins":[{"unified":"1f36a","native":"\uD83C\uDF6A"}],"version":1},"birthday":{"id":"birthday","name":"Birthday Cake","keywords":["food","dessert"],"skins":[{"unified":"1f382","native":"\uD83C\uDF82"}],"version":1},"cake":{"id":"cake","name":"Shortcake","keywords":["cake","food","dessert"],"skins":[{"unified":"1f370","native":"\uD83C\uDF70"}],"version":1},"cupcake":{"id":"cupcake","name":"Cupcake","keywords":["food","dessert","bakery","sweet"],"skins":[{"unified":"1f9c1","native":"\uD83E\uDDC1"}],"version":11},"pie":{"id":"pie","name":"Pie","keywords":["food","dessert","pastry"],"skins":[{"unified":"1f967","native":"\uD83E\uDD67"}],"version":5},"chocolate_bar":{"id":"chocolate_bar","name":"Chocolate Bar","keywords":["food","snack","dessert","sweet"],"skins":[{"unified":"1f36b","native":"\uD83C\uDF6B"}],"version":1},"candy":{"id":"candy","name":"Candy","keywords":["snack","dessert","sweet","lolly"],"skins":[{"unified":"1f36c","native":"\uD83C\uDF6C"}],"version":1},"lollipop":{"id":"lollipop","name":"Lollipop","keywords":["food","snack","candy","sweet"],"skins":[{"unified":"1f36d","native":"\uD83C\uDF6D"}],"version":1},"custard":{"id":"custard","name":"Custard","keywords":["dessert","food"],"skins":[{"unified":"1f36e","native":"\uD83C\uDF6E"}],"version":1},"honey_pot":{"id":"honey_pot","name":"Honey Pot","keywords":["bees","sweet","kitchen"],"skins":[{"unified":"1f36f","native":"\uD83C\uDF6F"}],"version":1},"baby_bottle":{"id":"baby_bottle","name":"Baby Bottle","keywords":["food","container","milk"],"skins":[{"unified":"1f37c","native":"\uD83C\uDF7C"}],"version":1},"glass_of_milk":{"id":"glass_of_milk","name":"Glass of Milk","keywords":["beverage","drink","cow"],"skins":[{"unified":"1f95b","native":"\uD83E\uDD5B"}],"version":3},"coffee":{"id":"coffee","name":"Hot Beverage","keywords":["coffee","caffeine","latte","espresso","mug"],"skins":[{"unified":"2615","native":"\u2615"}],"version":1},"teapot":{"id":"teapot","name":"Teapot","keywords":["drink","hot"],"skins":[{"unified":"1fad6","native":"\uD83E\uDED6"}],"version":13},"tea":{"id":"tea","name":"Teacup Without Handle","keywords":["tea","drink","bowl","breakfast","green","british"],"skins":[{"unified":"1f375","native":"\uD83C\uDF75"}],"version":1},"sake":{"id":"sake","name":"Sake","keywords":["wine","drink","drunk","beverage","japanese","alcohol","booze"],"skins":[{"unified":"1f376","native":"\uD83C\uDF76"}],"version":1},"champagne":{"id":"champagne","name":"Bottle with Popping Cork","keywords":["champagne","drink","wine","celebration"],"skins":[{"unified":"1f37e","native":"\uD83C\uDF7E"}],"version":1},"wine_glass":{"id":"wine_glass","name":"Wine Glass","keywords":["drink","beverage","drunk","alcohol","booze"],"skins":[{"unified":"1f377","native":"\uD83C\uDF77"}],"version":1},"cocktail":{"id":"cocktail","name":"Cocktail Glass","keywords":["drink","drunk","alcohol","beverage","booze","mojito"],"skins":[{"unified":"1f378","native":"\uD83C\uDF78"}],"version":1},"tropical_drink":{"id":"tropical_drink","name":"Tropical Drink","keywords":["beverage","cocktail","summer","beach","alcohol","booze","mojito"],"skins":[{"unified":"1f379","native":"\uD83C\uDF79"}],"version":1},"beer":{"id":"beer","name":"Beer Mug","keywords":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"skins":[{"unified":"1f37a","native":"\uD83C\uDF7A"}],"version":1},"beers":{"id":"beers","name":"Clinking Beer Mugs","keywords":["beers","relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"skins":[{"unified":"1f37b","native":"\uD83C\uDF7B"}],"version":1},"clinking_glasses":{"id":"clinking_glasses","name":"Clinking Glasses","keywords":["beverage","drink","party","alcohol","celebrate","cheers","wine","champagne","toast"],"skins":[{"unified":"1f942","native":"\uD83E\uDD42"}],"version":3},"tumbler_glass":{"id":"tumbler_glass","name":"Tumbler Glass","keywords":["drink","beverage","drunk","alcohol","liquor","booze","bourbon","scotch","whisky","shot"],"skins":[{"unified":"1f943","native":"\uD83E\uDD43"}],"version":3},"pouring_liquid":{"id":"pouring_liquid","name":"Pouring Liquid","keywords":["cup","water"],"skins":[{"unified":"1fad7","native":"\uD83E\uDED7"}],"version":14},"cup_with_straw":{"id":"cup_with_straw","name":"Cup with Straw","keywords":["drink","soda"],"skins":[{"unified":"1f964","native":"\uD83E\uDD64"}],"version":5},"bubble_tea":{"id":"bubble_tea","name":"Bubble Tea","keywords":["taiwan","boba","milk","straw"],"skins":[{"unified":"1f9cb","native":"\uD83E\uDDCB"}],"version":13},"beverage_box":{"id":"beverage_box","name":"Beverage Box","keywords":["drink"],"skins":[{"unified":"1f9c3","native":"\uD83E\uDDC3"}],"version":12},"mate_drink":{"id":"mate_drink","name":"Mate","keywords":["drink","tea","beverage"],"skins":[{"unified":"1f9c9","native":"\uD83E\uDDC9"}],"version":12},"ice_cube":{"id":"ice_cube","name":"Ice","keywords":["cube","water","cold"],"skins":[{"unified":"1f9ca","native":"\uD83E\uDDCA"}],"version":12},"chopsticks":{"id":"chopsticks","name":"Chopsticks","keywords":["food"],"skins":[{"unified":"1f962","native":"\uD83E\uDD62"}],"version":5},"knife_fork_plate":{"id":"knife_fork_plate","name":"Fork and Knife with Plate","keywords":["food","eat","meal","lunch","dinner","restaurant"],"skins":[{"unified":"1f37d-fe0f","native":"\uD83C\uDF7D\uFE0F"}],"version":1},"fork_and_knife":{"id":"fork_and_knife","name":"Fork and Knife","keywords":["cutlery","kitchen"],"skins":[{"unified":"1f374","native":"\uD83C\uDF74"}],"version":1},"spoon":{"id":"spoon","name":"Spoon","keywords":["cutlery","kitchen","tableware"],"skins":[{"unified":"1f944","native":"\uD83E\uDD44"}],"version":3},"hocho":{"id":"hocho","name":"Hocho","keywords":["knife","kitchen","blade","cutlery","weapon"],"skins":[{"unified":"1f52a","native":"\uD83D\uDD2A"}],"version":1},"jar":{"id":"jar","name":"Jar","keywords":["container","sauce"],"skins":[{"unified":"1fad9","native":"\uD83E\uDED9"}],"version":14},"amphora":{"id":"amphora","name":"Amphora","keywords":["vase","jar"],"skins":[{"unified":"1f3fa","native":"\uD83C\uDFFA"}],"version":1},"earth_africa":{"id":"earth_africa","name":"Earth Globe Europe-Africa","keywords":["africa","showing","europe","world","international"],"skins":[{"unified":"1f30d","native":"\uD83C\uDF0D"}],"version":1},"earth_americas":{"id":"earth_americas","name":"Earth Globe Americas","keywords":["showing","world","USA","international"],"skins":[{"unified":"1f30e","native":"\uD83C\uDF0E"}],"version":1},"earth_asia":{"id":"earth_asia","name":"Earth Globe Asia-Australia","keywords":["asia","showing","australia","world","east","international"],"skins":[{"unified":"1f30f","native":"\uD83C\uDF0F"}],"version":1},"globe_with_meridians":{"id":"globe_with_meridians","name":"Globe with Meridians","keywords":["earth","international","world","internet","interweb","i18n"],"skins":[{"unified":"1f310","native":"\uD83C\uDF10"}],"version":1},"world_map":{"id":"world_map","name":"World Map","keywords":["location","direction"],"skins":[{"unified":"1f5fa-fe0f","native":"\uD83D\uDDFA\uFE0F"}],"version":1},"japan":{"id":"japan","name":"Map of Japan","keywords":["nation","country","japanese","asia"],"skins":[{"unified":"1f5fe","native":"\uD83D\uDDFE"}],"version":1},"compass":{"id":"compass","name":"Compass","keywords":["magnetic","navigation","orienteering"],"skins":[{"unified":"1f9ed","native":"\uD83E\uDDED"}],"version":11},"snow_capped_mountain":{"id":"snow_capped_mountain","name":"Snow-Capped Mountain","keywords":["snow","capped","photo","nature","environment","winter","cold"],"skins":[{"unified":"1f3d4-fe0f","native":"\uD83C\uDFD4\uFE0F"}],"version":1},"mountain":{"id":"mountain","name":"Mountain","keywords":["photo","nature","environment"],"skins":[{"unified":"26f0-fe0f","native":"\u26F0\uFE0F"}],"version":1},"volcano":{"id":"volcano","name":"Volcano","keywords":["photo","nature","disaster"],"skins":[{"unified":"1f30b","native":"\uD83C\uDF0B"}],"version":1},"mount_fuji":{"id":"mount_fuji","name":"Mount Fuji","keywords":["photo","mountain","nature","japanese"],"skins":[{"unified":"1f5fb","native":"\uD83D\uDDFB"}],"version":1},"camping":{"id":"camping","name":"Camping","keywords":["photo","outdoors","tent"],"skins":[{"unified":"1f3d5-fe0f","native":"\uD83C\uDFD5\uFE0F"}],"version":1},"beach_with_umbrella":{"id":"beach_with_umbrella","name":"Beach with Umbrella","keywords":["weather","summer","sunny","sand","mojito"],"skins":[{"unified":"1f3d6-fe0f","native":"\uD83C\uDFD6\uFE0F"}],"version":1},"desert":{"id":"desert","name":"Desert","keywords":["photo","warm","saharah"],"skins":[{"unified":"1f3dc-fe0f","native":"\uD83C\uDFDC\uFE0F"}],"version":1},"desert_island":{"id":"desert_island","name":"Desert Island","keywords":["photo","tropical","mojito"],"skins":[{"unified":"1f3dd-fe0f","native":"\uD83C\uDFDD\uFE0F"}],"version":1},"national_park":{"id":"national_park","name":"National Park","keywords":["photo","environment","nature"],"skins":[{"unified":"1f3de-fe0f","native":"\uD83C\uDFDE\uFE0F"}],"version":1},"stadium":{"id":"stadium","name":"Stadium","keywords":["photo","place","sports","concert","venue"],"skins":[{"unified":"1f3df-fe0f","native":"\uD83C\uDFDF\uFE0F"}],"version":1},"classical_building":{"id":"classical_building","name":"Classical Building","keywords":["art","culture","history"],"skins":[{"unified":"1f3db-fe0f","native":"\uD83C\uDFDB\uFE0F"}],"version":1},"building_construction":{"id":"building_construction","name":"Building Construction","keywords":["wip","working","progress"],"skins":[{"unified":"1f3d7-fe0f","native":"\uD83C\uDFD7\uFE0F"}],"version":1},"bricks":{"id":"bricks","name":"Brick","keywords":["bricks"],"skins":[{"unified":"1f9f1","native":"\uD83E\uDDF1"}],"version":11},"rock":{"id":"rock","name":"Rock","keywords":["stone"],"skins":[{"unified":"1faa8","native":"\uD83E\uDEA8"}],"version":13},"wood":{"id":"wood","name":"Wood","keywords":["nature","timber","trunk"],"skins":[{"unified":"1fab5","native":"\uD83E\uDEB5"}],"version":13},"hut":{"id":"hut","name":"Hut","keywords":["house","structure"],"skins":[{"unified":"1f6d6","native":"\uD83D\uDED6"}],"version":13},"house_buildings":{"id":"house_buildings","name":"Houses","keywords":["house","buildings","photo"],"skins":[{"unified":"1f3d8-fe0f","native":"\uD83C\uDFD8\uFE0F"}],"version":1},"derelict_house_building":{"id":"derelict_house_building","name":"Derelict House","keywords":["building","abandon","evict","broken"],"skins":[{"unified":"1f3da-fe0f","native":"\uD83C\uDFDA\uFE0F"}],"version":1},"house":{"id":"house","name":"House","keywords":["building","home"],"skins":[{"unified":"1f3e0","native":"\uD83C\uDFE0"}],"version":1},"house_with_garden":{"id":"house_with_garden","name":"House with Garden","keywords":["home","plant","nature"],"skins":[{"unified":"1f3e1","native":"\uD83C\uDFE1"}],"version":1},"office":{"id":"office","name":"Office Building","keywords":["bureau","work"],"skins":[{"unified":"1f3e2","native":"\uD83C\uDFE2"}],"version":1},"post_office":{"id":"post_office","name":"Japanese Post Office","keywords":["building","envelope","communication"],"skins":[{"unified":"1f3e3","native":"\uD83C\uDFE3"}],"version":1},"european_post_office":{"id":"european_post_office","name":"Post Office","keywords":["european","building","email"],"skins":[{"unified":"1f3e4","native":"\uD83C\uDFE4"}],"version":1},"hospital":{"id":"hospital","name":"Hospital","keywords":["building","health","surgery","doctor"],"skins":[{"unified":"1f3e5","native":"\uD83C\uDFE5"}],"version":1},"bank":{"id":"bank","name":"Bank","keywords":["building","money","sales","cash","business","enterprise"],"skins":[{"unified":"1f3e6","native":"\uD83C\uDFE6"}],"version":1},"hotel":{"id":"hotel","name":"Hotel","keywords":["building","accomodation","checkin"],"skins":[{"unified":"1f3e8","native":"\uD83C\uDFE8"}],"version":1},"love_hotel":{"id":"love_hotel","name":"Love Hotel","keywords":["like","affection","dating"],"skins":[{"unified":"1f3e9","native":"\uD83C\uDFE9"}],"version":1},"convenience_store":{"id":"convenience_store","name":"Convenience Store","keywords":["building","shopping","groceries"],"skins":[{"unified":"1f3ea","native":"\uD83C\uDFEA"}],"version":1},"school":{"id":"school","name":"School","keywords":["building","student","education","learn","teach"],"skins":[{"unified":"1f3eb","native":"\uD83C\uDFEB"}],"version":1},"department_store":{"id":"department_store","name":"Department Store","keywords":["building","shopping","mall"],"skins":[{"unified":"1f3ec","native":"\uD83C\uDFEC"}],"version":1},"factory":{"id":"factory","name":"Factory","keywords":["building","industry","pollution","smoke"],"skins":[{"unified":"1f3ed","native":"\uD83C\uDFED"}],"version":1},"japanese_castle":{"id":"japanese_castle","name":"Japanese Castle","keywords":["photo","building"],"skins":[{"unified":"1f3ef","native":"\uD83C\uDFEF"}],"version":1},"european_castle":{"id":"european_castle","name":"Castle","keywords":["european","building","royalty","history"],"skins":[{"unified":"1f3f0","native":"\uD83C\uDFF0"}],"version":1},"wedding":{"id":"wedding","name":"Wedding","keywords":["love","like","affection","couple","marriage","bride","groom"],"skins":[{"unified":"1f492","native":"\uD83D\uDC92"}],"version":1},"tokyo_tower":{"id":"tokyo_tower","name":"Tokyo Tower","keywords":["photo","japanese"],"skins":[{"unified":"1f5fc","native":"\uD83D\uDDFC"}],"version":1},"statue_of_liberty":{"id":"statue_of_liberty","name":"Statue of Liberty","keywords":["american","newyork"],"skins":[{"unified":"1f5fd","native":"\uD83D\uDDFD"}],"version":1},"church":{"id":"church","name":"Church","keywords":["building","religion","christ"],"skins":[{"unified":"26ea","native":"\u26EA"}],"version":1},"mosque":{"id":"mosque","name":"Mosque","keywords":["islam","worship","minaret"],"skins":[{"unified":"1f54c","native":"\uD83D\uDD4C"}],"version":1},"hindu_temple":{"id":"hindu_temple","name":"Hindu Temple","keywords":["religion"],"skins":[{"unified":"1f6d5","native":"\uD83D\uDED5"}],"version":12},"synagogue":{"id":"synagogue","name":"Synagogue","keywords":["judaism","worship","temple","jewish"],"skins":[{"unified":"1f54d","native":"\uD83D\uDD4D"}],"version":1},"shinto_shrine":{"id":"shinto_shrine","name":"Shinto Shrine","keywords":["temple","japan","kyoto"],"skins":[{"unified":"26e9-fe0f","native":"\u26E9\uFE0F"}],"version":1},"kaaba":{"id":"kaaba","name":"Kaaba","keywords":["mecca","mosque","islam"],"skins":[{"unified":"1f54b","native":"\uD83D\uDD4B"}],"version":1},"fountain":{"id":"fountain","name":"Fountain","keywords":["photo","summer","water","fresh"],"skins":[{"unified":"26f2","native":"\u26F2"}],"version":1},"tent":{"id":"tent","name":"Tent","keywords":["photo","camping","outdoors"],"skins":[{"unified":"26fa","native":"\u26FA"}],"version":1},"foggy":{"id":"foggy","name":"Foggy","keywords":["photo","mountain"],"skins":[{"unified":"1f301","native":"\uD83C\uDF01"}],"version":1},"night_with_stars":{"id":"night_with_stars","name":"Night with Stars","keywords":["evening","city","downtown"],"skins":[{"unified":"1f303","native":"\uD83C\uDF03"}],"version":1},"cityscape":{"id":"cityscape","name":"Cityscape","keywords":["photo","night","life","urban"],"skins":[{"unified":"1f3d9-fe0f","native":"\uD83C\uDFD9\uFE0F"}],"version":1},"sunrise_over_mountains":{"id":"sunrise_over_mountains","name":"Sunrise over Mountains","keywords":["view","vacation","photo"],"skins":[{"unified":"1f304","native":"\uD83C\uDF04"}],"version":1},"sunrise":{"id":"sunrise","name":"Sunrise","keywords":["morning","view","vacation","photo"],"skins":[{"unified":"1f305","native":"\uD83C\uDF05"}],"version":1},"city_sunset":{"id":"city_sunset","name":"Cityscape at Dusk","keywords":["city","sunset","photo","evening","sky","buildings"],"skins":[{"unified":"1f306","native":"\uD83C\uDF06"}],"version":1},"city_sunrise":{"id":"city_sunrise","name":"Sunset","keywords":["city","sunrise","photo","good","morning","dawn"],"skins":[{"unified":"1f307","native":"\uD83C\uDF07"}],"version":1},"bridge_at_night":{"id":"bridge_at_night","name":"Bridge at Night","keywords":["photo","sanfrancisco"],"skins":[{"unified":"1f309","native":"\uD83C\uDF09"}],"version":1},"hotsprings":{"id":"hotsprings","name":"Hot Springs","keywords":["hotsprings","bath","warm","relax"],"skins":[{"unified":"2668-fe0f","native":"\u2668\uFE0F"}],"version":1},"carousel_horse":{"id":"carousel_horse","name":"Carousel Horse","keywords":["photo","carnival"],"skins":[{"unified":"1f3a0","native":"\uD83C\uDFA0"}],"version":1},"playground_slide":{"id":"playground_slide","name":"Playground Slide","keywords":["fun","park"],"skins":[{"unified":"1f6dd","native":"\uD83D\uDEDD"}],"version":14},"ferris_wheel":{"id":"ferris_wheel","name":"Ferris Wheel","keywords":["photo","carnival","londoneye"],"skins":[{"unified":"1f3a1","native":"\uD83C\uDFA1"}],"version":1},"roller_coaster":{"id":"roller_coaster","name":"Roller Coaster","keywords":["carnival","playground","photo","fun"],"skins":[{"unified":"1f3a2","native":"\uD83C\uDFA2"}],"version":1},"barber":{"id":"barber","name":"Barber Pole","keywords":["hair","salon","style"],"skins":[{"unified":"1f488","native":"\uD83D\uDC88"}],"version":1},"circus_tent":{"id":"circus_tent","name":"Circus Tent","keywords":["festival","carnival","party"],"skins":[{"unified":"1f3aa","native":"\uD83C\uDFAA"}],"version":1},"steam_locomotive":{"id":"steam_locomotive","name":"Locomotive","keywords":["steam","transportation","vehicle","train"],"skins":[{"unified":"1f682","native":"\uD83D\uDE82"}],"version":1},"railway_car":{"id":"railway_car","name":"Railway Car","keywords":["transportation","vehicle"],"skins":[{"unified":"1f683","native":"\uD83D\uDE83"}],"version":1},"bullettrain_side":{"id":"bullettrain_side","name":"High-Speed Train","keywords":["bullettrain","side","high","speed","transportation","vehicle"],"skins":[{"unified":"1f684","native":"\uD83D\uDE84"}],"version":1},"bullettrain_front":{"id":"bullettrain_front","name":"Bullet Train","keywords":["bullettrain","front","transportation","vehicle","speed","fast","public","travel"],"skins":[{"unified":"1f685","native":"\uD83D\uDE85"}],"version":1},"train2":{"id":"train2","name":"Train","keywords":["train2","transportation","vehicle"],"skins":[{"unified":"1f686","native":"\uD83D\uDE86"}],"version":1},"metro":{"id":"metro","name":"Metro","keywords":["transportation","blue","square","mrt","underground","tube"],"skins":[{"unified":"1f687","native":"\uD83D\uDE87"}],"version":1},"light_rail":{"id":"light_rail","name":"Light Rail","keywords":["transportation","vehicle"],"skins":[{"unified":"1f688","native":"\uD83D\uDE88"}],"version":1},"station":{"id":"station","name":"Station","keywords":["transportation","vehicle","public"],"skins":[{"unified":"1f689","native":"\uD83D\uDE89"}],"version":1},"tram":{"id":"tram","name":"Tram","keywords":["transportation","vehicle"],"skins":[{"unified":"1f68a","native":"\uD83D\uDE8A"}],"version":1},"monorail":{"id":"monorail","name":"Monorail","keywords":["transportation","vehicle"],"skins":[{"unified":"1f69d","native":"\uD83D\uDE9D"}],"version":1},"mountain_railway":{"id":"mountain_railway","name":"Mountain Railway","keywords":["transportation","vehicle"],"skins":[{"unified":"1f69e","native":"\uD83D\uDE9E"}],"version":1},"train":{"id":"train","name":"Tram Car","keywords":["train","transportation","vehicle","carriage","public","travel"],"skins":[{"unified":"1f68b","native":"\uD83D\uDE8B"}],"version":1},"bus":{"id":"bus","name":"Bus","keywords":["car","vehicle","transportation"],"skins":[{"unified":"1f68c","native":"\uD83D\uDE8C"}],"version":1},"oncoming_bus":{"id":"oncoming_bus","name":"Oncoming Bus","keywords":["vehicle","transportation"],"skins":[{"unified":"1f68d","native":"\uD83D\uDE8D"}],"version":1},"trolleybus":{"id":"trolleybus","name":"Trolleybus","keywords":["bart","transportation","vehicle"],"skins":[{"unified":"1f68e","native":"\uD83D\uDE8E"}],"version":1},"minibus":{"id":"minibus","name":"Minibus","keywords":["vehicle","car","transportation"],"skins":[{"unified":"1f690","native":"\uD83D\uDE90"}],"version":1},"ambulance":{"id":"ambulance","name":"Ambulance","keywords":["health","911","hospital"],"skins":[{"unified":"1f691","native":"\uD83D\uDE91"}],"version":1},"fire_engine":{"id":"fire_engine","name":"Fire Engine","keywords":["transportation","cars","vehicle"],"skins":[{"unified":"1f692","native":"\uD83D\uDE92"}],"version":1},"police_car":{"id":"police_car","name":"Police Car","keywords":["vehicle","cars","transportation","law","legal","enforcement"],"skins":[{"unified":"1f693","native":"\uD83D\uDE93"}],"version":1},"oncoming_police_car":{"id":"oncoming_police_car","name":"Oncoming Police Car","keywords":["vehicle","law","legal","enforcement","911"],"skins":[{"unified":"1f694","native":"\uD83D\uDE94"}],"version":1},"taxi":{"id":"taxi","name":"Taxi","keywords":["uber","vehicle","cars","transportation"],"skins":[{"unified":"1f695","native":"\uD83D\uDE95"}],"version":1},"oncoming_taxi":{"id":"oncoming_taxi","name":"Oncoming Taxi","keywords":["vehicle","cars","uber"],"skins":[{"unified":"1f696","native":"\uD83D\uDE96"}],"version":1},"car":{"id":"car","name":"Automobile","keywords":["car","red","transportation","vehicle"],"skins":[{"unified":"1f697","native":"\uD83D\uDE97"}],"version":1},"oncoming_automobile":{"id":"oncoming_automobile","name":"Oncoming Automobile","keywords":["car","vehicle","transportation"],"skins":[{"unified":"1f698","native":"\uD83D\uDE98"}],"version":1},"blue_car":{"id":"blue_car","name":"Recreational Vehicle","keywords":["blue","car","sport","utility","transportation"],"skins":[{"unified":"1f699","native":"\uD83D\uDE99"}],"version":1},"pickup_truck":{"id":"pickup_truck","name":"Pickup Truck","keywords":["car","transportation"],"skins":[{"unified":"1f6fb","native":"\uD83D\uDEFB"}],"version":13},"truck":{"id":"truck","name":"Delivery Truck","keywords":["cars","transportation"],"skins":[{"unified":"1f69a","native":"\uD83D\uDE9A"}],"version":1},"articulated_lorry":{"id":"articulated_lorry","name":"Articulated Lorry","keywords":["vehicle","cars","transportation","express"],"skins":[{"unified":"1f69b","native":"\uD83D\uDE9B"}],"version":1},"tractor":{"id":"tractor","name":"Tractor","keywords":["vehicle","car","farming","agriculture"],"skins":[{"unified":"1f69c","native":"\uD83D\uDE9C"}],"version":1},"racing_car":{"id":"racing_car","name":"Racing Car","keywords":["sports","race","fast","formula","f1"],"skins":[{"unified":"1f3ce-fe0f","native":"\uD83C\uDFCE\uFE0F"}],"version":1},"racing_motorcycle":{"id":"racing_motorcycle","name":"Motorcycle","keywords":["racing","race","sports","fast"],"skins":[{"unified":"1f3cd-fe0f","native":"\uD83C\uDFCD\uFE0F"}],"version":1},"motor_scooter":{"id":"motor_scooter","name":"Motor Scooter","keywords":["vehicle","vespa","sasha"],"skins":[{"unified":"1f6f5","native":"\uD83D\uDEF5"}],"version":3},"manual_wheelchair":{"id":"manual_wheelchair","name":"Manual Wheelchair","keywords":["accessibility"],"skins":[{"unified":"1f9bd","native":"\uD83E\uDDBD"}],"version":12},"motorized_wheelchair":{"id":"motorized_wheelchair","name":"Motorized Wheelchair","keywords":["accessibility"],"skins":[{"unified":"1f9bc","native":"\uD83E\uDDBC"}],"version":12},"auto_rickshaw":{"id":"auto_rickshaw","name":"Auto Rickshaw","keywords":["move","transportation"],"skins":[{"unified":"1f6fa","native":"\uD83D\uDEFA"}],"version":12},"bike":{"id":"bike","name":"Bicycle","keywords":["bike","sports","exercise","hipster"],"skins":[{"unified":"1f6b2","native":"\uD83D\uDEB2"}],"version":1},"scooter":{"id":"scooter","name":"Scooter","keywords":["kick","vehicle","razor"],"skins":[{"unified":"1f6f4","native":"\uD83D\uDEF4"}],"version":3},"skateboard":{"id":"skateboard","name":"Skateboard","keywords":["board"],"skins":[{"unified":"1f6f9","native":"\uD83D\uDEF9"}],"version":11},"roller_skate":{"id":"roller_skate","name":"Roller Skate","keywords":["footwear","sports"],"skins":[{"unified":"1f6fc","native":"\uD83D\uDEFC"}],"version":13},"busstop":{"id":"busstop","name":"Bus Stop","keywords":["busstop","transportation","wait"],"skins":[{"unified":"1f68f","native":"\uD83D\uDE8F"}],"version":1},"motorway":{"id":"motorway","name":"Motorway","keywords":["road","cupertino","interstate","highway"],"skins":[{"unified":"1f6e3-fe0f","native":"\uD83D\uDEE3\uFE0F"}],"version":1},"railway_track":{"id":"railway_track","name":"Railway Track","keywords":["train","transportation"],"skins":[{"unified":"1f6e4-fe0f","native":"\uD83D\uDEE4\uFE0F"}],"version":1},"oil_drum":{"id":"oil_drum","name":"Oil Drum","keywords":["barrell"],"skins":[{"unified":"1f6e2-fe0f","native":"\uD83D\uDEE2\uFE0F"}],"version":1},"fuelpump":{"id":"fuelpump","name":"Fuel Pump","keywords":["fuelpump","gas","station","petroleum"],"skins":[{"unified":"26fd","native":"\u26FD"}],"version":1},"wheel":{"id":"wheel","name":"Wheel","keywords":["car","transport"],"skins":[{"unified":"1f6de","native":"\uD83D\uDEDE"}],"version":14},"rotating_light":{"id":"rotating_light","name":"Police Car Light","keywords":["rotating","ambulance","911","emergency","alert","error","pinged","law","legal"],"skins":[{"unified":"1f6a8","native":"\uD83D\uDEA8"}],"version":1},"traffic_light":{"id":"traffic_light","name":"Horizontal Traffic Light","keywords":["transportation","signal"],"skins":[{"unified":"1f6a5","native":"\uD83D\uDEA5"}],"version":1},"vertical_traffic_light":{"id":"vertical_traffic_light","name":"Vertical Traffic Light","keywords":["transportation","driving"],"skins":[{"unified":"1f6a6","native":"\uD83D\uDEA6"}],"version":1},"octagonal_sign":{"id":"octagonal_sign","name":"Stop Sign","keywords":["octagonal"],"skins":[{"unified":"1f6d1","native":"\uD83D\uDED1"}],"version":3},"construction":{"id":"construction","name":"Construction","keywords":["wip","progress","caution","warning"],"skins":[{"unified":"1f6a7","native":"\uD83D\uDEA7"}],"version":1},"anchor":{"id":"anchor","name":"Anchor","keywords":["ship","ferry","sea","boat"],"skins":[{"unified":"2693","native":"\u2693"}],"version":1},"ring_buoy":{"id":"ring_buoy","name":"Ring Buoy","keywords":["life","saver","preserver"],"skins":[{"unified":"1f6df","native":"\uD83D\uDEDF"}],"version":14},"boat":{"id":"boat","name":"Sailboat","keywords":["boat","ship","summer","transportation","water","sailing"],"skins":[{"unified":"26f5","native":"\u26F5"}],"version":1},"canoe":{"id":"canoe","name":"Canoe","keywords":["boat","paddle","water","ship"],"skins":[{"unified":"1f6f6","native":"\uD83D\uDEF6"}],"version":3},"speedboat":{"id":"speedboat","name":"Speedboat","keywords":["ship","transportation","vehicle","summer"],"skins":[{"unified":"1f6a4","native":"\uD83D\uDEA4"}],"version":1},"passenger_ship":{"id":"passenger_ship","name":"Passenger Ship","keywords":["yacht","cruise","ferry"],"skins":[{"unified":"1f6f3-fe0f","native":"\uD83D\uDEF3\uFE0F"}],"version":1},"ferry":{"id":"ferry","name":"Ferry","keywords":["boat","ship","yacht"],"skins":[{"unified":"26f4-fe0f","native":"\u26F4\uFE0F"}],"version":1},"motor_boat":{"id":"motor_boat","name":"Motor Boat","keywords":["ship"],"skins":[{"unified":"1f6e5-fe0f","native":"\uD83D\uDEE5\uFE0F"}],"version":1},"ship":{"id":"ship","name":"Ship","keywords":["transportation","titanic","deploy"],"skins":[{"unified":"1f6a2","native":"\uD83D\uDEA2"}],"version":1},"airplane":{"id":"airplane","name":"Airplane","keywords":["vehicle","transportation","flight","fly"],"skins":[{"unified":"2708-fe0f","native":"\u2708\uFE0F"}],"version":1},"small_airplane":{"id":"small_airplane","name":"Small Airplane","keywords":["flight","transportation","fly","vehicle"],"skins":[{"unified":"1f6e9-fe0f","native":"\uD83D\uDEE9\uFE0F"}],"version":1},"airplane_departure":{"id":"airplane_departure","name":"Airplane Departure","keywords":["airport","flight","landing"],"skins":[{"unified":"1f6eb","native":"\uD83D\uDEEB"}],"version":1},"airplane_arriving":{"id":"airplane_arriving","name":"Airplane Arrival","keywords":["arriving","airport","flight","boarding"],"skins":[{"unified":"1f6ec","native":"\uD83D\uDEEC"}],"version":1},"parachute":{"id":"parachute","name":"Parachute","keywords":["fly","glide"],"skins":[{"unified":"1fa82","native":"\uD83E\uDE82"}],"version":12},"seat":{"id":"seat","name":"Seat","keywords":["sit","airplane","transport","bus","flight","fly"],"skins":[{"unified":"1f4ba","native":"\uD83D\uDCBA"}],"version":1},"helicopter":{"id":"helicopter","name":"Helicopter","keywords":["transportation","vehicle","fly"],"skins":[{"unified":"1f681","native":"\uD83D\uDE81"}],"version":1},"suspension_railway":{"id":"suspension_railway","name":"Suspension Railway","keywords":["vehicle","transportation"],"skins":[{"unified":"1f69f","native":"\uD83D\uDE9F"}],"version":1},"mountain_cableway":{"id":"mountain_cableway","name":"Mountain Cableway","keywords":["transportation","vehicle","ski"],"skins":[{"unified":"1f6a0","native":"\uD83D\uDEA0"}],"version":1},"aerial_tramway":{"id":"aerial_tramway","name":"Aerial Tramway","keywords":["transportation","vehicle","ski"],"skins":[{"unified":"1f6a1","native":"\uD83D\uDEA1"}],"version":1},"satellite":{"id":"satellite","name":"Satellite","keywords":["communication","gps","orbit","spaceflight","NASA","ISS"],"skins":[{"unified":"1f6f0-fe0f","native":"\uD83D\uDEF0\uFE0F"}],"version":1},"rocket":{"id":"rocket","name":"Rocket","keywords":["launch","ship","staffmode","NASA","outer","space","fly"],"skins":[{"unified":"1f680","native":"\uD83D\uDE80"}],"version":1},"flying_saucer":{"id":"flying_saucer","name":"Flying Saucer","keywords":["transportation","vehicle","ufo"],"skins":[{"unified":"1f6f8","native":"\uD83D\uDEF8"}],"version":5},"bellhop_bell":{"id":"bellhop_bell","name":"Bellhop Bell","keywords":["service"],"skins":[{"unified":"1f6ce-fe0f","native":"\uD83D\uDECE\uFE0F"}],"version":1},"luggage":{"id":"luggage","name":"Luggage","keywords":["packing","travel"],"skins":[{"unified":"1f9f3","native":"\uD83E\uDDF3"}],"version":11},"hourglass":{"id":"hourglass","name":"Hourglass","keywords":["done","time","clock","oldschool","limit","exam","quiz","test"],"skins":[{"unified":"231b","native":"\u231B"}],"version":1},"hourglass_flowing_sand":{"id":"hourglass_flowing_sand","name":"Hourglass Not Done","keywords":["flowing","sand","oldschool","time","countdown"],"skins":[{"unified":"23f3","native":"\u23F3"}],"version":1},"watch":{"id":"watch","name":"Watch","keywords":["time","accessories"],"skins":[{"unified":"231a","native":"\u231A"}],"version":1},"alarm_clock":{"id":"alarm_clock","name":"Alarm Clock","keywords":["time","wake"],"skins":[{"unified":"23f0","native":"\u23F0"}],"version":1},"stopwatch":{"id":"stopwatch","name":"Stopwatch","keywords":["time","deadline"],"skins":[{"unified":"23f1-fe0f","native":"\u23F1\uFE0F"}],"version":1},"timer_clock":{"id":"timer_clock","name":"Timer Clock","keywords":["alarm"],"skins":[{"unified":"23f2-fe0f","native":"\u23F2\uFE0F"}],"version":1},"mantelpiece_clock":{"id":"mantelpiece_clock","name":"Mantelpiece Clock","keywords":["time"],"skins":[{"unified":"1f570-fe0f","native":"\uD83D\uDD70\uFE0F"}],"version":1},"clock12":{"id":"clock12","name":"Twelve O\u2019clock","keywords":["clock12","o","clock","12","00:00","0000","12:00","1200","time","noon","midnight","midday","late","early","schedule"],"skins":[{"unified":"1f55b","native":"\uD83D\uDD5B"}],"version":1},"clock1230":{"id":"clock1230","name":"Twelve-Thirty","keywords":["clock1230","twelve","thirty","00:30","0030","12:30","1230","time","late","early","schedule"],"skins":[{"unified":"1f567","native":"\uD83D\uDD67"}],"version":1},"clock1":{"id":"clock1","name":"One O\u2019clock","keywords":["clock1","o","clock","1","1:00","100","13:00","1300","time","late","early","schedule"],"skins":[{"unified":"1f550","native":"\uD83D\uDD50"}],"version":1},"clock130":{"id":"clock130","name":"One-Thirty","keywords":["clock130","one","thirty","1:30","130","13:30","1330","time","late","early","schedule"],"skins":[{"unified":"1f55c","native":"\uD83D\uDD5C"}],"version":1},"clock2":{"id":"clock2","name":"Two O\u2019clock","keywords":["clock2","o","clock","2","2:00","200","14:00","1400","time","late","early","schedule"],"skins":[{"unified":"1f551","native":"\uD83D\uDD51"}],"version":1},"clock230":{"id":"clock230","name":"Two-Thirty","keywords":["clock230","two","thirty","2:30","230","14:30","1430","time","late","early","schedule"],"skins":[{"unified":"1f55d","native":"\uD83D\uDD5D"}],"version":1},"clock3":{"id":"clock3","name":"Three O\u2019clock","keywords":["clock3","o","clock","3","3:00","300","15:00","1500","time","late","early","schedule"],"skins":[{"unified":"1f552","native":"\uD83D\uDD52"}],"version":1},"clock330":{"id":"clock330","name":"Three-Thirty","keywords":["clock330","three","thirty","3:30","330","15:30","1530","time","late","early","schedule"],"skins":[{"unified":"1f55e","native":"\uD83D\uDD5E"}],"version":1},"clock4":{"id":"clock4","name":"Four O\u2019clock","keywords":["clock4","o","clock","4","4:00","400","16:00","1600","time","late","early","schedule"],"skins":[{"unified":"1f553","native":"\uD83D\uDD53"}],"version":1},"clock430":{"id":"clock430","name":"Four-Thirty","keywords":["clock430","four","thirty","4:30","430","16:30","1630","time","late","early","schedule"],"skins":[{"unified":"1f55f","native":"\uD83D\uDD5F"}],"version":1},"clock5":{"id":"clock5","name":"Five O\u2019clock","keywords":["clock5","o","clock","5","5:00","500","17:00","1700","time","late","early","schedule"],"skins":[{"unified":"1f554","native":"\uD83D\uDD54"}],"version":1},"clock530":{"id":"clock530","name":"Five-Thirty","keywords":["clock530","five","thirty","5:30","530","17:30","1730","time","late","early","schedule"],"skins":[{"unified":"1f560","native":"\uD83D\uDD60"}],"version":1},"clock6":{"id":"clock6","name":"Six O\u2019clock","keywords":["clock6","o","clock","6","6:00","600","18:00","1800","time","late","early","schedule","dawn","dusk"],"skins":[{"unified":"1f555","native":"\uD83D\uDD55"}],"version":1},"clock630":{"id":"clock630","name":"Six-Thirty","keywords":["clock630","six","thirty","6:30","630","18:30","1830","time","late","early","schedule"],"skins":[{"unified":"1f561","native":"\uD83D\uDD61"}],"version":1},"clock7":{"id":"clock7","name":"Seven O\u2019clock","keywords":["clock7","o","clock","7","7:00","700","19:00","1900","time","late","early","schedule"],"skins":[{"unified":"1f556","native":"\uD83D\uDD56"}],"version":1},"clock730":{"id":"clock730","name":"Seven-Thirty","keywords":["clock730","seven","thirty","7:30","730","19:30","1930","time","late","early","schedule"],"skins":[{"unified":"1f562","native":"\uD83D\uDD62"}],"version":1},"clock8":{"id":"clock8","name":"Eight O\u2019clock","keywords":["clock8","o","clock","8","8:00","800","20:00","2000","time","late","early","schedule"],"skins":[{"unified":"1f557","native":"\uD83D\uDD57"}],"version":1},"clock830":{"id":"clock830","name":"Eight-Thirty","keywords":["clock830","eight","thirty","8:30","830","20:30","2030","time","late","early","schedule"],"skins":[{"unified":"1f563","native":"\uD83D\uDD63"}],"version":1},"clock9":{"id":"clock9","name":"Nine O\u2019clock","keywords":["clock9","o","clock","9","9:00","900","21:00","2100","time","late","early","schedule"],"skins":[{"unified":"1f558","native":"\uD83D\uDD58"}],"version":1},"clock930":{"id":"clock930","name":"Nine-Thirty","keywords":["clock930","nine","thirty","9:30","930","21:30","2130","time","late","early","schedule"],"skins":[{"unified":"1f564","native":"\uD83D\uDD64"}],"version":1},"clock10":{"id":"clock10","name":"Ten O\u2019clock","keywords":["clock10","o","clock","10","10:00","1000","22:00","2200","time","late","early","schedule"],"skins":[{"unified":"1f559","native":"\uD83D\uDD59"}],"version":1},"clock1030":{"id":"clock1030","name":"Ten-Thirty","keywords":["clock1030","ten","thirty","10:30","1030","22:30","2230","time","late","early","schedule"],"skins":[{"unified":"1f565","native":"\uD83D\uDD65"}],"version":1},"clock11":{"id":"clock11","name":"Eleven O\u2019clock","keywords":["clock11","o","clock","11","11:00","1100","23:00","2300","time","late","early","schedule"],"skins":[{"unified":"1f55a","native":"\uD83D\uDD5A"}],"version":1},"clock1130":{"id":"clock1130","name":"Eleven-Thirty","keywords":["clock1130","eleven","thirty","11:30","1130","23:30","2330","time","late","early","schedule"],"skins":[{"unified":"1f566","native":"\uD83D\uDD66"}],"version":1},"new_moon":{"id":"new_moon","name":"New Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f311","native":"\uD83C\uDF11"}],"version":1},"waxing_crescent_moon":{"id":"waxing_crescent_moon","name":"Waxing Crescent Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f312","native":"\uD83C\uDF12"}],"version":1},"first_quarter_moon":{"id":"first_quarter_moon","name":"First Quarter Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f313","native":"\uD83C\uDF13"}],"version":1},"moon":{"id":"moon","name":"Waxing Gibbous Moon","keywords":["nature","night","sky","gray","twilight","planet","space","evening","sleep"],"skins":[{"unified":"1f314","native":"\uD83C\uDF14"}],"version":1},"full_moon":{"id":"full_moon","name":"Full Moon","keywords":["nature","yellow","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f315","native":"\uD83C\uDF15"}],"version":1},"waning_gibbous_moon":{"id":"waning_gibbous_moon","name":"Waning Gibbous Moon","keywords":["nature","twilight","planet","space","night","evening","sleep","waxing"],"skins":[{"unified":"1f316","native":"\uD83C\uDF16"}],"version":1},"last_quarter_moon":{"id":"last_quarter_moon","name":"Last Quarter Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f317","native":"\uD83C\uDF17"}],"version":1},"waning_crescent_moon":{"id":"waning_crescent_moon","name":"Waning Crescent Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f318","native":"\uD83C\uDF18"}],"version":1},"crescent_moon":{"id":"crescent_moon","name":"Crescent Moon","keywords":["night","sleep","sky","evening","magic"],"skins":[{"unified":"1f319","native":"\uD83C\uDF19"}],"version":1},"new_moon_with_face":{"id":"new_moon_with_face","name":"New Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31a","native":"\uD83C\uDF1A"}],"version":1},"first_quarter_moon_with_face":{"id":"first_quarter_moon_with_face","name":"First Quarter Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31b","native":"\uD83C\uDF1B"}],"version":1},"last_quarter_moon_with_face":{"id":"last_quarter_moon_with_face","name":"Last Quarter Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31c","native":"\uD83C\uDF1C"}],"version":1},"thermometer":{"id":"thermometer","name":"Thermometer","keywords":["weather","temperature","hot","cold"],"skins":[{"unified":"1f321-fe0f","native":"\uD83C\uDF21\uFE0F"}],"version":1},"sunny":{"id":"sunny","name":"Sun","keywords":["sunny","weather","nature","brightness","summer","beach","spring"],"skins":[{"unified":"2600-fe0f","native":"\u2600\uFE0F"}],"version":1},"full_moon_with_face":{"id":"full_moon_with_face","name":"Full Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31d","native":"\uD83C\uDF1D"}],"version":1},"sun_with_face":{"id":"sun_with_face","name":"Sun with Face","keywords":["nature","morning","sky"],"skins":[{"unified":"1f31e","native":"\uD83C\uDF1E"}],"version":1},"ringed_planet":{"id":"ringed_planet","name":"Ringed Planet","keywords":["outerspace"],"skins":[{"unified":"1fa90","native":"\uD83E\uDE90"}],"version":12},"star":{"id":"star","name":"Star","keywords":["night","yellow"],"skins":[{"unified":"2b50","native":"\u2B50"}],"version":1},"star2":{"id":"star2","name":"Glowing Star","keywords":["star2","night","sparkle","awesome","good","magic"],"skins":[{"unified":"1f31f","native":"\uD83C\uDF1F"}],"version":1},"stars":{"id":"stars","name":"Shooting Star","keywords":["stars","night","photo"],"skins":[{"unified":"1f320","native":"\uD83C\uDF20"}],"version":1},"milky_way":{"id":"milky_way","name":"Milky Way","keywords":["photo","space","stars"],"skins":[{"unified":"1f30c","native":"\uD83C\uDF0C"}],"version":1},"cloud":{"id":"cloud","name":"Cloud","keywords":["weather","sky"],"skins":[{"unified":"2601-fe0f","native":"\u2601\uFE0F"}],"version":1},"partly_sunny":{"id":"partly_sunny","name":"Sun Behind Cloud","keywords":["partly","sunny","weather","nature","cloudy","morning","fall","spring"],"skins":[{"unified":"26c5","native":"\u26C5"}],"version":1},"thunder_cloud_and_rain":{"id":"thunder_cloud_and_rain","name":"Cloud with Lightning and Rain","keywords":["thunder","weather"],"skins":[{"unified":"26c8-fe0f","native":"\u26C8\uFE0F"}],"version":1},"mostly_sunny":{"id":"mostly_sunny","name":"Sun Behind Small Cloud","keywords":["mostly","sunny","weather"],"skins":[{"unified":"1f324-fe0f","native":"\uD83C\uDF24\uFE0F"}],"version":1},"barely_sunny":{"id":"barely_sunny","name":"Sun Behind Large Cloud","keywords":["barely","sunny","weather"],"skins":[{"unified":"1f325-fe0f","native":"\uD83C\uDF25\uFE0F"}],"version":1},"partly_sunny_rain":{"id":"partly_sunny_rain","name":"Sun Behind Rain Cloud","keywords":["partly","sunny","weather"],"skins":[{"unified":"1f326-fe0f","native":"\uD83C\uDF26\uFE0F"}],"version":1},"rain_cloud":{"id":"rain_cloud","name":"Cloud with Rain","keywords":["weather"],"skins":[{"unified":"1f327-fe0f","native":"\uD83C\uDF27\uFE0F"}],"version":1},"snow_cloud":{"id":"snow_cloud","name":"Cloud with Snow","keywords":["weather"],"skins":[{"unified":"1f328-fe0f","native":"\uD83C\uDF28\uFE0F"}],"version":1},"lightning":{"id":"lightning","name":"Cloud with Lightning","keywords":["weather","thunder"],"skins":[{"unified":"1f329-fe0f","native":"\uD83C\uDF29\uFE0F"}],"version":1},"tornado":{"id":"tornado","name":"Tornado","keywords":["cloud","weather","cyclone","twister"],"skins":[{"unified":"1f32a-fe0f","native":"\uD83C\uDF2A\uFE0F"}],"version":1},"fog":{"id":"fog","name":"Fog","keywords":["weather"],"skins":[{"unified":"1f32b-fe0f","native":"\uD83C\uDF2B\uFE0F"}],"version":1},"wind_blowing_face":{"id":"wind_blowing_face","name":"Wind Face","keywords":["blowing","gust","air"],"skins":[{"unified":"1f32c-fe0f","native":"\uD83C\uDF2C\uFE0F"}],"version":1},"cyclone":{"id":"cyclone","name":"Cyclone","keywords":["weather","swirl","blue","cloud","vortex","spiral","whirlpool","spin","tornado","hurricane","typhoon"],"skins":[{"unified":"1f300","native":"\uD83C\uDF00"}],"version":1},"rainbow":{"id":"rainbow","name":"Rainbow","keywords":["nature","happy","unicorn","face","photo","sky","spring"],"skins":[{"unified":"1f308","native":"\uD83C\uDF08"}],"version":1},"closed_umbrella":{"id":"closed_umbrella","name":"Closed Umbrella","keywords":["weather","rain","drizzle"],"skins":[{"unified":"1f302","native":"\uD83C\uDF02"}],"version":1},"umbrella":{"id":"umbrella","name":"Umbrella","keywords":["weather","spring"],"skins":[{"unified":"2602-fe0f","native":"\u2602\uFE0F"}],"version":1},"umbrella_with_rain_drops":{"id":"umbrella_with_rain_drops","name":"Umbrella with Rain Drops","keywords":["rainy","weather","spring"],"skins":[{"unified":"2614","native":"\u2614"}],"version":1},"umbrella_on_ground":{"id":"umbrella_on_ground","name":"Umbrella on Ground","keywords":["weather","summer"],"skins":[{"unified":"26f1-fe0f","native":"\u26F1\uFE0F"}],"version":1},"zap":{"id":"zap","name":"High Voltage","keywords":["zap","thunder","weather","lightning","bolt","fast"],"skins":[{"unified":"26a1","native":"\u26A1"}],"version":1},"snowflake":{"id":"snowflake","name":"Snowflake","keywords":["winter","season","cold","weather","christmas","xmas"],"skins":[{"unified":"2744-fe0f","native":"\u2744\uFE0F"}],"version":1},"snowman":{"id":"snowman","name":"Snowman","keywords":["winter","season","cold","weather","christmas","xmas","frozen"],"skins":[{"unified":"2603-fe0f","native":"\u2603\uFE0F"}],"version":1},"snowman_without_snow":{"id":"snowman_without_snow","name":"Snowman Without Snow","keywords":["winter","season","cold","weather","christmas","xmas","frozen"],"skins":[{"unified":"26c4","native":"\u26C4"}],"version":1},"comet":{"id":"comet","name":"Comet","keywords":["space"],"skins":[{"unified":"2604-fe0f","native":"\u2604\uFE0F"}],"version":1},"fire":{"id":"fire","name":"Fire","keywords":["hot","cook","flame"],"skins":[{"unified":"1f525","native":"\uD83D\uDD25"}],"version":1},"droplet":{"id":"droplet","name":"Droplet","keywords":["water","drip","faucet","spring"],"skins":[{"unified":"1f4a7","native":"\uD83D\uDCA7"}],"version":1},"ocean":{"id":"ocean","name":"Water Wave","keywords":["ocean","sea","nature","tsunami","disaster"],"skins":[{"unified":"1f30a","native":"\uD83C\uDF0A"}],"version":1},"jack_o_lantern":{"id":"jack_o_lantern","name":"Jack-O-Lantern","keywords":["jack","o","lantern","halloween","light","pumpkin","creepy","fall"],"skins":[{"unified":"1f383","native":"\uD83C\uDF83"}],"version":1},"christmas_tree":{"id":"christmas_tree","name":"Christmas Tree","keywords":["festival","vacation","december","xmas","celebration"],"skins":[{"unified":"1f384","native":"\uD83C\uDF84"}],"version":1},"fireworks":{"id":"fireworks","name":"Fireworks","keywords":["photo","festival","carnival","congratulations"],"skins":[{"unified":"1f386","native":"\uD83C\uDF86"}],"version":1},"sparkler":{"id":"sparkler","name":"Sparkler","keywords":["stars","night","shine"],"skins":[{"unified":"1f387","native":"\uD83C\uDF87"}],"version":1},"firecracker":{"id":"firecracker","name":"Firecracker","keywords":["dynamite","boom","explode","explosion","explosive"],"skins":[{"unified":"1f9e8","native":"\uD83E\uDDE8"}],"version":11},"sparkles":{"id":"sparkles","name":"Sparkles","keywords":["stars","shine","shiny","cool","awesome","good","magic"],"skins":[{"unified":"2728","native":"\u2728"}],"version":1},"balloon":{"id":"balloon","name":"Balloon","keywords":["party","celebration","birthday","circus"],"skins":[{"unified":"1f388","native":"\uD83C\uDF88"}],"version":1},"tada":{"id":"tada","name":"Party Popper","keywords":["tada","congratulations","birthday","magic","circus","celebration"],"skins":[{"unified":"1f389","native":"\uD83C\uDF89"}],"version":1},"confetti_ball":{"id":"confetti_ball","name":"Confetti Ball","keywords":["festival","party","birthday","circus"],"skins":[{"unified":"1f38a","native":"\uD83C\uDF8A"}],"version":1},"tanabata_tree":{"id":"tanabata_tree","name":"Tanabata Tree","keywords":["plant","nature","branch","summer","bamboo","wish","star","festival","tanzaku"],"skins":[{"unified":"1f38b","native":"\uD83C\uDF8B"}],"version":1},"bamboo":{"id":"bamboo","name":"Pine Decoration","keywords":["bamboo","japanese","plant","nature","vegetable","panda","new","years"],"skins":[{"unified":"1f38d","native":"\uD83C\uDF8D"}],"version":1},"dolls":{"id":"dolls","name":"Japanese Dolls","keywords":["toy","kimono"],"skins":[{"unified":"1f38e","native":"\uD83C\uDF8E"}],"version":1},"flags":{"id":"flags","name":"Carp Streamer","keywords":["flags","fish","japanese","koinobori","banner"],"skins":[{"unified":"1f38f","native":"\uD83C\uDF8F"}],"version":1},"wind_chime":{"id":"wind_chime","name":"Wind Chime","keywords":["nature","ding","spring","bell"],"skins":[{"unified":"1f390","native":"\uD83C\uDF90"}],"version":1},"rice_scene":{"id":"rice_scene","name":"Moon Viewing Ceremony","keywords":["rice","scene","photo","japan","asia","tsukimi"],"skins":[{"unified":"1f391","native":"\uD83C\uDF91"}],"version":1},"red_envelope":{"id":"red_envelope","name":"Red Envelope","keywords":["gift"],"skins":[{"unified":"1f9e7","native":"\uD83E\uDDE7"}],"version":11},"ribbon":{"id":"ribbon","name":"Ribbon","keywords":["decoration","pink","girl","bowtie"],"skins":[{"unified":"1f380","native":"\uD83C\uDF80"}],"version":1},"gift":{"id":"gift","name":"Wrapped Gift","keywords":["present","birthday","christmas","xmas"],"skins":[{"unified":"1f381","native":"\uD83C\uDF81"}],"version":1},"reminder_ribbon":{"id":"reminder_ribbon","name":"Reminder Ribbon","keywords":["sports","cause","support","awareness"],"skins":[{"unified":"1f397-fe0f","native":"\uD83C\uDF97\uFE0F"}],"version":1},"admission_tickets":{"id":"admission_tickets","name":"Admission Tickets","keywords":["sports","concert","entrance"],"skins":[{"unified":"1f39f-fe0f","native":"\uD83C\uDF9F\uFE0F"}],"version":1},"ticket":{"id":"ticket","name":"Ticket","keywords":["event","concert","pass"],"skins":[{"unified":"1f3ab","native":"\uD83C\uDFAB"}],"version":1},"medal":{"id":"medal","name":"Military Medal","keywords":["award","winning","army"],"skins":[{"unified":"1f396-fe0f","native":"\uD83C\uDF96\uFE0F"}],"version":1},"trophy":{"id":"trophy","name":"Trophy","keywords":["win","award","contest","place","ftw","ceremony"],"skins":[{"unified":"1f3c6","native":"\uD83C\uDFC6"}],"version":1},"sports_medal":{"id":"sports_medal","name":"Sports Medal","keywords":["award","winning"],"skins":[{"unified":"1f3c5","native":"\uD83C\uDFC5"}],"version":1},"first_place_medal":{"id":"first_place_medal","name":"1st Place Medal","keywords":["first","award","winning"],"skins":[{"unified":"1f947","native":"\uD83E\uDD47"}],"version":3},"second_place_medal":{"id":"second_place_medal","name":"2nd Place Medal","keywords":["second","award"],"skins":[{"unified":"1f948","native":"\uD83E\uDD48"}],"version":3},"third_place_medal":{"id":"third_place_medal","name":"3rd Place Medal","keywords":["third","award"],"skins":[{"unified":"1f949","native":"\uD83E\uDD49"}],"version":3},"soccer":{"id":"soccer","name":"Soccer Ball","keywords":["sports","football"],"skins":[{"unified":"26bd","native":"\u26BD"}],"version":1},"baseball":{"id":"baseball","name":"Baseball","keywords":["sports","balls"],"skins":[{"unified":"26be","native":"\u26BE"}],"version":1},"softball":{"id":"softball","name":"Softball","keywords":["sports","balls"],"skins":[{"unified":"1f94e","native":"\uD83E\uDD4E"}],"version":11},"basketball":{"id":"basketball","name":"Basketball","keywords":["sports","balls","NBA"],"skins":[{"unified":"1f3c0","native":"\uD83C\uDFC0"}],"version":1},"volleyball":{"id":"volleyball","name":"Volleyball","keywords":["sports","balls"],"skins":[{"unified":"1f3d0","native":"\uD83C\uDFD0"}],"version":1},"football":{"id":"football","name":"American Football","keywords":["sports","balls","NFL"],"skins":[{"unified":"1f3c8","native":"\uD83C\uDFC8"}],"version":1},"rugby_football":{"id":"rugby_football","name":"Rugby Football","keywords":["sports","team"],"skins":[{"unified":"1f3c9","native":"\uD83C\uDFC9"}],"version":1},"tennis":{"id":"tennis","name":"Tennis","keywords":["sports","balls","green"],"skins":[{"unified":"1f3be","native":"\uD83C\uDFBE"}],"version":1},"flying_disc":{"id":"flying_disc","name":"Flying Disc","keywords":["sports","frisbee","ultimate"],"skins":[{"unified":"1f94f","native":"\uD83E\uDD4F"}],"version":11},"bowling":{"id":"bowling","name":"Bowling","keywords":["sports","fun","play"],"skins":[{"unified":"1f3b3","native":"\uD83C\uDFB3"}],"version":1},"cricket_bat_and_ball":{"id":"cricket_bat_and_ball","name":"Cricket Game","keywords":["bat","and","ball","sports"],"skins":[{"unified":"1f3cf","native":"\uD83C\uDFCF"}],"version":1},"field_hockey_stick_and_ball":{"id":"field_hockey_stick_and_ball","name":"Field Hockey","keywords":["stick","and","ball","sports"],"skins":[{"unified":"1f3d1","native":"\uD83C\uDFD1"}],"version":1},"ice_hockey_stick_and_puck":{"id":"ice_hockey_stick_and_puck","name":"Ice Hockey","keywords":["stick","and","puck","sports"],"skins":[{"unified":"1f3d2","native":"\uD83C\uDFD2"}],"version":1},"lacrosse":{"id":"lacrosse","name":"Lacrosse","keywords":["sports","ball","stick"],"skins":[{"unified":"1f94d","native":"\uD83E\uDD4D"}],"version":11},"table_tennis_paddle_and_ball":{"id":"table_tennis_paddle_and_ball","name":"Ping Pong","keywords":["table","tennis","paddle","and","ball","sports","pingpong"],"skins":[{"unified":"1f3d3","native":"\uD83C\uDFD3"}],"version":1},"badminton_racquet_and_shuttlecock":{"id":"badminton_racquet_and_shuttlecock","name":"Badminton","keywords":["racquet","and","shuttlecock","sports"],"skins":[{"unified":"1f3f8","native":"\uD83C\uDFF8"}],"version":1},"boxing_glove":{"id":"boxing_glove","name":"Boxing Glove","keywords":["sports","fighting"],"skins":[{"unified":"1f94a","native":"\uD83E\uDD4A"}],"version":3},"martial_arts_uniform":{"id":"martial_arts_uniform","name":"Martial Arts Uniform","keywords":["judo","karate","taekwondo"],"skins":[{"unified":"1f94b","native":"\uD83E\uDD4B"}],"version":3},"goal_net":{"id":"goal_net","name":"Goal Net","keywords":["sports"],"skins":[{"unified":"1f945","native":"\uD83E\uDD45"}],"version":3},"golf":{"id":"golf","name":"Flag in Hole","keywords":["golf","sports","business","summer"],"skins":[{"unified":"26f3","native":"\u26F3"}],"version":1},"ice_skate":{"id":"ice_skate","name":"Ice Skate","keywords":["sports"],"skins":[{"unified":"26f8-fe0f","native":"\u26F8\uFE0F"}],"version":1},"fishing_pole_and_fish":{"id":"fishing_pole_and_fish","name":"Fishing Pole","keywords":["and","fish","food","hobby","summer"],"skins":[{"unified":"1f3a3","native":"\uD83C\uDFA3"}],"version":1},"diving_mask":{"id":"diving_mask","name":"Diving Mask","keywords":["sport","ocean"],"skins":[{"unified":"1f93f","native":"\uD83E\uDD3F"}],"version":12},"running_shirt_with_sash":{"id":"running_shirt_with_sash","name":"Running Shirt","keywords":["with","sash","play","pageant"],"skins":[{"unified":"1f3bd","native":"\uD83C\uDFBD"}],"version":1},"ski":{"id":"ski","name":"Skis","keywords":["ski","sports","winter","cold","snow"],"skins":[{"unified":"1f3bf","native":"\uD83C\uDFBF"}],"version":1},"sled":{"id":"sled","name":"Sled","keywords":["sleigh","luge","toboggan"],"skins":[{"unified":"1f6f7","native":"\uD83D\uDEF7"}],"version":5},"curling_stone":{"id":"curling_stone","name":"Curling Stone","keywords":["sports"],"skins":[{"unified":"1f94c","native":"\uD83E\uDD4C"}],"version":5},"dart":{"id":"dart","name":"Bullseye","keywords":["dart","direct","hit","game","play","bar","target"],"skins":[{"unified":"1f3af","native":"\uD83C\uDFAF"}],"version":1},"yo-yo":{"id":"yo-yo","name":"Yo-Yo","keywords":["yo","toy"],"skins":[{"unified":"1fa80","native":"\uD83E\uDE80"}],"version":12},"kite":{"id":"kite","name":"Kite","keywords":["wind","fly"],"skins":[{"unified":"1fa81","native":"\uD83E\uDE81"}],"version":12},"gun":{"id":"gun","name":"Pistol","keywords":["gun","violence","weapon","revolver"],"skins":[{"unified":"1f52b","native":"\uD83D\uDD2B"}],"version":1},"8ball":{"id":"8ball","name":"Billiards","keywords":["8ball","pool","8","ball","hobby","game","luck","magic"],"skins":[{"unified":"1f3b1","native":"\uD83C\uDFB1"}],"version":1},"crystal_ball":{"id":"crystal_ball","name":"Crystal Ball","keywords":["disco","party","magic","circus","fortune","teller"],"skins":[{"unified":"1f52e","native":"\uD83D\uDD2E"}],"version":1},"magic_wand":{"id":"magic_wand","name":"Magic Wand","keywords":["supernature","power"],"skins":[{"unified":"1fa84","native":"\uD83E\uDE84"}],"version":13},"video_game":{"id":"video_game","name":"Video Game","keywords":["play","console","PS4","controller"],"skins":[{"unified":"1f3ae","native":"\uD83C\uDFAE"}],"version":1},"joystick":{"id":"joystick","name":"Joystick","keywords":["game","play"],"skins":[{"unified":"1f579-fe0f","native":"\uD83D\uDD79\uFE0F"}],"version":1},"slot_machine":{"id":"slot_machine","name":"Slot Machine","keywords":["bet","gamble","vegas","fruit","luck","casino"],"skins":[{"unified":"1f3b0","native":"\uD83C\uDFB0"}],"version":1},"game_die":{"id":"game_die","name":"Game Die","keywords":["dice","random","tabletop","play","luck"],"skins":[{"unified":"1f3b2","native":"\uD83C\uDFB2"}],"version":1},"jigsaw":{"id":"jigsaw","name":"Puzzle Piece","keywords":["jigsaw","interlocking"],"skins":[{"unified":"1f9e9","native":"\uD83E\uDDE9"}],"version":11},"teddy_bear":{"id":"teddy_bear","name":"Teddy Bear","keywords":["plush","stuffed"],"skins":[{"unified":"1f9f8","native":"\uD83E\uDDF8"}],"version":11},"pinata":{"id":"pinata","name":"Pinata","keywords":["mexico","candy","celebration"],"skins":[{"unified":"1fa85","native":"\uD83E\uDE85"}],"version":13},"mirror_ball":{"id":"mirror_ball","name":"Mirror Ball","keywords":["disco","dance","party"],"skins":[{"unified":"1faa9","native":"\uD83E\uDEA9"}],"version":14},"nesting_dolls":{"id":"nesting_dolls","name":"Nesting Dolls","keywords":["matryoshka","toy"],"skins":[{"unified":"1fa86","native":"\uD83E\uDE86"}],"version":13},"spades":{"id":"spades","name":"Spade Suit","keywords":["spades","poker","cards","suits","magic"],"skins":[{"unified":"2660-fe0f","native":"\u2660\uFE0F"}],"version":1},"hearts":{"id":"hearts","name":"Heart Suit","keywords":["hearts","poker","cards","magic","suits"],"skins":[{"unified":"2665-fe0f","native":"\u2665\uFE0F"}],"version":1},"diamonds":{"id":"diamonds","name":"Diamond Suit","keywords":["diamonds","poker","cards","magic","suits"],"skins":[{"unified":"2666-fe0f","native":"\u2666\uFE0F"}],"version":1},"clubs":{"id":"clubs","name":"Club Suit","keywords":["clubs","poker","cards","magic","suits"],"skins":[{"unified":"2663-fe0f","native":"\u2663\uFE0F"}],"version":1},"chess_pawn":{"id":"chess_pawn","name":"Chess Pawn","keywords":["expendable"],"skins":[{"unified":"265f-fe0f","native":"\u265F\uFE0F"}],"version":11},"black_joker":{"id":"black_joker","name":"Joker","keywords":["black","poker","cards","game","play","magic"],"skins":[{"unified":"1f0cf","native":"\uD83C\uDCCF"}],"version":1},"mahjong":{"id":"mahjong","name":"Mahjong Red Dragon","keywords":["game","play","chinese","kanji"],"skins":[{"unified":"1f004","native":"\uD83C\uDC04"}],"version":1},"flower_playing_cards":{"id":"flower_playing_cards","name":"Flower Playing Cards","keywords":["game","sunset","red"],"skins":[{"unified":"1f3b4","native":"\uD83C\uDFB4"}],"version":1},"performing_arts":{"id":"performing_arts","name":"Performing Arts","keywords":["acting","theater","drama"],"skins":[{"unified":"1f3ad","native":"\uD83C\uDFAD"}],"version":1},"frame_with_picture":{"id":"frame_with_picture","name":"Framed Picture","keywords":["frame","with","photography"],"skins":[{"unified":"1f5bc-fe0f","native":"\uD83D\uDDBC\uFE0F"}],"version":1},"art":{"id":"art","name":"Artist Palette","keywords":["art","design","paint","draw","colors"],"skins":[{"unified":"1f3a8","native":"\uD83C\uDFA8"}],"version":1},"thread":{"id":"thread","name":"Thread","keywords":["needle","sewing","spool","string"],"skins":[{"unified":"1f9f5","native":"\uD83E\uDDF5"}],"version":11},"sewing_needle":{"id":"sewing_needle","name":"Sewing Needle","keywords":["stitches"],"skins":[{"unified":"1faa1","native":"\uD83E\uDEA1"}],"version":13},"yarn":{"id":"yarn","name":"Yarn","keywords":["ball","crochet","knit"],"skins":[{"unified":"1f9f6","native":"\uD83E\uDDF6"}],"version":11},"knot":{"id":"knot","name":"Knot","keywords":["rope","scout"],"skins":[{"unified":"1faa2","native":"\uD83E\uDEA2"}],"version":13},"eyeglasses":{"id":"eyeglasses","name":"Glasses","keywords":["eyeglasses","fashion","accessories","eyesight","nerdy","dork","geek"],"skins":[{"unified":"1f453","native":"\uD83D\uDC53"}],"version":1},"dark_sunglasses":{"id":"dark_sunglasses","name":"Sunglasses","keywords":["dark","face","cool","accessories"],"skins":[{"unified":"1f576-fe0f","native":"\uD83D\uDD76\uFE0F"}],"version":1},"goggles":{"id":"goggles","name":"Goggles","keywords":["eyes","protection","safety"],"skins":[{"unified":"1f97d","native":"\uD83E\uDD7D"}],"version":11},"lab_coat":{"id":"lab_coat","name":"Lab Coat","keywords":["doctor","experiment","scientist","chemist"],"skins":[{"unified":"1f97c","native":"\uD83E\uDD7C"}],"version":11},"safety_vest":{"id":"safety_vest","name":"Safety Vest","keywords":["protection"],"skins":[{"unified":"1f9ba","native":"\uD83E\uDDBA"}],"version":12},"necktie":{"id":"necktie","name":"Necktie","keywords":["shirt","suitup","formal","fashion","cloth","business"],"skins":[{"unified":"1f454","native":"\uD83D\uDC54"}],"version":1},"shirt":{"id":"shirt","name":"T-Shirt","keywords":["shirt","tshirt","t","fashion","cloth","casual","tee"],"skins":[{"unified":"1f455","native":"\uD83D\uDC55"}],"version":1},"jeans":{"id":"jeans","name":"Jeans","keywords":["fashion","shopping"],"skins":[{"unified":"1f456","native":"\uD83D\uDC56"}],"version":1},"scarf":{"id":"scarf","name":"Scarf","keywords":["neck","winter","clothes"],"skins":[{"unified":"1f9e3","native":"\uD83E\uDDE3"}],"version":5},"gloves":{"id":"gloves","name":"Gloves","keywords":["hands","winter","clothes"],"skins":[{"unified":"1f9e4","native":"\uD83E\uDDE4"}],"version":5},"coat":{"id":"coat","name":"Coat","keywords":["jacket"],"skins":[{"unified":"1f9e5","native":"\uD83E\uDDE5"}],"version":5},"socks":{"id":"socks","name":"Socks","keywords":["stockings","clothes"],"skins":[{"unified":"1f9e6","native":"\uD83E\uDDE6"}],"version":5},"dress":{"id":"dress","name":"Dress","keywords":["clothes","fashion","shopping"],"skins":[{"unified":"1f457","native":"\uD83D\uDC57"}],"version":1},"kimono":{"id":"kimono","name":"Kimono","keywords":["dress","fashion","women","female","japanese"],"skins":[{"unified":"1f458","native":"\uD83D\uDC58"}],"version":1},"sari":{"id":"sari","name":"Sari","keywords":["dress"],"skins":[{"unified":"1f97b","native":"\uD83E\uDD7B"}],"version":12},"one-piece_swimsuit":{"id":"one-piece_swimsuit","name":"One-Piece Swimsuit","keywords":["one","piece","fashion"],"skins":[{"unified":"1fa71","native":"\uD83E\uDE71"}],"version":12},"briefs":{"id":"briefs","name":"Briefs","keywords":["clothing"],"skins":[{"unified":"1fa72","native":"\uD83E\uDE72"}],"version":12},"shorts":{"id":"shorts","name":"Shorts","keywords":["clothing"],"skins":[{"unified":"1fa73","native":"\uD83E\uDE73"}],"version":12},"bikini":{"id":"bikini","name":"Bikini","keywords":["swimming","female","woman","girl","fashion","beach","summer"],"skins":[{"unified":"1f459","native":"\uD83D\uDC59"}],"version":1},"womans_clothes":{"id":"womans_clothes","name":"Womans Clothes","keywords":["woman","s","fashion","shopping","bags","female"],"skins":[{"unified":"1f45a","native":"\uD83D\uDC5A"}],"version":1},"folding_hand_fan":{"id":"folding_hand_fan","name":"Folding Hand Fan","keywords":["flamenco","hot"],"skins":[{"unified":"1faad","native":"\uD83E\uDEAD"}],"version":15},"purse":{"id":"purse","name":"Purse","keywords":["fashion","accessories","money","sales","shopping"],"skins":[{"unified":"1f45b","native":"\uD83D\uDC5B"}],"version":1},"handbag":{"id":"handbag","name":"Handbag","keywords":["fashion","accessory","accessories","shopping"],"skins":[{"unified":"1f45c","native":"\uD83D\uDC5C"}],"version":1},"pouch":{"id":"pouch","name":"Pouch","keywords":["clutch","bag","accessories","shopping"],"skins":[{"unified":"1f45d","native":"\uD83D\uDC5D"}],"version":1},"shopping_bags":{"id":"shopping_bags","name":"Shopping Bags","keywords":["mall","buy","purchase"],"skins":[{"unified":"1f6cd-fe0f","native":"\uD83D\uDECD\uFE0F"}],"version":1},"school_satchel":{"id":"school_satchel","name":"Backpack","keywords":["school","satchel","student","education","bag"],"skins":[{"unified":"1f392","native":"\uD83C\uDF92"}],"version":1},"thong_sandal":{"id":"thong_sandal","name":"Thong Sandal","keywords":["footwear","summer"],"skins":[{"unified":"1fa74","native":"\uD83E\uDE74"}],"version":13},"mans_shoe":{"id":"mans_shoe","name":"Mans Shoe","keywords":["man","s","fashion","male"],"skins":[{"unified":"1f45e","native":"\uD83D\uDC5E"}],"version":1},"athletic_shoe":{"id":"athletic_shoe","name":"Running Shoe","keywords":["athletic","shoes","sports","sneakers"],"skins":[{"unified":"1f45f","native":"\uD83D\uDC5F"}],"version":1},"hiking_boot":{"id":"hiking_boot","name":"Hiking Boot","keywords":["backpacking","camping"],"skins":[{"unified":"1f97e","native":"\uD83E\uDD7E"}],"version":11},"womans_flat_shoe":{"id":"womans_flat_shoe","name":"Flat Shoe","keywords":["womans","ballet","slip","on","slipper"],"skins":[{"unified":"1f97f","native":"\uD83E\uDD7F"}],"version":11},"high_heel":{"id":"high_heel","name":"High-Heeled Shoe","keywords":["high","heel","heeled","fashion","shoes","female","pumps","stiletto"],"skins":[{"unified":"1f460","native":"\uD83D\uDC60"}],"version":1},"sandal":{"id":"sandal","name":"Womans Sandal","keywords":["woman","s","shoes","fashion","flip","flops"],"skins":[{"unified":"1f461","native":"\uD83D\uDC61"}],"version":1},"ballet_shoes":{"id":"ballet_shoes","name":"Ballet Shoes","keywords":["dance"],"skins":[{"unified":"1fa70","native":"\uD83E\uDE70"}],"version":12},"boot":{"id":"boot","name":"Womans Boots","keywords":["boot","woman","s","shoes","fashion"],"skins":[{"unified":"1f462","native":"\uD83D\uDC62"}],"version":1},"hair_pick":{"id":"hair_pick","name":"Hair Pick","keywords":["afro","comb"],"skins":[{"unified":"1faae","native":"\uD83E\uDEAE"}],"version":15},"crown":{"id":"crown","name":"Crown","keywords":["king","kod","leader","royalty","lord"],"skins":[{"unified":"1f451","native":"\uD83D\uDC51"}],"version":1},"womans_hat":{"id":"womans_hat","name":"Womans Hat","keywords":["woman","s","fashion","accessories","female","lady","spring"],"skins":[{"unified":"1f452","native":"\uD83D\uDC52"}],"version":1},"tophat":{"id":"tophat","name":"Top Hat","keywords":["tophat","magic","gentleman","classy","circus"],"skins":[{"unified":"1f3a9","native":"\uD83C\uDFA9"}],"version":1},"mortar_board":{"id":"mortar_board","name":"Graduation Cap","keywords":["mortar","board","school","college","degree","university","hat","legal","learn","education"],"skins":[{"unified":"1f393","native":"\uD83C\uDF93"}],"version":1},"billed_cap":{"id":"billed_cap","name":"Billed Cap","keywords":["baseball"],"skins":[{"unified":"1f9e2","native":"\uD83E\uDDE2"}],"version":5},"military_helmet":{"id":"military_helmet","name":"Military Helmet","keywords":["army","protection"],"skins":[{"unified":"1fa96","native":"\uD83E\uDE96"}],"version":13},"helmet_with_white_cross":{"id":"helmet_with_white_cross","name":"Rescue Worker\u2019s Helmet","keywords":["with","white","cross","worker","s","construction","build"],"skins":[{"unified":"26d1-fe0f","native":"\u26D1\uFE0F"}],"version":1},"prayer_beads":{"id":"prayer_beads","name":"Prayer Beads","keywords":["dhikr","religious"],"skins":[{"unified":"1f4ff","native":"\uD83D\uDCFF"}],"version":1},"lipstick":{"id":"lipstick","name":"Lipstick","keywords":["female","girl","fashion","woman"],"skins":[{"unified":"1f484","native":"\uD83D\uDC84"}],"version":1},"ring":{"id":"ring","name":"Ring","keywords":["wedding","propose","marriage","valentines","diamond","fashion","jewelry","gem","engagement"],"skins":[{"unified":"1f48d","native":"\uD83D\uDC8D"}],"version":1},"gem":{"id":"gem","name":"Gem Stone","keywords":["blue","ruby","diamond","jewelry"],"skins":[{"unified":"1f48e","native":"\uD83D\uDC8E"}],"version":1},"mute":{"id":"mute","name":"Muted Speaker","keywords":["mute","sound","volume","silence","quiet"],"skins":[{"unified":"1f507","native":"\uD83D\uDD07"}],"version":1},"speaker":{"id":"speaker","name":"Speaker","keywords":["low","volume","sound","silence","broadcast"],"skins":[{"unified":"1f508","native":"\uD83D\uDD08"}],"version":1},"sound":{"id":"sound","name":"Speaker Medium Volume","keywords":["sound","broadcast"],"skins":[{"unified":"1f509","native":"\uD83D\uDD09"}],"version":1},"loud_sound":{"id":"loud_sound","name":"Speaker High Volume","keywords":["loud","sound","noise","noisy","broadcast"],"skins":[{"unified":"1f50a","native":"\uD83D\uDD0A"}],"version":1},"loudspeaker":{"id":"loudspeaker","name":"Loudspeaker","keywords":["volume","sound"],"skins":[{"unified":"1f4e2","native":"\uD83D\uDCE2"}],"version":1},"mega":{"id":"mega","name":"Megaphone","keywords":["mega","sound","speaker","volume"],"skins":[{"unified":"1f4e3","native":"\uD83D\uDCE3"}],"version":1},"postal_horn":{"id":"postal_horn","name":"Postal Horn","keywords":["instrument","music"],"skins":[{"unified":"1f4ef","native":"\uD83D\uDCEF"}],"version":1},"bell":{"id":"bell","name":"Bell","keywords":["sound","notification","christmas","xmas","chime"],"skins":[{"unified":"1f514","native":"\uD83D\uDD14"}],"version":1},"no_bell":{"id":"no_bell","name":"Bell with Slash","keywords":["no","sound","volume","mute","quiet","silent"],"skins":[{"unified":"1f515","native":"\uD83D\uDD15"}],"version":1},"musical_score":{"id":"musical_score","name":"Musical Score","keywords":["treble","clef","compose"],"skins":[{"unified":"1f3bc","native":"\uD83C\uDFBC"}],"version":1},"musical_note":{"id":"musical_note","name":"Musical Note","keywords":["score","tone","sound"],"skins":[{"unified":"1f3b5","native":"\uD83C\uDFB5"}],"version":1},"notes":{"id":"notes","name":"Musical Notes","keywords":["music","score"],"skins":[{"unified":"1f3b6","native":"\uD83C\uDFB6"}],"version":1},"studio_microphone":{"id":"studio_microphone","name":"Studio Microphone","keywords":["sing","recording","artist","talkshow"],"skins":[{"unified":"1f399-fe0f","native":"\uD83C\uDF99\uFE0F"}],"version":1},"level_slider":{"id":"level_slider","name":"Level Slider","keywords":["scale"],"skins":[{"unified":"1f39a-fe0f","native":"\uD83C\uDF9A\uFE0F"}],"version":1},"control_knobs":{"id":"control_knobs","name":"Control Knobs","keywords":["dial"],"skins":[{"unified":"1f39b-fe0f","native":"\uD83C\uDF9B\uFE0F"}],"version":1},"microphone":{"id":"microphone","name":"Microphone","keywords":["sound","music","PA","sing","talkshow"],"skins":[{"unified":"1f3a4","native":"\uD83C\uDFA4"}],"version":1},"headphones":{"id":"headphones","name":"Headphone","keywords":["headphones","music","score","gadgets"],"skins":[{"unified":"1f3a7","native":"\uD83C\uDFA7"}],"version":1},"radio":{"id":"radio","name":"Radio","keywords":["communication","music","podcast","program"],"skins":[{"unified":"1f4fb","native":"\uD83D\uDCFB"}],"version":1},"saxophone":{"id":"saxophone","name":"Saxophone","keywords":["music","instrument","jazz","blues"],"skins":[{"unified":"1f3b7","native":"\uD83C\uDFB7"}],"version":1},"accordion":{"id":"accordion","name":"Accordion","keywords":["music"],"skins":[{"unified":"1fa97","native":"\uD83E\uDE97"}],"version":13},"guitar":{"id":"guitar","name":"Guitar","keywords":["music","instrument"],"skins":[{"unified":"1f3b8","native":"\uD83C\uDFB8"}],"version":1},"musical_keyboard":{"id":"musical_keyboard","name":"Musical Keyboard","keywords":["piano","instrument","compose"],"skins":[{"unified":"1f3b9","native":"\uD83C\uDFB9"}],"version":1},"trumpet":{"id":"trumpet","name":"Trumpet","keywords":["music","brass"],"skins":[{"unified":"1f3ba","native":"\uD83C\uDFBA"}],"version":1},"violin":{"id":"violin","name":"Violin","keywords":["music","instrument","orchestra","symphony"],"skins":[{"unified":"1f3bb","native":"\uD83C\uDFBB"}],"version":1},"banjo":{"id":"banjo","name":"Banjo","keywords":["music","instructment"],"skins":[{"unified":"1fa95","native":"\uD83E\uDE95"}],"version":12},"drum_with_drumsticks":{"id":"drum_with_drumsticks","name":"Drum","keywords":["with","drumsticks","music","instrument","snare"],"skins":[{"unified":"1f941","native":"\uD83E\uDD41"}],"version":3},"long_drum":{"id":"long_drum","name":"Long Drum","keywords":["music"],"skins":[{"unified":"1fa98","native":"\uD83E\uDE98"}],"version":13},"maracas":{"id":"maracas","name":"Maracas","keywords":["music","instrument","percussion"],"skins":[{"unified":"1fa87","native":"\uD83E\uDE87"}],"version":15},"flute":{"id":"flute","name":"Flute","keywords":["bamboo","music","instrument","pied","piper"],"skins":[{"unified":"1fa88","native":"\uD83E\uDE88"}],"version":15},"iphone":{"id":"iphone","name":"Mobile Phone","keywords":["iphone","technology","apple","gadgets","dial"],"skins":[{"unified":"1f4f1","native":"\uD83D\uDCF1"}],"version":1},"calling":{"id":"calling","name":"Mobile Phone with Arrow","keywords":["calling","iphone","incoming"],"skins":[{"unified":"1f4f2","native":"\uD83D\uDCF2"}],"version":1},"phone":{"id":"phone","name":"Telephone","keywords":["phone","technology","communication","dial"],"skins":[{"unified":"260e-fe0f","native":"\u260E\uFE0F"}],"version":1},"telephone_receiver":{"id":"telephone_receiver","name":"Telephone Receiver","keywords":["technology","communication","dial"],"skins":[{"unified":"1f4de","native":"\uD83D\uDCDE"}],"version":1},"pager":{"id":"pager","name":"Pager","keywords":["bbcall","oldschool","90s"],"skins":[{"unified":"1f4df","native":"\uD83D\uDCDF"}],"version":1},"fax":{"id":"fax","name":"Fax Machine","keywords":["communication","technology"],"skins":[{"unified":"1f4e0","native":"\uD83D\uDCE0"}],"version":1},"battery":{"id":"battery","name":"Battery","keywords":["power","energy","sustain"],"skins":[{"unified":"1f50b","native":"\uD83D\uDD0B"}],"version":1},"low_battery":{"id":"low_battery","name":"Low Battery","keywords":["drained","dead"],"skins":[{"unified":"1faab","native":"\uD83E\uDEAB"}],"version":14},"electric_plug":{"id":"electric_plug","name":"Electric Plug","keywords":["charger","power"],"skins":[{"unified":"1f50c","native":"\uD83D\uDD0C"}],"version":1},"computer":{"id":"computer","name":"Laptop","keywords":["computer","technology","screen","display","monitor"],"skins":[{"unified":"1f4bb","native":"\uD83D\uDCBB"}],"version":1},"desktop_computer":{"id":"desktop_computer","name":"Desktop Computer","keywords":["technology","computing","screen"],"skins":[{"unified":"1f5a5-fe0f","native":"\uD83D\uDDA5\uFE0F"}],"version":1},"printer":{"id":"printer","name":"Printer","keywords":["paper","ink"],"skins":[{"unified":"1f5a8-fe0f","native":"\uD83D\uDDA8\uFE0F"}],"version":1},"keyboard":{"id":"keyboard","name":"Keyboard","keywords":["technology","computer","type","input","text"],"skins":[{"unified":"2328-fe0f","native":"\u2328\uFE0F"}],"version":1},"three_button_mouse":{"id":"three_button_mouse","name":"Computer Mouse","keywords":["three","button","click"],"skins":[{"unified":"1f5b1-fe0f","native":"\uD83D\uDDB1\uFE0F"}],"version":1},"trackball":{"id":"trackball","name":"Trackball","keywords":["technology","trackpad"],"skins":[{"unified":"1f5b2-fe0f","native":"\uD83D\uDDB2\uFE0F"}],"version":1},"minidisc":{"id":"minidisc","name":"Minidisc","keywords":["computer","disk","technology","record","data","90s"],"skins":[{"unified":"1f4bd","native":"\uD83D\uDCBD"}],"version":1},"floppy_disk":{"id":"floppy_disk","name":"Floppy Disk","keywords":["oldschool","technology","save","90s","80s"],"skins":[{"unified":"1f4be","native":"\uD83D\uDCBE"}],"version":1},"cd":{"id":"cd","name":"Optical Disc","keywords":["cd","disk","technology","dvd","90s"],"skins":[{"unified":"1f4bf","native":"\uD83D\uDCBF"}],"version":1},"dvd":{"id":"dvd","name":"Dvd","keywords":["cd","disk","disc"],"skins":[{"unified":"1f4c0","native":"\uD83D\uDCC0"}],"version":1},"abacus":{"id":"abacus","name":"Abacus","keywords":["calculation"],"skins":[{"unified":"1f9ee","native":"\uD83E\uDDEE"}],"version":11},"movie_camera":{"id":"movie_camera","name":"Movie Camera","keywords":["film","record"],"skins":[{"unified":"1f3a5","native":"\uD83C\uDFA5"}],"version":1},"film_frames":{"id":"film_frames","name":"Film Frames","keywords":["movie"],"skins":[{"unified":"1f39e-fe0f","native":"\uD83C\uDF9E\uFE0F"}],"version":1},"film_projector":{"id":"film_projector","name":"Film Projector","keywords":["video","tape","record","movie"],"skins":[{"unified":"1f4fd-fe0f","native":"\uD83D\uDCFD\uFE0F"}],"version":1},"clapper":{"id":"clapper","name":"Clapper Board","keywords":["movie","film","record"],"skins":[{"unified":"1f3ac","native":"\uD83C\uDFAC"}],"version":1},"tv":{"id":"tv","name":"Television","keywords":["tv","technology","program","oldschool","show"],"skins":[{"unified":"1f4fa","native":"\uD83D\uDCFA"}],"version":1},"camera":{"id":"camera","name":"Camera","keywords":["gadgets","photography"],"skins":[{"unified":"1f4f7","native":"\uD83D\uDCF7"}],"version":1},"camera_with_flash":{"id":"camera_with_flash","name":"Camera with Flash","keywords":["photography","gadgets"],"skins":[{"unified":"1f4f8","native":"\uD83D\uDCF8"}],"version":1},"video_camera":{"id":"video_camera","name":"Video Camera","keywords":["film","record"],"skins":[{"unified":"1f4f9","native":"\uD83D\uDCF9"}],"version":1},"vhs":{"id":"vhs","name":"Videocassette","keywords":["vhs","record","video","oldschool","90s","80s"],"skins":[{"unified":"1f4fc","native":"\uD83D\uDCFC"}],"version":1},"mag":{"id":"mag","name":"Magnifying Glass Tilted Left","keywords":["mag","search","zoom","find","detective"],"skins":[{"unified":"1f50d","native":"\uD83D\uDD0D"}],"version":1},"mag_right":{"id":"mag_right","name":"Magnifying Glass Tilted Right","keywords":["mag","search","zoom","find","detective"],"skins":[{"unified":"1f50e","native":"\uD83D\uDD0E"}],"version":1},"candle":{"id":"candle","name":"Candle","keywords":["fire","wax"],"skins":[{"unified":"1f56f-fe0f","native":"\uD83D\uDD6F\uFE0F"}],"version":1},"bulb":{"id":"bulb","name":"Light Bulb","keywords":["electricity","idea"],"skins":[{"unified":"1f4a1","native":"\uD83D\uDCA1"}],"version":1},"flashlight":{"id":"flashlight","name":"Flashlight","keywords":["dark","camping","sight","night"],"skins":[{"unified":"1f526","native":"\uD83D\uDD26"}],"version":1},"izakaya_lantern":{"id":"izakaya_lantern","name":"Izakaya Lantern","keywords":["red","paper","light","halloween","spooky"],"skins":[{"unified":"1f3ee","native":"\uD83C\uDFEE"}],"version":1},"diya_lamp":{"id":"diya_lamp","name":"Diya Lamp","keywords":["lighting"],"skins":[{"unified":"1fa94","native":"\uD83E\uDE94"}],"version":12},"notebook_with_decorative_cover":{"id":"notebook_with_decorative_cover","name":"Notebook with Decorative Cover","keywords":["classroom","notes","record","paper","study"],"skins":[{"unified":"1f4d4","native":"\uD83D\uDCD4"}],"version":1},"closed_book":{"id":"closed_book","name":"Closed Book","keywords":["read","library","knowledge","textbook","learn"],"skins":[{"unified":"1f4d5","native":"\uD83D\uDCD5"}],"version":1},"book":{"id":"book","name":"Open Book","keywords":["read","library","knowledge","literature","learn","study"],"skins":[{"unified":"1f4d6","native":"\uD83D\uDCD6"}],"version":1},"green_book":{"id":"green_book","name":"Green Book","keywords":["read","library","knowledge","study"],"skins":[{"unified":"1f4d7","native":"\uD83D\uDCD7"}],"version":1},"blue_book":{"id":"blue_book","name":"Blue Book","keywords":["read","library","knowledge","learn","study"],"skins":[{"unified":"1f4d8","native":"\uD83D\uDCD8"}],"version":1},"orange_book":{"id":"orange_book","name":"Orange Book","keywords":["read","library","knowledge","textbook","study"],"skins":[{"unified":"1f4d9","native":"\uD83D\uDCD9"}],"version":1},"books":{"id":"books","name":"Books","keywords":["literature","library","study"],"skins":[{"unified":"1f4da","native":"\uD83D\uDCDA"}],"version":1},"notebook":{"id":"notebook","name":"Notebook","keywords":["stationery","record","notes","paper","study"],"skins":[{"unified":"1f4d3","native":"\uD83D\uDCD3"}],"version":1},"ledger":{"id":"ledger","name":"Ledger","keywords":["notes","paper"],"skins":[{"unified":"1f4d2","native":"\uD83D\uDCD2"}],"version":1},"page_with_curl":{"id":"page_with_curl","name":"Page with Curl","keywords":["documents","office","paper"],"skins":[{"unified":"1f4c3","native":"\uD83D\uDCC3"}],"version":1},"scroll":{"id":"scroll","name":"Scroll","keywords":["documents","ancient","history","paper"],"skins":[{"unified":"1f4dc","native":"\uD83D\uDCDC"}],"version":1},"page_facing_up":{"id":"page_facing_up","name":"Page Facing Up","keywords":["documents","office","paper","information"],"skins":[{"unified":"1f4c4","native":"\uD83D\uDCC4"}],"version":1},"newspaper":{"id":"newspaper","name":"Newspaper","keywords":["press","headline"],"skins":[{"unified":"1f4f0","native":"\uD83D\uDCF0"}],"version":1},"rolled_up_newspaper":{"id":"rolled_up_newspaper","name":"Rolled-Up Newspaper","keywords":["rolled","up","press","headline"],"skins":[{"unified":"1f5de-fe0f","native":"\uD83D\uDDDE\uFE0F"}],"version":1},"bookmark_tabs":{"id":"bookmark_tabs","name":"Bookmark Tabs","keywords":["favorite","save","order","tidy"],"skins":[{"unified":"1f4d1","native":"\uD83D\uDCD1"}],"version":1},"bookmark":{"id":"bookmark","name":"Bookmark","keywords":["favorite","label","save"],"skins":[{"unified":"1f516","native":"\uD83D\uDD16"}],"version":1},"label":{"id":"label","name":"Label","keywords":["sale","tag"],"skins":[{"unified":"1f3f7-fe0f","native":"\uD83C\uDFF7\uFE0F"}],"version":1},"moneybag":{"id":"moneybag","name":"Money Bag","keywords":["moneybag","dollar","payment","coins","sale"],"skins":[{"unified":"1f4b0","native":"\uD83D\uDCB0"}],"version":1},"coin":{"id":"coin","name":"Coin","keywords":["money","currency"],"skins":[{"unified":"1fa99","native":"\uD83E\uDE99"}],"version":13},"yen":{"id":"yen","name":"Yen Banknote","keywords":["money","sales","japanese","dollar","currency"],"skins":[{"unified":"1f4b4","native":"\uD83D\uDCB4"}],"version":1},"dollar":{"id":"dollar","name":"Dollar Banknote","keywords":["money","sales","bill","currency"],"skins":[{"unified":"1f4b5","native":"\uD83D\uDCB5"}],"version":1},"euro":{"id":"euro","name":"Euro Banknote","keywords":["money","sales","dollar","currency"],"skins":[{"unified":"1f4b6","native":"\uD83D\uDCB6"}],"version":1},"pound":{"id":"pound","name":"Pound Banknote","keywords":["british","sterling","money","sales","bills","uk","england","currency"],"skins":[{"unified":"1f4b7","native":"\uD83D\uDCB7"}],"version":1},"money_with_wings":{"id":"money_with_wings","name":"Money with Wings","keywords":["dollar","bills","payment","sale"],"skins":[{"unified":"1f4b8","native":"\uD83D\uDCB8"}],"version":1},"credit_card":{"id":"credit_card","name":"Credit Card","keywords":["money","sales","dollar","bill","payment","shopping"],"skins":[{"unified":"1f4b3","native":"\uD83D\uDCB3"}],"version":1},"receipt":{"id":"receipt","name":"Receipt","keywords":["accounting","expenses"],"skins":[{"unified":"1f9fe","native":"\uD83E\uDDFE"}],"version":11},"chart":{"id":"chart","name":"Chart Increasing with Yen","keywords":["green","square","graph","presentation","stats"],"skins":[{"unified":"1f4b9","native":"\uD83D\uDCB9"}],"version":1},"email":{"id":"email","name":"Envelope","keywords":["email","letter","postal","inbox","communication"],"skins":[{"unified":"2709-fe0f","native":"\u2709\uFE0F"}],"version":1},"e-mail":{"id":"e-mail","name":"E-Mail","keywords":["e","mail","communication","inbox"],"skins":[{"unified":"1f4e7","native":"\uD83D\uDCE7"}],"version":1},"incoming_envelope":{"id":"incoming_envelope","name":"Incoming Envelope","keywords":["email","inbox"],"skins":[{"unified":"1f4e8","native":"\uD83D\uDCE8"}],"version":1},"envelope_with_arrow":{"id":"envelope_with_arrow","name":"Envelope with Arrow","keywords":["email","communication"],"skins":[{"unified":"1f4e9","native":"\uD83D\uDCE9"}],"version":1},"outbox_tray":{"id":"outbox_tray","name":"Outbox Tray","keywords":["inbox","email"],"skins":[{"unified":"1f4e4","native":"\uD83D\uDCE4"}],"version":1},"inbox_tray":{"id":"inbox_tray","name":"Inbox Tray","keywords":["email","documents"],"skins":[{"unified":"1f4e5","native":"\uD83D\uDCE5"}],"version":1},"package":{"id":"package","name":"Package","keywords":["mail","gift","cardboard","box","moving"],"skins":[{"unified":"1f4e6","native":"\uD83D\uDCE6"}],"version":1},"mailbox":{"id":"mailbox","name":"Closed Mailbox with Raised Flag","keywords":["email","inbox","communication"],"skins":[{"unified":"1f4eb","native":"\uD83D\uDCEB"}],"version":1},"mailbox_closed":{"id":"mailbox_closed","name":"Closed Mailbox with Lowered Flag","keywords":["email","communication","inbox"],"skins":[{"unified":"1f4ea","native":"\uD83D\uDCEA"}],"version":1},"mailbox_with_mail":{"id":"mailbox_with_mail","name":"Open Mailbox with Raised Flag","keywords":["mail","email","inbox","communication"],"skins":[{"unified":"1f4ec","native":"\uD83D\uDCEC"}],"version":1},"mailbox_with_no_mail":{"id":"mailbox_with_no_mail","name":"Open Mailbox with Lowered Flag","keywords":["no","mail","email","inbox"],"skins":[{"unified":"1f4ed","native":"\uD83D\uDCED"}],"version":1},"postbox":{"id":"postbox","name":"Postbox","keywords":["email","letter","envelope"],"skins":[{"unified":"1f4ee","native":"\uD83D\uDCEE"}],"version":1},"ballot_box_with_ballot":{"id":"ballot_box_with_ballot","name":"Ballot Box with Ballot","keywords":["election","vote"],"skins":[{"unified":"1f5f3-fe0f","native":"\uD83D\uDDF3\uFE0F"}],"version":1},"pencil2":{"id":"pencil2","name":"Pencil","keywords":["pencil2","stationery","write","paper","writing","school","study"],"skins":[{"unified":"270f-fe0f","native":"\u270F\uFE0F"}],"version":1},"black_nib":{"id":"black_nib","name":"Black Nib","keywords":["pen","stationery","writing","write"],"skins":[{"unified":"2712-fe0f","native":"\u2712\uFE0F"}],"version":1},"lower_left_fountain_pen":{"id":"lower_left_fountain_pen","name":"Fountain Pen","keywords":["lower","left","stationery","writing","write"],"skins":[{"unified":"1f58b-fe0f","native":"\uD83D\uDD8B\uFE0F"}],"version":1},"lower_left_ballpoint_pen":{"id":"lower_left_ballpoint_pen","name":"Pen","keywords":["lower","left","ballpoint","stationery","writing","write"],"skins":[{"unified":"1f58a-fe0f","native":"\uD83D\uDD8A\uFE0F"}],"version":1},"lower_left_paintbrush":{"id":"lower_left_paintbrush","name":"Paintbrush","keywords":["lower","left","drawing","creativity","art"],"skins":[{"unified":"1f58c-fe0f","native":"\uD83D\uDD8C\uFE0F"}],"version":1},"lower_left_crayon":{"id":"lower_left_crayon","name":"Crayon","keywords":["lower","left","drawing","creativity"],"skins":[{"unified":"1f58d-fe0f","native":"\uD83D\uDD8D\uFE0F"}],"version":1},"memo":{"id":"memo","name":"Memo","keywords":["pencil","write","documents","stationery","paper","writing","legal","exam","quiz","test","study","compose"],"skins":[{"unified":"1f4dd","native":"\uD83D\uDCDD"}],"version":1},"briefcase":{"id":"briefcase","name":"Briefcase","keywords":["business","documents","work","law","legal","job","career"],"skins":[{"unified":"1f4bc","native":"\uD83D\uDCBC"}],"version":1},"file_folder":{"id":"file_folder","name":"File Folder","keywords":["documents","business","office"],"skins":[{"unified":"1f4c1","native":"\uD83D\uDCC1"}],"version":1},"open_file_folder":{"id":"open_file_folder","name":"Open File Folder","keywords":["documents","load"],"skins":[{"unified":"1f4c2","native":"\uD83D\uDCC2"}],"version":1},"card_index_dividers":{"id":"card_index_dividers","name":"Card Index Dividers","keywords":["organizing","business","stationery"],"skins":[{"unified":"1f5c2-fe0f","native":"\uD83D\uDDC2\uFE0F"}],"version":1},"date":{"id":"date","name":"Calendar","keywords":["date","schedule"],"skins":[{"unified":"1f4c5","native":"\uD83D\uDCC5"}],"version":1},"calendar":{"id":"calendar","name":"Tear-off Calendar","keywords":["tear","off","schedule","date","planning"],"skins":[{"unified":"1f4c6","native":"\uD83D\uDCC6"}],"version":1},"spiral_note_pad":{"id":"spiral_note_pad","name":"Spiral Notepad","keywords":["note","pad","memo","stationery"],"skins":[{"unified":"1f5d2-fe0f","native":"\uD83D\uDDD2\uFE0F"}],"version":1},"spiral_calendar_pad":{"id":"spiral_calendar_pad","name":"Spiral Calendar","keywords":["pad","date","schedule","planning"],"skins":[{"unified":"1f5d3-fe0f","native":"\uD83D\uDDD3\uFE0F"}],"version":1},"card_index":{"id":"card_index","name":"Card Index","keywords":["business","stationery"],"skins":[{"unified":"1f4c7","native":"\uD83D\uDCC7"}],"version":1},"chart_with_upwards_trend":{"id":"chart_with_upwards_trend","name":"Chart Increasing","keywords":["with","upwards","trend","graph","presentation","stats","recovery","business","economics","money","sales","good","success"],"skins":[{"unified":"1f4c8","native":"\uD83D\uDCC8"}],"version":1},"chart_with_downwards_trend":{"id":"chart_with_downwards_trend","name":"Chart Decreasing","keywords":["with","downwards","trend","graph","presentation","stats","recession","business","economics","money","sales","bad","failure"],"skins":[{"unified":"1f4c9","native":"\uD83D\uDCC9"}],"version":1},"bar_chart":{"id":"bar_chart","name":"Bar Chart","keywords":["graph","presentation","stats"],"skins":[{"unified":"1f4ca","native":"\uD83D\uDCCA"}],"version":1},"clipboard":{"id":"clipboard","name":"Clipboard","keywords":["stationery","documents"],"skins":[{"unified":"1f4cb","native":"\uD83D\uDCCB"}],"version":1},"pushpin":{"id":"pushpin","name":"Pushpin","keywords":["stationery","mark","here"],"skins":[{"unified":"1f4cc","native":"\uD83D\uDCCC"}],"version":1},"round_pushpin":{"id":"round_pushpin","name":"Round Pushpin","keywords":["stationery","location","map","here"],"skins":[{"unified":"1f4cd","native":"\uD83D\uDCCD"}],"version":1},"paperclip":{"id":"paperclip","name":"Paperclip","keywords":["documents","stationery"],"skins":[{"unified":"1f4ce","native":"\uD83D\uDCCE"}],"version":1},"linked_paperclips":{"id":"linked_paperclips","name":"Linked Paperclips","keywords":["documents","stationery"],"skins":[{"unified":"1f587-fe0f","native":"\uD83D\uDD87\uFE0F"}],"version":1},"straight_ruler":{"id":"straight_ruler","name":"Straight Ruler","keywords":["stationery","calculate","length","math","school","drawing","architect","sketch"],"skins":[{"unified":"1f4cf","native":"\uD83D\uDCCF"}],"version":1},"triangular_ruler":{"id":"triangular_ruler","name":"Triangular Ruler","keywords":["stationery","math","architect","sketch"],"skins":[{"unified":"1f4d0","native":"\uD83D\uDCD0"}],"version":1},"scissors":{"id":"scissors","name":"Scissors","keywords":["stationery","cut"],"skins":[{"unified":"2702-fe0f","native":"\u2702\uFE0F"}],"version":1},"card_file_box":{"id":"card_file_box","name":"Card File Box","keywords":["business","stationery"],"skins":[{"unified":"1f5c3-fe0f","native":"\uD83D\uDDC3\uFE0F"}],"version":1},"file_cabinet":{"id":"file_cabinet","name":"File Cabinet","keywords":["filing","organizing"],"skins":[{"unified":"1f5c4-fe0f","native":"\uD83D\uDDC4\uFE0F"}],"version":1},"wastebasket":{"id":"wastebasket","name":"Wastebasket","keywords":["bin","trash","rubbish","garbage","toss"],"skins":[{"unified":"1f5d1-fe0f","native":"\uD83D\uDDD1\uFE0F"}],"version":1},"lock":{"id":"lock","name":"Lock","keywords":["locked","security","password","padlock"],"skins":[{"unified":"1f512","native":"\uD83D\uDD12"}],"version":1},"unlock":{"id":"unlock","name":"Unlocked","keywords":["unlock","privacy","security"],"skins":[{"unified":"1f513","native":"\uD83D\uDD13"}],"version":1},"lock_with_ink_pen":{"id":"lock_with_ink_pen","name":"Locked with Pen","keywords":["lock","ink","security","secret"],"skins":[{"unified":"1f50f","native":"\uD83D\uDD0F"}],"version":1},"closed_lock_with_key":{"id":"closed_lock_with_key","name":"Locked with Key","keywords":["closed","lock","security","privacy"],"skins":[{"unified":"1f510","native":"\uD83D\uDD10"}],"version":1},"key":{"id":"key","name":"Key","keywords":["lock","door","password"],"skins":[{"unified":"1f511","native":"\uD83D\uDD11"}],"version":1},"old_key":{"id":"old_key","name":"Old Key","keywords":["lock","door","password"],"skins":[{"unified":"1f5dd-fe0f","native":"\uD83D\uDDDD\uFE0F"}],"version":1},"hammer":{"id":"hammer","name":"Hammer","keywords":["tools","build","create"],"skins":[{"unified":"1f528","native":"\uD83D\uDD28"}],"version":1},"axe":{"id":"axe","name":"Axe","keywords":["tool","chop","cut"],"skins":[{"unified":"1fa93","native":"\uD83E\uDE93"}],"version":12},"pick":{"id":"pick","name":"Pick","keywords":["tools","dig"],"skins":[{"unified":"26cf-fe0f","native":"\u26CF\uFE0F"}],"version":1},"hammer_and_pick":{"id":"hammer_and_pick","name":"Hammer and Pick","keywords":["tools","build","create"],"skins":[{"unified":"2692-fe0f","native":"\u2692\uFE0F"}],"version":1},"hammer_and_wrench":{"id":"hammer_and_wrench","name":"Hammer and Wrench","keywords":["tools","build","create"],"skins":[{"unified":"1f6e0-fe0f","native":"\uD83D\uDEE0\uFE0F"}],"version":1},"dagger_knife":{"id":"dagger_knife","name":"Dagger","keywords":["knife","weapon"],"skins":[{"unified":"1f5e1-fe0f","native":"\uD83D\uDDE1\uFE0F"}],"version":1},"crossed_swords":{"id":"crossed_swords","name":"Crossed Swords","keywords":["weapon"],"skins":[{"unified":"2694-fe0f","native":"\u2694\uFE0F"}],"version":1},"bomb":{"id":"bomb","name":"Bomb","keywords":["boom","explode","explosion","terrorism"],"skins":[{"unified":"1f4a3","native":"\uD83D\uDCA3"}],"version":1},"boomerang":{"id":"boomerang","name":"Boomerang","keywords":["weapon"],"skins":[{"unified":"1fa83","native":"\uD83E\uDE83"}],"version":13},"bow_and_arrow":{"id":"bow_and_arrow","name":"Bow and Arrow","keywords":["sports"],"skins":[{"unified":"1f3f9","native":"\uD83C\uDFF9"}],"version":1},"shield":{"id":"shield","name":"Shield","keywords":["protection","security"],"skins":[{"unified":"1f6e1-fe0f","native":"\uD83D\uDEE1\uFE0F"}],"version":1},"carpentry_saw":{"id":"carpentry_saw","name":"Carpentry Saw","keywords":["cut","chop"],"skins":[{"unified":"1fa9a","native":"\uD83E\uDE9A"}],"version":13},"wrench":{"id":"wrench","name":"Wrench","keywords":["tools","diy","ikea","fix","maintainer"],"skins":[{"unified":"1f527","native":"\uD83D\uDD27"}],"version":1},"screwdriver":{"id":"screwdriver","name":"Screwdriver","keywords":["tools"],"skins":[{"unified":"1fa9b","native":"\uD83E\uDE9B"}],"version":13},"nut_and_bolt":{"id":"nut_and_bolt","name":"Nut and Bolt","keywords":["handy","tools","fix"],"skins":[{"unified":"1f529","native":"\uD83D\uDD29"}],"version":1},"gear":{"id":"gear","name":"Gear","keywords":["cog"],"skins":[{"unified":"2699-fe0f","native":"\u2699\uFE0F"}],"version":1},"compression":{"id":"compression","name":"Clamp","keywords":["compression","tool"],"skins":[{"unified":"1f5dc-fe0f","native":"\uD83D\uDDDC\uFE0F"}],"version":1},"scales":{"id":"scales","name":"Balance Scale","keywords":["scales","law","fairness","weight"],"skins":[{"unified":"2696-fe0f","native":"\u2696\uFE0F"}],"version":1},"probing_cane":{"id":"probing_cane","name":"White Cane","keywords":["probing","accessibility"],"skins":[{"unified":"1f9af","native":"\uD83E\uDDAF"}],"version":12},"link":{"id":"link","name":"Link","keywords":["rings","url"],"skins":[{"unified":"1f517","native":"\uD83D\uDD17"}],"version":1},"chains":{"id":"chains","name":"Chains","keywords":["lock","arrest"],"skins":[{"unified":"26d3-fe0f","native":"\u26D3\uFE0F"}],"version":1},"hook":{"id":"hook","name":"Hook","keywords":["tools"],"skins":[{"unified":"1fa9d","native":"\uD83E\uDE9D"}],"version":13},"toolbox":{"id":"toolbox","name":"Toolbox","keywords":["tools","diy","fix","maintainer","mechanic"],"skins":[{"unified":"1f9f0","native":"\uD83E\uDDF0"}],"version":11},"magnet":{"id":"magnet","name":"Magnet","keywords":["attraction","magnetic"],"skins":[{"unified":"1f9f2","native":"\uD83E\uDDF2"}],"version":11},"ladder":{"id":"ladder","name":"Ladder","keywords":["tools"],"skins":[{"unified":"1fa9c","native":"\uD83E\uDE9C"}],"version":13},"alembic":{"id":"alembic","name":"Alembic","keywords":["distilling","science","experiment","chemistry"],"skins":[{"unified":"2697-fe0f","native":"\u2697\uFE0F"}],"version":1},"test_tube":{"id":"test_tube","name":"Test Tube","keywords":["chemistry","experiment","lab","science"],"skins":[{"unified":"1f9ea","native":"\uD83E\uDDEA"}],"version":11},"petri_dish":{"id":"petri_dish","name":"Petri Dish","keywords":["bacteria","biology","culture","lab"],"skins":[{"unified":"1f9eb","native":"\uD83E\uDDEB"}],"version":11},"dna":{"id":"dna","name":"Dna","keywords":["biologist","genetics","life"],"skins":[{"unified":"1f9ec","native":"\uD83E\uDDEC"}],"version":11},"microscope":{"id":"microscope","name":"Microscope","keywords":["laboratory","experiment","zoomin","science","study"],"skins":[{"unified":"1f52c","native":"\uD83D\uDD2C"}],"version":1},"telescope":{"id":"telescope","name":"Telescope","keywords":["stars","space","zoom","science","astronomy"],"skins":[{"unified":"1f52d","native":"\uD83D\uDD2D"}],"version":1},"satellite_antenna":{"id":"satellite_antenna","name":"Satellite Antenna","keywords":["communication","future","radio","space"],"skins":[{"unified":"1f4e1","native":"\uD83D\uDCE1"}],"version":1},"syringe":{"id":"syringe","name":"Syringe","keywords":["health","hospital","drugs","blood","medicine","needle","doctor","nurse"],"skins":[{"unified":"1f489","native":"\uD83D\uDC89"}],"version":1},"drop_of_blood":{"id":"drop_of_blood","name":"Drop of Blood","keywords":["period","hurt","harm","wound"],"skins":[{"unified":"1fa78","native":"\uD83E\uDE78"}],"version":12},"pill":{"id":"pill","name":"Pill","keywords":["health","medicine","doctor","pharmacy","drug"],"skins":[{"unified":"1f48a","native":"\uD83D\uDC8A"}],"version":1},"adhesive_bandage":{"id":"adhesive_bandage","name":"Adhesive Bandage","keywords":["heal"],"skins":[{"unified":"1fa79","native":"\uD83E\uDE79"}],"version":12},"crutch":{"id":"crutch","name":"Crutch","keywords":["accessibility","assist"],"skins":[{"unified":"1fa7c","native":"\uD83E\uDE7C"}],"version":14},"stethoscope":{"id":"stethoscope","name":"Stethoscope","keywords":["health"],"skins":[{"unified":"1fa7a","native":"\uD83E\uDE7A"}],"version":12},"x-ray":{"id":"x-ray","name":"X-Ray","keywords":["x","ray","skeleton","medicine"],"skins":[{"unified":"1fa7b","native":"\uD83E\uDE7B"}],"version":14},"door":{"id":"door","name":"Door","keywords":["house","entry","exit"],"skins":[{"unified":"1f6aa","native":"\uD83D\uDEAA"}],"version":1},"elevator":{"id":"elevator","name":"Elevator","keywords":["lift"],"skins":[{"unified":"1f6d7","native":"\uD83D\uDED7"}],"version":13},"mirror":{"id":"mirror","name":"Mirror","keywords":["reflection"],"skins":[{"unified":"1fa9e","native":"\uD83E\uDE9E"}],"version":13},"window":{"id":"window","name":"Window","keywords":["scenery"],"skins":[{"unified":"1fa9f","native":"\uD83E\uDE9F"}],"version":13},"bed":{"id":"bed","name":"Bed","keywords":["sleep","rest"],"skins":[{"unified":"1f6cf-fe0f","native":"\uD83D\uDECF\uFE0F"}],"version":1},"couch_and_lamp":{"id":"couch_and_lamp","name":"Couch and Lamp","keywords":["read","chill"],"skins":[{"unified":"1f6cb-fe0f","native":"\uD83D\uDECB\uFE0F"}],"version":1},"chair":{"id":"chair","name":"Chair","keywords":["sit","furniture"],"skins":[{"unified":"1fa91","native":"\uD83E\uDE91"}],"version":12},"toilet":{"id":"toilet","name":"Toilet","keywords":["restroom","wc","washroom","bathroom","potty"],"skins":[{"unified":"1f6bd","native":"\uD83D\uDEBD"}],"version":1},"plunger":{"id":"plunger","name":"Plunger","keywords":["toilet"],"skins":[{"unified":"1faa0","native":"\uD83E\uDEA0"}],"version":13},"shower":{"id":"shower","name":"Shower","keywords":["clean","water","bathroom"],"skins":[{"unified":"1f6bf","native":"\uD83D\uDEBF"}],"version":1},"bathtub":{"id":"bathtub","name":"Bathtub","keywords":["clean","shower","bathroom"],"skins":[{"unified":"1f6c1","native":"\uD83D\uDEC1"}],"version":1},"mouse_trap":{"id":"mouse_trap","name":"Mouse Trap","keywords":["cheese"],"skins":[{"unified":"1faa4","native":"\uD83E\uDEA4"}],"version":13},"razor":{"id":"razor","name":"Razor","keywords":["cut"],"skins":[{"unified":"1fa92","native":"\uD83E\uDE92"}],"version":12},"lotion_bottle":{"id":"lotion_bottle","name":"Lotion Bottle","keywords":["moisturizer","sunscreen"],"skins":[{"unified":"1f9f4","native":"\uD83E\uDDF4"}],"version":11},"safety_pin":{"id":"safety_pin","name":"Safety Pin","keywords":["diaper"],"skins":[{"unified":"1f9f7","native":"\uD83E\uDDF7"}],"version":11},"broom":{"id":"broom","name":"Broom","keywords":["cleaning","sweeping","witch"],"skins":[{"unified":"1f9f9","native":"\uD83E\uDDF9"}],"version":11},"basket":{"id":"basket","name":"Basket","keywords":["laundry"],"skins":[{"unified":"1f9fa","native":"\uD83E\uDDFA"}],"version":11},"roll_of_paper":{"id":"roll_of_paper","name":"Roll of Paper","keywords":[],"skins":[{"unified":"1f9fb","native":"\uD83E\uDDFB"}],"version":11},"bucket":{"id":"bucket","name":"Bucket","keywords":["water","container"],"skins":[{"unified":"1faa3","native":"\uD83E\uDEA3"}],"version":13},"soap":{"id":"soap","name":"Soap","keywords":["bar","bathing","cleaning","lather"],"skins":[{"unified":"1f9fc","native":"\uD83E\uDDFC"}],"version":11},"bubbles":{"id":"bubbles","name":"Bubbles","keywords":["soap","fun","carbonation","sparkling"],"skins":[{"unified":"1fae7","native":"\uD83E\uDEE7"}],"version":14},"toothbrush":{"id":"toothbrush","name":"Toothbrush","keywords":["hygiene","dental"],"skins":[{"unified":"1faa5","native":"\uD83E\uDEA5"}],"version":13},"sponge":{"id":"sponge","name":"Sponge","keywords":["absorbing","cleaning","porous"],"skins":[{"unified":"1f9fd","native":"\uD83E\uDDFD"}],"version":11},"fire_extinguisher":{"id":"fire_extinguisher","name":"Fire Extinguisher","keywords":["quench"],"skins":[{"unified":"1f9ef","native":"\uD83E\uDDEF"}],"version":11},"shopping_trolley":{"id":"shopping_trolley","name":"Shopping Cart","keywords":["trolley"],"skins":[{"unified":"1f6d2","native":"\uD83D\uDED2"}],"version":3},"smoking":{"id":"smoking","name":"Cigarette","keywords":["smoking","kills","tobacco","joint","smoke"],"skins":[{"unified":"1f6ac","native":"\uD83D\uDEAC"}],"version":1},"coffin":{"id":"coffin","name":"Coffin","keywords":["vampire","dead","die","death","rip","graveyard","cemetery","casket","funeral","box"],"skins":[{"unified":"26b0-fe0f","native":"\u26B0\uFE0F"}],"version":1},"headstone":{"id":"headstone","name":"Headstone","keywords":["death","rip","grave"],"skins":[{"unified":"1faa6","native":"\uD83E\uDEA6"}],"version":13},"funeral_urn":{"id":"funeral_urn","name":"Funeral Urn","keywords":["dead","die","death","rip","ashes"],"skins":[{"unified":"26b1-fe0f","native":"\u26B1\uFE0F"}],"version":1},"nazar_amulet":{"id":"nazar_amulet","name":"Nazar Amulet","keywords":["bead","charm"],"skins":[{"unified":"1f9ff","native":"\uD83E\uDDFF"}],"version":11},"hamsa":{"id":"hamsa","name":"Hamsa","keywords":["religion","protection"],"skins":[{"unified":"1faac","native":"\uD83E\uDEAC"}],"version":14},"moyai":{"id":"moyai","name":"Moai","keywords":["moyai","rock","easter","island"],"skins":[{"unified":"1f5ff","native":"\uD83D\uDDFF"}],"version":1},"placard":{"id":"placard","name":"Placard","keywords":["announcement"],"skins":[{"unified":"1faa7","native":"\uD83E\uDEA7"}],"version":13},"identification_card":{"id":"identification_card","name":"Identification Card","keywords":["document"],"skins":[{"unified":"1faaa","native":"\uD83E\uDEAA"}],"version":14},"atm":{"id":"atm","name":"Atm Sign","keywords":["money","sales","cash","blue","square","payment","bank"],"skins":[{"unified":"1f3e7","native":"\uD83C\uDFE7"}],"version":1},"put_litter_in_its_place":{"id":"put_litter_in_its_place","name":"Litter in Bin Sign","keywords":["put","its","place","blue","square","human","info"],"skins":[{"unified":"1f6ae","native":"\uD83D\uDEAE"}],"version":1},"potable_water":{"id":"potable_water","name":"Potable Water","keywords":["blue","square","liquid","restroom","cleaning","faucet"],"skins":[{"unified":"1f6b0","native":"\uD83D\uDEB0"}],"version":1},"wheelchair":{"id":"wheelchair","name":"Wheelchair Symbol","keywords":["blue","square","disabled","accessibility"],"skins":[{"unified":"267f","native":"\u267F"}],"version":1},"mens":{"id":"mens","name":"Men\u2019s Room","keywords":["mens","men","s","toilet","restroom","wc","blue","square","gender","male"],"skins":[{"unified":"1f6b9","native":"\uD83D\uDEB9"}],"version":1},"womens":{"id":"womens","name":"Women\u2019s Room","keywords":["womens","women","s","purple","square","woman","female","toilet","loo","restroom","gender"],"skins":[{"unified":"1f6ba","native":"\uD83D\uDEBA"}],"version":1},"restroom":{"id":"restroom","name":"Restroom","keywords":["blue","square","toilet","refresh","wc","gender"],"skins":[{"unified":"1f6bb","native":"\uD83D\uDEBB"}],"version":1},"baby_symbol":{"id":"baby_symbol","name":"Baby Symbol","keywords":["orange","square","child"],"skins":[{"unified":"1f6bc","native":"\uD83D\uDEBC"}],"version":1},"wc":{"id":"wc","name":"Water Closet","keywords":["wc","toilet","restroom","blue","square"],"skins":[{"unified":"1f6be","native":"\uD83D\uDEBE"}],"version":1},"passport_control":{"id":"passport_control","name":"Passport Control","keywords":["custom","blue","square"],"skins":[{"unified":"1f6c2","native":"\uD83D\uDEC2"}],"version":1},"customs":{"id":"customs","name":"Customs","keywords":["passport","border","blue","square"],"skins":[{"unified":"1f6c3","native":"\uD83D\uDEC3"}],"version":1},"baggage_claim":{"id":"baggage_claim","name":"Baggage Claim","keywords":["blue","square","airport","transport"],"skins":[{"unified":"1f6c4","native":"\uD83D\uDEC4"}],"version":1},"left_luggage":{"id":"left_luggage","name":"Left Luggage","keywords":["blue","square","travel"],"skins":[{"unified":"1f6c5","native":"\uD83D\uDEC5"}],"version":1},"warning":{"id":"warning","name":"Warning","keywords":["exclamation","wip","alert","error","problem","issue"],"skins":[{"unified":"26a0-fe0f","native":"\u26A0\uFE0F"}],"version":1},"children_crossing":{"id":"children_crossing","name":"Children Crossing","keywords":["school","warning","danger","sign","driving","yellow","diamond"],"skins":[{"unified":"1f6b8","native":"\uD83D\uDEB8"}],"version":1},"no_entry":{"id":"no_entry","name":"No Entry","keywords":["limit","security","privacy","bad","denied","stop","circle"],"skins":[{"unified":"26d4","native":"\u26D4"}],"version":1},"no_entry_sign":{"id":"no_entry_sign","name":"Prohibited","keywords":["no","entry","sign","forbid","stop","limit","denied","disallow","circle"],"skins":[{"unified":"1f6ab","native":"\uD83D\uDEAB"}],"version":1},"no_bicycles":{"id":"no_bicycles","name":"No Bicycles","keywords":["cyclist","prohibited","circle"],"skins":[{"unified":"1f6b3","native":"\uD83D\uDEB3"}],"version":1},"no_smoking":{"id":"no_smoking","name":"No Smoking","keywords":["cigarette","blue","square","smell","smoke"],"skins":[{"unified":"1f6ad","native":"\uD83D\uDEAD"}],"version":1},"do_not_litter":{"id":"do_not_litter","name":"No Littering","keywords":["do","not","litter","trash","bin","garbage","circle"],"skins":[{"unified":"1f6af","native":"\uD83D\uDEAF"}],"version":1},"non-potable_water":{"id":"non-potable_water","name":"Non-Potable Water","keywords":["non","potable","drink","faucet","tap","circle"],"skins":[{"unified":"1f6b1","native":"\uD83D\uDEB1"}],"version":1},"no_pedestrians":{"id":"no_pedestrians","name":"No Pedestrians","keywords":["rules","crossing","walking","circle"],"skins":[{"unified":"1f6b7","native":"\uD83D\uDEB7"}],"version":1},"no_mobile_phones":{"id":"no_mobile_phones","name":"No Mobile Phones","keywords":["iphone","mute","circle"],"skins":[{"unified":"1f4f5","native":"\uD83D\uDCF5"}],"version":1},"underage":{"id":"underage","name":"No One Under Eighteen","keywords":["underage","18","drink","pub","night","minor","circle"],"skins":[{"unified":"1f51e","native":"\uD83D\uDD1E"}],"version":1},"radioactive_sign":{"id":"radioactive_sign","name":"Radioactive","keywords":["sign","nuclear","danger"],"skins":[{"unified":"2622-fe0f","native":"\u2622\uFE0F"}],"version":1},"biohazard_sign":{"id":"biohazard_sign","name":"Biohazard","keywords":["sign","danger"],"skins":[{"unified":"2623-fe0f","native":"\u2623\uFE0F"}],"version":1},"arrow_up":{"id":"arrow_up","name":"Up Arrow","keywords":["blue","square","continue","top","direction"],"skins":[{"unified":"2b06-fe0f","native":"\u2B06\uFE0F"}],"version":1},"arrow_upper_right":{"id":"arrow_upper_right","name":"Up-Right Arrow","keywords":["upper","right","up","blue","square","point","direction","diagonal","northeast"],"skins":[{"unified":"2197-fe0f","native":"\u2197\uFE0F"}],"version":1},"arrow_right":{"id":"arrow_right","name":"Right Arrow","keywords":["blue","square","next"],"skins":[{"unified":"27a1-fe0f","native":"\u27A1\uFE0F"}],"version":1},"arrow_lower_right":{"id":"arrow_lower_right","name":"South East Arrow","keywords":["lower","right","down","blue","square","direction","diagonal","southeast"],"skins":[{"unified":"2198-fe0f","native":"\u2198\uFE0F"}],"version":1},"arrow_down":{"id":"arrow_down","name":"Down Arrow","keywords":["blue","square","direction","bottom"],"skins":[{"unified":"2b07-fe0f","native":"\u2B07\uFE0F"}],"version":1},"arrow_lower_left":{"id":"arrow_lower_left","name":"Down-Left Arrow","keywords":["lower","left","down","blue","square","direction","diagonal","southwest"],"skins":[{"unified":"2199-fe0f","native":"\u2199\uFE0F"}],"version":1},"arrow_left":{"id":"arrow_left","name":"Left Arrow","keywords":["blue","square","previous","back"],"skins":[{"unified":"2b05-fe0f","native":"\u2B05\uFE0F"}],"version":1},"arrow_upper_left":{"id":"arrow_upper_left","name":"Up-Left Arrow","keywords":["upper","left","up","blue","square","point","direction","diagonal","northwest"],"skins":[{"unified":"2196-fe0f","native":"\u2196\uFE0F"}],"version":1},"arrow_up_down":{"id":"arrow_up_down","name":"Up Down Arrow","keywords":["blue","square","direction","way","vertical"],"skins":[{"unified":"2195-fe0f","native":"\u2195\uFE0F"}],"version":1},"left_right_arrow":{"id":"left_right_arrow","name":"Left Right Arrow","keywords":["shape","direction","horizontal","sideways"],"skins":[{"unified":"2194-fe0f","native":"\u2194\uFE0F"}],"version":1},"leftwards_arrow_with_hook":{"id":"leftwards_arrow_with_hook","name":"Right Arrow Curving Left","keywords":["leftwards","with","hook","back","return","blue","square","undo","enter"],"skins":[{"unified":"21a9-fe0f","native":"\u21A9\uFE0F"}],"version":1},"arrow_right_hook":{"id":"arrow_right_hook","name":"Left Arrow Curving Right","keywords":["hook","blue","square","return","rotate","direction"],"skins":[{"unified":"21aa-fe0f","native":"\u21AA\uFE0F"}],"version":1},"arrow_heading_up":{"id":"arrow_heading_up","name":"Right Arrow Curving Up","keywords":["heading","blue","square","direction","top"],"skins":[{"unified":"2934-fe0f","native":"\u2934\uFE0F"}],"version":1},"arrow_heading_down":{"id":"arrow_heading_down","name":"Right Arrow Curving Down","keywords":["heading","blue","square","direction","bottom"],"skins":[{"unified":"2935-fe0f","native":"\u2935\uFE0F"}],"version":1},"arrows_clockwise":{"id":"arrows_clockwise","name":"Clockwise Vertical Arrows","keywords":["sync","cycle","round","repeat"],"skins":[{"unified":"1f503","native":"\uD83D\uDD03"}],"version":1},"arrows_counterclockwise":{"id":"arrows_counterclockwise","name":"Counterclockwise Arrows Button","keywords":["blue","square","sync","cycle"],"skins":[{"unified":"1f504","native":"\uD83D\uDD04"}],"version":1},"back":{"id":"back","name":"Back Arrow","keywords":["words","return"],"skins":[{"unified":"1f519","native":"\uD83D\uDD19"}],"version":1},"end":{"id":"end","name":"End Arrow","keywords":["words"],"skins":[{"unified":"1f51a","native":"\uD83D\uDD1A"}],"version":1},"on":{"id":"on","name":"On! Arrow","keywords":["on","words"],"skins":[{"unified":"1f51b","native":"\uD83D\uDD1B"}],"version":1},"soon":{"id":"soon","name":"Soon Arrow","keywords":["words"],"skins":[{"unified":"1f51c","native":"\uD83D\uDD1C"}],"version":1},"top":{"id":"top","name":"Top Arrow","keywords":["words","blue","square"],"skins":[{"unified":"1f51d","native":"\uD83D\uDD1D"}],"version":1},"place_of_worship":{"id":"place_of_worship","name":"Place of Worship","keywords":["religion","church","temple","prayer"],"skins":[{"unified":"1f6d0","native":"\uD83D\uDED0"}],"version":1},"atom_symbol":{"id":"atom_symbol","name":"Atom Symbol","keywords":["science","physics","chemistry"],"skins":[{"unified":"269b-fe0f","native":"\u269B\uFE0F"}],"version":1},"om_symbol":{"id":"om_symbol","name":"Om","keywords":["symbol","hinduism","buddhism","sikhism","jainism"],"skins":[{"unified":"1f549-fe0f","native":"\uD83D\uDD49\uFE0F"}],"version":1},"star_of_david":{"id":"star_of_david","name":"Star of David","keywords":["judaism"],"skins":[{"unified":"2721-fe0f","native":"\u2721\uFE0F"}],"version":1},"wheel_of_dharma":{"id":"wheel_of_dharma","name":"Wheel of Dharma","keywords":["hinduism","buddhism","sikhism","jainism"],"skins":[{"unified":"2638-fe0f","native":"\u2638\uFE0F"}],"version":1},"yin_yang":{"id":"yin_yang","name":"Yin Yang","keywords":["balance"],"skins":[{"unified":"262f-fe0f","native":"\u262F\uFE0F"}],"version":1},"latin_cross":{"id":"latin_cross","name":"Latin Cross","keywords":["christianity"],"skins":[{"unified":"271d-fe0f","native":"\u271D\uFE0F"}],"version":1},"orthodox_cross":{"id":"orthodox_cross","name":"Orthodox Cross","keywords":["suppedaneum","religion"],"skins":[{"unified":"2626-fe0f","native":"\u2626\uFE0F"}],"version":1},"star_and_crescent":{"id":"star_and_crescent","name":"Star and Crescent","keywords":["islam"],"skins":[{"unified":"262a-fe0f","native":"\u262A\uFE0F"}],"version":1},"peace_symbol":{"id":"peace_symbol","name":"Peace Symbol","keywords":["hippie"],"skins":[{"unified":"262e-fe0f","native":"\u262E\uFE0F"}],"version":1},"menorah_with_nine_branches":{"id":"menorah_with_nine_branches","name":"Menorah","keywords":["with","nine","branches","hanukkah","candles","jewish"],"skins":[{"unified":"1f54e","native":"\uD83D\uDD4E"}],"version":1},"six_pointed_star":{"id":"six_pointed_star","name":"Dotted Six-Pointed Star","keywords":["six","pointed","purple","square","religion","jewish","hexagram"],"skins":[{"unified":"1f52f","native":"\uD83D\uDD2F"}],"version":1},"khanda":{"id":"khanda","name":"Khanda","keywords":["Sikhism","religion"],"skins":[{"unified":"1faaf","native":"\uD83E\uDEAF"}],"version":15},"aries":{"id":"aries","name":"Aries","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"2648","native":"\u2648"}],"version":1},"taurus":{"id":"taurus","name":"Taurus","keywords":["purple","square","sign","zodiac","astrology"],"skins":[{"unified":"2649","native":"\u2649"}],"version":1},"gemini":{"id":"gemini","name":"Gemini","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264a","native":"\u264A"}],"version":1},"cancer":{"id":"cancer","name":"Cancer","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264b","native":"\u264B"}],"version":1},"leo":{"id":"leo","name":"Leo","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"264c","native":"\u264C"}],"version":1},"virgo":{"id":"virgo","name":"Virgo","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264d","native":"\u264D"}],"version":1},"libra":{"id":"libra","name":"Libra","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"264e","native":"\u264E"}],"version":1},"scorpius":{"id":"scorpius","name":"Scorpio","keywords":["scorpius","sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264f","native":"\u264F"}],"version":1},"sagittarius":{"id":"sagittarius","name":"Sagittarius","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"2650","native":"\u2650"}],"version":1},"capricorn":{"id":"capricorn","name":"Capricorn","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"2651","native":"\u2651"}],"version":1},"aquarius":{"id":"aquarius","name":"Aquarius","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"2652","native":"\u2652"}],"version":1},"pisces":{"id":"pisces","name":"Pisces","keywords":["purple","square","sign","zodiac","astrology"],"skins":[{"unified":"2653","native":"\u2653"}],"version":1},"ophiuchus":{"id":"ophiuchus","name":"Ophiuchus","keywords":["sign","purple","square","constellation","astrology"],"skins":[{"unified":"26ce","native":"\u26CE"}],"version":1},"twisted_rightwards_arrows":{"id":"twisted_rightwards_arrows","name":"Shuffle Tracks Button","keywords":["twisted","rightwards","arrows","blue","square","music","random"],"skins":[{"unified":"1f500","native":"\uD83D\uDD00"}],"version":1},"repeat":{"id":"repeat","name":"Repeat Button","keywords":["loop","record"],"skins":[{"unified":"1f501","native":"\uD83D\uDD01"}],"version":1},"repeat_one":{"id":"repeat_one","name":"Repeat Single Button","keywords":["one","blue","square","loop"],"skins":[{"unified":"1f502","native":"\uD83D\uDD02"}],"version":1},"arrow_forward":{"id":"arrow_forward","name":"Play Button","keywords":["arrow","forward","blue","square","right","direction"],"skins":[{"unified":"25b6-fe0f","native":"\u25B6\uFE0F"}],"version":1},"fast_forward":{"id":"fast_forward","name":"Fast-Forward Button","keywords":["fast","forward","blue","square","play","speed","continue"],"skins":[{"unified":"23e9","native":"\u23E9"}],"version":1},"black_right_pointing_double_triangle_with_vertical_bar":{"id":"black_right_pointing_double_triangle_with_vertical_bar","name":"Next Track Button","keywords":["black","right","pointing","double","triangle","with","vertical","bar","forward","blue","square"],"skins":[{"unified":"23ed-fe0f","native":"\u23ED\uFE0F"}],"version":1},"black_right_pointing_triangle_with_double_vertical_bar":{"id":"black_right_pointing_triangle_with_double_vertical_bar","name":"Play or Pause Button","keywords":["black","right","pointing","triangle","with","double","vertical","bar","blue","square"],"skins":[{"unified":"23ef-fe0f","native":"\u23EF\uFE0F"}],"version":1},"arrow_backward":{"id":"arrow_backward","name":"Reverse Button","keywords":["arrow","backward","blue","square","left","direction"],"skins":[{"unified":"25c0-fe0f","native":"\u25C0\uFE0F"}],"version":1},"rewind":{"id":"rewind","name":"Fast Reverse Button","keywords":["rewind","play","blue","square"],"skins":[{"unified":"23ea","native":"\u23EA"}],"version":1},"black_left_pointing_double_triangle_with_vertical_bar":{"id":"black_left_pointing_double_triangle_with_vertical_bar","name":"Last Track Button","keywords":["black","left","pointing","double","triangle","with","vertical","bar","backward"],"skins":[{"unified":"23ee-fe0f","native":"\u23EE\uFE0F"}],"version":1},"arrow_up_small":{"id":"arrow_up_small","name":"Upwards Button","keywords":["arrow","up","small","blue","square","triangle","direction","point","forward","top"],"skins":[{"unified":"1f53c","native":"\uD83D\uDD3C"}],"version":1},"arrow_double_up":{"id":"arrow_double_up","name":"Fast Up Button","keywords":["arrow","double","blue","square","direction","top"],"skins":[{"unified":"23eb","native":"\u23EB"}],"version":1},"arrow_down_small":{"id":"arrow_down_small","name":"Downwards Button","keywords":["arrow","down","small","blue","square","direction","bottom"],"skins":[{"unified":"1f53d","native":"\uD83D\uDD3D"}],"version":1},"arrow_double_down":{"id":"arrow_double_down","name":"Fast Down Button","keywords":["arrow","double","blue","square","direction","bottom"],"skins":[{"unified":"23ec","native":"\u23EC"}],"version":1},"double_vertical_bar":{"id":"double_vertical_bar","name":"Pause Button","keywords":["double","vertical","bar","blue","square"],"skins":[{"unified":"23f8-fe0f","native":"\u23F8\uFE0F"}],"version":1},"black_square_for_stop":{"id":"black_square_for_stop","name":"Stop Button","keywords":["black","square","for","blue"],"skins":[{"unified":"23f9-fe0f","native":"\u23F9\uFE0F"}],"version":1},"black_circle_for_record":{"id":"black_circle_for_record","name":"Record Button","keywords":["black","circle","for","blue","square"],"skins":[{"unified":"23fa-fe0f","native":"\u23FA\uFE0F"}],"version":1},"eject":{"id":"eject","name":"Eject Button","keywords":["blue","square"],"skins":[{"unified":"23cf-fe0f","native":"\u23CF\uFE0F"}],"version":1},"cinema":{"id":"cinema","name":"Cinema","keywords":["blue","square","record","film","movie","curtain","stage","theater"],"skins":[{"unified":"1f3a6","native":"\uD83C\uDFA6"}],"version":1},"low_brightness":{"id":"low_brightness","name":"Dim Button","keywords":["low","brightness","sun","afternoon","warm","summer"],"skins":[{"unified":"1f505","native":"\uD83D\uDD05"}],"version":1},"high_brightness":{"id":"high_brightness","name":"Bright Button","keywords":["high","brightness","sun","light"],"skins":[{"unified":"1f506","native":"\uD83D\uDD06"}],"version":1},"signal_strength":{"id":"signal_strength","name":"Antenna Bars","keywords":["signal","strength","blue","square","reception","phone","internet","connection","wifi","bluetooth"],"skins":[{"unified":"1f4f6","native":"\uD83D\uDCF6"}],"version":1},"wireless":{"id":"wireless","name":"Wireless","keywords":["wifi","internet","contactless","signal"],"skins":[{"unified":"1f6dc","native":"\uD83D\uDEDC"}],"version":15},"vibration_mode":{"id":"vibration_mode","name":"Vibration Mode","keywords":["orange","square","phone"],"skins":[{"unified":"1f4f3","native":"\uD83D\uDCF3"}],"version":1},"mobile_phone_off":{"id":"mobile_phone_off","name":"Mobile Phone off","keywords":["mute","orange","square","silence","quiet"],"skins":[{"unified":"1f4f4","native":"\uD83D\uDCF4"}],"version":1},"female_sign":{"id":"female_sign","name":"Female Sign","keywords":["woman","women","lady","girl"],"skins":[{"unified":"2640-fe0f","native":"\u2640\uFE0F"}],"version":4},"male_sign":{"id":"male_sign","name":"Male Sign","keywords":["man","boy","men"],"skins":[{"unified":"2642-fe0f","native":"\u2642\uFE0F"}],"version":4},"transgender_symbol":{"id":"transgender_symbol","name":"Transgender Symbol","keywords":["lgbtq"],"skins":[{"unified":"26a7-fe0f","native":"\u26A7\uFE0F"}],"version":13},"heavy_multiplication_x":{"id":"heavy_multiplication_x","name":"Multiply","keywords":["heavy","multiplication","x","sign","math","calculation"],"skins":[{"unified":"2716-fe0f","native":"\u2716\uFE0F"}],"version":1},"heavy_plus_sign":{"id":"heavy_plus_sign","name":"Plus","keywords":["heavy","sign","math","calculation","addition","more","increase"],"skins":[{"unified":"2795","native":"\u2795"}],"version":1},"heavy_minus_sign":{"id":"heavy_minus_sign","name":"Minus","keywords":["heavy","sign","math","calculation","subtract","less"],"skins":[{"unified":"2796","native":"\u2796"}],"version":1},"heavy_division_sign":{"id":"heavy_division_sign","name":"Divide","keywords":["heavy","division","sign","math","calculation"],"skins":[{"unified":"2797","native":"\u2797"}],"version":1},"heavy_equals_sign":{"id":"heavy_equals_sign","name":"Heavy Equals Sign","keywords":["math"],"skins":[{"unified":"1f7f0","native":"\uD83D\uDFF0"}],"version":14},"infinity":{"id":"infinity","name":"Infinity","keywords":["forever"],"skins":[{"unified":"267e-fe0f","native":"\u267E\uFE0F"}],"version":11},"bangbang":{"id":"bangbang","name":"Double Exclamation Mark","keywords":["bangbang","surprise"],"skins":[{"unified":"203c-fe0f","native":"\u203C\uFE0F"}],"version":1},"interrobang":{"id":"interrobang","name":"Exclamation Question Mark","keywords":["interrobang","wat","punctuation","surprise"],"skins":[{"unified":"2049-fe0f","native":"\u2049\uFE0F"}],"version":1},"question":{"id":"question","name":"Red Question Mark","keywords":["doubt","confused"],"skins":[{"unified":"2753","native":"\u2753"}],"version":1},"grey_question":{"id":"grey_question","name":"White Question Mark","keywords":["grey","doubts","gray","huh","confused"],"skins":[{"unified":"2754","native":"\u2754"}],"version":1},"grey_exclamation":{"id":"grey_exclamation","name":"White Exclamation Mark","keywords":["grey","surprise","punctuation","gray","wow","warning"],"skins":[{"unified":"2755","native":"\u2755"}],"version":1},"exclamation":{"id":"exclamation","name":"Red Exclamation Mark","keywords":["heavy","danger","surprise","punctuation","wow","warning"],"skins":[{"unified":"2757","native":"\u2757"}],"version":1},"wavy_dash":{"id":"wavy_dash","name":"Wavy Dash","keywords":["draw","line","moustache","mustache","squiggle","scribble"],"skins":[{"unified":"3030-fe0f","native":"\u3030\uFE0F"}],"version":1},"currency_exchange":{"id":"currency_exchange","name":"Currency Exchange","keywords":["money","sales","dollar","travel"],"skins":[{"unified":"1f4b1","native":"\uD83D\uDCB1"}],"version":1},"heavy_dollar_sign":{"id":"heavy_dollar_sign","name":"Heavy Dollar Sign","keywords":["money","sales","payment","currency","buck"],"skins":[{"unified":"1f4b2","native":"\uD83D\uDCB2"}],"version":1},"medical_symbol":{"id":"medical_symbol","name":"Medical Symbol","keywords":["staff","of","aesculapius","health","hospital"],"skins":[{"unified":"2695-fe0f","native":"\u2695\uFE0F"}],"version":4},"recycle":{"id":"recycle","name":"Recycling Symbol","keywords":["recycle","arrow","environment","garbage","trash"],"skins":[{"unified":"267b-fe0f","native":"\u267B\uFE0F"}],"version":1},"fleur_de_lis":{"id":"fleur_de_lis","name":"Fleur-De-Lis","keywords":["fleur","de","lis","decorative","scout"],"skins":[{"unified":"269c-fe0f","native":"\u269C\uFE0F"}],"version":1},"trident":{"id":"trident","name":"Trident Emblem","keywords":["weapon","spear"],"skins":[{"unified":"1f531","native":"\uD83D\uDD31"}],"version":1},"name_badge":{"id":"name_badge","name":"Name Badge","keywords":["fire","forbid"],"skins":[{"unified":"1f4db","native":"\uD83D\uDCDB"}],"version":1},"beginner":{"id":"beginner","name":"Japanese Symbol for Beginner","keywords":["badge","shield"],"skins":[{"unified":"1f530","native":"\uD83D\uDD30"}],"version":1},"o":{"id":"o","name":"Hollow Red Circle","keywords":["o","round"],"skins":[{"unified":"2b55","native":"\u2B55"}],"version":1},"white_check_mark":{"id":"white_check_mark","name":"Check Mark Button","keywords":["white","green","square","ok","agree","vote","election","answer","tick"],"skins":[{"unified":"2705","native":"\u2705"}],"version":1},"ballot_box_with_check":{"id":"ballot_box_with_check","name":"Check Box with Check","keywords":["ballot","ok","agree","confirm","black","square","vote","election","yes","tick"],"skins":[{"unified":"2611-fe0f","native":"\u2611\uFE0F"}],"version":1},"heavy_check_mark":{"id":"heavy_check_mark","name":"Check Mark","keywords":["heavy","ok","nike","answer","yes","tick"],"skins":[{"unified":"2714-fe0f","native":"\u2714\uFE0F"}],"version":1},"x":{"id":"x","name":"Cross Mark","keywords":["x","no","delete","remove","cancel","red"],"skins":[{"unified":"274c","native":"\u274C"}],"version":1},"negative_squared_cross_mark":{"id":"negative_squared_cross_mark","name":"Cross Mark Button","keywords":["negative","squared","x","green","square","no","deny"],"skins":[{"unified":"274e","native":"\u274E"}],"version":1},"curly_loop":{"id":"curly_loop","name":"Curly Loop","keywords":["scribble","draw","shape","squiggle"],"skins":[{"unified":"27b0","native":"\u27B0"}],"version":1},"loop":{"id":"loop","name":"Double Curly Loop","keywords":["tape","cassette"],"skins":[{"unified":"27bf","native":"\u27BF"}],"version":1},"part_alternation_mark":{"id":"part_alternation_mark","name":"Part Alternation Mark","keywords":["graph","presentation","stats","business","economics","bad"],"skins":[{"unified":"303d-fe0f","native":"\u303D\uFE0F"}],"version":1},"eight_spoked_asterisk":{"id":"eight_spoked_asterisk","name":"Eight Spoked Asterisk","keywords":["star","sparkle","green","square"],"skins":[{"unified":"2733-fe0f","native":"\u2733\uFE0F"}],"version":1},"eight_pointed_black_star":{"id":"eight_pointed_black_star","name":"Eight-Pointed Star","keywords":["eight","pointed","black","orange","square","shape","polygon"],"skins":[{"unified":"2734-fe0f","native":"\u2734\uFE0F"}],"version":1},"sparkle":{"id":"sparkle","name":"Sparkle","keywords":["stars","green","square","awesome","good","fireworks"],"skins":[{"unified":"2747-fe0f","native":"\u2747\uFE0F"}],"version":1},"copyright":{"id":"copyright","name":"Copyright","keywords":["ip","license","circle","law","legal"],"skins":[{"unified":"00a9-fe0f","native":"\xa9\uFE0F"}],"version":1},"registered":{"id":"registered","name":"Registered","keywords":["alphabet","circle"],"skins":[{"unified":"00ae-fe0f","native":"\xae\uFE0F"}],"version":1},"tm":{"id":"tm","name":"Trade Mark","keywords":["tm","trademark","brand","law","legal"],"skins":[{"unified":"2122-fe0f","native":"\u2122\uFE0F"}],"version":1},"hash":{"id":"hash","name":"Hash Key","keywords":["keycap","","symbol","blue","square","twitter"],"skins":[{"unified":"0023-fe0f-20e3","native":"#\uFE0F\u20E3"}],"version":1},"keycap_star":{"id":"keycap_star","name":"Keycap: *","keywords":["keycap","star",""],"skins":[{"unified":"002a-fe0f-20e3","native":"*\uFE0F\u20E3"}],"version":2},"zero":{"id":"zero","name":"Keycap 0","keywords":["zero","numbers","blue","square","null"],"skins":[{"unified":"0030-fe0f-20e3","native":"0\uFE0F\u20E3"}],"version":1},"one":{"id":"one","name":"Keycap 1","keywords":["one","blue","square","numbers"],"skins":[{"unified":"0031-fe0f-20e3","native":"1\uFE0F\u20E3"}],"version":1},"two":{"id":"two","name":"Keycap 2","keywords":["two","numbers","prime","blue","square"],"skins":[{"unified":"0032-fe0f-20e3","native":"2\uFE0F\u20E3"}],"version":1},"three":{"id":"three","name":"Keycap 3","keywords":["three","numbers","prime","blue","square"],"skins":[{"unified":"0033-fe0f-20e3","native":"3\uFE0F\u20E3"}],"version":1},"four":{"id":"four","name":"Keycap 4","keywords":["four","numbers","blue","square"],"skins":[{"unified":"0034-fe0f-20e3","native":"4\uFE0F\u20E3"}],"version":1},"five":{"id":"five","name":"Keycap 5","keywords":["five","numbers","blue","square","prime"],"skins":[{"unified":"0035-fe0f-20e3","native":"5\uFE0F\u20E3"}],"version":1},"six":{"id":"six","name":"Keycap 6","keywords":["six","numbers","blue","square"],"skins":[{"unified":"0036-fe0f-20e3","native":"6\uFE0F\u20E3"}],"version":1},"seven":{"id":"seven","name":"Keycap 7","keywords":["seven","numbers","blue","square","prime"],"skins":[{"unified":"0037-fe0f-20e3","native":"7\uFE0F\u20E3"}],"version":1},"eight":{"id":"eight","name":"Keycap 8","keywords":["eight","blue","square","numbers"],"skins":[{"unified":"0038-fe0f-20e3","native":"8\uFE0F\u20E3"}],"version":1},"nine":{"id":"nine","name":"Keycap 9","keywords":["nine","blue","square","numbers"],"skins":[{"unified":"0039-fe0f-20e3","native":"9\uFE0F\u20E3"}],"version":1},"keycap_ten":{"id":"keycap_ten","name":"Keycap 10","keywords":["ten","numbers","blue","square"],"skins":[{"unified":"1f51f","native":"\uD83D\uDD1F"}],"version":1},"capital_abcd":{"id":"capital_abcd","name":"Input Latin Uppercase","keywords":["capital","abcd","alphabet","words","blue","square"],"skins":[{"unified":"1f520","native":"\uD83D\uDD20"}],"version":1},"abcd":{"id":"abcd","name":"Input Latin Lowercase","keywords":["abcd","blue","square","alphabet"],"skins":[{"unified":"1f521","native":"\uD83D\uDD21"}],"version":1},"symbols":{"id":"symbols","name":"Input Symbols","keywords":["blue","square","music","note","ampersand","percent","glyphs","characters"],"skins":[{"unified":"1f523","native":"\uD83D\uDD23"}],"version":1},"abc":{"id":"abc","name":"Input Latin Letters","keywords":["abc","blue","square","alphabet"],"skins":[{"unified":"1f524","native":"\uD83D\uDD24"}],"version":1},"a":{"id":"a","name":"A Button (blood Type)","keywords":["red","square","alphabet","letter"],"skins":[{"unified":"1f170-fe0f","native":"\uD83C\uDD70\uFE0F"}],"version":1},"ab":{"id":"ab","name":"Negative Squared Ab","keywords":["button","red","square","alphabet"],"skins":[{"unified":"1f18e","native":"\uD83C\uDD8E"}],"version":1},"b":{"id":"b","name":"B Button (blood Type)","keywords":["red","square","alphabet","letter"],"skins":[{"unified":"1f171-fe0f","native":"\uD83C\uDD71\uFE0F"}],"version":1},"cl":{"id":"cl","name":"Cl Button","keywords":["alphabet","words","red","square"],"skins":[{"unified":"1f191","native":"\uD83C\uDD91"}],"version":1},"cool":{"id":"cool","name":"Cool Button","keywords":["words","blue","square"],"skins":[{"unified":"1f192","native":"\uD83C\uDD92"}],"version":1},"free":{"id":"free","name":"Free Button","keywords":["blue","square","words"],"skins":[{"unified":"1f193","native":"\uD83C\uDD93"}],"version":1},"information_source":{"id":"information_source","name":"Information","keywords":["source","blue","square","alphabet","letter"],"skins":[{"unified":"2139-fe0f","native":"\u2139\uFE0F"}],"version":1},"id":{"id":"id","name":"Id Button","keywords":["purple","square","words"],"skins":[{"unified":"1f194","native":"\uD83C\uDD94"}],"version":1},"m":{"id":"m","name":"Circled M","keywords":["alphabet","blue","circle","letter"],"skins":[{"unified":"24c2-fe0f","native":"\u24C2\uFE0F"}],"version":1},"new":{"id":"new","name":"New Button","keywords":["blue","square","words","start"],"skins":[{"unified":"1f195","native":"\uD83C\uDD95"}],"version":1},"ng":{"id":"ng","name":"Ng Button","keywords":["blue","square","words","shape","icon"],"skins":[{"unified":"1f196","native":"\uD83C\uDD96"}],"version":1},"o2":{"id":"o2","name":"O Button (blood Type)","keywords":["o2","alphabet","red","square","letter"],"skins":[{"unified":"1f17e-fe0f","native":"\uD83C\uDD7E\uFE0F"}],"version":1},"ok":{"id":"ok","name":"Ok Button","keywords":["good","agree","yes","blue","square"],"skins":[{"unified":"1f197","native":"\uD83C\uDD97"}],"version":1},"parking":{"id":"parking","name":"P Button","keywords":["parking","cars","blue","square","alphabet","letter"],"skins":[{"unified":"1f17f-fe0f","native":"\uD83C\uDD7F\uFE0F"}],"version":1},"sos":{"id":"sos","name":"Sos Button","keywords":["help","red","square","words","emergency","911"],"skins":[{"unified":"1f198","native":"\uD83C\uDD98"}],"version":1},"up":{"id":"up","name":"Up! Button","keywords":["up","blue","square","above","high"],"skins":[{"unified":"1f199","native":"\uD83C\uDD99"}],"version":1},"vs":{"id":"vs","name":"Vs Button","keywords":["words","orange","square"],"skins":[{"unified":"1f19a","native":"\uD83C\uDD9A"}],"version":1},"koko":{"id":"koko","name":"Squared Katakana Koko","keywords":["japanese","here","button","blue","square","destination"],"skins":[{"unified":"1f201","native":"\uD83C\uDE01"}],"version":1},"sa":{"id":"sa","name":"Squared Katakana Sa","keywords":["japanese","service","charge","button","blue","square"],"skins":[{"unified":"1f202-fe0f","native":"\uD83C\uDE02\uFE0F"}],"version":1},"u6708":{"id":"u6708","name":"Japanese \u201Cmonthly Amount\u201D Button","keywords":["u6708","monthly","amount","chinese","month","moon","orange","square","kanji"],"skins":[{"unified":"1f237-fe0f","native":"\uD83C\uDE37\uFE0F"}],"version":1},"u6709":{"id":"u6709","name":"Squared Cjk Unified Ideograph-6709","keywords":["u6709","japanese","not","free","of","charge","button","orange","square","chinese","have","kanji"],"skins":[{"unified":"1f236","native":"\uD83C\uDE36"}],"version":1},"u6307":{"id":"u6307","name":"Japanese \u201Creserved\u201D Button","keywords":["u6307","reserved","chinese","point","green","square","kanji"],"skins":[{"unified":"1f22f","native":"\uD83C\uDE2F"}],"version":1},"ideograph_advantage":{"id":"ideograph_advantage","name":"Japanese \u201Cbargain\u201D Button","keywords":["ideograph","advantage","bargain","chinese","kanji","obtain","get","circle"],"skins":[{"unified":"1f250","native":"\uD83C\uDE50"}],"version":1},"u5272":{"id":"u5272","name":"Japanese \u201Cdiscount\u201D Button","keywords":["u5272","discount","cut","divide","chinese","kanji","pink","square"],"skins":[{"unified":"1f239","native":"\uD83C\uDE39"}],"version":1},"u7121":{"id":"u7121","name":"Japanese \u201Cfree of Charge\u201D Button","keywords":["u7121","free","charge","nothing","chinese","kanji","orange","square"],"skins":[{"unified":"1f21a","native":"\uD83C\uDE1A"}],"version":1},"u7981":{"id":"u7981","name":"Japanese \u201Cprohibited\u201D Button","keywords":["u7981","prohibited","kanji","chinese","forbidden","limit","restricted","red","square"],"skins":[{"unified":"1f232","native":"\uD83C\uDE32"}],"version":1},"accept":{"id":"accept","name":"Circled Ideograph Accept","keywords":["japanese","acceptable","button","ok","good","chinese","kanji","agree","yes","orange","circle"],"skins":[{"unified":"1f251","native":"\uD83C\uDE51"}],"version":1},"u7533":{"id":"u7533","name":"Japanese \u201Capplication\u201D Button","keywords":["u7533","application","chinese","kanji","orange","square"],"skins":[{"unified":"1f238","native":"\uD83C\uDE38"}],"version":1},"u5408":{"id":"u5408","name":"Japanese \u201Cpassing Grade\u201D Button","keywords":["u5408","passing","grade","chinese","join","kanji","red","square"],"skins":[{"unified":"1f234","native":"\uD83C\uDE34"}],"version":1},"u7a7a":{"id":"u7a7a","name":"Japanese \u201Cvacancy\u201D Button","keywords":["u7a7a","vacancy","kanji","chinese","empty","sky","blue","square"],"skins":[{"unified":"1f233","native":"\uD83C\uDE33"}],"version":1},"congratulations":{"id":"congratulations","name":"Circled Ideograph Congratulation","keywords":["congratulations","japanese","button","chinese","kanji","red","circle"],"skins":[{"unified":"3297-fe0f","native":"\u3297\uFE0F"}],"version":1},"secret":{"id":"secret","name":"Circled Ideograph Secret","keywords":["japanese","button","privacy","chinese","sshh","kanji","red","circle"],"skins":[{"unified":"3299-fe0f","native":"\u3299\uFE0F"}],"version":1},"u55b6":{"id":"u55b6","name":"Squared Cjk Unified Ideograph-55b6","keywords":["u55b6","japanese","open","for","business","button","opening","hours","orange","square"],"skins":[{"unified":"1f23a","native":"\uD83C\uDE3A"}],"version":1},"u6e80":{"id":"u6e80","name":"Japanese \u201Cno Vacancy\u201D Button","keywords":["u6e80","no","vacancy","full","chinese","red","square","kanji"],"skins":[{"unified":"1f235","native":"\uD83C\uDE35"}],"version":1},"red_circle":{"id":"red_circle","name":"Red Circle","keywords":["shape","error","danger"],"skins":[{"unified":"1f534","native":"\uD83D\uDD34"}],"version":1},"large_orange_circle":{"id":"large_orange_circle","name":"Orange Circle","keywords":["large","round"],"skins":[{"unified":"1f7e0","native":"\uD83D\uDFE0"}],"version":12},"large_yellow_circle":{"id":"large_yellow_circle","name":"Yellow Circle","keywords":["large","round"],"skins":[{"unified":"1f7e1","native":"\uD83D\uDFE1"}],"version":12},"large_green_circle":{"id":"large_green_circle","name":"Green Circle","keywords":["large","round"],"skins":[{"unified":"1f7e2","native":"\uD83D\uDFE2"}],"version":12},"large_blue_circle":{"id":"large_blue_circle","name":"Blue Circle","keywords":["large","shape","icon","button"],"skins":[{"unified":"1f535","native":"\uD83D\uDD35"}],"version":1},"large_purple_circle":{"id":"large_purple_circle","name":"Purple Circle","keywords":["large","round"],"skins":[{"unified":"1f7e3","native":"\uD83D\uDFE3"}],"version":12},"large_brown_circle":{"id":"large_brown_circle","name":"Brown Circle","keywords":["large","round"],"skins":[{"unified":"1f7e4","native":"\uD83D\uDFE4"}],"version":12},"black_circle":{"id":"black_circle","name":"Black Circle","keywords":["shape","button","round"],"skins":[{"unified":"26ab","native":"\u26AB"}],"version":1},"white_circle":{"id":"white_circle","name":"White Circle","keywords":["shape","round"],"skins":[{"unified":"26aa","native":"\u26AA"}],"version":1},"large_red_square":{"id":"large_red_square","name":"Red Square","keywords":["large"],"skins":[{"unified":"1f7e5","native":"\uD83D\uDFE5"}],"version":12},"large_orange_square":{"id":"large_orange_square","name":"Orange Square","keywords":["large"],"skins":[{"unified":"1f7e7","native":"\uD83D\uDFE7"}],"version":12},"large_yellow_square":{"id":"large_yellow_square","name":"Yellow Square","keywords":["large"],"skins":[{"unified":"1f7e8","native":"\uD83D\uDFE8"}],"version":12},"large_green_square":{"id":"large_green_square","name":"Green Square","keywords":["large"],"skins":[{"unified":"1f7e9","native":"\uD83D\uDFE9"}],"version":12},"large_blue_square":{"id":"large_blue_square","name":"Blue Square","keywords":["large"],"skins":[{"unified":"1f7e6","native":"\uD83D\uDFE6"}],"version":12},"large_purple_square":{"id":"large_purple_square","name":"Purple Square","keywords":["large"],"skins":[{"unified":"1f7ea","native":"\uD83D\uDFEA"}],"version":12},"large_brown_square":{"id":"large_brown_square","name":"Brown Square","keywords":["large"],"skins":[{"unified":"1f7eb","native":"\uD83D\uDFEB"}],"version":12},"black_large_square":{"id":"black_large_square","name":"Black Large Square","keywords":["shape","icon","button"],"skins":[{"unified":"2b1b","native":"\u2B1B"}],"version":1},"white_large_square":{"id":"white_large_square","name":"White Large Square","keywords":["shape","icon","stone","button"],"skins":[{"unified":"2b1c","native":"\u2B1C"}],"version":1},"black_medium_square":{"id":"black_medium_square","name":"Black Medium Square","keywords":["shape","button","icon"],"skins":[{"unified":"25fc-fe0f","native":"\u25FC\uFE0F"}],"version":1},"white_medium_square":{"id":"white_medium_square","name":"White Medium Square","keywords":["shape","stone","icon"],"skins":[{"unified":"25fb-fe0f","native":"\u25FB\uFE0F"}],"version":1},"black_medium_small_square":{"id":"black_medium_small_square","name":"Black Medium Small Square","keywords":["icon","shape","button"],"skins":[{"unified":"25fe","native":"\u25FE"}],"version":1},"white_medium_small_square":{"id":"white_medium_small_square","name":"White Medium Small Square","keywords":["shape","stone","icon","button"],"skins":[{"unified":"25fd","native":"\u25FD"}],"version":1},"black_small_square":{"id":"black_small_square","name":"Black Small Square","keywords":["shape","icon"],"skins":[{"unified":"25aa-fe0f","native":"\u25AA\uFE0F"}],"version":1},"white_small_square":{"id":"white_small_square","name":"White Small Square","keywords":["shape","icon"],"skins":[{"unified":"25ab-fe0f","native":"\u25AB\uFE0F"}],"version":1},"large_orange_diamond":{"id":"large_orange_diamond","name":"Large Orange Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f536","native":"\uD83D\uDD36"}],"version":1},"large_blue_diamond":{"id":"large_blue_diamond","name":"Large Blue Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f537","native":"\uD83D\uDD37"}],"version":1},"small_orange_diamond":{"id":"small_orange_diamond","name":"Small Orange Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f538","native":"\uD83D\uDD38"}],"version":1},"small_blue_diamond":{"id":"small_blue_diamond","name":"Small Blue Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f539","native":"\uD83D\uDD39"}],"version":1},"small_red_triangle":{"id":"small_red_triangle","name":"Red Triangle Pointed Up","keywords":["small","shape","direction","top"],"skins":[{"unified":"1f53a","native":"\uD83D\uDD3A"}],"version":1},"small_red_triangle_down":{"id":"small_red_triangle_down","name":"Red Triangle Pointed Down","keywords":["small","shape","direction","bottom"],"skins":[{"unified":"1f53b","native":"\uD83D\uDD3B"}],"version":1},"diamond_shape_with_a_dot_inside":{"id":"diamond_shape_with_a_dot_inside","name":"Diamond with a Dot","keywords":["shape","inside","jewel","blue","gem","crystal","fancy"],"skins":[{"unified":"1f4a0","native":"\uD83D\uDCA0"}],"version":1},"radio_button":{"id":"radio_button","name":"Radio Button","keywords":["input","old","music","circle"],"skins":[{"unified":"1f518","native":"\uD83D\uDD18"}],"version":1},"white_square_button":{"id":"white_square_button","name":"White Square Button","keywords":["shape","input"],"skins":[{"unified":"1f533","native":"\uD83D\uDD33"}],"version":1},"black_square_button":{"id":"black_square_button","name":"Black Square Button","keywords":["shape","input","frame"],"skins":[{"unified":"1f532","native":"\uD83D\uDD32"}],"version":1},"checkered_flag":{"id":"checkered_flag","name":"Chequered Flag","keywords":["checkered","contest","finishline","race","gokart"],"skins":[{"unified":"1f3c1","native":"\uD83C\uDFC1"}],"version":1},"triangular_flag_on_post":{"id":"triangular_flag_on_post","name":"Triangular Flag","keywords":["on","post","mark","milestone","place"],"skins":[{"unified":"1f6a9","native":"\uD83D\uDEA9"}],"version":1},"crossed_flags":{"id":"crossed_flags","name":"Crossed Flags","keywords":["japanese","nation","country","border"],"skins":[{"unified":"1f38c","native":"\uD83C\uDF8C"}],"version":1},"waving_black_flag":{"id":"waving_black_flag","name":"Black Flag","keywords":["waving","pirate"],"skins":[{"unified":"1f3f4","native":"\uD83C\uDFF4"}],"version":1},"waving_white_flag":{"id":"waving_white_flag","name":"White Flag","keywords":["waving","losing","loser","lost","surrender","give","up","fail"],"skins":[{"unified":"1f3f3-fe0f","native":"\uD83C\uDFF3\uFE0F"}],"version":1},"rainbow-flag":{"id":"rainbow-flag","name":"Rainbow Flag","keywords":["pride","gay","lgbt","glbt","queer","homosexual","lesbian","bisexual","transgender"],"skins":[{"unified":"1f3f3-fe0f-200d-1f308","native":"\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08"}],"version":4},"transgender_flag":{"id":"transgender_flag","name":"Transgender Flag","keywords":["lgbtq"],"skins":[{"unified":"1f3f3-fe0f-200d-26a7-fe0f","native":"\uD83C\uDFF3\uFE0F\u200D\u26A7\uFE0F"}],"version":13},"pirate_flag":{"id":"pirate_flag","name":"Pirate Flag","keywords":["skull","crossbones","banner"],"skins":[{"unified":"1f3f4-200d-2620-fe0f","native":"\uD83C\uDFF4\u200D\u2620\uFE0F"}],"version":11},"flag-ac":{"id":"flag-ac","name":"Ascension Island Flag","keywords":["ac"],"skins":[{"unified":"1f1e6-1f1e8","native":"\uD83C\uDDE6\uD83C\uDDE8"}],"version":2},"flag-ad":{"id":"flag-ad","name":"Andorra Flag","keywords":["ad","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1e9","native":"\uD83C\uDDE6\uD83C\uDDE9"}],"version":2},"flag-ae":{"id":"flag-ae","name":"United Arab Emirates Flag","keywords":["ae","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ea","native":"\uD83C\uDDE6\uD83C\uDDEA"}],"version":2},"flag-af":{"id":"flag-af","name":"Afghanistan Flag","keywords":["af","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1eb","native":"\uD83C\uDDE6\uD83C\uDDEB"}],"version":2},"flag-ag":{"id":"flag-ag","name":"Antigua & Barbuda Flag","keywords":["ag","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ec","native":"\uD83C\uDDE6\uD83C\uDDEC"}],"version":2},"flag-ai":{"id":"flag-ai","name":"Anguilla Flag","keywords":["ai","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ee","native":"\uD83C\uDDE6\uD83C\uDDEE"}],"version":2},"flag-al":{"id":"flag-al","name":"Albania Flag","keywords":["al","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f1","native":"\uD83C\uDDE6\uD83C\uDDF1"}],"version":2},"flag-am":{"id":"flag-am","name":"Armenia Flag","keywords":["am","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f2","native":"\uD83C\uDDE6\uD83C\uDDF2"}],"version":2},"flag-ao":{"id":"flag-ao","name":"Angola Flag","keywords":["ao","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f4","native":"\uD83C\uDDE6\uD83C\uDDF4"}],"version":2},"flag-aq":{"id":"flag-aq","name":"Antarctica Flag","keywords":["aq","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f6","native":"\uD83C\uDDE6\uD83C\uDDF6"}],"version":2},"flag-ar":{"id":"flag-ar","name":"Argentina Flag","keywords":["ar","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f7","native":"\uD83C\uDDE6\uD83C\uDDF7"}],"version":2},"flag-as":{"id":"flag-as","name":"American Samoa Flag","keywords":["as","ws","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f8","native":"\uD83C\uDDE6\uD83C\uDDF8"}],"version":2},"flag-at":{"id":"flag-at","name":"Austria Flag","keywords":["at","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f9","native":"\uD83C\uDDE6\uD83C\uDDF9"}],"version":2},"flag-au":{"id":"flag-au","name":"Australia Flag","keywords":["au","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1fa","native":"\uD83C\uDDE6\uD83C\uDDFA"}],"version":2},"flag-aw":{"id":"flag-aw","name":"Aruba Flag","keywords":["aw","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1fc","native":"\uD83C\uDDE6\uD83C\uDDFC"}],"version":2},"flag-ax":{"id":"flag-ax","name":"\xc5land Islands Flag","keywords":["ax","aland","Aland","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1fd","native":"\uD83C\uDDE6\uD83C\uDDFD"}],"version":2},"flag-az":{"id":"flag-az","name":"Azerbaijan Flag","keywords":["az","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ff","native":"\uD83C\uDDE6\uD83C\uDDFF"}],"version":2},"flag-ba":{"id":"flag-ba","name":"Bosnia & Herzegovina Flag","keywords":["ba","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1e6","native":"\uD83C\uDDE7\uD83C\uDDE6"}],"version":2},"flag-bb":{"id":"flag-bb","name":"Barbados Flag","keywords":["bb","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1e7","native":"\uD83C\uDDE7\uD83C\uDDE7"}],"version":2},"flag-bd":{"id":"flag-bd","name":"Bangladesh Flag","keywords":["bd","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1e9","native":"\uD83C\uDDE7\uD83C\uDDE9"}],"version":2},"flag-be":{"id":"flag-be","name":"Belgium Flag","keywords":["be","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ea","native":"\uD83C\uDDE7\uD83C\uDDEA"}],"version":2},"flag-bf":{"id":"flag-bf","name":"Burkina Faso Flag","keywords":["bf","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1eb","native":"\uD83C\uDDE7\uD83C\uDDEB"}],"version":2},"flag-bg":{"id":"flag-bg","name":"Bulgaria Flag","keywords":["bg","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ec","native":"\uD83C\uDDE7\uD83C\uDDEC"}],"version":2},"flag-bh":{"id":"flag-bh","name":"Bahrain Flag","keywords":["bh","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ed","native":"\uD83C\uDDE7\uD83C\uDDED"}],"version":2},"flag-bi":{"id":"flag-bi","name":"Burundi Flag","keywords":["bi","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ee","native":"\uD83C\uDDE7\uD83C\uDDEE"}],"version":2},"flag-bj":{"id":"flag-bj","name":"Benin Flag","keywords":["bj","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ef","native":"\uD83C\uDDE7\uD83C\uDDEF"}],"version":2},"flag-bl":{"id":"flag-bl","name":"St. Barth\xe9lemy Flag","keywords":["bl","st","barthelemy","saint","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f1","native":"\uD83C\uDDE7\uD83C\uDDF1"}],"version":2},"flag-bm":{"id":"flag-bm","name":"Bermuda Flag","keywords":["bm","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f2","native":"\uD83C\uDDE7\uD83C\uDDF2"}],"version":2},"flag-bn":{"id":"flag-bn","name":"Brunei Flag","keywords":["bn","darussalam","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f3","native":"\uD83C\uDDE7\uD83C\uDDF3"}],"version":2},"flag-bo":{"id":"flag-bo","name":"Bolivia Flag","keywords":["bo","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f4","native":"\uD83C\uDDE7\uD83C\uDDF4"}],"version":2},"flag-bq":{"id":"flag-bq","name":"Caribbean Netherlands Flag","keywords":["bq","bonaire","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f6","native":"\uD83C\uDDE7\uD83C\uDDF6"}],"version":2},"flag-br":{"id":"flag-br","name":"Brazil Flag","keywords":["br","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f7","native":"\uD83C\uDDE7\uD83C\uDDF7"}],"version":2},"flag-bs":{"id":"flag-bs","name":"Bahamas Flag","keywords":["bs","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f8","native":"\uD83C\uDDE7\uD83C\uDDF8"}],"version":2},"flag-bt":{"id":"flag-bt","name":"Bhutan Flag","keywords":["bt","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f9","native":"\uD83C\uDDE7\uD83C\uDDF9"}],"version":2},"flag-bv":{"id":"flag-bv","name":"Bouvet Island Flag","keywords":["bv","norway"],"skins":[{"unified":"1f1e7-1f1fb","native":"\uD83C\uDDE7\uD83C\uDDFB"}],"version":2},"flag-bw":{"id":"flag-bw","name":"Botswana Flag","keywords":["bw","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1fc","native":"\uD83C\uDDE7\uD83C\uDDFC"}],"version":2},"flag-by":{"id":"flag-by","name":"Belarus Flag","keywords":["by","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1fe","native":"\uD83C\uDDE7\uD83C\uDDFE"}],"version":2},"flag-bz":{"id":"flag-bz","name":"Belize Flag","keywords":["bz","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ff","native":"\uD83C\uDDE7\uD83C\uDDFF"}],"version":2},"flag-ca":{"id":"flag-ca","name":"Canada Flag","keywords":["ca","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1e6","native":"\uD83C\uDDE8\uD83C\uDDE6"}],"version":2},"flag-cc":{"id":"flag-cc","name":"Cocos (keeling) Islands Flag","keywords":["cc","keeling","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1e8","native":"\uD83C\uDDE8\uD83C\uDDE8"}],"version":2},"flag-cd":{"id":"flag-cd","name":"Congo - Kinshasa Flag","keywords":["cd","democratic","republic","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1e9","native":"\uD83C\uDDE8\uD83C\uDDE9"}],"version":2},"flag-cf":{"id":"flag-cf","name":"Central African Republic Flag","keywords":["cf","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1eb","native":"\uD83C\uDDE8\uD83C\uDDEB"}],"version":2},"flag-cg":{"id":"flag-cg","name":"Congo - Brazzaville Flag","keywords":["cg","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ec","native":"\uD83C\uDDE8\uD83C\uDDEC"}],"version":2},"flag-ch":{"id":"flag-ch","name":"Switzerland Flag","keywords":["ch","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ed","native":"\uD83C\uDDE8\uD83C\uDDED"}],"version":2},"flag-ci":{"id":"flag-ci","name":"C\xf4te D\u2019ivoire Flag","keywords":["ci","cote","d","ivoire","ivory","coast","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ee","native":"\uD83C\uDDE8\uD83C\uDDEE"}],"version":2},"flag-ck":{"id":"flag-ck","name":"Cook Islands Flag","keywords":["ck","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f0","native":"\uD83C\uDDE8\uD83C\uDDF0"}],"version":2},"flag-cl":{"id":"flag-cl","name":"Chile Flag","keywords":["cl","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f1","native":"\uD83C\uDDE8\uD83C\uDDF1"}],"version":2},"flag-cm":{"id":"flag-cm","name":"Cameroon Flag","keywords":["cm","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f2","native":"\uD83C\uDDE8\uD83C\uDDF2"}],"version":2},"cn":{"id":"cn","name":"China Flag","keywords":["cn","chinese","prc","country","nation","banner"],"skins":[{"unified":"1f1e8-1f1f3","native":"\uD83C\uDDE8\uD83C\uDDF3"}],"version":1},"flag-co":{"id":"flag-co","name":"Colombia Flag","keywords":["co","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f4","native":"\uD83C\uDDE8\uD83C\uDDF4"}],"version":2},"flag-cp":{"id":"flag-cp","name":"Clipperton Island Flag","keywords":["cp"],"skins":[{"unified":"1f1e8-1f1f5","native":"\uD83C\uDDE8\uD83C\uDDF5"}],"version":2},"flag-cr":{"id":"flag-cr","name":"Costa Rica Flag","keywords":["cr","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f7","native":"\uD83C\uDDE8\uD83C\uDDF7"}],"version":2},"flag-cu":{"id":"flag-cu","name":"Cuba Flag","keywords":["cu","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fa","native":"\uD83C\uDDE8\uD83C\uDDFA"}],"version":2},"flag-cv":{"id":"flag-cv","name":"Cape Verde Flag","keywords":["cv","cabo","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fb","native":"\uD83C\uDDE8\uD83C\uDDFB"}],"version":2},"flag-cw":{"id":"flag-cw","name":"Cura\xe7ao Flag","keywords":["cw","curacao","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fc","native":"\uD83C\uDDE8\uD83C\uDDFC"}],"version":2},"flag-cx":{"id":"flag-cx","name":"Christmas Island Flag","keywords":["cx","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fd","native":"\uD83C\uDDE8\uD83C\uDDFD"}],"version":2},"flag-cy":{"id":"flag-cy","name":"Cyprus Flag","keywords":["cy","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fe","native":"\uD83C\uDDE8\uD83C\uDDFE"}],"version":2},"flag-cz":{"id":"flag-cz","name":"Czechia Flag","keywords":["cz","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ff","native":"\uD83C\uDDE8\uD83C\uDDFF"}],"version":2},"de":{"id":"de","name":"Germany Flag","keywords":["de","german","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1ea","native":"\uD83C\uDDE9\uD83C\uDDEA"}],"version":1},"flag-dg":{"id":"flag-dg","name":"Diego Garcia Flag","keywords":["dg"],"skins":[{"unified":"1f1e9-1f1ec","native":"\uD83C\uDDE9\uD83C\uDDEC"}],"version":2},"flag-dj":{"id":"flag-dj","name":"Djibouti Flag","keywords":["dj","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1ef","native":"\uD83C\uDDE9\uD83C\uDDEF"}],"version":2},"flag-dk":{"id":"flag-dk","name":"Denmark Flag","keywords":["dk","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1f0","native":"\uD83C\uDDE9\uD83C\uDDF0"}],"version":2},"flag-dm":{"id":"flag-dm","name":"Dominica Flag","keywords":["dm","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1f2","native":"\uD83C\uDDE9\uD83C\uDDF2"}],"version":2},"flag-do":{"id":"flag-do","name":"Dominican Republic Flag","keywords":["do","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1f4","native":"\uD83C\uDDE9\uD83C\uDDF4"}],"version":2},"flag-dz":{"id":"flag-dz","name":"Algeria Flag","keywords":["dz","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1ff","native":"\uD83C\uDDE9\uD83C\uDDFF"}],"version":2},"flag-ea":{"id":"flag-ea","name":"Ceuta & Melilla Flag","keywords":["ea"],"skins":[{"unified":"1f1ea-1f1e6","native":"\uD83C\uDDEA\uD83C\uDDE6"}],"version":2},"flag-ec":{"id":"flag-ec","name":"Ecuador Flag","keywords":["ec","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1e8","native":"\uD83C\uDDEA\uD83C\uDDE8"}],"version":2},"flag-ee":{"id":"flag-ee","name":"Estonia Flag","keywords":["ee","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1ea","native":"\uD83C\uDDEA\uD83C\uDDEA"}],"version":2},"flag-eg":{"id":"flag-eg","name":"Egypt Flag","keywords":["eg","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1ec","native":"\uD83C\uDDEA\uD83C\uDDEC"}],"version":2},"flag-eh":{"id":"flag-eh","name":"Western Sahara Flag","keywords":["eh","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1ed","native":"\uD83C\uDDEA\uD83C\uDDED"}],"version":2},"flag-er":{"id":"flag-er","name":"Eritrea Flag","keywords":["er","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1f7","native":"\uD83C\uDDEA\uD83C\uDDF7"}],"version":2},"es":{"id":"es","name":"Spain Flag","keywords":["es","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1f8","native":"\uD83C\uDDEA\uD83C\uDDF8"}],"version":1},"flag-et":{"id":"flag-et","name":"Ethiopia Flag","keywords":["et","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1f9","native":"\uD83C\uDDEA\uD83C\uDDF9"}],"version":2},"flag-eu":{"id":"flag-eu","name":"European Union Flag","keywords":["eu","banner"],"skins":[{"unified":"1f1ea-1f1fa","native":"\uD83C\uDDEA\uD83C\uDDFA"}],"version":2},"flag-fi":{"id":"flag-fi","name":"Finland Flag","keywords":["fi","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1ee","native":"\uD83C\uDDEB\uD83C\uDDEE"}],"version":2},"flag-fj":{"id":"flag-fj","name":"Fiji Flag","keywords":["fj","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1ef","native":"\uD83C\uDDEB\uD83C\uDDEF"}],"version":2},"flag-fk":{"id":"flag-fk","name":"Falkland Islands Flag","keywords":["fk","malvinas","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1f0","native":"\uD83C\uDDEB\uD83C\uDDF0"}],"version":2},"flag-fm":{"id":"flag-fm","name":"Micronesia Flag","keywords":["fm","federated","states","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1f2","native":"\uD83C\uDDEB\uD83C\uDDF2"}],"version":2},"flag-fo":{"id":"flag-fo","name":"Faroe Islands Flag","keywords":["fo","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1f4","native":"\uD83C\uDDEB\uD83C\uDDF4"}],"version":2},"fr":{"id":"fr","name":"France Flag","keywords":["fr","banner","nation","french","country"],"skins":[{"unified":"1f1eb-1f1f7","native":"\uD83C\uDDEB\uD83C\uDDF7"}],"version":1},"flag-ga":{"id":"flag-ga","name":"Gabon Flag","keywords":["ga","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1e6","native":"\uD83C\uDDEC\uD83C\uDDE6"}],"version":2},"gb":{"id":"gb","name":"United Kingdom Flag","keywords":["gb","uk","great","britain","northern","ireland","nation","country","banner","british","UK","english","england","union","jack"],"skins":[{"unified":"1f1ec-1f1e7","native":"\uD83C\uDDEC\uD83C\uDDE7"}],"version":1},"flag-gd":{"id":"flag-gd","name":"Grenada Flag","keywords":["gd","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1e9","native":"\uD83C\uDDEC\uD83C\uDDE9"}],"version":2},"flag-ge":{"id":"flag-ge","name":"Georgia Flag","keywords":["ge","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ea","native":"\uD83C\uDDEC\uD83C\uDDEA"}],"version":2},"flag-gf":{"id":"flag-gf","name":"French Guiana Flag","keywords":["gf","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1eb","native":"\uD83C\uDDEC\uD83C\uDDEB"}],"version":2},"flag-gg":{"id":"flag-gg","name":"Guernsey Flag","keywords":["gg","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ec","native":"\uD83C\uDDEC\uD83C\uDDEC"}],"version":2},"flag-gh":{"id":"flag-gh","name":"Ghana Flag","keywords":["gh","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ed","native":"\uD83C\uDDEC\uD83C\uDDED"}],"version":2},"flag-gi":{"id":"flag-gi","name":"Gibraltar Flag","keywords":["gi","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ee","native":"\uD83C\uDDEC\uD83C\uDDEE"}],"version":2},"flag-gl":{"id":"flag-gl","name":"Greenland Flag","keywords":["gl","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f1","native":"\uD83C\uDDEC\uD83C\uDDF1"}],"version":2},"flag-gm":{"id":"flag-gm","name":"Gambia Flag","keywords":["gm","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f2","native":"\uD83C\uDDEC\uD83C\uDDF2"}],"version":2},"flag-gn":{"id":"flag-gn","name":"Guinea Flag","keywords":["gn","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f3","native":"\uD83C\uDDEC\uD83C\uDDF3"}],"version":2},"flag-gp":{"id":"flag-gp","name":"Guadeloupe Flag","keywords":["gp","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f5","native":"\uD83C\uDDEC\uD83C\uDDF5"}],"version":2},"flag-gq":{"id":"flag-gq","name":"Equatorial Guinea Flag","keywords":["gq","gn","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f6","native":"\uD83C\uDDEC\uD83C\uDDF6"}],"version":2},"flag-gr":{"id":"flag-gr","name":"Greece Flag","keywords":["gr","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f7","native":"\uD83C\uDDEC\uD83C\uDDF7"}],"version":2},"flag-gs":{"id":"flag-gs","name":"South Georgia & South Sandwich Islands Flag","keywords":["gs","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f8","native":"\uD83C\uDDEC\uD83C\uDDF8"}],"version":2},"flag-gt":{"id":"flag-gt","name":"Guatemala Flag","keywords":["gt","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f9","native":"\uD83C\uDDEC\uD83C\uDDF9"}],"version":2},"flag-gu":{"id":"flag-gu","name":"Guam Flag","keywords":["gu","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1fa","native":"\uD83C\uDDEC\uD83C\uDDFA"}],"version":2},"flag-gw":{"id":"flag-gw","name":"Guinea-Bissau Flag","keywords":["gw","guinea","bissau","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1fc","native":"\uD83C\uDDEC\uD83C\uDDFC"}],"version":2},"flag-gy":{"id":"flag-gy","name":"Guyana Flag","keywords":["gy","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1fe","native":"\uD83C\uDDEC\uD83C\uDDFE"}],"version":2},"flag-hk":{"id":"flag-hk","name":"Hong Kong Sar China Flag","keywords":["hk","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f0","native":"\uD83C\uDDED\uD83C\uDDF0"}],"version":2},"flag-hm":{"id":"flag-hm","name":"Heard & Mcdonald Islands Flag","keywords":["hm"],"skins":[{"unified":"1f1ed-1f1f2","native":"\uD83C\uDDED\uD83C\uDDF2"}],"version":2},"flag-hn":{"id":"flag-hn","name":"Honduras Flag","keywords":["hn","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f3","native":"\uD83C\uDDED\uD83C\uDDF3"}],"version":2},"flag-hr":{"id":"flag-hr","name":"Croatia Flag","keywords":["hr","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f7","native":"\uD83C\uDDED\uD83C\uDDF7"}],"version":2},"flag-ht":{"id":"flag-ht","name":"Haiti Flag","keywords":["ht","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f9","native":"\uD83C\uDDED\uD83C\uDDF9"}],"version":2},"flag-hu":{"id":"flag-hu","name":"Hungary Flag","keywords":["hu","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1fa","native":"\uD83C\uDDED\uD83C\uDDFA"}],"version":2},"flag-ic":{"id":"flag-ic","name":"Canary Islands Flag","keywords":["ic","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1e8","native":"\uD83C\uDDEE\uD83C\uDDE8"}],"version":2},"flag-id":{"id":"flag-id","name":"Indonesia Flag","keywords":["id","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1e9","native":"\uD83C\uDDEE\uD83C\uDDE9"}],"version":2},"flag-ie":{"id":"flag-ie","name":"Ireland Flag","keywords":["ie","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1ea","native":"\uD83C\uDDEE\uD83C\uDDEA"}],"version":2},"flag-il":{"id":"flag-il","name":"Israel Flag","keywords":["il","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f1","native":"\uD83C\uDDEE\uD83C\uDDF1"}],"version":2},"flag-im":{"id":"flag-im","name":"Isle of Man Flag","keywords":["im","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f2","native":"\uD83C\uDDEE\uD83C\uDDF2"}],"version":2},"flag-in":{"id":"flag-in","name":"India Flag","keywords":["in","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f3","native":"\uD83C\uDDEE\uD83C\uDDF3"}],"version":2},"flag-io":{"id":"flag-io","name":"British Indian Ocean Territory Flag","keywords":["io","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f4","native":"\uD83C\uDDEE\uD83C\uDDF4"}],"version":2},"flag-iq":{"id":"flag-iq","name":"Iraq Flag","keywords":["iq","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f6","native":"\uD83C\uDDEE\uD83C\uDDF6"}],"version":2},"flag-ir":{"id":"flag-ir","name":"Iran Flag","keywords":["ir","islamic","republic","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f7","native":"\uD83C\uDDEE\uD83C\uDDF7"}],"version":2},"flag-is":{"id":"flag-is","name":"Iceland Flag","keywords":["is","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f8","native":"\uD83C\uDDEE\uD83C\uDDF8"}],"version":2},"it":{"id":"it","name":"Italy Flag","keywords":["it","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f9","native":"\uD83C\uDDEE\uD83C\uDDF9"}],"version":1},"flag-je":{"id":"flag-je","name":"Jersey Flag","keywords":["je","nation","country","banner"],"skins":[{"unified":"1f1ef-1f1ea","native":"\uD83C\uDDEF\uD83C\uDDEA"}],"version":2},"flag-jm":{"id":"flag-jm","name":"Jamaica Flag","keywords":["jm","nation","country","banner"],"skins":[{"unified":"1f1ef-1f1f2","native":"\uD83C\uDDEF\uD83C\uDDF2"}],"version":2},"flag-jo":{"id":"flag-jo","name":"Jordan Flag","keywords":["jo","nation","country","banner"],"skins":[{"unified":"1f1ef-1f1f4","native":"\uD83C\uDDEF\uD83C\uDDF4"}],"version":2},"jp":{"id":"jp","name":"Japan Flag","keywords":["jp","japanese","nation","country","banner","ja"],"skins":[{"unified":"1f1ef-1f1f5","native":"\uD83C\uDDEF\uD83C\uDDF5"}],"version":1},"flag-ke":{"id":"flag-ke","name":"Kenya Flag","keywords":["ke","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ea","native":"\uD83C\uDDF0\uD83C\uDDEA"}],"version":2},"flag-kg":{"id":"flag-kg","name":"Kyrgyzstan Flag","keywords":["kg","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ec","native":"\uD83C\uDDF0\uD83C\uDDEC"}],"version":2},"flag-kh":{"id":"flag-kh","name":"Cambodia Flag","keywords":["kh","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ed","native":"\uD83C\uDDF0\uD83C\uDDED"}],"version":2},"flag-ki":{"id":"flag-ki","name":"Kiribati Flag","keywords":["ki","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ee","native":"\uD83C\uDDF0\uD83C\uDDEE"}],"version":2},"flag-km":{"id":"flag-km","name":"Comoros Flag","keywords":["km","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f2","native":"\uD83C\uDDF0\uD83C\uDDF2"}],"version":2},"flag-kn":{"id":"flag-kn","name":"St. Kitts & Nevis Flag","keywords":["kn","st","saint","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f3","native":"\uD83C\uDDF0\uD83C\uDDF3"}],"version":2},"flag-kp":{"id":"flag-kp","name":"North Korea Flag","keywords":["kp","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f5","native":"\uD83C\uDDF0\uD83C\uDDF5"}],"version":2},"kr":{"id":"kr","name":"South Korea Flag","keywords":["kr","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f7","native":"\uD83C\uDDF0\uD83C\uDDF7"}],"version":1},"flag-kw":{"id":"flag-kw","name":"Kuwait Flag","keywords":["kw","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1fc","native":"\uD83C\uDDF0\uD83C\uDDFC"}],"version":2},"flag-ky":{"id":"flag-ky","name":"Cayman Islands Flag","keywords":["ky","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1fe","native":"\uD83C\uDDF0\uD83C\uDDFE"}],"version":2},"flag-kz":{"id":"flag-kz","name":"Kazakhstan Flag","keywords":["kz","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ff","native":"\uD83C\uDDF0\uD83C\uDDFF"}],"version":2},"flag-la":{"id":"flag-la","name":"Laos Flag","keywords":["la","lao","democratic","republic","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1e6","native":"\uD83C\uDDF1\uD83C\uDDE6"}],"version":2},"flag-lb":{"id":"flag-lb","name":"Lebanon Flag","keywords":["lb","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1e7","native":"\uD83C\uDDF1\uD83C\uDDE7"}],"version":2},"flag-lc":{"id":"flag-lc","name":"St. Lucia Flag","keywords":["lc","st","saint","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1e8","native":"\uD83C\uDDF1\uD83C\uDDE8"}],"version":2},"flag-li":{"id":"flag-li","name":"Liechtenstein Flag","keywords":["li","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1ee","native":"\uD83C\uDDF1\uD83C\uDDEE"}],"version":2},"flag-lk":{"id":"flag-lk","name":"Sri Lanka Flag","keywords":["lk","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f0","native":"\uD83C\uDDF1\uD83C\uDDF0"}],"version":2},"flag-lr":{"id":"flag-lr","name":"Liberia Flag","keywords":["lr","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f7","native":"\uD83C\uDDF1\uD83C\uDDF7"}],"version":2},"flag-ls":{"id":"flag-ls","name":"Lesotho Flag","keywords":["ls","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f8","native":"\uD83C\uDDF1\uD83C\uDDF8"}],"version":2},"flag-lt":{"id":"flag-lt","name":"Lithuania Flag","keywords":["lt","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f9","native":"\uD83C\uDDF1\uD83C\uDDF9"}],"version":2},"flag-lu":{"id":"flag-lu","name":"Luxembourg Flag","keywords":["lu","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1fa","native":"\uD83C\uDDF1\uD83C\uDDFA"}],"version":2},"flag-lv":{"id":"flag-lv","name":"Latvia Flag","keywords":["lv","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1fb","native":"\uD83C\uDDF1\uD83C\uDDFB"}],"version":2},"flag-ly":{"id":"flag-ly","name":"Libya Flag","keywords":["ly","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1fe","native":"\uD83C\uDDF1\uD83C\uDDFE"}],"version":2},"flag-ma":{"id":"flag-ma","name":"Morocco Flag","keywords":["ma","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1e6","native":"\uD83C\uDDF2\uD83C\uDDE6"}],"version":2},"flag-mc":{"id":"flag-mc","name":"Monaco Flag","keywords":["mc","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1e8","native":"\uD83C\uDDF2\uD83C\uDDE8"}],"version":2},"flag-md":{"id":"flag-md","name":"Moldova Flag","keywords":["md","republic","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1e9","native":"\uD83C\uDDF2\uD83C\uDDE9"}],"version":2},"flag-me":{"id":"flag-me","name":"Montenegro Flag","keywords":["me","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ea","native":"\uD83C\uDDF2\uD83C\uDDEA"}],"version":2},"flag-mf":{"id":"flag-mf","name":"St. Martin Flag","keywords":["mf","st"],"skins":[{"unified":"1f1f2-1f1eb","native":"\uD83C\uDDF2\uD83C\uDDEB"}],"version":2},"flag-mg":{"id":"flag-mg","name":"Madagascar Flag","keywords":["mg","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ec","native":"\uD83C\uDDF2\uD83C\uDDEC"}],"version":2},"flag-mh":{"id":"flag-mh","name":"Marshall Islands Flag","keywords":["mh","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ed","native":"\uD83C\uDDF2\uD83C\uDDED"}],"version":2},"flag-mk":{"id":"flag-mk","name":"North Macedonia Flag","keywords":["mk","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f0","native":"\uD83C\uDDF2\uD83C\uDDF0"}],"version":2},"flag-ml":{"id":"flag-ml","name":"Mali Flag","keywords":["ml","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f1","native":"\uD83C\uDDF2\uD83C\uDDF1"}],"version":2},"flag-mm":{"id":"flag-mm","name":"Myanmar (burma) Flag","keywords":["mm","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f2","native":"\uD83C\uDDF2\uD83C\uDDF2"}],"version":2},"flag-mn":{"id":"flag-mn","name":"Mongolia Flag","keywords":["mn","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f3","native":"\uD83C\uDDF2\uD83C\uDDF3"}],"version":2},"flag-mo":{"id":"flag-mo","name":"Macao Sar China Flag","keywords":["mo","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f4","native":"\uD83C\uDDF2\uD83C\uDDF4"}],"version":2},"flag-mp":{"id":"flag-mp","name":"Northern Mariana Islands Flag","keywords":["mp","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f5","native":"\uD83C\uDDF2\uD83C\uDDF5"}],"version":2},"flag-mq":{"id":"flag-mq","name":"Martinique Flag","keywords":["mq","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f6","native":"\uD83C\uDDF2\uD83C\uDDF6"}],"version":2},"flag-mr":{"id":"flag-mr","name":"Mauritania Flag","keywords":["mr","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f7","native":"\uD83C\uDDF2\uD83C\uDDF7"}],"version":2},"flag-ms":{"id":"flag-ms","name":"Montserrat Flag","keywords":["ms","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f8","native":"\uD83C\uDDF2\uD83C\uDDF8"}],"version":2},"flag-mt":{"id":"flag-mt","name":"Malta Flag","keywords":["mt","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f9","native":"\uD83C\uDDF2\uD83C\uDDF9"}],"version":2},"flag-mu":{"id":"flag-mu","name":"Mauritius Flag","keywords":["mu","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fa","native":"\uD83C\uDDF2\uD83C\uDDFA"}],"version":2},"flag-mv":{"id":"flag-mv","name":"Maldives Flag","keywords":["mv","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fb","native":"\uD83C\uDDF2\uD83C\uDDFB"}],"version":2},"flag-mw":{"id":"flag-mw","name":"Malawi Flag","keywords":["mw","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fc","native":"\uD83C\uDDF2\uD83C\uDDFC"}],"version":2},"flag-mx":{"id":"flag-mx","name":"Mexico Flag","keywords":["mx","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fd","native":"\uD83C\uDDF2\uD83C\uDDFD"}],"version":2},"flag-my":{"id":"flag-my","name":"Malaysia Flag","keywords":["my","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fe","native":"\uD83C\uDDF2\uD83C\uDDFE"}],"version":2},"flag-mz":{"id":"flag-mz","name":"Mozambique Flag","keywords":["mz","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ff","native":"\uD83C\uDDF2\uD83C\uDDFF"}],"version":2},"flag-na":{"id":"flag-na","name":"Namibia Flag","keywords":["na","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1e6","native":"\uD83C\uDDF3\uD83C\uDDE6"}],"version":2},"flag-nc":{"id":"flag-nc","name":"New Caledonia Flag","keywords":["nc","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1e8","native":"\uD83C\uDDF3\uD83C\uDDE8"}],"version":2},"flag-ne":{"id":"flag-ne","name":"Niger Flag","keywords":["ne","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ea","native":"\uD83C\uDDF3\uD83C\uDDEA"}],"version":2},"flag-nf":{"id":"flag-nf","name":"Norfolk Island Flag","keywords":["nf","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1eb","native":"\uD83C\uDDF3\uD83C\uDDEB"}],"version":2},"flag-ng":{"id":"flag-ng","name":"Nigeria Flag","keywords":["ng","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ec","native":"\uD83C\uDDF3\uD83C\uDDEC"}],"version":2},"flag-ni":{"id":"flag-ni","name":"Nicaragua Flag","keywords":["ni","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ee","native":"\uD83C\uDDF3\uD83C\uDDEE"}],"version":2},"flag-nl":{"id":"flag-nl","name":"Netherlands Flag","keywords":["nl","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f1","native":"\uD83C\uDDF3\uD83C\uDDF1"}],"version":2},"flag-no":{"id":"flag-no","name":"Norway Flag","keywords":["no","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f4","native":"\uD83C\uDDF3\uD83C\uDDF4"}],"version":2},"flag-np":{"id":"flag-np","name":"Nepal Flag","keywords":["np","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f5","native":"\uD83C\uDDF3\uD83C\uDDF5"}],"version":2},"flag-nr":{"id":"flag-nr","name":"Nauru Flag","keywords":["nr","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f7","native":"\uD83C\uDDF3\uD83C\uDDF7"}],"version":2},"flag-nu":{"id":"flag-nu","name":"Niue Flag","keywords":["nu","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1fa","native":"\uD83C\uDDF3\uD83C\uDDFA"}],"version":2},"flag-nz":{"id":"flag-nz","name":"New Zealand Flag","keywords":["nz","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ff","native":"\uD83C\uDDF3\uD83C\uDDFF"}],"version":2},"flag-om":{"id":"flag-om","name":"Oman Flag","keywords":["om","symbol","nation","country","banner"],"skins":[{"unified":"1f1f4-1f1f2","native":"\uD83C\uDDF4\uD83C\uDDF2"}],"version":2},"flag-pa":{"id":"flag-pa","name":"Panama Flag","keywords":["pa","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1e6","native":"\uD83C\uDDF5\uD83C\uDDE6"}],"version":2},"flag-pe":{"id":"flag-pe","name":"Peru Flag","keywords":["pe","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1ea","native":"\uD83C\uDDF5\uD83C\uDDEA"}],"version":2},"flag-pf":{"id":"flag-pf","name":"French Polynesia Flag","keywords":["pf","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1eb","native":"\uD83C\uDDF5\uD83C\uDDEB"}],"version":2},"flag-pg":{"id":"flag-pg","name":"Papua New Guinea Flag","keywords":["pg","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1ec","native":"\uD83C\uDDF5\uD83C\uDDEC"}],"version":2},"flag-ph":{"id":"flag-ph","name":"Philippines Flag","keywords":["ph","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1ed","native":"\uD83C\uDDF5\uD83C\uDDED"}],"version":2},"flag-pk":{"id":"flag-pk","name":"Pakistan Flag","keywords":["pk","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f0","native":"\uD83C\uDDF5\uD83C\uDDF0"}],"version":2},"flag-pl":{"id":"flag-pl","name":"Poland Flag","keywords":["pl","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f1","native":"\uD83C\uDDF5\uD83C\uDDF1"}],"version":2},"flag-pm":{"id":"flag-pm","name":"St. Pierre & Miquelon Flag","keywords":["pm","st","saint","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f2","native":"\uD83C\uDDF5\uD83C\uDDF2"}],"version":2},"flag-pn":{"id":"flag-pn","name":"Pitcairn Islands Flag","keywords":["pn","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f3","native":"\uD83C\uDDF5\uD83C\uDDF3"}],"version":2},"flag-pr":{"id":"flag-pr","name":"Puerto Rico Flag","keywords":["pr","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f7","native":"\uD83C\uDDF5\uD83C\uDDF7"}],"version":2},"flag-ps":{"id":"flag-ps","name":"Palestinian Territories Flag","keywords":["ps","palestine","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f8","native":"\uD83C\uDDF5\uD83C\uDDF8"}],"version":2},"flag-pt":{"id":"flag-pt","name":"Portugal Flag","keywords":["pt","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f9","native":"\uD83C\uDDF5\uD83C\uDDF9"}],"version":2},"flag-pw":{"id":"flag-pw","name":"Palau Flag","keywords":["pw","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1fc","native":"\uD83C\uDDF5\uD83C\uDDFC"}],"version":2},"flag-py":{"id":"flag-py","name":"Paraguay Flag","keywords":["py","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1fe","native":"\uD83C\uDDF5\uD83C\uDDFE"}],"version":2},"flag-qa":{"id":"flag-qa","name":"Qatar Flag","keywords":["qa","nation","country","banner"],"skins":[{"unified":"1f1f6-1f1e6","native":"\uD83C\uDDF6\uD83C\uDDE6"}],"version":2},"flag-re":{"id":"flag-re","name":"R\xe9union Flag","keywords":["re","reunion","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1ea","native":"\uD83C\uDDF7\uD83C\uDDEA"}],"version":2},"flag-ro":{"id":"flag-ro","name":"Romania Flag","keywords":["ro","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1f4","native":"\uD83C\uDDF7\uD83C\uDDF4"}],"version":2},"flag-rs":{"id":"flag-rs","name":"Serbia Flag","keywords":["rs","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1f8","native":"\uD83C\uDDF7\uD83C\uDDF8"}],"version":2},"ru":{"id":"ru","name":"Russia Flag","keywords":["ru","russian","federation","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1fa","native":"\uD83C\uDDF7\uD83C\uDDFA"}],"version":1},"flag-rw":{"id":"flag-rw","name":"Rwanda Flag","keywords":["rw","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1fc","native":"\uD83C\uDDF7\uD83C\uDDFC"}],"version":2},"flag-sa":{"id":"flag-sa","name":"Saudi Arabia Flag","keywords":["sa","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e6","native":"\uD83C\uDDF8\uD83C\uDDE6"}],"version":2},"flag-sb":{"id":"flag-sb","name":"Solomon Islands Flag","keywords":["sb","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e7","native":"\uD83C\uDDF8\uD83C\uDDE7"}],"version":2},"flag-sc":{"id":"flag-sc","name":"Seychelles Flag","keywords":["sc","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e8","native":"\uD83C\uDDF8\uD83C\uDDE8"}],"version":2},"flag-sd":{"id":"flag-sd","name":"Sudan Flag","keywords":["sd","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e9","native":"\uD83C\uDDF8\uD83C\uDDE9"}],"version":2},"flag-se":{"id":"flag-se","name":"Sweden Flag","keywords":["se","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ea","native":"\uD83C\uDDF8\uD83C\uDDEA"}],"version":2},"flag-sg":{"id":"flag-sg","name":"Singapore Flag","keywords":["sg","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ec","native":"\uD83C\uDDF8\uD83C\uDDEC"}],"version":2},"flag-sh":{"id":"flag-sh","name":"St. Helena Flag","keywords":["sh","st","saint","ascension","tristan","cunha","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ed","native":"\uD83C\uDDF8\uD83C\uDDED"}],"version":2},"flag-si":{"id":"flag-si","name":"Slovenia Flag","keywords":["si","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ee","native":"\uD83C\uDDF8\uD83C\uDDEE"}],"version":2},"flag-sj":{"id":"flag-sj","name":"Svalbard & Jan Mayen Flag","keywords":["sj"],"skins":[{"unified":"1f1f8-1f1ef","native":"\uD83C\uDDF8\uD83C\uDDEF"}],"version":2},"flag-sk":{"id":"flag-sk","name":"Slovakia Flag","keywords":["sk","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f0","native":"\uD83C\uDDF8\uD83C\uDDF0"}],"version":2},"flag-sl":{"id":"flag-sl","name":"Sierra Leone Flag","keywords":["sl","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f1","native":"\uD83C\uDDF8\uD83C\uDDF1"}],"version":2},"flag-sm":{"id":"flag-sm","name":"San Marino Flag","keywords":["sm","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f2","native":"\uD83C\uDDF8\uD83C\uDDF2"}],"version":2},"flag-sn":{"id":"flag-sn","name":"Senegal Flag","keywords":["sn","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f3","native":"\uD83C\uDDF8\uD83C\uDDF3"}],"version":2},"flag-so":{"id":"flag-so","name":"Somalia Flag","keywords":["so","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f4","native":"\uD83C\uDDF8\uD83C\uDDF4"}],"version":2},"flag-sr":{"id":"flag-sr","name":"Suriname Flag","keywords":["sr","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f7","native":"\uD83C\uDDF8\uD83C\uDDF7"}],"version":2},"flag-ss":{"id":"flag-ss","name":"South Sudan Flag","keywords":["ss","sd","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f8","native":"\uD83C\uDDF8\uD83C\uDDF8"}],"version":2},"flag-st":{"id":"flag-st","name":"S\xe3o Tom\xe9 & Pr\xedncipe Flag","keywords":["st","sao","tome","principe","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f9","native":"\uD83C\uDDF8\uD83C\uDDF9"}],"version":2},"flag-sv":{"id":"flag-sv","name":"El Salvador Flag","keywords":["sv","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1fb","native":"\uD83C\uDDF8\uD83C\uDDFB"}],"version":2},"flag-sx":{"id":"flag-sx","name":"Sint Maarten Flag","keywords":["sx","dutch","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1fd","native":"\uD83C\uDDF8\uD83C\uDDFD"}],"version":2},"flag-sy":{"id":"flag-sy","name":"Syria Flag","keywords":["sy","syrian","arab","republic","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1fe","native":"\uD83C\uDDF8\uD83C\uDDFE"}],"version":2},"flag-sz":{"id":"flag-sz","name":"Eswatini Flag","keywords":["sz","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ff","native":"\uD83C\uDDF8\uD83C\uDDFF"}],"version":2},"flag-ta":{"id":"flag-ta","name":"Tristan Da Cunha Flag","keywords":["ta"],"skins":[{"unified":"1f1f9-1f1e6","native":"\uD83C\uDDF9\uD83C\uDDE6"}],"version":2},"flag-tc":{"id":"flag-tc","name":"Turks & Caicos Islands Flag","keywords":["tc","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1e8","native":"\uD83C\uDDF9\uD83C\uDDE8"}],"version":2},"flag-td":{"id":"flag-td","name":"Chad Flag","keywords":["td","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1e9","native":"\uD83C\uDDF9\uD83C\uDDE9"}],"version":2},"flag-tf":{"id":"flag-tf","name":"French Southern Territories Flag","keywords":["tf","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1eb","native":"\uD83C\uDDF9\uD83C\uDDEB"}],"version":2},"flag-tg":{"id":"flag-tg","name":"Togo Flag","keywords":["tg","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ec","native":"\uD83C\uDDF9\uD83C\uDDEC"}],"version":2},"flag-th":{"id":"flag-th","name":"Thailand Flag","keywords":["th","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ed","native":"\uD83C\uDDF9\uD83C\uDDED"}],"version":2},"flag-tj":{"id":"flag-tj","name":"Tajikistan Flag","keywords":["tj","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ef","native":"\uD83C\uDDF9\uD83C\uDDEF"}],"version":2},"flag-tk":{"id":"flag-tk","name":"Tokelau Flag","keywords":["tk","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f0","native":"\uD83C\uDDF9\uD83C\uDDF0"}],"version":2},"flag-tl":{"id":"flag-tl","name":"Timor-Leste Flag","keywords":["tl","timor","leste","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f1","native":"\uD83C\uDDF9\uD83C\uDDF1"}],"version":2},"flag-tm":{"id":"flag-tm","name":"Turkmenistan Flag","keywords":["tm","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f2","native":"\uD83C\uDDF9\uD83C\uDDF2"}],"version":2},"flag-tn":{"id":"flag-tn","name":"Tunisia Flag","keywords":["tn","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f3","native":"\uD83C\uDDF9\uD83C\uDDF3"}],"version":2},"flag-to":{"id":"flag-to","name":"Tonga Flag","keywords":["to","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f4","native":"\uD83C\uDDF9\uD83C\uDDF4"}],"version":2},"flag-tr":{"id":"flag-tr","name":"Turkey Flag","keywords":["tr","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f7","native":"\uD83C\uDDF9\uD83C\uDDF7"}],"version":2},"flag-tt":{"id":"flag-tt","name":"Trinidad & Tobago Flag","keywords":["tt","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f9","native":"\uD83C\uDDF9\uD83C\uDDF9"}],"version":2},"flag-tv":{"id":"flag-tv","name":"Tuvalu Flag","keywords":["tv","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1fb","native":"\uD83C\uDDF9\uD83C\uDDFB"}],"version":2},"flag-tw":{"id":"flag-tw","name":"Taiwan Flag","keywords":["tw","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1fc","native":"\uD83C\uDDF9\uD83C\uDDFC"}],"version":2},"flag-tz":{"id":"flag-tz","name":"Tanzania Flag","keywords":["tz","united","republic","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ff","native":"\uD83C\uDDF9\uD83C\uDDFF"}],"version":2},"flag-ua":{"id":"flag-ua","name":"Ukraine Flag","keywords":["ua","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1e6","native":"\uD83C\uDDFA\uD83C\uDDE6"}],"version":2},"flag-ug":{"id":"flag-ug","name":"Uganda Flag","keywords":["ug","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1ec","native":"\uD83C\uDDFA\uD83C\uDDEC"}],"version":2},"flag-um":{"id":"flag-um","name":"U.s. Outlying Islands Flag","keywords":["um","u","s"],"skins":[{"unified":"1f1fa-1f1f2","native":"\uD83C\uDDFA\uD83C\uDDF2"}],"version":2},"flag-un":{"id":"flag-un","name":"United Nations Flag","keywords":["un","banner"],"skins":[{"unified":"1f1fa-1f1f3","native":"\uD83C\uDDFA\uD83C\uDDF3"}],"version":4},"us":{"id":"us","name":"United States Flag","keywords":["us","america","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1f8","native":"\uD83C\uDDFA\uD83C\uDDF8"}],"version":1},"flag-uy":{"id":"flag-uy","name":"Uruguay Flag","keywords":["uy","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1fe","native":"\uD83C\uDDFA\uD83C\uDDFE"}],"version":2},"flag-uz":{"id":"flag-uz","name":"Uzbekistan Flag","keywords":["uz","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1ff","native":"\uD83C\uDDFA\uD83C\uDDFF"}],"version":2},"flag-va":{"id":"flag-va","name":"Vatican City Flag","keywords":["va","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1e6","native":"\uD83C\uDDFB\uD83C\uDDE6"}],"version":2},"flag-vc":{"id":"flag-vc","name":"St. Vincent & Grenadines Flag","keywords":["vc","st","saint","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1e8","native":"\uD83C\uDDFB\uD83C\uDDE8"}],"version":2},"flag-ve":{"id":"flag-ve","name":"Venezuela Flag","keywords":["ve","bolivarian","republic","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1ea","native":"\uD83C\uDDFB\uD83C\uDDEA"}],"version":2},"flag-vg":{"id":"flag-vg","name":"British Virgin Islands Flag","keywords":["vg","bvi","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1ec","native":"\uD83C\uDDFB\uD83C\uDDEC"}],"version":2},"flag-vi":{"id":"flag-vi","name":"U.s. Virgin Islands Flag","keywords":["vi","u","s","us","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1ee","native":"\uD83C\uDDFB\uD83C\uDDEE"}],"version":2},"flag-vn":{"id":"flag-vn","name":"Vietnam Flag","keywords":["vn","viet","nam","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1f3","native":"\uD83C\uDDFB\uD83C\uDDF3"}],"version":2},"flag-vu":{"id":"flag-vu","name":"Vanuatu Flag","keywords":["vu","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1fa","native":"\uD83C\uDDFB\uD83C\uDDFA"}],"version":2},"flag-wf":{"id":"flag-wf","name":"Wallis & Futuna Flag","keywords":["wf","nation","country","banner"],"skins":[{"unified":"1f1fc-1f1eb","native":"\uD83C\uDDFC\uD83C\uDDEB"}],"version":2},"flag-ws":{"id":"flag-ws","name":"Samoa Flag","keywords":["ws","nation","country","banner"],"skins":[{"unified":"1f1fc-1f1f8","native":"\uD83C\uDDFC\uD83C\uDDF8"}],"version":2},"flag-xk":{"id":"flag-xk","name":"Kosovo Flag","keywords":["xk","nation","country","banner"],"skins":[{"unified":"1f1fd-1f1f0","native":"\uD83C\uDDFD\uD83C\uDDF0"}],"version":2},"flag-ye":{"id":"flag-ye","name":"Yemen Flag","keywords":["ye","nation","country","banner"],"skins":[{"unified":"1f1fe-1f1ea","native":"\uD83C\uDDFE\uD83C\uDDEA"}],"version":2},"flag-yt":{"id":"flag-yt","name":"Mayotte Flag","keywords":["yt","nation","country","banner"],"skins":[{"unified":"1f1fe-1f1f9","native":"\uD83C\uDDFE\uD83C\uDDF9"}],"version":2},"flag-za":{"id":"flag-za","name":"South Africa Flag","keywords":["za","nation","country","banner"],"skins":[{"unified":"1f1ff-1f1e6","native":"\uD83C\uDDFF\uD83C\uDDE6"}],"version":2},"flag-zm":{"id":"flag-zm","name":"Zambia Flag","keywords":["zm","nation","country","banner"],"skins":[{"unified":"1f1ff-1f1f2","native":"\uD83C\uDDFF\uD83C\uDDF2"}],"version":2},"flag-zw":{"id":"flag-zw","name":"Zimbabwe Flag","keywords":["zw","nation","country","banner"],"skins":[{"unified":"1f1ff-1f1fc","native":"\uD83C\uDDFF\uD83C\uDDFC"}],"version":2},"flag-england":{"id":"flag-england","name":"England Flag","keywords":["english"],"skins":[{"unified":"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f","native":"\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F"}],"version":5},"flag-scotland":{"id":"flag-scotland","name":"Scotland Flag","keywords":["scottish"],"skins":[{"unified":"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f","native":"\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F"}],"version":5},"flag-wales":{"id":"flag-wales","name":"Wales Flag","keywords":["welsh"],"skins":[{"unified":"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f","native":"\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F"}],"version":5}},"aliases":{"satisfied":"laughing","grinning_face_with_star_eyes":"star-struck","grinning_face_with_one_large_and_one_small_eye":"zany_face","smiling_face_with_smiling_eyes_and_hand_covering_mouth":"face_with_hand_over_mouth","face_with_finger_covering_closed_lips":"shushing_face","face_with_one_eyebrow_raised":"face_with_raised_eyebrow","face_with_open_mouth_vomiting":"face_vomiting","shocked_face_with_exploding_head":"exploding_head","serious_face_with_symbols_covering_mouth":"face_with_symbols_on_mouth","poop":"hankey","shit":"hankey","collision":"boom","raised_hand":"hand","hand_with_index_and_middle_fingers_crossed":"crossed_fingers","sign_of_the_horns":"the_horns","reversed_hand_with_middle_finger_extended":"middle_finger","thumbsup":"+1","thumbsdown":"-1","punch":"facepunch","mother_christmas":"mrs_claus","running":"runner","man-with-bunny-ears-partying":"men-with-bunny-ears-partying","woman-with-bunny-ears-partying":"women-with-bunny-ears-partying","women_holding_hands":"two_women_holding_hands","woman_and_man_holding_hands":"man_and_woman_holding_hands","couple":"man_and_woman_holding_hands","men_holding_hands":"two_men_holding_hands","paw_prints":"feet","flipper":"dolphin","honeybee":"bee","lady_beetle":"ladybug","cooking":"fried_egg","knife":"hocho","red_car":"car","sailboat":"boat","waxing_gibbous_moon":"moon","sun_small_cloud":"mostly_sunny","sun_behind_cloud":"barely_sunny","sun_behind_rain_cloud":"partly_sunny_rain","lightning_cloud":"lightning","tornado_cloud":"tornado","tshirt":"shirt","shoe":"mans_shoe","telephone":"phone","lantern":"izakaya_lantern","open_book":"book","envelope":"email","pencil":"memo","heavy_exclamation_mark":"exclamation","staff_of_aesculapius":"medical_symbol","flag-cn":"cn","flag-de":"de","flag-es":"es","flag-fr":"fr","uk":"gb","flag-gb":"gb","flag-it":"it","flag-jp":"jp","flag-kr":"kr","flag-ru":"ru","flag-us":"us"},"sheet":{"cols":61,"rows":61}}');


function $cc519efa84d20a3e$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$n, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$u, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$a8257692ac88316c, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$t, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$r, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$o, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$f, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$e = {}, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$c = [], $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$a(n1, l1) {
    for(var u1 in l1)n1[u1] = l1[u1];
    return n1;
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$h(n2) {
    var l2 = n2.parentNode;
    l2 && l2.removeChild(n2);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d(l3, u2, i1) {
    var t1, r1, o1, f1 = {};
    for(o1 in u2)"key" == o1 ? t1 = u2[o1] : "ref" == o1 ? r1 = u2[o1] : f1[o1] = u2[o1];
    if (arguments.length > 2 && (f1.children = arguments.length > 3 ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$n.call(arguments, 2) : i1), "function" == typeof l3 && null != l3.defaultProps) for(o1 in l3.defaultProps)void 0 === f1[o1] && (f1[o1] = l3.defaultProps[o1]);
    return $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$y(l3, f1, t1, r1, null);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$y(n3, i2, t2, r2, o2) {
    var f2 = {
        type: n3,
        props: i2,
        key: t2,
        ref: r2,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o2 ? ++$cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$u : o2
    };
    return null == o2 && null != $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode(f2), f2;
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$ffb0004e005737fa(n4) {
    return n4.children;
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8(n5, l4) {
    this.props = n5, this.context = l4;
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$k(n6, l5) {
    if (null == l5) return n6.__ ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$k(n6.__, n6.__.__k.indexOf(n6) + 1) : null;
    for(var u3; l5 < n6.__k.length; l5++)if (null != (u3 = n6.__k[l5]) && null != u3.__e) return u3.__e;
    return "function" == typeof n6.type ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$k(n6) : null;
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$b(n7) {
    var l6, u4;
    if (null != (n7 = n7.__) && null != n7.__c) {
        for(n7.__e = n7.__c.base = null, l6 = 0; l6 < n7.__k.length; l6++)if (null != (u4 = n7.__k[l6]) && null != u4.__e) {
            n7.__e = n7.__c.base = u4.__e;
            break;
        }
        return $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$b(n7);
    }
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$m(n8) {
    (!n8.__d && (n8.__d = !0) && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$t.push(n8) && !$cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$g.__r++ || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$o !== $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.debounceRendering) && (($cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$o = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.debounceRendering) || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$r)($cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$g);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$g() {
    for(var n9; $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$g.__r = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$t.length;)n9 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$t.sort(function(n10, l7) {
        return n10.__v.__b - l7.__v.__b;
    }), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$t = [], n9.some(function(n11) {
        var l8, u5, i3, t3, r3, o3;
        n11.__d && (r3 = (t3 = (l8 = n11).__v).__e, (o3 = l8.__P) && (u5 = [], (i3 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$a({}, t3)).__v = t3.__v + 1, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$j(o3, t3, i3, l8.__n, void 0 !== o3.ownerSVGElement, null != t3.__h ? [
            r3
        ] : null, u5, null == r3 ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$k(t3) : r3, t3.__h), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$z(u5, t3), t3.__e != r3 && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$b(t3)));
    });
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$w(n12, l9, u6, i4, t4, r4, o4, f3, s1, a1) {
    var h1, v1, p1, _1, b1, m1, g1, w1 = i4 && i4.__k || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$c, A1 = w1.length;
    for(u6.__k = [], h1 = 0; h1 < l9.length; h1++)if (null != (_1 = u6.__k[h1] = null == (_1 = l9[h1]) || "boolean" == typeof _1 ? null : "string" == typeof _1 || "number" == typeof _1 || "bigint" == typeof _1 ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$y(null, _1, null, null, _1) : Array.isArray(_1) ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$y($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$ffb0004e005737fa, {
        children: _1
    }, null, null, null) : _1.__b > 0 ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$y(_1.type, _1.props, _1.key, null, _1.__v) : _1)) {
        if (_1.__ = u6, _1.__b = u6.__b + 1, null === (p1 = w1[h1]) || p1 && _1.key == p1.key && _1.type === p1.type) w1[h1] = void 0;
        else for(v1 = 0; v1 < A1; v1++){
            if ((p1 = w1[v1]) && _1.key == p1.key && _1.type === p1.type) {
                w1[v1] = void 0;
                break;
            }
            p1 = null;
        }
        $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$j(n12, _1, p1 = p1 || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$e, t4, r4, o4, f3, s1, a1), b1 = _1.__e, (v1 = _1.ref) && p1.ref != v1 && (g1 || (g1 = []), p1.ref && g1.push(p1.ref, null, _1), g1.push(v1, _1.__c || b1, _1)), null != b1 ? (null == m1 && (m1 = b1), "function" == typeof _1.type && _1.__k === p1.__k ? _1.__d = s1 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$x(_1, s1, n12) : s1 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$P(n12, _1, p1, w1, b1, s1), "function" == typeof u6.type && (u6.__d = s1)) : s1 && p1.__e == s1 && s1.parentNode != n12 && (s1 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$k(p1));
    }
    for(u6.__e = m1, h1 = A1; h1--;)null != w1[h1] && ("function" == typeof u6.type && null != w1[h1].__e && w1[h1].__e == u6.__d && (u6.__d = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$k(i4, h1 + 1)), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$N(w1[h1], w1[h1]));
    if (g1) for(h1 = 0; h1 < g1.length; h1++)$cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$M(g1[h1], g1[++h1], g1[++h1]);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$x(n13, l10, u7) {
    for(var i5, t5 = n13.__k, r5 = 0; t5 && r5 < t5.length; r5++)(i5 = t5[r5]) && (i5.__ = n13, l10 = "function" == typeof i5.type ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$x(i5, l10, u7) : $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$P(u7, i5, i5, t5, i5.__e, l10));
    return l10;
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n14, l11) {
    return l11 = l11 || [], null == n14 || "boolean" == typeof n14 || (Array.isArray(n14) ? n14.some(function(n15) {
        $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n15, l11);
    }) : l11.push(n14)), l11;
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$P(n16, l12, u8, i6, t6, r6) {
    var o5, f4, e1;
    if (void 0 !== l12.__d) o5 = l12.__d, l12.__d = void 0;
    else if (null == u8 || t6 != r6 || null == t6.parentNode) n: if (null == r6 || r6.parentNode !== n16) n16.appendChild(t6), o5 = null;
    else {
        for(f4 = r6, e1 = 0; (f4 = f4.nextSibling) && e1 < i6.length; e1 += 2)if (f4 == t6) break n;
        n16.insertBefore(t6, r6), o5 = r6;
    }
    return void 0 !== o5 ? o5 : t6.nextSibling;
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$C(n17, l13, u9, i7, t7) {
    var r7;
    for(r7 in u9)"children" === r7 || "key" === r7 || r7 in l13 || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$H(n17, r7, null, u9[r7], i7);
    for(r7 in l13)t7 && "function" != typeof l13[r7] || "children" === r7 || "key" === r7 || "value" === r7 || "checked" === r7 || u9[r7] === l13[r7] || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$H(n17, r7, l13[r7], u9[r7], i7);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$$(n18, l14, u10) {
    "-" === l14[0] ? n18.setProperty(l14, u10) : n18[l14] = null == u10 ? "" : "number" != typeof u10 || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$s.test(l14) ? u10 : u10 + "px";
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$H(n19, l15, u11, i8, t8) {
    var r8;
    n: if ("style" === l15) {
        if ("string" == typeof u11) n19.style.cssText = u11;
        else {
            if ("string" == typeof i8 && (n19.style.cssText = i8 = ""), i8) for(l15 in i8)u11 && l15 in u11 || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$$(n19.style, l15, "");
            if (u11) for(l15 in u11)i8 && u11[l15] === i8[l15] || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$$(n19.style, l15, u11[l15]);
        }
    } else if ("o" === l15[0] && "n" === l15[1]) r8 = l15 !== (l15 = l15.replace(/Capture$/, "")), l15 = l15.toLowerCase() in n19 ? l15.toLowerCase().slice(2) : l15.slice(2), n19.l || (n19.l = {}), n19.l[l15 + r8] = u11, u11 ? i8 || n19.addEventListener(l15, r8 ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$T : $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$I, r8) : n19.removeEventListener(l15, r8 ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$T : $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$I, r8);
    else if ("dangerouslySetInnerHTML" !== l15) {
        if (t8) l15 = l15.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
        else if ("href" !== l15 && "list" !== l15 && "form" !== l15 && "tabIndex" !== l15 && "download" !== l15 && l15 in n19) try {
            n19[l15] = null == u11 ? "" : u11;
            break n;
        } catch (n) {}
        "function" == typeof u11 || (null != u11 && (!1 !== u11 || "a" === l15[0] && "r" === l15[1]) ? n19.setAttribute(l15, u11) : n19.removeAttribute(l15));
    }
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$I(n20) {
    this.l[n20.type + !1]($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event(n20) : n20);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$T(n21) {
    this.l[n21.type + !0]($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event(n21) : n21);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$j(n22, u12, i9, t9, r9, o6, f5, e2, c1) {
    var s2, h2, v2, y1, p2, k1, b2, m2, g2, x1, A2, P1 = u12.type;
    if (void 0 !== u12.constructor) return null;
    null != i9.__h && (c1 = i9.__h, e2 = u12.__e = i9.__e, u12.__h = null, o6 = [
        e2
    ]), (s2 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__b) && s2(u12);
    try {
        n: if ("function" == typeof P1) {
            if (m2 = u12.props, g2 = (s2 = P1.contextType) && t9[s2.__c], x1 = s2 ? g2 ? g2.props.value : s2.__ : t9, i9.__c ? b2 = (h2 = u12.__c = i9.__c).__ = h2.__E : ("prototype" in P1 && P1.prototype.render ? u12.__c = h2 = new P1(m2, x1) : (u12.__c = h2 = new $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8(m2, x1), h2.constructor = P1, h2.render = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$O), g2 && g2.sub(h2), h2.props = m2, h2.state || (h2.state = {}), h2.context = x1, h2.__n = t9, v2 = h2.__d = !0, h2.__h = []), null == h2.__s && (h2.__s = h2.state), null != P1.getDerivedStateFromProps && (h2.__s == h2.state && (h2.__s = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$a({}, h2.__s)), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$a(h2.__s, P1.getDerivedStateFromProps(m2, h2.__s))), y1 = h2.props, p2 = h2.state, v2) null == P1.getDerivedStateFromProps && null != h2.componentWillMount && h2.componentWillMount(), null != h2.componentDidMount && h2.__h.push(h2.componentDidMount);
            else {
                if (null == P1.getDerivedStateFromProps && m2 !== y1 && null != h2.componentWillReceiveProps && h2.componentWillReceiveProps(m2, x1), !h2.__e && null != h2.shouldComponentUpdate && !1 === h2.shouldComponentUpdate(m2, h2.__s, x1) || u12.__v === i9.__v) {
                    h2.props = m2, h2.state = h2.__s, u12.__v !== i9.__v && (h2.__d = !1), h2.__v = u12, u12.__e = i9.__e, u12.__k = i9.__k, u12.__k.forEach(function(n23) {
                        n23 && (n23.__ = u12);
                    }), h2.__h.length && f5.push(h2);
                    break n;
                }
                null != h2.componentWillUpdate && h2.componentWillUpdate(m2, h2.__s, x1), null != h2.componentDidUpdate && h2.__h.push(function() {
                    h2.componentDidUpdate(y1, p2, k1);
                });
            }
            h2.context = x1, h2.props = m2, h2.state = h2.__s, (s2 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__r) && s2(u12), h2.__d = !1, h2.__v = u12, h2.__P = n22, s2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s, null != h2.getChildContext && (t9 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$a($cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$a({}, t9), h2.getChildContext())), v2 || null == h2.getSnapshotBeforeUpdate || (k1 = h2.getSnapshotBeforeUpdate(y1, p2)), A2 = null != s2 && s2.type === $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$ffb0004e005737fa && null == s2.key ? s2.props.children : s2, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$w(n22, Array.isArray(A2) ? A2 : [
                A2
            ], u12, i9, t9, r9, o6, f5, e2, c1), h2.base = u12.__e, u12.__h = null, h2.__h.length && f5.push(h2), b2 && (h2.__E = h2.__ = null), h2.__e = !1;
        } else null == o6 && u12.__v === i9.__v ? (u12.__k = i9.__k, u12.__e = i9.__e) : u12.__e = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$L(i9.__e, u12, i9, t9, r9, o6, f5, c1);
        (s2 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.diffed) && s2(u12);
    } catch (n24) {
        u12.__v = null, (c1 || null != o6) && (u12.__e = e2, u12.__h = !!c1, o6[o6.indexOf(e2)] = null), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n24, u12, i9);
    }
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$z(n25, u13) {
    $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__c && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__c(u13, n25), n25.some(function(u14) {
        try {
            n25 = u14.__h, u14.__h = [], n25.some(function(n26) {
                n26.call(u14);
            });
        } catch (n27) {
            $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n27, u14.__v);
        }
    });
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$L(l16, u15, i10, t10, r10, o7, f6, c2) {
    var s3, a2, v3, y2 = i10.props, p3 = u15.props, d1 = u15.type, _2 = 0;
    if ("svg" === d1 && (r10 = !0), null != o7) {
        for(; _2 < o7.length; _2++)if ((s3 = o7[_2]) && "setAttribute" in s3 == !!d1 && (d1 ? s3.localName === d1 : 3 === s3.nodeType)) {
            l16 = s3, o7[_2] = null;
            break;
        }
    }
    if (null == l16) {
        if (null === d1) return document.createTextNode(p3);
        l16 = r10 ? document.createElementNS("http://www.w3.org/2000/svg", d1) : document.createElement(d1, p3.is && p3), o7 = null, c2 = !1;
    }
    if (null === d1) y2 === p3 || c2 && l16.data === p3 || (l16.data = p3);
    else {
        if (o7 = o7 && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$n.call(l16.childNodes), a2 = (y2 = i10.props || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$e).dangerouslySetInnerHTML, v3 = p3.dangerouslySetInnerHTML, !c2) {
            if (null != o7) for(y2 = {}, _2 = 0; _2 < l16.attributes.length; _2++)y2[l16.attributes[_2].name] = l16.attributes[_2].value;
            (v3 || a2) && (v3 && (a2 && v3.__html == a2.__html || v3.__html === l16.innerHTML) || (l16.innerHTML = v3 && v3.__html || ""));
        }
        if ($cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$C(l16, p3, y2, r10, c2), v3) u15.__k = [];
        else if (_2 = u15.props.children, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$w(l16, Array.isArray(_2) ? _2 : [
            _2
        ], u15, i10, t10, r10 && "foreignObject" !== d1, o7, f6, o7 ? o7[0] : i10.__k && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$k(i10, 0), c2), null != o7) for(_2 = o7.length; _2--;)null != o7[_2] && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$h(o7[_2]);
        c2 || ("value" in p3 && void 0 !== (_2 = p3.value) && (_2 !== y2.value || _2 !== l16.value || "progress" === d1 && !_2) && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$H(l16, "value", _2, y2.value, !1), "checked" in p3 && void 0 !== (_2 = p3.checked) && _2 !== l16.checked && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$H(l16, "checked", _2, y2.checked, !1));
    }
    return l16;
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$M(n28, u16, i11) {
    try {
        "function" == typeof n28 ? n28(u16) : n28.current = u16;
    } catch (n29) {
        $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n29, i11);
    }
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$N(n30, u17, i12) {
    var t11, r11;
    if ($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount(n30), (t11 = n30.ref) && (t11.current && t11.current !== n30.__e || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$M(t11, null, u17)), null != (t11 = n30.__c)) {
        if (t11.componentWillUnmount) try {
            t11.componentWillUnmount();
        } catch (n31) {
            $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n31, u17);
        }
        t11.base = t11.__P = null;
    }
    if (t11 = n30.__k) for(r11 = 0; r11 < t11.length; r11++)t11[r11] && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$N(t11[r11], u17, "function" != typeof n30.type);
    i12 || null == n30.__e || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$h(n30.__e), n30.__e = n30.__d = void 0;
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$O(n32, l, u18) {
    return this.constructor(n32, u18);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99(u19, i13, t12) {
    var r12, o8, f7;
    $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__ && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__(u19, i13), o8 = (r12 = "function" == typeof t12) ? null : t12 && t12.__k || i13.__k, f7 = [], $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$j(i13, u19 = (!r12 && t12 || i13).__k = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$ffb0004e005737fa, null, [
        u19
    ]), o8 || $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$e, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$e, void 0 !== i13.ownerSVGElement, !r12 && t12 ? [
        t12
    ] : o8 ? null : i13.firstChild ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$n.call(i13.childNodes) : null, f7, !r12 && t12 ? t12 : o8 ? o8.__e : i13.firstChild, r12), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$z(f7, u19);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$fa8d919ba61d84db(n33, l17) {
    $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99(n33, l17, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$fa8d919ba61d84db);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$e530037191fcd5d7(l18, u20, i14) {
    var t13, r13, o9, f8 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$a({}, l18.props);
    for(o9 in u20)"key" == o9 ? t13 = u20[o9] : "ref" == o9 ? r13 = u20[o9] : f8[o9] = u20[o9];
    return arguments.length > 2 && (f8.children = arguments.length > 3 ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$n.call(arguments, 2) : i14), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$y(l18.type, f8, t13 || l18.key, r13 || l18.ref, null);
}
function $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$fd42f52fd3ae1109(n34, l19) {
    var u21 = {
        __c: l19 = "__cC" + $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$f++,
        __: n34,
        Consumer: function(n35, l20) {
            return n35.children(l20);
        },
        Provider: function(n36) {
            var u22, i15;
            return this.getChildContext || (u22 = [], (i15 = {})[l19] = this, this.getChildContext = function() {
                return i15;
            }, this.shouldComponentUpdate = function(n37) {
                this.props.value !== n37.value && u22.some($cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$m);
            }, this.sub = function(n38) {
                u22.push(n38);
                var l21 = n38.componentWillUnmount;
                n38.componentWillUnmount = function() {
                    u22.splice(u22.indexOf(n38), 1), l21 && l21.call(n38);
                };
            }), n36.children;
        }
    };
    return u21.Provider.__ = u21.Consumer.contextType = u21;
}
$cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$n = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$c.slice, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2 = {
    __e: function(n39, l22) {
        for(var u23, i16, t14; l22 = l22.__;)if ((u23 = l22.__c) && !u23.__) try {
            if ((i16 = u23.constructor) && null != i16.getDerivedStateFromError && (u23.setState(i16.getDerivedStateFromError(n39)), t14 = u23.__d), null != u23.componentDidCatch && (u23.componentDidCatch(n39), t14 = u23.__d), t14) return u23.__E = u23;
        } catch (l23) {
            n39 = l23;
        }
        throw n39;
    }
}, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$u = 0, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$a8257692ac88316c = function(n40) {
    return null != n40 && void 0 === n40.constructor;
}, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.setState = function(n41, l24) {
    var u24;
    u24 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$a({}, this.state), "function" == typeof n41 && (n41 = n41($cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$a({}, u24), this.props)), n41 && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$a(u24, n41), null != n41 && this.__v && (l24 && this.__h.push(l24), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$m(this));
}, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.forceUpdate = function(n42) {
    this.__v && (this.__e = !0, n42 && this.__h.push(n42), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$m(this));
}, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.render = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$ffb0004e005737fa, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$t = [], $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$g.__r = 0, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$var$f = 0;
var $cc519efa84d20a3e$var$$bd9dd35321b03dd4$var$o = 0;
function $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b(_1, e1, n, t, f) {
    var l, s, u = {};
    for(s in e1)"ref" == s ? l = e1[s] : u[s] = e1[s];
    var a = {
        type: _1,
        props: u,
        key: n,
        ref: l,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: --$cc519efa84d20a3e$var$$bd9dd35321b03dd4$var$o,
        __source: t,
        __self: f
    };
    if ("function" == typeof _1 && (l = _1.defaultProps)) for(s in l)void 0 === u[s] && (u[s] = l[s]);
    return $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode(a), a;
}
function $cc519efa84d20a3e$var$$f72b75cf796873c7$var$set(key, value) {
    try {
        window.localStorage[`emoji-mart.${key}`] = JSON.stringify(value);
    } catch (error) {}
}
function $cc519efa84d20a3e$var$$f72b75cf796873c7$var$get(key) {
    try {
        const value = window.localStorage[`emoji-mart.${key}`];
        if (value) return JSON.parse(value);
    } catch (error) {}
}
var $cc519efa84d20a3e$export$390f32400eaf98c9 = {
    set: $cc519efa84d20a3e$var$$f72b75cf796873c7$var$set,
    get: $cc519efa84d20a3e$var$$f72b75cf796873c7$var$get
};
const $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$CACHE = new Map();
const $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$VERSIONS = [
    {
        v: 15,
        emoji: "\uD83E\uDEE8"
    },
    {
        v: 14,
        emoji: "\uD83E\uDEE0"
    },
    {
        v: 13.1,
        emoji: "\uD83D\uDE36\u200D\uD83C\uDF2B\uFE0F"
    },
    {
        v: 13,
        emoji: "\uD83E\uDD78"
    },
    {
        v: 12.1,
        emoji: "\uD83E\uDDD1\u200D\uD83E\uDDB0"
    },
    {
        v: 12,
        emoji: "\uD83E\uDD71"
    },
    {
        v: 11,
        emoji: "\uD83E\uDD70"
    },
    {
        v: 5,
        emoji: "\uD83E\uDD29"
    },
    {
        v: 4,
        emoji: "\uD83D\uDC71\u200D\u2640\uFE0F"
    },
    {
        v: 3,
        emoji: "\uD83E\uDD23"
    },
    {
        v: 2,
        emoji: "\uD83D\uDC4B\uD83C\uDFFB"
    },
    {
        v: 1,
        emoji: "\uD83D\uDE43"
    }
];
function $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$latestVersion() {
    for (const { v: v, emoji: emoji } of $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$VERSIONS){
        if ($cc519efa84d20a3e$var$$c84d045dcc34faf5$var$isSupported(emoji)) return v;
    }
}
function $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$noCountryFlags() {
    if ($cc519efa84d20a3e$var$$c84d045dcc34faf5$var$isSupported("\uD83C\uDDE8\uD83C\uDDE6")) return false;
    return true;
}
function $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$isSupported(emoji) {
    if ($cc519efa84d20a3e$var$$c84d045dcc34faf5$var$CACHE.has(emoji)) return $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$CACHE.get(emoji);
    const supported = $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$isEmojiSupported(emoji);
    $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$CACHE.set(emoji, supported);
    return supported;
}
// https://github.com/koala-interactive/is-emoji-supported
const $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$isEmojiSupported = (()=>{
    let ctx = null;
    try {
        if (!navigator.userAgent.includes("jsdom")) ctx = document.createElement("canvas").getContext("2d", {
            willReadFrequently: true
        });
    } catch  {}
    // Not in browser env
    if (!ctx) return ()=>false;
    const CANVAS_HEIGHT = 25;
    const CANVAS_WIDTH = 20;
    const textSize = Math.floor(CANVAS_HEIGHT / 2);
    // Initialize convas context
    ctx.font = textSize + "px Arial, Sans-Serif";
    ctx.textBaseline = "top";
    ctx.canvas.width = CANVAS_WIDTH * 2;
    ctx.canvas.height = CANVAS_HEIGHT;
    return (unicode)=>{
        ctx.clearRect(0, 0, CANVAS_WIDTH * 2, CANVAS_HEIGHT);
        // Draw in red on the left
        ctx.fillStyle = "#FF0000";
        ctx.fillText(unicode, 0, 22);
        // Draw in blue on right
        ctx.fillStyle = "#0000FF";
        ctx.fillText(unicode, CANVAS_WIDTH, 22);
        const a = ctx.getImageData(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT).data;
        const count = a.length;
        let i = 0;
        // Search the first visible pixel
        for(; i < count && !a[i + 3]; i += 4);
        // No visible pixel
        if (i >= count) return false;
        // Emoji has immutable color, so we check the color of the emoji in two different colors
        // the result show be the same.
        const x = CANVAS_WIDTH + i / 4 % CANVAS_WIDTH;
        const y = Math.floor(i / 4 / CANVAS_WIDTH);
        const b = ctx.getImageData(x, y, 1, 1).data;
        if (a[i] !== b[0] || a[i + 2] !== b[2]) return false;
        // Some emojis are a contraction of different ones, so if it's not
        // supported, it will show multiple characters
        if (ctx.measureText(unicode).width >= CANVAS_WIDTH) return false;
        // Supported
        return true;
    };
})();
var $cc519efa84d20a3e$var$$c84d045dcc34faf5$export$2e2bcd8739ae039 = {
    latestVersion: $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$latestVersion,
    noCountryFlags: $cc519efa84d20a3e$var$$c84d045dcc34faf5$var$noCountryFlags
};
const $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$DEFAULTS = [
    "+1",
    "grinning",
    "kissing_heart",
    "heart_eyes",
    "laughing",
    "stuck_out_tongue_winking_eye",
    "sweat_smile",
    "joy",
    "scream",
    "disappointed",
    "unamused",
    "weary",
    "sob",
    "sunglasses",
    "heart"
];
let $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index = null;
function $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$add(emoji) {
    $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index || ($cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index = $cc519efa84d20a3e$export$390f32400eaf98c9.get("frequently") || {});
    const emojiId = emoji.id || emoji;
    if (!emojiId) return;
    $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index[emojiId] || ($cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index[emojiId] = 0);
    $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index[emojiId] += 1;
    $cc519efa84d20a3e$export$390f32400eaf98c9.set("last", emojiId);
    $cc519efa84d20a3e$export$390f32400eaf98c9.set("frequently", $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index);
}
function $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$get({ maxFrequentRows: maxFrequentRows, perLine: perLine }) {
    if (!maxFrequentRows) return [];
    $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index || ($cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index = $cc519efa84d20a3e$export$390f32400eaf98c9.get("frequently"));
    let emojiIds = [];
    if (!$cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index) {
        $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index = {};
        for(let i in $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$DEFAULTS.slice(0, perLine)){
            const emojiId = $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$DEFAULTS[i];
            $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index[emojiId] = perLine - i;
            emojiIds.push(emojiId);
        }
        return emojiIds;
    }
    const max = maxFrequentRows * perLine;
    const last = $cc519efa84d20a3e$export$390f32400eaf98c9.get("last");
    for(let emojiId in $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index)emojiIds.push(emojiId);
    emojiIds.sort((a, b)=>{
        const aScore = $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index[b];
        const bScore = $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index[a];
        if (aScore == bScore) return a.localeCompare(b);
        return aScore - bScore;
    });
    if (emojiIds.length > max) {
        const removedIds = emojiIds.slice(max);
        emojiIds = emojiIds.slice(0, max);
        for (let removedId of removedIds){
            if (removedId == last) continue;
            delete $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index[removedId];
        }
        if (last && emojiIds.indexOf(last) == -1) {
            delete $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index[emojiIds[emojiIds.length - 1]];
            emojiIds.splice(-1, 1, last);
        }
        $cc519efa84d20a3e$export$390f32400eaf98c9.set("frequently", $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$Index);
    }
    return emojiIds;
}
var $cc519efa84d20a3e$export$d42f766cf4e359f3 = {
    add: $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$add,
    get: $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$get,
    DEFAULTS: $cc519efa84d20a3e$var$$b22cfd0a55410b4f$var$DEFAULTS
};
var $cc519efa84d20a3e$var$$8d50d93417ef682a$exports = {};
$cc519efa84d20a3e$var$$8d50d93417ef682a$exports = JSON.parse('{"search":"Search","search_no_results_1":"Oh no!","search_no_results_2":"That emoji couldn\u2019t be found","pick":"Pick an emoji\u2026","add_custom":"Add custom emoji","categories":{"activity":"Activity","custom":"Custom","flags":"Flags","foods":"Food & Drink","frequent":"Frequently used","nature":"Animals & Nature","objects":"Objects","people":"Smileys & People","places":"Travel & Places","search":"Search Results","symbols":"Symbols"},"skins":{"1":"Default","2":"Light","3":"Medium-Light","4":"Medium","5":"Medium-Dark","6":"Dark","choose":"Choose default skin tone"}}');
var $cc519efa84d20a3e$var$$b247ea80b67298d5$export$2e2bcd8739ae039 = {
    autoFocus: {
        value: false
    },
    dynamicWidth: {
        value: false
    },
    emojiButtonColors: {
        value: null
    },
    emojiButtonRadius: {
        value: "100%"
    },
    emojiButtonSize: {
        value: 36
    },
    emojiSize: {
        value: 24
    },
    emojiVersion: {
        value: 15,
        choices: [
            1,
            2,
            3,
            4,
            5,
            11,
            12,
            12.1,
            13,
            13.1,
            14,
            15
        ]
    },
    exceptEmojis: {
        value: []
    },
    icons: {
        value: "auto",
        choices: [
            "auto",
            "outline",
            "solid"
        ]
    },
    locale: {
        value: "en",
        choices: [
            "en",
            "ar",
            "be",
            "cs",
            "de",
            "es",
            "fa",
            "fi",
            "fr",
            "hi",
            "it",
            "ja",
            "ko",
            "nl",
            "pl",
            "pt",
            "ru",
            "sa",
            "tr",
            "uk",
            "vi",
            "zh"
        ]
    },
    maxFrequentRows: {
        value: 4
    },
    navPosition: {
        value: "top",
        choices: [
            "top",
            "bottom",
            "none"
        ]
    },
    noCountryFlags: {
        value: false
    },
    noResultsEmoji: {
        value: null
    },
    perLine: {
        value: 9
    },
    previewEmoji: {
        value: null
    },
    previewPosition: {
        value: "bottom",
        choices: [
            "top",
            "bottom",
            "none"
        ]
    },
    searchPosition: {
        value: "sticky",
        choices: [
            "sticky",
            "static",
            "none"
        ]
    },
    set: {
        value: "native",
        choices: [
            "native",
            "apple",
            "facebook",
            "google",
            "twitter"
        ]
    },
    skin: {
        value: 1,
        choices: [
            1,
            2,
            3,
            4,
            5,
            6
        ]
    },
    skinTonePosition: {
        value: "preview",
        choices: [
            "preview",
            "search",
            "none"
        ]
    },
    theme: {
        value: "auto",
        choices: [
            "auto",
            "light",
            "dark"
        ]
    },
    // Data
    categories: null,
    categoryIcons: null,
    custom: null,
    data: null,
    i18n: null,
    // Callbacks
    getImageURL: null,
    getSpritesheetURL: null,
    onAddCustomEmoji: null,
    onClickOutside: null,
    onEmojiSelect: null,
    // Deprecated
    stickySearch: {
        deprecated: true,
        value: true
    }
};
let $cc519efa84d20a3e$export$dbe3113d60765c1a = null;
let $cc519efa84d20a3e$export$2d0294657ab35f1b = null;
const $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$fetchCache = {};
async function $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$fetchJSON(src) {
    if ($cc519efa84d20a3e$var$$7adb23b0109cc36a$var$fetchCache[src]) return $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$fetchCache[src];
    const response = await fetch(src);
    const json = await response.json();
    $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$fetchCache[src] = json;
    return json;
}
let $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$promise = null;
let $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$initiated = false;
let $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$initCallback = null;
let $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$initialized = false;
function $cc519efa84d20a3e$export$2cd8252107eb640b(options, { caller: caller } = {}) {
    $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$promise || ($cc519efa84d20a3e$var$$7adb23b0109cc36a$var$promise = new Promise((resolve)=>{
        $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$initCallback = resolve;
    }));
    if (options) $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$_init(options);
    else if (caller && !$cc519efa84d20a3e$var$$7adb23b0109cc36a$var$initialized) console.warn(`\`${caller}\` requires data to be initialized first. Promise will be pending until \`init\` is called.`);
    return $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$promise;
}
async function $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$_init(props) {
    $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$initialized = true;
    let { emojiVersion: emojiVersion, set: set, locale: locale } = props;
    emojiVersion || (emojiVersion = $cc519efa84d20a3e$var$$b247ea80b67298d5$export$2e2bcd8739ae039.emojiVersion.value);
    set || (set = $cc519efa84d20a3e$var$$b247ea80b67298d5$export$2e2bcd8739ae039.set.value);
    locale || (locale = $cc519efa84d20a3e$var$$b247ea80b67298d5$export$2e2bcd8739ae039.locale.value);
    if (!$cc519efa84d20a3e$export$2d0294657ab35f1b) {
        $cc519efa84d20a3e$export$2d0294657ab35f1b = (typeof props.data === "function" ? await props.data() : props.data) || await $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$fetchJSON(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/sets/${emojiVersion}/${set}.json`);
        $cc519efa84d20a3e$export$2d0294657ab35f1b.emoticons = {};
        $cc519efa84d20a3e$export$2d0294657ab35f1b.natives = {};
        $cc519efa84d20a3e$export$2d0294657ab35f1b.categories.unshift({
            id: "frequent",
            emojis: []
        });
        for(const alias in $cc519efa84d20a3e$export$2d0294657ab35f1b.aliases){
            const emojiId = $cc519efa84d20a3e$export$2d0294657ab35f1b.aliases[alias];
            const emoji = $cc519efa84d20a3e$export$2d0294657ab35f1b.emojis[emojiId];
            if (!emoji) continue;
            emoji.aliases || (emoji.aliases = []);
            emoji.aliases.push(alias);
        }
        $cc519efa84d20a3e$export$2d0294657ab35f1b.originalCategories = $cc519efa84d20a3e$export$2d0294657ab35f1b.categories;
    } else $cc519efa84d20a3e$export$2d0294657ab35f1b.categories = $cc519efa84d20a3e$export$2d0294657ab35f1b.categories.filter((c)=>{
        const isCustom = !!c.name;
        if (!isCustom) return true;
        return false;
    });
    $cc519efa84d20a3e$export$dbe3113d60765c1a = (typeof props.i18n === "function" ? await props.i18n() : props.i18n) || (locale == "en" ? /*@__PURE__*/ $cc519efa84d20a3e$var$$parcel$interopDefault($cc519efa84d20a3e$var$$8d50d93417ef682a$exports) : await $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$fetchJSON(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/i18n/${locale}.json`));
    if (props.custom) for(let i in props.custom){
        i = parseInt(i);
        const category = props.custom[i];
        const prevCategory = props.custom[i - 1];
        if (!category.emojis || !category.emojis.length) continue;
        category.id || (category.id = `custom_${i + 1}`);
        category.name || (category.name = $cc519efa84d20a3e$export$dbe3113d60765c1a.categories.custom);
        if (prevCategory && !category.icon) category.target = prevCategory.target || prevCategory;
        $cc519efa84d20a3e$export$2d0294657ab35f1b.categories.push(category);
        for (const emoji of category.emojis)$cc519efa84d20a3e$export$2d0294657ab35f1b.emojis[emoji.id] = emoji;
    }
    if (props.categories) $cc519efa84d20a3e$export$2d0294657ab35f1b.categories = $cc519efa84d20a3e$export$2d0294657ab35f1b.originalCategories.filter((c)=>{
        return props.categories.indexOf(c.id) != -1;
    }).sort((c1, c2)=>{
        const i1 = props.categories.indexOf(c1.id);
        const i2 = props.categories.indexOf(c2.id);
        return i1 - i2;
    });
    let latestVersionSupport = null;
    let noCountryFlags = null;
    if (set == "native") {
        latestVersionSupport = $cc519efa84d20a3e$var$$c84d045dcc34faf5$export$2e2bcd8739ae039.latestVersion();
        noCountryFlags = props.noCountryFlags || $cc519efa84d20a3e$var$$c84d045dcc34faf5$export$2e2bcd8739ae039.noCountryFlags();
    }
    let categoryIndex = $cc519efa84d20a3e$export$2d0294657ab35f1b.categories.length;
    let resetSearchIndex = false;
    while(categoryIndex--){
        const category = $cc519efa84d20a3e$export$2d0294657ab35f1b.categories[categoryIndex];
        if (category.id == "frequent") {
            let { maxFrequentRows: maxFrequentRows, perLine: perLine } = props;
            maxFrequentRows = maxFrequentRows >= 0 ? maxFrequentRows : $cc519efa84d20a3e$var$$b247ea80b67298d5$export$2e2bcd8739ae039.maxFrequentRows.value;
            perLine || (perLine = $cc519efa84d20a3e$var$$b247ea80b67298d5$export$2e2bcd8739ae039.perLine.value);
            category.emojis = $cc519efa84d20a3e$export$d42f766cf4e359f3.get({
                maxFrequentRows: maxFrequentRows,
                perLine: perLine
            });
        }
        if (!category.emojis || !category.emojis.length) {
            $cc519efa84d20a3e$export$2d0294657ab35f1b.categories.splice(categoryIndex, 1);
            continue;
        }
        const { categoryIcons: categoryIcons } = props;
        if (categoryIcons) {
            const icon = categoryIcons[category.id];
            if (icon && !category.icon) category.icon = icon;
        }
        let emojiIndex = category.emojis.length;
        while(emojiIndex--){
            const emojiId = category.emojis[emojiIndex];
            const emoji = emojiId.id ? emojiId : $cc519efa84d20a3e$export$2d0294657ab35f1b.emojis[emojiId];
            const ignore = ()=>{
                category.emojis.splice(emojiIndex, 1);
            };
            if (!emoji || props.exceptEmojis && props.exceptEmojis.includes(emoji.id)) {
                ignore();
                continue;
            }
            if (latestVersionSupport && emoji.version > latestVersionSupport) {
                ignore();
                continue;
            }
            if (noCountryFlags && category.id == "flags") {
                if (!$cc519efa84d20a3e$export$bcb25aa587e9cb13.includes(emoji.id)) {
                    ignore();
                    continue;
                }
            }
            if (!emoji.search) {
                resetSearchIndex = true;
                emoji.search = "," + [
                    [
                        emoji.id,
                        false
                    ],
                    [
                        emoji.name,
                        true
                    ],
                    [
                        emoji.keywords,
                        false
                    ],
                    [
                        emoji.emoticons,
                        false
                    ]
                ].map(([strings, split])=>{
                    if (!strings) return;
                    return (Array.isArray(strings) ? strings : [
                        strings
                    ]).map((string)=>{
                        return (split ? string.split(/[-|_|\s]+/) : [
                            string
                        ]).map((s)=>s.toLowerCase());
                    }).flat();
                }).flat().filter((a)=>a && a.trim()).join(",");
                if (emoji.emoticons) for (const emoticon of emoji.emoticons){
                    if ($cc519efa84d20a3e$export$2d0294657ab35f1b.emoticons[emoticon]) continue;
                    $cc519efa84d20a3e$export$2d0294657ab35f1b.emoticons[emoticon] = emoji.id;
                }
                let skinIndex = 0;
                for (const skin of emoji.skins){
                    if (!skin) continue;
                    skinIndex++;
                    const { native: native } = skin;
                    if (native) {
                        $cc519efa84d20a3e$export$2d0294657ab35f1b.natives[native] = emoji.id;
                        emoji.search += `,${native}`;
                    }
                    const skinShortcodes = skinIndex == 1 ? "" : `:skin-tone-${skinIndex}:`;
                    skin.shortcodes = `:${emoji.id}:${skinShortcodes}`;
                }
            }
        }
    }
    if (resetSearchIndex) $cc519efa84d20a3e$export$147b480b3694c1f3.reset();
    $cc519efa84d20a3e$var$$7adb23b0109cc36a$var$initCallback();
}
function $cc519efa84d20a3e$var$$7adb23b0109cc36a$export$75fe5f91d452f94b(props, defaultProps, element) {
    props || (props = {});
    const _props = {};
    for(let k in defaultProps)_props[k] = $cc519efa84d20a3e$var$$7adb23b0109cc36a$export$88c9ddb45cea7241(k, props, defaultProps, element);
    return _props;
}
function $cc519efa84d20a3e$var$$7adb23b0109cc36a$export$88c9ddb45cea7241(propName, props, defaultProps, element) {
    const defaults = defaultProps[propName];
    let value = element && element.getAttribute(propName) || (props[propName] != null && props[propName] != undefined ? props[propName] : null);
    if (!defaults) return value;
    if (value != null && defaults.value && typeof defaults.value != typeof value) {
        if (typeof defaults.value == "boolean") value = value == "false" ? false : true;
        else value = defaults.value.constructor(value);
    }
    if (defaults.transform && value) value = defaults.transform(value);
    if (value == null || defaults.choices && defaults.choices.indexOf(value) == -1) value = defaults.value;
    return value;
}
const $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$SHORTCODES_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
let $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$Pool = null;
function $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$get(emojiId) {
    if (emojiId.id) return emojiId;
    return $cc519efa84d20a3e$export$2d0294657ab35f1b.emojis[emojiId] || $cc519efa84d20a3e$export$2d0294657ab35f1b.emojis[$cc519efa84d20a3e$export$2d0294657ab35f1b.aliases[emojiId]] || $cc519efa84d20a3e$export$2d0294657ab35f1b.emojis[$cc519efa84d20a3e$export$2d0294657ab35f1b.natives[emojiId]];
}
function $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$reset() {
    $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$Pool = null;
}
async function $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$search(value, { maxResults: maxResults, caller: caller } = {}) {
    if (!value || !value.trim().length) return null;
    maxResults || (maxResults = 90);
    await $cc519efa84d20a3e$export$2cd8252107eb640b(null, {
        caller: caller || "SearchIndex.search"
    });
    const values = value.toLowerCase().replace(/(\w)-/, "$1 ").split(/[\s|,]+/).filter((word, i, words)=>{
        return word.trim() && words.indexOf(word) == i;
    });
    if (!values.length) return;
    let pool = $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$Pool || ($cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$Pool = Object.values($cc519efa84d20a3e$export$2d0294657ab35f1b.emojis));
    let results, scores;
    for (const value1 of values){
        if (!pool.length) break;
        results = [];
        scores = {};
        for (const emoji of pool){
            if (!emoji.search) continue;
            const score = emoji.search.indexOf(`,${value1}`);
            if (score == -1) continue;
            results.push(emoji);
            scores[emoji.id] || (scores[emoji.id] = 0);
            scores[emoji.id] += emoji.id == value1 ? 0 : score + 1;
        }
        pool = results;
    }
    if (results.length < 2) return results;
    results.sort((a, b)=>{
        const aScore = scores[a.id];
        const bScore = scores[b.id];
        if (aScore == bScore) return a.id.localeCompare(b.id);
        return aScore - bScore;
    });
    if (results.length > maxResults) results = results.slice(0, maxResults);
    return results;
}
var $cc519efa84d20a3e$export$147b480b3694c1f3 = {
    search: $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$search,
    get: $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$get,
    reset: $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$reset,
    SHORTCODES_REGEX: $cc519efa84d20a3e$var$$c4d155af13ad4d4b$var$SHORTCODES_REGEX
};
const $cc519efa84d20a3e$export$bcb25aa587e9cb13 = [
    "checkered_flag",
    "crossed_flags",
    "pirate_flag",
    "rainbow-flag",
    "transgender_flag",
    "triangular_flag_on_post",
    "waving_black_flag",
    "waving_white_flag"
];
function $cc519efa84d20a3e$var$$693b183b0a78708f$export$9cb4719e2e525b7a(a, b) {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index)=>val == b[index]);
}
async function $cc519efa84d20a3e$var$$693b183b0a78708f$export$e772c8ff12451969(frames = 1) {
    for(let _ in [
        ...Array(frames).keys()
    ])await new Promise(requestAnimationFrame);
}
function $cc519efa84d20a3e$var$$693b183b0a78708f$export$d10ac59fbe52a745(emoji, { skinIndex: skinIndex = 0 } = {}) {
    const skin = emoji.skins[skinIndex] || (()=>{
        skinIndex = 0;
        return emoji.skins[skinIndex];
    })();
    const emojiData = {
        id: emoji.id,
        name: emoji.name,
        native: skin.native,
        unified: skin.unified,
        keywords: emoji.keywords,
        shortcodes: skin.shortcodes || emoji.shortcodes
    };
    if (emoji.skins.length > 1) emojiData.skin = skinIndex + 1;
    if (skin.src) emojiData.src = skin.src;
    if (emoji.aliases && emoji.aliases.length) emojiData.aliases = emoji.aliases;
    if (emoji.emoticons && emoji.emoticons.length) emojiData.emoticons = emoji.emoticons;
    return emojiData;
}
async function $cc519efa84d20a3e$export$5ef5574deca44bc0(nativeString) {
    const results = await $cc519efa84d20a3e$export$147b480b3694c1f3.search(nativeString, {
        maxResults: 1,
        caller: "getEmojiDataFromNative"
    });
    if (!results || !results.length) return null;
    const emoji = results[0];
    let skinIndex = 0;
    for (let skin of emoji.skins){
        if (skin.native == nativeString) break;
        skinIndex++;
    }
    return $cc519efa84d20a3e$var$$693b183b0a78708f$export$d10ac59fbe52a745(emoji, {
        skinIndex: skinIndex
    });
}
const $cc519efa84d20a3e$var$$fcccfb36ed0cde68$var$categories = {
    activity: {
        outline: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
            })
        }),
        solid: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M16.17 337.5c0 44.98 7.565 83.54 13.98 107.9C35.22 464.3 50.46 496 174.9 496c9.566 0 19.59-.4707 29.84-1.271L17.33 307.3C16.53 317.6 16.17 327.7 16.17 337.5zM495.8 174.5c0-44.98-7.565-83.53-13.98-107.9c-4.688-17.54-18.34-31.23-36.04-35.95C435.5 27.91 392.9 16 337 16c-9.564 0-19.59 .4707-29.84 1.271l187.5 187.5C495.5 194.4 495.8 184.3 495.8 174.5zM26.77 248.8l236.3 236.3c142-36.1 203.9-150.4 222.2-221.1L248.9 26.87C106.9 62.96 45.07 177.2 26.77 248.8zM256 335.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L164.7 283.3C161.6 280.2 160 276.1 160 271.1c0-8.529 6.865-16 16-16c4.095 0 8.189 1.562 11.31 4.688l64.01 64C254.4 327.8 256 331.9 256 335.1zM304 287.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L212.7 235.3C209.6 232.2 208 228.1 208 223.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01C302.5 279.8 304 283.9 304 287.1zM256 175.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01c3.125 3.125 4.688 7.219 4.688 11.31c0 9.133-7.468 16-16 16c-4.094 0-8.189-1.562-11.31-4.688l-64.01-64.01C257.6 184.2 256 180.1 256 175.1z"
            })
        })
    },
    custom: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
            d: "M417.1 368c-5.937 10.27-16.69 16-27.75 16c-5.422 0-10.92-1.375-15.97-4.281L256 311.4V448c0 17.67-14.33 32-31.1 32S192 465.7 192 448V311.4l-118.3 68.29C68.67 382.6 63.17 384 57.75 384c-11.06 0-21.81-5.734-27.75-16c-8.828-15.31-3.594-34.88 11.72-43.72L159.1 256L41.72 187.7C26.41 178.9 21.17 159.3 29.1 144C36.63 132.5 49.26 126.7 61.65 128.2C65.78 128.7 69.88 130.1 73.72 132.3L192 200.6V64c0-17.67 14.33-32 32-32S256 46.33 256 64v136.6l118.3-68.29c3.838-2.213 7.939-3.539 12.07-4.051C398.7 126.7 411.4 132.5 417.1 144c8.828 15.31 3.594 34.88-11.72 43.72L288 256l118.3 68.28C421.6 333.1 426.8 352.7 417.1 368z"
        })
    }),
    flags: {
        outline: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
            })
        }),
        solid: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M64 496C64 504.8 56.75 512 48 512h-32C7.25 512 0 504.8 0 496V32c0-17.75 14.25-32 32-32s32 14.25 32 32V496zM476.3 0c-6.365 0-13.01 1.35-19.34 4.233c-45.69 20.86-79.56 27.94-107.8 27.94c-59.96 0-94.81-31.86-163.9-31.87C160.9 .3055 131.6 4.867 96 15.75v350.5c32-9.984 59.87-14.1 84.85-14.1c73.63 0 124.9 31.78 198.6 31.78c31.91 0 68.02-5.971 111.1-23.09C504.1 355.9 512 344.4 512 332.1V30.73C512 11.1 495.3 0 476.3 0z"
            })
        })
    },
    foods: {
        outline: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
            })
        }),
        solid: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M481.9 270.1C490.9 279.1 496 291.3 496 304C496 316.7 490.9 328.9 481.9 337.9C472.9 346.9 460.7 352 448 352H64C51.27 352 39.06 346.9 30.06 337.9C21.06 328.9 16 316.7 16 304C16 291.3 21.06 279.1 30.06 270.1C39.06 261.1 51.27 256 64 256H448C460.7 256 472.9 261.1 481.9 270.1zM475.3 388.7C478.3 391.7 480 395.8 480 400V416C480 432.1 473.3 449.3 461.3 461.3C449.3 473.3 432.1 480 416 480H96C79.03 480 62.75 473.3 50.75 461.3C38.74 449.3 32 432.1 32 416V400C32 395.8 33.69 391.7 36.69 388.7C39.69 385.7 43.76 384 48 384H464C468.2 384 472.3 385.7 475.3 388.7zM50.39 220.8C45.93 218.6 42.03 215.5 38.97 211.6C35.91 207.7 33.79 203.2 32.75 198.4C31.71 193.5 31.8 188.5 32.99 183.7C54.98 97.02 146.5 32 256 32C365.5 32 457 97.02 479 183.7C480.2 188.5 480.3 193.5 479.2 198.4C478.2 203.2 476.1 207.7 473 211.6C469.1 215.5 466.1 218.6 461.6 220.8C457.2 222.9 452.3 224 447.3 224H64.67C59.73 224 54.84 222.9 50.39 220.8zM372.7 116.7C369.7 119.7 368 123.8 368 128C368 131.2 368.9 134.3 370.7 136.9C372.5 139.5 374.1 141.6 377.9 142.8C380.8 143.1 384 144.3 387.1 143.7C390.2 143.1 393.1 141.6 395.3 139.3C397.6 137.1 399.1 134.2 399.7 131.1C400.3 128 399.1 124.8 398.8 121.9C397.6 118.1 395.5 116.5 392.9 114.7C390.3 112.9 387.2 111.1 384 111.1C379.8 111.1 375.7 113.7 372.7 116.7V116.7zM244.7 84.69C241.7 87.69 240 91.76 240 96C240 99.16 240.9 102.3 242.7 104.9C244.5 107.5 246.1 109.6 249.9 110.8C252.8 111.1 256 112.3 259.1 111.7C262.2 111.1 265.1 109.6 267.3 107.3C269.6 105.1 271.1 102.2 271.7 99.12C272.3 96.02 271.1 92.8 270.8 89.88C269.6 86.95 267.5 84.45 264.9 82.7C262.3 80.94 259.2 79.1 256 79.1C251.8 79.1 247.7 81.69 244.7 84.69V84.69zM116.7 116.7C113.7 119.7 112 123.8 112 128C112 131.2 112.9 134.3 114.7 136.9C116.5 139.5 118.1 141.6 121.9 142.8C124.8 143.1 128 144.3 131.1 143.7C134.2 143.1 137.1 141.6 139.3 139.3C141.6 137.1 143.1 134.2 143.7 131.1C144.3 128 143.1 124.8 142.8 121.9C141.6 118.1 139.5 116.5 136.9 114.7C134.3 112.9 131.2 111.1 128 111.1C123.8 111.1 119.7 113.7 116.7 116.7L116.7 116.7z"
            })
        })
    },
    frequent: {
        outline: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
                }),
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
                })
            ]
        }),
        solid: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"
            })
        })
    },
    nature: {
        outline: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
                }),
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
                })
            ]
        }),
        solid: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 576 512",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M332.7 19.85C334.6 8.395 344.5 0 356.1 0C363.6 0 370.6 3.52 375.1 9.502L392 32H444.1C456.8 32 469.1 37.06 478.1 46.06L496 64H552C565.3 64 576 74.75 576 88V112C576 156.2 540.2 192 496 192H426.7L421.6 222.5L309.6 158.5L332.7 19.85zM448 64C439.2 64 432 71.16 432 80C432 88.84 439.2 96 448 96C456.8 96 464 88.84 464 80C464 71.16 456.8 64 448 64zM416 256.1V480C416 497.7 401.7 512 384 512H352C334.3 512 320 497.7 320 480V364.8C295.1 377.1 268.8 384 240 384C211.2 384 184 377.1 160 364.8V480C160 497.7 145.7 512 128 512H96C78.33 512 64 497.7 64 480V249.8C35.23 238.9 12.64 214.5 4.836 183.3L.9558 167.8C-3.331 150.6 7.094 133.2 24.24 128.1C41.38 124.7 58.76 135.1 63.05 152.2L66.93 167.8C70.49 182 83.29 191.1 97.97 191.1H303.8L416 256.1z"
            })
        })
    },
    objects: {
        outline: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
                }),
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
                })
            ]
        }),
        solid: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 384 512",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM191.4 .0132C89.44 .3257 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.61 288.9-.2837 191.4 .0132zM192 96.01c-44.13 0-80 35.89-80 79.1C112 184.8 104.8 192 96 192S80 184.8 80 176c0-61.76 50.25-111.1 112-111.1c8.844 0 16 7.159 16 16S200.8 96.01 192 96.01z"
            })
        })
    },
    people: {
        outline: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
                }),
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
                })
            ]
        }),
        solid: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 432C332.1 432 396.2 382 415.2 314.1C419.1 300.4 407.8 288 393.6 288H118.4C104.2 288 92.92 300.4 96.76 314.1C115.8 382 179.9 432 256 432V432zM176.4 160C158.7 160 144.4 174.3 144.4 192C144.4 209.7 158.7 224 176.4 224C194 224 208.4 209.7 208.4 192C208.4 174.3 194 160 176.4 160zM336.4 224C354 224 368.4 209.7 368.4 192C368.4 174.3 354 160 336.4 160C318.7 160 304.4 174.3 304.4 192C304.4 209.7 318.7 224 336.4 224z"
            })
        })
    },
    places: {
        outline: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
                }),
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
                })
            ]
        }),
        solid: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M39.61 196.8L74.8 96.29C88.27 57.78 124.6 32 165.4 32H346.6C387.4 32 423.7 57.78 437.2 96.29L472.4 196.8C495.6 206.4 512 229.3 512 256V448C512 465.7 497.7 480 480 480H448C430.3 480 416 465.7 416 448V400H96V448C96 465.7 81.67 480 64 480H32C14.33 480 0 465.7 0 448V256C0 229.3 16.36 206.4 39.61 196.8V196.8zM109.1 192H402.9L376.8 117.4C372.3 104.6 360.2 96 346.6 96H165.4C151.8 96 139.7 104.6 135.2 117.4L109.1 192zM96 256C78.33 256 64 270.3 64 288C64 305.7 78.33 320 96 320C113.7 320 128 305.7 128 288C128 270.3 113.7 256 96 256zM416 320C433.7 320 448 305.7 448 288C448 270.3 433.7 256 416 256C398.3 256 384 270.3 384 288C384 305.7 398.3 320 416 320z"
            })
        })
    },
    symbols: {
        outline: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
            })
        }),
        solid: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M500.3 7.251C507.7 13.33 512 22.41 512 31.1V175.1C512 202.5 483.3 223.1 447.1 223.1C412.7 223.1 383.1 202.5 383.1 175.1C383.1 149.5 412.7 127.1 447.1 127.1V71.03L351.1 90.23V207.1C351.1 234.5 323.3 255.1 287.1 255.1C252.7 255.1 223.1 234.5 223.1 207.1C223.1 181.5 252.7 159.1 287.1 159.1V63.1C287.1 48.74 298.8 35.61 313.7 32.62L473.7 .6198C483.1-1.261 492.9 1.173 500.3 7.251H500.3zM74.66 303.1L86.5 286.2C92.43 277.3 102.4 271.1 113.1 271.1H174.9C185.6 271.1 195.6 277.3 201.5 286.2L213.3 303.1H239.1C266.5 303.1 287.1 325.5 287.1 351.1V463.1C287.1 490.5 266.5 511.1 239.1 511.1H47.1C21.49 511.1-.0019 490.5-.0019 463.1V351.1C-.0019 325.5 21.49 303.1 47.1 303.1H74.66zM143.1 359.1C117.5 359.1 95.1 381.5 95.1 407.1C95.1 434.5 117.5 455.1 143.1 455.1C170.5 455.1 191.1 434.5 191.1 407.1C191.1 381.5 170.5 359.1 143.1 359.1zM440.3 367.1H496C502.7 367.1 508.6 372.1 510.1 378.4C513.3 384.6 511.6 391.7 506.5 396L378.5 508C372.9 512.1 364.6 513.3 358.6 508.9C352.6 504.6 350.3 496.6 353.3 489.7L391.7 399.1H336C329.3 399.1 323.4 395.9 321 389.6C318.7 383.4 320.4 376.3 325.5 371.1L453.5 259.1C459.1 255 467.4 254.7 473.4 259.1C479.4 263.4 481.6 271.4 478.7 278.3L440.3 367.1zM116.7 219.1L19.85 119.2C-8.112 90.26-6.614 42.31 24.85 15.34C51.82-8.137 93.26-3.642 118.2 21.83L128.2 32.32L137.7 21.83C162.7-3.642 203.6-8.137 231.6 15.34C262.6 42.31 264.1 90.26 236.1 119.2L139.7 219.1C133.2 225.6 122.7 225.6 116.7 219.1H116.7z"
            })
        })
    }
};
const $cc519efa84d20a3e$var$$fcccfb36ed0cde68$var$search = {
    loupe: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
            d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
        })
    }),
    delete: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
            d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
        })
    })
};
var $cc519efa84d20a3e$var$$fcccfb36ed0cde68$export$2e2bcd8739ae039 = {
    categories: $cc519efa84d20a3e$var$$fcccfb36ed0cde68$var$categories,
    search: $cc519efa84d20a3e$var$$fcccfb36ed0cde68$var$search
};
function $cc519efa84d20a3e$var$$254755d3f438722f$export$2e2bcd8739ae039(props) {
    let { id: id, skin: skin, emoji: emoji } = props;
    if (props.shortcodes) {
        const matches = props.shortcodes.match($cc519efa84d20a3e$export$147b480b3694c1f3.SHORTCODES_REGEX);
        if (matches) {
            id = matches[1];
            if (matches[2]) skin = matches[2];
        }
    }
    emoji || (emoji = $cc519efa84d20a3e$export$147b480b3694c1f3.get(id || props.native));
    if (!emoji) return props.fallback;
    const emojiSkin = emoji.skins[skin - 1] || emoji.skins[0];
    const imageSrc = emojiSkin.src || (props.set != "native" && !props.spritesheet ? typeof props.getImageURL === "function" ? props.getImageURL(props.set, emojiSkin.unified) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${props.set}@15.0.1/img/${props.set}/64/${emojiSkin.unified}.png` : undefined);
    const spritesheetSrc = typeof props.getSpritesheetURL === "function" ? props.getSpritesheetURL(props.set) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${props.set}@15.0.1/img/${props.set}/sheets-256/64.png`;
    return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
        class: "emoji-mart-emoji",
        "data-emoji-set": props.set,
        children: imageSrc ? $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("img", {
            style: {
                maxWidth: props.size || "1em",
                maxHeight: props.size || "1em",
                display: "inline-block"
            },
            alt: emojiSkin.native || emojiSkin.shortcodes,
            src: imageSrc
        }) : props.set == "native" ? $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
            style: {
                fontSize: props.size,
                fontFamily: '"EmojiMart", "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "Android Emoji"'
            },
            children: emojiSkin.native
        }) : $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
            style: {
                display: "block",
                width: props.size,
                height: props.size,
                backgroundImage: `url(${spritesheetSrc})`,
                backgroundSize: `${100 * $cc519efa84d20a3e$export$2d0294657ab35f1b.sheet.cols}% ${100 * $cc519efa84d20a3e$export$2d0294657ab35f1b.sheet.rows}%`,
                backgroundPosition: `${100 / ($cc519efa84d20a3e$export$2d0294657ab35f1b.sheet.cols - 1) * emojiSkin.x}% ${100 / ($cc519efa84d20a3e$export$2d0294657ab35f1b.sheet.rows - 1) * emojiSkin.y}%`
            }
        })
    });
}
const $cc519efa84d20a3e$var$$6f57cc9cd54c5aaa$var$WindowHTMLElement = typeof window !== "undefined" && window.HTMLElement ? window.HTMLElement : Object;
class $cc519efa84d20a3e$var$$6f57cc9cd54c5aaa$export$2e2bcd8739ae039 extends $cc519efa84d20a3e$var$$6f57cc9cd54c5aaa$var$WindowHTMLElement {
    static get observedAttributes() {
        return Object.keys(this.Props);
    }
    update(props = {}) {
        for(let k in props)this.attributeChangedCallback(k, null, props[k]);
    }
    attributeChangedCallback(attr, _, newValue) {
        if (!this.component) return;
        const value = $cc519efa84d20a3e$var$$7adb23b0109cc36a$export$88c9ddb45cea7241(attr, {
            [attr]: newValue
        }, this.constructor.Props, this);
        if (this.component.componentWillReceiveProps) this.component.componentWillReceiveProps({
            [attr]: value
        });
        else {
            this.component.props[attr] = value;
            this.component.forceUpdate();
        }
    }
    disconnectedCallback() {
        this.disconnected = true;
        if (this.component && this.component.unregister) this.component.unregister();
    }
    constructor(props = {}){
        super();
        this.props = props;
        if (props.parent || props.ref) {
            let ref = null;
            const parent = props.parent || (ref = props.ref && props.ref.current);
            if (ref) ref.innerHTML = "";
            if (parent) parent.appendChild(this);
        }
    }
}
class $cc519efa84d20a3e$var$$26f27c338a96b1a6$export$2e2bcd8739ae039 extends $cc519efa84d20a3e$var$$6f57cc9cd54c5aaa$export$2e2bcd8739ae039 {
    setShadow() {
        this.attachShadow({
            mode: "open"
        });
    }
    injectStyles(styles) {
        if (!styles) return;
        const style = document.createElement("style");
        style.textContent = styles;
        this.shadowRoot.insertBefore(style, this.shadowRoot.firstChild);
    }
    constructor(props, { styles: styles } = {}){
        super(props);
        this.setShadow();
        this.injectStyles(styles);
    }
}
var $cc519efa84d20a3e$var$$3d90f6e46fb2dd47$export$2e2bcd8739ae039 = {
    fallback: "",
    id: "",
    native: "",
    shortcodes: "",
    size: {
        value: "",
        transform: (value)=>{
            // If the value is a number, then we assume it’s a pixel value.
            if (!/\D/.test(value)) return `${value}px`;
            return value;
        }
    },
    // Shared
    set: $cc519efa84d20a3e$var$$b247ea80b67298d5$export$2e2bcd8739ae039.set,
    skin: $cc519efa84d20a3e$var$$b247ea80b67298d5$export$2e2bcd8739ae039.skin
};
class $cc519efa84d20a3e$export$56cc48506ff790a extends $cc519efa84d20a3e$var$$6f57cc9cd54c5aaa$export$2e2bcd8739ae039 {
    async connectedCallback() {
        const props = $cc519efa84d20a3e$var$$7adb23b0109cc36a$export$75fe5f91d452f94b(this.props, $cc519efa84d20a3e$var$$3d90f6e46fb2dd47$export$2e2bcd8739ae039, this);
        props.element = this;
        props.ref = (component)=>{
            this.component = component;
        };
        await $cc519efa84d20a3e$export$2cd8252107eb640b();
        if (this.disconnected) return;
        $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99($cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($cc519efa84d20a3e$var$$254755d3f438722f$export$2e2bcd8739ae039, {
            ...props
        }), this);
    }
    constructor(props){
        super(props);
    }
}
$cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039($cc519efa84d20a3e$export$56cc48506ff790a, "Props", $cc519efa84d20a3e$var$$3d90f6e46fb2dd47$export$2e2bcd8739ae039);
if (typeof customElements !== "undefined" && !customElements.get("em-emoji")) customElements.define("em-emoji", $cc519efa84d20a3e$export$56cc48506ff790a);
var $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$t, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$r, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$o = 0, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$i = [], $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$c = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__b, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$f = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__r, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$e = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.diffed, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$a = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__c, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$v = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount;
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$m(t1, r1) {
    $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__h && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__h($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u, t1, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$o || r1), $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$o = 0;
    var i1 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u.__H || ($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u.__H = {
        __: [],
        __h: []
    });
    return t1 >= i1.__.length && i1.__.push({}), i1.__[t1];
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$60241385465d0a34(n1) {
    return $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$o = 1, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$13e3392192263954($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$w, n1);
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$13e3392192263954(n2, r2, o1) {
    var i2 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$m($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$t++, 2);
    return i2.t = n2, i2.__c || (i2.__ = [
        o1 ? o1(r2) : $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$w(void 0, r2),
        function(n3) {
            var t2 = i2.t(i2.__[0], n3);
            i2.__[0] !== t2 && (i2.__ = [
                t2,
                i2.__[1]
            ], i2.__c.setState({}));
        }
    ], i2.__c = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u), i2.__;
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$6d9c69b0de29b591(r3, o2) {
    var i3 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$m($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$t++, 3);
    !$cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__s && $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$k(i3.__H, o2) && (i3.__ = r3, i3.__H = o2, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u.__H.__h.push(i3));
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$e5c5a5f917a5871c(r4, o3) {
    var i4 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$m($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$t++, 4);
    !$cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__s && $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$k(i4.__H, o3) && (i4.__ = r4, i4.__H = o3, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u.__h.push(i4));
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$b8f5890fc79d6aca(n4) {
    return $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$o = 5, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$1538c33de8887b59(function() {
        return {
            current: n4
        };
    }, []);
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$d5a552a76deda3c2(n5, t3, u1) {
    $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$o = 6, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$e5c5a5f917a5871c(function() {
        "function" == typeof n5 ? n5(t3()) : n5 && (n5.current = t3());
    }, null == u1 ? u1 : u1.concat(n5));
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$1538c33de8887b59(n6, u2) {
    var r5 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$m($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$t++, 7);
    return $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$k(r5.__H, u2) && (r5.__ = n6(), r5.__H = u2, r5.__h = n6), r5.__;
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$35808ee640e87ca7(n7, t4) {
    return $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$o = 8, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$1538c33de8887b59(function() {
        return n7;
    }, t4);
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$fae74005e78b1a27(n8) {
    var r6 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u.context[n8.__c], o4 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$m($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$t++, 9);
    return o4.c = n8, r6 ? (null == o4.__ && (o4.__ = !0, r6.sub($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u)), r6.props.value) : n8.__;
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$dc8fbce3eb94dc1e(t5, u3) {
    $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.useDebugValue && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.useDebugValue(u3 ? u3(t5) : t5);
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$c052f6604b7d51fe(n9) {
    var r7 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$m($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$t++, 10), o5 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$60241385465d0a34();
    return r7.__ = n9, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u.componentDidCatch || ($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u.componentDidCatch = function(n10) {
        r7.__ && r7.__(n10), o5[1](n10);
    }), [
        o5[0],
        function() {
            o5[1](void 0);
        }
    ];
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$x() {
    var t6;
    for($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$i.sort(function(n11, t7) {
        return n11.__v.__b - t7.__v.__b;
    }); t6 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$i.pop();)if (t6.__P) try {
        t6.__H.__h.forEach($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$g), t6.__H.__h.forEach($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$j), t6.__H.__h = [];
    } catch (u4) {
        t6.__H.__h = [], $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(u4, t6.__v);
    }
}
$cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__b = function(n12) {
    $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u = null, $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$c && $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$c(n12);
}, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__r = function(n13) {
    $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$f && $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$f(n13), $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$t = 0;
    var r8 = ($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u = n13.__c).__H;
    r8 && (r8.__h.forEach($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$g), r8.__h.forEach($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$j), r8.__h = []);
}, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.diffed = function(t8) {
    $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$e && $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$e(t8);
    var o6 = t8.__c;
    o6 && o6.__H && o6.__H.__h.length && (1 !== $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$i.push(o6) && $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$r === $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.requestAnimationFrame || (($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$r = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.requestAnimationFrame) || function(n14) {
        var t9, u5 = function() {
            clearTimeout(r9), $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$b && cancelAnimationFrame(t9), setTimeout(n14);
        }, r9 = setTimeout(u5, 100);
        $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$b && (t9 = requestAnimationFrame(u5));
    })($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$x)), $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u = null;
}, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__c = function(t10, u6) {
    u6.some(function(t11) {
        try {
            t11.__h.forEach($cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$g), t11.__h = t11.__h.filter(function(n15) {
                return !n15.__ || $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$j(n15);
            });
        } catch (r10) {
            u6.some(function(n16) {
                n16.__h && (n16.__h = []);
            }), u6 = [], $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(r10, t11.__v);
        }
    }), $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$a && $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$a(t10, u6);
}, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount = function(t12) {
    $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$v && $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$v(t12);
    var u7, r11 = t12.__c;
    r11 && r11.__H && (r11.__H.__.forEach(function(n17) {
        try {
            $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$g(n17);
        } catch (n18) {
            u7 = n18;
        }
    }), u7 && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(u7, r11.__v));
};
var $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$b = "function" == typeof requestAnimationFrame;
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$g(n19) {
    var t13 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u, r12 = n19.__c;
    "function" == typeof r12 && (n19.__c = void 0, r12()), $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u = t13;
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$j(n20) {
    var t14 = $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u;
    n20.__c = n20.__(), $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$u = t14;
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$k(n21, t15) {
    return !n21 || n21.length !== t15.length || t15.some(function(t16, u8) {
        return t16 !== n21[u8];
    });
}
function $cc519efa84d20a3e$var$$1a9a8ef576b7773d$var$w(n22, t17) {
    return "function" == typeof t17 ? t17(n22) : t17;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$var$S(n1, t1) {
    for(var e1 in t1)n1[e1] = t1[e1];
    return n1;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$var$C(n2, t2) {
    for(var e2 in n2)if ("__source" !== e2 && !(e2 in t2)) return !0;
    for(var r1 in t2)if ("__source" !== r1 && n2[r1] !== t2[r1]) return !0;
    return !1;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$221d75b3f55bb0bd(n3) {
    this.props = n3;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$7c73462e0d25e514(n4, t3) {
    function e3(n5) {
        var e4 = this.props.ref, r3 = e4 == n5.ref;
        return !r3 && e4 && (e4.call ? e4(null) : e4.current = null), t3 ? !t3(this.props, n5) || !r3 : $cc519efa84d20a3e$var$$dc040a17866866fa$var$C(this.props, n5);
    }
    function r2(t4) {
        return this.shouldComponentUpdate = e3, $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d(n4, t4);
    }
    return r2.displayName = "Memo(" + (n4.displayName || n4.name) + ")", r2.prototype.isReactComponent = !0, r2.__f = !0, r2;
}
($cc519efa84d20a3e$var$$dc040a17866866fa$export$221d75b3f55bb0bd.prototype = new $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8).isPureReactComponent = !0, $cc519efa84d20a3e$var$$dc040a17866866fa$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n6, t5) {
    return $cc519efa84d20a3e$var$$dc040a17866866fa$var$C(this.props, n6) || $cc519efa84d20a3e$var$$dc040a17866866fa$var$C(this.state, t5);
};
var $cc519efa84d20a3e$var$$dc040a17866866fa$var$w = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__b;
$cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__b = function(n7) {
    n7.type && n7.type.__f && n7.ref && (n7.props.ref = n7.ref, n7.ref = null), $cc519efa84d20a3e$var$$dc040a17866866fa$var$w && $cc519efa84d20a3e$var$$dc040a17866866fa$var$w(n7);
};
var $cc519efa84d20a3e$var$$dc040a17866866fa$var$R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$257a8862b851cb5b(n8) {
    function t6(t7, e5) {
        var r4 = $cc519efa84d20a3e$var$$dc040a17866866fa$var$S({}, t7);
        return delete r4.ref, n8(r4, (e5 = t7.ref || e5) && ("object" != typeof e5 || "current" in e5) ? e5 : null);
    }
    return t6.$$typeof = $cc519efa84d20a3e$var$$dc040a17866866fa$var$R, t6.render = t6, t6.prototype.isReactComponent = t6.__f = !0, t6.displayName = "ForwardRef(" + (n8.displayName || n8.name) + ")", t6;
}
var $cc519efa84d20a3e$var$$dc040a17866866fa$var$N = function(n9, t8) {
    return null == n9 ? null : $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$47e4c5b300681277($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n9).map(t8));
}, $cc519efa84d20a3e$var$$dc040a17866866fa$export$dca3b0875bd9a954 = {
    map: $cc519efa84d20a3e$var$$dc040a17866866fa$var$N,
    forEach: $cc519efa84d20a3e$var$$dc040a17866866fa$var$N,
    count: function(n10) {
        return n10 ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n10).length : 0;
    },
    only: function(n11) {
        var t9 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n11);
        if (1 !== t9.length) throw "Children.only";
        return t9[0];
    },
    toArray: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$47e4c5b300681277
}, $cc519efa84d20a3e$var$$dc040a17866866fa$var$A = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e;
$cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e = function(n12, t10, e6) {
    if (n12.then) {
        for(var r5, u1 = t10; u1 = u1.__;)if ((r5 = u1.__c) && r5.__c) return null == t10.__e && (t10.__e = e6.__e, t10.__k = e6.__k), r5.__c(n12, t10);
    }
    $cc519efa84d20a3e$var$$dc040a17866866fa$var$A(n12, t10, e6);
};
var $cc519efa84d20a3e$var$$dc040a17866866fa$var$O = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount;
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$var$U(n13) {
    var t11 = n13.__.__c;
    return t11 && t11.__e && t11.__e(n13);
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$488013bae63b21da(n14) {
    var t12, e7, r6;
    function u2(u3) {
        if (t12 || (t12 = n14()).then(function(n15) {
            e7 = n15.default || n15;
        }, function(n16) {
            r6 = n16;
        }), r6) throw r6;
        if (!e7) throw t12;
        return $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d(e7, u3);
    }
    return u2.displayName = "Lazy", u2.__f = !0, u2;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
$cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount = function(n17) {
    var t13 = n17.__c;
    t13 && t13.__R && t13.__R(), t13 && !0 === n17.__h && (n17.type = null), $cc519efa84d20a3e$var$$dc040a17866866fa$var$O && $cc519efa84d20a3e$var$$dc040a17866866fa$var$O(n17);
}, ($cc519efa84d20a3e$var$$dc040a17866866fa$export$74bf444e3cd11ea5.prototype = new $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8).__c = function(n18, t14) {
    var e8 = t14.__c, r7 = this;
    null == r7.t && (r7.t = []), r7.t.push(e8);
    var u4 = $cc519efa84d20a3e$var$$dc040a17866866fa$var$U(r7.__v), o1 = !1, i1 = function() {
        o1 || (o1 = !0, e8.__R = null, u4 ? u4(l1) : l1());
    };
    e8.__R = i1;
    var l1 = function() {
        if (!--r7.__u) {
            if (r7.state.__e) {
                var n19 = r7.state.__e;
                r7.__v.__k[0] = function n22(t17, e9, r8) {
                    return t17 && (t17.__v = null, t17.__k = t17.__k && t17.__k.map(function(t18) {
                        return n22(t18, e9, r8);
                    }), t17.__c && t17.__c.__P === e9 && (t17.__e && r8.insertBefore(t17.__e, t17.__d), t17.__c.__e = !0, t17.__c.__P = r8)), t17;
                }(n19, n19.__c.__P, n19.__c.__O);
            }
            var t15;
            for(r7.setState({
                __e: r7.__b = null
            }); t15 = r7.t.pop();)t15.forceUpdate();
        }
    }, c1 = !0 === t14.__h;
    r7.__u++ || c1 || r7.setState({
        __e: r7.__b = r7.__v.__k[0]
    }), n18.then(i1, i1);
}, $cc519efa84d20a3e$var$$dc040a17866866fa$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $cc519efa84d20a3e$var$$dc040a17866866fa$export$74bf444e3cd11ea5.prototype.render = function(n23, t19) {
    if (this.__b) {
        if (this.__v.__k) {
            var e10 = document.createElement("div"), r9 = this.__v.__k[0].__c;
            this.__v.__k[0] = function n24(t20, e13, r12) {
                return t20 && (t20.__c && t20.__c.__H && (t20.__c.__H.__.forEach(function(n25) {
                    "function" == typeof n25.__c && n25.__c();
                }), t20.__c.__H = null), null != (t20 = $cc519efa84d20a3e$var$$dc040a17866866fa$var$S({}, t20)).__c && (t20.__c.__P === r12 && (t20.__c.__P = e13), t20.__c = null), t20.__k = t20.__k && t20.__k.map(function(t21) {
                    return n24(t21, e13, r12);
                })), t20;
            }(this.__b, e10, r9.__O = r9.__P);
        }
        this.__b = null;
    }
    var u5 = t19.__e && $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$ffb0004e005737fa, null, n23.fallback);
    return u5 && (u5.__h = null), [
        $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$ffb0004e005737fa, null, t19.__e ? null : n23.children),
        u5
    ];
};
var $cc519efa84d20a3e$var$$dc040a17866866fa$var$T = function(n26, t22, e14) {
    if (++e14[1] === e14[0] && n26.o.delete(t22), n26.props.revealOrder && ("t" !== n26.props.revealOrder[0] || !n26.o.size)) for(e14 = n26.u; e14;){
        for(; e14.length > 3;)e14.pop()();
        if (e14[1] < e14[0]) break;
        n26.u = e14 = e14[2];
    }
};
function $cc519efa84d20a3e$var$$dc040a17866866fa$var$D(n27) {
    return this.getChildContext = function() {
        return n27.context;
    }, n27.children;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$var$I(n28) {
    var t23 = this, e15 = n28.i;
    t23.componentWillUnmount = function() {
        $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99(null, t23.l), t23.l = null, t23.i = null;
    }, t23.i && t23.i !== e15 && t23.componentWillUnmount(), n28.__v ? (t23.l || (t23.i = e15, t23.l = {
        nodeType: 1,
        parentNode: e15,
        childNodes: [],
        appendChild: function(n29) {
            this.childNodes.push(n29), t23.i.appendChild(n29);
        },
        insertBefore: function(n30, e) {
            this.childNodes.push(n30), t23.i.appendChild(n30);
        },
        removeChild: function(n31) {
            this.childNodes.splice(this.childNodes.indexOf(n31) >>> 1, 1), t23.i.removeChild(n31);
        }
    }), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d($cc519efa84d20a3e$var$$dc040a17866866fa$var$D, {
        context: t23.context
    }, n28.__v), t23.l)) : t23.l && t23.componentWillUnmount();
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$d39a5bbd09211389(n32, t24) {
    return $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d($cc519efa84d20a3e$var$$dc040a17866866fa$var$I, {
        __v: n32,
        i: t24
    });
}
($cc519efa84d20a3e$var$$dc040a17866866fa$export$998bcd577473dd93.prototype = new $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8).__e = function(n33) {
    var t25 = this, e16 = $cc519efa84d20a3e$var$$dc040a17866866fa$var$U(t25.__v), r13 = t25.o.get(n33);
    return r13[0]++, function(u6) {
        var o2 = function() {
            t25.props.revealOrder ? (r13.push(u6), $cc519efa84d20a3e$var$$dc040a17866866fa$var$T(t25, n33, r13)) : u6();
        };
        e16 ? e16(o2) : o2();
    };
}, $cc519efa84d20a3e$var$$dc040a17866866fa$export$998bcd577473dd93.prototype.render = function(n34) {
    this.u = null, this.o = new Map;
    var t26 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n34.children);
    n34.revealOrder && "b" === n34.revealOrder[0] && t26.reverse();
    for(var e17 = t26.length; e17--;)this.o.set(t26[e17], this.u = [
        1,
        0,
        this.u
    ]);
    return n34.children;
}, $cc519efa84d20a3e$var$$dc040a17866866fa$export$998bcd577473dd93.prototype.componentDidUpdate = $cc519efa84d20a3e$var$$dc040a17866866fa$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n35 = this;
    this.o.forEach(function(t27, e18) {
        $cc519efa84d20a3e$var$$dc040a17866866fa$var$T(n35, e18, t27);
    });
};
var $cc519efa84d20a3e$var$$dc040a17866866fa$var$j = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $cc519efa84d20a3e$var$$dc040a17866866fa$var$P = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $cc519efa84d20a3e$var$$dc040a17866866fa$var$V = "undefined" != typeof document, $cc519efa84d20a3e$var$$dc040a17866866fa$var$z = function(n36) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n36);
};
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$b3890eb0ae9dca99(n37, t28, e19) {
    return null == t28.__k && (t28.textContent = ""), $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99(n37, t28), "function" == typeof e19 && e19(), n37 ? n37.__c : null;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$fa8d919ba61d84db(n38, t29, e20) {
    return $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$fa8d919ba61d84db(n38, t29), "function" == typeof e20 && e20(), n38 ? n38.__c : null;
}
$cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(n39) {
    Object.defineProperty($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype, n39, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + n39];
        },
        set: function(t30) {
            Object.defineProperty(this, n39, {
                configurable: !0,
                writable: !0,
                value: t30
            });
        }
    });
});
var $cc519efa84d20a3e$var$$dc040a17866866fa$var$H = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event;
function $cc519efa84d20a3e$var$$dc040a17866866fa$var$Z() {}
function $cc519efa84d20a3e$var$$dc040a17866866fa$var$Y() {
    return this.cancelBubble;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$var$q() {
    return this.defaultPrevented;
}
$cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event = function(n40) {
    return $cc519efa84d20a3e$var$$dc040a17866866fa$var$H && (n40 = $cc519efa84d20a3e$var$$dc040a17866866fa$var$H(n40)), n40.persist = $cc519efa84d20a3e$var$$dc040a17866866fa$var$Z, n40.isPropagationStopped = $cc519efa84d20a3e$var$$dc040a17866866fa$var$Y, n40.isDefaultPrevented = $cc519efa84d20a3e$var$$dc040a17866866fa$var$q, n40.nativeEvent = n40;
};
var $cc519efa84d20a3e$var$$dc040a17866866fa$var$G, $cc519efa84d20a3e$var$$dc040a17866866fa$var$J = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $cc519efa84d20a3e$var$$dc040a17866866fa$var$K = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode;
$cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode = function(n41) {
    var t31 = n41.type, e21 = n41.props, r14 = e21;
    if ("string" == typeof t31) {
        var u7 = -1 === t31.indexOf("-");
        for(var o3 in r14 = {}, e21){
            var i2 = e21[o3];
            $cc519efa84d20a3e$var$$dc040a17866866fa$var$V && "children" === o3 && "noscript" === t31 || "value" === o3 && "defaultValue" in e21 && null == i2 || ("defaultValue" === o3 && "value" in e21 && null == e21.value ? o3 = "value" : "download" === o3 && !0 === i2 ? i2 = "" : /ondoubleclick/i.test(o3) ? o3 = "ondblclick" : /^onchange(textarea|input)/i.test(o3 + t31) && !$cc519efa84d20a3e$var$$dc040a17866866fa$var$z(e21.type) ? o3 = "oninput" : /^onfocus$/i.test(o3) ? o3 = "onfocusin" : /^onblur$/i.test(o3) ? o3 = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp)/.test(o3) ? o3 = o3.toLowerCase() : u7 && $cc519efa84d20a3e$var$$dc040a17866866fa$var$P.test(o3) ? o3 = o3.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === i2 && (i2 = void 0), r14[o3] = i2);
        }
        "select" == t31 && r14.multiple && Array.isArray(r14.value) && (r14.value = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$47e4c5b300681277(e21.children).forEach(function(n42) {
            n42.props.selected = -1 != r14.value.indexOf(n42.props.value);
        })), "select" == t31 && null != r14.defaultValue && (r14.value = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$47e4c5b300681277(e21.children).forEach(function(n43) {
            n43.props.selected = r14.multiple ? -1 != r14.defaultValue.indexOf(n43.props.value) : r14.defaultValue == n43.props.value;
        })), n41.props = r14, e21.class != e21.className && ($cc519efa84d20a3e$var$$dc040a17866866fa$var$J.enumerable = "className" in e21, null != e21.className && (r14.class = e21.className), Object.defineProperty(r14, "className", $cc519efa84d20a3e$var$$dc040a17866866fa$var$J));
    }
    n41.$$typeof = $cc519efa84d20a3e$var$$dc040a17866866fa$var$j, $cc519efa84d20a3e$var$$dc040a17866866fa$var$K && $cc519efa84d20a3e$var$$dc040a17866866fa$var$K(n41);
};
var $cc519efa84d20a3e$var$$dc040a17866866fa$var$Q = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__r;
$cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__r = function(n44) {
    $cc519efa84d20a3e$var$$dc040a17866866fa$var$Q && $cc519efa84d20a3e$var$$dc040a17866866fa$var$Q(n44), $cc519efa84d20a3e$var$$dc040a17866866fa$var$G = n44.__c;
};
var $cc519efa84d20a3e$var$$dc040a17866866fa$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n45) {
                return $cc519efa84d20a3e$var$$dc040a17866866fa$var$G.__n[n45.__c].props.value;
            }
        }
    }
}, $cc519efa84d20a3e$var$$dc040a17866866fa$export$83d89fbfd8236492 = "17.0.2";
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$d38cd72104c1f0e9(n46) {
    return $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d.bind(null, n46);
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$a8257692ac88316c(n47) {
    return !!n47 && n47.$$typeof === $cc519efa84d20a3e$var$$dc040a17866866fa$var$j;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$e530037191fcd5d7(n48) {
    return $cc519efa84d20a3e$var$$dc040a17866866fa$export$a8257692ac88316c(n48) ? $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$e530037191fcd5d7.apply(null, arguments) : n48;
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$502457920280e6be(n49) {
    return !!n49.__k && ($cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99(null, n49), !0);
}
function $cc519efa84d20a3e$var$$dc040a17866866fa$export$466bfc07425424d5(n50) {
    return n50 && (n50.base || 1 === n50.nodeType && n50) || null;
}
var $cc519efa84d20a3e$var$$dc040a17866866fa$export$c78a37762a8d58e1 = function(n51, t32) {
    return n51(t32);
}, $cc519efa84d20a3e$var$$dc040a17866866fa$export$cd75ccfd720a3cd4 = function(n52, t33) {
    return n52(t33);
}, $cc519efa84d20a3e$var$$dc040a17866866fa$export$5f8d39834fd61797 = $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$ffb0004e005737fa;
var $cc519efa84d20a3e$var$$dc040a17866866fa$export$2e2bcd8739ae039 = {
    useState: $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$60241385465d0a34,
    useReducer: $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$13e3392192263954,
    useEffect: $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$6d9c69b0de29b591,
    useLayoutEffect: $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$e5c5a5f917a5871c,
    useRef: $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$b8f5890fc79d6aca,
    useImperativeHandle: $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$d5a552a76deda3c2,
    useMemo: $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$1538c33de8887b59,
    useCallback: $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$35808ee640e87ca7,
    useContext: $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$fae74005e78b1a27,
    useDebugValue: $cc519efa84d20a3e$var$$1a9a8ef576b7773d$export$dc8fbce3eb94dc1e,
    version: "17.0.2",
    Children: $cc519efa84d20a3e$var$$dc040a17866866fa$export$dca3b0875bd9a954,
    render: $cc519efa84d20a3e$var$$dc040a17866866fa$export$b3890eb0ae9dca99,
    hydrate: $cc519efa84d20a3e$var$$dc040a17866866fa$export$fa8d919ba61d84db,
    unmountComponentAtNode: $cc519efa84d20a3e$var$$dc040a17866866fa$export$502457920280e6be,
    createPortal: $cc519efa84d20a3e$var$$dc040a17866866fa$export$d39a5bbd09211389,
    createElement: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d,
    createContext: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$fd42f52fd3ae1109,
    createFactory: $cc519efa84d20a3e$var$$dc040a17866866fa$export$d38cd72104c1f0e9,
    cloneElement: $cc519efa84d20a3e$var$$dc040a17866866fa$export$e530037191fcd5d7,
    createRef: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43,
    Fragment: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$ffb0004e005737fa,
    isValidElement: $cc519efa84d20a3e$var$$dc040a17866866fa$export$a8257692ac88316c,
    findDOMNode: $cc519efa84d20a3e$var$$dc040a17866866fa$export$466bfc07425424d5,
    Component: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8,
    PureComponent: $cc519efa84d20a3e$var$$dc040a17866866fa$export$221d75b3f55bb0bd,
    memo: $cc519efa84d20a3e$var$$dc040a17866866fa$export$7c73462e0d25e514,
    forwardRef: $cc519efa84d20a3e$var$$dc040a17866866fa$export$257a8862b851cb5b,
    flushSync: $cc519efa84d20a3e$var$$dc040a17866866fa$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $cc519efa84d20a3e$var$$dc040a17866866fa$export$c78a37762a8d58e1,
    StrictMode: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$ffb0004e005737fa,
    Suspense: $cc519efa84d20a3e$var$$dc040a17866866fa$export$74bf444e3cd11ea5,
    SuspenseList: $cc519efa84d20a3e$var$$dc040a17866866fa$export$998bcd577473dd93,
    lazy: $cc519efa84d20a3e$var$$dc040a17866866fa$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $cc519efa84d20a3e$var$$dc040a17866866fa$export$ae55be85d98224ed
};
const $cc519efa84d20a3e$var$$ec8c39fdad15601a$var$THEME_ICONS = {
    light: "outline",
    dark: "solid"
};
class $cc519efa84d20a3e$var$$ec8c39fdad15601a$export$2e2bcd8739ae039 extends $cc519efa84d20a3e$var$$dc040a17866866fa$export$221d75b3f55bb0bd {
    renderIcon(category) {
        const { icon: icon } = category;
        if (icon) {
            if (icon.svg) return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
                class: "flex",
                dangerouslySetInnerHTML: {
                    __html: icon.svg
                }
            });
            if (icon.src) return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("img", {
                src: icon.src
            });
        }
        const categoryIcons = $cc519efa84d20a3e$var$$fcccfb36ed0cde68$export$2e2bcd8739ae039.categories[category.id] || $cc519efa84d20a3e$var$$fcccfb36ed0cde68$export$2e2bcd8739ae039.categories.custom;
        const style = this.props.icons == "auto" ? $cc519efa84d20a3e$var$$ec8c39fdad15601a$var$THEME_ICONS[this.props.theme] : this.props.icons;
        return categoryIcons[style] || categoryIcons;
    }
    render() {
        let selectedCategoryIndex = null;
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("nav", {
            id: "nav",
            class: "padding",
            "data-position": this.props.position,
            dir: this.props.dir,
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                class: "flex relative",
                children: [
                    this.categories.map((category, i)=>{
                        const title = category.name || $cc519efa84d20a3e$export$dbe3113d60765c1a.categories[category.id];
                        const selected = !this.props.unfocused && category.id == this.state.categoryId;
                        if (selected) selectedCategoryIndex = i;
                        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("button", {
                            "aria-label": title,
                            "aria-selected": selected || undefined,
                            title: title,
                            type: "button",
                            class: "flex flex-grow flex-center",
                            onMouseDown: (e)=>e.preventDefault(),
                            onClick: ()=>{
                                this.props.onClick({
                                    category: category,
                                    i: i
                                });
                            },
                            children: this.renderIcon(category)
                        });
                    }),
                    $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                        class: "bar",
                        style: {
                            width: `${100 / this.categories.length}%`,
                            opacity: selectedCategoryIndex == null ? 0 : 1,
                            transform: this.props.dir === "rtl" ? `scaleX(-1) translateX(${selectedCategoryIndex * 100}%)` : `translateX(${selectedCategoryIndex * 100}%)`
                        }
                    })
                ]
            })
        });
    }
    constructor(){
        super();
        this.categories = $cc519efa84d20a3e$export$2d0294657ab35f1b.categories.filter((category)=>{
            return !category.target;
        });
        this.state = {
            categoryId: this.categories[0].id
        };
    }
}
class $cc519efa84d20a3e$var$$e0d4dda61265ff1e$export$2e2bcd8739ae039 extends $cc519efa84d20a3e$var$$dc040a17866866fa$export$221d75b3f55bb0bd {
    shouldComponentUpdate(nextProps) {
        for(let k in nextProps){
            if (k == "children") continue;
            if (nextProps[k] != this.props[k]) return true;
        }
        return false;
    }
    render() {
        return this.props.children;
    }
}
const $cc519efa84d20a3e$var$$89bd6bb200cc8fef$var$Performance = {
    rowsPerRender: 10
};
class $cc519efa84d20a3e$var$$89bd6bb200cc8fef$export$2e2bcd8739ae039 extends $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8 {
    getInitialState(props = this.props) {
        return {
            skin: $cc519efa84d20a3e$export$390f32400eaf98c9.get("skin") || props.skin,
            theme: this.initTheme(props.theme)
        };
    }
    componentWillMount() {
        this.dir = $cc519efa84d20a3e$export$dbe3113d60765c1a.rtl ? "rtl" : "ltr";
        this.refs = {
            menu: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            navigation: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            scroll: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            search: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            searchInput: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            skinToneButton: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            skinToneRadio: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43()
        };
        this.initGrid();
        if (this.props.stickySearch == false && this.props.searchPosition == "sticky") {
            console.warn("[EmojiMart] Deprecation warning: `stickySearch` has been renamed `searchPosition`.");
            this.props.searchPosition = "static";
        }
    }
    componentDidMount() {
        this.register();
        this.shadowRoot = this.base.parentNode;
        if (this.props.autoFocus) {
            const { searchInput: searchInput } = this.refs;
            if (searchInput.current) searchInput.current.focus();
        }
    }
    componentWillReceiveProps(nextProps) {
        this.nextState || (this.nextState = {});
        for(const k1 in nextProps)this.nextState[k1] = nextProps[k1];
        clearTimeout(this.nextStateTimer);
        this.nextStateTimer = setTimeout(()=>{
            let requiresGridReset = false;
            for(const k in this.nextState){
                this.props[k] = this.nextState[k];
                if (k === "custom" || k === "categories") requiresGridReset = true;
            }
            delete this.nextState;
            const nextState = this.getInitialState();
            if (requiresGridReset) return this.reset(nextState);
            this.setState(nextState);
        });
    }
    componentWillUnmount() {
        this.unregister();
    }
    async reset(nextState = {}) {
        await $cc519efa84d20a3e$export$2cd8252107eb640b(this.props);
        this.initGrid();
        this.unobserve();
        this.setState(nextState, ()=>{
            this.observeCategories();
            this.observeRows();
        });
    }
    register() {
        document.addEventListener("click", this.handleClickOutside);
        this.observe();
    }
    unregister() {
        document.removeEventListener("click", this.handleClickOutside);
        this.darkMedia?.removeEventListener("change", this.darkMediaCallback);
        this.unobserve();
    }
    observe() {
        this.observeCategories();
        this.observeRows();
    }
    unobserve({ except: except = [] } = {}) {
        if (!Array.isArray(except)) except = [
            except
        ];
        for (const observer of this.observers){
            if (except.includes(observer)) continue;
            observer.disconnect();
        }
        this.observers = [].concat(except);
    }
    initGrid() {
        const { categories: categories } = $cc519efa84d20a3e$export$2d0294657ab35f1b;
        this.refs.categories = new Map();
        const navKey = $cc519efa84d20a3e$export$2d0294657ab35f1b.categories.map((category)=>category.id).join(",");
        if (this.navKey && this.navKey != navKey) this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0);
        this.navKey = navKey;
        this.grid = [];
        this.grid.setsize = 0;
        const addRow = (rows, category)=>{
            const row = [];
            row.__categoryId = category.id;
            row.__index = rows.length;
            this.grid.push(row);
            const rowIndex = this.grid.length - 1;
            const rowRef = rowIndex % $cc519efa84d20a3e$var$$89bd6bb200cc8fef$var$Performance.rowsPerRender ? {} : $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43();
            rowRef.index = rowIndex;
            rowRef.posinset = this.grid.setsize + 1;
            rows.push(rowRef);
            return row;
        };
        for (let category1 of categories){
            const rows = [];
            let row = addRow(rows, category1);
            for (let emoji of category1.emojis){
                if (row.length == this.getPerLine()) row = addRow(rows, category1);
                this.grid.setsize += 1;
                row.push(emoji);
            }
            this.refs.categories.set(category1.id, {
                root: $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
                rows: rows
            });
        }
    }
    initTheme(theme) {
        if (theme != "auto") return theme;
        if (!this.darkMedia) {
            this.darkMedia = matchMedia("(prefers-color-scheme: dark)");
            if (this.darkMedia.media.match(/^not/)) return "light";
            this.darkMedia.addEventListener("change", this.darkMediaCallback);
        }
        return this.darkMedia.matches ? "dark" : "light";
    }
    initDynamicPerLine(props = this.props) {
        if (!props.dynamicWidth) return;
        const { element: element, emojiButtonSize: emojiButtonSize } = props;
        const calculatePerLine = ()=>{
            const { width: width } = element.getBoundingClientRect();
            return Math.floor(width / emojiButtonSize);
        };
        const observer = new ResizeObserver(()=>{
            this.unobserve({
                except: observer
            });
            this.setState({
                perLine: calculatePerLine()
            }, ()=>{
                this.initGrid();
                this.forceUpdate(()=>{
                    this.observeCategories();
                    this.observeRows();
                });
            });
        });
        observer.observe(element);
        this.observers.push(observer);
        return calculatePerLine();
    }
    getPerLine() {
        return this.state.perLine || this.props.perLine;
    }
    getEmojiByPos([p1, p2]) {
        const grid = this.state.searchResults || this.grid;
        const emoji = grid[p1] && grid[p1][p2];
        if (!emoji) return;
        return $cc519efa84d20a3e$export$147b480b3694c1f3.get(emoji);
    }
    observeCategories() {
        const navigation = this.refs.navigation.current;
        if (!navigation) return;
        const visibleCategories = new Map();
        const setFocusedCategory = (categoryId)=>{
            if (categoryId != navigation.state.categoryId) navigation.setState({
                categoryId: categoryId
            });
        };
        const observerOptions = {
            root: this.refs.scroll.current,
            threshold: [
                0.0,
                1.0
            ]
        };
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                const id = entry.target.dataset.id;
                visibleCategories.set(id, entry.intersectionRatio);
            }
            const ratios = [
                ...visibleCategories
            ];
            for (const [id, ratio] of ratios)if (ratio) {
                setFocusedCategory(id);
                break;
            }
        }, observerOptions);
        for (const { root: root } of this.refs.categories.values())observer.observe(root.current);
        this.observers.push(observer);
    }
    observeRows() {
        const visibleRows = {
            ...this.state.visibleRows
        };
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                const index = parseInt(entry.target.dataset.index);
                if (entry.isIntersecting) visibleRows[index] = true;
                else delete visibleRows[index];
            }
            this.setState({
                visibleRows: visibleRows
            });
        }, {
            root: this.refs.scroll.current,
            rootMargin: `${this.props.emojiButtonSize * ($cc519efa84d20a3e$var$$89bd6bb200cc8fef$var$Performance.rowsPerRender + 5)}px 0px ${this.props.emojiButtonSize * $cc519efa84d20a3e$var$$89bd6bb200cc8fef$var$Performance.rowsPerRender}px`
        });
        for (const { rows: rows } of this.refs.categories.values()){
            for (const row of rows)if (row.current) observer.observe(row.current);
        }
        this.observers.push(observer);
    }
    preventDefault(e) {
        e.preventDefault();
    }
    unfocusSearch() {
        const input = this.refs.searchInput.current;
        if (!input) return;
        input.blur();
    }
    navigate({ e: e, input: input, left: left, right: right, up: up, down: down }) {
        const grid = this.state.searchResults || this.grid;
        if (!grid.length) return;
        let [p1, p2] = this.state.pos;
        const pos = (()=>{
            if (p1 == 0) {
                if (p2 == 0 && !e.repeat && (left || up)) return null;
            }
            if (p1 == -1) {
                if (!e.repeat && (right || down) && input.selectionStart == input.value.length) return [
                    0,
                    0
                ];
                return null;
            }
            if (left || right) {
                let row = grid[p1];
                const increment = left ? -1 : 1;
                p2 += increment;
                if (!row[p2]) {
                    p1 += increment;
                    row = grid[p1];
                    if (!row) {
                        p1 = left ? 0 : grid.length - 1;
                        p2 = left ? 0 : grid[p1].length - 1;
                        return [
                            p1,
                            p2
                        ];
                    }
                    p2 = left ? row.length - 1 : 0;
                }
                return [
                    p1,
                    p2
                ];
            }
            if (up || down) {
                p1 += up ? -1 : 1;
                const row = grid[p1];
                if (!row) {
                    p1 = up ? 0 : grid.length - 1;
                    p2 = up ? 0 : grid[p1].length - 1;
                    return [
                        p1,
                        p2
                    ];
                }
                if (!row[p2]) p2 = row.length - 1;
                return [
                    p1,
                    p2
                ];
            }
        })();
        if (pos) e.preventDefault();
        else {
            if (this.state.pos[0] > -1) this.setState({
                pos: [
                    -1,
                    -1
                ]
            });
            return;
        }
        this.setState({
            pos: pos,
            keyboard: true
        }, ()=>{
            this.scrollTo({
                row: pos[0]
            });
        });
    }
    scrollTo({ categoryId: categoryId, row: row }) {
        const grid = this.state.searchResults || this.grid;
        if (!grid.length) return;
        const scroll = this.refs.scroll.current;
        const scrollRect = scroll.getBoundingClientRect();
        let scrollTop = 0;
        if (row >= 0) categoryId = grid[row].__categoryId;
        if (categoryId) {
            const ref = this.refs[categoryId] || this.refs.categories.get(categoryId).root;
            const categoryRect = ref.current.getBoundingClientRect();
            scrollTop = categoryRect.top - (scrollRect.top - scroll.scrollTop) + 1;
        }
        if (row >= 0) {
            if (!row) scrollTop = 0;
            else {
                const rowIndex = grid[row].__index;
                const rowTop = scrollTop + rowIndex * this.props.emojiButtonSize;
                const rowBot = rowTop + this.props.emojiButtonSize + this.props.emojiButtonSize * 0.88;
                if (rowTop < scroll.scrollTop) scrollTop = rowTop;
                else if (rowBot > scroll.scrollTop + scrollRect.height) scrollTop = rowBot - scrollRect.height;
                else return;
            }
        }
        this.ignoreMouse();
        scroll.scrollTop = scrollTop;
    }
    ignoreMouse() {
        this.mouseIsIgnored = true;
        clearTimeout(this.ignoreMouseTimer);
        this.ignoreMouseTimer = setTimeout(()=>{
            delete this.mouseIsIgnored;
        }, 100);
    }
    handleEmojiOver(pos) {
        if (this.mouseIsIgnored || this.state.showSkins) return;
        this.setState({
            pos: pos || [
                -1,
                -1
            ],
            keyboard: false
        });
    }
    handleEmojiClick({ e: e, emoji: emoji, pos: pos }) {
        if (!this.props.onEmojiSelect) return;
        if (!emoji && pos) emoji = this.getEmojiByPos(pos);
        if (emoji) {
            const emojiData = $cc519efa84d20a3e$var$$693b183b0a78708f$export$d10ac59fbe52a745(emoji, {
                skinIndex: this.state.skin - 1
            });
            if (this.props.maxFrequentRows) $cc519efa84d20a3e$export$d42f766cf4e359f3.add(emojiData, this.props);
            this.props.onEmojiSelect(emojiData, e);
        }
    }
    closeSkins() {
        if (!this.state.showSkins) return;
        this.setState({
            showSkins: null,
            tempSkin: null
        });
        this.base.removeEventListener("click", this.handleBaseClick);
        this.base.removeEventListener("keydown", this.handleBaseKeydown);
    }
    handleSkinMouseOver(tempSkin) {
        this.setState({
            tempSkin: tempSkin
        });
    }
    handleSkinClick(skin) {
        this.ignoreMouse();
        this.closeSkins();
        this.setState({
            skin: skin,
            tempSkin: null
        });
        $cc519efa84d20a3e$export$390f32400eaf98c9.set("skin", skin);
    }
    renderNav() {
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($cc519efa84d20a3e$var$$ec8c39fdad15601a$export$2e2bcd8739ae039, {
            ref: this.refs.navigation,
            icons: this.props.icons,
            theme: this.state.theme,
            dir: this.dir,
            unfocused: !!this.state.searchResults,
            position: this.props.navPosition,
            onClick: this.handleCategoryClick
        }, this.navKey);
    }
    renderPreview() {
        const emoji = this.getEmojiByPos(this.state.pos);
        const noSearchResults = this.state.searchResults && !this.state.searchResults.length;
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            id: "preview",
            class: "flex flex-middle",
            dir: this.dir,
            "data-position": this.props.previewPosition,
            children: [
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    class: "flex flex-middle flex-grow",
                    children: [
                        $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: "flex flex-auto flex-middle flex-center",
                            style: {
                                height: this.props.emojiButtonSize,
                                fontSize: this.props.emojiButtonSize
                            },
                            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($cc519efa84d20a3e$var$$254755d3f438722f$export$2e2bcd8739ae039, {
                                emoji: emoji,
                                id: noSearchResults ? this.props.noResultsEmoji || "cry" : this.props.previewEmoji || (this.props.previewPosition == "top" ? "point_down" : "point_up"),
                                set: this.props.set,
                                size: this.props.emojiButtonSize,
                                skin: this.state.tempSkin || this.state.skin,
                                spritesheet: true,
                                getSpritesheetURL: this.props.getSpritesheetURL
                            })
                        }),
                        $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: `margin-${this.dir[0]}`,
                            children: emoji || noSearchResults ? $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                class: `padding-${this.dir[2]} align-${this.dir[0]}`,
                                children: [
                                    $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                        class: "preview-title ellipsis",
                                        children: emoji ? emoji.name : $cc519efa84d20a3e$export$dbe3113d60765c1a.search_no_results_1
                                    }),
                                    $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                        class: "preview-subtitle ellipsis color-c",
                                        children: emoji ? emoji.skins[0].shortcodes : $cc519efa84d20a3e$export$dbe3113d60765c1a.search_no_results_2
                                    })
                                ]
                            }) : $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                class: "preview-placeholder color-c",
                                children: $cc519efa84d20a3e$export$dbe3113d60765c1a.pick
                            })
                        })
                    ]
                }),
                !emoji && this.props.skinTonePosition == "preview" && this.renderSkinToneButton()
            ]
        });
    }
    renderEmojiButton(emoji, { pos: pos, posinset: posinset, grid: grid }) {
        const size = this.props.emojiButtonSize;
        const skin = this.state.tempSkin || this.state.skin;
        const emojiSkin = emoji.skins[skin - 1] || emoji.skins[0];
        const native = emojiSkin.native;
        const selected = $cc519efa84d20a3e$var$$693b183b0a78708f$export$9cb4719e2e525b7a(this.state.pos, pos);
        const key = pos.concat(emoji.id).join("");
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($cc519efa84d20a3e$var$$e0d4dda61265ff1e$export$2e2bcd8739ae039, {
            selected: selected,
            skin: skin,
            size: size,
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("button", {
                "aria-label": native,
                "aria-selected": selected || undefined,
                "aria-posinset": posinset,
                "aria-setsize": grid.setsize,
                "data-keyboard": this.state.keyboard,
                title: this.props.previewPosition == "none" ? emoji.name : undefined,
                type: "button",
                class: "flex flex-center flex-middle",
                tabindex: "-1",
                onClick: (e)=>this.handleEmojiClick({
                        e: e,
                        emoji: emoji
                    }),
                onMouseEnter: ()=>this.handleEmojiOver(pos),
                onMouseLeave: ()=>this.handleEmojiOver(),
                style: {
                    width: this.props.emojiButtonSize,
                    height: this.props.emojiButtonSize,
                    fontSize: this.props.emojiSize,
                    lineHeight: 0
                },
                children: [
                    $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                        "aria-hidden": "true",
                        class: "background",
                        style: {
                            borderRadius: this.props.emojiButtonRadius,
                            backgroundColor: this.props.emojiButtonColors ? this.props.emojiButtonColors[(posinset - 1) % this.props.emojiButtonColors.length] : undefined
                        }
                    }),
                    $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($cc519efa84d20a3e$var$$254755d3f438722f$export$2e2bcd8739ae039, {
                        emoji: emoji,
                        set: this.props.set,
                        size: this.props.emojiSize,
                        skin: skin,
                        spritesheet: true,
                        getSpritesheetURL: this.props.getSpritesheetURL
                    })
                ]
            })
        }, key);
    }
    renderSearch() {
        const renderSkinTone = this.props.previewPosition == "none" || this.props.skinTonePosition == "search";
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            children: [
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    class: "spacer"
                }),
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    class: "flex flex-middle",
                    children: [
                        $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: "search relative flex-grow",
                            children: [
                                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("input", {
                                    type: "search",
                                    ref: this.refs.searchInput,
                                    placeholder: $cc519efa84d20a3e$export$dbe3113d60765c1a.search,
                                    onClick: this.handleSearchClick,
                                    onInput: this.handleSearchInput,
                                    onKeyDown: this.handleSearchKeyDown,
                                    autoComplete: "off"
                                }),
                                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
                                    class: "icon loupe flex",
                                    children: $cc519efa84d20a3e$var$$fcccfb36ed0cde68$export$2e2bcd8739ae039.search.loupe
                                }),
                                this.state.searchResults && $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("button", {
                                    title: "Clear",
                                    "aria-label": "Clear",
                                    type: "button",
                                    class: "icon delete flex",
                                    onClick: this.clearSearch,
                                    onMouseDown: this.preventDefault,
                                    children: $cc519efa84d20a3e$var$$fcccfb36ed0cde68$export$2e2bcd8739ae039.search.delete
                                })
                            ]
                        }),
                        renderSkinTone && this.renderSkinToneButton()
                    ]
                })
            ]
        });
    }
    renderSearchResults() {
        const { searchResults: searchResults } = this.state;
        if (!searchResults) return null;
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            class: "category",
            ref: this.refs.search,
            children: [
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    class: `sticky padding-small align-${this.dir[0]}`,
                    children: $cc519efa84d20a3e$export$dbe3113d60765c1a.categories.search
                }),
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    children: !searchResults.length ? $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                        class: `padding-small align-${this.dir[0]}`,
                        children: this.props.onAddCustomEmoji && $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("a", {
                            onClick: this.props.onAddCustomEmoji,
                            children: $cc519efa84d20a3e$export$dbe3113d60765c1a.add_custom
                        })
                    }) : searchResults.map((row, i)=>{
                        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: "flex",
                            children: row.map((emoji, ii)=>{
                                return this.renderEmojiButton(emoji, {
                                    pos: [
                                        i,
                                        ii
                                    ],
                                    posinset: i * this.props.perLine + ii + 1,
                                    grid: searchResults
                                });
                            })
                        });
                    })
                })
            ]
        });
    }
    renderCategories() {
        const { categories: categories } = $cc519efa84d20a3e$export$2d0294657ab35f1b;
        const hidden = !!this.state.searchResults;
        const perLine = this.getPerLine();
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            style: {
                visibility: hidden ? "hidden" : undefined,
                display: hidden ? "none" : undefined,
                height: "100%"
            },
            children: categories.map((category)=>{
                const { root: root, rows: rows } = this.refs.categories.get(category.id);
                return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    "data-id": category.target ? category.target.id : category.id,
                    class: "category",
                    ref: root,
                    children: [
                        $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: `sticky padding-small align-${this.dir[0]}`,
                            children: category.name || $cc519efa84d20a3e$export$dbe3113d60765c1a.categories[category.id]
                        }),
                        $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: "relative",
                            style: {
                                height: rows.length * this.props.emojiButtonSize
                            },
                            children: rows.map((row, i)=>{
                                const targetRow = row.index - row.index % $cc519efa84d20a3e$var$$89bd6bb200cc8fef$var$Performance.rowsPerRender;
                                const visible = this.state.visibleRows[targetRow];
                                const ref = "current" in row ? row : undefined;
                                if (!visible && !ref) return null;
                                const start = i * perLine;
                                const end = start + perLine;
                                const emojiIds = category.emojis.slice(start, end);
                                if (emojiIds.length < perLine) emojiIds.push(...new Array(perLine - emojiIds.length));
                                return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                    "data-index": row.index,
                                    ref: ref,
                                    class: "flex row",
                                    style: {
                                        top: i * this.props.emojiButtonSize
                                    },
                                    children: visible && emojiIds.map((emojiId, ii)=>{
                                        if (!emojiId) return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                            style: {
                                                width: this.props.emojiButtonSize,
                                                height: this.props.emojiButtonSize
                                            }
                                        });
                                        const emoji = $cc519efa84d20a3e$export$147b480b3694c1f3.get(emojiId);
                                        return this.renderEmojiButton(emoji, {
                                            pos: [
                                                row.index,
                                                ii
                                            ],
                                            posinset: row.posinset + ii,
                                            grid: this.grid
                                        });
                                    })
                                }, row.index);
                            })
                        })
                    ]
                });
            })
        });
    }
    renderSkinToneButton() {
        if (this.props.skinTonePosition == "none") return null;
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            class: "flex flex-auto flex-center flex-middle",
            style: {
                position: "relative",
                width: this.props.emojiButtonSize,
                height: this.props.emojiButtonSize
            },
            children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("button", {
                type: "button",
                ref: this.refs.skinToneButton,
                class: "skin-tone-button flex flex-auto flex-center flex-middle",
                "aria-selected": this.state.showSkins ? "" : undefined,
                "aria-label": $cc519efa84d20a3e$export$dbe3113d60765c1a.skins.choose,
                title: $cc519efa84d20a3e$export$dbe3113d60765c1a.skins.choose,
                onClick: this.openSkins,
                style: {
                    width: this.props.emojiSize,
                    height: this.props.emojiSize
                },
                children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
                    class: `skin-tone skin-tone-${this.state.skin}`
                })
            })
        });
    }
    renderLiveRegion() {
        const emoji = this.getEmojiByPos(this.state.pos);
        const contents = emoji ? emoji.name : "";
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            "aria-live": "polite",
            class: "sr-only",
            children: contents
        });
    }
    renderSkins() {
        const skinToneButton = this.refs.skinToneButton.current;
        const skinToneButtonRect = skinToneButton.getBoundingClientRect();
        const baseRect = this.base.getBoundingClientRect();
        const position = {};
        if (this.dir == "ltr") position.right = baseRect.right - skinToneButtonRect.right - 3;
        else position.left = skinToneButtonRect.left - baseRect.left - 3;
        if (this.props.previewPosition == "bottom" && this.props.skinTonePosition == "preview") position.bottom = baseRect.bottom - skinToneButtonRect.top + 6;
        else {
            position.top = skinToneButtonRect.bottom - baseRect.top + 3;
            position.bottom = "auto";
        }
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            ref: this.refs.menu,
            role: "radiogroup",
            dir: this.dir,
            "aria-label": $cc519efa84d20a3e$export$dbe3113d60765c1a.skins.choose,
            class: "menu hidden",
            "data-position": position.top ? "top" : "bottom",
            style: position,
            children: [
                ...Array(6).keys()
            ].map((i)=>{
                const skin = i + 1;
                const checked = this.state.skin == skin;
                return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    children: [
                        $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("input", {
                            type: "radio",
                            name: "skin-tone",
                            value: skin,
                            "aria-label": $cc519efa84d20a3e$export$dbe3113d60765c1a.skins[skin],
                            ref: checked ? this.refs.skinToneRadio : null,
                            defaultChecked: checked,
                            onChange: ()=>this.handleSkinMouseOver(skin),
                            onKeyDown: (e)=>{
                                if (e.code == "Enter" || e.code == "Space" || e.code == "Tab") {
                                    e.preventDefault();
                                    this.handleSkinClick(skin);
                                }
                            }
                        }),
                        $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("button", {
                            "aria-hidden": "true",
                            tabindex: "-1",
                            onClick: ()=>this.handleSkinClick(skin),
                            onMouseEnter: ()=>this.handleSkinMouseOver(skin),
                            onMouseLeave: ()=>this.handleSkinMouseOver(),
                            class: "option flex flex-grow flex-middle",
                            children: [
                                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
                                    class: `skin-tone skin-tone-${skin}`
                                }),
                                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
                                    class: "margin-small-lr",
                                    children: $cc519efa84d20a3e$export$dbe3113d60765c1a.skins[skin]
                                })
                            ]
                        })
                    ]
                });
            })
        });
    }
    render() {
        const lineWidth = this.props.perLine * this.props.emojiButtonSize;
        return $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("section", {
            id: "root",
            class: "flex flex-column",
            dir: this.dir,
            style: {
                width: this.props.dynamicWidth ? "100%" : `calc(${lineWidth}px + (var(--padding) + var(--sidebar-width)))`
            },
            "data-emoji-set": this.props.set,
            "data-theme": this.state.theme,
            "data-menu": this.state.showSkins ? "" : undefined,
            children: [
                this.props.previewPosition == "top" && this.renderPreview(),
                this.props.navPosition == "top" && this.renderNav(),
                this.props.searchPosition == "sticky" && $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    class: "padding-lr",
                    children: this.renderSearch()
                }),
                $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    ref: this.refs.scroll,
                    class: "scroll flex-grow padding-lr",
                    children: $cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                        style: {
                            width: this.props.dynamicWidth ? "100%" : lineWidth,
                            height: "100%"
                        },
                        children: [
                            this.props.searchPosition == "static" && this.renderSearch(),
                            this.renderSearchResults(),
                            this.renderCategories()
                        ]
                    })
                }),
                this.props.navPosition == "bottom" && this.renderNav(),
                this.props.previewPosition == "bottom" && this.renderPreview(),
                this.state.showSkins && this.renderSkins(),
                this.renderLiveRegion()
            ]
        });
    }
    constructor(props){
        super();
        $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "darkMediaCallback", ()=>{
            if (this.props.theme != "auto") return;
            this.setState({
                theme: this.darkMedia.matches ? "dark" : "light"
            });
        });
        $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleClickOutside", (e)=>{
            const { element: element } = this.props;
            if (e.target != element) {
                if (this.state.showSkins) this.closeSkins();
                if (this.props.onClickOutside) this.props.onClickOutside(e);
            }
        });
        $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleBaseClick", (e)=>{
            if (!this.state.showSkins) return;
            if (!e.target.closest(".menu")) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.closeSkins();
            }
        });
        $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleBaseKeydown", (e)=>{
            if (!this.state.showSkins) return;
            if (e.key == "Escape") {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.closeSkins();
            }
        });
        $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleSearchClick", ()=>{
            const emoji = this.getEmojiByPos(this.state.pos);
            if (!emoji) return;
            this.setState({
                pos: [
                    -1,
                    -1
                ]
            });
        });
        $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleSearchInput", async ()=>{
            const input = this.refs.searchInput.current;
            if (!input) return;
            const { value: value } = input;
            const searchResults = await $cc519efa84d20a3e$export$147b480b3694c1f3.search(value);
            const afterRender = ()=>{
                if (!this.refs.scroll.current) return;
                this.refs.scroll.current.scrollTop = 0;
            };
            if (!searchResults) return this.setState({
                searchResults: searchResults,
                pos: [
                    -1,
                    -1
                ]
            }, afterRender);
            const pos = input.selectionStart == input.value.length ? [
                0,
                0
            ] : [
                -1,
                -1
            ];
            const grid = [];
            grid.setsize = searchResults.length;
            let row = null;
            for (let emoji of searchResults){
                if (!grid.length || row.length == this.getPerLine()) {
                    row = [];
                    row.__categoryId = "search";
                    row.__index = grid.length;
                    grid.push(row);
                }
                row.push(emoji);
            }
            this.ignoreMouse();
            this.setState({
                searchResults: grid,
                pos: pos
            }, afterRender);
        });
        $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleSearchKeyDown", (e)=>{
            // const specialKey = e.altKey || e.ctrlKey || e.metaKey
            const input = e.currentTarget;
            e.stopImmediatePropagation();
            switch(e.key){
                case "ArrowLeft":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        left: true
                    });
                    break;
                case "ArrowRight":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        right: true
                    });
                    break;
                case "ArrowUp":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        up: true
                    });
                    break;
                case "ArrowDown":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        down: true
                    });
                    break;
                case "Enter":
                    e.preventDefault();
                    this.handleEmojiClick({
                        e: e,
                        pos: this.state.pos
                    });
                    break;
                case "Escape":
                    e.preventDefault();
                    if (this.state.searchResults) this.clearSearch();
                    else this.unfocusSearch();
                    break;
                default:
                    break;
            }
        });
        $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "clearSearch", ()=>{
            const input = this.refs.searchInput.current;
            if (!input) return;
            input.value = "";
            input.focus();
            this.handleSearchInput();
        });
        $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleCategoryClick", ({ category: category, i: i })=>{
            this.scrollTo(i == 0 ? {
                row: -1
            } : {
                categoryId: category.id
            });
        });
        $cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "openSkins", (e)=>{
            const { currentTarget: currentTarget } = e;
            const rect = currentTarget.getBoundingClientRect();
            this.setState({
                showSkins: rect
            }, async ()=>{
                // Firefox requires 2 frames for the transition to consistenly work
                await $cc519efa84d20a3e$var$$693b183b0a78708f$export$e772c8ff12451969(2);
                const menu = this.refs.menu.current;
                if (!menu) return;
                menu.classList.remove("hidden");
                this.refs.skinToneRadio.current.focus();
                this.base.addEventListener("click", this.handleBaseClick, true);
                this.base.addEventListener("keydown", this.handleBaseKeydown, true);
            });
        });
        this.observers = [];
        this.state = {
            pos: [
                -1,
                -1
            ],
            perLine: this.initDynamicPerLine(props),
            visibleRows: {
                0: true
            },
            ...this.getInitialState(props)
        };
    }
}
class $cc519efa84d20a3e$export$ba25329847403e11 extends $cc519efa84d20a3e$var$$26f27c338a96b1a6$export$2e2bcd8739ae039 {
    async connectedCallback() {
        const props = $cc519efa84d20a3e$var$$7adb23b0109cc36a$export$75fe5f91d452f94b(this.props, $cc519efa84d20a3e$var$$b247ea80b67298d5$export$2e2bcd8739ae039, this);
        props.element = this;
        props.ref = (component)=>{
            this.component = component;
        };
        await $cc519efa84d20a3e$export$2cd8252107eb640b(props);
        if (this.disconnected) return;
        $cc519efa84d20a3e$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99($cc519efa84d20a3e$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($cc519efa84d20a3e$var$$89bd6bb200cc8fef$export$2e2bcd8739ae039, {
            ...props
        }), this.shadowRoot);
    }
    constructor(props){
        super(props, {
            styles: /*@__PURE__*/ $cc519efa84d20a3e$var$$parcel$interopDefault($cc519efa84d20a3e$var$$329d53ba9fd7125f$exports)
        });
    }
}
$cc519efa84d20a3e$var$$c770c458706daa72$export$2e2bcd8739ae039($cc519efa84d20a3e$export$ba25329847403e11, "Props", $cc519efa84d20a3e$var$$b247ea80b67298d5$export$2e2bcd8739ae039);
if (typeof customElements !== "undefined" && !customElements.get("em-emoji-picker")) customElements.define("em-emoji-picker", $cc519efa84d20a3e$export$ba25329847403e11);
var $cc519efa84d20a3e$var$$329d53ba9fd7125f$exports = {};
$cc519efa84d20a3e$var$$329d53ba9fd7125f$exports = ':host {\n  width: min-content;\n  height: 435px;\n  min-height: 230px;\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow);\n  --border-radius: 10px;\n  --category-icon-size: 18px;\n  --font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;\n  --font-size: 15px;\n  --preview-placeholder-size: 21px;\n  --preview-title-size: 1.1em;\n  --preview-subtitle-size: .9em;\n  --shadow-color: 0deg 0% 0%;\n  --shadow: .3px .5px 2.7px hsl(var(--shadow-color) / .14), .4px .8px 1px -3.2px hsl(var(--shadow-color) / .14), 1px 2px 2.5px -4.5px hsl(var(--shadow-color) / .14);\n  display: flex;\n}\n\n[data-theme="light"] {\n  --em-rgb-color: var(--rgb-color, 34, 36, 39);\n  --em-rgb-accent: var(--rgb-accent, 34, 102, 237);\n  --em-rgb-background: var(--rgb-background, 255, 255, 255);\n  --em-rgb-input: var(--rgb-input, 255, 255, 255);\n  --em-color-border: var(--color-border, rgba(0, 0, 0, .05));\n  --em-color-border-over: var(--color-border-over, rgba(0, 0, 0, .1));\n}\n\n[data-theme="dark"] {\n  --em-rgb-color: var(--rgb-color, 222, 222, 221);\n  --em-rgb-accent: var(--rgb-accent, 58, 130, 247);\n  --em-rgb-background: var(--rgb-background, 21, 22, 23);\n  --em-rgb-input: var(--rgb-input, 0, 0, 0);\n  --em-color-border: var(--color-border, rgba(255, 255, 255, .1));\n  --em-color-border-over: var(--color-border-over, rgba(255, 255, 255, .2));\n}\n\n#root {\n  --color-a: rgb(var(--em-rgb-color));\n  --color-b: rgba(var(--em-rgb-color), .65);\n  --color-c: rgba(var(--em-rgb-color), .45);\n  --padding: 12px;\n  --padding-small: calc(var(--padding) / 2);\n  --sidebar-width: 16px;\n  --duration: 225ms;\n  --duration-fast: 125ms;\n  --duration-instant: 50ms;\n  --easing: cubic-bezier(.4, 0, .2, 1);\n  width: 100%;\n  text-align: left;\n  border-radius: var(--border-radius);\n  background-color: rgb(var(--em-rgb-background));\n  position: relative;\n}\n\n@media (prefers-reduced-motion) {\n  #root {\n    --duration: 0;\n    --duration-fast: 0;\n    --duration-instant: 0;\n  }\n}\n\n#root[data-menu] button {\n  cursor: auto;\n}\n\n#root[data-menu] .menu button {\n  cursor: pointer;\n}\n\n:host, #root, input, button {\n  color: rgb(var(--em-rgb-color));\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: normal;\n}\n\n*, :before, :after {\n  box-sizing: border-box;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.relative {\n  position: relative;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-auto {\n  flex: none;\n}\n\n.flex-center {\n  justify-content: center;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.flex-grow {\n  flex: auto;\n}\n\n.flex-middle {\n  align-items: center;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.padding {\n  padding: var(--padding);\n}\n\n.padding-t {\n  padding-top: var(--padding);\n}\n\n.padding-lr {\n  padding-left: var(--padding);\n  padding-right: var(--padding);\n}\n\n.padding-r {\n  padding-right: var(--padding);\n}\n\n.padding-small {\n  padding: var(--padding-small);\n}\n\n.padding-small-b {\n  padding-bottom: var(--padding-small);\n}\n\n.padding-small-lr {\n  padding-left: var(--padding-small);\n  padding-right: var(--padding-small);\n}\n\n.margin {\n  margin: var(--padding);\n}\n\n.margin-r {\n  margin-right: var(--padding);\n}\n\n.margin-l {\n  margin-left: var(--padding);\n}\n\n.margin-small-l {\n  margin-left: var(--padding-small);\n}\n\n.margin-small-lr {\n  margin-left: var(--padding-small);\n  margin-right: var(--padding-small);\n}\n\n.align-l {\n  text-align: left;\n}\n\n.align-r {\n  text-align: right;\n}\n\n.color-a {\n  color: var(--color-a);\n}\n\n.color-b {\n  color: var(--color-b);\n}\n\n.color-c {\n  color: var(--color-c);\n}\n\n.ellipsis {\n  white-space: nowrap;\n  max-width: 100%;\n  width: auto;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.sr-only {\n  width: 1px;\n  height: 1px;\n  position: absolute;\n  top: auto;\n  left: -10000px;\n  overflow: hidden;\n}\n\na {\n  cursor: pointer;\n  color: rgb(var(--em-rgb-accent));\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.spacer {\n  height: 10px;\n}\n\n[dir="rtl"] .scroll {\n  padding-left: 0;\n  padding-right: var(--padding);\n}\n\n.scroll {\n  padding-right: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.scroll::-webkit-scrollbar {\n  width: var(--sidebar-width);\n  height: var(--sidebar-width);\n}\n\n.scroll::-webkit-scrollbar-track {\n  border: 0;\n}\n\n.scroll::-webkit-scrollbar-button {\n  width: 0;\n  height: 0;\n  display: none;\n}\n\n.scroll::-webkit-scrollbar-corner {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.scroll::-webkit-scrollbar-thumb {\n  min-height: 20%;\n  min-height: 65px;\n  border: 4px solid rgb(var(--em-rgb-background));\n  border-radius: 8px;\n}\n\n.scroll::-webkit-scrollbar-thumb:hover {\n  background-color: var(--em-color-border-over) !important;\n}\n\n.scroll:hover::-webkit-scrollbar-thumb {\n  background-color: var(--em-color-border);\n}\n\n.sticky {\n  z-index: 1;\n  background-color: rgba(var(--em-rgb-background), .9);\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n  font-weight: 500;\n  position: sticky;\n  top: -1px;\n}\n\n[dir="rtl"] .search input[type="search"] {\n  padding: 10px 2.2em 10px 2em;\n}\n\n[dir="rtl"] .search .loupe {\n  left: auto;\n  right: .7em;\n}\n\n[dir="rtl"] .search .delete {\n  left: .7em;\n  right: auto;\n}\n\n.search {\n  z-index: 2;\n  position: relative;\n}\n\n.search input, .search button {\n  font-size: calc(var(--font-size)  - 1px);\n}\n\n.search input[type="search"] {\n  width: 100%;\n  background-color: var(--em-color-border);\n  transition-duration: var(--duration);\n  transition-property: background-color, box-shadow;\n  transition-timing-function: var(--easing);\n  border: 0;\n  border-radius: 10px;\n  outline: 0;\n  padding: 10px 2em 10px 2.2em;\n  display: block;\n}\n\n.search input[type="search"]::-ms-input-placeholder {\n  color: inherit;\n  opacity: .6;\n}\n\n.search input[type="search"]::placeholder {\n  color: inherit;\n  opacity: .6;\n}\n\n.search input[type="search"], .search input[type="search"]::-webkit-search-decoration, .search input[type="search"]::-webkit-search-cancel-button, .search input[type="search"]::-webkit-search-results-button, .search input[type="search"]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n}\n\n.search input[type="search"]:focus {\n  background-color: rgb(var(--em-rgb-input));\n  box-shadow: inset 0 0 0 1px rgb(var(--em-rgb-accent)), 0 1px 3px rgba(65, 69, 73, .2);\n}\n\n.search .icon {\n  z-index: 1;\n  color: rgba(var(--em-rgb-color), .7);\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.search .loupe {\n  pointer-events: none;\n  left: .7em;\n}\n\n.search .delete {\n  right: .7em;\n}\n\nsvg {\n  fill: currentColor;\n  width: 1em;\n  height: 1em;\n}\n\nbutton {\n  -webkit-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  color: currentColor;\n  background-color: rgba(0, 0, 0, 0);\n  border: 0;\n}\n\n#nav {\n  z-index: 2;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  padding-right: var(--sidebar-width);\n  position: relative;\n}\n\n#nav button {\n  color: var(--color-b);\n  transition: color var(--duration) var(--easing);\n}\n\n#nav button:hover {\n  color: var(--color-a);\n}\n\n#nav svg, #nav img {\n  width: var(--category-icon-size);\n  height: var(--category-icon-size);\n}\n\n#nav[dir="rtl"] .bar {\n  left: auto;\n  right: 0;\n}\n\n#nav .bar {\n  width: 100%;\n  height: 3px;\n  background-color: rgb(var(--em-rgb-accent));\n  transition: transform var(--duration) var(--easing);\n  border-radius: 3px 3px 0 0;\n  position: absolute;\n  bottom: -12px;\n  left: 0;\n}\n\n#nav button[aria-selected] {\n  color: rgb(var(--em-rgb-accent));\n}\n\n#preview {\n  z-index: 2;\n  padding: calc(var(--padding)  + 4px) var(--padding);\n  padding-right: var(--sidebar-width);\n  position: relative;\n}\n\n#preview .preview-placeholder {\n  font-size: var(--preview-placeholder-size);\n}\n\n#preview .preview-title {\n  font-size: var(--preview-title-size);\n}\n\n#preview .preview-subtitle {\n  font-size: var(--preview-subtitle-size);\n}\n\n#nav:before, #preview:before {\n  content: "";\n  height: 2px;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\n#nav[data-position="top"]:before, #preview[data-position="top"]:before {\n  background: linear-gradient(to bottom, var(--em-color-border), transparent);\n  top: 100%;\n}\n\n#nav[data-position="bottom"]:before, #preview[data-position="bottom"]:before {\n  background: linear-gradient(to top, var(--em-color-border), transparent);\n  bottom: 100%;\n}\n\n.category:last-child {\n  min-height: calc(100% + 1px);\n}\n\n.category button {\n  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;\n  position: relative;\n}\n\n.category button > * {\n  position: relative;\n}\n\n.category button .background {\n  opacity: 0;\n  background-color: var(--em-color-border);\n  transition: opacity var(--duration-fast) var(--easing) var(--duration-instant);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.category button:hover .background {\n  transition-duration: var(--duration-instant);\n  transition-delay: 0s;\n}\n\n.category button[aria-selected] .background {\n  opacity: 1;\n}\n\n.category button[data-keyboard] .background {\n  transition: none;\n}\n\n.row {\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.skin-tone-button {\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 100%;\n}\n\n.skin-tone-button:hover {\n  border-color: var(--em-color-border);\n}\n\n.skin-tone-button:active .skin-tone {\n  transform: scale(.85) !important;\n}\n\n.skin-tone-button .skin-tone {\n  transition: transform var(--duration) var(--easing);\n}\n\n.skin-tone-button[aria-selected] {\n  background-color: var(--em-color-border);\n  border-top-color: rgba(0, 0, 0, .05);\n  border-bottom-color: rgba(0, 0, 0, 0);\n  border-left-width: 0;\n  border-right-width: 0;\n}\n\n.skin-tone-button[aria-selected] .skin-tone {\n  transform: scale(.9);\n}\n\n.menu {\n  z-index: 2;\n  white-space: nowrap;\n  border: 1px solid var(--em-color-border);\n  background-color: rgba(var(--em-rgb-background), .9);\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n  transition-property: opacity, transform;\n  transition-duration: var(--duration);\n  transition-timing-function: var(--easing);\n  border-radius: 10px;\n  padding: 4px;\n  position: absolute;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, .05);\n}\n\n.menu.hidden {\n  opacity: 0;\n}\n\n.menu[data-position="bottom"] {\n  transform-origin: 100% 100%;\n}\n\n.menu[data-position="bottom"].hidden {\n  transform: scale(.9)rotate(-3deg)translateY(5%);\n}\n\n.menu[data-position="top"] {\n  transform-origin: 100% 0;\n}\n\n.menu[data-position="top"].hidden {\n  transform: scale(.9)rotate(3deg)translateY(-5%);\n}\n\n.menu input[type="radio"] {\n  clip: rect(0 0 0 0);\n  width: 1px;\n  height: 1px;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  overflow: hidden;\n}\n\n.menu input[type="radio"]:checked + .option {\n  box-shadow: 0 0 0 2px rgb(var(--em-rgb-accent));\n}\n\n.option {\n  width: 100%;\n  border-radius: 6px;\n  padding: 4px 6px;\n}\n\n.option:hover {\n  color: #fff;\n  background-color: rgb(var(--em-rgb-accent));\n}\n\n.skin-tone {\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n}\n\n.skin-tone:after {\n  content: "";\n  mix-blend-mode: overlay;\n  background: linear-gradient(rgba(255, 255, 255, .2), rgba(0, 0, 0, 0));\n  border: 1px solid rgba(0, 0, 0, .8);\n  border-radius: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  box-shadow: inset 0 -2px 3px #000, inset 0 1px 2px #fff;\n}\n\n.skin-tone-1 {\n  background-color: #ffc93a;\n}\n\n.skin-tone-2 {\n  background-color: #ffdab7;\n}\n\n.skin-tone-3 {\n  background-color: #e7b98f;\n}\n\n.skin-tone-4 {\n  background-color: #c88c61;\n}\n\n.skin-tone-5 {\n  background-color: #a46134;\n}\n\n.skin-tone-6 {\n  background-color: #5d4437;\n}\n\n[data-index] {\n  justify-content: space-between;\n}\n\n[data-emoji-set="twitter"] .skin-tone:after {\n  box-shadow: none;\n  border-color: rgba(0, 0, 0, .5);\n}\n\n[data-emoji-set="twitter"] .skin-tone-1 {\n  background-color: #fade72;\n}\n\n[data-emoji-set="twitter"] .skin-tone-2 {\n  background-color: #f3dfd0;\n}\n\n[data-emoji-set="twitter"] .skin-tone-3 {\n  background-color: #eed3a8;\n}\n\n[data-emoji-set="twitter"] .skin-tone-4 {\n  background-color: #cfad8d;\n}\n\n[data-emoji-set="twitter"] .skin-tone-5 {\n  background-color: #a8805d;\n}\n\n[data-emoji-set="twitter"] .skin-tone-6 {\n  background-color: #765542;\n}\n\n[data-emoji-set="google"] .skin-tone:after {\n  box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, .4);\n}\n\n[data-emoji-set="google"] .skin-tone-1 {\n  background-color: #f5c748;\n}\n\n[data-emoji-set="google"] .skin-tone-2 {\n  background-color: #f1d5aa;\n}\n\n[data-emoji-set="google"] .skin-tone-3 {\n  background-color: #d4b48d;\n}\n\n[data-emoji-set="google"] .skin-tone-4 {\n  background-color: #aa876b;\n}\n\n[data-emoji-set="google"] .skin-tone-5 {\n  background-color: #916544;\n}\n\n[data-emoji-set="google"] .skin-tone-6 {\n  background-color: #61493f;\n}\n\n[data-emoji-set="facebook"] .skin-tone:after {\n  border-color: rgba(0, 0, 0, .4);\n  box-shadow: inset 0 -2px 3px #000, inset 0 1px 4px #fff;\n}\n\n[data-emoji-set="facebook"] .skin-tone-1 {\n  background-color: #f5c748;\n}\n\n[data-emoji-set="facebook"] .skin-tone-2 {\n  background-color: #f1d5aa;\n}\n\n[data-emoji-set="facebook"] .skin-tone-3 {\n  background-color: #d4b48d;\n}\n\n[data-emoji-set="facebook"] .skin-tone-4 {\n  background-color: #aa876b;\n}\n\n[data-emoji-set="facebook"] .skin-tone-5 {\n  background-color: #916544;\n}\n\n[data-emoji-set="facebook"] .skin-tone-6 {\n  background-color: #61493f;\n}\n\n';




var $177e986090725a2b$var$deleteIcon = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";
var $177e986090725a2b$var$deleteImage = document.createElement("img");
$177e986090725a2b$var$deleteImage.src = $177e986090725a2b$var$deleteIcon;
var $177e986090725a2b$var$deleteControl = new (0, $ab3f2a5cc6216ae5$export$7a7fa4424cb20976)({
    x: 0.5,
    y: -0.5,
    offsetX: 16,
    offsetY: -16,
    cursorStyle: "pointer",
    mouseUpHandler: $177e986090725a2b$var$deleteObject,
    render: $177e986090725a2b$var$renderIcon,
    sizeX: 24,
    sizeY: 24
});
function $177e986090725a2b$var$deleteObject(eventData, transform) {
    var target = transform.target;
    var canvas = target.canvas;
    canvas.remove(target);
    canvas.requestRenderAll();
}
function $177e986090725a2b$var$renderIcon(ctx, left, top, styleOverride, fabricObject) {
    var size = this.sizeX;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabricObject.angle / 180 * Math.PI);
    ctx.drawImage($177e986090725a2b$var$deleteImage, -size / 2, -size / 2, size, size);
    ctx.restore();
}
function $177e986090725a2b$export$da24119849a5ac1b(obj) {
    obj.controls.deleteControl = $177e986090725a2b$var$deleteControl;
}


var $bb4b8eef9fb9bc23$var$emojiButton = document.querySelector("#emoji-button");
var $bb4b8eef9fb9bc23$var$emojiWidget = document.querySelector("#emoji-widget");
function $bb4b8eef9fb9bc23$var$addEmojiToCanvas(emoji) {
    var text = new (0, $ab3f2a5cc6216ae5$export$72cf63a35cb577f7)(emoji, {
        left: 100,
        top: 100,
        fontSize: 44,
        fontFamily: "Arial",
        originX: "center",
        originY: "center"
    });
    (0, $177e986090725a2b$export$da24119849a5ac1b)(text);
    (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).fabricCanvas.add(text);
}
function $bb4b8eef9fb9bc23$var$showEmojiPicker(b) {
    $bb4b8eef9fb9bc23$var$emojiWidget.style.display = b ? "block" : "none";
    if (b) {
        function onClickOutside(e) {
            if (e.target !== $bb4b8eef9fb9bc23$var$emojiWidget && !$bb4b8eef9fb9bc23$var$emojiWidget.contains(e.target)) {
                $bb4b8eef9fb9bc23$var$showEmojiPicker(false);
                document.removeEventListener("pointerdown", onClickOutside);
            }
        }
        document.addEventListener("pointerdown", onClickOutside);
    }
}
function $bb4b8eef9fb9bc23$export$2e2bcd8739ae039() {
    new (0, $cc519efa84d20a3e$export$ba25329847403e11)({
        parent: $bb4b8eef9fb9bc23$var$emojiWidget,
        data: (0, (/*@__PURE__*/$parcel$interopDefault($c6f037291b4db98a$exports))),
        emojiButtonRadius: "6px",
        theme: "auto",
        onEmojiSelect: function(emoji) {
            $bb4b8eef9fb9bc23$var$addEmojiToCanvas(emoji.native);
            $bb4b8eef9fb9bc23$var$showEmojiPicker(false);
        }
    });
    $bb4b8eef9fb9bc23$var$emojiButton.addEventListener("click", function(e) {
        $bb4b8eef9fb9bc23$var$showEmojiPicker(true);
        e.stopPropagation();
    });
}






var $411d286ba465e42a$var$textButton = document.querySelector("#text-button");
var $411d286ba465e42a$var$textInput = document.querySelector("#text-input");
var $411d286ba465e42a$var$textColor = document.querySelector("#text-color");
var $411d286ba465e42a$var$textFont = document.querySelector("#text-font");
var $411d286ba465e42a$var$textBold = document.querySelector("#text-bold");
var $411d286ba465e42a$var$textWidget = document.querySelector("#text-widget");
var $411d286ba465e42a$var$submitButton = document.querySelector("#text-submit");
function $411d286ba465e42a$var$styleInput() {
    $411d286ba465e42a$var$textInput.style.color = $411d286ba465e42a$var$textColor.value;
    $411d286ba465e42a$var$textInput.style.fontWeight = $411d286ba465e42a$var$textBold.checked ? "bold" : "normal";
    $411d286ba465e42a$var$textInput.style.fontFamily = $411d286ba465e42a$var$textFont.value;
}
$411d286ba465e42a$var$textColor.onchange = $411d286ba465e42a$var$styleInput;
$411d286ba465e42a$var$textFont.onchange = $411d286ba465e42a$var$styleInput;
$411d286ba465e42a$var$textBold.onchange = $411d286ba465e42a$var$styleInput;
function $411d286ba465e42a$var$addTextToCanvas(emoji) {
    var text = new (0, $ab3f2a5cc6216ae5$export$72cf63a35cb577f7)(emoji, {
        left: 100,
        top: 100,
        fontSize: 44,
        fontFamily: $411d286ba465e42a$var$textFont.value,
        originX: "center",
        originY: "center",
        fill: $411d286ba465e42a$var$textColor.value,
        fontWeight: $411d286ba465e42a$var$textBold.checked ? "bold" : "normal"
    });
    (0, $177e986090725a2b$export$da24119849a5ac1b)(text);
    (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).fabricCanvas.add(text);
}
function $411d286ba465e42a$var$showTextCreator(b) {
    $411d286ba465e42a$var$textWidget.style.display = b ? "flex" : "none";
    if (b) {
        function onClickOutside(e) {
            if (e.target !== $411d286ba465e42a$var$textWidget && !$411d286ba465e42a$var$textWidget.contains(e.target)) {
                $411d286ba465e42a$var$showTextCreator(false);
                document.removeEventListener("pointerdown", onClickOutside);
            }
        }
        document.addEventListener("pointerdown", onClickOutside);
    }
}
function $411d286ba465e42a$export$2e2bcd8739ae039() {
    $411d286ba465e42a$var$showTextCreator(false);
    $411d286ba465e42a$var$textButton.addEventListener("click", function(e) {
        $411d286ba465e42a$var$showTextCreator(true);
        e.stopPropagation();
    });
    $411d286ba465e42a$var$submitButton.addEventListener("click", function(e) {
        var text = $411d286ba465e42a$var$textInput.value;
        $411d286ba465e42a$var$addTextToCanvas(text);
        $411d286ba465e42a$var$showTextCreator(false);
        $411d286ba465e42a$var$textInput.value = "";
    });
}


var $f27a99974ce68c5f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f27a99974ce68c5f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f27a99974ce68c5f$var$canvasContainer = document.getElementById("canvas-editor");
var $f27a99974ce68c5f$var$downloadButton = document.getElementById("download");
var $f27a99974ce68c5f$var$shareButton = document.getElementById("share");
var $f27a99974ce68c5f$var$canvas = document.getElementById("fabric-canvas");
var $f27a99974ce68c5f$var$fabricCanvas = new $ab3f2a5cc6216ae5$export$8d01c972ee8b14a9($f27a99974ce68c5f$var$canvas, {
    width: window.innerWidth,
    height: window.innerHeight
});
(0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).fabricCanvas = $f27a99974ce68c5f$var$fabricCanvas;
(0, $2dbde92a00aadffa$export$72c03c4379b553)();
(0, $bb4b8eef9fb9bc23$export$2e2bcd8739ae039)();
(0, $411d286ba465e42a$export$2e2bcd8739ae039)();
$f27a99974ce68c5f$var$fabricCanvas.on({
    "object:modified": (0, $b53765e5fbe92ac9$export$715facf17dc37e45),
    "object:added": (0, $b53765e5fbe92ac9$export$715facf17dc37e45),
    "object:removed": (0, $b53765e5fbe92ac9$export$715facf17dc37e45)
});
(0, $7d25ac3a95a01df6$export$2e2bcd8739ae039).on("trimChange", function(event) {
    var start = event.start, end = event.end;
    (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).trimStart = start;
    (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).trimEnd = end;
    (0, $b53765e5fbe92ac9$export$715facf17dc37e45)();
});
(0, $7d25ac3a95a01df6$export$2e2bcd8739ae039).on("receiveVideo", function(event) {
    return $f27a99974ce68c5f$var$__awaiter(void 0, void 0, void 0, function() {
        var frames, fps, width, height, aspectRatio, cssHeight, canvasPlayer;
        return $f27a99974ce68c5f$var$__generator(this, function(_a) {
            frames = event.frames, fps = event.fps, width = event.width, height = event.height;
            (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).videoFrames = frames;
            aspectRatio = width / height;
            // match fabric canvas to video dimensions
            $f27a99974ce68c5f$var$fabricCanvas.setDimensions({
                width: width,
                height: height
            });
            cssHeight = window.innerWidth / aspectRatio;
            $f27a99974ce68c5f$var$canvasContainer.style.width = "".concat(window.innerWidth, "px");
            $f27a99974ce68c5f$var$canvasContainer.style.height = "".concat(cssHeight, "px");
            $f27a99974ce68c5f$var$fabricCanvas.setDimensions({
                width: "100%",
                height: "100%"
            }, {
                cssOnly: true
            });
            canvasPlayer = new (0, $c17b7bec70f4fcd5$export$2e2bcd8739ae039)(frames, fps, width, height);
            $f27a99974ce68c5f$var$canvasContainer.appendChild(canvasPlayer.container);
            (0, $b53765e5fbe92ac9$export$715facf17dc37e45)();
            if (navigator.share) $f27a99974ce68c5f$var$shareButton.onclick = function() {
                return $f27a99974ce68c5f$var$__awaiter(void 0, void 0, void 0, function() {
                    var bakedVideoFrames, blob, file, err_1;
                    return $f27a99974ce68c5f$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).bakedVideoFrames
                                ];
                            case 1:
                                bakedVideoFrames = _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    (0, $73780af2e1c5e77c$export$fb609dbfb0d8ccc7)({
                                        frames: bakedVideoFrames,
                                        width: width,
                                        height: height,
                                        fps: fps
                                    })
                                ];
                            case 2:
                                blob = _a.sent();
                                file = new File([
                                    blob
                                ], "poki.mp4", {
                                    type: "video/mp4"
                                });
                                _a.label = 3;
                            case 3:
                                _a.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    navigator.share({
                                        files: [
                                            file
                                        ],
                                        title: "Test Gameplay Video",
                                        text: "Check out this game from Poki!"
                                    })
                                ];
                            case 4:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                err_1 = _a.sent();
                                console.error("%cPOKI_REPLAY:%c error sharing", "font-weight: bold", "", err_1);
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            else $f27a99974ce68c5f$var$shareButton.style.display = "none";
            $f27a99974ce68c5f$var$downloadButton.onclick = function() {
                return $f27a99974ce68c5f$var$__awaiter(void 0, void 0, void 0, function() {
                    var bakedVideoFrames, blob, file, url, a;
                    return $f27a99974ce68c5f$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    (0, $cf74ec4da4573f1f$export$2e2bcd8739ae039).bakedVideoFrames
                                ];
                            case 1:
                                bakedVideoFrames = _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    (0, $73780af2e1c5e77c$export$fb609dbfb0d8ccc7)({
                                        frames: bakedVideoFrames,
                                        width: width,
                                        height: height,
                                        fps: fps
                                    })
                                ];
                            case 2:
                                blob = _a.sent();
                                file = new File([
                                    blob
                                ], "poki.mp4", {
                                    type: "video/mp4"
                                });
                                url = URL.createObjectURL(file);
                                a = document.createElement("a");
                                a.href = url;
                                a.download = file.name;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                URL.revokeObjectURL(url);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            return [
                2 /*return*/ 
            ];
        });
    });
});


//# sourceMappingURL=index.b56f9e0d.js.map
